
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("4FYDR", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.40', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HUAWEI = 'Huawei', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', OPERA = 'Opera', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /(?:honor)([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Honor'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Lenovo'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    'Nokia'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OnePlus'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("5nRL1", function(module, exports) {
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $b8b2d306bbe1b8cb$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(elem, window);
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(pageLayoutRoot, window);
        }
    }
}
/**
 * Gets the effective bounding rectangle for an element, handling display: contents elements
 * by collecting dimensions from their children instead
 */ function $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(elem, window) {
    const computedStyle = window.getComputedStyle(elem);
    // If element has display: contents, collect bounding rect from children
    if (computedStyle.display === 'contents') {
        const children = Array.from(elem.children);
        if (children.length === 0) // No children, return zero rect
        return new DOMRect(0, 0, 0, 0);
        // Calculate union of all children's bounding rects
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        children.forEach((child)=>{
            const childRect = child.getBoundingClientRect();
            // Skip children with zero dimensions (likely also display: contents)
            if (childRect.width > 0 || childRect.height > 0) {
                minX = Math.min(minX, childRect.left);
                minY = Math.min(minY, childRect.top);
                maxX = Math.max(maxX, childRect.right);
                maxY = Math.max(maxY, childRect.bottom);
            }
        });
        // If no children with dimensions found, return zero rect
        if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
        return new DOMRect(minX, minY, maxX - minX, maxY - minY);
    }
    // Normal element, return its bounding rect
    return elem.getBoundingClientRect();
}
module.exports["collectSSRPlaceholderDimensions"] = $b8b2d306bbe1b8cb$export$aee7516e57289027;

});

parcelRegister("3ay3Q", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $baiQV = parcelRequire("baiQV");


var $53d5Q = parcelRequire("53d5Q");


var $aqLdL = parcelRequire("aqLdL");


var $28pAQ = parcelRequire("28pAQ");


var $jJ2Ec = parcelRequire("jJ2Ec");


var $4u5NT = parcelRequire("4u5NT");




const $7414ebe21cd8146c$var$nameCache = new WeakMap();
function $7414ebe21cd8146c$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $7414ebe21cd8146c$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (err) {
        return false;
    }
}
function $7414ebe21cd8146c$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $7414ebe21cd8146c$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $7414ebe21cd8146c$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'data-testid') || $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($7414ebe21cd8146c$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $7414ebe21cd8146c$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$7414ebe21cd8146c$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $7414ebe21cd8146c$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $7414ebe21cd8146c$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $7414ebe21cd8146c$var$getUniqueSelector(selectorConfig, element);
    $7414ebe21cd8146c$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $7414ebe21cd8146c$export$2e2bcd8739ae039 = $7414ebe21cd8146c$var$getElementName;


let $d5a6c732cffb1707$var$performanceEventObserver;
const $d5a6c732cffb1707$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $d5a6c732cffb1707$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $d5a6c732cffb1707$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $d5a6c732cffb1707$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($d5a6c732cffb1707$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $d5a6c732cffb1707$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $d5a6c732cffb1707$export$17afbba0f16b4b19 = ()=>{
    $d5a6c732cffb1707$var$performanceEventObserver = $d5a6c732cffb1707$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $d5a6c732cffb1707$export$e6be05b411ce21a6(entry);
    });
    return $d5a6c732cffb1707$var$performanceEventObserver;
};
const $d5a6c732cffb1707$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $d5a6c732cffb1707$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $7414ebe21cd8146c$export$2e2bcd8739ae039)($d5a6c732cffb1707$var$selectorConfig, entry.target);
            }
        }
    }
};



var $i328h = parcelRequire("i328h");


var $eggFB = parcelRequire("eggFB");




function $89fa2b1673704460$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $dh538.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $eggFB.unstable_scheduleCallback)((0, $eggFB.unstable_IdlePriority), work);
}
var $89fa2b1673704460$export$2e2bcd8739ae039 = $89fa2b1673704460$var$scheduleIdleCallback;


let $726cef1959388e45$var$initialized = false;
function $726cef1959388e45$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $4u5NT.sinkInteractionHandler)(sinkFn);
}
function $726cef1959388e45$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) {
                    if ((0, $dh538.fg)('enable_ufo_devtools_api_for_extra_events')) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        }
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(experimentalMetricsOnIdle);
    }
    (0, $aqLdL.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $726cef1959388e45$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $4u5NT.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                if ((0, $dh538.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}
function $726cef1959388e45$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $4u5NT.interactionExtraMetrics).sinkHandler((interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)=>{
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(async ()=>{
            const payload = await createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                if ((0, $dh538.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}
function $726cef1959388e45$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $28pAQ.sinkExtraSearchPageInteractionHandler)(sinkFn);
}



function $726cef1959388e45$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($726cef1959388e45$var$initialized) return;
    // Initialize pressure observer for CPU usage monitoring
    (0, $i328h.initialisePressureObserver)();
    (0, $i328h.initialiseMemoryObserver)();
    (0, $53d5Q.setUFOConfig)(config);
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        (0, $4u5NT.postInteractionLog).initializeVCObserver(vcOptions);
        if (config?.experimentalInteractionMetrics?.enabled) (0, $aqLdL.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config?.extraInteractionMetrics?.enabled) (0, $4u5NT.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $jJ2Ec.setupHiddenTimingCapture)();
    (0, $baiQV.startLighthouseObserver)();
    $726cef1959388e45$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $d5a6c732cffb1707$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("d36Ll")),
        (parcelRequire("eGXpu")),
        (parcelRequire("10huY"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createInteractionExtraMetricsPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $726cef1959388e45$var$sinkInteraction(instance, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $726cef1959388e45$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if (config.postInteractionLog?.enabled) $726cef1959388e45$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config?.extraInteractionMetrics?.enabled && (0, $dh538.fg)('platform_ufo_enable_ttai_with_3p')) $726cef1959388e45$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $726cef1959388e45$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $726cef1959388e45$var$sinkInteraction(awc, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $726cef1959388e45$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if (config.postInteractionLog?.enabled) $726cef1959388e45$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config?.extraInteractionMetrics?.enabled && (0, $dh538.fg)('platform_ufo_enable_ttai_with_3p')) $726cef1959388e45$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $726cef1959388e45$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}
module.exports["init"] = $726cef1959388e45$export$2cd8252107eb640b;

});

parcelRegister("baiQV", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $5ee5d57771f6c7fe$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $5ee5d57771f6c7fe$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $dh538.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$5ee5d57771f6c7fe$var$isSameRects(previousRect, currentRect));
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}


const $f98053df596c1c19$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};


const $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $3d4a3152b88eeea8$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}



class $3bf1fc6946af5f4a$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe = {
    [(0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask]: new $3bf1fc6946af5f4a$export$2c6e86519c9e8188(),
    [(0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift]: new $3bf1fc6946af5f4a$export$2c6e86519c9e8188()
};




let $e20935e0f33fbf41$var$pe = null;
function $e20935e0f33fbf41$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($e20935e0f33fbf41$var$pe !== null) return $e20935e0f33fbf41$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift) (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift].push(entry);
            if (entry.entryType === (0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask) (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask].push(entry);
        });
    };
    $e20935e0f33fbf41$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $e20935e0f33fbf41$var$pe;
}
function $e20935e0f33fbf41$export$768ccc3ab7bac3ea() {
    $e20935e0f33fbf41$var$getObserver()?.observe({
        type: (0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift,
        buffered: true
    });
}
function $e20935e0f33fbf41$export$54fb8b6aaf70ec9c() {
    $e20935e0f33fbf41$var$getObserver()?.observe({
        type: (0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask,
        buffered: true
    });
}


function $507b4d71ea76a7a5$export$5ecf2aafafee3e0() {
    (0, $e20935e0f33fbf41$export$768ccc3ab7bac3ea)();
    (0, $e20935e0f33fbf41$export$54fb8b6aaf70ec9c)();
}
function $507b4d71ea76a7a5$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $3d4a3152b88eeea8$export$2d6e933b35bd3407)(start, stop, (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $5ee5d57771f6c7fe$export$fc6227831ee7c7)(start, stop, (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}
module.exports["startLighthouseObserver"] = $507b4d71ea76a7a5$export$5ecf2aafafee3e0;
module.exports["getLighthouseMetrics"] = $507b4d71ea76a7a5$export$b46cecdf698e4bb5;

});

parcelRegister("i328h", function(module, exports) {
const $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $1b7ceb7dea9fa404$var$pressureRecordBuffer = [];
let $1b7ceb7dea9fa404$var$pressureObserver = null;
let $1b7ceb7dea9fa404$var$memoryRecordBuffer = [];
let $1b7ceb7dea9fa404$var$memoryInterval;
function $1b7ceb7dea9fa404$export$6c1060bed5fea050() {
    $1b7ceb7dea9fa404$var$pressureRecordBuffer.length = 0;
}
function $1b7ceb7dea9fa404$export$aa672c7221b183b0() {
    $1b7ceb7dea9fa404$var$memoryRecordBuffer.length = 0;
}
function $1b7ceb7dea9fa404$export$ec86686c1d2e65bc(filter) {
    $1b7ceb7dea9fa404$var$pressureRecordBuffer = $1b7ceb7dea9fa404$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $1b7ceb7dea9fa404$export$c0142ac82f5d0c28(filter) {
    $1b7ceb7dea9fa404$var$memoryRecordBuffer = $1b7ceb7dea9fa404$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $1b7ceb7dea9fa404$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $1b7ceb7dea9fa404$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $1b7ceb7dea9fa404$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $1b7ceb7dea9fa404$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $1b7ceb7dea9fa404$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $1b7ceb7dea9fa404$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $1b7ceb7dea9fa404$var$convertBytesToMegabytes($1b7ceb7dea9fa404$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            avgTotalJSHeapSizeInMB: $1b7ceb7dea9fa404$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $1b7ceb7dea9fa404$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $1b7ceb7dea9fa404$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $1b7ceb7dea9fa404$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $1b7ceb7dea9fa404$var$pressureObserver = new PressureObserver((records)=>{
                if ($1b7ceb7dea9fa404$var$pressureRecordBuffer.length + records.length <= $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH) $1b7ceb7dea9fa404$var$pressureRecordBuffer.push(...records);
            });
            $1b7ceb7dea9fa404$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (err) {
    /* do nothing, this is a best efforts metric */ }
}
function $1b7ceb7dea9fa404$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $1b7ceb7dea9fa404$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($1b7ceb7dea9fa404$var$memoryRecordBuffer.length <= $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH) $1b7ceb7dea9fa404$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $1b7ceb7dea9fa404$export$10899ada382f2ae3() {
    clearInterval($1b7ceb7dea9fa404$var$memoryInterval);
}
function $1b7ceb7dea9fa404$export$b9fdd785f0fc1d40() {
    $1b7ceb7dea9fa404$var$pressureObserver?.disconnect();
}
module.exports["createPressureStateReport"] = $1b7ceb7dea9fa404$export$1f0ff35da084986e;
module.exports["createMemoryStateReport"] = $1b7ceb7dea9fa404$export$3b47ebb9832b4e24;
module.exports["initialisePressureObserver"] = $1b7ceb7dea9fa404$export$117ebc554c6e9f2f;
module.exports["initialiseMemoryObserver"] = $1b7ceb7dea9fa404$export$a3271f53e91faab7;

});

parcelRegister("d36Ll", function(module, exports) {

let $9800cd13931da468$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9800cd13931da468$var$load("813OY").then(()=>parcelRequire('kGADV'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("eGXpu", function(module, exports) {

let $ab23128a70d930e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab23128a70d930e1$var$load("gQfqa").then(()=>parcelRequire('bprG4'));

});

parcelRegister("10huY", function(module, exports) {

let $0bb35d667a864b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bb35d667a864b37$var$load("gLWw8").then(()=>parcelRequire('jyLMo'));

});

parcelRegister("aanDq", function(module, exports) {

var $53d5Q = parcelRequire("53d5Q");

const $f9a9983405b992e1$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $f9a9983405b992e1$var$getAllowedParams() {
    const config = (0, $53d5Q.getConfig)();
    return config?.allowedResourcesParams || $f9a9983405b992e1$var$defaultAllowedParams;
}
function $f9a9983405b992e1$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $f9a9983405b992e1$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
}
let $f9a9983405b992e1$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $f9a9983405b992e1$var$handleQueryParams(url);
    }
};
function $f9a9983405b992e1$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $f9a9983405b992e1$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $f9a9983405b992e1$var$config = newConfig;
}
function $f9a9983405b992e1$export$44487a86467333c3() {
    return $f9a9983405b992e1$var$config;
}
module.exports["configure"] = $f9a9983405b992e1$export$8d21e34596265fa2;
module.exports["getConfig"] = $f9a9983405b992e1$export$44487a86467333c3;

});

parcelRegister("hS38r", function(module, exports) {

var $8litl = parcelRequire("8litl");

const $3117d1f5648443d3$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $3117d1f5648443d3$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $3117d1f5648443d3$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $8litl.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $8litl.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $8litl.roundEpsilon)(entry.startTime),
            duration: (0, $8litl.roundEpsilon)(entry.duration),
            fetchStart: (0, $8litl.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $8litl.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $8litl.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $8litl.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $8litl.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $8litl.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $3117d1f5648443d3$var$getPerformanceObject();
        const PerformanceObserver = $3117d1f5648443d3$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($3117d1f5648443d3$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $3117d1f5648443d3$export$bea963256235a63e.timings = resources.map((resource)=>$3117d1f5648443d3$export$bea963256235a63e.transformResource(resource));
        $3117d1f5648443d3$export$bea963256235a63e.observer = new PerformanceObserver($3117d1f5648443d3$export$bea963256235a63e.addTimings);
        $3117d1f5648443d3$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($3117d1f5648443d3$export$bea963256235a63e.observer) {
            $3117d1f5648443d3$export$bea963256235a63e.observer.disconnect();
            $3117d1f5648443d3$export$bea963256235a63e.observer = null;
        }
        $3117d1f5648443d3$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$3117d1f5648443d3$export$bea963256235a63e.transformResource(entry));
        const overflow = $3117d1f5648443d3$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $3117d1f5648443d3$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $3117d1f5648443d3$export$bea963256235a63e.maxSize;
            $3117d1f5648443d3$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $3117d1f5648443d3$export$bea963256235a63e.timings.push(...entries);
    }
};
function $3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $3117d1f5648443d3$export$4138a729ef1db028(startTime, endTime) {
    const performance = $3117d1f5648443d3$var$getPerformanceObject();
    const PerformanceObserver = $3117d1f5648443d3$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$3117d1f5648443d3$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $3117d1f5648443d3$export$bea963256235a63e.timings.filter((timing)=>$3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime));
}
module.exports["resourceTimingBuffer"] = $3117d1f5648443d3$export$bea963256235a63e;
module.exports["filterResourceTimings"] = $3117d1f5648443d3$export$4138a729ef1db028;

});

parcelRegister("8litl", function(module, exports) {
function $1eb0154571433801$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}
module.exports["roundEpsilon"] = $1eb0154571433801$export$56014375de40214b;

});

parcelRegister("hPcrh", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR = '/';
function $9d50b67dcef9fae2$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $9d50b67dcef9fae2$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $9d50b67dcef9fae2$var$SSR_PREFIX = 'ssr';
function $9d50b67dcef9fae2$var$mapKey(key) {
    if (key === 'total') return $9d50b67dcef9fae2$var$SSR_PREFIX;
    return `${$9d50b67dcef9fae2$var$SSR_PREFIX}${$9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $9d50b67dcef9fae2$var$config;
function $9d50b67dcef9fae2$export$8d21e34596265fa2(ssrConfig) {
    $9d50b67dcef9fae2$var$config = ssrConfig;
}
function $9d50b67dcef9fae2$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return performance.getEntriesByType('navigation')?.[0];
}
function $9d50b67dcef9fae2$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($9d50b67dcef9fae2$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $9d50b67dcef9fae2$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $9d50b67dcef9fae2$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $9d50b67dcef9fae2$export$5300d1b82e594615() {
    const serverTimingsByName = $9d50b67dcef9fae2$var$getServerTimingsByName();
    const edgeTotalDuration = serverTimingsByName['cdn-downstream-fbl']?.duration ?? serverTimingsByName['atl-edge']?.duration;
    if (!edgeTotalDuration) return null;
    const edgeOffset = $9d50b67dcef9fae2$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (serverTimingsByName['cdn-upstream-dns']?.duration || 0) + (serverTimingsByName['cdn-upstream-connect']?.duration || 0);
    const cfUpstreamDuration = (serverTimingsByName['cdn-upstream-fbl']?.duration || 0) - cfInternalDuration;
    const cfDownstreamDuration = (serverTimingsByName['cdn-downstream-fbl']?.duration || 0) - (serverTimingsByName['cdn-upstream-fbl']?.duration || 0);
    const atlEdgeDuration = serverTimingsByName['atl-edge']?.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: serverTimingsByName['cdn-downstream-fbl']?.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: serverTimingsByName['atl-edge-internal']?.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $9d50b67dcef9fae2$export$bf7408e83532dcd0() {
    let defaultSSRTimings = {};
    if ((0, $dh538.fg)('platform_ufo_default_ssr_edge_timings')) defaultSSRTimings = $9d50b67dcef9fae2$export$5300d1b82e594615();
    let configTimings = {};
    if (typeof $9d50b67dcef9fae2$var$config?.getTimings === 'function') configTimings = $9d50b67dcef9fae2$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($9d50b67dcef9fae2$var$filterEntry(entry[1])) acc[$9d50b67dcef9fae2$var$mapKey(entry[0])] = $9d50b67dcef9fae2$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $9d50b67dcef9fae2$export$c7ad864055e75537() {
    return !!$9d50b67dcef9fae2$var$config?.getDoneMark();
}
function $9d50b67dcef9fae2$export$5eade9354185583d() {
    return $9d50b67dcef9fae2$var$config?.getSsrPhaseSuccess?.();
}
function $9d50b67dcef9fae2$export$3def7672244bab0c() {
    return $9d50b67dcef9fae2$var$config?.getDoneMark() ?? undefined;
}
function $9d50b67dcef9fae2$export$1c4a9b5e6e22393d() {
    if (!$9d50b67dcef9fae2$var$config?.getFeatureFlags) return undefined;
    try {
        return $9d50b67dcef9fae2$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}
module.exports["configure"] = $9d50b67dcef9fae2$export$8d21e34596265fa2;
module.exports["getSSRTimings"] = $9d50b67dcef9fae2$export$bf7408e83532dcd0;
module.exports["getSSRSuccess"] = $9d50b67dcef9fae2$export$c7ad864055e75537;
module.exports["getSSRPhaseSuccess"] = $9d50b67dcef9fae2$export$5eade9354185583d;
module.exports["getSSRDoneTime"] = $9d50b67dcef9fae2$export$3def7672244bab0c;
module.exports["getSSRFeatureFlags"] = $9d50b67dcef9fae2$export$1c4a9b5e6e22393d;

});

parcelRegister("8Lf0D", function(module, exports) {
/**
 * Auto Incrementing ID
 *
 * Basic ID generation using a global integer
 */ class $35e1d987475b995b$export$1545ba9ccf1841ab {
    /**
   * ID
   *
   * Returns a stringified auto-incrementing ID
   */ ID() {
        return (++this.incrementor).toString();
    }
    /**
   * Reset
   *
   * Returns the incrementor to its original state
   */ reset() {
        this.incrementor = -1;
    }
    constructor(){
        this.incrementor = -1;
    }
}
module.exports["AutoIncrementingID"] = $35e1d987475b995b$export$1545ba9ccf1841ab;

});

parcelRegister("jy3Cx", function(module, exports) {
/**
 * Cache
 *
 * A generic cache designed to house just about anything. You can implement
 * your own type-safe LRU or just use it as a hash table
 */ class $f95e45deccc3ce2b$export$94affb487e701bf2 {
    /**
   * Data
   *
   * Returns the entirety of the cache
   */ get data() {
        return this._cache;
    }
    /**
   * Get
   *
   * Returns a cache value by key
   */ get(key) {
        return this._cache[key];
    }
    /**
   * Has
   *
   * Returns whether or not a given key exists in the cache
   */ has(key) {
        return this._cache.hasOwnProperty(key);
    }
    /**
   * Set
   *
   * Overrides the value of a given key with the specified value
   */ set(key, value) {
        this._cache[key] = value;
    }
    /**
   * Delete
   *
   * Deletes the specified cache key
   */ delete(key) {
        delete this._cache[key];
    }
    /**
   * Keys
   *
   * Returns all currently set cache keys
   */ get keys() {
        return Object.keys(this._cache);
    }
    /**
   * Values
   *
   * Returns all cached values
   */ get values() {
        return Object.values(this._cache);
    }
    /**
   * Clear
   *
   * Clears all cached values
   */ clear() {
        this._cache = {};
    }
    constructor(cache){
        this._cache = void 0;
        this._cache = cache || {};
    }
}
module.exports["Cache"] = $f95e45deccc3ce2b$export$94affb487e701bf2;

});

parcelRegister("5leFG", function(module, exports) {

var $jy3Cx = parcelRequire("jy3Cx");


var $bPw0L = parcelRequire("bPw0L");

class $e398c0accbc425cf$export$5087227eb54526 extends Map {
    /**
   * Stream
   *
   * Adds a stream of messages to the bus and invokes active
   * subscriptions to the corresponding message types
   */ async stream(events) {
        if (!events.length) return;
        const hash = {};
        for (const event of events){
            if (event.type in hash) hash[event.type].push(event);
            else hash[event.type] = [
                event
            ];
            this.cache(event.type, event);
        }
        await Promise.all(Object.keys(hash).map((key)=>{
            return this.dispatch(key, hash[key]);
        }));
    }
    /**
   * On
   *
   * Allows for registering listeners to incoming message types. Simply
   * pass the message type you wish to receive notifications for and
   * a callback to invoke
   */ on(event, callback) {
        const index = this.get(event) || new (0, $bPw0L.EventIndex)();
        const ID = index.subscribe(callback);
        this.set(event, index);
        return ID;
    }
    /**
   * Off
   *
   * Removes an event listener by event-name and ID
   */ off(event, ID) {
        const index = this.get(event);
        if (index) {
            index.unsubscribe(ID);
            if (index.size === 0) this.delete(event);
        }
    }
    /**
   * Dispatch
   *
   * Invokes all subscriptions for a given event type. Each listener
   * receives its corresponding messages as an argument
   */ async dispatch(event, ...params) {
        const index = this.get(event);
        if (index) await index.dispatch(params);
    }
    /**
   * Cache
   *
   * When caching is enabled, the Event Bus can act as a
   * database for historical message accumulation. To enable
   * this feature, pass `enableCache: true` to the constructor
   */ cache(key, value) {
        if (!this.enableCache) return;
        const values = this.Cache.get(key) || [];
        values.push(value);
        this.Cache.set(key, values);
    }
    constructor(cache){
        super();
        this.enableCache = false;
        this.Cache = new (0, $jy3Cx.Cache)();
        if (cache) this.enableCache = true;
    }
}
module.exports["EventBus"] = $e398c0accbc425cf$export$5087227eb54526;

});

parcelRegister("bPw0L", function(module, exports) {

var $8Lf0D = parcelRequire("8Lf0D");

class $93598c3fbf25b38d$export$8a9c48e07ede8c4b extends Map {
    /**
   * Subscribe
   *
   * Adds a subscription to the index and returns a unique
   * identifier
   */ subscribe(listener) {
        const ID = this.IDs.ID();
        this.set(ID, listener);
        return ID;
    }
    /**
   * Unsubscribe
   *
   * Removes a subscription from the index by ID
   */ unsubscribe(ID) {
        this.delete(ID);
    }
    /**
   * Dispatch
   *
   * Dispatches events to their registered listeners
   */ async dispatch(messages) {
        for (const [_, listener] of this)await Promise.resolve(listener(...messages));
    }
    constructor(...args){
        super(...args);
        this.IDs = new (0, $8Lf0D.AutoIncrementingID)();
    }
}
module.exports["EventIndex"] = $93598c3fbf25b38d$export$8a9c48e07ede8c4b;

});

parcelRegister("5j7rq", function(module, exports) {

let $3dd47fcb8b89f2bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3dd47fcb8b89f2bd$var$load("9SyhI"),
    $3dd47fcb8b89f2bd$var$load("76XJy")
]).then(()=>parcelRequire('a4qOe'));

});

parcelRegister("bZGgW", function(module, exports) {

let $8bb62e98d3878706$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bb62e98d3878706$var$load("gSXIX").then(()=>parcelRequire('kWFOs'));

});

parcelRegister("dYU3e", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");



var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");



var $7Lnfv = parcelRequire("7Lnfv");


var $jQ6FG = parcelRequire("jQ6FG");


var $3joiD = parcelRequire("3joiD");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");


const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   * In component: query getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery or getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    const queryName = (0, $jQ6FG.getQueryName)(name, variables);
    let single = true;
    // If the query has already been preloaded with network only
    // Subsequent query with same name and variable should be done with cache-first to avoid duplicate network request
    (0, $3joiD.flagQueryPreloadedByNetworkOnly)(queryName, variables, fetchPolicy);
    const queryContext = {
        single: single,
        ...context
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // Save current boundary context
    const currentBoundary = window.__PRELOAD_BOUNDARY_NAME__;
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return client.query({
            query: query,
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy,
            context: queryContext
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // Restore the previous boundary context as soon as the query resolves
            window.__PRELOAD_BOUNDARY_NAME__ = currentBoundary;
            const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
            return {
                ...result,
                hasErrors: hasErrors
            };
        });
    })();
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("7NOdL", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $da1ccafc0c457033$export$ab00fc0363cea48f = (0, $eSUdr.default)`query ThemeQuery{lookAndFeel{custom{horizontalHeader{backgroundColor primaryNavigation{highlightColor}}}}}`;
module.exports["ThemeQuery"] = $da1ccafc0c457033$export$ab00fc0363cea48f;

});

parcelRegister("lyWac", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return Promise.allSettled(values).then((results)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            const errors = [];
            for (const result of results){
                if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
                else if (result.status === 'fulfilled') {
                    const fulfilledValue = result.value;
                    if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                    else if (Array.isArray(fulfilledValue)) {
                        const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                        errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                    }
                }
            }
            if (errors.length > 0) {
                // Errors on preloader functions are not meant to break anything.
                // But we still want to know them...
                // eslint-disable-next-line no-console
                console.error('Errors caught by waitForAllReturnWhenError', {
                    errors: errors.map((error)=>error.message)
                });
                return errors;
            }
        });
    })();
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("4vyfK", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $fjiOd = parcelRequire("fjiOd");

function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationWithSpaceKeyQuery),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                spaceKey: spaceKey,
                version: version
            }
        }).then(({ data: data })=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (data?.space?.homepageId) (0, $dYU3e.writeQuery)({
                /* @ts-expect-error http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationQuery),
                variables: {
                    location: Array.isArray(location) ? null : location,
                    locations: Array.isArray(location) ? location : [],
                    contentId: data?.space?.homepageId,
                    spaceKey: null,
                    version: version
                },
                data: {
                    webItemSections: data?.space?.homepageWebSections || []
                }
            });
        });
    })();
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationQuery),
        variables: variables
    });
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("fjiOd", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $78914c14925ace72$export$abf96c374bfacb58 = (0, $eSUdr.default)`query WebItemLocationQuery($location:String$locations:[String]$contentId:ID$spaceKey:String$version:Int){webItemSections(location:$location locations:$locations contentId:$contentId key:$spaceKey version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}`;
const $78914c14925ace72$export$c4b66d2db87918fa = (0, $eSUdr.default)`query WebItemLocationWithSpaceKeyQuery($location:String$locations:[String]$spaceKey:String$version:Int){space(key:$spaceKey){id homepageId homepageWebSections(location:$location locations:$locations version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}}`;
module.exports["WebItemLocationQuery"] = $78914c14925ace72$export$abf96c374bfacb58;
module.exports["WebItemLocationWithSpaceKeyQuery"] = $78914c14925ace72$export$c4b66d2db87918fa;

});

parcelRegister("djivE", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $b39dec7f786be123$export$ee12a476cbc81467 = (0, $eSUdr.default)`query AppNavigationUnifiedQuery{lookAndFeel{custom{horizontalHeader{backgroundColor primaryNavigation{highlightColor}}}}siteConfiguration{customSiteLogo}siteSettings{siteTitle showApplicationTitle}siteDescription{logoUrl}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}user:confluence_atlassianUser(current:true){id confluence{permissionType}}}`;
module.exports["AppNavigationUnifiedQuery"] = $b39dec7f786be123$export$ee12a476cbc81467;

});

parcelRegister("1gIBc", function(module, exports) {

var $hlXJc = parcelRequire("hlXJc");

const $81c46c72467953dc$export$3469c87f51a9319d = (0, $hlXJc.default);
module.exports["ConfluenceFreePoolTargetExperimentQuery"] = $81c46c72467953dc$export$3469c87f51a9319d;

});

parcelRegister("hlXJc", function(module, exports) {
/**
 * @generated SignedSource<<f2eaf12e81c9df2f3ddfc3ecba3ee444>>
 * @relayHash d1109b47420f692c9d571a6491430101
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15b5c888b820d8d6912f252abb07c7e51b1f77a12da7f9c810071e2a8f929fa5
const $5afa799f4cb821b5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
        "kind": "LinkedField",
        "name": "entitlementProfile",
        "plural": false,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfilePaidFeatureUsageResult",
                "kind": "LinkedField",
                "name": "paidFeatureUsage",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "featureName"
                    }
                ]
            },
            {
                "concreteType": "GrowthUnifiedProfileTrialHistoryResult",
                "kind": "LinkedField",
                "name": "trialHistory",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "trialType"
                    }
                ]
            }
        ]
    }, v4 = {
        "args": [
            {
                "kind": "Literal",
                "name": "chargeElement",
                "value": "user"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement",
        "storageKey": "latestUsageForChargeElement(chargeElement:\"user\")"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v7 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "createdAt"
            }
        ],
        "type": "CcpEntitlement"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "standard"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v11 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConfluenceFreePoolTargetExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"standard\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConfluenceFreePoolTargetExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v14 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v14 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"standard\")"
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d1109b47420f692c9d571a6491430101",
            "id": "15b5c888b820d8d6912f252abb07c7e51b1f77a12da7f9c810071e2a8f929fa5",
            "metadata": {},
            "name": "ConfluenceFreePoolTargetExperimentQuery",
            "operationKind": "query",
            "text": "query ConfluenceFreePoolTargetExperimentQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,entitlementProfile{paidFeatureUsage{featureName},trialHistory{trialType}},latestUsageForChargeElement(chargeElement:\"user\"),preDunning{__typename,status},transactionAccount{__typename,isBillToPresent,...on Node{__isNode:__typename,id}},subscription{__typename,trial{__typename,timeLeft},...on CcpSubscription{id}},...on CcpEntitlement{createdAt},experienceCapabilities{__typename,changeOfferingV2(offeringName:\"standard\"){__typename,isAvailableToUser,experienceUrl}},id}}}}"
        }
    };
}();
$5afa799f4cb821b5$var$node.hash = "2c7e6fee64dd7316e53c8a7296d8f97d";
var $5afa799f4cb821b5$export$2e2bcd8739ae039 = $5afa799f4cb821b5$var$node;
module.exports["default"] = $5afa799f4cb821b5$export$2e2bcd8739ae039;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenAIStreamingSpotlight: 'aifc-onboarding:hasSeenAIStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = [
    ...Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575)
];
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("66UJS", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $6d1fd49d30c18d78$export$dfae498b41374c60 = (0, $eSUdr.default)`query GetOnboardingState($key:[String]){onboardingState(key:$key){key value}}`;
const $6d1fd49d30c18d78$export$c27b6f5527b13ff2 = (0, $eSUdr.default)`mutation SetOnboardingState($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`;
module.exports["getOnboardingStateGQL"] = $6d1fd49d30c18d78$export$dfae498b41374c60;
module.exports["setOnboardingStateGQL"] = $6d1fd49d30c18d78$export$c27b6f5527b13ff2;

});

parcelRegister("hAiCi", function(module, exports) {
/**
 * @generated SignedSource<<f38afc5cf1ecbca3e793116d0b0f529a>>
 * @relayHash 7658ddb717a4b391d8bc81365920180f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7cc8812baff3574b87484e9d4defb2826a8648c8a0740eba6603ac7e78f303c5
const $1d80fc45612ce410$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeNav4AdminOptIn"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "value"
    }, v2 = [
        {
            "concreteType": "SiteConfiguration",
            "kind": "LinkedField",
            "name": "siteConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customSiteLogo"
                }
            ]
        },
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "siteTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "showApplicationTitle"
                },
                {
                    "condition": "includeNav4AdminOptIn",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isNav4OptedIn"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "SiteDescription",
            "kind": "LinkedField",
            "name": "siteDescription",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopNavigationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopNavigationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7658ddb717a4b391d8bc81365920180f",
            "id": "7cc8812baff3574b87484e9d4defb2826a8648c8a0740eba6603ac7e78f303c5",
            "metadata": {},
            "name": "TopNavigationQuery",
            "operationKind": "query",
            "text": "query TopNavigationQuery($includeNav4AdminOptIn:Boolean!){siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle,isNav4OptedIn@include(if:$includeNav4AdminOptIn)},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary},photos{value}}}"
        }
    };
}();
$1d80fc45612ce410$var$node.hash = "60341092e84fcf290aa2d48438186979";
var $1d80fc45612ce410$export$2e2bcd8739ae039 = $1d80fc45612ce410$var$node;
module.exports["default"] = $1d80fc45612ce410$export$2e2bcd8739ae039;

});

parcelRegister("74VX5", function(module, exports) {
/**
 * @generated SignedSource<<6dbe057c43272742b66eaa5c5b9d4422>>
 * @relayHash 13e9ccffd4783d3489f7fdc0bdb79076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8
const $7964c46f2f85665b$var$node = function() {
    var v0 = [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "13e9ccffd4783d3489f7fdc0bdb79076",
            "id": "9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8",
            "metadata": {},
            "name": "NotificationsButtonQuery",
            "operationKind": "query",
            "text": "query NotificationsButtonQuery{notifications{unseenNotificationCount}}"
        }
    };
}();
$7964c46f2f85665b$var$node.hash = "942a544fd139c706378825d031824679";
var $7964c46f2f85665b$export$2e2bcd8739ae039 = $7964c46f2f85665b$var$node;
module.exports["default"] = $7964c46f2f85665b$export$2e2bcd8739ae039;

});

parcelRegister("a1A9A", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $584545d3b04636eb$export$7ddbcd2882651055 = (0, $eSUdr.default)`query OperationsQuery{siteOperations{userProfile application}}`;
module.exports["OperationsQuery"] = $584545d3b04636eb$export$7ddbcd2882651055;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$ed215fd77db898ec(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToScriptTags"] = $372ebd682f0fb003$export$ed215fd77db898ec;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("eS4vC", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");




var $4VJDS = parcelRequire("4VJDS");

const $a98f386ac75dbb32$var$DEFAULT_DATA_FETCHER_TIMEOUT = 1000;
class $a98f386ac75dbb32$var$DataFetcherTimeoutError extends Error {
}
function $a98f386ac75dbb32$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
function $a98f386ac75dbb32$export$818f8a0f43a80504() {
    if (window.__SSR_REACT_STREAMING__) return Object.values(window.__dataFetcherForSuspense__ || {}).every((dataFetcher)=>{
        // All query are put into default category. No Suspense should wait for default.
        return !dataFetcher.isPending();
    });
    return true;
}
async function $a98f386ac75dbb32$export$bcf8c46c380b2b4c(promises) {
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return Promise.allSettled(promises).then((results)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            const errors = results.filter((result)=>result.status === 'rejected').map((result)=>result.reason);
            // Keep the same interface as Promise.all putting all other errors in otherErrors field
            if (errors.length > 0) {
                // eslint-disable-next-line no-console
                console.error(`Error caught by createDataFetcherForSuspense`, {
                    errors: errors.map((error)=>error.message)
                });
                const error = errors[0];
                if (errors.length > 1) error.otherErrors = errors.slice(1);
                throw error;
            }
            return results.filter((result)=>result.status === 'fulfilled').map((result)=>result.value);
        });
    })();
}
function $a98f386ac75dbb32$export$51ac369f090007c2(dataFetcherName, callback) {
    window.__PRELOAD_BOUNDARY_NAME__ = dataFetcherName;
    let promise;
    try {
        promise = callback();
    } catch (error) {
        promise = Promise.reject(error);
    }
    promise = promise ?? Promise.resolve();
    if (Array.isArray(promise)) promise = $a98f386ac75dbb32$export$bcf8c46c380b2b4c(promise);
    if (!window.__SSR_REACT_STREAMING__) return promise;
    if (!window.__dataFetcherForSuspense__) window.__dataFetcherForSuspense__ = {};
    const dataFetcher = window.__dataFetcherForSuspense__[dataFetcherName];
    if (!dataFetcher) window.__dataFetcherForSuspense__[dataFetcherName] = $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, promise);
    // Restore the default boundary
    window.__PRELOAD_BOUNDARY_NAME__ = 'default';
    return Promise.resolve();
}
function $a98f386ac75dbb32$var$guardTimeout(name, promise) {
    const dataFetcherTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_data_fetcher_timeout', $a98f386ac75dbb32$var$DEFAULT_DATA_FETCHER_TIMEOUT);
    return Promise.race([
        promise,
        new Promise((_, reject)=>setTimeout(()=>{
                reject(new $a98f386ac75dbb32$var$DataFetcherTimeoutError(`Data fetcher ${name} timeout in ${dataFetcherTimeout}ms`));
            }, dataFetcherTimeout))
    ]);
}
function $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, promise) {
    let dataResult = null;
    let errorResult = null;
    let promiseState = 'pending';
    const measureName = `ssr-app/stream/dataFetcher:${dataFetcherName}`;
    const suspender = new Promise((resolve)=>{
        (()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (()=>{
                const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
                return $a98f386ac75dbb32$var$guardTimeout(dataFetcherName, promise).then((result)=>{
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
                    dataResult = result;
                    promiseState = 'resolved';
                    resolve();
                });
            })().catch((error)=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                errorResult = error;
                promiseState = 'error';
                // When encountered multiple errors, errors other than the first one are stored in otherErrors field.
                const errors = [
                    error
                ].concat(error.otherErrors || []);
                for (const err of errors)// eslint-disable-next-line no-console
                console.error(`Error when preloading query for data fetcher ${dataFetcherName}: ${err.message}`);
                resolve();
            });
        })();
    });
    return {
        getName () {
            return dataFetcherName;
        },
        isTimeout () {
            return errorResult instanceof $a98f386ac75dbb32$var$DataFetcherTimeoutError;
        },
        getError () {
            return errorResult;
        },
        isPending () {
            return promiseState === 'pending';
        },
        getPromise () {
            return promise;
        },
        read () {
            if (promiseState === 'pending') throw suspender;
            else if (promiseState === 'error') // Data fetcher is a wrapper of preloader. If an error happened we don't want to blow up the tree too early.
            // Return null here to signal the Suspense to continue.
            // The normal error handling in the component will take care of it.
            return null;
            else if (promiseState === 'resolved') return dataResult;
        }
    };
}
module.exports["getDataFetcherForSuspense"] = $a98f386ac75dbb32$export$63116239d47be9ca;
module.exports["createDataFetcherForSuspense"] = $a98f386ac75dbb32$export$51ac369f090007c2;

});

parcelRegister("5btyx", function(module, exports) {

var $5O1YC = parcelRequire("5O1YC");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/workspace/manifest.ts
var $3c64e80b41bd68bf$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5O1YC.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $5O1YC.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $3c64e80b41bd68bf$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $3c64e80b41bd68bf$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $3c64e80b41bd68bf$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $3c64e80b41bd68bf$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $3c64e80b41bd68bf$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $3c64e80b41bd68bf$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $3c64e80b41bd68bf$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $3c64e80b41bd68bf$export$d47d8a7e69df1865;

});

parcelRegister("5O1YC", function(module, exports) {
// src/confluence/workspace/types.ts
var $43a327cfc847ac6c$export$19f1a63686ec0369 = "confluence", $43a327cfc847ac6c$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $43a327cfc847ac6c$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $43a327cfc847ac6c$export$f1c423a93fbc71;

});

parcelRegister("liVIA", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $f8280d0c6d55064a$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $f8280d0c6d55064a$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f8280d0c6d55064a$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $f8280d0c6d55064a$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f8280d0c6d55064a$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $f8280d0c6d55064a$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f8280d0c6d55064a$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f8280d0c6d55064a$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $f8280d0c6d55064a$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$a651929fa48b856 = 'nthUserOnboardingFlagViewed';
const $3c94963df51c0e13$export$26694bcd9ab12240 = 'nthUserOnboardingPageViewed';
const $3c94963df51c0e13$export$ff82dad92156967f = 'nthUserGSPagePath';
const $3c94963df51c0e13$export$a05aab42c7cc2cd2 = 'nthUserBannerDismissed';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$aae58c16337c3635 = {
    BULK_ACTIONS_CHANGEBOARDING_SPOTLIGHT_DISMISSED: 'content-tree-bulk-actions:isBulkActionsChangeboardingSpotlightDismissed'
};
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$cba7fd986c721ece = {
    HAS_DISMISSED_MODAL: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
    HAS_DISMISSED_BANNER: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$cd598425c00dde23 = {
    HAS_AUTO_FOLLOWED_TEAMMATES: 'nth-user-auto-follow-teammates:hasAutoFollowedTeammates',
    AUTO_FOLLOW_BANNER_DISMISSED: 'nth-user-auto-follow-teammates:autoFollowBannerDismissed',
    AUTO_FOLLOW_BANNER_SHOWN_AT: 'nth-user-auto-follow-teammates:autoFollowBannerShownAt'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$80e5e8b49cc0805c = 'revamped-bpqa:showRevampedBpqaForFoundingAdmin';
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$f9ff90838813e652 = {
    FIRST_PASTE_VIEWED: 'improve-writing-on-paste:firstPasteViewed',
    SECOND_PASTE_VIEWED: 'improve-writing-on-paste:secondPasteViewed'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IMPROVED_GET_STARTED_NTH_USER_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$ff82dad92156967f}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`,
    NTH_USER_ONBOARDING_FLAG_VIEWED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$a651929fa48b856}`,
    NTH_USER_ONBOARDING_PAGE_VIEWED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$26694bcd9ab12240}`,
    NTH_USER_BANNER_DISMISSED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$a05aab42c7cc2cd2}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$80e5e8b49cc0805c,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$cba7fd986c721ece),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$aae58c16337c3635),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$cd598425c00dde23),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$f9ff90838813e652),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3)
];
module.exports["PEOPLE"] = $3c94963df51c0e13$export$f35f2899eb1390e3;
module.exports["NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP"] = $3c94963df51c0e13$export$275d3dda87d2fa7a;
module.exports["NTH_USER_ONBOARDING_FLAG_VIEWED"] = $3c94963df51c0e13$export$a651929fa48b856;
module.exports["NTH_USER_ONBOARDING_PAGE_VIEWED"] = $3c94963df51c0e13$export$26694bcd9ab12240;
module.exports["IMPROVED_GET_STARTED_NTH_USER_PATH"] = $3c94963df51c0e13$export$ff82dad92156967f;
module.exports["HELP"] = $3c94963df51c0e13$export$da223e550b96c9d6;
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$b99b309b286adebc;
module.exports["IS_NAV_4_SPACE_TOUR_DISMISSED"] = $3c94963df51c0e13$export$20b0548cf5859d6;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CONTENT_TREE_BULK_ACTIONS"] = $3c94963df51c0e13$export$aae58c16337c3635;
module.exports["MODERNIZE_CONFLUENCE_IPM_MODAL"] = $3c94963df51c0e13$export$cba7fd986c721ece;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["NTH_USER_AUTO_FOLLOW_TEAMMATES"] = $3c94963df51c0e13$export$cd598425c00dde23;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["IMPROVE_WRITING_ON_PASTE"] = $3c94963df51c0e13$export$f9ff90838813e652;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("8CHHT", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $9WAeG = parcelRequire("9WAeG");


var $xwvlW = parcelRequire("xwvlW");


var $d9tcB = parcelRequire("d9tcB");


var $3mugH = parcelRequire("3mugH");


var $9wGTI = parcelRequire("9wGTI");


var $7bGfj = parcelRequire("7bGfj");


var $ai75e = parcelRequire("ai75e");


var $3b6WO = parcelRequire("3b6WO");


var $g36ZK = parcelRequire("g36ZK");


var $8n0y0 = parcelRequire("8n0y0");

const $23196774779b9db8$export$c2a4ad12f3f7d068 = async (staticContext, extensions, contentId, spaceKey, moduleType)=>{
    // We suspend all GraphQL requests once React rendering starts.
    // However, this would cause the query here to never resolve, making the sidebar wait forever.
    // The preload flag tells next/packages/graphql/src/links/SSRLink.ts to allow this query since it is part of preloading.
    const fetchContext = {
        contentId: contentId,
        spaceKey: spaceKey,
        preload: true
    };
    const filteredResult = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $ai75e.filterExtensionsByDisplayConditions)(extensions, staticContext, fetchContext);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    $23196774779b9db8$var$setWindowExtensions(moduleType, filteredResult.extsToDisplay, filteredResult.conditionsError);
};
const $23196774779b9db8$var$setWindowExtensions = (moduleType, extensions, error)=>{
    window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
    window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
        extensions: extensions,
        error: error
    };
};
async function $23196774779b9db8$export$afb6180712276ba1({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, queryOptions: queryOptions, expandAppOwner: expandAppOwner = false, skipFilter: skipFilter = false }) {
    const { cloudId: cloudId, activationId: activationId, isLoggedIn: isLoggedIn, accessStatus: accessStatus, locale: locale } = (0, $xwvlW.getPreloaderFnContext)();
    const hasAccessNarrowingSupport = (0, $3b6WO.supportsAccessNarrowing)(moduleType);
    const isAnonymous = !isLoggedIn;
    const isExternalCollaborator = accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:ForgeExtensionList', async ()=>{
        try {
            if ((0, $9wGTI.fg)('use_new_forge_extension_list_call')) {
                const extensions = await (async ()=>{
                    const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                    const _asyncResult2 = await (0, $8n0y0.preloadForgeApps)({
                        cloudId: cloudId,
                        locale: locale,
                        types: [
                            moduleType
                        ],
                        context: {
                            spaceKey: spaceKey,
                            contentId: contentId
                        },
                        includeHidden: false
                    });
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                    return _asyncResult2;
                })();
                if (extensions) $23196774779b9db8$var$setWindowExtensions(moduleType, extensions, undefined);
            } else {
                // eslint-disable-next-line check-preloaders/no-promise-all
                const [staticContext, extensions] = await (async ()=>{
                    const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
                    const _asyncResult3 = await Promise.all([
                        (0, $7bGfj.preloadUseStaticContext)({
                            spaceKey: spaceKey
                        }),
                        (0, $g36ZK.preloadExtensions)({
                            spaceKey: spaceKey,
                            cloudId: cloudId,
                            activationId: activationId,
                            locale: locale,
                            hasAccessNarrowingSupport: hasAccessNarrowingSupport,
                            expandAppOwner: expandAppOwner,
                            moduleType: moduleType,
                            queryOptions: queryOptions,
                            skip: isAnonymous || isExternalCollaborator,
                            skipFilter: skipFilter
                        })
                    ]);
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
                    return _asyncResult3;
                })();
                if (extensions) await (async ()=>{
                    const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
                    const _asyncResult4 = await $23196774779b9db8$export$c2a4ad12f3f7d068(staticContext, extensions, contentId, spaceKey, moduleType);
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
                    return _asyncResult4;
                })();
            }
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Filed to get forge extension list: ${e.message}`));
        }
    });
}
module.exports["preloadUseExtensionList"] = $23196774779b9db8$export$afb6180712276ba1;

});

parcelRegister("7bGfj", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $xwvlW = parcelRequire("xwvlW");


var $dYU3e = parcelRequire("dYU3e");


var $w033M = parcelRequire("w033M");


var $fWkVZ = parcelRequire("fWkVZ");


var $3mugH = parcelRequire("3mugH");


var $fZP6u = parcelRequire("fZP6u");


var $lW4X5 = parcelRequire("lW4X5");

async function $2425eddd602024a2$export$b1ba723b791aac28({ spaceKey: spaceKey }) {
    const { isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    try {
        // eslint-disable-next-line check-preloaders/no-promise-all
        const [{ data: spaceAdminData }, { data: privilegeData }] = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await Promise.all([
                (0, $dYU3e.query)({
                    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fZP6u.DisplayConditionsSpaceAdminQuery),
                    variables: {
                        spaceKey: spaceKey
                    }
                }),
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $dYU3e.query)({
                    query: (0, $lW4X5.UserPrivilegeQuery)
                })
            ]);
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        const isSpaceAdmin = spaceAdminData?.space?.currentUser?.isAdmin;
        const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(privilegeData);
        const isAdmin = isSiteAdmin || (0, $fWkVZ.getIsProductAdminFromQuery)(privilegeData);
        return {
            isSpaceAdmin: isSpaceAdmin,
            isLoggedIn: isLoggedIn,
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin
        };
    } catch (e) {
        (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Cannot preload data for useStaticContext, using defaults for SSR: ${e.message}`));
        return {
            isLoggedIn: isLoggedIn,
            isSpaceAdmin: false,
            isAdmin: false,
            isSiteAdmin: false
        };
    }
}
module.exports["preloadUseStaticContext"] = $2425eddd602024a2$export$b1ba723b791aac28;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("fZP6u", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b1231f710711408a$export$f23a0916c5538950 = (0, $eSUdr.default)`query DisplayConditionsSpaceAdminQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}}}`;
module.exports["DisplayConditionsSpaceAdminQuery"] = $b1231f710711408a$export$f23a0916c5538950;

});

parcelRegister("lW4X5", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $1d2ccf453314b8e9$export$7f7daa8dea90d2b2 = (0, $eSUdr.default)`query UserPrivilegeQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`;
module.exports["UserPrivilegeQuery"] = $1d2ccf453314b8e9$export$7f7daa8dea90d2b2;

});

parcelRegister("ai75e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3GH4X = parcelRequire("3GH4X");


var $6a9Hv = parcelRequire("6a9Hv");


var $inPa6 = parcelRequire("inPa6");


var $72sWB = parcelRequire("72sWB");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $e4o8D = parcelRequire("e4o8D");


var $7Ndnw = parcelRequire("7Ndnw");


var $hEvd5 = parcelRequire("hEvd5");


var $hrNEt = parcelRequire("hrNEt");

const $3dc7d80f22ba1523$var$noExtensions = [];
const $3dc7d80f22ba1523$var$extendStaticContext = (baseContext, ext)=>{
    const { hasAccess: hasAppAccess = false } = ext.userAccess || {};
    const { active: appIsLicensed = false, capabilitySet: capabilitySet } = ext.license || {};
    const appEdition = $3dc7d80f22ba1523$var$mapCapabilitySetToEdition(capabilitySet);
    const extendedContext = {
        ...baseContext,
        hasAppAccess: hasAppAccess,
        appIsLicensed: appIsLicensed,
        ...appEdition && {
            appEdition: appEdition
        }
    };
    return extendedContext;
};
const $3dc7d80f22ba1523$var$mapCapabilitySetToEdition = (capabilitySet)=>{
    switch(capabilitySet){
        case 'capabilityStandard':
            return 'standard';
        case 'capabilityAdvanced':
            return 'advanced';
        case 'capabilityFree':
            return 'free';
        default:
            return capabilitySet;
    }
};
const $3dc7d80f22ba1523$var$initiateConditionsCheck = (extensions, dataProvider, staticContext)=>{
    // TODO(rtoropov): Add displayConditions to Extension type to avoid conversion to 'any'.
    return extensions.map((ext)=>{
        const conditions = ext.properties.displayConditions;
        if (!conditions) return true;
        const contextToUse = $3dc7d80f22ba1523$var$extendStaticContext(staticContext, ext);
        return (0, $72sWB.doesMeetConditions)(conditions, contextToUse, dataProvider);
    }).map((boolOrPromise)=>typeof boolOrPromise === 'boolean' ? Promise.resolve(boolOrPromise) : boolOrPromise);
};
const $3dc7d80f22ba1523$var$maybeFetchPropertyData = (dataProvider, fetchContext, fetchErrorRef)=>{
    if (dataProvider.propertyValueRequests.length) (0, $hEvd5.fetchPropertyData)(dataProvider.propertyValueRequests, fetchContext).then((response)=>dataProvider.resolve({
            propertyValues: response
        })).catch((error)=>{
        fetchErrorRef.error = error;
        (0, $7Sm4c.markErrorAsHandled)(error);
        return dataProvider.reject(error);
    });
};
const $3dc7d80f22ba1523$var$hasConditions = (extension)=>extension.properties.displayConditions;
const $3dc7d80f22ba1523$var$getAnalyticsEvent = ({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, allExtensions: allExtensions, displayedExtensions: displayedExtensions, propertyRequests: propertyRequests, fetchError: fetchError, conditionsError: conditionsError })=>{
    const requestCountByEntityType = (0, (/*@__PURE__*/$parcel$interopDefault($3GH4X)))(// Remove requests for the same property key and same entity type (could be multiple because of `objectName` attr).
    (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(propertyRequests, (req)=>req.entity + req.propertyKey), (request)=>request.entity);
    return {
        type: 'sendOperationalEvent',
        data: {
            containerType: 'space',
            containerId: spaceKey,
            objectType: 'page',
            objectId: contentId,
            source: moduleType,
            action: 'displayConditionsProcessed',
            actionSubject: 'forgeUIExtensions',
            actionSubjectId: moduleType,
            attributes: {
                totalExtensions: allExtensions.length,
                totalWithConditions: allExtensions.filter($3dc7d80f22ba1523$var$hasConditions).length,
                totalDisplayed: displayedExtensions.length,
                fetchedPropertyCounts: requestCountByEntityType,
                fetchFailed: Boolean(fetchError),
                conditionsFailed: Boolean(conditionsError)
            }
        }
    };
};
const $3dc7d80f22ba1523$var$handleFulfilled = (results, extensions)=>extensions.filter((_, i)=>results[i].status === 'fulfilled' && results[i].value);
const $3dc7d80f22ba1523$var$handleRejected = (results)=>{
    const reason = results.find((result)=>result.status === 'rejected')?.reason;
    return reason ? new Error(reason.message || reason) : undefined;
};
// If the module supports and uses useExtensionsFilteredByDisplayConditions hook, the module name should be added to the array below
const $3dc7d80f22ba1523$var$supportedDisplayConditionsModules = new Set([
    (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
    (0, $7Ndnw.FORGE_MODULE_BYLINE),
    (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
    (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
    (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
    (0, $7Ndnw.FORGE_MODULE_GLOBAL_SETTINGS),
    (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
    (0, $7Ndnw.FORGE_MODULE_SPACE_SETTINGS)
]);
const $3dc7d80f22ba1523$export$fe102d81db9ee117 = async (extensions, staticContext, fetchContext)=>{
    const dataProvider = new (0, $72sWB.ClientDataProvider)();
    // This function has side effects to set dataProvider.propertyValueRequests used in maybeFetchPropertyData
    const resultsPromises = $3dc7d80f22ba1523$var$initiateConditionsCheck(extensions, dataProvider, staticContext);
    const fetchErrorRef = {};
    // This function has side effects that if it is not called before allSettled, the promise below will never resolve.
    $3dc7d80f22ba1523$var$maybeFetchPropertyData(dataProvider, fetchContext, fetchErrorRef);
    const results = await Promise.allSettled(resultsPromises);
    const extsToDisplay = $3dc7d80f22ba1523$var$handleFulfilled(results, extensions);
    const conditionsError = $3dc7d80f22ba1523$var$handleRejected(results);
    return {
        dataProvider: dataProvider,
        extsToDisplay: extsToDisplay,
        conditionsError: conditionsError,
        fetchError: fetchErrorRef.error
    };
};
function $3dc7d80f22ba1523$export$7e85617fdd979ffe(moduleType, allExtensions, extensionsLoading, extensionsError) {
    const extensions = !allExtensions.length ? $3dc7d80f22ba1523$var$noExtensions : allExtensions;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { staticContext: staticContext, loading: staticContextLoading, error: staticContextError } = (0, $hrNEt.useStaticContext)({
        moduleType: moduleType,
        spaceKey: spaceKey
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [extensionsState, setExtensionsState] = (0, $42omo.useState)(()=>{
        // Only use the cached data once on server-side and when hydrate
        const serverOrSSRRendered = renderServerPlaceholder || window.__SSR_RENDERED__;
        const hasContext = !staticContextLoading && staticContext;
        if (serverOrSSRRendered && hasContext && window.__SSR_FORGE_EXTENSIONS__) {
            const cached = window.__SSR_FORGE_EXTENSIONS__[moduleType];
            if (cached) {
                if (window.__SSR_RENDERED__ && !window.__SSR_REACT_STREAMING__) // Ensure on client-side the cached data only used once when hydrate.
                delete window.__SSR_FORGE_EXTENSIONS__[moduleType];
                return {
                    ...cached,
                    loading: false
                };
            }
        }
        return {
            extensions: $3dc7d80f22ba1523$var$noExtensions,
            loading: true,
            error: undefined
        };
    });
    (0, $42omo.useEffect)(()=>{
        const serverOrSSRRendered = renderServerPlaceholder || window.__SSR_RENDERED__;
        const hasContext = !staticContextLoading && staticContext;
        if (serverOrSSRRendered && hasContext && window.__SSR_FORGE_EXTENSIONS__ && window.__SSR_REACT_STREAMING__) {
            const cached = window.__SSR_FORGE_EXTENSIONS__[moduleType];
            if (cached) {
                if (window.__SSR_RENDERED__) // Ensure on client-side the cached data only used once when hydrate.
                delete window.__SSR_FORGE_EXTENSIONS__[moduleType];
            }
        }
    }, [
        extensionsState,
        renderServerPlaceholder,
        staticContext,
        staticContextLoading,
        moduleType
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!$3dc7d80f22ba1523$var$supportedDisplayConditionsModules.has(moduleType)) {
            setExtensionsState({
                extensions: extensions,
                loading: extensionsLoading,
                error: extensionsError
            });
            return;
        }
        if (extensionsError || staticContextError) {
            setExtensionsState({
                extensions: $3dc7d80f22ba1523$var$noExtensions,
                loading: false,
                error: extensionsError || staticContextError
            });
            return;
        }
        if (staticContextLoading || extensionsLoading) return;
        const fetchContext = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $3dc7d80f22ba1523$export$fe102d81db9ee117(extensions, staticContext, fetchContext).then(({ dataProvider: dataProvider, extsToDisplay: extsToDisplay, conditionsError: conditionsError, fetchError: fetchError })=>{
            setExtensionsState({
                extensions: extsToDisplay,
                loading: false,
                error: conditionsError
            });
            if (extensions.some($3dc7d80f22ba1523$var$hasConditions)) createAnalyticsEvent($3dc7d80f22ba1523$var$getAnalyticsEvent({
                contentId: contentId,
                spaceKey: spaceKey,
                moduleType: moduleType,
                allExtensions: extensions,
                displayedExtensions: extsToDisplay,
                propertyRequests: dataProvider.propertyValueRequests,
                fetchError: fetchError,
                conditionsError: conditionsError
            })).fire();
        });
    }, [
        extensions,
        staticContext,
        extensionsLoading,
        staticContextLoading,
        extensionsError,
        staticContextError,
        contentId,
        spaceKey,
        moduleType,
        createAnalyticsEvent
    ]);
    return extensionsState;
}
module.exports["filterExtensionsByDisplayConditions"] = $3dc7d80f22ba1523$export$fe102d81db9ee117;
module.exports["useExtensionsFilteredByDisplayConditions"] = $3dc7d80f22ba1523$export$7e85617fdd979ffe;

});

parcelRegister("3GH4X", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $2af6b5f2fc42996a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2af6b5f2fc42996a$var$hasOwnProperty = $2af6b5f2fc42996a$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $2af6b5f2fc42996a$var$countBy = $77wHb(function(result, value, key) {
    if ($2af6b5f2fc42996a$var$hasOwnProperty.call(result, key)) ++result[key];
    else $3PAnx(result, key, 1);
});
module.exports = $2af6b5f2fc42996a$var$countBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("72sWB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("7Aqra")), module.exports);

$hXuPC.__exportStar((parcelRequire("crtnq")), module.exports);

});

parcelRegister("7Aqra", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesMeetConditions = void 0;

var $kxK2Z = parcelRequire("kxK2Z");


var $8psx2 = parcelRequire("8psx2");


var $7woy3 = parcelRequire("7woy3");

var $5860670df9908f5c$var$unhandledOperation = function(operation) {
    throw new Error($8psx2.errors.unhandledOperation(operation));
};
var $5860670df9908f5c$var$checkOperation = function(operation, conditionsInput, staticContextInput, clientData) {
    var conditions = $kxK2Z.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    var staticContext = $kxK2Z.isObject(staticContextInput) ? staticContextInput : {};
    var staticKeys = [];
    var operationEntries = [];
    var propertyConditions;
    if (Array.isArray(conditions)) propertyConditions = conditions;
    else {
        staticKeys = Object.keys(conditions).filter($kxK2Z.isStaticKey);
        propertyConditions = Object.entries(conditions).filter(function(_a) {
            var key = _a[0];
            return $kxK2Z.isEntityPropertyCondition(key);
        }).map(function(_a) {
            var _b;
            var key = _a[0], condition = _a[1];
            return _b = {}, _b[key] = condition, _b;
        });
        operationEntries = Object.entries(conditions).filter(function(_a) {
            var key = _a[0], _ = _a[1];
            return $kxK2Z.isOperation(key);
        });
    }
    var staticKeysLength = staticKeys.length;
    var operationsLength = operationEntries.length;
    var propertyConditionsLength = propertyConditions.length;
    var staticEqualityComparator = function(key) {
        return (Array.isArray(conditions[key]) ? conditions[key] : [
            conditions[key]
        ]).includes(staticContext[key]);
    };
    if (staticKeysLength === 0 && operationsLength === 0 && propertyConditionsLength === 0) return $kxK2Z.Instruction.Skip;
    if (staticKeysLength !== 0 || propertyConditionsLength !== 0) {
        var clientDataConditionResult = void 0;
        switch(operation){
            case $kxK2Z.AND_OPERATION:
                if (staticKeysLength && !staticKeys.every(staticEqualityComparator)) return false;
                clientDataConditionResult = $7woy3.entityPropertyHandlers[$kxK2Z.AND_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== $kxK2Z.Instruction.Continue) return clientDataConditionResult;
                break;
            case $kxK2Z.OR_OPERATION:
                if (staticKeysLength && staticKeys.some(staticEqualityComparator)) return true;
                clientDataConditionResult = $7woy3.entityPropertyHandlers[$kxK2Z.OR_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== $kxK2Z.Instruction.Continue) return clientDataConditionResult;
                break;
            case $kxK2Z.NOT_OPERATION:
                if (staticKeysLength && staticKeys.some(function(key) {
                    return !staticEqualityComparator(key);
                })) return true;
                clientDataConditionResult = $7woy3.entityPropertyHandlers[$kxK2Z.NOT_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== $kxK2Z.Instruction.Continue) return clientDataConditionResult;
                break;
            default:
                return $5860670df9908f5c$var$unhandledOperation(operation);
        }
    }
    for(var index = 0; index < operationEntries.length; index += 1){
        var _a = operationEntries[index], nextOperation = _a[0], nextConditions = _a[1];
        var nextOperationResult = $5860670df9908f5c$var$checkOperation(nextOperation, nextConditions, staticContext, clientData);
        if (nextOperationResult === $kxK2Z.Instruction.NeedData) return nextOperationResult;
        switch(operation){
            case $kxK2Z.AND_OPERATION:
                if (nextOperationResult === false) return false;
                if (nextOperationResult === $kxK2Z.Instruction.Skip && operationsLength === 1) return staticKeysLength + propertyConditionsLength === 0 ? $kxK2Z.Instruction.Skip : true;
                break;
            case $kxK2Z.OR_OPERATION:
                if (nextOperationResult === true) return true;
                if (nextOperationResult === $kxK2Z.Instruction.Skip && operationsLength === 1) return staticKeysLength + propertyConditionsLength === 0 ? $kxK2Z.Instruction.Skip : false;
                break;
            case $kxK2Z.NOT_OPERATION:
                if (nextOperationResult === false) return true;
                if (nextOperationResult === $kxK2Z.Instruction.Skip && operationsLength === 1) return staticKeysLength + propertyConditionsLength === 0 ? $kxK2Z.Instruction.Skip : false;
                break;
            default:
                return $5860670df9908f5c$var$unhandledOperation(operation);
        }
    }
    switch(operation){
        case $kxK2Z.AND_OPERATION:
            return true;
        case $kxK2Z.OR_OPERATION:
            return false;
        case $kxK2Z.NOT_OPERATION:
            return false;
        default:
            return $5860670df9908f5c$var$unhandledOperation(operation);
    }
};
var $5860670df9908f5c$var$validateNesting = function(conditionsInput, nesting) {
    if (nesting === void 0) nesting = 0;
    if (nesting >= 10) throw new Error($8psx2.errors.nestingOvercomplicated());
    var conditions = $kxK2Z.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    if (Array.isArray(conditions)) return;
    Object.entries(conditions).filter(function(_a) {
        var key = _a[0], _ = _a[1];
        return $kxK2Z.isOperation(key);
    }).forEach(function(_a) {
        var _ = _a[0], condition = _a[1];
        return $5860670df9908f5c$var$validateNesting(condition, nesting + 1);
    });
};
module.exports.doesMeetConditions = function(conditions, staticContext, clientDataProvider) {
    try {
        $5860670df9908f5c$var$validateNesting(conditions);
        var result_1 = $5860670df9908f5c$var$checkOperation($kxK2Z.AND_OPERATION, conditions, staticContext);
        if (result_1 !== $kxK2Z.Instruction.NeedData) return result_1 === $kxK2Z.Instruction.Skip ? true : result_1;
        if (!clientDataProvider) return false;
        return clientDataProvider.fetchPropertyValues($7woy3.collectEntityPropertiesToFetch(conditions)).then(function(clientData) {
            result_1 = $5860670df9908f5c$var$checkOperation($kxK2Z.AND_OPERATION, conditions, staticContext, clientData);
            return result_1 === $kxK2Z.Instruction.Skip ? true : result_1;
        }).catch(function() {
            return false;
        });
    } catch (_a) {
        return false;
    }
};

});

parcelRegister("kxK2Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isStaticKey = module.exports.isEntityPropertyCondition = module.exports.isOperation = module.exports.isObjectOrArray = module.exports.isObject = module.exports.Instruction = module.exports.SUPPORTED_OPERATIONS = module.exports.NOT_OPERATION = module.exports.OR_OPERATION = module.exports.AND_OPERATION = void 0;

var $crtnq = parcelRequire("crtnq");

module.exports.AND_OPERATION = 'and';
module.exports.OR_OPERATION = 'or';
module.exports.NOT_OPERATION = 'not';
module.exports.SUPPORTED_OPERATIONS = [
    module.exports.AND_OPERATION,
    module.exports.OR_OPERATION,
    module.exports.NOT_OPERATION
];
var $ef4a9bc23e9dfffa$var$Instruction;
(function(Instruction) {
    Instruction["Skip"] = "skip";
    Instruction["NeedData"] = "need-data";
    Instruction["Continue"] = "continue";
})($ef4a9bc23e9dfffa$var$Instruction = module.exports.Instruction || (module.exports.Instruction = {}));
module.exports.isObject = function(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
};
module.exports.isObjectOrArray = function(x) {
    return module.exports.isObject(x) || Array.isArray(x);
};
module.exports.isOperation = function(key) {
    return module.exports.SUPPORTED_OPERATIONS.includes(key);
};
module.exports.isEntityPropertyCondition = function(key) {
    return Object.values($crtnq.PropertyConditionType).includes(key);
};
module.exports.isStaticKey = function(key) {
    return !module.exports.isOperation(key) && !module.exports.isEntityPropertyCondition(key);
};

});

parcelRegister("crtnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientDataProvider = module.exports.EntityType = module.exports.PropertyConditionType = void 0;
var $90eecb456f971fbb$var$PropertyConditionType;
(function(PropertyConditionType) {
    PropertyConditionType["EntityPropertyExists"] = "entityPropertyExists";
    PropertyConditionType["EntityPropertyEqualTo"] = "entityPropertyEqualTo";
    PropertyConditionType["EntityPropertyContainsAny"] = "entityPropertyContainsAny";
    PropertyConditionType["EntityPropertyContainsAll"] = "entityPropertyContainsAll";
})($90eecb456f971fbb$var$PropertyConditionType = module.exports.PropertyConditionType || (module.exports.PropertyConditionType = {}));
var $90eecb456f971fbb$var$EntityType;
(function(EntityType) {
    EntityType["Space"] = "space";
    EntityType["Content"] = "content";
})($90eecb456f971fbb$var$EntityType = module.exports.EntityType || (module.exports.EntityType = {}));
var $90eecb456f971fbb$var$ClientDataProvider = function() {
    function ClientDataProvider() {
        var _this = this;
        this.globalFetchPromise = new Promise(function(resolve, reject) {
            _this.globalFetchResolve = resolve;
            _this.globalFetchReject = reject;
        });
        this.propertyValueRequests = [];
    }
    ClientDataProvider.prototype.fetchPropertyValues = function(propValueRequests) {
        var _a;
        (_a = this.propertyValueRequests).push.apply(_a, propValueRequests);
        return this.globalFetchPromise;
    };
    ClientDataProvider.prototype.resolve = function(clientData) {
        var _a;
        (_a = this.globalFetchResolve) === null || _a === void 0 || _a.call(this, clientData);
    };
    ClientDataProvider.prototype.reject = function(reason) {
        var _a;
        (_a = this.globalFetchReject) === null || _a === void 0 || _a.call(this, reason);
    };
    return ClientDataProvider;
}();
module.exports.ClientDataProvider = $90eecb456f971fbb$var$ClientDataProvider;

});

parcelRegister("8psx2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errors = void 0;
module.exports.errors = {
    nestingOvercomplicated: function() {
        return 'Nesting of display conditions exceeds 10 levels';
    },
    unhandledOperation: function(operation) {
        return "Unhandled operation: " + operation;
    },
    unsupportedConditionType: function(conditionType) {
        return "Unsupported condition type: " + conditionType;
    }
};

});

parcelRegister("7woy3", function(module, exports) {
"use strict";
var $579e905048985c50$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.collectEntityPropertiesToFetch = module.exports.entityPropertyHandlers = void 0;

var $hXuPC = parcelRequire("hXuPC");


var $crtnq = parcelRequire("crtnq");


var $8psx2 = parcelRequire("8psx2");


var $kxK2Z = parcelRequire("kxK2Z");

var $579e905048985c50$var$asArray = function(value) {
    return Array.isArray(value) ? value : [
        value
    ];
};
var $579e905048985c50$var$entityId = function(entityProperty) {
    return [
        entityProperty.entity,
        entityProperty.propertyKey,
        entityProperty.objectName
    ].filter(Boolean).join('-');
};
var $579e905048985c50$var$doesEntityPropertyMatch = function(condition, propertyValuesResponse) {
    var conditionType = Object.keys(condition)[0];
    var conditionFields = condition[conditionType];
    var id = $579e905048985c50$var$entityId(conditionFields);
    var propertyValue = propertyValuesResponse[id];
    var expectedValue = conditionFields.value;
    var propValueArray;
    switch(conditionType){
        case $crtnq.PropertyConditionType.EntityPropertyExists:
            return propertyValue != null;
        case $crtnq.PropertyConditionType.EntityPropertyEqualTo:
            return propertyValue === expectedValue;
        case $crtnq.PropertyConditionType.EntityPropertyContainsAny:
            propValueArray = $579e905048985c50$var$asArray(propertyValue);
            return $579e905048985c50$var$asArray(expectedValue).some(function(expected) {
                return propValueArray.includes(expected);
            });
        case $crtnq.PropertyConditionType.EntityPropertyContainsAll:
            propValueArray = $579e905048985c50$var$asArray(propertyValue);
            return $579e905048985c50$var$asArray(expectedValue).every(function(expected) {
                return propValueArray.includes(expected);
            });
        default:
            throw new Error($8psx2.errors.unsupportedConditionType(conditionType));
    }
};
var $579e905048985c50$var$clientConditionsPreCheck = function(clientDataConditionsLength, clientData) {
    if (!clientDataConditionsLength) return $kxK2Z.Instruction.Continue;
    if (!clientData) return $kxK2Z.Instruction.NeedData;
};
var $579e905048985c50$var$entityPropertyAndHandler = function(propertyConditions, clientData) {
    var preCheck = $579e905048985c50$var$clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) return preCheck;
    if (!propertyConditions.every(function(propCondition) {
        return $579e905048985c50$var$doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) return false;
    return $kxK2Z.Instruction.Continue;
};
var $579e905048985c50$var$entityPropertyOrHandler = function(propertyConditions, clientData) {
    var preCheck = $579e905048985c50$var$clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) return preCheck;
    if (propertyConditions.some(function(propCondition) {
        return $579e905048985c50$var$doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) return true;
    return $kxK2Z.Instruction.Continue;
};
var $579e905048985c50$var$entityPropertyNotHandler = function(propertyConditions, clientData) {
    var preCheck = $579e905048985c50$var$clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) return preCheck;
    if (propertyConditions.some(function(propCondition) {
        return !$579e905048985c50$var$doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) return true;
    return $kxK2Z.Instruction.Continue;
};
module.exports.entityPropertyHandlers = ($579e905048985c50$var$_a = {}, $579e905048985c50$var$_a[$kxK2Z.AND_OPERATION] = $579e905048985c50$var$entityPropertyAndHandler, $579e905048985c50$var$_a[$kxK2Z.OR_OPERATION] = $579e905048985c50$var$entityPropertyOrHandler, $579e905048985c50$var$_a[$kxK2Z.NOT_OPERATION] = $579e905048985c50$var$entityPropertyNotHandler, $579e905048985c50$var$_a);
var $579e905048985c50$var$buildPropertyValueRequest = function(entityProperty) {
    return $hXuPC.__assign({
        id: $579e905048985c50$var$entityId(entityProperty),
        entity: entityProperty.entity,
        propertyKey: entityProperty.propertyKey
    }, entityProperty.objectName && {
        objectName: entityProperty.objectName
    });
};
module.exports.collectEntityPropertiesToFetch = function(conditionsInput) {
    var conditions = $kxK2Z.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    var propertyRequests = [];
    if (Array.isArray(conditions)) {
        for(var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++){
            var propertyCondition = conditions_1[_i];
            var key = Object.keys(propertyCondition).find($kxK2Z.isEntityPropertyCondition);
            if (key) {
                var entityProperty = propertyCondition[key];
                propertyRequests.push($579e905048985c50$var$buildPropertyValueRequest(entityProperty));
            }
        }
        return propertyRequests;
    }
    Object.entries(conditions).filter(function(_a) {
        var key = _a[0], _ = _a[1];
        return $kxK2Z.isEntityPropertyCondition(key);
    }).forEach(function(_a) {
        var _ = _a[0], condition = _a[1];
        return propertyRequests.push($579e905048985c50$var$buildPropertyValueRequest(condition));
    });
    Object.entries(conditions).filter(function(_a) {
        var key = _a[0], _ = _a[1];
        return $kxK2Z.isOperation(key);
    }).forEach(function(_a) {
        var _ = _a[0], condition = _a[1];
        return propertyRequests.push.apply(propertyRequests, module.exports.collectEntityPropertiesToFetch(condition));
    });
    return propertyRequests;
};

});

parcelRegister("e4o8D", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("hEvd5", function(module, exports) {
// Usage of 'lodash/get' is justified here because:
// 1. Object from which the property is read is an arbitrary JSON object thus it has 'any' type.
// 2. The path that is used to read a property from an object is represented by a string and that is coming from a
//    Forge app config, thus 'idx' doesn't quite work here.
// eslint-disable-next-line no-restricted-imports

var $kkhbp = parcelRequire("kkhbp");


var $1wScy = parcelRequire("1wScy");


var $6cypx = parcelRequire("6cypx");


var $72sWB = parcelRequire("72sWB");


var $hp2SH = parcelRequire("hp2SH");


var $kDGTp = parcelRequire("kDGTp");


var $h3AlT = parcelRequire("h3AlT");

const $26012d14f130037a$var$fetchProperties = (propKeysById, query, fetchContext, extractPropsFromResponse)=>{
    const propKeysToFetch = [
        ...new Set(propKeysById.map(([_, key])=>key))
    ];
    const { preload: preload, ...restOfFetchContext } = fetchContext;
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: query,
        fetchPolicy: 'cache-first',
        variables: {
            ...restOfFetchContext,
            propertyKeys: propKeysToFetch
        },
        // We suspend all GraphQL requests once React rendering starts.
        // However, this would cause the query here to never resolve, making the sidebar wait forever.
        // The preload flag tells next/packages/graphql/src/links/SSRLink.ts to allow this query since it is part of preloading.
        context: {
            preload: preload
        }
    }).then((response)=>{
        const properties = extractPropsFromResponse(response);
        const propValuesByKeys = new Map(properties.map((prop)=>[
                prop.key,
                JSON.parse(prop.value)
            ]));
        return Object.fromEntries(propKeysById.filter(([_, key])=>propValuesByKeys.has(key)).map(([id, key])=>[
                id,
                propValuesByKeys.get(key)
            ]));
    });
};
const $26012d14f130037a$var$fetchContentProperties = (propKeysById, fetchContext)=>{
    return $26012d14f130037a$var$fetchProperties(propKeysById, (0, $kDGTp.DisplayConditionsContentPropertiesQuery), fetchContext, (res)=>res.data.content.nodes[0].properties.nodes);
};
const $26012d14f130037a$var$fetchSpaceProperties = (propKeysById, fetchContext)=>{
    return $26012d14f130037a$var$fetchProperties(propKeysById, (0, $h3AlT.SpacePropertiesQuery), fetchContext, (res)=>res.data.experimentalSpaceProperties);
};
const $26012d14f130037a$var$propertyFetchers = new Map([
    [
        (0, $72sWB.EntityType).Content,
        $26012d14f130037a$var$fetchContentProperties
    ],
    [
        (0, $72sWB.EntityType).Space,
        $26012d14f130037a$var$fetchSpaceProperties
    ]
]);
const $26012d14f130037a$var$createIdToPropValuePair = (propRequest, propValuesById)=>{
    const propValue = propValuesById[propRequest.id];
    if (!propRequest.objectName) return [
        propRequest.id,
        $26012d14f130037a$var$stringify(propValue)
    ];
    const nestedValue = (0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(propValue, propRequest.objectName);
    return [
        propRequest.id,
        $26012d14f130037a$var$stringify(nestedValue)
    ];
};
const $26012d14f130037a$var$stringify = (value, stringifyArray = false)=>{
    if (typeof value === 'undefined' || value === null) return undefined;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6cypx)))(value)) return value;
    if (!stringifyArray && Array.isArray(value)) return value.map((item)=>$26012d14f130037a$var$stringify(item, true));
    return JSON.stringify(value);
};
const $26012d14f130037a$export$56719c7943afd673 = (propertyRequestsInput, fetchContext)=>{
    const propertyRequests = propertyRequestsInput || [];
    if (!propertyRequests.length) return Promise.resolve({});
    const requestsByEntityType = (0, (/*@__PURE__*/$parcel$interopDefault($1wScy)))(propertyRequests, (request)=>request.entity);
    const propValuePromises = Object.entries(requestsByEntityType).map(([entityType, propRequests])=>{
        const propFetcher = $26012d14f130037a$var$propertyFetchers.get(entityType);
        if (!propFetcher) throw new Error(`Can't find entity property fetcher. Unknown entity type: ${entityType}`);
        return propFetcher(propRequests.map((p)=>[
                p.id,
                p.propertyKey
            ]), fetchContext);
    });
    return Promise.all(propValuePromises).then((propValues)=>{
        if (!propValues.length || propValues.every((values)=>!Object.keys(values).length)) return {};
        const allValuesById = propValues.reduce((previous, current)=>({
                ...previous,
                ...current
            }));
        const propValuesResponse = {};
        propertyRequests.map((propRequest)=>$26012d14f130037a$var$createIdToPropValuePair(propRequest, allValuesById)).filter(([_, value])=>typeof value !== 'undefined') // Filter out those with undefined value.
        .forEach(([id, value])=>propValuesResponse[id] = value);
        return propValuesResponse;
    });
};
module.exports["fetchPropertyData"] = $26012d14f130037a$export$56719c7943afd673;

});

parcelRegister("1wScy", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $11d2d2e303d6c19d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11d2d2e303d6c19d$var$hasOwnProperty = $11d2d2e303d6c19d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $11d2d2e303d6c19d$var$groupBy = $77wHb(function(result, value, key) {
    if ($11d2d2e303d6c19d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3PAnx(result, key, [
        value
    ]);
});
module.exports = $11d2d2e303d6c19d$var$groupBy;

});

parcelRegister("6cypx", function(module, exports) {

var $9vwa5 = parcelRequire("9vwa5");


var $fZxmY = parcelRequire("fZxmY");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $483e8e607dfcb0ce$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $483e8e607dfcb0ce$var$isString(value) {
    return typeof value == 'string' || !$fZxmY(value) && $6eZU2(value) && $9vwa5(value) == $483e8e607dfcb0ce$var$stringTag;
}
module.exports = $483e8e607dfcb0ce$var$isString;

});

parcelRegister("kDGTp", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $14c27313364e494e$export$6339cc1dc96d188e = (0, $eSUdr.default)`query DisplayConditionsContentPropertiesQuery($contentId:ID!$propertyKeys:[String]!){content(id:$contentId){nodes{id properties(keys:$propertyKeys){nodes{id key value}}}}}`;
module.exports["DisplayConditionsContentPropertiesQuery"] = $14c27313364e494e$export$6339cc1dc96d188e;

});

parcelRegister("h3AlT", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ee88e82b5e23aa66$export$c1909450e0cdd8c = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query SpacePropertiesQuery($spaceKey:String!$propertyKeys:[String!]!)@experimental{experimentalSpaceProperties(spaceKey:$spaceKey propertyKeys:$propertyKeys){key value}}`;
module.exports["SpacePropertiesQuery"] = $ee88e82b5e23aa66$export$c1909450e0cdd8c;

});

parcelRegister("hrNEt", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $w033M = parcelRequire("w033M");


var $fWkVZ = parcelRequire("fWkVZ");


var $a1A9A = parcelRequire("a1A9A");


var $7Ndnw = parcelRequire("7Ndnw");


var $lW4X5 = parcelRequire("lW4X5");


var $fZP6u = parcelRequire("fZP6u");

function $890fd8ee42caf977$export$ea6c3ae2bd3a5510({ moduleType: moduleType, spaceKey: spaceKey }) {
    const { isLoggedIn: isLoggedIn, userId: userId } = (0, $bQm3c.useSessionData)();
    const isGlobalExtension = (0, $7Ndnw.forgeGlobalExtensions).includes(moduleType);
    const { data: spaceAdminData, loading: spaceAdminLoading, error: spaceAdminError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $fZP6u.DisplayConditionsSpaceAdminQuery), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey || isGlobalExtension
    });
    const { data: operationData, loading: operationLoading, error: operationError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $a1A9A.OperationsQuery), {
        skip: !userId
    });
    let canViewUserProfiles = false;
    if (operationData) canViewUserProfiles = operationData?.siteOperations?.userProfile?.includes('read');
    const { data: privilegeData, loading: privilegeLoading, error: privilegeError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $lW4X5.UserPrivilegeQuery), {
        skip: operationLoading || !!operationError || !canViewUserProfiles
    });
    const isSpaceAdmin = spaceAdminData?.space?.currentUser?.isAdmin;
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(privilegeData);
    const isAdmin = isSiteAdmin || (0, $fWkVZ.getIsProductAdminFromQuery)(privilegeData);
    const staticContext = (0, $42omo.useMemo)(()=>({
            isSpaceAdmin: isSpaceAdmin,
            isLoggedIn: isLoggedIn,
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin
        }), [
        isSpaceAdmin,
        isLoggedIn,
        isAdmin,
        isSiteAdmin
    ]);
    if (spaceAdminLoading || spaceAdminError) return {
        loading: spaceAdminLoading,
        error: spaceAdminError
    };
    if (operationLoading || operationError) return {
        loading: operationLoading,
        error: operationError
    };
    if (privilegeLoading || privilegeError) return {
        loading: privilegeLoading,
        error: privilegeError
    };
    return {
        staticContext: staticContext,
        loading: false
    };
}
module.exports["useStaticContext"] = $890fd8ee42caf977$export$ea6c3ae2bd3a5510;

});

parcelRegister("3b6WO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bsX2q = parcelRequire("bsX2q");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $ep3mz = parcelRequire("ep3mz");


var $foQ4a = parcelRequire("foQ4a");


var $1uFM6 = parcelRequire("1uFM6");


var $bFDX4 = parcelRequire("bFDX4");


var $9wGTI = parcelRequire("9wGTI");


var $ai75e = parcelRequire("ai75e");


var $7Ndnw = parcelRequire("7Ndnw");


var $1OQlm = parcelRequire("1OQlm");


var $8pViN = parcelRequire("8pViN");


var $29b2c = parcelRequire("29b2c");

const $8eb9026be26e0c85$var$supportedAccessNarrowingModules = new Set([
    (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
    (0, $7Ndnw.FORGE_MODULE_BYLINE),
    (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
    (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
    (0, $7Ndnw.FORGE_MODULE_CUSTOM_CONTENT),
    (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
    (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE),
    (0, $7Ndnw.FORGE_MODULE_SPACE_SETTINGS)
]);
const $8eb9026be26e0c85$export$14fabe1ddcf1dc25 = (moduleType)=>{
    return $8eb9026be26e0c85$var$supportedAccessNarrowingModules.has(moduleType);
};
const $8eb9026be26e0c85$export$cab421e039d23b2 = ({ moduleType: moduleType, queryOptions: queryOptions, expandAppOwner: expandAppOwner = false, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly })=>{
    const fetchHook = (0, $9wGTI.fg)('use_new_forge_extension_list_call') ? (0, $29b2c.usePreFilteredExtensionList) : $8eb9026be26e0c85$var$useUnfilteredExtensionList;
    return fetchHook({
        moduleType: moduleType,
        queryOptions: queryOptions,
        expandAppOwner: expandAppOwner,
        returnBlockedExtensions: returnBlockedExtensions,
        skipQuery: skipQuery,
        spaceContextOnly: spaceContextOnly
    });
};
const $8eb9026be26e0c85$var$useUnfilteredExtensionList = ({ moduleType: moduleType, queryOptions: queryOptions, expandAppOwner: expandAppOwner = false, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { userId: userId, cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: spaceData, loading: spaceLoading, error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const dataClassificationTags = spaceData?.dataClassificationTags;
    const shouldSkip = Boolean(skipQuery) || !userId && !(0, $9wGTI.fg)('unskip_useextensionlist_unlicensed_support') || Boolean(isExternalCollaborator) && !(0, $9wGTI.fg)('unskip_useextensionlist_unlicensed_support') || Boolean(spaceLoading) || Boolean(spaceError);
    // Memorize most of the computations
    const memoHasAccessNarrowingSupport = (0, $42omo.useMemo)(()=>$8eb9026be26e0c85$export$14fabe1ddcf1dc25(moduleType), [
        moduleType
    ]);
    const memoUseExtensionListExternalProps = (0, $42omo.useMemo)(()=>(0, $8pViN.getUseExtensionListOptions)({
            cloudId: cloudId,
            activationId: activationId,
            locale: locale,
            dataClassificationTags: dataClassificationTags,
            hasAccessNarrowingSupport: memoHasAccessNarrowingSupport,
            expandAppOwner: expandAppOwner,
            moduleType: moduleType,
            queryOptions: queryOptions,
            skip: shouldSkip,
            skipFilter: false
        }), [
        cloudId,
        activationId,
        locale,
        dataClassificationTags,
        memoHasAccessNarrowingSupport,
        expandAppOwner,
        moduleType,
        queryOptions,
        shouldSkip
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = (0, $bsX2q.useExtensionList)(memoUseExtensionListExternalProps);
    // Filter out extensions blocked by App Access Rule if necessary
    const extsDataFilteredByAppAccessRule = (0, $42omo.useMemo)(()=>extsData && !returnBlockedExtensions ? extsData.filter((ext)=>!(0, $1OQlm.isBlockedByAppAccessRule)(ext)) : extsData, [
        extsData,
        returnBlockedExtensions
    ]);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    const { extensions: extensions, loading: loading, error: error } = (0, $ai75e.useExtensionsFilteredByDisplayConditions)(moduleType, extsDataFilteredByAppAccessRule, extsLoading || spaceLoading, extsError || spaceError);
    return {
        extensions: extensions,
        loading: loading,
        error: error
    };
};
module.exports["supportsAccessNarrowing"] = $8eb9026be26e0c85$export$14fabe1ddcf1dc25;
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("bsX2q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");

const $0f17c7f20af36c2d$export$73c0408abd298d1b = (client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, ssr = false)=>{
    const variables = filter ? {
        contextIds: contextIds,
        locale: locale,
        filter: filter
    } : {
        contextIds: contextIds,
        locale: locale,
        type: extensionType
    };
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner, dataClassificationTagIds) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner, undefined, dataClassificationTagIds);
    // In SSR mode render and fetch is one-pass we can't do cache-and-network
    if (ssr && queryOptions?.fetchPolicy === 'cache-and-network') queryOptions.fetchPolicy = 'cache-first';
    return {
        variables: variables,
        ...queryOptions,
        query: query,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $0f17c7f20af36c2d$export$1e6dc3c07340999 = ({ loading: loading, data: data })=>{
    if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
        if ('extensions' in data.extensionContexts[0]) return data.extensionContexts[0].extensions ?? null;
        else if ('extensionsByType' in data.extensionContexts[0]) return data.extensionContexts[0].extensionsByType ?? null;
    }
    return null;
};
const $0f17c7f20af36c2d$export$152846a4183c1a10 = async ({ client: client, contextIds: contextIds, type: extensionType, filter: filter, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale, queryFn: queryFn })=>{
    if (!queryFn) return null;
    const requestOptions = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, true);
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
    requestOptions.query = requestOptions.query || query;
    const { data: data } = await queryFn(requestOptions);
    if (!data) return null;
    return $0f17c7f20af36c2d$export$1e6dc3c07340999({
        loading: false,
        data: data
    });
};
const $0f17c7f20af36c2d$export$cab421e039d23b2 = ({ contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)(requestOptions.query || query, requestOptions);
    const extensions = $0f17c7f20af36c2d$export$1e6dc3c07340999({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'useExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
module.exports["createExtensionListQueryOptions"] = $0f17c7f20af36c2d$export$73c0408abd298d1b;
module.exports["getExtensionsFromGQLResult"] = $0f17c7f20af36c2d$export$1e6dc3c07340999;
module.exports["getExtensionListForSSR"] = $0f17c7f20af36c2d$export$152846a4183c1a10;
module.exports["useExtensionList"] = $0f17c7f20af36c2d$export$cab421e039d23b2;

});

parcelRegister("grQpA", function(module, exports) {
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $3afb5a6a58db13d7$export$d76ef0f862d061a6;
module.exports["isGQLGatewayError"] = $3afb5a6a58db13d7$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $3afb5a6a58db13d7$export$9c0545f564a8227f;

});

parcelRegister("5U2YR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $jIiuI = parcelRequire("jIiuI");

const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $42omo.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $hQK66.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $a50a0967117e6a0e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $a50a0967117e6a0e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $a50a0967117e6a0e$export$dba2dab0d0f39612;

});

parcelRegister("jIiuI", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $42omo.createContext)((0, $1Aku8.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $669e2d348d1011a7$export$6a671bebd9daad64;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("39Ajm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");

const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$54ff27488d768aba = (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2ce486181186726b$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2ce486181186726b$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2ce486181186726b$export$54ff27488d768aba;

});

parcelRegister("3Spjc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $7TH2w = parcelRequire("7TH2w");

const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543
    }, children);
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $ee4a4828226e63ce$export$d28801614368e543;
module.exports["sendEvent"] = $ee4a4828226e63ce$export$7329bcdc3edcd90e;
module.exports["default"] = $ee4a4828226e63ce$export$2e2bcd8739ae039;

});

parcelRegister("1Igmn", function(module, exports) {
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $0be0f811af274f82$export$14ef296862e3705e;

});

parcelRegister("kqIWy", function(module, exports) {

var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey)=>{
    /** @schema cc */ const useSpaceDetailQuery = (0, $4ZxLt.default);
    const options = {
        variables: {
            spaceKey: spaceKey
        }
    };
    const { loading: loading, data: data, error: error } = (0, $9wGTI.fg)('stop_watching_more_queries') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)(useSpaceDetailQuery, options) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(useSpaceDetailQuery, options);
    return {
        loading: loading,
        data: data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined,
        error: error
    };
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<dba482b8278907dc3da4caa91ab1ec66>>
 * @relayHash 5ea23e55ef5088b9c4837d3773b81cb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5ea23e55ef5088b9c4837d3773b81cb1",
            "id": "e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "a1e29398bca6058e29a8240f26bd213b";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("1OQlm", function(module, exports) {
const $b3217fa901c7995d$export$bf98aa5bf4a9468c = (extension)=>extension?.dataClassificationPolicyDecision?.status === 'BLOCKED';
module.exports["isBlockedByAppAccessRule"] = $b3217fa901c7995d$export$bf98aa5bf4a9468c;

});

parcelRegister("8pViN", function(module, exports) {

var $grQpA = parcelRequire("grQpA");


var $gKr8t = parcelRequire("gKr8t");


var $aF5bm = parcelRequire("aF5bm");

const $fd7354817da8896a$export$6fc31218a1cb9c7c = ({ cloudId: cloudId, activationId: activationId, locale: locale, dataClassificationTags: dataClassificationTags, hasAccessNarrowingSupport: hasAccessNarrowingSupport, expandAppOwner: expandAppOwner, moduleType: moduleType, queryOptions: queryOptions, skip: skip, skipFilter: skipFilter })=>{
    const workspaceARI = (0, $aF5bm.getWorkspaceARI)({
        cloudId: cloudId,
        activationId: activationId
    });
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        contextIds: [
            workspaceARI
        ],
        type: moduleType,
        queryOptions: {
            ...queryOptions,
            skip: skip
        },
        expandAppOwner: expandAppOwner,
        locale: locale
    };
    // Passing the `filter` key will use the newer extension() resolver over the extensionByType() resolver
    // Going forward we to use the newer resolver
    // IMPORTANT NOTE: For some reason the addition of using filter (uses newer Forge resolver) is causing SSR to timeout when calling
    // preloadUseExtensionList with the FORGE_MODULE_BYLINE extension point. Creating this workaround by skipping the filter - be careful to test before removing this flag.
    // TODO: replace with new resolver  https://product-fabric.atlassian.net/browse/CCECO-3476
    if (hasAccessNarrowingSupport && !skipFilter) {
        options.filter = [
            {
                type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    moduleType
                ]
            }
        ];
        options.dataClassificationTagIds = dataClassificationTags || [];
    }
    return options;
};
module.exports["getUseExtensionListOptions"] = $fd7354817da8896a$export$6fc31218a1cb9c7c;

});

parcelRegister("aF5bm", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});

parcelRegister("29b2c", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $42omo = parcelRequire("42omo");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $0b28db5178e5e87b$export$323d0ca5ac902e76 = ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
        cloudId: cloudId,
        locale: locale,
        moduleType: moduleType,
        queryOptions: queryOptions,
        includeHidden: returnBlockedExtensions,
        spaceKey: spaceKey,
        contentId: contentId,
        spaceContextOnly: spaceContextOnly
    });
    const { extensions: extsData, loading: extsLoading, error: extsError } = (0, $7zIsq.usePrefilteredExtensionList)(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
module.exports["usePreFilteredExtensionList"] = $0b28db5178e5e87b$export$323d0ca5ac902e76;

});

parcelRegister("7zIsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");


var $8VYSW = parcelRequire("8VYSW");

const $f6a9c96fc0de3888$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $f6a9c96fc0de3888$export$88e0391b02a3c5c9 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $f6a9c96fc0de3888$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $f6a9c96fc0de3888$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $f6a9c96fc0de3888$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $f6a9c96fc0de3888$export$55348c7eb6377fe1;

});

parcelRegister("8VYSW", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");


var $dh538 = parcelRequire("dh538");

const $2303076e1c638c7b$var$cache = new Map();
const $2303076e1c638c7b$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ((0, $dh538.fg)('memoize_prefiltered_extensions')) {
        if ($2303076e1c638c7b$var$cache.has(extensionsIds)) return $2303076e1c638c7b$var$cache.get(extensionsIds);
    }
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $2303076e1c638c7b$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    if ((0, $dh538.fg)('memoize_prefiltered_extensions')) $2303076e1c638c7b$var$cache.set(extensionsIds, result);
    return result;
};
const $2303076e1c638c7b$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $2303076e1c638c7b$export$9ff84ea1b2ab439c;

});

parcelRegister("6qkXi", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly && (0, $6mKj3.expVal)('confluence_fix_space_apps_flickering', 'isEnabled', false) ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("g36ZK", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $bsX2q = parcelRequire("bsX2q");


var $5SzHz = parcelRequire("5SzHz");


var $dYU3e = parcelRequire("dYU3e");


var $8pViN = parcelRequire("8pViN");

const $3dc7607ceb214e1b$export$1959416aaf82ac88 = async ({ spaceKey: spaceKey, cloudId: cloudId, activationId: activationId, locale: locale, hasAccessNarrowingSupport: hasAccessNarrowingSupport, expandAppOwner: expandAppOwner, moduleType: moduleType, queryOptions: queryOptions, skip: skip, skipFilter: skipFilter })=>{
    const { data: data } = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $5SzHz.preloadSpaceDetail)(spaceKey);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    const dataClassificationTags = data?.space?.dataClassificationTags;
    return (0, $bsX2q.getExtensionListForSSR)({
        ...(0, $8pViN.getUseExtensionListOptions)({
            cloudId: cloudId,
            activationId: activationId,
            locale: locale,
            dataClassificationTags: dataClassificationTags,
            hasAccessNarrowingSupport: hasAccessNarrowingSupport,
            expandAppOwner: expandAppOwner,
            moduleType: moduleType,
            queryOptions: queryOptions,
            skip: skip,
            skipFilter: skipFilter
        }),
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ queryFn: (0, $dYU3e.query)
    });
};
module.exports["preloadExtensions"] = $3dc7607ceb214e1b$export$1959416aaf82ac88;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '')=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '')=>{
    if (!(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey);
    return $01831239f93415a0$var$getEmptyResult();
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("8n0y0", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $eSUdr = parcelRequire("eSUdr");


var $aIwYp = parcelRequire("aIwYp");


var $dYU3e = parcelRequire("dYU3e");


var $9wGTI = parcelRequire("9wGTI");


var $8pJsP = parcelRequire("8pJsP");

const $0469ff9a24207ab9$export$e95a50d7f0e263b5 = async ({ cloudId: cloudId, locale: locale, types: types, context: context, includeHidden: includeHidden })=>{
    if ((0, $9wGTI.fg)('memoize_prefiltered_extensions')) return (0, $aIwYp.preloadPrefilteredExtensionList)(// This is s a special case that the query is from platform in DocumentNode not Relay TaggedNode
    // query can handle both Relay TaggedNode and DocumentNode but type is only declared as Relay TaggedNode
    (0, $dYU3e.queryAgg), {
        cloudId: cloudId,
        locale: locale,
        types: types,
        context: context,
        includeHidden: includeHidden
    });
    else {
        const { data: data } = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $eSUdr.default)`query preloadForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner consentUrl environmentId environmentKey environmentType migrationKey key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet}userAccess{enabled hasAccess}type installationId installationConfig{key value}hiddenBy}}`,
                variables: {
                    cloudId: cloudId,
                    locale: locale,
                    types: types,
                    context: {
                        spaceKey: context.spaceKey,
                        contentId: context.contentId ? parseInt(context.contentId) || undefined : undefined
                    },
                    includeHidden: includeHidden
                }
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        return $0469ff9a24207ab9$var$transformForgeApps(data);
    }
};
const $0469ff9a24207ab9$var$transformForgeApps = (data)=>{
    if (!data || !data.confluence_forgeExtensionsByType) return null;
    return (0, $8pJsP.transformPreFilteredExtensions)(data.confluence_forgeExtensionsByType);
};
module.exports["preloadForgeApps"] = $0469ff9a24207ab9$export$e95a50d7f0e263b5;

});

parcelRegister("aIwYp", function(module, exports) {

var $8VYSW = parcelRequire("8VYSW");


var $7zIsq = parcelRequire("7zIsq");


var $39Ajm = parcelRequire("39Ajm");

const $1539bb55e97e95bf$export$689e6fec3c3a045c = async (query, { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, queryOptions: queryOptions })=>{
    const { fetchPolicy: _, ...requestOptions } = (0, $7zIsq.createUsePrefilteredExtensionListQueryOptions)(cloudId, context, undefined, types, locale, includeHidden, queryOptions);
    const { data: data } = await query({
        query: (0, $39Ajm.FetchPreFilteredForgeAppsQuery),
        ...requestOptions
    });
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["preloadPrefilteredExtensionList"] = $1539bb55e97e95bf$export$689e6fec3c3a045c;

});

parcelRegister("8pJsP", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");

const $be0a345f7ae1b5e4$export$9ff84ea1b2ab439c = (extensions)=>{
    return (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    //@ts-ignore capabilitySet mapped to valid value
                    capabilitySet: extension.license.capabilitySet === 'CAPABILITY_ADVANCED' ? 'capabilityAdvanced' : 'capabilityStandard'
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
};
module.exports["transformPreFilteredExtensions"] = $be0a345f7ae1b5e4$export$9ff84ea1b2ab439c;

});

parcelRegister("8dUjs", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $eSLr0 = parcelRequire("eSLr0");


var $7Ndnw = parcelRequire("7Ndnw");


var $5tgcI = parcelRequire("5tgcI");

const $84cd59e06a85be4f$export$a9c446837cd59ef8 = [
    (0, $5tgcI.SPACES_KEY),
    (0, $5tgcI.PEOPLE_KEY),
    (0, $5tgcI.DISCOVER_KEY)
];
const $84cd59e06a85be4f$export$a56df56fab66279e = ({ edition: edition, accessStatus: accessStatus })=>{
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const hideAutomation = edition !== 'PREMIUM' || !isAdmin;
    const notAllowedWebItems = [
        ...$84cd59e06a85be4f$export$a9c446837cd59ef8,
        hideAutomation ? (0, $5tgcI.AUTOMATION_KEY) : ''
    ];
    return {
        webItemParams: {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            notAllowedWebItems: notAllowedWebItems
        },
        forgeExtensionParams: {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            spaceKey: ''
        }
    };
};
module.exports["getGlobalAppsParams"] = $84cd59e06a85be4f$export$a56df56fab66279e;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("5tgcI", function(module, exports) {
const $696759caf06ef68c$export$af39e4edc5e74 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $696759caf06ef68c$export$97c436ccc42cbac9 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $696759caf06ef68c$export$3a7ae658938afc39 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.confluence.emcee__enduser-discover';
const $696759caf06ef68c$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
const $696759caf06ef68c$export$8a23ae6ca6b0c9ee = 'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link';
const $696759caf06ef68c$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $696759caf06ef68c$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
module.exports["SPACES_KEY"] = $696759caf06ef68c$export$af39e4edc5e74;
module.exports["PEOPLE_KEY"] = $696759caf06ef68c$export$97c436ccc42cbac9;
module.exports["DISCOVER_KEY"] = $696759caf06ef68c$export$3a7ae658938afc39;
module.exports["AUTOMATION_KEY"] = $696759caf06ef68c$export$ee99bc1ad01a63ae;
module.exports["CALENDAR_KEY"] = $696759caf06ef68c$export$8a23ae6ca6b0c9ee;
module.exports["ANALYTICS_KEY"] = $696759caf06ef68c$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $696759caf06ef68c$export$6c3d789a4f56bea2;

});

parcelRegister("he3NE", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $2383d17835531100$export$e367407479ee8cd8 = (0, $eSUdr.default)`query GetLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus productKey}}}`;
module.exports["GetLicensedProductsQuery"] = $2383d17835531100$export$e367407479ee8cd8;

});

parcelRegister("9sGCn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");


var $9p0fU = parcelRequire("9p0fU");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeAndStatusFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $9p0fU.PTPageSubTypeFragment)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $9p0fU.SearchConfluencePageBlogAttachmentSubTypeFragment)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("9p0fU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f3357fc24ccca23a$export$6345dfb10a0b6cbe = (0, $eSUdr.default)`fragment SubTypeAndStatusContentFragment on Content{id subType status}`;
const $f3357fc24ccca23a$export$4121dd5434380612 = (0, $eSUdr.default)`fragment SubTypeContentFragment on Content{id subType}`;
const $f3357fc24ccca23a$export$e7df79006c7c4a55 = (0, $eSUdr.default)`fragment SubTypePageTreeFragment on PTPage{id subType}`;
const $f3357fc24ccca23a$export$e77fa03b04da6df0 = (0, $eSUdr.default)`fragment SubTypeFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`;
module.exports["ContentSubTypeAndStatusFragment"] = $f3357fc24ccca23a$export$6345dfb10a0b6cbe;
module.exports["ContentSubTypeFragment"] = $f3357fc24ccca23a$export$4121dd5434380612;
module.exports["PTPageSubTypeFragment"] = $f3357fc24ccca23a$export$e7df79006c7c4a55;
module.exports["SearchConfluencePageBlogAttachmentSubTypeFragment"] = $f3357fc24ccca23a$export$e77fa03b04da6df0;

});

parcelRegister("aT8im", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $inPa6 = parcelRequire("inPa6");


var $1o4fX = parcelRequire("1o4fX");


var $7Sm4c = parcelRequire("7Sm4c");





var $ivb8S = parcelRequire("ivb8S");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $2Q7EG = parcelRequire("2Q7EG");

const $318f5483656bcff4$export$cf07606bc08d56a7 = 'growth-luna-edition-awareness-standard-to-premium:treatmentPillDismissed';
const $318f5483656bcff4$export$22acf73b61314d4f = (0, $eSUdr.default)`query useConfluenceStandardToPremiumExperimentQuery($key:[String]){isSiteAdmin onboardingState(key:$key){key value}license{trialEndDate firstPredunningEndTime}}`;
const $318f5483656bcff4$export$f2e766b4a1af4c38 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $j1Ss3.useQuery)($318f5483656bcff4$export$22acf73b61314d4f, {
        variables: {
            key: $318f5483656bcff4$export$cf07606bc08d56a7
        },
        fetchPolicy: 'cache-only'
    });
    const { edition: confluenceEdition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: $318f5483656bcff4$export$cf07606bc08d56a7,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'ea-standard-to-premium-query',
                source: 'useConfluenceStandardToPremiumExperiment',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    // Exposure fired earlier in experiment when they see EA
    const enrolled = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'control') || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'treatment');
    const isSiteAdmin = data?.isSiteAdmin;
    const edition = confluenceEdition?.toLocaleLowerCase();
    const trialEndDate = data?.license?.trialEndDate;
    const trialDaysLeft = (0, $9wGTI.fg)('tako-4040_connie_trial_days_left_standardisation') ? (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(data?.license?.trialEndDate) : (0, $2Q7EG.getTrialDaysLeft)(trialEndDate);
    const isInTrial = !data || loading || error ? undefined : trialDaysLeft ? trialDaysLeft > 0 : false;
    const firstPredunningEndTime = data?.license?.firstPredunningEndTime;
    const isInPreDunning = firstPredunningEndTime ? Date.now() < firstPredunningEndTime : false;
    const { treatmentPillDismissed: treatmentPillDismissed } = (0, $ivb8S.deserializeState)(data?.onboardingState ? {
        onboardingState: data?.onboardingState
    } : null);
    const isDismissed = loading || !!error || !!treatmentPillDismissed;
    const isEligibleForUpsellExperiment = enrolled && edition === 'standard' && isInTrial === false && !isInPreDunning && !!isSiteAdmin;
    return {
        isEligibleForUpsellExperiment: isEligibleForUpsellExperiment,
        cloudId: cloudId,
        product: 'confluence',
        edition: edition,
        userRoles: isSiteAdmin ? [
            'SITE_ADMIN'
        ] : [],
        hasDismissedButton: isDismissed,
        onDismissButton: handleDismiss
    };
};
module.exports["EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED"] = $318f5483656bcff4$export$cf07606bc08d56a7;
module.exports["useConfluenceStandardToPremiumExperimentQuery"] = $318f5483656bcff4$export$22acf73b61314d4f;
module.exports["useConfluenceStandardToPremiumExperiment"] = $318f5483656bcff4$export$f2e766b4a1af4c38;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("ivb8S", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $cbOce = parcelRequire("cbOce");


var $6mKj3 = parcelRequire("6mKj3");

const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined) onboardingState.forEach(({ key: key, value: value })=>{
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) return;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    });
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`, {
        update (cache, { data: data }) {
            const states = data.setOnboardingState;
            states.forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                cache.writeFragment({
                    id: `OnboardingState:${key}`,
                    fragment: (0, $eSUdr.default)`fragment myKey on OnboardingState{key value}`,
                    data: {
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $j1Ss3.useQuery)((0, $6mKj3.expVal)('confluence_consolidate_onboarding_state_queries', 'isEnabled', false) ? // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Preloaded GraphQL Operation
    (0, $eSUdr.default)`query GetOnboardingState($key:[String]){onboardingState(key:$key){key value}}` : (0, $eSUdr.default)`query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key value}}`, {
        variables: {
            key: key
        },
        skip: skipQuery
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("2Q7EG", function(module, exports) {

var $917iu = parcelRequire("917iu");

const $eea3be158b3f7463$export$666163d445f1868a = (queryData)=>{
    const trialEndDate = queryData?.license?.trialEndDate;
    return $eea3be158b3f7463$export$954628993bf3188e(trialEndDate);
};
const $eea3be158b3f7463$export$954628993bf3188e = (trialEndDate)=>{
    if (!trialEndDate) return null;
    // +1 day to round up for fractional days
    return (0, $917iu.default)(new Date(trialEndDate), new Date()) + 1;
};
module.exports["getTrialDaysLeft"] = $eea3be158b3f7463$export$954628993bf3188e;

});

parcelRegister("3y1ko", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");



var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    let shard = '';
    try {
        let res;
        res = await (async ()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult2 = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            return _asyncResult2;
        })();
        if (res.ok) enabled = await (async ()=>{
            const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult3 = await res.text();
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
            return _asyncResult3;
        })() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state in shard ${shard}: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await (async ()=>{
        const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult4 = await $4c06255176f911bc$export$632d1cf1f5c6210f();
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
        return _asyncResult4;
    })();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader",
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown
    }, children));
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("hVYQB", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f1f77e8bc02638a4$export$daa26b98bb3c2376 = (0, $eSUdr.default)`query DraftRedirectQuery($contentId:ID!$draftShareId:String$status:[String]){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id links{webui}properties(key:"editor"){nodes{id key value}}}}}`;
module.exports["DraftRedirectQuery"] = $f1f77e8bc02638a4$export$daa26b98bb3c2376;

});

parcelRegister("fyUox", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $2eBB6 = parcelRequire("2eBB6");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $2eBB6.HomepageIdQuery),
            variables: {
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $2eBB6.TitleContentPropertyQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("2eBB6", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $1f4aa8fbcf4655e8$export$3c49a0cb2883cfe4 = (0, $eSUdr.default)`query TitleContentPropertyQuery($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id pageTitlePublished:properties(key:"page-title-property-published"){nodes{id key value version{number}}}pageTitleDraft:properties(key:"page-title-property-draft"){nodes{id key value version{number}}}metadata{frontend{coverPictureWidth}}}}}`;
const $1f4aa8fbcf4655e8$export$ebbf9aacf1858ce5 = (0, $eSUdr.default)`query HomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id homepage{id}}}`;
module.exports["TitleContentPropertyQuery"] = $1f4aa8fbcf4655e8$export$3c49a0cb2883cfe4;
module.exports["HomepageIdQuery"] = $1f4aa8fbcf4655e8$export$ebbf9aacf1858ce5;

});

parcelRegister("gKMkU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dYU3e = parcelRequire("dYU3e");


var $gw4Eo = parcelRequire("gw4Eo");

const $7309ff12be989147$export$a95d48b280e02650 = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>{
    const entityAri = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        resourceId: contentId,
        activationId: ''
    });
    const workspaceId = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'workspace',
        resourceId: activationId,
        activationId: ''
    });
    return (0, $dYU3e.queryAgg)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: $7309ff12be989147$export$2d09cf1ac847a2a4,
        variables: {
            workspaceId: workspaceId,
            entityAri: entityAri
        }
    });
};
const $7309ff12be989147$export$2d09cf1ac847a2a4 = (0, $eSUdr.default)`query PlatformHighlightKeywordsQuery($entityAri:String!$workspaceId:String!$jiraReporterAccountId:String$jiraAssigneeAccountId:String$inputText:KnowledgeDiscoveryKeyPhraseInputText){knowledgeDiscovery{keyPhrases(entityAri:$entityAri workspaceId:$workspaceId jiraReporterAccountId:$jiraReporterAccountId jiraAssigneeAccountId:$jiraAssigneeAccountId inputText:$inputText)@optIn(to:"KnowledgeDiscovery Get Key Phrases"){__typename ...on KnowledgeDiscoveryKeyPhraseConnection{nodes{...on KnowledgeDiscoveryKeyPhrase{keyPhrase category}}}...on QueryError{message}}}}`;
module.exports["preloadAutohighlights"] = $7309ff12be989147$export$a95d48b280e02650;
module.exports["PlatformHighlightKeywordsQuery"] = $7309ff12be989147$export$2d09cf1ac847a2a4;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE
};
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    INCLUDE: 'include',
    LEGACY_CONTENT: 'legacy-content'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = Boolean(attrs?.parameters) ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl, isLivePagesFeatureEnabled) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl, isLivePagesFeatureEnabled);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams || {}
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("aMlgD", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $cgtv4.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    }
});
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl, isLivePagesFeatureEnabled)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (isLivePagesFeatureEnabled && (0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl, isLivePagesFeatureEnabled)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if (isLivePagesFeatureEnabled && (0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $hR9WV = parcelRequire("hR9WV");


var $6l6jb = parcelRequire("6l6jb");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError
            });
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {
async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData }) {
    if (skip) return {
        data: undefined,
        errors: []
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                errors: []
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                errors: []
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            errors: []
        };
    } catch (error) {
        const apolloError = error;
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            errors: apolloError.graphQLErrors || []
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: headers,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $9A0hR = parcelRequire("9A0hR");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $9A0hR.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, null, null, null, originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("fOjen", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $50a5089b6004564c$export$852364220ec700a8 = /*#__PURE__*/ function(DataSecurityPolicyAction) {
    DataSecurityPolicyAction["APP_ACCESS"] = "APP_ACCESS";
    DataSecurityPolicyAction["PAGE_EXPORT"] = "PAGE_EXPORT";
    DataSecurityPolicyAction["PUBLIC_LINKS"] = "PUBLIC_LINKS";
    return DataSecurityPolicyAction;
}({});
var $50a5089b6004564c$export$3c5b314640ce2287 = /*#__PURE__*/ function(DataSecurityPolicyDecidableContentStatus) {
    DataSecurityPolicyDecidableContentStatus["ARCHIVED"] = "ARCHIVED";
    DataSecurityPolicyDecidableContentStatus["CURRENT"] = "CURRENT";
    DataSecurityPolicyDecidableContentStatus["DRAFT"] = "DRAFT";
    return DataSecurityPolicyDecidableContentStatus;
}({});
module.exports["DataSecurityPolicyAction"] = $50a5089b6004564c$export$852364220ec700a8;

});

parcelRegister("25RVt", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $01cc250f38200635$export$ed16560030d1977a = (0, $eSUdr.default)`query DSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!$contentId:ID!$contentStatus:DataSecurityPolicyDecidableContentStatus!$contentVersion:Int!$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action contentId:$contentId contentStatus:$contentStatus contentVersion:$contentVersion spaceKey:$spaceKey){action allowed}}}`;
module.exports["DSPIsActionEnabledForContentQuery"] = $01cc250f38200635$export$ed16560030d1977a;

});

parcelRegister("cg3Zk", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $742fdc50e083de17$export$6f580a57816cd596 = (0, $eSUdr.default)`query RequestViewQuery($id:ID!){singleContent(id:$id){id status links{webui}}user:confluence_atlassianUser(current:true){id confluence{roles{canBeSuperAdmin}}}}`;
module.exports["RequestViewQuery"] = $742fdc50e083de17$export$6f580a57816cd596;

});

parcelRegister("eDV4X", function(module, exports) {
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});
module.exports["ALLOWED_CONTENT_STATUSES"] = $e24dc53dc88ae3e8$export$3211963609921415;
module.exports["ActionTypes"] = $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4;
module.exports["INVALID_CHARACTERS"] = $e24dc53dc88ae3e8$export$cac90560d1a4fb86;
module.exports["ContentTypes"] = $e24dc53dc88ae3e8$export$b9e669a853ca2f38;

});

parcelRegister("fD4xZ", function(module, exports) {
/**
 * @generated SignedSource<<00c867f9ff32a690d2d64bc6ac01ddd2>>
 * @relayHash c16bdfa077971f51c800aa53740cee17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90985f9063fa73aeab5db37248e435f944e233be152dae66ff279d8a899b3988
const $d6621697d90b85f7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "refetchQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "refetchQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "prefix"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c16bdfa077971f51c800aa53740cee17",
            "id": "90985f9063fa73aeab5db37248e435f944e233be152dae66ff279d8a899b3988",
            "metadata": {},
            "name": "useLabelsSelectPropsQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsQuery($contentId:ID!,$refetchQuery:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations@skip(if:$refetchQuery){operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}}}"
        }
    };
}();
$d6621697d90b85f7$var$node.hash = "8cab44d2cb7a98dca8bf5c892a415540";
var $d6621697d90b85f7$export$2e2bcd8739ae039 = $d6621697d90b85f7$var$node;
module.exports["default"] = $d6621697d90b85f7$export$2e2bcd8739ae039;

});

parcelRegister("9xoMO", function(module, exports) {

var $dBcar = parcelRequire("dBcar");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $da9fp = parcelRequire("da9fp");


var $lohHj = parcelRequire("lohHj");


var $b4VFP = parcelRequire("b4VFP");


var $d282Z = parcelRequire("d282Z");


var $d0hiC = parcelRequire("d0hiC");


var $9DBk6 = parcelRequire("9DBk6");


var $isKLx = parcelRequire("isKLx");


var $1gy7x = parcelRequire("1gy7x");


var $h86CY = parcelRequire("h86CY");


var $jbYIt = parcelRequire("jbYIt");


var $ccGoc = parcelRequire("ccGoc");


var $eoU1C = parcelRequire("eoU1C");


var $2wUAJ = parcelRequire("2wUAJ");


var $6eN5W = parcelRequire("6eN5W");


var $kNKrY = parcelRequire("kNKrY");


var $iErzy = parcelRequire("iErzy");


var $eAuT4 = parcelRequire("eAuT4");


var $lIcXr = parcelRequire("lIcXr");


var $bPDOf = parcelRequire("bPDOf");


var $eyUJP = parcelRequire("eyUJP");


var $9qLVv = parcelRequire("9qLVv");


var $eC276 = parcelRequire("eC276");

const $af0fb818e1350632$export$1c433575c0d65d05 = [
    ...(0, $2wUAJ.StorageEnforcementOnboardingKeys),
    ...(0, $dBcar.OnboardingKeys),
    ...(0, $gxTpP.ContextualInviteNudgeOnboardingKeys),
    ...(0, $5cryL.EditorOnboardingKeys),
    ...(0, $d282Z.InsightsOnboardingKeys),
    ...(0, $isKLx.SpaceMissionControlOnboardingKeys),
    ...(0, $h86CY.PresenceAdminFeedbackSurveyOnboardingKeys),
    ...(0, $jbYIt.RoleBasedAccessControlOnboardingKeys),
    ...(0, $ccGoc.RovoVideoPlayerStateOnboardingKeys),
    ...(0, $eoU1C.ShareAndRestrictDialogOnboardingKeys),
    ...(0, $6eN5W.TrialComponentsOnboardingKeys),
    ...(0, $1gy7x.PersonalizedTemplatesOnboardingKeys),
    ...(0, $9DBk6.LiveDocsOnboardingKeys),
    ...(0, $b4VFP.HomeTakeoverOnboardingKeys),
    ...(0, $lohHj.FeedOnboardingKeys),
    ...(0, $da9fp.OptionalNthUserGuidedTourOnboardingKeys),
    ...(0, $d0hiC.LandInSpampleSpaceOnboardingKeys),
    ...(0, $kNKrY.CreateIntroFirstStepOnboardingStateKeys),
    ...(0, $iErzy.ExperimentPromptWhiteboardTemplatesOnboardingKeys),
    ...(0, $eAuT4.NotesOnboardingSpotlightKeys),
    ...(0, $lIcXr.NewContentHistoryOnboardingStateKeys),
    ...(0, $bPDOf.AIFCOnboardingKeys),
    ...(0, $eyUJP.NthUserHomeOnboardingRevampKeys),
    ...(0, $9qLVv.RovoAwarenessOnboardingKeys),
    ...(0, $eC276.ExportJiraContextToPageTourKeys)
];
module.exports["OnboardingKeysCombined"] = $af0fb818e1350632$export$1c433575c0d65d05;

});

parcelRegister("gxTpP", function(module, exports) {
const $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab = {
    EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
};
const $62a1556a5bf2ef38$export$fdbc8dd83db637ed = [
    ...Object.values($62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab)
];
module.exports["CONTEXTUAL_INVITE_NUDGE"] = $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab;
module.exports["ContextualInviteNudgeOnboardingKeys"] = $62a1556a5bf2ef38$export$fdbc8dd83db637ed;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("da9fp", function(module, exports) {
const $565de75ce1406587$export$9228568dbaf24cda = {
    tourSeenAt: 'optional-nth-user-guided-tour:tourSeenAt',
    hasDismissedTour: 'optional-nth-user-guided-tour:hasDismissedTour',
    hasCompletedTour: 'optional-nth-user-guided-tour:hasCompletedTour',
    hasSeenFinishNudge: 'optional-nth-user-guided-tour:hasSeenFinishNudge',
    isEnrolledAsNewUser: 'optional-nth-user-guided-tour:isEnrolledAsNewUser'
};
const $565de75ce1406587$export$c9a13a78a28b997a = [
    ...Object.values($565de75ce1406587$export$9228568dbaf24cda)
];
module.exports["OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS"] = $565de75ce1406587$export$9228568dbaf24cda;
module.exports["OptionalNthUserGuidedTourOnboardingKeys"] = $565de75ce1406587$export$c9a13a78a28b997a;

});

parcelRegister("lohHj", function(module, exports) {
const $3f26c87821b680a5$export$215d0f9cb557eff8 = 'onboarding-popular-feed-card:isDismissed';
const $3f26c87821b680a5$export$84bf53f359485dfc = [
    $3f26c87821b680a5$export$215d0f9cb557eff8
];
module.exports["ONBOARDING_POPULAR_FEED_CARD_SEEN_KEY"] = $3f26c87821b680a5$export$215d0f9cb557eff8;
module.exports["FeedOnboardingKeys"] = $3f26c87821b680a5$export$84bf53f359485dfc;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = [
    ...Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2)
];
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("d0hiC", function(module, exports) {
const $fd31f36c9d251c72$export$3b7e7c8d78a4b783 = {
    hasDismissedBanner: 'land-in-sample-space:hasDismissedBanner',
    hasSeenSampleContentFlag: 'land-in-sample-space:hasSeenSampleContentFlag'
};
const $fd31f36c9d251c72$export$12692b0da4497e60 = [
    ...Object.values($fd31f36c9d251c72$export$3b7e7c8d78a4b783)
];
module.exports["LAND_IN_SAMPLE_SPACE_ONBOARDING_STATE_KEYS"] = $fd31f36c9d251c72$export$3b7e7c8d78a4b783;
module.exports["LandInSpampleSpaceOnboardingKeys"] = $fd31f36c9d251c72$export$12692b0da4497e60;

});

parcelRegister("9DBk6", function(module, exports) {
const $d9e19a0d44ee3302$export$9b7b03214c03f17d = {
    hasDismissedIntroSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
    hasDismissedLiveDocTour: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
    hasDismissedLiveDocModal: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
    hasDismissedContentWrapperTour: 'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
    hasDismissedAiButtonTour: 'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
    hasDismissedConvertToPageSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight'
};
const $d9e19a0d44ee3302$export$b02e3be205ee7739 = {
    LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
    LIVE_PAGE_CONTEXTUAL_NUDGE_ELIGIBLE: 'live-page-nudge:shareNudgeSpotlightEligible',
    // used to limit calls to the invite permissions API
    LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible'
};
const $d9e19a0d44ee3302$export$b3d9533dbdf35d0 = [
    ...Object.values($d9e19a0d44ee3302$export$9b7b03214c03f17d),
    ...Object.values($d9e19a0d44ee3302$export$b02e3be205ee7739)
];
module.exports["LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS"] = $d9e19a0d44ee3302$export$9b7b03214c03f17d;
module.exports["LIVE_PAGE_NUDGE"] = $d9e19a0d44ee3302$export$b02e3be205ee7739;
module.exports["LiveDocsOnboardingKeys"] = $d9e19a0d44ee3302$export$b3d9533dbdf35d0;

});

parcelRegister("isKLx", function(module, exports) {
const $d14f8037089c8dc2$export$92d46364e5595a5a = {
    SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
    SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
};
const $d14f8037089c8dc2$export$d9eb44525b9507f7 = [
    ...Object.values($d14f8037089c8dc2$export$92d46364e5595a5a)
];
module.exports["ONBOARDING_SPACE_MISSION_CONTROL"] = $d14f8037089c8dc2$export$92d46364e5595a5a;
module.exports["SpaceMissionControlOnboardingKeys"] = $d14f8037089c8dc2$export$d9eb44525b9507f7;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = [
    ...Object.values($071869849092e495$export$d8593f7ef284bfd8)
];
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("h86CY", function(module, exports) {
const $1dd4a0157170f997$export$f8474b3e5d170456 = {
    PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
};
const $1dd4a0157170f997$export$dcc0ca03f6f8c68d = [
    ...Object.values($1dd4a0157170f997$export$f8474b3e5d170456)
];
module.exports["ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS"] = $1dd4a0157170f997$export$f8474b3e5d170456;
module.exports["PresenceAdminFeedbackSurveyOnboardingKeys"] = $1dd4a0157170f997$export$dcc0ca03f6f8c68d;

});

parcelRegister("jbYIt", function(module, exports) {
const $15e5f1cf9df2e13c$export$67837434b2dea54f = {
    USERS_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:usersTableSpotlightSeen',
    DEFAULTS_ROLE_TABLE_MODAL_SEEN: 'RoleBasedAccessControl:defaultsRoleTableModalSeen',
    PRODUCT_ADMIN_MODAL_SEEN: 'RoleBasedAccessControl:productAdminModalSeen',
    DEFAULT_ROLE_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:defaultRoleTableSpotlightSeen',
    CUSTOM_ROLE_PAGE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:customRolePageSpotlightSeen'
};
const $15e5f1cf9df2e13c$export$134f165f9f20f01c = [
    ...Object.values($15e5f1cf9df2e13c$export$67837434b2dea54f)
];
module.exports["ONBOARDING_ROLE_BASED_ACCESS_CONTROL"] = $15e5f1cf9df2e13c$export$67837434b2dea54f;
module.exports["RoleBasedAccessControlOnboardingKeys"] = $15e5f1cf9df2e13c$export$134f165f9f20f01c;

});

parcelRegister("ccGoc", function(module, exports) {
const $1acbcc6f3166a324$export$fa80c824b7402d9f = {
    ROVO_VIDEO_PLAYER_SEEN: 'onboarding-rovo-video-player:rovoVideoPlayerSeen'
};
const $1acbcc6f3166a324$export$d42bdf2f6333fafd = [
    ...Object.values($1acbcc6f3166a324$export$fa80c824b7402d9f)
];
module.exports["ONBOARDING_ROVO_VIDEO_PLAYER_STATE_KEYS"] = $1acbcc6f3166a324$export$fa80c824b7402d9f;
module.exports["RovoVideoPlayerStateOnboardingKeys"] = $1acbcc6f3166a324$export$d42bdf2f6333fafd;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = [
    ...Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b)
];
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("2wUAJ", function(module, exports) {
const $70d55b678e14166c$export$13e578b1c1856d6f = {
    FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold'
};
const $70d55b678e14166c$export$abe3d9e5b5171ebf = [
    ...Object.values($70d55b678e14166c$export$13e578b1c1856d6f)
];
module.exports["STORAGE_ENFORCEMENT_STATE_KEYS"] = $70d55b678e14166c$export$13e578b1c1856d6f;
module.exports["StorageEnforcementOnboardingKeys"] = $70d55b678e14166c$export$abe3d9e5b5171ebf;

});

parcelRegister("6eN5W", function(module, exports) {
const $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f = {
    ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
    // The trial grace period is formally known as the "pre-dunning" period
    GRACE_PERIOD_BANNER_DISMISSED: 'trial-components:trialGracePeriodBannerDismissed',
    TRIAL_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial1DayFlag',
    TRIAL_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial3DayFlag',
    GRACE_PERIOD_0_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning0DayFlag',
    GRACE_PERIOD_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning1DayFlag',
    GRACE_PERIOD_2_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning2DayFlag',
    GRACE_PERIOD_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning3DayFlag',
    TRIAL_UNHANDLED_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrialUnhandledDayFlag'
};
const $e04ddb4a5df5bba6$export$8001dc7a7ed753e1 = [
    ...Object.values($e04ddb4a5df5bba6$export$840dd6f6c8ecd45f)
];
module.exports["TRIAL_COMPONENTS_EXPERIENCES"] = $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f;
module.exports["TrialComponentsOnboardingKeys"] = $e04ddb4a5df5bba6$export$8001dc7a7ed753e1;

});

parcelRegister("kNKrY", function(module, exports) {
const $9b3060c835515c41$export$ff14eab135fe9584 = {
    headerSeenAt: 'create-intro-first-step:headerSeenAt',
    headerCompleted: 'create-intro-first-step:headerCompleted',
    headerDismissed: 'create-intro-first-step:headerDismissed'
};
const $9b3060c835515c41$export$1c0fd29b58a87c97 = [
    ...Object.values($9b3060c835515c41$export$ff14eab135fe9584)
];
module.exports["CreateIntroFirstStepOnboardingStateKeys"] = $9b3060c835515c41$export$1c0fd29b58a87c97;

});

parcelRegister("iErzy", function(module, exports) {
const $73cef4510906c92e$export$b03044c2c0877870 = {
    isFiveWhysDismissed: 'prompt-whiteboard-templates:isFiveWhysDismissed',
    isFourLsDismissed: 'prompt-whiteboard-templates:isFourLsDismissed',
    isRetroBlueprintDismissed: 'prompt-whiteboard-templates:isRetroBlueprintDismissed',
    isBrainwritingDismissed: 'prompt-whiteboard-templates:isBrainwritingDismissed',
    isDisruptiveBrainstormingDismissed: 'prompt-whiteboard-templates:isDisruptiveBrainstormingDismissed'
};
const $73cef4510906c92e$export$3f4a20fe0370055a = [
    ...Object.values($73cef4510906c92e$export$b03044c2c0877870)
];
module.exports["ExperimentPromptWhiteboardTemplatesOnboardingKeys"] = $73cef4510906c92e$export$3f4a20fe0370055a;

});

parcelRegister("eAuT4", function(module, exports) {
const $5fc4daf9e891ce6f$export$b5d8775ad37f8a3d = {
    SPOTLIGHT_DISMISSED: 'notes-onboarding:hasSpotlightDismissed'
};
const $5fc4daf9e891ce6f$export$983b584b282200ba = [
    ...Object.values($5fc4daf9e891ce6f$export$b5d8775ad37f8a3d)
];
module.exports["NOTES_ONBOARDING_SPOTLIGHT"] = $5fc4daf9e891ce6f$export$b5d8775ad37f8a3d;
module.exports["NotesOnboardingSpotlightKeys"] = $5fc4daf9e891ce6f$export$983b584b282200ba;

});

parcelRegister("lIcXr", function(module, exports) {
const $06a9ae8b05df4a8c$export$561442d092b808c6 = {
    HAS_SEEN_SPOTLIGHT: 'new-content-history-onboarding:hasSeenSpotlight'
};
const $06a9ae8b05df4a8c$export$a8854c7bde991ac7 = [
    ...Object.values($06a9ae8b05df4a8c$export$561442d092b808c6)
];
module.exports["NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS"] = $06a9ae8b05df4a8c$export$561442d092b808c6;
module.exports["NewContentHistoryOnboardingStateKeys"] = $06a9ae8b05df4a8c$export$a8854c7bde991ac7;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = [
    ...Object.values($37b72543ace58c19$export$a266d7c13575e674)
];
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("9qLVv", function(module, exports) {
const $495b6b1f8e6e5795$export$994240b15b0ff991 = {
    hasDismissedHomeBanner: 'rovo-awareness:hasDismissedHomeBanner'
};
const $495b6b1f8e6e5795$export$b2ac58e92bc06a02 = [
    ...Object.values($495b6b1f8e6e5795$export$994240b15b0ff991)
];
module.exports["ROVO_AWARENESS_ONBOARDING_STATE_KEYS"] = $495b6b1f8e6e5795$export$994240b15b0ff991;
module.exports["RovoAwarenessOnboardingKeys"] = $495b6b1f8e6e5795$export$b2ac58e92bc06a02;

});

parcelRegister("eC276", function(module, exports) {
const $6acee6b0894846a1$export$fe11c6170169891b = {
    TOUR_COMPLETED: 'random:ExportJiraContextToPage:tourCompleted',
    TOUR_DISMISSED: 'random:ExportJiraContextToPage:tourDismissed'
};
const $6acee6b0894846a1$export$7eebc92289f9ff40 = [
    ...Object.values($6acee6b0894846a1$export$fe11c6170169891b)
];
module.exports["EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR"] = $6acee6b0894846a1$export$fe11c6170169891b;
module.exports["ExportJiraContextToPageTourKeys"] = $6acee6b0894846a1$export$7eebc92289f9ff40;

});

parcelRegister("cRQNp", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $3T2Zj = parcelRequire("3T2Zj");

function $345f814d0887da7c$export$8301c585ee328ce0({ contentId: contentId, includeContentBody: includeContentBody = true, status: status, useCache: useCache }) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $3T2Zj.ReadTimeQuery),
        variables: {
            contentId: contentId,
            includeContentBody: includeContentBody,
            status: status
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadReadTime"] = $345f814d0887da7c$export$8301c585ee328ce0;

});

parcelRegister("3T2Zj", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $bb1db1cfcc51cbce$export$9a0a69714186a2dc = (0, $eSUdr.default)`query ReadTimeQuery($contentId:ID$status:[String]$includeContentBody:Boolean=true){content(id:$contentId status:$status){nodes{id type body@include(if:$includeContentBody){dynamic{value representation}}operations{operation targetType}}}}`;
module.exports["ReadTimeQuery"] = $bb1db1cfcc51cbce$export$9a0a69714186a2dc;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("aqBZ0", function(module, exports) {
const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;

});

parcelRegister("ccWUN", function(module, exports) {
/**
 * @generated SignedSource<<e280b40973c69e9185e314e806885477>>
 * @relayHash 3fac23e69ad72cef246c33b6b22b24bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f
const $462dea7d21a073f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "concreteType": "ArchivedContentMetadata",
        "kind": "LinkedField",
        "name": "archivedContentMetadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "archiveNote"
            }
        ]
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "KnownUser"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "UnknownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3fac23e69ad72cef246c33b6b22b24bc",
            "id": "977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}}"
        }
    };
}();
$462dea7d21a073f6$var$node.hash = "e569274206c06e3436e0c3de5c5fe595";
var $462dea7d21a073f6$export$2e2bcd8739ae039 = $462dea7d21a073f6$var$node;
module.exports["default"] = $462dea7d21a073f6$export$2e2bcd8739ae039;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<4ae52768b16076b8d0cde983c3af9c2c>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("4trRg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $flWvL = parcelRequire("flWvL");


var $6yq6d = parcelRequire("6yq6d");

const $b51af1b6a5dfb3b5$export$79f4fda3b987b044 = ({ contentId: contentId, isDraft: isDraft, useCache: useCache = false, isArchived: isArchived })=>{
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $6yq6d.ContentModeQuery),
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadContentMode"] = $b51af1b6a5dfb3b5$export$79f4fda3b987b044;

});

parcelRegister("flWvL", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === ((0, $6mKj3.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense')) return (0, $6mKj3.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === ((0, $6mKj3.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense') ? (0, $6mKj3.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'COMPACT' : 'DENSE' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === ((0, $6mKj3.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense') ? 'standard' : (0, $6mKj3.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("6yq6d", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $af4e9b8e0b63c163$export$24663944ab29baba = (0, $eSUdr.default)`query ContentModeQuery($contentId:ID!$isDraft:Boolean!$status:[String]){content(id:$contentId status:$status){nodes{id contentProperties{latest@skip(if:$isDraft){contentMode}draft@include(if:$isDraft){contentMode}}}}}`;
module.exports["ContentModeQuery"] = $af4e9b8e0b63c163$export$24663944ab29baba;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("2xSF7", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $9d99fd4f882f896e$export$6a5b861d92d8a543 = (0, $eSUdr.default)`query ContentDataClassificationQuery($contentId:ID!$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId status:$lowerCaseContentStatusArray){id classificationLevelDetails{classificationLevel{id guideline description color name status}featureEnabled source}}}`;
module.exports["ContentDataClassificationQuery"] = $9d99fd4f882f896e$export$6a5b861d92d8a543;

});

parcelRegister("hqBgv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $9cb6dff7c1cbf98f$export$256961ed8e8e1e49 = (0, $eSUdr.default)`query DataClassificationEnabledQuery{isDataClassificationEnabled}`;
module.exports["DataClassificationEnabledQuery"] = $9cb6dff7c1cbf98f$export$256961ed8e8e1e49;

});

parcelRegister("lumgz", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $0b6a8bfd3c8020a4$export$10cb56c00ac59a8a = (0, $eSUdr.default)`query spaceForBaseSpaceQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id key alias name homepage{id}icon{path width height isDefault}type settings{routeOverrideEnabled}theme{themeKey}lookAndFeel{headings{key value}menus{hoverOrFocus{key value}color}header{backgroundColor button{backgroundColor color}primaryNavigation{color hoverOrFocus{key value}}secondaryNavigation{color hoverOrFocus{key value}}search{backgroundColor color}}content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}header{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}body{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}metadata{labels{nodes{prefix name id}}}operations{operation targetType}}}}`;
module.exports["spaceForBaseSpaceQuery"] = $0b6a8bfd3c8020a4$export$10cb56c00ac59a8a;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("82xkT", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $47b3b3d107c9e3d8$export$8c574c46798ffe77 = (0, $eSUdr.default)`query SpaceOverviewQuery($spaceKey:String!$excludeOperations:Boolean!){space(key:$spaceKey){id currentUser{isAdmin}name theme{themeKey}icon{path}homepage{id operations@skip(if:$excludeOperations){operation}properties(keys:["emoji-title-published"]){nodes{id key value}}}}}`;
module.exports["SpaceOverviewQuery"] = $47b3b3d107c9e3d8$export$8c574c46798ffe77;

});

parcelRegister("7C95e", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $18e93d7e870dee2c$export$f3209c72c697c538 = (0, $eSUdr.default)`query FavouriteSpaceQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isFavourited}}}`;
module.exports["FavouriteSpaceQuery"] = $18e93d7e870dee2c$export$f3209c72c697c538;

});

parcelRegister("c3dSY", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $8a46d0d2a20f0daa$export$257b287ae3940670 = (0, $eSUdr.default)`query WhiteboardUnifiedQuery($contentId:ID!$spaceKey:String$contentVersion:Int!){content(id:$contentId){nodes{id referenceId title operations{operation targetType}hasRestrictions hasViewRestrictions hasInheritedRestrictions space{id name key type alias}type status ancestors{id type title status}metadata{currentuser{favourited{isFavourite}}lastModifiedDate}properties(keys:["import-source" "imported-page-modified-date"]){nodes{key value}}history{createdBy{...on KnownUser{accountId}...on UnknownUser{accountId}}}}}spaces(spaceKey:$spaceKey first:10){nodes{id name homepage{id}}}user:confluence_atlassianUser(current:true){id confluence{space{id}}}paywallStatus(id:$contentId)canvasToken(contentId:$contentId){token}contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl}}entitlements{whiteboardFeatures{smartConnectors{isEntitled}smartSections{isEntitled}}}dataSecurityPolicy{isActionEnabledForContent(action:PAGE_EXPORT contentId:$contentId contentStatus:CURRENT spaceKey:$spaceKey contentVersion:$contentVersion){allowed}}}`;
module.exports["WhiteboardUnifiedQuery"] = $8a46d0d2a20f0daa$export$257b287ae3940670;

});

parcelRegister("aVmIf", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $557bf56f96dc85c8$export$530c9ba642f8af16 = (0, $eSUdr.default)`query SpaceQueryWhiteboards($spaceKey:String){space(key:$spaceKey){id name icon{path}homepage{id}}}`;
module.exports["SpaceQuery"] = $557bf56f96dc85c8$export$530c9ba642f8af16;

});

parcelRegister("2iJnA", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7de465164a80c8f0$export$c3eaa35ce91217cd = (0, $eSUdr.default)`query DatabaseUnifiedQuery($contentId:ID!$spaceKey:String$contentVersion:Int!){content(id:$contentId){nodes{id referenceId title operations{operation targetType}hasRestrictions hasViewRestrictions hasInheritedRestrictions space{id name key type alias}type status ancestors{id type title status}}}spaces(spaceKey:$spaceKey first:10){nodes{id name homepage{id}}}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}emails{value isPrimary}locale confluence{space{id}}}dataSecurityPolicy{isActionEnabledForContent(action:PAGE_EXPORT contentId:$contentId contentStatus:CURRENT spaceKey:$spaceKey contentVersion:$contentVersion){allowed}}}`;
module.exports["DatabaseUnifiedQuery"] = $7de465164a80c8f0$export$c3eaa35ce91217cd;

});

parcelRegister("1TElT", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $87Z8O = parcelRequire("87Z8O");

const $0272cf4ae0232c26$export$a9fe7043b42a1476 = (contentId, draftShareId, useCache)=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadEmojiTitle"] = $0272cf4ae0232c26$export$a9fe7043b42a1476;

});

parcelRegister("87Z8O", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $30f101ece1f63b68$export$a6ac8a3b189818d7 = (0, $eSUdr.default)`query getEmojiTitlePropertyQuery($contentId:ID$status:[String]$draftShareId:String$skipPublishedFragment:Boolean!){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id emojiTitlePublished:properties(key:"emoji-title-published")@skip(if:$skipPublishedFragment){nodes{id key value version{number}}}emojiTitleDraft:properties(key:"emoji-title-draft"){nodes{id key value version{number}}}contentProperties{latest{defaultTitleEmoji}}}}}`;
module.exports["getEmojiTitleProperty"] = $30f101ece1f63b68$export$a6ac8a3b189818d7;

});

parcelRegister("65pdw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gr7Mm = parcelRequire("gr7Mm");

function $4e9d3c2f55d09139$export$cca2a63dd6cc6345(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $gr7Mm.CoverPictureQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: draftShareId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadEditorPageCoverPicture"] = $4e9d3c2f55d09139$export$cca2a63dd6cc6345;

});

parcelRegister("gr7Mm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $34fb18e1eff4cb9b$export$32667dced0d2dcef = (0, $eSUdr.default)`query CoverPictureQuery($contentId:ID$status:[String]$draftShareId:String){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id properties(keys:["cover-picture-id-draft" "cover-picture-id-published"]){nodes{id key value version{number}}}}}}`;
module.exports["CoverPictureQuery"] = $34fb18e1eff4cb9b$export$32667dced0d2dcef;

});

parcelRegister("9wImN", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $9b97471f2bc23d67$export$486f2d283fa40127 = (0, $eSUdr.default)`query SmartCreatePageEditorDataWrapperComponentQuery($contentId:ID!){content(id:$contentId status:["draft"]){nodes{id title body{atlas_doc_format{value}}space{id key alias}}}}`;
module.exports["SmartCreatePageEditorDataWrapperComponentQuery"] = $9b97471f2bc23d67$export$486f2d283fa40127;

});

parcelRegister("ahDyi", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $8b164b879bf4196d$export$4acf0a5706eccdf6 = (0, $eSUdr.default)`query EmbedUnifiedQuery($contentId:ID!$spaceKey:String!){content(id:$contentId){nodes{id title metadata{frontend{embedUrl}currentuser{favourited{isFavourite}}}operations{operation targetType}hasRestrictions hasViewRestrictions hasInheritedRestrictions space{id name key type alias}type status ancestors{id type title status}embeddedProduct}}spaces(spaceKey:$spaceKey first:10){nodes{id name homepage{id}}}user:confluence_atlassianUser(current:true){id confluence{space{id}}}}`;
module.exports["EmbedUnifiedQuery"] = $8b164b879bf4196d$export$4acf0a5706eccdf6;

});

parcelRegister("cvj7x", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $65pdw = parcelRequire("65pdw");


var $1TElT = parcelRequire("1TElT");


var $3cpum = parcelRequire("3cpum");


var $7PLO8 = parcelRequire("7PLO8");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $4trRg = parcelRequire("4trRg");

parcelRequire("kGDoD");
var $9nGwZ = parcelRequire("9nGwZ");


var $1c0dB = parcelRequire("1c0dB");


var $kDt9L = parcelRequire("kDt9L");


var $4vyfK = parcelRequire("4vyfK");


var $cRQNp = parcelRequire("cRQNp");


var $eSLr0 = parcelRequire("eSLr0");


var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $lyWac = parcelRequire("lyWac");


var $9wGTI = parcelRequire("9wGTI");


var $9OYfw = parcelRequire("9OYfw");


var $hr9NW = parcelRequire("hr9NW");

const $c13994d6914d469f$var$logger = (0, $7W8i8.getLogger)('load-edit-page');
async function $c13994d6914d469f$export$1149cf9041c3e7b8({ spaceKey: spaceKey, contentId: contentId, shouldPreloadMentionsProvider: shouldPreloadMentionsProvider = false, useCache: useCache = false, catchFn: // use cache for native editor data
catchFn, isLivePage: isLivePage = false }) {
    // note: explicitly casting to Promise<any> to avoid typescript incorrectly inferring tuple types; although we don't use the return value of this function regardless
    $c13994d6914d469f$var$logger.debug`Calling preloadEditorData ${performance.now() / 1000}`;
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    // preload queries shared by Synchrony and Native Collab editors
    const immediateResultsPromises = [
        (0, $irrTO.preloadDraftContentAppearance)(contentId, useCache)
    ];
    // specific native collab editor queries
    if (!!contentId) {
        immediateResultsPromises.push((0, $9OYfw.preloadCollabDraftContent)(contentId, draftShareId, useCache));
        if ((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_emoji_otp', 'isEnabled', false)) immediateResultsPromises.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId));
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) {
            const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
            immediateResultsPromises.push((0, $4trRg.preloadContentMode)({
                contentId: contentId,
                isDraft: !isLivePage,
                useCache: useCache,
                isArchived: isArchived
            }));
        }
        immediateResultsPromises.push((0, $1TElT.preloadEmojiTitle)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollab)(contentId, draftShareId, useCache));
    }
    immediateResultsPromises.push((0, $65pdw.preloadEditorPageCoverPicture)(contentId, draftShareId, useCache), (0, $3cpum.preloadEditorContentState)({
        contentId: contentId,
        useCache: useCache,
        shouldGetDraftVersion: !isLivePage
    }));
    if (isLivePage) {
        // Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
        immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
        (0, $8CHHT.preloadUseExtensionList)({
            spaceKey: spaceKey || '',
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
            skipFilter: true
        }));
        immediateResultsPromises.push((0, $9nGwZ.preloadLastUpdated)(contentId, useCache));
        immediateResultsPromises.push((0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            useCache: useCache
        }));
    }
    if (shouldPreloadMentionsProvider) immediateResultsPromises.push((0, $kDt9L.preloadMentionsProvider)());
    immediateResultsPromises.push((0, $1c0dB.preloadEditorPageTitleContentProperties)({
        contentId: contentId,
        draftShareId: draftShareId,
        useCache: useCache
    }));
    await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $lyWac.waitForAllReturnWhenError)(immediateResultsPromises.map((p)=>!!catchFn ? p?.catch(catchFn) : p));
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    $c13994d6914d469f$var$logger.debug`preloadEditorData complete ${performance.now() / 1000}`;
}
module.exports["preloadEditorData"] = $c13994d6914d469f$export$1149cf9041c3e7b8;

});

parcelRegister("3cpum", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $bd27Q = parcelRequire("bd27Q");

function $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0({ contentId: contentId, useCache: useCache, shouldGetDraftVersion: shouldGetDraftVersion }) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $bd27Q.EditorContentStateQuery),
        variables: {
            contentId: contentId,
            isDraft: shouldGetDraftVersion
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadEditorContentState"] = $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0;

});

parcelRegister("bd27Q", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $aea79842a038b4f9$export$c33c26637710a569 = (0, $eSUdr.default)`query EditorContentStateQuery($contentId:ID!$isDraft:Boolean!){singleContent(id:$contentId){id contentState(isDraft:$isDraft){id name color restrictionLevel isCallerPermitted}contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}}availableContentStates(contentId:$contentId){customContentStates{name color id}spaceContentStates{name color id restrictionLevel}}}`;
module.exports["EditorContentStateQuery"] = $aea79842a038b4f9$export$c33c26637710a569;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lztxY = parcelRequire("lztxY");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $lztxY.getDraftContentAppearanceProperty),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("kGDoD", function(module, exports) {
$parcel$export(module.exports, "preloadLastUpdated", () => (parcelRequire("9nGwZ")).preloadLastUpdated);

var $9nGwZ = parcelRequire("9nGwZ");


var $6iSKO = parcelRequire("6iSKO");


});

parcelRegister("9nGwZ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6iSKO = parcelRequire("6iSKO");

function $693a95aca15bff58$export$e7a15421d1327843(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $6iSKO.ByLineLastUpdatedQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadLastUpdated"] = $693a95aca15bff58$export$e7a15421d1327843;

});

parcelRegister("6iSKO", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $496ee58992d0a352$export$aae43c54b1ffa341 = (0, $eSUdr.default)`query ByLineLastUpdatedQuery($contentId:ID!$status:[String]){content(id:$contentId status:$status){nodes{id version{friendlyWhen when}}}}`;
module.exports["ByLineLastUpdatedQuery"] = $496ee58992d0a352$export$aae43c54b1ffa341;

});

parcelRegister("1c0dB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $2eBB6 = parcelRequire("2eBB6");

const $cb49cba09ddc32ea$export$2ea86854c75d3ec8 = async ({ contentId: contentId, draftShareId: draftShareId, useCache: useCache })=>{
    const variables = {
        contentId: contentId,
        status: [
            'current',
            'draft',
            'archived'
        ],
        draftShareId: draftShareId,
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    };
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $2eBB6.TitleContentPropertyQuery),
        variables: variables
    });
};
module.exports["preloadEditorPageTitleContentProperties"] = $cb49cba09ddc32ea$export$2ea86854c75d3ec8;

});

parcelRegister("kDt9L", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $egFdh = parcelRequire("egFdh");

const $6bd71bdc26599ad9$export$45c648ba9bf4e12f = async ()=>(0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $egFdh.MentionsProviderQuery)
    });
module.exports["preloadMentionsProvider"] = $6bd71bdc26599ad9$export$45c648ba9bf4e12f;

});

parcelRegister("egFdh", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $032347ca36d77113$export$a93100a78b528047 = (0, $eSUdr.default)`query MentionsProviderQuery{entitlements{externalCollaborator{isEntitled}}}`;
module.exports["MentionsProviderQuery"] = $032347ca36d77113$export$a93100a78b528047;

});

parcelRegister("9OYfw", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $7ZQNA = parcelRequire("7ZQNA");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $6mKj3 = parcelRequire("6mKj3");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $7ZQNA.CollabDraftQuery),
            variables: {
                id: contentId,
                hydrateAdf: true,
                ...draftShareId ? {
                    draftShareId: draftShareId
                } : undefined
            },
            fetchPolicy: useCache ? 'cache-first' : 'network-only'
        }).then(async (result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
            // that doesn't preserve the result in caches if there is an error in SSR
            // So we need to preserve the error, to be able to verify it later during render phase in SSR
            if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
            // When `platform_editor_smart_card_otp` is enabled, we don't need to set __PRELOADED_LINKS_IN_DRAFT__,
            // because smart link data will be handled by editor's one tick provider.
            if (!(0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) {
                // Preloaded smartlinks don't have contentSlug, while preloaded draft does.
                // Extracting smartlinks from preloaded draft here, so it can be used to fix preloaded smartlinks.
                const preloadedDraftADF = result?.data?.collabDraft?.document || '';
                const urlMatch = /https?:\/\/[^\s"'<>()]+/g;
                window['__PRELOADED_LINKS_IN_DRAFT__'] = preloadedDraftADF.match(urlMatch) || [];
            }
            if ((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) // There are two reasons to store smart card URLs on the window object:
            // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
            //    so we must reconcile the list of smart cards with the draft content.
            // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
            //    so we need to add slugs sourced from the draft content.
            // Therefore, we extract smart cards from the draft content here, save them on the window object,
            // and later use them to align the Confluence snapshot with the draft content.
            window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodes)(result?.data?.collabDraft?.document || '');
            return result;
        });
    })();
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $l1kdf.NativeCollabQuery),
        variables: {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        }
    });
}
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("l1kdf", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $eSUdr.default)`query NativeCollabQuery($contentId:ID$draftShareId:String$status:[String]){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id type status version{number ncsStepVersion by{type ...on KnownUser{accountId}}}history{createdBy{displayName}createdDate}space{id name homepageId}labels{nodes{id name}}subType}}}`;
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("7ZQNA", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $eSUdr.default)`query CollabDraftQuery($id:ID!$draftShareId:String=""$hydrateAdf:Boolean){collabDraft(id:$id draftShareId:$draftShareId hydrateAdf:$hydrateAdf){document version metadata{title}}}`;
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("747ya", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7ZQNA = parcelRequire("7ZQNA");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const response = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $7ZQNA.CollabDraftQuery),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'network-only'
    });
    const { data: data, errors: errors } = response;
    if (errors || !data.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("27Dus", function(module, exports) {

var $477dG = parcelRequire("477dG");


var $et4nk = parcelRequire("et4nk");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$1970baffe86d32af(docJsonString) {
    if (!docJsonString) return [];
    const doc = JSON.parse(docJsonString);
    const cardProvider = new (0, $477dG.EditorCardProvider)('custom', undefined, 'CONFLUENCE');
    return (0, $et4nk.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
module.exports["findSmartCardNodes"] = $010c1dfc98319256$export$1970baffe86d32af;

});

parcelRegister("477dG", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $79vw2 = parcelRequire("79vw2");


var $i0VEL = parcelRequire("i0VEL");


var $1oCLl = parcelRequire("1oCLl");


var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");


var $1bFdN = parcelRequire("1bFdN");


var $5nJCu = parcelRequire("5nJCu");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $lEzf1 = parcelRequire("lEzf1");

const $807e27f9bf9a8610$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
const $807e27f9bf9a8610$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
const $807e27f9bf9a8610$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
const $807e27f9bf9a8610$var$isJiraList = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/);
const $807e27f9bf9a8610$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
const $807e27f9bf9a8610$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
const $807e27f9bf9a8610$var$isConfluenceWhiteboard = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
const $807e27f9bf9a8610$var$isConfluenceDatabase = (url)=>url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/);
const $807e27f9bf9a8610$var$isYoutubeVideo = (url)=>url.match(/^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/);
const $807e27f9bf9a8610$var$isLoomUrl = (url)=>{
    return url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
const $807e27f9bf9a8610$var$isJiraDashboard = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/);
};
const $807e27f9bf9a8610$var$isJiraBacklog = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/);
};
const $807e27f9bf9a8610$var$isJiraBoard = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraPlan = (url)=>{
    return(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?")));
};
const $807e27f9bf9a8610$var$isJiraVersion = (url)=>{
    return url.match(/https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/);
};
const $807e27f9bf9a8610$var$isJiraForm = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraSummary = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/);
};
const $807e27f9bf9a8610$var$isRovoAgentProfilePage = (url)=>{
    return url.match(/^https:\/\/.*?\/people\/agent\/.+$/);
};
const $807e27f9bf9a8610$var$isCustomer360LandingPage = (url)=>url.match(/^https:\/\/customer\.atlassian\.com\/.*$/);
const $807e27f9bf9a8610$var$isConfluenceTeamCalendars = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)"));
const $807e27f9bf9a8610$var$isJiraIssueNavigator = (url)=>url.match(/^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/);
const $807e27f9bf9a8610$var$isAvpVisualizationView = (url)=>url.match(/^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/);
const $807e27f9bf9a8610$export$6a9668b99d8a1708 = (url)=>/\/browse\/((?:\w+)-(?:\d+))/i.test(url);
class $807e27f9bf9a8610$export$e4635c0135e1a519 extends (0, $i0VEL.NodeDataProvider) {
    nodeDataKey(node) {
        // We can use URL as a key here, because CardClient returns the same data for the same URL
        // regardless of the type of card (inline, block, embed).
        return node.attrs.url;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            return this.cardClient.fetchData(url);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        return [
            'inlineCard',
            'blockCard',
            'embedCard'
        ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = (0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                    url: resourceUrl
                }
            }) : await this.cardClient.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return true;
        } catch (e) {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = (0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                    url: resourceUrl
                }
            }) : await this.cardClient.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return response;
        } catch (e) {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lEzf1.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $807e27f9bf9a8610$var$isJiraPlan(url);
        let isJiraFormEvaluated;
        if ((0, $dh538.fg)('smartlink_jira_software_form')) isJiraFormEvaluated = $807e27f9bf9a8610$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $807e27f9bf9a8610$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $dh538.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $807e27f9bf9a8610$var$isConfluenceTeamCalendars(url);
        if ($807e27f9bf9a8610$var$isJiraRoadmapOrTimeline(url) || $807e27f9bf9a8610$var$isPolarisView(url) || $807e27f9bf9a8610$var$isJwmView(url) || $807e27f9bf9a8610$var$isJiraList(url) || $807e27f9bf9a8610$var$isGiphyMedia(url) || $807e27f9bf9a8610$var$isProformaView(url) || $807e27f9bf9a8610$var$isConfluenceWhiteboard(url) || $807e27f9bf9a8610$var$isConfluenceDatabase(url) || $807e27f9bf9a8610$var$isYoutubeVideo(url) || $807e27f9bf9a8610$var$isLoomUrl(url) || $807e27f9bf9a8610$var$isJiraDashboard(url) || $807e27f9bf9a8610$var$isJiraBacklog(url) || $807e27f9bf9a8610$var$isJiraBoard(url) || $807e27f9bf9a8610$var$isRovoAgentProfilePage(url) || $807e27f9bf9a8610$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $807e27f9bf9a8610$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $807e27f9bf9a8610$var$isJiraIssueNavigator(url) || $807e27f9bf9a8610$var$isAvpVisualizationView(url) && (0, $dh538.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = (0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            }) : await this.cardClient.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $btw9C.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $79vw2.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch (e) {
            return false;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = (0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            }) : await this.cardClient.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch (e) {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $dh538.fg)('issue-link-suggestions-in-comments')) {
                if ($807e27f9bf9a8610$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                (isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined) && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.onResolve = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $5nJCu.Transformer)();
        this.onResolve = onResolve;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $807e27f9bf9a8610$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $k00oi.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $807e27f9bf9a8610$export$b7c3c9a99f7959f5 = new $807e27f9bf9a8610$export$e4635c0135e1a519();
module.exports["EditorCardProvider"] = $807e27f9bf9a8610$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $807e27f9bf9a8610$export$b7c3c9a99f7959f5;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.cache[dataKey] = {
                    source: 'network',
                    data: data
                };
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("dDhJe", function(module, exports) {
const $acfecaf0839e2c0b$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $acfecaf0839e2c0b$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $acfecaf0839e2c0b$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $acfecaf0839e2c0b$export$e2b040f052407032 = {
    dev: $acfecaf0839e2c0b$var$devBaseUrl,
    development: $acfecaf0839e2c0b$var$devBaseUrl,
    stg: $acfecaf0839e2c0b$var$stgBaseUrl,
    staging: $acfecaf0839e2c0b$var$stgBaseUrl,
    prd: $acfecaf0839e2c0b$var$prodBaseUrl,
    prod: $acfecaf0839e2c0b$var$prodBaseUrl,
    production: $acfecaf0839e2c0b$var$prodBaseUrl
};
const $acfecaf0839e2c0b$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $acfecaf0839e2c0b$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $acfecaf0839e2c0b$export$e2b040f052407032 ? $acfecaf0839e2c0b$export$e2b040f052407032[envKey] : $acfecaf0839e2c0b$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $acfecaf0839e2c0b$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $acfecaf0839e2c0b$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $acfecaf0839e2c0b$export$2e2bcd8739ae039 = $acfecaf0839e2c0b$export$e2b040f052407032;
module.exports["getBaseUrl"] = $acfecaf0839e2c0b$export$f654b28f82155665;
module.exports["getResolverUrl"] = $acfecaf0839e2c0b$export$dc37652c1696f231;

});

parcelRegister("5nJCu", function(module, exports) {
class $b839f3682b6db3a9$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b839f3682b6db3a9$export$f993aef960936087;

});

parcelRegister("k00oi", function(module, exports) {

var $1bFdN = parcelRequire("1bFdN");


var $1oCLl = parcelRequire("1oCLl");


var $Gi9G7 = parcelRequire("Gi9G7");


var $abpX2 = parcelRequire("abpX2");


var $jHnts = parcelRequire("jHnts");

var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");

var $gmi3X = parcelRequire("gmi3X");


var $97i3I = parcelRequire("97i3I");


var $9trs7 = parcelRequire("9trs7");


var $6a9Hv = parcelRequire("6a9Hv");


var $dh538 = parcelRequire("dh538");

const $542f7628c45b2158$var$MAX_BATCH_SIZE = 50;
const $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE = 100;
const $542f7628c45b2158$export$d6a66073b5d79eb3 = new (0, $9trs7.LRUMap)($542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE);
class $542f7628c45b2158$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $542f7628c45b2158$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $dh538.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $542f7628c45b2158$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $97i3I.isSuccessfulResponse)(response) || (0, $btw9C.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $97i3I.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $97i3I.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $97i3I.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $97i3I.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $97i3I.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $gmi3X.NetworkError)) return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $jHnts.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $jHnts.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $jHnts.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $jHnts.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.loadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $1oCLl.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $542f7628c45b2158$export$2e2bcd8739ae039;

});

parcelRegister("Gi9G7", function(module, exports) {
// Packages

var $bfRrZ = parcelRequire("bfRrZ");

function $07f201957e3f51a5$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $bfRrZ.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $07f201957e3f51a5$var$retry;

});

parcelRegister("bfRrZ", function(module, exports) {

module.exports = (parcelRequire("2CRnP"));

});

parcelRegister("2CRnP", function(module, exports) {

var $jWveU = parcelRequire("jWveU");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $jWveU(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("jWveU", function(module, exports) {
function $e84baaa017e10274$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $e84baaa017e10274$var$RetryOperation;
$e84baaa017e10274$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$e84baaa017e10274$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$e84baaa017e10274$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$e84baaa017e10274$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = $e84baaa017e10274$var$RetryOperation.prototype.try;
$e84baaa017e10274$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$e84baaa017e10274$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("abpX2", function(module, exports) {
'use strict';
class $769f0fd050ef86b5$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $769f0fd050ef86b5$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $769f0fd050ef86b5$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $769f0fd050ef86b5$var$pThrottle;
module.exports.AbortError = $769f0fd050ef86b5$var$AbortError;

});

parcelRegister("gmi3X", function(module, exports) {
const $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $ffe0c3b764a3e96a$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $ffe0c3b764a3e96a$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $ffe0c3b764a3e96a$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["NetworkError"] = $ffe0c3b764a3e96a$export$bae979e68e4dc802;
module.exports["request"] = $ffe0c3b764a3e96a$export$b5fe3f66a567bec0;

});

parcelRegister("97i3I", function(module, exports) {
const $e30f485c735f2746$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $e30f485c735f2746$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isSuccessfulResponse"] = $e30f485c735f2746$export$1b59fe731a28a49d;
module.exports["isErrorResponse"] = $e30f485c735f2746$export$bea7bee8a87e7c52;

});

parcelRegister("lEzf1", function(module, exports) {
const $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $73e1dba18235f000$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $73e1dba18235f000$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $73e1dba18235f000$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $73e1dba18235f000$export$b5fe3f66a567bec0;

});

parcelRegister("et4nk", function(module, exports) {
function $7f5b74af20e3e05b$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $7f5b74af20e3e05b$export$41263783ff0932a8;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("hr9NW", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $477dG = parcelRequire("477dG");


var $ibzAc = parcelRequire("ibzAc");


var $loQgl = parcelRequire("loQgl");


var $k00oi = parcelRequire("k00oi");


var $ge2sX = parcelRequire("ge2sX");


var $yuV6Z = parcelRequire("yuV6Z");


var $32x2E = parcelRequire("32x2E");


var $9WAeG = parcelRequire("9WAeG");


var $jQQYu = parcelRequire("jQQYu");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $60cDW = parcelRequire("60cDW");


var $aN0qB = parcelRequire("aN0qB");


var $hXGAG = parcelRequire("hXGAG");


var $kyRHQ = parcelRequire("kyRHQ");

const $8323d63e0ec880b7$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData';
const $8323d63e0ec880b7$var$DEFAULT_TIMEOUT = 500;
async function $8323d63e0ec880b7$export$82c96ba69b54d1e5(contentId) {
    if (!contentId) return;
    if (!$8323d63e0ec880b7$var$isSSR()) // If we are not in SSR, we don't need to preload node data providers data.
    return;
    await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $9WAeG.SSRMeasures).run($8323d63e0ec880b7$var$MEASURE_SEGMENT, async ()=>{
            const fetchAdfStart = performance.now();
            const docJsonString = await (async ()=>{
                const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult2 = await $8323d63e0ec880b7$var$fetchAdf(contentId);
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                return _asyncResult2;
            })();
            const fetchAdfDuration = performance.now() - fetchAdfStart;
            if (!docJsonString) return;
            const doc = JSON.parse(docJsonString);
            // Should be removed when all experiments are removed
            const experimentTimeouts = [];
            const providers = [];
            if ((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) {
                providers.push({
                    provider: $8323d63e0ec880b7$var$ssrEditorCardProvider(),
                    maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
                });
                experimentTimeouts.push(Math.max(0, (0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'timeoutStrategy', 'total') === 'total' ? Math.round((0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'timeout', 500) - fetchAdfDuration) : (0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'timeout', 500)));
            }
            if ((0, $6mKj3.expVal)('platform_editor_emoji_otp', 'isEnabled', false)) {
                const sessionData = await (async ()=>{
                    const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
                    const _asyncResult3 = await $8323d63e0ec880b7$var$getSessionData();
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
                    return _asyncResult3;
                })();
                const provider = $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider(sessionData);
                if (provider) {
                    providers.push({
                        provider: provider,
                        maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).emoji
                    });
                    experimentTimeouts.push((0, $6mKj3.expVal)('platform_editor_emoji_otp', 'timeout', 500));
                }
            }
            providers.forEach(({ provider: provider })=>{
                (0, $9WAeG.SSRMeasures).markMeasureStart($8323d63e0ec880b7$var$measureProviderSegment(provider.name));
            });
            const editorNodeDataProvidersData = await (async ()=>{
                const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult4 = await (0, $loQgl.prefetchNodeDataProvidersData)({
                    doc: doc,
                    providers: providers,
                    timeout: experimentTimeouts.length > 0 ? Math.min(...experimentTimeouts) : $8323d63e0ec880b7$var$DEFAULT_TIMEOUT,
                    maxNodesToVisit: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT)
                });
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
                return _asyncResult4;
            })();
            Object.entries(editorNodeDataProvidersData).forEach(([providerName, { duration: duration }])=>{
                (0, $9WAeG.SSRMeasures).setMeasureDuration($8323d63e0ec880b7$var$measureProviderSegment(providerName), duration);
            });
            window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                    providerName,
                    data
                ]));
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
}
function $8323d63e0ec880b7$var$fetchAdf(contentId) {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/fetch:AdfDocQuery`, async ()=>{
        try {
            const result = await (async ()=>{
                const _beforeResult5 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult5 = await (0, $dYU3e.query)({
                    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $hXGAG.AdfDocQuery),
                    variables: {
                        contentId: contentId,
                        status: [
                            'draft'
                        ]
                    },
                    fetchPolicy: 'network-only'
                });
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult5);
                return _asyncResult5;
            })();
            if (result.hasErrors) return undefined;
            return result.data?.singleContent?.body?.atlas_doc_format?.value || undefined;
        } catch  {
            return undefined;
        }
    });
}
function $8323d63e0ec880b7$var$getSessionData() {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/getSessionData`, async ()=>{
        return (0, $ge2sX.getSessionData)();
    });
}
function $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider(sessionData) {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = sessionData;
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $yuV6Z.createEmojiProviderParameters)({
        cloudId: cloudId,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn
    });
    return (0, $32x2E.getEmojiNodeDataProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
}
function $8323d63e0ec880b7$var$ssrEditorCardProvider() {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    // This URL will be something like `https://object-resolver.staging.atl-paas.net/resolve/batch`.
    // We need only protocol and host to pass it to the EditorCardProvider,
    // because path will be added by `CardClient`.
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    // We need to define a custom CardClient for SSR, because the default one works through public API gateway.
    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
    // Headers from `fetchORSForSSR` from confluence/next/packages/content-smartlinks/src/index.ts
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    return new (0, $477dG.EditorCardProvider)('custom', objectResolverURL, 'CONFLUENCE', undefined, ssrCardClient);
}
function $8323d63e0ec880b7$var$isSSR() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        typeof $kyRHQ !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}
function $8323d63e0ec880b7$var$measureProviderSegment(providerName) {
    return `${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/${providerName}`;
}
module.exports["preloadEditorNodeDataProvidersData"] = $8323d63e0ec880b7$export$82c96ba69b54d1e5;

});

parcelRegister("loQgl", function(module, exports) {

var $et4nk = parcelRequire("et4nk");

async function $33eee30649b8eece$export$65217f7ac34c2278({ providers: providers, doc: doc, timeout: timeout, maxNodesToVisit: maxNodesToVisit = Infinity }) {
    if (timeout <= 0) // If the global timeout is 0 or negative, skip fetching entirely.
    return providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            data: {},
            success: false,
            duration: 0
        };
        return acc;
    }, {});
    const providersWithDefaults = providers.map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch = Infinity, timeout: providerTimeout = Infinity })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            // Use the minimum of the global timeout and the provider-specific timeout
            timeout: Math.min(providerTimeout, timeout)
        }));
    const providerTimeouts = providersWithDefaults.reduce((acc, { provider: provider, timeout: timeout })=>{
        acc[provider.name] = timeout;
        return acc;
    }, {});
    const nodesWithProviders = (0, $et4nk.findNodesToPrefetch)(doc, providersWithDefaults, maxNodesToVisit).map(({ provider: provider, nodes: nodes })=>({
            provider: provider,
            nodes: nodes,
            timeout: providerTimeouts[provider.name]
        }));
    const promises = nodesWithProviders.map(async ({ nodes: nodes, provider: provider, timeout: timeout })=>{
        if (timeout <= 0) return {
            provider: provider,
            success: false,
            duration: 0,
            nodes: nodes,
            data: []
        };
        const start = performance.now();
        function getDurationFromStart() {
            return Math.min(performance.now() - start, timeout);
        }
        try {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject();
                }, timeout);
            });
            const data = await Promise.race([
                provider.fetchNodesData(nodes),
                timeoutPromise
            ]);
            return {
                provider: provider,
                success: true,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: data
            };
        } catch  {
            return {
                provider: provider,
                success: false,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: []
            };
        }
    });
    const results = await Promise.all(promises);
    return results.reduce((acc, { provider: provider, success: success, duration: duration, nodes: nodes, data: data })=>{
        const ssrData = data.reduce((providerSsrData, nodeData, nodeIndex)=>{
            const node = nodes[nodeIndex];
            const nodeDataKey = provider.nodeDataKey(node);
            providerSsrData[nodeDataKey] = nodeData;
            return providerSsrData;
        }, {});
        acc[provider.name] = {
            data: ssrData,
            success: success,
            duration: duration
        };
        return acc;
    }, {});
}
module.exports["prefetchNodeDataProvidersData"] = $33eee30649b8eece$export$65217f7ac34c2278;

});

parcelRegister("yuV6Z", function(module, exports) {
const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>`${$378a693b2c26358e$export$ca6dda5263526f75}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");

parcelRequire("8uNa8");
var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("8uNa8", function(module, exports) {
$parcel$export(module.exports, "emojiPlugin", () => (parcelRequire("hcboS")).emojiPlugin);
$parcel$export(module.exports, "EmojiNodeDataProvider", () => (parcelRequire("5B7Fh")).EmojiNodeDataProvider);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5B7Fh = parcelRequire("5B7Fh");

var $hcboS = parcelRequire("hcboS");


});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id ?? node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("hcboS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $ahUGI = parcelRequire("ahUGI");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $1S4f7 = parcelRequire("1S4f7");


var $lOELb = parcelRequire("lOELb");


var $lNDSG = parcelRequire("lNDSG");


var $ks2lK = parcelRequire("ks2lK");


var $kVNt7 = parcelRequire("kVNt7");

var $lGf1F = parcelRequire("lGf1F");

var $injKz = parcelRequire("injKz");

var $aGYoD = parcelRequire("aGYoD");


var $1yB28 = parcelRequire("1yB28");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $kQc80 = parcelRequire("kQc80");


var $j0XxS = parcelRequire("j0XxS");


var $lhIns = parcelRequire("lhIns");


var $cKEEj = parcelRequire("cKEEj");


var $cTFYB = parcelRequire("cTFYB");


var $aFWfo = parcelRequire("aFWfo");

const $8d1c5078b4947753$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $kVNt7.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $8d1c5078b4947753$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $8d1c5078b4947753$var$memoizedToItem = $8d1c5078b4947753$export$fc10aeed3a532e2a($8d1c5078b4947753$export$144d1b98bacb98cc);
const $8d1c5078b4947753$var$defaultListLimit = 50;
const $8d1c5078b4947753$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $8d1c5078b4947753$var$TRIGGER = ':';
function $8d1c5078b4947753$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $8d1c5078b4947753$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).EMOJI,
        trigger: $8d1c5078b4947753$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $8d1c5078b4947753$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            // @ts-ignore - Workaround for help-center local consumption
                            const emojiItems = emojiResult.emojis.map((emoji)=>$8d1c5078b4947753$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                // @ts-ignore - Workaround for help-center local consumption
                emojiProvider.filter($8d1c5078b4947753$var$TRIGGER.concat(query), {
                    limit: $8d1c5078b4947753$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $aGYoD.SearchSort).UsageFrequency : (0, $aGYoD.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $8d1c5078b4947753$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!(options?.disableAutoformat && (0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true)) && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $8d1c5078b4947753$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $injKz.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $injKz.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            const fragment = (0, $kQc80.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            // @ts-ignore - Workaround for help-center local consumption
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $j0XxS.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $42omo.useEffect)(()=>{
                $8d1c5078b4947753$var$delayUntilIdle(()=>{
                    (0, $lGf1F.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $cTFYB.inputRulePlugin)(schema, api?.analytics?.actions, api, (0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true) ? options?.disableAutoformat : undefined)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $cKEEj.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$8d1c5078b4947753$var$setProviderTr(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $kQc80.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aFWfo.InlineEmojiPopup), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'emoji',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emoji),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emojiDescription),
                        priority: 500,
                        keyshortcut: ':',
                        isDisabledOffline: false,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconEmoji), {}),
                        action (insert) {
                            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                                exposure: true
                            })) {
                                // Clear slash
                                let tr = insert('');
                                tr = (0, $cKEEj.setInlineEmojiPopupOpen)(true)(tr);
                                return tr;
                            }
                            const tr = insert(undefined);
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).CLICKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $lNDSG.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        // @ts-ignore - Workaround for help-center local consumption
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                                title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                                    description: intl.formatMessage((0, $ahUGI.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $8d1c5078b4947753$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $cKEEj.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $8d1c5078b4947753$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $8d1c5078b4947753$var$logRateWarning = ()=>{};
const $8d1c5078b4947753$var$setProviderTr = $8d1c5078b4947753$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $cKEEj.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $8d1c5078b4947753$var$logRateWarning);
const $8d1c5078b4947753$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $8d1c5078b4947753$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $8d1c5078b4947753$export$e3ef5170578bd8ba = new (0, $ks2lK.PluginKey)('emojiPlugin');
function $8d1c5078b4947753$var$getEmojiPluginState(state) {
    return $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state) || {};
}
function $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $1S4f7.SafePlugin)({
        key: $8d1c5078b4947753$export$e3ef5170578bd8ba,
        state: {
            // @ts-ignore - Workaround for help-center local consumption
            init () {
                if (options?.emojiProvider && (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            // @ts-ignore - Workaround for help-center local consumption
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($8d1c5078b4947753$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $cKEEj.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true) ? Promise.resolve(params.provider) : undefined
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            // @ts-ignore - Workaround for help-center local consumption
            nodeViews: {
                // @ts-ignore - Workaround for help-center local consumption
                emoji: (node)=>{
                    return new (0, $lhIns.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options?.emojiNodeDataProvider
                    });
                }
            }
        },
        // @ts-ignore - Workaround for help-center local consumption
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $8d1c5078b4947753$var$setProvider?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $8d1c5078b4947753$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                // @ts-ignore - Workaround for help-center local consumption
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["emojiPlugin"] = $8d1c5078b4947753$export$d1221bd3f80501e0;
module.exports["emojiPluginKey"] = $8d1c5078b4947753$export$e3ef5170578bd8ba;

});

parcelRegister("kQc80", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $bYZ53 = parcelRequire("bYZ53");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $86388d1937acfc41$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $5SAOw.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $86388d1937acfc41$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $86388d1937acfc41$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $8m4tT.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $ks2lK.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };
module.exports["createEmojiFragment"] = $86388d1937acfc41$export$c62c7770bca4be17;
module.exports["insertEmoji"] = $86388d1937acfc41$export$8d5c072327044b6f;

});

parcelRegister("j0XxS", function(module, exports) {

var $86xUj = parcelRequire("86xUj");


var $24P9d = parcelRequire("24P9d");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $ef49a6b5d9cf65a1$var$isSSR = Boolean(undefined);
const $ef49a6b5d9cf65a1$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $86xUj.emojiWithLocalId) : (0, $86xUj.emoji);
    if ($ef49a6b5d9cf65a1$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$ef49a6b5d9cf65a1$export$9edeb07c311f4561(node)
    };
};
function $ef49a6b5d9cf65a1$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $24P9d.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}
module.exports["emojiNodeSpec"] = $ef49a6b5d9cf65a1$export$d122e24cc43292f6;
module.exports["emojiToDom"] = $ef49a6b5d9cf65a1$export$9edeb07c311f4561;

});

parcelRegister("lhIns", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");

var $ig7BH = parcelRequire("ig7BH");


var $hWRJP = parcelRequire("hWRJP");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $j0XxS = parcelRequire("j0XxS");

function $14dc3fa642295a9f$export$1d677781db73ff20(fallbackText) {
    // Regular expression to match a single emoji character
    const emojiRegex = // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    RegExp("^(\\p{Emoji_Presentation}|\\p{Extended_Pictographic}\\u{FE0F}?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
    return emojiRegex.test(fallbackText);
}
class $14dc3fa642295a9f$export$cadc6675ce598ba8 {
    static logError(error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const emojiRepresentation = emojiDescription?.representation;
            if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation);
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        const fallbackElement = document.createElement('span');
        fallbackElement.innerText = this.node.attrs.text || this.node.attrs.shortName;
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${this.node.attrs.shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'sprite' in representation ? 'sprite' : 'image';
        // Add wrapper for the emoji
        const containerElement = document.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $ig7BH.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
    }
    createSpriteEmojiElement(representation) {
        const spriteElement = document.createElement('span');
        spriteElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $fhsiz.defaultEmojiHeight}px`;
        if (!(0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $fhsiz.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $fhsiz.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        const imageElement = document.createElement('img');
        imageElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) {
            imageElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
            imageElement.style.objectFit = 'contain';
        }
        if (representation.width && representation.height) {
            imageElement.height = (0, $fhsiz.defaultEmojiHeight);
            if (!(0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) // Because img.width is round to the nearest integer.
            imageElement.setAttribute('width', `${(0, $fhsiz.defaultEmojiHeight) / representation.height * representation.width}`);
        }
        imageElement.onerror = ()=>{
            if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) {
                this.renderFallback();
                return;
            }
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
                // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
                // mark the node to refresh when returning online.
                // Create a check that confirms if this.node.attrs.text if an ascii emoji
                if ($14dc3fa642295a9f$export$1d677781db73ff20(this.node.attrs.text)) this.renderFallback();
                else this.renderingFallback = true;
            }
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.destroy = ()=>{};
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $j0XxS.emojiToDom)(this.node));
        this.dom = dom;
        if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true)) this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        else this.domElement = dom instanceof HTMLElement ? dom : undefined;
        if ((0, $1oCLl.expValEquals)('platform_editor_emoji_otp', 'isEnabled', true) && emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription?.representation;
                if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            if ((0, $eTj7Y.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api?.emoji?.sharedState;
            if (!sharedState) return;
            let emojiProvider = sharedState.currentState()?.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState?.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if (prevSharedState?.mode === 'offline' && nextSharedState?.mode === 'online' && this.renderingFallback && (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) this.updateDom(sharedState.currentState()?.emojiProvider);
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection?.();
            };
        }
    }
}
module.exports["EmojiNodeView"] = $14dc3fa642295a9f$export$cadc6675ce598ba8;

});

parcelRegister("ig7BH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $2faac4f2f00836b4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $2faac4f2f00836b4$export$defe85febe8b728c;

});

parcelRegister("cKEEj", function(module, exports) {

var $hcboS = parcelRequire("hcboS");

const $38eca9ebbfac95ba$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $38eca9ebbfac95ba$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $38eca9ebbfac95ba$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $38eca9ebbfac95ba$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $38eca9ebbfac95ba$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });
module.exports["ACTIONS"] = $38eca9ebbfac95ba$export$92a1a3b7554e9387;
module.exports["setAsciiMap"] = $38eca9ebbfac95ba$export$5e8f481ab8296997;
module.exports["openTypeAhead"] = $38eca9ebbfac95ba$export$adbec20dbbf15a6b;
module.exports["setProvider"] = $38eca9ebbfac95ba$export$1572b3eade6662f9;
module.exports["setInlineEmojiPopupOpen"] = $38eca9ebbfac95ba$export$f53f9c9a74ec859b;

});

parcelRegister("cTFYB", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");


var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


var $1oCLl = parcelRequire("1oCLl");

let $4f54215972d22941$var$matcher;
function $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat && (0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true)) return;
    if (schema.nodes.emoji) {
        $4f54215972d22941$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $l03WE.createRule)($4f54215972d22941$var$AsciiEmojiMatcher.REGEX, $4f54215972d22941$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4f54215972d22941$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4f54215972d22941$var$matcher = new $4f54215972d22941$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4f54215972d22941$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4f54215972d22941$var$matcher) return null;
        const match = $4f54215972d22941$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4f54215972d22941$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4f54215972d22941$var$getLeadingString = (match, withParenthesis = true)=>match[$4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4f54215972d22941$var$getLeadingStringWithoutParentheses = (match)=>$4f54215972d22941$var$getLeadingString(match, false);
const $4f54215972d22941$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4f54215972d22941$var$getAsciiWithParentheses = (matchParts)=>$4f54215972d22941$var$getAscii(matchParts, true);
const $4f54215972d22941$var$getTrailingString = (match)=>match[$4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingStringWithoutParentheses(matchParts), $4f54215972d22941$var$getAsciiWithParentheses(matchParts), $4f54215972d22941$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingString(matchParts), $4f54215972d22941$var$getAscii(matchParts), $4f54215972d22941$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4f54215972d22941$var$AsciiEmojiMatcher.REGEX = new RegExp(`((?:^|[\\s${(0, $14sLv.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $14sLv.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3}( ))$`);
class $4f54215972d22941$var$RecordingAsciiEmojiMatcher extends $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4f54215972d22941$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).ASCII
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4f54215972d22941$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4f54215972d22941$export$2e2bcd8739ae039 = $4f54215972d22941$var$plugins;
module.exports["inputRulePlugin"] = $4f54215972d22941$export$568a7ed6897c4817;

});

parcelRegister("aFWfo", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $d925B = parcelRequire("d925B");


var $kuh1P = parcelRequire("kuh1P");


var $1Oo9w = parcelRequire("1Oo9w");


var $jwWgu = parcelRequire("jwWgu");


var $efG2U = parcelRequire("efG2U");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $fnia6 = parcelRequire("fnia6");


var $dh538 = parcelRequire("dh538");


var $cKEEj = parcelRequire("cKEEj");

const $5da86e14354f1f0f$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $5da86e14354f1f0f$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $5da86e14354f1f0f$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $1Oo9w.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if (isOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const emojiProvider = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        editorView.dispatch((0, $cKEEj.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $42omo.useMemo)(()=>(0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const isOpen = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement
    });
});
module.exports["InlineEmojiPopup"] = $5da86e14354f1f0f$export$295b54f3ba0abfa5;

});

parcelRegister("kuh1P", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $d925B = parcelRequire("d925B");

const $7e8a46109aa777b7$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};
module.exports["getDomRefFromSelection"] = $7e8a46109aa777b7$export$49d74ed2464a12b9;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("hXGAG", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $c207ef781d729b17$export$689ef413c8a1032c = (0, $eSUdr.default)`query AdfDocQuery($contentId:ID$status:[String]){singleContent(id:$contentId status:$status){id body{atlas_doc_format{value}}}}`;
module.exports["AdfDocQuery"] = $c207ef781d729b17$export$689ef413c8a1032c;

});

parcelRegister("fywGr", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $5cryL = parcelRequire("5cryL");


var $66UJS = parcelRequire("66UJS");

const $7aae32df106d9977$export$864cb1c5b7b9b39 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS))
        }
    });
};
module.exports["preloadEditorOnboardingState"] = $7aae32df106d9977$export$864cb1c5b7b9b39;

});

parcelRegister("32Xjk", function(module, exports) {
/**
 * @generated SignedSource<<a9e022e28ab25d508f71b663053f309c>>
 * @relayHash 3d166b53e496ae6a12171538cb6c6ca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce
const $6ea889d48284c196$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-ever-set"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-ever-set\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3d166b53e496ae6a12171538cb6c6ca8",
            "id": "47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce",
            "metadata": {},
            "name": "useEmojiEverSetPropertyQuery",
            "operationKind": "query",
            "text": "query useEmojiEverSetPropertyQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}}}"
        }
    };
}();
$6ea889d48284c196$var$node.hash = "7922225ac99254e0526a345863d19578";
var $6ea889d48284c196$export$2e2bcd8739ae039 = $6ea889d48284c196$var$node;
module.exports["default"] = $6ea889d48284c196$export$2e2bcd8739ae039;

});

parcelRegister("fiBb3", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $23261b803687ce64$export$2b17287e63c772da = (0, $eSUdr.default)`query ContentHeaderUnifiedQuery($contentId:ID!$spaceKey:String$versionOverride:Int$embeddedContentRender:String$limit:Int$useNewContentTopper:Boolean=false$status:[String]$includeGeneratedBy:Boolean=false){content(id:$contentId version:$versionOverride embeddedContentRender:$embeddedContentRender status:$status){nodes{id type subType title status appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}history{createdDate createdBy{type displayName ...on KnownUser{accountId}profilePicture{path}}ownedBy{type displayName ...on KnownUser{accountId}profilePicture{path}}lastOwnedBy{type displayName ...on KnownUser{accountId}profilePicture{path}}}emojiTitlePublished:properties(key:"emoji-title-published"){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}properties(key:"editor"){nodes{id key value}}space{id name homepageId}version{message by{type displayName ...on KnownUser{accountId}profilePicture{path}}friendlyWhen when number contentTypeModified}contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}}metadata{sourceTemplateEntityId lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}}}contentContributors(id:$contentId limit:$limit){count isCurrentUserContributor isOwnerContributor nodes{type displayName ...on KnownUser{accountId}profilePicture{path}}}space(key:$spaceKey){id theme{themeKey}lookAndFeel{headings{key value}content{header{background backgroundAttachment backgroundBlendMode backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPosition backgroundRepeat backgroundSize borderRadius padding}}}}}`;
module.exports["ContentHeaderUnifiedQuery"] = $23261b803687ce64$export$2b17287e63c772da;

});

parcelRegister("dPxOK", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $808b815339a04d5e$export$a00e3b42c37910ac = (0, $eSUdr.default)`query SpacePagesQuery($searchText:String!$filters:ConfluenceSearchFilters!$first:Int!$maxNumberOfResults:Int!$token:String$sortBy:[ConfluenceContentSortField!]$isLicensed:Boolean!$includeRecommended:Boolean=false$spaceId:String=""$scopes:[ConfluenceContentSearchScope!]!)@allowHigherTimeout{confluenceContentSearch(query:$searchText scopes:$scopes filters:$filters first:$first token:$token sort:$sortBy sessionAttributes:{experience:"confluence.spacePages"}){nodes{...on ConfluenceContentSearchResult@include(if:$isLicensed){watchDialogContent:content{id currentUserIsWatching type space{id key currentUser{isWatched isWatchingBlogs}operations{operation targetType}}}}...on ConfluenceContentSearchResult{id title url excerpt lastModified{value}content{id type subType status blank links{editui}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key alias name}history{createdBy{profilePicture{path}displayName ...on KnownUser{accountId}}ownedBy{profilePicture{path}displayName ...on KnownUser{accountId}}}metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}likes{count}version{by{profilePicture{path}displayName ...on KnownUser{accountId}}}}}}totalCount pageInfo{hasNextPage nextPageToken}}objectRecommendations(context:{containerId:$spaceId product:"confluence"}modelRequestParams:{experience:"ConfSpacePages" caller:"confluence"}maxNumberOfResults:$maxNumberOfResults)@include(if:$includeRecommended){nodes{id content{id title type subType status blank excerpt(length:372)links{webui editui}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key alias name}history{createdBy{profilePicture{path}displayName ...on KnownUser{accountId}}ownedBy{profilePicture{path}displayName ...on KnownUser{accountId}}}metadata{lastModifiedDate currentuser{favourited{isFavourite}}comments{commentsCount}}likes{count}version{by{profilePicture{path}displayName ...on KnownUser{accountId}}}}}}}`;
module.exports["SpacePagesQuery"] = $808b815339a04d5e$export$a00e3b42c37910ac;

});

parcelRegister("f3nZa", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $7de58d80405ca3af$export$ba58eecec1482def = (0, $eSUdr.default)`query PagesSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}`;
module.exports["PagesSpaceIdQuery"] = $7de58d80405ca3af$export$ba58eecec1482def;

});

parcelRegister("86moY", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $049755726a6450c1$export$8d7f96aa1035fc87 = (0, $eSUdr.default)`mutation SpacePagesAppearanceMutation($persistenceOption:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{globalPageCardAppearancePreference:$persistenceOption}){globalPageCardAppearancePreference}}`;
const $049755726a6450c1$export$555fc20901eb87ef = (0, $eSUdr.default)`mutation SpacePagesSortMutation($spaceKey:String!$field:PagesSortField!$order:PagesSortOrder!){updateUserPreferences(userPreferences:{spacePagesSortView:{spaceKey:$spaceKey spacePagesSortPersistenceOption:{field:$field order:$order}}}){spacePagesSortView(spaceKey:$spaceKey){field order}}}`;
const $049755726a6450c1$export$d0409301e9db0143 = (0, $eSUdr.default)`query SpacePagesPersistenceQuery($spaceKey:String!){userPreferences{globalPageCardAppearancePreference spacePagesSortView(spaceKey:$spaceKey){field order}}}`;
module.exports["SpacePagesPersistenceQuery"] = $049755726a6450c1$export$d0409301e9db0143;

});

parcelRegister("7AO3u", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $9d70d443261cdb0a$export$503b60f723e366ca = /*#__PURE__*/ function(ConfluenceContentSearchScope) {
    ConfluenceContentSearchScope["ATTACHMENT"] = "ATTACHMENT";
    ConfluenceContentSearchScope["BLOGPOST"] = "BLOGPOST";
    ConfluenceContentSearchScope["DATABASE"] = "DATABASE";
    ConfluenceContentSearchScope["EMBED"] = "EMBED";
    ConfluenceContentSearchScope["FOLDER"] = "FOLDER";
    ConfluenceContentSearchScope["PAGE"] = "PAGE";
    ConfluenceContentSearchScope["SPACE"] = "SPACE";
    ConfluenceContentSearchScope["WHITEBOARD"] = "WHITEBOARD";
    return ConfluenceContentSearchScope;
}({});
var $9d70d443261cdb0a$export$e9da5e0f236e706a = /*#__PURE__*/ function(ConfluenceContentSortingParameter) {
    ConfluenceContentSortingParameter["LAST_MODIFIED_DATE"] = "LAST_MODIFIED_DATE";
    ConfluenceContentSortingParameter["TITLE"] = "TITLE";
    return ConfluenceContentSortingParameter;
}({});
var $9d70d443261cdb0a$export$3464374b402385fe = /*#__PURE__*/ function(ConfluenceSearchContentStatus) {
    ConfluenceSearchContentStatus["ARCHIVED"] = "ARCHIVED";
    ConfluenceSearchContentStatus["CURRENT"] = "CURRENT";
    ConfluenceSearchContentStatus["DRAFT"] = "DRAFT";
    return ConfluenceSearchContentStatus;
}({});
var $9d70d443261cdb0a$export$285b07120e1d0458 = /*#__PURE__*/ function(LabelNamespaceEnum) {
    LabelNamespaceEnum["GLOBAL"] = "GLOBAL";
    LabelNamespaceEnum["MY"] = "MY";
    LabelNamespaceEnum["TEAM"] = "TEAM";
    return LabelNamespaceEnum;
}({});
var $9d70d443261cdb0a$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
    return SortOrder;
}({});
module.exports["ConfluenceContentSearchScope"] = $9d70d443261cdb0a$export$503b60f723e366ca;
module.exports["ConfluenceContentSortingParameter"] = $9d70d443261cdb0a$export$e9da5e0f236e706a;
module.exports["ConfluenceSearchContentStatus"] = $9d70d443261cdb0a$export$3464374b402385fe;
module.exports["LabelNamespaceEnum"] = $9d70d443261cdb0a$export$285b07120e1d0458;
module.exports["SortOrder"] = $9d70d443261cdb0a$export$7ae723045d45777a;

});

parcelRegister("ERQv7", function(module, exports) {
/**
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $2ad3479a036b83f6$export$a2685e6ac8ada3e6 = (0, $eSUdr.default)`query SearchResultsAGGSearchQuery($query:String!$cloudIdARI:[String!]!$limit:Int!$entities:[String!]!$commonFilters:SearchCommonFilter$confluenceFilters:SearchConfluenceFilter$sort:[SearchSortInput]$after:String$disableQueryReplacement:Boolean$experience:String!$isLicensed:Boolean!$includeRecommended:Boolean=false$spaceId:String!$tenantId:String!){search{results:search(experience:$experience query:$query first:$limit after:$after sort:$sort disableQueryReplacement:$disableQueryReplacement filters:{entities:$entities locations:$cloudIdARI commonFilters:$commonFilters confluenceFilters:$confluenceFilters}){totalCount edges{node{id __typename description iconUrl title type url ...on SearchConfluencePageBlogAttachment{lastModified isVerified space{id name webUiLink}...on SearchConfluencePageBlogAttachment@include(if:$isLicensed){watchDialogContent:content{id __typename currentUserIsWatching space{currentUser{isWatched isWatchingBlogs}operations{operation targetType}}}}content{id __typename blank excerpt}confluenceEntity{...on ConfluencePage{id __typename title type subtype pageStatus:status links{webUi editUi}metadata{titleEmojiPublished{__typename id key value}titleEmojiDraft{__typename id key value}}editorVersion:properties(keys:["editor"]){__typename key value}space{id key alias name}author{user{id picture name}}owner{user{id picture name}}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}likesSummary{count}}...on ConfluenceBlogPost{id __typename title type blogPostStatus:status links{webUi editUi}metadata{titleEmojiPublished{__typename id key value}titleEmojiDraft{__typename id key value}}editorVersion:properties(keys:["editor"]){__typename key value}space{id key alias name}author{user{id picture name}}owner{user{id picture name}}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}likesSummary{count}}...on ConfluenceEmbed{id __typename title type contentStatus:status links{webUi}metadata{titleEmojiPublished{__typename id key value}titleEmojiDraft{__typename id key value}}space{id key alias name}author{user{id picture name}}owner{user{id picture name}}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}}...on ConfluenceDatabase{id __typename title type contentStatus:status links{webUi}space{id key alias name}author{user{id picture name}}owner{user{id picture name}}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}}...on ConfluenceWhiteboard{id __typename title type contentStatus:status links{webUi}space{id key alias name}author{user{id picture name}}owner{user{id picture name}}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}}...on ConfluenceFolder{id __typename title type contentStatus:status links{webUi}space{id key alias name}author{user{id picture name}}owner{user{id picture name}}viewer{favoritedSummary{isFavorite}}}}}}}totalCount totalCounts{product count}pageInfo{endCursor}}}smarts@include(if:$includeRecommended){recommendedObject(recommendationsQuery:{context:{userId:"context" tenantId:$tenantId product:"confluence" containerId:$spaceId}modelRequestParams:{experience:$experience caller:"confluence"}requestingUserId:"context"}){content{id __typename blank excerpt(length:372)}object{...on ConfluencePage{id __typename title type subtype pageStatus:status links{webUi editUi __typename}metadata{titleEmojiDraft{__typename id key value}titleEmojiPublished{__typename id key value}}viewer{favoritedSummary{isFavorite}}editorVersion:properties(keys:["editor"]){__typename key value}space{id __typename key alias name}author{user{id __typename picture name}}owner{user{id picture name}}latestVersion{author{user{id __typename picture name}}createdAt}commentCountSummary{total}likesSummary{count}}...on ConfluenceBlogPost{id __typename title type blogPostStatus:status links{webUi editUi __typename}metadata{titleEmojiDraft{__typename id key value}titleEmojiPublished{__typename id key value}}viewer{favoritedSummary{isFavorite}}editorVersion:properties(keys:["editor"]){__typename key value}space{id __typename key alias name}author{user{id __typename picture name}}owner{user{id picture name}}latestVersion{author{user{id __typename picture name}}createdAt}commentCountSummary{total}likesSummary{count}}}}}}`;
module.exports["SearchResultsAGGSearchQuery"] = $2ad3479a036b83f6$export$a2685e6ac8ada3e6;

});

parcelRegister("dC2j7", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $7AO3u = parcelRequire("7AO3u");

/**
 * @generated SignedSource<<6015fe9dcb2ced0b48e0838e868c1529>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: agg
 *
 * @see https://go/typsy
 **/ var $ccee155af0706769$export$f2d20e136929adb = /*#__PURE__*/ function(ConfluenceBlogPostStatus) {
    ConfluenceBlogPostStatus["ARCHIVED"] = "ARCHIVED";
    ConfluenceBlogPostStatus["CURRENT"] = "CURRENT";
    ConfluenceBlogPostStatus["DELETED"] = "DELETED";
    ConfluenceBlogPostStatus["DRAFT"] = "DRAFT";
    ConfluenceBlogPostStatus["HISTORICAL"] = "HISTORICAL";
    ConfluenceBlogPostStatus["TRASHED"] = "TRASHED";
    return ConfluenceBlogPostStatus;
}({});
var $ccee155af0706769$export$707aa6fb934c37ca = /*#__PURE__*/ function(ConfluenceContentStatus) {
    ConfluenceContentStatus["ARCHIVED"] = "ARCHIVED";
    ConfluenceContentStatus["CURRENT"] = "CURRENT";
    ConfluenceContentStatus["DELETED"] = "DELETED";
    ConfluenceContentStatus["DRAFT"] = "DRAFT";
    ConfluenceContentStatus["HISTORICAL"] = "HISTORICAL";
    ConfluenceContentStatus["TRASHED"] = "TRASHED";
    return ConfluenceContentStatus;
}({});
var $ccee155af0706769$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["ATTACHMENT"] = "ATTACHMENT";
    ConfluenceContentType["BLOG_POST"] = "BLOG_POST";
    ConfluenceContentType["COMMENT"] = "COMMENT";
    ConfluenceContentType["PAGE"] = "PAGE";
    ConfluenceContentType["WHITEBOARD"] = "WHITEBOARD";
    return ConfluenceContentType;
}({});
var $ccee155af0706769$export$b9563c27e132ecf3 = /*#__PURE__*/ function(ConfluencePageStatus) {
    ConfluencePageStatus["ARCHIVED"] = "ARCHIVED";
    ConfluencePageStatus["CURRENT"] = "CURRENT";
    ConfluencePageStatus["DELETED"] = "DELETED";
    ConfluencePageStatus["DRAFT"] = "DRAFT";
    ConfluencePageStatus["HISTORICAL"] = "HISTORICAL";
    ConfluencePageStatus["TRASHED"] = "TRASHED";
    return ConfluencePageStatus;
}({});
var $ccee155af0706769$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ccee155af0706769$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["CURRENT"] = "CURRENT";
    SearchConfluenceDocumentStatus["ARCHIVED"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["DRAFT"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({});
var $ccee155af0706769$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchConfluenceRangeField["CREATED"] = "CREATED";
    return SearchConfluenceRangeField;
}({});
var $ccee155af0706769$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["ARCHIVED"] = "ARCHIVED";
    SearchContainerStatus["CURRENT"] = "CURRENT";
    return SearchContainerStatus;
}({});
var $ccee155af0706769$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["database"] = "database";
    SearchResultType["whiteboard"] = "whiteboard";
    SearchResultType["embed"] = "embed";
    SearchResultType["folder"] = "folder";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["dashboard"] = "dashboard";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["goal"] = "goal";
    SearchResultType["project_update"] = "project_update";
    SearchResultType["goal_update"] = "goal_update";
    SearchResultType["tag"] = "tag";
    SearchResultType["focus_area"] = "focus_area";
    SearchResultType["focus_area_status_update"] = "focus_area_status_update";
    SearchResultType["question"] = "question";
    SearchResultType["learning"] = "learning";
    SearchResultType["document"] = "document";
    SearchResultType["repository"] = "repository";
    SearchResultType["component"] = "component";
    SearchResultType["presentation"] = "presentation";
    SearchResultType["spreadsheet"] = "spreadsheet";
    SearchResultType["message"] = "message";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $ccee155af0706769$export$3cf9b6ba26bc95c6 = /*#__PURE__*/ function(SearchSortOrder) {
    SearchSortOrder["ASC"] = "ASC";
    SearchSortOrder["DESC"] = "DESC";
    return SearchSortOrder;
}({});


const $acb737f2b02900d4$export$3e1423ba918b02c3 = 12;
const $acb737f2b02900d4$export$964ee2c26a2e8aba = {
    page: 'ati:cloud:confluence:page',
    blogpost: 'ati:cloud:confluence:blogpost',
    embed: 'ati:cloud:confluence:embed',
    folder: 'ati:cloud:confluence:folder',
    whiteboard: 'ati:cloud:confluence:whiteboard',
    database: 'ati:cloud:confluence:database'
};
const $acb737f2b02900d4$var$AGG_EXPERIENCE = 'ConfSpacePages';
const $acb737f2b02900d4$var$STARRED_PAGE_LABEL = 'my:favourite';
const $acb737f2b02900d4$export$f471e8a003a4fb0d = (sortBy)=>{
    if (!sortBy) return [];
    const order = sortBy.order === (0, $7AO3u.SortOrder).ASC ? (0, $ccee155af0706769$export$3cf9b6ba26bc95c6).ASC : (0, $ccee155af0706769$export$3cf9b6ba26bc95c6).DESC;
    let field;
    switch(sortBy.field){
        case 'LAST_MODIFIED_DATE':
            field = 'latestModifiedDate';
            break;
        case 'TITLE':
            field = 'title';
            break;
        default:
            field = 'latestModifiedDate';
    }
    return [
        {
            field: field,
            order: order
        }
    ];
};
const $acb737f2b02900d4$export$832c8592ab821c21 = ({ cloudId: cloudId, spaceKey: spaceKey, userId: userId, isLicensed: isLicensed, spaceId: spaceId, isWhiteboardEnabled: isWhiteboardEnabled, isDatabaseEnabled: isDatabaseEnabled, searchText: searchText, pagesFilter: pagesFilter, sort: sort, after: after = '', includeRecommended: includeRecommended = false })=>{
    return {
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: $acb737f2b02900d4$export$3e1423ba918b02c3,
        after: after,
        query: searchText,
        commonFilters: {
            range: {}
        },
        confluenceFilters: {
            spacesFilter: [
                spaceKey
            ],
            ...pagesFilter === 'worked-on' && userId && isLicensed && {
                contributorsFilter: [
                    userId
                ]
            },
            ...pagesFilter === 'starred' && isLicensed && {
                labelsFilter: [
                    $acb737f2b02900d4$var$STARRED_PAGE_LABEL
                ]
            },
            titleMatchOnly: true,
            contentStatuses: [
                (0, $ccee155af0706769$export$75fb70288e44d634).CURRENT,
                (0, $ccee155af0706769$export$75fb70288e44d634).DRAFT
            ],
            containerStatus: []
        },
        sort: sort ? sort : [],
        entities: [
            $acb737f2b02900d4$export$964ee2c26a2e8aba.page,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.embed,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.folder,
            ...isWhiteboardEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.whiteboard
            ] : [],
            ...isDatabaseEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.database
            ] : []
        ],
        experience: $acb737f2b02900d4$var$AGG_EXPERIENCE,
        spaceId: spaceId,
        isLicensed: Boolean(isLicensed),
        includeRecommended: includeRecommended
    };
};
const $acb737f2b02900d4$export$9afcdf80918a886b = (options)=>{
    const { cloudId: cloudId, spaceKey: spaceKey, queryParams: queryParams, userId: userId, isLicensed: isLicensed, spaceId: spaceId = '', isWhiteboardEnabled: isWhiteboardEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false } = options;
    const pagesFilter = (0, $c3Qwv.getSingleParam)(queryParams, 'pagesFilter');
    const searchText = (0, $c3Qwv.getSingleParam)(queryParams, 'text') || '';
    const sort = [
        {
            field: 'latestModifiedDate',
            order: (0, $ccee155af0706769$export$3cf9b6ba26bc95c6).DESC
        }
    ];
    return $acb737f2b02900d4$export$832c8592ab821c21({
        cloudId: cloudId,
        spaceKey: spaceKey,
        userId: userId,
        isLicensed: isLicensed,
        spaceId: spaceId,
        isWhiteboardEnabled: isWhiteboardEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        searchText: searchText,
        pagesFilter: pagesFilter,
        sort: sort
    });
};
module.exports["SPACE_PAGES_QUERY_LIMIT"] = $acb737f2b02900d4$export$3e1423ba918b02c3;
module.exports["convertCcSortToAggSort"] = $acb737f2b02900d4$export$f471e8a003a4fb0d;
module.exports["getAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$832c8592ab821c21;
module.exports["getPreloadAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$9afcdf80918a886b;

});

parcelRegister("yuLaV", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard') return !(0, $lzcvT.isFedRamp)();
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("5IsL6", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $3TUla = parcelRequire("3TUla");

const $c4ac54148814de4b$export$25bcc47d8ed557d4 = ({ isLicensed: isLicensed })=>{
    if (!isLicensed) return Promise.resolve({
        data: null
    });
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)({
        query: (0, $3TUla.CreateSpaceQuery)
    });
};
module.exports["preloadCreateSpace"] = $c4ac54148814de4b$export$25bcc47d8ed557d4;

});

parcelRegister("3TUla", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $55feeb7bb29f9c98$export$d89481326706128c = (0, $eSUdr.default)`query CreateSpaceQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation}}}}`;
module.exports["CreateSpaceQuery"] = $55feeb7bb29f9c98$export$d89481326706128c;

});

parcelRegister("5WLjq", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $5IsL6 = parcelRequire("5IsL6");


var $fstZx = parcelRequire("fstZx");

const $0075b8fcac3e7fa4$export$19b525d696aff959 = ({ isLicensed: isLicensed, selectedSpaceKey: selectedSpaceKey })=>{
    const preloadQueries = [];
    if (isLicensed) {
        preloadQueries.push((0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fstZx.StarredSpacesQuery),
            variables: {}
        }));
        if (selectedSpaceKey) preloadQueries.push((0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fstZx.MyVisitedSpacesWithCurrentSpaceQuery),
            variables: {
                selectedSpaceKey: selectedSpaceKey
            }
        }));
        else preloadQueries.push((0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fstZx.MyVisitedSpacesQuery),
            variables: {}
        }));
    } else preloadQueries.push((0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fstZx.AnonymousSpacesQuery),
        variables: {}
    }));
    preloadQueries.push((0, $5IsL6.preloadCreateSpace)({
        isLicensed: isLicensed
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(preloadQueries);
};
module.exports["preloadSpacesList"] = $0075b8fcac3e7fa4$export$19b525d696aff959;

});

parcelRegister("fstZx", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $bb42a67b08b88af0$export$f89460d6594658f1 = (0, $eSUdr.default)`query StarredSpacesQuery{spaces(favourite:true first:30 status:"current"){nodes{alias id name key status icon{path}}}}`;
const $bb42a67b08b88af0$export$73b0293722a8eb9f = (0, $eSUdr.default)`query MyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias id name key status icon{path}}}}}`;
const $bb42a67b08b88af0$export$9fdae40747d95364 = (0, $eSUdr.default)`query MyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias id name key status icon{path}currentUser{isFavourited}}myVisitedSpaces(limit:26){nodes{spaces{alias id name key status icon{path}}}}}`;
const $bb42a67b08b88af0$export$2e53cde7a8b8bbee = (0, $eSUdr.default)`query AnonymousSpacesQuery{spaces(first:10){nodes{alias id name key status icon{path}}}}`;
const $bb42a67b08b88af0$export$7c52f7af355ed457 = (0, $eSUdr.default)`query SearchSpacesQuery($spaceNamePattern:String!$isLicensed:Boolean!){spaces(first:30 status:"current" spaceNamePattern:$spaceNamePattern){nodes{alias id name key status icon{path}currentUser@include(if:$isLicensed){isFavourited}}}}`;
module.exports["StarredSpacesQuery"] = $bb42a67b08b88af0$export$f89460d6594658f1;
module.exports["MyVisitedSpacesQuery"] = $bb42a67b08b88af0$export$73b0293722a8eb9f;
module.exports["MyVisitedSpacesWithCurrentSpaceQuery"] = $bb42a67b08b88af0$export$9fdae40747d95364;
module.exports["AnonymousSpacesQuery"] = $bb42a67b08b88af0$export$2e53cde7a8b8bbee;
module.exports["SearchSpacesQuery"] = $bb42a67b08b88af0$export$7c52f7af355ed457;

});

parcelRegister("li6DS", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $089e2fbb47e60e9c$export$18e4a645623974a8 = ()=>{
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) // Custom domain check not necessary when AGG migration enabled
    // as AGG plays nice with those, for these queries
    return (0, $6mKj3.expValEquals)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', true);
    // Checks if the tenant has the default domains. Activity V3 is not able to return Confluence pages for custom domain tenants
    // This check can be removed once the fix is completed: https://hello.jira.atlassian.cloud/browse/DISCO-4716
    const isDefaultDomain = window.location.hostname.endsWith('.atlassian.net') || window.location.hostname.endsWith('.jira-dev.com');
    const isLocalhost = window.location.hostname === 'localhost';
    return (isDefaultDomain || isLocalhost) && (0, $6mKj3.expValEquals)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', true);
};
module.exports["getIsActivityV3RecentsEnabled"] = $089e2fbb47e60e9c$export$18e4a645623974a8;

});

parcelRegister("7HSaW", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $8f0ff207aa3594ef$export$e367407479ee8cd8 = (0, $eSUdr.default)`query GetLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus productKey}}}`;
module.exports["GetLicensedProductsQuery"] = $8f0ff207aa3594ef$export$e367407479ee8cd8;

});

parcelRegister("iyPd9", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b4e2a77d9a5ab99b$export$b3c271f2152800f6 = (0, $eSUdr.default)`query FeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;
module.exports["FeatureDiscoveryQuery"] = $b4e2a77d9a5ab99b$export$b3c271f2152800f6;

});

parcelRegister("3cztU", function(module, exports) {
/**
 * @generated SignedSource<<46215f6cdc8b85e17d7dd057c80add5a>>
 * @relayHash f47bc93d7998ea210ac691b605f5b35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID af9ab646d72da9776393b5dea7993049fd837b63b73b763c24ae60f979741ab0
const $a845950f81d03c88$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeGeneratedBy"
    }, v3 = {
        "defaultValue": "relevant",
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "recentActionsCount"
    }, v6 = {
        "kind": "ScalarField",
        "name": "datetime"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v9 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v10 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v12 = {
        "kind": "InlineFragment",
        "selections": v11 /*: any*/ ,
        "type": "KnownUser"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": v11 /*: any*/ ,
        "type": "UnknownUser"
    }, v14 = [
        v7 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v14 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "version"
    }, v17 = [
        v16 /*: any*/ ,
        v15 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v20 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineText"
            }
        ],
        "type": "InlineComment"
    }, v22 = {
        "kind": "ScalarField",
        "name": "value"
    }, v23 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            v22 /*: any*/ 
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v24 = {
        "kind": "ScalarField",
        "name": "source"
    }, v25 = {
        "kind": "ScalarField",
        "name": "title"
    }, v26 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v27 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v18 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v28 = {
        "condition": "includeGeneratedBy",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "generatedBy"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v29 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v30 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v31 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v32 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v18 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v33 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "FeedPageInformation",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v35 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": true,
        "selections": [
            v18 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "ABSOLUTE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"ABSOLUTE\")"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "servingRecommendations"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v39 = [
        v38 /*: any*/ ,
        v7 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v40 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v39 /*: any*/ 
    }, v41 = [
        v16 /*: any*/ ,
        v40 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v15 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v17 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v17 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v17 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v36 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v39 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v38 /*: any*/ ,
                                v9 /*: any*/ ,
                                v36 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f47bc93d7998ea210ac691b605f5b35d",
            "id": "af9ab646d72da9776393b5dea7993049fd837b63b73b763c24ae60f979741ab0",
            "metadata": {},
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "operationKind": "query",
            "text": "query useFollowingFeedWithSortByStorageFeedContentQuery($first:Int,$after:String,$sortBy:String=\"relevant\",$includeGeneratedBy:Boolean=false){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}},excerpt(length:350),links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
        }
    };
}();
$a845950f81d03c88$var$node.hash = "c9afd79ecba25f914402168c882a0f16";
var $a845950f81d03c88$export$2e2bcd8739ae039 = $a845950f81d03c88$var$node;
module.exports["default"] = $a845950f81d03c88$export$2e2bcd8739ae039;

});

parcelRegister("g4evd", function(module, exports) {
/**
 * @generated SignedSource<<eb9d4944e1a52a578070fe20a1bb6369>>
 * @relayHash 40ddeb0ef9f72faff15ea2ef539798b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81
const $8f22a426de8950e5$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "feedTab"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "40ddeb0ef9f72faff15ea2ef539798b5",
            "id": "1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81",
            "metadata": {},
            "name": "useFeedTypeSelectorRefreshQuery",
            "operationKind": "query",
            "text": "query useFeedTypeSelectorRefreshQuery{userPreferences{__typename,feedTab}}"
        }
    };
}();
$8f22a426de8950e5$var$node.hash = "6ca55df8184dd78031693e2b650f878d";
var $8f22a426de8950e5$export$2e2bcd8739ae039 = $8f22a426de8950e5$var$node;
module.exports["default"] = $8f22a426de8950e5$export$2e2bcd8739ae039;

});

parcelRegister("lNpDX", function(module, exports) {
/**
 * @generated SignedSource<<b663021ea0faa7416d359459149b84ba>>
 * @relayHash fa28c71520999fdbebd6aac5fca9af40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0754da2b08e899504983583c59fdb85d420898d65d2f2ba9f082f6326e240b7
const $afadcf197f0b9a77$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeGeneratedBy"
    }, v3 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v10 = {
        "condition": "includeGeneratedBy",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "generatedBy"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v12 /*: any*/ 
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v19 = {
        "kind": "InlineFragment",
        "selections": v18 /*: any*/ ,
        "type": "KnownUser"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": v18 /*: any*/ ,
        "type": "UnknownUser"
    }, v21 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v23 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fa28c71520999fdbebd6aac5fca9af40",
            "id": "f0754da2b08e899504983583c59fdb85d420898d65d2f2ba9f082f6326e240b7",
            "metadata": {},
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "operationKind": "query",
            "text": "query usePopularFeedWithTimeGranularityStorageQuery($first:Int,$after:String,$timeGranularity:String=\"default\",$includeGeneratedBy:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$afadcf197f0b9a77$var$node.hash = "066549408fa32d5e0b0f3bb3ca182962";
var $afadcf197f0b9a77$export$2e2bcd8739ae039 = $afadcf197f0b9a77$var$node;
module.exports["default"] = $afadcf197f0b9a77$export$2e2bcd8739ae039;

});

parcelRegister("MyxIQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bnKhH = parcelRequire("bnKhH");


var $5dPMD = parcelRequire("5dPMD");


var $301rJ = parcelRequire("301rJ");



var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");


var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $5dPMD.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'post-office',
                // Tells Tesseract to S2S with `post-office`
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $bnKhH.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $5dPMD.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $42omo.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $42omo.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $42omo.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, preloadedSessionContext, extraFetchOptions)=>{
    return $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(preloadedSessionContext),
        environment: {
            currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(preloadedSessionContext.environment)
        }
    }, extraFetchOptions);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-\/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("7OD0G", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $4564ce70ae4ed46b$export$67e44d402eae028 = (0, $eSUdr.default)`query HomeWidgetsQuery{userPreferences{homeWidgets{id state __typename}__typename}}`;
module.exports["HomeWidgetsQuery"] = $4564ce70ae4ed46b$export$67e44d402eae028;

});

parcelRegister("d2JgU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $444d9675741064a8$export$b219f21d745a9c1c = (0, $eSUdr.default)`query WelcomeMessagesQuery{spaViewContext{welcomeMessageEditUrl welcomeMessageHtml resourceKeys resourceContexts showWelcomeMessageEditHint showEditButton}}`;
module.exports["WelcomeMessagesQuery"] = $444d9675741064a8$export$b219f21d745a9c1c;

});

parcelRegister("a67vB", function(module, exports) {

var $8EU84 = parcelRequire("8EU84");


var $ctLrB = parcelRequire("ctLrB");


var $MTTRf = parcelRequire("MTTRf");

const $4b2ee2ac7b774614$export$154132902c275093 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, first: first = 10, isActivityV3MigrationEnabled: isActivityV3MigrationEnabled = false })=>({
        query: isActivityV3MigrationEnabled ? (0, $MTTRf.HomeRecentWorkV3Query) : (0, $MTTRf.HomeRecentWorkQuery),
        variables: {
            cloudId: isActivityV3MigrationEnabled ? (0, $8EU84.PlatformSiteAri).create({
                siteId: cloudId
            }).toString() : cloudId,
            first: first,
            after: '',
            objectTypes: [
                (0, $ctLrB.ActivitiesObjectType).PAGE,
                (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
                (0, $ctLrB.ActivitiesObjectType).EMBED,
                ...isWhiteboardViewedEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                ] : [],
                ...isDatabaseEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).DATABASE
                ] : [],
                ...isActivityV3MigrationEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).CONTENT
                ] : []
            ]
        },
        skip: !isLoggedIn
    });
module.exports["getRecentWorkQueryOptions"] = $4b2ee2ac7b774614$export$154132902c275093;

});

parcelRegister("8EU84", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $64dd994054bb68c8$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $64dd994054bb68c8$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $64dd994054bb68c8$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $64dd994054bb68c8$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $64dd994054bb68c8$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $64dd994054bb68c8$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $64dd994054bb68c8$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $64dd994054bb68c8$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $64dd994054bb68c8$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("ctLrB", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $cgtv4 = parcelRequire("cgtv4");

var $61e4e33a86012bad$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState[LoadingState["done"] = 0] = "done";
    LoadingState[LoadingState["initial"] = 1] = "initial";
    LoadingState[LoadingState["pagination"] = 2] = "pagination";
    return LoadingState;
}({});
var $61e4e33a86012bad$export$f5dd0176116f8854 = /*#__PURE__*/ function(HomeViewFilters) {
    HomeViewFilters["ALL"] = "ALL";
    HomeViewFilters["WORKED_ON"] = "WORKED_ON";
    HomeViewFilters["CREATED"] = "CREATED";
    HomeViewFilters["STARRED"] = "STARRED";
    HomeViewFilters["TASKS"] = "TASKS";
    HomeViewFilters["DRAFTS"] = "DRAFTS";
    return HomeViewFilters;
}({});
var $61e4e33a86012bad$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $61e4e33a86012bad$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["CONTENT"] = "CONTENT";
    ActivitiesObjectType["COMMENT"] = "COMMENT";
    return ActivitiesObjectType;
}({});
const $61e4e33a86012bad$var$i18n = (0, $cgtv4.defineMessages)({
    untitled: {
        id: "home.views.untitled",
        defaultMessage: "Untitled"
    }
});
const $61e4e33a86012bad$export$232e7dd3cd551a33 = $61e4e33a86012bad$var$i18n.untitled;
const $61e4e33a86012bad$export$2786ecc2e2951fe3 = (networkStatus)=>{
    if (networkStatus === (0, $9wEpK.NetworkStatus).loading || networkStatus === (0, $9wEpK.NetworkStatus).setVariables) return 1;
    if (networkStatus === (0, $9wEpK.NetworkStatus).fetchMore) return 2;
    return 0;
};
function $61e4e33a86012bad$export$b29ea735dcfba3c1(value) {
    return value !== null && value !== undefined;
}
const $61e4e33a86012bad$export$4b0a6c95b9c45006 = (textFilter, title)=>{
    const trimmedTextFilter = textFilter.trim();
    if (trimmedTextFilter === '') return true;
    return (title || '').toUpperCase().indexOf(textFilter.toUpperCase()) > -1;
};
const $61e4e33a86012bad$export$c29c1699278467fe = (recent, isActivityV3HomeRecent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (isActivityV3HomeRecent && content) {
        content.type = content.type?.toLowerCase();
        if (content.type === 'blog_post') content.type = 'blogpost';
        content.subtype = content.subtype?.toLowerCase();
        // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
        // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
        // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
        content.status = [
            content.status,
            content.pageStatus,
            content.blogStatus
        ].find((status)=>status)?.toLowerCase();
        // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
        if (content.status === 'draft' && content.createdAt) content.status = 'current';
        recent.event.eventType = recent.event?.eventType.toUpperCase();
    }
    return recent;
};
const $61e4e33a86012bad$export$7105b33a95adadcf = (content)=>{
    return content?.status !== 'archived';
};
const $61e4e33a86012bad$export$d54a312242c6a930 = (content)=>{
    return content?.status !== 'trashed';
};
const $61e4e33a86012bad$export$78ba6bbd8fcbc43f = (userId, content)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    return userId === createdBy?.accountId;
};
module.exports["LoadingState"] = $61e4e33a86012bad$export$62aa48085237e36f;
module.exports["HomeViewFilters"] = $61e4e33a86012bad$export$f5dd0176116f8854;
module.exports["ActivityEventType"] = $61e4e33a86012bad$export$132f858337fea016;
module.exports["ActivitiesObjectType"] = $61e4e33a86012bad$export$4edf00fad4b97379;
module.exports["untitled"] = $61e4e33a86012bad$export$232e7dd3cd551a33;
module.exports["getLoadingState"] = $61e4e33a86012bad$export$2786ecc2e2951fe3;
module.exports["notEmpty"] = $61e4e33a86012bad$export$b29ea735dcfba3c1;
module.exports["byTitle"] = $61e4e33a86012bad$export$4b0a6c95b9c45006;
module.exports["transformActivityData"] = $61e4e33a86012bad$export$c29c1699278467fe;
module.exports["notArchived"] = $61e4e33a86012bad$export$7105b33a95adadcf;
module.exports["notDeleted"] = $61e4e33a86012bad$export$d54a312242c6a930;
module.exports["isCreatorCurrentUser"] = $61e4e33a86012bad$export$78ba6bbd8fcbc43f;

});

parcelRegister("MTTRf", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $fed37ec4c6d5a8b4$export$93fc89076fcc0c52 = (0, $eSUdr.default)`query HomeRecentWorkQuery($cloudId:ID!$first:Int$after:String$objectTypes:[ActivitiesObjectType!]){activities{myActivities{all(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$first after:$after){edges{cursor node{id timestamp object{id events{eventType}content{id title subType type links{webui editui}metadata{sourceTemplateEntityId}space{alias id key name}status blank emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}}}}}}}}}`;
const $fed37ec4c6d5a8b4$export$cc29847299262653 = (0, $eSUdr.default)`query useHomeRecentWorkDataV3Query($cloudId:ID!$first:Int$after:String$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}...on ConfluenceWhiteboard{id title type status links{webUi}space{alias id key name}}...on ConfluenceDatabase{id title type status links{webUi}space{alias id key name}}...on ConfluenceEmbed{id title type status links{webUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}}}event{timestamp eventType}}}}}}}`;
module.exports["HomeRecentWorkQuery"] = $fed37ec4c6d5a8b4$export$93fc89076fcc0c52;
module.exports["HomeRecentWorkV3Query"] = $fed37ec4c6d5a8b4$export$cc29847299262653;

});

parcelRegister("y9T5W", function(module, exports) {
const $c2f13451050bd3c6$export$a1180afea81894e6 = 6;
module.exports["ALL_RECENT_ITEMS_COUNT_HOME_REFRESH"] = $c2f13451050bd3c6$export$a1180afea81894e6;

});

parcelRegister("k2RxH", function(module, exports) {

var $8EU84 = parcelRequire("8EU84");


var $1dnxO = parcelRequire("1dnxO");


var $li6DS = parcelRequire("li6DS");


var $ctLrB = parcelRequire("ctLrB");


var $dTFEh = parcelRequire("dTFEh");


var $fD3hS = parcelRequire("fD3hS");

// This list matches the event types Activity Platform uses for
// activities.myActivities.workedOn with CREATED and UPDATED
// removed as those events are only used in Jira
// https://bitbucket.org/atlassian/worklens/src/bff1a264119c0121e1e7ec7787442cdf0e177f40/src/main/java/com/atlassian/worklens/settings/EventsSettings.java#lines-38
const $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES = [
    (0, $ctLrB.ActivityEventType).COMMENTED,
    (0, $ctLrB.ActivityEventType).EDITED,
    (0, $ctLrB.ActivityEventType).PUBLISHED,
    (0, $ctLrB.ActivityEventType).UPDATED
];
const $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3 = [
    (0, $ctLrB.ActivityEventType).EDITED,
    (0, $ctLrB.ActivityEventType).PUBLISHED,
    (0, $ctLrB.ActivityEventType).UPDATED,
    (0, $ctLrB.ActivityEventType).CREATED,
    (0, $ctLrB.ActivityEventType).STARTED,
    (0, $ctLrB.ActivityEventType).SNAPSHOTTED
];
const $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES = [
    (0, $ctLrB.ActivityEventType).COMMENTED,
    ...$355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3
];
const $355018d1e9284f84$var$OBJECT_TYPES = [
    (0, $ctLrB.ActivitiesObjectType).PAGE,
    (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
    (0, $ctLrB.ActivitiesObjectType).EMBED
];
const $355018d1e9284f84$var$PAGE_SIZE = 24;
const $355018d1e9284f84$export$c0883c47d72a59fc = ({ pill: pill, cloudId: cloudId, endCursor: endCursor, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled })=>{
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const createdDateFilter = isNav4Enabled ? 'and created >= startOfDay("-90d") ' : '';
    const isActivityV3RecentsEnabled = (0, $li6DS.getIsActivityV3RecentsEnabled)();
    const activityQuery = isActivityV3RecentsEnabled ? (0, $fD3hS.HomeRecentActivityQuery) : (0, $dTFEh.HomeRecentActivitiesQuery);
    const activityCloudId = isActivityV3RecentsEnabled ? (0, $8EU84.PlatformSiteAri).create({
        siteId: cloudId
    }).toString() : cloudId;
    switch(pill){
        case 'created':
            return {
                query: (0, $dTFEh.HomeRecentCreatedQuery),
                variables: {
                    cql: `type in (page, blogpost, embed${isWhiteboardUpdatedEnabled ? ', whiteboard' : ''}${isDatabaseEnabled ? ', database' : ''}) and owner=currentUser() ${createdDateFilter}order by created desc`,
                    cqlcontext: `{"contentStatuses":["draft", "current"]}`,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor
                }
            };
        case 'worked-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: isActivityV3RecentsEnabled ? $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3 : $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        ...isActivityV3RecentsEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).CONTENT
                        ] : []
                    ]
                }
            };
        case 'collaborated-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: (0, $8EU84.PlatformSiteAri).create({
                        siteId: cloudId
                    }).toString(),
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        (0, $ctLrB.ActivitiesObjectType).COMMENT
                    ]
                }
            };
        case 'all':
        default:
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: [],
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardViewedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        ...isActivityV3RecentsEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).CONTENT
                        ] : []
                    ]
                }
            };
    }
};
module.exports["getRecentQueryOptions"] = $355018d1e9284f84$export$c0883c47d72a59fc;

});

parcelRegister("dTFEh", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $27b84da9e4be640f$export$4cd16757ca3b8d2 = (0, $eSUdr.default)`query HomeRecentUserPreferencesQuery{userPreferences{recentFilter}}`;
const $27b84da9e4be640f$export$5b0a6ecec307c73a = (0, $eSUdr.default)`mutation HomeRecentUserPreferencesMutation($filter:RecentFilter){updateUserPreferences(userPreferences:{recentFilter:$filter}){recentFilter}}`;
const $27b84da9e4be640f$export$e31d4e9aea7e8eeb = (0, $eSUdr.default)`query HomeRecentActivitiesQuery($cloudId:ID!$first:Int$after:String$eventTypes:[ActivityEventType!]$objectTypes:[ActivitiesObjectType!]){activities{myActivities{all(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]eventTypes:$eventTypes}}]first:$first after:$after){edges{cursor node{id timestamp object{id events{eventType}content{id title type subType links{webui editui}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}space{alias id key name}likes{count}status blank editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id value key}}}}}}pageInfo{hasNextPage}}}}}`;
const $27b84da9e4be640f$export$1b405121a715cf1a = (0, $eSUdr.default)`query HomeRecentCreatedQuery($cql:String!$cqlcontext:String!$first:Int$after:String){search:confluence_search(cql:$cql cqlcontext:$cqlcontext first:$first after:$after){nodes{content{id title type subType links{webui editui}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}space{alias id key name}likes{count}status blank metadata{createdDate}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published"]){nodes{id value key}}history{createdBy{...on KnownUser{accountId}}}version{by{...on KnownUser{accountId}}}}}pageInfo{hasNextPage endCursor}}}`;
module.exports["HomeRecentUserPreferencesQuery"] = $27b84da9e4be640f$export$4cd16757ca3b8d2;
module.exports["HomeRecentActivitiesQuery"] = $27b84da9e4be640f$export$e31d4e9aea7e8eeb;
module.exports["HomeRecentCreatedQuery"] = $27b84da9e4be640f$export$1b405121a715cf1a;

});

parcelRegister("fD3hS", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f2dd689bb1ecd7e4$export$2b6ee81eb817f811 = (0, $eSUdr.default)`query HomeRecentActivityQuery($cloudId:ID!$first:Int$after:String$eventTypes:[String!]$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes eventTypes:$eventTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}...on ConfluenceDatabase{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}...on ConfluenceEmbed{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceInlineComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}}}...on ConfluenceFooterComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}}}}}event{timestamp eventType}}}pageInfo{hasNextPage endCursor}}}}}`;
module.exports["HomeRecentActivityQuery"] = $f2dd689bb1ecd7e4$export$2b6ee81eb817f811;

});

parcelRegister("h6oqk", function(module, exports) {

var $1Z8HH = parcelRequire("1Z8HH");

const $989c3fbcf8cb03b6$var$PAGE_SIZE = 24;
const $989c3fbcf8cb03b6$export$b5d0611211eebe41 = (_)=>({
        query: (0, $1Z8HH.HomeStarredPagesQuery),
        variables: {
            limit: $989c3fbcf8cb03b6$var$PAGE_SIZE,
            start: 0
        }
    });
module.exports["getStarredQueryOptions"] = $989c3fbcf8cb03b6$export$b5d0611211eebe41;

});

parcelRegister("1Z8HH", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $0f962776926af63c$export$a0b606bd5fa7d090 = (0, $eSUdr.default)`query HomeStarredPagesQuery($limit:Int$start:Int)@allowHigherTimeout{favoriteContent(limit:$limit start:$start){nodes{id subType type title excerpt links{editui webui}history{lastUpdated{when}}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published"]){nodes{id key value}}metadata{currentuser{favourited{isFavourite}viewed{lastSeen}}likes{count}comments{commentsCount}}space{alias id key name}}pageInfo{hasNextPage endCursor}}}`;
module.exports["HomeStarredPagesQuery"] = $0f962776926af63c$export$a0b606bd5fa7d090;

});

parcelRegister("kgC8N", function(module, exports) {

var $i4C0a = parcelRequire("i4C0a");

const $8494f2a7cbb1632a$var$PAGE_SIZE = 24;
const $8494f2a7cbb1632a$export$c37c2a94b8c9c502 = (_)=>({
        query: (0, $i4C0a.HomeDraftsQuery),
        variables: {
            cqlcontext: `{"contentStatuses":["draft"]}`,
            first: $8494f2a7cbb1632a$var$PAGE_SIZE
        }
    });
module.exports["getDraftsQueryOptions"] = $8494f2a7cbb1632a$export$c37c2a94b8c9c502;

});

parcelRegister("i4C0a", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $75d16630eeb20da5$export$c6036e96d07e5663 = (0, $eSUdr.default)`query HomeDraftsQuery($cqlcontext:String$first:Int$after:String){search:confluence_search(cql:"type in (page,blogpost) order by lastModified desc" cqlcontext:$cqlcontext first:$first after:$after){nodes{content{id title type subType links{webui editui}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}space{alias id key name}likes{count}status blank metadata{lastModifiedDate}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-draft"]){nodes{id key value}}}}pageInfo{hasNextPage endCursor}}}`;
module.exports["HomeDraftsQuery"] = $75d16630eeb20da5$export$c6036e96d07e5663;

});

parcelRegister("01STT", function(module, exports) {
var $8357fd24c5d501e8$export$27a5bd065ad55220 = /*#__PURE__*/ function(View) {
    View["OVERVIEW"] = "overview";
    View["RECENT"] = "recent";
    View["STARRED"] = "starred";
    View["WATCHING"] = "watching";
    View["DRAFTS"] = "drafts";
    View["TASKS"] = "tasks";
    return View;
}({});
const $8357fd24c5d501e8$export$f183fe8f38c8cf4f = [
    "recent",
    "starred",
    "watching",
    "drafts",
    "tasks"
];
module.exports["View"] = $8357fd24c5d501e8$export$27a5bd065ad55220;
module.exports["SUPPORTED_ROUTES"] = $8357fd24c5d501e8$export$f183fe8f38c8cf4f;

});

parcelRegister("iwZYw", function(module, exports) {
/**
 * @generated SignedSource<<610171f2ecff92626e7eaca44640b36c>>
 * @relayHash 7354786c74bc87b4af0be7aa1c508959
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc
const $3ac726b99ebc60d4$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceAdminAnnouncementBanner",
            "kind": "LinkedField",
            "name": "adminAnnouncementBanner",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                },
                {
                    "kind": "ScalarField",
                    "name": "content"
                },
                {
                    "kind": "ScalarField",
                    "name": "appearance"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7354786c74bc87b4af0be7aa1c508959",
            "id": "cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc",
            "metadata": {},
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "operationKind": "query",
            "text": "query useRegisterAdminAnnouncementBannerQuery{adminAnnouncementBanner{id,isDismissible,content,appearance,title,updatedAt}}"
        }
    };
}();
$3ac726b99ebc60d4$var$node.hash = "240e64f11995d52e66311a69dc8032ab";
var $3ac726b99ebc60d4$export$2e2bcd8739ae039 = $3ac726b99ebc60d4$var$node;
module.exports["default"] = $3ac726b99ebc60d4$export$2e2bcd8739ae039;

});

parcelRegister("cpPWT", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $375253a0664acfd5$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $375253a0664acfd5$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $375253a0664acfd5$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $375253a0664acfd5$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $42omo.createContext)($375253a0664acfd5$export$a28a0c048b24fc5a());
const $375253a0664acfd5$export$c7535f8ebc5b75a9 = $375253a0664acfd5$export$ea58328f3ceee4d4.Provider;
const $375253a0664acfd5$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($375253a0664acfd5$export$c7535f8ebc5b75a9, {
            value: $375253a0664acfd5$export$a28a0c048b24fc5a()
        }, children);
const $375253a0664acfd5$export$89f8e1f623d8f5ac = ()=>(0, $42omo.useContext)($375253a0664acfd5$export$ea58328f3ceee4d4);
module.exports["createMessagePlacementValues"] = $375253a0664acfd5$export$a28a0c048b24fc5a;
module.exports["MessagePlacementProvider"] = $375253a0664acfd5$export$c7535f8ebc5b75a9;
module.exports["useMessagePlacementHooks"] = $375253a0664acfd5$export$89f8e1f623d8f5ac;

});

parcelRegister("j0Fou", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $PAiZW = parcelRequire("PAiZW");


var $kO3gu = parcelRequire("kO3gu");


var $8Bzrf = parcelRequire("8Bzrf");


var $eHv8q = parcelRequire("eHv8q");


var $9OLUt = parcelRequire("9OLUt");


var $42omo = parcelRequire("42omo");

const $68a42afbf7553230$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        if ((0, $c6GJD.default).checkGate('post-office-use-placement-with-client')) return (0, $9OLUt.createUsePlacementWithClient)(placementId, fetcher);
        return (0, $eHv8q.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    const apiDependencies = (0, $42omo.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};
module.exports["usePlacementApi"] = $68a42afbf7553230$export$201bbce8187a6e3c;

});

parcelRegister("eHv8q", function(module, exports) {

var $2OGMq = parcelRequire("2OGMq");


var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $872a969cc90d2799$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $42omo.useRef)();
        const isRunningPromise = (0, $42omo.useRef)(false);
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $42omo.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $gAOec.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $2OGMq.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $gAOec.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};
module.exports["createUsePlacement"] = $872a969cc90d2799$export$ee1d67e435d25cb5;

});

parcelRegister("2OGMq", function(module, exports) {
const $c9d2f99792ae105c$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $c9d2f99792ae105c$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $c9d2f99792ae105c$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$c9d2f99792ae105c$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $c9d2f99792ae105c$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($c9d2f99792ae105c$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$c9d2f99792ae105c$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};
module.exports["fetchPlacementData"] = $c9d2f99792ae105c$export$ce743d02f83ee521;

});

parcelRegister("9OLUt", function(module, exports) {

var $hy3a0 = parcelRequire("hy3a0");


var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");

const $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $hy3a0.useFetchPlacementData)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};
module.exports["createUsePlacementWithClient"] = $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1;

});

parcelRegister("hy3a0", function(module, exports) {

var $fCcUZ = parcelRequire("fCcUZ");

const $785c8761b65409e5$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $785c8761b65409e5$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $785c8761b65409e5$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$785c8761b65409e5$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $785c8761b65409e5$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $785c8761b65409e5$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($785c8761b65409e5$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$785c8761b65409e5$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $fCcUZ.default)(placementId ? url : null, (url)=>fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$785c8761b65409e5$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};
module.exports["useFetchPlacementData"] = $785c8761b65409e5$export$ef70136078f15deb;

});

parcelRegister("fCcUZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $96T14 = parcelRequire("96T14");
parcelRequire("ltrno");
var $ltrno = parcelRequire("ltrno");

var $hKRm8 = parcelRequire("hKRm8");

// Shared state between server components and client components
const $b5e46ce872016a0c$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $b5e46ce872016a0c$var$UNDEFINED = /*#__NOINLINE__*/ $b5e46ce872016a0c$var$noop();
const $b5e46ce872016a0c$var$OBJECT = Object;
const $b5e46ce872016a0c$var$isUndefined = (v)=>v === $b5e46ce872016a0c$var$UNDEFINED;
const $b5e46ce872016a0c$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $b5e46ce872016a0c$var$table = new WeakMap();
const $b5e46ce872016a0c$var$getTypeName = (value)=>$b5e46ce872016a0c$var$OBJECT.prototype.toString.call(value);
const $b5e46ce872016a0c$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $b5e46ce872016a0c$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $b5e46ce872016a0c$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $b5e46ce872016a0c$var$getTypeName(arg);
    const isDate = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($b5e46ce872016a0c$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $b5e46ce872016a0c$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$b5e46ce872016a0c$var$counter + '~';
        $b5e46ce872016a0c$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $b5e46ce872016a0c$var$stableHash(arg[index]) + ',';
            $b5e46ce872016a0c$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $b5e46ce872016a0c$var$OBJECT.keys(arg).sort();
            while(!$b5e46ce872016a0c$var$isUndefined(index = keys.pop()))if (!$b5e46ce872016a0c$var$isUndefined(arg[index])) result += index + ':' + $b5e46ce872016a0c$var$stableHash(arg[index]) + ',';
            $b5e46ce872016a0c$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $b5e46ce872016a0c$var$serialize = (key)=>{
    if ($b5e46ce872016a0c$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $b5e46ce872016a0c$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $b5e46ce872016a0c$export$dbab534a48e651ef = (key)=>$b5e46ce872016a0c$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $b5e46ce872016a0c$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $b5e46ce872016a0c$var$WITH_DEDUPE = {
    dedupe: true
};
const $b5e46ce872016a0c$var$resolvedUndef = Promise.resolve((0, $96T14.U));
const $b5e46ce872016a0c$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $96T14.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $96T14.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $42omo.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $42omo.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $42omo.useRef)(key);
    const fetcherRef = (0, $42omo.useRef)(fetcher);
    const configRef = (0, $42omo.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $96T14.z)(cache, key);
    const stateDependencies = (0, $42omo.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $96T14.e)(fallbackData) ? (0, $96T14.e)(config.fallback) ? (0, $96T14.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $96T14.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $42omo.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $96T14.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $96T14.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $hxT4C.useSyncExternalStore)((0, $42omo.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $96T14.e)(cachedData) ? fallback && (0, $96T14.B)(fallback) ? $b5e46ce872016a0c$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $42omo.useRef)(data);
    const returnedData = keepPreviousData ? (0, $96T14.e)(cachedData) ? (0, $96T14.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $96T14.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $96T14.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $96T14.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $96T14.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $96T14.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $96T14.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $42omo.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $96T14.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $96T14.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $96T14.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $96T14.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $96T14.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $96T14.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $96T14.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $hKRm8).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $42omo.useCallback)((...args)=>{
        return (0, $96T14.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $96T14.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $96T14.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $96T14.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $96T14.U), $b5e46ce872016a0c$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $hKRm8).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $hKRm8).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $hKRm8).MUTATE_EVENT) return revalidate();
            else if (type == (0, $hKRm8).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $ltrno.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $96T14.e)(data) || (0, $96T14.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $96T14.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $96T14.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $96T14.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($b5e46ce872016a0c$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $42omo.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        const hasKeyButNoData = key && (0, $96T14.e)(data);
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $96T14.I) && (0, $96T14.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $96T14.e)(req) && hasKeyButNoData ? boundMutate(req) : $b5e46ce872016a0c$var$resolvedUndef;
        $b5e46ce872016a0c$var$use(mutateReq);
        if (!(0, $96T14.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($b5e46ce872016a0c$var$WITH_DEDUPE) : $b5e46ce872016a0c$var$resolvedUndef;
        if (!(0, $96T14.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $b5e46ce872016a0c$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $b5e46ce872016a0c$export$4c7bbecdacc3ca2c = (0, $96T14.O).defineProperty((0, $96T14.g), 'defaultValue', {
    value: (0, $96T14.d)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $b5e46ce872016a0c$export$2e2bcd8739ae039 = (0, $ltrno.withArgs)($b5e46ce872016a0c$var$useSWRHandler);
module.exports["SWRConfig"] = $b5e46ce872016a0c$export$4c7bbecdacc3ca2c;
module.exports["default"] = $b5e46ce872016a0c$export$2e2bcd8739ae039;

});

parcelRegister("96T14", function(module, exports) {
$parcel$export(module.exports, "c", () => $6a1f59ad6a5062ba$export$db3b6bfb95261072);

var $42omo = parcelRequire("42omo");


var $hKRm8 = parcelRequire("hKRm8");


var $hrSFW = parcelRequire("hrSFW");

'use client';
// Global state used to deduplicate requests and store listeners
const $6a1f59ad6a5062ba$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $6a1f59ad6a5062ba$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $6a1f59ad6a5062ba$export$ebd11618f299a286();
const $6a1f59ad6a5062ba$export$c4ce752e73470fba = Object;
const $6a1f59ad6a5062ba$export$f1e1789686576879 = (v)=>v === $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08;
const $6a1f59ad6a5062ba$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $6a1f59ad6a5062ba$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $6a1f59ad6a5062ba$export$ef35774e6d314e91 = (x)=>$6a1f59ad6a5062ba$export$407448d2b89b1813(x.then);
const $6a1f59ad6a5062ba$var$EMPTY_CACHE = {};
const $6a1f59ad6a5062ba$var$INITIAL_CACHE = {};
const $6a1f59ad6a5062ba$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $6a1f59ad6a5062ba$export$23f2a1d2818174ef = typeof window != $6a1f59ad6a5062ba$var$STR_UNDEFINED;
const $6a1f59ad6a5062ba$export$efccba1c4a2ef57b = typeof document != $6a1f59ad6a5062ba$var$STR_UNDEFINED;
const $6a1f59ad6a5062ba$export$d141bba7fdc215a3 = $6a1f59ad6a5062ba$export$23f2a1d2818174ef && 'Deno' in window;
const $6a1f59ad6a5062ba$export$4a5767248b18ef41 = ()=>$6a1f59ad6a5062ba$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $6a1f59ad6a5062ba$var$STR_UNDEFINED;
const $6a1f59ad6a5062ba$export$df995fae86a55f06 = (cache, key)=>{
    const state = $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$6a1f59ad6a5062ba$export$f1e1789686576879(key) && cache.get(key) || $6a1f59ad6a5062ba$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$6a1f59ad6a5062ba$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $6a1f59ad6a5062ba$var$INITIAL_CACHE)) $6a1f59ad6a5062ba$var$INITIAL_CACHE[key] = prev;
                state[5](key, $6a1f59ad6a5062ba$export$953cecd6e717a553(prev, info), prev || $6a1f59ad6a5062ba$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$6a1f59ad6a5062ba$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $6a1f59ad6a5062ba$var$INITIAL_CACHE) return $6a1f59ad6a5062ba$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$6a1f59ad6a5062ba$export$f1e1789686576879(key) && cache.get(key) || $6a1f59ad6a5062ba$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $6a1f59ad6a5062ba$var$online = true;
const $6a1f59ad6a5062ba$var$isOnline = ()=>$6a1f59ad6a5062ba$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$6a1f59ad6a5062ba$var$onWindowEvent, $6a1f59ad6a5062ba$var$offWindowEvent] = $6a1f59ad6a5062ba$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $6a1f59ad6a5062ba$export$ebd11618f299a286,
    $6a1f59ad6a5062ba$export$ebd11618f299a286
];
const $6a1f59ad6a5062ba$var$isVisible = ()=>{
    const visibilityState = $6a1f59ad6a5062ba$export$efccba1c4a2ef57b && document.visibilityState;
    return $6a1f59ad6a5062ba$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $6a1f59ad6a5062ba$var$initFocus = (callback)=>{
    // focus revalidate
    if ($6a1f59ad6a5062ba$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $6a1f59ad6a5062ba$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($6a1f59ad6a5062ba$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $6a1f59ad6a5062ba$var$offWindowEvent('focus', callback);
    };
};
const $6a1f59ad6a5062ba$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $6a1f59ad6a5062ba$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $6a1f59ad6a5062ba$var$online = false;
    };
    $6a1f59ad6a5062ba$var$onWindowEvent('online', onOnline);
    $6a1f59ad6a5062ba$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $6a1f59ad6a5062ba$var$offWindowEvent('online', onOnline);
        $6a1f59ad6a5062ba$var$offWindowEvent('offline', onOffline);
    };
};
const $6a1f59ad6a5062ba$export$ffb5f4729a158638 = {
    isOnline: $6a1f59ad6a5062ba$var$isOnline,
    isVisible: $6a1f59ad6a5062ba$var$isVisible
};
const $6a1f59ad6a5062ba$export$9e5f44173e64f162 = {
    initFocus: $6a1f59ad6a5062ba$var$initFocus,
    initReconnect: $6a1f59ad6a5062ba$var$initReconnect
};
const $6a1f59ad6a5062ba$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useId;
const $6a1f59ad6a5062ba$export$43caf9889c228507 = !$6a1f59ad6a5062ba$export$23f2a1d2818174ef || $6a1f59ad6a5062ba$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $6a1f59ad6a5062ba$export$625550452a3fa3ec = (f)=>$6a1f59ad6a5062ba$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $6a1f59ad6a5062ba$export$3b14a55fb2447963 = $6a1f59ad6a5062ba$export$43caf9889c228507 ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $6a1f59ad6a5062ba$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $6a1f59ad6a5062ba$export$90a7f3efeed30595 = !$6a1f59ad6a5062ba$export$43caf9889c228507 && $6a1f59ad6a5062ba$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($6a1f59ad6a5062ba$var$navigatorConnection.effectiveType) || $6a1f59ad6a5062ba$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $6a1f59ad6a5062ba$var$table = new WeakMap();
const $6a1f59ad6a5062ba$var$getTypeName = (value)=>$6a1f59ad6a5062ba$export$c4ce752e73470fba.prototype.toString.call(value);
const $6a1f59ad6a5062ba$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $6a1f59ad6a5062ba$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $6a1f59ad6a5062ba$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $6a1f59ad6a5062ba$var$getTypeName(arg);
    const isDate = $6a1f59ad6a5062ba$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $6a1f59ad6a5062ba$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $6a1f59ad6a5062ba$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($6a1f59ad6a5062ba$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $6a1f59ad6a5062ba$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$6a1f59ad6a5062ba$var$counter + '~';
        $6a1f59ad6a5062ba$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $6a1f59ad6a5062ba$export$882b5998b3b9117c(arg[index]) + ',';
            $6a1f59ad6a5062ba$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $6a1f59ad6a5062ba$export$c4ce752e73470fba.keys(arg).sort();
            while(!$6a1f59ad6a5062ba$export$f1e1789686576879(index = keys.pop()))if (!$6a1f59ad6a5062ba$export$f1e1789686576879(arg[index])) result += index + ':' + $6a1f59ad6a5062ba$export$882b5998b3b9117c(arg[index]) + ',';
            $6a1f59ad6a5062ba$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $6a1f59ad6a5062ba$export$2408f22a0fab9ae5 = (key)=>{
    if ($6a1f59ad6a5062ba$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $6a1f59ad6a5062ba$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $6a1f59ad6a5062ba$var$__timestamp = 0;
const $6a1f59ad6a5062ba$export$ae1af26003f05816 = ()=>++$6a1f59ad6a5062ba$var$__timestamp;
async function $6a1f59ad6a5062ba$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $6a1f59ad6a5062ba$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($6a1f59ad6a5062ba$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $6a1f59ad6a5062ba$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $6a1f59ad6a5062ba$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $6a1f59ad6a5062ba$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($hKRm8.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $6a1f59ad6a5062ba$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$6a1f59ad6a5062ba$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $6a1f59ad6a5062ba$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $6a1f59ad6a5062ba$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($6a1f59ad6a5062ba$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $6a1f59ad6a5062ba$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($6a1f59ad6a5062ba$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08,
                        _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08,
                    _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $6a1f59ad6a5062ba$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $6a1f59ad6a5062ba$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $6a1f59ad6a5062ba$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$6a1f59ad6a5062ba$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $6a1f59ad6a5062ba$export$953cecd6e717a553($6a1f59ad6a5062ba$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $6a1f59ad6a5062ba$export$7ccc53e8f1e7dfc5.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, provider);
        let unmount = $6a1f59ad6a5062ba$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$6a1f59ad6a5062ba$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$6a1f59ad6a5062ba$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, $6a1f59ad6a5062ba$var$revalidateAllKeys.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $hKRm8.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, $6a1f59ad6a5062ba$var$revalidateAllKeys.bind($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $hKRm8.RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $6a1f59ad6a5062ba$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $6a1f59ad6a5062ba$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$6a1f59ad6a5062ba$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $6a1f59ad6a5062ba$export$342063e11d6c3cad = (0, $hrSFW.dequal);
// Default cache provider
const [$6a1f59ad6a5062ba$export$db3b6bfb95261072, $6a1f59ad6a5062ba$export$35e795649ee09318] = $6a1f59ad6a5062ba$export$dda1d9f60106f0e9(new Map());
// Default config
const $6a1f59ad6a5062ba$export$4368d992c4eafac0 = $6a1f59ad6a5062ba$export$953cecd6e717a553({
    // events
    onLoadingSlow: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    onSuccess: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    onError: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    onErrorRetry: $6a1f59ad6a5062ba$var$onErrorRetry,
    onDiscarded: $6a1f59ad6a5062ba$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $6a1f59ad6a5062ba$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $6a1f59ad6a5062ba$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $6a1f59ad6a5062ba$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $6a1f59ad6a5062ba$export$db3b6bfb95261072,
    mutate: $6a1f59ad6a5062ba$export$35e795649ee09318,
    fallback: {}
}, $6a1f59ad6a5062ba$export$ffb5f4729a158638);
const $6a1f59ad6a5062ba$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $6a1f59ad6a5062ba$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $6a1f59ad6a5062ba$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $6a1f59ad6a5062ba$export$25ce5a424b770e84 = (0, $42omo.createContext)({});
const $6a1f59ad6a5062ba$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $42omo.useContext)($6a1f59ad6a5062ba$export$25ce5a424b770e84);
    const isFunctionalConfig = $6a1f59ad6a5062ba$export$407448d2b89b1813(value);
    const config = (0, $42omo.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $42omo.useMemo)(()=>isFunctionalConfig ? config : $6a1f59ad6a5062ba$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $42omo.useRef)($6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $6a1f59ad6a5062ba$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $6a1f59ad6a5062ba$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $6a1f59ad6a5062ba$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $42omo.createElement)($6a1f59ad6a5062ba$export$25ce5a424b770e84.Provider, $6a1f59ad6a5062ba$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};
module.exports["b"] = $6a1f59ad6a5062ba$export$8b22cf2602fb60ce;
module.exports["U"] = $6a1f59ad6a5062ba$export$3a6d5c9ae78a2c08;
module.exports["O"] = $6a1f59ad6a5062ba$export$c4ce752e73470fba;
module.exports["e"] = $6a1f59ad6a5062ba$export$f1e1789686576879;
module.exports["a"] = $6a1f59ad6a5062ba$export$407448d2b89b1813;
module.exports["m"] = $6a1f59ad6a5062ba$export$953cecd6e717a553;
module.exports["B"] = $6a1f59ad6a5062ba$export$ef35774e6d314e91;
module.exports["i"] = $6a1f59ad6a5062ba$export$23f2a1d2818174ef;
module.exports["z"] = $6a1f59ad6a5062ba$export$df995fae86a55f06;
module.exports["I"] = $6a1f59ad6a5062ba$export$9bb611d729802a56;
module.exports["r"] = $6a1f59ad6a5062ba$export$43caf9889c228507;
module.exports["t"] = $6a1f59ad6a5062ba$export$625550452a3fa3ec;
module.exports["u"] = $6a1f59ad6a5062ba$export$3b14a55fb2447963;
module.exports["s"] = $6a1f59ad6a5062ba$export$2408f22a0fab9ae5;
module.exports["o"] = $6a1f59ad6a5062ba$export$ae1af26003f05816;
module.exports["n"] = $6a1f59ad6a5062ba$export$7ccc53e8f1e7dfc5;
module.exports["d"] = $6a1f59ad6a5062ba$export$4368d992c4eafac0;
module.exports["f"] = $6a1f59ad6a5062ba$export$2d1720544b23b823;
module.exports["S"] = $6a1f59ad6a5062ba$export$25ce5a424b770e84;
module.exports["g"] = $6a1f59ad6a5062ba$export$39b482c5e57630a8;

});

parcelRegister("hKRm8", function(module, exports) {
const $0355effb9da30fde$export$831c820ad60f9d12 = 0;
const $0355effb9da30fde$export$24e9454cb99a11dc = 1;
const $0355effb9da30fde$export$75ea288459391154 = 2;
const $0355effb9da30fde$export$b019c3839228f243 = 3;
module.exports["FOCUS_EVENT"] = $0355effb9da30fde$export$831c820ad60f9d12;
module.exports["RECONNECT_EVENT"] = $0355effb9da30fde$export$24e9454cb99a11dc;
module.exports["MUTATE_EVENT"] = $0355effb9da30fde$export$75ea288459391154;
module.exports["ERROR_REVALIDATE_EVENT"] = $0355effb9da30fde$export$b019c3839228f243;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("ltrno", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $fa218ac480f8609c$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $fa218ac480f8609c$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $fa218ac480f8609c$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("96T14")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("96T14")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("96T14")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("96T14")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("96T14")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("96T14")).s);

var $96T14 = parcelRequire("96T14");


var $hKRm8 = parcelRequire("hKRm8");


var $aQZOK = parcelRequire("aQZOK");


var $42omo = parcelRequire("42omo");


// @ts-expect-error
const $fa218ac480f8609c$var$enableDevtools = (0, $96T14.i) && window.__SWR_DEVTOOLS_USE__;
const $fa218ac480f8609c$var$use = $fa218ac480f8609c$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $fa218ac480f8609c$var$setupDevTools = ()=>{
    if ($fa218ac480f8609c$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
};
const $fa218ac480f8609c$export$a3295358bff77e = (args)=>{
    return (0, $96T14.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $fa218ac480f8609c$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $42omo.useContext)((0, $96T14.S));
    const mergedConfig = (0, $42omo.useMemo)(()=>(0, $96T14.m)((0, $96T14.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $fa218ac480f8609c$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $96T14.s)(key_);
    const [, , , PRELOAD] = (0, $96T14.b).get((0, $96T14.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $fa218ac480f8609c$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $96T14.s)(key_);
            const [, , , PRELOAD] = (0, $96T14.b).get((0, $96T14.c));
            if (key.startsWith((0, $aQZOK.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $96T14.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $fa218ac480f8609c$var$BUILT_IN_MIDDLEWARE = $fa218ac480f8609c$var$use.concat($fa218ac480f8609c$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $fa218ac480f8609c$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $fa218ac480f8609c$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $fa218ac480f8609c$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $96T14.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($fa218ac480f8609c$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $fa218ac480f8609c$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $fa218ac480f8609c$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $fa218ac480f8609c$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$fa218ac480f8609c$var$setupDevTools();

});

parcelRegister("aQZOK", function(module, exports) {
const $7e6eb65cf45696a8$export$8667f065faedc62c = '$inf$';
module.exports["INFINITE_PREFIX"] = $7e6eb65cf45696a8$export$8667f065faedc62c;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("agV92", function(module, exports) {

let $77a7b9c6e0ce40b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $77a7b9c6e0ce40b1$var$load("kDPsc"),
    $77a7b9c6e0ce40b1$var$load("3G5wx")
]).then(()=>parcelRequire('fwAQ0'));

});

parcelRegister("4pbFR", function(module, exports) {

let $33528d7b2963fc2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $33528d7b2963fc2c$var$load("kDPsc"),
    $33528d7b2963fc2c$var$load("6CK1s")
]).then(()=>parcelRequire('a43ur'));

});

parcelRegister("5cdgS", function(module, exports) {

let $3c885e23b8078f52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3c885e23b8078f52$var$load("kDPsc"),
    $3c885e23b8078f52$var$load("926ek")
]).then(()=>parcelRequire('gNkpT'));

});

parcelRegister("dYHzb", function(module, exports) {

let $a2d2ac5b5dabdca4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2d2ac5b5dabdca4$var$load("kDPsc"),
    $a2d2ac5b5dabdca4$var$load("gaUC1")
]).then(()=>parcelRequire('k8aVR'));

});

parcelRegister("7u34o", function(module, exports) {

let $572db758f2db9995$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $572db758f2db9995$var$load("kDPsc"),
    $572db758f2db9995$var$load("ikrRd")
]).then(()=>parcelRequire('cRKQU'));

});

parcelRegister("9LxyI", function(module, exports) {

let $71c288ecfcfec3d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $71c288ecfcfec3d0$var$load("kDPsc"),
    $71c288ecfcfec3d0$var$load("1npYA")
]).then(()=>parcelRequire('35P9D'));

});

parcelRegister("19SzR", function(module, exports) {

let $0d80f7a1fa3b6d91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d80f7a1fa3b6d91$var$load("3KV1Y"),
    $0d80f7a1fa3b6d91$var$load("kDPsc"),
    $0d80f7a1fa3b6d91$var$load("c5gFe")
]).then(()=>parcelRequire('6KYBJ'));

});

parcelRegister("gTwHj", function(module, exports) {

let $c4cb2578a0ce9f14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4cb2578a0ce9f14$var$load("3KV1Y"),
    $c4cb2578a0ce9f14$var$load("kDPsc"),
    $c4cb2578a0ce9f14$var$load("j1DDh")
]).then(()=>parcelRequire('d6NMQ'));

});

parcelRegister("lH9P7", function(module, exports) {

let $fcb53bdf34fd873f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fcb53bdf34fd873f$var$load("6wr18"),
    $fcb53bdf34fd873f$var$load("8JZKd"),
    $fcb53bdf34fd873f$var$load("dxwAu"),
    $fcb53bdf34fd873f$var$load("3EXzu"),
    $fcb53bdf34fd873f$var$load("jdjSr"),
    $fcb53bdf34fd873f$var$load("3KZyj"),
    $fcb53bdf34fd873f$var$load("kDPsc"),
    $fcb53bdf34fd873f$var$load("4eilt"),
    $fcb53bdf34fd873f$var$load("ffEVr"),
    $fcb53bdf34fd873f$var$load("d23vF")
]).then(()=>parcelRequire('egpSh'));

});

parcelRegister("cvTkr", function(module, exports) {

let $91c34c66be19ff9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $91c34c66be19ff9a$var$load("6wr18"),
    $91c34c66be19ff9a$var$load("8JZKd"),
    $91c34c66be19ff9a$var$load("dxwAu"),
    $91c34c66be19ff9a$var$load("3EXzu"),
    $91c34c66be19ff9a$var$load("jdjSr"),
    $91c34c66be19ff9a$var$load("3KZyj"),
    $91c34c66be19ff9a$var$load("kDPsc"),
    $91c34c66be19ff9a$var$load("ffEVr"),
    $91c34c66be19ff9a$var$load("4eilt")
]).then(()=>parcelRequire('6tq3k'));

});

parcelRegister("8vaSI", function(module, exports) {

let $6309a8d7fb6b2226$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6309a8d7fb6b2226$var$load("3KV1Y"),
    $6309a8d7fb6b2226$var$load("kDPsc"),
    $6309a8d7fb6b2226$var$load("cQR04")
]).then(()=>parcelRequire('7EhPK'));

});

parcelRegister("h53hv", function(module, exports) {

let $c6f572e503add763$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c6f572e503add763$var$load("kDPsc"),
    $c6f572e503add763$var$load("ebZF2")
]).then(()=>parcelRequire('ihYsf'));

});

parcelRegister("fxiho", function(module, exports) {

let $b4f81e096feb5cea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4f81e096feb5cea$var$load("kDPsc"),
    $b4f81e096feb5cea$var$load("5Qmut")
]).then(()=>parcelRequire('aIf1e'));

});

parcelRegister("4uGo9", function(module, exports) {

let $345ad83bf55b3e86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $345ad83bf55b3e86$var$load("kDPsc"),
    $345ad83bf55b3e86$var$load("aGJ4a")
]).then(()=>parcelRequire('gp1NP'));

});

parcelRegister("3SqrE", function(module, exports) {

let $2d2aeda817cd552d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d2aeda817cd552d$var$load("lPDuX"),
    $2d2aeda817cd552d$var$load("8JZKd"),
    $2d2aeda817cd552d$var$load("dxwAu"),
    $2d2aeda817cd552d$var$load("3EXzu"),
    $2d2aeda817cd552d$var$load("jdjSr"),
    $2d2aeda817cd552d$var$load("3KZyj"),
    $2d2aeda817cd552d$var$load("kDPsc"),
    $2d2aeda817cd552d$var$load("kM6re")
]).then(()=>parcelRequire('bTu8V'));

});

parcelRegister("70JJt", function(module, exports) {

let $51ac01fd549299b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $51ac01fd549299b2$var$load("jdjSr"),
    $51ac01fd549299b2$var$load("3KZyj"),
    $51ac01fd549299b2$var$load("kDPsc"),
    $51ac01fd549299b2$var$load("fRrg0")
]).then(()=>parcelRequire('7aApD'));

});

parcelRegister("kW2gP", function(module, exports) {

let $f3dafc4c29873b01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3dafc4c29873b01$var$load("6wr18"),
    $f3dafc4c29873b01$var$load("8JZKd"),
    $f3dafc4c29873b01$var$load("dxwAu"),
    $f3dafc4c29873b01$var$load("3EXzu"),
    $f3dafc4c29873b01$var$load("jdjSr"),
    $f3dafc4c29873b01$var$load("3KZyj"),
    $f3dafc4c29873b01$var$load("kDPsc"),
    $f3dafc4c29873b01$var$load("ffEVr"),
    $f3dafc4c29873b01$var$load("iqdt6")
]).then(()=>parcelRequire('gu1SQ'));

});

parcelRegister("9mJEY", function(module, exports) {

let $6d199640b846043c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d199640b846043c$var$load("lPDuX"),
    $6d199640b846043c$var$load("8JZKd"),
    $6d199640b846043c$var$load("dxwAu"),
    $6d199640b846043c$var$load("3EXzu"),
    $6d199640b846043c$var$load("jdjSr"),
    $6d199640b846043c$var$load("3KZyj"),
    $6d199640b846043c$var$load("kDPsc"),
    $6d199640b846043c$var$load("34wRu")
]).then(()=>parcelRequire('hja8R'));

});

parcelRegister("5GcCI", function(module, exports) {

let $422aaac3e456e112$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $422aaac3e456e112$var$load("lPDuX"),
    $422aaac3e456e112$var$load("8JZKd"),
    $422aaac3e456e112$var$load("dxwAu"),
    $422aaac3e456e112$var$load("3EXzu"),
    $422aaac3e456e112$var$load("jdjSr"),
    $422aaac3e456e112$var$load("3KZyj"),
    $422aaac3e456e112$var$load("kDPsc"),
    $422aaac3e456e112$var$load("eL8EA")
]).then(()=>parcelRequire('2QxAP'));

});

parcelRegister("2Ekgi", function(module, exports) {

let $1edf08c18ebc364a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1edf08c18ebc364a$var$load("kDPsc"),
    $1edf08c18ebc364a$var$load("8otE8")
]).then(()=>parcelRequire('bOshH'));

});

parcelRegister("jU7vx", function(module, exports) {

let $e7d9122a5e9c50e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e7d9122a5e9c50e5$var$load("kDPsc"),
    $e7d9122a5e9c50e5$var$load("k6Mgt")
]).then(()=>parcelRequire('6GeD6'));

});

parcelRegister("7DE3Q", function(module, exports) {

let $58fb403ac9b3468f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $58fb403ac9b3468f$var$load("kDPsc"),
    $58fb403ac9b3468f$var$load("kp2ma")
]).then(()=>parcelRequire('71KbU'));

});

parcelRegister("2tUZf", function(module, exports) {

let $1cea7e9f359d4da0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1cea7e9f359d4da0$var$load("kDPsc"),
    $1cea7e9f359d4da0$var$load("16R8u")
]).then(()=>parcelRequire('6DbUp'));

});

parcelRegister("l1Npo", function(module, exports) {

let $f4f0047b21816d27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4f0047b21816d27$var$load("kDPsc"),
    $f4f0047b21816d27$var$load("4p4bD")
]).then(()=>parcelRequire('ebxMi'));

});

parcelRegister("9oIeY", function(module, exports) {

let $01c402c6eef7e67c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01c402c6eef7e67c$var$load("kDPsc"),
    $01c402c6eef7e67c$var$load("20iLk")
]).then(()=>parcelRequire('hYgtC'));

});

parcelRegister("6hb9T", function(module, exports) {

let $491cfc78b9c2996b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $491cfc78b9c2996b$var$load("kDPsc"),
    $491cfc78b9c2996b$var$load("bPoc6")
]).then(()=>parcelRequire('l1cwM'));

});

parcelRegister("gq7xe", function(module, exports) {

let $bf44eb5b2715546a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf44eb5b2715546a$var$load("kiGNy"),
    $bf44eb5b2715546a$var$load("kDPsc"),
    $bf44eb5b2715546a$var$load("1N732")
]).then(()=>parcelRequire('bAtET'));

});

parcelRegister("iO8cz", function(module, exports) {

let $db134232af593050$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db134232af593050$var$load("9XYQ9"),
    $db134232af593050$var$load("lKcQU"),
    $db134232af593050$var$load("kiGNy"),
    $db134232af593050$var$load("kDPsc"),
    $db134232af593050$var$load("i1IyX")
]).then(()=>parcelRequire('5xERy'));

});

parcelRegister("f0kKh", function(module, exports) {

let $aec6f2bd6a5c0ed2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aec6f2bd6a5c0ed2$var$load("kDPsc"),
    $aec6f2bd6a5c0ed2$var$load("fOtNs")
]).then(()=>parcelRequire('6ZDf9'));

});

parcelRegister("l9IZw", function(module, exports) {

let $f66d5697e9a932cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f66d5697e9a932cf$var$load("kDPsc"),
    $f66d5697e9a932cf$var$load("5oL16")
]).then(()=>parcelRequire('aVGO8'));

});

parcelRegister("dAAas", function(module, exports) {

let $9e4ab15202d9a487$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e4ab15202d9a487$var$load("kDPsc"),
    $9e4ab15202d9a487$var$load("iYPek")
]).then(()=>parcelRequire('j1Wqs'));

});

parcelRegister("i4Qwf", function(module, exports) {

let $d29156ee190cce26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d29156ee190cce26$var$load("kDPsc"),
    $d29156ee190cce26$var$load("fOy1c")
]).then(()=>parcelRequire('71rIN'));

});

parcelRegister("i3736", function(module, exports) {

let $d23df997c0f43738$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d23df997c0f43738$var$load("kDPsc"),
    $d23df997c0f43738$var$load("10oey")
]).then(()=>parcelRequire('j6mc5'));

});

parcelRegister("6J1Ey", function(module, exports) {

let $4e583a52d3a1375e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e583a52d3a1375e$var$load("kDPsc"),
    $4e583a52d3a1375e$var$load("9pZKV")
]).then(()=>parcelRequire('29xuN'));

});

parcelRegister("9eRe1", function(module, exports) {

let $6b9eb5404b49244b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b9eb5404b49244b$var$load("kDPsc"),
    $6b9eb5404b49244b$var$load("1hiqo")
]).then(()=>parcelRequire('8NiE4'));

});

parcelRegister("ivT4W", function(module, exports) {

let $d7a5d8b93335b77f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d7a5d8b93335b77f$var$load("kDPsc"),
    $d7a5d8b93335b77f$var$load("d864Y")
]).then(()=>parcelRequire('8rWqo'));

});

parcelRegister("4R2KF", function(module, exports) {

let $388e3f1124aaeea1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $388e3f1124aaeea1$var$load("kDPsc"),
    $388e3f1124aaeea1$var$load("6hlj7")
]).then(()=>parcelRequire('3huTA'));

});

parcelRegister("eaJgs", function(module, exports) {

let $a5151c6caa1a1a7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a5151c6caa1a1a7a$var$load("kDPsc"),
    $a5151c6caa1a1a7a$var$load("6JwQH")
]).then(()=>parcelRequire('hbs7o'));

});

parcelRegister("3MMPs", function(module, exports) {

let $2c1bbb3711e2b6a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c1bbb3711e2b6a7$var$load("kDPsc"),
    $2c1bbb3711e2b6a7$var$load("1llHF")
]).then(()=>parcelRequire('hRgVC'));

});

parcelRegister("DrreJ", function(module, exports) {

let $0768ed4ee48e30c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0768ed4ee48e30c2$var$load("kDPsc"),
    $0768ed4ee48e30c2$var$load("53uoN")
]).then(()=>parcelRequire('1XcBd'));

});

parcelRegister("diOLt", function(module, exports) {

let $9af455998c327bfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9af455998c327bfe$var$load("kDPsc"),
    $9af455998c327bfe$var$load("deMui")
]).then(()=>parcelRequire('59bfh'));

});

parcelRegister("iObgZ", function(module, exports) {

let $db15a4195d5031e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db15a4195d5031e0$var$load("kDPsc"),
    $db15a4195d5031e0$var$load("5zlmP")
]).then(()=>parcelRequire('9ZJkB'));

});

parcelRegister("lUC1Z", function(module, exports) {

let $ff3c5418216999fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ff3c5418216999fb$var$load("kDPsc"),
    $ff3c5418216999fb$var$load("4gpLy")
]).then(()=>parcelRequire('6UP22'));

});

parcelRegister("fXMRT", function(module, exports) {

let $b9f245ee31d9e923$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b9f245ee31d9e923$var$load("kDPsc"),
    $b9f245ee31d9e923$var$load("eCFud")
]).then(()=>parcelRequire('8z07K'));

});

parcelRegister("iJ5jF", function(module, exports) {

let $da208da7783169b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da208da7783169b6$var$load("kDPsc"),
    $da208da7783169b6$var$load("4TcdQ")
]).then(()=>parcelRequire('kgJJN'));

});

parcelRegister("9EEgw", function(module, exports) {

let $7077155cd87e831c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7077155cd87e831c$var$load("kDPsc"),
    $7077155cd87e831c$var$load("hC295")
]).then(()=>parcelRequire('ex5uU'));

});

parcelRegister("bX57u", function(module, exports) {

let $8b392d12da92d79f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b392d12da92d79f$var$load("6wr18"),
    $8b392d12da92d79f$var$load("ffEVr"),
    $8b392d12da92d79f$var$load("kDPsc"),
    $8b392d12da92d79f$var$load("jUe3X")
]).then(()=>parcelRequire('jvsYc'));

});

parcelRegister("18uKq", function(module, exports) {

let $0d3e63b25e523f74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d3e63b25e523f74$var$load("kDPsc"),
    $0d3e63b25e523f74$var$load("kHvlO")
]).then(()=>parcelRequire('fuZzH'));

});

parcelRegister("f7nwM", function(module, exports) {

let $b019c293e1693560$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b019c293e1693560$var$load("kDPsc"),
    $b019c293e1693560$var$load("6jNWq")
]).then(()=>parcelRequire('5n8d3'));

});

parcelRegister("68Axg", function(module, exports) {

let $477fd49d31fe98b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $477fd49d31fe98b7$var$load("kDPsc"),
    $477fd49d31fe98b7$var$load("3m9re")
]).then(()=>parcelRequire('hHfH9'));

});

parcelRegister("kWSyz", function(module, exports) {

let $f4038b384d6421fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4038b384d6421fb$var$load("kDPsc"),
    $f4038b384d6421fb$var$load("2oglp")
]).then(()=>parcelRequire('84C2y'));

});

parcelRegister("b4MNL", function(module, exports) {

let $8105ec68f73960d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8105ec68f73960d6$var$load("kDPsc"),
    $8105ec68f73960d6$var$load("jh0xO")
]).then(()=>parcelRequire('6vWxb'));

});

parcelRegister("88jnE", function(module, exports) {

let $5ebe1aa80762b726$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5ebe1aa80762b726$var$load("kDPsc"),
    $5ebe1aa80762b726$var$load("5xRpV")
]).then(()=>parcelRequire('aSwMH'));

});

parcelRegister("f8JUn", function(module, exports) {

let $b05b36cffea48137$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b05b36cffea48137$var$load("kDPsc"),
    $b05b36cffea48137$var$load("dodbW")
]).then(()=>parcelRequire('gDcgd'));

});

parcelRegister("1MKv1", function(module, exports) {

let $14ce57f570a3474b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14ce57f570a3474b$var$load("kDPsc"),
    $14ce57f570a3474b$var$load("9USAR")
]).then(()=>parcelRequire('adC7x'));

});

parcelRegister("6vcqN", function(module, exports) {

let $4bbf47eab297111d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4bbf47eab297111d$var$load("kDPsc"),
    $4bbf47eab297111d$var$load("7tbBL")
]).then(()=>parcelRequire('ihnIJ'));

});

parcelRegister("4SxCw", function(module, exports) {

let $38d648dfa4bf1f2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $38d648dfa4bf1f2b$var$load("kDPsc"),
    $38d648dfa4bf1f2b$var$load("19xe3")
]).then(()=>parcelRequire('VtCYO'));

});

parcelRegister("93rDA", function(module, exports) {

let $6979d51a2300bc15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6979d51a2300bc15$var$load("kDPsc"),
    $6979d51a2300bc15$var$load("gex3C")
]).then(()=>parcelRequire('fbBtU'));

});

parcelRegister("lkMgQ", function(module, exports) {

let $f880e8c6ba4bb91f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f880e8c6ba4bb91f$var$load("kDPsc"),
    $f880e8c6ba4bb91f$var$load("2VVfz")
]).then(()=>parcelRequire('1phEn'));

});

parcelRegister("l3ZbL", function(module, exports) {

let $f5595798212b47ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5595798212b47ab$var$load("kDPsc"),
    $f5595798212b47ab$var$load("adyb9")
]).then(()=>parcelRequire('iPB5v'));

});

parcelRegister("jv9C2", function(module, exports) {

let $e3285e68f8515079$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e3285e68f8515079$var$load("kDPsc"),
    $e3285e68f8515079$var$load("cuewJ")
]).then(()=>parcelRequire('71Pdv'));

});

parcelRegister("cwbpJ", function(module, exports) {

let $91d153c819c72254$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $91d153c819c72254$var$load("kDPsc"),
    $91d153c819c72254$var$load("5NFhD")
]).then(()=>parcelRequire('011Nq'));

});

parcelRegister("jQRRW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $5pS3b = parcelRequire("5pS3b");

const $221a2b03be5b44a4$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5pS3b.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withIntlProvider"] = $221a2b03be5b44a4$export$a5d940130f33be3f;

});

parcelRegister("5pS3b", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $ewi8o = parcelRequire("ewi8o");

function $b2d267b4c02f41c6$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $8C5kA.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $b2d267b4c02f41c6$export$480518999dfc4151(props) {
    const { locale: locale } = $b2d267b4c02f41c6$var$useFetchLocale();
    const messages = (0, $ewi8o.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}
module.exports["IntlProvider"] = $b2d267b4c02f41c6$export$480518999dfc4151;

});

parcelRegister("ewi8o", function(module, exports) {

var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");

const $9f428f426036dbfa$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $42omo.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};
module.exports["useIntlMessages"] = $9f428f426036dbfa$export$2641ec9a2025a81f;

});

parcelRegister("k3ebb", function(module, exports) {
module.exports = JSON.parse("{\"INAPP-2055.spotlight.body\":[{\"type\":0,\"value\":\"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed\"}],\"INAPP-2055.spotlight.primary\":[{\"type\":0,\"value\":\"Learn more\"}],\"INAPP-2055.spotlight.secondary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-2055.spotlight.title\":[{\"type\":0,\"value\":\"Create rich and informative alerts\"}],\"INAPP-3273.spotlight.body\":[{\"type\":0,\"value\":\"Triage and resolve alerts faster by using Atlassian Intelligence to access similar alerts.\"}],\"INAPP-3273.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-3273.spotlight.title\":[{\"type\":0,\"value\":\"Drive faster alert resolution with Atlassian Intelligence\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.body\":[{\"type\":0,\"value\":\"Expand to quickly view all alerts in the group.\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.title\":[{\"type\":0,\"value\":\"View grouped alerts\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.body\":[{\"type\":0,\"value\":\"Rovo helps you classify your alerts as signal or noise so you can focus on what matters most.\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.title\":[{\"type\":0,\"value\":\"Triage alerts faster\"}],\"jira-ops-unified-view-revamp.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-ops-unified-view-revamp.spotlight.go-back\":[{\"type\":0,\"value\":\"Go back\"}],\"jira-ops-unified-view-revamp.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-ops-unified-view-revamp.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}]}");

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("ktaGw", function(module, exports) {

let $ee6ecdd9e62a6018$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee6ecdd9e62a6018$var$load("izosY").then(()=>parcelRequire('697Tr'));

});

parcelRegister("1nAmB", function(module, exports) {

let $1014257bc41fe578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1014257bc41fe578$var$load("3AtlW").then(()=>parcelRequire('bxLKl'));

});

parcelRegister("kADfk", function(module, exports) {

let $efd59cf13251bde5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $efd59cf13251bde5$var$load("49R0z").then(()=>parcelRequire('2D505'));

});

parcelRegister("39Kqy", function(module, exports) {

let $24c639d62efdcbb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24c639d62efdcbb7$var$load("awYAY").then(()=>parcelRequire('9lbX1'));

});

parcelRegister("lspmN", function(module, exports) {

let $f9efe3c9f712c8ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9efe3c9f712c8ba$var$load("d4kiK").then(()=>parcelRequire('cb2XJ'));

});

parcelRegister("OUGQx", function(module, exports) {

let $0990a51807c89fdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0990a51807c89fdb$var$load("30jIn").then(()=>parcelRequire('2zrZa'));

});

parcelRegister("aXzEj", function(module, exports) {

let $7fab1141442428c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7fab1141442428c2$var$load("8e9HE").then(()=>parcelRequire('e9jSz'));

});

parcelRegister("eeT8z", function(module, exports) {

let $a5dd2497131cfec6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5dd2497131cfec6$var$load("5PqJ2").then(()=>parcelRequire('c05fi'));

});

parcelRegister("gWIaz", function(module, exports) {

let $c564534987e61082$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c564534987e61082$var$load("eqI14").then(()=>parcelRequire('8FtQT'));

});

parcelRegister("7edTv", function(module, exports) {

let $54349e56bc0722ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54349e56bc0722ef$var$load("3sl1f").then(()=>parcelRequire('4QaSh'));

});

parcelRegister("4OGmS", function(module, exports) {

let $381cb258235fad51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $381cb258235fad51$var$load("3pZNx").then(()=>parcelRequire('aYpuU'));

});

parcelRegister("7BE2v", function(module, exports) {

let $589b0c1f4473ac7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $589b0c1f4473ac7c$var$load("axOzI").then(()=>parcelRequire('fkUiE'));

});

parcelRegister("56MyO", function(module, exports) {

let $3b832e68c0f16f11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b832e68c0f16f11$var$load("3KSkB").then(()=>parcelRequire('1muii'));

});

parcelRegister("qLVGx", function(module, exports) {

let $05079b9abc3461d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05079b9abc3461d4$var$load("39iSL").then(()=>parcelRequire('5H9GZ'));

});

parcelRegister("48zwW", function(module, exports) {

let $30337859cc2d7ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30337859cc2d7ead$var$load("dNXsf").then(()=>parcelRequire('9mVBJ'));

});

parcelRegister("cQeIN", function(module, exports) {

let $9595c2ba18306dbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9595c2ba18306dbe$var$load("7Vq2p").then(()=>parcelRequire('80Id3'));

});

parcelRegister("1Dxz8", function(module, exports) {

let $1313786c25f0b69a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1313786c25f0b69a$var$load("b7Crx").then(()=>parcelRequire('41zJe'));

});

parcelRegister("d4Hmo", function(module, exports) {

let $984d488628fea574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $984d488628fea574$var$load("ef4Ev").then(()=>parcelRequire('ez8W0'));

});

parcelRegister("gjyaO", function(module, exports) {

let $be08edd46504f822$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be08edd46504f822$var$load("dam1i").then(()=>parcelRequire('d9lvP'));

});

parcelRegister("cAhBk", function(module, exports) {

let $9296800d174d5338$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9296800d174d5338$var$load("edH9A").then(()=>parcelRequire('8auZY'));

});

parcelRegister("8YHHO", function(module, exports) {

let $6895d46172f6ca48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6895d46172f6ca48$var$load("aYhwp").then(()=>parcelRequire('bhisA'));

});

parcelRegister("759f8", function(module, exports) {

let $52802b7f628937a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $52802b7f628937a3$var$load("g5eT1").then(()=>parcelRequire('e9W1F'));

});

parcelRegister("7Y4Mm", function(module, exports) {

let $5cd1d808ebe21561$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5cd1d808ebe21561$var$load("a0epF").then(()=>parcelRequire('fNV4p'));

});

parcelRegister("fBb1L", function(module, exports) {

let $b5b2dd8cd186752a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5b2dd8cd186752a$var$load("cS8nd").then(()=>parcelRequire('c83ZD'));

});

parcelRegister("fO9qZ", function(module, exports) {

let $b822d7f98d409fb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b822d7f98d409fb9$var$load("gcjwP").then(()=>parcelRequire('jnt25'));

});

parcelRegister("kYiGN", function(module, exports) {

let $f447e88dcdfd7d56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f447e88dcdfd7d56$var$load("6wQZW").then(()=>parcelRequire('gX6ZO'));

});

parcelRegister("25Upz", function(module, exports) {

let $1867ce871f32473a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1867ce871f32473a$var$load("6s9LC").then(()=>parcelRequire('k4e6D'));

});

parcelRegister("2KPG0", function(module, exports) {

let $2017f680e599f00e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2017f680e599f00e$var$load("buj9L").then(()=>parcelRequire('2EuJ7'));

});

parcelRegister("8uKnv", function(module, exports) {

let $62f519c72ec35a3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62f519c72ec35a3d$var$load("gnYru").then(()=>parcelRequire('8oIJl'));

});

parcelRegister("hHp3F", function(module, exports) {

let $ce29e3dbd59c233e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce29e3dbd59c233e$var$load("gujd3").then(()=>parcelRequire('joDGC'));

});

parcelRegister("ex8X1", function(module, exports) {

let $a94b173bb39e871e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a94b173bb39e871e$var$load("hyz8a").then(()=>parcelRequire('4XEzj'));

});

parcelRegister("6SbWl", function(module, exports) {

let $50110c42dbc0fb20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50110c42dbc0fb20$var$load("d6dBt").then(()=>parcelRequire('4HH5G'));

});

parcelRegister("6wqja", function(module, exports) {

let $4bfa2380898257dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4bfa2380898257dd$var$load("jg4bP").then(()=>parcelRequire('8DdeG'));

});

parcelRegister("5VpDs", function(module, exports) {

let $45062941f9bb99f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45062941f9bb99f9$var$load("hMfET").then(()=>parcelRequire('es9Pj'));

});

parcelRegister("b2ONX", function(module, exports) {
module.exports = JSON.parse('{"INAPP-1736.spotlight.body":[{"type":0,"value":"We\'ve got the basic settings for your integration covered. Customize them to make sure you get the most out of the integration."}],"INAPP-1736.spotlight.primary":[{"type":0,"value":"OK"}],"INAPP-1736.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-1736.spotlight.title":[{"type":0,"value":"Set up your integration"}],"INAPP-1737.spotlight.body":[{"type":0,"value":"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"}],"INAPP-1737.spotlight.primary":[{"type":0,"value":"Learn more"}],"INAPP-1737.spotlight.secondary":[{"type":0,"value":"OK"}],"INAPP-1737.spotlight.title":[{"type":0,"value":"Create rich and informative alerts"}],"alert.status.acked":[{"type":0,"value":"Acknowledged"}],"alert.status.closed":[{"type":0,"value":"Closed"}],"alert.status.open":[{"type":0,"value":"Open"}],"alert.status.snoozed":[{"type":0,"value":"Snoozed"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Note added"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View alert in OpsGenie"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert acknowledged: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert acknowledged: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert assigned: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert closed: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-new.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" New alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-audit-log-download.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"alexstrasza.jsm-operations-audit-log-download.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"alexstrasza.jsm-operations-audit-log-download.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"alexstrasza.jsm-operations-audit-log-download.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"alexstrasza.jsm-operations-audit-log-download.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"alexstrasza.jsm-operations-audit-log-download.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" ends"}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending, at "},{"type":1,"value":"endTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending now."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.app-store-logo.alt.no-translate":[{"type":0,"value":"Download on the App Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.link-text.no-translate":[{"type":0,"value":"update your notification settings"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.no-translate":[{"type":0,"value":"To customize the email or unsubscribe, "},{"type":1,"value":"link"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.mobile-app.no-translate":[{"type":0,"value":"Stay notified and comment on the go with Jira Service Management Mobile App"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.play-store-logo.alt.no-translate":[{"type":0,"value":"Download on the Play Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer-logo.alt.no-translate":[{"type":0,"value":"Atlassian"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.privacy-policy.no-translate":[{"type":0,"value":"Privacy Policy"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.text.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" starts"}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting, at "},{"type":1,"value":"startTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting now."}],"eoc-heartbeats.message-id.spotlight.body":[{"type":0,"value":"Copy heartbeat\u2019s name, edit, duplicate, and manage more heartbeat actions."}],"eoc-heartbeats.message-id.spotlight.dismiss":[{"type":0,"value":"OK"}],"eoc-heartbeats.message-id.spotlight.title":[{"type":0,"value":"Easy access to heartbeat actions"}],"eoc-heartbeats.tour.learn-more.no-translate":[{"type":0,"value":"Learn More"}]}');

});

parcelRegister("8gKl9", function(module, exports) {

let $6053c38877b29ee9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6053c38877b29ee9$var$load("0l0tL").then(()=>parcelRequire('gsb8W'));

});

parcelRegister("jpSOO", function(module, exports) {

let $e22adff0b36f5f5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e22adff0b36f5f5b$var$load("kS4Lw").then(()=>parcelRequire('fPIB7'));

});

parcelRegister("6AecT", function(module, exports) {

let $4cb12012ea66b4c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4cb12012ea66b4c5$var$load("5gGJt").then(()=>parcelRequire('96DZB'));

});

parcelRegister("hlWDs", function(module, exports) {

let $ca21e19bd87545fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca21e19bd87545fc$var$load("7g6eW").then(()=>parcelRequire('fXmH2'));

});

parcelRegister("l6nXd", function(module, exports) {

let $f5ccbd4e90c5a3e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5ccbd4e90c5a3e7$var$load("1Vhlr").then(()=>parcelRequire('jMeMF'));

});

parcelRegister("iEmwp", function(module, exports) {

let $d93d6ec487addf17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d93d6ec487addf17$var$load("63Pb3").then(()=>parcelRequire('3W12e'));

});

parcelRegister("2gNE9", function(module, exports) {

let $1a7396303d37eb39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a7396303d37eb39$var$load("lEX61").then(()=>parcelRequire('bHmzJ'));

});

parcelRegister("aTgWD", function(module, exports) {

let $7edc2f4866763f6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7edc2f4866763f6e$var$load("fqkMC").then(()=>parcelRequire('bA5Ka'));

});

parcelRegister("iiAsS", function(module, exports) {

let $d5263194561155ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5263194561155ca$var$load("99PJi").then(()=>parcelRequire('1hFWg'));

});

parcelRegister("2tWdS", function(module, exports) {

let $1ceb740818ca6ac0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ceb740818ca6ac0$var$load("6D08s").then(()=>parcelRequire('l6rHB'));

});

parcelRegister("iiOFt", function(module, exports) {

let $d5313608989c4ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5313608989c4ead$var$load("ijPpX").then(()=>parcelRequire('bEmjJ'));

});

parcelRegister("aeHTQ", function(module, exports) {

let $773d43be7a4872c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $773d43be7a4872c4$var$load("dfhwS").then(()=>parcelRequire('lwhLg'));

});

parcelRegister("5GK6s", function(module, exports) {

let $4244a318eef3e4a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4244a318eef3e4a5$var$load("4rU0s").then(()=>parcelRequire('dPuzR'));

});

parcelRegister("eEw0a", function(module, exports) {

let $aaad9fff1cf3629f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aaad9fff1cf3629f$var$load("2rRxY").then(()=>parcelRequire('bZN2t'));

});

parcelRegister("jthau", function(module, exports) {

let $e2ce0b02ea63610a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e2ce0b02ea63610a$var$load("claFy").then(()=>parcelRequire('3sSbK'));

});

parcelRegister("84Cxf", function(module, exports) {

let $5e0c96b9d5dc34cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e0c96b9d5dc34cd$var$load("5Kn8Z").then(()=>parcelRequire('7VfNr'));

});

parcelRegister("iW3kM", function(module, exports) {

let $dc903ad91b69b5bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc903ad91b69b5bf$var$load("jLj2M").then(()=>parcelRequire('7WvbB'));

});

parcelRegister("9nNUV", function(module, exports) {

let $6d4cfb89288098d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d4cfb89288098d3$var$load("l4bde").then(()=>parcelRequire('kz3Lh'));

});

parcelRegister("81GdU", function(module, exports) {

let $5d7f2b68a04d6302$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d7f2b68a04d6302$var$load("2aiDg").then(()=>parcelRequire('ieaKJ'));

});

parcelRegister("92qiC", function(module, exports) {

let $6948b375c36d309d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6948b375c36d309d$var$load("9NdQS").then(()=>parcelRequire('9DuFq'));

});

parcelRegister("9bHyb", function(module, exports) {

let $6b06ec5a3045285a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b06ec5a3045285a$var$load("1BHqK").then(()=>parcelRequire('aKkQw'));

});

parcelRegister("gvcyQ", function(module, exports) {

let $c03948f5fa5dc9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c03948f5fa5dc9d7$var$load("fuAjW").then(()=>parcelRequire('7cokY'));

});

parcelRegister("jRfhy", function(module, exports) {

let $e74ed246ba47b870$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e74ed246ba47b870$var$load("l8hOj").then(()=>parcelRequire('jCu14'));

});

parcelRegister("irGVY", function(module, exports) {

let $d6dc0d666f47ed9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6dc0d666f47ed9c$var$load("kCJuv").then(()=>parcelRequire('KcT4F'));

});

parcelRegister("7O4me", function(module, exports) {

let $5af0953e181c4611$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5af0953e181c4611$var$load("56AJD").then(()=>parcelRequire('b1TUx'));

});

parcelRegister("4s7jC", function(module, exports) {

let $33df73a81e07998e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33df73a81e07998e$var$load("4pLuY").then(()=>parcelRequire('7NfSm'));

});

parcelRegister("dA2nN", function(module, exports) {

let $9e307c50a4ba392f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e307c50a4ba392f$var$load("kFWZh").then(()=>parcelRequire('8Gg0l'));

});

parcelRegister("9IUYg", function(module, exports) {

let $71446a59d7380bf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71446a59d7380bf9$var$load("ap3Co").then(()=>parcelRequire('96cpV'));

});

parcelRegister("bCUq0", function(module, exports) {

let $876f01daf945e216$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $876f01daf945e216$var$load("51qYO").then(()=>parcelRequire('6Ru1J'));

});

parcelRegister("ew9Iy", function(module, exports) {

let $a91b978f79d29a11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a91b978f79d29a11$var$load("80DaC").then(()=>parcelRequire('877gu'));

});

parcelRegister("h6IDB", function(module, exports) {

let $c7459f5618d2558f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7459f5618d2558f$var$load("CxhW1").then(()=>parcelRequire('32UbK'));

});

parcelRegister("hKi96", function(module, exports) {

let $ceb4ceed4e80294e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ceb4ceed4e80294e$var$load("5D9Of").then(()=>parcelRequire('4EO5i'));

});

parcelRegister("4Dsjr", function(module, exports) {

let $3600c435b6e9d62d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3600c435b6e9d62d$var$load("IN5iq").then(()=>parcelRequire('2LOlb'));

});

parcelRegister("laflr", function(module, exports) {

let $f6866f4a4ba2691e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6866f4a4ba2691e$var$load("akVf8").then(()=>parcelRequire('iUU9u'));

});

parcelRegister("faKVU", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.button-text":[{"type":0,"value":"Create meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.description":[{"type":0,"value":"Share goals, set context, and save time with a meeting notes template."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header":[{"type":0,"value":"Keep meetings aligned and actionable"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header-image.alt-text":[{"type":0,"value":"Atlassian Confluence logo"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.main-image.alt-text":[{"type":0,"value":"Meeting notes illustration showing document with highlighted content"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-image.alt-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.unsubscribe-link-text":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"a"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template.email.subject":[{"type":0,"value":"Save time with a Confluence meeting notes template"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part1":[{"type":0,"value":"Your teammates are using Confluence to share project context, capture decisions, and more in "},{"type":1,"value":"projectName"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part2":[{"type":0,"value":"Here\'s what they\'ve recently linked to your Jira project:"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.email.subject":[{"type":0,"value":"Your team in "},{"type":1,"value":"projectName"},{"type":0,"value":" is using Confluence for project docs--see what they\u2019ve added"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.button-cta":[{"type":0,"value":"Open Confluence"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.signoff":[{"type":0,"value":"See what else is happening across your company:"}],"confluence-reminder.cta.button":[{"type":0,"value":"Accept invite"}],"confluence-reminder.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"confluence-reminder.email.subject":[{"type":0,"value":"Reminder: "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to collaborate in Confluence"}],"confluence-reminder.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"confluence-reminder.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"confluence-reminder.inviter.avatar.alt":[{"type":0,"value":"Profile photo of "},{"type":1,"value":"inviterName"}],"confluence-reminder.main.heading":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to join Confluence"}],"confluence-reminder.product.description":[{"type":0,"value":"Plan projects, run meetings, and brainstorm ideas with your team\u2014all in one place."}],"confluence-reminder.redacted.heading":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.redacted.subject":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.social-proof.text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":" customers use "},{"type":1,"value":"productName"},{"type":0,"value":" to move work forward"}],"confluence.fastAndSnappy.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.fastAndSnappy.survey.statement":[{"type":0,"value":"Confluence feels fast and snappy."}],"confluence.lovability.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.lovability.survey.statement":[{"type":0,"value":"Confluence is a product I love using."}],"post-office-team.confluence-reactivate-inactive-link-paste-in-jira-email.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}]}');

});

parcelRegister("2hVW4", function(module, exports) {

let $1aaa1c2151bdc005$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1aaa1c2151bdc005$var$load("4Pnig").then(()=>parcelRequire('6YKP0'));

});

parcelRegister("fAaEK", function(module, exports) {

let $b5827be4aed14d9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5827be4aed14d9b$var$load("TlLku").then(()=>parcelRequire('hRqbJ'));

});

parcelRegister("8GjgQ", function(module, exports) {

let $652131bf4f1dbd09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $652131bf4f1dbd09$var$load("5JIp5").then(()=>parcelRequire('gKnJd'));

});

parcelRegister("5a41J", function(module, exports) {

let $3c210293e9e613b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c210293e9e613b8$var$load("fC8IH").then(()=>parcelRequire('ba3HB'));

});

parcelRegister("fix6E", function(module, exports) {

let $b23237a66943085a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b23237a66943085a$var$load("104CE").then(()=>parcelRequire('01Oij'));

});

parcelRegister("bwCLU", function(module, exports) {

let $8640c21a29e9f6e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8640c21a29e9f6e3$var$load("4OdV1").then(()=>parcelRequire('lwLs9'));

});

parcelRegister("4bt64", function(module, exports) {

let $30bec28d7b61e5a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30bec28d7b61e5a5$var$load("29P6Z").then(()=>parcelRequire('4awuM'));

});

parcelRegister("6MvOp", function(module, exports) {

let $4effe701f6dd6e68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4effe701f6dd6e68$var$load("3LT6Y").then(()=>parcelRequire('k85Dj'));

});

parcelRegister("60oCJ", function(module, exports) {

let $45f5d7e8b83f8f10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45f5d7e8b83f8f10$var$load("aUk88").then(()=>parcelRequire('jJZSp'));

});

parcelRegister("hgfXf", function(module, exports) {

let $c9104e8b701d7952$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9104e8b701d7952$var$load("ilw9Q").then(()=>parcelRequire('fx9se'));

});

parcelRegister("bf7FY", function(module, exports) {

let $82f70cb80c571015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82f70cb80c571015$var$load("4sHGL").then(()=>parcelRequire('k4nta'));

});

parcelRegister("8TUis", function(module, exports) {

let $67af2127738bcf45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $67af2127738bcf45$var$load("gqzPx").then(()=>parcelRequire('9EUOa'));

});

parcelRegister("goxB3", function(module, exports) {

let $bef8f2d6347758e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bef8f2d6347758e0$var$load("c2wP7").then(()=>parcelRequire('gD4xH'));

});

parcelRegister("atMnC", function(module, exports) {

let $7a1224118f78d7b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a1224118f78d7b5$var$load("5GFGF").then(()=>parcelRequire('hWxC2'));

});

parcelRegister("eDBpO", function(module, exports) {

let $aa81bb1c2acc1dca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa81bb1c2acc1dca$var$load("jfz2k").then(()=>parcelRequire('5QZzy'));

});

parcelRegister("fndj2", function(module, exports) {

let $b313534d3146fddf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b313534d3146fddf$var$load("5ejxC").then(()=>parcelRequire('b33bB'));

});

parcelRegister("1Fzpx", function(module, exports) {

let $137516a37654b52e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $137516a37654b52e$var$load("fjNLR").then(()=>parcelRequire('ep2qs'));

});

parcelRegister("4ZXgO", function(module, exports) {

let $3a3ad5c1768ea6cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a3ad5c1768ea6cd$var$load("cHkhr").then(()=>parcelRequire('7W04t'));

});

parcelRegister("7ArxX", function(module, exports) {

let $5861436913b35b65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5861436913b35b65$var$load("dzJ0w").then(()=>parcelRequire('9u8ii'));

});

parcelRegister("kHy3v", function(module, exports) {

let $f1223d8a762292bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1223d8a762292bb$var$load("hvMMD").then(()=>parcelRequire('hV7Xw'));

});

parcelRegister("27vXu", function(module, exports) {

let $18b5067cf8e92ad3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18b5067cf8e92ad3$var$load("5Gah6").then(()=>parcelRequire('jq88S'));

});

parcelRegister("aGvLS", function(module, exports) {

let $7c7678bb7d8fb38b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c7678bb7d8fb38b$var$load("e3rNQ").then(()=>parcelRequire('g9737'));

});

parcelRegister("brfyh", function(module, exports) {

let $853e47a07dd07467$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $853e47a07dd07467$var$load("fZSN3").then(()=>parcelRequire('d6LkT'));

});

parcelRegister("9S126", function(module, exports) {

let $72f9f54acf42fc05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72f9f54acf42fc05$var$load("c0zXU").then(()=>parcelRequire('3eG9z'));

});

parcelRegister("7Hl4N", function(module, exports) {

let $59ace5dc3c52929c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $59ace5dc3c52929c$var$load("lA9u7").then(()=>parcelRequire('4i7fO'));

});

parcelRegister("18607", function(module, exports) {

let $0d2b31733891be89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d2b31733891be89$var$load("PjV2H").then(()=>parcelRequire('9Hpkr'));

});

parcelRegister("k3ViT", function(module, exports) {

let $e9b089c2bf88f8fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9b089c2bf88f8fa$var$load("2Leae").then(()=>parcelRequire('7Nbjk'));

});

parcelRegister("cISby", function(module, exports) {

let $9433a02d93c95687$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9433a02d93c95687$var$load("75IKC").then(()=>parcelRequire('9NWLE'));

});

parcelRegister("3JasV", function(module, exports) {

let $2b6db147cad9b95d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b6db147cad9b95d$var$load("j26Ur").then(()=>parcelRequire('6YaUi'));

});

parcelRegister("9euEq", function(module, exports) {

let $6b8d3289ba4eb2f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b8d3289ba4eb2f0$var$load("77kvn").then(()=>parcelRequire('6z1Qp'));

});

parcelRegister("bQrvq", function(module, exports) {

let $89f9e326bdd7d5ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89f9e326bdd7d5ae$var$load("ikviJ").then(()=>parcelRequire('75xzh'));

});

parcelRegister("5y8fx", function(module, exports) {

let $40a686eab9c6c982$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40a686eab9c6c982$var$load("9zjjt").then(()=>parcelRequire('eEtHi'));

});

parcelRegister("jUr6Q", function(module, exports) {

let $e7e846ab1cc53017$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7e846ab1cc53017$var$load("2PJpv").then(()=>parcelRequire('9s0Bd'));

});

parcelRegister("1PEi6", function(module, exports) {

let $1559ced11f925384$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1559ced11f925384$var$load("jysVQ").then(()=>parcelRequire('dDVJF'));

});

parcelRegister("96o0f", function(module, exports) {
module.exports = JSON.parse("{\"confluence-inline-reactions-mcu-nudge.description.many-reactions\":[{\"type\":1,\"value\":\"user1\"},{\"type\":0,\"value\":\", \"},{\"type\":1,\"value\":\"user2\"},{\"type\":0,\"value\":\" and \"},{\"type\":1,\"value\":\"count\"},{\"type\":0,\"value\":\" other\"},{\"offset\":0,\"options\":{\"one\":{\"value\":[]},\"other\":{\"value\":[{\"type\":0,\"value\":\"s\"}]}},\"pluralType\":\"cardinal\",\"type\":6,\"value\":\"count\"},{\"type\":0,\"value\":\" reacted to this page\"}],\"confluence-inline-reactions-mcu-nudge.description.no-reactions\":[{\"type\":0,\"value\":\"Be the first one to react\"}],\"confluence-inline-reactions-mcu-nudge.description.one-reaction\":[{\"type\":1,\"value\":\"user\"},{\"type\":0,\"value\":\" reacted to this page\"}],\"confluence-inline-reactions-mcu-nudge.description.two-reactions\":[{\"type\":1,\"value\":\"user1\"},{\"type\":0,\"value\":\" and \"},{\"type\":1,\"value\":\"user2\"},{\"type\":0,\"value\":\" reacted to this page\"}],\"confluence-inline-reactions-mcu-nudge.title\":[{\"type\":0,\"value\":\"Love this page? Let \"},{\"type\":1,\"value\":\"authorName\"},{\"type\":0,\"value\":\" know\"}],\"post-office.confluence-resurrected-user-welcome-back.body\":[{\"type\":0,\"value\":\"Jump into the top discussions and pages you might have missed.\"}],\"post-office.confluence-resurrected-user-welcome-back.close\":[{\"type\":0,\"value\":\"Close\"}],\"post-office.confluence-resurrected-user-welcome-back.cta\":[{\"type\":0,\"value\":\"See what's popular\"}],\"post-office.confluence-resurrected-user-welcome-back.image-alt\":[{\"type\":0,\"value\":\"Two hearts overlapped with each other\"}],\"post-office.confluence-resurrected-user-welcome-back.next-best-action.header\":[{\"type\":0,\"value\":\"Welcome back!\"}]}");

});

parcelRegister("8pkfo", function(module, exports) {

let $61f05d3685a1f622$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61f05d3685a1f622$var$load("9lgXg").then(()=>parcelRequire('bj2br'));

});

parcelRegister("3xGoG", function(module, exports) {

let $2945575a62842ee4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2945575a62842ee4$var$load("cGVHa").then(()=>parcelRequire('7ApBu'));

});

parcelRegister("40eBS", function(module, exports) {

let $2ea27eb66f072cd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ea27eb66f072cd4$var$load("124it").then(()=>parcelRequire('3ntz2'));

});

parcelRegister("aPwCB", function(module, exports) {

let $7e27f8c145d8ea2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e27f8c145d8ea2a$var$load("gL84Y").then(()=>parcelRequire('OOVjL'));

});

parcelRegister("4ugRI", function(module, exports) {

let $34470be016111738$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34470be016111738$var$load("fpqFW").then(()=>parcelRequire('e5vLF'));

});

parcelRegister("lXmGM", function(module, exports) {

let $ffc0b53d188482a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffc0b53d188482a4$var$load("9LGea").then(()=>parcelRequire('9YAnZ'));

});

parcelRegister("f4AyR", function(module, exports) {

let $af9397080bd6c926$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af9397080bd6c926$var$load("7uvFU").then(()=>parcelRequire('lMFWW'));

});

parcelRegister("kCR1F", function(module, exports) {

let $f0407d1cf9a6452b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0407d1cf9a6452b$var$load("lb58d").then(()=>parcelRequire('fZ956'));

});

parcelRegister("cmHVh", function(module, exports) {

let $90099c45518641f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90099c45518641f6$var$load("53hWW").then(()=>parcelRequire('iPUlN'));

});

parcelRegister("4l2T3", function(module, exports) {

let $328b5ce1181d3fab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $328b5ce1181d3fab$var$load("ao95w").then(()=>parcelRequire('7PzL9'));

});

parcelRegister("dFQgI", function(module, exports) {

let $9f47a627672a1856$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f47a627672a1856$var$load("2qn3g").then(()=>parcelRequire('37RXh'));

});

parcelRegister("2dfft", function(module, exports) {

let $19c89fbac79a025d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19c89fbac79a025d$var$load("3U2Yj").then(()=>parcelRequire('6mZms'));

});

parcelRegister("kvq2U", function(module, exports) {

let $eedae81428f24645$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eedae81428f24645$var$load("55GPM").then(()=>parcelRequire('5C4qU'));

});

parcelRegister("fuDUl", function(module, exports) {

let $b4789d3ab8eab63f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4789d3ab8eab63f$var$load("bWZ2H").then(()=>parcelRequire('6yRTH'));

});

parcelRegister("CbMTN", function(module, exports) {

let $072cb183c6b8510a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $072cb183c6b8510a$var$load("c41dA").then(()=>parcelRequire('Zu92b'));

});

parcelRegister("95nBU", function(module, exports) {

let $69d6e53d4c9f3822$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69d6e53d4c9f3822$var$load("hP4MP").then(()=>parcelRequire('dGxBa'));

});

parcelRegister("5zIEY", function(module, exports) {

let $40f2dd281e5bedda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40f2dd281e5bedda$var$load("dB864").then(()=>parcelRequire('afv3s'));

});

parcelRegister("g3fl3", function(module, exports) {

let $baf8d3118ac881fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $baf8d3118ac881fb$var$load("373qZ").then(()=>parcelRequire('fObJH'));

});

parcelRegister("lY2P3", function(module, exports) {

let $ffe1640fe1cf897a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffe1640fe1cf897a$var$load("7GCHJ").then(()=>parcelRequire('7Ri80'));

});

parcelRegister("hSkuL", function(module, exports) {

let $d03760ba1e343de9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d03760ba1e343de9$var$load("kkWcG").then(()=>parcelRequire('9Wa6U'));

});

parcelRegister("2LCWr", function(module, exports) {

let $203e2d8822e56c9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $203e2d8822e56c9b$var$load("aa9mr").then(()=>parcelRequire('6LCpG'));

});

parcelRegister("l3u53", function(module, exports) {

let $f541362ce11da5b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f541362ce11da5b1$var$load("bz1s9").then(()=>parcelRequire('jGfPl'));

});

parcelRegister("iagzr", function(module, exports) {

let $d39603c2a0dd6744$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d39603c2a0dd6744$var$load("gUDkD").then(()=>parcelRequire('1fRy2'));

});

parcelRegister("a57cu", function(module, exports) {

let $756ff4debffe7db3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $756ff4debffe7db3$var$load("6O8uL").then(()=>parcelRequire('dJHTm'));

});

parcelRegister("hhSu4", function(module, exports) {

let $c95e49928dd60070$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c95e49928dd60070$var$load("RuRWN").then(()=>parcelRequire('kBSC8'));

});

parcelRegister("4j5zJ", function(module, exports) {

let $322d42f08775439f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $322d42f08775439f$var$load("7po8a").then(()=>parcelRequire('lIYnd'));

});

parcelRegister("gVJGC", function(module, exports) {

let $032e47e175e40287$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $032e47e175e40287$var$load("aSbz2").then(()=>parcelRequire('9t6IE'));

});

parcelRegister("frDwI", function(module, exports) {

let $b3e809ccc2e1d73d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3e809ccc2e1d73d$var$load("b0Nov").then(()=>parcelRequire('5B42Z'));

});

parcelRegister("DmzaP", function(module, exports) {

let $076525d57706c0a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $076525d57706c0a0$var$load("cinaN").then(()=>parcelRequire('h35rw'));

});

parcelRegister("bi3sU", function(module, exports) {

let $83841041c52a5833$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83841041c52a5833$var$load("jV8xH").then(()=>parcelRequire('hBjVA'));

});

parcelRegister("8cyvu", function(module, exports) {

let $5f8a360bd574f58e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f8a360bd574f58e$var$load("aP9AA").then(()=>parcelRequire('6GPkr'));

});

parcelRegister("9qg2r", function(module, exports) {

let $6dc2fbabc78c5440$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dc2fbabc78c5440$var$load("1YvQ0").then(()=>parcelRequire('6CsZV'));

});

parcelRegister("e0XLq", function(module, exports) {

let $a33f6cab1825618d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a33f6cab1825618d$var$load("8SIrc").then(()=>parcelRequire('bVRXd'));

});

parcelRegister("4senR", function(module, exports) {

let $33e4ef4a40c99386$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33e4ef4a40c99386$var$load("2nTkk").then(()=>parcelRequire('dGCxL'));

});

parcelRegister("ayxoO", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.primary":[{"type":0,"value":"Try Rovo now"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.secondary":[{"type":0,"value":"Try Rovo now"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.subtitle":[{"type":0,"value":"Jump into Confluence to discover what\'s possible."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.title":[{"type":0,"value":"Ready to get started?"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.description":[{"type":0,"value":"Prompt Rovo to start creating for you. Use anything across Confluence as input."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.link":[{"type":0,"value":"Create with Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.title":[{"type":0,"value":"Create any content with Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.description":[{"type":0,"value":"Utilize Rovo in any doc or page by highlighting any text. Edit your writing or start drafting."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.link":[{"type":0,"value":"Edit with Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.title":[{"type":0,"value":"Edit with Rovo in docs and pages"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.description":[{"type":0,"value":"Save time by using summaries and audio briefings to get the context you need."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.link":[{"type":0,"value":"Try audio briefings"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.title":[{"type":0,"value":"Get information faster"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.features.title":[{"type":0,"value":"Use Rovo in a number of ways:"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.hero.alt":[{"type":0,"value":"Atlassian Intelligence"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.rovo":[{"type":0,"value":"Rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle":[{"type":0,"value":"Looks like you used "},{"type":1,"value":"featureName"},{"type":0,"value":" \u2014 here are more ways to use Rovo in Confluence."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle.video.variant":[{"type":0,"value":"Looks like you used "},{"type":1,"value":"featureName"},{"type":0,"value":". Here are a few more ideas for using Rovo."}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome":[{"type":0,"value":"Welcome, "},{"type":1,"value":"firstName"},{"type":0,"value":"!"}],"cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome-rovo":[{"type":0,"value":"Let\'s look at "},{"type":1,"value":"rovo"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject":[{"type":0,"value":"Rovo is here for whatever you need"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiAudioBriefings":[{"type":0,"value":"Listen to what else Rovo can do"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiChat":[{"type":0,"value":"Use Rovo in a lot more ways than just chat"}],"cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiDefinitions":[{"type":0,"value":"Rovo can do more than just define"}],"cc-flywheel-feature-discovery.rovo-awareness-survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"cc-flywheel-feature-discovery.rovo-awareness-survey.statement":[{"type":0,"value":"I\'m aware of Atlassian Rovo and its functionalities."}],"confluence-create-with-rovo-announcement-splash.modal.describe.item":[{"type":0,"value":"Describe what to create, let Rovo start it"}],"confluence-create-with-rovo-announcement-splash.modal.description":[{"type":0,"value":"Bye-bye blank page. Rovo can create what you need with a simple description and the power of your team\'s data."}],"confluence-create-with-rovo-announcement-splash.modal.edit.item":[{"type":0,"value":"Brain dump thoughts on a page, let Rovo edit it"}],"confluence-create-with-rovo-announcement-splash.modal.header":[{"type":0,"value":"Introducing Create with Rovo"}],"confluence-create-with-rovo-announcement-splash.modal.idea.item":[{"type":0,"value":"Put an idea on a whiteboard, let Rovo diagram it"}],"confluence-create-with-rovo-announcement-splash.modal.primary-button":[{"type":0,"value":"Try Create with Rovo"}],"post-office.confluence-create-with-rovo-side-nav-nudge.body":[{"type":0,"value":"With a simple prompt, Rovo can draft a page or whiteboard."}],"post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action":[{"type":0,"value":"Show me how"}],"post-office.confluence-create-with-rovo-side-nav-nudge.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-create-with-rovo-side-nav-nudge.heading":[{"type":0,"value":"You describe, Rovo creates"}]}');

});

parcelRegister("44VVw", function(module, exports) {

let $2f8478323d4c13d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f8478323d4c13d9$var$load("i9sd0").then(()=>parcelRequire('cNaUs'));

});

parcelRegister("lj8VP", function(module, exports) {

let $f8324cf91eef6216$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8324cf91eef6216$var$load("aNg21").then(()=>parcelRequire('5PagH'));

});

parcelRegister("7b5JG", function(module, exports) {

let $539e027f2ee89c1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $539e027f2ee89c1e$var$load("YEGhv").then(()=>parcelRequire('5poWa'));

});

parcelRegister("fkiO8", function(module, exports) {

let $b287500f9315e7e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b287500f9315e7e7$var$load("d8WL7").then(()=>parcelRequire('bIxfG'));

});

parcelRegister("ctn5G", function(module, exports) {

let $914a1ac5f73c88a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $914a1ac5f73c88a0$var$load("g9jRX").then(()=>parcelRequire('3HEHB'));

});

parcelRegister("lEFIu", function(module, exports) {

let $fc3db16eda3725af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc3db16eda3725af$var$load("120fV").then(()=>parcelRequire('5CGAS'));

});

parcelRegister("6Vy8L", function(module, exports) {

let $50b28c8918e987db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50b28c8918e987db$var$load("ekyg6").then(()=>parcelRequire('aqygr'));

});

parcelRegister("i9SUy", function(module, exports) {

let $d383a97e5a50810d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d383a97e5a50810d$var$load("j5F5K").then(()=>parcelRequire('3QoEw'));

});

parcelRegister("3D2oa", function(module, exports) {

let $2a46de015d91a00b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a46de015d91a00b$var$load("dXu4x").then(()=>parcelRequire('9e0h0'));

});

parcelRegister("aBfSC", function(module, exports) {

let $7b79ad85a00e11a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b79ad85a00e11a4$var$load("34YSq").then(()=>parcelRequire('gQOAT'));

});

parcelRegister("aXfLu", function(module, exports) {

let $7f9ba4ae6111fc3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f9ba4ae6111fc3f$var$load("18TX5").then(()=>parcelRequire('fhOxf'));

});

parcelRegister("hHbpn", function(module, exports) {

let $ce1f4d45b003d767$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce1f4d45b003d767$var$load("9Cdzw").then(()=>parcelRequire('hev8y'));

});

parcelRegister("3FQml", function(module, exports) {

let $2acdd0e8bc9a2ee8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2acdd0e8bc9a2ee8$var$load("gfsfz").then(()=>parcelRequire('3ZaVC'));

});

parcelRegister("epMeh", function(module, exports) {

let $a7e8cfd1cddae748$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7e8cfd1cddae748$var$load("guNAg").then(()=>parcelRequire('7Scqn'));

});

parcelRegister("M4CYG", function(module, exports) {

let $090812c4edc10c79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $090812c4edc10c79$var$load("cM3gY").then(()=>parcelRequire('fvvbN'));

});

parcelRegister("ax0T5", function(module, exports) {

let $7aadacaa18fff6dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7aadacaa18fff6dc$var$load("6yRq3").then(()=>parcelRequire('gXjXB'));

});

parcelRegister("h19CY", function(module, exports) {

let $c639ff86e9f73b05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c639ff86e9f73b05$var$load("cft22").then(()=>parcelRequire('8s2Tz'));

});

parcelRegister("jd0kM", function(module, exports) {

let $dfbf7d95e8ee8e7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dfbf7d95e8ee8e7c$var$load("gctEz").then(()=>parcelRequire('dLsgU'));

});

parcelRegister("cP3TX", function(module, exports) {

let $955d46369d6a6694$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $955d46369d6a6694$var$load("9PPH7").then(()=>parcelRequire('3OurB'));

});

parcelRegister("kkbnw", function(module, exports) {

let $ecbe806929203a1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ecbe806929203a1c$var$load("1y1eN").then(()=>parcelRequire('k5E3d'));

});

parcelRegister("jwK8C", function(module, exports) {

let $e374cb874d83eee2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e374cb874d83eee2$var$load("e8jpx").then(()=>parcelRequire('2wn0H'));

});

parcelRegister("h63LY", function(module, exports) {

let $c725ec6a0d7788ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c725ec6a0d7788ad$var$load("6tWAg").then(()=>parcelRequire('81BX8'));

});

parcelRegister("bZxBV", function(module, exports) {

let $8baf769f66212337$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8baf769f66212337$var$load("fjbzp").then(()=>parcelRequire('krc3E'));

});

parcelRegister("8dMdU", function(module, exports) {

let $5fc4f1ca32e0944c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fc4f1ca32e0944c$var$load("kTsGE").then(()=>parcelRequire('dwA0d'));

});

parcelRegister("bb8gm", function(module, exports) {

let $8237219b8db303ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8237219b8db303ed$var$load("8JuRr").then(()=>parcelRequire('ild7S'));

});

parcelRegister("gEoeD", function(module, exports) {

let $c1f32e5da3fa24eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1f32e5da3fa24eb$var$load("aiOLS").then(()=>parcelRequire('g2xHn'));

});

parcelRegister("ax3oZ", function(module, exports) {

let $7aafa00a85ba7dfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7aafa00a85ba7dfe$var$load("eleM6").then(()=>parcelRequire('eO2lu'));

});

parcelRegister("6qkex", function(module, exports) {

let $4ad4ddbde676a0ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ad4ddbde676a0ad$var$load("1pFHs").then(()=>parcelRequire('l7tGE'));

});

parcelRegister("cnFuw", function(module, exports) {

let $9037d15592e9cad6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9037d15592e9cad6$var$load("jEuPM").then(()=>parcelRequire('bbnmk'));

});

parcelRegister("32434", function(module, exports) {

let $2354b2ee7aa9e8b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2354b2ee7aa9e8b2$var$load("d0Fxy").then(()=>parcelRequire('7WiGm'));

});

parcelRegister("cnPZE", function(module, exports) {

let $903ff6d13dcf8a8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $903ff6d13dcf8a8a$var$load("deThS").then(()=>parcelRequire('d7TUP'));

});

parcelRegister("ceQUP", function(module, exports) {

let $8e8fd6c31a542c28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e8fd6c31a542c28$var$load("a7oQV").then(()=>parcelRequire('jxmii'));

});

parcelRegister("2Ee5k", function(module, exports) {

let $1eda3e30d24fea96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1eda3e30d24fea96$var$load("7sItg").then(()=>parcelRequire('kqsMW'));

});

parcelRegister("lYBDN", function(module, exports) {

let $fffc66453f53c7c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fffc66453f53c7c9$var$load("kKXTS").then(()=>parcelRequire('6pgwb'));

});

parcelRegister("e77Av", function(module, exports) {
module.exports = JSON.parse('{"ccommerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-dispute":[{"type":0,"value":"Action required: ACH Direct debit payment failed"}],"commerce-access-invalid-payment-ccp.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-access-invalid-payment-hams.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch":[{"type":0,"value":"To understand more on why we couldn\'t generate your invoice, please "},{"type":1,"value":"getInTouchLink"},{"type":0,"value":" with us."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch-link":[{"type":0,"value":"get in touch"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.no-invoice-generation":[{"type":0,"value":"We couldn\'t generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") as we don\'t have\\n\\t\\t\\t\\tyour complete billing information. As a result, your subscription has been canceled."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-1":[{"type":0,"value":"Once you\u2019ve updated the billing details, reactivate your subscription by going to "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5":[{"type":0,"value":". If you reactivate your subscription within 60 days of cancellation, your data and preferences will remain the same."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-partner-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.wrong-details":[{"type":0,"value":"It could be because you\u2019ve entered the wrong details, or that the information you\u2019ve provided us is\\n\\t\\t\\t\\tincomplete. Don\'t worry, you can reactivate your subscription after updating your billing information."}],"commerce-credit-account-deactivation-ccp.clear-unpaid-invoices":[{"type":0,"value":"Clear any unpaid invoices associated with your account."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.help-message":[{"type":0,"value":"We understand that managing payments can sometimes be challenging, and we\'re here to help."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.learn-reasons":[{"type":0,"value":"Learn about possible reasons"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.message":[{"type":0,"value":"You can no longer use Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms to place your orders as your billing account\u2019s eligibility has been suspended. "},{"type":1,"value":"learnReason"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.title":[{"type":0,"value":"You\u2019re no longer eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" terms"}],"commerce-credit-account-deactivation-ccp.reach-out":[{"type":0,"value":"Reach out to us so we can review your eligibility."}],"commerce-credit-account-deactivation-ccp.reconsider-eligibility":[{"type":0,"value":"If you\u2019d like us to reconsider your eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms, we suggest you to:"}],"commerce-credit-account-deactivation-ccp.view-unpaid-invoices-link":[{"type":0,"value":"View unpaid invoices"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.couldn\'t-approve-request":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your request because you\u2019ve reached the maximum credit limit that we can offer at this time. You can check back in a few months to see if your eligibility has changed."}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Unable to offer a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.rejected.title":[{"type":0,"value":"We\u2019re unable to offer you a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.thank-you.submitting":[{"type":0,"value":"Thank you for submitting your application for increasing your Atlassian Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit."}],"commerce-credit-account-limit-increase-request-rejection-ccp.move-forward":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce-credit-account-reactivation-ccp.message-template.good-news.restored.billing.account":[{"type":0,"value":"Good news! We\u2019ve restored your billing account\u2019s eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details:"}],"commerce-credit-account-reactivation-ccp.message-template.restored.title":[{"type":0,"value":"Your eligibility has been restored"}],"commerce-invoice-generated-ccp-g.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp-g.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-terms-payment-pending-ccp.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-updated-ccp-g.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp-g.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-invoice-updated-ccp.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-marketing-multiple-product-upgrade-ccp.subtext":[{"type":0,"value":"Atlassian Administration"}],"commerce-on-account-approval-partner.email.attached-instructions":[{"type":0,"value":"We\'ve attached instructions outlining how to read your statement."}],"commerce-on-account-approval-partner.email.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Pay on account with terms of Net-\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from statement date."}],"commerce-on-account-approval-partner.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-approval-partner.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-approval-partner.email.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce-on-account-approval-partner.email.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the statement date"}],"commerce-on-account-approval-partner.email.statement-info":[{"type":0,"value":"As Pay on account Partner, you will now receive a statement twice a month (on the 1st and 16th) covering\\n\\t\\t\\t\\tinvoices for the periods 16th to last day and 1st to 15th respectively."}],"commerce-on-account-approval-partner.email.subject":[{"type":0,"value":"Your Pay on account request is approved"}],"commerce-on-account-approval-partner.email.title":[{"type":0,"value":"Your Pay on account request has been approved"}],"commerce-on-account-deactivation-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-deactivation-partner-ccp.email.apply-again":[{"type":0,"value":"You may apply again for Pay on account option after 6 months. Don\u2019t worry, you can still place new orders using a credit card. "}],"commerce-on-account-deactivation-partner-ccp.email.contact-us":[{"type":0,"value":"Should you have questions or wish to discuss ways to reactivate your pay on account option, please contact us at "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-deactivation-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-deactivation-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-deactivation-partner-ccp.email.on-account-being-deactivated":[{"type":0,"value":"Your Pay on account option with Atlassian is being deactivated effective immediately, due to overdue balances and failure to meet the agreed payment terms. "}],"commerce-on-account-deactivation-partner-ccp.email.reach-us":[{"type":0,"value":"You can reach out to us if you need further help in placing your order."}],"commerce-on-account-deactivation-partner-ccp.email.subject":[{"type":0,"value":"Pay on account deactivation notice"}],"commerce-on-account-deactivation-partner-ccp.email.title":[{"type":0,"value":"Pay on account is deactivated"}],"commerce-on-account-rejection-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.apply-again":[{"type":0,"value":"You can resubmit your application after 6 months to be considered again.  "}],"commerce-on-account-rejection-partner-ccp.email.contact-us":[{"type":0,"value":"You can still go ahead with your purchase. We suggest using a credit card to pay for your order. If you still need help placing an order contact us at  "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-rejection-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-rejection-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-rejection-partner-ccp.email.on-account-application-rejected":[{"type":0,"value":"Thank you for submitting your application for Pay on account. Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements. "}],"commerce-on-account-rejection-partner-ccp.email.sales-op-support.no-translate":[{"type":0,"value":"sales-ops-support@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.subject":[{"type":0,"value":"Pay on account application rejection notice"}],"commerce-on-account-rejection-partner-ccp.email.title":[{"type":0,"value":"We\u2019re unable to approve your Pay on account request"}],"commerce-payment-failure-ccp.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"FAQ"}],"commerce-payment-failure-hams.email.not-trial.without-cc.add-payment-details":[{"type":0,"value":"We noticed you haven\'t added payment details for "},{"type":1,"value":"allProductListString"},{"type":0,"value":". Add payment details today so your team can keep working without interruption."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.subject":[{"type":1,"value":"subject"}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or alternatively contact your bank.Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for Atlassian Cloud "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-1":[{"type":0,"value":"We\'re unable to process your payment for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":":"}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-2":[{"type":0,"value":"This is due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.not-processed":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"allProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.additional-actions":[{"type":0,"value":"If you\u2019re unable to make payments or you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details.submit":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request":[{"type":0,"value":"For more information about what happens when you\u2019re unsubscribed from Atlassian Access, "},{"type":1,"value":"submitRequestLink"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"see our FAQ"}],"commerce-payment-failure-hams.email.trial.without-cc.2-4.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-1":[{"type":0,"value":"It\u2019s okay, we all get busy! Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but you can still add your payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-1":[{"type":0,"value":"Your Standard plan trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-2":[{"type":0,"value":"But it\u2019s not too late! You can still add payment details and keep the work you\u2019ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested.cancel-subscription":[{"type":0,"value":"cancel your subscription"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-1":[{"type":0,"value":"Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but this could just be the beginning! Add payment details to keep working\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\twith your dream team."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more.support":[{"type":0,"value":"support.atlassian.com"}],"commerce-payment-failure-hams.email.trial.without-cc.org.2-4.expiration":[{"type":0,"value":"It\'s okay, we all get busy! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.org.4more.expiration.expiration":[{"type":0,"value":"It\'s not too late! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdetails and keep the work you\'ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.org.less2.expiration":[{"type":0,"value":"Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but this could just be the beginning. Add payment details to keep working with your dream team"}],"commerce-payment-failure-hams.email.trial.without-cc.without-cc.org.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can unsubscribe at any time within the Manage Subscriptions area\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tof your organization administration."}],"commerce-payment-failure-hams.email.update-payment-details":[{"type":0,"value":"Update Payment Detail"}],"commerce-payment-failure-trials.add-payment":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.add-payment-without-access":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.billing-cycle-label.no-translate":[{"type":0,"value":" | "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.billing-cycle-text-label.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.card-details":[{"type":0,"value":"Card: "},{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"lastFourDigits"}],"commerce-payment-failure-trials.contact-your-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue.\\n                        Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.contact_us":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation. We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access.contact_us_link":[{"type":0,"value":"Contact us"}],"commerce-payment-failure-trials.contact_us_access.data_storage_link":[{"type":0,"value":"Data Storage FAQs"}],"commerce-payment-failure-trials.contact_us_access.downgrade_link":[{"type":0,"value":"downgrade to a free plan"}],"commerce-payment-failure-trials.couldnt-charge-card":[{"type":0,"value":"We\'re reaching out as we couldn\'t charge your card for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.couldnt-charge-paypal":[{"type":0,"value":"We couldn\'t charge your PayPal account for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" because there was a problem with your account settings or the payment method selected from your PayPal wallet."}],"commerce-payment-failure-trials.ent-org-name-with-space-label.no-translate":[{"type":1,"value":"separator"},{"type":0,"value":" "},{"type":1,"value":"entOrgName"},{"type":0,"value":" "}],"commerce-payment-failure-trials.entitlement-number-label.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.entitlement-number-text.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.has_payment_method.add-payment-caption":[{"type":0,"value":"Add payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.caption":[{"type":0,"value":"Action required: Your payment was declined"}],"commerce-payment-failure-trials.has_payment_method.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment, based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.has_company_name.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"companyName"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.no_retries.partners.caption":[{"type":0,"value":"Action required: Update payment details by "},{"type":1,"value":"dueDate"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.payment-declined-title":[{"type":0,"value":"Action required: Payment declined for #"},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access":[{"type":0,"value":"Update your credit card details, or add a different credit card. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual":[{"type":0,"value":"Update your payment details or add a different payment method to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-monthly-subscriptions":[{"type":0,"value":"For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-payment-caption":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.update-paypal":[{"type":0,"value":"Log in to your PayPal account and go to your automatic payment settings. Select a different payment method for your Atlassian payment. You should also check that your account isn\'t restricted and allows international payments."}],"commerce-payment-failure-trials.has_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.invoice-number":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.invoice-number-label":[{"type":0,"value":"Invoice Number:"}],"commerce-payment-failure-trials.invoice_pdf_attachment":[{"type":0,"value":"For your records, the invoice with payment due is attached as a PDF."}],"commerce-payment-failure-trials.item-description-label.no-translate":[{"type":1,"value":"description"}],"commerce-payment-failure-trials.item-description.no-translate":[{"type":0,"value":" "},{"type":1,"value":"description"}],"commerce-payment-failure-trials.log-in-paypal":[{"type":0,"value":"Log in to PayPal"}],"commerce-payment-failure-trials.no_payment_method.partners.add_your_payment_details":[{"type":0,"value":"Add payment details today to avoid interruptions."}],"commerce-payment-failure-trials.no_payment_method.partners.caption":[{"type":0,"value":"Add payment details to avoid interruptions"}],"commerce-payment-failure-trials.no_payment_method.partners.title.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.partners.title.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.title":[{"type":0,"value":"Action required: Add your payment details"}],"commerce-payment-failure-trials.no_payment_method.unable_to_process_your_payment":[{"type":0,"value":"We were unable to process your payment since we haven\'t received your payment details for your subscription."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process your payment for Atlassian products as you haven\'t provided us with payment details yet."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process-access":[{"type":0,"value":"We\'re reaching out as we couldn\'t process your recent payment for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" due to an issue with your account\'s payment details."}],"commerce-payment-failure-trials.payment":[{"type":0,"value":"This payment was for:"}],"commerce-payment-failure-trials.paypal-details":[{"type":0,"value":"PayPal account: "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.sold-to-details.address":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"address"}],"commerce-payment-failure-trials.sold-to-details.address-message":[{"type":0,"value":"Address:"}],"commerce-payment-failure-trials.sold-to-details.company":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"companyName"}],"commerce-payment-failure-trials.sold-to-details.company-label":[{"type":0,"value":"Company:"}],"commerce-payment-failure-trials.sold-to-details.customer-contact":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"customerContact"}],"commerce-payment-failure-trials.sold-to-details.customer-contact-label":[{"type":0,"value":"Customer contact:"}],"commerce-payment-failure-trials.total-bill":[{"type":0,"value":"Your total bill is "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce-payment-failure-trials.update-credit-card":[{"type":0,"value":"Update your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-without-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.we_will_try_to_process_again":[{"type":0,"value":"We\u2019ll try to process your payment again on "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-payment-failure-trials.what-to-do":[{"type":0,"value":"What you need to do:"}],"commerce-payment-failure-trials.without-payment-faq-product-access-lost":[{"type":0,"value":"Without this payment, product access will be lost, and product data will be permanently deleted soon after. See our "},{"type":1,"value":"element"}],"commerce-permission-request-add-payment-ccp.email.add-payment-request-text":[{"type":0,"value":"There is an add payment request from "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") for the subscription: "}],"commerce-permission-request-add-payment-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce-permission-request-add-payment-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce-permission-request-add-payment-ccp.email.personal-note.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"commerce-permission-request-add-payment-ccp.email.subtext-for-personal-note":[{"type":0,"value":"To help you with more details, here\u2019s a note from the requester: "}],"commerce-permission-request-add-payment-ccp.email.title":[{"type":0,"value":"Request from "},{"type":1,"value":"name"},{"type":0,"value":" to add payment details"}],"commerce-permission-request-add-payment-ccp.email.whats-next-subtext":[{"type":0,"value":"If you approve the request, continue with adding payment details for the subscription and we\u2019ll notify the requester. Ignore this email to deny. "}],"commerce-permission-request-add-payment-response-ccp.email.add-payment-request-text":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"commerce-permission-request-add-payment-response-ccp.email.benefits-text":[{"type":0,"value":"You can now enjoy the benefits of:"}],"commerce-permission-request-add-payment-response-ccp.email.go-to-site":[{"type":0,"value":"Go to site"}],"commerce-permission-request-add-payment-response-ccp.email.title":[{"type":0,"value":"Your request is complete"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-count":[{"type":0,"value":"Units: "},{"type":1,"value":"count"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-entitlement-number":[{"type":1,"value":"entitlementNumber"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.free-entitlement.no-action":[{"type":0,"value":"You don\u2019t need to do anything, and your monthly Statuspage payments will remain the same."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.merged-addon":[{"type":0,"value":"Over the next few days, we\u2019ll simplify things for you by merging these "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on subscriptions into one:"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.multiple-addons":[{"type":0,"value":"We noticed your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" for "},{"type":1,"value":"site"},{"type":0,"value":" has more than one "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on: "}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.merged-add-on":[{"type":0,"value":"You\u2019ll only see one Subscribers add-on listed on your next invoice."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-change":[{"type":0,"value":"There\u2019s no change to what you\u2019ll pay each month."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-setup":[{"type":0,"value":"You won\u2019t need to set up or configure anything."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.title":[{"type":0,"value":"We\u2019re merging your "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-ons for Statuspage"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.what-this-means":[{"type":0,"value":"What this means for you"}],"commerce-pre-dunning-ccp.email.paid-entitlement.add-payment-text.retryThree":[{"type":0,"value":"You can prevent being deactivated by reducing your user count, purchasing a paid plan, or "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce-pre-dunning-ccp.email.paid-entitlement.add-payment.retryOne":[{"type":0,"value":"You\u2019ll be downgraded to the Free plan if you haven\u2019t added payment details and you have fewer than 10 users."}],"commerce-pre-dunning-ccp.email.paid-entitlement.add-payment.retryThree":[{"type":0,"value":"You\u2019ll be downgraded to the Free plan if you haven\u2019t added payment details and you have fewer than 10 users. Otherwise, your site will be deactivated. "}],"commerce-pre-dunning-ccp.email.paid-entitlement.curr-plan":[{"type":0,"value":"To choose a different plan, "}],"commerce-pre-dunning-ccp.email.pick-a-plan.retryOne":[{"type":0,"value":"Add your payment details to keep your team\u2019s progress going with the advanced features they need."}],"commerce-pre-dunning-ccp.email.pick-a-plan.retryTwo":[{"type":0,"value":"To keep access to advanced "},{"type":1,"value":"productName"},{"type":0,"value":" features, you now have until "},{"type":1,"value":"gracePeriodEndDate"},{"type":0,"value":" to add your payment details and keep your team going with the Premium plan."}],"commerce-pre-dunning-ccp.email.title.retryOne":[{"type":0,"value":"Last day to make a choice"}],"commerce-pre-dunning-ccp.email.title.retryThree":[{"type":0,"value":"This doesn\u2019t have to be goodbye"}],"commerce-pre-dunning-ccp.email.title.retryTwo":[{"type":0,"value":"We\'ve given you more time to choose"}],"commerce-pre-dunning-ccp.email.trial-ended.retryOne":[{"type":1,"value":"firstName"},{"type":0,"value":", that\'s a wrap\u2014your "},{"type":1,"value":"productName"},{"type":0,"value":" trial "},{"children":[{"type":0,"value":"has ended."}],"type":8,"value":"strong"}],"commerce-pre-dunning-ccp.email.trial-ended.retryThree":[{"type":1,"value":"firstName"},{"type":0,"value":", this is your "},{"children":[{"type":0,"value":"last chance"}],"type":8,"value":"strong"},{"type":0,"value":" to keep the "},{"type":1,"value":"productName"},{"type":0,"value":" Premium plan, and keep your team going with advanced "},{"type":1,"value":"productName"},{"type":0,"value":" features."}],"commerce-pre-dunning-ccp.email.trial-ended.retryTwo":[{"type":1,"value":"firstName"},{"type":0,"value":", it\'s OK we all get busy."}],"commerce-reactivation-order-to-paid-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-cancellation-ecc.email.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" canceled"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-reactivation-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-reactivation-trial-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce-subscription-skip-trial-ccp.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.estimated-bill":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excluding tax)"},{"type":1,"value":"content"}],"commerce-subscription-skip-trial-ccp.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" subscription "}],"commerce-subscription-systematic-downgrade-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" subscription "}],"commerce.bill-estimate-common.key":[{"type":0,"value":"Estimated bill:"}],"commerce.bill-estimate-common.value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excludes tax)"}],"commerce.billing-cycle-common.key":[{"type":0,"value":"Billing cycle:"}],"commerce.billing-cycle-common.value":[{"type":1,"value":"billingCycle"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.cancellation-reason":[{"type":0,"value":"It could be because the information provided to us is incorrect or incomplete. Don\'t worry,\\n                            the subscription can be reactivated after you update your billing information."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.reactive-within":[{"type":1,"value":"content"},{"type":0,"value":" If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.subscription-cancellation-message":[{"type":0,"value":"We couldn\'t generate an invoice for the following subscription as we don\'t have your complete billing information.\\n                            As a result, the subscription has been canceled."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription canceled - update billing details"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.subject":[{"type":1,"value":"title"},{"type":0,"value":" canceled"}],"commerce.commerce-credit-account-approval-ccp.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-approval-ccp.message-template.approved.title":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application has been approved"}],"commerce.commerce-credit-account-approval-ccp.message-template.email.subject":[{"type":0,"value":"Approved for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-approval-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details: "}],"commerce.commerce-credit-account-deactivation-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your account is now ineligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-limit-update-ccp.email.list.new-credit-limit":[{"type":0,"value":"New Credit limit: "},{"type":1,"value":"newCreditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-limit-update-ccp.email.possible-reasons":[{"type":0,"value":"Learn about possible reasons."}],"commerce.commerce-credit-account-limit-update-ccp.email.statement-info":[{"type":0,"value":"We\u2019ve decreased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". "},{"type":1,"value":"possibleReasons"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.decrease.title":[{"type":0,"value":"We\u2019ve decreased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.decrease.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been decreased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.increase.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been increased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve increased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". Here are the details: "}],"commerce.commerce-credit-account-limit-update-ccp.message-template.increase.title":[{"type":0,"value":"We\u2019ve increased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-reactivation-ccp.message-template.email.subject":[{"type":0,"value":"Your account is now re-eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.bad-news":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements."}],"commerce.commerce-credit-account-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Couldn\u2019t approve your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application"}],"commerce.commerce-credit-account-rejection-ccp.message-template.other-option":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce.commerce-credit-account-rejection-ccp.message-template.rejection.title":[{"type":0,"value":"We\u2019re unable to approve you for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.thanks":[{"type":0,"value":"Thank you for submitting your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.card-expiry-warning-message":[{"type":0,"value":"Heads up \u2014 your credit card expires in "},{"type":1,"value":"expiryMonthAndYear"},{"type":0,"value":". To make sure your next payment is made on time so you can continue using your subscriptions without interruption, you\u2019ll need to update your payment details before "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action":[{"type":0,"value":"What happens if I don\u2019t update my details?"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action-warning":[{"type":0,"value":"Your next payment attempt will fail \u2013 this means your subscription could be deactivated and you could lose product access and data."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.select":[{"type":0,"value":"Select "}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your credit card expires soon"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.time-to-update-credit-card-details":[{"type":0,"value":"Time to update your credit card details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details":[{"type":0,"value":"Update payment details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details-note":[{"type":0,"value":" below to edit your saved card."}],"commerce.commerce-customer-contact-remove-digest.email.body.removed-contact":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.caption":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.contact-removed":[{"type":0,"value":"Contact removed: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.impacted-subscriptions":[{"type":0,"value":"Impacted subscriptions:"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.intro":[{"type":0,"value":"We\'ve removed a key customer contact from a billing profile."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.questions":[{"type":0,"value":"If you have any questions, please reach out to your Atlassian billing partner."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.removed-by":[{"type":0,"value":"Removed by: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes":[{"type":0,"value":"You can view the changes at "},{"type":1,"value":"url"},{"type":0,"value":" page."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes-link":[{"type":0,"value":"partner managed subscriptions"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" subscriptions."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.subject":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customers-deactivation-eve.email.body-p1":[{"type":0,"value":"U.S. law prohibits Atlassian, an Australian corporation with offices in the United States, from providing you with access to our products and services. After analyzing the applicable lists of restricted parties maintained by the U.S. Government, we were unable to confirm that your name was not affiliated with a restricted party."}],"commerce.commerce-customers-deactivation-eve.email.body-p2":[{"type":0,"value":"If this is a case of misidentification, please reply with two different copies of official documentation to verify your identity."}],"commerce.commerce-customers-deactivation-eve.email.body-p3":[{"type":0,"value":"Official documentation includes, but is not limited to, a government-issued driver\'s license or identification card, passport, utility bill, mortgage or bank statement, etc. Please make sure your full name and address are clearly visible."}],"commerce.commerce-customers-deactivation-eve.email.body-p4":[{"type":0,"value":"You may check out these resources for more information: U.S. export controls ("},{"type":1,"value":"exportControl"},{"type":0,"value":") | Consolidated Screening List ("},{"type":1,"value":"csl"},{"type":0,"value":")"}],"commerce.commerce-customers-deactivation-eve.email.body-p5":[{"type":0,"value":"Please reply directly via email with any further questions and the identification requested."}],"commerce.commerce-customers-deactivation-eve.email.body-p6":[{"type":0,"value":"We look forward to your reply."}],"commerce.commerce-customers-deactivation-eve.email.body.csl":[{"type":0,"value":"https://www.trade.gov/consolidated-screening-list"}],"commerce.commerce-customers-deactivation-eve.email.body.exportControl":[{"type":0,"value":"https://www.trade.gov/us-export-controls"}],"commerce.commerce-customers-deactivation-eve.email.caption":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-customers-deactivation-eve.email.salutation":[{"type":0,"value":"Dear Atlassian user,"}],"commerce.commerce-customers-deactivation-eve.email.subject":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.custom":[{"type":1,"value":"greetingText"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.default":[{"type":0,"value":"Dear "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-dynamic-content-test-cns.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"message"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-generated-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"businessKey"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-generated-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.offer-message":[{"type":0,"value":"When you use the two together, you can centralize your docs, connect work across teams and more. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-congratulations-message":[{"type":0,"value":"Did you know that "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Confluence?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-product-caption":[{"type":0,"value":"Build a single source of truth for all your team\u2019s important info"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.cta.try-now":[{"type":0,"value":"Try now"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.offer-message":[{"type":0,"value":"Together, the products help you capture ideas and prioritize work, so you\u2019re always organized. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-congratulations-message":[{"type":0,"value":"Did you know "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Jira Product Discovery?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-product-caption":[{"type":0,"value":"Say goodbye to messy backlogs"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.offer-message":[{"type":0,"value":"With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-congratulations-message":[{"type":0,"value":"People who use Jira Service Management say that work is more visible for all teams involved, from request to resolution."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-product-caption":[{"type":0,"value":"Bring developers, IT, and operations onto the same platform"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.offer-message":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-congratulations-message":[{"type":0,"value":"Jira and "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" can help you visualize and deliver work, fast."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-product-caption":[{"type":0,"value":"Break down silos and connect the dots between teams"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-congratulations-message":[{"type":0,"value":"Congrats on purchasing "},{"type":1,"value":"purchasedProductTitle"},{"type":0,"value":"! Get free trials of these products and unlock these advanced features:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-product-caption":[{"type":0,"value":"Get free trials of "},{"type":1,"value":"productName1"},{"type":0,"value":" & "},{"type":1,"value":"productName2"},{"type":0,"value":" Standard with your "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" purchase"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.trial-length-message":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement-with-trial-length.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.single-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-space-permissions":[{"type":0,"value":"Advanced user & space permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.higher-automation-limit":[{"type":0,"value":"Higher automation limit"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.insights-into-page-views":[{"type":0,"value":"Get insights into page views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.on-call-management":[{"type":0,"value":"On-call management"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.published-views":[{"type":0,"value":"Published views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.trial-length":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents":[{"type":0,"value":"Unlimited agents"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents-storage":[{"type":0,"value":"Unlocked agent & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creator-storage":[{"type":0,"value":"Unlocked creator & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-user-storage":[{"type":0,"value":"Unlocked user & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-users":[{"type":0,"value":"Unlimited users"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-archive.alt-text":[{"type":0,"value":"Icon - Archive"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-graph.alt-text":[{"type":0,"value":"Icon - Graph"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-lightning.alt-text":[{"type":0,"value":"Icon - Lightning"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-link.alt-text":[{"type":0,"value":"Icon - Link"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-people.alt-text":[{"type":0,"value":"Icon - People"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-phone.alt-text":[{"type":0,"value":"Icon - Phone"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-unlock.alt-text":[{"type":0,"value":"Icon - Unlock"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.billing":[{"type":1,"value":"billingUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.faq":[{"type":0,"value":"FAQs"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.migrate":[{"type":0,"value":"You have been successfully migrated from Jira Work Management to Jira, within "},{"type":1,"value":"site"},{"type":0,"value":"."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.options":[{"type":0,"value":"To view pricing, auto-renewal, and cancellation options, go to "},{"type":1,"value":"billing"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.site":[{"type":1,"value":"siteUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.subsciption":[{"type":0,"value":"The current price of your subscription has not changed. However, pricing may vary if changes are made to your user tier, plan, and/or licensing. See "},{"type":1,"value":"faq"},{"type":0,"value":" for more details."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.caption":[{"type":0,"value":"You\u2019ve been successfully migrated to Jira"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.subject":[{"type":0,"value":"Your migration was successful"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.encryption-policy-info":[{"type":0,"value":"CMK policy enrollment is required for activation. "},{"type":1,"value":"supportInfo"},{"type":0,"value":" to self-enroll before provisioning Atlassian app instances. For step-by-step instructions, refer to the support "},{"type":1,"value":"CMKSupportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.manage-subscription":[{"type":0,"value":"Please click \u2018Manage Subscription\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.partner-managed-subscription":[{"type":0,"value":"Please visit your partner-managed subscriptions page"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.view-subscription":[{"type":0,"value":"Please click \u2018View all Subscriptions\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration. You can view a detailed breakdown of your team\u2019s usage in your billing account."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.cbp-details":[{"type":0,"value":"Your plan includes:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"You can visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":" to learn more about how billing works."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"We\u2019ll send the final invoice within 24 hours, which will include all the details and payment options for your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" details from your "},{"type":1,"value":"hostingDetails"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.non-cloud.billing-info":[{"type":0,"value":"Go to your billing account to set up your new subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated-with-date.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription from its start date"}]},"other":{"value":[{"type":0,"value":"subscriptions from their start dates"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-reseller":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.give-admin-permission":[{"type":0,"value":"Setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian billing partner. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian reseller. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-reseller":[{"type":0,"value":"You can view or cancel your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time by going to "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" and following the steps."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"the subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.setup-your-site":[{"type":0,"value":"Get started straight away by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":":"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-url":[{"children":[{"type":1,"value":"siteURL"}],"type":8,"value":"a"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.ecc-reseller-managed-subscription.url":[{"type":0,"value":"your Subscription overview"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body-ecc.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.subject":[{"type":1,"value":"billToPartyName"},{"type":0,"value":": Atlassian product order confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.auto_prov_notification":[{"type":0,"value":"The products will be added to your customer\u2019s account shortly."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.cbp-details":[{"type":0,"value":"The plan also includes the following:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.customer_contact_info":[{"type":0,"value":"Your customer contact can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.get-started":[{"type":0,"value":"You can get started straight away by setting up the subscriptions. We\u2019ve also sent a notification to your customer with a setup link to get started. "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from our "},{"type":1,"value":"ppcHomePage"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_invoice_info":[{"type":0,"value":"We\u2019ll email the invoice with all the details within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_notification":[{"type":0,"value":"We\u2019ll also send a notification to your customer with a link to set up their new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and get started."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-details":[{"type":0,"value":"We\u2019ll send you an invoice with all the details within 24 hours. We\u2019ll also send an email to your customer with a link to set up and get started with their new subscription. You can get started straight away by setting up the subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order, and the products will be ready to use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\'ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscriptions from their start dates. We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.with.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscription/s on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"For more information on how to manage your subscriptions and billing, visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"Expect the final invoice within 24 hours, which will include all the necessary details and payment options for your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your cloud site for your new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your Atlassian order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-date.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-manage-subscriptions":[{"type":0,"value":"You can view the subscription from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.next_steps":[{"type":0,"value":"Get started by setting up your customer\u2019s cloud site for the new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.ppc_homepage":[{"type":0,"value":" You can also view and manage the subscription details from our Partner Purchasing Center. "},{"type":1,"value":"viewQuoteUrl"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.processing":[{"type":0,"value":"We\u2019re processing the payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-date.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.subject":[{"type":0,"value":"We\u2019ve received your order for "},{"type":1,"value":"customerCompanyName"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message-template.email.subject":[{"type":0,"value":"This template has been deprecated"}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message.email.body.no-translate":[{"type":0,"value":"This template has been deprecated as it has been merged along with \'commerce-quote-order-fulfilled-ccp\' template with dynamic content added to differentiate between pull/push payment method."}],"commerce.commerce-partner-cancellation-personal-data-deletion-link":[{"type":0,"value":"personal data deletion request form"}],"commerce.commerce-partner-personal-data-deletion":[{"type":0,"value":"If your customer would like to place a request for immediate deletion of personal data after cancellation, they can submit a "},{"type":1,"value":"formLink"},{"type":0,"value":". Otherwise, the data will be deleted in accordance with Atlassian\u2019s standard "},{"type":1,"value":"policyLink"},{"type":0,"value":"."}],"commerce.commerce-payment-method-manage-ccp.account-ending-key":[{"type":0,"value":"Account ending: "}],"commerce.commerce-payment-method-manage-ccp.account-ending-value":[{"type":1,"value":"last4"}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-key":[{"type":0,"value":"Account holder name: "}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-value":[{"type":1,"value":"accountHolder"}],"commerce.commerce-payment-method-manage-ccp.authorization-date-key":[{"type":0,"value":"Authorization date: "}],"commerce.commerce-payment-method-manage-ccp.authorization-date-value":[{"type":1,"value":"authorizationDate"}],"commerce.commerce-payment-method-manage-ccp.authorization-details":[{"type":0,"value":"Authorization details"}],"commerce.commerce-payment-method-manage-ccp.bank-name-key":[{"type":0,"value":"Bank name: "}],"commerce.commerce-payment-method-manage-ccp.bank-name-value":[{"type":1,"value":"bankName"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-authorization":[{"type":0,"value":"Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-dispute":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce.commerce-payment-method-manage-ccp.could-not-process-payment":[{"type":0,"value":"We couldn\'t process your recent payment due to a dispute raised with your bank."}],"commerce.commerce-payment-method-manage-ccp.direct-debit-legal-terms":[{"type":0,"value":"You have authorized Atlassian to debit the bank account specified above for any amount owed for charges arising from your use of Atlassian\u2019 services and/or purchase of products from Atlassian, pursuant to Atlassian\u2019 website and terms, until this authorization is revoked. You have authorized Atlassian to debit your bank account periodically if and when you use Atlassian\u2019 services or purchase more than one of Atlassian\u2019 products periodically pursuant to Atlassian terms. Payments that fall outside the regular debits authorized above will only be debited after your authorization is obtained."}],"commerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-mandate":[{"type":0,"value":"Confirmation: Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.how-to-cancel-direct-debit":[{"type":0,"value":"You can cancel this direct debit at any time by deleting the linked bank account from your "},{"type":1,"value":"paymentMethods"},{"type":0,"value":" page"}],"commerce.commerce-payment-method-manage-ccp.payment-methods":[{"type":0,"value":"Payment methods"}],"commerce.commerce-payment-method-manage-ccp.received-authorization":[{"type":0,"value":"We\u2019ve received your authorization for direct debit."}],"commerce.commerce-payment-method-manage-ccp.routing-number-key":[{"type":0,"value":"Routing number: "}],"commerce.commerce-payment-method-manage-ccp.routing-number-value":[{"type":1,"value":"routingNumber"}],"commerce.commerce-payment-method-manage-ccp.update-bank-details":[{"type":0,"value":"Update your bank account details, or link a different bank account. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce.commerce-permission-request-add-payment-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: You have an add payment request"}],"commerce.commerce-permission-request-add-payment-response-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Request complete: Payment details added by billing admin "}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.cta.accept-billing-admin-request":[{"type":0,"value":"Review billing admin request"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.ba-request-text":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") is requesting billing admin permission for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.personal-note.no-translate":[{"type":1,"value":"customMessage"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.subtext-for-personal-note":[{"type":0,"value":"The request was sent with the following note: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.title":[{"type":1,"value":"name"},{"type":0,"value":" is requesting billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.what-they-can-do":[{"type":0,"value":"If you approve, they\'ll be able to:"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.whats-next-subtext":[{"type":0,"value":"If you accept the request, we\'ll notify the requester. If you don\'t want to grant billing admin access, you can decline the request."}],"commerce.commerce-permission-request-grant-ba-role-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: "},{"type":1,"value":"requesterName"},{"type":0,"value":" is requesting Billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.cta.manageSubscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails-for-changes":[{"type":0,"value":"Receive emails about any changes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.request-billing-admin":[{"type":0,"value":"Request billing admins to make changes to subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-site":[{"type":0,"value":"View, upgrade, downgrade and cancel subscriptions in your site"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-approved-text":[{"type":0,"value":"Great news - your billing admin request has been approved for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-declined-text":[{"type":0,"value":"Your request to become a billing admin on the following account has been declined."}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-approved":[{"type":0,"value":"You\'re now a billing admin"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get":[{"type":0,"value":"You\'ll now be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get-without-access":[{"type":0,"value":"You\'ll still be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.approved":[{"type":0,"value":"Your billing admin request has been approved"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-pre-comms-sp-add-on-merge-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Important information about your Statuspage add-ons"}],"commerce.commerce-pre-dunning-ccp.message-template.email.subject.first-reminder":[{"type":0,"value":"Your trial ends today! Keep your "},{"type":1,"value":"productName"},{"type":0,"value":" plan"}],"commerce.commerce-pre-dunning-ccp.message-template.email.subject.second-reminder":[{"type":0,"value":"You\u2019ve got extra time to keep your plan"}],"commerce.commerce-pre-dunning-ccp.message-template.email.subject.third-reminder":[{"type":0,"value":"Last chance to keep your plan!"}],"commerce.commerce-quote-expired-ccp.email.caption":[{"type":0,"value":"Your quote has expired"}],"commerce.commerce-quote-expired-ccp.email.contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-quote-expired-ccp.email.ready-to-order":[{"type":0,"value":"If you\u2019d like to try Atlassian products, opt for a free trial."}],"commerce.commerce-quote-expired-ccp.email.reminder-before-expiry":[{"type":0,"value":"Your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired. You\u2019ll no longer be able to pay for it."}],"commerce.commerce-quote-expired-ccp.email.view-quote":[{"type":0,"value":"You can always create a new quote by reaching out to us."}],"commerce.commerce-quote-expired-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"It\u2019s time to renew your subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.request-quote-to-avoid-losing-access":[{"type":0,"value":"To avoid losing access to your products, request a quote that is valid until the end of your billing cycle. When you are ready to pay, simply review the quote and place your order. "}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.list-subscriptions":[{"type":0,"value":"Subscriptions list:"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.caption":[{"type":0,"value":"It\u2019s time to renew"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.reach-out-to-create-quote":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.request-quote-to-avoid-customer-losing-access":[{"type":0,"value":"To avoid losing access to the products, request a quote valid until the end of your billing cycle. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring":[{"type":0,"value":"Just a heads up that you have subscriptions that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring-for-customer-company":[{"type":0,"value":"Just a heads up that you have subscriptions for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-open-auto-fix-estimate.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.caption":[{"type":0,"value":"It\u2019s time to renew "}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.get-in-touch":[{"type":0,"value":"Get in touch with your Atlassian Billing Partner to get started on your renewal. They\u2019ll be able to help you with your quote and any next steps."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.let-you-know":[{"type":0,"value":"We hope you\u2019ve been enjoying your Atlassian products. We wanted to let you know that your subscription/s expire soon, so it\u2019s time to renew."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-quote-open-auto-renewal-ccp.message-template.email.ecc.subject":[{"type":0,"value":"Contact your Atlassian Billing Partner to renew "}],"commerce.commerce-quote-open-ccp.email.contract-type-non-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, contact your customer advocate."}],"commerce.commerce-quote-open-ccp.email.contract-type-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, go to the quote in your billing account and proceed to create an order."}],"commerce.commerce-quote-open-ccp.email.direct-customer-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":1,"value":"billingUrlText"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open-reminder":[{"type":0,"value":"Keep in mind, if you have product trials in the quote, we recommend placing your order before the trial ends. If you need more time, "},{"children":[{"type":0,"value":"reach out to us"}],"type":8,"value":"RawLink"},{"type":0,"value":" to extend your quote validity."}],"commerce.commerce-quote-open-ccp.email.manage-subscription":[{"type":0,"value":"You can view subscription and billing details on your "},{"children":[{"type":0,"value":"Manage Subscriptions"}],"type":8,"value":"RawLink"},{"type":0,"value":" page."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open":[{"type":0,"value":"Good news \u2013 the quote you requested is now ready:"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open-details":[{"type":0,"value":"The quote will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details, select \u2018View quote\u2019 and download the PDF."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.email.partner-ppc-homepage":[{"type":0,"value":"You can also view quotes and manage these subscriptions from our Partner Purchasing Center. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is here!"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.partner-or-reseller":[{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is ready"}],"commerce.commerce-quote-reminder-expiry-ccp.email.administration":[{"type":0,"value":"Administration"}],"commerce.commerce-quote-reminder-expiry-ccp.email.caption":[{"type":0,"value":"Your quote will expire soon"}],"commerce.commerce-quote-reminder-expiry-ccp.email.order-in-bac":[{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":" and create an order."}],"commerce.commerce-quote-reminder-expiry-ccp.email.ready-to-order":[{"type":0,"value":"When you\u2019re ready to convert your quote to an order, go to your site\'s "}],"commerce.commerce-quote-reminder-expiry-ccp.email.reminder-before-expiry":[{"type":0,"value":"This is a friendly reminder that your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire on "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". Once expired, the quote will be canceled and you have to create a new one."}],"commerce.commerce-quote-reminder-expiry-ccp.email.view-quote":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-reminder-expiry-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire soon"}],"commerce.commerce-quote-stale-ccp.email.body":[{"type":0,"value":"Just a heads up that your quote for "},{"type":1,"value":"companyName"},{"type":0,"value":" needs to be updated before it can be moved back to OPEN."}],"commerce.commerce-quote-stale-ccp.email.caption":[{"type":0,"value":"Your quote needs to be reviewed"}],"commerce.commerce-quote-stale-ccp.email.update-line-item":[{"type":0,"value":"Head to the effected line item/s on the quote and follow the prompts from the error to update it. If that doesn\'t work, you\'ll need to raise a GSAC ticket so that an Atlassian Customer Advocate can look into it."}],"commerce.commerce-quote-stale-ccp.message-template.email.subject":[{"type":0,"value":"Action required: "},{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" needs review"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.caption":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been successfully reactivated"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.we-will-charge":[{"type":0,"value":"We\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entNumber"},{"type":0,"value":")"}],"commerce.commerce-reactivation-order-to-paid-ccp.personal-information":[{"type":0,"value":"Since you reactivated your subscription within 60 days of cancellation, your data and preferences\\n                    are as you left them. You can jump right in and get started!"}],"commerce.commerce-refund-internal-ccp.message-template.email.adc-refund.body":[{"type":0,"value":"Advocate Central REFUND LINK - "},{"type":1,"value":"advocateCentralUrl"},{"type":0,"value":"/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-bank-transfer.subject":[{"type":0,"value":"Bank Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-onAccount.subject":[{"type":0,"value":"Expert Account Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund.body":[{"type":0,"value":"CASSI REFUND LINK - "},{"type":1,"value":"cassiUrl"},{"type":0,"value":"/ui/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-rde-caption":[{"type":0,"value":"Upgrade to Rovo Dev Standard to get more Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"Rovo Dev credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-monitor":[{"type":0,"value":"You can monitor usage in your billing account to see which users have used their allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-ugrade-to-standard":[{"type":0,"value":"To increase Rovo Dev credits and allow extra usage, organization admins can upgrade to Rovo Dev Standard."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-user-cannot-use-extra":[{"type":0,"value":"Users who are at their credit limit won\'t be able to use any Rovo Dev features until the next billing cycle."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done anytime in Atlassian Administration to keep costs predictable. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-extra-usage-charges":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trialsneed-to-know-list-function-disabled":[{"type":0,"value":"Rovo Dev functionality is disabled for users who reach their allowance, and usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done at any time in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-will-be-disabled":[{"type":0,"value":"Once users use up their Rovo Dev credits, Rovo Dev functionality will be disabled until usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-rde-info-message":[{"type":0,"value":"At least one of your users has used up their free Rovo Dev credit allowance in Jira."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-ship-to-party-archival-ccp.body.initimation":[{"type":0,"value":"Please note that this sold-to address is no longer available for billing."}],"commerce.commerce-ship-to-party-archival-ccp.body.partner.p3":[{"type":0,"value":"To view the changes, head to "},{"type":1,"value":"ppcHomePageLink"},{"type":0,"value":"."}],"commerce.commerce-ship-to-party-archival-ccp.email.body.disclaimer":[{"type":0,"value":"We\'ve deactivated the below sold-to address:"}],"commerce.commerce-ship-to-party-archival-ccp.message-template.email.subject":[{"type":1,"value":"name"},{"type":0,"value":" Sold to address deactivated"}],"commerce.commerce-soft-limit-breach-ccp.email.automatic-upgrade":[{"type":0,"value":"Automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.email.manage-users":[{"type":0,"value":"Manage "},{"type":1,"value":"product"}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade":[{"type":0,"value":"Don\'t want to upgrade? "}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade-text":[{"type":0,"value":"We recommend removing "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users before your upgrade date. You can do this by selecting Manage users in your "},{"type":1,"value":"product"},{"type":0,"value":" subscription"}],"commerce.commerce-soft-limit-breach-ccp.email.note1":[{"type":0,"value":"If no changes are made, you\'ll be upgraded and we\'ll send you an invoice of prorated costs for the remainder of your billing period."}],"commerce.commerce-soft-limit-breach-ccp.email.note2":[{"type":0,"value":"You don\'t need to take any action. We\'ll automatically upgrade your account and the new charges will be applied."}],"commerce.commerce-soft-limit-breach-ccp.email.product-limit-exceeded":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" user limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" has exceeded by "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder":[{"type":0,"value":"In a few days you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder-caption":[{"type":0,"value":"You\u2019re about to be upgraded"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder":[{"type":0,"value":"Soon you\'ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder-caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder":[{"type":0,"value":"In the next week, you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count. "}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder-caption":[{"type":0,"value":"You\u2019ll be upgraded soon"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.final-reminder":[{"type":0,"value":"Last chance: manage users before automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.reminder":[{"type":0,"value":"Action required before automatic upgrade"}],"commerce.commerce-subscription-activation-ccp.message-template.ecc.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.setup-site":[{"type":0,"value":"Setting up the site means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.with-site":[{"type":0,"value":"Your products are ready for use "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.without-site":[{"type":0,"value":"Set up your subscription and get started"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian partner had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.site-info":[{"type":0,"value":"They\'ll be added to your site shortly."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian reseller had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage these subscriptions from our "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.subscriptions-active":[{"type":0,"value":"Great news \u2014 the subscriptions that you ordered for your customer on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are now active and ready to use. We\u2019ve also informed your customer that they can get started."}],"commerce.commerce-subscription-activation-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to your "},{"type":1,"value":"managedSubscriptionUrl"},{"type":0,"value":" page and following the steps."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.partner-managed-subscription.url":[{"type":0,"value":"Subscription overview"}],"commerce.commerce-subscription-activation-ccp.message-template.email.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.ecc":[{"type":0,"value":"It\u2019s time to set up your subscription"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.partner":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": it\u2019s time to set up subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.singular":[{"type":0,"value":"It\'s time to set up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subscriptions-active":[{"type":0,"value":"Great news \u2014 the "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" is"}]},"other":{"value":[{"type":0,"value":"subscriptions that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active."}],"commerce.commerce-subscription-activation-ccp.message-template.email.time-to-get-set-up":[{"type":0,"value":"It\'s time to get set up"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.add-on.cta":[{"type":0,"value":"Increase usage limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.add-on.cta":[{"type":0,"value":"Get quote for higher limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-auto-downgrade-ccp.email.partner.subject.with.company.name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.limted.features.info":[{"type":0,"value":"This way, your customer can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uncollectible":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uninvoiceable":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we don\u2019t have your customer\u2019s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.explore-plans":[{"type":0,"value":"Explore plans"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.how-to-get-back-to-original-plan":[{"type":0,"value":"If you\'d like to get back to your original plan, go to "},{"children":[{"type":0,"value":"Subscriptions"}],"type":8,"value":"b"},{"type":0,"value":" and select "},{"children":[{"type":0,"value":"Manage"}],"type":8,"value":"b"},{"type":0,"value":" for your product. In "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":", select "},{"children":[{"type":0,"value":"Change plan"}],"type":8,"value":"b"},{"type":0,"value":" to upgrade."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.request-deletion-of-personal-data-link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"). As a result, we\'ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"You may also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption-v2":[{"type":1,"value":"firstName"},{"type":0,"value":", you\u2019re now on the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" subscription downgraded to a Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject-v2":[{"type":0,"value":"We\u2019ve switched you to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.summary-v2":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":", as of today, you\'ve been switched to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.upgrade-your-subscription":[{"type":0,"value":"You can also choose to upgrade to go back to your original plan."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.go-back-original-plan":[{"type":0,"value":"Want to go back on the original plan?"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.review-and-manage-subscription":[{"type":0,"value":"Review the customer\u2019s billing details from our Partner Purchasing Center and change the subscription."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for this subscription. As a result, we\'ve moved the subscription to the Free plan. This way, "},{"type":1,"value":"productName"},{"type":0,"value":" can still be used, but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"Your customer can also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" moved to Free plan due to payment issue"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.partner.email.body.personal-data-retention-summary.link":[{"type":0,"value":"request for deletion of their personal data."}],"commerce.commerce-subscription-auto-upgrade-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Your customer can now enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, with instructions."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.email.icon-warning.alt-text":[{"type":0,"value":"Icon - Warning"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Important things to know about "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions2":[{"type":0,"value":"Cancel your subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you\u2019ll just need to make sure your Atlassian billing partner has the correct billing details. We\u2019ve also sent them an email with instructions."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been upgraded to the "},{"type":1,"value":"planName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject2":[{"type":0,"value":"Action required to prevent deactivation"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.add-payment-details":[{"type":0,"value":"Add payment details before the trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", otherwise the subscription will be deactivated."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access":[{"type":0,"value":"You\u2019ll lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" if you don\u2019t take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.caption.take-action-avoid-site-deactivation":[{"type":0,"value":"Take action, avoid site deactivation"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019ve already added your payment details, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject2":[{"type":0,"value":"Action required to prevent deactivation"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-admin-partner.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or have your customer\u2019s admin remove users so you can switch back to Free in the "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.add-payment-or-remove-users":[{"type":0,"value":"To keep unlimited and users stay on Standard, ensure your Atlassian billing partner updates your billing details. We\u2019ve also sent them instructions. To switch back to Free, "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.take-action":[{"type":0,"value":"Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation. For help, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.direct-customer.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":" to switch back to the Free plan. Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.over-free-limit-moved-to-standard":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to Standard, which includes unlimited users."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.partner-purchasing-center":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.remove-users":[{"type":0,"value":"remove users"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link2.no-translate":[{"type":1,"value":"envPrefix"},{"type":0,"value":"atlassian.com/partner-managed-subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.caption":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.closing-line":[{"type":0,"value":"Your new bill date will be in effect from the next billing cycle. To transition you to the new\\n\\t\\t\\t\\t\\t  bill date, pro-rated adjustments will be applied to your next invoice."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.first-line":[{"type":0,"value":"We\u2019ve processed your request to change the bill date for your "},{"type":1,"value":"productName"},{"type":0,"value":"\\n\\t\\t\\t\\t\\t\\t("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription to "},{"type":1,"value":"requestedNextBillingDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.second-line":[{"type":0,"value":"If you have any other product and subscriptions on the same site that belong to the same product family,\\n            they need to be billed together. That means we\u2019ve changed the bill date for those subscriptions too."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template.email.subject":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-cancellation-ecc.email.body.billing-partner":[{"type":0,"value":"Atlassian billing partner"}],"commerce.commerce-subscription-cancellation-ecc.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" subscription is canceled"}],"commerce.commerce-subscription-cancellation-ecc.email.body.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-ecc.email.body.data-will-be-deleted":[{"type":0,"value":"Data will be deleted within 60 days from the date of cancellation. If you\u2019d like to request deletion of the data earlier, "}],"commerce.commerce-subscription-cancellation-ecc.email.body.reactivate":[{"type":0,"value":"Your Atlassian billing partner can ask us to reactivate the subscription if needed. If you weren\u2019t expecting this email, you can contact us."}],"commerce.commerce-subscription-cancellation-ecc.email.body.this-is-to-let-you-know":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-direct-customer-non-cloud":[{"type":0,"value":"If you want to keep your subscription, "},{"type":1,"value":"reachOutLinkForNonCloud"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\u2019ve received your request to cancel your subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.ul.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.ul.siteURL":[{"type":0,"value":"("},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ul.subscription":[{"type":0,"value":"Subscription: "}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.body.could-not-process-payment":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription since we were unable to process your payment. "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for the following subscription.As a result, the subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject.no-customer-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.cta-direct-customer.reactivate-subscription":[{"type":0,"value":"Don\u2019t worry, all\u2019s not lost! You can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days, we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription-button":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.product-list-item":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.update-payment-details":[{"type":0,"value":"We recommend updating your payment details to ensure this doesn\'t happen again."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.payment-details-up-to-date":[{"type":0,"value":"To avoid this in the future, ensure your payment details are up to date."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes canceled"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-view-cancel-subscription":[{"type":0,"value":"You can view or cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.managed-subscriptions-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-manage-subscription":[{"type":0,"value":"You can manage the subscription from the "},{"type":1,"value":"partnerPurchaseCentralUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, your customer\u2019s subscriptions are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-view-cancel-subscription":[{"type":0,"value":"Your customer contact can view and cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"Based on a quote that you\u2019ve already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-view-cancel-subscription":[{"type":0,"value":"You can view and manage your subscription from your billing account. "}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":" We\u2019ll charge your chosen payment details annually, and your subscription will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":"We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.auto-renewal":[{"type":0,"value":"As requested, your subscription has now been moved to the annual (auto-renewal) plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.termed":[{"type":0,"value":"As requested, your subscription has now been moved to the annual plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.caption":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":"We\u2019ll charge your chosen payment details annually for this subscription, and it will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":" We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.auto-renewal":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n\\t\\t\\t\\tAs requested, your subscription has been moved to an annual (auto-renewal) plan, which will start after\\n\\t\\t\\t\\tyour trial period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.termed":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n                As requested, your subscription has been moved to an annual plan, which will start after your trial\\n                period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.subject":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.charge-quantities-added-message":[{"type":0,"value":"You added new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to your subscription. Based on these changes, we\u2019ve adjusted your billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and prorated the cost for new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for the remaining time in your billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.estimated-bill":[{"type":0,"value":"Your estimated bill for the next billing cycle is "},{"children":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"type":8,"value":"b"},{"type":0,"value":" (excluding tax)."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.final-invoice-details":[{"type":0,"value":"Your final invoice will reflect all "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of your current billing period and the subsequent prorated charges."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.to-view-bill":[{"type":0,"value":"To view your bill breakdown and usage details, visit your "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":" page."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.charge-quantities-added-message":[{"type":0,"value":"More "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been added to the following subscription:"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.final-invoice-details":[{"type":0,"value":"The final invoice will reflect the total number of "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of the current billing cycle."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.p2-billing-adjusted":[{"type":0,"value":"The billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been adjusted to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and the cost for the new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" has been prorated for the remaining time in the billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.ppc":[{"type":0,"value":"You can view the usage details from our "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your customer\u2019s team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.app-retiring":[{"type":0,"value":"We wanted to let you know that we\u2019re no longer offering "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". "}],"commerce.commerce-subscription-offering-cancellation-ccp.email.atlassian-suite":[{"type":0,"value":"Atlassian suite"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-at-end-of-billing-cycle":[{"type":0,"value":"This means your subscription will be canceled at the end of your current billing cycle."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-immediately":[{"type":0,"value":"This means your subscription will be canceled 30 days from the date of this email."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-on-offering-expiry-date":[{"type":0,"value":"This means your subscription will be canceled on "},{"type":1,"value":"expiryDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.caption":[{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is being retired"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.marketplace-apps":[{"type":0,"value":"Marketplace apps"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.other-plans-available":[{"type":0,"value":"There may still be other "},{"type":1,"value":"appName"},{"type":0,"value":" plans available \u2014 you can check out our "},{"type":1,"value":"atlassianSuite"},{"type":0,"value":" of products or "},{"type":1,"value":"marketplaceApps"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription will be canceled"}],"commerce.commerce-subscription-offering-movement-ccp.email.app-getting-replaced":[{"type":0,"value":" The developers of "},{"type":1,"value":"appName"},{"type":0,"value":" are retiring this app and replacing it with a free version. Your paid\\n                subscription will transition to "},{"type":1,"value":"freeAppName"},{"type":0,"value":". At the end of your current billing cycle, you\u2019ll no\\n                longer be charged to use this app."}],"commerce.commerce-subscription-offering-movement-ccp.email.caption":[{"type":0,"value":"Your paid subscription for this app will convert to a free subscription"}],"commerce.commerce-subscription-offering-movement-ccp.message-template.email.subject":[{"type":1,"value":"appName"},{"type":0,"value":" is being retired."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp-g.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and billing details on your "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.manage-url":[{"type":0,"value":"Manage Subscriptions"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.ba-when-the-trial-ends":[{"type":0,"value":"Your subscription will be canceled, unless you place an order for the paid plan before the trial end date. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.bu-when-the-trial-ends":[{"type":0,"value":"When you\'re ready to start paid subscription, your billing admin will need to use the quote we send them to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-partner-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p2.partner":[{"type":0,"value":"When trial ends, the subscription will be deactivated. To extend the trial "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3":[{"type":0,"value":"We\'ve sent a quote to your billing admin. When you\'re ready to start your paid subscription, your billing admin will need to use the quote to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3-admin":[{"type":0,"value":"During your trial, we\'ll send you a quote. When you\'re ready to start your paid subscription, you can use the quote to place the order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.reach-out-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.ba.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-details":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-cbp-details":[{"type":0,"value":"Your new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.upgraded-cbp-details":[{"type":0,"value":"The new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-cc.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allowance for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.caption-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.cbps-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota type. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":". You won\'t be charged if you switch before the trial ends."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.rovo-dev-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-on":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.twc-as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends"},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.twc-good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-description":[{"type":0,"value":", and you\u2019ll continue to be charged for your existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new.partners":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin":[{"type":0,"value":"For a seamless transition when your trial ends, you\'ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-user":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.twc.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption.grouped":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans.grouped":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences.grouped":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject.grouped":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details.grouped":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption.grouped":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans.grouped":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details.grouped":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-ccp-g.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you left them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.email.body.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you \\n\\t\\t\\t\\t\\t\\t\\t\\tleft them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information-next":[{"type":0,"value":"If you\u2019ve already settled the outstanding amount, you\u2019re all set. If not, settling it immediately will ensure uninterrupted service and prevent any future deactivations."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information.partner":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your customer\u2019s data and preferences will be as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.what\'s-next":[{"type":0,"value":"What\u2019s next"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription trial successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription trial."}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.subject.customerCompanyName":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.trial.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information":[{"type":0,"value":"When your trial ends, we\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information.partner":[{"type":0,"value":"When the trial ends, we\u2019ll charge the chosen payment method and send an invoice within 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.caption":[{"type":0,"value":"We\'ve reactivated your subscriptions"}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.details":[{"type":0,"value":"Your data and preferences are just as you left them, so your team can jump back in straight away."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.intro":[{"type":0,"value":"As requested, we\'ve reactivated "},{"type":1,"value":"numOfReactivatedSubscriptions"},{"type":0,"value":" subscriptions in the last 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.subject":[{"type":0,"value":"Your daily reactivations"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure your service continues smoothly, we\'ve moved you back on your previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription-change-plan":[{"type":0,"value":"Go to Manage subscription, then Change plan. "}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.payment-details-up-to-date":[{"type":0,"value":"Make sure your payment details are up to date."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users you have exceeds the user limit allowed on your updated plan. You can do this by heading to your Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure service continues smoothly, we\'ve changed the subscription back to its previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users exceeds the user limit allowed on the updated plan. You can do this from the Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.manage-subscription":[{"type":0,"value":"Ensure the payment details are up to date then manage the subscription in Partner Purchasing Center."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription changed"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-key":[{"type":0,"value":"Users:"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-value":[{"type":1,"value":"users"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.direct-customer-whats-next":[{"type":0,"value":"You can use your current plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.nonpause-billing-accepted-request":[{"type":0,"value":"We\'ve accepted your request to move your subscription from monthly to annual (auto-renewal) plan, which will start at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.nonpause-billing-caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-accepted-request":[{"type":0,"value":"You can use the current plan, but your partner would need to contact us for any modifications. "}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details":[{"children":[{"type":0,"value":"Subscription:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details-billing-partner":[{"children":[{"type":0,"value":"Atlassian billing partner:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"billingPartner"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.nonpause-billing-current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-accepted-request":[{"type":0,"value":"The customer can continue with the existing plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"The billing cycle for one of your customer\u2019s subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ve also informed your customer about the change."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-wont-billed":[{"type":0,"value":"Your customer won\'t be billed between the end of the current monthly billing cycle and the start of the annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.wont-billed.direct-customer-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.caption":[{"type":0,"value":"Your billing frequency will soon be changed"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.contact-us":[{"type":0,"value":"If you have any questions concerning this change, please contact us."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.request-to-change-bill-freq":[{"type":0,"value":"We received a request to change the billing frequency for your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.when-will-cycle-change":[{"type":0,"value":"We\u2019ll change your "},{"type":1,"value":"oldBillingCycleName"},{"type":0,"value":" subscription to "},{"type":1,"value":"newBillingCycleName"},{"type":0,"value":" subscription at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.message-template.email.subject":[{"type":0,"value":"Your request to change your billing frequency"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.caption":[{"type":0,"value":"Welcome to the "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.charge-chosen-payment-method":[{"type":0,"value":"We\'ll charge your chosen payment method within 24 hours and send you a payment confirmation along with your invoice"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.caption":[{"type":0,"value":"Welcome to your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision":[{"type":0,"value":"If you decide that this isn\u2019t for you, "},{"type":1,"value":"content"},{"type":0,"value":" "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-multiple-offering":[{"type":0,"value":"you can change your plan from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-single-offering":[{"type":0,"value":"you can cancel anytime from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.great-news":[{"type":0,"value":"Great news \u2014 your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.how-addon-billed":[{"type":0,"value":"Find out more about "},{"type":1,"value":"manageAddonLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.manage-addon-link":[{"type":0,"value":"how add-ons are billed"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.on-pricing-plan":[{"type":0,"value":" on "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com/partner-managed-subscriptions"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.caption":[{"type":0,"value":"Welcome to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision":[{"type":0,"value":"If your customer decides this isn\u2019t for them, they can "},{"type":1,"value":"content"},{"type":0,"value":" at any time from "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-multiple-offering":[{"type":0,"value":"change their plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-single-offering":[{"type":0,"value":"cancel the subscription"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.great-news":[{"type":0,"value":"Great news \u2014 "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription"},{"type":1,"value":"companyName"},{"type":0,"value":" is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.personal-information":[{"type":0,"value":"Remember - your invoice contains personal information such as your address and other billing admin details, so you should only share it with trusted sources."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan":[{"type":0,"value":"Change plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan-and-upgrade":[{"type":0,"value":" and upgrade your subscription. Don\u2019t forget to add your payment details so you can use "},{"type":1,"value":"productName"},{"type":0,"value":" without any interruptions."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.manage-subscription-button":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.no-payment-info":[{"type":0,"value":"Since we dont have your complete billing information, we moved you to the Free plan. You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" but with limited features."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.product-info":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is now on the Free plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.to-get-back-go-to":[{"type":0,"value":"Want to go back on the "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" plan? Select "}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.trial-has-ended":[{"type":0,"value":"Your "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" has ended. We hope you enjoyed it!"}],"commerce.commerce-subscription-transferred-ccp-g.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.can-now-manage":[{"type":0,"value":"You can now manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.uninterrupted-service":[{"type":0,"value":"To ensure uninterrupted access to your subscriptions, add your payment details before your bill end date."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can view and cancel the subscription by going to "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-from-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-to-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-from-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-to-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.can-not-manage":[{"type":0,"value":"You can no longer manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":". However, all the invoices up to the date of transfer are still available."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.caption":[{"type":0,"value":"Subscription removed from billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.product-transferred-info":[{"type":0,"value":"If you had any other product and subscriptions on the same site that belonged to the same product family,\\n\\t\\t\\tthey need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription from your Billing Account, "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.caption":[{"type":0,"value":"Subscription added to your billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.product-transferred-info":[{"type":0,"value":"If the billing account "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":" had any other product and subscriptions on the same site that belonged to the same product family, they need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\u2019ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-customer-billing-account.caption":[{"type":0,"value":"Subscription transferred to your billing account"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.trial-ended-message":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". Your paid plan has now started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.trial-ended-message":[{"type":0,"value":"The free "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended, and the paid period has started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge the chosen payment method and send you an invoice soon, along with the payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject.without-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.moved-back-old-plan":[{"type":0,"value":"The subscription will be moved back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan. You don\'t have to pay any additional charges for the trial period used as we continued your billing per your "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan while on trial. If you were initially on the Free plan, you won\'t be charged anything. "}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.subscription-opted-out-from-to":[{"type":0,"value":"As requested, we\'ve ended the no-cost "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial of the following product:"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"If needed, you can always restart the trial from our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial ended on request"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.trial-ended-message":[{"type":0,"value":"The no-cost "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.upgrade-offering-message":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" paid plan:"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"To view the subscription, visit our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.we-will-charge-message":[{"type":0,"value":"We\u2019ll charge you for a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with the payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan has started"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": No cost "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" trial period has ended"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.ba-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.bu-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.cancel":[{"type":0,"value":"If you decide this isn\u2019t for you, you can cancel your subscription before your trial ends by logging in to your account."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.on-trial":[{"type":0,"value":"Good news \u2014 you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.trial-auto-convert":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.lets-make-it-official":[{"type":0,"value":"Let\u2019s make it official"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-flies":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is coming to an end"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-to-make-a-choice":[{"type":1,"value":"firstName"},{"type":0,"value":", it\u2019s time to make a choice"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.add-payment":[{"type":0,"value":"If you want to continue with the paid plan, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion":[{"type":0,"value":"If you want to continue, you don\u2019t need to do anything. When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off":[{"type":0,"value":"Your subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"You\u2019ll be moved back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan":[{"type":0,"value":"You can change or cancel your subscription before your trial ends by going to "},{"type":1,"value":"changePlanLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan.3-days-left":[{"type":0,"value":"You\u2019ll be downgraded to the Free plan if you haven\u2019t added payment details and you have fewer than 10 users."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the user limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.extend-trial":[{"type":0,"value":"If you\u2019d like to extend your trial, you\u2019ll need to contact us at "},{"type":1,"value":"salesOpsSupportEmail"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.proceed-add-payment.3-days-left":[{"type":0,"value":"To choose a different plan, "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending.3-days-left":[{"type":0,"value":"Add your payment details to keep your team going strong with the features that work best for them."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.scheduled-for-cancellation":[{"type":0,"value":"You can undo the cancellation by "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end-twc":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial and your team\'s making the most of the increased collaboration."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end.3-days-left":[{"type":0,"value":"There are "},{"children":[{"type":0,"value":"3 days left"}],"type":8,"value":"strong"},{"type":0,"value":" in your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial, but you\u2019ve got options."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features.your-features-include":[{"children":[{"type":0,"value":"Your features include:"}],"type":8,"value":"b"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.end-of-trial-with-pde":[{"type":0,"value":"Your subscription begins on "},{"type":1,"value":"subscriptionStartDate"},{"type":0,"value":". Learn about your plan\u2019s features and see what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.end-of-trial-with-pde":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off":[{"type":0,"value":"When the trial ends, the subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-upgrade-trial":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, the subscription will be moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and charged on the next bill date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.deactivate-if-payment-not-added":[{"type":0,"value":"To continue, add payment details (if you haven\u2019t already) before your trial ends to avoid deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"To continue with the paid plan, add payment details (if you haven\u2019t already) before your trial ends to avoid downgrading to the Free plan or deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.extend-trial":[{"type":0,"value":"To extend the trial, "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your customer\'s "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.scheduled-for-cancellation":[{"type":0,"value":"The trial is scheduled for cancellation. If your customer wants to undo the cancellation, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.add-payment":[{"type":0,"value":"Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.end-of-trial-with-pde":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.keep-plan":[{"type":0,"value":"Keep your "},{"type":1,"value":"productName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.add-payment":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.trial-ends-soon":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.trial-ends-soon":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.add-payment-details":[{"type":0,"value":"We noticed that we don\'t have your payment details on file. Add payment details before the renewal date to avoid any disruptions to your subscription."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.caption":[{"type":0,"value":"Your upcoming renewal"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.payment-method-charged":[{"type":0,"value":"We\u2019ll charge your chosen payment method at this time. If you want to use a different payment method, update your details before the renewal date."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.renewal-reminder":[{"type":0,"value":"This is a friendly reminder that your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will renew on "},{"type":1,"value":"renewalDate"},{"type":0,"value":". Here are the details:"}],"commerce.commerce-subscription-upcoming-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription renews soon"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-trial-extension-ad.created-date-bold.key":[{"type":0,"value":"Created date: "}],"commerce.commerce-trial-extension-ad.created-date-value":[{"type":1,"value":"createdDate"}],"commerce.commerce-trial-extension-ad.created-date.key":[{"type":1,"value":"createdDateKey"}],"commerce.commerce-trial-extension-ad.email.approved":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has approved the request."}],"commerce.commerce-trial-extension-ad.email.caption":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.email.declined":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has declined the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.default":[{"type":0,"value":"Your request for a trial extension has been received and is being processed."}],"commerce.commerce-trial-extension-ad.email.in-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" is the assignee of the approval request."}],"commerce.commerce-trial-extension-ad.email.reasons-provided":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has provided supporting reasons."}],"commerce.commerce-trial-extension-ad.email.reasons-requested":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has requested supporting reasons."}],"commerce.commerce-trial-extension-ad.email.request-cancelled":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has cancelled the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.waiting-for-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has submitted a new Trial Extension request."}],"commerce.commerce-trial-extension-ad.initiator-id-bold.key":[{"type":0,"value":"Initiator: "}],"commerce.commerce-trial-extension-ad.initiator-id-value":[{"type":1,"value":"initiator"}],"commerce.commerce-trial-extension-ad.initiator-id.key":[{"type":1,"value":"initiatorKey"}],"commerce.commerce-trial-extension-ad.message-template.email.subject":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id-bold.key":[{"type":0,"value":"Request ID: "}],"commerce.commerce-trial-extension-ad.request-id-value":[{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id.key":[{"type":1,"value":"requestIdKey"}],"commerce.commerce-trial-extension-ad.status-bold.key":[{"type":0,"value":"Status: "}],"commerce.commerce-trial-extension-ad.status-value":[{"type":1,"value":"status"}],"commerce.commerce-trial-extension-ad.status.key":[{"type":1,"value":"statusKey"}],"commerce.commerce-trial-extension-ad.subscription-bold.key":[{"type":0,"value":"Subscription: "}],"commerce.commerce-trial-extension-ad.subscription-value":[{"type":1,"value":"entitlementNumber"}],"commerce.commerce-trial-extension-ad.subscription.key":[{"type":1,"value":"subscriptionKey"}],"commerce.commerce-trial-extension-ad.support-ticket-id-bold.key":[{"type":0,"value":"Support Ticket: "}],"commerce.commerce-trial-extension-ad.support-ticket-id-value":[{"type":1,"value":"supportTicket"}],"commerce.commerce-trial-extension-ad.support-ticket-id.key":[{"type":1,"value":"supportTicketKey"}],"commerce.commerce-trial-extension-ad.total-trial-length-bold.key":[{"type":0,"value":"Total days on trial so far: "}],"commerce.commerce-trial-extension-ad.total-trial-length-value":[{"type":1,"value":"currentTotalTrialLength"}],"commerce.commerce-trial-extension-ad.total-trial-length.key":[{"type":1,"value":"totalTrialLengthKey"}],"commerce.commerce-trial-extension-ad.trial-length-bold.key":[{"type":0,"value":"Request: "}],"commerce.commerce-trial-extension-ad.trial-length-value":[{"type":0,"value":"Extend trial for "},{"type":1,"value":"netTrialDays"},{"type":0,"value":" days"}],"commerce.commerce-trial-extension-ad.trial-length.key":[{"type":1,"value":"requestKey"}],"commerce.commerce.commerce-ship-to-party-archival-ccp.email.body.caption":[{"type":1,"value":"name"},{"type":0,"value":": Sold to address deactivated"}],"commerce.common-ui.manage-subscription-from-ppc-homepage":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":"."}],"commerce.common-ui.ppc":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.common.atlassian-privacy-policy":[{"type":0,"value":"Atlassian Privacy Policy"}],"commerce.common.contact-us-to-talk-or-downgrade-to-free":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce.common.contact-your-bank-for-more-info":[{"type":0,"value":"Contact your bank if you need more information about the issue."}],"commerce.common.contacting-our-support-team":[{"type":0,"value":"contacting our support team"}],"commerce.common.contacting-us":[{"type":0,"value":"contacting us"}],"commerce.common.data-retention-and-backup-policy":[{"type":0,"value":"data retention and backup policies"}],"commerce.common.data-storage-faqs":[{"type":0,"value":"Data Storage FAQs"}],"commerce.common.downgrade-to-a-free-plan":[{"type":0,"value":"downgrade to a free plan"}],"commerce.common.email.atl-logo.alt-text":[{"type":0,"value":"Atlassian logo"}],"commerce.common.email.billing-url":[{"type":1,"value":"url"}],"commerce.common.email.bitbucket-logo.alt-text":[{"type":0,"value":"Bitbucket logo"}],"commerce.common.email.compass-logo.alt-text":[{"type":0,"value":"Compass logo"}],"commerce.common.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.common.email.csm-logo.alt-text":[{"type":0,"value":"Customer Service Management logo"}],"commerce.common.email.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"commerce.common.email.guard-logo.alt-text":[{"type":0,"value":"Guard logo"}],"commerce.common.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.common.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.common.email.loom-logo.alt-text":[{"type":0,"value":"Loom logo"}],"commerce.common.email.rovo-dev-logo.alt-text":[{"type":0,"value":"Rovo Dev logo"}],"commerce.common.email.rovo-logo.alt-text":[{"type":0,"value":"Rovo logo"}],"commerce.common.email.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.common.email.talent-logo.alt-text":[{"type":0,"value":"Talent logo"}],"commerce.common.if-you-are-unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce.common.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.common.manage-subscription-document-link":[{"type":0,"value":"Manage your subscription for Standard and Premium plans"}],"commerce.common.subscriptiom-reactivation-link":[{"type":0,"value":"reactivate your subscription"}],"commerce.common.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.email.body.what-happens-if-your-customer-uses-extra":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.email.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.email.cms.learn-more":[{"type":0,"value":"Pay later by invoice."}],"commerce.email.dont-want-continue":[{"type":0,"value":"Don\'t want to continue with the subscription?"}],"commerce.email.dont-want-to-cancel":[{"type":0,"value":"Don\'t want to cancel?"}],"commerce.email.extra-usage-charge-for-metered-billing":[{"type":0,"value":"Remember, if the included quantity or allowance for any of the usage types on the subscription are exceeded each billing cycle, extra usage charges will be added to the next invoice. "},{"type":1,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.email.how-to":[{"type":0,"value":"How to pay your invoices"}],"commerce.email.included-products":[{"type":0,"value":"Included products:"}],"commerce.email.last-page":[{"type":0,"value":"The last page of your invoice includes Atlassian\u2019s account details and instructions on how to pay."}],"commerce.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"}],"commerce.email.list.payment-method":[{"type":0,"value":"Payment method: Pay later by invoice"}],"commerce.email.list.payment-terms":[{"type":0,"value":"Payment terms: "},{"type":1,"value":"netTermsDuration"}],"commerce.email.list.taxId":[{"type":1,"value":"identifierName"},{"type":0,"value":": "},{"type":1,"value":"id"}],"commerce.email.new-plan-includes":[{"type":0,"value":"Your new plan includes:"}],"commerce.email.payment-days":[{"type":0,"value":"You\u2019ll have "},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the order invoice date to send your payment to Atlassian. You can pay using bank transfer or ACH/check (U.S. banks). "}],"commerce.email.subscription-and-billing-support-url":[{"type":0,"value":"More about how billing works."}],"commerce.email.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.email.subscription-includes":[{"type":0,"value":"Your subscription includes:"}],"commerce.email.subscription-includes-quotes":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.email.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.email.teamwork-collection":[{"type":0,"value":"Teamwork Collection can make it easy for your whole organization to work more effectively together - "},{"type":1,"value":"findOut"},{"type":0,"value":"."}],"commerce.email.teamwork-collection.find-out":[{"type":0,"value":"find out more about Atlassian collections"}],"commerce.email.the.new-plan-includes":[{"type":0,"value":"The new plan includes:"}],"commerce.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.email.view-usage":[{"type":0,"value":"View usage"}],"commerce.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.email.what-do-you-need-to-do":[{"type":0,"value":"What you need to do:"}],"commerce.email.what-happens-when-trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.whats-next":[{"type":0,"value":"What\u2019s next?"}],"commerce.learn-more":[{"type":0,"value":"To learn more, see "},{"type":1,"value":"learnMore"}],"commerce.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce.message-template.email.explore-all-features-button.explore-all-features":[{"type":0,"value":"Explore all features"}],"commerce.message-template.email.features-list.confluence.premium.analytics":[{"children":[{"type":0,"value":"Analytics:"}],"type":8,"value":"b"},{"type":0,"value":" See who has viewed a page and when"}],"commerce.message-template.email.features-list.confluence.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.confluence.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.confluence.standard.page-insights":[{"children":[{"type":0,"value":"Page insights:"}],"type":8,"value":"b"},{"type":0,"value":" See engagement data, like page views"}],"commerce.message-template.email.features-list.confluence.standard.page-permissions":[{"children":[{"type":0,"value":"Page permissions:"}],"type":8,"value":"b"},{"type":0,"value":" Choose who can view, edit, and comment"}],"commerce.message-template.email.features-list.confluence.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jira.premium.cross-team-planning":[{"children":[{"type":0,"value":"Cross-team planning:"}],"type":8,"value":"b"},{"type":0,"value":" See all projects and timelines in one place"}],"commerce.message-template.email.features-list.jira.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your work and remove human error"}],"commerce.message-template.email.features-list.jira.standard.data-residency":[{"children":[{"type":0,"value":"Data residency:"}],"type":8,"value":"b"},{"type":0,"value":" Choose where your data is stored"}],"commerce.message-template.email.features-list.jira.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jpd.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jpd.premium.roadmaps":[{"children":[{"type":0,"value":"Roadmaps:"}],"type":8,"value":"b"},{"type":0,"value":" See multiple roadmaps in a single view"}],"commerce.message-template.email.features-list.jpd.premium.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jpd.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up work and reduce human error"}],"commerce.message-template.email.features-list.jpd.standard.published-views":[{"children":[{"type":0,"value":"Published views:"}],"type":8,"value":"b"},{"type":0,"value":" Share read-only views with anyone"}],"commerce.message-template.email.features-list.jpd.standard.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jsm.premium.ai-features":[{"children":[{"type":0,"value":"AI features:"}],"type":8,"value":"b"},{"type":0,"value":" AI-powered agents, search, and chat"}],"commerce.message-template.email.features-list.jsm.premium.change-automation":[{"children":[{"type":0,"value":"Change automation:"}],"type":8,"value":"b"},{"type":0,"value":" Gate deploys and automate record creation"}],"commerce.message-template.email.features-list.jsm.premium.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.jsm.standard.branded-help-center":[{"children":[{"type":0,"value":"Branded help center:"}],"type":8,"value":"b"},{"type":0,"value":" Use your company\'s branding and URLs"}],"commerce.message-template.email.features-list.jsm.standard.enhanced-support":[{"children":[{"type":0,"value":"Enhanced support:"}],"type":8,"value":"b"},{"type":0,"value":" Get business hour support from our experts"}],"commerce.message-template.email.features-list.jsm.standard.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.loom.business-ai.advanced-editing":[{"children":[{"type":0,"value":"Advanced editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim, stitch, remove silence and filler words"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.loom.business.editing":[{"children":[{"type":0,"value":"Editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim out mistakes or stitch multiple videos together"}],"commerce.message-template.email.features-list.loom.business.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.service-collection.premium.advanced-aiops":[{"children":[{"type":0,"value":"Advanced AIOps:"}],"type":8,"value":"b"},{"type":0,"value":" Fast alert grouping, incident creation, and more"}],"commerce.message-template.email.features-list.service-collection.premium.ai-agents":[{"children":[{"type":0,"value":"AI agents:"}],"type":8,"value":"b"},{"type":0,"value":" Save time and use AI for basic conversational support"}],"commerce.message-template.email.features-list.service-collection.premium.asset-management":[{"children":[{"type":0,"value":"Asset management:"}],"type":8,"value":"b"},{"type":0,"value":" Manage the lifecycle of assets and services"}],"commerce.message-template.email.features-list.service-collection.standard.ai-powered-agents":[{"children":[{"type":0,"value":"AI-powered agents:"}],"type":8,"value":"b"},{"type":0,"value":" Automate support, resolve requests faster"}],"commerce.message-template.email.features-list.service-collection.standard.custom-help-center":[{"children":[{"type":0,"value":"Custom help center:"}],"type":8,"value":"b"},{"type":0,"value":" Deliver a seamless support experience"}],"commerce.message-template.email.features-list.service-collection.standard.unlimited-emails":[{"children":[{"type":0,"value":"Unlimited emails:"}],"type":8,"value":"b"},{"type":0,"value":" Talk to customers as much as you need"}],"commerce.message-template.email.upgrade-benefits.compass.body.customizations":[{"type":0,"value":"More customizations"}],"commerce.message-template.email.upgrade-benefits.compass.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benefits.compass.body.reusable-templates":[{"type":0,"value":"20 reusable templates"}],"commerce.message-template.email.upgrade-benifits.compass.body.storage":[{"type":0,"value":"One year of data retention"}],"commerce.message-template.email.upgrade-benifits.compass.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.confluence.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.confluence.body.page-analytics":[{"type":0,"value":"Page analytics"}],"commerce.message-template.email.upgrade-benifits.confluence.body.space-and-page-permissions":[{"type":0,"value":"Space and page permissions"}],"commerce.message-template.email.upgrade-benifits.confluence.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.confluence.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jira.body.create-issues":[{"type":0,"value":"Anonymous access to let external users view and create issues"}],"commerce.message-template.email.upgrade-benifits.jira.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jira.body.issue-permissions":[{"type":0,"value":"Advanced project and issue permissions"}],"commerce.message-template.email.upgrade-benifits.jira.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jira.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.message-template.email.upgrade-benifits.jpd.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jpd.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.message-template.email.upgrade-benifits.jsm.body.automation-rules-per-month":[{"type":0,"value":"500 project automation rules per month"}],"commerce.message-template.email.upgrade-benifits.jsm.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jsm.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jsm.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jsm.body.track-changes":[{"type":0,"value":"Audit logs to troubleshoot and track changes"}],"commerce.message-template.next-steps":[{"type":0,"value":"Next steps:"}],"commerce.message-template.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.next-bill-estimate-common.key":[{"type":0,"value":"Next estimated bill (prorated):"}],"commerce.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.partner-name.key":[{"type":0,"value":"Atlassian billing partner:"}],"commerce.partner-name.value":[{"type":1,"value":"partnerName"}],"commerce.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n    \\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days."}],"commerce.requested-by-common.key":[{"type":0,"value":"Requested by:"}],"commerce.requested-by-common.value":[{"type":1,"value":"orderPlacedBy"}],"commerce.requested-by-common.value-with-email":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"emailLink"},{"type":0,"value":")"}],"commerce.requested-by-common.value-without-email":[{"type":1,"value":"name"}],"commerce.reseller-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from the "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":" page."}],"commerce.reseller-manage-subscriptions-subscription-overview":[{"type":0,"value":"Subscription overview"}],"commerce.ship-to-information.address-key":[{"type":0,"value":"Address:"}],"commerce.ship-to-information.address-value":[{"type":1,"value":"soldToAddress"}],"commerce.ship-to-information.company-name-key":[{"type":0,"value":"Company:"}],"commerce.ship-to-information.company-name-key-alt-customer":[{"type":0,"value":"Customer:"}],"commerce.ship-to-information.company-name-value":[{"type":1,"value":"soldToCompanyName"}],"commerce.ship-to-information.end-customer-contact-key":[{"type":0,"value":"Customer contact:"}],"commerce.ship-to-information.end-customer-contact-value":[{"type":1,"value":"endCustomerContacts"}],"commerce.ship-to-information.invoice-number-key":[{"type":0,"value":"Invoice number:"}],"commerce.ship-to-information.invoice-number-value":[{"type":1,"value":"invoiceNumber"}],"commerce.subscription-common.entitlement-details":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-with-org-name":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") | "},{"type":1,"value":"orgName"}],"commerce.subscription-common.entitlement-details-with-site-url":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-without-orgName":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.key":[{"type":0,"value":"Subscription:"}],"commerce.subscription-common.quote-number-key":[{"type":0,"value":"Quote:"}],"commerce.subscription-common.quote-number-value":[{"type":1,"value":"quoteNumber"}],"commerce.subscription-common.value-with-offering":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-offering-without-entitlement":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"commerce.subscription-common.value-with-pricing-plan":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"pricingPlanName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-product":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"commerce.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"common.cloud-payment-retry-actions.admin-hub-url":[{"type":0,"value":"admin.atlassian.com"}],"common.cloud-payment-retry-actions.atlassian-administration":[{"type":0,"value":"Atlassian administration"}],"common.cloud-payment-retry-actions.billing-console-url":[{"type":0,"value":"admin.atlassian.com/billing"}],"common.cloud-payment-retry-actions.billing-overview":[{"type":0,"value":"Billing overview"}],"common.cloud-payment-retry-actions.change-plan":[{"type":0,"value":"Change plan"}],"common.cloud-payment-retry-actions.contact-supportt":[{"type":0,"value":"If you need to speak to our team, you may "},{"type":1,"value":"element"},{"type":0,"value":" to the Atlassian Support Team."}],"common.cloud-payment-retry-actions.contact-us-heading":[{"type":0,"value":"Contact us:"}],"common.cloud-payment-retry-actions.data-storage-faq":[{"type":0,"value":"Data Storage FAQs"}],"common.cloud-payment-retry-actions.downgrade-heading":[{"type":0,"value":"Downgrade to a Free plan:"}],"common.cloud-payment-retry-actions.export-data":[{"type":0,"value":"We advise you to export your business data from your Atlassian instance. For more information, see our "},{"type":1,"value":"element"}],"common.cloud-payment-retry-actions.export-data-heading":[{"type":0,"value":"Export your data:"}],"common.cloud-payment-retry-actions.free":[{"type":0,"value":"Free"}],"common.cloud-payment-retry-actions.free-plan-change":[{"type":0,"value":"Change to the Free plan at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"billingOverview"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" in the "},{"type":1,"value":"subscriptions"},{"type":0,"value":" section. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" for your product. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"planChange"},{"type":0,"value":". Select the "},{"type":1,"value":"free"},{"type":0,"value":" plan and confirm"}],"common.cloud-payment-retry-actions.here-are-actions":[{"type":0,"value":"Here are some actions we suggest you take:"}],"common.cloud-payment-retry-actions.manage":[{"type":0,"value":"Manage"}],"common.cloud-payment-retry-actions.manage-users":[{"type":0,"value":"Manage users"}],"common.cloud-payment-retry-actions.reduce-users":[{"type":0,"value":"If applicable, you\'ll first need to reduce users to 10 or fewer (three agents or fewer for Jira Service Management). Go to your site\'s admin at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"admin"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":". Find users you want to remove, and select "},{"type":1,"value":"showDetails"},{"type":0,"value":"."}],"common.cloud-payment-retry-actions.show-details":[{"type":0,"value":"Show details &gt; Actions &gt; Remove user"}],"common.cloud-payment-retry-actions.submit-ticket":[{"type":0,"value":"Submit a ticket"}],"common.cloud-payment-retry-actions.subscription-details":[{"type":0,"value":"Subscription details"}],"common.cloud-payment-retry-actions.subscriptions":[{"type":0,"value":"Subscriptions"}],"common.cloud-payment-retry-actions.what-if-unable":[{"type":0,"value":"What if I\'m unable to make payments?"}],"common.invoice.manage-subscriptions.partner-info":[{"type":0,"value":"To manage subscriptions, visit our Partner Purchasing Center (PPC)."}],"common.invoice.manage-subscriptions.subscription-info":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"post-office.commerce-access-invalid-payment-hams.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"post-office.commerce-access-invalid-payment-hams.error-message.access":[{"type":0,"value":"We couldn\u2019t process your payment for Atlassian Access since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.bitbucket":[{"type":0,"value":"We couldn\u2019t process your payment for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.cloud":[{"type":0,"value":"We couldn\'t process your payment for Atlassian Cloud since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.server":[{"type":0,"value":"We couldn\u2019t process your payment for "},{"type":1,"value":"productInfoString"},{"type":0,"value":" since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.retry-button":[{"type":0,"value":"Retry Payment"}],"post-office.commerce-access-invalid-payment-hams.retry-message":[{"type":0,"value":"Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or asked to authenticate in a different way."}],"post-office.commerce-common.Contact-us":[{"type":0,"value":"Contact us"}],"post-office.commerce-common.atlassian-support-team":[{"type":0,"value":"Atlassian Support Team"}],"post-office.commerce-common.blocks.regards":[{"type":0,"value":"Regards,"}],"post-office.commerce-common.blocks.thanks":[{"type":0,"value":"Thanks,"}],"post-office.commerce-common.cheers":[{"type":0,"value":"Cheers,"}],"post-office.commerce-common.cheers.from-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.cheers.from-atlassians":[{"type":0,"value":"The Atlassians"}],"post-office.commerce-common.choose-plan-link":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.choose-plan.billing-console":[{"type":0,"value":"Keep Premium plan"}],"post-office.commerce-common.choose-plan.choose-plan.billing-console":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.consumption.included-quantity-details":[{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"includedQuantityUnit"}],"post-office.commerce-common.consumption.summary-included-quantity":[{"type":0,"value":"Included quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity":[{"type":0,"value":"Consumed quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity-details":[{"type":1,"value":"consumedQuantity"},{"type":0,"value":" "},{"type":1,"value":"consumedQuantityUnit"}],"post-office.commerce-common.consumptionl.summary.consumption-percentage":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% consumed"}],"post-office.commerce-common.contact-support-button.partner":[{"type":0,"value":"Contact Support"}],"post-office.commerce-common.contact-us":[{"type":0,"value":"contact us"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-service-management":[{"type":0,"value":"Atlassian Jira Service Management"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-service-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.email.plan-section.description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" 30-day money back guarantee if you forget to cancel."}],"post-office.commerce-common.email.plan-section.explore-plan.link-description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Explore all plans \u2192"}],"type":8,"value":"b"}],"post-office.commerce-common.email.subscription-details-section.billing-cycle-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Billing cycle"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-subtitle.end-of-trial-with-pde":[{"type":0,"value":"First bill estimate"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-suffix.end-of-trial-with-pde":[{"type":0,"value":" (Excludes taxes)"}],"post-office.commerce-common.email.subscription-details-section.plan-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Plan"}],"post-office.commerce-common.email.subscription-details-section.title.end-of-trial-with-pde":[{"type":0,"value":"Subscription details"}],"post-office.commerce-common.email.subscription-details-section.trial-ends-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Trial ends"}],"post-office.commerce-common.email.subscription.description.end-of-trial-with-pde":[{"type":0,"value":"When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"post-office.commerce-common.email.subscription.headline.end-of-trial-with-pde":[{"type":0,"value":"You don\'t need to do anything"}],"post-office.commerce-common.email.subscription.tick-circle-green-icon.end-of-trial-with-pde":[{"type":0,"value":"Green tick circle icon for the billing section"}],"post-office.commerce-common.features-image.confluence-premium":[{"type":0,"value":"Confluence Premium Features"}],"post-office.commerce-common.features-image.confluence-standard":[{"type":0,"value":"Confluence Standard Features"}],"post-office.commerce-common.features-image.jira-premium":[{"type":0,"value":"Jira Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-premium":[{"type":0,"value":"Jira Product Discovery Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-standard":[{"type":0,"value":"Jira Product Discovery Standard Features"}],"post-office.commerce-common.features-image.jira-service-management-premium":[{"type":0,"value":"Jira Service Management Premium Features"}],"post-office.commerce-common.features-image.jira-service-management-standard":[{"type":0,"value":"Jira Service Management Standard Features"}],"post-office.commerce-common.features-image.jira-standard":[{"type":0,"value":"Jira Standard Features"}],"post-office.commerce-common.features-image.loom-business":[{"type":0,"value":"Loom Business Features"}],"post-office.commerce-common.features-image.loom-business-ai":[{"type":0,"value":"Loom Business + AI Features"}],"post-office.commerce-common.features-image.service-collection-premium":[{"type":0,"value":"Service Collection Premium Features"}],"post-office.commerce-common.features-image.service-collection-standard":[{"type":0,"value":"Service Collection Standard Features"}],"post-office.commerce-common.footer-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer-v2.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer-v2.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.commerce-common.footer-v2.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer-v2.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer-v2.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer-v2.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer-v2.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer-v2.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.commerce-common.footer-v2.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer-v2.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.commerce-common.footer-v2.x-alt-text":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.x-title":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer-v2.youtube-title":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.commerce-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer.office-address.we-are-located-at":[{"type":0,"value":"We are located at "}],"post-office.commerce-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.commerce-common.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.formal-goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"post-office.commerce-common.formal-goodbye.contact-representative":[{"type":0,"value":"Contact your Atlassian representative if you have any questions."}],"post-office.commerce-common.formal-thank-you":[{"type":0,"value":"Thank you for taking action at your earliest convenience."}],"post-office.commerce-common.get-in-touch":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouchLink"}],"post-office.commerce-common.need-help-with-contact-us":[{"type":0,"value":"Need help with plans and billing? "},{"type":1,"value":"contactUs"}],"post-office.commerce-common.not-personal-greetings":[{"type":0,"value":"Hi,"}],"post-office.commerce-common.payment-details.add":[{"type":0,"value":"Add payment details"}],"post-office.commerce-common.payment-details.add.v2":[{"type":0,"value":"explore your plan options"}],"post-office.commerce-common.payment-details.update":[{"type":0,"value":"Update payment details"}],"post-office.commerce-common.personal-greetings":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"post-office.commerce-common.product.entitlement-number.billing-cycle":[{"type":0,"value":"Billing cycle: "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.product.entitlement-number.requested-by-email-id":[{"type":0,"value":"Requested by: "},{"type":1,"value":"requestedByEmailId"}],"post-office.commerce-common.product.entitlement-number.site-url.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"}]},"true":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"}]}},"type":5,"value":"hasSiteUrl"}],"post-office.commerce-common.product.entitlement-number.users-count":[{"type":1,"value":"chargeElement"},{"type":0,"value":"s: "},{"type":1,"value":"usersCount"}],"post-office.commerce-common.product.product-title.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"productName"}]},"true":{"value":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"offeringName"},{"type":0,"value":")"}]}},"type":5,"value":"hasOfferingName"}],"post-office.commerce-common.subscription-product-details.bill-estimate-and-currency":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"post-office.commerce-common.subscription-product-details.bill-estimate-title":[{"type":0,"value":"Total bill estimate"}],"post-office.commerce-common.subscription-product-details.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription-product-details.exclude-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscription-product-details.offering-name.user-size.billing-cycle.no-translate":[{"type":1,"value":"siteDetails"}],"post-office.commerce-common.subscription-product-details.product-name.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription-product-details.site-url.no-translate":[{"type":1,"value":"siteURL"}],"post-office.commerce-common.subscription.atlassian-guard-standard":[{"type":0,"value":"Atlassian Guard Standard"}],"post-office.commerce-common.subscription.atlassian-rovo":[{"type":0,"value":"Atlassian Rovo"}],"post-office.commerce-common.subscription.cbp-charge-element-package-network":[{"children":[{"type":0,"value":"Network traffic:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-storage":[{"children":[{"type":0,"value":"Package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo Dev credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" credits per user"}],"post-office.commerce-common.subscription.cbp-charge-element-runners":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage":[{"children":[{"type":0,"value":"Storage (Git LFS):"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage-minutes":[{"children":[{"type":0,"value":"Build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.free-access":[{"type":0,"value":"Free access to:"}],"post-office.commerce-common.subscription.included-products":[{"type":0,"value":"Included products:"}],"post-office.commerce-common.subscription.product-title.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.address.no-translate":[{"type":0,"value":"Address: "},{"type":1,"value":"address"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.company.no-translate":[{"type":0,"value":"Company: "},{"type":1,"value":"companyName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.customer-contact.no-translate":[{"type":0,"value":"Customer contact: "},{"type":1,"value":"customerContact"}],"post-office.commerce-common.subscription.product.billing-cycle.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.subscription.product.billing-user-partner-contextual-info.partner-name.no-translate":[{"type":0,"value":"Atlassian billing partner: "},{"type":1,"value":"billingPartner"}],"post-office.commerce-common.subscription.product.charge quantities.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"usageQuantity"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":"s "}],"post-office.commerce-common.subscription.product.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription.product.offering-name.no-translate":[{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"post-office.commerce-common.subscription.product.site-url.no-translate":[{"type":1,"value":"siteUrl"}],"post-office.commerce-common.subscription.rovo-dev-credit-allocation":[{"type":1,"value":"credits"},{"type":0,"value":" Rovo Dev credits per user"}],"post-office.commerce-common.subscriptions-change-plan":[{"type":0,"value":"Subscriptions"}],"post-office.commerce-common.subscriptions.excludes-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscriptions.this-payment-is-for":[{"type":0,"value":"This payment is for:"}],"post-office.commerce-common.subscriptions.total-bill-estimate":[{"type":0,"value":"Total bill estimate:"}],"post-office.commerce-common.subscriptions.total-bill-estimate-after-trial":[{"type":0,"value":"Total bill estimate after trial ends:"}],"post-office.commerce-common.subscriptions.your-estimated-bill-is":[{"type":0,"value":"Your estimated bill is:"}],"post-office.commerce-common.the-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.view-subscription.billing-console":[{"type":0,"value":"View subscription"}],"post-office.commerce-order-fulfilled-ccp.email.billing-account.other-host-type":[{"type":0,"value":"billing account"}],"post-office.commerce-order-fulfilled-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-ccp.email.cmk.support-url":[{"type":0,"value":"page"}],"post-office.commerce-order-fulfilled-ccp.email.direct-customer.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-ccp.email.siteAdmin.cloud":[{"type":0,"value":"site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"}],"post-office.commerce-order-fulfilled-ccp.email.support-url":[{"type":0,"value":"billing support"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.siteAdmin":[{"type":0,"value":"Administration"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.support-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.view-quote-url":[{"type":0,"value":"Learn more"}],"post-office.commerce-payment-failure-hams.email.support.additional_actions":[{"type":0,"value":"additional actions"}],"post-office.commerce-payment-failure-hams.email.title.check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.expiration":[{"type":0,"value":"This doesn\'t have to be a goodbye"}],"post-office.commerce-payment-failure-hams.email.title.expired":[{"type":0,"value":"Your Atlassian subscription has expired"}],"post-office.commerce-payment-failure-hams.email.title.make-it-official":[{"type":0,"value":"Let\'s make it official!"}],"post-office.commerce-payment-failure-hams.email.title.trial-check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.trial-end":[{"type":0,"value":"Your trial has ended. What\'s next?"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.email.partner.set-up":[{"type":0,"value":"set up the collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.direct-customer.set-up":[{"type":0,"value":"set up your collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.partner.set-up":[{"type":0,"value":"sets up the collection"}]}');

});

parcelRegister("lnCdp", function(module, exports) {

let $f90963b6f59bf27f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f90963b6f59bf27f$var$load("fMM0W").then(()=>parcelRequire('2e3Ru'));

});

parcelRegister("eb1gR", function(module, exports) {

let $a52314250a699df4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a52314250a699df4$var$load("3Eh3Y").then(()=>parcelRequire('gkDnC'));

});

parcelRegister("5RIKb", function(module, exports) {

let $44549c2c5ec50afe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44549c2c5ec50afe$var$load("hUJ4u").then(()=>parcelRequire('fNRM8'));

});

parcelRegister("dovsn", function(module, exports) {

let $9c05eaebaa1526f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c05eaebaa1526f8$var$load("epSJY").then(()=>parcelRequire('2iK9l'));

});

parcelRegister("8ujMv", function(module, exports) {

let $62e0783f73bd716e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62e0783f73bd716e$var$load("bLCoT").then(()=>parcelRequire('dIHua'));

});

parcelRegister("7uLNo", function(module, exports) {

let $575068fdd925a4c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $575068fdd925a4c3$var$load("9ChkX").then(()=>parcelRequire('dQRlT'));

});

parcelRegister("h5IDc", function(module, exports) {

let $c71586284ca5c822$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c71586284ca5c822$var$load("hU0gB").then(()=>parcelRequire('laEC1'));

});

parcelRegister("eqahM", function(module, exports) {

let $a7fb78eb831a98a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7fb78eb831a98a1$var$load("ibkLf").then(()=>parcelRequire('4Ti42'));

});

parcelRegister("gUfa2", function(module, exports) {

let $c4eda2f26b5cd8f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4eda2f26b5cd8f0$var$load("ilwVm").then(()=>parcelRequire('f9hOT'));

});

parcelRegister("fzoAJ", function(module, exports) {

let $b55d333c17e48c7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b55d333c17e48c7d$var$load("klVOv").then(()=>parcelRequire('2O82h'));

});

parcelRegister("bHHEy", function(module, exports) {

let $88559279cca4e865$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88559279cca4e865$var$load("iCSFT").then(()=>parcelRequire('elRIk'));

});

parcelRegister("1LZnU", function(module, exports) {

let $14a9cbeb14fe137c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $14a9cbeb14fe137c$var$load("fFwmN").then(()=>parcelRequire('bpioJ'));

});

parcelRegister("e5v3e", function(module, exports) {

let $a4199e6c3ef53710$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4199e6c3ef53710$var$load("lzYuB").then(()=>parcelRequire('18Lyj'));

});

parcelRegister("9nIBZ", function(module, exports) {

let $6d48de005396102e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d48de005396102e$var$load("4juqu").then(()=>parcelRequire('2iyEy'));

});

parcelRegister("26FpJ", function(module, exports) {

let $188c4444e4be4fbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $188c4444e4be4fbb$var$load("aH3js").then(()=>parcelRequire('2UazD'));

});

parcelRegister("4Gifa", function(module, exports) {

let $36893c791389fdbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36893c791389fdbf$var$load("cWVaN").then(()=>parcelRequire('2tzo9'));

});

parcelRegister("gjCMe", function(module, exports) {

let $be0c7ff7f9cb33db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be0c7ff7f9cb33db$var$load("7ZMjf").then(()=>parcelRequire('gCfOe'));

});

parcelRegister("2uT7I", function(module, exports) {

let $1d19247ef646d984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d19247ef646d984$var$load("cP5Vm").then(()=>parcelRequire('7z1Gc'));

});

parcelRegister("hvuuM", function(module, exports) {

let $034a04135217bf9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $034a04135217bf9c$var$load("jpsMP").then(()=>parcelRequire('cie0a'));

});

parcelRegister("hnBZg", function(module, exports) {

let $ca720d20820723d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca720d20820723d6$var$load("3Nesj").then(()=>parcelRequire('ipjdj'));

});

parcelRegister("7SJn9", function(module, exports) {

let $5bd0c58e6a37443d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bd0c58e6a37443d$var$load("jFE9F").then(()=>parcelRequire('f8XV3'));

});

parcelRegister("j05vz", function(module, exports) {

let $dd524a3c81b05553$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd524a3c81b05553$var$load("loRRx").then(()=>parcelRequire('d6uE7'));

});

parcelRegister("i0UGC", function(module, exports) {

let $d1d432cf25355ef9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1d432cf25355ef9$var$load("894iO").then(()=>parcelRequire('f5jiF'));

});

parcelRegister("7sBhv", function(module, exports) {

let $56e81137eb7b8dd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56e81137eb7b8dd9$var$load("8jC0S").then(()=>parcelRequire('j0e2J'));

});

parcelRegister("luKLP", function(module, exports) {

let $fa60adf38f6d04c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa60adf38f6d04c6$var$load("llNzy").then(()=>parcelRequire('9YxKt'));

});

parcelRegister("1eM5i", function(module, exports) {

let $0e6c65d4f95bca4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e6c65d4f95bca4d$var$load("3EOn7").then(()=>parcelRequire('53R9u'));

});

parcelRegister("5VqXr", function(module, exports) {

let $45072fd92e0a8f91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45072fd92e0a8f91$var$load("56IgT").then(()=>parcelRequire('7Mwv4'));

});

parcelRegister("aFL7V", function(module, exports) {

let $7c524a1e81ecec70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c524a1e81ecec70$var$load("iGnJK").then(()=>parcelRequire('414QG'));

});

parcelRegister("hADG6", function(module, exports) {

let $cce493b154339453$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cce493b154339453$var$load("2dTBo").then(()=>parcelRequire('56IBy'));

});

parcelRegister("h6zhf", function(module, exports) {

let $c73e5c7f9dfb532b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c73e5c7f9dfb532b$var$load("dJqBp").then(()=>parcelRequire('aBX1P'));

});

parcelRegister("gk800", function(module, exports) {

let $be24b8115ff66b7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be24b8115ff66b7b$var$load("4KjiR").then(()=>parcelRequire('5Wn3P'));

});

parcelRegister("8KsH5", function(module, exports) {

let $65e8e0a5fc18bebe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65e8e0a5fc18bebe$var$load("7o9PN").then(()=>parcelRequire('hzKad'));

});

parcelRegister("8gA9a", function(module, exports) {

let $604bdb5b98d25431$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $604bdb5b98d25431$var$load("9UQcb").then(()=>parcelRequire('c9I2t'));

});

parcelRegister("e3o5i", function(module, exports) {

let $a3b4072eb30c3a1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3b4072eb30c3a1e$var$load("5sqYT").then(()=>parcelRequire('hmPR0'));

});

parcelRegister("2Zvud", function(module, exports) {

let $22d9b3cd6e322ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22d9b3cd6e322ced$var$load("jRTH1").then(()=>parcelRequire('ei2MK'));

});

parcelRegister("cYsan", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("4P6Vl", function(module, exports) {

let $38314bc418b47d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38314bc418b47d1e$var$load("3Mvpe").then(()=>parcelRequire('70m7S'));

});

parcelRegister("27aNh", function(module, exports) {

let $18a49ba8fa6de244$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18a49ba8fa6de244$var$load("frKDr").then(()=>parcelRequire('hqEeD'));

});

parcelRegister("aSlsY", function(module, exports) {

let $7eaf99476a49e0ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eaf99476a49e0ba$var$load("bjjck").then(()=>parcelRequire('a3QjM'));

});

parcelRegister("cOAck", function(module, exports) {

let $95463bac650a58f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95463bac650a58f1$var$load("iJz71").then(()=>parcelRequire('irzXr'));

});

parcelRegister("76gkg", function(module, exports) {

let $52b5c1e6747725bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $52b5c1e6747725bd$var$load("1ynXL").then(()=>parcelRequire('lPLnq'));

});

parcelRegister("2Bl1Y", function(module, exports) {

let $1e4f59c25a3a3683$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1e4f59c25a3a3683$var$load("9Tqjv").then(()=>parcelRequire('a2jXj'));

});

parcelRegister("grzFC", function(module, exports) {

let $bf8ad656fa93659a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf8ad656fa93659a$var$load("95GQ6").then(()=>parcelRequire('9prXl'));

});

parcelRegister("6JE8A", function(module, exports) {

let $4e7614872121963d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e7614872121963d$var$load("cOqwO").then(()=>parcelRequire('6U26G'));

});

parcelRegister("9S9M8", function(module, exports) {

let $7300bd6911e5c79d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7300bd6911e5c79d$var$load("lMCPq").then(()=>parcelRequire('ihIJC'));

});

parcelRegister("gkLcq", function(module, exports) {

let $be4320716f6f41e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be4320716f6f41e0$var$load("akfMh").then(()=>parcelRequire('ilzaM'));

});

parcelRegister("lLyBc", function(module, exports) {

let $fd88d36b34961fe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd88d36b34961fe5$var$load("g4Ezq").then(()=>parcelRequire('8MEkZ'));

});

parcelRegister("4jCEx", function(module, exports) {

let $3246eb6e5b598b44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3246eb6e5b598b44$var$load("7oKyj").then(()=>parcelRequire('lWnug'));

});

parcelRegister("7OGyS", function(module, exports) {

let $5b0e37bb750cefc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b0e37bb750cefc3$var$load("4WuEN").then(()=>parcelRequire('8z5Fd'));

});

parcelRegister("8clR5", function(module, exports) {

let $5f8065b59b285a42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f8065b59b285a42$var$load("7eb4c").then(()=>parcelRequire('dPsCl'));

});

parcelRegister("3MYuU", function(module, exports) {

let $2c24c857c76b6de3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c24c857c76b6de3$var$load("9gvzs").then(()=>parcelRequire('2gTzu'));

});

parcelRegister("aBCf4", function(module, exports) {

let $7b8b062d544f25df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b8b062d544f25df$var$load("2NHJm").then(()=>parcelRequire('iy8je'));

});

parcelRegister("5Bhq2", function(module, exports) {

let $413deb7e80b78a05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $413deb7e80b78a05$var$load("lzkjk").then(()=>parcelRequire('4Ykei'));

});

parcelRegister("3rRY7", function(module, exports) {

let $282dc1ca58969375$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $282dc1ca58969375$var$load("3Dg4n").then(()=>parcelRequire('lwBQR'));

});

parcelRegister("30lWk", function(module, exports) {

let $230263f88e4f1e8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $230263f88e4f1e8f$var$load("kgkaG").then(()=>parcelRequire('3pX63'));

});

parcelRegister("hA595", function(module, exports) {

let $ccc9ca46abe22024$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ccc9ca46abe22024$var$load("c9cT7").then(()=>parcelRequire('8j7Sz'));

});

parcelRegister("3RoXR", function(module, exports) {

let $2cf9afc82bb3e4cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2cf9afc82bb3e4cf$var$load("30Bx7").then(()=>parcelRequire('jFBzj'));

});

parcelRegister("2j9hJ", function(module, exports) {

let $1ae48ee9ce334678$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ae48ee9ce334678$var$load("8eAVU").then(()=>parcelRequire('dY0nX'));

});

parcelRegister("eRauK", function(module, exports) {

let $ad0e2803226cb0e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad0e2803226cb0e9$var$load("aMdzs").then(()=>parcelRequire('joaA7'));

});

parcelRegister("krh33", function(module, exports) {

let $ee138dac9f451845$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee138dac9f451845$var$load("kRNym").then(()=>parcelRequire('28wDW'));

});

parcelRegister("eaNh3", function(module, exports) {

let $a51838ac0750cef3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a51838ac0750cef3$var$load("jwuG0").then(()=>parcelRequire('keiA6'));

});

parcelRegister("dbpza", function(module, exports) {

let $999022602688a0f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $999022602688a0f5$var$load("7In40").then(()=>parcelRequire('1g9AV'));

});

parcelRegister("gDeem", function(module, exports) {

let $c1bb53c9b9db92da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1bb53c9b9db92da$var$load("4rTb3").then(()=>parcelRequire('j2Qpo'));

});

parcelRegister("16hwG", function(module, exports) {

let $0cd3f2535cd35711$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cd3f2535cd35711$var$load("7zydV").then(()=>parcelRequire('5Ss5z'));

});

parcelRegister("hsd8R", function(module, exports) {

let $cb4f3ee4377f6801$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb4f3ee4377f6801$var$load("gBME1").then(()=>parcelRequire('dHZrs'));

});

parcelRegister("2JjwY", function(module, exports) {

let $1fceef26e364702d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fceef26e364702d$var$load("4jkxA").then(()=>parcelRequire('9HpHb'));

});

parcelRegister("epoZZ", function(module, exports) {

let $a7d6cab9f5f604fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7d6cab9f5f604fb$var$load("5xqxE").then(()=>parcelRequire('e8JXo'));

});

parcelRegister("2k0Bf", function(module, exports) {

let $1b0dea1f7626ee92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b0dea1f7626ee92$var$load("6n8TN").then(()=>parcelRequire('iqugp'));

});

parcelRegister("gGmMl", function(module, exports) {

let $c2523cf52d78d8e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2523cf52d78d8e0$var$load("4GzfW").then(()=>parcelRequire('6oUMz'));

});

parcelRegister("4Juzw", function(module, exports) {

let $3723145385ae5bca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3723145385ae5bca$var$load("8QvoP").then(()=>parcelRequire('ll8DE'));

});

parcelRegister("hutRG", function(module, exports) {
module.exports = JSON.parse("{\"shared-user-preferences-onboarding.modal.alternative-text\":[{\"type\":0,\"value\":\"Alternatively, you can choose light or dark theme from your display settings in your account.\"}],\"shared-user-preferences-onboarding.modal.button.accept\":[{\"type\":0,\"value\":\"Accept\"}],\"shared-user-preferences-onboarding.modal.button.choose-theme\":[{\"type\":0,\"value\":\"Choose theme\"}],\"shared-user-preferences-onboarding.modal.description\":[{\"type\":0,\"value\":\"All your Atlassian apps will now match your browser's theme by default.\"}],\"shared-user-preferences-onboarding.modal.feature.consistent\":[{\"type\":0,\"value\":\"Consistent look and feel across all apps\"}],\"shared-user-preferences-onboarding.modal.feature.override\":[{\"type\":0,\"value\":\"Override theme preferences for certain apps\"}],\"shared-user-preferences-onboarding.modal.feature.set-once\":[{\"type\":0,\"value\":\"Only set your theme preferences once\"}],\"shared-user-preferences-onboarding.modal.title\":[{\"type\":0,\"value\":\"Your theme is now synced\"}]}");

});

parcelRegister("erlv3", function(module, exports) {

let $a83443b93675ce31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a83443b93675ce31$var$load("kHJL1").then(()=>parcelRequire('klL0c'));

});

parcelRegister("hyrCI", function(module, exports) {

let $cc7b0a16f6921e71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc7b0a16f6921e71$var$load("5zhBR").then(()=>parcelRequire('5ICPG'));

});

parcelRegister("lRpEo", function(module, exports) {

let $fea271e388992377$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fea271e388992377$var$load("7HsFX").then(()=>parcelRequire('hsdoS'));

});

parcelRegister("ggw2O", function(module, exports) {

let $bd76ff498b0c2692$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd76ff498b0c2692$var$load("eezIh").then(()=>parcelRequire('eAim8'));

});

parcelRegister("hPTao", function(module, exports) {

let $cfc1fe04b4fe2cc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfc1fe04b4fe2cc5$var$load("7nZOc").then(()=>parcelRequire('7n1Yj'));

});

parcelRegister("lcBLN", function(module, exports) {

let $f6f80448ec180cb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6f80448ec180cb6$var$load("16ctX").then(()=>parcelRequire('ewuzo'));

});

parcelRegister("dBkh6", function(module, exports) {

let $9e6e7534dbc220e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e6e7534dbc220e0$var$load("lRsSW").then(()=>parcelRequire('6tp8x'));

});

parcelRegister("dFJoB", function(module, exports) {

let $9f42516015e35160$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f42516015e35160$var$load("33w3O").then(()=>parcelRequire('h4r0z'));

});

parcelRegister("4Dzz2", function(module, exports) {

let $3606643c6b9ee668$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3606643c6b9ee668$var$load("3V9JV").then(()=>parcelRequire('agzbM'));

});

parcelRegister("9oSEu", function(module, exports) {

let $6d80bfbb2af7906e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d80bfbb2af7906e$var$load("lR2iC").then(()=>parcelRequire('WTx7Y'));

});

parcelRegister("2LYdk", function(module, exports) {

let $204eadd0e8fafcee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $204eadd0e8fafcee$var$load("3KeA9").then(()=>parcelRequire('9QQr7'));

});

parcelRegister("4BCOh", function(module, exports) {

let $35a8b8f9b156d7b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35a8b8f9b156d7b3$var$load("7VauH").then(()=>parcelRequire('lh3Xp'));

});

parcelRegister("j1vKh", function(module, exports) {

let $dd96bc5344d365e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd96bc5344d365e1$var$load("6gxg1").then(()=>parcelRequire('8IvqN'));

});

parcelRegister("6bsbz", function(module, exports) {

let $4809a23c9cfcbbff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4809a23c9cfcbbff$var$load("fC53x").then(()=>parcelRequire('aVpbD'));

});

parcelRegister("alXGr", function(module, exports) {

let $789a297517fe617c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $789a297517fe617c$var$load("03q9Y").then(()=>parcelRequire('bxkXp'));

});

parcelRegister("2zxWZ", function(module, exports) {

let $1df92f7c22ec43d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1df92f7c22ec43d2$var$load("lzICY").then(()=>parcelRequire('84yl1'));

});

parcelRegister("5ucB7", function(module, exports) {

let $3fe986b556f080fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fe986b556f080fd$var$load("kL6EC").then(()=>parcelRequire('gOpw9'));

});

parcelRegister("h6Pun", function(module, exports) {

let $c74aefd5dc5cb8d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c74aefd5dc5cb8d1$var$load("ls6yt").then(()=>parcelRequire('aXBLi'));

});

parcelRegister("9AvLk", function(module, exports) {

let $6fb01d3683097f98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fb01d3683097f98$var$load("3b3AF").then(()=>parcelRequire('eio5I'));

});

parcelRegister("3ABqE", function(module, exports) {

let $29d1c47e51ad505c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29d1c47e51ad505c$var$load("fqluR").then(()=>parcelRequire('eabsn'));

});

parcelRegister("lW5ia", function(module, exports) {

let $ff831ea98928c073$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff831ea98928c073$var$load("i4oFC").then(()=>parcelRequire('hjOit'));

});

parcelRegister("biIex", function(module, exports) {

let $83a3affe43753d35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83a3affe43753d35$var$load("dlXMJ").then(()=>parcelRequire('GkLoD'));

});

parcelRegister("4Xmpo", function(module, exports) {

let $39be0dfa20f55fa4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $39be0dfa20f55fa4$var$load("3Wz8w").then(()=>parcelRequire('j1M7k'));

});

parcelRegister("8105H", function(module, exports) {

let $5d5e7cc4f0e8ea0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d5e7cc4f0e8ea0d$var$load("eJuYi").then(()=>parcelRequire('9VUhq'));

});

parcelRegister("6GstT", function(module, exports) {

let $4ddcc21a2fd98dbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ddcc21a2fd98dbb$var$load("gLWOP").then(()=>parcelRequire('bupB5'));

});

parcelRegister("b825f", function(module, exports) {

let $81a20ed37a1f163b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81a20ed37a1f163b$var$load("xYuTp").then(()=>parcelRequire('Dw2OB'));

});

parcelRegister("7HCuW", function(module, exports) {

let $59ba697e18561da2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $59ba697e18561da2$var$load("lbYf0").then(()=>parcelRequire('17Zy6'));

});

parcelRegister("9Uxty", function(module, exports) {

let $73734f9b01b99814$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73734f9b01b99814$var$load("5RCMm").then(()=>parcelRequire('e6LBR'));

});

parcelRegister("fwEkh", function(module, exports) {

let $b4d9201388e548c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4d9201388e548c1$var$load("CMPTw").then(()=>parcelRequire('irg4k'));

});

parcelRegister("4QDVl", function(module, exports) {

let $387afcd36034ffd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $387afcd36034ffd4$var$load("3K3Qm").then(()=>parcelRequire('cRU8U'));

});

parcelRegister("k26Lv", function(module, exports) {

let $e9593dfd95311e9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9593dfd95311e9f$var$load("5RzGS").then(()=>parcelRequire('EmpfH'));

});

parcelRegister("7jx5e", function(module, exports) {

let $5533f86dc733431c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5533f86dc733431c$var$load("iIXZI").then(()=>parcelRequire('emiD2'));

});

parcelRegister("c0uLU", function(module, exports) {

let $8bdd5abf3eaac397$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bdd5abf3eaac397$var$load("iii8A").then(()=>parcelRequire('lxO7G'));

});

parcelRegister("gqxhP", function(module, exports) {

let $bf58e514c67c4a8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf58e514c67c4a8d$var$load("M926c").then(()=>parcelRequire('54Fog'));

});

parcelRegister("8SCD0", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ineA9 = parcelRequire("ineA9");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6c9af975b930043$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $e6c9af975b930043$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("9DoTa")));
        case 'da':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4qglW")));
        case 'de':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bfbM8")));
        case 'en-GB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("auur8")));
        case 'en-US':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqlmj")));
        case 'en-XA':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4LGQD")));
        case 'en-XB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iQahz")));
        case 'en-ZZ':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1vN03")));
        case 'en':
            return $e6c9af975b930043$var$importHelper(await Promise.resolve((parcelRequire("ineA9"))));
        case 'es':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("l8F02")));
        case 'et':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4lx9v")));
        case 'fi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7SJgz")));
        case 'fr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2hAcG")));
        case 'hr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3KRsA")));
        case 'hu':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lorva")));
        case 'it':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7z1yN")));
        case 'ja':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6Lmbg")));
        case 'ko':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hDbAj")));
        case 'nb':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("ifA95")));
        case 'nl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("c8rti")));
        case 'pl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kWAHY")));
        case 'pt-BR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("8m74M")));
        case 'ro':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("cHbRQ")));
        case 'ru':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iginQ")));
        case 'sl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("buteN")));
        case 'sr-RS':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kXpFG")));
        case 'sr-YR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6DRMN")));
        case 'sr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bytiP")));
        case 'sv':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("5eaPb")));
        case 'th':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2JhNV")));
        case 'tr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lJjy6")));
        case 'uk':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqddP")));
        case 'vi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lRJ6S")));
        case 'zh-CN':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        case 'zh-TW':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("aazgg")));
        case 'zh':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ineA9));
    }
};
module.exports["messagesLoader"] = $e6c9af975b930043$export$720676d8cac8fbb;

});

parcelRegister("ineA9", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-prioritization-template.jpd.title":[{"type":0,"value":"Prioritize ideas"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.admin-hub-recommendation.actions-heading":[{"type":0,"value":"Actions"}],"growth.admin-hub-recommendation.free-plan":[{"type":0,"value":"Free, cancel anytime"}],"growth.admin-hub-recommendation.heading":[{"type":0,"value":"Recommended based on your existing products"}],"growth.admin-hub-recommendation.plan-heading":[{"type":0,"value":"Plan"}],"growth.admin-hub-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-dynamic-description.value-proposition":[{"type":0,"value":"Plan, track, and organize any project"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.confluence-apps-description":[{"type":0,"value":"Jira, video, and AI"}],"growth.recommendation-twc.confluence-apps-title":[{"type":0,"value":"Apps that click with Confluence"}],"growth.recommendation-twc.image-alt-text":[{"type":0,"value":"Rovo and Loom"}],"growth.recommendation-twc.jira-apps-description":[{"type":0,"value":"Add video and AI to Jira to work smarter."}],"growth.recommendation-twc.jira-apps-title":[{"type":0,"value":"Transform teamwork"}],"growth.recommendation-twc.twc-apps-description":[{"type":0,"value":"Docs, video, and agents in one place"}],"growth.recommendation-twc.twc-apps-lozenge":[{"type":0,"value":"New"}],"growth.recommendation-twc.twc-apps-non-tech-description":[{"type":0,"value":"Connect plans and docs using AI"}],"growth.recommendation-twc.twc-apps-non-tech-title":[{"type":0,"value":"A smarter way to work"}],"growth.recommendation-twc.twc-apps-tech-description":[{"type":0,"value":"Work 3x faster with connected tools"}],"growth.recommendation-twc.twc-apps-tech-title":[{"type":0,"value":"Tools built for speed"}],"growth.recommendation-twc.twc-apps-title":[{"type":0,"value":"Work faster across tools"}],"growth.recommendation-twc.twc-image-alt-text":[{"type":0,"value":"Teamwork Collection"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.check-jira":[{"type":0,"value":"Check Jira"}],"post-office.growth.jira-activation-project-recommendation.hello-message":[{"type":0,"value":":wave: Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text":[{"type":0,"value":"Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."}],"post-office.growth.jira-activation-project-recommendation.messages-exist":[{"type":0,"value":"Don\u2019t forget to get caught up on your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"project"}]},"other":{"value":[{"type":0,"value":"projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":" in Jira! Take a quick look to get up-to-date on your teammates\u2019 progress."}],"post-office.growth.jira-activation-project-recommendation.see-projects":[{"type":0,"value":"See all projects"}],"post-office.growth.jira-activation-project-recommendation.you-have-messages":[{"offset":0,"options":{"=0":{"value":[]},"=1":{"value":[]},"=2":{"value":[{"type":0,"value":"You have *two projects*:"}]},"=3":{"value":[{"type":0,"value":"You have *three projects*:"}]},"other":{"value":[{"type":0,"value":"You have *"},{"options":{"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects*. Here are three to get you started:"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork":[{"type":0,"value":"the tools you use (Jira)"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify":[{"type":0,"value":"the way you use your existing tools and apps"}],"post-office.nav-4-projects-recommendations.reasons-modal-explanation":[{"type":0,"value":"We think "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"rovo-3p-party-integration-admin-nudge.action.connect":[{"type":0,"value":"Connect now"}],"rovo-3p-party-integration-admin-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-three-apps":[{"type":0,"value":"Over 90% of your team shares content on "},{"type":1,"value":"appName"},{"type":0,"value":", "},{"type":1,"value":"secondAppName"},{"type":0,"value":", and other apps. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-two-apps":[{"type":0,"value":"Over 90% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.low-percentage":[{"type":0,"value":"Most of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.more-than-two-apps":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team shares content on "},{"type":1,"value":"appName"},{"type":0,"value":", "},{"type":1,"value":"secondAppName"},{"type":0,"value":", and other apps. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.one-app":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.more-apps-label":[{"type":0,"value":"More apps"}],"rovo-3p-party-integration-admin-nudge.title.more-than-two-apps":[{"type":0,"value":"Connect more apps"}],"rovo-3p-party-integration-admin-nudge.title.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"rovo-3p-party-integration-admin-nudge.title.two-apps":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" and "},{"type":1,"value":"secondAppName"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("9DoTa", function(module, exports) {

let $703b0ff5e45f39ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $703b0ff5e45f39ca$var$load("i5eMd").then(()=>parcelRequire('bvjlk'));

});

parcelRegister("4qglW", function(module, exports) {

let $33864678917c99b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33864678917c99b3$var$load("4UPfH").then(()=>parcelRequire('IzetR'));

});

parcelRegister("bfbM8", function(module, exports) {

let $82fa3abe0ee41d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82fa3abe0ee41d1e$var$load("gd4qs").then(()=>parcelRequire('b60fG'));

});

parcelRegister("auur8", function(module, exports) {

let $7a3450d5cacf3802$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a3450d5cacf3802$var$load("fviv5").then(()=>parcelRequire('d1j2S'));

});

parcelRegister("hqlmj", function(module, exports) {

let $caf56ecfe84fe48c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf56ecfe84fe48c$var$load("hEkXc").then(()=>parcelRequire('dnFPq'));

});

parcelRegister("4LGQD", function(module, exports) {

let $378cc9e57c8473fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $378cc9e57c8473fa$var$load("6oOC9").then(()=>parcelRequire('4WIcD'));

});

parcelRegister("iQahz", function(module, exports) {

let $db750f2ad2fc95cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db750f2ad2fc95cb$var$load("le1sE").then(()=>parcelRequire('7DdDO'));

});

parcelRegister("1vN03", function(module, exports) {

let $119eb210e4162adb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $119eb210e4162adb$var$load("eBoC7").then(()=>parcelRequire('hWRzS'));

});

parcelRegister("l8F02", function(module, exports) {

let $f63a26007ba32907$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f63a26007ba32907$var$load("bNv64").then(()=>parcelRequire('c7q37'));

});

parcelRegister("4lx9v", function(module, exports) {

let $32a2d6f90f7dc6dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32a2d6f90f7dc6dd$var$load("bAoKR").then(()=>parcelRequire('6eH2E'));

});

parcelRegister("7SJgz", function(module, exports) {

let $5bd0b07a6c7362cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bd0b07a6c7362cc$var$load("4Afgd").then(()=>parcelRequire('Plo13'));

});

parcelRegister("2hAcG", function(module, exports) {

let $1a99408df5c40000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a99408df5c40000$var$load("cMubu").then(()=>parcelRequire('iY0zC'));

});

parcelRegister("3KRsA", function(module, exports) {

let $2bbf230e3c7786a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bbf230e3c7786a6$var$load("oUCro").then(()=>parcelRequire('6luhh'));

});

parcelRegister("lorva", function(module, exports) {

let $f9312c1c621b494e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9312c1c621b494e$var$load("3fLE9").then(()=>parcelRequire('lqPAG'));

});

parcelRegister("7z1yN", function(module, exports) {

let $581d0323511a36f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $581d0323511a36f5$var$load("8hOn0").then(()=>parcelRequire('85Nk7'));

});

parcelRegister("6Lmbg", function(module, exports) {

let $4ec85677d908e5ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ec85677d908e5ea$var$load("h4OCL").then(()=>parcelRequire('gdGRk'));

});

parcelRegister("hDbAj", function(module, exports) {

let $cd5f10a6a7e39aac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd5f10a6a7e39aac$var$load("bcQs2").then(()=>parcelRequire('eVsDT'));

});

parcelRegister("ifA95", function(module, exports) {

let $d495aa769fbc0b39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d495aa769fbc0b39$var$load("aBa7j").then(()=>parcelRequire('76Zjl'));

});

parcelRegister("c8rti", function(module, exports) {

let $8d5b8aafb917ed74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d5b8aafb917ed74$var$load("b544F").then(()=>parcelRequire('8JOK1'));

});

parcelRegister("kWAHY", function(module, exports) {

let $f3f5b2f1a0e0f500$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3f5b2f1a0e0f500$var$load("K6fhx").then(()=>parcelRequire('5eTse'));

});

parcelRegister("8m74M", function(module, exports) {

let $6155ddfe74a250ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6155ddfe74a250ea$var$load("gZU54").then(()=>parcelRequire('1OKs8'));

});

parcelRegister("cHbRQ", function(module, exports) {

let $93e2b4d7e19c96a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93e2b4d7e19c96a8$var$load("hlJc4").then(()=>parcelRequire('Xa5VS'));

});

parcelRegister("iginQ", function(module, exports) {

let $d4b7fb3604fa2dd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4b7fb3604fa2dd6$var$load("4Wdqb").then(()=>parcelRequire('7W27q'));

});

parcelRegister("buteN", function(module, exports) {

let $85d92d084d6748bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85d92d084d6748bf$var$load("bJMZS").then(()=>parcelRequire('hu9se'));

});

parcelRegister("kXpFG", function(module, exports) {

let $03eff490f7a06afd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03eff490f7a06afd$var$load("exiT6").then(()=>parcelRequire('llE8x'));

});

parcelRegister("6DRMN", function(module, exports) {

let $4d601b614fe17619$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d601b614fe17619$var$load("jLkRH").then(()=>parcelRequire('195GW'));

});

parcelRegister("bytiP", function(module, exports) {

let $8699999c641b845b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8699999c641b845b$var$load("dmrYq").then(()=>parcelRequire('inCkW'));

});

parcelRegister("5eaPb", function(module, exports) {

let $3ce6a816be8813ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ce6a816be8813ae$var$load("k10Cs").then(()=>parcelRequire('6CeqQ'));

});

parcelRegister("2JhNV", function(module, exports) {

let $1fcd9849f2e198be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fcd9849f2e198be$var$load("g5LV7").then(()=>parcelRequire('88szQ'));

});

parcelRegister("lJjy6", function(module, exports) {

let $fd1cf6ff1ab4b3c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd1cf6ff1ab4b3c6$var$load("1n8w9").then(()=>parcelRequire('8mq9f'));

});

parcelRegister("hqddP", function(module, exports) {

let $caef1efdd7b47752$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caef1efdd7b47752$var$load("2QtDQ").then(()=>parcelRequire('gOCry'));

});

parcelRegister("lRJ6S", function(module, exports) {

let $feb18a1e86664bd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $feb18a1e86664bd6$var$load("i2vEA").then(()=>parcelRequire('8bOb4'));

});

parcelRegister("dNB4M", function(module, exports) {

let $a0bc9c843510574d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0bc9c843510574d$var$load("f1B4n").then(()=>parcelRequire('03O98'));

});

parcelRegister("aazgg", function(module, exports) {

let $767630bad9dc7d72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767630bad9dc7d72$var$load("l079e").then(()=>parcelRequire('eLabs'));

});

parcelRegister("cGs9w", function(module, exports) {
module.exports = JSON.parse('{"INAPP-2131.spotlight.body":[{"type":0,"value":"We\'ve added Confluence so you can organize all of your project documentation. It\'s free for up to 10 users."}],"INAPP-2131.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"INAPP-2270.spotlight.body":[{"type":0,"value":"Collaborate on requirements, meetings notes, retros, and more."}],"INAPP-2270.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2270.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2270.spotlight.title":[{"type":0,"value":"Create docs without leaving Jira"}],"INAPP-2271.spotlight.body":[{"type":0,"value":"Create a single source of truth for your project docs. It\'s free to try."}],"INAPP-2271.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2271.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2271.spotlight.title":[{"type":0,"value":"You have Confluence!"}],"growth-starburst.common.arrow-right.alt-text":[{"type":0,"value":"Arrow right"}],"growth-starburst.common.bundled-existing-apps.header":[{"type":0,"value":"Bundled with your existing apps"}],"growth-starburst.common.icon-check-circle-blue.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-starburst.common.icon-confluence.alt-text":[{"type":0,"value":"Icon - Confluence"}],"growth-starburst.common.icon-jira.alt-text":[{"type":0,"value":"Icon - Jira"}],"growth-starburst.common.icon-loom.alt-text":[{"type":0,"value":"Icon - Loom"}],"growth-starburst.common.icon-rovo.alt-text":[{"type":0,"value":"Icon - Rovo"}],"growth-starburst.common.percentage.alt-text":[{"type":0,"value":"Percentage "},{"type":1,"value":"percentage"}],"growth-starburst.common.pro-tip.alt-text":[{"type":0,"value":"Pro tip"}],"growth-starburst.common.twc-email-summary.confluence":[{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"b"},{"type":0,"value":" - Idea & knowledge sharing"}],"growth-starburst.common.twc-email-summary.header":[{"type":0,"value":"Your Teamwork Collection gives you access to:"}],"growth-starburst.common.twc-email-summary.jira":[{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"b"},{"type":0,"value":" - Work planning & tracking"}],"growth-starburst.common.twc-email-summary.loom":[{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" - Async video communication"}],"growth-starburst.common.twc-email-summary.rovo":[{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"},{"type":0,"value":" - AI Chat, Search & a team of specialized Agents"}],"growth-starburst.ep-migration-inapp-3280.description":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"growth-starburst.ep-migration-inapp-3280.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3280.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3280.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.ep-migration-inapp-3282.description":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"growth-starburst.ep-migration-inapp-3282.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3282.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3282.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.description":[{"type":0,"value":"Try summarizing or generating more content with AI. You can always come back to this panel."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.description":[{"type":0,"value":"Try Keep adding content to your page. You can type /ai to prompt AI."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.description":[{"type":0,"value":"Create docs directly in Jira to capture work, strategy, and more \u2014 with AI doing the heavy lifting."}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.title":[{"type":0,"value":"Turn ideas into docs instantly with AI"}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.description":[{"type":0,"value":"Create video messages using Loom to talk through updates, feedback, or upcoming work."}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.title":[{"type":0,"value":"Record & share videos"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.explore":[{"type":0,"value":"Explore"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.next":[{"type":0,"value":"Next"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.skip":[{"type":0,"value":"Dismiss"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-enabled":[{"type":0,"value":"enabled"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-label":[{"type":0,"value":"Auto advance:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.dismiss-button":[{"type":0,"value":"Dismiss Tour"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.start-from-step-label":[{"type":0,"value":"Start from step:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.steps-label":[{"type":0,"value":"Steps:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.title":[{"type":0,"value":"TWC Spotlight Tour Test"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-confluence":[{"type":0,"value":"Create documents in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"b"},{"type":0,"value":" to share knowledge"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-jira":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"b"},{"type":0,"value":" to organize and plan projects"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.premium":[{"type":0,"value":"Save time with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" and get AI-generated meeting recaps"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.standard":[{"type":0,"value":"Save time with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" and record async video updates"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-rovo":[{"type":0,"value":"Get AI-powered help and keep work moving with "},{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.description":[{"type":0,"value":"Teamwork Collection brings together Jira, Confluence, Loom, and Rovo so you can plan, document, and collaborate across teams\u2014all in one place."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.explore-features-link":[{"type":0,"value":"Explore all features \u2192"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.features-title":[{"type":0,"value":"Finish work 3x faster with Teamwork Collection"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.get-started-button":[{"type":0,"value":"Get started"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.heading":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested to try Teamwork Collection"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.logo.alt":[{"type":0,"value":"Teamwork Collection Atlassian"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.premium":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", 30-day trial of Premium."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":", we\'ll remind you 3 days before your trial ends."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.standard":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", 14-day trial of Standard."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":", we\'ll remind you 3 days before your trial ends."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.visual.alt":[{"type":0,"value":"Teamwork Collection visual showing Jira, Confluence, Loom, and Rovo"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.subject":[{"type":0,"value":"Approval required:"},{"type":1,"value":"requesterName"},{"type":0,"value":" wants to try Teamwork Collection"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraConf":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Save time with AI-generated meeting notes and async video"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraConf":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.header.jiraConf":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Save time with AI-generated meeting notes and async video"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.step1Title.jiraConf":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email-price-savings.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.conf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.confAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jira":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.conf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.confAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jira":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.confAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.conf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.confAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jira":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.header.conf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.confAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jira":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork "},{"children":[{"type":0,"value":"3x faster"}],"type":8,"value":"blue"},{"type":0,"value":" with video and AI"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraConf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.conf":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.confAndLoom":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Reduce repetitive syncs and follow-ups \u2014 Loom videos and automated recaps keep everyone aligned."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndLoom":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.conf":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.confAndLoom":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jira":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndLoom":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.conf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.confAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jira":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.conf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.confAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jira":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.conf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.jira":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.conf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.jira":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.conf":[{"type":0,"value":"Try Jira today to make getting work done a snap!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jira":[{"type":0,"value":"Try Confluence today to start connecting org-wide knowledge to your work."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.land":[{"type":0,"value":"Try out Confluence today to add context to your work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.land":[{"type":0,"value":"Bring your next big idea to life"}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.conf":[{"type":0,"value":"Use Jira to visualize your tasks and workflows. Plus, use AI-powered automations to get the whole team get moving fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jira":[{"type":0,"value":"Use Confluence to capture notes, draft plans, share project insights. Plus, keep it all organized alongside Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jiraConf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.land":[{"type":0,"value":"Hit \u201CCreate\u201D in Confluence to jot down notes, draft plans, or share learnings. Pick a ready-made template to start fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Jira & Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Confluence & Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDDBC\uFE0F See the full picture for your projects"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.conf":[{"type":0,"value":"Plan it, track it, get it done"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jira":[{"type":0,"value":"Go from cluttered docs to organized knowledge"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jiraConf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.land":[{"type":0,"value":"Say \u201Cgoodbye\u201D to boring project docs"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jiraConf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Jira views as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Confluence docs as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jiraConf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jiraConf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.conf":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange issues in columns, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" over months or quarters."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jira":[{"type":0,"value":"Add Jira boards, Google forms, Figma designs, Excel spreadsheets & more\u2014right into Confluence. It\'s your team\'s new single source of truth!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.land":[{"type":0,"value":"Embed Jira views, reports, and forms directly into Confluence pages with Smart Links."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.conf":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jira":[{"type":0,"value":"Connect your work from anywhere"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.land":[{"type":0,"value":"Keep it all in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.conf":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jira":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.land":[{"type":0,"value":"Let AI automatically turn Confluence pages and whiteboards into trackable work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.conf":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jira":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.land":[{"type":0,"value":"Transform ideas into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.conf":[{"type":0,"value":"Create and edit Confluence docs and whiteboards right inside Jira to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jira":[{"type":0,"value":"Create and edit docs, whiteboards (anything, really!) right inside Confluence to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.land":[{"type":0,"value":"View, edit, and create Confluence pages and whiteboards right from Jira, without losing context."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.conf":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jira":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.land":[{"type":0,"value":"View work across teams"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.conf":[{"type":0,"value":"Our top tips for planning and tracking work:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jira":[{"type":0,"value":"Our top tips for connecting team knowledge:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jiraConf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.land":[{"type":0,"value":"How to plan, track, and doc with Confluence and Jira:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.conf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jira":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Chat with Rovo AI today to get on the fast-track to productivity."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.land":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to try out Rovo AI?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.conf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jira":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jiraConf":[{"type":0,"value":"Summarize, search, and streamline any task. No context-switching, no searching\u2014just better results."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.land":[{"type":0,"value":"Record a Loom video to add visual context to project updates, presentations, and training materials in Jira and Confluence."}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD2B Your secret to better, faster teamwork"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.conf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jira":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jiraConf":[{"type":0,"value":"Get to \u201Cdone\u201D faster with Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.land":[{"type":0,"value":"Bring work to life with video"}],"growth-starburst.twc-onboarding-email-2.message-template.email.item1.jiraConf":[{"children":[{"type":0,"value":"Take action in a flash"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Chat with Rovo AI to summarize updates, create tasks, and draft content in seconds."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item2.jiraConf":[{"children":[{"type":0,"value":"Find, don\'t search"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Rovo AI Search provides rich, contextual answers grounded in your org\'s knowledge, history, and context."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item3.jiraConf":[{"children":[{"type":0,"value":"Say \u201Chey\u201D to your AI teammate"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Call on Rovo to tackle any task and act on insights across all your apps and integrations."}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.land":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.land":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.conf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.jira":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.land":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.conf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.jira":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.land":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.conf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.jira":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.land":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.conf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.jira":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.land":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.conf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.jira":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.land":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.conf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.jira":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.land":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.conf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jira":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jiraConf":[{"type":0,"value":"Top tips for working smarter & speedier with Rovo AI:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.land":[{"type":0,"value":"How to work with AI-powered videos in Loom:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.conf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jira":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.land":[{"type":0,"value":"Use Rovo AI to turn deliver big ideas faster and collaborate as a human-AI team. Try out Rovo AI with your collection of apps today."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.conf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jira":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.land":[{"type":0,"value":"Discover a whole new way to teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.conf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jira":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jiraConf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.land":[{"type":0,"value":"Supercharge how you work with AI-powered Search, Chat, and Agents\u2014all integrated directly into Jira, Confluence, and Loom."}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83E\uDD29 Here\'s everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.conf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jira":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jiraConf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.land":[{"type":0,"value":"Get to \u201Cdone\u201D faster with your apps + Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipButtonText.land":[{"type":0,"value":"Read more"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipContent.land":[{"type":0,"value":"The Rovo guide introduces the basics of working with AI Search, Chat and agents."}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.conf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jira":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.land":[{"type":0,"value":"Need help dreaming up your next big idea? Brainstorm project docs and tasks with Rovo Chat to create everything you need in the blink of an eye."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.conf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jira":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.land":[{"type":0,"value":"Create anything in seconds!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.conf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jira":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.land":[{"type":0,"value":"Use Rovo AI to automatically scan Confluence pages for action items and turn them into Jira tasks with just a few clicks."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.conf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jira":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.land":[{"type":0,"value":"Transform pages into action"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.conf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jira":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.land":[{"type":0,"value":"Use Rovo AI to break your Jira work items into easily-achievable sub-tasks. Automatically surface related Confluence pages, and use them to create descriptions."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.conf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jira":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.land":[{"type":0,"value":"Instantly enhance your work"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Description.land":[{"type":0,"value":"Create and embed a Loom right from your Confluence page (along with AI-generated notes or action items!) and keep everyone in-the-know."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Title.land":[{"type":0,"value":"Auto-summarize with video"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.conf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jira":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jiraConf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.land":[{"type":0,"value":"Try this workflow for using Jira, Confluence, Loom, and Rovo together:"}],"growth-starburst.twc-onboarding-widget.onboarding-card.dismiss-tooltip":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-onboarding-widget.onboarding-card.status":[{"type":0,"value":"Completed"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.conf":[{"type":0,"value":"See how Jira, Loom, and Rovo plug into your Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jira":[{"type":0,"value":"See how Confluence, Loom, and Rovo plug into your Jira workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"See how Loom and Rovo plug into your Jira and Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.land":[{"type":0,"value":"Jump into Jira to create your first task"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.content.conf":[{"type":0,"value":"Your new collection of apps supercharges productivity with work tracking across teams, async video, and AI-powered insights\u2014all alongside Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.jira":[{"type":0,"value":"Your new collection of apps supercharges productivity with org-wide knowledge sharing, async video, and AI-powered insights\u2014all alongside Jira."}],"growth-starburst.twc-welcome-email.message-template.email.content.jiraConf":[{"type":0,"value":"Your new collection of apps supercharges productivity with async video and AI-powered insights\u2014all alongside Jira & Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.land":[{"type":0,"value":"Collaborate and achieve more\u2014right from day one. We\'ll guide you step-by-step over the next few days."}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.header.conf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jira":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jiraConf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.land":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create and share information effortlessly\u2014plan better, stay aligned, and keep everything you need right at your fingertips."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Send quick video messages that add context, save time, reduce meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.land":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"work items"}],"type":8,"value":"b"},{"type":0,"value":", which are chunks of work (just like to-dos) that you can break down into smaller, more achievable tasks."}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.conf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jira":[{"type":0,"value":"Organize knowledge with Confluence"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.land":[{"type":0,"value":"Break down your work"}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jira":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.land":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"fields"}],"type":8,"value":"b"},{"type":0,"value":" to include all the important details to your work items, like due dates, assignees, priority, and more."}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.conf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jira":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.land":[{"type":0,"value":"Add important details"}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.conf":[{"type":0,"value":"Plan and manage anything\u2014from big projects to daily tasks\u2014with seamless workflows, real-time tracking, and clear alignment to goals."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.jira":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.land":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange work items in columns and by status, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" view over months or quarters."}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.conf":[{"type":0,"value":"Get it done with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.jira":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.land":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.conf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jira":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jiraConf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.land":[{"type":0,"value":"We recommend starting with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.subheaderDescription.land":[{"type":0,"value":"Managing your projects starts with Jira. Start by setting things up to manage your work more efficiently:"}],"jira-project-space-connected.message-templates.spotlight-description-couse":[{"type":0,"value":"Create pages for your project without leaving Jira."}],"jira-project-space-connected.message-templates.spotlight-description-xflow":[{"type":0,"value":"Create Confluence pages within Jira. Free for 10 users."}],"jira-project-space-connected.message-templates.spotlight-header-couse":[{"type":0,"value":"Your project has Confluence pages"}],"jira-project-space-connected.message-templates.spotlight-header-xflow":[{"type":0,"value":"Add pages to your project"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body":[{"type":0,"value":"Instead of manually typing meeting notes, why not try Loom to record meetings?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close":[{"type":0,"value":"Close"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta":[{"type":0,"value":"Try now"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header":[{"type":0,"value":"Automate meeting notes"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt":[{"type":0,"value":"Notepad with sparkling background"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.for-you-spotlight-text":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.rovo-chat-spotlight-text":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.switcher-spotlight-text":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.townsquare-twc-modal.twc-modal-story.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-spotlight.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.twc-onboarding-modal.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-modal.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-modal.apps-icon-label":[{"type":0,"value":"Apps"}],"townsquare.twc-onboarding-modal.atlassian-home":[{"type":0,"value":"Access all your "},{"children":[{"type":0,"value":"work"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"spaces"}],"type":8,"value":"bold"},{"type":0,"value":" in Atlassian Home"}],"townsquare.twc-onboarding-modal.atlassian-logo-label":[{"type":0,"value":"Atlassian"}],"townsquare.twc-onboarding-modal.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-modal.close-button-label":[{"type":0,"value":"Close onboarding modal"}],"townsquare.twc-onboarding-modal.confluence-feature":[{"type":0,"value":"Document notes and knowledge in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.confluence-icon-label":[{"type":0,"value":"Confluence"}],"townsquare.twc-onboarding-modal.connect-integrations":[{"type":0,"value":"Connect work with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.connect-work-title":[{"type":0,"value":"Connect work across Atlassian"}],"townsquare.twc-onboarding-modal.description":[{"type":0,"value":"Collaborating is easier than ever with new apps and features, including AI-powered Search and Chat."}],"townsquare.twc-onboarding-modal.explore-atlassian-home":[{"type":0,"value":"Explore Atlassian Home"}],"townsquare.twc-onboarding-modal.explore-loom":[{"type":0,"value":"Explore Loom"}],"townsquare.twc-onboarding-modal.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-modal.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-modal.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-modal.got-it-button":[{"type":0,"value":"Got it"}],"townsquare.twc-onboarding-modal.home-icon-label":[{"type":0,"value":"Home"}],"townsquare.twc-onboarding-modal.illustration-alt":[{"type":0,"value":"Illustration showing collaborative teamwork with connected apps and AI-powered features"}],"townsquare.twc-onboarding-modal.integration-feature":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.integration-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.jira-confluence-features":[{"type":0,"value":"Add context in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"},{"type":0,"value":" with detailed docs in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-feature":[{"type":0,"value":"Map out your team\'s work and tasks in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-icon-label":[{"type":0,"value":"Jira"}],"townsquare.twc-onboarding-modal.left-align-icon-label":[{"type":0,"value":"Align Text Left"}],"townsquare.twc-onboarding-modal.loom-add-demos":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"demos"}],"type":8,"value":"bold"},{"type":0,"value":" and walkthroughs of your work in Jira"}],"townsquare.twc-onboarding-modal.loom-bring-together":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, goals, AI"}],"type":8,"value":"bold"},{"type":0,"value":", and more"}],"townsquare.twc-onboarding-modal.loom-description":[{"type":0,"value":"Loom makes it easy to record videos and streamline communication in the apps you already use:"}],"townsquare.twc-onboarding-modal.loom-feature":[{"type":0,"value":"Share and embed async video updates with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.loom-icon-label":[{"type":0,"value":"Loom"}],"townsquare.twc-onboarding-modal.loom-share-updates":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"},{"type":0,"value":" to easily share updates and knowledge"}],"townsquare.twc-onboarding-modal.loom-title":[{"type":0,"value":"Create better shareouts with Loom"}],"townsquare.twc-onboarding-modal.loom-use-videos":[{"type":0,"value":"Use videos to give "},{"children":[{"type":0,"value":"context"}],"type":8,"value":"bold"},{"type":0,"value":" to Confluence pages"}],"townsquare.twc-onboarding-modal.new-apps-one":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.new-apps-title":[{"type":0,"value":"New apps and features are here"}],"townsquare.twc-onboarding-modal.new-apps-two":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":1,"value":"appTwoName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-modal.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-modal.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-modal.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-modal.spotlight.close-button-label":[{"type":0,"value":"Close onboarding spotlight tour"}],"townsquare.twc-onboarding-modal.take-a-tour-button":[{"type":0,"value":"Take a tour"}],"townsquare.twc-onboarding-modal.teams-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.title":[{"type":0,"value":"Transform teamwork, together"}],"townsquare.twc-onboarding-modal.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-spotlight.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-spotlight.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-spotlight.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-spotlight.close-button-label":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-spotlight.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-spotlight.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-spotlight.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-spotlight.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-spotlight.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-spotlight.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-spotlight.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-spotlight.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-widget.chat-card.cta":[{"type":0,"value":"Try Chat"}],"townsquare.twc-onboarding-widget.chat-card.description":[{"type":0,"value":"Get helpful answers to your questions and collaborate with AI on your work."}],"townsquare.twc-onboarding-widget.chat-card.heading":[{"type":0,"value":"Chat with Rovo"}],"townsquare.twc-onboarding-widget.confluence-card.cta":[{"type":0,"value":"Try Confluence"}],"townsquare.twc-onboarding-widget.confluence-card.description":[{"type":0,"value":"Create a knowledge bank available to everyone in your team."}],"townsquare.twc-onboarding-widget.confluence-card.heading":[{"type":0,"value":"Write docs with Confluence"}],"townsquare.twc-onboarding-widget.goals-card.cta":[{"type":0,"value":"Try Goals"}],"townsquare.twc-onboarding-widget.goals-card.description":[{"type":0,"value":"Align your work with goals to make sure you are on track."}],"townsquare.twc-onboarding-widget.goals-card.heading":[{"type":0,"value":"Track progress with goals"}],"townsquare.twc-onboarding-widget.jira-card.cta":[{"type":0,"value":"Try Jira"}],"townsquare.twc-onboarding-widget.jira-card.description":[{"type":0,"value":"Create project tasks to begin managing your project."}],"townsquare.twc-onboarding-widget.jira-card.heading":[{"type":0,"value":"Plan out tasks with Jira"}],"townsquare.twc-onboarding-widget.loom-card.cta":[{"type":0,"value":"Try Loom"}],"townsquare.twc-onboarding-widget.loom-card.description":[{"type":0,"value":"Share async video updates and reduce meetings for all."}],"townsquare.twc-onboarding-widget.loom-card.heading":[{"type":0,"value":"Share updates with Loom"}],"townsquare.twc-onboarding-widget.search-card.cta":[{"type":0,"value":"Try Search"}],"townsquare.twc-onboarding-widget.search-card.description":[{"type":0,"value":"Power up your searches with AI and find what you\'re looking for faster."}],"townsquare.twc-onboarding-widget.search-card.heading":[{"type":0,"value":"Find more with Search"}],"townsquare.twc-onboarding-widget.studio-card.cta":[{"type":0,"value":"Try Studio"}],"townsquare.twc-onboarding-widget.studio-card.description":[{"type":0,"value":"Build custom AI agents, automations, and more without needing to code."}],"townsquare.twc-onboarding-widget.studio-card.heading":[{"type":0,"value":"Automate work with Studio"}],"townsquare.twc-onboarding-widget.teams-card.cta":[{"type":0,"value":"Try Teams"}],"townsquare.twc-onboarding-widget.teams-card.description":[{"type":0,"value":"Collaborate more with teams and unlock the power of your teammates."}],"townsquare.twc-onboarding-widget.teams-card.heading":[{"type":0,"value":"Collaborate with teams"}],"townsquare.twc-onboarding-widget.twc-card.cta":[{"type":0,"value":"Watch video"}],"townsquare.twc-onboarding-widget.twc-card.description":[{"type":0,"value":"Not sure where to start? Find out how your apps can streamline your work."}],"townsquare.twc-onboarding-widget.twc-card.heading":[{"type":0,"value":"See how it all works together"}],"townsquare.twc-onboarding-widget.twc-card.modal-close":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-widget.twc-card.modal-external-link":[{"type":0,"value":"Open link"}],"townsquare.twc-onboarding-widget.twc-card.modal-title":[{"type":0,"value":"Welcome to Atlassian"}],"twc.email.header.alt":[{"type":0,"value":"Teamwork Collection Atlassian"}]}');

});

parcelRegister("dhNNU", function(module, exports) {

let $9ac37ef3cce02440$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ac37ef3cce02440$var$load("aqnFU").then(()=>parcelRequire('jYKHD'));

});

parcelRegister("jeBuB", function(module, exports) {

let $e00c6860b85e4658$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e00c6860b85e4658$var$load("8IMxm").then(()=>parcelRequire('hNpkf'));

});

parcelRegister("j6f4O", function(module, exports) {

let $de7a45c5df1f7d9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de7a45c5df1f7d9b$var$load("5XnIl").then(()=>parcelRequire('a1RiA'));

});

parcelRegister("kD2zY", function(module, exports) {

let $f0497354db2fd90f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0497354db2fd90f$var$load("5Axcp").then(()=>parcelRequire('kdROr'));

});

parcelRegister("92Bya", function(module, exports) {

let $69516d9e1a6e32ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69516d9e1a6e32ef$var$load("8IMve").then(()=>parcelRequire('1Ek80'));

});

parcelRegister("aOWdw", function(module, exports) {

let $7e0bbb9b78325536$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e0bbb9b78325536$var$load("3Suyp").then(()=>parcelRequire('ei8yv'));

});

parcelRegister("7t4bC", function(module, exports) {

let $56fe7d2ca6661ff6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56fe7d2ca6661ff6$var$load("7QQXz").then(()=>parcelRequire('2PgcG'));

});

parcelRegister("7Sa8a", function(module, exports) {

let $5bb56f4d5ad59576$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bb56f4d5ad59576$var$load("9wHYa").then(()=>parcelRequire('1HGZy'));

});

parcelRegister("lXA5l", function(module, exports) {

let $ffcb1970202a00ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffcb1970202a00ac$var$load("amUuO").then(()=>parcelRequire('64R0b'));

});

parcelRegister("5aTpK", function(module, exports) {

let $3c48df106ec5adb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c48df106ec5adb9$var$load("hQmwz").then(()=>parcelRequire('hRXdX'));

});

parcelRegister("7fLFn", function(module, exports) {

let $547ee8ad6758eca1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $547ee8ad6758eca1$var$load("8u6e4").then(()=>parcelRequire('8kSz9'));

});

parcelRegister("lhgAS", function(module, exports) {

let $f7d80eb4c0ac4ee3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7d80eb4c0ac4ee3$var$load("d1pZ3").then(()=>parcelRequire('4vpaT'));

});

parcelRegister("lNiHq", function(module, exports) {

let $fddcade5dff993bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fddcade5dff993bf$var$load("sXDfU").then(()=>parcelRequire('9PwX5'));

});

parcelRegister("h1f53", function(module, exports) {

let $c63e3a5cec821530$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c63e3a5cec821530$var$load("5ktje").then(()=>parcelRequire('5j0tp'));

});

parcelRegister("9euo9", function(module, exports) {

let $6b8cfe60d53b77ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b8cfe60d53b77ed$var$load("6zSFk").then(()=>parcelRequire('8Q41L'));

});

parcelRegister("aQeTx", function(module, exports) {

let $7e4a50808c076bb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e4a50808c076bb7$var$load("5u7RJ").then(()=>parcelRequire('74Awr'));

});

parcelRegister("jKCUu", function(module, exports) {

let $e6107ef57df48fef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6107ef57df48fef$var$load("9igas").then(()=>parcelRequire('21oBo'));

});

parcelRegister("1u5LJ", function(module, exports) {

let $114d115e867eb5f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $114d115e867eb5f5$var$load("5VCId").then(()=>parcelRequire('1BVGI'));

});

parcelRegister("d2bnS", function(module, exports) {

let $97d44aeda7a6b877$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97d44aeda7a6b877$var$load("5U9Bf").then(()=>parcelRequire('dOoDk'));

});

parcelRegister("bd2Zq", function(module, exports) {

let $82933a480f2fd7de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82933a480f2fd7de$var$load("cJRtC").then(()=>parcelRequire('hJlwC'));

});

parcelRegister("1wPMw", function(module, exports) {

let $11d0f25b26cbc41f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11d0f25b26cbc41f$var$load("9CnFE").then(()=>parcelRequire('aLq5r'));

});

parcelRegister("gF5rz", function(module, exports) {

let $c214b2b320eec5d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c214b2b320eec5d6$var$load("kOzld").then(()=>parcelRequire('3mpWH'));

});

parcelRegister("elclF", function(module, exports) {

let $a70c9b059ae1b002$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a70c9b059ae1b002$var$load("72WHu").then(()=>parcelRequire('glQOK'));

});

parcelRegister("kbgzR", function(module, exports) {

let $eb11b1a98b3708c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb11b1a98b3708c0$var$load("8lLIr").then(()=>parcelRequire('gbPzc'));

});

parcelRegister("v1pT0", function(module, exports) {

let $05d3fea7fa91b50f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05d3fea7fa91b50f$var$load("8swF7").then(()=>parcelRequire('kf6KA'));

});

parcelRegister("l0Crr", function(module, exports) {

let $f4b76ac404019fb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4b76ac404019fb4$var$load("aM9Tn").then(()=>parcelRequire('jACzc'));

});

parcelRegister("9PZYW", function(module, exports) {

let $7298f4d07fde2f8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7298f4d07fde2f8e$var$load("dO5k0").then(()=>parcelRequire('27czT'));

});

parcelRegister("injBd", function(module, exports) {

let $d60993fd2ff869e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d60993fd2ff869e0$var$load("lGEzi").then(()=>parcelRequire('KrNgY'));

});

parcelRegister("hzgJF", function(module, exports) {

let $cca2afe71ba85f7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cca2afe71ba85f7e$var$load("dho0e").then(()=>parcelRequire('lxrg6'));

});

parcelRegister("2aS0a", function(module, exports) {

let $1956678aa30362a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1956678aa30362a8$var$load("blgK2").then(()=>parcelRequire('g4x51'));

});

parcelRegister("5cu4s", function(module, exports) {

let $3c95662b351ec287$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c95662b351ec287$var$load("vIWKw").then(()=>parcelRequire('5FvHz'));

});

parcelRegister("lplb2", function(module, exports) {

let $f95c5c15577a5f65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f95c5c15577a5f65$var$load("30rzZ").then(()=>parcelRequire('kFAfQ'));

});

parcelRegister("8nYPU", function(module, exports) {

let $61afa98769f6470c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61afa98769f6470c$var$load("bAque").then(()=>parcelRequire('aeOOR'));

});

parcelRegister("50zN1", function(module, exports) {

let $3a58b6ee5047b80c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a58b6ee5047b80c$var$load("80chk").then(()=>parcelRequire('58v4x'));

});

parcelRegister("8Wdqe", function(module, exports) {
module.exports = JSON.parse('{"jira-chronos.jira-plan-created-reminder-experiment.email.body.closing.no-translate":[{"type":0,"value":"Happy planning!"}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.completion-note.no-translate":[{"type":0,"value":"If you\'ve already completed these steps, you\'re good to go."}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.cta-button.no-translate":[{"type":0,"value":"Open your plan"}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.intro.no-translate":[{"type":0,"value":"You\'ve created a new Jira plan \u201C"},{"type":1,"value":"planTitle"},{"type":0,"value":"\u201D. Now let\'s unlock its full power."}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.see-big-picture.no-translate":[{"children":[{"type":0,"value":"See the big picture"}],"type":8,"value":"strong"},{"type":0,"value":". Your plan brings together work across teams, projects and releases into one roadmap."}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.signature.no-translate":[{"type":0,"value":"- The Jira Plans team \u2013 Atlassian"}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.stay-realistic.no-translate":[{"children":[{"type":0,"value":"Stay realistic"}],"type":8,"value":"strong"},{"type":0,"value":". Adjust your timeline view, filter and group by fields, and explore Capacity and Velocity. All so you know what your team can deliver and when."}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.turn-work-commitments.no-translate":[{"children":[{"type":0,"value":"Turn work into commitments"}],"type":8,"value":"strong"},{"type":0,"value":". Edit or create work items, assign your team, and link work with dependencies or releases so everyone knows what comes next."}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"jira-chronos.jira-plan-created-reminder-experiment.email.body.visualize-results.no-translate":[{"children":[{"type":0,"value":"Visualize results"}],"type":8,"value":"strong"},{"type":0,"value":". Use the Summary, Calendar, Dependencies and Program Board views to track progress, avoid surprises and keep delivery on track."}],"jira-chronos.jira-plan-created-reminder-experiment.message-template.email.subject.no-translate":[{"type":0,"value":"Your next steps in "},{"type":1,"value":"planTitle"},{"type":0,"value":" to plan and track complex work confidently"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.avatar.no-translate":[{"type":0,"value":"avatar"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.globe.no-translate":[{"type":0,"value":"globeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"planTitle"},{"type":0,"value":" "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.join.link":[{"type":0,"value":"Join the Plan"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.learn.more.message":[{"type":0,"value":"Learn more about Jira"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.logo.no-translate":[{"type":0,"value":"logo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template.dot":[{"type":0,"value":"."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.write.no-translate":[{"type":0,"value":"writeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"planTitle"},{"type":0,"value":")"}],"jira-plan-add-user-changeboarding.message-templates.spotlight-body":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Add people"}],"type":8,"value":"b"},{"type":0,"value":" in this menu to share this plan with people outside of your organization."}],"jira-plan-add-user-changeboarding.message-templates.spotlight-cta":[{"type":0,"value":"Close"}],"jira-plan-add-user-changeboarding.message-templates.spotlight-header":[{"type":0,"value":"Spread the good word"}],"jira-plans-efa-change-boarding.message-templates.flag.description":[{"type":0,"value":"Fields that aren\u2019t part of a project\u2019s configuration can no longer be used in your plan. In this case, add the fields to your project\u2019s field configuration to use them again."}],"jira-plans-efa-change-boarding.message-templates.flag.goToSettings":[{"type":0,"value":"Go to settings"}],"jira-plans-efa-change-boarding.message-templates.flag.read-more":[{"type":0,"value":"Read more"}],"jira-plans-efa-change-boarding.message-templates.flag.title":[{"type":0,"value":"Some fields in your plan might no longer be available for your projects."}]}');

});

parcelRegister("9VKWU", function(module, exports) {

let $73addb0820ce0cdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73addb0820ce0cdd$var$load("bFOLQ").then(()=>parcelRequire('jz6EW'));

});

parcelRegister("eEiCw", function(module, exports) {

let $aaa33ebe332c61ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aaa33ebe332c61ca$var$load("gZdcf").then(()=>parcelRequire('kJZys'));

});

parcelRegister("9JB41", function(module, exports) {

let $716511294ed5e6ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $716511294ed5e6ff$var$load("5XZYg").then(()=>parcelRequire('kELyd'));

});

parcelRegister("hV07a", function(module, exports) {

let $d0b7d94b8fb36f2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0b7d94b8fb36f2b$var$load("8606Q").then(()=>parcelRequire('ccqVV'));

});

parcelRegister("gDq2e", function(module, exports) {

let $c1c47bdcdec51882$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1c47bdcdec51882$var$load("iXY8o").then(()=>parcelRequire('2yT3X'));

});

parcelRegister("6bPds", function(module, exports) {

let $481b7f9e207b260c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $481b7f9e207b260c$var$load("aZgVL").then(()=>parcelRequire('JpnY2'));

});

parcelRegister("ecgTI", function(module, exports) {

let $02aad3cb334bf3af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $02aad3cb334bf3af$var$load("Opl2l").then(()=>parcelRequire('ixj8r'));

});

parcelRegister("6o8ua", function(module, exports) {

let $4a6b910c98f1dd38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a6b910c98f1dd38$var$load("6riHk").then(()=>parcelRequire('jXtba'));

});

parcelRegister("9QeTC", function(module, exports) {

let $72a486760866dc0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72a486760866dc0f$var$load("9YQYw").then(()=>parcelRequire('8HhNv'));

});

parcelRegister("8bUPH", function(module, exports) {

let $5f6b6f9d6980b45e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f6b6f9d6980b45e$var$load("ejbGK").then(()=>parcelRequire('4WZyG'));

});

parcelRegister("jydp9", function(module, exports) {

let $e3bb97287526de48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3bb97287526de48$var$load("6mjPT").then(()=>parcelRequire('3sE2m'));

});

parcelRegister("iloKM", function(module, exports) {

let $d5ad63b3d02b364a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5ad63b3d02b364a$var$load("epOmi").then(()=>parcelRequire('calXt'));

});

parcelRegister("dfyFv", function(module, exports) {

let $9a579187f46248ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a579187f46248ef$var$load("4WDAC").then(()=>parcelRequire('aDy4u'));

});

parcelRegister("kENzV", function(module, exports) {

let $f09e004da05b6026$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f09e004da05b6026$var$load("4qLQo").then(()=>parcelRequire('fKdvz'));

});

parcelRegister("6eell", function(module, exports) {

let $488f2d28f5fa2101$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $488f2d28f5fa2101$var$load("kX7CO").then(()=>parcelRequire('gbuK8'));

});

parcelRegister("1YD3M", function(module, exports) {

let $1709b18b46093cf4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1709b18b46093cf4$var$load("kVmkh").then(()=>parcelRequire('iiIWy'));

});

parcelRegister("4kGYK", function(module, exports) {

let $327a5e60fc471d5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $327a5e60fc471d5f$var$load("dta3s").then(()=>parcelRequire('6EtFI'));

});

parcelRegister("4Hq5s", function(module, exports) {

let $36bf69e7ec920a2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36bf69e7ec920a2a$var$load("cU1bg").then(()=>parcelRequire('31Mvf'));

});

parcelRegister("6Fddj", function(module, exports) {

let $4da0d26483d99cb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4da0d26483d99cb6$var$load("jixIn").then(()=>parcelRequire('b8C5r'));

});

parcelRegister("6BShP", function(module, exports) {

let $4d004ef65d82b7b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d004ef65d82b7b8$var$load("dnADU").then(()=>parcelRequire('lMHbT'));

});

parcelRegister("67yyE", function(module, exports) {

let $474e33f9eacecc73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $474e33f9eacecc73$var$load("lGjdm").then(()=>parcelRequire('2aBLw'));

});

parcelRegister("El8YA", function(module, exports) {

let $07942341592f7cea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07942341592f7cea$var$load("lln6F").then(()=>parcelRequire('i6sCI'));

});

parcelRegister("eYNBw", function(module, exports) {

let $ae7d25a50307b6fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae7d25a50307b6fe$var$load("hQkGr").then(()=>parcelRequire('aQ86W'));

});

parcelRegister("dEblD", function(module, exports) {

let $9ef7d0457ffc7b29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ef7d0457ffc7b29$var$load("aWeYx").then(()=>parcelRequire('5kIN6'));

});

parcelRegister("jh6sZ", function(module, exports) {

let $e0849eff528e9b9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0849eff528e9b9b$var$load("fyJlv").then(()=>parcelRequire('kwNO6'));

});

parcelRegister("eAgqe", function(module, exports) {

let $a9e12a9079550183$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9e12a9079550183$var$load("6RpIk").then(()=>parcelRequire('1QaNg'));

});

parcelRegister("7LJh0", function(module, exports) {

let $5a800a8570381111$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a800a8570381111$var$load("bV9I0").then(()=>parcelRequire('fROot'));

});

parcelRegister("aqwUD", function(module, exports) {

let $7975dcd4c42a666f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7975dcd4c42a666f$var$load("9Eycr").then(()=>parcelRequire('jb76V'));

});

parcelRegister("2JiTe", function(module, exports) {

let $1fce6fd8b2d94118$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fce6fd8b2d94118$var$load("5wUQd").then(()=>parcelRequire('4s9GW'));

});

parcelRegister("4gyuP", function(module, exports) {

let $31b36a4d0f3d182b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31b36a4d0f3d182b$var$load("akLPz").then(()=>parcelRequire('8N9fs'));

});

parcelRegister("2cyZP", function(module, exports) {

let $19a7d945ea0dea26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19a7d945ea0dea26$var$load("6yBZZ").then(()=>parcelRequire('huhfR'));

});

parcelRegister("hhfGW", function(module, exports) {

let $c94032366bea9084$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c94032366bea9084$var$load("jKEvE").then(()=>parcelRequire('3RgGT'));

});

parcelRegister("gvgJi", function(module, exports) {

let $c03c84c37c5f8f3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c03c84c37c5f8f3d$var$load("jqOKH").then(()=>parcelRequire('acqAM'));

});

parcelRegister("btEIp", function(module, exports) {

let $85b1fc5592c7c3aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85b1fc5592c7c3aa$var$load("98LiC").then(()=>parcelRequire('1dTgQ'));

});

parcelRegister("5U1zM", function(module, exports) {
module.exports = JSON.parse("{\"jira-board-inline-editing-onboarding.message-templates.ok-button\":[{\"type\":0,\"value\":\"OK\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-body\":[{\"type\":0,\"value\":\"You can now edit fields like the summary, assignee, parent and estimate. Select the fields to edit them.\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-header\":[{\"type\":0,\"value\":\"Edit details of the work item directly in the board\"}]}");

});

parcelRegister("kCxZ5", function(module, exports) {

let $f031b7d3c404d102$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f031b7d3c404d102$var$load("hLQnq").then(()=>parcelRequire('dHAUx'));

});

parcelRegister("alWoE", function(module, exports) {

let $789929e71d5d2b4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $789929e71d5d2b4a$var$load("bfeTU").then(()=>parcelRequire('dyPRF'));

});

parcelRegister("2k0yx", function(module, exports) {

let $1b0de17754e5ac3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b0de17754e5ac3c$var$load("j5WDM").then(()=>parcelRequire('2wY3J'));

});

parcelRegister("iFxq4", function(module, exports) {

let $d975fac433438bd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d975fac433438bd1$var$load("aqPSc").then(()=>parcelRequire('5KA11'));

});

parcelRegister("3Xjc2", function(module, exports) {

let $2e15c522b2aa714b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e15c522b2aa714b$var$load("3fp4P").then(()=>parcelRequire('emAAV'));

});

parcelRegister("51O5A", function(module, exports) {

let $3a93e666a4241d84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a93e666a4241d84$var$load("himgz").then(()=>parcelRequire('6glWt'));

});

parcelRegister("dnjzB", function(module, exports) {

let $9bcc9b300b42e015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bcc9b300b42e015$var$load("geKrL").then(()=>parcelRequire('erYks'));

});

parcelRegister("ahSoT", function(module, exports) {

let $77d5b0b72510c876$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77d5b0b72510c876$var$load("lO9sq").then(()=>parcelRequire('hckSd'));

});

parcelRegister("cJXik", function(module, exports) {

let $9467aeafd1ba55e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9467aeafd1ba55e4$var$load("9AR7a").then(()=>parcelRequire('5uJ2G'));

});

parcelRegister("3f0Fr", function(module, exports) {

let $25c34a52bb42cbd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25c34a52bb42cbd9$var$load("qq3t5").then(()=>parcelRequire('fh3pW'));

});

parcelRegister("iWQO6", function(module, exports) {

let $dcb69b2b850efa93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcb69b2b850efa93$var$load("b6ipk").then(()=>parcelRequire('ent0H'));

});

parcelRegister("c6nXU", function(module, exports) {

let $8cf8a295bc6d1166$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cf8a295bc6d1166$var$load("aXBcV").then(()=>parcelRequire('kWwKq'));

});

parcelRegister("7M0f6", function(module, exports) {

let $5a8d344a04c3a384$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a8d344a04c3a384$var$load("7lkW2").then(()=>parcelRequire('dhhKL'));

});

parcelRegister("15WTx", function(module, exports) {

let $0cc3f15d30a33c53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cc3f15d30a33c53$var$load("fsTi2").then(()=>parcelRequire('bMgPR'));

});

parcelRegister("lAzjh", function(module, exports) {

let $fb785991d6fe2f8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb785991d6fe2f8d$var$load("jTqsp").then(()=>parcelRequire('lhJ8i'));

});

parcelRegister("beV3E", function(module, exports) {

let $82ed430c171f0a06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82ed430c171f0a06$var$load("jZRfO").then(()=>parcelRequire('eerah'));

});

parcelRegister("8Kz2Z", function(module, exports) {

let $65edce416b792a5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65edce416b792a5d$var$load("5fOvo").then(()=>parcelRequire('cCvPR'));

});

parcelRegister("aFbGF", function(module, exports) {

let $7c36cc8d34c45179$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c36cc8d34c45179$var$load("jw6Fw").then(()=>parcelRequire('6BnaY'));

});

parcelRegister("a24Sy", function(module, exports) {

let $74dde01ea109e0b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74dde01ea109e0b2$var$load("hWm6t").then(()=>parcelRequire('6B1xj'));

});

parcelRegister("6tcP1", function(module, exports) {

let $4b5f65aaa89b05d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4b5f65aaa89b05d9$var$load("ccP4M").then(()=>parcelRequire('2SgQR'));

});

parcelRegister("7kDLD", function(module, exports) {

let $55693f9c65f39d06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55693f9c65f39d06$var$load("d8SO1").then(()=>parcelRequire('awnz4'));

});

parcelRegister("9JcU7", function(module, exports) {

let $715253835f51dcd5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $715253835f51dcd5$var$load("eL5Xf").then(()=>parcelRequire('hD5rJ'));

});

parcelRegister("1eIXL", function(module, exports) {

let $0e69f9f9875dc783$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e69f9f9875dc783$var$load("GcGD5").then(()=>parcelRequire('i692O'));

});

parcelRegister("ik5VI", function(module, exports) {

let $d56eb1d2e65d0188$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d56eb1d2e65d0188$var$load("1Tmeq").then(()=>parcelRequire('c9IZL'));

});

parcelRegister("1wmX4", function(module, exports) {

let $11ba955453896f1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11ba955453896f1f$var$load("aDUXT").then(()=>parcelRequire('5YVNj'));

});

parcelRegister("gJj4D", function(module, exports) {

let $c2dfa4f0bb3b13de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2dfa4f0bb3b13de$var$load("32RHR").then(()=>parcelRequire('bXJLo'));

});

parcelRegister("kGFwa", function(module, exports) {

let $f0f7ef7c0e47b464$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0f7ef7c0e47b464$var$load("fLRnq").then(()=>parcelRequire('1NLDX'));

});

parcelRegister("6XJTT", function(module, exports) {

let $511bdb9f7bc5dbdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $511bdb9f7bc5dbdd$var$load("6w1yT").then(()=>parcelRequire('3nNhz'));

});

parcelRegister("cDsqP", function(module, exports) {

let $932f2e7a3b909c04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $932f2e7a3b909c04$var$load("4UKLt").then(()=>parcelRequire('5Lgid'));

});

parcelRegister("1sfji", function(module, exports) {

let $10f448495e6b0db7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $10f448495e6b0db7$var$load("4ryKW").then(()=>parcelRequire('4o595'));

});

parcelRegister("hwmk8", function(module, exports) {

let $cc16bdde0ed03975$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc16bdde0ed03975$var$load("bQxQQ").then(()=>parcelRequire('avO0W'));

});

parcelRegister("8aXh4", function(module, exports) {

let $5f3d3c924666bf8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f3d3c924666bf8a$var$load("lQN2i").then(()=>parcelRequire('juvgQ'));

});

parcelRegister("gAZxn", function(module, exports) {

let $c14fbe282a1fa120$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c14fbe282a1fa120$var$load("8x856").then(()=>parcelRequire('Jxc1c'));

});

parcelRegister("2LLiX", function(module, exports) {

let $2044aa470f0e84f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2044aa470f0e84f3$var$load("hOgqE").then(()=>parcelRequire('gnTSm'));

});

parcelRegister("6rGkx", function(module, exports) {
module.exports = JSON.parse("{\"dismissButton\":[{\"type\":0,\"value\":\"OK\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved the status and resolution field to the left\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved status to the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"post-office.jira-issueview-status.main-heading.no-translate\":[{\"type\":0,\"value\":\"Welcome to Jira Issue View Status\"}]}");

});

parcelRegister("btONi", function(module, exports) {

let $85b9cdcf25dd52f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85b9cdcf25dd52f7$var$load("afHt5").then(()=>parcelRequire('1FuKj'));

});

parcelRegister("cVlbZ", function(module, exports) {

let $968b3f442ff2a2dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $968b3f442ff2a2dd$var$load("aiHku").then(()=>parcelRequire('8nmXG'));

});

parcelRegister("kBSwR", function(module, exports) {

let $f0118fa6fcb53653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0118fa6fcb53653$var$load("iRgSc").then(()=>parcelRequire('cMVtX'));

});

parcelRegister("iq2Ha", function(module, exports) {

let $d68cbee664c2fecd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d68cbee664c2fecd$var$load("hASKq").then(()=>parcelRequire('aApJ5'));

});

parcelRegister("5Za3J", function(module, exports) {

let $45ba73cc64f2355e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45ba73cc64f2355e$var$load("lRPUn").then(()=>parcelRequire('h7M99'));

});

parcelRegister("7qdcA", function(module, exports) {

let $567533c2e9d06dd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $567533c2e9d06dd9$var$load("1Io1M").then(()=>parcelRequire('jnFeZ'));

});

parcelRegister("fVPDF", function(module, exports) {

let $b9943c4ba9e7a1e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b9943c4ba9e7a1e9$var$load("kEVX0").then(()=>parcelRequire('2r6Al'));

});

parcelRegister("18JTz", function(module, exports) {

let $0d4a23a70c0e9c3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d4a23a70c0e9c3e$var$load("goPCF").then(()=>parcelRequire('ekjQz'));

});

parcelRegister("dO75E", function(module, exports) {

let $a0d571ce7a7b8f51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0d571ce7a7b8f51$var$load("hdQ3n").then(()=>parcelRequire('gZWG2'));

});

parcelRegister("6nyeE", function(module, exports) {

let $4a4f7278b21f97fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a4f7278b21f97fd$var$load("54HVR").then(()=>parcelRequire('96u8o'));

});

parcelRegister("lyfNH", function(module, exports) {

let $fb09079ab5fea915$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb09079ab5fea915$var$load("kiXKy").then(()=>parcelRequire('lnh2Q'));

});

parcelRegister("3EeAE", function(module, exports) {

let $2a806cd81043989b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a806cd81043989b$var$load("8GmfZ").then(()=>parcelRequire('fTiqQ'));

});

parcelRegister("hqdIj", function(module, exports) {

let $caef80a8ec22893d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caef80a8ec22893d$var$load("cMMJw").then(()=>parcelRequire('iFazd'));

});

parcelRegister("dW9f5", function(module, exports) {

let $a257dc7802e257e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a257dc7802e257e7$var$load("aJNOs").then(()=>parcelRequire('Zqh0A'));

});

parcelRegister("9wfQB", function(module, exports) {

let $6ee36532f62a0c6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ee36532f62a0c6b$var$load("6MZNE").then(()=>parcelRequire('cseSs'));

});

parcelRegister("hRkFc", function(module, exports) {

let $d0076a416b9bbb5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0076a416b9bbb5d$var$load("iJpVF").then(()=>parcelRequire('f5Tod'));

});

parcelRegister("ddJov", function(module, exports) {

let $99ffb39bf3a1fbe9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ffb39bf3a1fbe9$var$load("7PL9E").then(()=>parcelRequire('dNRCe'));

});

parcelRegister("jigr4", function(module, exports) {

let $039ff154b6372d4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $039ff154b6372d4a$var$load("eSmn9").then(()=>parcelRequire('88yes'));

});

parcelRegister("54TR9", function(module, exports) {

let $3b28a75741e2bc3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b28a75741e2bc3d$var$load("h5vux").then(()=>parcelRequire('kyT0s'));

});

parcelRegister("ecgqg", function(module, exports) {

let $a55eece13787ff2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a55eece13787ff2b$var$load("dzp9v").then(()=>parcelRequire('u4lEZ'));

});

parcelRegister("kNY9t", function(module, exports) {

let $f2570b2033c2bb21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2570b2033c2bb21$var$load("lfV4b").then(()=>parcelRequire('c88aq'));

});

parcelRegister("6R1Tz", function(module, exports) {

let $4fd929ac5fa476f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fd929ac5fa476f5$var$load("hnzJi").then(()=>parcelRequire('3mVC3'));

});

parcelRegister("1OM09", function(module, exports) {

let $152fb20e6f7df686$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $152fb20e6f7df686$var$load("1VEoh").then(()=>parcelRequire('2e4bZ'));

});

parcelRegister("2VfZD", function(module, exports) {

let $220d4f8f4f192e70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $220d4f8f4f192e70$var$load("3C3qD").then(()=>parcelRequire('aTlUh'));

});

parcelRegister("bzCDp", function(module, exports) {

let $86d0ee9ea90e9c75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86d0ee9ea90e9c75$var$load("Ju5La").then(()=>parcelRequire('c7rEO'));

});

parcelRegister("aMyR0", function(module, exports) {

let $7d996c5c38523de8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d996c5c38523de8$var$load("2fDar").then(()=>parcelRequire('lXziF'));

});

parcelRegister("7AUrQ", function(module, exports) {

let $5877ae99e288e5b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5877ae99e288e5b3$var$load("hBNuK").then(()=>parcelRequire('6021Z'));

});

parcelRegister("2PyPc", function(module, exports) {

let $20fb5bad14e1f439$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20fb5bad14e1f439$var$load("5O05U").then(()=>parcelRequire('lyys6'));

});

parcelRegister("YyzdC", function(module, exports) {

let $0b606b018b993099$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b606b018b993099$var$load("3XRbj").then(()=>parcelRequire('c3Tsk'));

});

parcelRegister("iURxI", function(module, exports) {

let $dc56fd7317ef715e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc56fd7317ef715e$var$load("4315y").then(()=>parcelRequire('4GuUb'));

});

parcelRegister("hTDKi", function(module, exports) {

let $d07667694c778e94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d07667694c778e94$var$load("j315U").then(()=>parcelRequire('liO2D'));

});

parcelRegister("a1UKY", function(module, exports) {

let $74d60616fa9488aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74d60616fa9488aa$var$load("9yiBg").then(()=>parcelRequire('h1ytc'));

});

parcelRegister("i0vtB", function(module, exports) {

let $d1c0a4a3c6816817$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1c0a4a3c6816817$var$load("i4Skc").then(()=>parcelRequire('6I2GO'));

});

parcelRegister("6xqzX", function(module, exports) {

let $4c2a713064ae1684$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c2a713064ae1684$var$load("gE1SW").then(()=>parcelRequire('g0ggp'));

});

parcelRegister("kKV5X", function(module, exports) {
module.exports = JSON.parse("{\"jira-nin-grid-navigation-onboarding.closeButton\":[{\"type\":0,\"value\":\"Close\"}],\"jira-nin-grid-navigation-onboarding.enterEscapeNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Enter\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" activates inline edit mode while \"},{\"children\":[{\"type\":0,\"value\":\"Escape\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" returns you to cell navigation.\"}],\"jira-nin-grid-navigation-onboarding.heading\":[{\"type\":0,\"value\":\"Improved keyboard navigation\"}],\"jira-nin-grid-navigation-onboarding.homeEndPageNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Home\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" skips to the first cell in a row, \"},{\"children\":[{\"type\":0,\"value\":\"End\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" to the last. \"},{\"children\":[{\"type\":0,\"value\":\"Page Down\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" scrolls 1 page down, \"},{\"children\":[{\"type\":0,\"value\":\"Page Up\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" scrolls 1 page up, keeping focus in the same cell.\"}],\"jira-nin-grid-navigation-onboarding.moreShortcuts\":[{\"type\":0,\"value\":\"More shortcuts\"}],\"jira-nin-grid-navigation-onboarding.okButton\":[{\"type\":0,\"value\":\"Ok\"}],\"jira-nin-grid-navigation-onboarding.tabAndArrowNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Tab\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" into and out of the view quickly, and use \"},{\"children\":[{\"type\":0,\"value\":\"arrow keys\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" to navigate cells.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescription\":[{\"type\":0,\"value\":\"We've applied your settings from All work view. Do you want to apply your settings from the old List view instead? This includes the filters, groups, and columns you've set.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltText\":[{\"type\":0,\"value\":\"Illustration of multiple spaces stacked to show everything will migrate together.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextCurrentSpace\":[{\"type\":0,\"value\":\"Illustration of a single space showing the list settings will migrate to the new view.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextNo\":[{\"type\":0,\"value\":\"Illustration of a cursor selecting the More actions menu to choose migrate later.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNo\":[{\"type\":0,\"value\":\"No, keep my settings from the All work view\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescription\":[{\"type\":0,\"value\":\"You can apply old List view settings later in the More actions (...) menu in the list.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpaces\":[{\"type\":0,\"value\":\"Yes, apply settings from all Jira spaces\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpace\":[{\"type\":0,\"value\":\"Yes, apply settings from \"},{\"type\":1,\"value\":\"spaceName\"},{\"type\":0,\"value\":\" space\"}],\"jira-nin-paid-list-merge-modal-onboarding.description\":[{\"type\":0,\"value\":\"We've combined the best of List and All Work views to bring you one powerful, unified view for managing work.\"}],\"jira-nin-paid-list-merge-modal-onboarding.heading\":[{\"type\":0,\"value\":\"List and All Work are merging\"}],\"jira-nin-paid-list-merge-modal-onboarding.learnMoreLink\":[{\"type\":0,\"value\":\"Read our announcement on Community\"}],\"jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback\":[{\"type\":0,\"value\":\"current\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label\":[{\"type\":0,\"value\":\"Apply settings\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label\":[{\"type\":0,\"value\":\"Explore List view\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.filter\":[{\"type\":0,\"value\":\"Search, filter, and group work items to quickly find what you need.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions\":[{\"type\":0,\"value\":\"Adjust how you visualise the work with charts and format rules. You can also apply your old list settings.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text\":[{\"type\":0,\"value\":\"Find work faster using filters.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text.advanced.jql\":[{\"type\":0,\"value\":\"Select advanced or JQL mode to filter by more fields.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.title\":[{\"type\":0,\"value\":\"A new home for filters\"}]}");

});

parcelRegister("1NYRC", function(module, exports) {

let $1509945a515c47ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1509945a515c47ab$var$load("iVXva").then(()=>parcelRequire('b9HNL'));

});

parcelRegister("dYrYA", function(module, exports) {

let $a2c6947330d56774$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a2c6947330d56774$var$load("irtvq").then(()=>parcelRequire('6XNbh'));

});

parcelRegister("kEZZO", function(module, exports) {

let $f0a7a2302a401ef1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0a7a2302a401ef1$var$load("fBFci").then(()=>parcelRequire('kkxvM'));

});

parcelRegister("if7BP", function(module, exports) {

let $d47f87b6b95d47f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d47f87b6b95d47f4$var$load("l6dWA").then(()=>parcelRequire('h7n9s'));

});

parcelRegister("gkAL1", function(module, exports) {

let $be3b06da2deb4d49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be3b06da2deb4d49$var$load("5gsdi").then(()=>parcelRequire('lTUxC'));

});

parcelRegister("galxv", function(module, exports) {

let $bc4e49c79daa0be0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc4e49c79daa0be0$var$load("f5JIU").then(()=>parcelRequire('i1B53'));

});

parcelRegister("1KbcF", function(module, exports) {

let $1452c7138e146f03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1452c7138e146f03$var$load("c8CAi").then(()=>parcelRequire('g9ImX'));

});

parcelRegister("5R3U2", function(module, exports) {

let $4434ee088297eb9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4434ee088297eb9e$var$load("1aYtX").then(()=>parcelRequire('e6Toy'));

});

parcelRegister("gbJYL", function(module, exports) {

let $bc9156ea5e5a72ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc9156ea5e5a72ec$var$load("gSKQp").then(()=>parcelRequire('5mgu9'));

});

parcelRegister("cdHiZ", function(module, exports) {

let $8e584a758ca19dab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e584a758ca19dab$var$load("32AUX").then(()=>parcelRequire('039Sx'));

});

parcelRegister("ULOdL", function(module, exports) {

let $0aaa50f3cf9e69e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0aaa50f3cf9e69e2$var$load("dovy2").then(()=>parcelRequire('9WKzB'));

});

parcelRegister("iJaMK", function(module, exports) {

let $da24cbb27379bdfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da24cbb27379bdfd$var$load("7j92c").then(()=>parcelRequire('lFVl2'));

});

parcelRegister("2Tui6", function(module, exports) {

let $21b837021e579aa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b837021e579aa1$var$load("9fqkh").then(()=>parcelRequire('688Nc'));

});

parcelRegister("dCK44", function(module, exports) {

let $9eb28e6e6554f28b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9eb28e6e6554f28b$var$load("gjImt").then(()=>parcelRequire('gJavF'));

});

parcelRegister("1aPXW", function(module, exports) {

let $0daf08f037851ae5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0daf08f037851ae5$var$load("dtXUg").then(()=>parcelRequire('gLzQ7'));

});

parcelRegister("bs5bi", function(module, exports) {

let $8566541fa57a82f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8566541fa57a82f1$var$load("9eMDo").then(()=>parcelRequire('kxY57'));

});

parcelRegister("f9TiZ", function(module, exports) {

let $b09298bb402a25fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b09298bb402a25fc$var$load("8LOW4").then(()=>parcelRequire('86c8j'));

});

parcelRegister("cS71P", function(module, exports) {

let $95effaea00b8df72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95effaea00b8df72$var$load("khT8i").then(()=>parcelRequire('hxhBB'));

});

parcelRegister("bHpBu", function(module, exports) {

let $88479239f9e1047a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88479239f9e1047a$var$load("9uQpw").then(()=>parcelRequire('7z7s1'));

});

parcelRegister("gc3W0", function(module, exports) {

let $bca0d1a3f0289a1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bca0d1a3f0289a1e$var$load("iLKT4").then(()=>parcelRequire('aZcUb'));

});

parcelRegister("cW099", function(module, exports) {

let $96ab03f03010a99d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96ab03f03010a99d$var$load("dyn4Q").then(()=>parcelRequire('L00gy'));

});

parcelRegister("1iQtT", function(module, exports) {

let $0f302e8c78e90feb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f302e8c78e90feb$var$load("6guFg").then(()=>parcelRequire('BAU7q'));

});

parcelRegister("dQkcb", function(module, exports) {

let $a13fcc19e26c235d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a13fcc19e26c235d$var$load("gOLRZ").then(()=>parcelRequire('6CFYe'));

});

parcelRegister("eCQlI", function(module, exports) {

let $aa5d38cb876fac08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa5d38cb876fac08$var$load("65ciN").then(()=>parcelRequire('eML1P'));

});

parcelRegister("8erZp", function(module, exports) {

let $5fe557aa05bffc40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fe557aa05bffc40$var$load("f8r36").then(()=>parcelRequire('7LA0I'));

});

parcelRegister("4nl4V", function(module, exports) {

let $32f9a92ab8a3ade9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32f9a92ab8a3ade9$var$load("4kLmh").then(()=>parcelRequire('aowbr'));

});

parcelRegister("abr61", function(module, exports) {

let $769ff32a8bde94d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $769ff32a8bde94d0$var$load("3vCNW").then(()=>parcelRequire('5OEnJ'));

});

parcelRegister("aJo6X", function(module, exports) {

let $7d00cf53cffb71af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d00cf53cffb71af$var$load("iQ3Co").then(()=>parcelRequire('7AjxY'));

});

parcelRegister("gqVEY", function(module, exports) {

let $bf6bcd1ef8e65af4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf6bcd1ef8e65af4$var$load("lHDFC").then(()=>parcelRequire('2Qcwu'));

});

parcelRegister("85Yqg", function(module, exports) {

let $5e4da906838252a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e4da906838252a2$var$load("76GMf").then(()=>parcelRequire('ggbRv'));

});

parcelRegister("3AeHJ", function(module, exports) {

let $29c023db4f990c65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29c023db4f990c65$var$load("liQTV").then(()=>parcelRequire('3faZa'));

});

parcelRegister("55eKA", function(module, exports) {

let $3b38dc7be41904b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b38dc7be41904b3$var$load("fwU2z").then(()=>parcelRequire('hLvCO'));

});

parcelRegister("1iVmS", function(module, exports) {

let $0f33f8f54472a1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f33f8f54472a1fc$var$load("fgDVq").then(()=>parcelRequire('B1a5R'));

});

parcelRegister("ed1DR", function(module, exports) {

let $a5838da50538774f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5838da50538774f$var$load("8RZLP").then(()=>parcelRequire('5nggI'));

});

parcelRegister("8eaIp", function(module, exports) {
module.exports = JSON.parse("{\"jira-pandora.common.footer.address.no-translate\":[{\"type\":0,\"value\":\"341 George Street, Sydney, NSW, 2000, Australia\"}],\"jira-pandora.common.footer.copyright.no-translate\":[{\"type\":0,\"value\":\"Copyright 2025 Atlassian Pty Ltd. All rights reserved.\"}],\"jira-pandora.common.project-access-email.banner.alt\":[{\"type\":0,\"value\":\"Jira banner image\"}],\"jira-pandora.jira-project-access-granted.email.body.content\":[{\"type\":0,\"value\":\"You can now access \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"You can now access your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.button.redacted.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.email.button.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"You've been granted access to your project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.subject\":[{\"type\":0,\"value\":\"You've been granted access to \"},{\"type\":1,\"value\":\"projectName\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.content\":[{\"type\":0,\"value\":\"Users have requested to join \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" project\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"Users have requested to join your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.redacted.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"Access request for your project\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.subject\":[{\"type\":0,\"value\":\"Access request for \"},{\"type\":1,\"value\":\"projectName\"}],\"jira.jira-notify-reaction.message-template.text.single-reaction-with-name\":[{\"type\":0,\"value\":\":bell: *\"},{\"type\":1,\"value\":\"userName\"},{\"type\":0,\"value\":\" reacted to your comment*\"}],\"jira.jira-notify-reaction.message-template.text.view-comment\":[{\"type\":0,\"value\":\"View comment\"}]}");

});

parcelRegister("8soQH", function(module, exports) {

let $628436b8e8e8eaf8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $628436b8e8e8eaf8$var$load("ks76h").then(()=>parcelRequire('45V88'));

});

parcelRegister("AcmB1", function(module, exports) {

let $06ccf4081353d32a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $06ccf4081353d32a$var$load("fzTL1").then(()=>parcelRequire('7akKj'));

});

parcelRegister("eBZC4", function(module, exports) {

let $aa345078086aa5b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa345078086aa5b6$var$load("42exk").then(()=>parcelRequire('lKCMg'));

});

parcelRegister("aQguK", function(module, exports) {

let $7e4b8e44f8036bdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e4b8e44f8036bdc$var$load("dkLpW").then(()=>parcelRequire('ijhOv'));

});

parcelRegister("34B0a", function(module, exports) {

let $23ce729a58c03ca4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23ce729a58c03ca4$var$load("eWmKu").then(()=>parcelRequire('cBAaP'));

});

parcelRegister("cxnmS", function(module, exports) {

let $920ab18013b0f7f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $920ab18013b0f7f8$var$load("jt6Nc").then(()=>parcelRequire('1nEI6'));

});

parcelRegister("4EYTl", function(module, exports) {

let $364a21ad792f719a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $364a21ad792f719a$var$load("lqf4p").then(()=>parcelRequire('2DoLm'));

});

parcelRegister("bJtGs", function(module, exports) {

let $88aaec3e6f4d3912$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88aaec3e6f4d3912$var$load("c45pb").then(()=>parcelRequire('y1Wnl'));

});

parcelRegister("j11u3", function(module, exports) {

let $dd7f42f8d84f45ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd7f42f8d84f45ee$var$load("7eyPa").then(()=>parcelRequire('bvpLA'));

});

parcelRegister("4Iu9a", function(module, exports) {

let $36f2a803ed4a3c32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36f2a803ed4a3c32$var$load("O2IGv").then(()=>parcelRequire('9lbqx'));

});

parcelRegister("2Nl1L", function(module, exports) {

let $209077fe3f5a3c5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $209077fe3f5a3c5c$var$load("62Ypr").then(()=>parcelRequire('cifrM'));

});

parcelRegister("iFn6p", function(module, exports) {

let $d96df9f5e0fa655f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d96df9f5e0fa655f$var$load("csjms").then(()=>parcelRequire('21RiV'));

});

parcelRegister("b3s7K", function(module, exports) {

let $80c5ca5ceb491d87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80c5ca5ceb491d87$var$load("gbVrg").then(()=>parcelRequire('7sMrv'));

});

parcelRegister("1TvLV", function(module, exports) {

let $161392c6bbc05a47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $161392c6bbc05a47$var$load("1sYxz").then(()=>parcelRequire('ebWgz'));

});

parcelRegister("f2hYx", function(module, exports) {

let $af24fc72b5ddd3d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af24fc72b5ddd3d5$var$load("fzXBH").then(()=>parcelRequire('bK0aF'));

});

parcelRegister("4CBdR", function(module, exports) {

let $35d795a27addcd23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35d795a27addcd23$var$load("5wMyt").then(()=>parcelRequire('hh8kS'));

});

parcelRegister("1RKr2", function(module, exports) {

let $15bec2b593e79cc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15bec2b593e79cc8$var$load("cHRYh").then(()=>parcelRequire('cpvvm'));

});

parcelRegister("bhjSn", function(module, exports) {

let $8360b32f307ad8d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8360b32f307ad8d8$var$load("1GUTB").then(()=>parcelRequire('8lmTs'));

});

parcelRegister("9bBvZ", function(module, exports) {

let $6b023dcd7b78e012$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b023dcd7b78e012$var$load("02nNU").then(()=>parcelRequire('ez1g9'));

});

parcelRegister("lHU96", function(module, exports) {

let $fcd92a84b6f9ea7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcd92a84b6f9ea7a$var$load("1mlos").then(()=>parcelRequire('jaOZS'));

});

parcelRegister("7uvFj", function(module, exports) {

let $5743e5d6930650cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5743e5d6930650cf$var$load("6d23n").then(()=>parcelRequire('f9TVv'));

});

parcelRegister("845sW", function(module, exports) {

let $5df2efd6bd97e0ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5df2efd6bd97e0ad$var$load("he9IT").then(()=>parcelRequire('6ALbD'));

});

parcelRegister("gu9bW", function(module, exports) {

let $c00693f1a5aed643$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c00693f1a5aed643$var$load("bs9oy").then(()=>parcelRequire('iHbmF'));

});

parcelRegister("2jE4Q", function(module, exports) {

let $1afc7199fc8a1221$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1afc7199fc8a1221$var$load("l9cUJ").then(()=>parcelRequire('l8TDJ'));

});

parcelRegister("fXcft", function(module, exports) {

let $b9d5de07414b1cc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b9d5de07414b1cc2$var$load("4Mr42").then(()=>parcelRequire('0UymV'));

});

parcelRegister("iQ2Vw", function(module, exports) {

let $db6f5a8b38850674$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db6f5a8b38850674$var$load("3TuC7").then(()=>parcelRequire('6lyud'));

});

parcelRegister("gtYuO", function(module, exports) {

let $bffe4800c3d63df7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bffe4800c3d63df7$var$load("5B1VR").then(()=>parcelRequire('jdBzR'));

});

parcelRegister("asYPk", function(module, exports) {

let $79ebb3dfc5515bc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79ebb3dfc5515bc1$var$load("i3DnP").then(()=>parcelRequire('3vVaC'));

});

parcelRegister("3jL6F", function(module, exports) {

let $26a7afd84de512ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26a7afd84de512ac$var$load("6M7E7").then(()=>parcelRequire('DaM6a'));

});

parcelRegister("dt5Ek", function(module, exports) {

let $9ce25dad1436faff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ce25dad1436faff$var$load("aJZ5d").then(()=>parcelRequire('ezVkX'));

});

parcelRegister("8CrAA", function(module, exports) {

let $646745fa2207cf38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $646745fa2207cf38$var$load("jkveD").then(()=>parcelRequire('lLkdp'));

});

parcelRegister("5Xak2", function(module, exports) {

let $455a7830a7586ba0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $455a7830a7586ba0$var$load("ib8vr").then(()=>parcelRequire('5L5lX'));

});

parcelRegister("2x03E", function(module, exports) {

let $1d7eb55452c561f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d7eb55452c561f4$var$load("llprT").then(()=>parcelRequire('58Kxq'));

});

parcelRegister("4a5zq", function(module, exports) {

let $307c6ac0f5b5f612$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $307c6ac0f5b5f612$var$load("ftS0S").then(()=>parcelRequire('3XMWt'));

});

parcelRegister("6Ey85", function(module, exports) {
module.exports = JSON.parse('{"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.now":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.soon":[{"type":0,"value":"Jira \'projects\' will soon be renamed \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.learn-more":[{"type":0,"value":"Read more about this change"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.now":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.soon":[{"type":0,"value":"Coming soon"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.html.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.footer.custom.message":[{"type":1,"value":"footerText"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.get.apps.new":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"a1"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"a2"},{"type":0,"value":"."}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"/"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"mentioned you"}],"type":8,"value":"strong"},{"type":0,"value":" on a work item"}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.reply-button":[{"type":0,"value":"Reply"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.body":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.learn-more":[{"type":0,"value":"Learn more"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.title":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited.invited-custom-message":[{"type":1,"value":"customMessage"}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this project on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This project and its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("ls6Zj", function(module, exports) {

let $f9e1a22b103f8367$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9e1a22b103f8367$var$load("7Yj9o").then(()=>parcelRequire('6jwGQ'));

});

parcelRegister("15mZm", function(module, exports) {

let $0ca8172ba9f4d4b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ca8172ba9f4d4b6$var$load("dBwdi").then(()=>parcelRequire('74s8I'));

});

parcelRegister("doZ7S", function(module, exports) {

let $9c1cee9c5d7f522b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c1cee9c5d7f522b$var$load("j9yw3").then(()=>parcelRequire('02V19'));

});

parcelRegister("diQmT", function(module, exports) {

let $9af594070c140dee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9af594070c140dee$var$load("l8iFi").then(()=>parcelRequire('hCGRQ'));

});

parcelRegister("7hpmi", function(module, exports) {

let $54cdca9fba214c9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54cdca9fba214c9d$var$load("lBZIH").then(()=>parcelRequire('6ZxwT'));

});

parcelRegister("8Fw4S", function(module, exports) {

let $64fb09005b66f024$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64fb09005b66f024$var$load("joixz").then(()=>parcelRequire('cwpN3'));

});

parcelRegister("l1He6", function(module, exports) {

let $f4eb38db34656c46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4eb38db34656c46$var$load("4i4Kt").then(()=>parcelRequire('beOaf'));

});

parcelRegister("ilTZL", function(module, exports) {

let $d5c59fa5122463ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5c59fa5122463ac$var$load("2lJZz").then(()=>parcelRequire('6LaWj'));

});

parcelRegister("3BLr5", function(module, exports) {

let $2a099f9729b89de1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a099f9729b89de1$var$load("7U9F6").then(()=>parcelRequire('fqRiS'));

});

parcelRegister("cAkqT", function(module, exports) {

let $9298b255c5d5d45b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9298b255c5d5d45b$var$load("kdo3S").then(()=>parcelRequire('bUxcb'));

});

parcelRegister("2pYQB", function(module, exports) {

let $1c2d1d9555fc3222$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c2d1d9555fc3222$var$load("csrC6").then(()=>parcelRequire('95hjm'));

});

parcelRegister("hQ4xx", function(module, exports) {

let $cfcad08e62c6ce6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfcad08e62c6ce6c$var$load("iMP7C").then(()=>parcelRequire('2la6R'));

});

parcelRegister("1gNZX", function(module, exports) {

let $0ece11b5b15f85ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ece11b5b15f85ff$var$load("q3l0L").then(()=>parcelRequire('dlQ8N'));

});

parcelRegister("54YVY", function(module, exports) {

let $3b2c97b25c184454$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b2c97b25c184454$var$load("5Z3qI").then(()=>parcelRequire('dLZfG'));

});

parcelRegister("9IWwn", function(module, exports) {

let $71459e3b2608d195$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71459e3b2608d195$var$load("1x1kI").then(()=>parcelRequire('7dLLD'));

});

parcelRegister("5MqOz", function(module, exports) {

let $43563c468b0b8307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43563c468b0b8307$var$load("7m2nY").then(()=>parcelRequire('E24ro'));

});

parcelRegister("6O41U", function(module, exports) {

let $4f4a89cdc9f0e5b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f4a89cdc9f0e5b4$var$load("3VEav").then(()=>parcelRequire('80TMP'));

});

parcelRegister("dMSCA", function(module, exports) {

let $a09a20bb9a0ef81d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a09a20bb9a0ef81d$var$load("CYzZ6").then(()=>parcelRequire('6eaHY'));

});

parcelRegister("w1ZQX", function(module, exports) {

let $060489c36e3809cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $060489c36e3809cf$var$load("avS1q").then(()=>parcelRequire('bvbVP'));

});

parcelRegister("47Edk", function(module, exports) {

let $30070285efb6dded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30070285efb6dded$var$load("kqxDJ").then(()=>parcelRequire('huU6a'));

});

parcelRegister("i7S8e", function(module, exports) {

let $d322dedbd2af4a74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d322dedbd2af4a74$var$load("dziTX").then(()=>parcelRequire('iLn5v'));

});

parcelRegister("eM3rX", function(module, exports) {

let $ac18397cf0817cc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac18397cf0817cc4$var$load("e365F").then(()=>parcelRequire('l5bNB'));

});

parcelRegister("gsuf5", function(module, exports) {

let $bfb6b85fb473ed25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfb6b85fb473ed25$var$load("e3Wja").then(()=>parcelRequire('4qQ9E'));

});

parcelRegister("3GLTX", function(module, exports) {

let $2afa739990e90400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2afa739990e90400$var$load("hgEfL").then(()=>parcelRequire('kwyOm'));

});

parcelRegister("ghIyH", function(module, exports) {

let $bdb0cc4b17b196d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdb0cc4b17b196d6$var$load("5nPJL").then(()=>parcelRequire('jNvDS'));

});

parcelRegister("kTdQD", function(module, exports) {

let $f353af9974f3ac57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f353af9974f3ac57$var$load("6bLCw").then(()=>parcelRequire('6q8dO'));

});

parcelRegister("ao0pU", function(module, exports) {

let $78fc780b78fe826e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78fc780b78fe826e$var$load("5eF31").then(()=>parcelRequire('7fyIe'));

});

parcelRegister("d5zS6", function(module, exports) {

let $98779157fbcdbd32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98779157fbcdbd32$var$load("hSDas").then(()=>parcelRequire('dk9zU'));

});

parcelRegister("kU9Bh", function(module, exports) {

let $f3807c05689a862a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3807c05689a862a$var$load("jyp3O").then(()=>parcelRequire('fDMQY'));

});

parcelRegister("6gc2r", function(module, exports) {

let $48ed9345137a7fd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48ed9345137a7fd3$var$load("cZgN3").then(()=>parcelRequire('1soyt'));

});

parcelRegister("6q3fz", function(module, exports) {

let $4ac7b12d877cf259$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ac7b12d877cf259$var$load("l0VRX").then(()=>parcelRequire('l0MAd'));

});

parcelRegister("l9eWx", function(module, exports) {

let $f65607a6d5011585$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f65607a6d5011585$var$load("1QYgR").then(()=>parcelRequire('cffGX'));

});

parcelRegister("5qgOk", function(module, exports) {

let $3f2c6bb30b0c2927$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f2c6bb30b0c2927$var$load("9VcQN").then(()=>parcelRequire('3RLpu'));

});

parcelRegister("37UgO", function(module, exports) {

let $246dac9ac88a6789$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $246dac9ac88a6789$var$load("k7It5").then(()=>parcelRequire('5ozG8'));

});

parcelRegister("8tEET", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("iitm0", function(module, exports) {

let $d520ad83b7b11e6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d520ad83b7b11e6a$var$load("12mie").then(()=>parcelRequire('gHN26'));

});

parcelRegister("9a0Kb", function(module, exports) {

let $6ab59fefeba7ef7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ab59fefeba7ef7d$var$load("lX3hU").then(()=>parcelRequire('dP4uk'));

});

parcelRegister("9X8kp", function(module, exports) {

let $73f0158b88479145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73f0158b88479145$var$load("glVF0").then(()=>parcelRequire('gJP5f'));

});

parcelRegister("d4wxz", function(module, exports) {

let $9844e3eedb2f7a55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9844e3eedb2f7a55$var$load("lTvyt").then(()=>parcelRequire('aYYK8'));

});

parcelRegister("8N0XQ", function(module, exports) {

let $6663a5cfdfad2fca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6663a5cfdfad2fca$var$load("2hH31").then(()=>parcelRequire('iDdMo'));

});

parcelRegister("qvwys", function(module, exports) {

let $04fae1d90c8a64cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04fae1d90c8a64cb$var$load("cmMrn").then(()=>parcelRequire('2Q4q0'));

});

parcelRegister("jJAhj", function(module, exports) {

let $e5de5c5e0f99983f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5de5c5e0f99983f$var$load("2DWrJ").then(()=>parcelRequire('ahzrV'));

});

parcelRegister("aC7Do", function(module, exports) {

let $7ba36009f4f73020$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ba36009f4f73020$var$load("Ddbkb").then(()=>parcelRequire('bPVDt'));

});

parcelRegister("a2hH9", function(module, exports) {

let $74e7d1228ec68f99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74e7d1228ec68f99$var$load("h7KVv").then(()=>parcelRequire('3mjdz'));

});

parcelRegister("aGNXV", function(module, exports) {

let $7c8495c0a88befdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c8495c0a88befdb$var$load("9d1Ui").then(()=>parcelRequire('8QGBH'));

});

parcelRegister("3ygJs", function(module, exports) {

let $296186b8a4536d31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $296186b8a4536d31$var$load("6QOF8").then(()=>parcelRequire('mD7UB'));

});

parcelRegister("lEm5y", function(module, exports) {

let $fc2e77b791abda48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc2e77b791abda48$var$load("hELm2").then(()=>parcelRequire('evxEr'));

});

parcelRegister("8yWzv", function(module, exports) {

let $63beeecc625673fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $63beeecc625673fe$var$load("fTjh6").then(()=>parcelRequire('b2gKV'));

});

parcelRegister("byGSA", function(module, exports) {

let $86a421aa88c13b84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86a421aa88c13b84$var$load("jtL6y").then(()=>parcelRequire('7lu1B'));

});

parcelRegister("71g5k", function(module, exports) {

let $51c51a83c3509dc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51c51a83c3509dc0$var$load("4kFYm").then(()=>parcelRequire('85PqM'));

});

parcelRegister("6HenW", function(module, exports) {

let $4e01ead27732e99f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e01ead27732e99f$var$load("etT7C").then(()=>parcelRequire('3NE6B'));

});

parcelRegister("5HXUg", function(module, exports) {

let $427f700f4d98e278$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $427f700f4d98e278$var$load("6zH8Y").then(()=>parcelRequire('iikGX'));

});

parcelRegister("eODHb", function(module, exports) {

let $ac9486e807833e5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac9486e807833e5d$var$load("ciUip").then(()=>parcelRequire('eEUNg'));

});

parcelRegister("dLADO", function(module, exports) {

let $a05c164e4ba3361c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a05c164e4ba3361c$var$load("4SS6F").then(()=>parcelRequire('f9lx5'));

});

parcelRegister("24VEe", function(module, exports) {

let $1838ac24c98c1436$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1838ac24c98c1436$var$load("khomJ").then(()=>parcelRequire('9XVn7'));

});

parcelRegister("40iY1", function(module, exports) {

let $2ea5dffa156d7c7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ea5dffa156d7c7c$var$load("l3PYj").then(()=>parcelRequire('3FpGZ'));

});

parcelRegister("egl1q", function(module, exports) {

let $a622ddd6c34ada21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a622ddd6c34ada21$var$load("hLcol").then(()=>parcelRequire('eU6sn'));

});

parcelRegister("9mMGO", function(module, exports) {

let $6d1befde1abc0d82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d1befde1abc0d82$var$load("jZro9").then(()=>parcelRequire('ikdCz'));

});

parcelRegister("3qFE0", function(module, exports) {

let $27f41a7fb3ff5913$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27f41a7fb3ff5913$var$load("aVX51").then(()=>parcelRequire('5fONF'));

});

parcelRegister("3wQcD", function(module, exports) {

let $291cdaa3ecdf9a99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $291cdaa3ecdf9a99$var$load("5JIp8").then(()=>parcelRequire('ff6WO'));

});

parcelRegister("fDOxt", function(module, exports) {

let $b631b37b31632e21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b631b37b31632e21$var$load("8Lmyh").then(()=>parcelRequire('fTVkt'));

});

parcelRegister("9Eqsz", function(module, exports) {

let $706c5fd4a58e9b85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $706c5fd4a58e9b85$var$load("fz3OS").then(()=>parcelRequire('dWu3Q'));

});

parcelRegister("gyn2A", function(module, exports) {

let $c0d1b1beb57b374a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c0d1b1beb57b374a$var$load("cfJp1").then(()=>parcelRequire('4yDJ1'));

});

parcelRegister("hhf8Q", function(module, exports) {

let $c93fc50380f4199b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c93fc50380f4199b$var$load("d5QGH").then(()=>parcelRequire('CVmAv'));

});

parcelRegister("9prlg", function(module, exports) {

let $6d9ba86cb606cc46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d9ba86cb606cc46$var$load("9oxHW").then(()=>parcelRequire('DFtL7'));

});

parcelRegister("bGNnN", function(module, exports) {

let $8829ec5f6734cd9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8829ec5f6734cd9d$var$load("emJGv").then(()=>parcelRequire('2l8UK'));

});

parcelRegister("glZwc", function(module, exports) {

let $be7e53ca38a41728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be7e53ca38a41728$var$load("8ToNm").then(()=>parcelRequire('ibM2P'));

});

parcelRegister("29rck", function(module, exports) {

let $191184f606c7ce8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $191184f606c7ce8d$var$load("bs8sn").then(()=>parcelRequire('47EfI'));

});

parcelRegister("3upPm", function(module, exports) {

let $28a8353813d420f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28a8353813d420f2$var$load("a2brZ").then(()=>parcelRequire('evTqT'));

});

parcelRegister("7Avpo", function(module, exports) {
module.exports = JSON.parse('{"dismiss":[{"type":0,"value":"Dismiss"}],"jira-issueview-layouts.issue-view-layout-picker-changeboarding-body":[{"type":0,"value":"Choose a layout that works best for you."}],"jira-issueview-layouts.issue-view-layout-picker-changeboarding-heading":[{"type":0,"value":"Customise your view"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-key":[{"type":1,"value":"workItemKey"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-summary":[{"type":1,"value":"workItemSummary"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.body":[{"type":0,"value":"Don\'t let this work slip under the radar. Keep an eye on these unassigned work items by watching them, or assign them to yourself."}],"jira-thor.jira-notifications-project-recap.message-template-template.email.heading":[{"type":0,"value":"This work hasn\'t been assigned to anyone"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.manage-notifications":[{"type":0,"value":"Manage notifications"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.separator-dot":[{"type":0,"value":"\u2022"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.assign.action":[{"type":0,"value":"Assign to me"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.watch.action":[{"type":0,"value":"Watch"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.remaining.items":[{"type":0,"value":"+"},{"type":1,"value":"remaining"},{"type":0,"value":" more..."}],"jira-thor.jira-notifications-project-recap.message-template-template.project.total.unassigned.items":[{"type":0,"value":"Unassigned work items ("},{"type":1,"value":"totalCount"},{"type":0,"value":")"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.view.all":[{"type":0,"value":"View all in Jira"}],"jira-thor.jira-notifications-project-recap.message-template.email.subject.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", don\'t miss this week\'s unassigned work items"}],"jira.jira-notifications-project-recap.message-template-template.email.contact-us":[{"type":0,"value":"Contact us"}],"jira.jira-notifications-project-recap.message-template-template.email.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira.jira-notifications-project-recap.message-template-template.email.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"try-now":[{"type":0,"value":"Try now"}]}');

});

parcelRegister("a0TdC", function(module, exports) {

let $74a4bcbaeb7ac59d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74a4bcbaeb7ac59d$var$load("92KXm").then(()=>parcelRequire('briIo'));

});

parcelRegister("gqO11", function(module, exports) {

let $031649ca990b4a09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $031649ca990b4a09$var$load("cairS").then(()=>parcelRequire('jgOMk'));

});

parcelRegister("80j8c", function(module, exports) {

let $5d3d29e012fbc2ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d3d29e012fbc2ae$var$load("9NBjE").then(()=>parcelRequire('989RU'));

});

parcelRegister("ggGPf", function(module, exports) {

let $bd7f5c41e8c45ac5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd7f5c41e8c45ac5$var$load("aW2bK").then(()=>parcelRequire('49Cii'));

});

parcelRegister("eIhkO", function(module, exports) {

let $ab629f0c13f68da7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab629f0c13f68da7$var$load("6DSlI").then(()=>parcelRequire('4ycyq'));

});

parcelRegister("kykTy", function(module, exports) {

let $ef6730f5f4aa3086$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ef6730f5f4aa3086$var$load("eZu3k").then(()=>parcelRequire('grJNh'));

});

parcelRegister("hXpMY", function(module, exports) {

let $d12bf378c5c4ae55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d12bf378c5c4ae55$var$load("4PAqy").then(()=>parcelRequire('iTvpm'));

});

parcelRegister("3zH5O", function(module, exports) {

let $29a6115278450e75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29a6115278450e75$var$load("8fZau").then(()=>parcelRequire('8z0yN'));

});

parcelRegister("kMfIv", function(module, exports) {

let $f2047b5c9d32f384$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2047b5c9d32f384$var$load("bBCXO").then(()=>parcelRequire('34kR8'));

});

parcelRegister("6NYY8", function(module, exports) {

let $4f469cd250b7b18f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f469cd250b7b18f$var$load("amBlL").then(()=>parcelRequire('cIHit'));

});

parcelRegister("8yglT", function(module, exports) {

let $639e2ee61814832e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $639e2ee61814832e$var$load("ahQtE").then(()=>parcelRequire('h7kDA'));

});

parcelRegister("i28gE", function(module, exports) {

let $d20ed3ae8e38ab02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d20ed3ae8e38ab02$var$load("irmPo").then(()=>parcelRequire('bdPxU'));

});

parcelRegister("eZ5im", function(module, exports) {

let $ae8adeb4cc995f56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae8adeb4cc995f56$var$load("hcBjl").then(()=>parcelRequire('eDJUH'));

});

parcelRegister("g64jS", function(module, exports) {

let $bb808ea6a944b5fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb808ea6a944b5fe$var$load("fgvs9").then(()=>parcelRequire('6kP7g'));

});

parcelRegister("e7ciT", function(module, exports) {

let $a46b436271c7c029$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a46b436271c7c029$var$load("avby0").then(()=>parcelRequire('eCjgs'));

});

parcelRegister("igB6V", function(module, exports) {

let $d4c6820d3692ac7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4c6820d3692ac7a$var$load("eDajw").then(()=>parcelRequire('iMuN8'));

});

parcelRegister("70kBu", function(module, exports) {

let $519883f6c0ebed46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $519883f6c0ebed46$var$load("bOb9Z").then(()=>parcelRequire('2rJye'));

});

parcelRegister("784yx", function(module, exports) {

let $530cd0818ff85181$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $530cd0818ff85181$var$load("fowFM").then(()=>parcelRequire('iQDa1'));

});

parcelRegister("2Gi8T", function(module, exports) {

let $1f3d93bd85c0496c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f3d93bd85c0496c$var$load("7zDle").then(()=>parcelRequire('7RLK4'));

});

parcelRegister("7QniB", function(module, exports) {

let $5b5f767363e9008f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b5f767363e9008f$var$load("6AXkd").then(()=>parcelRequire('akF9t'));

});

parcelRegister("9DALs", function(module, exports) {

let $7044463e9c47b4e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7044463e9c47b4e0$var$load("8vLs2").then(()=>parcelRequire('5MxR5'));

});

parcelRegister("gdtHV", function(module, exports) {

let $bce4e781c115767a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bce4e781c115767a$var$load("1DdF7").then(()=>parcelRequire('jXksK'));

});

parcelRegister("dwptc", function(module, exports) {

let $9d820557e493501f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d820557e493501f$var$load("bU8uA").then(()=>parcelRequire('i3h4u'));

});

parcelRegister("gLV0w", function(module, exports) {

let $c35d419969758bd7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c35d419969758bd7$var$load("kLnpa").then(()=>parcelRequire('dKgNE'));

});

parcelRegister("blQVb", function(module, exports) {

let $843ab4f3b3210da7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $843ab4f3b3210da7$var$load("6LCoe").then(()=>parcelRequire('jUMgS'));

});

parcelRegister("1lI9B", function(module, exports) {

let $0fba00a4e0d36826$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fba00a4e0d36826$var$load("3L482").then(()=>parcelRequire('faXq4'));

});

parcelRegister("1pmm2", function(module, exports) {

let $1069776558128422$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1069776558128422$var$load("ixq83").then(()=>parcelRequire('5d8Ou'));

});

parcelRegister("1TOTx", function(module, exports) {

let $1622682393015ef4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1622682393015ef4$var$load("bcOms").then(()=>parcelRequire('pIM0E'));

});

parcelRegister("2SPfj", function(module, exports) {

let $2198604d68a20e6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2198604d68a20e6f$var$load("gFEx7").then(()=>parcelRequire('j8C48'));

});

parcelRegister("grmIM", function(module, exports) {

let $bf80caf17047fb89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf80caf17047fb89$var$load("cZaAY").then(()=>parcelRequire('kl9WO'));

});

parcelRegister("kLC05", function(module, exports) {

let $f1e5ac882de6472c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1e5ac882de6472c$var$load("en5b2").then(()=>parcelRequire('kTS7u'));

});

parcelRegister("eCIUg", function(module, exports) {

let $aa5772c72cd0a70c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa5772c72cd0a70c$var$load("iZ4Cd").then(()=>parcelRequire('kFL29'));

});

parcelRegister("jioKh", function(module, exports) {

let $e0c2e4ad67e7960e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0c2e4ad67e7960e$var$load("6kz39").then(()=>parcelRequire('bExYt'));

});

parcelRegister("hhWJp", function(module, exports) {

let $c961950f0947426f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c961950f0947426f$var$load("3Y3Tr").then(()=>parcelRequire('kHg0E'));

});

parcelRegister("57xWx", function(module, exports) {
module.exports = JSON.parse("{\"frozen-columns-onboarding.spotlight.body\":[{\"type\":0,\"value\":\"Sort, freeze and resize Work from a single control.\"}],\"frozen-columns-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"OK\"}],\"frozen-columns-onboarding.spotlight.heading\":[{\"type\":0,\"value\":\"Manage Work\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.body\":[{\"type\":0,\"value\":\"Group work by fields including versions, labels, work types and more.\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"OK\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.heading\":[{\"type\":0,\"value\":\"Group work to stay organized\"}]}");

});

parcelRegister("gAEGB", function(module, exports) {

let $c13f9191f818bc78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c13f9191f818bc78$var$load("20Ni3").then(()=>parcelRequire('buXT4'));

});

parcelRegister("dMJF5", function(module, exports) {

let $a0932d89b84b54d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0932d89b84b54d7$var$load("dlCxV").then(()=>parcelRequire('lJRLk'));

});

parcelRegister("6pKIv", function(module, exports) {

let $4ab950da08866ff4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ab950da08866ff4$var$load("9XJxM").then(()=>parcelRequire('kQbbV'));

});

parcelRegister("jqwrY", function(module, exports) {

let $e2499def421773d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e2499def421773d5$var$load("4BhtJ").then(()=>parcelRequire('36kNt'));

});

parcelRegister("3W8CE", function(module, exports) {

let $2ddd7a1762381e04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ddd7a1762381e04$var$load("g6ZYs").then(()=>parcelRequire('76r0N'));

});

parcelRegister("h214p", function(module, exports) {

let $c66374109b055a38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c66374109b055a38$var$load("fjhyt").then(()=>parcelRequire('lPj6I'));

});

parcelRegister("kLlQM", function(module, exports) {

let $f1d925787820e3a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1d925787820e3a2$var$load("ku4in").then(()=>parcelRequire('dd3Zm'));

});

parcelRegister("iCeA1", function(module, exports) {

let $d8d715e26ccf3de7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8d715e26ccf3de7$var$load("fbCyW").then(()=>parcelRequire('1DwoI'));

});

parcelRegister("5rCoM", function(module, exports) {

let $3f6d428ecf8ab1ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f6d428ecf8ab1ed$var$load("hgIdF").then(()=>parcelRequire('d6Jww'));

});

parcelRegister("aw1rm", function(module, exports) {

let $7a7e028e9cd6cfb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a7e028e9cd6cfb9$var$load("iDpf4").then(()=>parcelRequire('jw9xM'));

});

parcelRegister("8ITYw", function(module, exports) {

let $659dda4ba48e2c83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $659dda4ba48e2c83$var$load("dZkdz").then(()=>parcelRequire('S4YmJ'));

});

parcelRegister("c0Gtc", function(module, exports) {

let $8be66dc03421917b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8be66dc03421917b$var$load("jK7IB").then(()=>parcelRequire('75ppW'));

});

parcelRegister("leZEY", function(module, exports) {

let $f76abc255da813f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f76abc255da813f7$var$load("5knon").then(()=>parcelRequire('fxWOL'));

});

parcelRegister("7tJBP", function(module, exports) {

let $571e9ee1faa82189$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $571e9ee1faa82189$var$load("7DvZK").then(()=>parcelRequire('lG56O'));

});

parcelRegister("5yLqW", function(module, exports) {

let $40c4ec0da2988eab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40c4ec0da2988eab$var$load("1bjPC").then(()=>parcelRequire('b6pCU'));

});

parcelRegister("6yV4D", function(module, exports) {

let $4c7230bb068e1aa3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c7230bb068e1aa3$var$load("1cB2I").then(()=>parcelRequire('hsQNE'));

});

parcelRegister("ezNqT", function(module, exports) {

let $a9caade4c4d08682$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9caade4c4d08682$var$load("i2nFm").then(()=>parcelRequire('cU1zD'));

});

parcelRegister("8tM0n", function(module, exports) {

let $62c644f5f5fe4f54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62c644f5f5fe4f54$var$load("4SJX4").then(()=>parcelRequire('i784l'));

});

parcelRegister("hr9h0", function(module, exports) {

let $cb1c26be017b4703$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb1c26be017b4703$var$load("19Dzb").then(()=>parcelRequire('i57eq'));

});

parcelRegister("lTIc2", function(module, exports) {

let $ff1103dba2bffb14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff1103dba2bffb14$var$load("jd0MW").then(()=>parcelRequire('hy1lX'));

});

parcelRegister("ghpeV", function(module, exports) {

let $bda1cff801acf7cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bda1cff801acf7cf$var$load("eXELD").then(()=>parcelRequire('1sXoi'));

});

parcelRegister("cZ8Qj", function(module, exports) {

let $97420a81774fb395$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97420a81774fb395$var$load("jY5sI").then(()=>parcelRequire('215xL'));

});

parcelRegister("kEyaV", function(module, exports) {

let $f0920d89daf8356b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0920d89daf8356b$var$load("jT9wv").then(()=>parcelRequire('aj53f'));

});

parcelRegister("8InNC", function(module, exports) {

let $6584e4da87702524$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6584e4da87702524$var$load("jQdF8").then(()=>parcelRequire('btQ2m'));

});

parcelRegister("hfnTn", function(module, exports) {

let $c8e65edf2b34db63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8e65edf2b34db63$var$load("dmBXV").then(()=>parcelRequire('gNW5W'));

});

parcelRegister("67PcB", function(module, exports) {

let $475b1d33b43312a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $475b1d33b43312a0$var$load("7wWfx").then(()=>parcelRequire('iWmRT'));

});

parcelRegister("22vVN", function(module, exports) {

let $17c4898821ea5200$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17c4898821ea5200$var$load("d82zB").then(()=>parcelRequire('cSyHG'));

});

parcelRegister("aA24d", function(module, exports) {

let $7b3ede9e2c34ae3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b3ede9e2c34ae3c$var$load("boM6T").then(()=>parcelRequire('1oEhO'));

});

parcelRegister("fFh2C", function(module, exports) {

let $b677e76045e28235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b677e76045e28235$var$load("hGyPr").then(()=>parcelRequire('938pC'));

});

parcelRegister("8x8Qx", function(module, exports) {

let $636844879e8cdf42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $636844879e8cdf42$var$load("7B7s8").then(()=>parcelRequire('dxRY0'));

});

parcelRegister("kOrUi", function(module, exports) {

let $f26e1fee821e50bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f26e1fee821e50bf$var$load("dVnnv").then(()=>parcelRequire('3t9pO'));

});

parcelRegister("c5TSF", function(module, exports) {

let $8ce14c65afdc6811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ce14c65afdc6811$var$load("4QMLW").then(()=>parcelRequire('1e9Mm'));

});

parcelRegister("dlwhB", function(module, exports) {

let $9b76473bc67ece99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b76473bc67ece99$var$load("bTeYa").then(()=>parcelRequire('hHceS'));

});

parcelRegister("bzFAS", function(module, exports) {

let $86d33a4444a6a134$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86d33a4444a6a134$var$load("jZ99Z").then(()=>parcelRequire('baqzM'));

});

parcelRegister("5j4Cn", function(module, exports) {
module.exports = JSON.parse('{"jsm-project-summary-onboarding.changeLayout":[{"type":0,"value":"Change the layout and order of charts"}],"jsm-project-summary-onboarding.closeButton":[{"type":0,"value":"Close"}],"jsm-project-summary-onboarding.description":[{"type":0,"value":"You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."}],"jsm-project-summary-onboarding.editFilters":[{"type":0,"value":"Edit filters"}],"jsm-project-summary-onboarding.heading":[{"type":0,"value":"Edit your space summary"}],"jsm-project-summary-onboarding.hideAddCharts":[{"type":0,"value":"Hide or add charts"}],"jsm-project-summary-onboarding.moreAboutFeature":[{"type":0,"value":"More about space summary"}],"jsm-project-summary-onboarding.okButton":[{"type":0,"value":"Got it"}],"jsm-project-summary-onboarding.whatsNewTitle":[{"type":0,"value":"What\u2019s new?"}]}');

});

parcelRegister("dBqKf", function(module, exports) {

let $9e737a12c4bbb83a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e737a12c4bbb83a$var$load("71ZfD").then(()=>parcelRequire('2T0sT'));

});

parcelRegister("3Qq1K", function(module, exports) {

let $2cca6ae084e3b2b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2cca6ae084e3b2b5$var$load("kYEsp").then(()=>parcelRequire('fr2U1'));

});

parcelRegister("dV1W3", function(module, exports) {

let $a222198c71a5346f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a222198c71a5346f$var$load("4tvhv").then(()=>parcelRequire('hx9ka'));

});

parcelRegister("90jP0", function(module, exports) {

let $68e37d55f2d87ebf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $68e37d55f2d87ebf$var$load("5eop4").then(()=>parcelRequire('bEGgx'));

});

parcelRegister("iC5L5", function(module, exports) {

let $d8d03e1cceb55cb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8d03e1cceb55cb0$var$load("5YEPv").then(()=>parcelRequire('3Z1ar'));

});

parcelRegister("hsrB8", function(module, exports) {

let $cb5a759163bc4a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb5a759163bc4a5e$var$load("1Bn96").then(()=>parcelRequire('bxLpT'));

});

parcelRegister("iJkX5", function(module, exports) {

let $da2cae959d9fe512$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da2cae959d9fe512$var$load("7Pg2p").then(()=>parcelRequire('qmn3S'));

});

parcelRegister("dcLFo", function(module, exports) {

let $99d15ef9a45aedc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99d15ef9a45aedc4$var$load("5BZYq").then(()=>parcelRequire('7EHde'));

});

parcelRegister("9l0bw", function(module, exports) {

let $6cc637f23f505b6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cc637f23f505b6e$var$load("gzVLb").then(()=>parcelRequire('8LbUN'));

});

parcelRegister("ilvnY", function(module, exports) {

let $d5b288b16021bb00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5b288b16021bb00$var$load("fjNHB").then(()=>parcelRequire('34tgh'));

});

parcelRegister("jCs0C", function(module, exports) {

let $e4874af0fcf407ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4874af0fcf407ee$var$load("8wgTR").then(()=>parcelRequire('2YF6k'));

});

parcelRegister("5SsPO", function(module, exports) {

let $44785cda0d6f1977$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44785cda0d6f1977$var$load("lLpfP").then(()=>parcelRequire('crvL4'));

});

parcelRegister("d9xvN", function(module, exports) {

let $99361c5fe3fba7fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99361c5fe3fba7fa$var$load("6j79B").then(()=>parcelRequire('Ep8H8'));

});

parcelRegister("frfnt", function(module, exports) {

let $b3d54e4929f6deed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3d54e4929f6deed$var$load("dpeU1").then(()=>parcelRequire('7NPrx'));

});

parcelRegister("inUxe", function(module, exports) {

let $d6263aa9aaf97319$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6263aa9aaf97319$var$load("4A3f7").then(()=>parcelRequire('i2p5v'));

});

parcelRegister("flQhK", function(module, exports) {

let $b2d15ff40d112e1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2d15ff40d112e1a$var$load("1BVEq").then(()=>parcelRequire('2AtWd'));

});

parcelRegister("1OMhC", function(module, exports) {

let $152fe9fdf836feb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $152fe9fdf836feb6$var$load("jUMMO").then(()=>parcelRequire('9jC9P'));

});

parcelRegister("81qiI", function(module, exports) {

let $5d72d1878359424d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d72d1878359424d$var$load("bQCV5").then(()=>parcelRequire('7b1u7'));

});

parcelRegister("3BqL6", function(module, exports) {

let $29f99587fdb562da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29f99587fdb562da$var$load("7dDmH").then(()=>parcelRequire('lPInm'));

});

parcelRegister("jGcQ3", function(module, exports) {

let $e53be605e2a21597$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e53be605e2a21597$var$load("jBsSN").then(()=>parcelRequire('3DVt4'));

});

parcelRegister("1uDtI", function(module, exports) {

let $1167375c057b5bc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1167375c057b5bc2$var$load("4Av21").then(()=>parcelRequire('jtGep'));

});

parcelRegister("lduSs", function(module, exports) {

let $f722c376c99fdc71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f722c376c99fdc71$var$load("9P1aS").then(()=>parcelRequire('c8Q2n'));

});

parcelRegister("7rL6x", function(module, exports) {

let $56bf97f6c3a53761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56bf97f6c3a53761$var$load("ME74m").then(()=>parcelRequire('4vFQJ'));

});

parcelRegister("13N5z", function(module, exports) {

let $0c5c264e28184ba9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c5c264e28184ba9$var$load("16muz").then(()=>parcelRequire('8S2d5'));

});

parcelRegister("6p4u1", function(module, exports) {

let $4a988e211cfb73b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a988e211cfb73b3$var$load("44AF2").then(()=>parcelRequire('MeKSQ'));

});

parcelRegister("hmV0j", function(module, exports) {

let $ca50b58dabdae38c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca50b58dabdae38c$var$load("4dVgm").then(()=>parcelRequire('hBhq3'));

});

parcelRegister("82CEB", function(module, exports) {

let $5dac7e788e55864b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5dac7e788e55864b$var$load("2IyJP").then(()=>parcelRequire('hv1Az'));

});

parcelRegister("cqbvt", function(module, exports) {

let $90b0d6b52ebaa0f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90b0d6b52ebaa0f4$var$load("hdZjB").then(()=>parcelRequire('aoRVr'));

});

parcelRegister("4OMwv", function(module, exports) {

let $382178a0864d5cfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $382178a0864d5cfe$var$load("bSySW").then(()=>parcelRequire('Cam0x'));

});

parcelRegister("aTMcN", function(module, exports) {

let $7ef46f0c79a2ac2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ef46f0c79a2ac2d$var$load("jFPli").then(()=>parcelRequire('hjEHA'));

});

parcelRegister("cSl8T", function(module, exports) {

let $95faeda1d3929df8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95faeda1d3929df8$var$load("tpYwC").then(()=>parcelRequire('cn7RC'));

});

parcelRegister("grGrh", function(module, exports) {

let $bf901678f6ad1f5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf901678f6ad1f5a$var$load("ijyQj").then(()=>parcelRequire('9E78Q'));

});

parcelRegister("4fT85", function(module, exports) {

let $319353b56d137ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $319353b56d137ead$var$load("8eCH0").then(()=>parcelRequire('io0Lo'));

});

parcelRegister("hsL5e", function(module, exports) {

let $cb6992f8a1f9faac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb6992f8a1f9faac$var$load("LclDr").then(()=>parcelRequire('d2zPy'));

});

parcelRegister("7BpGO", function(module, exports) {
module.exports = JSON.parse('{"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading":[{"type":0,"value":"Consumption-based pricing starts with your next renewal"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro":[{"type":0,"value":"We\u2019re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "},{"type":1,"value":"cbpEffectiveDate"},{"type":0,"value":". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know":[{"type":0,"value":"Helpful things to know:"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text":[{"type":0,"value":"comment"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text":[{"type":0,"value":"lightbulb"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema":[{"children":[{"type":0,"value":"Contact support"}],"type":8,"value":"a"},{"type":0,"value":" if you have any questions"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit":[{"type":0,"value":"Consider "},{"children":[{"type":0,"value":"optimizing the structure of your schemas"}],"type":8,"value":"a"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button":[{"type":0,"value":"More details"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject":[{"type":0,"value":"[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide":[{"type":0,"value":"For more information, read more about "},{"children":[{"type":0,"value":"how feature usage limits work"}],"type":8,"value":"a"},{"type":0,"value":"."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button":[{"type":0,"value":"View and manage usage"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar":[{"type":0,"value":"User Avatar"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection":[{"type":0,"value":"Connection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge":[{"type":0,"value":"ID Badge"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description":[{"type":0,"value":"Deliver better customer support and quickly turn feedback into product improvements."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title":[{"type":0,"value":"Delight external customers with purpose-built features"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description":[{"type":0,"value":"Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title":[{"type":0,"value":"Unite teams to deliver exceptional service experiences"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us":[{"type":0,"value":"Contact us"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog":[{"type":0,"value":"Blog"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate":[{"type":0,"value":"Twitter"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":","}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" has requested a trial of Service Collection."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" requested your organization try Service Collection, Atlassian\u2019s solution for AI service management at high velocity."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta":[{"type":0,"value":"Try Service Collection for free"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":", "},{"type":1,"value":"requestingUserName"},{"type":0,"value":" wants you to start a Service Collection trial"}]}');

});

parcelRegister("6QBDZ", function(module, exports) {

let $4fc4ccb32bbf259c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fc4ccb32bbf259c$var$load("buWQo").then(()=>parcelRequire('jwwdv'));

});

parcelRegister("hsbp6", function(module, exports) {

let $cb4de5c053c35e1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb4de5c053c35e1c$var$load("bxZKZ").then(()=>parcelRequire('dvpU1'));

});

parcelRegister("5XNq8", function(module, exports) {

let $4578cc570218199d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4578cc570218199d$var$load("4uuyw").then(()=>parcelRequire('fwZvg'));

});

parcelRegister("jaglo", function(module, exports) {

let $df3ba110688b00d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df3ba110688b00d6$var$load("2qXcV").then(()=>parcelRequire('4VUSU'));

});

parcelRegister("lln0M", function(module, exports) {

let $f89d68bcea0ff631$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f89d68bcea0ff631$var$load("elG2c").then(()=>parcelRequire('3iOYF'));

});

parcelRegister("4R0PP", function(module, exports) {

let $388cc2755fc72999$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $388cc2755fc72999$var$load("3V7D1").then(()=>parcelRequire('lnyUd'));

});

parcelRegister("zm9ce", function(module, exports) {

let $06a472ff32f96172$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $06a472ff32f96172$var$load("jO9JA").then(()=>parcelRequire('jI7oG'));

});

parcelRegister("2PCg8", function(module, exports) {

let $20fe05ae0034f4c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20fe05ae0034f4c7$var$load("fuwWn").then(()=>parcelRequire('cRloE'));

});

parcelRegister("cSEky", function(module, exports) {

let $9609cff92260751d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9609cff92260751d$var$load("eJOes").then(()=>parcelRequire('hp07f'));

});

parcelRegister("8jOSK", function(module, exports) {

let $60e79131d9723a40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60e79131d9723a40$var$load("dSv74").then(()=>parcelRequire('12n7A'));

});

parcelRegister("lqJAb", function(module, exports) {

let $f99f62698e93e16b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f99f62698e93e16b$var$load("bVOQk").then(()=>parcelRequire('9uj17'));

});

parcelRegister("hLNRp", function(module, exports) {

let $cefd80b1afa8feb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cefd80b1afa8feb3$var$load("aYLJl").then(()=>parcelRequire('b9FSQ'));

});

parcelRegister("hEaLO", function(module, exports) {

let $cd8e86d8d69763f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd8e86d8d69763f2$var$load("dkMGw").then(()=>parcelRequire('1eenD'));

});

parcelRegister("edyni", function(module, exports) {

let $a59cf1afdbc00623$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a59cf1afdbc00623$var$load("4e64W").then(()=>parcelRequire('3Zqas'));

});

parcelRegister("3v8Uk", function(module, exports) {

let $28cb2d2d7331e888$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28cb2d2d7331e888$var$load("2557e").then(()=>parcelRequire('fCSaL'));

});

parcelRegister("bUyhs", function(module, exports) {

let $8abf84134836bc28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8abf84134836bc28$var$load("jFAe5").then(()=>parcelRequire('j281j'));

});

parcelRegister("4DZSE", function(module, exports) {

let $361ace1f90fb7a4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $361ace1f90fb7a4e$var$load("iiWbr").then(()=>parcelRequire('hOaWN'));

});

parcelRegister("kZ3Vp", function(module, exports) {

let $f46c8c950b0ef0d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f46c8c950b0ef0d6$var$load("ky0u2").then(()=>parcelRequire('1l7RQ'));

});

parcelRegister("5L9Y0", function(module, exports) {

let $431912bc8d9ed7db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $431912bc8d9ed7db$var$load("8dO9q").then(()=>parcelRequire('1KwlE'));

});

parcelRegister("9VlSx", function(module, exports) {

let $739a689663d28d88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $739a689663d28d88$var$load("5JSTH").then(()=>parcelRequire('1cFLu'));

});

parcelRegister("2IZJt", function(module, exports) {

let $1fbf93997dadbafc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fbf93997dadbafc$var$load("25N5T").then(()=>parcelRequire('2jPVy'));

});

parcelRegister("2IzXu", function(module, exports) {

let $1fab957193d1d319$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fab957193d1d319$var$load("4muy4").then(()=>parcelRequire('af0Hy'));

});

parcelRegister("bholk", function(module, exports) {

let $83642a475909fb55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83642a475909fb55$var$load("eYatm").then(()=>parcelRequire('2Z71B'));

});

parcelRegister("8bDhu", function(module, exports) {

let $5f5dd23b7ce2a143$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f5dd23b7ce2a143$var$load("ipSCZ").then(()=>parcelRequire('cGxOa'));

});

parcelRegister("4wkUe", function(module, exports) {

let $34aa5e1515eb8c2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34aa5e1515eb8c2d$var$load("3WUT3").then(()=>parcelRequire('24yoB'));

});

parcelRegister("jKH7t", function(module, exports) {

let $e613c2dab77671fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e613c2dab77671fc$var$load("66fD9").then(()=>parcelRequire('oWc1A'));

});

parcelRegister("ax7Wv", function(module, exports) {

let $7ab325b009aae694$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ab325b009aae694$var$load("f4Itd").then(()=>parcelRequire('jz5XV'));

});

parcelRegister("iXAiR", function(module, exports) {

let $dcd9e5bea65a9fe4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcd9e5bea65a9fe4$var$load("30JEs").then(()=>parcelRequire('5sSOO'));

});

parcelRegister("1kllb", function(module, exports) {

let $0f783681d79effd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f783681d79effd3$var$load("5t0DK").then(()=>parcelRequire('1JGHk'));

});

parcelRegister("bMeLJ", function(module, exports) {

let $892fa234e16d0ae9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $892fa234e16d0ae9$var$load("gNlLk").then(()=>parcelRequire('2525D'));

});

parcelRegister("cGxs1", function(module, exports) {

let $93c35aeda166b5bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93c35aeda166b5bc$var$load("c8iqx").then(()=>parcelRequire('33cWm'));

});

parcelRegister("bQE6x", function(module, exports) {

let $8a03a8f57dc4b450$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a03a8f57dc4b450$var$load("lQs6A").then(()=>parcelRequire('bmkcG'));

});

parcelRegister("5fPLI", function(module, exports) {

let $3d3682a4e3224c37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d3682a4e3224c37$var$load("fgTaG").then(()=>parcelRequire('7y2Wl'));

});

parcelRegister("2h5uo", function(module, exports) {

let $1a816d590986555b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a816d590986555b$var$load("jlFvm").then(()=>parcelRequire('cOflU'));

});

parcelRegister("8nApX", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("dkP8f", function(module, exports) {

let $9b54ce59ed110425$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b54ce59ed110425$var$load("gk64V").then(()=>parcelRequire('5IIdf'));

});

parcelRegister("9K0ut", function(module, exports) {

let $7178ca59f16d3321$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7178ca59f16d3321$var$load("fsnzn").then(()=>parcelRequire('4vVNg'));

});

parcelRegister("erGSk", function(module, exports) {

let $a844d86a68519c66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a844d86a68519c66$var$load("8JWF2").then(()=>parcelRequire('9LjTG'));

});

parcelRegister("xzGgN", function(module, exports) {

let $064ec2a40134f30e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $064ec2a40134f30e$var$load("czxXO").then(()=>parcelRequire('04Nh9'));

});

parcelRegister("afhQo", function(module, exports) {

let $7759258c9f1a7b40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7759258c9f1a7b40$var$load("2SHBN").then(()=>parcelRequire('6isq3'));

});

parcelRegister("418JS", function(module, exports) {

let $2ece08ca9ce0fd9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ece08ca9ce0fd9f$var$load("8Vsnm").then(()=>parcelRequire('jHZA4'));

});

parcelRegister("2bn0B", function(module, exports) {

let $196e74ec3e2071d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $196e74ec3e2071d4$var$load("ll2xm").then(()=>parcelRequire('CHhGe'));

});

parcelRegister("4bOOa", function(module, exports) {

let $30cf99f6bd7943b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30cf99f6bd7943b0$var$load("30zeN").then(()=>parcelRequire('bLNg4'));

});

parcelRegister("euHFi", function(module, exports) {

let $a8d5bd05841ae516$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8d5bd05841ae516$var$load("asSvh").then(()=>parcelRequire('24p1b'));

});

parcelRegister("9FYQQ", function(module, exports) {

let $70b72535ff06630a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70b72535ff06630a$var$load("ko3ZY").then(()=>parcelRequire('felsP'));

});

parcelRegister("9PYIr", function(module, exports) {

let $7297f964468a3efa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7297f964468a3efa$var$load("8hhkt").then(()=>parcelRequire('l8yVa'));

});

parcelRegister("aOs9j", function(module, exports) {

let $7df468bccc4a7c9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7df468bccc4a7c9e$var$load("3hBeC").then(()=>parcelRequire('lVZTS'));

});

parcelRegister("apYGp", function(module, exports) {

let $795b4f8a55492cc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $795b4f8a55492cc8$var$load("5yF0J").then(()=>parcelRequire('c8PQm'));

});

parcelRegister("bQEQ9", function(module, exports) {

let $8a043b0777e302a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a043b0777e302a3$var$load("a6jC4").then(()=>parcelRequire('7GItp'));

});

parcelRegister("9gMNA", function(module, exports) {

let $6bfb761abb00b843$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6bfb761abb00b843$var$load("aFMAu").then(()=>parcelRequire('10yxD'));

});

parcelRegister("bUcVf", function(module, exports) {

let $8aaef2c627fae52c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8aaef2c627fae52c$var$load("8oLhH").then(()=>parcelRequire('kQgQ4'));

});

parcelRegister("bE0oF", function(module, exports) {

let $87a3bcf80800cec9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $87a3bcf80800cec9$var$load("8cxcS").then(()=>parcelRequire('kzpl0'));

});

parcelRegister("dcBMI", function(module, exports) {

let $99c9b49a3c631fc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c9b49a3c631fc6$var$load("20mGg").then(()=>parcelRequire('bQEeI'));

});

parcelRegister("eayvQ", function(module, exports) {

let $a50cc552e900f8a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a50cc552e900f8a3$var$load("d4idW").then(()=>parcelRequire('3arua'));

});

parcelRegister("ktNCp", function(module, exports) {

let $ee8d014708fcfbe2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee8d014708fcfbe2$var$load("9pe2W").then(()=>parcelRequire('iWqAW'));

});

parcelRegister("iF5CO", function(module, exports) {

let $d9606b597a3b6709$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9606b597a3b6709$var$load("f9Y88").then(()=>parcelRequire('38lNl'));

});

parcelRegister("7ynNQ", function(module, exports) {

let $57fe2c29da44e0c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57fe2c29da44e0c3$var$load("h5YWz").then(()=>parcelRequire('jUTzs'));

});

parcelRegister("cRdXf", function(module, exports) {

let $95c542623c2f474c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95c542623c2f474c$var$load("6zoXD").then(()=>parcelRequire('3FJdS'));

});

parcelRegister("431S1", function(module, exports) {

let $2f28e4a35ee4728e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f28e4a35ee4728e$var$load("e1zG7").then(()=>parcelRequire('bbMoQ'));

});

parcelRegister("cLOXU", function(module, exports) {

let $94c16874f8ca58e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94c16874f8ca58e4$var$load("gOG0m").then(()=>parcelRequire('k6JMo'));

});

parcelRegister("9k4WX", function(module, exports) {

let $6c99d2476fa77929$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c99d2476fa77929$var$load("jnwxR").then(()=>parcelRequire('fvdnX'));

});

parcelRegister("kuR5A", function(module, exports) {

let $eebfca5cd355b1f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eebfca5cd355b1f0$var$load("kdhLI").then(()=>parcelRequire('ghdUi'));

});

parcelRegister("8mOnM", function(module, exports) {

let $617775c07208347b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $617775c07208347b$var$load("jLmcr").then(()=>parcelRequire('dnrkl'));

});

parcelRegister("aSGVv", function(module, exports) {

let $7ec03ed340617d62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ec03ed340617d62$var$load("14wFt").then(()=>parcelRequire('3cCIn'));

});

parcelRegister("akt5W", function(module, exports) {

let $785257423d4cf3dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $785257423d4cf3dd$var$load("88BSo").then(()=>parcelRequire('4RFM5'));

});

parcelRegister("6Mt5i", function(module, exports) {

let $4efdc95a52796118$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4efdc95a52796118$var$load("i8jRD").then(()=>parcelRequire('k1d4Y'));

});

parcelRegister("fSpz2", function(module, exports) {

let $b8efbaacc4227d0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8efbaacc4227d0f$var$load("bdOCZ").then(()=>parcelRequire('1JGyY'));

});

parcelRegister("10c2u", function(module, exports) {

let $0baf213eb796a2b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0baf213eb796a2b3$var$load("e5Kbr").then(()=>parcelRequire('l9pzx'));

});

parcelRegister("fzjVn", function(module, exports) {

let $b55994800bef8bad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b55994800bef8bad$var$load("Ck85q").then(()=>parcelRequire('lnuY1'));

});

parcelRegister("kHXyL", function(module, exports) {
module.exports = JSON.parse('{"got-it":[{"type":0,"value":"Got it"}],"mercury.mercury-groups-configure-permissions.message-template.email.configurePermissions":[{"type":0,"value":"Configure permissions"}],"mercury.mercury-groups-configure-permissions.message-template.email.footerText":[{"type":0,"value":"You received this email because you\u2019re an admin for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"mercury.mercury-groups-configure-permissions.message-template.email.footerTextRedacted":[{"type":0,"value":"You received this email because you\u2019re an admin for this organization."}],"mercury.mercury-groups-configure-permissions.message-template.email.heading":[{"type":0,"value":"Configure permissions for Focus user groups"}],"mercury.mercury-groups-configure-permissions.message-template.email.introduction":[{"type":0,"value":"Some user groups in your organization require updated permissions. This happens when:"}],"mercury.mercury-groups-configure-permissions.message-template.email.introductionItem1":[{"type":0,"value":"1. A new group has been added to Focus, or"}],"mercury.mercury-groups-configure-permissions.message-template.email.introductionItem2":[{"type":0,"value":"2. An existing group\u2019s Focus role has changed in Atlassian Administration."}],"mercury.mercury-groups-configure-permissions.message-template.email.learnMore":[{"type":0,"value":"Learn more"}],"mercury.mercury-groups-configure-permissions.message-template.email.subject.no-translate":[{"type":0,"value":"Action needed: Enable Focus permissions"}],"mercury.mercury-groups-configure-permissions.message-template.email.whatToDoNext":[{"type":0,"value":"Please review and enable permissions for these groups so affected users can start using Focus."}],"mercury.mercury-monthly-digest.email.arrow-icon.alt":[{"type":0,"value":"arrow-icon"}],"mercury.mercury-monthly-digest.email.arrow-right-icon.alt":[{"type":0,"value":"arrow-right-icon"}],"mercury.mercury-monthly-digest.email.calendar-icon.alt":[{"type":0,"value":"calendar-icon"}],"mercury.mercury-monthly-digest.email.catch.up.link":[{"type":0,"value":"Jump into Atlassian Focus"}],"mercury.mercury-monthly-digest.email.catch.up.text":[{"type":0,"value":"Want to catch up on previous updates? "},{"type":1,"value":"link"}],"mercury.mercury-monthly-digest.email.date-changed":[{"type":0,"value":"Date Changed"}],"mercury.mercury-monthly-digest.email.focus-area-icon.alt":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-monthly-digest.email.footer.atlassian-logo.alt":[{"type":0,"value":"Atlassian footer"}],"mercury.mercury-monthly-digest.email.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Focus"}],"mercury.mercury-monthly-digest.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"mercury.mercury-monthly-digest.email.for":[{"type":0,"value":"for"}],"mercury.mercury-monthly-digest.email.header.logoAltText":[{"type":0,"value":"Focus Logo"}],"mercury.mercury-monthly-digest.email.no-target-date.alt":[{"type":0,"value":"No target date set"}],"mercury.mercury-monthly-digest.email.status-changed":[{"type":0,"value":"Status changed"}],"mercury.mercury-monthly-digest.email.total-following.sub-header":[{"type":0,"value":"You\'re following "},{"type":1,"value":"total"},{"type":0,"value":" active focus areas, here\'s the breakdown."}],"mercury.mercury-monthly-digest.email.view-update":[{"type":0,"value":"View Update"}],"mercury.mercury-monthly-digest.message-template.email.subject.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", here are your monthly focus area updates"}],"mercury.mercury-re-engage-empty-focus-area.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"mercury.mercury-re-engage-empty-focus-area.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"mercury.mercury-re-engage-empty-focus-area.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"mercury.mercury-re-engage-empty-focus-area.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"mercury.mercury-re-engage-empty-focus-area.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"mercury.mercury-re-engage-empty-focus-area.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.cta-text.no-translate":[{"type":0,"value":"Explore automations"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.cta-url.no-translate":[{"type":0,"value":"https://support.atlassian.com/cloud-automation/docs/use-focus-with-jira-automations/"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.description.no-translate":[{"type":0,"value":"Automatically add Jira work to focus areas based on criteria like project, team, assignee, and more."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.title.no-translate":[{"type":0,"value":"Work linking automation"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.cta-text.no-translate":[{"type":0,"value":"Configure permissions"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.cta-url.no-translate":[{"type":0,"value":"https://support.atlassian.com/focus/docs/manage-user-group-permissions/"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.description.no-translate":[{"type":0,"value":"You can now configure permissions by user group \u2014 giving you more control over who can edit focus areas."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.title.no-translate":[{"type":0,"value":"Group permissions"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.cta-text.no-translate":[{"type":0,"value":"Visit focus areas"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.cta-url.no-translate":[{"type":0,"value":"https://helium.jira-dev.com/focus/reviews"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.description.no-translate":[{"type":0,"value":"We\'ve released updates to work in Focus, including custom Jira Align terminology, improved Jira status mapping, and rollups from child focus areas."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.title.no-translate":[{"type":0,"value":"Work improvements"}],"mercury.mercury-re-engage-whats-new.feature-highlights.heading.no-translate":[{"type":0,"value":"Feature highlights"}],"mercury.mercury-re-engage-whats-new.feature-highlights.icon.alt.no-translate":[{"type":0,"value":"Feature icon"}],"mercury.mercury-re-engage-whats-new.feature-highlights.subheading.no-translate":[{"type":0,"value":"Check out what\'s new and improved in Focus."}],"mercury.mercury-re-engage-whats-new.focus-area-summary.heading.no-translate":[{"type":0,"value":"Your team has created "},{"type":1,"value":"noOfFocusAreas"},{"type":0,"value":" new focus areas \u2014 follow to get notified of progress."}],"mercury.mercury-re-engage-whats-new.focus-area.created-by.no-translate":[{"type":1,"value":"relativeDate"},{"type":0,"value":" \xb7 created by "},{"type":1,"value":"userName"}],"mercury.mercury-re-engage-whats-new.focus-area.created-date.no-translate":[{"type":1,"value":"relativeDate"}],"mercury.mercury-re-engage-whats-new.focus-area.created.days-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" day ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" days ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.hours-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" hour ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" hours ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.minutes-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" minute ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" minutes ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.months-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" month ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" months ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.seconds-ago.no-translate":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"just now"}]},"=1":{"value":[{"type":7},{"type":0,"value":" second ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" seconds ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.weeks-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" week ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" weeks ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.icon.alt-text":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-re-engage-whats-new.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"mercury.mercury-re-engage-whats-new.follow-button.no-translate":[{"type":0,"value":"Follow"}],"mercury.mercury-re-engage-whats-new.message-template.email.banner.alt.no-translate":[{"type":0,"value":"Strategy Collection"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.atlassian-logo-alt.no-translate":[{"type":0,"value":"Atlassian"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.sent-by.no-translate":[{"type":0,"value":"This email was sent to you by Atlassian Focus"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"mercury.mercury-re-engage-whats-new.message-template.email.header.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", your team created "},{"children":[{"type":1,"value":"count"}],"type":8,"value":"countSpan"},{"type":0,"value":" new Focus areas"}],"mercury.mercury-re-engage-whats-new.message-template.email.pre-header.no-translate":[{"type":0,"value":"New ways to connect work and keep your team aligned."}],"mercury.mercury-re-engage-whats-new.message-template.email.subject.no-translate":[{"type":0,"value":"What\u2019s new in Focus"}],"mercury.mercury-re-engage-whats-new.test-message.email.header.sub-text.no-translate":[{"type":0,"value":"Follow to stay informed and get notified of progress."}],"mercury.message-templates.edit-focus-area-heirarchy-spotlight-body":[{"type":0,"value":"Whenever you need to make changes to your hierarchy you can do so from settings."}],"mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading":[{"type":0,"value":"Edit your focus area hierarchy"}]}');

});

parcelRegister("1d7Xm", function(module, exports) {

let $0e1d2d50638aa04a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e1d2d50638aa04a$var$load("233DY").then(()=>parcelRequire('fKwU8'));

});

parcelRegister("fhIlA", function(module, exports) {

let $b20ad7fe56e41be9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b20ad7fe56e41be9$var$load("fPDWC").then(()=>parcelRequire('35reh'));

});

parcelRegister("97nLs", function(module, exports) {

let $6a3733a367b8118e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a3733a367b8118e$var$load("1nNbp").then(()=>parcelRequire('jvqSD'));

});

parcelRegister("hnGKA", function(module, exports) {

let $ca75befe454ca2c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca75befe454ca2c7$var$load("kVG1M").then(()=>parcelRequire('kNDd8'));

});

parcelRegister("3Lnvg", function(module, exports) {

let $2bd7fe26a209d908$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bd7fe26a209d908$var$load("2dw9h").then(()=>parcelRequire('i7wi3'));

});

parcelRegister("2uM3C", function(module, exports) {

let $1d13a94d7213469a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d13a94d7213469a$var$load("eHGzF").then(()=>parcelRequire('dqYiy'));

});

parcelRegister("8yElw", function(module, exports) {

let $63b0cb9cfcd9150e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $63b0cb9cfcd9150e$var$load("7ogxc").then(()=>parcelRequire('8OCzv'));

});

parcelRegister("auCC2", function(module, exports) {

let $7a3aa859523330fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a3aa859523330fc$var$load("fDdMl").then(()=>parcelRequire('2Iidu'));

});

parcelRegister("3WFy2", function(module, exports) {

let $2df70474e112b4db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2df70474e112b4db$var$load("aV0w9").then(()=>parcelRequire('eVkih'));

});

parcelRegister("4vHmF", function(module, exports) {

let $348bb1f66c5233d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $348bb1f66c5233d5$var$load("j1eUL").then(()=>parcelRequire('5KSuP'));

});

parcelRegister("lYcKE", function(module, exports) {

let $ffe917c3a7be8151$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffe917c3a7be8151$var$load("cc1H3").then(()=>parcelRequire('bDSsV'));

});

parcelRegister("9G9oT", function(module, exports) {

let $70bf540ac3fcefc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70bf540ac3fcefc5$var$load("iBJl3").then(()=>parcelRequire('iwR1g'));

});

parcelRegister("8iP56", function(module, exports) {

let $60b7a0d982553695$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60b7a0d982553695$var$load("lYlZW").then(()=>parcelRequire('51pqL'));

});

parcelRegister("iDdYL", function(module, exports) {

let $d906b67297d20a1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d906b67297d20a1d$var$load("deZDr").then(()=>parcelRequire('mkvWp'));

});

parcelRegister("7sVxF", function(module, exports) {

let $56f7c8961670fdce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56f7c8961670fdce$var$load("iZvLM").then(()=>parcelRequire('3LR6X'));

});

parcelRegister("1NRP3", function(module, exports) {

let $15041e0e94c94573$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15041e0e94c94573$var$load("ejFfH").then(()=>parcelRequire('7299x'));

});

parcelRegister("eSyFb", function(module, exports) {

let $ad50ff3a0c162144$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad50ff3a0c162144$var$load("9XWAe").then(()=>parcelRequire('ckkq8'));

});

parcelRegister("jiKDf", function(module, exports) {

let $e0d3dee97e37f57a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0d3dee97e37f57a$var$load("cjEpc").then(()=>parcelRequire('4wXd5'));

});

parcelRegister("lOf4U", function(module, exports) {

let $fe09f6b4561f70d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fe09f6b4561f70d6$var$load("fKD9g").then(()=>parcelRequire('1WAgc'));

});

parcelRegister("14cLa", function(module, exports) {

let $0c700ff866d40d95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c700ff866d40d95$var$load("4p1M4").then(()=>parcelRequire('7vChv'));

});

parcelRegister("7gvhr", function(module, exports) {

let $54a24aa51b90be98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54a24aa51b90be98$var$load("6F9Q6").then(()=>parcelRequire('68T1m'));

});

parcelRegister("isYx2", function(module, exports) {

let $d719cbe6ef09f58d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d719cbe6ef09f58d$var$load("eAqp7").then(()=>parcelRequire('8zEpB'));

});

parcelRegister("2ivap", function(module, exports) {

let $1ac57049a24f3731$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ac57049a24f3731$var$load("eLnWW").then(()=>parcelRequire('hIbcI'));

});

parcelRegister("bspFP", function(module, exports) {

let $857639795340119b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $857639795340119b$var$load("3oq4x").then(()=>parcelRequire('inFdk'));

});

parcelRegister("iT7Bj", function(module, exports) {

let $dc034268eb8c7529$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc034268eb8c7529$var$load("hrbca").then(()=>parcelRequire('iUZjn'));

});

parcelRegister("1ufvN", function(module, exports) {

let $1154a01f93764fe8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1154a01f93764fe8$var$load("hjKX1").then(()=>parcelRequire('a3ED6'));

});

parcelRegister("gummO", function(module, exports) {

let $c010cc4771b297b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c010cc4771b297b1$var$load("aOoSy").then(()=>parcelRequire('7jnAA'));

});

parcelRegister("4kqhJ", function(module, exports) {

let $326d6b4fd96be8d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $326d6b4fd96be8d7$var$load("gDItP").then(()=>parcelRequire('SCLJM'));

});

parcelRegister("gip1e", function(module, exports) {

let $bdd1bc03597b82e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdd1bc03597b82e1$var$load("p1FD0").then(()=>parcelRequire('8vZ67'));

});

parcelRegister("lRss2", function(module, exports) {

let $fea49e0a4b3da52b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fea49e0a4b3da52b$var$load("4cWYg").then(()=>parcelRequire('cC6lI'));

});

parcelRegister("kSxqn", function(module, exports) {

let $f332c7356b9f6e94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f332c7356b9f6e94$var$load("afWwx").then(()=>parcelRequire('dfKtg'));

});

parcelRegister("452Wi", function(module, exports) {

let $2f89e8b6d831d8ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f89e8b6d831d8ec$var$load("1rCyU").then(()=>parcelRequire('6aXrQ'));

});

parcelRegister("jJkiB", function(module, exports) {

let $e5d1f73e913b63b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5d1f73e913b63b4$var$load("9iSQB").then(()=>parcelRequire('c3n3p'));

});

parcelRegister("fVcfA", function(module, exports) {

let $b975ae8fb90b3bdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b975ae8fb90b3bdd$var$load("anqUS").then(()=>parcelRequire('rAGPp'));

});

parcelRegister("jeVa2", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"playground.post-office-auto-merge-config.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.post-office-auto-merge-config.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.post-office-auto-merge-config.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.post-office-auto-merge-config.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"playground.post-office-auto-merge-config.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"playground.post-office-auto-merge-config.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.post-office-auto-merge-config.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("8jtTq", function(module, exports) {

let $60d74934f3fc4f2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60d74934f3fc4f2d$var$load("4naQb").then(()=>parcelRequire('7WEkG'));

});

parcelRegister("cv3GI", function(module, exports) {

let $919b3d9d355b965c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $919b3d9d355b965c$var$load("dqLxh").then(()=>parcelRequire('azhMm'));

});

parcelRegister("ZXTsi", function(module, exports) {

let $0ba42835c54e4fbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ba42835c54e4fbb$var$load("8WeOJ").then(()=>parcelRequire('78ZfA'));

});

parcelRegister("lY5PF", function(module, exports) {

let $ffe3b9c6d44a0d09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffe3b9c6d44a0d09$var$load("Ror2l").then(()=>parcelRequire('gdBO8'));

});

parcelRegister("9V8xD", function(module, exports) {

let $7390101d8126e1bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7390101d8126e1bd$var$load("drAPP").then(()=>parcelRequire('3DBMU'));

});

parcelRegister("7pWep", function(module, exports) {

let $566809c5586072e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $566809c5586072e0$var$load("esJrS").then(()=>parcelRequire('1Ja9P'));

});

parcelRegister("6rKzg", function(module, exports) {

let $4b19631981ab924d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4b19631981ab924d$var$load("lGAmz").then(()=>parcelRequire('biXgE'));

});

parcelRegister("2oKaF", function(module, exports) {

let $1bf1a33f953205dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1bf1a33f953205dc$var$load("khrIN").then(()=>parcelRequire('h4j8A'));

});

parcelRegister("41esF", function(module, exports) {

let $2ed27928cd788e44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ed27928cd788e44$var$load("jtHQR").then(()=>parcelRequire('cOAQ0'));

});

parcelRegister("dRD1P", function(module, exports) {

let $a17e7fdba862d49d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a17e7fdba862d49d$var$load("ixtOF").then(()=>parcelRequire('f8gcV'));

});

parcelRegister("fFTG6", function(module, exports) {

let $b695dfd516b154ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b695dfd516b154ac$var$load("fIHQM").then(()=>parcelRequire('l9n03'));

});

parcelRegister("bCI0M", function(module, exports) {

let $8765621c816a7691$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8765621c816a7691$var$load("kylxz").then(()=>parcelRequire('8k3Dp'));

});

parcelRegister("4l9p8", function(module, exports) {

let $32906b1e071934a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32906b1e071934a6$var$load("22CLQ").then(()=>parcelRequire('aDz18'));

});

parcelRegister("brtXp", function(module, exports) {

let $85497431c9caea5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85497431c9caea5b$var$load("dniwF").then(()=>parcelRequire('drxA7'));

});

parcelRegister("FE06j", function(module, exports) {

let $07d2dbbdad86cc63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07d2dbbdad86cc63$var$load("bxYVx").then(()=>parcelRequire('3usyN'));

});

parcelRegister("4QkHm", function(module, exports) {

let $386c12fec7a863d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $386c12fec7a863d3$var$load("9y5Sq").then(()=>parcelRequire('kssqx'));

});

parcelRegister("gbbp3", function(module, exports) {

let $bc7684d9967ffe8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc7684d9967ffe8f$var$load("i2egy").then(()=>parcelRequire('6iScM'));

});

parcelRegister("e82Fu", function(module, exports) {

let $a493e1ea29534ab6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a493e1ea29534ab6$var$load("b55kW").then(()=>parcelRequire('eQ2gb'));

});

parcelRegister("e6FoT", function(module, exports) {

let $a451bd80e4cc8590$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a451bd80e4cc8590$var$load("hhVwh").then(()=>parcelRequire('jLy0N'));

});

parcelRegister("fhiWh", function(module, exports) {

let $b1f7226b5b50be9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1f7226b5b50be9d$var$load("h3C0X").then(()=>parcelRequire('3QxlH'));

});

parcelRegister("aWZX5", function(module, exports) {

let $7f8f6089c9f65a67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f8f6089c9f65a67$var$load("eo1Nf").then(()=>parcelRequire('1h2Il'));

});

parcelRegister("aV1kH", function(module, exports) {

let $7f3042f4c62cd8da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f3042f4c62cd8da$var$load("l7vp6").then(()=>parcelRequire('hJpAP'));

});

parcelRegister("6f7fJ", function(module, exports) {

let $48b9c506223d77b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48b9c506223d77b2$var$load("5dqQO").then(()=>parcelRequire('6sj97'));

});

parcelRegister("7y5pr", function(module, exports) {

let $57efe78feb2dff90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57efe78feb2dff90$var$load("cw6Fw").then(()=>parcelRequire('5g2dy'));

});

parcelRegister("jHNNf", function(module, exports) {

let $e588a866ca439639$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e588a866ca439639$var$load("f0uil").then(()=>parcelRequire('lQSZ5'));

});

parcelRegister("8Qs2q", function(module, exports) {

let $6708eddb17e5dda2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6708eddb17e5dda2$var$load("jtO9F").then(()=>parcelRequire('j1nNh'));

});

parcelRegister("kVBlv", function(module, exports) {

let $f3c619a7336e0990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3c619a7336e0990$var$load("dXgKT").then(()=>parcelRequire('9SXle'));

});

parcelRegister("46N3z", function(module, exports) {

let $2fddc698f812fa93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2fddc698f812fa93$var$load("4xODr").then(()=>parcelRequire('iTbmt'));

});

parcelRegister("l5yjD", function(module, exports) {

let $f5a4aef63b1b252b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5a4aef63b1b252b$var$load("75XmY").then(()=>parcelRequire('iG3jk'));

});

parcelRegister("gM1Sd", function(module, exports) {

let $c362950c8cc8211d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c362950c8cc8211d$var$load("4qXPA").then(()=>parcelRequire('abn1m'));

});

parcelRegister("jcc6B", function(module, exports) {

let $df988734d8b113d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df988734d8b113d1$var$load("8yIqn").then(()=>parcelRequire('21Ujf'));

});

parcelRegister("eSb44", function(module, exports) {

let $ad3eb1063f20961e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad3eb1063f20961e$var$load("e0f4q").then(()=>parcelRequire('lHABM'));

});

parcelRegister("ab3Wu", function(module, exports) {

let $01e9841611536c2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01e9841611536c2b$var$load("726Hx").then(()=>parcelRequire('fjIWF'));

});

parcelRegister("4KkWY", function(module, exports) {

let $374bb58e0478b75f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $374bb58e0478b75f$var$load("icq5C").then(()=>parcelRequire('9o7yY'));

});

parcelRegister("kMgxO", function(module, exports) {
module.exports = JSON.parse('{"Check out the support documentation for more details.":[{"type":0,"value":"Check out the support documentation for more details."}],"Dismiss":[{"type":0,"value":"Dismiss"}],"Looking to enhance the agent experience?":[{"type":0,"value":"Looking to enhance the agent experience?"}],"Not now":[{"type":0,"value":"Not now"}],"Show me":[{"type":0,"value":"Show me"}],"Show me the apps":[{"type":0,"value":"Show me the apps"}],"Upgrade options":[{"type":0,"value":"Upgrade options"}],"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!":[{"type":0,"value":"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!"}],"We\'ve made some changes to imports":[{"type":0,"value":"We\'ve made some changes to imports"}],"We\u2019re having trouble with your plan":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"We\u2019ve kept you on the Standard plan of Confluence for now.":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users.":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"confluence-3p-connector-nudge.action.connect-nonfinal":[{"type":0,"value":"Connect now"}],"confluence-3p-connector-nudge.action.learnMore-nonfinal":[{"type":0,"value":"Learn more"}],"confluence-3p-connector-nudge.description-nonfinal":[{"type":0,"value":"You\'ve been using "},{"type":1,"value":"providerName"},{"type":0,"value":" in Confluence. Connect it to get richer previews and better search."}],"confluence-3p-connector-nudge.title-nonfinal":[{"type":0,"value":"Connect "},{"type":1,"value":"providerName"}],"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer":[{"type":0,"value":"Uses AI. Verify results."}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer-alt-text":[{"type":0,"value":"Information icon"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office-team.email-with-tracking-links.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.email-with-tracking-links.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.email-with-tracking-links.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.email-with-tracking-links.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.email-with-tracking-links.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.email-with-tracking-links.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.email-with-tracking-links.test-message.email.confluence-link.text.no-translate":[{"type":0,"value":"Go to Confluence link"}],"post-office-team.email-with-tracking-links.test-message.email.jira-link.text.no-translate":[{"type":0,"value":"Go to Jira link"}],"post-office-team.email-with-tracking-links.test-message.email.trello-link.text.no-translate":[{"type":0,"value":"Go to Trello board"}],"post-office-team.push-msg-object-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.push-msg-object-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.push-msg-object-tracking.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office-team.push-msg-object-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.push-msg-object-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.push-msg-object-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.push-msg-object-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.push-msg-object-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\\n\\t\\t\\t\\t\\tResearch team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}],"post-office.post-office-team.push-msg-object-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.post-office-team.push-msg-object-tracking.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.triggered-ipms.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.triggered-ipms.spotlight-body":[{"type":0,"value":"This is an example you can use to scaffold your own Spotlight experiences."}],"post-office.triggered-ipms.spotlight-body-1":[{"type":0,"value":"This is an example you can use to scaffold your own Spotlight Tour experiences."}],"post-office.triggered-ipms.spotlight-body-2":[{"type":0,"value":"You can transition between steps with the back, next action handlers."}],"post-office.triggered-ipms.spotlight-body-3":[{"type":0,"value":"And complete, or opt out of the tour with the done, and dismiss props."}],"post-office.triggered-ipms.spotlight-button-back":[{"type":0,"value":"Back"}],"post-office.triggered-ipms.spotlight-button-done":[{"type":0,"value":"Done"}],"post-office.triggered-ipms.spotlight-button-next":[{"type":0,"value":"Next"}],"post-office.triggered-ipms.spotlight-heading":[{"type":0,"value":"Spotlight Tour Example"}]}');

});

parcelRegister("myuXu", function(module, exports) {

let $043cd0d6b068b9f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $043cd0d6b068b9f6$var$load("89k3K").then(()=>parcelRequire('Co4xy'));

});

parcelRegister("1Zl29", function(module, exports) {

let $172bcdd03699f684$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $172bcdd03699f684$var$load("i4TIz").then(()=>parcelRequire('iB0OS'));

});

parcelRegister("3ktao", function(module, exports) {

let $26c9dd3fa9151fea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26c9dd3fa9151fea$var$load("aJTUh").then(()=>parcelRequire('kVtQW'));

});

parcelRegister("aTDX5", function(module, exports) {

let $7eee080f84383ef6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eee080f84383ef6$var$load("4UjsP").then(()=>parcelRequire('8SHH6'));

});

parcelRegister("gMxgr", function(module, exports) {

let $c37aeea100731088$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c37aeea100731088$var$load("eAMuS").then(()=>parcelRequire('4BKTu'));

});

parcelRegister("1Af9x", function(module, exports) {

let $1274e84305edc447$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1274e84305edc447$var$load("cgGsl").then(()=>parcelRequire('aA2px'));

});

parcelRegister("buXa0", function(module, exports) {

let $85f0630ff2417c67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85f0630ff2417c67$var$load("jCHho").then(()=>parcelRequire('j1D9P'));

});

parcelRegister("ccbpW", function(module, exports) {

let $8e0f7646ca409140$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e0f7646ca409140$var$load("V9B1k").then(()=>parcelRequire('8sTMU'));

});

parcelRegister("j434L", function(module, exports) {

let $de10c6d6aa84c266$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de10c6d6aa84c266$var$load("lHcdb").then(()=>parcelRequire('63U6R'));

});

parcelRegister("dMsU4", function(module, exports) {

let $a0862dacf79c82a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0862dacf79c82a2$var$load("8GdFF").then(()=>parcelRequire('usVdc'));

});

parcelRegister("jyRDE", function(module, exports) {

let $e3dacccf6d91b87b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3dacccf6d91b87b$var$load("1RIZj").then(()=>parcelRequire('79vH0'));

});

parcelRegister("9pglX", function(module, exports) {

let $6d932242d21b1165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d932242d21b1165$var$load("6XajZ").then(()=>parcelRequire('5GSxA'));

});

parcelRegister("iozT6", function(module, exports) {

let $d6464e751b04691b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6464e751b04691b$var$load("h17IG").then(()=>parcelRequire('6fBb8'));

});

parcelRegister("dJrYt", function(module, exports) {

let $0294787994f85f03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0294787994f85f03$var$load("gr1Hg").then(()=>parcelRequire('2gvJk'));

});

parcelRegister("7B9fx", function(module, exports) {

let $588329e80ad5a2e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $588329e80ad5a2e6$var$load("ex9RG").then(()=>parcelRequire('aJCau'));

});

parcelRegister("7GCXU", function(module, exports) {

let $598aae54c1a009e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $598aae54c1a009e4$var$load("lpnZh").then(()=>parcelRequire('aWdCQ'));

});

parcelRegister("eDQJt", function(module, exports) {

let $aa8d9cc340d98eb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa8d9cc340d98eb8$var$load("79K0y").then(()=>parcelRequire('lPJba'));

});

parcelRegister("h2jfy", function(module, exports) {

let $c6718e348de1e33f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c6718e348de1e33f$var$load("bi09N").then(()=>parcelRequire('7rjx9'));

});

parcelRegister("jFjcD", function(module, exports) {

let $e510bdeb2eda46ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e510bdeb2eda46ca$var$load("iwWXu").then(()=>parcelRequire('4Qx3O'));

});

parcelRegister("2pDy6", function(module, exports) {

let $1c1c982ff7628e88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c1c982ff7628e88$var$load("coHip").then(()=>parcelRequire('b85cr'));

});

parcelRegister("7ef6d", function(module, exports) {

let $54358d9f2fefdd1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54358d9f2fefdd1d$var$load("kiUGs").then(()=>parcelRequire('hEjEd'));

});

parcelRegister("na8Hk", function(module, exports) {

let $045a038c67b9402f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $045a038c67b9402f$var$load("aHmyu").then(()=>parcelRequire('kMiOr'));

});

parcelRegister("cgktE", function(module, exports) {

let $8ed6dd0957798f4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ed6dd0957798f4a$var$load("1vP6v").then(()=>parcelRequire('9znD6'));

});

parcelRegister("1I6NP", function(module, exports) {

let $13ef2d5ab0911d26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $13ef2d5ab0911d26$var$load("aO2Db").then(()=>parcelRequire('96Dop'));

});

parcelRegister("9BVla", function(module, exports) {

let $6ff40c6264893904$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ff40c6264893904$var$load("g49kY").then(()=>parcelRequire('dgI5j'));

});

parcelRegister("cZ5ja", function(module, exports) {

let $973f4ca1175d1217$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $973f4ca1175d1217$var$load("9Vcgl").then(()=>parcelRequire('28lMX'));

});

parcelRegister("im5oS", function(module, exports) {

let $d5ce78700f0202e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5ce78700f0202e8$var$load("jzyvw").then(()=>parcelRequire('ag8Mt'));

});

parcelRegister("e6ztg", function(module, exports) {

let $a44d2408cda76a96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a44d2408cda76a96$var$load("jE6NT").then(()=>parcelRequire('2yLDN'));

});

parcelRegister("lTjdd", function(module, exports) {

let $fefda3280fb6a5b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fefda3280fb6a5b4$var$load("jPFt3").then(()=>parcelRequire('3QGFD'));

});

parcelRegister("f1Q5v", function(module, exports) {

let $af0f5a9209bda4f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af0f5a9209bda4f0$var$load("dchHI").then(()=>parcelRequire('7WQQ0'));

});

parcelRegister("gDyIy", function(module, exports) {

let $c1cb380d18d37cc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1cb380d18d37cc7$var$load("7IGY8").then(()=>parcelRequire('htGib'));

});

parcelRegister("9JZXX", function(module, exports) {

let $7178622f45300f96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7178622f45300f96$var$load("jTear").then(()=>parcelRequire('2Eg1T'));

});

parcelRegister("e8Hp5", function(module, exports) {

let $a4b37b1a9bfa0d68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4b37b1a9bfa0d68$var$load("ilX2r").then(()=>parcelRequire('eAjlW'));

});

parcelRegister("2iQNZ", function(module, exports) {

let $1ad6394208fc1b58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ad6394208fc1b58$var$load("hbZkz").then(()=>parcelRequire('6ltFW'));

});

parcelRegister("3nDO6", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6YvRD = parcelRequire("6YvRD");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8393a846181017db$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8393a846181017db$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8393a846181017db$var$importHelper(await (parcelRequire("3MpkQ")));
        case 'da':
            return $8393a846181017db$var$importHelper(await (parcelRequire("byKYQ")));
        case 'de':
            return $8393a846181017db$var$importHelper(await (parcelRequire("Ny4Dt")));
        case 'en-GB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lwrPN")));
        case 'en-US':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cfGkc")));
        case 'en-XA':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eBjVi")));
        case 'en-XB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("b9V4D")));
        case 'en-ZZ':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cjS15")));
        case 'en':
            return $8393a846181017db$var$importHelper(await Promise.resolve((parcelRequire("6YvRD"))));
        case 'es':
            return $8393a846181017db$var$importHelper(await (parcelRequire("fUiux")));
        case 'et':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6DVur")));
        case 'fi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8FDQ0")));
        case 'fr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7zYd1")));
        case 'hr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kUL2N")));
        case 'hu':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6eZER")));
        case 'it':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eUqg6")));
        case 'ja':
            return $8393a846181017db$var$importHelper(await (parcelRequire("at2wl")));
        case 'ko':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ihALB")));
        case 'nb':
            return $8393a846181017db$var$importHelper(await (parcelRequire("1ZGET")));
        case 'nl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIxnh")));
        case 'pl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9WZ2j")));
        case 'pt-BR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bhB5c")));
        case 'ro':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ckNRb")));
        case 'ru':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ir1xn")));
        case 'sl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("di9OC")));
        case 'sr-RS':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIjgo")));
        case 'sr-YR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8E5tZ")));
        case 'sr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("75Frc")));
        case 'sv':
            return $8393a846181017db$var$importHelper(await (parcelRequire("aCqVE")));
        case 'th':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2q19p")));
        case 'tr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kP7UO")));
        case 'uk':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cJoPm")));
        case 'vi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("h62OK")));
        case 'zh-CN':
            return $8393a846181017db$var$importHelper(await (parcelRequire("95Xcn")));
        case 'zh-TW':
            return $8393a846181017db$var$importHelper(await (parcelRequire("dzsOs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6YvRD));
    }
};
module.exports["messagesLoader"] = $8393a846181017db$export$720676d8cac8fbb;

});

parcelRegister("6YvRD", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.browser-push-body.no-translate\":[{\"type\":0,\"value\":\"You are a lovely\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("3MpkQ", function(module, exports) {

let $2c0981d7c54f4e53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c0981d7c54f4e53$var$load("bv8GZ").then(()=>parcelRequire('74xff'));

});

parcelRegister("byKYQ", function(module, exports) {

let $022bfd294816e214$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $022bfd294816e214$var$load("cdeuH").then(()=>parcelRequire('hQIGt'));

});

parcelRegister("Ny4Dt", function(module, exports) {

let $094f020f0aa3b5f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $094f020f0aa3b5f7$var$load("7gF8f").then(()=>parcelRequire('j9sSr'));

});

parcelRegister("lwrPN", function(module, exports) {

let $fab22d73b102392e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fab22d73b102392e$var$load("djb49").then(()=>parcelRequire('4tVXT'));

});

parcelRegister("cfGkc", function(module, exports) {

let $8eb7b7970922d5fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8eb7b7970922d5fc$var$load("koawN").then(()=>parcelRequire('k7TQm'));

});

parcelRegister("eBjVi", function(module, exports) {

let $aa13f9b6f0cd2936$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa13f9b6f0cd2936$var$load("6htQT").then(()=>parcelRequire('lIWyQ'));

});

parcelRegister("b9V4D", function(module, exports) {

let $81fccea2c7692076$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81fccea2c7692076$var$load("fi75i").then(()=>parcelRequire('5QCdA'));

});

parcelRegister("cjS15", function(module, exports) {

let $8f8128f149f291d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f8128f149f291d2$var$load("ksTQ6").then(()=>parcelRequire('4EAWY'));

});

parcelRegister("fUiux", function(module, exports) {

let $b94a6e00f1130c23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b94a6e00f1130c23$var$load("5CGnz").then(()=>parcelRequire('1PSNt'));

});

parcelRegister("6DVur", function(module, exports) {

let $4d62fae3367e8fba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d62fae3367e8fba$var$load("X0Jic").then(()=>parcelRequire('cNrRQ'));

});

parcelRegister("8FDQ0", function(module, exports) {

let $65010e043670e359$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65010e043670e359$var$load("9Oxgj").then(()=>parcelRequire('5L1ix'));

});

parcelRegister("7zYd1", function(module, exports) {

let $584a81908bcf6b02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $584a81908bcf6b02$var$load("kAg8V").then(()=>parcelRequire('f4vYC'));

});

parcelRegister("kUL2N", function(module, exports) {

let $f39d8798e3aacd6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f39d8798e3aacd6e$var$load("36XYg").then(()=>parcelRequire('jRDUE'));

});

parcelRegister("6eZER", function(module, exports) {

let $48b3e0de1ed42ace$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48b3e0de1ed42ace$var$load("fM2oh").then(()=>parcelRequire('lmfGu'));

});

parcelRegister("eUqg6", function(module, exports) {

let $adaaaa1542ad404d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adaaaa1542ad404d$var$load("xnqy2").then(()=>parcelRequire('J7CId'));

});

parcelRegister("at2wl", function(module, exports) {

let $79ee915b8a5cfa5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79ee915b8a5cfa5f$var$load("awkVi").then(()=>parcelRequire('iEu8X'));

});

parcelRegister("ihALB", function(module, exports) {

let $d4f655a3a30906cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4f655a3a30906cd$var$load("11DLa").then(()=>parcelRequire('lklBt'));

});

parcelRegister("1ZGET", function(module, exports) {

let $173c9412aa2d6ea2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $173c9412aa2d6ea2$var$load("barSq").then(()=>parcelRequire('edhkG'));

});

parcelRegister("jIxnh", function(module, exports) {

let $e5ac03dff8d9aeff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5ac03dff8d9aeff$var$load("a8heY").then(()=>parcelRequire('aFb9z'));

});

parcelRegister("9WZ2j", function(module, exports) {

let $73e8e060a723dc38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73e8e060a723dc38$var$load("6hlNE").then(()=>parcelRequire('bAPfw'));

});

parcelRegister("bhB5c", function(module, exports) {

let $836e0c1dd75645f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $836e0c1dd75645f5$var$load("2bqSD").then(()=>parcelRequire('c1E8Q'));

});

parcelRegister("ckNRb", function(module, exports) {

let $8fae06d114550a7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fae06d114550a7b$var$load("j6IGj").then(()=>parcelRequire('88y6K'));

});

parcelRegister("ir1xn", function(module, exports) {

let $d6bbf0de65f9bce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6bbf0de65f9bce4$var$load("bJykp").then(()=>parcelRequire('8Rjw5'));

});

parcelRegister("di9OC", function(module, exports) {

let $9ad491ee252155d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ad491ee252155d7$var$load("7Rbde").then(()=>parcelRequire('awMdX'));

});

parcelRegister("jIjgo", function(module, exports) {

let $e5a111b573c22c47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5a111b573c22c47$var$load("l8auu").then(()=>parcelRequire('eNbID'));

});

parcelRegister("8E5tZ", function(module, exports) {

let $64b64febd9024da4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64b64febd9024da4$var$load("3ColL").then(()=>parcelRequire('YVOUf'));

});

parcelRegister("75Frc", function(module, exports) {

let $529924b6cea297fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $529924b6cea297fd$var$load("2VSOH").then(()=>parcelRequire('fEcqf'));

});

parcelRegister("aCqVE", function(module, exports) {

let $7bb257853d40c532$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bb257853d40c532$var$load("dh2Er").then(()=>parcelRequire('6TlJn'));

});

parcelRegister("2q19p", function(module, exports) {

let $1c2ee6fb468abb06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c2ee6fb468abb06$var$load("kyBJI").then(()=>parcelRequire('7Nysq'));

});

parcelRegister("kP7UO", function(module, exports) {

let $f28eb5e89a23de79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f28eb5e89a23de79$var$load("eBLgB").then(()=>parcelRequire('1gaUd'));

});

parcelRegister("cJoPm", function(module, exports) {

let $944cf23be3b0d1a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $944cf23be3b0d1a4$var$load("ahhGv").then(()=>parcelRequire('bcwM6'));

});

parcelRegister("h62OK", function(module, exports) {

let $c7252eb9922192b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7252eb9922192b6$var$load("1Zesg").then(()=>parcelRequire('7fZ9R'));

});

parcelRegister("95Xcn", function(module, exports) {

let $69f280464f678177$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69f280464f678177$var$load("eLlpV").then(()=>parcelRequire('15VSW'));

});

parcelRegister("dzsOs", function(module, exports) {

let $9e14e4de0de5cb5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e14e4de0de5cb5f$var$load("bV8sS").then(()=>parcelRequire('dU88R'));

});

parcelRegister("l7nJS", function(module, exports) {
module.exports = JSON.parse("{\"rovo-agents.scenario-onboarding.backButton\":[{\"type\":0,\"value\":\"Back\"}],\"rovo-agents.scenario-onboarding.doneButton\":[{\"type\":0,\"value\":\"Done\"}],\"rovo-agents.scenario-onboarding.gettingStarted\":[{\"type\":0,\"value\":\"Getting started with your agent\"}],\"rovo-agents.scenario-onboarding.nextButton\":[{\"type\":0,\"value\":\"Next\"}],\"rovo-agents.scenario-onboarding.startTour\":[{\"type\":0,\"value\":\"Start Tour\"}],\"rovo-agents.scenario-onboarding.step1Body\":[{\"type\":0,\"value\":\"Scenarios allow you to instruct your agent to do things differently depending on the situation.\"}],\"rovo-agents.scenario-onboarding.step1Headline\":[{\"type\":0,\"value\":\"Tune your agent to each situation\"}],\"rovo-agents.scenario-onboarding.step2Body\":[{\"type\":0,\"value\":\"Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation.\"}],\"rovo-agents.scenario-onboarding.step2Headline\":[{\"type\":0,\"value\":\"Set your agent's traits and goals\"}],\"rovo-agents.scenario-onboarding.step3Body\":[{\"type\":0,\"value\":\"You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation.\"}],\"rovo-agents.scenario-onboarding.step3Headline\":[{\"type\":0,\"value\":\"See what your agent knows\"}],\"rovo-agents.scenario-onboarding.step4Body\":[{\"type\":0,\"value\":\"You can add skills to your agent's scenarios so it can connect and take action across apps.\"}],\"rovo-agents.scenario-onboarding.step4Headline\":[{\"type\":0,\"value\":\"See what your agent can do\"}],\"rovo-agents.scenario-onboarding.stepIndicator\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("7F3wY", function(module, exports) {

let $593f19e2a1825cdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $593f19e2a1825cdb$var$load("1eIRF").then(()=>parcelRequire('jDatA'));

});

parcelRegister("5ThXX", function(module, exports) {

let $44a00681c75483f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44a00681c75483f2$var$load("3aKJV").then(()=>parcelRequire('gYv7J'));

});

parcelRegister("ifLF0", function(module, exports) {

let $d49e9915e2025685$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d49e9915e2025685$var$load("bvL9U").then(()=>parcelRequire('3ncrE'));

});

parcelRegister("hQpPC", function(module, exports) {

let $cfdb549eb2c97eba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfdb549eb2c97eba$var$load("1HNuh").then(()=>parcelRequire('1OT7K'));

});

parcelRegister("grX31", function(module, exports) {

let $bf9cf89b15f74ffb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf9cf89b15f74ffb$var$load("5nM89").then(()=>parcelRequire('j1jR0'));

});

parcelRegister("56m6k", function(module, exports) {

let $3b6ea81b2753230a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b6ea81b2753230a$var$load("gfA6x").then(()=>parcelRequire('xrZKp'));

});

parcelRegister("j2jty", function(module, exports) {

let $ddbd4faeff81facd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddbd4faeff81facd$var$load("2ncxe").then(()=>parcelRequire('dD9uY'));

});

parcelRegister("aUTQd", function(module, exports) {

let $7f2a733d739e2607$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f2a733d739e2607$var$load("gQpFC").then(()=>parcelRequire('1YxvO'));

});

parcelRegister("2lc7b", function(module, exports) {

let $1b46f0b2e881056b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b46f0b2e881056b$var$load("aQi3k").then(()=>parcelRequire('d22qs'));

});

parcelRegister("9De0h", function(module, exports) {

let $70329e6402aff8c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70329e6402aff8c8$var$load("7r4Mk").then(()=>parcelRequire('4JJyB'));

});

parcelRegister("dPQCn", function(module, exports) {

let $a128da9da0a9c917$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a128da9da0a9c917$var$load("ezmrI").then(()=>parcelRequire('scPYT'));

});

parcelRegister("a3wwm", function(module, exports) {

let $752369317e754c2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $752369317e754c2d$var$load("8u2dK").then(()=>parcelRequire('8i35h'));

});

parcelRegister("N8n34", function(module, exports) {

let $093b11f971f19873$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $093b11f971f19873$var$load("iQKsR").then(()=>parcelRequire('eEEbH'));

});

parcelRegister("f73Ab", function(module, exports) {

let $b00a49e19326fcca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b00a49e19326fcca$var$load("l6Qbn").then(()=>parcelRequire('4Ko8J'));

});

parcelRegister("d1TD1", function(module, exports) {

let $97c684fc2512469b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97c684fc2512469b$var$load("cmxTT").then(()=>parcelRequire('lTx3E'));

});

parcelRegister("hqk7Y", function(module, exports) {

let $caf47a5202978575$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf47a5202978575$var$load("kOuFW").then(()=>parcelRequire('eQlp1'));

});

parcelRegister("6JSr6", function(module, exports) {

let $4e812be8e303a1d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e812be8e303a1d8$var$load("7S12o").then(()=>parcelRequire('1Z5O1'));

});

parcelRegister("PTBOV", function(module, exports) {

let $09bfe65332700b28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09bfe65332700b28$var$load("hOtIt").then(()=>parcelRequire('lx8ik'));

});

parcelRegister("BDhK6", function(module, exports) {

let $0711ee08417bc018$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0711ee08417bc018$var$load("hsogV").then(()=>parcelRequire('1IIuQ'));

});

parcelRegister("az4lL", function(module, exports) {

let $7b108c147c097a0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b108c147c097a0b$var$load("a7pdV").then(()=>parcelRequire('bga69'));

});

parcelRegister("kjp2o", function(module, exports) {

let $ec9900f43d05714d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec9900f43d05714d$var$load("ectHA").then(()=>parcelRequire('6CrhD'));

});

parcelRegister("3G2oA", function(module, exports) {

let $2ad7270acf9716fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ad7270acf9716fd$var$load("iHRZw").then(()=>parcelRequire('cQrPH'));

});

parcelRegister("eDz89", function(module, exports) {

let $aa7ff56684fe27a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa7ff56684fe27a0$var$load("3oWaU").then(()=>parcelRequire('7R82u'));

});

parcelRegister("j0FpS", function(module, exports) {

let $dd6e24d4b9141fff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd6e24d4b9141fff$var$load("bjotz").then(()=>parcelRequire('cqziN'));

});

parcelRegister("3VhJA", function(module, exports) {

let $2db473a318f885fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2db473a318f885fc$var$load("iOoAK").then(()=>parcelRequire('6Hmfz'));

});

parcelRegister("gsLZE", function(module, exports) {

let $bfc47d56c5f3041b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfc47d56c5f3041b$var$load("kDGaT").then(()=>parcelRequire('9NKdT'));

});

parcelRegister("ebIbe", function(module, exports) {

let $a5445d033110b74d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5445d033110b74d$var$load("jCVeU").then(()=>parcelRequire('eZmdV'));

});

parcelRegister("eJp0O", function(module, exports) {

let $ab98ab87180bb9b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab98ab87180bb9b5$var$load("e8CAg").then(()=>parcelRequire('i7S3K'));

});

parcelRegister("hXakN", function(module, exports) {

let $d11ff691de3a4123$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d11ff691de3a4123$var$load("iALKs").then(()=>parcelRequire('4MIWH'));

});

parcelRegister("dn1vt", function(module, exports) {

let $9bbe978df6b46361$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bbe978df6b46361$var$load("kiuvA").then(()=>parcelRequire('jVS84'));

});

parcelRegister("3kGQX", function(module, exports) {

let $26d47b161d2812bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26d47b161d2812bd$var$load("9d6gK").then(()=>parcelRequire('8G8gO'));

});

parcelRegister("fcA9B", function(module, exports) {

let $b114056685c3b293$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b114056685c3b293$var$load("alRHJ").then(()=>parcelRequire('6g6AR'));

});

parcelRegister("ayJEf", function(module, exports) {

let $7b007d2471ef62e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b007d2471ef62e7$var$load("5n9Ut").then(()=>parcelRequire('1zo8U'));

});

parcelRegister("eWB3S", function(module, exports) {

let $ae133b1a448e9365$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae133b1a448e9365$var$load("hPmxZ").then(()=>parcelRequire('f7OYW'));

});

parcelRegister("6e6y3", function(module, exports) {
module.exports = JSON.parse('{"rovo-button-onboarding-spotlight.copy-version-a.bodyText":[{"type":0,"value":"Connect the dots, simplify writing, and move projects forward."}],"rovo-button-onboarding-spotlight.copy-version-a.headlineText":[{"type":0,"value":"Your AI teammate is here"}],"rovo-button-onboarding-spotlight.copy-version-b.bodyText":[{"type":0,"value":"Rovo helps your team turn rough ideas into clear, polished pages."}],"rovo-button-onboarding-spotlight.copy-version-b.headlineText":[{"type":0,"value":"Create with AI"}],"rovo-button-onboarding-spotlight.copy-version-c.bodyText":[{"type":0,"value":"Your new AI teammate\u2019s here to draft, refine, and summarize content."}],"rovo-button-onboarding-spotlight.copy-version-c.headlineText":[{"type":0,"value":"Work smarter with Rovo"}],"rovo-button-onboarding-spotlight.getStartedButtonLabel":[{"type":0,"value":"Get started"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"rovo-expansion.rovo-extension-download-end-users.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-end-users.email.body.hello.subtext":[{"type":0,"value":"Love using Rovo? Take it to the next level with the Rovo browser extension."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.download-extension":[{"type":0,"value":"Download the extension"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.make-rovo-your-own":[{"type":0,"value":"Here\u2019s what you get"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.rovo-extension-features.description":[{"type":0,"value":"Rovo extension features: Chat with your company\u2019s knowledge base, right from any browser tab. Ask questions about what\u2019s open. Get context that connects back to your projects. Pick up where you left off. Rovo\u2019s new tab page keeps your recent work ready after that last unexpected interruption. Create what you need, fast. Instantly create work items across Jira, Confluence, and Loom. Make teamwork easy."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.try-it-today":[{"type":0,"value":"Try it today."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Try out the Rovo browser extension \u2013 Available now"}],"rovo-expansion.rovo-extension-download-org-admins-no-usage.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"rovo-expansion.rovo-extension-download-org-admins-no-usage.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"rovo-expansion.rovo-extension-download-org-admins-usage.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-org-admins-usage.email.body.hello.subtext":[{"type":0,"value":"Companies are using "},{"children":[{"type":0,"value":"AI 400% as often"}],"type":8,"value":"span"},{"type":0,"value":" with the Rovo browser extension. Scale your org\u2019s AI adoption fast."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.download-extension":[{"type":0,"value":"Install the extension across your company"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.contact-us":[{"type":0,"value":"Contact us"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-aria":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-title":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-aria":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-1":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-2":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.full":[{"type":0,"value":"to opt out of future emails like this"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.short":[{"type":0,"value":"Unsubscribe"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-aria":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-title":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.make-rovo-your-own":[{"type":0,"value":"Make Rovo your own"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.ready-to-roll-out":[{"type":0,"value":"Ready to roll out?"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.rovo-features.description":[{"type":0,"value":"Customize the experience: add your company\u2019s logo, colors, and background to the new tab page. Push your announcements: Company-wide updates and news to every user\u2019s new tab. Users stay in control of their browsing experience by customizing or opting out in their extension settings."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.vitafleet-spotlight.description":[{"type":0,"value":"Rovo extension with company branding and annoucements."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.why-rovo.description":[{"type":0,"value":"Rovo is Atlassian\u2019s AI. It is designed for teamwork, connecting knowledge, people, and action to move work forward. Today Rovo includes Enterprise Search, Chat, Studio, Agents, and Skills and can be connected to 50+ 3rd party tools."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.your-team-will-thank-you":[{"type":0,"value":"Your team will thank you."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Get the Rovo extension ready for your whole team"}],"rovo-extension-install-cta-left-nav.chrome-icon-alt":[{"type":0,"value":"Google Chrome Icon"}],"rovo-extension-install-cta-left-nav.description":[{"type":0,"value":"Rovo Chat knows your context. Available from any tab."}],"rovo-extension-install-cta-left-nav.description.copy-version-b":[{"type":0,"value":"Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab."}],"rovo-extension-install-cta-left-nav.description.copy-version-c":[{"type":0,"value":"30K+ workers use it to chat with AI that understands their company."}],"rovo-extension-install-cta-left-nav.description.copy-version-d":[{"type":0,"value":"Chat with AI that understands your projects and teams. No switching tabs needed."}],"rovo-extension-install-cta-left-nav.dismiss-label":[{"type":0,"value":"Dismiss message"}],"rovo-extension-install-cta-left-nav.heading":[{"type":0,"value":"Get help with what you\'re working on"}],"rovo-extension-install-cta-left-nav.heading.copy-version-b":[{"type":0,"value":"Get answers for work, anywhere"}],"rovo-extension-install-cta-left-nav.heading.copy-version-c":[{"type":0,"value":"Unlock Rovo in every tab"}],"rovo-extension-install-cta-left-nav.heading.copy-version-d":[{"type":0,"value":"Bring Rovo to every tab"}],"rovo-extension-install-cta-left-nav.link":[{"type":0,"value":"Get the browser extension"}],"rovo-extension-install-cta-left-nav.rovo-icon-alt":[{"type":0,"value":"Rovo Icon"}]}');

});

parcelRegister("idRZz", function(module, exports) {

let $d4435296cfb68c94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4435296cfb68c94$var$load("kpSc4").then(()=>parcelRequire('89xPm'));

});

parcelRegister("7d8jN", function(module, exports) {

let $540033236f439308$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $540033236f439308$var$load("i3cfl").then(()=>parcelRequire('8kBPZ'));

});

parcelRegister("eJosu", function(module, exports) {

let $ab983d9efd1861d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab983d9efd1861d3$var$load("jy3XW").then(()=>parcelRequire('79Dsu'));

});

parcelRegister("fSR9p", function(module, exports) {

let $b90520d038b00bcb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b90520d038b00bcb$var$load("cJhLC").then(()=>parcelRequire('4m2RD'));

});

parcelRegister("2aOul", function(module, exports) {

let $1953ade984590544$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1953ade984590544$var$load("k6B8h").then(()=>parcelRequire('CQmJI'));

});

parcelRegister("8KWRB", function(module, exports) {

let $660047b4f0e1301c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $660047b4f0e1301c$var$load("klnez").then(()=>parcelRequire('4es1M'));

});

parcelRegister("aD6lN", function(module, exports) {

let $01ff44040e0ccbd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01ff44040e0ccbd8$var$load("cYDv1").then(()=>parcelRequire('97IsN'));

});

parcelRegister("ht1nW", function(module, exports) {

let $cb76382a9f576507$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb76382a9f576507$var$load("g3r6l").then(()=>parcelRequire('hTfdg'));

});

parcelRegister("6TdpN", function(module, exports) {

let $5042491214156eec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5042491214156eec$var$load("dfrnV").then(()=>parcelRequire('cHyox'));

});

parcelRegister("3dPbj", function(module, exports) {

let $258a498c8b1866aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $258a498c8b1866aa$var$load("jYSNZ").then(()=>parcelRequire('fzVcR'));

});

parcelRegister("bNrrT", function(module, exports) {

let $8969901238b990aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8969901238b990aa$var$load("rzYAC").then(()=>parcelRequire('2zbZb'));

});

parcelRegister("fzWvN", function(module, exports) {

let $b5778323c097400b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5778323c097400b$var$load("b1RNi").then(()=>parcelRequire('g1IzC'));

});

parcelRegister("k9LUw", function(module, exports) {

let $eac9cff7e134e983$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eac9cff7e134e983$var$load("fcU7k").then(()=>parcelRequire('2dQJG'));

});

parcelRegister("7NEGR", function(module, exports) {

let $5adcac43c901bc7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5adcac43c901bc7f$var$load("lYtN4").then(()=>parcelRequire('ek20L'));

});

parcelRegister("fHFaz", function(module, exports) {

let $b6eace8e0f75ab54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6eace8e0f75ab54$var$load("hvz65").then(()=>parcelRequire('4f0Oq'));

});

parcelRegister("lB4Ue", function(module, exports) {

let $fb90dbea861114d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb90dbea861114d2$var$load("6aWEg").then(()=>parcelRequire('bkHdf'));

});

parcelRegister("hcpTt", function(module, exports) {

let $c857a49c0ce50a62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c857a49c0ce50a62$var$load("3AkwZ").then(()=>parcelRequire('aZ2hi'));

});

parcelRegister("lLSQO", function(module, exports) {

let $fd988902d5e753ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd988902d5e753ad$var$load("cbHUA").then(()=>parcelRequire('91Xd7'));

});

parcelRegister("04L3J", function(module, exports) {

let $00e4e0ccb0bc5769$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $00e4e0ccb0bc5769$var$load("5485f").then(()=>parcelRequire('24N9u'));

});

parcelRegister("7Gmd2", function(module, exports) {

let $597daeef7021c298$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $597daeef7021c298$var$load("d4ETO").then(()=>parcelRequire('9Rcfo'));

});

parcelRegister("eCPZn", function(module, exports) {

let $aa5cf1394f619b2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa5cf1394f619b2f$var$load("2sU7M").then(()=>parcelRequire('8kSvx'));

});

parcelRegister("2siS3", function(module, exports) {

let $1c9cd5a4bc1b7808$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c9cd5a4bc1b7808$var$load("zXFQE").then(()=>parcelRequire('7sEYG'));

});

parcelRegister("jYxQj", function(module, exports) {

let $e8addf61dfaa7a86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8addf61dfaa7a86$var$load("8pLiY").then(()=>parcelRequire('bcdVB'));

});

parcelRegister("i2pRS", function(module, exports) {

let $03638e5dda7132b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03638e5dda7132b1$var$load("3J4FI").then(()=>parcelRequire('1nusn'));

});

parcelRegister("6851R", function(module, exports) {

let $4767641929e2988c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4767641929e2988c$var$load("h8FRl").then(()=>parcelRequire('fiOEz'));

});

parcelRegister("79owM", function(module, exports) {

let $534c665f69ebe5d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $534c665f69ebe5d4$var$load("8Ptvx").then(()=>parcelRequire('4bbsk'));

});

parcelRegister("fOIhl", function(module, exports) {

let $b83ddf63e2660e2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b83ddf63e2660e2a$var$load("9NEAK").then(()=>parcelRequire('cXQvP'));

});

parcelRegister("dgcZd", function(module, exports) {

let $9a76d7d0f5070274$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a76d7d0f5070274$var$load("2l1wL").then(()=>parcelRequire('1JovN'));

});

parcelRegister("hR3zt", function(module, exports) {

let $cffa281416d999f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cffa281416d999f7$var$load("d5Ft0").then(()=>parcelRequire('6aOOn'));

});

parcelRegister("kHeB2", function(module, exports) {

let $f113255d2b14abdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f113255d2b14abdc$var$load("1zTvG").then(()=>parcelRequire('g9bZA'));

});

parcelRegister("jX25P", function(module, exports) {

let $e86526a3ec5da4f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e86526a3ec5da4f9$var$load("cxb60").then(()=>parcelRequire('eUtmf'));

});

parcelRegister("inesZ", function(module, exports) {

let $d60598c181cbb709$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d60598c181cbb709$var$load("a3cvU").then(()=>parcelRequire('8XP6i'));

});

parcelRegister("4hAqw", function(module, exports) {

let $31e50188543ae68c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31e50188543ae68c$var$load("2p07R").then(()=>parcelRequire('greUY'));

});

parcelRegister("62O4L", function(module, exports) {

let $4669c6009e0642a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4669c6009e0642a9$var$load("hTwNV").then(()=>parcelRequire('jLR9K'));

});

parcelRegister("kdvUL", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Mosz = parcelRequire("8Mosz");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a5b98d263d96b9ca$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a5b98d263d96b9ca$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5kzWa")));
        case 'da':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("i4vm8")));
        case 'de':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2criv")));
        case 'en-GB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7leZF")));
        case 'en-US':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("lIduW")));
        case 'en-XA':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Ga8j")));
        case 'en-XB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9SvDD")));
        case 'en-ZZ':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ilsDR")));
        case 'en':
            return $a5b98d263d96b9ca$var$importHelper(await Promise.resolve((parcelRequire("8Mosz"))));
        case 'es':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("eA1bq")));
        case 'et':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("20oYo")));
        case 'fi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5uv0c")));
        case 'fr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aT1Cx")));
        case 'hr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("loDZu")));
        case 'hu':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("j3kFT")));
        case 'it':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ks52q")));
        case 'ja':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aTDBw")));
        case 'ko':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bTqNO")));
        case 'nb':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("10NvT")));
        case 'nl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("4Yta3")));
        case 'pl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7T2DO")));
        case 'pt-BR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("86KYZ")));
        case 'ro':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9ZXMc")));
        case 'ru':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bP7Hx")));
        case 'sl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("3iSMg")));
        case 'sr-RS':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("gjRTJ")));
        case 'sr-YR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("dDE21")));
        case 'sr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7Se25")));
        case 'sv':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("giWmH")));
        case 'th':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2rtZr")));
        case 'tr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("az1hp")));
        case 'uk':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hW673")));
        case 'vi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("34J1c")));
        case 'zh-CN':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cMfEi")));
        case 'zh-TW':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("iVQsE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Mosz));
    }
};
module.exports["messagesLoader"] = $a5b98d263d96b9ca$export$720676d8cac8fbb;

});

parcelRegister("8Mosz", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-digest-local-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-local-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-microsoft-teams.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, this is test message from Post Office: \"},{\"type\":1,\"value\":\"text\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-lifecycle-email-recipients.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted test mobile push notification from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.in-app-notification.body\":[{\"type\":1,\"value\":\"body\"}],\"test-messages.in-app-notification.title\":[{\"type\":0,\"value\":\"Test Notification \"},{\"type\":1,\"value\":\"title\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Redacted Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-content-diffing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-content-diffing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-local.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-local.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate\":[{\"type\":0,\"value\":\"Click me!\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-low-priority.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-low-priority.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-low-priority.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-low-priority.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-low-priority.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-low-priority.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-low-priority.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate\":[{\"type\":0,\"value\":\"This is a redacted test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-in-app-notification.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office test-message-in-app-notification \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-lifecycle-email-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-lifecycle-email-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-lifecycle-email-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-lifecycle.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-lifecycle.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-message-failures.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-message-failures.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-no-tracking.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-no-tracking.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate\":[{\"type\":0,\"value\":\"This is a TrackedLink that isn't being tracked!\"}],\"test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate\":[{\"type\":1,\"value\":\"greeting\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("5kzWa", function(module, exports) {

let $3e1ab25bd080ef18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e1ab25bd080ef18$var$load("1jsQH").then(()=>parcelRequire('fa8lP'));

});

parcelRegister("i4vm8", function(module, exports) {

let $d280ec5dc220c64f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d280ec5dc220c64f$var$load("deyvi").then(()=>parcelRequire('e3sAb'));

});

parcelRegister("2criv", function(module, exports) {

let $19a1e074f016a288$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19a1e074f016a288$var$load("6dERU").then(()=>parcelRequire('gch8x'));

});

parcelRegister("7leZF", function(module, exports) {

let $558620019a9af14d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $558620019a9af14d$var$load("kTurq").then(()=>parcelRequire('8ptsW'));

});

parcelRegister("lIduW", function(module, exports) {

let $fce82d783e15c0ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fce82d783e15c0ae$var$load("fbIIm").then(()=>parcelRequire('a6GY6'));

});

parcelRegister("6Ga8j", function(module, exports) {

let $4dce8689974dee0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4dce8689974dee0c$var$load("7l3it").then(()=>parcelRequire('8fxxk'));

});

parcelRegister("9SvDD", function(module, exports) {

let $7311b2ec66131e05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7311b2ec66131e05$var$load("i64HJ").then(()=>parcelRequire('efBlj'));

});

parcelRegister("ilsDR", function(module, exports) {

let $d5b067deab340511$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5b067deab340511$var$load("j0PWv").then(()=>parcelRequire('ks6TI'));

});

parcelRegister("eA1bq", function(module, exports) {

let $a9d558780c2a5d28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9d558780c2a5d28$var$load("dlmud").then(()=>parcelRequire('imT4f'));

});

parcelRegister("20oYo", function(module, exports) {

let $175ef3f7b5281c9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $175ef3f7b5281c9e$var$load("7snhF").then(()=>parcelRequire('cQTYN'));

});

parcelRegister("5uv0c", function(module, exports) {

let $3ff7cd8091ce22a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ff7cd8091ce22a4$var$load("cbkj0").then(()=>parcelRequire('j8AG8'));

});

parcelRegister("aT1Cx", function(module, exports) {

let $7ed04c3d213b805a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ed04c3d213b805a$var$load("17m16").then(()=>parcelRequire('cdNFz'));

});

parcelRegister("loDZu", function(module, exports) {

let $f93adc2ef4ae79f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f93adc2ef4ae79f5$var$load("eQZk8").then(()=>parcelRequire('8akbo'));

});

parcelRegister("j3kFT", function(module, exports) {

let $ddee55b7ab979037$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddee55b7ab979037$var$load("b4NO6").then(()=>parcelRequire('gPFiy'));

});

parcelRegister("ks52q", function(module, exports) {

let $ee3a549cc562cf0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee3a549cc562cf0d$var$load("1K1Fj").then(()=>parcelRequire('dIMMS'));

});

parcelRegister("aTDBw", function(module, exports) {

let $7eedc2fbe15b315c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eedc2fbe15b315c$var$load("38sfA").then(()=>parcelRequire('css4w'));

});

parcelRegister("bTqNO", function(module, exports) {

let $8a899f28c59c2af5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a899f28c59c2af5$var$load("bjmre").then(()=>parcelRequire('9R9u0'));

});

parcelRegister("10NvT", function(module, exports) {

let $0bcc32df5e9c1b1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bcc32df5e9c1b1f$var$load("asvK9").then(()=>parcelRequire('6DTdr'));

});

parcelRegister("4Yta3", function(module, exports) {

let $39f362cd04b24307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $39f362cd04b24307$var$load("7v6wU").then(()=>parcelRequire('ceZMk'));

});

parcelRegister("7T2DO", function(module, exports) {

let $5bdfb7f14449e2c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bdfb7f14449e2c0$var$load("aEpRh").then(()=>parcelRequire('jtjwW'));

});

parcelRegister("86KYZ", function(module, exports) {

let $5e73541143b39bdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e73541143b39bdc$var$load("3fuR9").then(()=>parcelRequire('l8CqS'));

});

parcelRegister("9ZXMc", function(module, exports) {

let $74782de4a4745e6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74782de4a4745e6c$var$load("bSjyK").then(()=>parcelRequire('fFbIU'));

});

parcelRegister("bP7Hx", function(module, exports) {

let $89ba6e7402c93988$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89ba6e7402c93988$var$load("fMrUo").then(()=>parcelRequire('hHfxK'));

});

parcelRegister("3iSMg", function(module, exports) {

let $267d8b2ea98c2197$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $267d8b2ea98c2197$var$load("glLvq").then(()=>parcelRequire('lr9gd'));

});

parcelRegister("gjRTJ", function(module, exports) {

let $be183aac679ffec9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be183aac679ffec9$var$load("fFGjZ").then(()=>parcelRequire('ilsFV'));

});

parcelRegister("dDE21", function(module, exports) {

let $9eddf85990b84494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9eddf85990b84494$var$load("fEAqG").then(()=>parcelRequire('8xJoA'));

});

parcelRegister("7Se25", function(module, exports) {

let $5bb876238d07b83c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bb876238d07b83c$var$load("e9tHh").then(()=>parcelRequire('b1h3K'));

});

parcelRegister("giWmH", function(module, exports) {

let $bdeb99e2433e700b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdeb99e2433e700b$var$load("9eNkX").then(()=>parcelRequire('2OLbL'));

});

parcelRegister("2rtZr", function(module, exports) {

let $1c755dc3df24f4b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c755dc3df24f4b3$var$load("fTPgj").then(()=>parcelRequire('lSTN4'));

});

parcelRegister("az1hp", function(module, exports) {

let $7b0e2a6644cdd48f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b0e2a6644cdd48f$var$load("h0uBE").then(()=>parcelRequire('74ATO'));

});

parcelRegister("hW673", function(module, exports) {

let $d0ec98572b185326$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0ec98572b185326$var$load("lKa7i").then(()=>parcelRequire('3fixv'));

});

parcelRegister("34J1c", function(module, exports) {

let $23d4aa8a0a9f8628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23d4aa8a0a9f8628$var$load("9aufD").then(()=>parcelRequire('kafqC'));

});

parcelRegister("cMfEi", function(module, exports) {

let $94d61b4e9741d415$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94d61b4e9741d415$var$load("gDiIK").then(()=>parcelRequire('19yAM'));

});

parcelRegister("iVQsE", function(module, exports) {

let $dc863e8c0dddf9f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc863e8c0dddf9f8$var$load("j9OUx").then(()=>parcelRequire('jSsWA'));

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("9oJIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kO3gu = parcelRequire("kO3gu");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("6wbAc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $852cc06e57df817b$export$83b038038df2eb9 = (0, $eSUdr.default)`query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id settings{routeOverrideEnabled}}}`;
module.exports["SpaceRestrictionCheckQuery"] = $852cc06e57df817b$export$83b038038df2eb9;

});

parcelRegister("dtDUi", function(module, exports) {

var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("dP3ac", function(module, exports) {

var $hs90m = parcelRequire("hs90m");

const $6bb999f896c7d6ae$var$createPostOfficeGasv3ListenerStore = ()=>{
    const subscribers = new Map();
    const handleEvent = (event)=>{
        subscribers.forEach((callback, matcher)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hs90m)))(event.payload, matcher)) callback();
        });
    };
    const subscribe = (matcher, callback)=>{
        subscribers.set(matcher, callback);
        return ()=>{
            subscribers.delete(matcher);
        };
    };
    return {
        subscribe: subscribe,
        handleEvent: handleEvent
    };
};
const $6bb999f896c7d6ae$export$19b95495a42be187 = $6bb999f896c7d6ae$var$createPostOfficeGasv3ListenerStore();
module.exports["postOfficeGasv3ListenerStore"] = $6bb999f896c7d6ae$export$19b95495a42be187;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("djMdn", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ee867efa4e0f51e3$export$e5c6d63c1f3f867f = (0, $42omo.createContext)({
    usePageRecommendationData: ()=>({
            data: undefined,
            loading: false,
            hoverPageError: undefined,
            recPageError: undefined
        }),
    useInlineReactionsData: (_numberOfReactedUsers, _skip)=>({
            data: {
                authorName: undefined,
                authorAvatar: undefined,
                reactionsCount: undefined,
                reactionsSummary: undefined,
                reactedUsers: undefined,
                userId: undefined,
                activationId: undefined
            },
            loading: false,
            error: undefined
        }),
    getPageDataFromUrl: ()=>({
            contentId: undefined,
            contentType: undefined,
            spaceKey: undefined
        }),
    emojiProvider: undefined
});
module.exports["ConfluenceExperimentsContext"] = $ee867efa4e0f51e3$export$e5c6d63c1f3f867f;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled = false, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7PLO8 = parcelRequire("7PLO8");


var $6mKj3 = parcelRequire("6mKj3");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $87Z8O = parcelRequire("87Z8O");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $dh538.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentPropertyExperimentalMutation: updateContentPropertyExperimentalMutation, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage
        }
    });
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        if ((0, $6mKj3.expValEquals)('migrate_off_experimentalupdatecontentproperty', 'isEnabled', true)) return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
        else return updateContentPropertyExperimentalMutation({
            variables: {
                contentId: contentId,
                propertyKey: propertyKey,
                propertyValue: emojiValue,
                versionNumber: String(newVersionNumber)
            },
            update: (proxy)=>{
                try {
                    const cacheData = proxy.readQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }
                    });
                    if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                        ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                        id: contentId,
                        key: propertyKey,
                        value: emojiValue,
                        version: {
                            number: newVersionNumber,
                            __typename: 'Version'
                        }
                    };
                    proxy.writeQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        },
                        data: data
                    });
                } catch (error) {
                    throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                }
            },
            optimisticResponse: {
                __typename: 'Mutation',
                experimentalUpdateContentProperty: {
                    __typename: 'ExperimentalUpdateContentProperty',
                    success: true,
                    id: contentId,
                    key: propertyKey,
                    value: emojiValue
                }
            }
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentPropertyExperimentalMutation: updateContentPropertyExperimentalMutation, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        if ((0, $6mKj3.expValEquals)('migrate_off_experimentalupdatecontentproperty', 'isEnabled', true)) return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $87Z8O.getEmojiTitleProperty),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
        else return updateContentPropertyExperimentalMutation({
            variables: {
                contentId: contentId,
                propertyKey: propertyKey,
                isDelete: true
            },
            update: (proxy)=>{
                try {
                    const data = proxy.readQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }
                    });
                    data.content.nodes[0][emojiStatusFieldName] = {
                        nodes: [],
                        __typename: 'PaginatedJsonContentPropertyList'
                    };
                    proxy.writeQuery({
                        query: (0, $87Z8O.getEmojiTitleProperty),
                        variables: {
                            contentId: contentId,
                            status: [
                                'current',
                                'draft'
                            ],
                            skipPublishedFragment: true,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        },
                        data: data
                    });
                } catch (error) {
                    throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                }
            },
            optimisticResponse: {
                __typename: 'Mutation',
                experimentalUpdateContentProperty: {
                    __typename: 'ExperimentalUpdateContentProperty',
                    success: true
                }
            }
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("3shHM", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $87Z8O = parcelRequire("87Z8O");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const { data: data } = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $87Z8O.getEmojiTitleProperty),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        }
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: property?.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    const nodes = (data?.content?.nodes?.[0] || data?.singleContent)?.[emojiFieldName]?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["getHasEmojiPublished"] = $61659933fe71a4ee$export$53519180ca077ff2;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    // whiteboards and live pages are always published, so return EMOJI_TITLE_PUBLISHED_FIELD
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $dv2RR = parcelRequire("dv2RR");

var $h5kkk = parcelRequire("h5kkk");

var $7Snli = parcelRequire("7Snli");

var $l71ia = parcelRequire("l71ia");

var $9ekTs = parcelRequire("9ekTs");

var $hLgiF = parcelRequire("hLgiF");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $9ekTs.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $dv2RR.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $hLgiF.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $h5kkk.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $7Snli.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $l71ia.ConfluenceFolderAri).parse(ari).folderId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("dv2RR", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $9d40651b93ec8285$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $9d40651b93ec8285$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("h5kkk", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $c702abc9aa7743aa$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $c702abc9aa7743aa$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c702abc9aa7743aa$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $c702abc9aa7743aa$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c702abc9aa7743aa$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $c702abc9aa7743aa$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c702abc9aa7743aa$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c702abc9aa7743aa$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $c702abc9aa7743aa$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("7Snli", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $5bbfaedf27f3fe31$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $5bbfaedf27f3fe31$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5bbfaedf27f3fe31$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $5bbfaedf27f3fe31$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5bbfaedf27f3fe31$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $5bbfaedf27f3fe31$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $5bbfaedf27f3fe31$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $5bbfaedf27f3fe31$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $5bbfaedf27f3fe31$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("l71ia", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f5eb40fa9685eb58$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f5eb40fa9685eb58$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f5eb40fa9685eb58$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f5eb40fa9685eb58$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f5eb40fa9685eb58$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f5eb40fa9685eb58$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f5eb40fa9685eb58$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f5eb40fa9685eb58$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f5eb40fa9685eb58$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("9ekTs", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $6b85a0e0b8f4dc4d$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $6b85a0e0b8f4dc4d$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("hLgiF", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $cee378513c934e92$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $cee378513c934e92$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("4XcQZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $dcd0924fd6cc7ace$export$d322defea4af96d5 = (0, $eSUdr.default)`query EndOfPageRecommendationQuery($type:String!$id:ID!$exp:String!$key:ID!$keyString:String!){space(key:$keyString){id}getRecommendedPages(entityType:$type entityId:$id experience:$exp){recommendedPages{content{id title type subType creatorId links{webui}history{ownedBy{displayName}}space{id key name}emoji:properties(key:"emoji-title-published"){nodes{id key value}}}strategy}status{userCanToggle isEnabled}}getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled defaultBehavior}}`;
module.exports["EndOfPageRecommendationQuery"] = $dcd0924fd6cc7ace$export$d322defea4af96d5;

});

parcelRegister("3V1KT", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $eSUdr.default)`query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id contentReactionsSummary{reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
const $bb6fcff23ee99252$export$d86780bd83b9ba91 = (0, $eSUdr.default)`query ConfluenceReactionsContentQuery($cloudId:ID!$contentId:ID!$contentType:GraphQLReactionContentType!){confluence_contentReactionsSummary(cloudId:$cloudId contentType:$contentType contentId:$contentId){contentReactionsSummary:reactionsSummary{reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}`;
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("2OQgp", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b = (0, $eSUdr.default)`query ReactedUsersQuery($contentId:String!$containerId:String!$containerType:ContainerType!$contentType:GraphQLReactionContentType!$emojiId:String!){reactedUsers(contentId:$contentId containerId:$containerId containerType:$containerType contentType:$contentType emojiId:$emojiId){count emojiId reacted confluencePerson{accountId displayName profilePicture{path}}}}`;
const $b0d4ef9b24ddbdc3$export$7c88675012b9ae8f = (0, $eSUdr.default)`query ConfluenceReactedUsersQuery($cloudId:ID!$contentId:String!$containerId:String!$containerType:ContainerType!$contentType:GraphQLReactionContentType!$emojiId:String!){confluence_reactedUsers(cloudId:$cloudId input:{contentId:$contentId containerId:$containerId containerType:$containerType contentType:$contentType emojiId:$emojiId}){count emojiId reacted confluencePerson{accountId displayName profilePicture{path}}}}`;
module.exports["ReactedUsersQuery"] = $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("49sr4", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("ctMWd")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("82BVR")).Targets);

var $ctMWd = parcelRequire("ctMWd");


var $82BVR = parcelRequire("82BVR");


});

parcelRegister("ctMWd", function(module, exports) {
class $0081b4f618dff6fe$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $0081b4f618dff6fe$export$a5e53d1dcbd6eb61;

});

parcelRegister("82BVR", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $49d7ae8ec7eae7d8$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $49d7ae8ec7eae7d8$export$59a8eb9cff113544;

});

parcelRegister("bdD2n", function(module, exports) {

let $82af309fb306d661$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $82af309fb306d661$var$load("bS0aO"),
    $82af309fb306d661$var$load("1or3R")
]).then(()=>parcelRequire('3Subp'));

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cryCi = parcelRequire("cryCi");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("bEsuL", function(module, exports) {

let $87b988b6361c5c64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $87b988b6361c5c64$var$load("9XYQ9"),
    $87b988b6361c5c64$var$load("a0ogJ"),
    $87b988b6361c5c64$var$load("6wr18"),
    $87b988b6361c5c64$var$load("aL59j"),
    $87b988b6361c5c64$var$load("j4ThT"),
    $87b988b6361c5c64$var$load("5uN9h"),
    $87b988b6361c5c64$var$load("8JZKd"),
    $87b988b6361c5c64$var$load("1d7Ag"),
    $87b988b6361c5c64$var$load("1TOYq"),
    $87b988b6361c5c64$var$load("7Q5vz"),
    $87b988b6361c5c64$var$load("ffEVr"),
    $87b988b6361c5c64$var$load("7zPi7")
]).then(()=>parcelRequire('MVtCj'));

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        const navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $T1bCI.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $8rneB = parcelRequire("8rneB");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $T1bCI.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("brNvA", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $42omo.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $42omo.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $42omo.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $42omo.useState)(null);
    const providerValue = (0, $42omo.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("fN9wG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $iXCQx = parcelRequire("iXCQx");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $17wUi = parcelRequire("17wUi");


var $csz5R = parcelRequire("csz5R");


var $elPdM = parcelRequire("elPdM");

const $bd929afc952baa40$var$INVITE_CAPABILITIES_URL = '/gateway/api/v3/invitations/capabilities';
const $bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY = 'confluence_invite_capabilities_direct_invite_mode';
const $bd929afc952baa40$var$i18n = (0, $cgtv4.defineMessages)({
    inviteSuccessTitle: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.title",
        defaultMessage: "Successfully added"
    },
    inviteSuccessDescription: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.description",
        defaultMessage: "We sent an email to <b>{name}</b> confirming you added them to Confluence."
    }
});
const $bd929afc952baa40$export$3bdfaf8c811be72d = /*#__PURE__*/ (0, $42omo.createContext)({});
const $bd929afc952baa40$var$hasDirectInviteCapabilities = async (cloudId, createAnalyticsEvent)=>{
    try {
        const canUserAccessJira = await $bd929afc952baa40$var$hasJiraSoftwareAccess(cloudId);
        let directInviteMode;
        let invitePendingApprovalMode;
        if (canUserAccessJira) {
            //Call invite capabilities endpoint only if directInviteMode value is not available from local storage
            directInviteMode = (0, $17wUi.confluenceLocalStorageInstance).getItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY);
            if (!directInviteMode) {
                const response = await (0, $f7B1p.cfetch)(`${$bd929afc952baa40$var$INVITE_CAPABILITIES_URL}?resource=ari:cloud:platform::site/${cloudId}`, {
                    method: 'GET',
                    headers: {
                        ACCEPT: 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
                const data = await response.json();
                for (const item of data)if (item?.resourceARI?.includes('confluence')) {
                    directInviteMode = item?.directInvite?.mode;
                    invitePendingApprovalMode = item?.invitePendingApproval?.mode;
                    break;
                }
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'editor',
                        action: 'fetched',
                        actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                        attributes: {
                            directInviteMode: directInviteMode,
                            invitePendingApprovalMode: invitePendingApprovalMode
                        }
                    }
                }).fire();
                if (!!directInviteMode) (0, $17wUi.confluenceLocalStorageInstance).setItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY, directInviteMode, 86400);
            }
        }
        return directInviteMode === 'ANYONE';
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        createAnalyticsEvent && createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'editor',
                action: 'errored',
                actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                attributes: {
                    errorMessage: errorMessage
                }
            }
        }).fire();
        return false;
    }
};
const $bd929afc952baa40$var$hasJiraSoftwareAccess = async (cloudId)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $csz5R.GetUserAccessQuery),
        variables: {
            resourceId: `ari:cloud:jira::site/${cloudId}`,
            permissionId: 'write'
        }
    }).then(({ data: data })=>{
        const hasJira = data?.confluence_tenantContext?.licensedProducts.some((product)=>product?.productKey?.toLowerCase().includes('jira-software') && product?.licenseStatus === (0, $elPdM.LicenseStatus).ACTIVE);
        return !!hasJira && data?.permitted;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return false;
    });
};
const $bd929afc952baa40$export$266d732058715003 = ({ children: children, flags: flags })=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const promiseRef = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleXProductUserInvite = (0, $42omo.useCallback)(()=>{
        //check the eligibility criteria only once per SPA
        if (promiseRef.current) return promiseRef.current;
        promiseRef.current = (async ()=>{
            try {
                if (!(0, $9wGTI.fg)('cc_virality_x_product_user_invite_kill_switch') || !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS)) return false;
                return await $bd929afc952baa40$var$hasDirectInviteCapabilities(cloudId, createAnalyticsEvent);
            } catch (e) {
                return false;
            }
        })();
        return promiseRef.current;
    }, [
        accessStatus,
        cloudId,
        createAnalyticsEvent
    ]);
    const showSuccessFlag = (0, $42omo.useCallback)((name, isSuccess)=>{
        if (isSuccess) flags.showFlag({
            id: `x-product-user-invite-success`,
            title: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessTitle),
            description: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessDescription, {
                name: name,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        weight: "bold"
                    }, chunks)
            }),
            type: 'success-circle'
        });
    }, [
        flags,
        formatMessage
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            isEligibleXProductUserInvite: isEligibleXProductUserInvite,
            onXProductUserInviteClick: (name, isSuccess)=>{
                showSuccessFlag(name, isSuccess);
            }
        }), [
        isEligibleXProductUserInvite,
        showSuccessFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd929afc952baa40$export$3bdfaf8c811be72d.Provider, {
        value: value
    }, children);
};
const $bd929afc952baa40$export$363c701b8b10381c = (0, $7aRa9.withFlags)($bd929afc952baa40$export$266d732058715003);
module.exports["XProductUserInviteContext"] = $bd929afc952baa40$export$3bdfaf8c811be72d;
module.exports["XProductUserInviteProvider"] = $bd929afc952baa40$export$363c701b8b10381c;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("csz5R", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $212cbe357c6b81cb$export$c97e544e33b94e50 = (0, $eSUdr.default)`query GetUserAccessQuery($resourceId:String!$permissionId:String!){confluence_tenantContext{licensedProducts{licenseStatus productKey}}permitted(resourceId:$resourceId permissionId:$permissionId)}`;
module.exports["GetUserAccessQuery"] = $212cbe357c6b81cb$export$c97e544e33b94e50;

});

parcelRegister("elPdM", function(module, exports) {
/**
 * @generated SignedSource<<a9e9815167cf406f3c6ef437385f5336>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $ad8e722f7df5268a$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $ad8e722f7df5268a$export$902181cb056f3d0b;

});

parcelRegister("kCeSx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f022e5db44f52121$export$2e2bcd8739ae039);

var $kFqI2 = parcelRequire("kFqI2");


var $64Cib = parcelRequire("64Cib");


var $eYRlV = parcelRequire("eYRlV");


var $iyEDi = parcelRequire("iyEDi");


var $eYNcX = parcelRequire("eYNcX");


var $g4VeD = parcelRequire("g4VeD");

const $f022e5db44f52121$var$selectContentsFromIds = (0, $eYRlV.createContentsFromIdsSelector)();
const $f022e5db44f52121$export$c31df4bd766f9c35 = (state)=>{
    let spaceKey;
    let contentId;
    let contentType;
    let createpageProps = {};
    // CreatePage passes draftId as contentId. Use it instead of the one coming from
    if (state.editor.get('draftId') && state.editor.get('statusCode') === (0, $eYNcX.OK)) {
        contentId = state.editor.get('draftId');
        const createdPage = state.editor.get('result');
        let ancestors;
        let parentPage;
        if (typeof createdPage?.get === 'function') {
            contentType = createdPage.get('type', null);
            ancestors = createdPage.get('ancestors', []);
            parentPage = ancestors.last();
        } else {
            contentType = createdPage.type;
            ancestors = createdPage.ancestors || [];
            parentPage = ancestors[ancestors.length - 1];
        }
        createpageProps = {
            parentPageId: `${// So the page can either be a plain object or a record depending on timing...
            // TODO: Get rid of all the redux here.
            parentPage ? typeof parentPage.get === 'function' ? parentPage.get('id') : parentPage.id : 0}`,
            // cast to string
            pageVersion: 0 // enforce version 0, otherwise saving will fail with 409 Conflict
        };
    }
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    const location = (0, $iyEDi.getLocation)(state);
    if (!spaceKey) spaceKey = routeParams.spaceKey;
    if (!contentId) // on old viewPage we need `contentId` for request permissions component
    // we can get it as `pageId` from location query;
    contentId = routeParams.contentId || (location.query || {}).pageId;
    if (!contentId && spaceKey) // Fallback to space homepage if no content id found
    contentId = `${state.entities.getIn([
        'spaces',
        spaceKey,
        'homepageId'
    ])}`; // string
    const currentPage = state.entities.getIn([
        'contents',
        `${contentId}`
    ]);
    if (contentId && currentPage) contentType = currentPage.type;
    const editorForCommentsIsEnabled = state.views.viewPage.editor.contentId;
    if (editorForCommentsIsEnabled) contentType = 'comment';
    if ([
        'CREATE_TEMPLATE_SPACE',
        'EDIT_TEMPLATE_SPACE',
        'EDIT_TEMPLATE',
        'CREATE_TEMPLATE'
    ].includes(location.routeName)) contentType = 'template';
    let viewpageProps = {};
    const currentPageVersion = state.entities.getIn([
        'versions',
        `${contentId}`
    ], {});
    if (currentPage) {
        const parentPage = currentPage.ancestors && currentPage.ancestors.size ? $f022e5db44f52121$var$selectContentsFromIds((0, $64Cib.fromJS)([
            currentPage.ancestors.last()
        ]), state).first() : null;
        viewpageProps = {
            pageTitle: currentPage.title,
            pageVersion: currentPageVersion.number,
            parentPageTitle: parentPage ? parentPage.title : '',
            parentPageId: parentPage ? parentPage.id : '0',
            canRemovePage: currentPage.currentUserPermissions && currentPage.currentUserPermissions.includes('delete')
        };
    }
    const experimentProps = {
        experimentFeatures: state.views.dashboard.get('experimentFeatures')
    };
    // TODO: there is no simple way to select the parent yet so this code will be commented out till we solve it
    // matches /spaces/{spaceKey}/pages or /spaces/{spaceKey}/pages/ only
    //const isPageTree = /\/spaces\/([~0-9A-z]*)\/pages(\/)?$/.test(location.pathname);
    //const contextualMenuOpenForPageId = state.views.spaceHome.pageTreeContextualMenu;
    //
    //if (isPageTree && !!contextualMenuOpenForPageId) {
    //    const selectedPage = state.entities.getIn(['contents', contextualMenuOpenForPageId]);
    //    if (selectedPage) {
    //        const parentPage = selectedPage.ancestors.size ? selectContentsFromIds(fromJS([selectedPage.ancestors.last()]), state).first() : null;
    //        viewpageProps = {
    //            contentId: selectedPage.id,
    //            pageTitle: selectedPage.title,
    //            parentPageTitle: parentPage ? parentPage.title : null,
    //            parentPageId: parentPage ? parentPage.id : '0',
    //            canRemovePage: selectedPage.currentUserPermissions.includes('delete')
    //        };
    //    }
    //}
    return {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        spaceName: state.entities.getIn([
            'spaces',
            spaceKey,
            'name'
        ]),
        spaceType: state.entities.getIn([
            'spaces',
            spaceKey,
            'type'
        ]),
        ...viewpageProps,
        ...createpageProps,
        ...experimentProps
    };
};
var $f022e5db44f52121$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($f022e5db44f52121$export$c31df4bd766f9c35)((0, $g4VeD.default));

});

parcelRegister("eYRlV", function(module, exports) {

var $b4Wym = parcelRequire("b4Wym");


var $64Cib = parcelRequire("64Cib");


var $ePeSL = parcelRequire("ePeSL");

const $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES = {
    'meeting-notes': true,
    decisions: true,
    'kb-how-to-article': true,
    'file-list': true,
    retrospective: true,
    requirements: true,
    'shared-links': true,
    'kb-troubleshooting-article': true,
    'task-report': true,
    jirareport: true
};
function $ae800dfdeadf4eac$var$isEmpty(data) {
    if (!data) return true;
    return !$ae800dfdeadf4eac$var$size(data);
}
function $ae800dfdeadf4eac$var$size(data) {
    if (!data) return 0;
    return data.hasOwnProperty('size') ? data.size : data.length;
}
const $ae800dfdeadf4eac$export$1ada442d7b78f25 = (0, $ePeSL.default)((item)=>item, (item, users)=>users, // 'containers' may be a space or a content, right now it's only ever content on file records
(item, users, containers)=>containers, (item, users, containers, versions)=>versions, (item, users, containers, versions)=>{
    let version = versions.get(`${item.version}`);
    if (version) version = version.set('by', users.get(version.by));
    const container = item.container ? containers.get(`${item.container}`) : null;
    let result = item.set('createdBy', users.get(item.createdBy)).set('version', version);
    if (item.contributors) result = result.set('contributors', item.contributors.map((accountId)=>users.get(accountId)));
    if (item.viewers) result = result.set('viewers', item.viewers.map((accountId)=>users.get(accountId)));
    if (container) {
        result = result.set('container', container);
        const containerVersion = container.get('version');
        if (containerVersion) result = result.setIn([
            'container',
            'version'
        ], versions.get(`${containerVersion}`));
    }
    return result;
});
const $ae800dfdeadf4eac$export$5c63e7dafa621e16 = (contentId, state)=>{
    const entities = state.entities;
    const content = entities.get('contents').get(`${contentId}`);
    if (content && (content.createdBy || content.version)) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, entities.get('users'), entities.get('contents'), entities.get('versions'));
    return content;
};
const $ae800dfdeadf4eac$export$fe6dd8e2950283cb = (state, contentId, permissionType)=>{
    const content = state.entities.getIn([
        'contents',
        contentId
    ]);
    return content.currentUserPermissions.contains(permissionType);
};
const $ae800dfdeadf4eac$export$84b461ed686ebfb9 = (state, contentId)=>$ae800dfdeadf4eac$export$fe6dd8e2950283cb(state, contentId, 'update');
const $ae800dfdeadf4eac$var$buildContentCreatedBy = (0, $ePeSL.default)((item)=>item, (item, users)=>users, (item, users)=>item.set('createdBy', users.get(item.createdBy)));
const $ae800dfdeadf4eac$export$5c767ea021dac201 = ()=>(0, $b4Wym.createSelector)((ids)=>ids, (ids, state, contents)=>contents || state.entities.get('contents'), (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('versions'), (ids, state)=>state.entities.get('users'), // 'containers' may be a space or a content, right now it's only ever content on file records
    (ids, contents, containers, versions, users)=>{
        if (!ids) return null;
        if (typeof ids === 'number' || typeof ids === 'string') ids = (0, $64Cib.List)([
            `${ids}`
        ]);
        if (ids.length && !(0, $64Cib.List).isList(ids)) ids = (0, $64Cib.List)(ids);
        if (!ids.size) return (0, $64Cib.List)([]);
        ids = ids.filter((id)=>!!contents.get(`${id}`));
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content.createdBy || content.version) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, users, containers, versions);
            return content;
        });
    });
const $ae800dfdeadf4eac$export$7203590478a6c254 = ()=>(0, $b4Wym.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, contents)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $64Cib.List)([]);
        return ids.map((id)=>contents.get(`${id}`));
    });
const $ae800dfdeadf4eac$export$167cb14480de4389 = ()=>(0, $b4Wym.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('users'), (ids, contents, users)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $64Cib.List)([]);
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content && content.createdBy) return $ae800dfdeadf4eac$var$buildContentCreatedBy(content, users);
            return content;
        });
    });
const $ae800dfdeadf4eac$var$getContent = (contentId, state)=>state.entities.getIn([
        'contents',
        contentId
    ]);
const $ae800dfdeadf4eac$var$getLabels = (contentId, state)=>state.entities.get('labels');
const $ae800dfdeadf4eac$export$e23bbeb6c3d185f2 = (0, $b4Wym.createSelector)($ae800dfdeadf4eac$var$getContent, $ae800dfdeadf4eac$var$getLabels, (content, labels)=>{
    if (!content || !labels) return '';
    const contentLabels = content.get('labels');
    if (!contentLabels || contentLabels.size === 0) return '';
    const contentBlueprintId = contentLabels.find((labelId)=>{
        const labelData = labels.get(labelId);
        return !labelData ? false : $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES[labelData.get('name')];
    });
    return contentBlueprintId ? labels.get(contentBlueprintId).get('name') : '';
});
module.exports["buildContentItem"] = $ae800dfdeadf4eac$export$5c63e7dafa621e16;
module.exports["createContentsFromIdsSelector"] = $ae800dfdeadf4eac$export$5c767ea021dac201;

});

parcelRegister("ePeSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $acb15f65db8e2947$export$2e2bcd8739ae039);

var $b4Wym = parcelRequire("b4Wym");

/**
 * WeakMapMemoizer allows memoisation of lists
 */ class $acb15f65db8e2947$var$WeakMapMemoizer {
    memoize(...weakArgs) {
        return this._memoizeImpl(this.map, weakArgs, 0);
    }
    _memoizeImpl(map, args, i) {
        let value = map.get(args[i]);
        if (i === args.length - 1) {
            if (!value) {
                value = this.func(...args);
                map.set(args[i], value);
            }
            return value;
        }
        if (!value) {
            value = new WeakMap();
            map.set(args[i], value);
        }
        return this._memoizeImpl(value, args, i + 1);
    }
    constructor(func){
        this.map = new WeakMap();
        this.func = func;
    }
}
var /**
 * createSelectorCreator - drop in replacement for reselect.createSelector
 * which offers better performance when dealing with lists that should
 * be recreated very often
 */ $acb15f65db8e2947$export$2e2bcd8739ae039 = (0, $b4Wym.createSelectorCreator)((func)=>{
    const memoizer = new $acb15f65db8e2947$var$WeakMapMemoizer(func);
    return memoizer.memoize.bind(memoizer);
});

});

parcelRegister("g4VeD", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $6g1oe = parcelRequire("6g1oe");


var $cSdzn = parcelRequire("cSdzn");

class $bb496ac4c35df382$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    componentDidMount() {
        this._setLegacyProps(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this._setLegacyProps(nextProps);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.props, nextProps);
    }
    componentWillUnmount() {
        this._setAJSValues({});
        this._cancelWaitForGlobalInProgress();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this._waitForGlobalInProgress = null;
        this._setLegacyProps = (props)=>{
            this._cancelWaitForGlobalInProgress();
            this._waitForGlobalInProgress = (0, $cSdzn.default)({
                listener: 'LegacyBridge.js',
                globalProperty: 'AJS.params'
            }, ()=>this._setAJSValues(props));
        };
        this._cancelWaitForGlobalInProgress = ()=>{
            if (this._waitForGlobalInProgress) // This prevents waitForGlobal to updates this component in random order in case of multiple calls.
            this._waitForGlobalInProgress.cancel();
        };
        this._setAJSValues = (props)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS || !(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.params) return;
            const { spaceKey: spaceKey, spaceName: spaceName, spaceType: spaceType, contentId: contentId, contentType: contentType, pageTitle: pageTitle, pageVersion: pageVersion, parentPageId: parentPageId, parentPageTitle: parentPageTitle, canRemovePage: canRemovePage, experimentFeatures: experimentFeatures } = props;
            const createPage = pageVersion === 0;
            const pageId = createPage ? '0' : contentId;
            // page/content info
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.params.pageId = pageId;
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.params.spaceKey = spaceKey;
            const metaParams = {
                // page/content info
                'content-id': contentId,
                'content-type': contentType,
                'page-id': pageId,
                'page-title': pageTitle,
                'page-version': pageVersion,
                'parent-page-id': parentPageId,
                'parent-page-title': parentPageTitle,
                'latest-page-id': contentId,
                'can-remove-page': canRemovePage,
                'new-page': createPage,
                // space info
                'space-key': spaceKey,
                'space-name': spaceName,
                'space-type': spaceType,
                // experiments
                'experiment-features': experimentFeatures
            };
            // Do not set if legacy bridge in next has already handled
            // See: next/packages/view-page/src/LegacyBridgeNext.js
            if ((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.Meta && !(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.Meta.get('has-next-legacy-bridge')) Object.keys(metaParams).forEach((key)=>{
                // standalone mode doesn't have AJS
                (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.Meta.set(key, metaParams[key]);
            });
        };
    }
}
$bb496ac4c35df382$export$2e2bcd8739ae039.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    pageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    pageVersion: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    parentPageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    parentPageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    canRemovePage: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    experimentFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["default"] = $bb496ac4c35df382$export$2e2bcd8739ae039;

});

parcelRegister("cSdzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f50dcfd27e28ce$export$2e2bcd8739ae039);
function $95f50dcfd27e28ce$var$isDefined(path) {
    const pathParts = path.split('.');
    let obj = window[pathParts.shift()];
    while(typeof obj !== 'undefined' && pathParts.length)obj = obj[pathParts.shift()];
    return obj;
}
const $95f50dcfd27e28ce$var$lines = {};
function $95f50dcfd27e28ce$var$logOnce(message) {}
function $95f50dcfd27e28ce$export$d2adf65b87e47523() {
    for(const key in $95f50dcfd27e28ce$var$lines)delete $95f50dcfd27e28ce$var$lines[key];
}
function $95f50dcfd27e28ce$export$2e2bcd8739ae039({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
        $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $95f50dcfd27e28ce$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
            $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
    return {
        cancel () {
            if (waitForGlobalInterval) clearInterval(waitForGlobalInterval);
        }
    };
}

});

parcelRegister("2cEww", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b04916d9a8148b2$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $5b04916d9a8148b2$export$2e2bcd8739ae039({ dataKey: dataKey, value: value }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    (0, $42omo.useMemo)(()=>{
        if (!interactionContext) return;
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, $4u5NT.addCohortingCustomData)(currentInteractionId, dataKey, value);
    }, [
        dataKey,
        value,
        interactionContext
    ]);
    return null;
}
function $5b04916d9a8148b2$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $feexy.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $4u5NT.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $5b04916d9a8148b2$export$f9c6890b323d326b;

});

parcelRegister("aXWtB", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};

const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>(await (parcelRequire("lAgSM"))).ConfluenceConversationAssistant,
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("lAgSM", function(module, exports) {

let $fb6a0e461758da1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fb6a0e461758da1c$var$load("fTFcV"),
    $fb6a0e461758da1c$var$load("a0ybh"),
    $fb6a0e461758da1c$var$load("aoJPa")
]).then(()=>parcelRequire('kaQDe'));

});

parcelRegister("gLUd5", function(module, exports) {
$parcel$export(module.exports, "exitBranchFn", () => (parcelRequire("5Z4kM")).exitBranchFn);
$parcel$export(module.exports, "isBranchDeployFn", () => (parcelRequire("5Z4kM")).isBranchDeployFn);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $5Z4kM = parcelRequire("5Z4kM");


//Plain div to display while chunk loads, avoids help menu resizing after loading
// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
const $9708b4b4a3dbcb64$var$loadingDiv = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            width: '100%',
            height: 29
        }
    });

const $9708b4b4a3dbcb64$export$d6072dc961e0177e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xx4Me",
    name: "ExitBranchDeploy",
    loader: async ()=>(await (parcelRequire("kXolj"))).ExitBranchDeploy,
    loading: $9708b4b4a3dbcb64$var$loadingDiv
});

const $9708b4b4a3dbcb64$export$b39479f42d974760 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RVoYJ",
    name: "FeedbackCollectorButton",
    loader: async ()=>(await (parcelRequire("l2X2Y"))).FeedbackCollectorButton,
    loading: $9708b4b4a3dbcb64$var$loadingDiv
});

});

parcelRegister("kXolj", function(module, exports) {

let $f41c334f363cc916$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f41c334f363cc916$var$load("jZwEH").then(()=>parcelRequire('cxEGh'));

});

parcelRegister("l2X2Y", function(module, exports) {

let $f5279659d1479060$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5279659d1479060$var$load("6wr18"),
    $f5279659d1479060$var$load("ffEVr"),
    $f5279659d1479060$var$load("dUr0C")
]).then(()=>parcelRequire('3ZEEP'));

});

parcelRegister("5Z4kM", function(module, exports) {
/* eslint no-restricted-syntax: 0 */ 
var $jiJCD = parcelRequire("jiJCD");


var $68uaC = parcelRequire("68uaC");

const $45b602e848c81a5d$export$28445d8a8237c240 = 'useFrontendBranch';
const $45b602e848c81a5d$export$2db401a6b81eceee = 'useFrontendBuildVersion';
const $45b602e848c81a5d$export$399982ccb22744fa = ()=>{
    const urlComponents = (0, $jiJCD.parse)(window.location.href, true);
    window.location.assign((0, $jiJCD.format)({
        path: urlComponents.path,
        query: {
            ...urlComponents.query,
            [$45b602e848c81a5d$export$28445d8a8237c240]: 'off',
            [$45b602e848c81a5d$export$2db401a6b81eceee]: 'off'
        },
        hash: urlComponents.hash
    }));
};
const $45b602e848c81a5d$export$6b1dc8f4a2350eb5 = ()=>{
    let cookieBasedBranchVersion;
    const isBifrost = window.__IS_BIFROST__;
    let bifrostOverrideVersion;
    try {
        cookieBasedBranchVersion = (0, $68uaC.Cookies).get($45b602e848c81a5d$export$28445d8a8237c240);
        if (isBifrost) bifrostOverrideVersion = (0, $68uaC.Cookies).get('bifrost-override');
    } catch (err) {
        // Likely a firefox edge-case: "Error: can't access dead object"
        // Occasionally, document.cookie is cleaned up despite living
        // references -- including js-cookie's
        cookieBasedBranchVersion = 'off';
        if (isBifrost) bifrostOverrideVersion = 'off';
    }
    if (isBifrost) return !!(bifrostOverrideVersion && !bifrostOverrideVersion.includes('CLASSIC-off-off'));
    return !!(cookieBasedBranchVersion && cookieBasedBranchVersion !== 'off');
};
module.exports["exitBranchFn"] = $45b602e848c81a5d$export$399982ccb22744fa;
module.exports["isBranchDeployFn"] = $45b602e848c81a5d$export$6b1dc8f4a2350eb5;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = ()=>Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3a15fff847513284 = ()=>Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("4o1RV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    return (0, $42omo.useMemo)(()=>({
            routePolicy: routePolicy,
            ...shimUrl
        }), [
        routePolicy,
        shimUrl
    ]);
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
				 * Transition within the same window if the target route is navigating to the same content
				 * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
				 **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                        open(url, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url, forceReload);
                    else open(url, target);
                };
                /**
				 * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
				 * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
				 * tab, EP should not shim (rebase) it since the embedding product has already had a chance
				 * and they chose not to. On the other hand, if the embedding product does not tell EP to
				 * nagivate, EP can shim the url only when opening a new tab (some links might not have been
				 * shimmed, need to shim all links supposed to be shimmed as the last defense).
				 **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    const shimUrl = (0, $42omo.useCallback)((urlToShim)=>{
        return $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimAdfUrls = (0, $42omo.useCallback)((adf)=>{
        if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
        const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
        $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        return adfClone;
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimHtmlUrls = (0, $42omo.useCallback)((html)=>{
        if (!shimTemplate || !html) return html;
        // shimHtmlUrls is used on legacy macros, but some legacy macros return stringified ADFEntity
        // Check if the input is a JSON-stringified ADFEntity
        try {
            const parsedContent = JSON.parse(html);
            if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                // It's a valid ADF document - check if it needs nested table transformation
                if (html.includes('"extensionKey":"nested-table"')) {
                    const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                    return JSON.stringify(processedAdf);
                } else {
                    // ADF without nested tables - just delegate to shimAdfUrls and stringify the result
                    const shimmedAdf = shimAdfUrls(parsedContent);
                    return JSON.stringify(shimmedAdf);
                }
            }
        } catch  {
        // Not valid JSON, fall through to HTML processing
        }
        // Process as HTML string (for non-ADF content)
        try {
            return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, 'text/html'), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
        } catch  {
            return html;
        }
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter,
        shimAdfUrls
    ]);
    return (0, $42omo.useMemo)(()=>({
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        }), [
        shimUrl,
        shimAdfUrls,
        shimHtmlUrls
    ]);
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("aFbGo", function(module, exports) {
const $3fe527a88453b695$export$5dd7a635c52544a = ()=>window?.location?.search?.indexOf('lite=1') >= 0;
module.exports["isViewPageLite"] = $3fe527a88453b695$export$5dd7a635c52544a;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["isBMPageLoad"] = $2a47a9fc48674e91$export$9dede01b6f349441;
module.exports["hasBMPageLoadStarted"] = $2a47a9fc48674e91$export$cb339d0cd5cc821c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("4MlWS", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $5e721815b49d014a$export$491825b5144ba722 = /*#__PURE__*/ function(ClientNetworkStatus) {
    ClientNetworkStatus["IP_BLOCKED"] = "IP_BLOCKED";
    ClientNetworkStatus["OFFLINE"] = "OFFLINE";
    ClientNetworkStatus["ONLINE"] = "ONLINE";
    ClientNetworkStatus["RATE_LIMITED"] = "RATE_LIMITED";
    ClientNetworkStatus["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    return ClientNetworkStatus;
}({});
module.exports["ClientNetworkStatus"] = $5e721815b49d014a$export$491825b5144ba722;

});

parcelRegister("aYxMO", function(module, exports) {

let $7fd9b73c6522cc05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7fd9b73c6522cc05$var$load("aWPe2").then(()=>parcelRequire('bDxwy'));

});

parcelRegister("bEdUx", function(module, exports) {
/* HighlightActionsProvider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4JDbp = parcelRequire("4JDbp");


var $1dnxO = parcelRequire("1dnxO");


var $e4o8D = parcelRequire("e4o8D");

const $cef29f59925fac19$var$styles = null;
const $cef29f59925fac19$export$873f34bfb1875202 = 'highlight-actions-portal-container';
let $cef29f59925fac19$var$popupPortalContainerWidth;
function $cef29f59925fac19$var$onResize(width) {
    // Hide popup when the container is resized.
    if (width !== $cef29f59925fac19$var$popupPortalContainerWidth) {
        $cef29f59925fac19$var$popupPortalContainerWidth = width;
        window.dispatchEvent(new CustomEvent('highlight-actions.container.resized'));
    }
}
const $cef29f59925fac19$export$8b383aca014c1850 = ()=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: $cef29f59925fac19$export$873f34bfb1875202,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pbyilow"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $4JDbp.WidthObserver), {
        setWidth: $cef29f59925fac19$var$onResize
    }));
}; /**
    *  In Nav4, we need to render the HighlightActionsProvider inside the #AkMainContent container instead of at the top of
    *  our app in <App />. This is because Nav4 uses a grid. So in Nav4 the window itself no longer scrolls; the #AkMainContent
    *  element does.
    *
    *  These HighlightActionsProviderForNav3 and HighlightActionsProviderForNav4 components allow us to render
    *  HighlightActions in different places depending on which nav is enabled.
    */ 
const $cef29f59925fac19$export$84dec73d5759755c = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return (0, $1dnxO.getIsNav4Enabled)() ? null : /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
}; // Only renders the Highlight Actions Provider if we're using Nav4
const $cef29f59925fac19$export$68a992a5cacaa78b = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return (0, $1dnxO.getIsNav4Enabled)() ? /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null) : null;
};
module.exports["popupPortalContainerId"] = $cef29f59925fac19$export$873f34bfb1875202;
module.exports["HighlightActionsProviderForNav3"] = $cef29f59925fac19$export$84dec73d5759755c;
module.exports["HighlightActionsProviderForNav4"] = $cef29f59925fac19$export$68a992a5cacaa78b;

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("dTt0t", function(module, exports) {

let $a1d6e98377bd5bbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a1d6e98377bd5bbe$var$load("8k5W1").then(()=>parcelRequire('42H7Z'));

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const twentyFourHoursAgoInSecondsFallbackReplayCap = Math.floor((Date.now() - 86400000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < twentyFourHoursAgoInSecondsFallbackReplayCap) sequenceNumber = twentyFourHoursAgoInSecondsFallbackReplayCap;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");

const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $42omo.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch (e) {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("3JgB7", function(module, exports) {

let $2b7273002326465f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b7273002326465f$var$load("5zLU3").then(()=>parcelRequire('6nGVD'));

});

parcelRegister("9RxHT", function(module, exports) {

let $72e335c8ec12e3d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72e335c8ec12e3d2$var$load("9dZCH").then(()=>parcelRequire('ghOyy'));

});

parcelRegister("5gmpn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6b55c9cc88888b7$export$93af822566053b3e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GCw5R",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'MainLayout',
    loader: async ()=>(await (parcelRequire("1E185"))).MainLayout
});
module.exports["MainLayout"] = $f6b55c9cc88888b7$export$93af822566053b3e;

});

parcelRegister("1E185", function(module, exports) {

let $132a6726db9fc553$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("cd7QD"), 5)),
    $132a6726db9fc553$var$load("4GE9S")
]).then(()=>parcelRequire('cmkWO'));

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("6pwLK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5vi32 = parcelRequire("5vi32");


var $lJlG6 = parcelRequire("lJlG6");


var $jxpvN = parcelRequire("jxpvN");

const $f91eb48475fb1f4e$export$fce08d0d9d687787 = ({ includeTopNav: includeTopNav, children: children })=>{
    const { includeTopNav: inheritedOrDefaultValue } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    if (typeof includeTopNav !== 'boolean') includeTopNav = isEmbeddedConfluence || isMobileApp ? false : inheritedOrDefaultValue;
    const bannerContextValue = (0, $42omo.useMemo)(()=>({
            includeTopNav: includeTopNav
        }), [
        includeTopNav
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: bannerContextValue
    }, children);
};
module.exports["BannerContextProvider"] = $f91eb48475fb1f4e$export$fce08d0d9d687787;

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("jxpvN", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $42omo.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("djZz9", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $38a3bf8a14810337$export$de3a38bd9f6fbd0c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JEntR",
    name: "SpaceOverviewLoader",
    loader: async ()=>(await (parcelRequire("9eq7C"))).SpaceOverview
});
module.exports["SpaceOverviewLoader"] = $38a3bf8a14810337$export$de3a38bd9f6fbd0c;

});

parcelRegister("9eq7C", function(module, exports) {

let $6b89af22a4830275$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b89af22a4830275$var$load("a1VZ3"),
    $6b89af22a4830275$var$load("1R71g"),
    $6b89af22a4830275$var$load("iXzmH"),
    $6b89af22a4830275$var$load("65c4i"),
    $6b89af22a4830275$var$load("7whwt"),
    $6b89af22a4830275$var$load("5HTaY"),
    $6b89af22a4830275$var$load("6tsCm"),
    $6b89af22a4830275$var$load("3yM79"),
    $6b89af22a4830275$var$load("2F69B"),
    $6b89af22a4830275$var$load("5coOi"),
    $6b89af22a4830275$var$load("aZinD"),
    $6b89af22a4830275$var$load("9Z7qK"),
    $6b89af22a4830275$var$load("duPDN"),
    $6b89af22a4830275$var$load("70qyO"),
    $6b89af22a4830275$var$load("aVVRX"),
    $6b89af22a4830275$var$load("fkeSV"),
    $6b89af22a4830275$var$load("hcj2C"),
    $6b89af22a4830275$var$load("2UF2x"),
    $6b89af22a4830275$var$load("fgAx2"),
    $6b89af22a4830275$var$load("8YSo7"),
    $6b89af22a4830275$var$load("lqbST"),
    $6b89af22a4830275$var$load("gLGsg"),
    $6b89af22a4830275$var$load("2Cftu"),
    $6b89af22a4830275$var$load("4i0CB"),
    $6b89af22a4830275$var$load("jkPqm"),
    $6b89af22a4830275$var$load("8ab9M"),
    $6b89af22a4830275$var$load("gyOzw"),
    $6b89af22a4830275$var$load("87NBA"),
    $6b89af22a4830275$var$load("8KnyD"),
    $6b89af22a4830275$var$load("bRz9K"),
    $6b89af22a4830275$var$load("4Lgj0"),
    $6b89af22a4830275$var$load("kSJiq"),
    $6b89af22a4830275$var$load("ePdWC"),
    $6b89af22a4830275$var$load("lBzRN"),
    $6b89af22a4830275$var$load("6Nsud"),
    $6b89af22a4830275$var$load("gmzZ6"),
    $6b89af22a4830275$var$load("ipiLs"),
    $6b89af22a4830275$var$load("1Jgsw"),
    $6b89af22a4830275$var$load("dclpt"),
    $6b89af22a4830275$var$load("tKhaz"),
    $6b89af22a4830275$var$load("jwWp5"),
    $6b89af22a4830275$var$load("6wr18"),
    $6b89af22a4830275$var$load("cyGuT"),
    $6b89af22a4830275$var$load("9wxKg"),
    $6b89af22a4830275$var$load("Wowvf"),
    $6b89af22a4830275$var$load("let0D"),
    $6b89af22a4830275$var$load("ffEVr"),
    $6b89af22a4830275$var$load("kUbUu"),
    $6b89af22a4830275$var$load("dIKn2"),
    $6b89af22a4830275$var$load("8fdGr"),
    $6b89af22a4830275$var$load("hhss7"),
    $6b89af22a4830275$var$load("1gUNx"),
    $6b89af22a4830275$var$load("7EorR"),
    $6b89af22a4830275$var$load("e66P8")
]).then(()=>parcelRequire('eiWUW'));

});

parcelRegister("iqPBi", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $2daQU = parcelRequire("2daQU");


var $inPa6 = parcelRequire("inPa6");



var $dPJCf = parcelRequire("dPJCf");


var $1ytiN = parcelRequire("1ytiN");


var $fM6x5 = parcelRequire("fM6x5");


var $cEgMD = parcelRequire("cEgMD");


var $8oCjN = parcelRequire("8oCjN");


var $4b4iP = parcelRequire("4b4iP");


var $j9XVO = parcelRequire("j9XVO");

const $023f02fd9a9aead0$var$DISPLAY_ROOT = 'display';
const $023f02fd9a9aead0$var$SPACE_ROOT = 'spaces';
const $023f02fd9a9aead0$var$getUrlRoot = (pathname)=>{
    if (!pathname) return undefined;
    if (pathname.includes(`/${$023f02fd9a9aead0$var$SPACE_ROOT}/`)) return $023f02fd9a9aead0$var$SPACE_ROOT;
    else if (pathname.includes(`/${$023f02fd9a9aead0$var$DISPLAY_ROOT}/`)) return $023f02fd9a9aead0$var$DISPLAY_ROOT;
    else return undefined;
};
const $023f02fd9a9aead0$var$useContentSlug = (0, $dPJCf.createRouteParamHook)('contentSlug');
const $023f02fd9a9aead0$var$useContentId = (0, $dPJCf.createRouteParamHook)('contentId');
const $023f02fd9a9aead0$var$LegacySpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const history = (0, $dPJCf.useHistory)();
    const isFirstRoute = history?.length === 1;
    const location = (0, $QU6QS.useLocation)();
    const fixSpaceEncodingInSpaceKey = ()=>{
        const pathname = location?.pathname || '';
        const decodedPathname = decodeURIComponent(pathname);
        if (// excludes the cases where there are no + symbols to replace at all
        // eg: /spaces/perfectly-fine-space-key
        pathname.indexOf('+') !== -1 && // excludes the cases where there is a + that follows the space key portion of the path
        // eg: /spaces/DS/other+stuff+that+contains+plus
        spaceKey.indexOf('+') !== -1 && // excludes the cases where the decoded path name still contains a + (from %2B)
        // , but the replacement to strip the + from the space key has already happened in previous SPA transition
        // eg: pathname = '/spaces/space%2Bkey', decodedPathname = '/spaces/space+key', spaceKey = 'space+key'
        decodedPathname.indexOf(`spaces/${spaceKey}`) !== -1) history?.replace?.({
            ...location,
            // Ensure we are replacing the "+" in the space key not other funny stuff
            pathname: decodedPathname.replace(`spaces/${spaceKey}`, `spaces/${spaceKey}`.replace(/\+/g, ' '))
        });
    };
    const removeEmailQueryParameters = ()=>{
        if (!location?.search?.includes('src=mail') && !location?.search?.includes('src.mail.')) return;
        let search = location?.search?.substring(1);
        const params = search.split('&').filter((param)=>!param.includes('src=mail') && !param.startsWith('src.mail.'));
        search = `?${params.join('&')}`;
        history?.replace?.({
            ...location,
            search: search
        });
    };
    (0, $42omo.useEffect)(()=>{
        fixSpaceEncodingInSpaceKey();
        removeEmailQueryParameters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isSpaceLoading) return;
        if (space && space.alias && space.alias !== spaceKey) {
            const pathnameRoot = $023f02fd9a9aead0$var$getUrlRoot(location?.pathname);
            if (pathnameRoot) {
                const routeName = routeDataRef.current?.routeName || null;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'redirect',
                        actionSubject: 'route',
                        source: 'SpaceBase',
                        attributes: {
                            routeName: routeName,
                            // Space key related attributes.
                            areSpaceKeysEqualLowercase: space?.alias?.toLowerCase() === spaceKey?.toLowerCase()
                        }
                    }
                }).fire();
                history?.replace?.({
                    ...location,
                    pathname: location?.pathname?.replace(`/${pathnameRoot}/${spaceKey}`, `/${pathnameRoot}/${space.alias}`)
                });
            }
            return;
        }
    }, [
        createAnalyticsEvent,
        history,
        location,
        space,
        spaceKey,
        routeDataRef,
        isSpaceLoading
    ]);
    /*
   * Removing SpaceBaseThemedComponent for the Company Hub app-like experience
   *
   * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
   * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
   */ const SpaceBaseWrapper = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? (0, $42omo.Fragment) : (0, $8oCjN.SpaceBaseThemedComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        isFirstRoute: isFirstRoute,
        goBackPreviousPage: history?.goBack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpaceBaseWrapper, null, children)));
};
const $023f02fd9a9aead0$var$SpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    return $023f02fd9a9aead0$var$LegacySpaceBaseComponent({
        children: children,
        spaceKey: spaceKey,
        space: space,
        isSpaceLoading: isSpaceLoading
    });
};
const $023f02fd9a9aead0$var$useSpaceKey = (0, $dPJCf.createRouteParamHook)('spaceKey');
const $023f02fd9a9aead0$export$adbf61121b32bd9b = ({ children: children, spaceKey: spaceKey })=>{
    const resolvedSpaceKey = $023f02fd9a9aead0$var$useSpaceKey() || spaceKey || '';
    const { space: space, loading: loading } = (0, $j9XVO.useSpaceBaseQuery)({
        resolvedSpaceKey: resolvedSpaceKey
    });
    return (0, $fM6x5.default)(()=>space?.name)($023f02fd9a9aead0$var$SpaceBaseComponent)({
        spaceKey: resolvedSpaceKey,
        space: space,
        children: children,
        isSpaceLoading: loading
    });
};
module.exports["SpaceBase"] = $023f02fd9a9aead0$export$adbf61121b32bd9b;

});

parcelRegister("fM6x5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6436abe84fc91b7d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $8EsbU = parcelRequire("8EsbU");


var $d5RCH = parcelRequire("d5RCH");

function $6436abe84fc91b7d$export$2e2bcd8739ae039(getTitle, wrapperStyle) {
    if (typeof wrapperStyle === 'undefined') wrapperStyle = {};
    return (BaseComponent)=>(props)=>{
            const title = getTitle(props);
            const siteTitle = (0, $8EsbU.getOverride)('site-title') || '';
            const titleDefinedOnWindow = window['__DOCUMENT_TITLE_TAG__'] || '';
            let titleProp;
            if (titleDefinedOnWindow) titleProp = titleDefinedOnWindow;
            else if (title && siteTitle) titleProp = `${title} - ${siteTitle}`;
            else titleProp = title || siteTitle;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: wrapperStyle,
                "data-testid": "with-document-title"
            }, !window['__SSR_RENDERED__'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
                title: titleProp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, props)));
        };
}

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("8oCjN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $6mKj3 = parcelRequire("6mKj3");


var $lKNXy = parcelRequire("lKNXy");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $3Klda = parcelRequire("3Klda");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $fyPYm = parcelRequire("fyPYm");


var $kmaxw = parcelRequire("kmaxw");


var $eSlm6 = parcelRequire("eSlm6");

const $7bbee5da9ba28ec8$var$connectAddonContainerStyle = {
    position: 'relative'
};
const $7bbee5da9ba28ec8$var$connectAddonProps = {
    contentStyle: {
        width: '100%',
        textAlign: 'center',
        display: 'inline-block'
    },
    width: '100%',
    height: '100%'
};
const $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX = /^ac:(.*)__(.*)-remote-theme$/;
const $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7 = (themeKey)=>{
    const regexResult = $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX.exec(themeKey);
    return regexResult ? [
        regexResult[1],
        regexResult[2]
    ] : [
        null,
        null
    ];
};
const $7bbee5da9ba28ec8$export$7f576b861c4a75d4 = ({ children: children })=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    let chooseContentUnifiedQuery = (0, $61vTv.ContentUnifiedQuery);
    if (contentType === 'blogpost') chooseContentUnifiedQuery = (0, $lpxTx.ContentBlogUnifiedQuery);
    const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
    const skipContentQuery = !contentId || !spaceKey || !isSpaceOverview || contentIdLoading;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const contentQueryResult = (0, $xQxzY.useQuery)(chooseContentUnifiedQuery, {
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null,
            useNewContentTopper: true
        },
        skip: skipContentQuery
    });
    const themeKey = contentQueryResult?.data?.space?.theme?.themeKey;
    const routeOverrideEnabled = contentQueryResult?.data?.space?.settings?.routeOverrideEnabled;
    const [themeAddonKey, themeModuleKey] = $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7(themeKey);
    const skipOverrideQuery = !themeAddonKey || !themeModuleKey || !routeOverrideEnabled;
    const overrideQueryArgs = {
        variables: {
            themeAddonKey: themeAddonKey,
            themeModuleKey: themeModuleKey,
            spaceKey: spaceKey || '',
            spaceHomePageId: contentId || ''
        },
        skip: skipOverrideQuery
    };
    const overrideQueryResult = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_queries_exp', 'isEnabled', true) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
     ? (0, $eSlm6.useExperimentalThemeSpaceHomeOverrideQuery)(overrideQueryArgs) : (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $kmaxw.ExperimentalThemeSpaceHomeOverrideQuery), overrideQueryArgs);
    if (contentQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(contentQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(contentQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    }
    if (overrideQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(overrideQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(overrideQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    }
    if (contentIdLoading) return null;
    if (skipContentQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    if (contentQueryResult.loading || !skipOverrideQuery && overrideQueryResult.loading) return null;
    if (skipOverrideQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    if (!contentQueryResult.data || !overrideQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    const { hasSpaceHomeOverride: hasSpaceHomeOverride, spaceHomeOverrideDescriptor: spaceHomeOverrideDescriptor } = overrideQueryResult.data.experimentalThemeSpaceHomeOverride;
    if (!hasSpaceHomeOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    spaceHomeOverrideDescriptor.productContext = JSON.parse(spaceHomeOverrideDescriptor.productCtx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: spaceHomeOverrideDescriptor,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
};
module.exports["SpaceBaseThemedComponent"] = $7bbee5da9ba28ec8$export$7f576b861c4a75d4;

});

parcelRegister("lKNXy", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $d2cf06290ddd4b8d$export$1679e39403bb0c0c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rJ3Sr",
    loader: async ()=>(await (parcelRequire("bDfDA"))).ConnectAddon,
    name: 'ConnectAddonNext'
});
module.exports["ConnectAddon"] = $d2cf06290ddd4b8d$export$1679e39403bb0c0c;

});

parcelRegister("bDfDA", function(module, exports) {

let $877f77819ad16d5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $877f77819ad16d5e$var$load("58kAD"),
    $877f77819ad16d5e$var$load("6d83I")
]).then(()=>parcelRequire('2uezU'));

});

parcelRegister("3Klda", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $42omo.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("fyPYm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bavCP = parcelRequire("bavCP");


var $5SaYG = parcelRequire("5SaYG");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = ({ contentId: contentId })=>{
    (0, $42omo.useEffect)(()=>{
        $701bdc3764047e40$var$lastContentId = contentId;
    }, [
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $5SaYG.ContentViewedEventQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: "network-only",
        skip: $701bdc3764047e40$var$lastContentId === contentId
    }, ()=>null);
};
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("bavCP", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");

function $86f32d96feea2a1f$export$67f105fad14d18d({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
}
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("5SaYG", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c8189816457a0210$export$4dc4e51ac72e6b33 = (0, $eSUdr.default)`query ContentViewedEventQuery($contentId:ID){content(id:$contentId trigger:"viewed"){nodes{id}}}`;
module.exports["ContentViewedEventQuery"] = $c8189816457a0210$export$4dc4e51ac72e6b33;

});

parcelRegister("kmaxw", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $301cd5cfa500762a$export$d9b1e55f2ab777a5 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query ExperimentalThemeSpaceHomeOverrideQuery($themeAddonKey:String$themeModuleKey:String$spaceKey:String!$spaceHomePageId:String!)@experimental{experimentalThemeSpaceHomeOverride(themeAddonKey:$themeAddonKey themeModuleKey:$themeModuleKey spaceKey:$spaceKey spaceHomePageId:$spaceHomePageId){hasSpaceHomeOverride spaceHomeOverrideDescriptor{addon_key apiMigrations{gdpr}contentClassifier contextJwt cp general h hostOrigin key moduleType origin productCtx sandbox structuredContext timeZone uniqueKey url w}}}`;
module.exports["ExperimentalThemeSpaceHomeOverrideQuery"] = $301cd5cfa500762a$export$d9b1e55f2ab777a5;

});

parcelRegister("eSlm6", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $d5f5bff41df6d94f$export$aa603d43549e91b7 = ({ skip: skip, variables: variables })=>{
    const { themeAddonKey: themeAddonKey, themeModuleKey: themeModuleKey, spaceKey: spaceKey, spaceHomePageId: spaceHomePageId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: ()=>{
            if (!themeAddonKey || !themeModuleKey) // This will be handled by parseResponseOnError to return expected data when these keys are missing
            throw new Error('themeAddonKey and themeModuleKey are missing');
            return `/wiki/plugins/servlet/ac/${themeAddonKey}/${themeModuleKey}/?classifier=json&space.key=${spaceKey}&content.id=${spaceHomePageId}&content.type=page`;
        },
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnError: ()=>null,
        parseResult: (data)=>({
                experimentalThemeSpaceHomeOverride: {
                    hasSpaceHomeOverride: data !== null,
                    spaceHomeOverrideDescriptor: data
                }
            }),
        skip: skip,
        variables: variables
    });
};
module.exports["useExperimentalThemeSpaceHomeOverrideQuery"] = $d5f5bff41df6d94f$export$aa603d43549e91b7;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval
    });
    (0, $42omo.useEffect)(()=>{
        if (!skip) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (!pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("4b4iP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $67Foi = parcelRequire("67Foi");


var $eAduJ = parcelRequire("eAduJ");


var $fG32j = parcelRequire("fG32j");


var $aZfd8 = parcelRequire("aZfd8");

const $343989ced147f5e6$export$20a459334853e190 = ({ children: children, spaceKey: spaceKey, isAnonymous: isAnonymous = false, contentId: contentId, isFirstRoute: isFirstRoute = false, goBackPreviousPage: goBackPreviousPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        spaceKey: spaceKey
    }, ({ isSpaceRestricted: isSpaceRestricted, isSpaceNotFound: isSpaceNotFound })=>{
        if (isSpaceRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eAduJ.RestrictedSpace), {
            goToPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute,
            contentId: contentId
        });
        if (isSpaceNotFound && !isAnonymous && !contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZfd8.Space404), {
            goBackPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            name: "spaceNotFoundScreen",
            id: spaceKey
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    });
};
module.exports["SpaceRestrictionHandler"] = $343989ced147f5e6$export$20a459334853e190;

});

parcelRegister("eAduJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0e8fee473144754c$export$5ef003f00c9525a1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wviAQ",
    name: "RestrictedSpace",
    loader: async ()=>(await (parcelRequire("c7EE9"))).RestrictedSpace
});
module.exports["RestrictedSpace"] = $0e8fee473144754c$export$5ef003f00c9525a1;

});

parcelRegister("c7EE9", function(module, exports) {

let $8d35ab0876a1439b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8d35ab0876a1439b$var$load("2F69B"),
    $8d35ab0876a1439b$var$load("hhss7"),
    $8d35ab0876a1439b$var$load("2OcM6")
]).then(()=>parcelRequire('9at9H'));

});

parcelRegister("fG32j", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $6jrkJ = parcelRequire("6jrkJ");


var $6mKj3 = parcelRequire("6mKj3");


var $3joiD = parcelRequire("3joiD");


var $6wbAc = parcelRequire("6wbAc");

function $06e8bea7aad8a7b8$export$f1b4255eb8ae314e({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey }) {
    const superAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let data, error, loading;
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(...(0, $3joiD.getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery)({
            query: (0, $6wbAc.SpaceRestrictionCheckQuery),
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        }));
        data = result.data;
        error = result.error;
        loading = result.loading;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
        (0, $6wbAc.SpaceRestrictionCheckQuery), {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            fetchPolicy: superAdminClaim ? 'no-cache' : 'network-only',
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    }
    let isErrorHandled;
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            isErrorHandled = true;
        }
    } else if (data) {
        isSpaceNotFound = false;
        isSpaceRestricted = false;
    }
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        if (loading) return null;
        return children({
            error: error,
            isSpaceNotFound: isSpaceNotFound,
            isSpaceRestricted: isSpaceRestricted
        });
    } else return children({
        error: isErrorHandled ? undefined : error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted,
        loading: loading
    });
}
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("aZfd8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $wtSEP = parcelRequire("wtSEP");

const $c70a78199cd90f84$export$a506b89ee82dfeb8 = (props)=>{
    const { isFirstRoute: isFirstRoute, goBackPreviousPage: goBackPreviousPage } = props;
    const onClickGoPreviousLink = (e)=>{
        e.preventDefault();
        if (goBackPreviousPage) goBackPreviousPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), {
        secondaryButtonProps: {
            children: !isFirstRoute && goBackPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "space-404.text.go.back.previous.page",
                defaultMessage: "Go to previous page"
            }),
            onClick: onClickGoPreviousLink
        }
    });
};
$c70a78199cd90f84$export$a506b89ee82dfeb8.displayName = 'Space404';
module.exports["Space404"] = $c70a78199cd90f84$export$a506b89ee82dfeb8;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("9RII4"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("9RII4", function(module, exports) {

let $72ebbeb6a57f7078$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72ebbeb6a57f7078$var$load("iMSgb"),
    $72ebbeb6a57f7078$var$load("2F69B"),
    $72ebbeb6a57f7078$var$load("hhss7"),
    $72ebbeb6a57f7078$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("j9XVO", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $6mKj3 = parcelRequire("6mKj3");


var $lumgz = parcelRequire("lumgz");

const $2278a3c3763ebfe6$export$a45766b8588918d2 = (0, $eSUdr.default)`query useSpaceBaseQuerySpaceQuery($spaceKey:String){space(key:$spaceKey){id key name alias}}`;
const $2278a3c3763ebfe6$export$8eab19bcc4a0311d = ({ resolvedSpaceKey: resolvedSpaceKey })=>{
    const { data: spaceBaseQueryData, loading: spaceBaseQueryLoading, error: spaceBaseQueryError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $lumgz.spaceForBaseSpaceQuery), {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        }
    });
    const { data: singleSpaceQueryData, loading: singleSpaceQueryLoading, error: singleSpaceQueryError } = (0, $xQxzY.useQuery)($2278a3c3763ebfe6$export$a45766b8588918d2, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || !(0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        }
    });
    let space, loading;
    if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
        loading = singleSpaceQueryLoading;
        space = singleSpaceQueryError && !singleSpaceQueryLoading ? null : singleSpaceQueryData?.space;
    } else {
        loading = spaceBaseQueryLoading;
        space = spaceBaseQueryError && !spaceBaseQueryLoading ? null : spaceBaseQueryData?.spaces?.nodes?.[0];
    }
    return {
        space: space,
        loading: loading
    };
};
module.exports["useSpaceBaseQuery"] = $2278a3c3763ebfe6$export$8eab19bcc4a0311d;

});

parcelRegister("hz81G", function(module, exports) {

let $cc9bee5fb7c73b84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc9bee5fb7c73b84$var$load("fp9cm").then(()=>parcelRequire('9ehFI'));

});

parcelRegister("hRE2l", function(module, exports) {

let $d0167163a3acd208$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0167163a3acd208$var$load("9sJzT"),
    $d0167163a3acd208$var$load("6XCf4"),
    $d0167163a3acd208$var$load("5pvpJ"),
    $d0167163a3acd208$var$load("1qlDN"),
    $d0167163a3acd208$var$load("1yVM6"),
    $d0167163a3acd208$var$load("22Xly")
]).then(()=>parcelRequire('kQJNb'));

});

parcelRegister("8NC5Z", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}`, {
        skip: shouldSkip
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements.companyHub.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("7CeAz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("eqNP8", function(module, exports) {
/* FullPageLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $94835ea6111c7010$var$zIndexBlanket = 500; // layers.blanket()
const $94835ea6111c7010$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154i1ssb _1ltv1ssb _t9ec1ooe _1pby1ap8",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v5641p41 _1pbybfng _4t3i1osq _1bsb1osq _kqsw1n9t _1ltvidpf _154iidpf _bfhkvuon _tzy47u59 _1lww1yx9",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$fe2b6579564feee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94835ea6111c7010$export$7c6e2c02157bb7d2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "full-page-loading-screen",
        size: 26
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94835ea6111c7010$export$5b927fc1ef8c468b, null));
module.exports["FullPageLoadingScreen"] = $94835ea6111c7010$export$fe2b6579564feee;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 25000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("gi8UL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $9A0hR = parcelRequire("9A0hR");


var $9wGTI = parcelRequire("9wGTI");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $43e2h = parcelRequire("43e2h");


var $bZB1l = parcelRequire("bZB1l");


var $kTR7R = parcelRequire("kTR7R");


var $4TEGh = parcelRequire("4TEGh");

const $acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR = 'A space already exists';
const $acd2ea8b6650161b$export$66010d469140e6a6 = (error)=>{
    return !!error?.graphQLErrors?.some((error)=>{
        const isStatusCode400 = error.extensions?.statusCode === 400;
        const hasSimpleErrorMessage = error.message.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR);
        const hasNestedErrorMessage = error.extensions?.data?.errors?.every((err)=>err?.message?.translation?.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR));
        return isStatusCode400 && (hasSimpleErrorMessage || hasNestedErrorMessage);
    });
};
const $acd2ea8b6650161b$export$167bd8b1ca11153c = "User doesn't have permission to create system space";
const $acd2ea8b6650161b$export$ed3e7d674501852d = (error)=>$acd2ea8b6650161b$var$hasNestedApolloErrorMessage(error, $acd2ea8b6650161b$export$167bd8b1ca11153c);
const $acd2ea8b6650161b$var$hasNestedApolloErrorMessage = (error, errorMessage)=>{
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.some((err)=>err?.message?.translation?.includes(errorMessage));
};
const $acd2ea8b6650161b$var$getErrorFlagConfig = (title, description, actions = [], id)=>({
        id: id,
        title: title,
        description: description,
        actions: actions
    });
const $acd2ea8b6650161b$var$showStalePermissionsErrorFlag = (flags)=>{
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagDescription,
        values: {
            a: (...chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__company-hub') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                    target: "_blank"
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                    href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                    target: "_blank"
                }, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagButton),
            onClick: ()=>window.location.reload()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions));
};
const $acd2ea8b6650161b$var$showUnauthorizedErrorFlag = (flags)=>{
    const id = 'create-system-space-permissions-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagDescription,
        values: {
            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagButton),
            href: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions, id));
};
const $acd2ea8b6650161b$var$showGenericErrorFlag = (flags)=>{
    const id = 'create-system-space-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagDescription);
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, [], id));
};
const $acd2ea8b6650161b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    createCompanyHubSpaceErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-title",
        defaultMessage: "Something went wrong"
    },
    createCompanyHubSpaceErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-description",
        defaultMessage: "Try again to continue setting up your landing page."
    },
    createCompanyHubSpacePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-title",
        defaultMessage: "You need permission"
    },
    createCompanyHubSpacePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-description",
        defaultMessage: "You need <b>Create space</b> permissions to create this hub."
    },
    createCompanyHubSpacePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-button",
        defaultMessage: "Go to permissions"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-title",
        defaultMessage: "We couldn\u2019t create your hub"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-description",
        defaultMessage: "Only product admins can create and activate a <a>Company hub</a>"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-button",
        defaultMessage: "Got it"
    }
});
async function $acd2ea8b6650161b$export$cb27704aaa7dfff2(flags) {
    const client = (0, $hp2SH.getApolloClient)();
    try {
        const hasHubSpace = await (0, $43e2h.checkIfCompanyHubSpaceExists)();
        if (!hasHubSpace) {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const { data: data, errors: errors } = await client.mutate({
                mutation: (0, $kTR7R.CreateCompanyHubSpaceMutation),
                variables: {
                    input: {
                        systemSpaceHomepageTemplate: (0, $bZB1l.SystemSpaceHomepageTemplate).EAP
                    }
                },
                update: (cache, { data: data })=>{
                    const companyHubName = data?.createSystemSpace?.name;
                    if (!companyHubName) return;
                    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, companyHubName);
                }
            });
            if (errors?.length) throw new (0, $9A0hR.ApolloErrorInterop)({
                graphQLErrors: errors
            });
            if (data?.createSystemSpace?.id != null) $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: true,
                homepageId: data?.createSystemSpace?.homepageId
            };
        }
        $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
        return {
            didCreateSpace: false,
            homepageId: undefined
        };
    } catch (error) {
        if ($acd2ea8b6650161b$export$66010d469140e6a6(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: false,
                homepageId: undefined
            };
        }
        if (flags) {
            if ($acd2ea8b6650161b$export$ed3e7d674501852d(error)) $acd2ea8b6650161b$var$showStalePermissionsErrorFlag(flags);
            else if ((0, $1uFM6.isUnauthorizedError)(error)) $acd2ea8b6650161b$var$showUnauthorizedErrorFlag(flags);
            else $acd2ea8b6650161b$var$showGenericErrorFlag(flags);
        }
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
}
function $acd2ea8b6650161b$var$updateFrontCoverStateCache(cache) {
    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, null, (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY);
}
function $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, companyHubName, frontCoverState) {
    cache.writeQuery({
        query: (0, $4TEGh.SiteConfigurationQuery),
        data: {
            siteSettings: {
                // Codegen is specifically configured to not add __typename when generating the types file,
                // so unfortunately ts-ignore is required here.
                // @ts-ignore
                __typename: 'SiteSettings',
                ...companyHubName ? {
                    companyHubName: companyHubName
                } : {},
                ...frontCoverState ? {
                    frontCover: {
                        frontCoverState: frontCoverState,
                        // Codegen is specifically configured to not add __typename when generating the types file,
                        // so unfortunately ts-ignore is required here.
                        // @ts-ignore
                        __typename: 'FrontCover'
                    }
                } : {}
            }
        }
    });
}
module.exports["hasStalePermissionsErrorMessage"] = $acd2ea8b6650161b$export$ed3e7d674501852d;
module.exports["i18n"] = $acd2ea8b6650161b$export$a7357cdd1f0b0168;
module.exports["createCompanyHubSpace"] = $acd2ea8b6650161b$export$cb27704aaa7dfff2;

});

parcelRegister("43e2h", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $cEgMD = parcelRequire("cEgMD");


var $dSvuc = parcelRequire("dSvuc");

async function $efb8b6f89ca41072$export$bd1440de1c6279ff() {
    const key = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (!key) throw new Error('Failed to get company hub space key');
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $dSvuc.CompanyHubSpaceQuery),
            variables: {
                key: key
            }
        });
        return !!data?.space?.id;
    } catch (error) {
        if (error?.message.includes('NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return false;
        } else throw error;
    }
}
module.exports["checkIfCompanyHubSpaceExists"] = $efb8b6f89ca41072$export$bd1440de1c6279ff;

});

parcelRegister("dSvuc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $d89c04ce1104682e$export$64834e9fe6776d12 = (0, $eSUdr.default)`query CompanyHubSpaceQuery($key:String!){space(key:$key){id}}`;
module.exports["CompanyHubSpaceQuery"] = $d89c04ce1104682e$export$64834e9fe6776d12;

});

parcelRegister("bZB1l", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $f8cc4d70fe32131d$export$7347d1c116cc1a56 = /*#__PURE__*/ function(SystemSpaceHomepageTemplate) {
    SystemSpaceHomepageTemplate["EAP"] = "EAP";
    SystemSpaceHomepageTemplate["MINIMAL"] = "MINIMAL";
    SystemSpaceHomepageTemplate["VISUAL"] = "VISUAL";
    return SystemSpaceHomepageTemplate;
}({});
module.exports["SystemSpaceHomepageTemplate"] = $f8cc4d70fe32131d$export$7347d1c116cc1a56;

});

parcelRegister("kTR7R", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $0b34b90a0ef38a24$export$c809dce00db58200 = (0, $eSUdr.default)`mutation CreateCompanyHubSpaceMutation($input:SystemSpaceHomepageInput!){createSystemSpace(input:$input){homepageId id name type}}`;
module.exports["CreateCompanyHubSpaceMutation"] = $0b34b90a0ef38a24$export$c809dce00db58200;

});

parcelRegister("4TEGh", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a66a89e54a931f6d$export$43bc7b961701c4a8 = (0, $eSUdr.default)`query SiteConfigurationQuery{siteSettings{companyHubName frontCover{frontCoverState}}}`;
module.exports["SiteConfigurationQuery"] = $a66a89e54a931f6d$export$43bc7b961701c4a8;

});

parcelRegister("9J6Xv", function(module, exports) {

let $714db6e7bb305ede$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $714db6e7bb305ede$var$load("bAXKU"),
    $714db6e7bb305ede$var$load("edPhJ"),
    $714db6e7bb305ede$var$load("lmJFL"),
    $714db6e7bb305ede$var$load("6wwLO"),
    $714db6e7bb305ede$var$load("lT0RE"),
    $714db6e7bb305ede$var$load("fgH74"),
    $714db6e7bb305ede$var$load("5VdYb"),
    $714db6e7bb305ede$var$load("1aPQ5"),
    $714db6e7bb305ede$var$load("4YwES"),
    $714db6e7bb305ede$var$load("9mtZC"),
    $714db6e7bb305ede$var$load("kFEyO"),
    $714db6e7bb305ede$var$load("gMWRW"),
    $714db6e7bb305ede$var$load("k28dP"),
    $714db6e7bb305ede$var$load("4CfTY"),
    $714db6e7bb305ede$var$load("adH3p"),
    $714db6e7bb305ede$var$load("2Mjri"),
    $714db6e7bb305ede$var$load("kTnVa"),
    $714db6e7bb305ede$var$load("4rKYa"),
    $714db6e7bb305ede$var$load("lRtGG"),
    $714db6e7bb305ede$var$load("iMSgb"),
    $714db6e7bb305ede$var$load("eErVv"),
    $714db6e7bb305ede$var$load("4Zl8Z"),
    $714db6e7bb305ede$var$load("a4yJG"),
    $714db6e7bb305ede$var$load("jvHRs"),
    $714db6e7bb305ede$var$load("k97iL"),
    $714db6e7bb305ede$var$load("gLGsg"),
    $714db6e7bb305ede$var$load("aL59j"),
    $714db6e7bb305ede$var$load("dD4ld"),
    $714db6e7bb305ede$var$load("9XYQ9"),
    $714db6e7bb305ede$var$load("7EorR"),
    $714db6e7bb305ede$var$load("cMlHc"),
    $714db6e7bb305ede$var$load("eVYW1"),
    $714db6e7bb305ede$var$load("ls0Um"),
    $714db6e7bb305ede$var$load("020xd"),
    $714db6e7bb305ede$var$load("eTBsW"),
    $714db6e7bb305ede$var$load("1oiJ6"),
    $714db6e7bb305ede$var$load("2fk6g"),
    $714db6e7bb305ede$var$load("4jPsO"),
    $714db6e7bb305ede$var$load("hPalR"),
    $714db6e7bb305ede$var$load("hszIA"),
    $714db6e7bb305ede$var$load("8059b"),
    $714db6e7bb305ede$var$load("3wmvj"),
    $714db6e7bb305ede$var$load("72780"),
    $714db6e7bb305ede$var$load("jDjSj"),
    $714db6e7bb305ede$var$load("8JZKd"),
    $714db6e7bb305ede$var$load("6wr18"),
    $714db6e7bb305ede$var$load("ffEVr"),
    $714db6e7bb305ede$var$load("61fF8"),
    $714db6e7bb305ede$var$load("8Gekp"),
    $714db6e7bb305ede$var$load("cYP30")
]).then(()=>parcelRequire('35RMv'));

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ var $8cf96aaaf31dfd76$export$75ebf2388340a0ba = /*#__PURE__*/ function(MustPreloadLoadableNames) {
    MustPreloadLoadableNames["ClassicRendererLoader"] = "ClassicRendererLoader";
    MustPreloadLoadableNames["ClassicEditorContextProviderLoader"] = "ClassicEditorContextProviderLoader";
    MustPreloadLoadableNames["NativeCollabLoader"] = "NativeCollabLoader";
    MustPreloadLoadableNames["FullPageEditorLoader"] = "FullPageEditorLoader";
    MustPreloadLoadableNames["ViewPageRouteComponentLoader"] = "ViewPageRouteComponentLoader";
    MustPreloadLoadableNames["LivePageComponentLoader"] = "LivePageComponentLoader";
    MustPreloadLoadableNames["EditorByLineArea"] = "EditorByLineArea";
    return MustPreloadLoadableNames;
}({});
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("6vGTt", function(module, exports) {

let $4bd6e91c814aeb4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4bd6e91c814aeb4d$var$load("cgtG8").then(()=>parcelRequire('g3qL5'));

});

parcelRegister("5AtW0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jZrBc = parcelRequire("jZrBc");

class $8777d177426e798b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsNew, this.props);
    }
    constructor(props){
        super(props);
    }
}
function $8777d177426e798b$var$WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8777d177426e798b$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $8777d177426e798b$export$2e2bcd8739ae039;

});

parcelRegister("7bZ3i", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $99uSl = parcelRequire("99uSl");


var $lgmus = parcelRequire("lgmus");


var $6q0AE = parcelRequire("6q0AE");


var $79vw2 = parcelRequire("79vw2");


var $dE3t3 = parcelRequire("dE3t3");


var $eIleF = parcelRequire("eIleF");


var $k00oi = parcelRequire("k00oi");

function $4cf4ff4aa0c52ddf$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel }) {
    const parentContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const defaultInitialState = (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $42omo.useMemo)(()=>{
        return (0, $99uSl.createStore)((0, $dE3t3.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>{
        const client = customClient || new (0, $k00oi.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        _platform)=>{
            const cardState = (0, $6q0AE.getUrl)(store, url);
            return cardState.details ? (0, $79vw2.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    const value = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $4cf4ff4aa0c52ddf$export$2e2bcd8739ae039 = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;
module.exports["SmartCardProvider"] = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;

});

parcelRegister("dE3t3", function(module, exports) {

var $9gPkz = parcelRequire("9gPkz");

var $btw9C = parcelRequire("btw9C");

const $93945b5bac9d9f43$var$isCardAction = (action)=>{
    return [
        (0, $9gPkz.ACTION_PENDING),
        (0, $9gPkz.ACTION_RESOLVING),
        (0, $9gPkz.ACTION_RESOLVED),
        (0, $9gPkz.ACTION_RELOADING),
        (0, $9gPkz.ACTION_ERROR),
        (0, $9gPkz.ACTION_ERROR_FALLBACK),
        (0, $9gPkz.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $93945b5bac9d9f43$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $btw9C.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $93945b5bac9d9f43$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $9gPkz.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVED:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $9gPkz.ACTION_RELOADING:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $9gPkz.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $9gPkz.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $9gPkz.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $93945b5bac9d9f43$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$93945b5bac9d9f43$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $93945b5bac9d9f43$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};
module.exports["cardReducer"] = $93945b5bac9d9f43$export$3c7c3113a97b6492;

});

parcelRegister("g3LxX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $753deba3fe656290$var$initialState = {
    isInViewMode: true,
    isInAutoFocusMode: true,
    selectedExtensionLocalId: null,
    selectedToEditCardId: null,
    selectedToRemoveCardId: null
};
// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const $753deba3fe656290$var$actions = {
    setIsInViewMode: (isInViewMode)=>({ setState: setState })=>{
            setState({
                isInViewMode: isInViewMode
            });
        },
    setIsInAutoFocusMode: (isInAutoFocusMode)=>({ setState: setState })=>{
            setState({
                isInAutoFocusMode: isInAutoFocusMode
            });
        },
    setSelectedExtensionLocalId: (extensionLocalId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedExtensionLocalId: extensionLocalId
            });
        },
    setSelectedToEditCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToEditCardId: cardId
            });
        },
    setSelectedToRemoveCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToRemoveCardId: cardId
            });
        }
};
const $753deba3fe656290$var$ExtensionsStateStore = (0, $1P1Tu.createStore)({
    initialState: $753deba3fe656290$var$initialState,
    actions: $753deba3fe656290$var$actions,
    name: 'ExtensionsStateStore'
});
const $753deba3fe656290$export$732cb2f7b629a11e = (0, $9zUhf.createHook)($753deba3fe656290$var$ExtensionsStateStore);
const $753deba3fe656290$export$d50cb813b9099554 = (0, $9zUhf.createActionsHook)($753deba3fe656290$var$ExtensionsStateStore);
module.exports["useExtensionsState"] = $753deba3fe656290$export$732cb2f7b629a11e;
module.exports["useExtensionsActions"] = $753deba3fe656290$export$d50cb813b9099554;

});

parcelRegister("gqsO5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5Y3fb = parcelRequire("5Y3fb");
// src/help/page/types.ts
var $c3316351a700af09$export$b6fe1f05324d51ea = "help", $c3316351a700af09$export$e6c9af890e88f3eb = "page";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/help/page/manifest.ts
var $400cfed5ea0ec5c5$var$helpPageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $c3316351a700af09$export$b6fe1f05324d51ea),
    resourceType: (0, $c3316351a700af09$export$e6c9af890e88f3eb),
    resourceIdSlug: "{activationId}/{pageId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/page/index.ts
var $400cfed5ea0ec5c5$export$7855a3c68b5a0b04 = class _HelpPageAri extends (0, $3NXcb.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $400cfed5ea0ec5c5$var$helpPageAriStaticOpts.qualifier,
            platformQualifier: $400cfed5ea0ec5c5$var$helpPageAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $400cfed5ea0ec5c5$var$helpPageAriStaticOpts.resourceOwner,
            resourceType: $400cfed5ea0ec5c5$var$helpPageAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.pageId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $400cfed5ea0ec5c5$var$helpPageAriStaticOpts);
        return new _HelpPageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $400cfed5ea0ec5c5$var$helpPageAriStaticOpts);
        return new _HelpPageAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts);
        this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};


const $6e2765f836bfa39f$export$9a47313ad5d1f7c3 = (asapIssuer, mediaToken, mediaUrl)=>async ()=>{
        return {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
        };
    };
const $6e2765f836bfa39f$export$98e696b66f6bbf2b = (mediaCollectionName, asapIssuer, mediaToken, mediaUrl)=>({
        uploadParams: {
            collection: mediaCollectionName
        },
        viewMediaClientConfig: {
            authProvider: $6e2765f836bfa39f$export$9a47313ad5d1f7c3(asapIssuer, mediaToken, mediaUrl),
            useSha256ForUploads: true
        }
    });
const $6e2765f836bfa39f$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $5Y3fb.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch (error) {
    // todo: add analytics
    }
};
const $6e2765f836bfa39f$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $6e2765f836bfa39f$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (0, $400cfed5ea0ec5c5$export$7855a3c68b5a0b04).create({
        activationId: activationId,
        pageId: pageId || helpCenterId
    }).toString() || '';
};
const $6e2765f836bfa39f$export$6a5aa704056d141b = (0, $42omo.createContext)(null);
const $6e2765f836bfa39f$export$ac8576a9912be18c = ()=>{
    const context = (0, $42omo.useContext)($6e2765f836bfa39f$export$6a5aa704056d141b);
    if (!context) throw new Error('useHubContext must be used within a HubContextProvider');
    return context;
};
module.exports["getMediaProvider"] = $6e2765f836bfa39f$export$98e696b66f6bbf2b;
module.exports["useHubContext"] = $6e2765f836bfa39f$export$ac8576a9912be18c;

});

parcelRegister("5Y3fb", function(module, exports) {
// src/help/help-center/types.ts
var $2b0c09992fb4f974$export$a4af98a27b4568ee = "help", $2b0c09992fb4f974$export$f6271ed6947e9084 = "help-center";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/help/help-center/manifest.ts
var $45851286fb5b07a6$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $2b0c09992fb4f974$export$a4af98a27b4568ee),
    resourceType: (0, $2b0c09992fb4f974$export$f6271ed6947e9084),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $45851286fb5b07a6$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $3NXcb.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $45851286fb5b07a6$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $45851286fb5b07a6$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $45851286fb5b07a6$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $45851286fb5b07a6$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $45851286fb5b07a6$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $45851286fb5b07a6$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
    constructor(opts){
        super(opts);
        this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
};
module.exports["HelpHelpCenterAri"] = $45851286fb5b07a6$export$a75f3c98d930b258;

});

parcelRegister("l0fE5", function(module, exports) {

let $f4a5bbf38c738b3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4a5bbf38c738b3a$var$load("8JZKd"),
    $f4a5bbf38c738b3a$var$load("d9TJ0"),
    $f4a5bbf38c738b3a$var$load("8nWJU"),
    $f4a5bbf38c738b3a$var$load("cgmWe"),
    $f4a5bbf38c738b3a$var$load("eErVv"),
    $f4a5bbf38c738b3a$var$load("2B6wT"),
    $f4a5bbf38c738b3a$var$load("gKYwM"),
    $f4a5bbf38c738b3a$var$load("lEurX"),
    $f4a5bbf38c738b3a$var$load("hwLGf"),
    $f4a5bbf38c738b3a$var$load("eYere"),
    $f4a5bbf38c738b3a$var$load("at1W4"),
    $f4a5bbf38c738b3a$var$load("kWNlz"),
    $f4a5bbf38c738b3a$var$load("cHTTI"),
    $f4a5bbf38c738b3a$var$load("ePdWC"),
    $f4a5bbf38c738b3a$var$load("lBzRN"),
    $f4a5bbf38c738b3a$var$load("7whwt"),
    $f4a5bbf38c738b3a$var$load("dChec"),
    $f4a5bbf38c738b3a$var$load("2YffH"),
    $f4a5bbf38c738b3a$var$load("f35QR"),
    $f4a5bbf38c738b3a$var$load("eVYW1"),
    $f4a5bbf38c738b3a$var$load("ls0Um"),
    $f4a5bbf38c738b3a$var$load("020xd"),
    $f4a5bbf38c738b3a$var$load("eTBsW"),
    $f4a5bbf38c738b3a$var$load("bYxCZ"),
    $f4a5bbf38c738b3a$var$load("6HBYC"),
    $f4a5bbf38c738b3a$var$load("1oiJ6"),
    $f4a5bbf38c738b3a$var$load("huUvS"),
    $f4a5bbf38c738b3a$var$load("3RdRc"),
    $f4a5bbf38c738b3a$var$load("98UJI"),
    $f4a5bbf38c738b3a$var$load("b0cmi"),
    $f4a5bbf38c738b3a$var$load("51haJ"),
    $f4a5bbf38c738b3a$var$load("7f9Fz"),
    $f4a5bbf38c738b3a$var$load("h4k4y"),
    $f4a5bbf38c738b3a$var$load("8bZKp"),
    $f4a5bbf38c738b3a$var$load("7RNcA"),
    $f4a5bbf38c738b3a$var$load("7jSfd"),
    $f4a5bbf38c738b3a$var$load("4HZlX"),
    $f4a5bbf38c738b3a$var$load("kDqHr"),
    $f4a5bbf38c738b3a$var$load("kjZZD"),
    $f4a5bbf38c738b3a$var$load("dTsOE"),
    $f4a5bbf38c738b3a$var$load("hhss7"),
    $f4a5bbf38c738b3a$var$load("7EorR"),
    $f4a5bbf38c738b3a$var$load("5IgYU"),
    $f4a5bbf38c738b3a$var$load("Wowvf"),
    $f4a5bbf38c738b3a$var$load("bTmOC"),
    $f4a5bbf38c738b3a$var$load("lFZaH"),
    $f4a5bbf38c738b3a$var$load("1Jgsw"),
    $f4a5bbf38c738b3a$var$load("lPQcc"),
    $f4a5bbf38c738b3a$var$load("4cHGm"),
    $f4a5bbf38c738b3a$var$load("9XYQ9"),
    $f4a5bbf38c738b3a$var$load("6wr18"),
    $f4a5bbf38c738b3a$var$load("cMlHc"),
    $f4a5bbf38c738b3a$var$load("ffEVr"),
    $f4a5bbf38c738b3a$var$load("2YDZN")
]).then(()=>parcelRequire('le2hP'));

});

parcelRegister("ab2CU", function(module, exports) {
const $8ad93972529e0d13$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $8ad93972529e0d13$export$b5a30704f903627a = 'jsm-help';
const $8ad93972529e0d13$export$727d928d273126f1 = 'jsmHelpExtension';
const $8ad93972529e0d13$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $8ad93972529e0d13$export$42fa33c628980eca = '1.0.0';
const $8ad93972529e0d13$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $8ad93972529e0d13$export$d95e7684b6658cc2 = {
    MANUAL: 'manual',
    COMMON_REQUESTS: 'common-requests'
};
module.exports["JSM_HELP_EXTENSION_TYPE"] = $8ad93972529e0d13$export$62b7ac1cc8a8f8d7;
module.exports["JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $8ad93972529e0d13$export$5eecea5c34e4d0ec;
module.exports["SourceType"] = $8ad93972529e0d13$export$d95e7684b6658cc2;

});

parcelRegister("3cMhk", function(module, exports) {
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $4a783e799621232b$export$5eb13835d9fc35c6 = 'page-topper';
const $4a783e799621232b$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $4a783e799621232b$export$bbe74ef6b7213123 = 'calloutBannerExtension';
module.exports["CALLOUT_BANNER_EXTENSION_TYPE"] = $4a783e799621232b$export$1e0076557b3776e7;
module.exports["CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE"] = $4a783e799621232b$export$bbe74ef6b7213123;

});

parcelRegister("cKAxI", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $cUcZ5 = parcelRequire("cUcZ5");


var $bre0g = parcelRequire("bre0g");


var $dh538 = parcelRequire("dh538");


var $fwDOR = parcelRequire("fwDOR");


var $lhvsH = parcelRequire("lhvsH");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");


var $kcoxM = parcelRequire("kcoxM");


var $5un3P = parcelRequire("5un3P");


var $82kD4 = parcelRequire("82kD4");


var $51FJF = parcelRequire("51FJF");


const $e60576104e03cc2c$var$CardsExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "JDp8H",
    name: "CardsExtension",
    loader: async ()=>(await (parcelRequire("77Rsc"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "cards-extension-loader"
        })
});
const $e60576104e03cc2c$export$b7316deff43c35f7 = (imageSrc, imageAltText)=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imageSrc: imageSrc,
        imagePosition: (0, $5un3P.ImagePosition).MIDDLE,
        imageAltText: imageAltText
    });
let $e60576104e03cc2c$var$cards = null;
const $e60576104e03cc2c$export$adc082ec96ce9cca = ()=>{
    if ($e60576104e03cc2c$var$cards) return $e60576104e03cc2c$var$cards;
    const initialCards = (0, $dh538.fg)('company_hub_cards_visual_update') ? (0, $kcoxM.CARDS_IMAGES_V5) : (0, $82kD4.CARDS_IMAGES_V3);
    return $e60576104e03cc2c$var$cards = initialCards.map(({ src: src, alt: alt })=>$e60576104e03cc2c$export$b7316deff43c35f7(src, alt));
};
const $e60576104e03cc2c$export$611063def302f5f2 = ({ extensionTitle: extensionTitle, isCardsV1GateEnabled: isCardsV1GateEnabled, isCardsV2GateEnabled: isCardsV2GateEnabled, isDynamicCardsAIDescriptionsEnabled: isDynamicCardsAIDescriptionsEnabled, defaultParameters: defaultParameters })=>{
    var _parameters;
    const parameters = {
        size: (0, $4cOi8.Height).MEDIUM,
        cards: $e60576104e03cc2c$export$adc082ec96ce9cca(),
        isAvatarShown: true,
        isPublishDateShown: false,
        extensionTitle: extensionTitle,
        version: (0, $kcoxM.CARDS_EXTENSION_VERSION_3),
        renderVariant: (0, $4cOi8.RenderVariant).MANUAL,
        isSegmentationShown: false,
        orientation: isCardsV1GateEnabled ? (0, $5un3P.Orientation).STACKED : (0, $5un3P.Orientation).ROW,
        alignment: isCardsV1GateEnabled ? (0, $5un3P.Alignment).CENTER : (0, $5un3P.Alignment).LEFT
    };
    (_parameters = parameters).isAutoscrollEnabled ?? (_parameters.isAutoscrollEnabled = false);
    if (isCardsV1GateEnabled) {
        var _parameters1, _parameters2, _parameters3, _parameters4, _parameters5;
        parameters.isAvatarShown = false;
        (_parameters1 = parameters).backgroundColor ?? (_parameters1.backgroundColor = defaultParameters?.backgroundColor ?? "var(--ds-surface-overlay, #FFFFFF)");
        (_parameters2 = parameters).textColor ?? (_parameters2.textColor = defaultParameters?.textColor ?? "var(--ds-text, #292A2E)");
        (_parameters3 = parameters).cornerStyle ?? (_parameters3.cornerStyle = (0, $4cOi8.CornerStyle).ROUNDED);
        (_parameters4 = parameters).isSocialStatsShown ?? (_parameters4.isSocialStatsShown = false);
        (_parameters5 = parameters).isIconShown ?? (_parameters5.isIconShown = true);
        parameters.version = (0, $kcoxM.CARDS_EXTENSION_VERSION_4);
    }
    if (isCardsV2GateEnabled) {
        var _parameters6, _parameters7, _parameters8, _parameters9;
        (_parameters6 = parameters).layout ?? (_parameters6.layout = (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT);
        (_parameters7 = parameters).isPaddingEnabled ?? (_parameters7.isPaddingEnabled = true);
        (_parameters8 = parameters).isLabelShown ?? (_parameters8.isLabelShown = true);
        (_parameters9 = parameters).borderColor ?? (_parameters9.borderColor = (0, $lhvsH.DEFAULT_GRAY_COLOR));
        parameters.version = (0, $kcoxM.CARDS_EXTENSION_VERSION_5);
    }
    if (isDynamicCardsAIDescriptionsEnabled) parameters.isDescriptionShown = true;
    return parameters;
};

const $e60576104e03cc2c$export$c0798477a3103ad2 = ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $e60576104e03cc2c$export$611063def302f5f2({
            extensionTitle: intl.formatMessage((0, $51FJF.messages).linkCardsMacroTitle),
            isCardsV1GateEnabled: (0, $dh538.fg)('company_hub_cards_visual_update'),
            isCardsV2GateEnabled: (0, $dh538.fg)('company_hub_cards_v2'),
            isDynamicCardsAIDescriptionsEnabled: (0, $dh538.fg)('company_hub_dynamic_cards_ai_descriptions'),
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $51FJF.messages).linkCardsMacroTitle),
                type: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                key: (0, $kcoxM.CARDS_EXTENSION_KEY),
                description: intl.formatMessage((0, $51FJF.messages).linkCardsMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("9AEfc")).then((mod)=>mod.CardsExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)($e60576104e03cc2c$var$CardsExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'extension',
                        key: (0, $kcoxM.CARDS_EXTENSION_KEY),
                        attrs: {
                            extensionType: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                            extensionKey: (0, $kcoxM.CARDS_EXTENSION_KEY),
                            layout: 'default',
                            parameters: parameters
                        }
                    }),
                source: 'premiumCardsInsert',
                setUpsellModalSource: setUpsellModalSource
            })
        ]);
    };
};
module.exports["getDefaultCards"] = $e60576104e03cc2c$export$adc082ec96ce9cca;
module.exports["getCardsExtensionParameters"] = $e60576104e03cc2c$export$611063def302f5f2;
module.exports["cardsExtensionProvider"] = $e60576104e03cc2c$export$c0798477a3103ad2;

});

parcelRegister("bre0g", function(module, exports) {

var $2cmfr = parcelRequire("2cmfr");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $2cmfr.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("lhvsH", function(module, exports) {

var $1u5CA = parcelRequire("1u5CA");

const $c7b070100499a556$export$47962e37d9fd03c7 = (0, $1u5CA.knownBackgroundColors)[10];
module.exports["DEFAULT_GRAY_COLOR"] = $c7b070100499a556$export$47962e37d9fd03c7;

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("5un3P", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");

const $a247ba2e22f9ecac$export$12c9c8946ce83b13 = 3;
var $a247ba2e22f9ecac$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $a247ba2e22f9ecac$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
    return Alignment;
}({});
var $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2 = /*#__PURE__*/ function(ImagePosition) {
    ImagePosition["TOP"] = "top";
    ImagePosition["MIDDLE"] = "middle";
    ImagePosition["BOTTOM"] = "bottom";
    return ImagePosition;
}({});
var $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e = /*#__PURE__*/ function(CardsLayout) {
    CardsLayout["FIXED_IMAGE_HEIGHT"] = "fixed-image-height";
    CardsLayout["FLEXIBLE_IMAGE_HEIGHT"] = "flexible-image-height";
    return CardsLayout;
}({});
module.exports["DEFAULT_DYNAMIC_CARDS_COUNT"] = $a247ba2e22f9ecac$export$12c9c8946ce83b13;
module.exports["Orientation"] = $a247ba2e22f9ecac$export$df54d73aa0ec5e82;
module.exports["Alignment"] = $a247ba2e22f9ecac$export$9d7927214ed7d2cf;
module.exports["ImagePosition"] = $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2;
module.exports["CardsLayout"] = $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e;

});

parcelRegister("82kD4", function(module, exports) {
const $7576bba209768b70$export$4e08923b7c578513 = [
    {
        src: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=1080',
        alt: 'green mountain across body of water'
    },
    {
        src: 'https://images.unsplash.com/photo-1501436513145-30f24e19fcc8?auto=format&fit=crop&q=80&w=1080',
        alt: 'calm body of water during golden hour'
    },
    {
        src: 'https://images.unsplash.com/photo-1580100586938-02822d99c4a8?auto=format&fit=crop&q=80&w=1080',
        alt: 'body of water near mountain during daytime'
    }
];
module.exports["CARDS_IMAGES_V3"] = $7576bba209768b70$export$4e08923b7c578513;

});

parcelRegister("51FJF", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d14ef5a1094a027d$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    linkCardsMacroTitle: {
        id: "company-hub.cards-extension.manifest.macro-title",
        defaultMessage: "Cards"
    },
    linkCardsMacroDescription: {
        id: "company-hub.cards-extension.manifest.macro-description",
        defaultMessage: "Display links as cards"
    }
});
module.exports["messages"] = $d14ef5a1094a027d$export$defe85febe8b728c;

});

parcelRegister("77Rsc", function(module, exports) {

let $5302a6aae6823961$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5302a6aae6823961$var$load("lEurX"),
    $5302a6aae6823961$var$load("bTmOC"),
    $5302a6aae6823961$var$load("8bZKp"),
    $5302a6aae6823961$var$load("7RNcA"),
    $5302a6aae6823961$var$load("7jSfd"),
    $5302a6aae6823961$var$load("4HZlX"),
    $5302a6aae6823961$var$load("kDqHr"),
    $5302a6aae6823961$var$load("6wr18"),
    $5302a6aae6823961$var$load("ffEVr"),
    $5302a6aae6823961$var$load("kjZZD"),
    $5302a6aae6823961$var$load("kWNlz"),
    $5302a6aae6823961$var$load("cHTTI"),
    $5302a6aae6823961$var$load("dTsOE"),
    $5302a6aae6823961$var$load("3gJkK")
]).then(()=>parcelRequire('gnpMO'));

});

parcelRegister("9AEfc", function(module, exports) {

let $6fb6b18034134dd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fb6b18034134dd2$var$load("gKYwM").then(()=>parcelRequire('4LKV2'));

});

parcelRegister("g6QUH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");


var $5Ac5G = parcelRequire("5Ac5G");


var $eIwIu = parcelRequire("eIwIu");


var $9XEGe = parcelRequire("9XEGe");


const $4059117d6b06825c$var$CarouselExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "g5PGT",
    name: "CarouselExtension",
    loader: async ()=>(await (parcelRequire("kfULj"))).CarouselExtension,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "carousel-extension-loader"
        })
});
const $4059117d6b06825c$var$carouselFrames = [
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE
    },
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    }
];
const $4059117d6b06825c$var$getV2Frames = ({ intl: intl, defaultParameters: defaultParameters })=>{
    return $4059117d6b06825c$var$carouselFrames.map(({ imageSrc: imageSrc, layout: layout })=>(0, $eIwIu.createNewFrameWithDefaultParameters)({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: {
                imageSrc: imageSrc,
                layout: layout
            }
        }));
};
const $4059117d6b06825c$export$3339a462074fecc3 = ({ extensionTitle: extensionTitle, intl: intl, defaultParameters: defaultParameters })=>({
        cards: $4059117d6b06825c$var$getV2Frames({
            intl: intl,
            defaultParameters: defaultParameters
        }),
        extensionTitle: extensionTitle,
        version: (0, $5Ac5G.CAROUSEL_VERSION_2),
        ...(0, $eIwIu.carouselNewParametersV2)
    });

const $4059117d6b06825c$export$e807a589fe0f4d24 = ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, intl: intl, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $4059117d6b06825c$export$3339a462074fecc3({
            extensionTitle: intl.formatMessage((0, $9XEGe.messages).carouselMacroTitle),
            intl: intl,
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $9XEGe.messages).carouselMacroTitleUpdated),
                type: (0, $5Ac5G.carouselExtensionType),
                key: (0, $5Ac5G.carouselExtensionKey),
                description: intl.formatMessage((0, $9XEGe.messages).carouselMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("a5YHa")).then((mod)=>mod.CarouselExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)($4059117d6b06825c$var$CarouselExtension, {
                            propsProvider: propsProvider,
                            extensionNode: node,
                            contentId: contentId
                        });
                    },
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["carouselParameters"] = $4059117d6b06825c$export$3339a462074fecc3;
module.exports["carouselExtensionProvider"] = $4059117d6b06825c$export$e807a589fe0f4d24;

});

parcelRegister("eIwIu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qzNs = parcelRequire("5qzNs");


var $8C5kA = parcelRequire("8C5kA");


var $cUcZ5 = parcelRequire("cUcZ5");


var $1VNax = parcelRequire("1VNax");

var $7q60U = parcelRequire("7q60U");

var $g3LxX = parcelRequire("g3LxX");

var $fOKpq = parcelRequire("fOKpq");


var $5Ac5G = parcelRequire("5Ac5G");


var $4cOi8 = parcelRequire("4cOi8");

var $9Uxg8 = parcelRequire("9Uxg8");


var $1JVKE = parcelRequire("1JVKE");

const $2417a3de58eaf173$export$3882df2b635374e2 = {
    cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $9Uxg8.NavigationStyle).THUMBNAILS
};
const $2417a3de58eaf173$export$b713c3bc8c446d60 = 'https://images.unsplash.com/photo-1488470015861-8bb1317353ef?auto=format&fit=crop&q=80&w=1080';
const $2417a3de58eaf173$export$27643bf44cc02178 = {
    [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: "var(--ds-text, #292A2E)",
    [(0, $4cOi8.ITEM_FIELDS).LAYOUT]: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: $2417a3de58eaf173$export$b713c3bc8c446d60,
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: "Close-up of a vibrant green palm leaf\u2019s patterns.",
    buttonText: '',
    buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
};
const $2417a3de58eaf173$export$4f94ab8184143ae6 = {
    imageSrc: 'https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1?auto=format&fit=crop&q=80&w=1080',
    imageAltText: 'purple and pink light illustration'
};
const $2417a3de58eaf173$export$5d30fc17e786110 = ({ intl: intl, defaultField: defaultField, randomLayout: randomLayout, defaultParameters: defaultParameters })=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: intl.formatMessage((0, $1JVKE.messages).placeholderTitle),
        isTitleUserEdited: false,
        description: intl.formatMessage((0, $1JVKE.messages).placeholderDescription),
        isDescriptionUserEdited: false,
        ...$2417a3de58eaf173$export$4f94ab8184143ae6,
        ...$2417a3de58eaf173$export$27643bf44cc02178,
        ...defaultParameters?.backgroundColor ? {
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: defaultParameters.backgroundColor
        } : {},
        ...defaultParameters?.textColor ? {
            [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: defaultParameters.textColor
        } : {},
        ...randomLayout && {
            [(0, $4cOi8.ITEM_FIELDS).LAYOUT]: randomLayout
        },
        ...defaultField
    });
const $2417a3de58eaf173$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited)=>{
    return {
        [(0, $4cOi8.ITEM_FIELDS).LINK]: link,
        [(0, $4cOi8.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $4cOi8.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false
    };
};
const $2417a3de58eaf173$var$fetchLocalIdMacroParameters = ({ editorActions: editorActions, localId: localId })=>{
    var _params, _params1, _params2;
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    params.version = (0, $5Ac5G.CAROUSEL_VERSION_2);
    const { cornerStyle: cornerStyle, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = $2417a3de58eaf173$export$3882df2b635374e2;
    (_params = params).cornerStyle ?? (_params.cornerStyle = cornerStyle);
    (_params1 = params).isAutoplayEnabled ?? (_params1.isAutoplayEnabled = isAutoplayEnabled);
    (_params2 = params).navigationStyle ?? (_params2.navigationStyle = navigationStyle);
    /* construct frames array with intercepted params */ params.cards = params.cards?.map((frame)=>{
        return {
            ...$2417a3de58eaf173$export$27643bf44cc02178,
            // override BG color back to white for v1 carousels to maintain parity...
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-input, #FFFFFF)",
            // ... but let frame BG color (if already set, eg to default color) override again
            ...(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(frame, [
                'imagePosition'
            ])
        };
    }) || params.cards;
    /* there were card fields added to carousel params that were nonfunctional.
   * reconstructing params to those with them omitted
   */ params = (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(params, [
        'size',
        'isPublishDateShown',
        'isAvatarShown'
    ]);
    return params;
};
const $2417a3de58eaf173$var$updateFrameInList = (frames, cardId, updatedField)=>frames.map((frame)=>{
        if (frame.cardId === cardId) return {
            ...frame,
            ...updatedField
        };
        return frame;
    });
const $2417a3de58eaf173$export$3cf295eeccc933e1 = ({ localId: localId, editorActions: editorActions })=>{
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const defaultParameters = branding?.defaultParameters;
    const [carouselParameters, setCarouselParameters] = (0, $42omo.useState)($2417a3de58eaf173$var$fetchLocalIdMacroParameters({
        editorActions: editorActions,
        localId: localId
    }));
    const usedLayoutsRef = (0, $42omo.useRef)(new Set());
    const lastUsedLayoutRef = (0, $42omo.useRef)(null);
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $g3LxX.useExtensionsActions)();
    const { cards: frames } = carouselParameters ?? {};
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const extensionNodeParams = $2417a3de58eaf173$var$fetchLocalIdMacroParameters({
            editorActions: editorActions,
            localId: localId
        });
        setCarouselParameters(extensionNodeParams);
    // we don't want to re-fetch the parameters when the default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorActions,
        localId
    ]);
    const getRandomLayout = (0, $42omo.useCallback)(()=>{
        const allLayouts = Object.values((0, $4cOi8.CommonLayout));
        if (usedLayoutsRef.current.size >= allLayouts.length - 1) usedLayoutsRef.current = new Set();
        const availableLayouts = allLayouts.filter((layout)=>!usedLayoutsRef.current.has(layout) && layout !== lastUsedLayoutRef.current);
        const randomIndex = Math.floor(Math.random() * availableLayouts.length);
        const randomLayout = availableLayouts[randomIndex];
        usedLayoutsRef.current.add(randomLayout);
        lastUsedLayoutRef.current = randomLayout;
        return randomLayout;
    }, []);
    const updateExtensionParams = (0, $42omo.useCallback)((newExtensionParameters)=>{
        setCarouselParameters((prevParams)=>{
            const updatedParams = {
                ...prevParams,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const addFrame = (0, $42omo.useCallback)(()=>{
        const newFrame = $2417a3de58eaf173$export$5d30fc17e786110({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: undefined,
            randomLayout: getRandomLayout()
        });
        updateExtensionParams({
            cards: [
                ...(0, $1VNax.checkItems)(frames) || [],
                newFrame
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newFrame.cardId);
    // no need to re-run when default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        frames,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        intl,
        getRandomLayout
    ]);
    const removeFrame = (0, $42omo.useCallback)((cardId)=>updateExtensionParams({
            cards: frames.filter((frame)=>frame.cardId !== cardId)
        }), [
        frames,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $42omo.useCallback)((updatedFields)=>updateExtensionParams(updatedFields), [
        updateExtensionParams
    ]);
    const updateFrameFormField = (0, $42omo.useCallback)((cardId, updatedField)=>{
        const updatedFrames = $2417a3de58eaf173$var$updateFrameInList(frames, cardId, updatedField);
        updateExtensionParams({
            cards: updatedFrames
        });
    }, [
        frames,
        updateExtensionParams
    ]);
    const carouselActions = (0, $42omo.useMemo)(()=>({
            addFrame: addFrame,
            removeFrame: removeFrame,
            updateMainFormField: updateMainFormField,
            updateFrameFormField: updateFrameFormField
        }), [
        addFrame,
        removeFrame,
        updateMainFormField,
        updateFrameFormField
    ]);
    return {
        carouselParameters: carouselParameters,
        carouselActions: carouselActions
    };
};
module.exports["carouselNewParametersV2"] = $2417a3de58eaf173$export$3882df2b635374e2;
module.exports["FRAME_V2_DEFAULT_IMAGE_SRC"] = $2417a3de58eaf173$export$b713c3bc8c446d60;
module.exports["frameNewParametersV2"] = $2417a3de58eaf173$export$27643bf44cc02178;
module.exports["createNewFrameWithDefaultParameters"] = $2417a3de58eaf173$export$5d30fc17e786110;
module.exports["updateLinkAndConfluencePageId"] = $2417a3de58eaf173$export$721510bd2cdb9b4f;
module.exports["useCarouselExtensionParametersAndActions"] = $2417a3de58eaf173$export$3cf295eeccc933e1;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    object = $9rfkh(object, path);
    return object == null || delete object[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("1VNax", function(module, exports) {
const $c0bf087c1d0f2640$var$validateItemsUrls = (items)=>{
    items.forEach((item)=>{
        if (!!item?.link && !item?.link.startsWith('http')) item.link = '';
    });
};
const $c0bf087c1d0f2640$export$3831ccf0db7ad748 = (items)=>{
    if (!items || items?.length === 0) return null;
    else if (Array.isArray(items)) {
        $c0bf087c1d0f2640$var$validateItemsUrls(items);
        return items;
    }
};
module.exports["checkItems"] = $c0bf087c1d0f2640$export$3831ccf0db7ad748;

});

parcelRegister("fOKpq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $7c1587c4cdf698a9$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $42omo.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $7c1587c4cdf698a9$export$774887fcc3922763 = ({ children: children, ...props })=>{
    const defaultValue = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($7c1587c4cdf698a9$export$49e1053dfc41d188.Provider, {
        value: value,
        children: children
    });
};
function $7c1587c4cdf698a9$export$8dcbb40932065737() {
    const ctx = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
}
module.exports["ProductDependenciesContext"] = $7c1587c4cdf698a9$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $7c1587c4cdf698a9$export$8dcbb40932065737;

});

parcelRegister("9Uxg8", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");

var $4c5172dc3da882ee$export$f8af16d8231e3b4e = /*#__PURE__*/ function(NavigationStyle) {
    NavigationStyle["PROGRESS_CIRCLES"] = "progress-circles";
    NavigationStyle["THUMBNAILS"] = "thumbnails";
    return NavigationStyle;
}({});
var $4c5172dc3da882ee$export$f34582f4a07dd8dd = /*#__PURE__*/ function(FrameSizes) {
    FrameSizes["NAVIGATION_THUMBNAIL"] = "navigationThumbnail";
    FrameSizes["NAVIGATION_THUMBNAIL_V2"] = "navigationThumbnailV2";
    return FrameSizes;
}({});
const $4c5172dc3da882ee$export$288376e91ac51845 = {
    ["navigationThumbnailV2"]: {
        minWidth: 200,
        maxWidth: 200,
        height: 40
    },
    ["navigationThumbnail"]: {
        minWidth: 244,
        maxWidth: 250,
        height: 72
    }
};
module.exports["NavigationStyle"] = $4c5172dc3da882ee$export$f8af16d8231e3b4e;
module.exports["FrameSizes"] = $4c5172dc3da882ee$export$f34582f4a07dd8dd;
module.exports["framesDimensions"] = $4c5172dc3da882ee$export$288376e91ac51845;

});

parcelRegister("1JVKE", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $512cd77b50dddf7a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    placeholderTitle: {
        id: "company-hub.carousel-extension.placeholder.title",
        defaultMessage: "Give your frame a title"
    },
    placeholderDescription: {
        id: "company-hub.carousel-extension.placeholder.description",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});
module.exports["messages"] = $512cd77b50dddf7a$export$defe85febe8b728c;

});

parcelRegister("9XEGe", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $93d5a0345fe228e3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    carouselMacroTitle: {
        id: "company-hub.carousel-extension.manifest.macro-title",
        defaultMessage: "Carousel"
    },
    carouselMacroTitleUpdated: {
        id: "company-hub.carousel-extension.manifest.macro-title.updated",
        defaultMessage: "Carousel [Updated]"
    },
    carouselMacroDescription: {
        id: "company-hub.carousel-extension.manifest.macro-description",
        defaultMessage: "Create a rotating trio of dynamic frames."
    }
});
module.exports["messages"] = $93d5a0345fe228e3$export$defe85febe8b728c;

});

parcelRegister("kfULj", function(module, exports) {

let $ebf13d250e709a22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ebf13d250e709a22$var$load("kWNlz"),
    $ebf13d250e709a22$var$load("cHTTI"),
    $ebf13d250e709a22$var$load("kpq80"),
    $ebf13d250e709a22$var$load("bTmOC"),
    $ebf13d250e709a22$var$load("6aY84"),
    $ebf13d250e709a22$var$load("5CaYW"),
    $ebf13d250e709a22$var$load("8bZKp"),
    $ebf13d250e709a22$var$load("7RNcA"),
    $ebf13d250e709a22$var$load("7jSfd"),
    $ebf13d250e709a22$var$load("4HZlX"),
    $ebf13d250e709a22$var$load("kDqHr"),
    $ebf13d250e709a22$var$load("6wr18"),
    $ebf13d250e709a22$var$load("ffEVr"),
    $ebf13d250e709a22$var$load("kjZZD"),
    $ebf13d250e709a22$var$load("dTsOE"),
    $ebf13d250e709a22$var$load("bap37")
]).then(()=>parcelRequire('9deYz'));

});

parcelRegister("a5YHa", function(module, exports) {

let $759973d0146159f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $759973d0146159f3$var$load("8nWJU").then(()=>parcelRequire('ayHRb'));

});

parcelRegister("aYtOO", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $cUcZ5 = parcelRequire("cUcZ5");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $fcAaV = parcelRequire("fcAaV");


var $cVaAA = parcelRequire("cVaAA");


var $dEsCs = parcelRequire("dEsCs");


var $ktHpM = parcelRequire("ktHpM");

const $bff4494b16ff252f$var$LINKS_MENU_VERSION_1 = '1';

const $bff4494b16ff252f$var$LinksMenuExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l5-_n",
    name: "LinksMenuExtension",
    loader: async ()=>(await (parcelRequire("accAV"))).LinksMenuExtension,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "links-menu-extension-loader"
        })
});
const $bff4494b16ff252f$export$e0faacd43528e300 = {
    alignment: (0, $dEsCs.ALIGNMENT).CENTER,
    fillColor: "var(--ds-surface-overlay, #FFFFFF)",
    borderColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    border: (0, $dEsCs.BORDER).NONE,
    cornerStyle: (0, $dEsCs.CORNERS).SHARP,
    textColor: "var(--ds-text, #292A2E)",
    highlightColor: "var(--ds-text, #292A2E)"
};
const $bff4494b16ff252f$var$getParameters = ({ formatMessage: formatMessage, defaultParameters: defaultParameters })=>({
        extensionTitle: formatMessage((0, $ktHpM.messages).lozengeTitle),
        version: $bff4494b16ff252f$var$LINKS_MENU_VERSION_1,
        styles: {
            ...$bff4494b16ff252f$export$e0faacd43528e300,
            ...defaultParameters?.backgroundColor ? {
                fillColor: defaultParameters.backgroundColor,
                borderColor: defaultParameters.backgroundColor
            } : {},
            ...defaultParameters?.textColor ? {
                textColor: defaultParameters.textColor,
                highlightColor: defaultParameters.textColor
            } : {}
        },
        items: [
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                type: (0, $dEsCs.ITEM).LINK,
                title: formatMessage((0, $ktHpM.messages).firstDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                type: (0, $dEsCs.ITEM).LINK,
                title: formatMessage((0, $ktHpM.messages).secondDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                type: (0, $dEsCs.ITEM).MENU,
                title: formatMessage((0, $ktHpM.messages).thirdDefaultItem),
                childItems: [
                    {
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                        type: (0, $dEsCs.ITEM).LINK,
                        title: formatMessage((0, $ktHpM.messages).nestedDefaultItem),
                        link: ''
                    }
                ]
            }
        ]
    });

const $bff4494b16ff252f$export$7c3934f2ad869115 = async ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const parameters = $bff4494b16ff252f$var$getParameters({
            formatMessage: intl.formatMessage,
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $ktHpM.messages).linksMenuTitle),
                type: (0, $cVaAA.LINKS_MENU_EXTENSION_TYPE),
                key: 'links-menu',
                description: intl.formatMessage((0, $ktHpM.messages).linksMenuDescription),
                icons: {
                    '48': ()=>(parcelRequire("2YLKr")).then((mod)=>mod.LinksMenuExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)($bff4494b16ff252f$var$LinksMenuExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                // @TODO add links menu upsell in COMPHUB-2408
                setUpsellModalSource: undefined,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["DEFAULT_STYLES"] = $bff4494b16ff252f$export$e0faacd43528e300;
module.exports["linksMenuExtensionProvider"] = $bff4494b16ff252f$export$7c3934f2ad869115;

});

parcelRegister("dEsCs", function(module, exports) {
var $a31b1dbcb326eba3$export$25d99ac3e552cf7a = /*#__PURE__*/ function(ITEM) {
    ITEM["LINK"] = "link";
    ITEM["MENU"] = "menu";
    return ITEM;
}({});
var $a31b1dbcb326eba3$export$470d0905851e47a1 = /*#__PURE__*/ function(ALIGNMENT) {
    ALIGNMENT["LEFT"] = "left";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["RIGHT"] = "right";
    return ALIGNMENT;
}({});
var $a31b1dbcb326eba3$export$8a9179e387c60c17 = /*#__PURE__*/ function(BORDER) {
    BORDER["NONE"] = "none";
    BORDER["ALL_SIDES"] = "all_sides";
    BORDER["BOTTOM"] = "bottom";
    return BORDER;
}({});
var $a31b1dbcb326eba3$export$87780c3e8dee494d = /*#__PURE__*/ function(CORNERS) {
    CORNERS["ROUND"] = "round";
    CORNERS["SHARP"] = "sharp";
    return CORNERS;
}({});
module.exports["ITEM"] = $a31b1dbcb326eba3$export$25d99ac3e552cf7a;
module.exports["ALIGNMENT"] = $a31b1dbcb326eba3$export$470d0905851e47a1;
module.exports["BORDER"] = $a31b1dbcb326eba3$export$8a9179e387c60c17;
module.exports["CORNERS"] = $a31b1dbcb326eba3$export$87780c3e8dee494d;

});

parcelRegister("ktHpM", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $bc353a1ca4476d36$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    linksMenuTitle: {
        id: "company-hub.links-menu-extension.manifest.extension-title",
        defaultMessage: "Links menu [New]"
    },
    lozengeTitle: {
        id: "company-hub.links-menu-extension.manifest.extension-lozenge-title",
        defaultMessage: "Links menu"
    },
    linksMenuDescription: {
        id: "company-hub.links-menu-extension.manifest.extension-description",
        defaultMessage: "Add multiple links and sub-menus to Company Hub"
    },
    firstDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.first-default-item",
        defaultMessage: "About us"
    },
    secondDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.second-default-item",
        defaultMessage: "Benefits"
    },
    thirdDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.third-default-item",
        defaultMessage: "Teams"
    },
    nestedDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.nested-default-item",
        defaultMessage: "Team 1"
    }
});
module.exports["messages"] = $bc353a1ca4476d36$export$defe85febe8b728c;

});

parcelRegister("accAV", function(module, exports) {

let $76c4cb6886609d68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $76c4cb6886609d68$var$load("igTEs").then(()=>parcelRequire('eMrjW'));

});

parcelRegister("2YLKr", function(module, exports) {

let $22b63923736fc1f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22b63923736fc1f0$var$load("7soIx").then(()=>parcelRequire('4YKKp'));

});

parcelRegister("2QkXB", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $fcAaV = parcelRequire("fcAaV");

var $cNwLI = parcelRequire("cNwLI");


var $6HKgG = parcelRequire("6HKgG");


var $6DWJW = parcelRequire("6DWJW");


const $1438c18bb2760da6$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "r-pUQ",
    name: "SectionExtension",
    loader: async ()=>(await (parcelRequire("fC20J"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "section-extension-loader"
        })
});
const $1438c18bb2760da6$var$sectionParameters = (intl)=>({
        extensionTitle: intl.formatMessage((0, $6DWJW.messages).lozengeTitle),
        backgroundColor: (0, $6HKgG.DEFAULT_BACKGROUND_COLOR),
        contentWidth: (0, $6HKgG.DEFAULT_CONTENT_WIDTH)
    });

const $1438c18bb2760da6$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $6DWJW.messages).title);
        const description = intl.formatMessage((0, $6DWJW.messages).description);
        const parameters = $1438c18bb2760da6$var$sectionParameters(intl);
        const type = (0, $cNwLI.SECTION_EXTENSION_TYPE);
        const key = (0, $6HKgG.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $6DWJW.messages).contentHeader),
            subHeader: intl.formatMessage((0, $6DWJW.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $6DWJW.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>(parcelRequire("lkdwc")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, $l998X.jsx)(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)($1438c18bb2760da6$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };
module.exports["sectionExtensionProvider"] = $1438c18bb2760da6$export$6775abcfdb3b0453;

});

parcelRegister("6HKgG", function(module, exports) {
const $c274b9d16f8d5323$export$bc69bf23ec1f99d5 = 'hub-section';
const $c274b9d16f8d5323$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $c274b9d16f8d5323$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $c274b9d16f8d5323$export$6cccba5fae1d609d = "wide";
const $c274b9d16f8d5323$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";
module.exports["SECTION_EXTENSION_KEY"] = $c274b9d16f8d5323$export$bc69bf23ec1f99d5;
module.exports["SECTION_EXTENSION_ANALYTICS_SOURCE"] = $c274b9d16f8d5323$export$7a75cc6a69e05549;
module.exports["CONTENT_WIDTH"] = $c274b9d16f8d5323$export$3130b484681bf8bc;
module.exports["DEFAULT_CONTENT_WIDTH"] = $c274b9d16f8d5323$export$6cccba5fae1d609d;
module.exports["DEFAULT_BACKGROUND_COLOR"] = $c274b9d16f8d5323$export$617cdcc6afaae4f7;

});

parcelRegister("6DWJW", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $687c08afff3e5712$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "company-hub.section-extension.manifest.extension-title",
        defaultMessage: "Section [New]"
    },
    lozengeTitle: {
        id: "company-hub.section-extension.manifest.extension-lozenge-title",
        defaultMessage: "Section"
    },
    description: {
        id: "company-hub.section-extension.manifest.macro-description",
        defaultMessage: "Group elements together with a background"
    },
    contentHeader: {
        id: "company-hub.section-extension.manifest.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub.section-extension.manifest.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    placeHolderTitle: {
        id: "company-hub.section-extension.manifest.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});
module.exports["messages"] = $687c08afff3e5712$export$defe85febe8b728c;

});

parcelRegister("fC20J", function(module, exports) {

let $b5dbf6ea707bc215$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5dbf6ea707bc215$var$load("grbhN").then(()=>parcelRequire('5cloc'));

});

parcelRegister("lkdwc", function(module, exports) {

let $f865f3b2f1da87a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f865f3b2f1da87a2$var$load("jle6Z").then(()=>parcelRequire('iNP4c'));

});

parcelRegister("2baLD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");

var $cNwLI = parcelRequire("cNwLI");


var $iC0lV = parcelRequire("iC0lV");


var $95CeO = parcelRequire("95CeO");


const $07a2866bda8a4248$var$SpotlightExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "p5n9G",
    name: "SpotlightExtension",
    loader: async ()=>(await (parcelRequire("5zO8J"))).Spotlight,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "spotlight-extension-loader"
        })
});
const $07a2866bda8a4248$export$bc4319ada86b358d = ({ intl: intl, defaultParameters: defaultParameters })=>({
        extensionTitle: intl.formatMessage((0, $95CeO.i18n).title),
        height: (0, $4cOi8.Height).MEDIUM,
        backgroundColor: defaultParameters?.backgroundColor ?? "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
        cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
        content: {
            text: {
                title: intl.formatMessage((0, $95CeO.i18n).initialTitleParameter),
                description: intl.formatMessage((0, $95CeO.i18n).initialDescriptionParameter),
                textColor: defaultParameters?.textColor ?? "var(--ds-text, #292A2E)"
            },
            button: {
                isButtonShown: false,
                text: '',
                link: '',
                style: (0, $4cOi8.ButtonStyle).DEFAULT
            },
            image: {
                imageSrc: 'https://images.unsplash.com/photo-1527519135413-1e146b552e10?q=80&w=2940&auto=format',
                altText: intl.formatMessage((0, $95CeO.i18n).initialImageAltTextParameter)
            }
        }
    });

const $07a2866bda8a4248$export$10b21ce9d2029ff1 = async ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource, intl: intl })=>{
        const title = intl.formatMessage((0, $95CeO.i18n).titleNew);
        const description = intl.formatMessage((0, $95CeO.i18n).description);
        const type = (0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE);
        const render = async ()=>({ node: node })=>/*#__PURE__*/ (0, $l998X.jsx)($07a2866bda8a4248$var$SpotlightExtension, {
                    isInEditor: true,
                    contentId: contentId,
                    extensionNode: node,
                    PropsProvider: propsProvider
                });
        const icons = {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("lkdwc")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, $l998X.jsx)(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const parameters = $07a2866bda8a4248$export$bc4319ada86b358d({
            intl: intl,
            defaultParameters: defaultParameters
        });
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            // missing openConfigPanel and editorActions
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                key: (0, $iC0lV.SPOTLIGHT_EXTENSION_KEY),
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumSpotlightInsert'
            })
        ]);
    };
};
module.exports["spotlightParameters"] = $07a2866bda8a4248$export$bc4319ada86b358d;
module.exports["spotlightExtensionProvider"] = $07a2866bda8a4248$export$10b21ce9d2029ff1;

});

parcelRegister("iC0lV", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");


var $afjCM = parcelRequire("afjCM");

const $dadf278331e20e03$export$8434ce10552078fe = 'spotlight';
const $dadf278331e20e03$export$af1b061943ec63f0 = [
    {
        label: (0, $afjCM.i18n).splitDesignContentFirstLabel,
        description: (0, $afjCM.i18n).splitDesignContentFirstDescription,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        label: (0, $afjCM.i18n).splitDesignImageFirstLabel,
        description: (0, $afjCM.i18n).splitDesignImageFirstDescription,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        label: (0, $afjCM.i18n).solidColorBackgroundLabel,
        description: (0, $afjCM.i18n).solidColorBackgroundDescription,
        value: (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND
    },
    {
        label: (0, $afjCM.i18n).frameAboveImageLabel,
        description: (0, $afjCM.i18n).frameAboveImageDescription,
        value: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE
    }
];
module.exports["SPOTLIGHT_EXTENSION_KEY"] = $dadf278331e20e03$export$8434ce10552078fe;
module.exports["layoutOptions"] = $dadf278331e20e03$export$af1b061943ec63f0;

});

parcelRegister("afjCM", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $b0bda2c986a36858$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    splitDesignContentFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label",
        defaultMessage: "Split design (content first)"
    },
    splitDesignContentFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description",
        defaultMessage: "Large image on the right with lots of room for content"
    },
    splitDesignImageFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label",
        defaultMessage: "Split design (image first)"
    },
    splitDesignImageFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description",
        defaultMessage: "Large image on the left with lots of room for content"
    },
    solidColorBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    },
    solidColorBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description",
        defaultMessage: "Content in front of a full-width color"
    },
    frameAboveImageLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label",
        defaultMessage: "Content frame inside image"
    },
    frameAboveImageDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description",
        defaultMessage: "Text box overlay on a large image"
    },
    // We will eventually use these translations when full background layout is properly introduced
    imageBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label",
        defaultMessage: "Image background"
    },
    imageBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description",
        defaultMessage: "Full-size image behind your content"
    }
});
module.exports["i18n"] = $b0bda2c986a36858$export$a7357cdd1f0b0168;

});

parcelRegister("95CeO", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $819f7046fed5f31d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "company-hub.spotlight-extension.manifest.macro-title",
        defaultMessage: "Spotlight"
    },
    description: {
        id: "company-hub.spotlight-extension.manifest.macro-description",
        defaultMessage: "Highlight important messages with a visual spotlight."
    },
    titleNew: {
        id: "company-hub.spotlight-extension.manifest.macro-title.new",
        defaultMessage: "Spotlight [New]"
    },
    initialTitleParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-title",
        defaultMessage: "Give your spotlight a title"
    },
    initialDescriptionParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-description",
        defaultMessage: "Design a spotlight to highlight your most vital information. Bring the most important messages to life with custom colors, a powerful image, and flexible layouts."
    },
    initialImageAltTextParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.alt-image-text",
        defaultMessage: "Landscape photography of desert"
    }
});
module.exports["i18n"] = $819f7046fed5f31d$export$a7357cdd1f0b0168;

});

parcelRegister("5zO8J", function(module, exports) {

let $40f71d58b0516178$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40f71d58b0516178$var$load("hwLGf"),
    $40f71d58b0516178$var$load("eYere"),
    $40f71d58b0516178$var$load("at1W4"),
    $40f71d58b0516178$var$load("kWNlz"),
    $40f71d58b0516178$var$load("cHTTI"),
    $40f71d58b0516178$var$load("ePdWC"),
    $40f71d58b0516178$var$load("lBzRN"),
    $40f71d58b0516178$var$load("7whwt"),
    $40f71d58b0516178$var$load("dChec"),
    $40f71d58b0516178$var$load("2YffH"),
    $40f71d58b0516178$var$load("f35QR"),
    $40f71d58b0516178$var$load("eVYW1"),
    $40f71d58b0516178$var$load("ls0Um"),
    $40f71d58b0516178$var$load("020xd"),
    $40f71d58b0516178$var$load("eTBsW"),
    $40f71d58b0516178$var$load("bYxCZ"),
    $40f71d58b0516178$var$load("6HBYC"),
    $40f71d58b0516178$var$load("1oiJ6"),
    $40f71d58b0516178$var$load("huUvS"),
    $40f71d58b0516178$var$load("3RdRc"),
    $40f71d58b0516178$var$load("98UJI"),
    $40f71d58b0516178$var$load("b0cmi"),
    $40f71d58b0516178$var$load("51haJ"),
    $40f71d58b0516178$var$load("4cHGm"),
    $40f71d58b0516178$var$load("7f9Fz"),
    $40f71d58b0516178$var$load("9XYQ9"),
    $40f71d58b0516178$var$load("h4k4y"),
    $40f71d58b0516178$var$load("8bZKp"),
    $40f71d58b0516178$var$load("7RNcA"),
    $40f71d58b0516178$var$load("7jSfd"),
    $40f71d58b0516178$var$load("4HZlX"),
    $40f71d58b0516178$var$load("kDqHr"),
    $40f71d58b0516178$var$load("6wr18"),
    $40f71d58b0516178$var$load("kjZZD"),
    $40f71d58b0516178$var$load("dTsOE"),
    $40f71d58b0516178$var$load("hhss7"),
    $40f71d58b0516178$var$load("7EorR"),
    $40f71d58b0516178$var$load("5IgYU"),
    $40f71d58b0516178$var$load("Wowvf"),
    $40f71d58b0516178$var$load("ffEVr"),
    $40f71d58b0516178$var$load("bTmOC"),
    $40f71d58b0516178$var$load("lFZaH")
]).then(()=>parcelRequire('27Ekc'));

});

parcelRegister("aUwPP", function(module, exports) {

var $5psdk = parcelRequire("5psdk");


var $5abq6 = parcelRequire("5abq6");


var $b9lC3 = parcelRequire("b9lC3");


var $87fJd = parcelRequire("87fJd");

const $8f944f557ac62b40$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $5psdk.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $b9lC3.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $b9lC3.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $b9lC3.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $87fJd.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $8f944f557ac62b40$export$171e576bb7c729fa;

});

parcelRegister("b9lC3", function(module, exports) {

var $aU3dp = parcelRequire("aU3dp");

var $d925B = parcelRequire("d925B");


var $dhoHU = parcelRequire("dhoHU");


var $5abq6 = parcelRequire("5abq6");


var $kecXX = parcelRequire("kecXX");


var $by9bj = parcelRequire("by9bj");

const $a4290f7701cf1730$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $a4290f7701cf1730$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $dhoHU.toggleBlockMark)(indentation, getNewIndentationAttrs, $a4290f7701cf1730$export$54db194d337db321)(state, dispatch);
    };
}
function $a4290f7701cf1730$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $kecXX.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $a4290f7701cf1730$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $by9bj.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $a4290f7701cf1730$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getIndentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $a4290f7701cf1730$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getOutdentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $a4290f7701cf1730$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $dhoHU.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $a4290f7701cf1730$export$54db194d337db321;
module.exports["getIndentCommand"] = $a4290f7701cf1730$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $a4290f7701cf1730$export$620b2a1f10eb3a5f;

});

parcelRegister("kecXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4de3432317ffe3$export$2e2bcd8739ae039);
function $2d4de3432317ffe3$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("by9bj", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aU3dp = parcelRequire("aU3dp");

const $a44445544afb543f$var$indentTypes = {
    paragraph: (0, $aU3dp.INDENT_TYPE).PARAGRAPH,
    heading: (0, $aU3dp.INDENT_TYPE).HEADING
};
function $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $a44445544afb543f$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $a44445544afb543f$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $a44445544afb543f$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $a44445544afb543f$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $a44445544afb543f$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $a44445544afb543f$export$4f15b45384b61427;

});

parcelRegister("87fJd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $kTbzR = parcelRequire("kTbzR");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");


var $b9lC3 = parcelRequire("b9lC3");

function $e60d68c782a1a955$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $b9lC3.getIndentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.outdent)), (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $kTbzR.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $8m4tT.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
var $e60d68c782a1a955$export$2e2bcd8739ae039 = $e60d68c782a1a955$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $e60d68c782a1a955$export$e832373cff8dec22;

});

parcelRegister("axAnW", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $7e9dab50b8978c7c$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$7e9dab50b8978c7c$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};
module.exports["default"] = $7e9dab50b8978c7c$export$2e2bcd8739ae039;

});

parcelRegister("kkQZq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed290d22e560c9dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $hPd3F = parcelRequire("hPd3F");


var $7cTWR = parcelRequire("7cTWR");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $9A5yV = parcelRequire("9A5yV");

function $ed290d22e560c9dd$var$_defineProperty(e, r, t) {
    return (r = $ed290d22e560c9dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ed290d22e560c9dd$var$_toPropertyKey(t) {
    var i = $ed290d22e560c9dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ed290d22e560c9dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ed290d22e560c9dd$var$baselineUnit = "var(--ds-space-050, 4px)";
const $ed290d22e560c9dd$var$COLOR_N900 = '#091E42';
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $ed290d22e560c9dd$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$Image = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$ButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$BodyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1b66 _n3td1b66 _syazi7uo",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ed290d22e560c9dd$export$c7313f750e9cbc9d extends (0, $42omo.Component) {
    getPrimaryButton() {
        const { primaryAction: primaryAction, primaryText: primaryText } = this.props;
        return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
    getSecondaryButton() {
        const { secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
    getActionButton(appearance, onClick, action, text) {
        const type = action ? action.type : (0, $7cTWR.buttonActionTypes).DISMISS;
        switch(type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                {
                    const actionData = action.data;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                        href: actionData.url,
                        target: actionData.target,
                        appearance: appearance,
                        onClick: onClick
                    }, text);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    appearance: appearance,
                    onClick: onClick
                }, text);
        }
    }
    render() {
        const { children: children, title: title, imageSrc: imageSrc, imageAlt: imageAlt, body: body, position: position, order: order, secondaryText: secondaryText } = this.props;
        const messageContent = {
            image: null,
            title: null,
            body: null
        };
        if (title) // eslint-disable-next-line @atlaskit/design-system/use-heading
        messageContent.title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h4", {
            key: "title"
        }, title);
        if (imageSrc) messageContent.image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$Image, {
            key: "img",
            src: imageSrc,
            alt: imageAlt
        });
        messageContent.body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$BodyContainer, {
            key: "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
        const orderedContent = order.map((c)=>messageContent[c]);
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ContentContainer, null, orderedContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ButtonContainer, null, this.getPrimaryButton(), secondaryText ? this.getSecondaryButton() : null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hPd3F.default), {
            content: content,
            placement: position,
            isOpen: true
        }, children);
    }
    constructor(...args){
        super(...args);
        $ed290d22e560c9dd$var$_defineProperty(this, "onPrimaryClick", ()=>{
            this.props.fireClickEvent('primary');
        });
        $ed290d22e560c9dd$var$_defineProperty(this, "onSecondaryClick", ()=>{
            this.props.fireClickEvent('secondary');
        });
    }
}
$ed290d22e560c9dd$var$_defineProperty($ed290d22e560c9dd$export$c7313f750e9cbc9d, "defaultProps", {
    children: null,
    order: [
        'title',
        'image',
        'body'
    ],
    position: 'bottom left'
});
const $ed290d22e560c9dd$export$3660ec843fc5ef1b = (0, $3Npfo.default)($ed290d22e560c9dd$export$c7313f750e9cbc9d);
var $ed290d22e560c9dd$export$2e2bcd8739ae039 = (0, $k5HOq.default)($ed290d22e560c9dd$export$3660ec843fc5ef1b, 'inlineDialog');

});

parcelRegister("7cTWR", function(module, exports) {
const $31e3ef3c9b5f37b6$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $31e3ef3c9b5f37b6$export$e7d79186651244da;

});

parcelRegister("3Npfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $924fbb9a636b21af$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

var $924fbb9a636b21af$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $42omo.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $1DWH0.default)()(EngagementEventsWrapper);
};

});

parcelRegister("k5HOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47b6edde9367a4f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

var $e47b6edde9367a4f$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $42omo.useState)(null);
        const unsubscribeRef = (0, $42omo.useRef)(null);
        const removeConfigRef = (0, $42omo.useRef)(null);
        const canSubscribe = (0, $42omo.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $42omo.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $42omo.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $42omo.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $42omo.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $42omo.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $42omo.useRef)(engagementId);
        const previousMessageType = (0, $42omo.useRef)(messageType);
        const previousOnMessageDisposition = (0, $42omo.useRef)(onMessageDisposition);
        (0, $42omo.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("9A5yV", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $8cb2cd879eafccd1$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $8cb2cd879eafccd1$export$2e2bcd8739ae039;

});

parcelRegister("iPfZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EngagementSpotlight", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2Fndw = parcelRequire("2Fndw");


var $iiBJH = parcelRequire("iiBJH");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $8cBM8 = parcelRequire("8cBM8");

const $d1e26a6c07491d4a$var$SpotlightWithVariables = (0, $iiBJH.default)((0, $8cBM8.default));
const $d1e26a6c07491d4a$export$f57123e11f24bec9 = (0, $3Npfo.default)($d1e26a6c07491d4a$var$SpotlightWithVariables);
const $d1e26a6c07491d4a$var$SpotlightWithMessage = (0, $k5HOq.default)($d1e26a6c07491d4a$export$f57123e11f24bec9, 'spotlight');
function $d1e26a6c07491d4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1e26a6c07491d4a$var$SpotlightWithMessage, props));
}

});

parcelRegister("iiBJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfa45347111319c$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $3Sftg = parcelRequire("3Sftg");

function $3cfa45347111319c$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $42omo.Component) {
        render() {
            const props = $3cfa45347111319c$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $3cfa45347111319c$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3Sftg.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3Sftg", function(module, exports) {

var $g47C5 = parcelRequire("g47C5");

var $4xewT = parcelRequire("4xewT");

function $e4ebe363c373022b$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $e4ebe363c373022b$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4xewT.runTemplateForUrl)(input, variables) : (0, $4xewT.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $g47C5.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $e4ebe363c373022b$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $e4ebe363c373022b$export$d808999430a3f186;

});

parcelRegister("g47C5", function(module, exports) {
const $e428a4697dceb24e$export$e26f00bd90899835 = 'success';
const $e428a4697dceb24e$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $e428a4697dceb24e$export$edb46161045fece7;

});

parcelRegister("4xewT", function(module, exports) {

var $i0lyP = parcelRequire("i0lyP");


var $cpDxi = parcelRequire("cpDxi");


var $g47C5 = parcelRequire("g47C5");


var $cuEWu = parcelRequire("cuEWu");

function $ace38877ac0d85ab$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $i0lyP.default)(template);
    return (0, $cuEWu.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ace38877ac0d85ab$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForUrl)(epTemplate, variables);
}
function $ace38877ac0d85ab$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $ace38877ac0d85ab$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $ace38877ac0d85ab$export$5681b97796b74884;

});

parcelRegister("i0lyP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2be59bfe0ce0113$export$2e2bcd8739ae039);

var $bz2UO = parcelRequire("bz2UO");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $e2be59bfe0ce0113$var$UNESCAPED_MATCH = 1;
const $e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS = 2;
const $e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS = 5;
function $e2be59bfe0ce0113$export$2e2bcd8739ae039(template) {
    const parts = (0, $bz2UO.regexpParts)(template, $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("bz2UO", function(module, exports) {
function $78901a26ed98192e$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $78901a26ed98192e$export$b16d411b3b6d6dff;

});

parcelRegister("cpDxi", function(module, exports) {

var $cuEWu = parcelRequire("cuEWu");


var $48gB0 = parcelRequire("48gB0");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $9d422126fe4600e0$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $cuEWu.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $9d422126fe4600e0$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForUrl(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForHtml(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, (0, $48gB0.default));
}
function $9d422126fe4600e0$export$d10ae881b12b8ef2(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForUrl);
}
function $9d422126fe4600e0$export$ca536300dbd6350(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $9d422126fe4600e0$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $9d422126fe4600e0$export$ca536300dbd6350;

});

parcelRegister("cuEWu", function(module, exports) {

var $1rjmQ = parcelRequire("1rjmQ");

function $5e0333abe2221126$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $5e0333abe2221126$export$4a33186abb06007b(template) {
    const variableParts = $5e0333abe2221126$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $1rjmQ.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $5e0333abe2221126$export$4a33186abb06007b;

});

parcelRegister("1rjmQ", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $56c35590cbe5b17a$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $56c35590cbe5b17a$export$c150c7c1a29f33d8;

});

parcelRegister("48gB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d527f6527719db2$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $8d527f6527719db2$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("8cBM8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $5RBJ9 = parcelRequire("5RBJ9");


var $7cTWR = parcelRequire("7cTWR");


var $9A5yV = parcelRequire("9A5yV");

class $86110ead6fe3e8af$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
    }
}
$86110ead6fe3e8af$export$2e2bcd8739ae039.defaultProps = {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
};
module.exports["default"] = $86110ead6fe3e8af$export$2e2bcd8739ae039;

});

parcelRegister("hwWwS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9b64448510e1eff4$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $42omo.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};
module.exports["useCoordination"] = $9b64448510e1eff4$export$3c29cca421979b0e;

});

parcelRegister("aVKfT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "93O33",
    name: "ForgeGlobalSettingsExtensionPoint",
    loader: async ()=>(await (parcelRequire("lpZOV"))).GlobalSettings
});
module.exports["ForgeGlobalSettingsExtensionPoint"] = $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4;

});

parcelRegister("lpZOV", function(module, exports) {

let $f97be30068de8f49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f97be30068de8f49$var$load("lPQcc"),
    $f97be30068de8f49$var$load("c6fAG")
]).then(()=>parcelRequire('jOztW'));

});

parcelRegister("jOXb3", function(module, exports) {

let $e6e09734dc28cb91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6e09734dc28cb91$var$load("iVLHX").then(()=>parcelRequire('7DYe9'));

});

parcelRegister("aF1vZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47940fef216e9562$export$2709da4acd7d0aec = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Q3Ruy",
    name: "AdvancedSearch",
    loader: async ()=>(await (parcelRequire("De1ch"))).AdvancedSearch
});
module.exports["AdvancedSearch"] = $47940fef216e9562$export$2709da4acd7d0aec;

});

parcelRegister("De1ch", function(module, exports) {

let $075e846096183c21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $075e846096183c21$var$load("7Omhy"),
    $075e846096183c21$var$load("8JZKd"),
    $075e846096183c21$var$load("2YffH"),
    $075e846096183c21$var$load("lmJFL"),
    $075e846096183c21$var$load("2F69B"),
    $075e846096183c21$var$load("1Jsgt"),
    $075e846096183c21$var$load("6mHrv"),
    $075e846096183c21$var$load("dhAgF"),
    $075e846096183c21$var$load("8xqKm"),
    $075e846096183c21$var$load("bAXKU"),
    $075e846096183c21$var$load("tKhaz"),
    $075e846096183c21$var$load("7RXky"),
    $075e846096183c21$var$load("fkeSV"),
    $075e846096183c21$var$load("h9Ed7"),
    $075e846096183c21$var$load("9A0ig"),
    $075e846096183c21$var$load("90kvt"),
    $075e846096183c21$var$load("eYere"),
    $075e846096183c21$var$load("at1W4"),
    $075e846096183c21$var$load("fSV9f"),
    $075e846096183c21$var$load("4eboO"),
    $075e846096183c21$var$load("8YSo7"),
    $075e846096183c21$var$load("gLGsg"),
    $075e846096183c21$var$load("9XYQ9"),
    $075e846096183c21$var$load("kiGNy"),
    $075e846096183c21$var$load("2Cftu"),
    $075e846096183c21$var$load("4i0CB"),
    $075e846096183c21$var$load("fTFcV"),
    $075e846096183c21$var$load("hv4mn"),
    $075e846096183c21$var$load("kjZZD"),
    $075e846096183c21$var$load("kWNlz"),
    $075e846096183c21$var$load("cHTTI"),
    $075e846096183c21$var$load("37ldp"),
    $075e846096183c21$var$load("jkPqm"),
    $075e846096183c21$var$load("dTsOE"),
    $075e846096183c21$var$load("awqCy"),
    $075e846096183c21$var$load("6wr18"),
    $075e846096183c21$var$load("cyGuT"),
    $075e846096183c21$var$load("ePdWC"),
    $075e846096183c21$var$load("lBzRN"),
    $075e846096183c21$var$load("9wxKg"),
    $075e846096183c21$var$load("Wowvf"),
    $075e846096183c21$var$load("6O8m6"),
    $075e846096183c21$var$load("5GxU8"),
    $075e846096183c21$var$load("amUNi"),
    $075e846096183c21$var$load("7whwt"),
    $075e846096183c21$var$load("8Gekp"),
    $075e846096183c21$var$load("7e13v"),
    $075e846096183c21$var$load("699ae"),
    $075e846096183c21$var$load("i7QCq"),
    $075e846096183c21$var$load("let0D"),
    $075e846096183c21$var$load("87NBA"),
    $075e846096183c21$var$load("ffEVr"),
    $075e846096183c21$var$load("kUbUu"),
    $075e846096183c21$var$load("hhss7"),
    $075e846096183c21$var$load("7EorR"),
    $075e846096183c21$var$load("mK22p")
]).then(()=>parcelRequire('luNAU'));

});

parcelRegister("9qbTD", function(module, exports) {

let $6dbfc51e8e51e615$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dbfc51e8e51e615$var$load("hDfPU").then(()=>parcelRequire('2mD8T'));

});

parcelRegister("kb9X9", function(module, exports) {

var $7i418 = parcelRequire("7i418");


var $AoYlq = parcelRequire("AoYlq");


var $d6TaN = parcelRequire("d6TaN");


var $6g1oe = parcelRequire("6g1oe");

const $eb0c8e33e0268c1c$export$d17bd3fb4432c2eb = (a, b)=>{
    // lodash reduce can reduce over objects, not just arrays
    /* istanbul ignore next */ const results = (0, (/*@__PURE__*/$parcel$interopDefault($7i418)))(a, (result, value, key)=>value === b[key] ? result : result.concat([
            `Prop name: '${key}'`,
            '1:',
            value,
            '2:',
            b[key]
        ], '=========='), []);
    /* istanbul ignore next */ if (!results || results.length === 0) return 'No change!';
    return results;
};
const $eb0c8e33e0268c1c$export$2225b4c39d37f8b3 = (obj1, obj2, omitProps = [])=>{
    if (obj1 === obj2) return true;
    const allKeys = (0, (/*@__PURE__*/$parcel$interopDefault($AoYlq)))((0, (/*@__PURE__*/$parcel$interopDefault($d6TaN)))(obj1), (0, (/*@__PURE__*/$parcel$interopDefault($d6TaN)))(obj2));
    for (const key of allKeys){
        if (omitProps.indexOf(key) >= 0) continue;
        if (obj1[key] !== obj2[key]) return false;
    }
    return true;
};
const $eb0c8e33e0268c1c$export$e3a9c512dde3781c = (name)=>{};
const $eb0c8e33e0268c1c$export$1b1e26e4583cf9d2 = (names)=>{
    var name;
};
const $eb0c8e33e0268c1c$export$948fe58907adae7d = (markA, markB)=>{
    return 'N/A';
};
const $eb0c8e33e0268c1c$export$76909ea6fcdbea03 = (name, markA, markB)=>{};
const $eb0c8e33e0268c1c$export$34e34130f1d9d12c = (mark)=>{
    return 'N/A';
};
const $eb0c8e33e0268c1c$export$a1e5925b5910cb4 = (mark)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance.mark(mark);
};
module.exports["performanceMarkInProd"] = $eb0c8e33e0268c1c$export$a1e5925b5910cb4;

});

parcelRegister("7i418", function(module, exports) {

var $52wl7 = parcelRequire("52wl7");


var $iawSg = parcelRequire("iawSg");


var $hWvFC = parcelRequire("hWvFC");


var $8ehsp = parcelRequire("8ehsp");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $54ed5492bda67974$var$reduce(collection, iteratee, accumulator) {
    var func = $fZxmY(collection) ? $52wl7 : $8ehsp, initAccum = arguments.length < 3;
    return func(collection, $hWvFC(iteratee, 4), accumulator, initAccum, $iawSg);
}
module.exports = $54ed5492bda67974$var$reduce;

});

parcelRegister("8ehsp", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5fdd2c2f38667b48$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5fdd2c2f38667b48$var$baseReduce;

});

parcelRegister("AoYlq", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");


var $9JSQw = parcelRequire("9JSQw");


var $ghltV = parcelRequire("ghltV");


var $bVtKl = parcelRequire("bVtKl");

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $06d6bbe2d946d3b0$var$union = $9JSQw(function(arrays) {
    return $ghltV($8jC8i(arrays, 1, $bVtKl, true));
});
module.exports = $06d6bbe2d946d3b0$var$union;

});

parcelRegister("7X6Jc", function(module, exports) {

let $5ca343298d4a1b05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5ca343298d4a1b05$var$load("1c1XO"),
    $5ca343298d4a1b05$var$load("dMWJp")
]).then(()=>parcelRequire('eTW2b'));

});

parcelRegister("9Ouxr", function(module, exports) {

let $725078da8edb46cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $725078da8edb46cd$var$load("7u5Uq"),
    $725078da8edb46cd$var$load("9A0ig"),
    $725078da8edb46cd$var$load("fTFcV"),
    $725078da8edb46cd$var$load("8Uu6s"),
    $725078da8edb46cd$var$load("gwtBH"),
    $725078da8edb46cd$var$load("fT09S"),
    $725078da8edb46cd$var$load("2cLQd"),
    $725078da8edb46cd$var$load("kBLPG"),
    $725078da8edb46cd$var$load("7whwt"),
    $725078da8edb46cd$var$load("6wr18"),
    $725078da8edb46cd$var$load("9PQXU"),
    $725078da8edb46cd$var$load("let0D"),
    $725078da8edb46cd$var$load("k0WnS"),
    $725078da8edb46cd$var$load("kTdzk"),
    $725078da8edb46cd$var$load("igHL0"),
    $725078da8edb46cd$var$load("4tiwv"),
    $725078da8edb46cd$var$load("dlm6q"),
    $725078da8edb46cd$var$load("hWZz2"),
    $725078da8edb46cd$var$load("c4vbc"),
    $725078da8edb46cd$var$load("7ZBIQ"),
    $725078da8edb46cd$var$load("5coOi"),
    $725078da8edb46cd$var$load("9ZkgN"),
    $725078da8edb46cd$var$load("P2OWY"),
    $725078da8edb46cd$var$load("7A5zJ"),
    $725078da8edb46cd$var$load("4XFRu"),
    $725078da8edb46cd$var$load("3gnID"),
    $725078da8edb46cd$var$load("4VOW6"),
    $725078da8edb46cd$var$load("g5HUX"),
    $725078da8edb46cd$var$load("a0ybh"),
    $725078da8edb46cd$var$load("h2QhJ"),
    $725078da8edb46cd$var$load("gLGsg"),
    $725078da8edb46cd$var$load("fwmQF"),
    $725078da8edb46cd$var$load("eeaKR"),
    $725078da8edb46cd$var$load("9sJzT"),
    $725078da8edb46cd$var$load("2F69B"),
    $725078da8edb46cd$var$load("6XCf4"),
    $725078da8edb46cd$var$load("hhss7"),
    $725078da8edb46cd$var$load("5pvpJ"),
    $725078da8edb46cd$var$load("1qlDN"),
    $725078da8edb46cd$var$load("1yVM6"),
    $725078da8edb46cd$var$load("ffEVr"),
    $725078da8edb46cd$var$load("5rfwb")
]).then(()=>parcelRequire('bUMKD'));

});

parcelRegister("7lrfj", function(module, exports) {

let $558fa1074ff5f10f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $558fa1074ff5f10f$var$load("amygy").then(()=>parcelRequire('iMfxO'));

});

parcelRegister("3oadb", function(module, exports) {

let $277b88cb36ea249a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $277b88cb36ea249a$var$load("9sJzT"),
    $277b88cb36ea249a$var$load("6XCf4"),
    $277b88cb36ea249a$var$load("fqGSw"),
    $277b88cb36ea249a$var$load("6wr18"),
    $277b88cb36ea249a$var$load("8Q6ef"),
    $277b88cb36ea249a$var$load("coJiW"),
    $277b88cb36ea249a$var$load("h4Nf7"),
    $277b88cb36ea249a$var$load("gryT8"),
    $277b88cb36ea249a$var$load("5uN9h"),
    $277b88cb36ea249a$var$load("2Cftu"),
    $277b88cb36ea249a$var$load("4i0CB"),
    $277b88cb36ea249a$var$load("awqCy"),
    $277b88cb36ea249a$var$load("4g2Mj"),
    $277b88cb36ea249a$var$load("7EorR"),
    $277b88cb36ea249a$var$load("ffEVr"),
    $277b88cb36ea249a$var$load("kUbUu"),
    $277b88cb36ea249a$var$load("hhss7"),
    $277b88cb36ea249a$var$load("9ftJe"),
    $277b88cb36ea249a$var$load("hA2SB"),
    $277b88cb36ea249a$var$load("5pvpJ"),
    $277b88cb36ea249a$var$load("1qlDN"),
    $277b88cb36ea249a$var$load("1yVM6"),
    $277b88cb36ea249a$var$load("6ExNy")
]).then(()=>parcelRequire('iIJIO'));

});

parcelRegister("ayyKy", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $1NBp8 = parcelRequire("1NBp8");


var $ge2sX = parcelRequire("ge2sX");


var $d9tcB = parcelRequire("d9tcB");

function $5340377d047d37c6$export$3c0681f7b17941c4(routeMatch) {
    if (routeMatch?.name === (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name || routeMatch?.name === (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && // Hub Dashboard aka Consolidated Settings (https://hello.atlassian.net/wiki/spaces/CLI/pages/4111377280/Project+Poster+Hub+Dashboard) uses /admin/permissions/hub without the tab param and doesn't use the site admin nav there:
    routeMatch?.params?.tab) {
        // https://hello.atlassian.net/wiki/spaces/~701217e532d6bdc7846948a0f4e8afe31a122/pages/3993181421/Company+Hub+-+Beta+Tag+Removal
        // documents the product and design folks of Company Hub want Hub permissions to be among the site admin screens of the product,
        // specifically next to permissions-related screens such as Global permissions, Space permissions, Analytics permissions, etc in
        // the Security section.
        const sessionData = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)());
        // But for non-site admins the site admin side nav is pretty much empty and, more importantly, there are no other
        // permissions-related screens there. Then Hub permissions in the site admin side nav can only make sense to site admins.
        if (sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS) return true;
    }
    return false;
}
module.exports["getCompanyHubSideNav"] = $5340377d047d37c6$export$3c0681f7b17941c4;

});

parcelRegister("agglT", function(module, exports) {
var $585d52ec7db54bb4$export$e0a694ad492b37fe = /*#__PURE__*/ function(CompanyHubSettingsPageTabsType) {
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["GENERAL"] = 0] = "GENERAL";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["ANALYTICS"] = 1] = "ANALYTICS";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["USERS"] = 2] = "USERS";
    return CompanyHubSettingsPageTabsType;
}({});
module.exports["CompanyHubSettingsPageTabsType"] = $585d52ec7db54bb4$export$e0a694ad492b37fe;

});

parcelRegister("8aYco", function(module, exports) {

let $5f3df4292c2f3993$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f3df4292c2f3993$var$load("gialu"),
    $5f3df4292c2f3993$var$load("gLGsg"),
    $5f3df4292c2f3993$var$load("3DC6Y"),
    $5f3df4292c2f3993$var$load("kJDIu"),
    $5f3df4292c2f3993$var$load("4UClM"),
    $5f3df4292c2f3993$var$load("lQZYM"),
    $5f3df4292c2f3993$var$load("a4mwL"),
    $5f3df4292c2f3993$var$load("eNZNF"),
    $5f3df4292c2f3993$var$load("2Mq3f"),
    $5f3df4292c2f3993$var$load("5uN9h"),
    $5f3df4292c2f3993$var$load("3kUQf"),
    $5f3df4292c2f3993$var$load("1fLz7")
]).then(()=>parcelRequire('eBAks'));

});

parcelRegister("iquRY", function(module, exports) {

var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        variables: {
            cloudId: cloudId
        },
        onError: (error)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== 'PRE_ROLES' : false;
    return {
        spaceRoleMode: data?.confluence_spaceRoleMode,
        isRbacEnabled: isNotPreRoles,
        loading: loading
    };
};
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("iGLU4", function(module, exports) {

let $d9b14ede7e11d8bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d9b14ede7e11d8bd$var$load("6wr18"),
    $d9b14ede7e11d8bd$var$load("ll4CQ"),
    $d9b14ede7e11d8bd$var$load("4aB7p"),
    $d9b14ede7e11d8bd$var$load("6CBhM"),
    $d9b14ede7e11d8bd$var$load("dXF2m"),
    $d9b14ede7e11d8bd$var$load("6pZc8"),
    $d9b14ede7e11d8bd$var$load("gialu"),
    $d9b14ede7e11d8bd$var$load("4CfTY"),
    $d9b14ede7e11d8bd$var$load("gctwz"),
    $d9b14ede7e11d8bd$var$load("4drdS"),
    $d9b14ede7e11d8bd$var$load("ffEVr"),
    $d9b14ede7e11d8bd$var$load("9sJzT"),
    $d9b14ede7e11d8bd$var$load("6XCf4"),
    $d9b14ede7e11d8bd$var$load("6xN9r"),
    $d9b14ede7e11d8bd$var$load("iQ0Jm"),
    $d9b14ede7e11d8bd$var$load("jle6Z"),
    $d9b14ede7e11d8bd$var$load("gtMen"),
    $d9b14ede7e11d8bd$var$load("8SLfD"),
    $d9b14ede7e11d8bd$var$load("7EorR"),
    $d9b14ede7e11d8bd$var$load("5pvpJ"),
    $d9b14ede7e11d8bd$var$load("1qlDN"),
    $d9b14ede7e11d8bd$var$load("1yVM6"),
    $d9b14ede7e11d8bd$var$load("7DSUW")
]).then(()=>parcelRequire('54mQG'));

});

parcelRegister("k3h41", function(module, exports) {

let $e99153015c4ceba0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e99153015c4ceba0$var$load("gialu"),
    $e99153015c4ceba0$var$load("5LAxC"),
    $e99153015c4ceba0$var$load("ll4CQ"),
    $e99153015c4ceba0$var$load("YlVRj"),
    $e99153015c4ceba0$var$load("1kY5y"),
    $e99153015c4ceba0$var$load("e1z0Z"),
    $e99153015c4ceba0$var$load("QcHuP"),
    $e99153015c4ceba0$var$load("9sJzT"),
    $e99153015c4ceba0$var$load("6XCf4"),
    $e99153015c4ceba0$var$load("5pvpJ"),
    $e99153015c4ceba0$var$load("hhss7"),
    $e99153015c4ceba0$var$load("bU3dV"),
    $e99153015c4ceba0$var$load("1qlDN"),
    $e99153015c4ceba0$var$load("1yVM6"),
    $e99153015c4ceba0$var$load("96X3r")
]).then(()=>parcelRequire('9FcLT'));

});

parcelRegister("gpuqf", function(module, exports) {

let $bf2694683709fd12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf2694683709fd12$var$load("2Mq3f"),
    $bf2694683709fd12$var$load("7EorR"),
    $bf2694683709fd12$var$load("5ZaO3")
]).then(()=>parcelRequire('dpLKi'));

});

parcelRegister("6V55f", function(module, exports) {

let $509c0271e6072601$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $509c0271e6072601$var$load("iIfud").then(()=>parcelRequire('fi3dY'));

});

parcelRegister("aDv5i", function(module, exports) {

let $7be5a8a2d4efb9db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7be5a8a2d4efb9db$var$load("8Q6ef"),
    $7be5a8a2d4efb9db$var$load("5uN9h"),
    $7be5a8a2d4efb9db$var$load("7EorR"),
    $7be5a8a2d4efb9db$var$load("4uUio")
]).then(()=>parcelRequire('ayZRr'));

});

parcelRegister("b1pD4", function(module, exports) {
$parcel$export(module.exports, "CommentsSectionLoader", () => (parcelRequire("3ACqI")).CommentsSectionLoader);

var $3ACqI = parcelRequire("3ACqI");


});

parcelRegister("3ACqI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $hnvzE = parcelRequire("hnvzE");


var $7d2Nc = parcelRequire("7d2Nc");


var $eHtji = parcelRequire("eHtji");


var $jmjWc = parcelRequire("jmjWc");


var $deTj5 = parcelRequire("deTj5");


var $6Hogt = parcelRequire("6Hogt");


var $2YUV8 = parcelRequire("2YUV8");


var $dDqLo = parcelRequire("dDqLo");


var $3Am3T = parcelRequire("3Am3T");


var $bQm3c = parcelRequire("bQm3c");


var $dkkKv = parcelRequire("dkkKv");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


const $bab3bd054370fc67$export$a378d01c696bd81e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZ3wU",
    name: "CommentsSectionFabric",
    // eslint-disable-next-line react/prop-types
    //@ts-ignore
    loading: ({ handlePageCommentsRender: handlePageCommentsRender })=>{
        return !handlePageCommentsRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), null) : null;
    },
    loader: ()=>//@ts-ignore
        (parcelRequire("kKD1g"))
});

const $bab3bd054370fc67$export$4740f0dffd11e693 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y3qpe",
    name: "CommentsSectionFabricPaint",
    loader: ()=>//@ts-ignore
        (parcelRequire("kKD1g"))
});
const $bab3bd054370fc67$export$2fa3aacacd7711f1 = ({ contentId: contentId, ...props })=>{
    // This information is available in the CommentsCountContext, but it also needs to be available to the legacy class
    // component so passing in directly from the hook as well
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $dDqLo.useCommentCounts)(contentId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const allowNestedComments = (0, $2YUV8.useAllowNestedComments)();
    const commentsDataActions = (0, $8i27m.useCommentsDataActions)();
    const { refetch: refetchActiveComments } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId
    });
    const { refetch: refetchActiveInlineComments } = (0, $7Oxky.useActiveInlineCommentsQuery)({
        pageId: contentId,
        markerRefList: []
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "page-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC),
        isCustomStart: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eHtji.PageSegmentLoadMark), {
        markName: "pageCommentsRenderStart",
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC)
    }), (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$4740f0dffd11e693, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$a378d01c696bd81e, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }))));
};
$bab3bd054370fc67$export$2fa3aacacd7711f1.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
};
module.exports["CommentsSectionLoader"] = $bab3bd054370fc67$export$2fa3aacacd7711f1;

});

parcelRegister("7d2Nc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $c2bdb1677e0a2d6c$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("deTj5", function(module, exports) {
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlia51 _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _1bsb1osq _4t3i1ylp _syaz1rpy _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkizff",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk1j28 _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if ((0, window.__SSR_RENDERED__) || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};
module.exports["CommentPlaceholder"] = $c27f350b69a05b43$export$46096a93b7c122b2;

});

parcelRegister("6Hogt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});
module.exports["PAGE_COMMENTS_METRIC"] = $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["RECAP_MODAL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$fdd1a35fb559480a;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("2YUV8", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");

const $d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery = (0, $eSUdr.default)`query useAllowNestedCommentsDetailsPanelContentCreatedDateQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id metadata{createdDate}}}}`;
const $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE = new Date(Date.UTC(2025, 2, 6)); // 6th March 2025. Only month is 0 indexed.
const $d2978a0663607f28$export$3044701888c6e050 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: createdDateData, loading: loading, error: error } = (0, $xQxzY.useQuery)($d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: 'current'
        },
        skip: !contentId
    });
    // If the feature flag is not enabled, we should always allow nested comments
    if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return true;
    const pageCreatedDate = createdDateData?.content?.nodes?.[0]?.metadata.createdDate;
    const isLivePage = pageMode === (0, $cD1qu.PageMode).LIVE;
    if (loading || error || !pageCreatedDate) return false;
    const pageCreateDateObject = new Date(pageCreatedDate);
    const isBeforeLaunchDate = pageCreateDateObject < $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE;
    return isBeforeLaunchDate && !isLivePage;
};
module.exports["useAllowNestedComments"] = $d2978a0663607f28$export$3044701888c6e050;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $6mKj3 = parcelRequire("6mKj3");


var $f5Wgm = parcelRequire("f5Wgm");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New implementation using ActiveCommentsQuery
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentsType.INLINE and CommentsType.FOOTER)
        skip: !(0, $6mKj3.expValEquals)('confluence_comment_use_active_comment_query_exp', 'isEnabled', true) || !contentId
    });
    return (0, $42omo.useMemo)(()=>{
        if (allCommentsData?.comments?.nodes && (0, $6mKj3.expValEquals)('confluence_comment_use_active_comment_query_exp', 'isEnabled', true)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === (0, $f5Wgm.CommentType).INLINE).length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === (0, $f5Wgm.CommentType).FOOTER).length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("dkkKv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fHAwL = parcelRequire("fHAwL");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $aUU0C = parcelRequire("aUU0C");


var $9rE3H = parcelRequire("9rE3H");


var $eg9xl = parcelRequire("eg9xl");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $7c240d799ee287c0$export$1369688a638bab5e = ({ pageId: pageId, skip: skip = false, type: type, onCompletedFn: onCompletedFn, returnNativeLoading: returnNativeLoading = false, useStableCommentsDataUpdates: useStableCommentsDataUpdates = false, fetchPolicy: fetchPolicy, isPreload: isPreload = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, setFooterCommentsLoadingState: setFooterCommentsLoadingState }] = (0, $8i27m.useCommentsData)();
    const [{ readCommentsListState: readCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const annotationsInEditorDoc = (0, $42omo.useMemo)(()=>{
        return new Set(annotations);
    }, [
        annotations
    ]);
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Using preload variables isn't 100% necessary since we write to the full cache,
    // but should be more stable in the event the full cache update fails
    const queryVariables = isPreload ? (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(pageId, isArchived) : (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
        pageId: pageId,
        type: type,
        isArchived: isArchived
    });
    const cacheUpdateFailedFetchPolicy = cacheUpdateFailed && (0, $9wGTI.fg)('confluence_comment_donot_use_cache') ? 'network-only' : undefined;
    const defaultFetchPolicy = skipQuery || isPreload ? 'cache-only' : 'cache-and-network'; // TODO: Cache and network probably not perfect, used to ensure consistency on the panel
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $eg9xl.ActiveCommentsQuery), {
        variables: queryVariables,
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: fetchPolicy || cacheUpdateFailedFetchPolicy || defaultFetchPolicy,
        skip: skipQuery,
        onCompleted: (result)=>{
            // onCompleted doesn't fire as expected after multiple cache reads
            if (!useStableCommentsDataUpdates && result) {
                (0, $3ZsvI.updateCommentsDataState)({
                    data: result,
                    readCommentsListState: readCommentsListState,
                    updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                    annotationsInEditorDoc: annotationsInEditorDoc,
                    pageMode: pageMode,
                    currentUserId: currentUserId ?? '',
                    isOpen: true
                });
                if (!skipQuery) // Don't update loading state if the query is skipped
                // onCompleted will still get called in some circumstances with skip = true
                (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
            }
            setLoading(false);
            if (result) onCompletedFn && onCompletedFn();
        },
        onError: undefined,
        errorPolicy: 'all'
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            setLoading(false);
        }
    }, [
        error
    ]);
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    let returnLoading = queryLoading;
    // If we're not returning the native loading out of apollo, update returnLoading to our tracked version
    if (!returnNativeLoading) returnLoading = !skipQuery ? loading : false;
    // We set totalCount to ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG when preload is loading
    // We should respect this regardless of context, since the query really is loading behind the scenes
    const isPreloadLoading = data?.comments?.totalCount === (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG);
    returnLoading = isPreloadLoading || returnLoading;
    (0, $42omo.useEffect)(()=>{
        // onCompleted gets fired on the first cache-read only, which as you can imagine causes a lot of race conditions during transition
        // This is the recommended way to deal with complex scenarios involving cache + network reads
        // onCompleted will also fire incorrectly for concurrent calls on the same page, since it has an outdated copy of hasAlreadyFetchedInitialData telescoped in before some calls complete
        if (!skipQuery && isPreloadLoading) // Mark this as preloading to prevent race conditions where loading is not yet set in caller
        setFooterCommentsLoadingState((0, $8i27m.FooterCommentsLoadingStateType).PRELOADING);
        if (useStableCommentsDataUpdates && !isPreloadLoading && !skipQuery && data) {
            // Preload updates data, which we don't want
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                readCommentsListState: readCommentsListState,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            // Don't update loading state if the query is skipped
            (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
        }
    }, [
        data,
        useStableCommentsDataUpdates,
        hasAlreadyFetchedInitialData,
        addNewCommentThreads,
        setCommentsDataMap,
        annotationsInEditorDoc,
        pageMode,
        currentUserId,
        readCommentsListState,
        skipQuery,
        type,
        setFooterCommentsLoadingState,
        isPreloadLoading
    ]);
    return {
        loading: returnLoading,
        data: data,
        error: error,
        refetch: refetch
    };
};
module.exports["useActiveCommentsQuery"] = $7c240d799ee287c0$export$1369688a638bab5e;

});

parcelRegister("aUU0C", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $1P1Tu.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $9zUhf.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $9zUhf.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("aPT9H", function(module, exports) {
/**
 * @graphql cc
 */ 
var $j1Ss3 = parcelRequire("j1Ss3");


var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $l5y3Y = parcelRequire("l5y3Y");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || !contentId
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query')) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("ftXPY", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $eSUdr.default)`query CommentsSectionQuery($offset:String$first:Long$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $eSUdr.default)`query CommentsSectionWithoutReactionsQuery($offset:String$first:Long$contentId:ID!){comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("l5y3Y", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $eSLr0 = parcelRequire("eSLr0");


var $8pvtc = parcelRequire("8pvtc");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8pvtc.WebPanelLocationQuery), {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        fetchPolicy: 'cache-first',
        skip: isPDFExport
    });
    return !isPDFExport && data && data.webPanels && data.webPanels.length > 0;
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("8pvtc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ac1e927e530cb686$export$d97dfe528d83a912 = (0, $eSUdr.default)`query WebPanelLocationQuery($location:String$contentId:ID$spaceKey:String){webPanels(location:$location contentId:$contentId key:$spaceKey){moduleKey completeKey html location label weight name}}`;
module.exports["WebPanelLocationQuery"] = $ac1e927e530cb686$export$d97dfe528d83a912;

});

parcelRegister("3Am3T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("7Oxky", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $fHAwL = parcelRequire("fHAwL");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $eSUdr.default)`query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList pageId:$pageId contentStatus:$contentStatus){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}createdAt{value}createdAtNonLocalized replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`;
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const [{ readCommentsListState: readCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const annotationsInEditorDoc = (0, $42omo.useMemo)(()=>{
        return new Set(annotations);
    }, [
        annotations
    ]);
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                readCommentsListState: readCommentsListState,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;
module.exports["useActiveInlineCommentsQuery"] = $9d95853344936385$export$6ddede7674b6d70f;

});

parcelRegister("kKD1g", function(module, exports) {

let $f1b65ef7189359b2$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $f1b65ef7189359b2$var$load("1Jgsw"),
    $f1b65ef7189359b2$var$load("duPDN"),
    $f1b65ef7189359b2$var$load("70qyO"),
    $f1b65ef7189359b2$var$load("gYeBT"),
    $f1b65ef7189359b2$var$load("fwmQF"),
    $f1b65ef7189359b2$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("1YwJ8"), 5)),
    $f1b65ef7189359b2$var$load("i0ttV"),
    $f1b65ef7189359b2$var$load("bAXKU"),
    $f1b65ef7189359b2$var$load("1c1XO"),
    $f1b65ef7189359b2$var$load("9Z7qK"),
    $f1b65ef7189359b2$var$load("gLGsg"),
    $f1b65ef7189359b2$var$load("ffEVr"),
    $f1b65ef7189359b2$var$load("8Gekp"),
    $f1b65ef7189359b2$var$load("2zqtv")
]).then(()=>parcelRequire('kXPQu'));

});

parcelRegister("7d2cw", function(module, exports) {

let $53fb745b66972d5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $53fb745b66972d5e$var$load("6lgEW"),
    $53fb745b66972d5e$var$load("8Uu6s"),
    $53fb745b66972d5e$var$load("2cLQd"),
    $53fb745b66972d5e$var$load("kBLPG"),
    $53fb745b66972d5e$var$load("5HTaY"),
    $53fb745b66972d5e$var$load("4tiwv"),
    $53fb745b66972d5e$var$load("dlm6q"),
    $53fb745b66972d5e$var$load("7u5Uq"),
    $53fb745b66972d5e$var$load("7ZBIQ"),
    $53fb745b66972d5e$var$load("3yM79"),
    $53fb745b66972d5e$var$load("5coOi"),
    $53fb745b66972d5e$var$load("9ZkgN"),
    $53fb745b66972d5e$var$load("P2OWY"),
    $53fb745b66972d5e$var$load("4XFRu"),
    $53fb745b66972d5e$var$load("jvBnQ"),
    $53fb745b66972d5e$var$load("gpfoY"),
    $53fb745b66972d5e$var$load("9VvWo"),
    $53fb745b66972d5e$var$load("bAXKU"),
    $53fb745b66972d5e$var$load("9Z7qK"),
    $53fb745b66972d5e$var$load("duPDN"),
    $53fb745b66972d5e$var$load("70qyO"),
    $53fb745b66972d5e$var$load("gYeBT"),
    $53fb745b66972d5e$var$load("9jS5g"),
    $53fb745b66972d5e$var$load("gLGsg"),
    $53fb745b66972d5e$var$load("fwmQF"),
    $53fb745b66972d5e$var$load("2F69B"),
    $53fb745b66972d5e$var$load("ePdWC"),
    $53fb745b66972d5e$var$load("lBzRN"),
    $53fb745b66972d5e$var$load("6Nsud"),
    $53fb745b66972d5e$var$load("gmzZ6"),
    $53fb745b66972d5e$var$load("ipiLs"),
    $53fb745b66972d5e$var$load("1Jgsw"),
    $53fb745b66972d5e$var$load("dclpt"),
    $53fb745b66972d5e$var$load("tKhaz"),
    $53fb745b66972d5e$var$load("jwWp5"),
    $53fb745b66972d5e$var$load("6wr18"),
    $53fb745b66972d5e$var$load("cyGuT"),
    $53fb745b66972d5e$var$load("9wxKg"),
    $53fb745b66972d5e$var$load("Wowvf"),
    $53fb745b66972d5e$var$load("let0D"),
    $53fb745b66972d5e$var$load("kUbUu"),
    $53fb745b66972d5e$var$load("dIKn2"),
    $53fb745b66972d5e$var$load("8fdGr"),
    $53fb745b66972d5e$var$load("1gUNx"),
    $53fb745b66972d5e$var$load("7EorR"),
    $53fb745b66972d5e$var$load("hhss7"),
    $53fb745b66972d5e$var$load("ffEVr"),
    $53fb745b66972d5e$var$load("8Gekp"),
    $53fb745b66972d5e$var$load("27cgC")
]).then(()=>parcelRequire('fp8N8'));

});

parcelRegister("4Yv1J", function(module, exports) {
$parcel$export(module.exports, "ContentExtensionsProvider", () => (parcelRequire("f5aR2")).ContentExtensionsProvider);

var $f5aR2 = parcelRequire("f5aR2");


});

parcelRegister("f5aR2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k77lQ = parcelRequire("k77lQ");


var $69aHU = parcelRequire("69aHU");


var $hFueH = parcelRequire("hFueH");


var $hMRhJ = parcelRequire("hMRhJ");


const $cc34c55db5a1bcbb$var$getLegacyContentExtensions = ()=>({
        loadSortableTable: ()=>(parcelRequire("gY2se"))
    });
const $cc34c55db5a1bcbb$var$providers = {
    getExtensionHandlers: $k77lQ.getExtensionHandlers,
    getLegacyContentExtensions: $cc34c55db5a1bcbb$var$getLegacyContentExtensions,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: $hFueH.default
};
const $cc34c55db5a1bcbb$export$2a88d3b468decd4a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: $cc34c55db5a1bcbb$var$providers
    }, children);
module.exports["ContentExtensionsProvider"] = $cc34c55db5a1bcbb$export$2a88d3b468decd4a;

});

parcelRegister("gY2se", function(module, exports) {

let $c5a42755014c640b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5a42755014c640b$var$load("kuPgl").then(()=>parcelRequire('5byen'));

});

parcelRegister("crTA1", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("iqZzD")).default);

var $iqZzD = parcelRequire("iqZzD");


});

parcelRegister("iqZzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ba6afbc5717c4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $iqPBi = parcelRequire("iqPBi");

var $d6ba6afbc5717c4a$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPBi.SpaceBase), props);
};

});

parcelRegister("eKeNR", function(module, exports) {

let $abc0d83271dc4421$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abc0d83271dc4421$var$load("kMc37"),
    $abc0d83271dc4421$var$load("8Qv5g"),
    $abc0d83271dc4421$var$load("4Jbf1"),
    $abc0d83271dc4421$var$load("e6wQ8"),
    $abc0d83271dc4421$var$load("jvHRs"),
    $abc0d83271dc4421$var$load("16mQP"),
    $abc0d83271dc4421$var$load("7RXky"),
    $abc0d83271dc4421$var$load("lVO3w"),
    $abc0d83271dc4421$var$load("fkeSV"),
    $abc0d83271dc4421$var$load("h2QhJ"),
    $abc0d83271dc4421$var$load("9XYQ9"),
    $abc0d83271dc4421$var$load("edPhJ"),
    $abc0d83271dc4421$var$load("3qsjq"),
    $abc0d83271dc4421$var$load("aKNGF"),
    $abc0d83271dc4421$var$load("lUlCu"),
    $abc0d83271dc4421$var$load("8JZKd"),
    $abc0d83271dc4421$var$load("kvwtq"),
    $abc0d83271dc4421$var$load("3kUQf"),
    $abc0d83271dc4421$var$load("jdLWZ"),
    $abc0d83271dc4421$var$load("fTFcV"),
    $abc0d83271dc4421$var$load("6wr18"),
    $abc0d83271dc4421$var$load("6faJ6"),
    $abc0d83271dc4421$var$load("ffEVr"),
    $abc0d83271dc4421$var$load("9SyhI"),
    $abc0d83271dc4421$var$load("ladkM"),
    $abc0d83271dc4421$var$load("ik9rg")
]).then(()=>parcelRequire('dg3UC'));

});

parcelRegister("kAxaH", function(module, exports) {

let $efd0e6a512858ce3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $efd0e6a512858ce3$var$load("lQZYM"),
    $efd0e6a512858ce3$var$load("7u5Uq"),
    $efd0e6a512858ce3$var$load("eNZNF"),
    $efd0e6a512858ce3$var$load("8JZKd"),
    $efd0e6a512858ce3$var$load("cArq8"),
    $efd0e6a512858ce3$var$load("5jNvH"),
    $efd0e6a512858ce3$var$load("hhss7"),
    $efd0e6a512858ce3$var$load("hyqsV"),
    $efd0e6a512858ce3$var$load("lPQcc"),
    $efd0e6a512858ce3$var$load("b7Mng"),
    $efd0e6a512858ce3$var$load("5pvpJ"),
    $efd0e6a512858ce3$var$load("567AN"),
    $efd0e6a512858ce3$var$load("3GBzS"),
    $efd0e6a512858ce3$var$load("1pxHe"),
    $efd0e6a512858ce3$var$load("eVJyV")
]).then(()=>parcelRequire('9yrtR'));

});

parcelRegister("5gklh", function(module, exports) {

let $3d4e39e482379916$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d4e39e482379916$var$load("6unZM").then(()=>parcelRequire('c0oNl'));

});

parcelRegister("kjKSX", function(module, exports) {

let $eca9f3733c3dcfa7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eca9f3733c3dcfa7$var$load("7UdVV").then(()=>parcelRequire('kCK7c'));

});

parcelRegister("hTO1G", function(module, exports) {

let $d07e60d9c890bb3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d07e60d9c890bb3e$var$load("ge3AN").then(()=>parcelRequire('iiG61'));

});

parcelRegister("WJkgK", function(module, exports) {

let $0b0893ad96ab6d7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b0893ad96ab6d7e$var$load("4Yemz").then(()=>parcelRequire('3R3rh'));

});

parcelRegister("gObvh", function(module, exports) {

let $c3ca3d2fd4a434ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3ca3d2fd4a434ff$var$load("8prF9").then(()=>parcelRequire('aJ0Cr'));

});

parcelRegister("grDVy", function(module, exports) {

let $bf8e23aca6966e58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf8e23aca6966e58$var$load("gialu"),
    $bf8e23aca6966e58$var$load("4CfTY"),
    $bf8e23aca6966e58$var$load("gctwz"),
    $bf8e23aca6966e58$var$load("4drdS"),
    $bf8e23aca6966e58$var$load("aIuOE")
]).then(()=>parcelRequire('56n4X'));

});

parcelRegister("kSHES", function(module, exports) {

let $f33ab76f69730595$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f33ab76f69730595$var$load("fV7Cf").then(()=>parcelRequire('gkSJt'));

});

parcelRegister("7SwJt", function(module, exports) {

let $5bc6f785b2fb175a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bc6f785b2fb175a$var$load("gialu"),
    $5bc6f785b2fb175a$var$load("4CfTY"),
    $5bc6f785b2fb175a$var$load("gctwz"),
    $5bc6f785b2fb175a$var$load("4drdS"),
    $5bc6f785b2fb175a$var$load("dezv5")
]).then(()=>parcelRequire('hD4yV'));

});

parcelRegister("f4SWy", function(module, exports) {

let $afa1d95931d21b73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afa1d95931d21b73$var$load("8Kivm"),
    $afa1d95931d21b73$var$load("8eNS3"),
    $afa1d95931d21b73$var$load("kSBog"),
    $afa1d95931d21b73$var$load("jwSno"),
    $afa1d95931d21b73$var$load("iQ0Jm"),
    $afa1d95931d21b73$var$load("2eiOk")
]).then(()=>parcelRequire('do0K0'));

});

parcelRegister("jOUeC", function(module, exports) {

let $e6de4ee6d721d073$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6de4ee6d721d073$var$load("EEHCI").then(()=>parcelRequire('dtJ3H'));

});

parcelRegister("amnPv", function(module, exports) {

let $78ae718ee14a8eb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78ae718ee14a8eb0$var$load("gABRh").then(()=>parcelRequire('3JgtQ'));

});

parcelRegister("bDjCi", function(module, exports) {
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => (parcelRequire("e8WZK")).ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE);
$parcel$export(module.exports, "CALENDAR_CONTEXT", () => (parcelRequire("ltKTq")).CALENDAR_CONTEXT);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $e8WZK = parcelRequire("e8WZK");


var $ltKTq = parcelRequire("ltKTq");


const $0fe83f4fb6168025$export$666c7163d0ae1b3f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UHi5n",
    name: "LazyTeamCalendars",
    loader: async ()=>(await (parcelRequire("hOi4Z"))).TeamCalendar
});

const $0fe83f4fb6168025$export$9bc5a864d70a9980 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DHsKy",
    name: "LazyHomepageCard",
    loader: async ()=>(await (parcelRequire("14ltO"))).HomepageCard
});

const $0fe83f4fb6168025$export$85a8d72151ca049b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sxt9o",
    name: "LazyTeamCalendarSiteSettingsPage",
    loader: async ()=>(await (parcelRequire("5C3xP"))).TeamCalendarSiteSettingsPage
});
module.exports["LazyTeamCalendars"] = $0fe83f4fb6168025$export$666c7163d0ae1b3f;
module.exports["LazyHomepageCard"] = $0fe83f4fb6168025$export$9bc5a864d70a9980;
module.exports["LazyTeamCalendarSiteSettingsPage"] = $0fe83f4fb6168025$export$85a8d72151ca049b;

});

parcelRegister("hOi4Z", function(module, exports) {

let $cf75215edb6b1d96$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $cf75215edb6b1d96$var$load("gLGsg"),
    $cf75215edb6b1d96$var$load("fqGSw"),
    $cf75215edb6b1d96$var$load("49GA1"),
    $cf75215edb6b1d96$var$load("32K9i"),
    $cf75215edb6b1d96$var$load("7whwt"),
    $cf75215edb6b1d96$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $cf75215edb6b1d96$var$load("5oU5X"),
    $cf75215edb6b1d96$var$load("i84dm"),
    $cf75215edb6b1d96$var$load("7WcBh"),
    $cf75215edb6b1d96$var$load("LXZNT"),
    $cf75215edb6b1d96$var$load("j2bbk"),
    $cf75215edb6b1d96$var$load("2F69B"),
    $cf75215edb6b1d96$var$load("a8Jk0"),
    $cf75215edb6b1d96$var$load("eEyVs"),
    $cf75215edb6b1d96$var$load("4Jbf1"),
    $cf75215edb6b1d96$var$load("lkOIY"),
    $cf75215edb6b1d96$var$load("gryT8"),
    $cf75215edb6b1d96$var$load("aeEUI"),
    $cf75215edb6b1d96$var$load("iXzmH"),
    $cf75215edb6b1d96$var$load("65c4i"),
    $cf75215edb6b1d96$var$load("7EorR"),
    $cf75215edb6b1d96$var$load("Wowvf"),
    $cf75215edb6b1d96$var$load("f1x0y"),
    $cf75215edb6b1d96$var$load("ffEVr"),
    $cf75215edb6b1d96$var$load("5t3NJ"),
    $cf75215edb6b1d96$var$load("alL67")
]).then(()=>parcelRequire('biV8C'));

});

parcelRegister("14ltO", function(module, exports) {

let $0c76d39bf0829f14$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $0c76d39bf0829f14$var$load("fqGSw"),
    $0c76d39bf0829f14$var$load("49GA1"),
    $0c76d39bf0829f14$var$load("32K9i"),
    $0c76d39bf0829f14$var$load("7whwt"),
    $0c76d39bf0829f14$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $0c76d39bf0829f14$var$load("5oU5X"),
    $0c76d39bf0829f14$var$load("i84dm"),
    $0c76d39bf0829f14$var$load("7WcBh"),
    $0c76d39bf0829f14$var$load("LXZNT"),
    $0c76d39bf0829f14$var$load("j2bbk"),
    $0c76d39bf0829f14$var$load("2F69B"),
    $0c76d39bf0829f14$var$load("eEyVs"),
    $0c76d39bf0829f14$var$load("4Jbf1"),
    $0c76d39bf0829f14$var$load("lkOIY"),
    $0c76d39bf0829f14$var$load("aeEUI"),
    $0c76d39bf0829f14$var$load("iXzmH"),
    $0c76d39bf0829f14$var$load("65c4i"),
    $0c76d39bf0829f14$var$load("7EorR"),
    $0c76d39bf0829f14$var$load("ffEVr"),
    $0c76d39bf0829f14$var$load("Wowvf"),
    $0c76d39bf0829f14$var$load("f1x0y"),
    $0c76d39bf0829f14$var$load("5t3NJ"),
    $0c76d39bf0829f14$var$load("3orE4")
]).then(()=>parcelRequire('IdTEh'));

});

parcelRegister("5C3xP", function(module, exports) {

let $41634039ac161f50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41634039ac161f50$var$load("5oU5X"),
    $41634039ac161f50$var$load("2F69B"),
    $41634039ac161f50$var$load("hhss7"),
    $41634039ac161f50$var$load("9g1FS")
]).then(()=>parcelRequire('4GncZ'));

});

parcelRegister("e8WZK", function(module, exports) {
const $5e4945ce4960200f$export$c0e43f82fc27fe04 = 'adminTeamCalendars';
module.exports["ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE"] = $5e4945ce4960200f$export$c0e43f82fc27fe04;

});

parcelRegister("ltKTq", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c9e0854a72739c18$export$feb9e2d8bc9b9b85 = /*#__PURE__*/ function(CALENDAR_CONTEXT) {
    CALENDAR_CONTEXT["SPACE_CALENDARS"] = "spaceCalendars";
    CALENDAR_CONTEXT["MY_CALENDARS"] = "myCalendars";
    CALENDAR_CONTEXT["SPACE_SUBCALENDAR"] = "spaceSubCalendar";
    CALENDAR_CONTEXT["EMBEDDED_SUBCALENDAR"] = "embeddedSubCalendar";
    CALENDAR_CONTEXT["MULTIPLE_CALENDARS"] = "multipleCalendars";
    CALENDAR_CONTEXT["EMBEDDED_MULTIPLE_CALENDARS"] = "embeddedMultipleCalendars";
    return CALENDAR_CONTEXT;
}({});
const $c9e0854a72739c18$var$TCContext = /*#__PURE__*/ (0, $42omo.createContext)({});
const $c9e0854a72739c18$export$5f8036cb54c4d559 = ()=>{
    const context = (0, $42omo.useContext)($c9e0854a72739c18$var$TCContext);
    if (context === undefined) throw new Error('useTCContextDispatch must be used within TCContextProvider');
    return context;
};
let $c9e0854a72739c18$var$initialState;
const $c9e0854a72739c18$var$getInitialState = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents, firstDay: firstDay })=>{
    return(// @ts-expect-error - TS2454 Typescript 5.9.2 upgrade
    $c9e0854a72739c18$var$initialState || {
        calendars: calendars,
        events: [],
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        viewDate: new Date(),
        dateTimeFormatOptions: {
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: userTimeFormat === 'displayTimeFormat12' ? 'h12' : 'h23',
            timeZone: userTimeZoneId
        },
        calendarErrors: [],
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
};
const $c9e0854a72739c18$var$AT = {
    SET_EVENTS: 'SET_EVENTS',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_CALENDARS: 'SET_CALENDARS',
    SET_VIEW_DATE: 'SET_VIEW_DATE',
    SET_CALENDAR_ERRORS: 'SET_CALENDAR_ERRORS',
    SET_IS_LOADING_EVENTS: 'SET_IS_LOADING_EVENTS',
    SET_FIRST_DAY: 'SET_FIRST_DAY'
};
const $c9e0854a72739c18$export$97f0c60a5aa0f317 = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, children: children, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents = false, firstDay: firstDay = 1 })=>{
    const initialState = $c9e0854a72739c18$var$getInitialState({
        calendars: calendars,
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
    const reducer = (0, $42omo.useCallback)((state, action)=>{
        switch(action.type){
            case $c9e0854a72739c18$var$AT.SET_EVENTS:
                return {
                    ...state,
                    events: action.events
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS:
                {
                    const calendarIds = action.calendarIds;
                    const newEvents = action.events;
                    const oldEvents = state.events.filter((event)=>!calendarIds.includes(event.subCalendarId));
                    const updatedEvents = oldEvents.concat(newEvents);
                    return {
                        ...state,
                        events: updatedEvents
                    };
                }
            case $c9e0854a72739c18$var$AT.SET_CALENDARS:
                return {
                    ...state,
                    calendars: action.calendars
                };
            case $c9e0854a72739c18$var$AT.SET_VIEW_DATE:
                return {
                    ...state,
                    viewDate: action.viewDate
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS:
                if (state.calendarErrors.length === 0 && action.calendarErrors.length === 0) return state;
                return {
                    ...state,
                    calendarErrors: action.calendarErrors
                };
            case $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS:
                return {
                    ...state,
                    isLoadingEvents: action.isLoadingEvents
                };
            case $c9e0854a72739c18$var$AT.SET_FIRST_DAY:
                return {
                    ...state,
                    firstDay: action.firstDay
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [state, dispatch] = (0, $42omo.useReducer)(reducer, initialState);
    const actions = (0, $42omo.useMemo)(()=>({
            setEvents: (events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_EVENTS,
                    events: events
                });
            },
            setCalendarEvents: (calendarIds, events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS,
                    calendarIds: calendarIds,
                    events: events
                });
            },
            setCalendars: (calendars)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDARS,
                    calendars: calendars
                });
            },
            setViewDate: (viewDate)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_VIEW_DATE,
                    viewDate: viewDate
                });
            },
            setCalendarErrors: (calendarErrors)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS,
                    calendarErrors: calendarErrors
                });
            },
            setIsLoadingEvents: (isLoadingEvents)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS,
                    isLoadingEvents: isLoadingEvents
                });
            },
            setFirstDay: (firstDay)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_FIRST_DAY,
                    firstDay: firstDay
                });
            }
        }), []);
    const tcContextValue = (0, $42omo.useMemo)(()=>({
            state: state,
            actions: actions
        }), [
        state,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9e0854a72739c18$var$TCContext.Provider, {
        value: tcContextValue
    }, children);
};
module.exports["CALENDAR_CONTEXT"] = $c9e0854a72739c18$export$feb9e2d8bc9b9b85;
module.exports["useTCContextDispatch"] = $c9e0854a72739c18$export$5f8036cb54c4d559;
module.exports["TCContextProvider"] = $c9e0854a72739c18$export$97f0c60a5aa0f317;

});

parcelRegister("iAxzI", function(module, exports) {

let $d885a21a603d1a46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d885a21a603d1a46$var$load("fAUr9").then(()=>parcelRequire('7EJ9w'));

});

parcelRegister("f6zUg", function(module, exports) {

let $aff344d5ae3f4125$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aff344d5ae3f4125$var$load("a1VZ3"),
    $aff344d5ae3f4125$var$load("6wr18"),
    $aff344d5ae3f4125$var$load("e2ujj"),
    $aff344d5ae3f4125$var$load("3qsjq"),
    $aff344d5ae3f4125$var$load("lUlCu"),
    $aff344d5ae3f4125$var$load("ffEVr"),
    $aff344d5ae3f4125$var$load("4pYLw")
]).then(()=>parcelRequire('i9E8j'));

});

parcelRegister("l40Ef", function(module, exports) {

let $f55a796a6d69688b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f55a796a6d69688b$var$load("evWu5").then(()=>parcelRequire('8foBH'));

});

parcelRegister("6O2BV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f497007dae01ffa$export$25fb473e92ff8332 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PT7yD",
    name: "ClassicEditorContextProviderLoader",
    loader: ()=>(parcelRequire("4BGfW"))
});
module.exports["ClassicEditorContextProviderLoader"] = $4f497007dae01ffa$export$25fb473e92ff8332;

});

parcelRegister("4BGfW", function(module, exports) {

let $35ab654aaa4f8660$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35ab654aaa4f8660$var$load("7Omhy"),
    $35ab654aaa4f8660$var$load("2YffH"),
    $35ab654aaa4f8660$var$load("A1eSR"),
    $35ab654aaa4f8660$var$load("2rCak"),
    $35ab654aaa4f8660$var$load("2F69B"),
    $35ab654aaa4f8660$var$load("aZinD"),
    $35ab654aaa4f8660$var$load("iIL8i"),
    $35ab654aaa4f8660$var$load("eYere"),
    $35ab654aaa4f8660$var$load("at1W4"),
    $35ab654aaa4f8660$var$load("lkOIY"),
    $35ab654aaa4f8660$var$load("hcj2C"),
    $35ab654aaa4f8660$var$load("2UF2x"),
    $35ab654aaa4f8660$var$load("4eboO"),
    $35ab654aaa4f8660$var$load("fgAx2"),
    $35ab654aaa4f8660$var$load("8YSo7"),
    $35ab654aaa4f8660$var$load("fqGSw"),
    $35ab654aaa4f8660$var$load("lqbST"),
    $35ab654aaa4f8660$var$load("4t77a"),
    $35ab654aaa4f8660$var$load("3CHGC"),
    $35ab654aaa4f8660$var$load("cgLyI"),
    $35ab654aaa4f8660$var$load("2Cftu"),
    $35ab654aaa4f8660$var$load("4i0CB"),
    $35ab654aaa4f8660$var$load("49GA1"),
    $35ab654aaa4f8660$var$load("32K9i"),
    $35ab654aaa4f8660$var$load("h4k4y"),
    $35ab654aaa4f8660$var$load("9ijrN"),
    $35ab654aaa4f8660$var$load("aeEUI"),
    $35ab654aaa4f8660$var$load("iXzmH"),
    $35ab654aaa4f8660$var$load("65c4i"),
    $35ab654aaa4f8660$var$load("kjZZD"),
    $35ab654aaa4f8660$var$load("jkPqm"),
    $35ab654aaa4f8660$var$load("awqCy"),
    $35ab654aaa4f8660$var$load("6wr18"),
    $35ab654aaa4f8660$var$load("cyGuT"),
    $35ab654aaa4f8660$var$load("8ab9M"),
    $35ab654aaa4f8660$var$load("gyOzw"),
    $35ab654aaa4f8660$var$load("ePdWC"),
    $35ab654aaa4f8660$var$load("lBzRN"),
    $35ab654aaa4f8660$var$load("9wxKg"),
    $35ab654aaa4f8660$var$load("fZt2F"),
    $35ab654aaa4f8660$var$load("Wowvf"),
    $35ab654aaa4f8660$var$load("6O8m6"),
    $35ab654aaa4f8660$var$load("5GxU8"),
    $35ab654aaa4f8660$var$load("amUNi"),
    $35ab654aaa4f8660$var$load("7whwt"),
    $35ab654aaa4f8660$var$load("7e13v"),
    $35ab654aaa4f8660$var$load("699ae"),
    $35ab654aaa4f8660$var$load("i7QCq"),
    $35ab654aaa4f8660$var$load("let0D"),
    $35ab654aaa4f8660$var$load("87NBA"),
    $35ab654aaa4f8660$var$load("8KnyD"),
    $35ab654aaa4f8660$var$load("6M36W"),
    $35ab654aaa4f8660$var$load("bRz9K"),
    $35ab654aaa4f8660$var$load("ffEVr"),
    $35ab654aaa4f8660$var$load("kUbUu"),
    $35ab654aaa4f8660$var$load("4Lgj0"),
    $35ab654aaa4f8660$var$load("kSJiq"),
    $35ab654aaa4f8660$var$load("dIKn2"),
    $35ab654aaa4f8660$var$load("8fdGr"),
    $35ab654aaa4f8660$var$load("hhss7"),
    $35ab654aaa4f8660$var$load("fnmhc"),
    $35ab654aaa4f8660$var$load("kdoia"),
    $35ab654aaa4f8660$var$load("7EorR"),
    $35ab654aaa4f8660$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("7EX8o", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $1c44eab82f88f298$export$3717da370a5be6bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NLJVG",
    name: "EmbeddedViewPageLoader",
    loader: async ()=>(await (parcelRequire("92gYo"))).EmbeddedViewPage,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ViewPageRouteComponentLoader
    ]
});
module.exports["EmbeddedViewPageLoader"] = $1c44eab82f88f298$export$3717da370a5be6bc;

});

parcelRegister("92gYo", function(module, exports) {

let $69417772207ef854$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69417772207ef854$var$load("6lgEW"),
    $69417772207ef854$var$load("8Uu6s"),
    $69417772207ef854$var$load("2cLQd"),
    $69417772207ef854$var$load("kBLPG"),
    $69417772207ef854$var$load("5HTaY"),
    $69417772207ef854$var$load("4tiwv"),
    $69417772207ef854$var$load("dlm6q"),
    $69417772207ef854$var$load("7u5Uq"),
    $69417772207ef854$var$load("7ZBIQ"),
    $69417772207ef854$var$load("3yM79"),
    $69417772207ef854$var$load("5coOi"),
    $69417772207ef854$var$load("9ZkgN"),
    $69417772207ef854$var$load("4XFRu"),
    $69417772207ef854$var$load("jvBnQ"),
    $69417772207ef854$var$load("gpfoY"),
    $69417772207ef854$var$load("9VvWo"),
    $69417772207ef854$var$load("bAXKU"),
    $69417772207ef854$var$load("9Z7qK"),
    $69417772207ef854$var$load("duPDN"),
    $69417772207ef854$var$load("70qyO"),
    $69417772207ef854$var$load("gYeBT"),
    $69417772207ef854$var$load("9jS5g"),
    $69417772207ef854$var$load("gLGsg"),
    $69417772207ef854$var$load("2F69B"),
    $69417772207ef854$var$load("dTsOE"),
    $69417772207ef854$var$load("8Gekp"),
    $69417772207ef854$var$load("6Up0b"),
    $69417772207ef854$var$load("ePdWC"),
    $69417772207ef854$var$load("lBzRN"),
    $69417772207ef854$var$load("6Nsud"),
    $69417772207ef854$var$load("gmzZ6"),
    $69417772207ef854$var$load("ipiLs"),
    $69417772207ef854$var$load("1Jgsw"),
    $69417772207ef854$var$load("dclpt"),
    $69417772207ef854$var$load("tKhaz"),
    $69417772207ef854$var$load("jwWp5"),
    $69417772207ef854$var$load("6wr18"),
    $69417772207ef854$var$load("cyGuT"),
    $69417772207ef854$var$load("9wxKg"),
    $69417772207ef854$var$load("Wowvf"),
    $69417772207ef854$var$load("let0D"),
    $69417772207ef854$var$load("ffEVr"),
    $69417772207ef854$var$load("kUbUu"),
    $69417772207ef854$var$load("7EorR"),
    $69417772207ef854$var$load("dIKn2"),
    $69417772207ef854$var$load("8fdGr"),
    $69417772207ef854$var$load("hhss7"),
    $69417772207ef854$var$load("1gUNx"),
    $69417772207ef854$var$load("WXYxI")
]).then(()=>parcelRequire('6N2H2'));

});

parcelRegister("4H46k", function(module, exports) {
// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.

var $jmjWc = parcelRequire("jmjWc");


const $36ae5bfcf92491af$export$2f32c75fff716fcc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b7m6n",
    name: "LazySpaceBlogRedirect",
    loader: async ()=>(await (parcelRequire("c29Ia"))).SpaceBlogRedirect
});

const $36ae5bfcf92491af$export$5590c410e7d0a293 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LfHUf",
    name: "LazySpaceCreatePage",
    loader: ()=>(parcelRequire("7zngW"))
});

const $36ae5bfcf92491af$export$e650af616d3a92cf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z1eTA",
    name: "LazyMobileWebContainer",
    loader: ()=>(parcelRequire("dty3l"))
});

const $36ae5bfcf92491af$export$dcf40c4d983a3b1f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TnNDX",
    name: "LazyDwellTime",
    loader: ()=>(parcelRequire("djVjJ"))
});

const $36ae5bfcf92491af$export$a804be9097757ef8 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GCYkT",
    name: "LazyConsumptionViewedAndCompletedEventTracker",
    loader: async ()=>(await (parcelRequire("ipPBg"))).ConsumptionViewedAndCompletedEventTracker
});

const $36ae5bfcf92491af$export$33256e23669f7955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AaHry",
    name: "LazyConfluenceNotFound",
    loader: ()=>(parcelRequire("eQZPX"))
});
module.exports["LazySpaceBlogRedirect"] = $36ae5bfcf92491af$export$2f32c75fff716fcc;
module.exports["LazySpaceCreatePage"] = $36ae5bfcf92491af$export$5590c410e7d0a293;
module.exports["LazyMobileWebContainer"] = $36ae5bfcf92491af$export$e650af616d3a92cf;
module.exports["LazyDwellTime"] = $36ae5bfcf92491af$export$dcf40c4d983a3b1f;
module.exports["LazyConsumptionViewedAndCompletedEventTracker"] = $36ae5bfcf92491af$export$a804be9097757ef8;
module.exports["LazyConfluenceNotFound"] = $36ae5bfcf92491af$export$33256e23669f7955;

});

parcelRegister("c29Ia", function(module, exports) {

let $8c2d346fe517694f$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("kzRPH"), 5)),
    $8c2d346fe517694f$var$load("gaXhw")
]).then(()=>parcelRequire('4bW1i'));

});

parcelRegister("7zngW", function(module, exports) {

let $582ddaaea157b60f$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $582ddaaea157b60f$var$load("3yM79"),
    $582ddaaea157b60f$var$load("eYere"),
    $582ddaaea157b60f$var$load("at1W4"),
    $582ddaaea157b60f$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("meCbt"), 5)),
    $582ddaaea157b60f$var$load("7deCi"),
    $582ddaaea157b60f$var$load("2SjHp"),
    $582ddaaea157b60f$var$load("cf5vC"),
    $582ddaaea157b60f$var$load("A1eSR"),
    $582ddaaea157b60f$var$load("2rCak"),
    $582ddaaea157b60f$var$load("e1cuZ"),
    $582ddaaea157b60f$var$load("89WyM"),
    $582ddaaea157b60f$var$load("aZinD"),
    $582ddaaea157b60f$var$load("O3OZ0"),
    $582ddaaea157b60f$var$load("coJiW"),
    $582ddaaea157b60f$var$load("iIL8i"),
    $582ddaaea157b60f$var$load("lPQcc"),
    $582ddaaea157b60f$var$load("lkOIY"),
    $582ddaaea157b60f$var$load("hcj2C"),
    $582ddaaea157b60f$var$load("2UF2x"),
    $582ddaaea157b60f$var$load("fgAx2"),
    $582ddaaea157b60f$var$load("7f9Fz"),
    $582ddaaea157b60f$var$load("fqGSw"),
    $582ddaaea157b60f$var$load("3CHGC"),
    $582ddaaea157b60f$var$load("cgLyI"),
    $582ddaaea157b60f$var$load("2F69B"),
    $582ddaaea157b60f$var$load("2Cftu"),
    $582ddaaea157b60f$var$load("4i0CB"),
    $582ddaaea157b60f$var$load("49GA1"),
    $582ddaaea157b60f$var$load("32K9i"),
    $582ddaaea157b60f$var$load("h4k4y"),
    $582ddaaea157b60f$var$load("9ijrN"),
    $582ddaaea157b60f$var$load("4xzkC"),
    $582ddaaea157b60f$var$load("aeEUI"),
    $582ddaaea157b60f$var$load("Wowvf"),
    $582ddaaea157b60f$var$load("iXzmH"),
    $582ddaaea157b60f$var$load("65c4i"),
    $582ddaaea157b60f$var$load("3TTZL"),
    $582ddaaea157b60f$var$load("37ldp"),
    $582ddaaea157b60f$var$load("jkPqm"),
    $582ddaaea157b60f$var$load("7EorR"),
    $582ddaaea157b60f$var$load("hhss7"),
    $582ddaaea157b60f$var$load("8ab9M"),
    $582ddaaea157b60f$var$load("gyOzw"),
    $582ddaaea157b60f$var$load("ePdWC"),
    $582ddaaea157b60f$var$load("lBzRN"),
    $582ddaaea157b60f$var$load("fZt2F"),
    $582ddaaea157b60f$var$load("9iITj"),
    $582ddaaea157b60f$var$load("ffEVr"),
    $582ddaaea157b60f$var$load("6M36W"),
    $582ddaaea157b60f$var$load("bRz9K"),
    $582ddaaea157b60f$var$load("hUIij"),
    $582ddaaea157b60f$var$load("4Lgj0"),
    $582ddaaea157b60f$var$load("kSJiq"),
    $582ddaaea157b60f$var$load("89Sbl"),
    $582ddaaea157b60f$var$load("fnmhc"),
    $582ddaaea157b60f$var$load("kdoia"),
    $582ddaaea157b60f$var$load("6Yu8N"),
    $582ddaaea157b60f$var$load("43hsF"),
    $582ddaaea157b60f$var$load("kHDuB"),
    $582ddaaea157b60f$var$load("6UKHF")
]).then(()=>parcelRequire('lJvEZ'));

});

parcelRegister("dty3l", function(module, exports) {

let $9cf865fd826c174c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9cf865fd826c174c$var$load("2F69B"),
    $9cf865fd826c174c$var$load("kOWvR"),
    $9cf865fd826c174c$var$load("4Lgj0"),
    $9cf865fd826c174c$var$load("kSJiq"),
    $9cf865fd826c174c$var$load("4D7T2")
]).then(()=>parcelRequire('1x5LM'));

});

parcelRegister("djVjJ", function(module, exports) {

let $9b2982b618f8cf76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b2982b618f8cf76$var$load("9HjYv").then(()=>parcelRequire('7SYCP'));

});

parcelRegister("ipPBg", function(module, exports) {

let $d682967ebe3fde01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d682967ebe3fde01$var$load("f2uDI").then(()=>parcelRequire('3deqg'));

});

parcelRegister("eQZPX", function(module, exports) {

let $ad05e39509ec3e59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad05e39509ec3e59$var$load("kOWvR").then(()=>parcelRequire('4uiGD'));

});

parcelRegister("9pOEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9jl6v = parcelRequire("9jl6v");

const $1adfb96e71037064$export$1d04f0e8aa57d594 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jl6v.InlineCommentsProvider), null, children);
};
module.exports["CommentContextWrapper"] = $1adfb96e71037064$export$1d04f0e8aa57d594;

});

parcelRegister("f6jYE", function(module, exports) {

let $afe6e99dc8e0d20c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $afe6e99dc8e0d20c$var$load("5J2Yz").then(()=>parcelRequire('gJcNU'));

});

parcelRegister("2VZOl", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $FOT9i.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $1P1Tu.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $9zUhf.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("8KbKw", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $3pJBd = parcelRequire("3pJBd");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $2XqLN.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        const apolloClient = (0, $hp2SH.getApolloClient)();
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const result = await apolloClient.query({
                query: (0, $3pJBd.GetCollabPermissionTokenQuery),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                }
            });
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            return result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
        } catch (e) {
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("3pJBd", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $8fbe44097771f132$export$20260f2c545eeec0 = (0, $eSUdr.default)`query getCollabToken($contentId:ID!$draftShareId:String){collabToken(id:$contentId draftShareId:$draftShareId){token}}`;
module.exports["GetCollabPermissionTokenQuery"] = $8fbe44097771f132$export$20260f2c545eeec0;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("hQm1C", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a8b418da1bc27466$export$871388fb833dfa56 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2M0Zq",
    name: "NativeCollabLoader",
    loader: async ()=>{
        const { NativeCollabComponent: NativeCollabComponent } = await (parcelRequire("iLeEQ"));
        return NativeCollabComponent;
    }
});
module.exports["NativeCollabLoader"] = $a8b418da1bc27466$export$871388fb833dfa56;

});

parcelRegister("iLeEQ", function(module, exports) {

let $da87fc847e3569bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da87fc847e3569bd$var$load("7whwt"),
    $da87fc847e3569bd$var$load("699ae"),
    $da87fc847e3569bd$var$load("i7QCq"),
    $da87fc847e3569bd$var$load("6wr18"),
    $da87fc847e3569bd$var$load("2F69B"),
    $da87fc847e3569bd$var$load("5zDuS"),
    $da87fc847e3569bd$var$load("gORtx"),
    $da87fc847e3569bd$var$load("cLdBj"),
    $da87fc847e3569bd$var$load("43yCy"),
    $da87fc847e3569bd$var$load("8RJ1Y"),
    $da87fc847e3569bd$var$load("4g2Mj"),
    $da87fc847e3569bd$var$load("9wxKg"),
    $da87fc847e3569bd$var$load("ffEVr"),
    $da87fc847e3569bd$var$load("hhss7"),
    $da87fc847e3569bd$var$load("btqFK")
]).then(()=>parcelRequire('03pNx'));

});

parcelRegister("8Hqv7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $9WAeG = parcelRequire("9WAeG");


var $7koGn = parcelRequire("7koGn");

const $6f5a0d3cf76b2edb$export$c4004a2b66cea884 = 'ssr-app/render/render-full-cycle';
function $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry() {
    const registry = new Set();
    function register(callback) {
        registry.add(callback);
    }
    function unregister(callback) {
        registry.delete(callback);
    }
    function notifyRenderComplete() {
        registry.forEach((callback)=>callback());
    }
    return {
        register: register,
        unregister: unregister,
        notifyRenderComplete: notifyRenderComplete
    };
}
const $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac = $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry();
const $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0 = ({ name: name, children: children })=>{
    const fullCycleSSRState = window.__FULLCYCLE_SSR__;
    const containerRef = (0, $42omo.useRef)(null);
    const onFullCycleRenderComplete = (0, $42omo.useCallback)(()=>{
        if (containerRef.current && fullCycleSSRState) {
            const html = (0, $7koGn.sanitizeInputLoadablesForSSR)(containerRef.current.innerHTML);
            fullCycleSSRState.htmlOutput[name] = html;
        }
    }, [
        name,
        fullCycleSSRState
    ]);
    (0, $42omo.useEffect)(()=>{
        $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.register(onFullCycleRenderComplete);
        return ()=>$6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.unregister(onFullCycleRenderComplete);
    }, [
        onFullCycleRenderComplete
    ]);
    return null;
};
const $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "fullCycleOutput"
    }, children);
};
const $6f5a0d3cf76b2edb$export$8f3a9d27aa76c470 = ({ name: name, children: children })=>{
    const renders = (0, $42omo.useRef)({});
    const onRender = (0, $42omo.useCallback)((id, phase, actualDuration)=>{
        const updateName = `${id}/${phase}`;
        renders.current[updateName] = (renders.current[updateName] || 0) + 1;
        // We offset the start time by the duration of the previous render because we have to use internal "startTime"
        // to align with the rest of the waterfall. The startTime from React profiler is very different, so the best
        // approximation is to subtract the duration of the render from the SSRMeasures timestamp as onRender callback
        // is called after the render cycle.
        (0, $9WAeG.SSRMeasures).addMeasure(`${$6f5a0d3cf76b2edb$export$c4004a2b66cea884}/${updateName}/${renders.current[updateName]}`, actualDuration, true);
    }, []);
    if (!(0, $9wGTI.fg)('confluence_profile_fullcycle')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0, {
        name: name
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Profiler), {
        id: name,
        onRender: onRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0, {
        name: name
    }, children));
};
module.exports["FullCycleRenderWrapper"] = $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8;
module.exports["FullCycleRenderWithProfiler"] = $6f5a0d3cf76b2edb$export$8f3a9d27aa76c470;

});

parcelRegister("7koGn", function(module, exports) {
const $a4af1bafcd952bf9$var$MARKER_REGEX = /<input(?:\s?type="hidden")? data-loadable-(begin|end)="([^"]*)"(?:\sdata-ssr-placeholder-id="([^"]*)")?(?:\sdata-debug-name="([^"]*)")?\s*?(?:\s?type="hidden")?\s*>(?!\s*<\/input>)/g;
function $a4af1bafcd952bf9$export$7400f7b8afb970c2(html) {
    return html.replace($a4af1bafcd952bf9$var$MARKER_REGEX, (inputTag)=>{
        return `${inputTag.slice(0, -1)} />`;
    });
}
module.exports["sanitizeInputLoadablesForSSR"] = $a4af1bafcd952bf9$export$7400f7b8afb970c2;

});

parcelRegister("6gETM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

const $5ed14ae7f856df1d$export$204c1449657d49fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
const $5ed14ae7f856df1d$export$ae764d691d5f37c6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3loHF",
    name: "TreeRootForServerPlaceholder",
    loader: async ()=>$5ed14ae7f856df1d$export$204c1449657d49fd,
    _reactTreeRootForServerPlaceholderId: true
});
const $5ed14ae7f856df1d$export$4279728e9b12d235 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ed14ae7f856df1d$export$ae764d691d5f37c6, null, children);
};
module.exports["TreeRootForServerPlaceholderWrapper"] = $5ed14ae7f856df1d$export$4279728e9b12d235;

});

parcelRegister("8jRXE", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ba942ead23497767$export$d49c8c8cf1b10f7e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ynpC3",
    name: "FullPageEditorLoader",
    loader: async ()=>{
        const { FullPageEditorComponent: FullPageEditorComponent } = await (parcelRequire("9DoWg"));
        return FullPageEditorComponent;
    }
});
module.exports["FullPageEditorLoader"] = $ba942ead23497767$export$d49c8c8cf1b10f7e;

});

parcelRegister("9DoWg", function(module, exports) {

let $703b19dec5f7dc91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $703b19dec5f7dc91$var$load("l3dqd"),
    $703b19dec5f7dc91$var$load("70qyO"),
    $703b19dec5f7dc91$var$load("7Omhy"),
    $703b19dec5f7dc91$var$load("2YffH"),
    $703b19dec5f7dc91$var$load("gmzZ6"),
    $703b19dec5f7dc91$var$load("A1eSR"),
    $703b19dec5f7dc91$var$load("2rCak"),
    $703b19dec5f7dc91$var$load("gtwnX"),
    $703b19dec5f7dc91$var$load("aSVxo"),
    $703b19dec5f7dc91$var$load("gpfoY"),
    $703b19dec5f7dc91$var$load("aZinD"),
    $703b19dec5f7dc91$var$load("1Jgsw"),
    $703b19dec5f7dc91$var$load("attzI"),
    $703b19dec5f7dc91$var$load("ihbI9"),
    $703b19dec5f7dc91$var$load("c7kN1"),
    $703b19dec5f7dc91$var$load("iY2SX"),
    $703b19dec5f7dc91$var$load("4cER0"),
    $703b19dec5f7dc91$var$load("90kvt"),
    $703b19dec5f7dc91$var$load("eYere"),
    $703b19dec5f7dc91$var$load("at1W4"),
    $703b19dec5f7dc91$var$load("hcj2C"),
    $703b19dec5f7dc91$var$load("2UF2x"),
    $703b19dec5f7dc91$var$load("65rGD"),
    $703b19dec5f7dc91$var$load("5Vmp6"),
    $703b19dec5f7dc91$var$load("ioxaT"),
    $703b19dec5f7dc91$var$load("3CHGC"),
    $703b19dec5f7dc91$var$load("cgLyI"),
    $703b19dec5f7dc91$var$load("2F69B"),
    $703b19dec5f7dc91$var$load("43yCy"),
    $703b19dec5f7dc91$var$load("49GA1"),
    $703b19dec5f7dc91$var$load("32K9i"),
    $703b19dec5f7dc91$var$load("5abXM"),
    $703b19dec5f7dc91$var$load("k78EM"),
    $703b19dec5f7dc91$var$load("8bZKp"),
    $703b19dec5f7dc91$var$load("7RNcA"),
    $703b19dec5f7dc91$var$load("kWNlz"),
    $703b19dec5f7dc91$var$load("cHTTI"),
    $703b19dec5f7dc91$var$load("8ab9M"),
    $703b19dec5f7dc91$var$load("gyOzw"),
    $703b19dec5f7dc91$var$load("ePdWC"),
    $703b19dec5f7dc91$var$load("lBzRN"),
    $703b19dec5f7dc91$var$load("9wxKg"),
    $703b19dec5f7dc91$var$load("7WaUI"),
    $703b19dec5f7dc91$var$load("gLGsg"),
    $703b19dec5f7dc91$var$load("3Kg3S"),
    $703b19dec5f7dc91$var$load("6O8m6"),
    $703b19dec5f7dc91$var$load("5GxU8"),
    $703b19dec5f7dc91$var$load("699ae"),
    $703b19dec5f7dc91$var$load("i7QCq"),
    $703b19dec5f7dc91$var$load("let0D"),
    $703b19dec5f7dc91$var$load("4Lgj0"),
    $703b19dec5f7dc91$var$load("kSJiq"),
    $703b19dec5f7dc91$var$load("4fAr4"),
    $703b19dec5f7dc91$var$load("cK6rU"),
    $703b19dec5f7dc91$var$load("fnmhc"),
    $703b19dec5f7dc91$var$load("kdoia"),
    $703b19dec5f7dc91$var$load("kUbUu"),
    $703b19dec5f7dc91$var$load("7Q5vz"),
    $703b19dec5f7dc91$var$load("2Cftu"),
    $703b19dec5f7dc91$var$load("4i0CB"),
    $703b19dec5f7dc91$var$load("7whwt"),
    $703b19dec5f7dc91$var$load("6wr18"),
    $703b19dec5f7dc91$var$load("kjZZD"),
    $703b19dec5f7dc91$var$load("Wowvf"),
    $703b19dec5f7dc91$var$load("hhss7"),
    $703b19dec5f7dc91$var$load("ffEVr"),
    $703b19dec5f7dc91$var$load("c4Kdp"),
    $703b19dec5f7dc91$var$load("7EorR"),
    $703b19dec5f7dc91$var$load("7x00I")
]).then(()=>parcelRequire('h1Y8a'));

});

parcelRegister("34NZw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d52b69b4dbbb4bb4$export$e6747c633274762a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "UL-jW",
    name: "PageShownPublicLinksEventLoader",
    loader: async ()=>{
        const { PageShownPublicLinksEvent: PageShownPublicLinksEvent } = await (parcelRequire("evlHl"));
        return PageShownPublicLinksEvent;
    }
});
module.exports["PageShownPublicLinksEventLoader"] = $d52b69b4dbbb4bb4$export$e6747c633274762a;

});

parcelRegister("evlHl", function(module, exports) {

let $a8f4cabc2ec9642a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8f4cabc2ec9642a$var$load("63zHi").then(()=>parcelRequire('jvel0'));

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $42omo = parcelRequire("42omo");


var $cVw8q = parcelRequire("cVw8q");


var $21K7m = parcelRequire("21K7m");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");

const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $42omo.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $42omo.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider = ({ children: children, value: value })=>{
    if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: value
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $42omo.createContext)({
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{}
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const [selectionProps, setSelectionProps] = (0, $42omo.useState)(null);
    const [hoverProps, setHoverProps] = (0, $42omo.useState)(null);
    const [viewProps, setViewProps] = (0, $42omo.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $42omo.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $42omo.useState)(null);
    const [showCreateComponent, setShowCreateComponent] = (0, $42omo.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $42omo.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $42omo.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $42omo.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $42omo.useState)();
    const [prevContentId, setPrevContentId] = (0, $42omo.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const annotationManager = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cVw8q.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $42omo.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $42omo.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) resetProviderState();
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
	 * NOTE: This function will not be calling setShowCreateComponent because it's
	 *       consumers will not be refreshing themselves with new selectionOptions.
	 *       It will now be the responsibility of the consumers of this function to call
	 *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
	 */ const setSelectionOptionsForCreateEditor = (0, $42omo.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // to exclude "not-page-or-doc" from pageClass to make typecheck happy
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? pageClassAttr : 'renderer',
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes ?? {}
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            if (!selectionProps) {
                if ((0, $9wGTI.fg)('confluence_frontend_nudgebar_no_double_click')) {
                    // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                    // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                    (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                    // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                    (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                    return;
                }
            }
            result = selectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            setSelectionOptions({
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            });
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $42omo.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // Since we generated the uuid ourselves, we need to replace the document generated with
            // the annotationId that we received from the backend so things line up correctly
            result = selectionProps.onCreate(annotationId);
            if (result) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                setTimeout(()=>{
                    // Tell the renderer to set the new comment to active
                    if (emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                        annotationIds: [
                            annotationId
                        ],
                        // eventTarget: wrapperDOM,
                        eventTarget: document.getElementById(annotationId)
                    })) {
                        emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                            annotationId: annotationId
                        });
                        setNewlyCreatedAnnotationId(annotationId);
                    }
                // We need the timeout to give the document the chance to make the marks properly
                }, 250);
            } else throw new Error('Error ocurred when applying the step to the active document');
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null)
        }), [
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'not-page-or-doc';
    if ((0, $gEtAQ.isDatabase)() || (0, $gEtAQ.isWhiteboard)()) return 'not-page-or-doc';
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some((selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason
            });
        },
        /**
		 * This completes the init experience and starts the draft to publish experience.
		 */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("eb9uS", function(module, exports) {

let $02a9f582dc5ad461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $02a9f582dc5ad461$var$load("gRb4i"),
    $02a9f582dc5ad461$var$load("amEt1"),
    $02a9f582dc5ad461$var$load("6wr18"),
    $02a9f582dc5ad461$var$load("e2ujj"),
    $02a9f582dc5ad461$var$load("19uFC"),
    $02a9f582dc5ad461$var$load("gLGsg"),
    $02a9f582dc5ad461$var$load("3qsjq"),
    $02a9f582dc5ad461$var$load("lUlCu"),
    $02a9f582dc5ad461$var$load("ffEVr"),
    $02a9f582dc5ad461$var$load("aDjtG")
]).then(()=>parcelRequire('fJXL7'));

});

parcelRegister("4edSW", function(module, exports) {

let $31433d8eb19e1aba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $31433d8eb19e1aba$var$load("8JZKd"),
    $31433d8eb19e1aba$var$load("9Q8Ik"),
    $31433d8eb19e1aba$var$load("3FG3M"),
    $31433d8eb19e1aba$var$load("8eNS3"),
    $31433d8eb19e1aba$var$load("foT6i"),
    $31433d8eb19e1aba$var$load("kSBog"),
    $31433d8eb19e1aba$var$load("jwSno"),
    $31433d8eb19e1aba$var$load("6wr18"),
    $31433d8eb19e1aba$var$load("aFS1j"),
    $31433d8eb19e1aba$var$load("a4yJG"),
    $31433d8eb19e1aba$var$load("fzHDF"),
    $31433d8eb19e1aba$var$load("9sJzT"),
    $31433d8eb19e1aba$var$load("6XCf4"),
    $31433d8eb19e1aba$var$load("5pvpJ"),
    $31433d8eb19e1aba$var$load("ffEVr"),
    $31433d8eb19e1aba$var$load("1qlDN"),
    $31433d8eb19e1aba$var$load("1yVM6"),
    $31433d8eb19e1aba$var$load("651dU")
]).then(()=>parcelRequire('gDZU2'));

});

parcelRegister("lt6Lx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $cgtv4.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $8C5kA.default)();
    const { siteTitle: siteTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence")
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    if (typeof document !== 'undefined' && document.title && !contentTitle) {
        // If contentTitle is empty, we're likely setting a generic title (just siteTitle or siteTitle with space)
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title && !isHomePage) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement('script', {
                dangerouslySetInnerHTML: {
                    __html: `document.title=${(0, $8vxJi.stringifyForSSR)(title)};`
                }
            });
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("3P3RU", function(module, exports) {

let $2c8922b3b77bc987$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c8922b3b77bc987$var$load("6kXh6"),
    $2c8922b3b77bc987$var$load("lPQcc"),
    $2c8922b3b77bc987$var$load("kKNsN")
]).then(()=>parcelRequire('1vSpd'));

});

parcelRegister("lSOk7", function(module, exports) {

let $fee5ad55f752594a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fee5ad55f752594a$var$load("9A0ig"),
    $fee5ad55f752594a$var$load("bgQ4c"),
    $fee5ad55f752594a$var$load("aSVxo"),
    $fee5ad55f752594a$var$load("5Z6sY"),
    $fee5ad55f752594a$var$load("iK6Gk"),
    $fee5ad55f752594a$var$load("g5HUX"),
    $fee5ad55f752594a$var$load("kEwWf"),
    $fee5ad55f752594a$var$load("gtMen"),
    $fee5ad55f752594a$var$load("5zDuS"),
    $fee5ad55f752594a$var$load("gORtx"),
    $fee5ad55f752594a$var$load("6XCf4"),
    $fee5ad55f752594a$var$load("bunf9"),
    $fee5ad55f752594a$var$load("9XYQ9"),
    $fee5ad55f752594a$var$load("kUbUu"),
    $fee5ad55f752594a$var$load("7Q5vz"),
    $fee5ad55f752594a$var$load("2Cftu"),
    $fee5ad55f752594a$var$load("4i0CB"),
    $fee5ad55f752594a$var$load("7whwt"),
    $fee5ad55f752594a$var$load("6wr18"),
    $fee5ad55f752594a$var$load("kjZZD"),
    $fee5ad55f752594a$var$load("Wowvf"),
    $fee5ad55f752594a$var$load("7EorR"),
    $fee5ad55f752594a$var$load("hhss7"),
    $fee5ad55f752594a$var$load("c4Kdp"),
    $fee5ad55f752594a$var$load("1qlDN"),
    $fee5ad55f752594a$var$load("1yVM6"),
    $fee5ad55f752594a$var$load("ffEVr"),
    $fee5ad55f752594a$var$load("j6RYV")
]).then(()=>parcelRequire('5y7xd'));

});

parcelRegister("1Q4ws", function(module, exports) {

let $156e27d4e26b1157$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $156e27d4e26b1157$var$load("9XYQ9"),
    $156e27d4e26b1157$var$load("7WaUI"),
    $156e27d4e26b1157$var$load("iI4dx"),
    $156e27d4e26b1157$var$load("jfplD"),
    $156e27d4e26b1157$var$load("j2bbk"),
    $156e27d4e26b1157$var$load("8UKe0"),
    $156e27d4e26b1157$var$load("9VvWo"),
    $156e27d4e26b1157$var$load("a4yJG"),
    $156e27d4e26b1157$var$load("jle6Z"),
    $156e27d4e26b1157$var$load("fzHDF"),
    $156e27d4e26b1157$var$load("a0ogJ"),
    $156e27d4e26b1157$var$load("6wr18"),
    $156e27d4e26b1157$var$load("aL59j"),
    $156e27d4e26b1157$var$load("j4ThT"),
    $156e27d4e26b1157$var$load("5uN9h"),
    $156e27d4e26b1157$var$load("8JZKd"),
    $156e27d4e26b1157$var$load("1d7Ag"),
    $156e27d4e26b1157$var$load("1TOYq"),
    $156e27d4e26b1157$var$load("7Q5vz"),
    $156e27d4e26b1157$var$load("kiGNy"),
    $156e27d4e26b1157$var$load("ffEVr"),
    $156e27d4e26b1157$var$load("dkIUD")
]).then(()=>parcelRequire('l2J3i'));

});

parcelRegister("2kCzs", function(module, exports) {

let $1b2b5e637a3053c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b2b5e637a3053c9$var$load("2cLQd"),
    $1b2b5e637a3053c9$var$load("jU00k"),
    $1b2b5e637a3053c9$var$load("aHhj2"),
    $1b2b5e637a3053c9$var$load("6tsCm"),
    $1b2b5e637a3053c9$var$load("2SjHp"),
    $1b2b5e637a3053c9$var$load("7u5Uq"),
    $1b2b5e637a3053c9$var$load("3yM79"),
    $1b2b5e637a3053c9$var$load("5coOi"),
    $1b2b5e637a3053c9$var$load("7A5zJ"),
    $1b2b5e637a3053c9$var$load("6wr18"),
    $1b2b5e637a3053c9$var$load("1Jgsw"),
    $1b2b5e637a3053c9$var$load("4VOW6"),
    $1b2b5e637a3053c9$var$load("h2QhJ"),
    $1b2b5e637a3053c9$var$load("7EorR"),
    $1b2b5e637a3053c9$var$load("St9Nk"),
    $1b2b5e637a3053c9$var$load("eN6nL"),
    $1b2b5e637a3053c9$var$load("3qsjq"),
    $1b2b5e637a3053c9$var$load("hhss7"),
    $1b2b5e637a3053c9$var$load("ffEVr"),
    $1b2b5e637a3053c9$var$load("fNffa")
]).then(()=>parcelRequire('7MAGI'));

});

parcelRegister("2RoXr", function(module, exports) {

let $2153e416366a55c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2153e416366a55c2$var$load("kFOec"),
    $2153e416366a55c2$var$load("9VvWo"),
    $2153e416366a55c2$var$load("3qsjq"),
    $2153e416366a55c2$var$load("lUlCu"),
    $2153e416366a55c2$var$load("cS7dz")
]).then(()=>parcelRequire('ec8HN'));

});

parcelRegister("iEUAa", function(module, exports) {

let $d957da7a44e77950$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d957da7a44e77950$var$load("IyjLX").then(()=>parcelRequire('esu8h'));

});

parcelRegister("ipfH1", function(module, exports) {

let $d666bc0d98260477$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d666bc0d98260477$var$load("7S9EX").then(()=>parcelRequire('3VmKy'));

});

parcelRegister("hwzJf", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a0c1672298304318$export$c34c105fee6e8977 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JsB5i",
    name: "GoToHomeLoader",
    loader: async ()=>(await (parcelRequire("dsUTi"))).GoToHome
});
module.exports["GoToHomeLoader"] = $a0c1672298304318$export$c34c105fee6e8977;

});

parcelRegister("dsUTi", function(module, exports) {

let $9cda053f51048b8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9cda053f51048b8c$var$load("c0lrw").then(()=>parcelRequire('7QGXJ'));

});

parcelRegister("idSff", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d4a3e046810f681f$export$1fe963e8f052ccbb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VM3qQ",
    name: "SiteHomepageRedirectLoader",
    loader: async ()=>(await (parcelRequire("azb28"))).SiteHomepageRedirect
});
module.exports["SiteHomepageRedirectLoader"] = $d4a3e046810f681f$export$1fe963e8f052ccbb;

});

parcelRegister("azb28", function(module, exports) {

let $7b15bb4474603b49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b15bb4474603b49$var$load("cgZOp").then(()=>parcelRequire('kkwpp'));

});

parcelRegister("8MiHL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $664150cfb8454085$export$325f108b642b51d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EdgKX",
    name: "LazyRouteToRightEditor",
    loader: ()=>(parcelRequire("cAdZk"))
});
module.exports["LazyRouteToRightEditor"] = $664150cfb8454085$export$325f108b642b51d;

});

parcelRegister("cAdZk", function(module, exports) {

let $025d388edb8d286f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $025d388edb8d286f$var$load("ait7e").then(()=>parcelRequire('ihMq7'));

});

parcelRegister("4JvlJ", function(module, exports) {

let $3723aec551358c7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3723aec551358c7f$var$load("huI9u"),
    $3723aec551358c7f$var$load("kgxfY"),
    $3723aec551358c7f$var$load("3yM79"),
    $3723aec551358c7f$var$load("bgQ4c"),
    $3723aec551358c7f$var$load("aSVxo"),
    $3723aec551358c7f$var$load("5Z6sY"),
    $3723aec551358c7f$var$load("3j5P3"),
    $3723aec551358c7f$var$load("dclpt"),
    $3723aec551358c7f$var$load("tKhaz"),
    $3723aec551358c7f$var$load("4VOW6"),
    $3723aec551358c7f$var$load("attzI"),
    $3723aec551358c7f$var$load("iK6Gk"),
    $3723aec551358c7f$var$load("g5HUX"),
    $3723aec551358c7f$var$load("9A0ig"),
    $3723aec551358c7f$var$load("fSV9f"),
    $3723aec551358c7f$var$load("h2QhJ"),
    $3723aec551358c7f$var$load("ioxaT"),
    $3723aec551358c7f$var$load("kEwWf"),
    $3723aec551358c7f$var$load("gtMen"),
    $3723aec551358c7f$var$load("7WaUI"),
    $3723aec551358c7f$var$load("3Kg3S"),
    $3723aec551358c7f$var$load("2F69B"),
    $3723aec551358c7f$var$load("5zDuS"),
    $3723aec551358c7f$var$load("gORtx"),
    $3723aec551358c7f$var$load("6XCf4"),
    $3723aec551358c7f$var$load("bunf9"),
    $3723aec551358c7f$var$load("9XYQ9"),
    $3723aec551358c7f$var$load("edPhJ"),
    $3723aec551358c7f$var$load("fTFcV"),
    $3723aec551358c7f$var$load("kUbUu"),
    $3723aec551358c7f$var$load("7Q5vz"),
    $3723aec551358c7f$var$load("2Cftu"),
    $3723aec551358c7f$var$load("4i0CB"),
    $3723aec551358c7f$var$load("7whwt"),
    $3723aec551358c7f$var$load("kjZZD"),
    $3723aec551358c7f$var$load("Wowvf"),
    $3723aec551358c7f$var$load("hhss7"),
    $3723aec551358c7f$var$load("c4Kdp"),
    $3723aec551358c7f$var$load("1qlDN"),
    $3723aec551358c7f$var$load("1yVM6"),
    $3723aec551358c7f$var$load("6wr18"),
    $3723aec551358c7f$var$load("l3dqd"),
    $3723aec551358c7f$var$load("70qyO"),
    $3723aec551358c7f$var$load("gLGsg"),
    $3723aec551358c7f$var$load("ffEVr"),
    $3723aec551358c7f$var$load("7EorR"),
    $3723aec551358c7f$var$load("aHCaB"),
    $3723aec551358c7f$var$load("lwNze")
]).then(()=>parcelRequire('dJsyi'));

});

parcelRegister("hk8wA", function(module, exports) {

let $c9caeac14d6e5787$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9caeac14d6e5787$var$load("7u5Uq"),
    $c9caeac14d6e5787$var$load("bgQ4c"),
    $c9caeac14d6e5787$var$load("5Z6sY"),
    $c9caeac14d6e5787$var$load("3j5P3"),
    $c9caeac14d6e5787$var$load("dclpt"),
    $c9caeac14d6e5787$var$load("tKhaz"),
    $c9caeac14d6e5787$var$load("4VOW6"),
    $c9caeac14d6e5787$var$load("attzI"),
    $c9caeac14d6e5787$var$load("g5HUX"),
    $c9caeac14d6e5787$var$load("9A0ig"),
    $c9caeac14d6e5787$var$load("fSV9f"),
    $c9caeac14d6e5787$var$load("a0ybh"),
    $c9caeac14d6e5787$var$load("h2QhJ"),
    $c9caeac14d6e5787$var$load("ioxaT"),
    $c9caeac14d6e5787$var$load("kEwWf"),
    $c9caeac14d6e5787$var$load("cLdBj"),
    $c9caeac14d6e5787$var$load("9XYQ9"),
    $c9caeac14d6e5787$var$load("edPhJ"),
    $c9caeac14d6e5787$var$load("fTFcV"),
    $c9caeac14d6e5787$var$load("3z2v3"),
    $c9caeac14d6e5787$var$load("6wr18"),
    $c9caeac14d6e5787$var$load("do7fn"),
    $c9caeac14d6e5787$var$load("dlm6q"),
    $c9caeac14d6e5787$var$load("1Jgsw"),
    $c9caeac14d6e5787$var$load("4eboO"),
    $c9caeac14d6e5787$var$load("2F69B"),
    $c9caeac14d6e5787$var$load("5zDuS"),
    $c9caeac14d6e5787$var$load("9ijrN"),
    $c9caeac14d6e5787$var$load("7EorR"),
    $c9caeac14d6e5787$var$load("awqCy"),
    $c9caeac14d6e5787$var$load("4g2Mj"),
    $c9caeac14d6e5787$var$load("fZt2F"),
    $c9caeac14d6e5787$var$load("6O8m6"),
    $c9caeac14d6e5787$var$load("5GxU8"),
    $c9caeac14d6e5787$var$load("amUNi"),
    $c9caeac14d6e5787$var$load("699ae"),
    $c9caeac14d6e5787$var$load("i7QCq"),
    $c9caeac14d6e5787$var$load("let0D"),
    $c9caeac14d6e5787$var$load("2bmVk"),
    $c9caeac14d6e5787$var$load("ffEVr"),
    $c9caeac14d6e5787$var$load("hhss7"),
    $c9caeac14d6e5787$var$load("7Omhy"),
    $c9caeac14d6e5787$var$load("kC80R"),
    $c9caeac14d6e5787$var$load("dUTj8"),
    $c9caeac14d6e5787$var$load("5MpJT")
]).then(()=>parcelRequire('7cCRg'));

});

parcelRegister("gZQYc", function(module, exports) {

let $c5fb6e91de01b2ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5fb6e91de01b2ea$var$load("9sJzT"),
    $c5fb6e91de01b2ea$var$load("6XCf4"),
    $c5fb6e91de01b2ea$var$load("5CaYW"),
    $c5fb6e91de01b2ea$var$load("5pvpJ"),
    $c5fb6e91de01b2ea$var$load("1qlDN"),
    $c5fb6e91de01b2ea$var$load("1yVM6"),
    $c5fb6e91de01b2ea$var$load("iO7VA")
]).then(()=>parcelRequire('4CchY'));

});

parcelRegister("iXUzT", function(module, exports) {

let $dce99fdec626f024$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dce99fdec626f024$var$load("3cI3U").then(()=>parcelRequire('5CzWQ'));

});

parcelRegister("7b5IB", function(module, exports) {

let $539dff0aaff945ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $539dff0aaff945ac$var$load("8Kivm"),
    $539dff0aaff945ac$var$load("hUIij"),
    $539dff0aaff945ac$var$load("6Up0b"),
    $539dff0aaff945ac$var$load("lnKog"),
    $539dff0aaff945ac$var$load("iQ0Jm"),
    $539dff0aaff945ac$var$load("5n2uM")
]).then(()=>parcelRequire('bexnX'));

});

parcelRegister("8R4tZ", function(module, exports) {

let $6726c0218d17ed6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6726c0218d17ed6d$var$load("lHNSl").then(()=>parcelRequire('8fbPW'));

});

parcelRegister("4pErf", function(module, exports) {

let $3368dd75d2c90463$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3368dd75d2c90463$var$load("vlZ5n").then(()=>parcelRequire('i5MLu'));

});

parcelRegister("dqpQq", function(module, exports) {

let $9c61c046eed2863a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c61c046eed2863a$var$load("hsAS2").then(()=>parcelRequire('6PsK0'));

});

parcelRegister("fFYfK", function(module, exports) {

let $b6996c5661b1fc74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6996c5661b1fc74$var$load("6wr18"),
    $b6996c5661b1fc74$var$load("hHrTM"),
    $b6996c5661b1fc74$var$load("4rKYa"),
    $b6996c5661b1fc74$var$load("ffEVr"),
    $b6996c5661b1fc74$var$load("2NgQt")
]).then(()=>parcelRequire('cPinp'));

});

parcelRegister("eUF5C", function(module, exports) {

let $adb62b380d09277c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $adb62b380d09277c$var$load("gLGsg"),
    $adb62b380d09277c$var$load("6wr18"),
    $adb62b380d09277c$var$load("2DNIK"),
    $adb62b380d09277c$var$load("eIzhm"),
    $adb62b380d09277c$var$load("huI9u"),
    $adb62b380d09277c$var$load("2Mq3f"),
    $adb62b380d09277c$var$load("lPQcc"),
    $adb62b380d09277c$var$load("g5HUX"),
    $adb62b380d09277c$var$load("8JZKd"),
    $adb62b380d09277c$var$load("kTv6A"),
    $adb62b380d09277c$var$load("9A0ig"),
    $adb62b380d09277c$var$load("9sJzT"),
    $adb62b380d09277c$var$load("6XCf4"),
    $adb62b380d09277c$var$load("5pvpJ"),
    $adb62b380d09277c$var$load("1qlDN"),
    $adb62b380d09277c$var$load("1yVM6"),
    $adb62b380d09277c$var$load("ffEVr"),
    $adb62b380d09277c$var$load("faxwR")
]).then(()=>parcelRequire('eHKVU'));

});

parcelRegister("6X7p0", function(module, exports) {

let $50fdfeb8e13c3bd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $50fdfeb8e13c3bd4$var$load("gLGsg"),
    $50fdfeb8e13c3bd4$var$load("6wr18"),
    $50fdfeb8e13c3bd4$var$load("3DC6Y"),
    $50fdfeb8e13c3bd4$var$load("1wMt1"),
    $50fdfeb8e13c3bd4$var$load("kJDIu"),
    $50fdfeb8e13c3bd4$var$load("4UClM"),
    $50fdfeb8e13c3bd4$var$load("lQZYM"),
    $50fdfeb8e13c3bd4$var$load("a4mwL"),
    $50fdfeb8e13c3bd4$var$load("4EFsN"),
    $50fdfeb8e13c3bd4$var$load("hHrTM"),
    $50fdfeb8e13c3bd4$var$load("fjOTL"),
    $50fdfeb8e13c3bd4$var$load("eNZNF"),
    $50fdfeb8e13c3bd4$var$load("8UKe0"),
    $50fdfeb8e13c3bd4$var$load("9sJzT"),
    $50fdfeb8e13c3bd4$var$load("5uN9h"),
    $50fdfeb8e13c3bd4$var$load("6XCf4"),
    $50fdfeb8e13c3bd4$var$load("5pvpJ"),
    $50fdfeb8e13c3bd4$var$load("ffEVr"),
    $50fdfeb8e13c3bd4$var$load("1qlDN"),
    $50fdfeb8e13c3bd4$var$load("1yVM6"),
    $50fdfeb8e13c3bd4$var$load("gYbv6")
]).then(()=>parcelRequire('9qsRH'));

});

parcelRegister("fVdPo", function(module, exports) {

let $b976e7d28125bbd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b976e7d28125bbd8$var$load("83Dnz").then(()=>parcelRequire('1e8Au'));

});

parcelRegister("9TVBV", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1KmJq = parcelRequire("1KmJq");


var $laHi9 = parcelRequire("laHi9");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $1BYn9 = parcelRequire("1BYn9");


var $9wGTI = parcelRequire("9wGTI");


var $hpRYU = parcelRequire("hpRYU");


var $1NBp8 = parcelRequire("1NBp8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $iquRY = parcelRequire("iquRY");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $70228f3077c41fe6$export$e57870671ec2468e = /*#__PURE__*/ function(BulkSetSpacePermissionSpaceType) {
    BulkSetSpacePermissionSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkSetSpacePermissionSpaceType["GLOBAL"] = "GLOBAL";
    BulkSetSpacePermissionSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkSetSpacePermissionSpaceType["PERSONAL"] = "PERSONAL";
    return BulkSetSpacePermissionSpaceType;
}({});
var $70228f3077c41fe6$export$8b2051573ac4b3d5 = /*#__PURE__*/ function(BulkSetSpacePermissionSubjectType) {
    BulkSetSpacePermissionSubjectType["GROUP"] = "GROUP";
    BulkSetSpacePermissionSubjectType["USER"] = "USER";
    return BulkSetSpacePermissionSubjectType;
}({});
var $70228f3077c41fe6$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});






var $gtD4K = parcelRequire("gtD4K");


var $aoVih = parcelRequire("aoVih");




const $0d65445224ec1da1$export$ebaaa2fd42680a02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: 'bulk-permissions.space.removal-warning.non-final',
        defaultMessage: '<b>Permission to view is not selected. This will remove the user or group from all spaces.</b>',
        description: 'Warning text telling the user that they are removing permissions for a user or group.',
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    })));



var $8A6YM = parcelRequire("8A6YM");

















/* BulkSpacePermissionsTable.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");







var $gEpEw = parcelRequire("gEpEw");


var $7gpC4 = parcelRequire("7gpC4");





var $eicAg = parcelRequire("eicAg");


var $yuLaV = parcelRequire("yuLaV");


var $jhwJP = parcelRequire("jhwJP");



var $9TVBV = parcelRequire("9TVBV");

const $7a1206d786c0ab1b$var$groupI18nBase = (0, $cgtv4.defineMessages)({
    selectAll: {
        id: "bulk-permissions.space.table.header.group.select-all",
        defaultMessage: "Select all"
    },
    all: {
        id: "bulk-permissions.space.table.header.group.all",
        defaultMessage: "All"
    },
    pages: {
        id: "bulk-permissions.space.table.header.group.pages",
        defaultMessage: "Pages"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds",
        defaultMessage: "Pages and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases",
        defaultMessage: "Pages, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds",
        defaultMessage: "Pages, whiteboards, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds",
        defaultMessage: "Pages, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds",
        defaultMessage: "Pages, whiteboards, databases, and Smart Links"
    },
    blogs: {
        id: "bulk-permissions.space.table.header.group.blogs",
        defaultMessage: "Blogs"
    },
    comments: {
        id: "bulk-permissions.space.table.header.group.comments",
        defaultMessage: "Comments"
    },
    attachments: {
        id: "bulk-permissions.space.table.header.group.attachments",
        defaultMessage: "Attachments"
    },
    restrictions: {
        id: "bulk-permissions.space.table.header.group.restrictions",
        defaultMessage: "Restrictions"
    },
    mail: {
        id: "bulk-permissions.space.table.header.group.mail",
        defaultMessage: "Mail"
    },
    space: {
        id: "bulk-permissions.space.table.header.group.space",
        defaultMessage: "Space"
    }
});
const $7a1206d786c0ab1b$var$groupI18nLiveDocs = (0, $cgtv4.defineMessages)({
    pages: {
        id: "bulk-permissions.space.table.header.group.pages.livedocs",
        defaultMessage: "Pages and live docs"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds.livedocs",
        defaultMessage: "Pages, live docs, and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    }
});
const $7a1206d786c0ab1b$var$groupI18n = (0, $jhwJP.mergeLiveDocI18n)($7a1206d786c0ab1b$var$groupI18nBase, $7a1206d786c0ab1b$var$groupI18nLiveDocs);
const $7a1206d786c0ab1b$var$columnI18n = (0, $cgtv4.defineMessages)({
    view: {
        id: "bulk-permissions.space.table.header.column.view",
        defaultMessage: "View"
    },
    deleteOwn: {
        id: "bulk-permissions.space.table.header.column.delete-own",
        defaultMessage: "Delete own"
    },
    add: {
        id: "bulk-permissions.space.table.header.column.Add",
        defaultMessage: "Add"
    },
    delete: {
        id: "bulk-permissions.space.table.header.column.delete",
        defaultMessage: "Delete"
    },
    archive: {
        id: "bulk-permissions.space.table.header.column.archive",
        defaultMessage: "Archive"
    },
    addDelete: {
        id: "bulk-permissions.space.table.header.column.add-delete",
        defaultMessage: "Add/Delete"
    },
    export: {
        id: "bulk-permissions.space.table.header.column.export",
        defaultMessage: "Export"
    },
    admin: {
        id: "bulk-permissions.space.table.header.column.admin",
        defaultMessage: "Admin"
    }
});
const $7a1206d786c0ab1b$var$i18n = (0, $cgtv4.defineMessages)({
    allViewTooltipContent: {
        id: "bulk-permissions.space.table.header.allViewTooltipContent",
        defaultMessage: "View permission determines who has access to the space."
    },
    allViewTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.allViewTooltipIconLabel",
        defaultMessage: "Learn more about view permissions"
    },
    deleteOwnTooltipContent: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipContent",
        defaultMessage: "Lets users delete their own content and attachments. (For comments, the \u201CAdd\u201D permission includes \u201CDelete Own\u201D)"
    },
    deleteOwnTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipIconLabel",
        defaultMessage: "Learn more about delete own"
    },
    restrictionsTooltipContent: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipContent",
        defaultMessage: "Lets users add and remove restrictions directly on content. Does not affect inherited restrictions."
    },
    restrictionsTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipIconLabel",
        defaultMessage: "Restrictions Add/Delete tooltip"
    }
});
const $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL = 'SELECT_ALL';
const $7a1206d786c0ab1b$var$CELL_BORDER = {
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$TableWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo1wug _19pkv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$CheckboxWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $7a1206d786c0ab1b$export$92f022c5db01744 = {
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE]: false
};
const $7a1206d786c0ab1b$export$2f227e4ea23eeffd = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions })=>{
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isSelectAllCheckbox, setSelectAllCheckbox] = (0, $42omo.useState)(false);
    spacePermissions.forEach((val)=>{
        $7a1206d786c0ab1b$export$92f022c5db01744[val] = true;
    });
    const [checkboxValues, setCheckboxValues] = (0, $42omo.useState)($7a1206d786c0ab1b$export$92f022c5db01744);
    (0, $42omo.useEffect)(()=>{
        Object.keys(checkboxValues).forEach((val)=>{
            checkboxValues[val] = false;
        });
        spacePermissions.forEach((val)=>{
            checkboxValues[val] = true;
        });
        setCheckboxValues(checkboxValues);
        checkSelectAllCheckbox(checkboxValues);
    }, [
        spacePermissions,
        checkboxValues
    ]);
    const getContentGroupName = (_isWhiteboardsEnabled, _isDatabasesEnabled)=>{
        if (!_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesEmbeds);
        else if (_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsEmbeds);
        else if (!_isWhiteboardsEnabled && _isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesDatabasesEmbeds);
        else return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsDatabasesEmbeds);
    };
    const groupNames = {
        SELECT_ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.selectAll),
        ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.all),
        CONTENT: getContentGroupName(isWhiteboardsEnabled, isDatabasesEnabled),
        BLOGS: formatMessage($7a1206d786c0ab1b$var$groupI18n.blogs),
        COMMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.comments),
        ATTACHMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.attachments),
        RESTRICTIONS: formatMessage($7a1206d786c0ab1b$var$groupI18n.restrictions),
        MAIL: formatMessage($7a1206d786c0ab1b$var$groupI18n.mail),
        SPACE: formatMessage($7a1206d786c0ab1b$var$groupI18n.space)
    };
    const columnNames = {
        VIEW: formatMessage($7a1206d786c0ab1b$var$columnI18n.view),
        DELETE_OWN: formatMessage($7a1206d786c0ab1b$var$columnI18n.deleteOwn),
        ADD: formatMessage($7a1206d786c0ab1b$var$columnI18n.add),
        DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.delete),
        ARCHIVE: formatMessage($7a1206d786c0ab1b$var$columnI18n.archive),
        ADD_DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.addDelete),
        EXPORT: formatMessage($7a1206d786c0ab1b$var$columnI18n.export),
        ADMIN: formatMessage($7a1206d786c0ab1b$var$columnI18n.admin)
    };
    const permissionsTableHeaders = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: "",
                columnName: groupNames.SELECT_ALL
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.VIEW,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.allViewTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.allViewTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.DELETE_OWN,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipIconLabel
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.ADD
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                showGroupName: true,
                groupName: groupNames.CONTENT,
                columnName: columnNames.ARCHIVE,
                centerGroupName: true,
                setWidth: true
            }),
            inlineStyles: {
                maxWidth: "var(--ds-space-1000, 80px)"
            }
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.RESTRICTIONS,
                columnName: columnNames.ADD_DELETE,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.EXPORT,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.ADMIN
            })
        }
    ];
    const updateSpacePermissions = (checkboxValues)=>{
        setSpacePermissions(Object.keys(checkboxValues).filter((val)=>checkboxValues[val]));
    };
    const checkSelectAllCheckbox = (valuesObject)=>{
        if (Object.values(valuesObject).every((v)=>{
            return v;
        })) setSelectAllCheckbox(true);
        else setSelectAllCheckbox(false);
    };
    const getAriaLabel = (checkBox)=>{
        switch(checkBox){
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE:
                return `${columnNames.VIEW} ${groupNames.ALL}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT:
                return `${columnNames.DELETE_OWN} ${groupNames.ALL}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE:
                return `${columnNames.ADD} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE:
                return `${columnNames.ARCHIVE} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE:
                return `${columnNames.DELETE} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG:
                return `${columnNames.ADD} ${groupNames.BLOGS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG:
                return `${columnNames.DELETE} ${groupNames.BLOGS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT:
                return `${columnNames.ADD} ${groupNames.COMMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT:
                return `${columnNames.DELETE} ${groupNames.COMMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT:
                return `${columnNames.ADD} ${groupNames.ATTACHMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT:
                return `${columnNames.DELETE} ${groupNames.ATTACHMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS:
                return `${columnNames.ADD_DELETE} ${groupNames.RESTRICTIONS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE:
                return `${columnNames.EXPORT} ${groupNames.SPACE}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE:
                return `${columnNames.ADMIN} ${groupNames.SPACE}`;
        }
    };
    const PermissionsTableCheckBox = ({ spacePermission: spacePermission })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            testId: `bulk-space-permissions-table-checkbox-${spacePermission}`,
            "aria-label": getAriaLabel(spacePermission),
            isChecked: getCheckedValue(spacePermission),
            isDisabled: spacePermission === (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE ? false : isDisabled(),
            onChange: ()=>{
                checkboxValues[spacePermission] = !checkboxValues[spacePermission];
                setCheckboxValues(checkboxValues);
                checkSelectAllCheckbox(checkboxValues);
                updateSpacePermissions(checkboxValues);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        actionSubject: 'checkbox',
                        action: 'clicked',
                        actionSubjectId: spacePermission,
                        source: (0, $9TVBV.ANALYTICS_SOURCE),
                        attributes: {
                            value: checkboxValues[spacePermission]
                        }
                    }
                }).fire();
            }
        }));
    };
    const handleSelectAllChange = ()=>{
        setSelectAllCheckbox(!isSelectAllCheckbox);
        Object.keys(checkboxValues).map((val)=>{
            checkboxValues[val] = !isSelectAllCheckbox;
        });
        setCheckboxValues(checkboxValues);
        updateSpacePermissions(checkboxValues);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'checkbox',
                action: 'clicked',
                actionSubjectId: 'COLUMN_KEY_SELECT_ALL',
                source: (0, $9TVBV.ANALYTICS_SOURCE),
                attributes: {
                    value: isSelectAllCheckbox
                }
            }
        }).fire();
    };
    const isDisabled = ()=>{
        return !checkboxValues[(0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE];
    };
    const getCheckedValue = (itemId)=>{
        return checkboxValues[itemId];
    };
    const checkboxes = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
                testId: "bulk-space-permissions-table-checkbox-SELECT_ALL",
                "aria-label": groupNames.SELECT_ALL,
                isChecked: isSelectAllCheckbox,
                isDisabled: false,
                onChange: handleSelectAllChange
            }))
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE
            })
        }
    ];
    const rowData = [
        checkboxValues
    ].map(()=>({
            key: `checkboxes`,
            cells: checkboxes
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7a1206d786c0ab1b$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gEpEw.default), {
        head: {
            cells: permissionsTableHeaders
        },
        rows: rowData,
        testId: "bulk-space-permissions-table"
    }));
};


const $ac9ac80a1cd63f38$var$i18n = (0, $cgtv4.defineMessages)({
    permissionsSelectionHeader: {
        id: "bulk-permissions.space.permissions-selection-header",
        defaultMessage: "Choose space permissions"
    },
    permissionsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext",
        defaultMessage: "Select which permissions the user or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsWithTeamsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext-with-teams",
        defaultMessage: "Select which permissions the user, team or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsSelectionSubtextAdditional: {
        id: "bulk-permissions.space.permissions-selection-subtext-additional",
        defaultMessage: "To remove permissions from all spaces, uncheck the view permission."
    }
});
const $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $ac9ac80a1cd63f38$var$subtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ac9ac80a1cd63f38$export$15775f46ef52c627 = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$subtextStyle
    }, formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $ac9ac80a1cd63f38$var$i18n.permissionsWithTeamsSelectionSubtext : $ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.200"
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtextAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7a1206d786c0ab1b$export$2f227e4ea23eeffd), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions
    }));
};



var $eIwUX = parcelRequire("eIwUX");





var $6xdDU = parcelRequire("6xdDU");


var $lsxnT = parcelRequire("lsxnT");


var $67Foi = parcelRequire("67Foi");


var $lM2MU = parcelRequire("lM2MU");










var $eEA8O = parcelRequire("eEA8O");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");




var $1GzhS = parcelRequire("1GzhS");






const $e9f437038d263d04$var$i18n = (0, $cgtv4.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to selected spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> (excluding personal) on your site with the selected permissions."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site with the selected permissions."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site with the selected permissions."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from selected spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove from all"
    }
});
const $e9f437038d263d04$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $e9f437038d263d04$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
const $e9f437038d263d04$export$b8704437d11c7fe7 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...isRemoval ? $e9f437038d263d04$var$i18n.removeConfirmationDialogTitle : $e9f437038d263d04$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $e9f437038d263d04$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$e9f437038d263d04$var$i18n.confirmationDialogWarning,
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e9f437038d263d04$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), isRemoval ? $e9f437038d263d04$var$i18n.removeButtonText : $e9f437038d263d04$var$i18n.addButtonText))));
};


const $0e3e25b83ca7a775$export$a9b83e32db9bc573 = ({ principalName: principalName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-space-permissions-dialog",
        id: "bulk-space-permissions-dialog",
        attributes: isRemoval ? {
            action: 'remove'
        } : {
            action: 'add'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        testId: "bulk-space-permissions-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e9f437038d263d04$export$b8704437d11c7fe7), {
        principalName: principalName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};



var $kAGh9 = parcelRequire("kAGh9");

const $eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation = (0, $eSUdr.default)`mutation BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation($spacePermissions:[SpacePermissionType]!$spaceTypes:[BulkSetSpacePermissionSpaceType]!$subjectId:ID!$subjectType:BulkSetSpacePermissionSubjectType!){bulkSetSpacePermissionAsync(input:{spacePermissions:$spacePermissions spaceTypes:$spaceTypes subjectId:$subjectId subjectType:$subjectType}){success errors{message extensions{errorType statusCode}}taskId}}`;
const $eb8c51b94819be10$export$f7109619a5e9e0d6 = 'bulkSpacePermissionsScreen';
const $eb8c51b94819be10$export$c4b5d6610bc5fc6e = (0, $cgtv4.defineMessages)({
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link",
        defaultMessage: "Space permissions"
    },
    bulkAddHeader: {
        id: "bulk-permissions.space.header",
        defaultMessage: "Add people to all spaces"
    },
    titleSubtext: {
        id: "bulk-permissions.space.title-subtext",
        defaultMessage: "Quickly add (or remove) an individual user or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    titleSubtextWithTeams: {
        id: "bulk-permissions.space.title-subtext-teams",
        defaultMessage: "Quickly add (or remove) an individual user, team or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    userPickerHeader: {
        id: "bulk-permissions.space.user-picker-header",
        defaultMessage: "Choose who to add or remove<asterisk>*</asterisk>"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext",
        defaultMessage: "You may only select one for this action."
    },
    asyncSuccessFlagTitle: {
        id: "bulk-permissions.space.async.update.success-flag-title",
        defaultMessage: "Bulk permissions change processing"
    },
    asyncSuccessFlagDescription: {
        id: "bulk-permissions.space.async.update.success-flag-description",
        defaultMessage: "These changes can take a while. We\u2019ll notify you when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.space.error-flag-title",
        defaultMessage: "Bulk permissions change failed"
    },
    errorFlagDescription: {
        id: "bulk-permissions.space.error-flag-description",
        defaultMessage: "We ran into a problem completing your bulk permissions change. Try again."
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Enter a person or group"
    },
    userPickerWithTeamsPlaceholder: {
        id: "bulk-permissions.space.user-picker-with-teams-placeholder",
        defaultMessage: "Enter a person, team or group"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemove: {
        id: "bulk-permissions.space.apply-button-text-remove",
        defaultMessage: "Remove from all"
    }
});
const $eb8c51b94819be10$var$bulkAddHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$bulkSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$userPickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $eb8c51b94819be10$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $eb8c51b94819be10$var$userPickerFineTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000'
});
const $eb8c51b94819be10$var$backButtonStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$userPickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $eb8c51b94819be10$var$requirementMessageStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$getPrincipalId = (principal)=>{
    if (!principal || Array.isArray(principal)) return '';
    const principalData = principal;
    return principalData.id || '';
};
const $eb8c51b94819be10$export$405a6cc8f1c994c8 = (0, $7aRa9.withFlags)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [spacePermissions, setSpacePermissions] = (0, $42omo.useState)([
        (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
    ]);
    const [stagedPrincipal, setStagedPrincipal] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    const [spaceSelection, setSpaceSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [showDialog, setShowDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const isRemoval = !spacePermissions.includes((0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE);
    const closeDialog = (0, $42omo.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const setInitState = (0, $42omo.useCallback)(()=>{
        setStagedPrincipal(undefined);
        setSpaceSelection((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
        setSpacePermissions([
            (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
        ]);
    }, []);
    const onMutationErrored = (0, $42omo.useCallback)((error)=>{
        closeDialog();
        flags.showErrorFlag({
            id: 'bulk-space-permissions.add.error',
            title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagTitle),
            description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagDescription),
            isAutoDismiss: true
        });
        experienceTracker.stopOnError({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: error
        });
    }, [
        closeDialog,
        flags,
        intl,
        experienceTracker
    ]);
    const onAsyncMutationSubmitted = (0, $42omo.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetSpacePermissionAsync?.errors?.length > 0) onMutationErrored(new Error('Bulk space permissions mutation failed', data?.bulkSetSpacePermissionAsync?.errors));
        else {
            flags.showSuccessFlag({
                id: 'bulk-space-permissions.async.update.success',
                title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagTitle),
                description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagDescription),
                isAutoDismiss: true
            });
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        }
        setInitState();
    }, [
        closeDialog,
        setInitState,
        onMutationErrored,
        flags,
        intl,
        experienceTracker
    ]);
    const getBulkSpacePermissionSubjectType = (0, $42omo.useCallback)(()=>{
        if (!stagedPrincipal || Array.isArray(stagedPrincipal)) return (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).USER;
        const principalData = stagedPrincipal;
        return principalData.type === 'user' ? (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).USER : (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).GROUP;
    }, [
        stagedPrincipal
    ]);
    const getBulkSpacePermissionSpaceType = (0, $42omo.useCallback)(()=>{
        switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).GLOBAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).COLLABORATION,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).PERSONAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).GLOBAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).COLLABORATION,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).PERSONAL
                ];
            default:
                return [
                    null
                ];
        }
    }, [
        spaceSelection
    ]);
    const [bulkUpdateAsync, { loading: asyncLoading, error: asyncError }] = (0, $1KmJq.useMutation)($eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: (err)=>{
            closeDialog();
            onMutationErrored(err);
        },
        variables: {
            spacePermissions: spacePermissions,
            subjectType: getBulkSpacePermissionSubjectType(),
            subjectId: $eb8c51b94819be10$var$getPrincipalId(stagedPrincipal),
            spaceTypes: getBulkSpacePermissionSpaceType()
        }
    });
    const openDialog = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
        setShowDialog(true);
    }, [
        setShowDialog,
        experienceTracker
    ]);
    const handleBackClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceRadioChange = (0, $42omo.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkSpacePermissionsType',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $42omo.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received && !Array.isArray(received)) {
            const principalData = received;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'principal',
                    action: 'selected',
                    actionSubjectId: 'bulkSpacePermissionsPrincipal',
                    source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                    attributes: {
                        principal: principalData.type,
                        verified: principalData.type === 'team' ? principalData.verified : 'N/A'
                    }
                }
            }).fire();
        }
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const onDialogConfirm = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsConfirm',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    verified: stagedPrincipal?.type === 'team' ? stagedPrincipal?.verified : 'N/A',
                    principal: stagedPrincipal?.type,
                    action: isRemoval ? 'remove' : 'add'
                }
            }
        }).fire();
        bulkUpdateAsync();
    }, [
        createAnalyticsEvent,
        bulkUpdateAsync,
        isRemoval,
        stagedPrincipal
    ]);
    const onDialogCancel = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsCancel',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
        closeDialog();
        experienceTracker.abort({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            reason: 'User closed the dialog'
        });
    }, [
        createAnalyticsEvent,
        experienceTracker,
        closeDialog
    ]);
    // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIwUX.RestrictedView), null);
    const pickerResultsFilter = (options)=>{
        // TEMPORARY WORKAROUND:
        // Smart User Picker does not currently expose a reliable field to identify guest users.
        // We're using the presence of the "GUEST" lozenge as a proxy to filter out guest users.
        // This should be revisited once the platform team adds a proper field
        // to accurately indicate guest status.
        return options.filter((option)=>{
            const { lozenge: lozenge } = option;
            const isGuest = typeof lozenge === 'object' && lozenge !== null && 'text' in lozenge && lozenge.text === 'GUEST';
            return !isGuest;
        });
    };
    const placeholderText = intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerWithTeamsPlaceholder : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerPlaceholder);
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kAGh9.BulkAccessManagementPage), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, asyncError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: asyncError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$backButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.backToSpacePermissions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkAddHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.bulkAddHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkSubtextStyle
    }, intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtextWithTeams : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: placeholderText,
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: true,
        placeholder: placeholderText,
        // @ts-ignore - Type 'null' is not assignable to type 'string | ((input: { inputValue: string; }) => string | null)'
        // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
        // This error was introduced after upgrading to TypeScript 5
        noOptionsMessage: null,
        onChange: onPrincipalChange,
        value: stagedPrincipal || [],
        smartFilterOptions: pickerResultsFilter,
        includeTeams: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals'),
        includeTeamsUpdates: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerFineTextStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceRadioChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac9ac80a1cd63f38$export$15775f46ef52c627), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions
    }), isRemoval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0d65445224ec1da1$export$ebaaa2fd42680a02), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: openDialog,
        isDisabled: stagedPrincipal === undefined
    }, intl.formatMessage(isRemoval ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextRemove : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $eb8c51b94819be10$var$requirementMessageStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0e3e25b83ca7a775$export$a9b83e32db9bc573), {
        principalName: !stagedPrincipal || Array.isArray(stagedPrincipal) ? '' : stagedPrincipal.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: asyncLoading,
        onConfirm: onDialogConfirm,
        onCancel: onDialogCancel
    }));
}));
module.exports["ANALYTICS_SOURCE"] = $eb8c51b94819be10$export$f7109619a5e9e0d6;
module.exports["i18nBulk"] = $eb8c51b94819be10$export$c4b5d6610bc5fc6e;
module.exports["BulkSpacePermissionsPage"] = $eb8c51b94819be10$export$405a6cc8f1c994c8;

});

parcelRegister("1BYn9", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $fWkVZ = parcelRequire("fWkVZ");

const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`);
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsProductAdmin"] = $141bd073c52fec74$export$44f5b9746e66da9;

});

parcelRegister("hpRYU", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $gtD4K = parcelRequire("gtD4K");


var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $6f0Oj = parcelRequire("6f0Oj");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $6mKj3 = parcelRequire("6mKj3");


var $jjoF2 = parcelRequire("jjoF2");


var $6RGMW = parcelRequire("6RGMW");


var $g3p2i = parcelRequire("g3p2i");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components })=>{
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $6RGMW.UserAndGroupSearchQuery));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`);
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: components,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context" // infer principal ID from UCT
        ,
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        enableEmailSearch: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        allowEmailSelectionWhenEmailMatched: !(0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false)
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("7lu50", function(module, exports) {
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("83Z6R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

function $b847dc1d37d68706$export$dcf9d4e77de27956(...[query, params]) {
    const resolversRef = (0, $42omo.useRef)();
    /**
	 * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
	 */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        params
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $cgtv4.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("11dKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $f9006b515271a00f$var$i18n = (0, $cgtv4.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/**
 * @generated SignedSource<<40e2b37836ef7625e634b9236789b118>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("6RGMW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $88fbd0e78227b736$export$9eed0d08b5194ae7 = (0, $eSUdr.default)`query UserAndGroupSearchQuery($searchTerm:String!$maxResults:Int=50$withGroups:Boolean=true$withUsers:Boolean=true$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm maxResults:$maxResults sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){type displayName permissionType profilePicture{path}...on KnownUser{accountId}}groups@include(if:$withGroups){id name permissionType}}}`;
module.exports["UserAndGroupSearchQuery"] = $88fbd0e78227b736$export$9eed0d08b5194ae7;

});

parcelRegister("kZ5GD", function(module, exports) {
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");

const $56d63ff022409480$var$packageName = "platform-pkg";
const $56d63ff022409480$var$packageVersion = "0.0.0-use.local";
const $56d63ff022409480$var$noop = (0, $ee7An.default);
const $56d63ff022409480$var$labelPaddingStyles = null;
const $56d63ff022409480$var$labelStyles = null;
const $56d63ff022409480$var$radioStyles = null;
const $56d63ff022409480$var$newRadioStyles = null;
const $56d63ff022409480$var$InnerRadio = /*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $56d63ff022409480$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $56d63ff022409480$var$packageName,
        packageVersion: $56d63ff022409480$var$packageVersion
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo _mqf81gmx _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $gMc0m.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosijmqp _11jyjmqp _f3ett94y _19ybs4qr _1d7ps4qr _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4ryaby5v _o1bdby5v _2kbkby5v _6cyrby5v _n8t0by5v _1o5rby5v _nxi6by5v _neoeby5v _1el2by5v _lekrbk0g _11v7bk0g _1if1bk0g _bl0ebk0g _92nabk0g _awurbk0g _1f8cbk0g _s2ftbk0g _17a1bk0g _x48a2sac _1ib22sac _wml02sac _tusm2sac _1c6f2sac _qftt2sac _1yk92sac _gdmb2sac _pmm42sac _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    (0, $dh538.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $56d63ff022409480$var$Radio = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($56d63ff022409480$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $56d63ff022409480$export$2e2bcd8739ae039 = $56d63ff022409480$var$Radio;
module.exports["default"] = $56d63ff022409480$export$2e2bcd8739ae039;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d6Fdl = parcelRequire("d6Fdl");


var $dh538 = parcelRequire("dh538");

function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $l998X.jsx)((0, $d6Fdl.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("eicAg", function(module, exports) {
/* HeaderCell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eXmBZ = parcelRequire("eXmBZ");


var $3gadb = parcelRequire("3gadb");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $eEA8O = parcelRequire("eEA8O");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$HeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { center: center, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1bahesu3 _1p57v77o _y3gn1h6o _1ul9xy5q _4t3i1wug",
            __cmplp.center ? "_4cvr1h6o" : "_4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$GroupNameWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { setWidth: setWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81vhk _1e0c1txw _2lx21bp4 _1bah1h6o _1reoewfl _o5721q9c _1tke1u1b _y3gn1h6o _syazi7uo",
            __cmplp.setWidth ? "_p12fglyw" : "_p12foahv",
            __cmplp.setWidth ? "_1bsb7l9q" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$largeGroupNameStyle = (0, $ecnYn.xcss)({
    whiteSpace: 'normal',
    wordBreak: 'keep-all'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$ColumnNameWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _1e0c1txw _o5721q9c _syazazsu _1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _4t3i4cqu _s7n4nkob _jq8g4cqu _14hp4cqu _irr31s93 _oq58tktm",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$export$efcbfab786023e1a = ({ groupName: groupName, columnName: columnName, showGroupName: showGroupName = false, testKey: testKey, tooltipContent: tooltipContent, tooltipIconLabel: tooltipIconLabel, centerGroupName: centerGroupName = false, setMaxWidth: setMaxWidth = false, setWidth: setWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$HeaderWrapper, {
        center: centerGroupName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$GroupNameWrapper, {
        "data-testid": testKey ? `space-table-header-${testKey}` : undefined,
        "aria-label": `${groupName}`,
        setMaxWidth: setMaxWidth,
        setWidth: setWidth
    }, showGroupName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            setWidth ? $1734009c6c243aaa$var$largeGroupNameStyle : false
        ]
    }, groupName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        "aria-label": `${groupName}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$ColumnNameWrapper, {
        key: groupName + columnName,
        "aria-label": `${columnName}`
    }, columnName, tooltipContent && tooltipIconLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tooltipContent)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            ...tooltipProps,
            appearance: "subtle-link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: formatMessage(tooltipIconLabel),
                color: "var(--ds-icon, #292A2E)",
                size: "small"
            })
        })))));
};
module.exports["HeaderCell"] = $1734009c6c243aaa$export$efcbfab786023e1a;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("auKqk", function(module, exports) {
/* ErrorPageComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $hhzGx = parcelRequire("hhzGx");


var $iNQQp = parcelRequire("iNQQp");

const $ae2504483138c997$var$ErrorContainerStyles = null;
const $ae2504483138c997$var$ErrorContainerMobileStyles = null;
const $ae2504483138c997$var$ErrorContainer = ({ isMobile: isMobile, resizeContainerRef: resizeContainerRef, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: resizeContainerRef,
        "data-vc": "not-found-container",
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _bfhkvuon _4t3i10fc _p12fauwl",
            isMobile && "_4t3i1kxc"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorPageWrapperStyles = null;
const $ae2504483138c997$var$ErrorPageWrapperMobileStyles = null;
const $ae2504483138c997$var$ErrorPageWrapper = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _p12fcv93 _2lx2vrvc",
            isMobile && "_2lx21bp4"
        ])
    }, children);
};
const $ae2504483138c997$var$AlignContentStyles = null;
const $ae2504483138c997$var$AlignContentMobileStyles = null;
const $ae2504483138c997$var$AlignContent = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18s8v47k _1wpz1h6o _y3gn1e5h",
            isMobile && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorTitleStyles = null;
const $ae2504483138c997$var$ErrorTitleMobileStyles = null;
const $ae2504483138c997$var$ErrorTitle = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_18s818rw _11c84xcc _k48pi7a9 _1bsbr5sb _syazi7uo",
            isMobile && "_11c81c04 _1bsb96ou"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorMessageStyles = null;
const $ae2504483138c997$var$ErrorMessageMobileStyles = null;
const $ae2504483138c997$var$ErrorMessage = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c82smr _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _k48pi7a9 _syazi7uo _p12fqxjr",
            isMobile && "_11c81ixg _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f96ou"
        ])
    }, children);
};
const $ae2504483138c997$var$ButtonContainerStyles = null;
const $ae2504483138c997$var$ButtonContainerMobileStyles = null;
const $ae2504483138c997$var$ButtonContainer = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1e5h",
            isMobile && "_1bah1h6o"
        ])
    }, children);
};
const $ae2504483138c997$var$primaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250'
});
const $ae2504483138c997$var$mobilePrimaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200'
});
const $ae2504483138c997$var$secondaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250',
    marginLeft: 'space.200'
});
const $ae2504483138c997$var$mobileSecondaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200',
    marginLeft: 'space.100'
});
const $ae2504483138c997$var$childrenStyles = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$mobileChildrenStyles = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-74px`
    marginTop: '-74px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$export$8350f8038f1a598b = ({ errorImage: errorImage, errorImageDark: errorImageDark, errorTitle: errorTitle, errorMessage: errorMessage, primaryButtonProps: primaryButtonProps, secondaryButtonProps: secondaryButtonProps, children: children })=>{
    const { resizeContainerRef: resizeContainerRef, shouldUseMobileLayout: shouldUseMobileLayout } = (0, $iNQQp.useErrorPageMobileLayout)();
    const isMobile = shouldUseMobileLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorContainer, {
        isMobile: isMobile,
        resizeContainerRef: resizeContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorPageWrapper, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile
    }, errorImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hhzGx.ErrorPageImage), {
        src: errorImage,
        srcDark: errorImageDark,
        isMobile: isMobile
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorTitle, {
        isMobile: isMobile
    }, errorTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorMessage, {
        isMobile: isMobile
    }, errorMessage), (primaryButtonProps?.children || secondaryButtonProps?.children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ButtonContainer, {
        isMobile: isMobile
    }, primaryButtonProps?.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isMobile ? $ae2504483138c997$var$mobilePrimaryButtonStyles : $ae2504483138c997$var$primaryButtonStyles
    }, 'href' in primaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "primary",
        ...primaryButtonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        ...primaryButtonProps
    })), secondaryButtonProps?.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isMobile ? $ae2504483138c997$var$mobileSecondaryButtonStyles : $ae2504483138c997$var$secondaryButtonStyles
    }, 'href' in secondaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "default",
        ...secondaryButtonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        ...secondaryButtonProps
    }))))), (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isMobile ? $ae2504483138c997$var$mobileChildrenStyles : $ae2504483138c997$var$childrenStyles
    }, children) : null);
};
module.exports["ErrorPageComponent"] = $ae2504483138c997$export$8350f8038f1a598b;

});

parcelRegister("hhzGx", function(module, exports) {
/* ErrorPageImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");

const $c32ae4d4c06d56af$var$imageStylesMobile = null;
const $c32ae4d4c06d56af$var$imageStylesDesktop = null;
const $c32ae4d4c06d56af$var$imageStyles = null;
function $c32ae4d4c06d56af$export$9afbc24a6b683cb2({ src: src, srcDark: srcDark, isMobile: isMobile }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: src,
        srcDark: srcDark || src,
        className: (0, $gMc0m.default)([
            isMobile && "_1bsb118a",
            !isMobile && "_1bsbn7od",
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f261p"
        ])
    });
}
module.exports["ErrorPageImage"] = $c32ae4d4c06d56af$export$9afbc24a6b683cb2;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cv8Bu = parcelRequire("cv8Bu");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $cv8Bu.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("cv8Bu", function(module, exports) {
/* theme-provider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $8z9j5 = parcelRequire("8z9j5");

var $hY0xh = parcelRequire("hY0xh");

var $bRSdj = parcelRequire("bRSdj");

var $60yhz = parcelRequire("60yhz");

const $d32a212d6e794c84$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $d32a212d6e794c84$var$ColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$ThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined); /**
                                                                                                  * __UNSAFE_useColorModeForMigration()__
                                                                                                  *
                                                                                                  * Returns the current color mode when inside the app provider.
                                                                                                  * Unlike useColorMode, this utility returns undefined, instead of throwing an error, when the app provider is missing.
                                                                                                  * This allows it to be used by components that need to operate with and without an app provider.
                                                                                                  */ 
function $d32a212d6e794c84$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    return value;
} /**
   * __useColorMode()__
   *
   * Returns the current color mode when inside the app provider.
   */ 
function $d32a212d6e794c84$export$20f3076712c8dfa() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $42omo.useState)(colorMode || 'light');
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $60yhz.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $d32a212d6e794c84$export$e2afe7397c3d11c7() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
} /**
   * __useTheme()__
   *
   * Returns the current theme settings when inside the app provider.
   */ 
function $d32a212d6e794c84$export$93d4e7f90805808f() {
    const theme = (0, $42omo.useContext)($d32a212d6e794c84$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $42omo.useState)(theme || (0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $60yhz.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
} /**
   * __useSetTheme()__
   *
   * Returns the theme setter when inside the app provider.
   */ 
function $d32a212d6e794c84$export$501aa0dcd5527a48() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $d32a212d6e794c84$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $d32a212d6e794c84$var$prefersDarkModeMql = $d32a212d6e794c84$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d32a212d6e794c84$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $d32a212d6e794c84$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $d32a212d6e794c84$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $d32a212d6e794c84$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $42omo.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $42omo.useState)($d32a212d6e794c84$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $42omo.useState)(()=>({
            ...$d32a212d6e794c84$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $42omo.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($d32a212d6e794c84$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $42omo.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // If fg enabled avoid mounting themes
        if ((0, $dh538.fg)('platform-static-theme-loading')) return;
         /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ 
        const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $bRSdj.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!$d32a212d6e794c84$var$prefersDarkModeMql) return;
        const unbindListener = (0, $fFa3V.bind)($d32a212d6e794c84$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = (0, $hY0xh.default)({
        ...theme,
        colorMode: reconciledColorMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: (0, $dh538.fg)('platform-static-theme-loading') ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-theme": attrs['data-theme'],
                        "data-color-mode": attrs['data-color-mode'],
                        className: (0, $gMc0m.default)([
                            $d32a212d6e794c84$var$contentStyles.body
                        ]),
                        children: children
                    }) : children
                })
            })
        })
    });
}
var $d32a212d6e794c84$export$2e2bcd8739ae039 = $d32a212d6e794c84$var$ThemeProvider;
module.exports["UNSAFE_useColorModeForMigration"] = $d32a212d6e794c84$export$ce91654eb9fea460;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("iNQQp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dwdz = parcelRequire("8dwdz");


var $9wGTI = parcelRequire("9wGTI");

const $5359ea5c70f1dd78$export$78b0da9378bc7a2d = ()=>{
    const MOBILE_BREAKPOINT = 700;
    const [isContainerNarrow, setIsContainerNarrow] = (0, $42omo.useState)(false);
    const lastIsNarrowRef = (0, $42omo.useRef)(null);
    const resizeObserverRef = (0, $42omo.useRef)(null);
    const handleResize = ([entry])=>{
        const nextIsNarrow = entry.contentRect.width < MOBILE_BREAKPOINT;
        if (lastIsNarrowRef.current !== nextIsNarrow) {
            lastIsNarrowRef.current = nextIsNarrow;
            setIsContainerNarrow(nextIsNarrow);
        }
    };
    const resizeContainerRef = (element)=>{
        // Clean up previous observer
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        // Set up new observer if element exists and feature gate is enabled
        if (element && (0, $9wGTI.fg)('responsive_confluence_errorpagecomponent')) {
            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(element);
            resizeObserverRef.current = resizeObserver;
        }
    };
    // Combine existing mobile detection with container width detection
    const shouldUseMobileLayout = isContainerNarrow || (0, $8dwdz.shouldShowMobileWeb)();
    return {
        resizeContainerRef: resizeContainerRef,
        shouldUseMobileLayout: shouldUseMobileLayout
    };
};
module.exports["useErrorPageMobileLayout"] = $5359ea5c70f1dd78$export$78b0da9378bc7a2d;

});

parcelRegister("6UBEn", function(module, exports) {
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $3cc01bd0176870aa$var$MIN_VALUE = 0;
const $3cc01bd0176870aa$var$MAX_VALUE = 1;
const $3cc01bd0176870aa$var$increasingBarAnimation = null;
const $3cc01bd0176870aa$var$decreasingBarAnimation = null;
const $3cc01bd0176870aa$var$containerStyles = null;
const $3cc01bd0176870aa$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $3cc01bd0176870aa$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $3cc01bd0176870aa$var$barStyles = null;
const $3cc01bd0176870aa$var$determinateBarStyles = null;
const $3cc01bd0176870aa$var$increasingBarStyles = null;
const $3cc01bd0176870aa$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $3cc01bd0176870aa$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $3cc01bd0176870aa$var$MIN_VALUE : Math.max($3cc01bd0176870aa$var$MIN_VALUE, Math.min(value, $3cc01bd0176870aa$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $3cc01bd0176870aa$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $3cc01bd0176870aa$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            $3cc01bd0176870aa$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $3cc01bd0176870aa$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $3cc01bd0176870aa$export$2e2bcd8739ae039 = $3cc01bd0176870aa$var$ProgressBar;
module.exports["default"] = $3cc01bd0176870aa$export$2e2bcd8739ae039;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("618I0"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("618I0", function(module, exports) {

let $4619977a62937b7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4619977a62937b7e$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("kAGh9", function(module, exports) {
/* BulkAccessManagementPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $laHi9 = parcelRequire("laHi9");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $92d16e8054e90c29$var$flexContainerStyles = null;
const $92d16e8054e90c29$export$124d4c7bf7db9715 = ({ id: id, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        id: id,
        className: (0, $gMc0m.default)([
            "_1e0c1txw"
        ]),
        children: children
    });
const $92d16e8054e90c29$var$contentWrapperStyles = null;
const $92d16e8054e90c29$export$6ce170286acaa8d3 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1ul9idpf _1reo15vq"
        ]),
        children: children
    });



var $1BYn9 = parcelRequire("1BYn9");


var $g3p2i = parcelRequire("g3p2i");


var $hpRYU = parcelRequire("hpRYU");


var $1NBp8 = parcelRequire("1NBp8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $c6lYi = parcelRequire("c6lYi");


var $6sX6R = parcelRequire("6sX6R");

var $bYvQP = parcelRequire("bYvQP");


var $9wGTI = parcelRequire("9wGTI");


var $8A6YM = parcelRequire("8A6YM");















var $kZ5GD = parcelRequire("kZ5GD");

const $8799edea050578d8$var$i18n = (0, $cgtv4.defineMessages)({
    actionSelectionHeader: {
        id: "bulk-permissions.space.action-selection-header",
        defaultMessage: "Action to perform<asterisk>*</asterisk>"
    },
    actionSelectionAdd: {
        id: "bulk-permissions.space.action-selection-add",
        defaultMessage: "Add or change access"
    },
    actionSelectionRemove: {
        id: "bulk-permissions.space.action-selection-remove",
        defaultMessage: "Remove access"
    }
});
var $8799edea050578d8$export$19d9f94347fa723d = /*#__PURE__*/ function(ActionSelection) {
    ActionSelection["AddOrChangeAccess"] = "add-or-change-access";
    ActionSelection["RemoveAccess"] = "remove-access";
    return ActionSelection;
}({});
const $8799edea050578d8$var$actionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $8799edea050578d8$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $8799edea050578d8$export$321778e99f9fd257 = ({ actionSelection: actionSelection, onRadioChange: onRadioChange })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8799edea050578d8$var$actionSelectionHeaderStyle,
        testId: "action-selection-radio-buttons"
    }, formatMessage($8799edea050578d8$var$i18n.actionSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8799edea050578d8$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "add-or-change-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "add-or-change-access",
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionAdd)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "remove-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "remove-access",
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionRemove)
    })));
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $2fd747c2df30bd9d$export$dc2a111abcc46324 = /*#__PURE__*/ function(BulkRoleAssignmentSpaceType) {
    BulkRoleAssignmentSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkRoleAssignmentSpaceType["GLOBAL"] = "GLOBAL";
    BulkRoleAssignmentSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkRoleAssignmentSpaceType["PERSONAL"] = "PERSONAL";
    return BulkRoleAssignmentSpaceType;
}({});
var $2fd747c2df30bd9d$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["TEAM"] = "TEAM";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});











var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");




var $5dK2X = parcelRequire("5dK2X");




var $bfgIy = parcelRequire("bfgIy");


var $1kHsc = parcelRequire("1kHsc");


var $ku6MO = parcelRequire("ku6MO");











var $9rnOu = parcelRequire("9rnOu");


var $g26MG = parcelRequire("g26MG");

/** @graphql cc **/ 









var $irVI7 = parcelRequire("irVI7");









const $5b8a2a030512dd5e$var$i18n = (0, $cgtv4.defineMessages)({
    errorIconLabel: {
        id: "bulk-permissions.flag-message.error-icon-label",
        defaultMessage: "Error"
    },
    processingFlagTitle: {
        id: "bulk-permissions.flag-message.processing",
        defaultMessage: "Bulk change processing"
    },
    processingFlagContent: {
        id: "bulk-permissions.flag-message.processing-content",
        defaultMessage: "This can take a while. We\u2019ll notify you by email when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.flag-message.error",
        defaultMessage: "Bulk access change failed"
    },
    errorFlagContent: {
        id: "bulk-permissions.flag-message.error-content",
        defaultMessage: "We ran into a problem completing your bulk access change. Try again."
    }
});
const $5b8a2a030512dd5e$export$4b081a83cd5f1b6f = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const showErrorFlag = ()=>flags.showErrorFlag({
            id: `error-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagContent),
            isAutoDismiss: true
        });
    const showProcessingFlag = ()=>flags.showInfoFlag({
            id: `processing-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagContent),
            isAutoDismiss: true
        });
    return {
        showErrorFlag: showErrorFlag,
        showProcessingFlag: showProcessingFlag
    };
};


const $838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery = (0, $eSUdr.default)`query useViewPermissionsModalPermissionsQuery{spacePermissionsAll{nodes{id displayName description hubDisplayName hubDescription priority group{displayName priority}requiredSpacePermissions}}}`;
const $838f830302a4f6f5$var$useViewPermissionsModalRolesQuery = (0, $eSUdr.default)`query useViewPermissionsModalRolesQuery{spaceRolesByCriteria{nodes{roleId roleDisplayName roleDescription roleType spacePermissionList{id priority displayName description hubDisplayName hubDescription requiredSpacePermissions}}pageInfo{endCursor hasNextPage}}}`;
const $838f830302a4f6f5$export$aec138b16dafcc0a = ({ flags: flags })=>{
    const [experienceStarted, setExperienceStarted] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showErrorFlag: showErrorFlag } = (0, $5b8a2a030512dd5e$export$4b081a83cd5f1b6f)({
        flags: flags
    });
    const fail = (error)=>{
        const experienceFailure = error || new Error('An error occurred');
        experienceTracker.fail({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: experienceFailure
        });
        showErrorFlag();
    };
    const { data: permissionsData, loading: loading } = (0, $xQxzY.useQuery)($838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        }
    });
    const { data: rolesData, loading: rolesLoading } = (0, $xQxzY.useQuery)($838f830302a4f6f5$var$useViewPermissionsModalRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (loading || rolesLoading && !experienceStarted) experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
    }, [
        loading,
        rolesLoading,
        experienceStarted,
        experienceTracker
    ]);
    return {
        loading: loading,
        permissions: permissionsData?.spacePermissionsAll?.nodes || [],
        roles: rolesData?.spaceRolesByCriteria?.nodes || []
    };
};









var $eXmBZ = parcelRequire("eXmBZ");





var $lsxnT = parcelRequire("lsxnT");




const $710ea738a38b5734$export$1a3c335d7dca645d = ({ content: content, isOpen: isOpen, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        isOpen: isOpen,
        content: ()=>content,
        placement: "bottom",
        trigger: (triggerProps)=>// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...triggerProps,
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                "aria-haspopup": true,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
                onClick: onClick,
                "aria-label": formatMessage({
                    id: "bulk-access.role-select.info-popup",
                    defaultMessage: "View info"
                })
            }, null)),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepermissions')
    }));
};















var $1GzhS = parcelRequire("1GzhS");






var $7hXDW = parcelRequire("7hXDW");




const $5e889a2aa3054314$var$i18n = (0, $cgtv4.defineMessages)({
    viewRolePermissionsLabel: {
        id: "bulk-permissions.info-popup.view-role-permissions-label",
        defaultMessage: "View role permissions"
    }
});
const $5e889a2aa3054314$var$contentStyle = (0, $ecnYn.xcss)({
    width: '315px',
    padding: 'space.300'
});
const $5e889a2aa3054314$var$headerStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $5e889a2aa3054314$var$buttonStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    display: 'flex',
    alignItems: 'center'
});
const $5e889a2aa3054314$var$usePermissionsSummary = ({ roleId: roleId, roleLookup: roleLookup })=>{
    const role = roleLookup.find((lookup)=>lookup.id === roleId);
    // Role access
    return {
        heading: role?.name,
        description: role?.description
    };
};
const $5e889a2aa3054314$export$90dae7b611e581b7 = ({ onCtaClick: onCtaClick, roleId: roleId, roleLookup: roleLookup })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { heading: heading, description: description } = $5e889a2aa3054314$var$usePermissionsSummary({
        roleId: roleId,
        roleLookup: roleLookup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $5e889a2aa3054314$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5e889a2aa3054314$var$headerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $5e889a2aa3054314$var$buttonStyle
    }, Boolean(roleId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onCtaClick
    }, formatMessage($5e889a2aa3054314$var$i18n.viewRolePermissionsLabel)) : null)));
};


const $117ed3de9d2a23fd$export$5bafd35f9dc9151a = ({ analyticsSource: analyticsSource, currentRole: currentRole, roleLookup: roleLookup, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const [isViewPermissionsModalOpen, setIsViewPermissionsModalOpen] = (0, $42omo.useState)(false);
    const { permissions: permissions, roles: roles } = (0, $838f830302a4f6f5$export$aec138b16dafcc0a)({
        flags: flags
    });
    const systemRoles = roles.filter((role)=>role?.roleType === 'SYSTEM');
    const customRoles = roles.filter((role)=>role?.roleType === 'CUSTOM');
    const onInfoButtonClick = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'role-select-info-button',
                source: analyticsSource,
                attributes: {
                    roleId: currentRole?.id
                }
            }
        }).fire();
    }, [
        isPopupOpen,
        currentRole?.id,
        analyticsSource,
        createAnalyticsEvent
    ]);
    const onPopupContentCtaClick = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
        setIsViewPermissionsModalOpen(true);
    }, []);
    const popupRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    (0, $42omo.useEffect)(()=>{
        if (popupRef.current) {
            const handleClickOutside = (e)=>{
                if (popupRef.current && !popupRef.current.contains(e.target)) setIsPopupOpen(false);
            };
            document.addEventListener('click', handleClickOutside);
            return ()=>document.removeEventListener('click', handleClickOutside);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isViewPermissionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9rnOu.ViewRolePermissionModal), {
        systemRoles: (0, $g26MG.normalizeSpaceRoleList)(systemRoles),
        customRoles: (0, $g26MG.normalizeSpaceRoleList)(customRoles),
        allPermissions: (0, $g26MG.normalizeSpacePermissionAll)(permissions),
        initialActiveRoleId: currentRole?.id,
        analyticsSource: analyticsSource,
        onClose: ()=>setIsViewPermissionsModalOpen(false)
    }), currentRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: popupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $710ea738a38b5734$export$1a3c335d7dca645d), {
        "data-testid": "role-selector-info-button",
        isOpen: isPopupOpen,
        onClick: onInfoButtonClick,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e889a2aa3054314$export$90dae7b611e581b7), {
            onCtaClick: onPopupContentCtaClick,
            roleId: currentRole.id,
            permissions: currentRole.permissions,
            roleLookup: roleLookup
        })
    })) : null);
};


const $0c8581713df69b2f$var$i18n = (0, $cgtv4.defineMessages)({
    roleSelectionHeader: {
        id: "bulk-permissions.space.role-selection-header",
        defaultMessage: "With what access<asterisk>*</asterisk>"
    },
    roleSelectionSubHeader: {
        id: "bulk-permissions.space.role-selection-sub-header",
        defaultMessage: "Choose the role they should have."
    },
    roleSelectionWarning: {
        id: "bulk-permissions.space.role-selection-warning",
        defaultMessage: "This will overwrite any existing access they have. <b>This can\u2019t be undone,</b> so make sure to double check your selections."
    },
    roleSelectLabel: {
        id: "bulk-permissions.space.role-select-label",
        defaultMessage: "Role"
    },
    roleSelectPlaceholder: {
        id: "bulk-permissions.space-role.select-placeholder",
        defaultMessage: "Select a role"
    }
});
const $0c8581713df69b2f$var$roleSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 'space.100'
});
const $0c8581713df69b2f$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $0c8581713df69b2f$var$roleSelectionContainer = (0, $ecnYn.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$sectionContainer = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$roleSelectInfoButtonStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    minWidth: '500px',
    alignItems: 'center'
});
const $0c8581713df69b2f$var$roleSelectStyle = (0, $ecnYn.xcss)({
    minWidth: '300px'
});
const $0c8581713df69b2f$var$roleSelectionSectionRolesQuery = (0, $eSUdr.default)`query RoleSelectionSectionRolesQuery{spaceRolesByCriteria{nodes{roleId roleDisplayName roleDescription roleType spacePermissionList{id priority displayName description requiredSpacePermissions}}}}`;
const $0c8581713df69b2f$export$884fc60bd42d0abd = ({ onRoleChange: onRoleChange, roleAssignment: roleAssignment, analyticsSource: analyticsSource, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceStarted, setExperienceStarted] = (0, $42omo.useState)(false);
    //TODO: update this and add it to experience tracker once the experience is created
    const BULK_ROLES_VIEW_EXPERIENCE = 'bulk-roles-view-experience';
    const placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectPlaceholder));
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($0c8581713df69b2f$var$roleSelectionSectionRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: BULK_ROLES_VIEW_EXPERIENCE
            });
        },
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: BULK_ROLES_VIEW_EXPERIENCE,
                error: error
            });
        }
    });
    const roleOptions = data?.spaceRolesByCriteria?.nodes.map((role)=>({
            id: role?.roleId || '',
            name: role?.roleDisplayName || '',
            permissions: role?.spacePermissionList.map((permission)=>permission.id) || [],
            description: role?.roleDescription || ''
        })) || [];
    (0, $42omo.useEffect)(()=>{
        if (loading && !experienceStarted) setExperienceStarted(true);
    }, [
        loading,
        experienceStarted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionHeaderStyle
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0c8581713df69b2f$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionSubHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        htmlFor: "role-selector"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectInfoButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ku6MO.RoleSelector), {
        value: roleAssignment?.id || null,
        onChange: onRoleChange,
        placeholder: placeholder,
        isLoading: loading,
        spaceRoleOptions: roleOptions,
        appearance: "default"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $117ed3de9d2a23fd$export$5bafd35f9dc9151a), {
        currentRole: roleAssignment,
        roleLookup: roleOptions,
        analyticsSource: analyticsSource,
        flags: flags
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionWarning, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    })));
};



var $eIwUX = parcelRequire("eIwUX");





var $6xdDU = parcelRequire("6xdDU");





var $lM2MU = parcelRequire("lM2MU");







var $gtD4K = parcelRequire("gtD4K");


var $eEA8O = parcelRequire("eEA8O");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");









var $67Foi = parcelRequire("67Foi");




const $d771d120872e42c7$var$i18n = (0, $cgtv4.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to all spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces (excluding personal)</b> on your site as <b>{roleName}</b>."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site as <b>{roleName}</b>."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site as <b>{roleName}</b>."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from all spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove access"
    }
});
const $d771d120872e42c7$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $d771d120872e42c7$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
const $d771d120872e42c7$export$6daa4510cb54b507 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, roleName: roleName, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-access-dialog",
        id: "bulk-access-dialog",
        attributes: {
            action: isRemoval ? 'remove' : 'add',
            spaceType: spaceSelection
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...isRemoval ? $d771d120872e42c7$var$i18n.removeConfirmationDialogTitle : $d771d120872e42c7$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $d771d120872e42c7$var$boldString,
            roleName: roleName
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $d771d120872e42c7$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$d771d120872e42c7$var$i18n.confirmationDialogWarning,
        values: {
            b: $d771d120872e42c7$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d771d120872e42c7$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), isRemoval ? $d771d120872e42c7$var$i18n.removeButtonText : $d771d120872e42c7$var$i18n.addButtonText))));
};


const $1d76093de32754c2$export$9297639d67b5de69 = ({ principalName: principalName, roleName: roleName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        testId: "bulk-access-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d771d120872e42c7$export$6daa4510cb54b507), {
        principalName: principalName,
        roleName: roleName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};


/**
 * @graphql cc
 */ 






var $1KmJq = parcelRequire("1KmJq");


const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation = (0, $eSUdr.default)`mutation useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation($principalId:ID!$principalType:RoleAssignmentPrincipalType!$roleId:ID!$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkSetRoleAssignmentToSpaces(input:{roleAssignment:{principal:{principalId:$principalId principalType:$principalType}roleId:$roleId}spaceTypes:$spaceTypes}){taskId success errors{message}}}`;
const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation = (0, $eSUdr.default)`mutation useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation($principalId:ID!$principalType:RoleAssignmentPrincipalType!$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkRemoveRoleAssignmentFromSpaces(input:{principal:{principalId:$principalId principalType:$principalType}spaceTypes:$spaceTypes}){taskId success errors{message}}}`;
const $754fc52bc3b4de65$export$667fffd9e35f2dcd = ({ closeDialog: closeDialog, flags: flags })=>{
    const { showErrorFlag: showErrorFlag, showProcessingFlag: showProcessingFlag } = (0, $5b8a2a030512dd5e$export$4b081a83cd5f1b6f)({
        flags: flags
    });
    const onMutationErrored = (0, $42omo.useCallback)(()=>{
        closeDialog();
        showErrorFlag();
    }, [
        closeDialog,
        showErrorFlag
    ]);
    const onAsyncMutationSubmitted = (0, $42omo.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetRoleAssignmentToSpaces?.errors?.length > 0 || data?.bulkRemoveRoleAssignmentFromSpaces?.errors?.length > 0) onMutationErrored();
        else if (data.bulkSetRoleAssignmentToSpaces?.taskId || data.bulkRemoveRoleAssignmentFromSpaces?.taskId) // show the progress flag
        showProcessingFlag();
    }, [
        closeDialog,
        showProcessingFlag,
        onMutationErrored
    ]);
    const [bulkSetRoleAssignmentToSpaces, { data: bulkAssignmentData }] = (0, $1KmJq.useMutation)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        }
    });
    const [bulkRemoveRoleAssignment, { data: bulkRemoveAssignmentData }] = (0, $1KmJq.useMutation)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        }
    });
    return {
        bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces,
        bulkRemoveRoleAssignment: bulkRemoveRoleAssignment,
        bulkAssignmentData: bulkAssignmentData,
        bulkRemoveAssignmentData: bulkRemoveAssignmentData
    };
};


/* SpaceSelectionRow.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $2W0qg = parcelRequire("2W0qg");






var $g5gZt = parcelRequire("g5gZt");


var $6R5uz = parcelRequire("6R5uz");


var $lE8sM = parcelRequire("lE8sM");








var $5dBQh = parcelRequire("5dBQh");


var $jTxSS = parcelRequire("jTxSS");


var $7uLCZ = parcelRequire("7uLCZ");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 





parcelRequire("42omo");

const $e64000d2546391c2$var$PANEL_WIDTH = 368;
const $e64000d2546391c2$export$614e920ab938d7a6 = 220;
const $e64000d2546391c2$var$rightSidePanelDrawerStyles = null;
const $e64000d2546391c2$var$rightSidePanelDrawerTransitionStyles = (width)=>({
        entered: {
            width: `${width}px`,
            flex: `0 0 ${width}px`
        },
        exiting: {
            width: 0,
            flex: `0 0 0`
        },
        exited: {
            width: 0,
            flex: `0 0 0`
        }
    });
const $e64000d2546391c2$export$ffc7784e6e6c8b9f = ({ transitionState: transitionState, children: children, width: width = $e64000d2546391c2$var$PANEL_WIDTH })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            width: `${width}px`,
            flex: `0 0 ${width}px`,
            transition: `width ${0.6 * width}ms, flex ${0.6 * width}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$e64000d2546391c2$var$rightSidePanelDrawerTransitionStyles(width)[transitionState]
        },
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _kqswh2mm"
        ]),
        children: children
    });
const $e64000d2546391c2$var$rightSidePanelDrawerContentStyles = null;
const $e64000d2546391c2$export$cef35cac62cae30d = ({ children: children, width: width = $e64000d2546391c2$var$PANEL_WIDTH })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            width: `${width}px`
        },
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1kl71o0q _bfhk1bhr _vchhusvi _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t"
        ]),
        children: children
    });


class $02e03f5ca81c5588$export$8912e7216438ef75 extends (0, $42omo.Component) {
    componentDidMount() {
        this.setState({
            container: (0, $5dBQh.canUseDOM) ? document.querySelector('#' + this.attachPanelTo) : undefined
        });
    }
    renderDrawer(Container) {
        const { children: children, isOpen: isOpen, skipAnimationOnMount: skipAnimationOnMount = false, mountOnEnter: mountOnEnter = true, unmountOnExit: unmountOnExit = true, disableEnterAnimation: disableEnterAnimation = false, disableExitAnimation: disableExitAnimation = false, onOpenAnimationFinished: onOpenAnimationFinished, onCloseAnimationFinished: onCloseAnimationFinished } = this.props;
        return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $7uLCZ.default), {
            in: isOpen,
            timeout: (0, $e64000d2546391c2$export$614e920ab938d7a6),
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit,
            appear: !skipAnimationOnMount,
            enter: !disableEnterAnimation,
            exit: !disableExitAnimation,
            onEntered: onOpenAnimationFinished,
            onExited: onCloseAnimationFinished,
            children: (state)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $e64000d2546391c2$export$ffc7784e6e6c8b9f), {
                    transitionState: state,
                    width: this.props.width,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e64000d2546391c2$export$cef35cac62cae30d), {
                        width: this.props.width,
                        children: children
                    })
                })
        }), Container);
    }
    render() {
        const { container: container } = this.state;
        return !!container ? this.renderDrawer(container) : null;
    }
    constructor(...args){
        super(...args);
        this.attachPanelTo = this.props.attachPanelTo;
        this.state = {
            entered: false,
            container: undefined
        };
    }
}
var $02e03f5ca81c5588$export$2e2bcd8739ae039 = $02e03f5ca81c5588$export$8912e7216438ef75;


/* SpaceSelectionPanelContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $hbYDZ = parcelRequire("hbYDZ");


var $hmuev = parcelRequire("hmuev");









var $gBbsI = parcelRequire("gBbsI");

var $7rvPL = parcelRequire("7rvPL");





var $1qfLF = parcelRequire("1qfLF");










var $2gD2K = parcelRequire("2gD2K");

const $7ca015af9cbe8f50$var$i18n = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "bulk-permissions.space-exclusion.multi-space-selector.placeholder.non-final",
        defaultMessage: "Search space name or key"
    }
});
const $7ca015af9cbe8f50$export$e023a6a0b0496c7c = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
        testId: "multi-space-selector",
        placeholder: formatMessage($7ca015af9cbe8f50$var$i18n.placeholder)
    }));
};











var $1RqgI = parcelRequire("1RqgI");




const $6d91e2fd2d24dc46$var$i18n = (0, $cgtv4.defineMessages)({
    spacesTableHeader: {
        id: "bulk-permissions.space.space-selection-table.header.non-final",
        defaultMessage: "Spaces"
    },
    emptyMessage: {
        id: "bulk-permissions.space.space-selection-table.empty-message.non-final",
        defaultMessage: "No spaces added yet"
    }
});
const $6d91e2fd2d24dc46$var$head = {
    cells: [
        {
            key: 'spaces',
            content: $6d91e2fd2d24dc46$var$i18n.spacesTableHeader.defaultMessage,
            isSortable: true
        }
    ]
};
const $6d91e2fd2d24dc46$var$rows = [];
const $6d91e2fd2d24dc46$export$730d4245715b50ca = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RqgI.default), {
        head: $6d91e2fd2d24dc46$var$head,
        rows: $6d91e2fd2d24dc46$var$rows,
        isFixedSize: true,
        emptyView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($6d91e2fd2d24dc46$var$i18n.emptyMessage)),
        defaultSortKey: "number",
        defaultSortOrder: "ASC",
        testId: "space-selection-panel-table"
    }));
};


const $9665e4e507aa0161$var$i18n = (0, $cgtv4.defineMessages)({
    exclusionTitle: {
        id: "bulk-permissions.space.space-exclusion-panel-content.exclusion-title.non-final",
        defaultMessage: "Spaces to exclude"
    },
    inclusionTitle: {
        id: "bulk-permissions.space.space-exclusion-panel-content.inclusion-title.non-final",
        defaultMessage: "Spaces to include"
    },
    closeButtonTooltip: {
        id: "bulk-permissions.space.space-exclusion-panel-content.close-tooltip.non-final",
        defaultMessage: "Close panel"
    },
    exclusionDescription: {
        id: "bulk-permissions.space.space-exclusion-panel-content.exclusion-description.non-final",
        defaultMessage: "Add which spaces should be excluded from this bulk access action."
    },
    inclusionDescription: {
        id: "bulk-permissions.space.space-exclusion-panel-content.inclusion-description.non-final",
        defaultMessage: "Add which spaces should be included in this bulk access action."
    },
    maximum: {
        id: "bulk-permissions.space.space-exclusion-panel-content.maximum.non-final",
        defaultMessage: "Maximum of 50."
    }
});
const $9665e4e507aa0161$var$styles = {
    header: "_1e0c1txw _1bah1yb4 _4cvr1h6o _n3tdu2gc",
    body: "_19bvpxbi _u5f3pxbi"
};
const $9665e4e507aa0161$export$898b6a3bd7c41a90 = ({ onClose: onClose, isExclusion: isExclusion })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        testId: "space-selection-right-side-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gBbsI.default), {
        "data-testId": "space-selection-panel-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $9665e4e507aa0161$var$styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
        label: "space selection icon",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "small"
    }, formatMessage(isExclusion ? $9665e4e507aa0161$var$i18n.exclusionTitle : $9665e4e507aa0161$var$i18n.inclusionTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "closeButton",
        onClick: onClose
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $9665e4e507aa0161$var$styles.body,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(isExclusion ? $9665e4e507aa0161$var$i18n.exclusionDescription : $9665e4e507aa0161$var$i18n.inclusionDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($9665e4e507aa0161$var$i18n.maximum)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ca015af9cbe8f50$export$e023a6a0b0496c7c), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6d91e2fd2d24dc46$export$730d4245715b50ca), null)))));
};


const $8a5ded6577214ab9$var$styles = {
    header: "_11c81ixg _k48p1wq8 _1e0c1txw _2lx2vrvc _ca0qpxbi _n3tdu2gc",
    inline: "_1e0c1txw _4cvr1h6o",
    asterisk: "_syaz9lu1"
};
const $8a5ded6577214ab9$var$rowStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: "var(--ds-radius-small, 4px)",
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'color.border.accent.blue',
    marginBottom: 'space.200',
    width: '300px',
    height: '76px',
    paddingLeft: 'space.150',
    backgroundColor: 'elevation.surface',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    }
});
const $8a5ded6577214ab9$var$i18n = (0, $cgtv4.defineMessages)({
    spaceExclusionRowLabel: {
        id: "bulk-permissions.space.space-exclusion-row.label.non-final",
        defaultMessage: "Spaces to exclude<asterisk>*</asterisk>"
    },
    spaceInclusionRowLabel: {
        id: "bulk-permissions.space.space-exclusion-row.label.non-final",
        defaultMessage: "Spaces to include<asterisk>*</asterisk>"
    },
    spaceSelectionButtonTitle: {
        id: "bulk-permissions.space.space-exclusion-row.title.non-final",
        defaultMessage: "Add spaces"
    }
});
const $8a5ded6577214ab9$export$44f2cba037b1084d = ({ isExclusion: isExclusion })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isSpaceSelectionPanelOpen, setIsSpaceSelectionPanelOpen] = (0, $42omo.useState)(false);
    const onClick = (0, $42omo.useCallback)(()=>{
        //TODO: Experience tracking
        // startExperience();
        if (!isSpaceSelectionPanelOpen) setIsSpaceSelectionPanelOpen(true);
        if (isSpaceSelectionPanelOpen) setIsSpaceSelectionPanelOpen(false);
    }, [
        setIsSpaceSelectionPanelOpen,
        isSpaceSelectionPanelOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92d16e8054e90c29$export$6ce170286acaa8d3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8a5ded6577214ab9$var$styles.header
    }, formatMessage(isExclusion ? $8a5ded6577214ab9$var$i18n.spaceExclusionRowLabel : $8a5ded6577214ab9$var$i18n.spaceInclusionRowLabel, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8a5ded6577214ab9$var$styles.asterisk
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $8a5ded6577214ab9$var$rowStyles,
        onClick: onClick,
        testId: "space-selection-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $8a5ded6577214ab9$var$styles.inline,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
        label: "",
        appearance: "gray",
        shape: "square",
        size: "24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, formatMessage($8a5ded6577214ab9$var$i18n.spaceSelectionButtonTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02e03f5ca81c5588$export$2e2bcd8739ae039), {
        isOpen: isSpaceSelectionPanelOpen,
        attachPanelTo: "SpaceSelectionPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9665e4e507aa0161$export$898b6a3bd7c41a90), {
        onClose: ()=>setIsSpaceSelectionPanelOpen(false),
        isExclusion: isExclusion
    }))));
};


const $1f40f2edcedc8ce5$export$f7109619a5e9e0d6 = 'bulkAccessManagementScreen';
const $1f40f2edcedc8ce5$var$i18n = (0, $cgtv4.defineMessages)({
    bulkRoleAccessHeader: {
        id: "bulk-permissions.space.role-access-header",
        defaultMessage: "Manage space access in bulk"
    },
    bulkRoleAccessSubtext: {
        id: "bulk-permissions.space.role-access-subtext",
        defaultMessage: "Quickly add, change, or remove access for individual users or groups across spaces on your Confluence site."
    },
    bulkRoleAccessTeamsSubtext: {
        id: "bulk-permissions.space.role-access-subtext-teams",
        defaultMessage: "Quickly add, change, or remove access for individual users, teams, or groups across spaces on your Confluence site."
    },
    warningSubtext: {
        id: "bulk-permissions.space.warning-subtext",
        defaultMessage: "<b>This can\u2019t be undone</b> so make sure to double check your selections."
    },
    userPickerAccessHeader: {
        id: "bulk-permissions.space.user-picker-access-header",
        defaultMessage: "Who<asterisk>*</asterisk>"
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Add a user, group, or user class"
    },
    userPickerTeamsPlaceholder: {
        id: "bulk-permissions.space.user-picker-teams-placeholder",
        defaultMessage: "Add a user, team, group, or user class"
    },
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link.role-access",
        defaultMessage: "Space permissions"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext.role-access",
        defaultMessage: "You may only select one for this action."
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add.role-access",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemoveRolesOnly: {
        id: "bulk-permissions.space.apply-button-text-remove-roles-only.role-access",
        defaultMessage: "Remove access"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message.role-access",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    }
});
const $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    width: '75%'
});
const $1f40f2edcedc8ce5$var$principlePickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $1f40f2edcedc8ce5$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $1f40f2edcedc8ce5$var$principlePickerFineTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1f40f2edcedc8ce5$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000',
    paddingBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle = (0, $ecnYn.xcss)({
    width: '100%',
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $1f40f2edcedc8ce5$var$principlePickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $1f40f2edcedc8ce5$var$requirementTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300',
    paddingBottom: 'space.1000',
    marginBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$styles = {
    removalWarningSubtext: "_n3td1ejb"
};
const $1f40f2edcedc8ce5$export$554dd5f0355b3be6 = (principal)=>{
    if (principal?.type === 'group') return (0, $9wGTI.fg)('nonsmart_user_picker_deprecation') ? principal?.id : principal?.extra?.id;
    return principal?.id;
};
const $1f40f2edcedc8ce5$export$9c91ebd69562789f = (options)=>{
    // TEMPORARY WORKAROUND https://product-fabric.atlassian.net/browse/CPE-3651:
    // Smart User Picker does not currently expose a reliable field to identify guest users.
    // We're using the presence of the "GUEST" lozenge as a proxy to filter out guest users.
    // This should be revisited once the platform team adds a proper field
    // to accurately indicate guest status.
    return options.filter((option)=>{
        const { lozenge: lozenge } = option;
        const isGuest = typeof lozenge === 'object' && lozenge !== null && 'text' in lozenge && lozenge.text === 'GUEST';
        return !isGuest;
    });
};
const $1f40f2edcedc8ce5$export$db2035bfb5892b74 = (0, $7aRa9.withFlags)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const accessClassInclusion = (0, $6sX6R.useAccessClassInclusion)();
    const [showDialog, setShowDialog] = (0, $42omo.useState)(false);
    const [stagedPrincipal, setStagedPrincipal] = (0, $42omo.useState)(undefined);
    const [spaceSelection, setSpaceSelection] = (0, $42omo.useState)((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const { setSearchQuery: setSearchQuery, transformOptions: transformOptions } = (0, $bYvQP.useAccessClassTransformer)();
    const [actionSelection, setActionSelection] = (0, $42omo.useState)((0, $8799edea050578d8$export$19d9f94347fa723d).AddOrChangeAccess);
    const [roleAssignment, setRoleAssignment] = (0, $42omo.useState)(null);
    const isRemoval = actionSelection === (0, $8799edea050578d8$export$19d9f94347fa723d).RemoveAccess;
    const closeDialog = (0, $42omo.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const { bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces, bulkRemoveRoleAssignment: bulkRemoveRoleAssignment } = (0, $754fc52bc3b4de65$export$667fffd9e35f2dcd)({
        closeDialog: closeDialog,
        flags: flags
    });
    const getSpaceTypes = (targetValue)=>{
        const spaceTypesArray = [
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).COLLABORATION,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).GLOBAL,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).KNOWLEDGE_BASE
        ];
        if (targetValue === (0, $8A6YM.SpaceSelection).AllExcludingPersonal) return spaceTypesArray.filter((type)=>type !== (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL);
        else if (targetValue === (0, $8A6YM.SpaceSelection).AllIncludingPersonal) return spaceTypesArray;
        else if (targetValue === (0, $8A6YM.SpaceSelection).OnlyPersonal) return [
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL
        ];
    };
    const getPrincipalType = (principalType)=>{
        if (principalType === 'group') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).GROUP;
        else if (principalType === 'team') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).GROUP;
        else if (principalType === 'custom') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).ACCESS_CLASS;
        else return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).USER;
    };
    const onDialogConfirm = (0, $42omo.useCallback)(async ()=>{
        closeDialog();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulk-access-management-confirm',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principalType: stagedPrincipal?.type === 'group' ? stagedPrincipal?.extra?.usageType : stagedPrincipal?.type,
                    verified: stagedPrincipal?.type === 'team' ? stagedPrincipal?.verified : 'N/A',
                    selectedRole: roleAssignment?.name,
                    spaceTypes: getSpaceTypes(spaceSelection),
                    action: isRemoval ? 'remove' : 'add'
                }
            }
        }).fire();
        isRemoval ? await bulkRemoveRoleAssignment({
            variables: {
                principalId: $1f40f2edcedc8ce5$export$554dd5f0355b3be6(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        }) : await bulkSetRoleAssignmentToSpaces({
            variables: {
                principalId: $1f40f2edcedc8ce5$export$554dd5f0355b3be6(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                roleId: roleAssignment.id,
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        });
    }, [
        closeDialog,
        isRemoval,
        bulkRemoveRoleAssignment,
        stagedPrincipal,
        spaceSelection,
        bulkSetRoleAssignmentToSpaces,
        roleAssignment,
        createAnalyticsEvent
    ]);
    const handleBackToDefaultSpaceAccessClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceTypeRadioChange = (0, $42omo.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementSpace',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceTypeChange = (0, $42omo.useCallback)((selectedSpaceType)=>{
        setSpaceSelection(selectedSpaceType);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'space type item',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementSpace',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    selectedSpaceType: selectedSpaceType,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onActionRadioChange = (0, $42omo.useCallback)((e)=>{
        setActionSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementAction',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    actionSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]); //Only passing roleId to the analytics event to avoid leaking UGC
    //Ticket to audit rest of analytics events: https://product-fabric.atlassian.net/browse/RBAC-1552
    const onRoleChange = (0, $42omo.useCallback)((role)=>{
        setRoleAssignment(role);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'role picker',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagement',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    roleAssignment: role.id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $42omo.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'principal',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementPrincipal',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principal: received.type,
                    verified: received.type === 'team' ? received.verified : 'N/A',
                    isRBACEnabled: true
                }
            }
        }).fire();
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const openDialog = (0, $42omo.useCallback)(()=>{
        setShowDialog(true);
    }, [
        setShowDialog
    ]); // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIwUX.RestrictedView), null);
    const shouldShowSpaceSelectionRow = spaceSelection === (0, $8A6YM.SpaceSelection).OnlySpecificSpaces || spaceSelection === (0, $8A6YM.SpaceSelection).AllExcludingSpecific;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92d16e8054e90c29$export$124d4c7bf7db9715), {
        id: "SpaceSelectionPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackToDefaultSpaceAccessClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.backToSpacePermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: "Bulk Space Roles"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle
    }, formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $1f40f2edcedc8ce5$var$i18n.bulkRoleAccessTeamsSubtext : $1f40f2edcedc8ce5$var$i18n.bulkRoleAccessSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerHeaderStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerAccessHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: (0, $9wGTI.fg)('nonsmart_user_picker_deprecation'),
        customInclusion: accessClassInclusion,
        placeholder: formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $1f40f2edcedc8ce5$var$i18n.userPickerTeamsPlaceholder : $1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        sitePermissionTypeFilter: (0, $g3p2i.SitePermissionTypeFilter).NONE,
        // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
        // This error was introduced after upgrading to TypeScript 5
        noOptionsMessage: null,
        onChange: (received)=>{
            onPrincipalChange(received);
        },
        value: stagedPrincipal || [],
        filterSearchResults: (value)=>value?.extra?.permissionType !== (0, $g3p2i.SitePermissionType).EXTERNAL,
        onInputChange: (searchQuery)=>setSearchQuery(searchQuery || ''),
        transformOptions: transformOptions,
        smartFilterOptions: $1f40f2edcedc8ce5$export$9c91ebd69562789f,
        includeTeams: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals'),
        includeTeamsUpdates: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerFineTextStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8799edea050578d8$export$321778e99f9fd257), {
        actionSelection: actionSelection,
        onRadioChange: onActionRadioChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceTypeRadioChange,
        onChange: onSpaceTypeChange
    }), shouldShowSpaceSelectionRow && (0, $9wGTI.fg)('confluence_rbac_spaces_ga') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a5ded6577214ab9$export$44f2cba037b1084d), {
        isExclusion: spaceSelection === (0, $8A6YM.SpaceSelection).AllExcludingSpecific
    }), isRemoval ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$styles.removalWarningSubtext
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.warningSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c8581713df69b2f$export$884fc60bd42d0abd), {
        onRoleChange: onRoleChange,
        roleAssignment: roleAssignment,
        analyticsSource: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
        flags: flags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: isRemoval ? 'danger' : 'primary',
        onClick: ()=>openDialog(),
        isDisabled: stagedPrincipal === undefined || !isRemoval && roleAssignment === null
    }, formatMessage(isRemoval ? $1f40f2edcedc8ce5$var$i18n.applyButtonTextRemoveRolesOnly : $1f40f2edcedc8ce5$var$i18n.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $1f40f2edcedc8ce5$var$requirementTextStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1d76093de32754c2$export$9297639d67b5de69), {
        principalName: stagedPrincipal?.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: false,
        onConfirm: onDialogConfirm,
        onCancel: closeDialog,
        roleName: roleAssignment?.name
    })));
}));
module.exports["ANALYTICS_SOURCE"] = $1f40f2edcedc8ce5$export$f7109619a5e9e0d6;
module.exports["getPrincipalId"] = $1f40f2edcedc8ce5$export$554dd5f0355b3be6;
module.exports["pickerResultsFilter"] = $1f40f2edcedc8ce5$export$9c91ebd69562789f;
module.exports["BulkAccessManagementPage"] = $1f40f2edcedc8ce5$export$db2035bfb5892b74;

});

parcelRegister("c6lYi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $7yOcR = parcelRequire("7yOcR");


var $7aRa9 = parcelRequire("7aRa9");


var $iquRY = parcelRequire("iquRY");


var $cNkvT = parcelRequire("cNkvT");

const $fa5a2619efb2e23a$var$i18n = (0, $cgtv4.defineMessages)({
    buttonText: {
        id: "space-roles.feedback-collector.button-text",
        defaultMessage: "Give feedback"
    },
    flagTitle: {
        id: "space-roles.feedback-collector.flag-title",
        defaultMessage: "Feedback submitted, thank you!"
    }
});
const $fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent = ({ flags: flags, source: source, appearance: appearance = 'default' })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))),
        appearance: appearance,
        onClick: ()=>setIsOpen(true)
    }, formatMessage($fa5a2619efb2e23a$var$i18n.buttonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cNkvT.SpaceRolesFeedbackCollector), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        onSubmit: ()=>{
            flags.showSuccessFlag({
                title: formatMessage($fa5a2619efb2e23a$var$i18n.flagTitle),
                isAutoDismiss: true
            });
        },
        source: source
    })) : null;
};
const $fa5a2619efb2e23a$export$b39479f42d974760 = (0, $7aRa9.withFlags)($fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent);
module.exports["FeedbackCollectorButton"] = $fa5a2619efb2e23a$export$b39479f42d974760;

});

parcelRegister("cNkvT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $biiXa = parcelRequire("biiXa");


var $bQm3c = parcelRequire("bQm3c");


var $iquRY = parcelRequire("iquRY");

const $fe7fcc34e2e5b785$var$i18n = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "space-roles.feedback-collector.title",
        defaultMessage: "Give feedback"
    },
    feedbackTitleDetails: {
        id: "space-roles.feedback-collector.title-details",
        defaultMessage: "How satisfied or dissatisfied are you overall with your experience using roles to manage access in Confluence?"
    }
});
const $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $fe7fcc34e2e5b785$var$ENTRYPOINT_ID = 'ba8149f4-b7d4-4f55-9e72-683a444d3b27';
const $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, source: source })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { displayName: displayName, userId: userId, cloudId: cloudId, edition: edition, environment: environment } = (0, $bQm3c.useSessionData)();
    const { spaceRoleMode: spaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const getFeedbackMetadata = ()=>{
        const feedbackMetadata = {
            userId: userId,
            cloudId: cloudId,
            edition: edition,
            environment: environment,
            source: source,
            spaceRoleMode: spaceRoleMode
        };
        return JSON.stringify(feedbackMetadata, null, 2);
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        onClose: onClose,
        onSubmit: onSubmit,
        entrypointId: $fe7fcc34e2e5b785$var$ENTRYPOINT_ID,
        locale: locale,
        name: displayName ?? '',
        atlassianAccountId: userId ?? undefined,
        showTypeField: false,
        feedbackTitle: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitleDetails),
        additionalFields: [
            {
                id: $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID,
                value: getFeedbackMetadata()
            }
        ]
    });
};
module.exports["SpaceRolesFeedbackCollector"] = $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d;

});

parcelRegister("biiXa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c4c27c8e6323826$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("29DUH")).default);


var $hrGQb = parcelRequire("hrGQb");


var $29DUH = parcelRequire("29DUH");


var $3c4c27c8e6323826$export$2e2bcd8739ae039 = (0, $hrGQb.default);

});

parcelRegister("hrGQb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $iA9co = parcelRequire("iA9co");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $2KPHZ = parcelRequire("2KPHZ");


var $gpfq4 = parcelRequire("gpfq4");


var $8zkrp = parcelRequire("8zkrp");

const $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $6b78f3070669f383$var$singleLineTruncatedText = (text, length = $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $gpfq4.default)(singleLineText, length);
};
class $6b78f3070669f383$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $6b78f3070669f383$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8zkrp.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            locale: this.props.locale,
            anonymousFeedback: (0, $dh538.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            }
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $2KPHZ.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $iA9co.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$6b78f3070669f383$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $6b78f3070669f383$export$2e2bcd8739ae039;

});

parcelRegister("2KPHZ", function(module, exports) {
const $defa15de0313af4d$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $defa15de0313af4d$export$f0f6fc934288a17c;

});

parcelRegister("gpfq4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bab40c5fbb12059f$export$2e2bcd8739ae039);
function $bab40c5fbb12059f$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("8zkrp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $7gpC4 = parcelRequire("7gpC4");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $kuB2l = parcelRequire("kuB2l");

var $jVhgp = parcelRequire("jVhgp");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $aoVih = parcelRequire("aoVih");


var $2gD2K = parcelRequire("2gD2K");


var $9EtP6 = parcelRequire("9EtP6");


var $6fnsQ = parcelRequire("6fnsQ");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $27c5bd5943874410$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        children: children
    });
};
const $27c5bd5943874410$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, disableSubmitButton: disableSubmitButton })=>{
    const [canBeContacted, setCanBeContacted] = (0, $42omo.useState)(false);
    const [description, setDescription] = (0, $42omo.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $42omo.useState)(false);
    const [type, setType] = (0, $42omo.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const [validationErrors, setValidationErrors] = (0, $42omo.useState)({});
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isTypeSelected = ()=>type !== 'empty';
    const canShowTextField = isTypeSelected() || !showTypeField;
    const hasDescription = description || hasDescriptionDefaultValue;
    // Feature flag determines validation behavior
    const useNewValidation = (0, $dh538.fg)('feedback-collector-custom-validation');
    const isDisabled = useNewValidation ? isSubmitting || disableSubmitButton // New: only disable when submitting or explicitly disabled
     : disableSubmitButton || (showTypeField ? !isTypeSelected() || !hasDescription : !hasDescription); // Old: disable based on form validation
    const getValidationErrors = ()=>{
        const errors = {};
        // Validate type selection if showTypeField is true
        if (showTypeField && !isTypeSelected()) errors.type = formatMessage((0, $fSdY7.messages).validationErrorTypeRequired);
        // Validate description if showDefaultTextFields is true
        if (showDefaultTextFields && !hasDescription) errors.description = formatMessage((0, $fSdY7.messages).validationErrorDescriptionRequired);
        return errors;
    };
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $fSdY7.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $fSdY7.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $fSdY7.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $fSdY7.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $fSdY7.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $fSdY7.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $fSdY7.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $fSdY7.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $42omo.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsxs)("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        },
        children: [
            formatMessage((0, $fSdY7.messages).requiredFieldsSummary),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
        ]
    });
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsx)("p", {
        children: formatMessage((0, $fSdY7.messages).feedbackIsAnonymous)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true,
        children: (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                if (useNewValidation) {
                    // New validation: validate on submit and show errors
                    const errors = getValidationErrors();
                    // If there are validation errors, show them and don't submit
                    if (Object.keys(errors).length > 0) {
                        setValidationErrors(errors);
                        return;
                    }
                }
                // Submit the form (both old and new validation paths reach here)
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $fSdY7.messages).feedbackTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                    children: [
                        requiredFieldsSummary,
                        feedbackTitleDetails,
                        customContent,
                        showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                            name: "topic",
                            label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                            isRequired: true,
                            children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                            ...restProps,
                                            onChange: (option)=>{
                                                if (!option || option instanceof Array) return;
                                                setType(option.value);
                                                // Clear validation error when user selects a type (only for new validation)
                                                if (useNewValidation && validationErrors.type) setValidationErrors((prev)=>({
                                                        ...prev,
                                                        type: undefined
                                                    }));
                                            },
                                            menuPortalTarget: document.body,
                                            styles: {
                                                menuPortal: (base)=>({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                            },
                                            options: selectOptions,
                                            // @ts-ignore
                                            ref: focusRef,
                                            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                            inputId: id
                                        }),
                                        useNewValidation && validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                            children: validationErrors.type
                                        })
                                    ]
                                })
                        }) : null,
                        showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                    isRequired: true,
                                    name: "description",
                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                    ...fieldProps,
                                                    name: "foo",
                                                    minimumRows: 6,
                                                    placeholder: summaryPlaceholder || undefined,
                                                    onChange: (e)=>{
                                                        setDescription(e.target.value);
                                                        // Clear validation error when user types
                                                        if (useNewValidation && validationErrors.description) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                description: undefined
                                                            }));
                                                    },
                                                    value: description
                                                }),
                                                useNewValidation && validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.description
                                                })
                                            ]
                                        })
                                }),
                                !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                            "aria-hidden": false,
                                            hidden: true,
                                            children: "Atlassian opt-in options"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "can-be-contacted",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                    values: {
                                                                        a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                target: "_blank",
                                                                                children: chunks
                                                                            })
                                                                    }
                                                                }
                                                            }),
                                                            onChange: (event)=>setCanBeContacted(event.target.checked)
                                                        }),
                                                        canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: canBeContactedLink
                                                        }),
                                                        !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                target: "_blank",
                                                                children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                            })
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "enroll-in-research-group",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                        }),
                                                        enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: enrolInResearchLink
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: 'anonymousFeedback',
                                        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                appearance: 'information',
                                                children: feedbackIsAnonymous
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $fSdY7.messages).cancelButtonLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            type: "submit",
                            isDisabled: isSubmitting || isDisabled,
                            testId: "feedbackCollectorSubmitBtn",
                            children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $fSdY7.messages).submitButtonLabel
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                if (useNewValidation) {
                    // New validation: validate on submit and show errors
                    const errors = getValidationErrors();
                    // If there are validation errors, show them and don't submit
                    if (Object.keys(errors).length > 0) {
                        setValidationErrors(errors);
                        return;
                    }
                }
                // Submit the form (both old and new validation paths reach here)
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $fSdY7.messages).feedbackTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                            children: [
                                requiredFieldsSummary,
                                feedbackTitleDetails,
                                customContent,
                                showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "topic",
                                    label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                                    isRequired: true,
                                    children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                                    ...restProps,
                                                    onChange: (option)=>{
                                                        if (!option || option instanceof Array) return;
                                                        setType(option.value);
                                                        // Clear validation error when user selects a type (only for new validation)
                                                        if (useNewValidation && validationErrors.type) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                type: undefined
                                                            }));
                                                    },
                                                    menuPortalTarget: document.body,
                                                    styles: {
                                                        menuPortal: (base)=>({
                                                                ...base,
                                                                zIndex: 9999
                                                            })
                                                    },
                                                    options: selectOptions,
                                                    // @ts-ignore
                                                    ref: focusRef,
                                                    placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                                    inputId: id
                                                }),
                                                useNewValidation && validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.type
                                                })
                                            ]
                                        })
                                }) : null,
                                showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                            isRequired: true,
                                            name: "description",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                            ...fieldProps,
                                                            name: "foo",
                                                            minimumRows: 6,
                                                            placeholder: summaryPlaceholder || undefined,
                                                            onChange: (e)=>{
                                                                setDescription(e.target.value);
                                                                // Clear validation error when user types
                                                                if (useNewValidation && validationErrors.description) setValidationErrors((prev)=>({
                                                                        ...prev,
                                                                        description: undefined
                                                                    }));
                                                            },
                                                            value: description
                                                        }),
                                                        useNewValidation && validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                            children: validationErrors.description
                                                        })
                                                    ]
                                                })
                                        }),
                                        !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                                    "aria-hidden": false,
                                                    hidden: true,
                                                    children: "Atlassian opt-in options"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "can-be-contacted",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                        ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                        ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                            values: {
                                                                                a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                        target: "_blank",
                                                                                        children: chunks
                                                                                    })
                                                                            }
                                                                        }
                                                                    }),
                                                                    onChange: (event)=>setCanBeContacted(event.target.checked)
                                                                }),
                                                                canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: canBeContactedLink
                                                                }),
                                                                !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                        target: "_blank",
                                                                        children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "enroll-in-research-group",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                                    onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                                }),
                                                                enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: enrolInResearchLink
                                                                })
                                                            ]
                                                        })
                                                })
                                            ]
                                        }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                name: 'anonymousFeedback',
                                                children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                        title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                        appearance: 'information',
                                                        children: feedbackIsAnonymous
                                                    })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "subtle",
                                    onClick: onClose,
                                    children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $fSdY7.messages).cancelButtonLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: isSubmitting || isDisabled,
                                    testId: "feedbackCollectorSubmitBtn",
                                    children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $fSdY7.messages).submitButtonLabel
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
const $27c5bd5943874410$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$FeedbackForm, {
            ...props
        })
    });
};
var $27c5bd5943874410$export$2e2bcd8739ae039 = $27c5bd5943874410$var$FeedbackFormWithIntl;
module.exports["default"] = $27c5bd5943874410$export$2e2bcd8739ae039;

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81ixg _1tn22smr",
    monospace: "_11c81ixg _ect41odn _1tn22smr _14mdudxr"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("fSdY7", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $a10dc5cbcf39e7b4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    }
});
module.exports["messages"] = $a10dc5cbcf39e7b4$export$defe85febe8b728c;

});

parcelRegister("giCws", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $1tbUg = parcelRequire("1tbUg");

const $9a574d55f4cfa28d$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $1tbUg.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale,
        children: children
    });
};
module.exports["IntlProviderWithResolvedMessages"] = $9a574d55f4cfa28d$export$f793de1293176fe6;

});

parcelRegister("1tbUg", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $c02f8c9a6f146725$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};
module.exports["getMessagesForLocale"] = $c02f8c9a6f146725$export$d0a3169680473b6c;

});

parcelRegister("29DUH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $aD1SW = parcelRequire("aD1SW");


var $8Y8Qi = parcelRequire("8Y8Qi");


var $dh538 = parcelRequire("dh538");


var $6fnsQ = parcelRequire("6fnsQ");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $36b921ab0de27528$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`,
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $fSdY7.messages).feedbackSuccessFlagDescriptionAppify : (0, $fSdY7.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $fSdY7.messages).feedbackSuccessFlagTitle)
    });
};
const $36b921ab0de27528$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: props.locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($36b921ab0de27528$var$FeedbackFlag, {
            ...props
        })
    });
var $36b921ab0de27528$export$2e2bcd8739ae039 = $36b921ab0de27528$var$FeedbackFlagWithIntl;
module.exports["default"] = $36b921ab0de27528$export$2e2bcd8739ae039;

});

parcelRegister("6sX6R", function(module, exports) {
/** @graphql cc **/ 
var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");

const $fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery = (0, $eSUdr.gql)`query useAccessClassInclusionClassesQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId displayName}}}`;
const $fed355c8c6dd10eb$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');


const $fed355c8c6dd10eb$export$3084d470555a4d72 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)($fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        }
    });
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    if (loading || error) return [];
    return [
        {
            ...allConfluenceUsers?.principalId && allConfluenceUsers?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceUsers.displayName)]: {
                    id: allConfluenceUsers.principalId,
                    name: allConfluenceUsers.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("56zia"))
                }
            },
            ...allConfluenceAdmins?.principalId && allConfluenceAdmins?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceAdmins.displayName)]: {
                    id: allConfluenceAdmins.principalId,
                    name: allConfluenceAdmins.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("56zia"))
                }
            }
        }
    ];
};
module.exports["useAccessClassInclusion"] = $fed355c8c6dd10eb$export$3084d470555a4d72;

});

parcelRegister("56zia", function(module, exports) {
module.exports = new URL("atlassian-icon.1175e11b.svg", import.meta.url).toString();

});

parcelRegister("bYvQP", function(module, exports) {
/** @graphql cc **/ 
var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");

const $eef51719bd266cea$var$useAccessClassTransformerQuery = (0, $eSUdr.gql)`query useAccessClassTransformerQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId displayName}}}`;
const $eef51719bd266cea$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');

const $eef51719bd266cea$export$8981ed613e05500d = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $xQxzY.useQuery)($eef51719bd266cea$var$useAccessClassTransformerQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        }
    });
    const [searchQuery, setSearchQuery] = (0, $42omo.useState)('');
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    const transformOptions = async (options)=>{
        const cleanedSearchTerm = $eef51719bd266cea$var$toLowerWithoutSpaces(searchQuery);
        const customInclusionList = [];
        [
            allConfluenceUsers,
            allConfluenceAdmins
        ].forEach((userClass)=>{
            if (userClass && $eef51719bd266cea$var$toLowerWithoutSpaces(userClass.displayName || '').includes(cleanedSearchTerm)) customInclusionList.push({
                id: userClass.principalId,
                name: userClass.displayName,
                type: 'custom',
                avatarUrl: (parcelRequire("56zia"))
            });
        });
        return [
            ...options,
            ...customInclusionList
        ];
    };
    return {
        setSearchQuery: setSearchQuery,
        transformOptions: transformOptions
    };
};
module.exports["useAccessClassTransformer"] = $eef51719bd266cea$export$8981ed613e05500d;

});

parcelRegister("ku6MO", function(module, exports) {
/* RoleSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

var $2gD2K = parcelRequire("2gD2K");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $dTk3A = parcelRequire("dTk3A");

const $d5c5d64568180920$var$menuItemStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $d5c5d64568180920$export$7b32174eb7b60a13 = ({ initialRoleId: initialRoleId, value: value, isLoading: isLoading, onChange: onChange, placeholder: placeholder, spaceRoleOptions: spaceRoleOptions, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, menuPlacement: menuPlacement = 'auto', appearance: appearance = 'subtle', noOptionsMessage: noOptionsMessage = '', spacing: spacing = 'default', menuPortalTarget: menuPortalTarget })=>{
    const [internalVal, setInternalVal] = (0, $42omo.useState)((value === undefined ? initialRoleId : value) || null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // The component is controlled if value is not `undefined`. `initialRole` will ignored in controlled mode.
    const isControlledComponent = value !== undefined;
    const options = (0, $42omo.useMemo)(()=>spaceRoleOptions.map((role)=>({
                id: role?.id ?? '',
                label: role?.name ?? '',
                value: role?.id ?? '',
                description: role?.description ?? ''
            })), [
        spaceRoleOptions
    ]);
    const getOptionFromValue = (0, $42omo.useCallback)((val)=>{
        if (!val) return null;
        return typeof val === 'string' ? options.find((option)=>option.value === val) || null : {
            id: val.value.toString(),
            label: val.label,
            value: val.value.toString(),
            description: ''
        };
    }, [
        options
    ]);
    const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, props, props.data.label));
    const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $d5c5d64568180920$var$menuItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest"
        }, props.data.description))));
    const handleChange = (newSelection)=>{
        const newSelectionType = spaceRoleOptions.find((role)=>role?.id === newSelection?.value)?.roleType;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'change',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    newSelection: newSelection?.id,
                    newSelectionType: newSelectionType
                }
            }
        }).fire();
        setInternalVal(newSelection?.value || null);
        onChange?.(spaceRoleOptions.find((role)=>role?.id === newSelection?.value));
    };
    const handleMenuOpen = (currentRoleSelection)=>{
        onMenuOpen?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'open',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    currentRoleSelection: currentRoleSelection?.id
                }
            }
        }).fire();
    };
    const SELECT_STYLE_PROPS = {
        isSearchable: false,
        styles: {
            menu: (base)=>({
                    ...base,
                    width: '320px',
                    padding: 0,
                    margin: 0,
                    zIndex: (0, $dTk3A.layers).modal() + 1 // Higher than modal to appear above modal content
                }),
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $dTk3A.layers).modal() + 1 // Higher than modal to appear above modal content
                })
        }
    };
    const selectValue = isControlledComponent ? getOptionFromValue(value) : getOptionFromValue(internalVal);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
        "data-testid": "space-roles-table-role-selector",
        placeholder: isLoading ? '' : placeholder,
        options: options,
        appearance: appearance,
        isLoading: isLoading,
        onChange: handleChange,
        onMenuOpen: ()=>handleMenuOpen(getOptionFromValue(isControlledComponent ? value : internalVal)),
        onMenuClose: onMenuClose,
        components: {
            SingleValue: CustomSingleValue,
            Option: CustomOption
        },
        menuPosition: "fixed",
        menuPlacement: menuPlacement,
        menuPortalTarget: menuPortalTarget,
        maxMenuHeight: 320,
        scrollBehavior: "outside",
        defaultValue: getOptionFromValue(initialRoleId),
        value: selectValue,
        noOptionsMessage: ()=>noOptionsMessage,
        spacing: spacing,
        ...SELECT_STYLE_PROPS
    });
};
module.exports["RoleSelector"] = $d5c5d64568180920$export$7b32174eb7b60a13;

});

parcelRegister("9rnOu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $75A8F = parcelRequire("75A8F");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $56M4r = parcelRequire("56M4r");

var $7rvPL = parcelRequire("7rvPL");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $d78f8d894583618b$var$i18n = (0, $cgtv4.defineMessages)({
    predefinedRoleListTitle: {
        id: "space-roles.view-role-permissions-modal.predefined-role-list-title",
        defaultMessage: "Confluence roles"
    },
    customRoleListTitle: {
        id: "space-roles.view-role-permissions-modal.custom-role-list-title",
        defaultMessage: "Custom roles"
    }
});
const $d78f8d894583618b$var$navContainerStyles = (0, $ecnYn.xcss)({
    width: '202px'
});
const $d78f8d894583618b$export$fa002117b34ac07e = ({ systemRoles: systemRoles, customRoles: customRoles, activeRoleId: activeRoleId, setActiveRoleId: setActiveRoleId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d78f8d894583618b$var$navContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
        title: formatMessage($d78f8d894583618b$var$i18n.predefinedRoleListTitle)
    }, systemRoles.map((role)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            key: role.id,
            isSelected: role.id === activeRoleId,
            onClick: ()=>setActiveRoleId(role.id)
        }, role.name))), customRoles && customRoles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
        title: formatMessage($d78f8d894583618b$var$i18n.customRoleListTitle)
    }, customRoles.map((role)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            key: role.id,
            isSelected: role.id === activeRoleId,
            onClick: ()=>setActiveRoleId(role.id)
        }, role.name))));
};


const $b296da749f5cb895$export$5cfd4e5ecf699324 = ({ systemRoles: systemRoles, customRoles: customRoles, allPermissions: allPermissions, onClose: onClose, initialActiveRoleId: initialActiveRoleId, analyticsSource: analyticsSource })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [activeRoleId, setActiveRoleId] = (0, $42omo.useState)(initialActiveRoleId || systemRoles[0]?.id || '');
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewRolePermissionsModal',
                attributes: {
                    source: analyticsSource
                }
            }
        }).fire();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75A8F.ViewRolePermissionsWrapper), {
        systemRoles: systemRoles,
        customRoles: customRoles,
        allPermissions: allPermissions,
        activeRoleId: activeRoleId,
        setActiveRoleId: setActiveRoleId,
        analyticsSource: analyticsSource,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d78f8d894583618b$export$fa002117b34ac07e), {
        systemRoles: systemRoles,
        customRoles: customRoles || [],
        activeRoleId: activeRoleId,
        setActiveRoleId: setActiveRoleId
    }));
};
module.exports["ViewRolePermissionModal"] = $b296da749f5cb895$export$5cfd4e5ecf699324;

});

parcelRegister("75A8F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $7hXDW = parcelRequire("7hXDW");


var $3sFtD = parcelRequire("3sFtD");


var $7yDmn = parcelRequire("7yDmn");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $6xdDU = parcelRequire("6xdDU");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $c6lYi = parcelRequire("c6lYi");


var $lsxnT = parcelRequire("lsxnT");


var $8Eh39 = parcelRequire("8Eh39");

const $1e059f1575c38760$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "space-roles.view-role-permissions-modal.title",
        defaultMessage: "Role permissions"
    },
    doneButtonText: {
        id: "space-roles.view-role-permissions-modal.done-button-text",
        defaultMessage: "Done"
    },
    permissionEnabled: {
        id: "space-roles.view-role-permissions-modal.permission-enabled",
        defaultMessage: "Enabled"
    },
    permissionDisabled: {
        id: "space-roles.view-role-permissions-modal.permission-disabled",
        defaultMessage: "Disabled"
    },
    editButtonLabel: {
        id: "space-roles.view-role-permissions-modal.edit-button-label",
        defaultMessage: "Edit role permissions"
    }
});
// -- Styles --
const $1e059f1575c38760$var$detailViewStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.600'
});
const $1e059f1575c38760$var$rolePermissionDetailContainerStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.400',
    rowGap: 'space.400',
    columnGap: 'space.1000',
    [(0, $bWLcG.media).above.sm]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    }
});
const $1e059f1575c38760$var$contentStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200'
});
const $1e059f1575c38760$var$checkboxGroupStyles = (0, $ecnYn.xcss)({
    gap: 'space.100',
    justifyContent: 'start'
});
const $1e059f1575c38760$var$modalHeaderStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    justifyContent: 'flex-end',
    width: '100%'
});
const $1e059f1575c38760$var$modalHeaderSpacing = (0, $ecnYn.xcss)({
    height: '100%',
    alignItems: 'center',
    width: '100%'
});
const $1e059f1575c38760$export$8008a8193747f6f5 = ({ systemRoles: systemRoles, customRoles: customRoles, allPermissions: allPermissions, onClose: onClose, activeRoleId: activeRoleId, analyticsSource: analyticsSource, title: title, children: children, footer: footer, extraPermissionContent: extraPermissionContent })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const activeRole = [
        ...systemRoles,
        ...customRoles || []
    ].find((role)=>role.id === activeRoleId);
    // Right side detail view
    // Build a dictionary for the active role to look up if a permission is enabled or not
    const activeRolePermissionDict = (0, $8Eh39.buildPermissionDictionary)(activeRole?.permissions || []);
    // Get all permissions and group them by group name
    const sortedPermissionGroupDict = (0, $8Eh39.getNormalizedPermissionItems)(undefined, allPermissions || []);
    const permissionListComps = Object.values(sortedPermissionGroupDict).map((group)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.150",
            key: group.group.name,
            xcss: $1e059f1575c38760$var$checkboxGroupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
            size: "xsmall"
        }, group.group.name), group.group.checkboxes.map((item)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.100",
                alignBlock: "start",
                key: item.id
            }, activeRolePermissionDict[item.id] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: formatMessage($1e059f1575c38760$var$i18n.permissionEnabled),
                color: "var(--ds-icon-success, #6A9A23)",
                spacing: "none"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: formatMessage($1e059f1575c38760$var$i18n.permissionDisabled),
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, item.displayName), extraPermissionContent?.[item.id] && extraPermissionContent[item.id]);
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 1000,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $1e059f1575c38760$var$modalHeaderSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium"
    }, title || formatMessage($1e059f1575c38760$var$i18n.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $1e059f1575c38760$var$modalHeaderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: analyticsSource,
        appearance: "subtle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: onClose
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $1e059f1575c38760$var$contentStyles
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1e059f1575c38760$var$detailViewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium"
    }, activeRole?.name || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, activeRole?.description || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        xcss: $1e059f1575c38760$var$rolePermissionDetailContainerStyle
    }, permissionListComps)))), footer || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClose
    }, formatMessage($1e059f1575c38760$var$i18n.doneButtonText))))));
};
module.exports["ViewRolePermissionsWrapper"] = $1e059f1575c38760$export$8008a8193747f6f5;

});

parcelRegister("8Eh39", function(module, exports) {
const $00348e3352156ed0$export$dbc5bcb243a11b25 = (permissions, allSpacePermissions, assignablePermissions)=>{
    // Permission groups are sorted here, then checkboxes of permissions are sorted below
    const sortedSpacePermissions = [
        ...allSpacePermissions
    ].sort((a, b)=>a.groupPriority - b.groupPriority);
    return Object.values(sortedSpacePermissions).reduce((acc, permission)=>{
        const isChecked = Boolean(permissions?.includes(permission.key));
        const checkbox = {
            id: permission.key,
            displayName: permission.actionName,
            priority: permission.priority,
            description: permission.description || '',
            isAssignable: !!assignablePermissions ? assignablePermissions.includes(permission.key) : true,
            isChecked: isChecked,
            isDisabled: false
        };
        const group = {
            groupName: permission.groupName,
            groupPriority: permission.groupPriority
        };
        if (!acc[group.groupName]) acc[group.groupName] = {
            group: {
                name: group.groupName,
                priority: group.groupPriority,
                checkboxes: []
            }
        };
        acc[group.groupName].group.checkboxes.push(checkbox);
        acc[group.groupName].group.checkboxes.sort((a, b)=>a.priority - b.priority);
        return acc;
    }, {});
};
const $00348e3352156ed0$export$eda4a295c95572c4 = (allowedPermissions)=>{
    return allowedPermissions.reduce((acc, permission)=>{
        acc[permission] = true;
        return acc;
    }, {});
};
module.exports["getNormalizedPermissionItems"] = $00348e3352156ed0$export$dbc5bcb243a11b25;
module.exports["buildPermissionDictionary"] = $00348e3352156ed0$export$eda4a295c95572c4;

});

parcelRegister("g26MG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lebfc = parcelRequire("lebfc");


var $lAFHW = parcelRequire("lAFHW");


var $buthI = parcelRequire("buthI");


var $9wGTI = parcelRequire("9wGTI");


var $fGLQm = parcelRequire("fGLQm");

var $itlCX = parcelRequire("itlCX");

const $bab3f5eb7fd997b5$var$AccessClassIcon = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
        appearance: 'brand'
    });
const $bab3f5eb7fd997b5$var$getPrincipalIcon = (principal)=>{
    switch(principal.__typename){
        case 'SpaceRoleGroupPrincipal':
            return 0, (/*@__PURE__*/$parcel$interopDefault($lebfc));
        case 'SpaceRoleAccessClassPrincipal':
            return principal.principalId === 'anonymous-users' ? (0, (/*@__PURE__*/$parcel$interopDefault($buthI))) : $bab3f5eb7fd997b5$var$AccessClassIcon;
        case 'ConfluenceSpaceRoleAppPrincipal':
        case 'SpaceRoleGuestPrincipal':
        case 'SpaceRoleUserPrincipal':
        default:
            return null;
    }
};
const $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8 = (data, isCompanyHub = false)=>{
    return data.map((item)=>({
            key: item.id,
            groupName: item.group.displayName,
            groupPriority: item.group.priority,
            // Use hubDisplayName if in companyhub context, otherwise fall back to displayName
            actionName: isCompanyHub && item.hubDisplayName || item.displayName,
            priority: item.priority,
            // Use hubDescription if in companyhub context, otherwise fall back to description
            description: isCompanyHub && item.hubDescription || item.description,
            requiredPermissions: item.requiredSpacePermissions
        }))// Filter out all actions without display names before the deprecation of some permissions is completed
    .filter((item)=>!!item.actionName);
};
const $bab3f5eb7fd997b5$export$429eba48f8769b83 = (rawData)=>{
    return rawData.filter((d)=>d !== null).map((item)=>({
            id: item.roleId,
            name: item.roleDisplayName,
            description: item.roleDescription,
            permissions: item.spacePermissionList.map((permission)=>permission.id),
            roleType: item.roleType,
            confluenceRoleAssignabilityCode: item.confluenceRoleAssignabilityCode
        }));
};
const $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591 = (type)=>{
    switch(type){
        case 'SpaceRoleGuestPrincipal':
            // Guests are users.
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'ConfluenceSpaceRoleAppPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).APP;
        case 'SpaceRoleGroupPrincipal':
            // Teams are groups.
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'SpaceRoleUserPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'SpaceRoleAccessClassPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
    }
};
const $bab3f5eb7fd997b5$export$bf16ef98b7c6b580 = (type)=>{
    switch(type){
        case 'user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'team':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'group':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'external_user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'custom':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
    }
};
const $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c = (rawData)=>{
    if (!rawData) return [];
    return rawData.map((item)=>{
        const { principal: principal, role: role } = item;
        const isTeam = principal.__typename === 'SpaceRoleGroupPrincipal' && principal.usageType === (0, $fGLQm.ConfluenceGroupUsageType).TEAM_COLLABORATION;
        return {
            assignmentId: principal.principalId,
            principal: {
                id: principal.principalId,
                displayName: principal.displayName,
                type: $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591(principal.__typename),
                email: 'email' in principal ? principal?.email : undefined,
                avatarUrl: 'profilePicture' in principal ? principal.profilePicture?.path : undefined,
                icon: isTeam && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? null : $bab3f5eb7fd997b5$var$getPrincipalIcon(principal),
                isGuest: principal.__typename === 'SpaceRoleGuestPrincipal',
                isTeam: isTeam
            },
            roleId: role?.roleId || null,
            roleLabel: role?.roleDisplayName || null,
            roleDescription: role?.roleDescription || null,
            // Principal can either be assigned granular space permissions, or permissions through a role
            permissions: item?.permissions?.map((permission)=>permission.id) || role?.spacePermissionList.map((permission)=>permission.id) || [],
            availableRoles: [],
            unavailableRoles: [],
            assignablePermissions: item.assignablePermissions?.map((permission)=>permission).filter(Boolean) || []
        };
    });
};
const $bab3f5eb7fd997b5$export$f41b22015074a487 = (groupCountRecords, assignments)=>{
    const groupCountMap = groupCountRecords.reduce((acc, { key: key, value: value })=>{
        if (key !== null) acc[key] = value;
        return acc;
    }, {});
    return assignments.map((assignment)=>({
            ...assignment,
            principal: assignment.principal.type === (0, $itlCX.RoleAssignmentPrincipalType).GROUP ? {
                ...assignment.principal,
                groupCount: groupCountMap[assignment.principal.id] ?? undefined
            } : assignment.principal
        }));
};
const $bab3f5eb7fd997b5$export$89b4246717b63b9f = (assignments, teamData)=>{
    if (!teamData || teamData.length === 0) return assignments;
    return assignments.map((row)=>{
        const teamInfo = teamData.find((team)=>team.id === row.principal.id);
        if (!teamInfo) return row;
        return {
            ...row,
            principal: {
                ...row.principal,
                icon: null,
                avatarUrl: teamInfo.largeAvatarImageUrl,
                isTeam: true,
                isVerified: teamInfo.isVerified
            }
        };
    });
};
const $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID = 'authenticated-users';
const $bab3f5eb7fd997b5$export$b3299b59e278e268 = (assignments)=>assignments.filter((record)=>record.principal.id !== $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID);
const $bab3f5eb7fd997b5$export$2fed59ad085105af = (displayTypes)=>{
    return displayTypes.filter((type)=>type !== 'TEAM').concat(displayTypes.includes('TEAM') ? [
        (0, $fGLQm.PrincipalFilterType).GROUP
    ] : []);
};
const $bab3f5eb7fd997b5$export$cc79220753e2d98a = (filterTypes)=>{
    if (filterTypes.length === 0) return [];
    const typesToFilterOut = [];
    if (!filterTypes.includes((0, $fGLQm.PrincipalFilterType).GROUP)) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).USERBASE_GROUP);
    if (!filterTypes.includes('TEAM')) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).TEAM_COLLABORATION);
    if (!filterTypes.includes((0, $fGLQm.PrincipalFilterType).USER_CLASS)) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).ADMIN_OVERSIGHT);
    return typesToFilterOut;
};
module.exports["normalizeSpacePermissionAll"] = $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8;
module.exports["normalizeSpaceRoleList"] = $bab3f5eb7fd997b5$export$429eba48f8769b83;
module.exports["getPrincipalTypeFromUserPickerType"] = $bab3f5eb7fd997b5$export$bf16ef98b7c6b580;
module.exports["normalizeAssignments"] = $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c;
module.exports["mergeGroupCountWithAssignments"] = $bab3f5eb7fd997b5$export$f41b22015074a487;
module.exports["mergeTeamDataWithAssignments"] = $bab3f5eb7fd997b5$export$89b4246717b63b9f;
module.exports["filterOutUnlicensedUsersAssignment"] = $bab3f5eb7fd997b5$export$b3299b59e278e268;
module.exports["displayPrincipalTypesToAPIPrincipalFilterTypes"] = $bab3f5eb7fd997b5$export$2fed59ad085105af;
module.exports["getTypesToFilterOut"] = $bab3f5eb7fd997b5$export$cc79220753e2d98a;

});

parcelRegister("fGLQm", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $4556f39c84e2f302$export$83836e07b7a1797e = /*#__PURE__*/ function(ConfluenceGroupManagementType) {
    ConfluenceGroupManagementType["ADMINS"] = "ADMINS";
    ConfluenceGroupManagementType["EXTERNAL"] = "EXTERNAL";
    ConfluenceGroupManagementType["OPEN"] = "OPEN";
    ConfluenceGroupManagementType["TEAM_MEMBERS"] = "TEAM_MEMBERS";
    return ConfluenceGroupManagementType;
}({});
var $4556f39c84e2f302$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $4556f39c84e2f302$export$c68cf5b85bcf89b0 = /*#__PURE__*/ function(PrincipalFilterType) {
    PrincipalFilterType["APP"] = "APP";
    PrincipalFilterType["GROUP"] = "GROUP";
    PrincipalFilterType["GUEST"] = "GUEST";
    PrincipalFilterType["USER"] = "USER";
    PrincipalFilterType["USER_CLASS"] = "USER_CLASS";
    return PrincipalFilterType;
}({});
var $4556f39c84e2f302$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({});
module.exports["ConfluenceGroupUsageType"] = $4556f39c84e2f302$export$e7c9280c9da1cc0a;
module.exports["PrincipalFilterType"] = $4556f39c84e2f302$export$c68cf5b85bcf89b0;

});

parcelRegister("itlCX", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d794298446e7cdbe$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["APP"] = "APP";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});
module.exports["RoleAssignmentPrincipalType"] = $d794298446e7cdbe$export$4e2d5448f3fd8728;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("bbaoL", function(module, exports) {

let $8238c9af2093d408$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8238c9af2093d408$var$load("fXI14").then(()=>parcelRequire('6TPcn'));

});

parcelRegister("7LCJI", function(module, exports) {

let $5a7af8657853101f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a7af8657853101f$var$load("6wr18"),
    $5a7af8657853101f$var$load("ffEVr"),
    $5a7af8657853101f$var$load("7uWW8")
]).then(()=>parcelRequire('1c1P5'));

});

parcelRegister("go5PI", function(module, exports) {
const $a85703dfa4960dc8$export$6efc679b5f68edbb = 'adminConfiguration';
const $a85703dfa4960dc8$export$29494bfe5045193 = 'https://support.atlassian.com/confluence-cloud/docs/insert-confluence-wiki-markup/';
const $a85703dfa4960dc8$export$68fe928f91262da7 = 'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/';
const $a85703dfa4960dc8$export$d1b15eb7eed612ff = 'https://support.atlassian.com/confluence-cloud/docs/configure-time-and-date-formats/';
const $a85703dfa4960dc8$export$4facdf667af1c221 = 'https://confluence.atlassian.com/x/A41jL';
const $a85703dfa4960dc8$export$c6b232dd07adf3e8 = 'https://support.atlassian.com/confluence-cloud/docs/view-a-page/';
module.exports["ADMIN_CONFIGURATION_ANALYTICS_SOURCE"] = $a85703dfa4960dc8$export$6efc679b5f68edbb;
module.exports["WIKI_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$29494bfe5045193;
module.exports["CONVERT_PAGES_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$68fe928f91262da7;
module.exports["DATE_TIME_FORMAT_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$d1b15eb7eed612ff;
module.exports["PRESENCE_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$c6b232dd07adf3e8;

});

parcelRegister("kFe3Q", function(module, exports) {

let $f0b28b31745d8df0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0b28b31745d8df0$var$load("hMzlw").then(()=>parcelRequire('lkTIR'));

});

parcelRegister("87xWZ", function(module, exports) {
const $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52 = 'adminDefaultSpaceLogoConfig';
const $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a = [
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.webp'
];
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE"] = $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52;
module.exports["ALLOWED_LOGO_FILE_EXTENSIONS"] = $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a;

});

parcelRegister("ksDMU", function(module, exports) {

let $ee55493640697816$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee55493640697816$var$load("lh6fT").then(()=>parcelRequire('f9aTe'));

});

parcelRegister("9VF1g", function(module, exports) {
const $3395fdb7c7788386$export$f57d5d3f8ce40ac2 = 'adminHeaderAndFooterConfig';
const $3395fdb7c7788386$export$6dbb84b06e78ca9 = '/admin/header-and-footer';
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE"] = $3395fdb7c7788386$export$f57d5d3f8ce40ac2;
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_PATH_NAME"] = $3395fdb7c7788386$export$6dbb84b06e78ca9;

});

parcelRegister("ktfnc", function(module, exports) {

let $ee7270e4559d9344$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee7270e4559d9344$var$load("8iU4E").then(()=>parcelRequire('46IN4'));

});

parcelRegister("kzcPl", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");

const $a85fb93a41cf2970$export$e7cba70eb2004729 = 'adminTemplatesAndBlueprints';
const $a85fb93a41cf2970$export$59e8eaf2c1cf7d28 = '/admin/templates-and-blueprints';
const $a85fb93a41cf2970$export$8726b5b334ad0749 = [
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_TEMPLATES_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_BLUEPRINTS_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_SYSTEM_TEMPLATES_LOAD_EXPERIENCE)
];
module.exports["ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE"] = $a85fb93a41cf2970$export$e7cba70eb2004729;
module.exports["PATH_NAME"] = $a85fb93a41cf2970$export$59e8eaf2c1cf7d28;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_SUB_EXPERIENCES"] = $a85fb93a41cf2970$export$8726b5b334ad0749;

});

parcelRegister("pI7qq", function(module, exports) {

let $04d48efb2da6bc27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04d48efb2da6bc27$var$load("dCPNW").then(()=>parcelRequire('bHNfF'));

});

parcelRegister("3Tdyk", function(module, exports) {
const $b18a48086d5c5e91$export$fa039ba6a22ab542 = 'adminNotifications';
module.exports["ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE"] = $b18a48086d5c5e91$export$fa039ba6a22ab542;

});

parcelRegister("aDiH1", function(module, exports) {

let $7bdc0bebe4c53722$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7bdc0bebe4c53722$var$load("iQ0Jm"),
    $7bdc0bebe4c53722$var$load("gLGsg"),
    $7bdc0bebe4c53722$var$load("krOJz")
]).then(()=>parcelRequire('lMhQj'));

});

parcelRegister("i6ccO", function(module, exports) {
const $5030b4f7b6082c77$export$40d649ebb84b67da = 'spaceReportsSiteSettings';
module.exports["ADMIN_SPACE_REPORT_SCREEN"] = $5030b4f7b6082c77$export$40d649ebb84b67da;

});

parcelRegister("1wgeK", function(module, exports) {

let $11b55fe1d7f0ccb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11b55fe1d7f0ccb3$var$load("lQHJf").then(()=>parcelRequire('2nzCJ'));

});

parcelRegister("jPtik", function(module, exports) {
const $877d602a9e3b74d4$export$3b900d9a0f807a35 = 'adminConfigureCodeMacro';
const $877d602a9e3b74d4$export$99fd23db6b16a233 = 'Confluence';
const $877d602a9e3b74d4$export$c73844cf6c80166 = 'Java';
module.exports["ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE"] = $877d602a9e3b74d4$export$3b900d9a0f807a35;
module.exports["DEFAULT_THEME_VALUE"] = $877d602a9e3b74d4$export$99fd23db6b16a233;
module.exports["DEFAULT_LANGUAGE_VALUE"] = $877d602a9e3b74d4$export$c73844cf6c80166;

});

parcelRegister("2OOsw", function(module, exports) {

let $20d7646468dc1fb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20d7646468dc1fb1$var$load("lMnCe").then(()=>parcelRequire('5XJaz'));

});

parcelRegister("5vGLM", function(module, exports) {
const $18527396bdb04510$export$5ab36823e88567de = 'securityConfiguration';
const $18527396bdb04510$export$40326e81f7c56c6a = 'https://support.atlassian.com/confluence-cloud/docs/hide-external-links-from-search-engines/';
const $18527396bdb04510$export$8802c1db742ad689 = 2147483647;
module.exports["ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE"] = $18527396bdb04510$export$5ab36823e88567de;
module.exports["EXTERNAL_LINKS_LEARN_MORE_LINK"] = $18527396bdb04510$export$40326e81f7c56c6a;
module.exports["MAX_SAFE_JAVA_INTEGER"] = $18527396bdb04510$export$8802c1db742ad689;

});

parcelRegister("eOW3x", function(module, exports) {

let $aca2c4f1ace949bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aca2c4f1ace949bc$var$load("kaFPr").then(()=>parcelRequire('2C4l7'));

});

parcelRegister("dWfBt", function(module, exports) {
const $3252933457ee5bfd$export$1c3a7fb1674ebcd2 = 'adminApplicationNavigator';
const $3252933457ee5bfd$export$59e8eaf2c1cf7d28 = '/admin/application-navigator';
module.exports["ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE"] = $3252933457ee5bfd$export$1c3a7fb1674ebcd2;

});

parcelRegister("bz3UX", function(module, exports) {

let $86b6008e69f92e26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86b6008e69f92e26$var$load("f4DD6").then(()=>parcelRequire('6JHmj'));

});

parcelRegister("9JmJC", function(module, exports) {
const $3381874ada981275$export$4ad87fa408071f9e = 'adminMacroUsage';
module.exports["ADMIN_MACRO_USAGE_ANALYTICS_SOURCE"] = $3381874ada981275$export$4ad87fa408071f9e;

});

parcelRegister("f99tb", function(module, exports) {

let $b06f0ac0e09b8169$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b06f0ac0e09b8169$var$load("2DNIK"),
    $b06f0ac0e09b8169$var$load("8JZKd"),
    $b06f0ac0e09b8169$var$load("kTv6A"),
    $b06f0ac0e09b8169$var$load("gLGsg"),
    $b06f0ac0e09b8169$var$load("3YiRE")
]).then(()=>parcelRequire('iR5x9'));

});

parcelRegister("4l9JY", function(module, exports) {
// Server expects the "after" parameter as a string index
const $bd0500c03ad06aff$export$eb9c69e3a09b9217 = '-1';
const $bd0500c03ad06aff$export$5716e8bcb003888d = 20;
const $bd0500c03ad06aff$export$717a6bceadab3608 = 'trashed';
const $bd0500c03ad06aff$export$ee14340141c11674 = 5000;
const $bd0500c03ad06aff$export$43b26519b9b8a3e = 'adminTrashedSpaces';
module.exports["DEFAULT_START_INDEX"] = $bd0500c03ad06aff$export$eb9c69e3a09b9217;
module.exports["DEFAULT_PAGE_SIZE"] = $bd0500c03ad06aff$export$5716e8bcb003888d;
module.exports["SPACE_STATUS_TRASHED"] = $bd0500c03ad06aff$export$717a6bceadab3608;
module.exports["POLL_INTERVAL_MS"] = $bd0500c03ad06aff$export$ee14340141c11674;
module.exports["ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE"] = $bd0500c03ad06aff$export$43b26519b9b8a3e;

});

parcelRegister("dCOIH", function(module, exports) {

let $9eb62ae5e8e4669c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9eb62ae5e8e4669c$var$load("iOJdB").then(()=>parcelRequire('452sv'));

});

parcelRegister("434W4", function(module, exports) {
// XMLs or CSVs should be in a zip file
const $b6c44f979bbed03e$export$417e5fe1d0de6e47 = [
    '.zip'
];
const $b6c44f979bbed03e$export$42f152cabc617ec2 = 1500;
const $b6c44f979bbed03e$export$5f9abcd3ce58c0ab = 'adminImportSpaces';
const $b6c44f979bbed03e$export$61387ee612136e90 = 300000;
const $b6c44f979bbed03e$export$9e3220b2979f5262 = 'https://marketplace.atlassian.com/apps/1219672/cloud-migration-assistant-for-confluence';
const $b6c44f979bbed03e$export$ebe1d3a4348867c4 = 'https://confluence.atlassian.com/doc/export-content-to-word-pdf-html-and-xml-139475.html#ExportContenttoWord,PDF,HTMLandXML-ExportmultiplepagestoHTML,XML,orPDF';
module.exports["ALLOWED_FILE_EXTENSIONS"] = $b6c44f979bbed03e$export$417e5fe1d0de6e47;
module.exports["IMPORT_STATUS_CHECK_POLL_INTERVAL_MS"] = $b6c44f979bbed03e$export$42f152cabc617ec2;
module.exports["ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE"] = $b6c44f979bbed03e$export$5f9abcd3ce58c0ab;
module.exports["MEDIA_AUTH_PROVIDER_FIVE_MIN_TIMEOUT"] = $b6c44f979bbed03e$export$61387ee612136e90;
module.exports["CLOUD_MIGRATION_ASSISTANT_LINK"] = $b6c44f979bbed03e$export$9e3220b2979f5262;
module.exports["EXPORT_HELP_LINK"] = $b6c44f979bbed03e$export$ebe1d3a4348867c4;

});

parcelRegister("iMgCe", function(module, exports) {

let $dab9993526fb29f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dab9993526fb29f0$var$load("4Z5Uh").then(()=>parcelRequire('f10rR'));

});

parcelRegister("2i0P8", function(module, exports) {
const $ffc87555304a609f$export$8b897d36b093ccf1 = 'adminJiraMacroRepair';
const $ffc87555304a609f$export$ee14340141c11674 = 1000;
const $ffc87555304a609f$export$765b83ed862a0ed = '/wiki/plugins/servlet/applinks/listApplicationLinks';
module.exports["ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE"] = $ffc87555304a609f$export$8b897d36b093ccf1;
module.exports["POLL_INTERVAL_MS"] = $ffc87555304a609f$export$ee14340141c11674;
module.exports["APP_LINKS_URL"] = $ffc87555304a609f$export$765b83ed862a0ed;

});

parcelRegister("bKpjI", function(module, exports) {

let $88d7a10176ff8e11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88d7a10176ff8e11$var$load("6KDUv").then(()=>parcelRequire('iiqL3'));

});

parcelRegister("ft9Jc", function(module, exports) {
const $5b008143e5994a1d$export$5b9a48b5dd6a4ea2 = 'adminThemes';
module.exports["ADMIN_THEMES_ANALYTICS_SOURCE"] = $5b008143e5994a1d$export$5b9a48b5dd6a4ea2;

});

parcelRegister("cGA12", function(module, exports) {

let $93c558407994c248$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93c558407994c248$var$load("9BxhS").then(()=>parcelRequire('5JXtG'));

});

parcelRegister("fmC2G", function(module, exports) {
const $2d4e85d5268f55f9$export$546ba186ec91e3c9 = 'adminPdfExport';
const $2d4e85d5268f55f9$export$dec669626e46bbfe = 'https://support.atlassian.com/confluence-cloud/docs/customize-exports-to-pdf/';
module.exports["ADMIN_PDF_EXPORT_ANALYTICS_SOURCE"] = $2d4e85d5268f55f9$export$546ba186ec91e3c9;
module.exports["STYLESHEET_SUPPORT_DOC_URL"] = $2d4e85d5268f55f9$export$dec669626e46bbfe;

});

parcelRegister("8Nhaa", function(module, exports) {
const $1ede882b6a23a4b1$export$fa5f102b28968fd8 = 'spaceManager';
module.exports["SPACE_MANAGER_ANALYTICS_SOURCE"] = $1ede882b6a23a4b1$export$fa5f102b28968fd8;

});

parcelRegister("6Dt64", function(module, exports) {

let $4d4cf4a378413b42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d4cf4a378413b42$var$load("foT6i"),
    $4d4cf4a378413b42$var$load("6wr18"),
    $4d4cf4a378413b42$var$load("ffEVr"),
    $4d4cf4a378413b42$var$load("aFS1j"),
    $4d4cf4a378413b42$var$load("gLGsg"),
    $4d4cf4a378413b42$var$load("2YlyO")
]).then(()=>parcelRequire('753aK'));

});

parcelRegister("1Si0y", function(module, exports) {

let $15d8cd9bfb2a7d2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $15d8cd9bfb2a7d2a$var$load("5LAxC"),
    $15d8cd9bfb2a7d2a$var$load("4aB7p"),
    $15d8cd9bfb2a7d2a$var$load("9sJzT"),
    $15d8cd9bfb2a7d2a$var$load("6XCf4"),
    $15d8cd9bfb2a7d2a$var$load("7EorR"),
    $15d8cd9bfb2a7d2a$var$load("5pvpJ"),
    $15d8cd9bfb2a7d2a$var$load("1qlDN"),
    $15d8cd9bfb2a7d2a$var$load("1yVM6"),
    $15d8cd9bfb2a7d2a$var$load("6gpUD")
]).then(()=>parcelRequire('dTw2J'));

});

parcelRegister("d73E7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $61e340fdd81a37ab$export$eb67fd6afe5bdfc8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7rQv",
    name: "WhiteboardRouteComponentLoader",
    loader: ()=>(parcelRequire("73Khj"))
});
module.exports["WhiteboardRouteComponentLoader"] = $61e340fdd81a37ab$export$eb67fd6afe5bdfc8;

});

parcelRegister("73Khj", function(module, exports) {

let $523cb61ca567bc4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $523cb61ca567bc4d$var$load("7Omhy"),
    $523cb61ca567bc4d$var$load("9A0ig"),
    $523cb61ca567bc4d$var$load("5coOi"),
    $523cb61ca567bc4d$var$load("fTFcV"),
    $523cb61ca567bc4d$var$load("hcj2C"),
    $523cb61ca567bc4d$var$load("2UF2x"),
    $523cb61ca567bc4d$var$load("jwWp5"),
    $523cb61ca567bc4d$var$load("2Cftu"),
    $523cb61ca567bc4d$var$load("4i0CB"),
    $523cb61ca567bc4d$var$load("ePdWC"),
    $523cb61ca567bc4d$var$load("lBzRN"),
    $523cb61ca567bc4d$var$load("4Lgj0"),
    $523cb61ca567bc4d$var$load("kSJiq"),
    $523cb61ca567bc4d$var$load("2YffH"),
    $523cb61ca567bc4d$var$load("8Uu6s"),
    $523cb61ca567bc4d$var$load("gwtBH"),
    $523cb61ca567bc4d$var$load("fT09S"),
    $523cb61ca567bc4d$var$load("igHL0"),
    $523cb61ca567bc4d$var$load("3gnID"),
    $523cb61ca567bc4d$var$load("90kvt"),
    $523cb61ca567bc4d$var$load("eYere"),
    $523cb61ca567bc4d$var$load("at1W4"),
    $523cb61ca567bc4d$var$load("65rGD"),
    $523cb61ca567bc4d$var$load("5Vmp6"),
    $523cb61ca567bc4d$var$load("4eboO"),
    $523cb61ca567bc4d$var$load("8YSo7"),
    $523cb61ca567bc4d$var$load("lqbST"),
    $523cb61ca567bc4d$var$load("4t77a"),
    $523cb61ca567bc4d$var$load("gLGsg"),
    $523cb61ca567bc4d$var$load("2F69B"),
    $523cb61ca567bc4d$var$load("5pvpJ"),
    $523cb61ca567bc4d$var$load("8bZKp"),
    $523cb61ca567bc4d$var$load("7RNcA"),
    $523cb61ca567bc4d$var$load("kjZZD"),
    $523cb61ca567bc4d$var$load("kWNlz"),
    $523cb61ca567bc4d$var$load("cHTTI"),
    $523cb61ca567bc4d$var$load("1qlDN"),
    $523cb61ca567bc4d$var$load("1yVM6"),
    $523cb61ca567bc4d$var$load("awqCy"),
    $523cb61ca567bc4d$var$load("6wr18"),
    $523cb61ca567bc4d$var$load("cyGuT"),
    $523cb61ca567bc4d$var$load("9wxKg"),
    $523cb61ca567bc4d$var$load("kel4J"),
    $523cb61ca567bc4d$var$load("Wowvf"),
    $523cb61ca567bc4d$var$load("6O8m6"),
    $523cb61ca567bc4d$var$load("5GxU8"),
    $523cb61ca567bc4d$var$load("amUNi"),
    $523cb61ca567bc4d$var$load("7whwt"),
    $523cb61ca567bc4d$var$load("7e13v"),
    $523cb61ca567bc4d$var$load("699ae"),
    $523cb61ca567bc4d$var$load("i7QCq"),
    $523cb61ca567bc4d$var$load("let0D"),
    $523cb61ca567bc4d$var$load("87NBA"),
    $523cb61ca567bc4d$var$load("8KnyD"),
    $523cb61ca567bc4d$var$load("ffEVr"),
    $523cb61ca567bc4d$var$load("kUbUu"),
    $523cb61ca567bc4d$var$load("dIKn2"),
    $523cb61ca567bc4d$var$load("8fdGr"),
    $523cb61ca567bc4d$var$load("hhss7"),
    $523cb61ca567bc4d$var$load("7EorR"),
    $523cb61ca567bc4d$var$load("jZkQK")
]).then(()=>parcelRequire('ib0d9'));

});

parcelRegister("3aHlq", function(module, exports) {

let $24f3ed9857d01a4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $24f3ed9857d01a4a$var$load("7u5Uq"),
    $24f3ed9857d01a4a$var$load("gLWJk")
]).then(()=>parcelRequire('5Idyr'));

});

parcelRegister("6oMqS", function(module, exports) {

let $4a8a8da7d20a809e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a8a8da7d20a809e$var$load("7u5Uq"),
    $4a8a8da7d20a809e$var$load("iOr1f")
]).then(()=>parcelRequire('58rkb'));

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("hVRC2", function(module, exports) {

let $035e792cd7ae5232$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $035e792cd7ae5232$var$load("7u5Uq"),
    $035e792cd7ae5232$var$load("4cHGm"),
    $035e792cd7ae5232$var$load("2F69B"),
    $035e792cd7ae5232$var$load("9XYQ9"),
    $035e792cd7ae5232$var$load("jkPqm"),
    $035e792cd7ae5232$var$load("9wxKg"),
    $035e792cd7ae5232$var$load("6wr18"),
    $035e792cd7ae5232$var$load("8JZKd"),
    $035e792cd7ae5232$var$load("kTv6A"),
    $035e792cd7ae5232$var$load("7EorR"),
    $035e792cd7ae5232$var$load("kHOMt"),
    $035e792cd7ae5232$var$load("hhss7"),
    $035e792cd7ae5232$var$load("Wowvf"),
    $035e792cd7ae5232$var$load("7e13v"),
    $035e792cd7ae5232$var$load("87NBA"),
    $035e792cd7ae5232$var$load("ffEVr"),
    $035e792cd7ae5232$var$load("c0JsV"),
    $035e792cd7ae5232$var$load("kZzff")
]).then(()=>parcelRequire('2rALa'));

});

parcelRegister("1MVQO", function(module, exports) {

let $14d726164ea7dd14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14d726164ea7dd14$var$load("5coOi"),
    $14d726164ea7dd14$var$load("6wr18"),
    $14d726164ea7dd14$var$load("gwtBH"),
    $14d726164ea7dd14$var$load("7u5Uq"),
    $14d726164ea7dd14$var$load("7ZBIQ"),
    $14d726164ea7dd14$var$load("7A5zJ"),
    $14d726164ea7dd14$var$load("gLGsg"),
    $14d726164ea7dd14$var$load("fwmQF"),
    $14d726164ea7dd14$var$load("2F69B"),
    $14d726164ea7dd14$var$load("ffEVr"),
    $14d726164ea7dd14$var$load("bT0I9")
]).then(()=>parcelRequire('1hCZf'));

});

parcelRegister("bwC5h", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $4b4iP = parcelRequire("4b4iP");

const $864039964f3f4398$var$SpaceRestriction = ({ spaceKey: spaceKey, contentId: contentId, children: children })=>{
    if (!spaceKey) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        contentId: contentId
    }, children);
};
$864039964f3f4398$var$SpaceRestriction.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired
};
var $864039964f3f4398$export$2e2bcd8739ae039 = $864039964f3f4398$var$SpaceRestriction;
module.exports["default"] = $864039964f3f4398$export$2e2bcd8739ae039;

});

parcelRegister("epBQg", function(module, exports) {

let $a7e0c1217d89d0a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7e0c1217d89d0a4$var$load("hmUGS").then(()=>parcelRequire('1azj7'));

});

parcelRegister("iufgB", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ef29e49aacc3ecbc$export$80e55c7cff6cb8a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IPyzb",
    name: "CreateContentRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("aRfTL"))).CreateContentRouteComponentWrapper
});
module.exports["CreateContentRouteComponentLoader"] = $ef29e49aacc3ecbc$export$80e55c7cff6cb8a;

});

parcelRegister("aRfTL", function(module, exports) {

let $7e7b2fb10dc2832d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e7b2fb10dc2832d$var$load("277qv"),
    $7e7b2fb10dc2832d$var$load("jkPqm"),
    $7e7b2fb10dc2832d$var$load("9wxKg"),
    $7e7b2fb10dc2832d$var$load("6wr18"),
    $7e7b2fb10dc2832d$var$load("igneX"),
    $7e7b2fb10dc2832d$var$load("hcj2C"),
    $7e7b2fb10dc2832d$var$load("2UF2x"),
    $7e7b2fb10dc2832d$var$load("3z2v3"),
    $7e7b2fb10dc2832d$var$load("8YSo7"),
    $7e7b2fb10dc2832d$var$load("Wowvf"),
    $7e7b2fb10dc2832d$var$load("ffEVr"),
    $7e7b2fb10dc2832d$var$load("4g2Mj"),
    $7e7b2fb10dc2832d$var$load("7e13v"),
    $7e7b2fb10dc2832d$var$load("699ae"),
    $7e7b2fb10dc2832d$var$load("i7QCq"),
    $7e7b2fb10dc2832d$var$load("let0D"),
    $7e7b2fb10dc2832d$var$load("87NBA"),
    $7e7b2fb10dc2832d$var$load("8KnyD"),
    $7e7b2fb10dc2832d$var$load("hhss7"),
    $7e7b2fb10dc2832d$var$load("7EorR"),
    $7e7b2fb10dc2832d$var$load("lrKPf")
]).then(()=>parcelRequire('79aVL'));

});

parcelRegister("6CEg5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $42omo.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("ko9Ek", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4cd8f2daf274114d$export$2312ebab360877df = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HinAE",
    // Name is used in next/packages/view-page/src/index.ts must match
    name: "ViewPageRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("B3wy8"))).ViewPageRouteComponent
});
module.exports["ViewPageRouteComponentLoader"] = $4cd8f2daf274114d$export$2312ebab360877df;

});

parcelRegister("B3wy8", function(module, exports) {

let $06f6309b95185a81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $06f6309b95185a81$var$load("7Omhy"),
    $06f6309b95185a81$var$load("2YffH"),
    $06f6309b95185a81$var$load("jdHbV"),
    $06f6309b95185a81$var$load("A1eSR"),
    $06f6309b95185a81$var$load("2rCak"),
    $06f6309b95185a81$var$load("2F69B"),
    $06f6309b95185a81$var$load("aZinD"),
    $06f6309b95185a81$var$load("iIL8i"),
    $06f6309b95185a81$var$load("eYere"),
    $06f6309b95185a81$var$load("at1W4"),
    $06f6309b95185a81$var$load("lkOIY"),
    $06f6309b95185a81$var$load("hcj2C"),
    $06f6309b95185a81$var$load("2UF2x"),
    $06f6309b95185a81$var$load("4eboO"),
    $06f6309b95185a81$var$load("fgAx2"),
    $06f6309b95185a81$var$load("8YSo7"),
    $06f6309b95185a81$var$load("fqGSw"),
    $06f6309b95185a81$var$load("lqbST"),
    $06f6309b95185a81$var$load("jwWp5"),
    $06f6309b95185a81$var$load("3CHGC"),
    $06f6309b95185a81$var$load("cgLyI"),
    $06f6309b95185a81$var$load("2Cftu"),
    $06f6309b95185a81$var$load("4i0CB"),
    $06f6309b95185a81$var$load("49GA1"),
    $06f6309b95185a81$var$load("32K9i"),
    $06f6309b95185a81$var$load("h4k4y"),
    $06f6309b95185a81$var$load("9ijrN"),
    $06f6309b95185a81$var$load("aeEUI"),
    $06f6309b95185a81$var$load("iXzmH"),
    $06f6309b95185a81$var$load("65c4i"),
    $06f6309b95185a81$var$load("kjZZD"),
    $06f6309b95185a81$var$load("jkPqm"),
    $06f6309b95185a81$var$load("awqCy"),
    $06f6309b95185a81$var$load("6wr18"),
    $06f6309b95185a81$var$load("cyGuT"),
    $06f6309b95185a81$var$load("8ab9M"),
    $06f6309b95185a81$var$load("gyOzw"),
    $06f6309b95185a81$var$load("ePdWC"),
    $06f6309b95185a81$var$load("lBzRN"),
    $06f6309b95185a81$var$load("9wxKg"),
    $06f6309b95185a81$var$load("fZt2F"),
    $06f6309b95185a81$var$load("Wowvf"),
    $06f6309b95185a81$var$load("6O8m6"),
    $06f6309b95185a81$var$load("5GxU8"),
    $06f6309b95185a81$var$load("amUNi"),
    $06f6309b95185a81$var$load("7whwt"),
    $06f6309b95185a81$var$load("7e13v"),
    $06f6309b95185a81$var$load("699ae"),
    $06f6309b95185a81$var$load("i7QCq"),
    $06f6309b95185a81$var$load("let0D"),
    $06f6309b95185a81$var$load("87NBA"),
    $06f6309b95185a81$var$load("8KnyD"),
    $06f6309b95185a81$var$load("bRz9K"),
    $06f6309b95185a81$var$load("ffEVr"),
    $06f6309b95185a81$var$load("kUbUu"),
    $06f6309b95185a81$var$load("4Lgj0"),
    $06f6309b95185a81$var$load("kSJiq"),
    $06f6309b95185a81$var$load("dIKn2"),
    $06f6309b95185a81$var$load("8fdGr"),
    $06f6309b95185a81$var$load("hhss7"),
    $06f6309b95185a81$var$load("fnmhc"),
    $06f6309b95185a81$var$load("kdoia"),
    $06f6309b95185a81$var$load("7EorR"),
    $06f6309b95185a81$var$load("2dt2D")
]).then(()=>parcelRequire('bkGU6'));

});

parcelRegister("4D2qK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d5ef270b375fd8a7$export$9a7f1112e3576698 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Nmdfv",
    name: "ViewPageLiteLoader",
    loader: async ()=>(await (parcelRequire("1H1Jc"))).ViewPageLite
});
module.exports["ViewPageLiteLoader"] = $d5ef270b375fd8a7$export$9a7f1112e3576698;

});

parcelRegister("1H1Jc", function(module, exports) {

let $13bb25c32a1f48af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $13bb25c32a1f48af$var$load("3z2v3"),
    $13bb25c32a1f48af$var$load("7whwt"),
    $13bb25c32a1f48af$var$load("8KnyD"),
    $13bb25c32a1f48af$var$load("bRz9K"),
    $13bb25c32a1f48af$var$load("2cLQd"),
    $13bb25c32a1f48af$var$load("kBLPG"),
    $13bb25c32a1f48af$var$load("4tiwv"),
    $13bb25c32a1f48af$var$load("dlm6q"),
    $13bb25c32a1f48af$var$load("7u5Uq"),
    $13bb25c32a1f48af$var$load("7ZBIQ"),
    $13bb25c32a1f48af$var$load("3yM79"),
    $13bb25c32a1f48af$var$load("5coOi"),
    $13bb25c32a1f48af$var$load("9ZkgN"),
    $13bb25c32a1f48af$var$load("P2OWY"),
    $13bb25c32a1f48af$var$load("7A5zJ"),
    $13bb25c32a1f48af$var$load("4XFRu"),
    $13bb25c32a1f48af$var$load("jvBnQ"),
    $13bb25c32a1f48af$var$load("O3OZ0"),
    $13bb25c32a1f48af$var$load("coJiW"),
    $13bb25c32a1f48af$var$load("h4Nf7"),
    $13bb25c32a1f48af$var$load("lqbST"),
    $13bb25c32a1f48af$var$load("2F69B"),
    $13bb25c32a1f48af$var$load("2Cftu"),
    $13bb25c32a1f48af$var$load("4i0CB"),
    $13bb25c32a1f48af$var$load("iXzmH"),
    $13bb25c32a1f48af$var$load("65c4i"),
    $13bb25c32a1f48af$var$load("jkPqm"),
    $13bb25c32a1f48af$var$load("dTsOE"),
    $13bb25c32a1f48af$var$load("4g2Mj"),
    $13bb25c32a1f48af$var$load("87NBA"),
    $13bb25c32a1f48af$var$load("hUIij"),
    $13bb25c32a1f48af$var$load("6Up0b"),
    $13bb25c32a1f48af$var$load("ePdWC"),
    $13bb25c32a1f48af$var$load("lBzRN"),
    $13bb25c32a1f48af$var$load("6Nsud"),
    $13bb25c32a1f48af$var$load("gmzZ6"),
    $13bb25c32a1f48af$var$load("ipiLs"),
    $13bb25c32a1f48af$var$load("1Jgsw"),
    $13bb25c32a1f48af$var$load("dclpt"),
    $13bb25c32a1f48af$var$load("tKhaz"),
    $13bb25c32a1f48af$var$load("jwWp5"),
    $13bb25c32a1f48af$var$load("6wr18"),
    $13bb25c32a1f48af$var$load("cyGuT"),
    $13bb25c32a1f48af$var$load("9wxKg"),
    $13bb25c32a1f48af$var$load("Wowvf"),
    $13bb25c32a1f48af$var$load("let0D"),
    $13bb25c32a1f48af$var$load("ffEVr"),
    $13bb25c32a1f48af$var$load("kUbUu"),
    $13bb25c32a1f48af$var$load("dIKn2"),
    $13bb25c32a1f48af$var$load("8fdGr"),
    $13bb25c32a1f48af$var$load("hhss7"),
    $13bb25c32a1f48af$var$load("1gUNx"),
    $13bb25c32a1f48af$var$load("7EorR"),
    $13bb25c32a1f48af$var$load("h9zFU")
]).then(()=>parcelRequire('kcroh'));

});

parcelRegister("grnbw", function(module, exports) {

let $bf8126fd754f52a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf8126fd754f52a0$var$load("lRtGG"),
    $bf8126fd754f52a0$var$load("7Xau5")
]).then(()=>parcelRequire('aUago'));

});

parcelRegister("8pBIa", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("6Evf5")).default);

var $6Evf5 = parcelRequire("6Evf5");


});

parcelRegister("6Evf5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");


var $hl1Kw = parcelRequire("hl1Kw");


var $3GP6F = parcelRequire("3GP6F");


var $gTyTP = parcelRequire("gTyTP");


var $aeLio = parcelRequire("aeLio");

parcelRequire("hAOSI");
var $9LzHv = parcelRequire("9LzHv");


var $iAoZQ = parcelRequire("iAoZQ");

const $4d7eb68e35a8590f$var$dayInMilliseconds = 86400000; // hours*minutes*seconds*milliseconds
const $4d7eb68e35a8590f$var$NO_DATE_DEFINED = -1;
const $4d7eb68e35a8590f$var$ARCHIVED = 'archived';
const $4d7eb68e35a8590f$export$10ab27af88aafb56 = (pastDateStr, currentDate = new Date())=>{
    const pastDate = new Date(pastDateStr);
    // days since creation
    return Math.round((currentDate.getTime() - pastDate.getTime()) / $4d7eb68e35a8590f$var$dayInMilliseconds);
};
const $4d7eb68e35a8590f$var$_getDaysSinceCreated = (node)=>{
    const createdDateStr = node?.history?.createdDate;
    return createdDateStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(createdDateStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$var$_getDaysSinceUpdated = (node)=>{
    const lastUpdatedStr = node?.history?.lastUpdated?.when;
    return lastUpdatedStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(lastUpdatedStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$export$f8668f0d8d89d19c = (currentDate = new Date())=>{
    const hours = currentDate.getHours();
    return hours >= 15 && hours <= 23;
};
const $4d7eb68e35a8590f$export$35de754c0b3b58bd = ()=>{
    if (document && document.visibilityState) return document.visibilityState;
    return 'unset';
};
const $4d7eb68e35a8590f$var$SendTrackViewPageEvent = ({ pageType: pageType, source: source })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    const commentLink = (0, $aeLio.useGetCommentLinkType)();
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $iAoZQ.SendTrackViewPageEventQuery), {
        variables: {
            contentId: contentId
        }
    });
    const space = data?.content?.nodes?.[0]?.space;
    const fabricEditorSupported = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorSupported;
    const fabricEditorEligibility = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorEligibility;
    if (error || loading || !space) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9LzHv.default), {
        action: "viewed",
        actionSubject: "page",
        source: source,
        containerType: "space",
        containerId: space.id,
        objectType: "page",
        objectId: contentId,
        attributes: {
            pageType: pageType,
            daysSinceCreated: $4d7eb68e35a8590f$var$_getDaysSinceCreated(data.content.nodes[0]),
            daysSinceModified: $4d7eb68e35a8590f$var$_getDaysSinceUpdated(data.content.nodes[0]),
            searchReferrer: searchSessionId,
            ...additionalAnalytics,
            isArchivedPage: data.content.nodes[0].status === $4d7eb68e35a8590f$var$ARCHIVED,
            viewedScreenAfter3PM: $4d7eb68e35a8590f$export$f8668f0d8d89d19c(),
            pageVisibility: $4d7eb68e35a8590f$export$35de754c0b3b58bd(),
            fabricEditorEligibility: fabricEditorEligibility,
            fabricEditorSupported: fabricEditorSupported,
            ...featureCodes && featureCodes.from ? {
                from: featureCodes.from
            } : {},
            livePageReleasePhase: livePageReleasePhase,
            ...commentLink && {
                commentLink: commentLink
            }
        }
    });
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.propTypes = {
    pageType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'page',
        'blogpost'
    ]),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'viewPageScreen',
        'mobileWebView'
    ])
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.defaultProps = {
    source: 'viewPageScreen'
};
var $4d7eb68e35a8590f$export$2e2bcd8739ae039 = $4d7eb68e35a8590f$var$SendTrackViewPageEvent;
module.exports["default"] = $4d7eb68e35a8590f$export$2e2bcd8739ae039;

});

parcelRegister("3GP6F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");




const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $QU6QS.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $42omo.useState)(queryParamsFeatureCodes);
    (0, $42omo.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};
module.exports["useFeatureCodesInURL"] = $9bc3195b956679d5$export$eddc138581adbc11;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("aeLio", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");

const $741319b101f491d9$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $741319b101f491d9$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $741319b101f491d9$export$f4b5305c973a36dc = ()=>{
    const focusedCommentId = $741319b101f491d9$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $741319b101f491d9$var$useReplyToCommentIdQueryParam();
    if (focusedCommentId) return 'isFocusedComment';
    else if (replyToCommentId) return 'isReplyToComment';
    return undefined;
};
module.exports["useGetCommentLinkType"] = $741319b101f491d9$export$f4b5305c973a36dc;

});

parcelRegister("hAOSI", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("9LzHv")).default);

var $9LzHv = parcelRequire("9LzHv");


});

parcelRegister("9LzHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $71c43243f3d11279$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $1DWH0 = parcelRequire("1DWH0");

const $71c43243f3d11279$var$sendTrackEvent = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const analyticsData = {
        action: props.action,
        actionSubject: props.actionSubject,
        attributes: props.attributes,
        containerId: props.containerId,
        containerType: props.containerType,
        objectId: props.objectId,
        objectType: props.objectType,
        source: props.source
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: analyticsData
    });
    analyticsEvent.fire();
};
function $71c43243f3d11279$var$SendTrackEventComponent(props) {
    const { action: action, actionSubject: actionSubject, attributes: attributes, containerId: containerId, containerType: containerType, objectId: objectId, objectType: objectType, source: source } = props;
    (0, $42omo.useEffect)(()=>{
        $71c43243f3d11279$var$sendTrackEvent(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        action,
        actionSubject,
        attributes,
        containerId,
        containerType,
        objectId,
        objectType,
        source
    ]);
    return null;
}
$71c43243f3d11279$var$SendTrackEventComponent.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    actionSubject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    containerType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    objectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    objectType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
$71c43243f3d11279$var$SendTrackEventComponent.defaultProps = {
    attributes: {}
};
var $71c43243f3d11279$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($71c43243f3d11279$var$SendTrackEventComponent);

});

parcelRegister("iAoZQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $d87efa95de2d7c4b$export$891b2cd76733e577 = (0, $eSUdr.default)`query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id history{createdDate lastUpdated{when}}metadata{frontend{fabricEditorSupported fabricEditorEligibility}}space{id}status}}}`;
module.exports["SendTrackViewPageEventQuery"] = $d87efa95de2d7c4b$export$891b2cd76733e577;

});

parcelRegister("f5cug", function(module, exports) {

let $afb1024e5bfae7bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afb1024e5bfae7bb$var$load("eEyVs"),
    $afb1024e5bfae7bb$var$load("iCuQy")
]).then(()=>parcelRequire('4Shbp'));

});

parcelRegister("jEQIl", function(module, exports) {

let $e4faa4b0d5de0a25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4faa4b0d5de0a25$var$load("ckx79").then(()=>parcelRequire('eGJ8h'));

});

parcelRegister("dY5Vp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $41efc32f19d16eca$export$aeb070a9ba92094e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UtR1u",
    name: "LazyQuestions",
    loader: async ()=>(await (parcelRequire("exNzl"))).Questions
});
module.exports["LazyQuestions"] = $41efc32f19d16eca$export$aeb070a9ba92094e;

});

parcelRegister("exNzl", function(module, exports) {

let $a96a9922bb964df9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a96a9922bb964df9$var$load("6wr18"),
    $a96a9922bb964df9$var$load("e2ujj"),
    $a96a9922bb964df9$var$load("huI9u"),
    $a96a9922bb964df9$var$load("g5HUX"),
    $a96a9922bb964df9$var$load("9A0ig"),
    $a96a9922bb964df9$var$load("ffEVr"),
    $a96a9922bb964df9$var$load("5xtwP")
]).then(()=>parcelRequire('gCU3O'));

});

parcelRegister("hherG", function(module, exports) {

let $c93f3ac700737ba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c93f3ac700737ba5$var$load("gLGsg"),
    $c93f3ac700737ba5$var$load("6wr18"),
    $c93f3ac700737ba5$var$load("gYJBG"),
    $c93f3ac700737ba5$var$load("gUDXN"),
    $c93f3ac700737ba5$var$load("aYcgF"),
    $c93f3ac700737ba5$var$load("6CBhM"),
    $c93f3ac700737ba5$var$load("dXF2m"),
    $c93f3ac700737ba5$var$load("4UClM"),
    $c93f3ac700737ba5$var$load("lQZYM"),
    $c93f3ac700737ba5$var$load("a4mwL"),
    $c93f3ac700737ba5$var$load("gcIaV"),
    $c93f3ac700737ba5$var$load("ffEVr"),
    $c93f3ac700737ba5$var$load("hLE8r")
]).then(()=>parcelRequire('9Gz8W'));

});

parcelRegister("exiD9", function(module, exports) {

let $a9529967064e4eb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a9529967064e4eb0$var$load("6CBhM"),
    $a9529967064e4eb0$var$load("dXF2m"),
    $a9529967064e4eb0$var$load("2sCab")
]).then(()=>parcelRequire('3GuAz'));

});

parcelRegister("4GF8o", function(module, exports) {

let $369afe182687e9c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $369afe182687e9c2$var$load("lEurX"),
    $369afe182687e9c2$var$load("gLGsg"),
    $369afe182687e9c2$var$load("6wr18"),
    $369afe182687e9c2$var$load("gYJBG"),
    $369afe182687e9c2$var$load("aYcgF"),
    $369afe182687e9c2$var$load("6CBhM"),
    $369afe182687e9c2$var$load("dXF2m"),
    $369afe182687e9c2$var$load("4UClM"),
    $369afe182687e9c2$var$load("67lYr"),
    $369afe182687e9c2$var$load("lQZYM"),
    $369afe182687e9c2$var$load("6tsCm"),
    $369afe182687e9c2$var$load("2KBe6"),
    $369afe182687e9c2$var$load("bYGFL"),
    $369afe182687e9c2$var$load("a4mwL"),
    $369afe182687e9c2$var$load("gcIaV"),
    $369afe182687e9c2$var$load("8UKe0"),
    $369afe182687e9c2$var$load("a8Jk0"),
    $369afe182687e9c2$var$load("ffEVr"),
    $369afe182687e9c2$var$load("6sFkE")
]).then(()=>parcelRequire('1T0Cv'));

});

parcelRegister("hGZAP", function(module, exports) {

let $ce1622fa29f54587$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ce1622fa29f54587$var$load("gLGsg"),
    $ce1622fa29f54587$var$load("6wr18"),
    $ce1622fa29f54587$var$load("gUDXN"),
    $ce1622fa29f54587$var$load("aYcgF"),
    $ce1622fa29f54587$var$load("6CBhM"),
    $ce1622fa29f54587$var$load("dXF2m"),
    $ce1622fa29f54587$var$load("4UClM"),
    $ce1622fa29f54587$var$load("lQZYM"),
    $ce1622fa29f54587$var$load("a4mwL"),
    $ce1622fa29f54587$var$load("gcIaV"),
    $ce1622fa29f54587$var$load("a8Jk0"),
    $ce1622fa29f54587$var$load("ffEVr"),
    $ce1622fa29f54587$var$load("bYnOS")
]).then(()=>parcelRequire('3EzW0'));

});

parcelRegister("5tYsv", function(module, exports) {

let $3fde8f0472d5414e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fde8f0472d5414e$var$load("ioTV7").then(()=>parcelRequire('9wYcO'));

});

parcelRegister("dt6VG", function(module, exports) {

let $9ce35bd8bdb6084b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ce35bd8bdb6084b$var$load("6wr18"),
    $9ce35bd8bdb6084b$var$load("5ppK3"),
    $9ce35bd8bdb6084b$var$load("ffEVr"),
    $9ce35bd8bdb6084b$var$load("ht9O7")
]).then(()=>parcelRequire('eTYeK'));

});

parcelRegister("kx184", function(module, exports) {

let $ef27c3f15859f81f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef27c3f15859f81f$var$load("6wr18"),
    $ef27c3f15859f81f$var$load("dMOc8"),
    $ef27c3f15859f81f$var$load("aX0L0"),
    $ef27c3f15859f81f$var$load("iQ0Jm"),
    $ef27c3f15859f81f$var$load("ijPJo"),
    $ef27c3f15859f81f$var$load("9sJzT"),
    $ef27c3f15859f81f$var$load("6XCf4"),
    $ef27c3f15859f81f$var$load("5pvpJ"),
    $ef27c3f15859f81f$var$load("ffEVr"),
    $ef27c3f15859f81f$var$load("1qlDN"),
    $ef27c3f15859f81f$var$load("1yVM6"),
    $ef27c3f15859f81f$var$load("5mKg8")
]).then(()=>parcelRequire('fyrrY'));

});

parcelRegister("l5PUQ", function(module, exports) {
const $794cae3221ca3442$export$ccc7dd6c48bfb65d = 'adminUserAccess';
const $794cae3221ca3442$export$728435b9c77444c = 500;
var $794cae3221ca3442$export$37d3310174fb25af = /*#__PURE__*/ function(PermissionResultType) {
    PermissionResultType["ALLOWED"] = "ALLOWED";
    PermissionResultType["DENIED"] = "DENIED";
    PermissionResultType["INHERITED"] = "INHERITED";
    PermissionResultType["IRRELEVANT"] = "IRRELEVANT";
    return PermissionResultType;
}({});
module.exports["ADMIN_USER_ACCESS_ANALYTICS_SOURCE"] = $794cae3221ca3442$export$ccc7dd6c48bfb65d;
module.exports["SPACE_PERMS_REPORT_POLL_INTERVAL_MS"] = $794cae3221ca3442$export$728435b9c77444c;
module.exports["PermissionResultType"] = $794cae3221ca3442$export$37d3310174fb25af;

});

parcelRegister("964fa", function(module, exports) {

let $69f7f74f2bf98c92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69f7f74f2bf98c92$var$load("kbzD1").then(()=>parcelRequire('aFOyu'));

});

parcelRegister("jPfZt", function(module, exports) {

let $e6ef2f192087738c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6ef2f192087738c$var$load("6folH"),
    $e6ef2f192087738c$var$load("5CaYW"),
    $e6ef2f192087738c$var$load("7niKq")
]).then(()=>parcelRequire('2O6Yo'));

});

parcelRegister("az3Zv", function(module, exports) {

let $7b1044d00b098997$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7b1044d00b098997$var$load("foT6i"),
    $7b1044d00b098997$var$load("k28dP"),
    $7b1044d00b098997$var$load("8yLIX"),
    $7b1044d00b098997$var$load("6wr18"),
    $7b1044d00b098997$var$load("ffEVr"),
    $7b1044d00b098997$var$load("aFS1j"),
    $7b1044d00b098997$var$load("2jEbr")
]).then(()=>parcelRequire('gaL8X'));

});

parcelRegister("4AqoJ", function(module, exports) {

let $356f004b837b7854$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $356f004b837b7854$var$load("8JZKd"),
    $356f004b837b7854$var$load("jSJrn"),
    $356f004b837b7854$var$load("9bVrI"),
    $356f004b837b7854$var$load("6CBhM"),
    $356f004b837b7854$var$load("foT6i"),
    $356f004b837b7854$var$load("3VL8p"),
    $356f004b837b7854$var$load("6wr18"),
    $356f004b837b7854$var$load("ffEVr"),
    $356f004b837b7854$var$load("aFS1j"),
    $356f004b837b7854$var$load("iQ0Jm"),
    $356f004b837b7854$var$load("hhss7"),
    $356f004b837b7854$var$load("4S0zt"),
    $356f004b837b7854$var$load("1jGw5")
]).then(()=>parcelRequire('8XK0M'));

});

parcelRegister("edpw6", function(module, exports) {

let $a59612b55a258248$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a59612b55a258248$var$load("aFUSO").then(()=>parcelRequire('8Cf2W'));

});

parcelRegister("e13Ip", function(module, exports) {

let $a3440a72be0d86b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a3440a72be0d86b2$var$load("9bVrI"),
    $a3440a72be0d86b2$var$load("6CBhM"),
    $a3440a72be0d86b2$var$load("foT6i"),
    $a3440a72be0d86b2$var$load("6wr18"),
    $a3440a72be0d86b2$var$load("ffEVr"),
    $a3440a72be0d86b2$var$load("aFS1j"),
    $a3440a72be0d86b2$var$load("hhss7"),
    $a3440a72be0d86b2$var$load("7O0x7")
]).then(()=>parcelRequire('cbGfM'));

});

parcelRegister("7K78n", function(module, exports) {

let $5a325cf5bbee8832$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a325cf5bbee8832$var$load("6wr18"),
    $5a325cf5bbee8832$var$load("2cLQd"),
    $5a325cf5bbee8832$var$load("aHhj2"),
    $5a325cf5bbee8832$var$load("6tsCm"),
    $5a325cf5bbee8832$var$load("2SjHp"),
    $5a325cf5bbee8832$var$load("7u5Uq"),
    $5a325cf5bbee8832$var$load("3yM79"),
    $5a325cf5bbee8832$var$load("5coOi"),
    $5a325cf5bbee8832$var$load("7A5zJ"),
    $5a325cf5bbee8832$var$load("3qsjq"),
    $5a325cf5bbee8832$var$load("hhss7"),
    $5a325cf5bbee8832$var$load("ffEVr"),
    $5a325cf5bbee8832$var$load("42uV7")
]).then(()=>parcelRequire('i6Ad2'));

});

parcelRegister("gZXR7", function(module, exports) {

let $c600c5f00226a18f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c600c5f00226a18f$var$load("6wr18"),
    $c600c5f00226a18f$var$load("bYGFL"),
    $c600c5f00226a18f$var$load("a4mwL"),
    $c600c5f00226a18f$var$load("gcIaV"),
    $c600c5f00226a18f$var$load("k5bNG"),
    $c600c5f00226a18f$var$load("2Gceu"),
    $c600c5f00226a18f$var$load("1Jsgt"),
    $c600c5f00226a18f$var$load("6mHrv"),
    $c600c5f00226a18f$var$load("dhAgF"),
    $c600c5f00226a18f$var$load("8JZKd"),
    $c600c5f00226a18f$var$load("8hSeL"),
    $c600c5f00226a18f$var$load("eEyVs"),
    $c600c5f00226a18f$var$load("7RXky"),
    $c600c5f00226a18f$var$load("fkeSV"),
    $c600c5f00226a18f$var$load("fSV9f"),
    $c600c5f00226a18f$var$load("5uN9h"),
    $c600c5f00226a18f$var$load("ffEVr"),
    $c600c5f00226a18f$var$load("fTFcV"),
    $c600c5f00226a18f$var$load("8Gekp"),
    $c600c5f00226a18f$var$load("lsoh8")
]).then(()=>parcelRequire('eP5Ba'));

});

parcelRegister("4M3H8", function(module, exports) {

let $379e82d32d715df2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $379e82d32d715df2$var$load("9cxnP").then(()=>parcelRequire('3J1Lm'));

});

parcelRegister("43Ghm", function(module, exports) {

let $2f483cf6a24c8c46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f483cf6a24c8c46$var$load("2DNIK"),
    $2f483cf6a24c8c46$var$load("8JZKd"),
    $2f483cf6a24c8c46$var$load("kTv6A"),
    $2f483cf6a24c8c46$var$load("aez9w")
]).then(()=>parcelRequire('cjovp'));

});

parcelRegister("7GuCn", function(module, exports) {

let $598434c0d7109764$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $598434c0d7109764$var$load("exvU8").then(()=>parcelRequire('9ZXTU'));

});

parcelRegister("lI1M4", function(module, exports) {

let $fcdf155b01bb53b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fcdf155b01bb53b0$var$load("6wr18"),
    $fcdf155b01bb53b0$var$load("ffEVr"),
    $fcdf155b01bb53b0$var$load("3KV1Y"),
    $fcdf155b01bb53b0$var$load("2MuhG")
]).then(()=>parcelRequire('gelCt'));

});

parcelRegister("syHJB", function(module, exports) {

let $055d89359b3569b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $055d89359b3569b3$var$load("9EI97").then(()=>parcelRequire('ivpO0'));

});

parcelRegister("i2w4s", function(module, exports) {

let $d2214a7e20c834ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2214a7e20c834ca$var$load("2n8AT").then(()=>parcelRequire('cv3PF'));

});

parcelRegister("kcni8", function(module, exports) {

let $eb46fed7e75084ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb46fed7e75084ad$var$load("jczTu").then(()=>parcelRequire('bnpc5'));

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dcvJ5")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $dcvJ5 = parcelRequire("dcvJ5");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("9NDUe", function(module, exports) {
var $4cf29b30fdb075be$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $4cf29b30fdb075be$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $4cf29b30fdb075be$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $4cf29b30fdb075be$export$cc26007c03242fff;

});

parcelRegister("dhIhb", function(module, exports) {

var $016Gq = parcelRequire("016Gq");

class $26809a44943661ed$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $016Gq.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $26809a44943661ed$export$13e680397ec8f3eb = new $26809a44943661ed$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $26809a44943661ed$export$13e680397ec8f3eb;

});

parcelRegister("016Gq", function(module, exports) {
const $12e944cb435d245e$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};
module.exports["isWindowObjectAvailable"] = $12e944cb435d245e$export$15e172712955e18f;

});

parcelRegister("6vQ7t", function(module, exports) {

var $6qdyn = parcelRequire("6qdyn");


var $6tPi7 = parcelRequire("6tPi7");

const $e4cbac7bea39b153$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $e4cbac7bea39b153$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $e4cbac7bea39b153$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $e4cbac7bea39b153$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $6qdyn.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $e4cbac7bea39b153$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $6tPi7.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e4cbac7bea39b153$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $6tPi7.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e4cbac7bea39b153$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $6tPi7.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};
module.exports["getGlobalEventStream"] = $e4cbac7bea39b153$export$6123a44dc2384540;
module.exports["setGlobalEventStream"] = $e4cbac7bea39b153$export$c1522520b417b066;
module.exports["subscribeEvent"] = $e4cbac7bea39b153$export$37863216db4b714d;
module.exports["unsubscribeEvent"] = $e4cbac7bea39b153$export$ee1a7bd1fc9ea85e;
module.exports["experiencePayloadEvent"] = $e4cbac7bea39b153$export$7c957416596ca127;

});

parcelRegister("6qdyn", function(module, exports) {
class $a1b384895ec34007$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($a1b384895ec34007$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($a1b384895ec34007$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$a1b384895ec34007$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $a1b384895ec34007$export$4ab84f6f04f6566d = new $a1b384895ec34007$var$UFOLogger();
const $a1b384895ec34007$export$b4958caff08a0960 = (...args)=>{
    $a1b384895ec34007$export$4ab84f6f04f6566d.log(...args);
};
const $a1b384895ec34007$export$d53d07b6034c4560 = (...args)=>{
    $a1b384895ec34007$export$4ab84f6f04f6566d.warn(...args);
};
module.exports["ufologger"] = $a1b384895ec34007$export$4ab84f6f04f6566d;
module.exports["ufolog"] = $a1b384895ec34007$export$b4958caff08a0960;
module.exports["ufowarn"] = $a1b384895ec34007$export$d53d07b6034c4560;

});

parcelRegister("6tPi7", function(module, exports) {
var $f460b044765998fd$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $f460b044765998fd$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $f460b044765998fd$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $f460b044765998fd$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $f460b044765998fd$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $f460b044765998fd$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $f460b044765998fd$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $f460b044765998fd$export$9f2bf58999404c75 = 'fmp';
const $f460b044765998fd$export$837e0f79a8056912 = 'inline-response';
module.exports["UFOGlobalEventStreamEventType"] = $f460b044765998fd$export$96253c35c37cf96b;
module.exports["PageVisibleState"] = $f460b044765998fd$export$a12c67b37a306b13;
module.exports["SUBSCRIBE_ALL"] = $f460b044765998fd$export$79bf131685ad41d7;
module.exports["FMP_MARK"] = $f460b044765998fd$export$9f2bf58999404c75;
module.exports["INLINE_RESPONSE_MARK"] = $f460b044765998fd$export$837e0f79a8056912;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("g9MzJ", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $d2cf0a153f80178a$export$2b1e17f3da11d791 = (0, $eSUdr.default)`query EditButtonQuery($contentId:ID!){content(id:$contentId){nodes{id type operations{operation targetType}metadata{frontend{fabricEditorSupported embedded collabService}}subType type space{id key}}}}`;
module.exports["EditButtonQuery"] = $d2cf0a153f80178a$export$2b1e17f3da11d791;

});

parcelRegister("eZFA1", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $4ab52410a046c365$export$1cf432ea3a028ecc = (0, $eSUdr.default)`query GrantAccessDialogLoaderQuery($contentId:ID!$accountId:ID!){singleContent(id:$contentId){id title}user:confluence_atlassianUser(id:$accountId){id displayName photos{value isPrimary}}}`;
module.exports["GrantAccessDialogLoaderQuery"] = $4ab52410a046c365$export$1cf432ea3a028ecc;

});

parcelRegister("e2cl6", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $04a93bdc56c089b3$export$6f731328c7af1575 = (0, $eSUdr.default)`query RendererContentState($contentId:ID!$isDraft:Boolean!$format:GraphQLDateFormat){singleContent(id:$contentId){id contentState(isDraft:$isDraft){id name color restrictionLevel}contentStateLastUpdated(format:$format){value}}}`;
module.exports["RendererContentStateQuery"] = $04a93bdc56c089b3$export$6f731328c7af1575;

});

parcelRegister("8SuT6", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $373e532e403842cf$export$ae77e0661f173b68 = /*#__PURE__*/ function(ContentStateRestrictionLevel) {
    ContentStateRestrictionLevel["NONE"] = "NONE";
    ContentStateRestrictionLevel["PAGE_OWNER"] = "PAGE_OWNER";
    return ContentStateRestrictionLevel;
}({});
var $373e532e403842cf$export$939016c6bb497bec = /*#__PURE__*/ function(GraphQLDateFormat) {
    GraphQLDateFormat["GLOBAL"] = "GLOBAL";
    GraphQLDateFormat["MILLIS"] = "MILLIS";
    GraphQLDateFormat["USER"] = "USER";
    GraphQLDateFormat["USER_FRIENDLY"] = "USER_FRIENDLY";
    return GraphQLDateFormat;
}({});
module.exports["GraphQLDateFormat"] = $373e532e403842cf$export$939016c6bb497bec;

});

parcelRegister("4xaWd", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $260b4b7c1ee337fd$export$87e25dcffffdaa64 = (0, $eSUdr.default)`query FavouriteButtonQuery($contentId:ID!){singleContent(id:$contentId){id type metadata{currentuser{favourited{isFavourite}}}}contentOperations:singleContent(id:$contentId){id operations{operation targetType}}}`;
module.exports["FavouriteButtonQuery"] = $260b4b7c1ee337fd$export$87e25dcffffdaa64;

});

parcelRegister("hpr9b", function(module, exports) {

var $6XxzN = parcelRequire("6XxzN");

const $0010f8f7298777ae$export$7db5b17cce09ecf7 = ()=>{
    return 0, $6XxzN.WatchDialogQueryWithWatchChildren;
};
module.exports["getWatchDialogQuery"] = $0010f8f7298777ae$export$7db5b17cce09ecf7;

});

parcelRegister("6XxzN", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $51124c5b395b8390$export$ff412db8b959e059 = (0, $eSUdr.default)`query WatchDialogQueryWithWatchChildren($contentId:ID!){singleContent(id:$contentId){id ...WatchDialogContentFragmentWithWatchChildren}}fragment WatchDialogContentFragmentWithWatchChildren on Content{id currentUserIsWatching currentUserIsWatchingChildren currentUserHasAncestorWatchingChildren type space{id key currentUser{isWatched isWatchingBlogs}operations{operation targetType}}}`;
module.exports["WatchDialogQueryWithWatchChildren"] = $51124c5b395b8390$export$ff412db8b959e059;

});

parcelRegister("6LsQQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $g2gGv = parcelRequire("g2gGv");

const $f8780459a3f4abf6$export$7da3cd10eb68919e = (0, $eSUdr.default)`query ContentTypesHeaderQuery($contentId:ID$useObjectHeader:Boolean!){content(id:$contentId status:["archived" "current" "draft"]){nodes{id title operations{operation targetType}space{id name key alias}type subType status version@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedVersionFragment}draftVersion@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedDraftVersionFragment}}}}${(0, $g2gGv.LastEditedVersionFragment)}${(0, $g2gGv.LastEditedDraftVersionFragment)}`;
module.exports["ContentTypesHeaderQuery"] = $f8780459a3f4abf6$export$7da3cd10eb68919e;

});

parcelRegister("g2gGv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $82f60ea6bd1b627b$export$deecf62d8ca1b922 = (0, $eSUdr.default)`fragment LastEditedVersionFragment on Version{by{displayName}when}`;
const $82f60ea6bd1b627b$export$36bc043d85f07c8 = (0, $eSUdr.default)`fragment LastEditedDraftVersionFragment on Version{by{displayName}when}`;
module.exports["LastEditedVersionFragment"] = $82f60ea6bd1b627b$export$deecf62d8ca1b922;
module.exports["LastEditedDraftVersionFragment"] = $82f60ea6bd1b627b$export$36bc043d85f07c8;

});

parcelRegister("k3bZO", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $e54f84fdc9bae4a0$export$74bb7cb63c9c267c = (0, $eSUdr.default)`query CustomHeaderAndFooterQuery($spaceKey:String){space(key:$spaceKey){id settings{customHeaderAndFooter{header{html js css spaUnfriendlyMacros{name}}footer{html js css spaUnfriendlyMacros{name}}}}}}`;
module.exports["CustomHeaderAndFooterQuery"] = $e54f84fdc9bae4a0$export$74bb7cb63c9c267c;

});

parcelRegister("1qiwK", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $9857557de8d9983c$export$6da16bc6e6dac136 = (0, $eSUdr.default)`query MediaDownloadTokenQuery($contentId:ID$status:[String]$missingContentId:Boolean=false){content(id:$contentId status:$status)@skip(if:$missingContentId){nodes{id body{atlas_doc_format{mediaToken{token}}}}}mediaConfiguration{clientId fileStoreUrl}}`;
module.exports["MediaDownloadTokenQuery"] = $9857557de8d9983c$export$6da16bc6e6dac136;

});

parcelRegister("8Ya23", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7d9def60e65e7ab6$export$4fc8ddb10c5d05fd = (0, $eSUdr.default)`query FocusedInlineCommentQuery($commentId:ID!$contentId:ID){content(id:$contentId){nodes{id type space{id}operations{operation targetType}}}comments(commentId:$commentId depth:ALL type:UNRESOLVED){nodes{ancestors{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}}`;
module.exports["FocusedInlineCommentQuery"] = $7d9def60e65e7ab6$export$4fc8ddb10c5d05fd;

});

parcelRegister("1R4Hk", function(module, exports) {

var $cOrQJ = parcelRequire("cOrQJ");

const $c6444b27b54a07b6$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};
module.exports["useIconThemed"] = $c6444b27b54a07b6$export$a38bb9a8c9e5bc30;

});

parcelRegister("exBjF", function(module, exports) {
parcelRequire("5V8lD");
var $4pgc7 = parcelRequire("4pgc7");
var $3jjlh = parcelRequire("3jjlh");
var $wbfRU = parcelRequire("wbfRU");
var $hPMbS = parcelRequire("hPMbS");
var $6UtPP = parcelRequire("6UtPP");

var $a96117fb0ff7c511$var$global = (0, $wbfRU.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $a96117fb0ff7c511$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $4pgc7.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $a96117fb0ff7c511$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $a96117fb0ff7c511$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $3jjlh.fill)($a96117fb0ff7c511$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $6UtPP.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $hPMbS.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $hPMbS.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($a96117fb0ff7c511$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();
module.exports["CaptureConsole"] = $a96117fb0ff7c511$export$25a43cb5b5c58c08;

});

parcelRegister("5V8lD", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("wbfRU")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("ksUmj")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("ksUmj")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("4pgc7")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("4pgc7")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("kGRNS")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("3jjlh")).fill);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("6UtPP")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("hPMbS")).safeJoin);





parcelRequire("wbfRU");


parcelRequire("ksUmj");

parcelRequire("4pgc7");




var $6NRdb = parcelRequire("6NRdb");

parcelRequire("kGRNS");

parcelRequire("3jjlh");



parcelRequire("6UtPP");



parcelRequire("hPMbS");




var $c1Rlb = parcelRequire("c1Rlb");






$parcel$exportWildcard(module.exports, $6NRdb);
$parcel$exportWildcard(module.exports, $c1Rlb);

});

parcelRegister("3FhX7", function(module, exports) {

var $wbfRU = parcelRequire("wbfRU");


var $ksUmj = parcelRequire("ksUmj");

function $2ab3206f334f2299$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2ab3206f334f2299$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2ab3206f334f2299$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $ksUmj.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $2ab3206f334f2299$export$1cfafeee2987818b() {
    var global = (0, $wbfRU.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}
module.exports["htmlTreeAsString"] = $2ab3206f334f2299$export$5647df6b7814ac86;

});

parcelRegister("wbfRU", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $6NRdb = parcelRequire("6NRdb");

var $060bb845762b2c42$var$fallbackGlobalObject = {};
function $060bb845762b2c42$export$256479dc0cea61c4() {
    return (0, $6NRdb.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $060bb845762b2c42$var$fallbackGlobalObject;
}
function $060bb845762b2c42$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $060bb845762b2c42$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
module.exports["getGlobalObject"] = $060bb845762b2c42$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $060bb845762b2c42$export$7e223ec222791509;

});

parcelRegister("6NRdb", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3kQPK = parcelRequire("3kQPK");


var $kyRHQ = parcelRequire("kyRHQ");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3kQPK.isBrowserBundle)() && Object.prototype.toString.call(typeof $kyRHQ !== 'undefined' ? $kyRHQ : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});

parcelRegister("3kQPK", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $26dc390a525d107c$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
module.exports["isBrowserBundle"] = $26dc390a525d107c$export$2928c40372e623c0;

});

parcelRegister("ksUmj", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $ee6223dddca4d288$var$objectToString = Object.prototype.toString;
function $ee6223dddca4d288$export$e6127cc7fe7395c3(wat) {
    switch($ee6223dddca4d288$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $ee6223dddca4d288$export$49034edbe6b62415(wat, Error);
    }
}
function $ee6223dddca4d288$var$isBuiltin(wat, ty) {
    return $ee6223dddca4d288$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $ee6223dddca4d288$export$9f9636d330b71954(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'ErrorEvent');
}
function $ee6223dddca4d288$export$ef9e2056653f0c8e(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'DOMError');
}
function $ee6223dddca4d288$export$12e869b2a583f783(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'DOMException');
}
function $ee6223dddca4d288$export$844ec244b1367d54(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'String');
}
function $ee6223dddca4d288$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $ee6223dddca4d288$export$53b83ca8eaab0383(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'Object');
}
function $ee6223dddca4d288$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $ee6223dddca4d288$export$49034edbe6b62415(wat, Event);
}
function $ee6223dddca4d288$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $ee6223dddca4d288$export$49034edbe6b62415(wat, Element);
}
function $ee6223dddca4d288$export$49841c62b9eff15(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'RegExp');
}
function $ee6223dddca4d288$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $ee6223dddca4d288$export$bc2894c7158efbac(wat) {
    return $ee6223dddca4d288$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $ee6223dddca4d288$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $ee6223dddca4d288$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
module.exports["isError"] = $ee6223dddca4d288$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $ee6223dddca4d288$export$49034edbe6b62415;
module.exports["isString"] = $ee6223dddca4d288$export$844ec244b1367d54;
module.exports["isPrimitive"] = $ee6223dddca4d288$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $ee6223dddca4d288$export$53b83ca8eaab0383;
module.exports["isEvent"] = $ee6223dddca4d288$export$9671ea99bd126ace;
module.exports["isElement"] = $ee6223dddca4d288$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $ee6223dddca4d288$export$49841c62b9eff15;
module.exports["isSyntheticEvent"] = $ee6223dddca4d288$export$bc2894c7158efbac;
module.exports["isNaN"] = $ee6223dddca4d288$export$c9f5652083b8129d;

});

parcelRegister("ldQnK", function(module, exports) {
var $f73371db46ba81c9$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];
module.exports["SeverityLevels"] = $f73371db46ba81c9$export$484b1ea9aec914c;

});

parcelRegister("4pgc7", function(module, exports) {
$parcel$export(module.exports, "logger", () => $33560f1d6b7016a1$export$af88d00dbe7f521);

var $hXuPC = parcelRequire("hXuPC");


var $kyuk6 = parcelRequire("kyuk6");


var $wbfRU = parcelRequire("wbfRU");

// TODO: Implement different loggers for different environments
var $33560f1d6b7016a1$var$global = (0, $wbfRU.getGlobalObject)();
/** Prefix for logging strings */ var $33560f1d6b7016a1$var$PREFIX = 'Sentry Logger ';
var $33560f1d6b7016a1$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $33560f1d6b7016a1$export$cda52e2a8927a2ca(callback) {
    var global = (0, $wbfRU.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $33560f1d6b7016a1$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $33560f1d6b7016a1$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $kyuk6.IS_DEBUG_BUILD) $33560f1d6b7016a1$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $33560f1d6b7016a1$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $33560f1d6b7016a1$var$global.console)[name].apply(_a, (0, $hXuPC.__spread)([
                    $33560f1d6b7016a1$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $33560f1d6b7016a1$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $33560f1d6b7016a1$export$af88d00dbe7f521;
if (0, $kyuk6.IS_DEBUG_BUILD) $33560f1d6b7016a1$export$af88d00dbe7f521 = (0, $wbfRU.getGlobalSingleton)('logger', $33560f1d6b7016a1$var$makeLogger);
else $33560f1d6b7016a1$export$af88d00dbe7f521 = $33560f1d6b7016a1$var$makeLogger();
module.exports["CONSOLE_LEVELS"] = $33560f1d6b7016a1$export$2a2b1d2252a69ecb;

});

parcelRegister("kyuk6", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $ef6e812e97b2e7a4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $ef6e812e97b2e7a4$export$48a8984ec0bf2e44;

});

parcelRegister("8KmfX", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $65e3e2445bc0a001$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports["memoBuilder"] = $65e3e2445bc0a001$export$8115b0b78e956ab3;

});

parcelRegister("kGRNS", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $ksUmj = parcelRequire("ksUmj");


var $8KmfX = parcelRequire("8KmfX");


var $3jjlh = parcelRequire("3jjlh");


var $2FEvv = parcelRequire("2FEvv");

function $03e31ed33816e4c8$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $03e31ed33816e4c8$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $03e31ed33816e4c8$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $03e31ed33816e4c8$export$a3295358bff77e(object, depth);
    if ($03e31ed33816e4c8$var$jsonSize(normalized) > maxSize) return $03e31ed33816e4c8$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $03e31ed33816e4c8$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $8KmfX.memoBuilder)();
    var _a = (0, $hXuPC.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $ksUmj.isNaN)(value)) return value;
    var stringified = $03e31ed33816e4c8$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $ksUmj.isError)(value) || (0, $ksUmj.isEvent)(value) ? (0, $3jjlh.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $03e31ed33816e4c8$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $03e31ed33816e4c8$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $ksUmj.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $2FEvv.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $03e31ed33816e4c8$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $03e31ed33816e4c8$var$jsonSize(value) {
    return $03e31ed33816e4c8$var$utf8Length(JSON.stringify(value));
}
module.exports["normalize"] = $03e31ed33816e4c8$export$a3295358bff77e;

});

parcelRegister("3jjlh", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $3FhX7 = parcelRequire("3FhX7");


var $ksUmj = parcelRequire("ksUmj");


var $hPMbS = parcelRequire("hPMbS");

function $26922664d1405f23$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $26922664d1405f23$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $26922664d1405f23$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $26922664d1405f23$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $26922664d1405f23$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $26922664d1405f23$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $26922664d1405f23$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $26922664d1405f23$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $ksUmj.isError)(value)) newObj = (0, $hXuPC.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $26922664d1405f23$var$getOwnProperties(value));
    else if ((0, $ksUmj.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $hXuPC.__assign)({
            type: event_1.type,
            target: $26922664d1405f23$var$serializeEventTarget(event_1.target),
            currentTarget: $26922664d1405f23$var$serializeEventTarget(event_1.currentTarget)
        }, $26922664d1405f23$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $ksUmj.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $26922664d1405f23$var$serializeEventTarget(target) {
    try {
        return (0, $ksUmj.isElement)(target) ? (0, $3FhX7.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $26922664d1405f23$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $26922664d1405f23$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($26922664d1405f23$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $hPMbS.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hPMbS.truncate)(serialized, maxLength);
    }
    return '';
}
function $26922664d1405f23$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $ksUmj.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $hXuPC.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $26922664d1405f23$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($26922664d1405f23$export$d25f2688db1bb433);
    return val;
}
function $26922664d1405f23$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $ksUmj.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports["fill"] = $26922664d1405f23$export$9563e054e6f787fb;
module.exports["convertToPlainObject"] = $26922664d1405f23$export$62ff257738bf57f5;

});

parcelRegister("hPMbS", function(module, exports) {

var $ksUmj = parcelRequire("ksUmj");

function $cfbc94b797f7d695$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $cfbc94b797f7d695$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $cfbc94b797f7d695$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $cfbc94b797f7d695$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $ksUmj.isString)(value)) return false;
    if ((0, $ksUmj.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $cfbc94b797f7d695$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
module.exports["truncate"] = $cfbc94b797f7d695$export$6a506b36fdea397d;
module.exports["safeJoin"] = $cfbc94b797f7d695$export$465e9d514283d4fd;

});

parcelRegister("2FEvv", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

var $1f1ed4f8ccef7485$var$STACKTRACE_LIMIT = 50;
function $1f1ed4f8ccef7485$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $hXuPC.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $hXuPC.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $1f1ed4f8ccef7485$export$c55c24c0eeba0205(frames);
    };
}
function $1f1ed4f8ccef7485$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $1f1ed4f8ccef7485$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $1f1ed4f8ccef7485$var$defaultFunctionName = '<anonymous>';
function $1f1ed4f8ccef7485$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $1f1ed4f8ccef7485$var$defaultFunctionName;
        return fn.name || $1f1ed4f8ccef7485$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $1f1ed4f8ccef7485$var$defaultFunctionName;
    }
}
module.exports["getFunctionName"] = $1f1ed4f8ccef7485$export$aad197c7121a6651;

});

parcelRegister("6UtPP", function(module, exports) {

var $d7UOt = parcelRequire("d7UOt");


var $ldQnK = parcelRequire("ldQnK");

function $507f1d9e8f769fdb$var$isSupportedSeverity(level) {
    return (0, $ldQnK.SeverityLevels).indexOf(level) !== -1;
}
function $507f1d9e8f769fdb$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $d7UOt.Severity).Warning;
    if ($507f1d9e8f769fdb$var$isSupportedSeverity(level)) return level;
    return (0, $d7UOt.Severity).Log;
}
module.exports["severityFromString"] = $507f1d9e8f769fdb$export$e01cef29b4327697;

});

parcelRegister("d7UOt", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $98e7ffb8aeed9be4$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $98e7ffb8aeed9be4$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($98e7ffb8aeed9be4$export$918a9776c0a3cf27 || ($98e7ffb8aeed9be4$export$918a9776c0a3cf27 = {}));
var $98e7ffb8aeed9be4$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("c1Rlb", function(module, exports) {

var $wbfRU = parcelRequire("wbfRU");


var $6NRdb = parcelRequire("6NRdb");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $wbfRU.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $6NRdb.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $6NRdb.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $wbfRU.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("emwrp", function(module, exports) {
parcelRequire("5V8lD");
var $4pgc7 = parcelRequire("4pgc7");


var $8kQ9p = parcelRequire("8kQ9p");

/** Deduplication filter */ var $a74c48ddcd29ab0c$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($a74c48ddcd29ab0c$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $8kQ9p.IS_DEBUG_BUILD) && (0, $4pgc7.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $a74c48ddcd29ab0c$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($a74c48ddcd29ab0c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($a74c48ddcd29ab0c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $a74c48ddcd29ab0c$var$_getExceptionFromEvent(previousEvent);
    var currentException = $a74c48ddcd29ab0c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $a74c48ddcd29ab0c$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $a74c48ddcd29ab0c$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}
module.exports["Dedupe"] = $a74c48ddcd29ab0c$export$688d98c249d31ad3;

});

parcelRegister("8kQ9p", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $6118a50aab7b3a53$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $6118a50aab7b3a53$export$48a8984ec0bf2e44;

});

parcelRegister("6JOHL", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("5V8lD");
var $ksUmj = parcelRequire("ksUmj");
var $4pgc7 = parcelRequire("4pgc7");
var $kGRNS = parcelRequire("kGRNS");


var $8kQ9p = parcelRequire("8kQ9p");

/** Patch toString calls to return proper name for wrapped functions */ var $4e7e46f7945dcb56$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $hXuPC.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $ksUmj.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $hXuPC.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $kGRNS.normalize)(errorData, this._options.depth);
            if ((0, $ksUmj.isPlainObject)(normalizedErrorData)) contexts = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $hXuPC.__assign)({}, normalizedErrorData), _a));
            return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $hXuPC.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $ksUmj.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $hXuPC.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $ksUmj.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $8kQ9p.IS_DEBUG_BUILD) && (0, $4pgc7.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();
module.exports["ExtraErrorData"] = $4e7e46f7945dcb56$export$56d961ef3a52a072;

});

parcelRegister("erpTL", function(module, exports) {
/** Add node transaction to the event */ var $a837ad3723132784$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();
module.exports["Transaction"] = $a837ad3723132784$export$febc5573c75cefb0;

});

parcelRegister("5spQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $jYbwE = parcelRequire("jYbwE");

Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $jYbwE.isEnvironmentBlockEnabled;
    }
});



Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $jYbwE.isFeatureEnabled;
    }
});

});

parcelRegister("jYbwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $5RB5d = parcelRequire("5RB5d");


var $bRppy = parcelRequire("bRppy");

/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $e89c8fa7bf5c28ec$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $e89c8fa7bf5c28ec$var$getBoundaryKey();
    return (0, $bRppy.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $e89c8fa7bf5c28ec$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @returns if the feature is available in the current cloud environment
 */ function $e89c8fa7bf5c28ec$var$isFeatureEnabled(environmentBlockName, featureName) {
    const boundaryKey = $e89c8fa7bf5c28ec$var$getBoundaryKey();
    return (0, $bRppy.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
}
module.exports.isFeatureEnabled = $e89c8fa7bf5c28ec$var$isFeatureEnabled;
function $e89c8fa7bf5c28ec$var$getBoundaryKey() {
    if ((0, $5RB5d.isFedrampModerate)()) return $bRppy.FED_MOD_KEY;
    if ((0, $5RB5d.isIsolatedCloud)()) return $bRppy.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $bRppy.COMMERCIAL_KEY;
}

});

parcelRegister("5RB5d", function(module, exports) {

var $9vFIg = parcelRequire("9vFIg");


var $iG8l7 = parcelRequire("iG8l7");

function $444eaaec2c4d71fe$export$9186ccba8effc5de() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $9vFIg.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $444eaaec2c4d71fe$export$104cb891a6e90b3a() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $9vFIg.FEDRAMP_MODERATE);
}
function $444eaaec2c4d71fe$export$80638ee198476daf() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $444eaaec2c4d71fe$export$839b022803d38d4d() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
module.exports["isIsolatedCloud"] = $444eaaec2c4d71fe$export$9186ccba8effc5de;
module.exports["isFedrampModerate"] = $444eaaec2c4d71fe$export$104cb891a6e90b3a;

});

parcelRegister("9vFIg", function(module, exports) {
const $6ec75da0edf32757$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $6ec75da0edf32757$export$f005e2e9f707cb5f = 'commercial';
const $6ec75da0edf32757$export$a739cd5aac835909 = 'staging';
const $6ec75da0edf32757$export$42dd0cdd351a4a9 = 'prod';
const $6ec75da0edf32757$export$404582bc18fe4d9e = 'dev';
const $6ec75da0edf32757$export$d8347b4aae768c2d = [
    $6ec75da0edf32757$export$f005e2e9f707cb5f
];
const $6ec75da0edf32757$export$b1b1ccc8f3e7f954 = [
    $6ec75da0edf32757$export$f005e2e9f707cb5f,
    $6ec75da0edf32757$export$ce553301d55c2fd8
];
const $6ec75da0edf32757$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $6ec75da0edf32757$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $6ec75da0edf32757$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
module.exports["FEDRAMP_MODERATE"] = $6ec75da0edf32757$export$ce553301d55c2fd8;
module.exports["ISOLATED_CLOUD_PERIMETERS"] = $6ec75da0edf32757$export$d8347b4aae768c2d;
module.exports["ATL_CTX_PERIMETER"] = $6ec75da0edf32757$export$87285944378c596;
module.exports["ATL_CTX_ISOLATION_CONTEXT_DOMAIN"] = $6ec75da0edf32757$export$715603e81922c3ec;
module.exports["ATL_CTX_ISOLATION_CONTEXT_ID"] = $6ec75da0edf32757$export$a0ffa0598c95dfb7;

});

parcelRegister("iG8l7", function(module, exports) {

var $9vFIg = parcelRequire("9vFIg");

/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $d9929e543e364378$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $d9929e543e364378$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}
module.exports["parseAtlCtxCookies"] = $d9929e543e364378$export$3fa7b7af96286cc9;

});

parcelRegister("bRppy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $bW2zJ = parcelRequire("bW2zJ");

Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $bW2zJ.isEnvironmentBlockEnabledForBoundary;
    }
});



Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $bW2zJ.isFeatureEnabledForBoundary;
    }
});

var $dAnKm = parcelRequire("dAnKm");

Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});

parcelRegister("bW2zJ", function(module, exports) {
"use strict";
var $8b071be3717020b1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $8b071be3717020b1$var$sdk_data_json_1 = $8b071be3717020b1$var$__importDefault((parcelRequire("leq11")));
const $8b071be3717020b1$var$aemEnvironmentBlockData = $8b071be3717020b1$var$sdk_data_json_1.default;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $8b071be3717020b1$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $8b071be3717020b1$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $8b071be3717020b1$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $8b071be3717020b1$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        return environmentBlockData.features[featureName]?.compositions[boundaryKey] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $8b071be3717020b1$var$isFeatureEnabledForBoundary;
function $8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    return $8b071be3717020b1$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName]?.compositions[boundaryKey] === true;
}

});

parcelRegister("leq11", function(module, exports) {
module.exports = JSON.parse("{\"environmentBlocks\":{\"atlassian-analytics\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"bitbucket\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"chat\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"confluence\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"ccma\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-anonymous-access\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-comment-and-header-links\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-company-hub\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-content-archiving\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-content-manager\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-databases\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":false}},\"confluence-editing-experience\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-employee-directory\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-loom-integration\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"confluence-mission-control\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-mobile-app\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"confluence-page-analytics\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-presenter-mode\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-public-links\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-questions\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-search\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-single-space-guests\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-slack-integration\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-smart-links\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-space-analytics\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-update-page-owners\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"confluence-whiteboards\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}}}},\"goals\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"guard-premium\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"guard-standard\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"home\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{\"home-status-backend\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}}}},\"jira\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"jcma\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-admin-site-optimiser\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-audit-log\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-backlogs\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-board-and-backlog-insights\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-boards-and-views\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-calendar-view\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-components-company-only\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-forms\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-github-for-jira\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-github-workflows\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-in-product-help\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-mobile-app\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-plans\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-project-archiving\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-project-templates\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-releases\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-slack\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-smart-links\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-team-managed-projects\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-workflow-configuration\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}}}},\"jira-align\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"jira-service-desk\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"jira-service-management-ai-ops\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-assets\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-chat-ops\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-chat\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-csm-functionality\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-deployment-gating\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-deployment-tracking\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":false}},\"jira-service-management-embeddable-widget\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-err-governance-api\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-help-center\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-incident-conference-calls\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-incident-management-integration\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-ops-genie-reporting\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jira-service-management-virtual-service-agent\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"jsm-alert-notifications\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-approvals\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-canned-responses\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-change-calendar\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-csat\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-customer-notifications\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-forms\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-knowledge-base\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-queues\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-services\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-sla-management\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"jsm-templates-and-views\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}}}},\"jira-software\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"loom\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"projects\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"rovo\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{\"rovo-ai-3p-connections\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"rovo-ai-app-availability\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"rovo-ai-machine-learning\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"rovo-ai-projects\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}}}},\"search\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"studio\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"teams\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"trello\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"adminhub\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-actor-profiles\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-alert-dashboard\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-alert-details\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-alert-messaging-integrations\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-app-requests\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-app-updates\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-audit-log\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-automatic-product-discovery\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-billing-console\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-brie\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-byok\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-content-scanning\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-custom-email-addresses\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-data-classifications\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-data-residency\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-data-security-policies\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-discovered-apps\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-dlp-partner-integrations\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-enforced-2-step-verification\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-enforced-data-security-policy-by-classification\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-experiment-controls\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-last-active-date\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-multiple-idps\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-org-deletion\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-org-transfer\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-release-tracks\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-remediation-api\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-remediation-recommendations\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-remediation-workflows\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-saml-sso\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-sandbox\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-self-service-product-acquisition\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-siem-integrations\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-url-subdomain-updates\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"adminhub-user-counts\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-user-impersonation\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"adminhub-user-provisioning\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}}}},\"anti-abuse-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"atlassian-visualization-platform-plato\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}}}},\"collaboration-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"commerce-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}}}},\"cross-product-search\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"ecosystem-oauth\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"forge-cli\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"forge-system-apps\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"forge\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}}}},\"growth-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"identity\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"identity-virality\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}}}},\"machine-learning-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"marketplace\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}}}},\"migrations\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"c2c-migrations\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"data-center-to-agc\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}}}},\"migrations-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"post-office\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"product-integrations-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"reactions\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"smartlinks\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"analytics-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"atlassian-graphql-gateway\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"automation-platform-automation-templates\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"automation-platform-branches\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"automation-platform-conditions\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"automation-platform-templates\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true}},\"automation-platform-triggers\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":false,\"isolated-commercial-cloud-ga\":true}}}},\"bifrost\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"core-network-automation\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"data-classification-governance-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"data-exchange-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"data-management-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"data-movement-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"data-platform-services\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"decisions-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"edge\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"internal-edge\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"job-execution-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"mail-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"networking\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"pollinator\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"targeting-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"tdp-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"tenant-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}},\"testing-platform\":{\"compositions\":{\"commercial-cloud\":true,\"fedramp-moderate\":true,\"isolated-commercial-cloud-ga\":true},\"features\":{}}}}");

});

parcelRegister("dAnKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-commercial-cloud-ga";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $bxT4f = parcelRequire("bxT4f");


var $4zCDj = parcelRequire("4zCDj");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const licensedProducts = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $4zCDj.GetLicensedProductsQuery)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === (0, $bxT4f.LicenseStatus).ACTIVE);
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("bxT4f", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $1b0cd2a957a24400$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $1b0cd2a957a24400$export$902181cb056f3d0b;

});

parcelRegister("4zCDj", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $55302aa376569ead$export$e367407479ee8cd8 = (0, $eSUdr.default)`query GetLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus productKey}}}`;
module.exports["GetLicensedProductsQuery"] = $55302aa376569ead$export$e367407479ee8cd8;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $eSUdr.default)`query ReactionsCommentsQuery($contentId:ID!$containerId:ID!){comments(commentId:$contentId contentStatus:[DRAFT CURRENT]){nodes{id reactionsSummary(pageId:$containerId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("1cxtL", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $32d7b0cfdec8cc05$export$d3cb04278ad9cbd5 = (0, $eSUdr.default)`query ContentPrerequisitesQuery($contentId:ID!$missingSpaceKey:Boolean=false$spaceKey:String){content(id:$contentId){nodes{id type space{id key alias}}}space(key:$spaceKey)@skip(if:$missingSpaceKey){id name}}`;
module.exports["ContentPrerequisitesQuery"] = $32d7b0cfdec8cc05$export$d3cb04278ad9cbd5;

});

parcelRegister("aZE1d", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $7c86b27540ecb105$export$61e26c9bad803fee = (0, $eSUdr.default)`query ContentRedirectQuery($contentId:ID$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id title space{id homepageId key alias}history{createdDate}}}}`;
module.exports["ContentRedirectQuery"] = $7c86b27540ecb105$export$61e26c9bad803fee;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<6f07c4fac57f6dc212d11302afa5f44f>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("gyneS", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b0a4ea0e16bf0a49$export$c154c9d0522d550a = (0, $eSUdr.default)`query ShareAndRestrictButtonQuery($contentId:ID!$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id hasInheritedRestrictions hasRestrictions hasViewRestrictions title}publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId pageStatus}}`;
module.exports["ShareAndRestrictButtonQuery"] = $b0a4ea0e16bf0a49$export$c154c9d0522d550a;

});

parcelRegister("gejop", function(module, exports) {
/**
 * @generated SignedSource<<dcc7465266fc46a48308c2a084af2ed9>>
 * @relayHash 3a27260e57e410ffecd4ba617c6d3637
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d
const $3cac748832e2023e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3a27260e57e410ffecd4ba617c6d3637",
            "id": "31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d",
            "metadata": {},
            "name": "useIsAIEnabledForContentQuery",
            "operationKind": "query",
            "text": "query useIsAIEnabledForContentQuery($contentId:ID!){content(id:$contentId){nodes{id,operations{targetType,operation}}}}"
        }
    };
}();
$3cac748832e2023e$var$node.hash = "87034a7db072a7db419402593bcbd707";
var $3cac748832e2023e$export$2e2bcd8739ae039 = $3cac748832e2023e$var$node;
module.exports["default"] = $3cac748832e2023e$export$2e2bcd8739ae039;

});

parcelRegister("jW8MZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a0da224f0094931c$export$658cf1ccfcb3ce94 = (0, $eSUdr.default)`query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id name externalCollaboratorCount currentUser{isAdmin}}}`;
module.exports["ViewSpaceExternalCollaboratorsDialogQuery"] = $a0da224f0094931c$export$658cf1ccfcb3ce94;

});

parcelRegister("eohUr", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $59d9e9a16ad897c7$export$944151d365bd26d2 = (0, $eSUdr.default)`query SpaceShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){quick{id url position title styleClass}}}`;
module.exports["SpaceShortcutsSpaceNavigationQuery"] = $59d9e9a16ad897c7$export$944151d365bd26d2;

});

parcelRegister("8q3aB", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $9090acc33078fd99$export$40bc69a2d697f368 = (0, $eSUdr.default)`query SpaceNavigationQuery($spaceKey:String$isLicensed:Boolean!){user:confluence_atlassianUser(current:true){id confluence{permissionType}}spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id webItemKey webItemCompleteKey title url position styleClass icon{path width height isDefault}iconClass hidden canHide tooltip linkIdentifier type}quick{id url position title styleClass}}space(key:$spaceKey){id key name type status icon{path}homepage{id}currentUser@include(if:$isLicensed){isAdmin isFavourited isWatched}operations{operation targetType}containsExternalCollaborators history{createdDate}didContainUserContent}}`;
module.exports["SpaceNavigationQuery"] = $9090acc33078fd99$export$40bc69a2d697f368;

});

parcelRegister("27YEi", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c4f1707e011f7101$export$dd691f55898fe398 = (0, $eSUdr.default)`query SpaceViewsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}`;
const $c4f1707e011f7101$export$c5ec5e7c6d75ef98 = (0, $eSUdr.default)`mutation SpaceViewsPersistenceMutation($spaceKey:String!$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}`;
module.exports["PersistenceQuery"] = $c4f1707e011f7101$export$dd691f55898fe398;

});

parcelRegister("aGl35", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c55f8973455480ec$export$e117a947a993af37 = (0, $eSUdr.default)`query SpaceViewsSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id homepage{id}operations{operation targetType}}}`;
const $c55f8973455480ec$export$e8210f1d97ec99cd = (0, $eSUdr.default)`query SpaceViewsContentQuery($first:Int!$spaceKey:String!$token:String$sort:String!$navigationType:String){content(first:$first spaceKey:$spaceKey orderby:$sort after:$token status:"current" navigationType:$navigationType){nodes{id title type subType hasRestrictions hasInheritedRestrictions links{webui base}properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value version{number}}}}pageInfo{hasNextPage endCursor}}}`;
const $c55f8973455480ec$export$4e20ef3fda88f1f1 = (0, $eSUdr.default)`query SpaceViewsRecentlyViewedQuery($cloudId:ID!$first:Int!$after:String$spaceId:ID!){activities{myActivities{viewed(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:[PAGE]cloudIds:[$cloudId]containerIds:[$spaceId]}}]first:$first after:$after){edges{node{id object{id localResourceId content{id title hasRestrictions hasInheritedRestrictions properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value version{number}}}}}}cursor}pageInfo{hasNextPage}}}}}`;
module.exports["SpaceRootQuery"] = $c55f8973455480ec$export$e117a947a993af37;
module.exports["SpaceViewsContentQuery"] = $c55f8973455480ec$export$e8210f1d97ec99cd;

});

parcelRegister("3zNFE", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $b715d80530d9857d$export$7376118bf2f7661d = (0, $eSUdr.default)`query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isLivePagesEnabled isWhiteboardsEnabled isDatabasesEnabled}}didContainUserContent id operations{operation targetType}}}`;
module.exports["FooterCreateButtonsQuery"] = $b715d80530d9857d$export$7376118bf2f7661d;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("inLKs", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7ec1eb52421f9faa$export$8d5511a885429a32 = (0, $eSUdr.default)`query PageTreeQuery($spaceKey:String!$statuses:[GraphQLPageStatus]$ptStatuses:[PTGraphQLPageStatus]$contentId:ID!$paginationLimit:Int$isSuperAdmin:Boolean!$isReplacePagesWithPTPageEnabled:Boolean!=false){currentPage:ptpage(id:$contentId spaceKey:$spaceKey pageTree:$paginationLimit status:$ptStatuses enablePaging:true){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}nearestAncestors{pageInfo{hasNextPage endCursor}nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}children{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}ptpage(spaceKey:$spaceKey pageTree:$paginationLimit status:$ptStatuses enablePaging:true)@include(if:$isReplacePagesWithPTPageEnabled){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}rootLevelPages:pages(spaceKey:$spaceKey status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id title status hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}}space(key:$spaceKey){id homepage{id}operations{operation targetType}}}`;
const $7ec1eb52421f9faa$export$f67032c82d01c852 = (0, $eSUdr.default)`query PageTreeWithSpaceKeyQuery($spaceKey:String!$statuses:[GraphQLPageStatus]$ptStatuses:[PTGraphQLPageStatus]$paginationLimit:Int$isSuperAdmin:Boolean!$isReplacePagesWithPTPageEnabled:Boolean!){space(key:$spaceKey){id homepageId pageTree(pageTree:$paginationLimit status:$ptStatuses enablePaging:true){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}nearestAncestors{pageInfo{hasNextPage endCursor}nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}children{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}operations{operation targetType}}ptpage(spaceKey:$spaceKey status:$ptStatuses)@include(if:$isReplacePagesWithPTPageEnabled){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}rootLevelPages:pages(spaceKey:$spaceKey status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id title status hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}}}`;
module.exports["PageTreeQuery"] = $7ec1eb52421f9faa$export$8d5511a885429a32;
module.exports["PageTreeWithSpaceKeyQuery"] = $7ec1eb52421f9faa$export$f67032c82d01c852;

});

parcelRegister("fL5TY", function(module, exports) {
/**
 * @generated SignedSource<<b72ab3593890fa91ef84036390360c22>>
 * @relayHash 32d094adde43b53166e21c73e0e18466
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db
const $b517e71d543026da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endCursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "endCursor"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "orderBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "blogpost"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blank"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft",
                                        "editor"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "32d094adde43b53166e21c73e0e18466",
            "id": "8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db",
            "metadata": {},
            "name": "BlogTreeRootComponentQuery",
            "operationKind": "query",
            "text": "query BlogTreeRootComponentQuery($spaceKey:String!,$first:Int,$endCursor:String,$statuses:[String],$orderBy:String){content(spaceKey:$spaceKey,type:\"blogpost\",first:$first,orderby:$orderBy,after:$endCursor,status:$statuses){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}"
        }
    };
}();
$b517e71d543026da$var$node.hash = "dcdc7591048a9e478035919db8a4bcd0";
var $b517e71d543026da$export$2e2bcd8739ae039 = $b517e71d543026da$var$node;
module.exports["default"] = $b517e71d543026da$export$2e2bcd8739ae039;

});

parcelRegister("6DMfJ", function(module, exports) {
const $4d5bd09a97238678$export$e3c11860ad35ba05 = [
    'current',
    'draft'
];
const $4d5bd09a97238678$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $4d5bd09a97238678$export$8ec3d08588d2eeda = 40;
const $4d5bd09a97238678$export$130b26c73bb9d040 = 16;
module.exports["BLOG_STATUSES"] = $4d5bd09a97238678$export$e3c11860ad35ba05;
module.exports["VIRTUAL_ROOT_ID"] = $4d5bd09a97238678$export$70918a400db2b6af;
module.exports["PAGE_SIZE"] = $4d5bd09a97238678$export$8ec3d08588d2eeda;
module.exports["INDENT_PER_LEVEL"] = $4d5bd09a97238678$export$130b26c73bb9d040;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<6050f94e69307ca99b98b624b9d08371>>
 * @relayHash a2b7f78fbc7a4e9ecead01083cfe8f24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "a2b7f78fbc7a4e9ecead01083cfe8f24",
            "id": "e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "4f4f276100c2961c7227836999fc58e5";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("5aVN7", function(module, exports) {

var $54pZY = parcelRequire("54pZY");

class $b2f6155fa23a5064$export$c00d22927c60484a extends (0, $54pZY.UFOAbstractExperience) {
}
module.exports["UFOExperience"] = $b2f6155fa23a5064$export$c00d22927c60484a;

});

parcelRegister("54pZY", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $9QRNP = parcelRequire("9QRNP");


var $016Gq = parcelRequire("016Gq");


var $6vQ7t = parcelRequire("6vQ7t");


var $6qdyn = parcelRequire("6qdyn");


var $dhIhb = parcelRequire("dhIhb");


var $6tPi7 = parcelRequire("6tPi7");


var $imJBP = parcelRequire("imJBP");


var $aKxav = parcelRequire("aKxav");


var $6jo0X = parcelRequire("6jo0X");


var $9NDUe = parcelRequire("9NDUe");

const $d3a526271a41f254$var$getPageVisibleState = ()=>{
    return !(0, $016Gq.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $6tPi7.PageVisibleState).VISIBLE : (0, $6tPi7.PageVisibleState).HIDDEN;
};
const $d3a526271a41f254$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $imJBP.roundPerfNow)();
};
class $d3a526271a41f254$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $6qdyn.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $6jo0X.canTransition)(this.state, newState)) {
            (0, $6qdyn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $aKxav.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $d3a526271a41f254$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $dQl1W.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $d3a526271a41f254$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6vQ7t.getGlobalEventStream)().push((0, $6vQ7t.unsubscribeEvent)((0, $6tPi7.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $6qdyn.ufolog)('this.parent', this.parent);
                (0, $6vQ7t.getGlobalEventStream)().push((0, $6vQ7t.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $6qdyn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $6qdyn.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $aKxav.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $d3a526271a41f254$var$getPageVisibleState();
            (0, $dhIhb.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $6qdyn.ufolog)('subscribed', this.id);
                (0, $6vQ7t.getGlobalEventStream)().push((0, $6vQ7t.subscribeEvent)((0, $6tPi7.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $6tPi7.FMP_MARK) && name !== (0, $6tPi7.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $6qdyn.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $d3a526271a41f254$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $aKxav.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $6tPi7.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $6tPi7.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $6qdyn.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $dhIhb.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $aKxav.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $aKxav.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $aKxav.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $6qdyn.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $9QRNP.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $aKxav.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $6tPi7.PageVisibleState).MIXED;
            (0, $dhIhb.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $d3a526271a41f254$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $9NDUe.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}
module.exports["perfNowOrTimestamp"] = $d3a526271a41f254$export$c753e8669d30c8ad;
module.exports["UFOAbstractExperience"] = $d3a526271a41f254$export$d31c89db257648c;

});

parcelRegister("9QRNP", function(module, exports) {
// temp solution until we can get it automated
const $1a93057d59887b2b$export$2295b861f318254a = '0.1.5';
module.exports["UFO_EXPERIMENTAL_BUILD_VERSION"] = $1a93057d59887b2b$export$2295b861f318254a;

});

parcelRegister("imJBP", function(module, exports) {
const $aa2c7935688bcbd0$export$5f490af6b2b115cf = ()=>~~performance.now();
module.exports["roundPerfNow"] = $aa2c7935688bcbd0$export$5f490af6b2b115cf;

});

parcelRegister("aKxav", function(module, exports) {
const $7fc074ada368fd30$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $7fc074ada368fd30$export$81b70111112841a0;

});

parcelRegister("6jo0X", function(module, exports) {

var $aKxav = parcelRequire("aKxav");

const $89a1cf54005d9d3a$var$UFOStateAvailableTransitions = {
    [(0, $aKxav.UFOExperienceState).NOT_STARTED.id]: [
        (0, $aKxav.UFOExperienceState).STARTED.id
    ],
    [(0, $aKxav.UFOExperienceState).STARTED.id]: [
        (0, $aKxav.UFOExperienceState).IN_PROGRESS.id,
        (0, $aKxav.UFOExperienceState).BLOCKED.id,
        (0, $aKxav.UFOExperienceState).SUCCEEDED.id,
        (0, $aKxav.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $aKxav.UFOExperienceState).FAILED.id,
        (0, $aKxav.UFOExperienceState).ABORTED.id
    ],
    [(0, $aKxav.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $aKxav.UFOExperienceState).BLOCKED.id,
        (0, $aKxav.UFOExperienceState).SUCCEEDED.id,
        (0, $aKxav.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $aKxav.UFOExperienceState).FAILED.id,
        (0, $aKxav.UFOExperienceState).ABORTED.id
    ],
    [(0, $aKxav.UFOExperienceState).BLOCKED.id]: [
        (0, $aKxav.UFOExperienceState).RECOVERED.id,
        (0, $aKxav.UFOExperienceState).ABORTED.id
    ],
    [(0, $aKxav.UFOExperienceState).RECOVERED.id]: [
        (0, $aKxav.UFOExperienceState).STARTED.id,
        (0, $aKxav.UFOExperienceState).SUCCEEDED.id,
        (0, $aKxav.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $aKxav.UFOExperienceState).FAILED.id,
        (0, $aKxav.UFOExperienceState).ABORTED.id
    ],
    [(0, $aKxav.UFOExperienceState).SUCCEEDED.id]: [
        (0, $aKxav.UFOExperienceState).STARTED.id
    ],
    [(0, $aKxav.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $aKxav.UFOExperienceState).SUCCEEDED.id,
        (0, $aKxav.UFOExperienceState).FAILED.id,
        (0, $aKxav.UFOExperienceState).ABORTED.id
    ],
    [(0, $aKxav.UFOExperienceState).FAILED.id]: [
        (0, $aKxav.UFOExperienceState).STARTED.id
    ],
    [(0, $aKxav.UFOExperienceState).ABORTED.id]: [
        (0, $aKxav.UFOExperienceState).STARTED.id
    ]
};
const $89a1cf54005d9d3a$export$178881f329fdb81f = (state1, state2)=>{
    return $89a1cf54005d9d3a$var$UFOStateAvailableTransitions[state1.id] && $89a1cf54005d9d3a$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};
module.exports["canTransition"] = $89a1cf54005d9d3a$export$178881f329fdb81f;

});

parcelRegister("k9Smn", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");

//      
var $eaced0a9c3d84a94$var$charCodeOfDot = ".".charCodeAt(0);
var $eaced0a9c3d84a94$var$reEscapeChar = /\\(\\)?/g;
var $eaced0a9c3d84a94$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $eaced0a9c3d84a94$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $eaced0a9c3d84a94$var$charCodeOfDot) result.push("");
    string.replace($eaced0a9c3d84a94$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($eaced0a9c3d84a94$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $eaced0a9c3d84a94$var$keysCache = {};
var $eaced0a9c3d84a94$var$keysRegex = /[.[\]]+/;
var $eaced0a9c3d84a94$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($eaced0a9c3d84a94$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $eaced0a9c3d84a94$var$keysCache[key] = key.split($eaced0a9c3d84a94$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $eaced0a9c3d84a94$var$keysCache[key] = $eaced0a9c3d84a94$var$stringToPath(key);
    }
    return $eaced0a9c3d84a94$var$keysCache[key];
};
//      
var $eaced0a9c3d84a94$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $eaced0a9c3d84a94$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $eaced0a9c3d84a94$var$_toPropertyKey(arg) {
    var key = $eaced0a9c3d84a94$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $eaced0a9c3d84a94$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eaced0a9c3d84a94$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $bDniu.default)(current, [
                key
            ].map($eaced0a9c3d84a94$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $7Q5yr.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $eaced0a9c3d84a94$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $eaced0a9c3d84a94$var$setInRecursor(state, 0, $eaced0a9c3d84a94$var$toPath(key), value1, destroyArrays);
};
var $eaced0a9c3d84a94$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $eaced0a9c3d84a94$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $eaced0a9c3d84a94$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(values, name);
    var error = $eaced0a9c3d84a94$export$c52e5867d5879e24(errors, name);
    if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) error = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
    var submitError = submitErrors && $eaced0a9c3d84a94$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $eaced0a9c3d84a94$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $eaced0a9c3d84a94$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $eaced0a9c3d84a94$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $eaced0a9c3d84a94$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$eaced0a9c3d84a94$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $eaced0a9c3d84a94$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$41e855cb628c1b55, $eaced0a9c3d84a94$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $eaced0a9c3d84a94$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3, $eaced0a9c3d84a94$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $eaced0a9c3d84a94$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$eaced0a9c3d84a94$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $eaced0a9c3d84a94$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $eaced0a9c3d84a94$export$83d89fbfd8236492 = "4.20.10";
var $eaced0a9c3d84a94$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $eaced0a9c3d84a94$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $eaced0a9c3d84a94$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $eaced0a9c3d84a94$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $eaced0a9c3d84a94$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $eaced0a9c3d84a94$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $eaced0a9c3d84a94$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $eaced0a9c3d84a94$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $7Q5yr.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $7Q5yr.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $7Q5yr.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $7Q5yr.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $7Q5yr.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $eaced0a9c3d84a94$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $eaced0a9c3d84a94$export$e6bdf135a54e021b,
                    shallowEqual: $eaced0a9c3d84a94$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $7Q5yr.default)({}, state.formState.values)); // clone to avoid writing
            if ($eaced0a9c3d84a94$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $eaced0a9c3d84a94$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $eaced0a9c3d84a94$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $7Q5yr.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $eaced0a9c3d84a94$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) {
                    var existing = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$eaced0a9c3d84a94$export$735bebc8ffabf28a] = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
                    merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$eaced0a9c3d84a94$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $eaced0a9c3d84a94$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $eaced0a9c3d84a94$var$notify(fieldSubscriber, fieldState, lastFieldState, $eaced0a9c3d84a94$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $eaced0a9c3d84a94$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$eaced0a9c3d84a94$var$hasAnyError(formState.errors) && !(formState.submitErrors && $eaced0a9c3d84a94$var$hasAnyError(formState.submitErrors));
        var nextFormState = $eaced0a9c3d84a94$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $eaced0a9c3d84a94$var$notify(state.subscribers, nextFormState, lastFormState, $eaced0a9c3d84a94$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $7Q5yr.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $eaced0a9c3d84a94$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $eaced0a9c3d84a94$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $eaced0a9c3d84a94$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $eaced0a9c3d84a94$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $eaced0a9c3d84a94$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $eaced0a9c3d84a94$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $eaced0a9c3d84a94$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $eaced0a9c3d84a94$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $eaced0a9c3d84a94$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $eaced0a9c3d84a94$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $eaced0a9c3d84a94$export$83d89fbfd8236492;
module.exports["createForm"] = $eaced0a9c3d84a94$export$f681a8129d2e9d28;

});

parcelRegister("jTvbt", function(module, exports) {

var $k9Smn = parcelRequire("k9Smn");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $e7bb57e5fe20696d$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $e7bb57e5fe20696d$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $e7bb57e5fe20696d$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $k9Smn.getIn)(errors, input.name);
    });
};
//      
var $e7bb57e5fe20696d$var$noop = function noop() {};
var $e7bb57e5fe20696d$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $e7bb57e5fe20696d$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $e7bb57e5fe20696d$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $e7bb57e5fe20696d$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $e7bb57e5fe20696d$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$e7bb57e5fe20696d$export$2e2bcd8739ae039 = $e7bb57e5fe20696d$var$createDecorator;
module.exports["default"] = $e7bb57e5fe20696d$export$2e2bcd8739ae039;

});

parcelRegister("abN8T", function(module, exports) {

var $92z90 = parcelRequire("92z90");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $76b10d1eacd527b2$var$set(object, path, value) {
    return object == null ? object : $92z90(object, path, value);
}
module.exports = $76b10d1eacd527b2$var$set;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $7kzZ3 = parcelRequire("7kzZ3");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $dTk3A.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 && (0, $dh538.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");

const $72bf3d2a48c5b2ec$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $16xFS.useLayering)();
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($72bf3d2a48c5b2ec$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["FocusManagerContext"] = $72bf3d2a48c5b2ec$export$f18c1d4fc7326096;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $4hF42 = parcelRequire("4hF42");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $02b3fc6de2f24ae9$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($02b3fc6de2f24ae9$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["SelectionStoreContext"] = $02b3fc6de2f24ae9$export$756f795847463ebd;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4hF42 = parcelRequire("4hF42");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c81vhk _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("2Pg7f", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $esRft = parcelRequire("esRft");


var $4JWgN = parcelRequire("4JWgN");


var $ee7An = parcelRequire("ee7An");


var $loiTn = parcelRequire("loiTn");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $fj4Q9 = parcelRequire("fj4Q9");


var $crJ46 = parcelRequire("crJ46");


var $6MWy1 = parcelRequire("6MWy1");


var $2cWqt = parcelRequire("2cWqt");


var $2LGbr = parcelRequire("2LGbr");


var $6Ac15 = parcelRequire("6Ac15");


var $1DG7o = parcelRequire("1DG7o");

const $49cfd043cf935c3d$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $49cfd043cf935c3d$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $49cfd043cf935c3d$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $esRft.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $ee7An.default;
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $4JWgN.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$49cfd043cf935c3d$var$getOverrides(overrides).MoreIndicator.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6MWy1.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cWqt.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatar, index)=>$49cfd043cf935c3d$var$getOverrides(overrides).AvatarGroupItem.render((0, $fj4Q9.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $c0qxy.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
var $49cfd043cf935c3d$export$2e2bcd8739ae039 = $49cfd043cf935c3d$var$AvatarGroup;
module.exports["default"] = $49cfd043cf935c3d$export$2e2bcd8739ae039;

});

parcelRegister("fj4Q9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");


var $atkCk = parcelRequire("atkCk");

const $b02c3981c986946c$var$AvatarGroupItem = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b02c3981c986946c$export$2e2bcd8739ae039 = $b02c3981c986946c$var$AvatarGroupItem;
module.exports["default"] = $b02c3981c986946c$export$2e2bcd8739ae039;

});

parcelRegister("atkCk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6MWy1 = parcelRequire("6MWy1");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $f69e73e233725633$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $f69e73e233725633$export$2e2bcd8739ae039 = $f69e73e233725633$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f69e73e233725633$export$2e2bcd8739ae039;

});

parcelRegister("6MWy1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $1ztii = parcelRequire("1ztii");

const $5d9c84f5f87b7a1d$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic
 */ const $5d9c84f5f87b7a1d$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $42omo.useEffect)(()=>{
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $1ztii.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: (0, $1ztii.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($5d9c84f5f87b7a1d$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $5d9c84f5f87b7a1d$export$2e2bcd8739ae039 = $5d9c84f5f87b7a1d$var$FocusManager;
module.exports["FocusManagerContext"] = $5d9c84f5f87b7a1d$export$f18c1d4fc7326096;
module.exports["default"] = $5d9c84f5f87b7a1d$export$2e2bcd8739ae039;

});

parcelRegister("1ztii", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cbf707a7ad85d1$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");

const $15cbf707a7ad85d1$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $15cbf707a7ad85d1$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $15cbf707a7ad85d1$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("crJ46", function(module, exports) {
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $97f44b6287529f93$var$gutter = "var(--ds-space-negative-050, -4px)";
const $97f44b6287529f93$var$listStyles = null;
const $97f44b6287529f93$var$listStylesFlagged = null;
const $97f44b6287529f93$var$listItemStyles = null;
const $97f44b6287529f93$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $97f44b6287529f93$export$2e2bcd8739ae039 = $97f44b6287529f93$var$Grid;
module.exports["default"] = $97f44b6287529f93$export$2e2bcd8739ae039;

});

parcelRegister("2cWqt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $6MWy1 = parcelRequire("6MWy1");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $fd056483eb698f52$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    (0, $42omo.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $fd056483eb698f52$export$2e2bcd8739ae039 = $fd056483eb698f52$var$PopupAvatarGroup;
module.exports["default"] = $fd056483eb698f52$export$2e2bcd8739ae039;

});

parcelRegister("2LGbr", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $965bb25f1302cdca$var$boxShadowCssVar = '--avatar-box-shadow';
const $965bb25f1302cdca$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _1q8w1np6 _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _t9ec1np6 _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon"
};
const $965bb25f1302cdca$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $965bb25f1302cdca$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $965bb25f1302cdca$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $965bb25f1302cdca$var$MAX_DISPLAY_COUNT = 99;
const $965bb25f1302cdca$var$MoreIndicator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $965bb25f1302cdca$var$MAX_DISPLAY_COUNT ? $965bb25f1302cdca$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$965bb25f1302cdca$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $gMc0m.default)([
            $965bb25f1302cdca$var$styles.root,
            $965bb25f1302cdca$var$borderRadiusMap[size],
            appearance === 'circle' && $965bb25f1302cdca$var$styles.circle,
            $965bb25f1302cdca$var$widthHeightMap[size],
            $965bb25f1302cdca$var$fontMap[size],
            isActive && $965bb25f1302cdca$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$965bb25f1302cdca$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $965bb25f1302cdca$export$2e2bcd8739ae039 = $965bb25f1302cdca$var$MoreIndicator;
module.exports["default"] = $965bb25f1302cdca$export$2e2bcd8739ae039;

});

parcelRegister("6Ac15", function(module, exports) {
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $7b5befcdc2ab883e$var$listStyles = null;
const $7b5befcdc2ab883e$var$listSmallStyles = null;
const $7b5befcdc2ab883e$var$listItemStyles = null;
const $7b5befcdc2ab883e$var$listItemSmallStyles = null;
const $7b5befcdc2ab883e$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7b5befcdc2ab883e$export$2e2bcd8739ae039 = $7b5befcdc2ab883e$var$Stack;
module.exports["default"] = $7b5befcdc2ab883e$export$2e2bcd8739ae039;

});

parcelRegister("1DG7o", function(module, exports) {
const $e8b8a534df2444a6$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $e8b8a534df2444a6$export$b067756944994c79;

});

parcelRegister("g7Pc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e34dc1cd2084e09d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $lHMuy = parcelRequire("lHMuy");

function $e34dc1cd2084e09d$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: label,
        tag: $e34dc1cd2084e09d$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lHMuy.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lHMuy.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $e34dc1cd2084e09d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});

parcelRegister("lHMuy", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6F6hl = parcelRequire("6F6hl");

const $994b46f1e25bb927$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $994b46f1e25bb927$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $994b46f1e25bb927$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $l998X.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}
module.exports["Decorator"] = $994b46f1e25bb927$export$a592b67c93d52467;

});

parcelRegister("03WRT", function(module, exports) {
$parcel$export(module.exports, "default", () => $484d2d2be4c10078$export$2e2bcd8739ae039);
const $484d2d2be4c10078$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $484d2d2be4c10078$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($484d2d2be4c10078$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("9QfXi", function(module, exports) {
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $2P8Ax = parcelRequire("2P8Ax");


var $dh538 = parcelRequire("dh538");


var $eFvgJ = parcelRequire("eFvgJ");


var $ei7H8 = parcelRequire("ei7H8");


var $e2ssP = parcelRequire("e2ssP");


var $lQ9rc = parcelRequire("lQ9rc");

const $05e49d7ff5fc6a12$var$getCodeBlockStyles = {
    codeFontFlagOn: "_11c81u0j",
    codeFontFlagOff: "_1wyb1crf _k48pi7a9 _ect41odn",
    root: "_2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhk187e _syazi7uo _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1xv3 _1vbw1xv3 _1v9c1xv3 _1srnt0uh _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gsb9t _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909i8nm _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgc124n _bu7z124n _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t36i7uo _137bh55r _1k7di7uo _97li16jw _12nh9lu1 _1g0517qg _i2igqmo9 _326zi7uo _113p1rpy _1n6t16jw _tgu817qg _1k4716jw _g0lxi7uo _ys4e1rpy _7gp8h55r _1yvqqmo9 _1vwwqmo9 _1rjuqmo9 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o6qmo9 _kxov17qg _1np517qg _m2f517qg _1b9t16jw _1tq616jw _1rd216jw _1pbk16jw _k3li16jw _13zt1rpy _2g12fb2s _k86bqmo9 _b5iy1rpy _gti31rpy _1f0g16jw _9d3e17qg _qdia16jw _72uv16jw",
    showLineNumbers: "_1707efft _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $05e49d7ff5fc6a12$var$CodeBlock = /*#__PURE__*/ (0, $42omo.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $42omo.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $42omo.useState)(false); // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $ei7H8.getLineNumWidth)(numLines) : 0; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled; // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $42omo.useEffect)(()=>{
        const schedule = (0, $2P8Ax.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $eFvgJ.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $42omo.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $42omo.useMemo)(()=>(0, $e2ssP.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]); // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text'; // https://product-fabric.atlassian.net/browse/DSP-22927
    const useCodeFont = (0, $dh538.fg)('platform_dst_code-token');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lQ9rc.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $gMc0m.default)([
            useCodeFont ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.codeFontFlagOn : $05e49d7ff5fc6a12$var$getCodeBlockStyles.codeFontFlagOff,
            $05e49d7ff5fc6a12$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.shouldWrapLongLines : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.showLineNumbers : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $05e49d7ff5fc6a12$export$2e2bcd8739ae039 = $05e49d7ff5fc6a12$var$CodeBlock;
module.exports["default"] = $05e49d7ff5fc6a12$export$2e2bcd8739ae039;

});

parcelRegister("eFvgJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $762b8efdd2f451a9$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $762b8efdd2f451a9$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $42omo.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $42omo.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};
module.exports["useHighlightLines"] = $762b8efdd2f451a9$export$84415a200bdf33ed;

});

parcelRegister("ei7H8", function(module, exports) {
const $89bf9ce5f21eb7b0$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
module.exports["getLineNumWidth"] = $89bf9ce5f21eb7b0$export$cb7aec0206b595d2;

});

parcelRegister("e2ssP", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $cTQmR = parcelRequire("cTQmR");

const $93742eb3c537aef5$export$f38728011c178796 = (0, $2XqLN.default)((language)=>{
    if (!language) return '';
    const match = (0, $cTQmR.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});
module.exports["normalizeLanguage"] = $93742eb3c537aef5$export$f38728011c178796;

});

parcelRegister("lQ9rc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e33420ccf6f6f193$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $fjCXq = parcelRequire("fjCXq");

var $e33420ccf6f6f193$export$2e2bcd8739ae039 = (0, $fjCXq.default);

});

parcelRegister("fjCXq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5sMDX = parcelRequire("5sMDX");

// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $d73ab72549e3e177$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $l998X.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, $5sMDX.default);
    AsyncHighlighter.astGeneratorPromise = void 0;
    return AsyncHighlighter;
};

const $d73ab72549e3e177$var$asyncGenerator = $d73ab72549e3e177$var$generator({
    loader: ()=>(parcelRequire("bhcM2")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $d73ab72549e3e177$export$2e2bcd8739ae039 = $d73ab72549e3e177$var$asyncGenerator;
module.exports["default"] = $d73ab72549e3e177$export$2e2bcd8739ae039;

});

parcelRegister("5sMDX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9THMM = parcelRequire("9THMM");


var $39xAV = parcelRequire("39xAV");

/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $65cd19df82755559$var$Highlight = /*#__PURE__*/ (0, $42omo.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $9THMM.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39xAV.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $65cd19df82755559$export$2e2bcd8739ae039 = $65cd19df82755559$var$Highlight;
module.exports["default"] = $65cd19df82755559$export$2e2bcd8739ae039;

});

parcelRegister("9THMM", function(module, exports) {
$parcel$export(module.exports, "default", () => $91ea43af234a8926$export$2e2bcd8739ae039);

var $5izKv = parcelRequire("5izKv");


var $gOgW3 = parcelRequire("gOgW3");


var $6RvGZ = parcelRequire("6RvGZ");


var $dA1U5 = parcelRequire("dA1U5");

const $91ea43af234a8926$var$newLineRegex = /\n/g;
function $91ea43af234a8926$var$getNewLines(str) {
    return str.match($91ea43af234a8926$var$newLineRegex);
}
function $91ea43af234a8926$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $dA1U5.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $5izKv.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $6RvGZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $91ea43af234a8926$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $gOgW3.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $gOgW3.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});

parcelRegister("5izKv", function(module, exports) {

var $gOgW3 = parcelRequire("gOgW3");


var $2hcc9 = parcelRequire("2hcc9");

function $837f3297854d8fe5$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $gOgW3.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $2hcc9.default)(lineNumber));
            return children;
        }
    };
}
var $837f3297854d8fe5$export$2e2bcd8739ae039 = $837f3297854d8fe5$var$createLineGenerator;
module.exports["default"] = $837f3297854d8fe5$export$2e2bcd8739ae039;

});

parcelRegister("gOgW3", function(module, exports) {
$parcel$export(module.exports, "default", () => $09aff78a89d513cf$export$2e2bcd8739ae039);

var $2hcc9 = parcelRequire("2hcc9");

function $09aff78a89d513cf$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});

parcelRegister("2hcc9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c2f4afe5a9a95f7$export$2e2bcd8739ae039);
function $3c2f4afe5a9a95f7$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});

parcelRegister("6RvGZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7ca1712ff76e68a$export$2e2bcd8739ae039);

var $gOgW3 = parcelRequire("gOgW3");

function $f7ca1712ff76e68a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $gOgW3.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $f7ca1712ff76e68a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("dA1U5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a86ea0fafcbd9c5$export$2e2bcd8739ae039);
function $1a86ea0fafcbd9c5$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});

parcelRegister("39xAV", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a0d4443c5f07c9$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dalCl = parcelRequire("dalCl");

function $33a0d4443c5f07c9$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dalCl.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});

parcelRegister("dalCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $60fb1400ee6b4dd3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");


var $8L2tn = parcelRequire("8L2tn");

function $60fb1400ee6b4dd3$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $60fb1400ee6b4dd3$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $03WRT.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $8L2tn.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $60fb1400ee6b4dd3$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});

parcelRegister("8L2tn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef41ad946a85b2e$export$2e2bcd8739ae039);

var $dalCl = parcelRequire("dalCl");

function $cef41ad946a85b2e$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dalCl.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});

parcelRegister("bhcM2", function(module, exports) {

let $835b30d7ea57673f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $835b30d7ea57673f$var$load("7PMju").then(()=>parcelRequire('kw2OH'));

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("eUDtA", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5nBzc = parcelRequire("5nBzc");


var $1DWH0 = parcelRequire("1DWH0");


var $hFf4D = parcelRequire("hFf4D");


var $aLypr = parcelRequire("aLypr");

function $fb06ceb36ba8e92b$var$_defineProperty(e, r, t) {
    return (r = $fb06ceb36ba8e92b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb06ceb36ba8e92b$var$_toPropertyKey(t) {
    var i = $fb06ceb36ba8e92b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb06ceb36ba8e92b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE = 'default';
const $fb06ceb36ba8e92b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $fb06ceb36ba8e92b$var$inlineBlockStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $fb06ceb36ba8e92b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $fb06ceb36ba8e92b$var$StatusInternal extends (0, $42omo.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap[color] || $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $gMc0m.default)([
                $fb06ceb36ba8e92b$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            maxWidth: $fb06ceb36ba8e92b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "hoverStartTime", 0);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $aLypr.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$fb06ceb36ba8e92b$var$_defineProperty($fb06ceb36ba8e92b$var$StatusInternal, "displayName", 'StatusInternal');
const $fb06ceb36ba8e92b$export$96e9906d6d93a972 = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($fb06ceb36ba8e92b$var$StatusInternal);
module.exports["Status"] = $fb06ceb36ba8e92b$export$96e9906d6d93a972;

});

parcelRegister("hFf4D", function(module, exports) {
const $d7337cb21e4187c0$export$d821aa4c8afb384e = 'fabric-elements';
const $d7337cb21e4187c0$var$packageName = "platform-pkg";
const $d7337cb21e4187c0$var$packageVersion = "0.0.0-use.local";
const $d7337cb21e4187c0$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $d7337cb21e4187c0$var$packageName;
        statusPayload.attributes.packageVersion = $d7337cb21e4187c0$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($d7337cb21e4187c0$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $d7337cb21e4187c0$export$aa98853957f9f5aa;

});

parcelRegister("aLypr", function(module, exports) {
const $e5e607f963e2ce3b$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $e5e607f963e2ce3b$export$7452d7062a4d0634;

});

parcelRegister("cQMhV", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => (parcelRequire("9h6tL")).PanelInfoIcon);
$parcel$export(module.exports, "PanelWarningIcon", () => (parcelRequire("7aW37")).PanelWarningIcon);
$parcel$export(module.exports, "PanelErrorIcon", () => (parcelRequire("9f7tI")).PanelErrorIcon);
$parcel$export(module.exports, "PanelSuccessIcon", () => (parcelRequire("5Eiz2")).PanelSuccessIcon);
$parcel$export(module.exports, "PanelNoteIcon", () => (parcelRequire("9jJiA")).PanelNoteIcon);
$parcel$export(module.exports, "BorderIcon", () => (parcelRequire("2cZUf")).BorderIcon);
$parcel$export(module.exports, "SteppedRainbowIconDecoration", () => (parcelRequire("i0DZE")).SteppedRainbowIconDecoration);
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => (parcelRequire("c0czl")).DynamicStrokeIconDecoration);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4wH3g = parcelRequire("4wH3g");


var $9h6tL = parcelRequire("9h6tL");


var $7aW37 = parcelRequire("7aW37");


var $9f7tI = parcelRequire("9f7tI");


var $5Eiz2 = parcelRequire("5Eiz2");


var $9jJiA = parcelRequire("9jJiA");


var $2cZUf = parcelRequire("2cZUf");


var $i0DZE = parcelRequire("i0DZE");


var $c0czl = parcelRequire("c0czl");


const $37f04d4596614e71$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7Wa7q",
    name: "IconTable",
    loader: ()=>(parcelRequire("jbX4H")).then((module)=>module.default),
    loading: ()=>null
});
module.exports["IconTable"] = $37f04d4596614e71$export$84f497075f5b07be;

});

parcelRegister("9h6tL", function(module, exports) {
/* PanelInfoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $4e1d4745b1e8289e$var$iconStyles = null;
const $4e1d4745b1e8289e$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
        fill: "currentColor"
    }));
};
const $4e1d4745b1e8289e$export$2187dc2d495c3efc = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($4e1d4745b1e8289e$var$PanelInfoGlyph, {
        role: "presentation"
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $4e1d4745b1e8289e$var$PanelInfoGlyph,
        ...props
    });
};
module.exports["PanelInfoIcon"] = $4e1d4745b1e8289e$export$2187dc2d495c3efc;

});

parcelRegister("7aW37", function(module, exports) {
/* PanelWarningIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $c82a733b017451e7$var$iconStyles = null;
const $c82a733b017451e7$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
        fill: "currentColor"
    }));
};
const $c82a733b017451e7$export$246c5468186717b7 = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($c82a733b017451e7$var$PanelWarningGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $c82a733b017451e7$var$PanelWarningGlyph,
        ...props
    });
};
module.exports["PanelWarningIcon"] = $c82a733b017451e7$export$246c5468186717b7;

});

parcelRegister("9f7tI", function(module, exports) {
/* PanelErrorIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $2c603864430226d2$var$iconStyles = null;
const $2c603864430226d2$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
        fill: "currentColor"
    }));
};
const $2c603864430226d2$export$76fa6c311f4e2871 = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($2c603864430226d2$var$PanelErrorGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $2c603864430226d2$var$PanelErrorGlyph,
        ...props
    });
};
module.exports["PanelErrorIcon"] = $2c603864430226d2$export$76fa6c311f4e2871;

});

parcelRegister("5Eiz2", function(module, exports) {
/* PanelSuccessIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $12304797f5f70131$var$iconStyles = null;
const $12304797f5f70131$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
        fill: "currentColor"
    }));
};
const $12304797f5f70131$export$a5a5162e21242c3c = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($12304797f5f70131$var$PanelSuccessGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $12304797f5f70131$var$PanelSuccessGlyph,
        ...props
    });
};
module.exports["PanelSuccessIcon"] = $12304797f5f70131$export$a5a5162e21242c3c;

});

parcelRegister("9jJiA", function(module, exports) {
/* PanelNoteIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $0eeb07e0bc008878$var$iconStyles = null;
const $0eeb07e0bc008878$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" // Ignored via go/ees005
        ,
        ...props
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
        fill: "currentColor"
    }));
};
const $0eeb07e0bc008878$export$d4f894f0c3f0db6 = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($0eeb07e0bc008878$var$PanelNoteGlyph, {
        "aria-label": props.label
    })) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ $42omo.createElement((0, $id7ja.default), {
        glyph: $0eeb07e0bc008878$var$PanelNoteGlyph,
        ...props
    });
};
module.exports["PanelNoteIcon"] = $0eeb07e0bc008878$export$d4f894f0c3f0db6;

});

parcelRegister("2cZUf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $cf52fae6a5ee486f$var$BorderIconGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.33333 8C8.15267 8 8 8.14933 8 8.33333V15.6667C8.0007 15.7549 8.03604 15.8392 8.0984 15.9016C8.16076 15.964 8.24514 15.9993 8.33333 16H15.6667C15.8473 16 16 15.8507 16 15.6667V8.33333C16 8.15267 15.8507 8 15.6667 8H8.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM7 6C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7Z",
        fill: "currentColor"
    }));
};
const $cf52fae6a5ee486f$export$7e14741e44d551 = (props)=>{
    return (0, $dh538.fg)('platform-custom-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cf52fae6a5ee486f$var$BorderIconGlyph, {
        "aria-label": props.label
    }) : // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $id7ja.default), {
        glyph: $cf52fae6a5ee486f$var$BorderIconGlyph,
        ...props
    });
};
module.exports["BorderIcon"] = $cf52fae6a5ee486f$export$7e14741e44d551;

});

parcelRegister("i0DZE", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $f085c45c6ac6dbc6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f085c45c6ac6dbc6$var$createSteppedRainbow = (colors)=>{
    return `
    linear-gradient(
      to right,
      ${colors.map((color, i)=>{
        const inc = 100 / colors.length;
        const pos = i + 1;
        if (i === 0) return `${color} ${pos * inc}%,`;
        if (i === colors.length - 1) return `${color} ${(pos - 1) * inc}%`;
        return `
            ${color} ${(pos - 1) * inc}%,
            ${color} ${pos * inc}%,
          `;
    }).join('\n')}
    )`;
};
const $f085c45c6ac6dbc6$export$8025971e8c08a5b8 = $f085c45c6ac6dbc6$var$createSteppedRainbow([
    "var(--ds-background-accent-purple-bolder, #964AC0)",
    "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "var(--ds-background-accent-orange-subtle, #FCA700)",
    "var(--ds-background-accent-red-bolder, #C9372C)"
]);
const $f085c45c6ac6dbc6$export$9427247cfe66d53e = $f085c45c6ac6dbc6$var$createSteppedRainbow([
    "var(--ds-background-accent-gray-subtle, #8C8F97)",
    "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)"
]);
const $f085c45c6ac6dbc6$var$barStyles = {
    name: "ox20r",
    styles: "position:absolute;left:0;right:0;top:var(--ds-space-200, 16px);margin:auto;width:12px;height:3px;border-radius:var(--ds-radius-small, 3px)"
};
const $f085c45c6ac6dbc6$var$textColorIconWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f085c45c6ac6dbc6$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    if (disabled) return $f085c45c6ac6dbc6$export$9427247cfe66d53e;
    return $f085c45c6ac6dbc6$export$8025971e8c08a5b8;
};
const $f085c45c6ac6dbc6$export$9141b78f26ee217c = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $f085c45c6ac6dbc6$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "toolbar-icon-stepped-rainbow",
        style: {
            background: $f085c45c6ac6dbc6$var$getBackground(selectedColor, disabled)
        },
        css: $f085c45c6ac6dbc6$var$barStyles
    }));
};
module.exports["SteppedRainbowIconDecoration"] = $f085c45c6ac6dbc6$export$9141b78f26ee217c;

});

parcelRegister("c0czl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

function $3ae2a3e708a69581$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ae2a3e708a69581$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $3ae2a3e708a69581$var$textColorIconWrapper = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $3ae2a3e708a69581$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)";
};
const $3ae2a3e708a69581$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3ae2a3e708a69581$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $3ae2a3e708a69581$var$getBackground(selectedColor, disabled)
        },
        css: $3ae2a3e708a69581$var$barStyles
    }));
};
module.exports["DynamicStrokeIconDecoration"] = $3ae2a3e708a69581$export$76b0278e018f8601;

});

parcelRegister("jbX4H", function(module, exports) {

let $df8cde70d2882e2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df8cde70d2882e2f$var$load("7Vmxp").then(()=>parcelRequire('aJWwp'));

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("6iY4P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("j6GAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("7t8Pn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $570216d1bcbf60e3$var$_react = $570216d1bcbf60e3$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $570216d1bcbf60e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $570216d1bcbf60e3$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $570216d1bcbf60e3$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$570216d1bcbf60e3$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $570216d1bcbf60e3$var$_default = module.exports.default = $570216d1bcbf60e3$var$SourceCode24Icon;

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8DZd1 = parcelRequire("8DZd1");


var $djgQ6 = parcelRequire("djgQ6");


var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))), (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))));
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("8DZd1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64b1721c286de662$var$_react = $64b1721c286de662$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $64b1721c286de662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64b1721c286de662$var$Generic16Icon = (props)=>/*#__PURE__*/ $64b1721c286de662$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$64b1721c286de662$var$Generic16Icon.displayName = 'Generic16Icon';
var $64b1721c286de662$var$_default = module.exports.default = $64b1721c286de662$var$Generic16Icon;

});

parcelRegister("djgQ6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9b0a1cae716cd1ca$var$_react = $9b0a1cae716cd1ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9b0a1cae716cd1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b0a1cae716cd1ca$var$Generic24Icon = (props)=>/*#__PURE__*/ $9b0a1cae716cd1ca$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9b0a1cae716cd1ca$var$Generic24Icon.displayName = 'Generic24Icon';
var $9b0a1cae716cd1ca$var$_default = module.exports.default = $9b0a1cae716cd1ca$var$Generic24Icon;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $jKhX7 = parcelRequire("jKhX7");


var $cQbj1 = parcelRequire("cQbj1");


var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($jKhX7))), (0, (/*@__PURE__*/$parcel$interopDefault($cQbj1)))));
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("jKhX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6003d2deb1d9822$var$_react = $e6003d2deb1d9822$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e6003d2deb1d9822$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6003d2deb1d9822$var$Presentation16Icon = (props)=>/*#__PURE__*/ $e6003d2deb1d9822$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6003d2deb1d9822$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $e6003d2deb1d9822$var$_default = module.exports.default = $e6003d2deb1d9822$var$Presentation16Icon;

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $lxsNd = parcelRequire("lxsNd");


var $iFCP2 = parcelRequire("iFCP2");


var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lxsNd))), (0, (/*@__PURE__*/$parcel$interopDefault($iFCP2)))));
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("lxsNd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fae303b458ee3eba$var$_react = $fae303b458ee3eba$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $fae303b458ee3eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fae303b458ee3eba$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $fae303b458ee3eba$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fae303b458ee3eba$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $fae303b458ee3eba$var$_default = module.exports.default = $fae303b458ee3eba$var$Spreadsheet16Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("2ixko", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ac71d7218c06efe$var$_react = $1ac71d7218c06efe$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $1ac71d7218c06efe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ac71d7218c06efe$var$Executable16Icon = (props)=>/*#__PURE__*/ $1ac71d7218c06efe$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$1ac71d7218c06efe$var$Executable16Icon.displayName = 'Executable16Icon';
var $1ac71d7218c06efe$var$_default = module.exports.default = $1ac71d7218c06efe$var$Executable16Icon;

});

parcelRegister("4dLYc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $312d962237f997a8$var$_react = $312d962237f997a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $312d962237f997a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $312d962237f997a8$var$Executable24Icon = (props)=>/*#__PURE__*/ $312d962237f997a8$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$312d962237f997a8$var$Executable24Icon.displayName = 'Executable24Icon';
var $312d962237f997a8$var$_default = module.exports.default = $312d962237f997a8$var$Executable24Icon;

});

parcelRegister("d5BUD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $987926a28539ecdc$var$_react = $987926a28539ecdc$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $987926a28539ecdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $987926a28539ecdc$var$Gif16Icon = (props)=>/*#__PURE__*/ $987926a28539ecdc$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$987926a28539ecdc$var$Gif16Icon.displayName = 'Gif16Icon';
var $987926a28539ecdc$var$_default = module.exports.default = $987926a28539ecdc$var$Gif16Icon;

});

parcelRegister("b4DX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $80ff0f2ee8339e7f$var$_react = $80ff0f2ee8339e7f$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $80ff0f2ee8339e7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80ff0f2ee8339e7f$var$Gif24Icon = (props)=>/*#__PURE__*/ $80ff0f2ee8339e7f$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$80ff0f2ee8339e7f$var$Gif24Icon.displayName = 'Gif24Icon';
var $80ff0f2ee8339e7f$var$_default = module.exports.default = $80ff0f2ee8339e7f$var$Gif24Icon;

});

parcelRegister("4rkAw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $33b9a76c1d425a4b$var$_react = $33b9a76c1d425a4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $33b9a76c1d425a4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33b9a76c1d425a4b$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $33b9a76c1d425a4b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$33b9a76c1d425a4b$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $33b9a76c1d425a4b$var$_default = module.exports.default = $33b9a76c1d425a4b$var$GoogleDoc16Icon;

});

parcelRegister("5W6v1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $45276929af089f1e$var$_react = $45276929af089f1e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $45276929af089f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45276929af089f1e$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $45276929af089f1e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$45276929af089f1e$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $45276929af089f1e$var$_default = module.exports.default = $45276929af089f1e$var$GoogleDoc24Icon;

});

parcelRegister("jDMpf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e4c73548be2d77b2$var$_react = $e4c73548be2d77b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e4c73548be2d77b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4c73548be2d77b2$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $e4c73548be2d77b2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e4c73548be2d77b2$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $e4c73548be2d77b2$var$_default = module.exports.default = $e4c73548be2d77b2$var$GoogleForm16Icon;

});

parcelRegister("av4P2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a508a3974c868b6$var$_react = $7a508a3974c868b6$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $7a508a3974c868b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a508a3974c868b6$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $7a508a3974c868b6$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7a508a3974c868b6$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $7a508a3974c868b6$var$_default = module.exports.default = $7a508a3974c868b6$var$GoogleForm24Icon;

});

parcelRegister("l59oX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f5915b8e34e2cce4$var$_react = $f5915b8e34e2cce4$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f5915b8e34e2cce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f5915b8e34e2cce4$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f5915b8e34e2cce4$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f5915b8e34e2cce4$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f5915b8e34e2cce4$var$_default = module.exports.default = $f5915b8e34e2cce4$var$GoogleSheet16Icon;

});

parcelRegister("giYeH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bded0d6c49d90549$var$_react = $bded0d6c49d90549$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $bded0d6c49d90549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bded0d6c49d90549$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $bded0d6c49d90549$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bded0d6c49d90549$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $bded0d6c49d90549$var$_default = module.exports.default = $bded0d6c49d90549$var$GoogleSheet24Icon;

});

parcelRegister("jOGxt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6d3af3126d12bf0$var$_react = $e6d3af3126d12bf0$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e6d3af3126d12bf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6d3af3126d12bf0$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $e6d3af3126d12bf0$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6d3af3126d12bf0$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $e6d3af3126d12bf0$var$_default = module.exports.default = $e6d3af3126d12bf0$var$GoogleSlide16Icon;

});

parcelRegister("eWLPt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ae1b9556e1933b44$var$_react = $ae1b9556e1933b44$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $ae1b9556e1933b44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae1b9556e1933b44$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $ae1b9556e1933b44$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ae1b9556e1933b44$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $ae1b9556e1933b44$var$_default = module.exports.default = $ae1b9556e1933b44$var$GoogleSlide24Icon;

});

parcelRegister("d8Kpd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $991004eb95b782af$var$_react = $991004eb95b782af$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $991004eb95b782af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $991004eb95b782af$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $991004eb95b782af$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$991004eb95b782af$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $991004eb95b782af$var$_default = module.exports.default = $991004eb95b782af$var$ExcelSpreadsheet16Icon;

});

parcelRegister("gH8Rx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c277896da6578a99$var$_react = $c277896da6578a99$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $c277896da6578a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c277896da6578a99$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $c277896da6578a99$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c277896da6578a99$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $c277896da6578a99$var$_default = module.exports.default = $c277896da6578a99$var$ExcelSpreadsheet24Icon;

});

parcelRegister("hY1Uy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d14985c3ed2ec0ae$var$_react = $d14985c3ed2ec0ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d14985c3ed2ec0ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $d14985c3ed2ec0ae$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d14985c3ed2ec0ae$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $d14985c3ed2ec0ae$var$_default = module.exports.default = $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon;

});

parcelRegister("dfQbH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a652876e1a65311$var$_react = $9a652876e1a65311$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9a652876e1a65311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a652876e1a65311$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $9a652876e1a65311$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a652876e1a65311$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $9a652876e1a65311$var$_default = module.exports.default = $9a652876e1a65311$var$PowerpointPresentation24Icon;

});

parcelRegister("90Icb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $68f6656ee3eec0b2$var$_react = $68f6656ee3eec0b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $68f6656ee3eec0b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68f6656ee3eec0b2$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $68f6656ee3eec0b2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$68f6656ee3eec0b2$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $68f6656ee3eec0b2$var$_default = module.exports.default = $68f6656ee3eec0b2$var$WordDocument16Icon;

});

parcelRegister("lkBga", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f8785e41f79a32cd$var$_react = $f8785e41f79a32cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f8785e41f79a32cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8785e41f79a32cd$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $f8785e41f79a32cd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f8785e41f79a32cd$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $f8785e41f79a32cd$var$_default = module.exports.default = $f8785e41f79a32cd$var$WordDocument24Icon;

});

parcelRegister("11LZV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0bfb1dce28d59ddd$var$_react = $0bfb1dce28d59ddd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $0bfb1dce28d59ddd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bfb1dce28d59ddd$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $0bfb1dce28d59ddd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$0bfb1dce28d59ddd$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $0bfb1dce28d59ddd$var$_default = module.exports.default = $0bfb1dce28d59ddd$var$PdfDocument16Icon;

});

parcelRegister("lzyQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fb47e6517d9f8e39$var$_react = $fb47e6517d9f8e39$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $fb47e6517d9f8e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb47e6517d9f8e39$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $fb47e6517d9f8e39$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fb47e6517d9f8e39$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $fb47e6517d9f8e39$var$_default = module.exports.default = $fb47e6517d9f8e39$var$PdfDocument24Icon;

});

parcelRegister("9W0IA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73ba16739a647a26$var$_react = $73ba16739a647a26$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $73ba16739a647a26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73ba16739a647a26$var$Sketch16Icon = (props)=>/*#__PURE__*/ $73ba16739a647a26$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$73ba16739a647a26$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $73ba16739a647a26$var$_default = module.exports.default = $73ba16739a647a26$var$Sketch16Icon;

});

parcelRegister("9AnKp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6fa9e5979f68da4f$var$_react = $6fa9e5979f68da4f$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $6fa9e5979f68da4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6fa9e5979f68da4f$var$Sketch24Icon = (props)=>/*#__PURE__*/ $6fa9e5979f68da4f$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6fa9e5979f68da4f$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $6fa9e5979f68da4f$var$_default = module.exports.default = $6fa9e5979f68da4f$var$Sketch24Icon;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("66dpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("fAGae", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");


var $9wGTI = parcelRequire("9wGTI");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && (0, window.__SSR_RENDERED__) && (0, $9wGTI.fg)('replace_react_render_image_with_image_tag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("e6pbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4452a63831cbd09$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $a4452a63831cbd09$var$t() {
    return $a4452a63831cbd09$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $a4452a63831cbd09$var$t.apply(this, arguments);
}
const $a4452a63831cbd09$var$n = [
    "children",
    "options"
], $a4452a63831cbd09$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $a4452a63831cbd09$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($a4452a63831cbd09$var$i || ($a4452a63831cbd09$var$i = {}));
const $a4452a63831cbd09$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $a4452a63831cbd09$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $a4452a63831cbd09$var$o = [
    "style",
    "script"
], $a4452a63831cbd09$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $a4452a63831cbd09$var$s = /mailto:/i, $a4452a63831cbd09$var$d = /\n{2,}$/, $a4452a63831cbd09$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $a4452a63831cbd09$var$p = /^ *> ?/gm, $a4452a63831cbd09$var$f = /^ {2,}\n/, $a4452a63831cbd09$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $a4452a63831cbd09$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $a4452a63831cbd09$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $a4452a63831cbd09$var$k = /^(?:\n *)*\n/, $a4452a63831cbd09$var$x = /\r\n?/g, $a4452a63831cbd09$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $a4452a63831cbd09$var$v = /^\[\^([^\]]+)]/, $a4452a63831cbd09$var$S = /\f/g, $a4452a63831cbd09$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $a4452a63831cbd09$var$$ = /^\s*?\[(x|\s)\]/, $a4452a63831cbd09$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $a4452a63831cbd09$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $a4452a63831cbd09$var$T = /^<!--[\s\S]*?(?:-->)/, $a4452a63831cbd09$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $a4452a63831cbd09$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $a4452a63831cbd09$var$M = /^\{.*\}$/, $a4452a63831cbd09$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $a4452a63831cbd09$var$I = /^<([^ >]+@[^ >]+)>/, $a4452a63831cbd09$var$U = /^<([^ >]+:\/[^ >]+)>/, $a4452a63831cbd09$var$D = /-([a-z])?/gi, $a4452a63831cbd09$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $a4452a63831cbd09$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $a4452a63831cbd09$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$P = /(\[|\])/g, $a4452a63831cbd09$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $a4452a63831cbd09$var$W = /\t/g, $a4452a63831cbd09$var$G = /(^ *\||\| *$)/g, $a4452a63831cbd09$var$Z = /^ *:-+: *$/, $a4452a63831cbd09$var$q = /^ *:-+ *$/, $a4452a63831cbd09$var$Q = /^ *-+: *$/, $a4452a63831cbd09$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $a4452a63831cbd09$var$X = new RegExp(`^([*_])\\1${$a4452a63831cbd09$var$V}\\1\\1(?!\\1)`), $a4452a63831cbd09$var$J = new RegExp(`^([*_])${$a4452a63831cbd09$var$V}\\1(?!\\1|\\w)`), $a4452a63831cbd09$var$K = new RegExp(`^==${$a4452a63831cbd09$var$V}==`), $a4452a63831cbd09$var$Y = new RegExp(`^~~${$a4452a63831cbd09$var$V}~~`), $a4452a63831cbd09$var$ee = /^\\([^0-9A-Za-z\s])/, $a4452a63831cbd09$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $a4452a63831cbd09$var$ne = /^\n+/, $a4452a63831cbd09$var$re = /^([ \t]*)/, $a4452a63831cbd09$var$ie = /\\([^\\])/g, $a4452a63831cbd09$var$le = / *\n+$/, $a4452a63831cbd09$var$ae = /(?:^|\n)( *)$/, $a4452a63831cbd09$var$oe = "(?:\\d+\\.)", $a4452a63831cbd09$var$ce = "(?:[*+-])";
function $a4452a63831cbd09$var$se(e) {
    return "( *)(" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + ") +";
}
const $a4452a63831cbd09$var$de = $a4452a63831cbd09$var$se(1), $a4452a63831cbd09$var$ue = $a4452a63831cbd09$var$se(2);
function $a4452a63831cbd09$var$pe(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue));
}
const $a4452a63831cbd09$var$fe = $a4452a63831cbd09$var$pe(1), $a4452a63831cbd09$var$he = $a4452a63831cbd09$var$pe(2);
function $a4452a63831cbd09$var$me(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $a4452a63831cbd09$var$ge = $a4452a63831cbd09$var$me(1), $a4452a63831cbd09$var$ye = $a4452a63831cbd09$var$me(2);
function $a4452a63831cbd09$var$ke(e) {
    const t = 1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $a4452a63831cbd09$var$xe = $a4452a63831cbd09$var$ke(1), $a4452a63831cbd09$var$be = $a4452a63831cbd09$var$ke(2);
function $a4452a63831cbd09$var$ve(e, t) {
    const n = 1 === t, i = n ? $a4452a63831cbd09$var$xe : $a4452a63831cbd09$var$be, l = n ? $a4452a63831cbd09$var$ge : $a4452a63831cbd09$var$ye, a = n ? $a4452a63831cbd09$var$fe : $a4452a63831cbd09$var$he;
    return {
        match (e, t, n) {
            const r = $a4452a63831cbd09$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($a4452a63831cbd09$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($a4452a63831cbd09$var$le, "\n\n")) : (r.inline = !0, h = s.replace($a4452a63831cbd09$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $a4452a63831cbd09$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $a4452a63831cbd09$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $a4452a63831cbd09$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $a4452a63831cbd09$var$$e = [
    $a4452a63831cbd09$var$u,
    $a4452a63831cbd09$var$m,
    $a4452a63831cbd09$var$g,
    $a4452a63831cbd09$var$w,
    $a4452a63831cbd09$var$z,
    $a4452a63831cbd09$var$C,
    $a4452a63831cbd09$var$T,
    $a4452a63831cbd09$var$j,
    $a4452a63831cbd09$var$ge,
    $a4452a63831cbd09$var$xe,
    $a4452a63831cbd09$var$ye,
    $a4452a63831cbd09$var$be
], $a4452a63831cbd09$var$we = [
    ...$a4452a63831cbd09$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $a4452a63831cbd09$var$L,
    $a4452a63831cbd09$var$B
];
function $a4452a63831cbd09$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $a4452a63831cbd09$var$ze(e) {
    return $a4452a63831cbd09$var$Q.test(e) ? "right" : $a4452a63831cbd09$var$Z.test(e) ? "center" : $a4452a63831cbd09$var$q.test(e) ? "left" : null;
}
function $a4452a63831cbd09$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $a4452a63831cbd09$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $a4452a63831cbd09$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($a4452a63831cbd09$var$G, "").split("|").map($a4452a63831cbd09$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $a4452a63831cbd09$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $a4452a63831cbd09$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.paragraph
    };
}
function $a4452a63831cbd09$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $a4452a63831cbd09$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $a4452a63831cbd09$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $a4452a63831cbd09$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$a4452a63831cbd09$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $a4452a63831cbd09$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $a4452a63831cbd09$var$De(e) {
    return e.replace($a4452a63831cbd09$var$ie, "$1");
}
function $a4452a63831cbd09$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $a4452a63831cbd09$var$Fe = (e, t, n)=>({
        children: $a4452a63831cbd09$var$je(t, e[1], n)
    });
function $a4452a63831cbd09$var$Pe() {
    return {};
}
function $a4452a63831cbd09$var$_e() {
    return null;
}
function $a4452a63831cbd09$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $a4452a63831cbd09$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $a4452a63831cbd09$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $a4452a63831cbd09$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $a4452a63831cbd09$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $a4452a63831cbd09$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $a4452a63831cbd09$var$t({}, n, l, {
            className: $a4452a63831cbd09$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($a4452a63831cbd09$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $a4452a63831cbd09$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($a4452a63831cbd09$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $42omo.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($a4452a63831cbd09$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($a4452a63831cbd09$var$O) && (e = e.replace($a4452a63831cbd09$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $a4452a63831cbd09$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($a4452a63831cbd09$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($a4452a63831cbd09$var$L.test(u) || $a4452a63831cbd09$var$B.test(u)) && (n[d] = $42omo.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$a4452a63831cbd09$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $a4452a63831cbd09$export$3e2338ea76b578c9, i.slugify = i.slugify || $a4452a63831cbd09$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $a4452a63831cbd09$var$t({}, $a4452a63831cbd09$var$a, i.namedCodesToUnicode) : $a4452a63831cbd09$var$a, i.createElement = i.createElement || $42omo.createElement;
    const q = [], Q = {}, V = {
        [$a4452a63831cbd09$export$e0aa44767d8750d5.blockQuote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($a4452a63831cbd09$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakLine]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$f),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakThematic]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$h),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $a4452a63831cbd09$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeFenced]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeInline]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnoteReference]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $a4452a63831cbd09$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.gfmTask]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.heading]: {
            match: $a4452a63831cbd09$var$Me(i.enforceAtxHeadings ? $a4452a63831cbd09$var$C : $a4452a63831cbd09$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[2], n),
                    id: i.slugify(e[2], $a4452a63831cbd09$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.headingSetext]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.heading
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($a4452a63831cbd09$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $a4452a63831cbd09$var$we.some((e)=>e.test(c)) ? $a4452a63831cbd09$var$He : $a4452a63831cbd09$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $a4452a63831cbd09$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlComment]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$T),
            order: 1,
            parse: ()=>({}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.image]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.link]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$Ne(t, e[1], n),
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $a4452a63831cbd09$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                };
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.orderedList]: $a4452a63831cbd09$var$ve(d, 1),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.unorderedList]: $a4452a63831cbd09$var$ve(d, 2),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$k),
            order: 3,
            parse: $a4452a63831cbd09$var$Pe,
            render: ()=>"\n"
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.paragraph]: {
            match: $a4452a63831cbd09$var$Ie,
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.ref]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refImage]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refLink]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($a4452a63831cbd09$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.table]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$j),
            order: 1,
            parse: $a4452a63831cbd09$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $a4452a63831cbd09$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $a4452a63831cbd09$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.text]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($a4452a63831cbd09$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textBolded]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEmphasized]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEscaped]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textMarked]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$K),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Y),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock], delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($a4452a63831cbd09$var$x, "\n").replace($a4452a63831cbd09$var$S, "").replace($a4452a63831cbd09$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $a4452a63831cbd09$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $a4452a63831cbd09$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $a4452a63831cbd09$var$n);
    return $42omo.cloneElement($a4452a63831cbd09$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("hpNab", function(module, exports) {

var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons',
        'loom-external-open'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $dh538 = parcelRequire("dh538");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $8C5kA = parcelRequire("8C5kA");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $8C5kA.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed')) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("kpYGL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $21366d93ef656d79$var$shimmerKeyframes = null;
const $21366d93ef656d79$var$skeletonStyles = null;
const $21366d93ef656d79$var$activeShimmerStyles = null; /**
                                   * __Skeleton__
                                   *
                                   * A skeleton acts as a placeholder for content, usually while the content loads.
                                   *
                                   * - [Examples](https://atlassian.design/components/skeleton/examples)
                                   * - [Code](https://atlassian.design/components/skeleton/code)
                                   */ 
const $21366d93ef656d79$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $gMc0m.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkizff",
            isShimmering && "",
            isShimmering && "_j7hq19vq"
        ])
    });
};
var $21366d93ef656d79$export$2e2bcd8739ae039 = $21366d93ef656d79$var$Skeleton;
module.exports["default"] = $21366d93ef656d79$export$2e2bcd8739ae039;

});

parcelRegister("9ISlX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kVnOi = parcelRequire("kVnOi");

class $d6477c19fa37ad04$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $kVnOi.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}
module.exports["EmbedResizeMessageListener"] = $d6477c19fa37ad04$export$3482036c37e627f4;

});

parcelRegister("9CM6e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dQl1W = parcelRequire("dQl1W");


var $bYRk6 = parcelRequire("bYRk6");


var $dh538 = parcelRequire("dh538");


var $lgqac = parcelRequire("lgqac");


var $aylI0 = parcelRequire("aylI0");


var $5Tie7 = parcelRequire("5Tie7");

const $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardProps);
    };
    if ((0, $dh538.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: (0, $lgqac.context)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            className: "loader-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aylI0.CardWithUrlContent), cardProps))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: (0, $lgqac.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aylI0.CardWithUrlContent), cardProps)));
};
module.exports["CardSSR"] = $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6;

});

parcelRegister("6CRn4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5311f5d282e4b997$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $gxsT9 = parcelRequire("gxsT9");


var $gAARK = parcelRequire("gAARK");


var $kfJSC = parcelRequire("kfJSC");


var $lqWNh = parcelRequire("lqWNh");


var $1OLls = parcelRequire("1OLls");

function $5311f5d282e4b997$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $lqWNh.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $kfJSC.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1OLls.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $dh538.fg)('media-perf-uplift-mutation-fix')
        }),
        ...!(0, $dh538.fg)('platform_editor_fix_media_in_renderer') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1OLls.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("kfJSC", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $lqWNh = parcelRequire("lqWNh");


var $gAARK = parcelRequire("gAARK");

function $7eac1e1fe0a5dbb7$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $7eac1e1fe0a5dbb7$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $7eac1e1fe0a5dbb7$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $gAARK.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $7eac1e1fe0a5dbb7$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $7eac1e1fe0a5dbb7$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $aFUXX.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $aFUXX.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $aFUXX.akEditorFullWidthLayoutWidth));
};
const $7eac1e1fe0a5dbb7$export$4ab195f543459515 = (origWidth = (0, $gAARK.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $aFUXX.akEditorDefaultLayoutWidth), minWidth = (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $7eac1e1fe0a5dbb7$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $7eac1e1fe0a5dbb7$export$f72673597dacfcfa = (value, interval = (0, $gAARK.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $7eac1e1fe0a5dbb7$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $gAARK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $7eac1e1fe0a5dbb7$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $lqWNh.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $lqWNh.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $7eac1e1fe0a5dbb7$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $7eac1e1fe0a5dbb7$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $7eac1e1fe0a5dbb7$export$7cc71489edfd26f8($pos, view) : $7eac1e1fe0a5dbb7$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $7eac1e1fe0a5dbb7$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $lqWNh.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $7eac1e1fe0a5dbb7$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $7eac1e1fe0a5dbb7$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $7eac1e1fe0a5dbb7$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $7eac1e1fe0a5dbb7$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $ks2lK.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};
module.exports["getMediaSinglePixelWidth"] = $7eac1e1fe0a5dbb7$export$a6f4ec2edd25b07e;
module.exports["calcMediaSinglePixelWidth"] = $7eac1e1fe0a5dbb7$export$5091b2c0d1cd2361;
module.exports["calcMediaSingleMaxWidth"] = $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21;
module.exports["getMediaSingleInitialWidth"] = $7eac1e1fe0a5dbb7$export$4ab195f543459515;
module.exports["calculateOffsetLeft"] = $7eac1e1fe0a5dbb7$export$ab1f1890e4428242;
module.exports["roundToNearest"] = $7eac1e1fe0a5dbb7$export$f72673597dacfcfa;
module.exports["calcMinWidth"] = $7eac1e1fe0a5dbb7$export$c7eaa4d46a45395;
module.exports["getMaxWidthForNestedNode"] = $7eac1e1fe0a5dbb7$export$4147ff5cc31ec064;
module.exports["getMaxWidthForNestedNodeNext"] = $7eac1e1fe0a5dbb7$export$bcefe8f1d5d7bbf3;
module.exports["currentMediaNodeWithPos"] = $7eac1e1fe0a5dbb7$export$22e4c8c04f58169d;

});

parcelRegister("1OLls", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $lqWNh = parcelRequire("lqWNh");


var $fJNzZ = parcelRequire("fJNzZ");

function $0ef555bed3f3ee7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $0ef555bed3f3ee7f$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $0ef555bed3f3ee7f$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $0ef555bed3f3ee7f$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $0ef555bed3f3ee7f$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $0ef555bed3f3ee7f$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $0ef555bed3f3ee7f$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $0ef555bed3f3ee7f$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ var $0ef555bed3f3ee7f$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $0ef555bed3f3ee7f$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = $0ef555bed3f3ee7f$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $0ef555bed3f3ee7f$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $0ef555bed3f3ee7f$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $0ef555bed3f3ee7f$var$calcMaxWidth(layout, containerWidth));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $0ef555bed3f3ee7f$var$_ref2, " ", isInRenderer ? $0ef555bed3f3ee7f$var$_ref : (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? `max-width: ${cssMaxWidth};` : `max-width: ${calculatedMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $lqWNh.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $0ef555bed3f3ee7f$var$float(layout), ";margin:", $0ef555bed3f3ee7f$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $lqWNh.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $0ef555bed3f3ee7f$var$isImageAligned(layout), ";");
};
const $0ef555bed3f3ee7f$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $9K4OG.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $9K4OG.css)("position:relative;", $0ef555bed3f3ee7f$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $0ef555bed3f3ee7f$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6(rest)
    }, children);
$0ef555bed3f3ee7f$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $0ef555bed3f3ee7f$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $0ef555bed3f3ee7f$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $0ef555bed3f3ee7f$export$e18e95249d813157;

});

parcelRegister("fBAKC", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("69fUv")));
const $7850275dc402dd65$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $7850275dc402dd65$export$f386473e8f104bcb;

});

parcelRegister("69fUv", function(module, exports) {

let $479fecd0aea59d37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $479fecd0aea59d37$var$load("koKgZ").then(()=>parcelRequire('7Fmwh'));

});

parcelRegister("h8cpw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $eIleF = parcelRequire("eIleF");


var $1oCLl = parcelRequire("1oCLl");


var $kKODE = parcelRequire("kKODE");


var $eB2Ls = parcelRequire("eB2Ls");


var $4gOU2 = parcelRequire("4gOU2");


var $dOvUN = parcelRequire("dOvUN");


var $afp1H = parcelRequire("afp1H");


var $bz6dj = parcelRequire("bz6dj");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");


var $lz9QA = parcelRequire("lz9QA");

function $4a6a130a5859a503$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))(), []);
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const invokeClientAction = (0, $9oOnT.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $7DSoa.default)();
    if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve(url);
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $eB2Ls.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $bz6dj.toAction)(downloadActionProps, invokeClientAction, (0, $afp1H.messages).download, 'download-content'));
        const viewActionProps = (0, $dOvUN.extractInvokeViewAction)(invokeParam);
        if (viewActionProps) actions.push((0, $bz6dj.toAction)(viewActionProps, invokeClientAction, (0, $afp1H.messages).view, 'view-content'));
        const previewActionProps = (0, $4gOU2.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        });
        if (previewActionProps) actions.push((0, $bz6dj.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $afp1H.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $4a6a130a5859a503$export$a95296ded9241771;

});

parcelRegister("bz6dj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

const $2752aec5c6b5a722$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $2752aec5c6b5a722$export$9d52be0dab870c7;

});

parcelRegister("7FiWH", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $8C5kA = parcelRequire("8C5kA");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $lOzEN = parcelRequire("lOzEN");


var $8tdj3 = parcelRequire("8tdj3");


var $jypE9 = parcelRequire("jypE9");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $iGbqR = parcelRequire("iGbqR");

var $d925B = parcelRequire("d925B");


var $3RxtY = parcelRequire("3RxtY");

function $f7a722354e8e82d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $f7a722354e8e82d7$var$containerStylesOld = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f7a722354e8e82d7$var$containerStyles = {
    name: "s1rv5c",
    styles: "position:relative;white-space:nowrap"
};
const $f7a722354e8e82d7$var$iconWrapperStylesOld = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $f7a722354e8e82d7$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $f7a722354e8e82d7$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $f7a722354e8e82d7$var$linkStylesCommon = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $f7a722354e8e82d7$var$linkStylesOld = (0, $ecnYn.xcss)({
    top: '-1px'
});
const $f7a722354e8e82d7$var$linkStylesHeightFix = (0, $ecnYn.xcss)({
    top: '0px',
    height: '1.2em'
});
const $f7a722354e8e82d7$var$linkStylesNewWithHeightFix = (0, $ecnYn.xcss)({
    top: '0px',
    visibility: 'hidden',
    height: '1.2em'
});
const $f7a722354e8e82d7$var$linkStylesVisible = (0, $ecnYn.xcss)({
    visibility: 'visible'
});
const $f7a722354e8e82d7$var$iconAndLabelStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: 'space.025'
});
const $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $f7a722354e8e82d7$var$ICON_WIDTH = 16;
const $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $f7a722354e8e82d7$var$MIN_CARD_WIDTH_NOT_COVERED_BY_OVERLAY = 30;
const $f7a722354e8e82d7$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $f7a722354e8e82d7$var$HoverLinkOverlayOriginal = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const containerRef = (0, $42omo.useRef)(null);
    const hoverLinkButtonRef = (0, $42omo.useRef)(null);
    const hiddenTextRef = (0, $42omo.useRef)(null);
    const [showLabel, setShowLabel] = (0, $42omo.useState)(true);
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const openTextWidthRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        const canShowLabel = cardWidth - openTextWidth > $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $f7a722354e8e82d7$var$ICON_WIDTH;
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $f7a722354e8e82d7$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $3RxtY.messages).previewButtonTitle) : formatMessage((0, $3RxtY.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: containerRef,
        css: $f7a722354e8e82d7$var$containerStylesOld,
        onDoubleClick: handleDoubleClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>handleOverlayChange(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>handleOverlayChange(false)
    }, children, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $f7a722354e8e82d7$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fpGTa.default), {
        ref: hoverLinkButtonRef,
        xcss: [
            $f7a722354e8e82d7$var$linkStylesCommon,
            (0, $1oCLl.expValEquals)('platform_editor_hoverlink_ui_fixes_exp', 'cohort', 'css_changes_only') ? $f7a722354e8e82d7$var$linkStylesHeightFix : $f7a722354e8e82d7$var$linkStylesOld
        ],
        href: url,
        target: "_blank",
        style: {
            paddingBlock: compactPadding ? '1px' : (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $f7a722354e8e82d7$var$iconWrapperStylesOld,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
const $f7a722354e8e82d7$var$HoverLinkOverlayNew = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const containerRef = (0, $42omo.useRef)(null);
    const iconRef = (0, $42omo.useRef)(null);
    const iconLeftRef = (0, $42omo.useRef)(0);
    const iconAndLabelRef = (0, $42omo.useRef)(null);
    const minMaxWidthRef = (0, $42omo.useRef)();
    const [showLabel, setShowLabel] = (0, $42omo.useState)(false);
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const [showOverlay, setShowOverlay] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isVisible && !isHovered) return;
        if (!containerRef.current) return;
        if (iconRef.current && iconAndLabelRef.current) {
            const iconRect = iconRef.current.getBoundingClientRect();
            iconLeftRef.current = iconRect.left;
            minMaxWidthRef.current = {
                min: iconRect.width,
                max: iconAndLabelRef.current.getBoundingClientRect().width
            };
        }
        if (!iconLeftRef.current || !minMaxWidthRef.current) return;
        const containerDomRect = containerRef.current.getBoundingClientRect();
        const containerStyles = getComputedStyle(containerRef.current);
        const containerHeight = containerDomRect.height - parseFloat(containerStyles.paddingTop) - parseFloat(containerStyles.paddingBottom) - parseFloat(containerStyles.borderTopWidth) - parseFloat(containerStyles.borderBottomWidth);
        const oneLine = parseFloat(containerStyles.lineHeight) >= containerHeight;
        const firstLineWidth = containerDomRect.right - iconLeftRef.current;
        // We don't want HoverLinkOverlay to cover the entire card if it is oneline. It allows the user to click on the card itself.
        const reservedWidth = oneLine ? $f7a722354e8e82d7$var$MIN_CARD_WIDTH_NOT_COVERED_BY_OVERLAY : 0;
        const availableWidth = firstLineWidth - reservedWidth;
        // True when icon and label can be shown
        setShowLabel(availableWidth >= minMaxWidthRef.current.max);
        // True when at least an icon can be shown
        setShowOverlay(availableWidth >= minMaxWidthRef.current.min);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $f7a722354e8e82d7$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $3RxtY.messages).previewButtonTitle) : formatMessage((0, $3RxtY.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: containerRef,
        css: $f7a722354e8e82d7$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        role: "presentation" // remove as part of platform_editor_hoverlink_ui_fixes_exp cleanup
        ,
        onFocus: ()=>{},
        onBlur: ()=>{}
    }, isHovered && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fpGTa.default), {
        xcss: [
            $f7a722354e8e82d7$var$linkStylesCommon,
            $f7a722354e8e82d7$var$linkStylesNewWithHeightFix,
            showOverlay && $f7a722354e8e82d7$var$linkStylesVisible
        ],
        href: url,
        target: "_blank",
        style: {
            paddingBlock: compactPadding ? '1px' : (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        as: "span",
        xcss: $f7a722354e8e82d7$var$iconAndLabelStyles,
        ref: iconAndLabelRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        ref: iconRef,
        as: "span",
        xcss: $f7a722354e8e82d7$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), (showLabel || !minMaxWidthRef.current) && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label))), children);
};
const $f7a722354e8e82d7$var$HoverLinkOverlay = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_hoverlink_ui_fixes_exp', 'cohort', 'css_js_changes'), $f7a722354e8e82d7$var$HoverLinkOverlayNew, $f7a722354e8e82d7$var$HoverLinkOverlayOriginal);
var $f7a722354e8e82d7$export$2e2bcd8739ae039 = $f7a722354e8e82d7$var$HoverLinkOverlay;
module.exports["default"] = $f7a722354e8e82d7$export$2e2bcd8739ae039;

});

parcelRegister("eLQM6", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b100a9eece33ac5b$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cDUfM")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b100a9eece33ac5b$var$LazyDatasourceTableView, props));
};
var $b100a9eece33ac5b$export$2e2bcd8739ae039 = $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $b100a9eece33ac5b$export$2e2bcd8739ae039;

});

parcelRegister("cDUfM", function(module, exports) {

let $9344c3531657f12d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9344c3531657f12d$var$load("jkPqm"),
    $9344c3531657f12d$var$load("7whwt"),
    $9344c3531657f12d$var$load("6wr18"),
    $9344c3531657f12d$var$load("jBtK5"),
    $9344c3531657f12d$var$load("5pvpJ"),
    $9344c3531657f12d$var$load("8JZKd"),
    $9344c3531657f12d$var$load("gxkWc"),
    $9344c3531657f12d$var$load("cwpgX"),
    $9344c3531657f12d$var$load("8makw"),
    $9344c3531657f12d$var$load("iXzmH"),
    $9344c3531657f12d$var$load("65c4i"),
    $9344c3531657f12d$var$load("db8rp"),
    $9344c3531657f12d$var$load("kHOMt"),
    $9344c3531657f12d$var$load("hhss7"),
    $9344c3531657f12d$var$load("Wowvf"),
    $9344c3531657f12d$var$load("7EorR"),
    $9344c3531657f12d$var$load("ffEVr"),
    $9344c3531657f12d$var$load("kUbUu"),
    $9344c3531657f12d$var$load("7ixUU")
]).then(()=>parcelRequire('jfuml'));

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("655oj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9trs7 = parcelRequire("9trs7");


var $eIleF = parcelRequire("eIleF");


var $gmi3X = parcelRequire("gmi3X");


var $1Okf1 = parcelRequire("1Okf1");

const $b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE = 50;
const $b1fdc4e801245f01$export$f82fcd766a8daa7f = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$40b1dd31340bd5c2 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$15cd58682efec5a5 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$5e074c0b68e2ce03 = 20;
const $b1fdc4e801245f01$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    const resolverUrl = (0, $1Okf1.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
			 * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
			 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $gmi3X.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $gmi3X.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $b1fdc4e801245f01$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $b1fdc4e801245f01$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $42omo.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $b1fdc4e801245f01$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $42omo.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $42omo.useCallback)((ari)=>{
        $b1fdc4e801245f01$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $b1fdc4e801245f01$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $42omo.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $b1fdc4e801245f01$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $b1fdc4e801245f01$export$7d812bb756889442;

});

parcelRegister("4Z0ju", function(module, exports) {
const $706ca8480df97452$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $706ca8480df97452$export$1de3504963fc32f2;

});

parcelRegister("2WHHL", function(module, exports) {
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $4de09c96514ff692$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $4de09c96514ff692$export$945a571f3b658bf;

});

parcelRegister("5jQxm", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("66utD")).getElementFromPointWithoutHoneypot);

var $66utD = parcelRequire("66utD");


});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $f7qXf.maxZIndex),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("4TIFs", function(module, exports) {
$parcel$export(module.exports, "default", () => $390ef28ea0b1f2a7$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $390ef28ea0b1f2a7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("hn4RR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e81c36a83f2b3e0f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $ggbZE = parcelRequire("ggbZE");


var $c6GJD = parcelRequire("c6GJD");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");


var $6wR36 = parcelRequire("6wR36");


var $18ASy = parcelRequire("18ASy");


var $gIdjl = parcelRequire("gIdjl");


var $jUMCq = parcelRequire("jUMCq");


var $lKhNz = parcelRequire("lKhNz");

const $e81c36a83f2b3e0f$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
// @ts-ignore - Workaround for help-center local consumption
const $e81c36a83f2b3e0f$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $e81c36a83f2b3e0f$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $e81c36a83f2b3e0f$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $fBMbo.di)($e81c36a83f2b3e0f$export$8c0773eab230d49e, (0, $lKhNz.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $lKhNz.useLinkWarningModal)();
    const resolveHyperlinkFG = (0, $c6GJD.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        const Link = enableResolve ? (0, $gIdjl.HyperlinkWithSmartLinkResolver) : (0, $18ASy.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR36.LinkAnalyticsContext), {
            url: href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
            href: href,
            isLinkComponent: isLinkComponent,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                // Only call the onClick if the link is safe
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUMCq.default), linkWarningModalProps));
    }
    const Link = isLinkComponent ? $e81c36a83f2b3e0f$export$8c0773eab230d49e : $e81c36a83f2b3e0f$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR36.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUMCq.default), linkWarningModalProps));
};
var $e81c36a83f2b3e0f$export$2e2bcd8739ae039 = (0, $ggbZE.default)($e81c36a83f2b3e0f$var$PACKAGE_DATA)($e81c36a83f2b3e0f$var$LinkUrl);

});

parcelRegister("6wR36", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $13440d2ce08719fa$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};
module.exports["LinkAnalyticsContext"] = $13440d2ce08719fa$export$9458cdec663b9ff1;

});

parcelRegister("18ASy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");

// @ts-ignore - Workaround for help-center local consumption
const $3be2cafa97b66d1a$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $3be2cafa97b66d1a$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $3be2cafa97b66d1a$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $3be2cafa97b66d1a$export$8c0773eab230d49e : $3be2cafa97b66d1a$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $3be2cafa97b66d1a$export$2e2bcd8739ae039 = $3be2cafa97b66d1a$var$Hyperlink;
module.exports["default"] = $3be2cafa97b66d1a$export$2e2bcd8739ae039;

});

parcelRegister("gIdjl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $gmMgo = parcelRequire("gmMgo");


var $c6GJD = parcelRequire("c6GJD");


var $79vw2 = parcelRequire("79vw2");


var $dh538 = parcelRequire("dh538");


var $226XV = parcelRequire("226XV");


var $jMHhY = parcelRequire("jMHhY");


var $g6cf7 = parcelRequire("g6cf7");


var $5MkWK = parcelRequire("5MkWK");


var $8jBuy = parcelRequire("8jBuy");


var $dLAsE = parcelRequire("dLAsE");


var $18ASy = parcelRequire("18ASy");


var $055M6 = parcelRequire("055M6");

const $05b0889a04ec2be1$var$HyperlinkFallbackComponent = ()=>null;
const $05b0889a04ec2be1$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $g6cf7.default)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DefaultComponent, props);
    };
const $05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { actions: actions, state: state } = (0, $jMHhY.default)({
        href: props.href || ''
    });
    const services = (0, $226XV.getServices)(state?.details);
    const thirdPartyARI = (0, $226XV.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $226XV.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $dh538.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dLAsE.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Only fire the event if the feature flag is on and other conditions are met
        if (state?.status === 'resolved' && e?.button === 0 && fire3PClickEvent && (0, $dh538.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state?.status
    ]);
    const onAuthorize = (0, $42omo.useCallback)(()=>actions.authorize('url'), [
        actions
    ]);
    const shouldRenderConnectBtn = ()=>{
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        const firstChild = props.children[0];
        try {
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild?.props?.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if (state?.status === 'unauthorized' && shouldRenderConnectBtn() && ((0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        const provider = (0, $79vw2.extractSmartLinkProvider)(state?.details);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $055M6.default), {
            ...props,
            onAuthorize: services?.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: services?.length > 0,
            provider: provider
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18ASy.default), {
        ...props,
        onClick: onClick
    });
};
const $05b0889a04ec2be1$export$1fdb4f77fe528a52 = (0, $lAJUP.withErrorBoundary)($05b0889a04ec2be1$var$withValidator((0, $gmMgo.default)((0, $8jBuy.default)($05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $18ASy.default)), {
    FallbackComponent: $05b0889a04ec2be1$var$HyperlinkFallbackComponent
});
module.exports["HyperlinkWithSmartLinkResolver"] = $05b0889a04ec2be1$export$1fdb4f77fe528a52;

});

parcelRegister("jMHhY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $a43ao = parcelRequire("a43ao");


var $226XV = parcelRequire("226XV");


var $lz9QA = parcelRequire("lz9QA");


var $lUh1d = parcelRequire("lUh1d");

const $8ce3085c5c5a77bd$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const state = (0, $lz9QA.useSmartCardState)(href);
    const definitionId = (0, $226XV.getDefinitionId)(state.details);
    const extensionKey = (0, $226XV.getExtensionKey)(state.details);
    const resourceType = (0, $226XV.getResourceType)(state.details);
    const actions = (0, $a43ao.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $lUh1d.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $42omo.useEffect)(()=>{
        $l6tPN.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $l6tPN.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: $l6tPN.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $8ce3085c5c5a77bd$export$2e2bcd8739ae039 = $8ce3085c5c5a77bd$var$useResolveHyperlink;
module.exports["default"] = $8ce3085c5c5a77bd$export$2e2bcd8739ae039;

});

parcelRegister("lUh1d", function(module, exports) {
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $42omo = parcelRequire("42omo");

const $30de6a1f90cac3ee$var$batchQueue = new Map();
const $30de6a1f90cac3ee$var$batchTimeouts = new Map();
const $30de6a1f90cac3ee$var$BATCH_DELAY = 250;
const $30de6a1f90cac3ee$var$executeBatch = (hostname)=>{
    const items = $30de6a1f90cac3ee$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $30de6a1f90cac3ee$var$batchQueue.delete(hostname);
    $30de6a1f90cac3ee$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $30de6a1f90cac3ee$var$addToBatch = (hostname, item)=>{
    if (!$30de6a1f90cac3ee$var$batchQueue.has(hostname)) $30de6a1f90cac3ee$var$batchQueue.set(hostname, []);
    $30de6a1f90cac3ee$var$batchQueue.get(hostname).push(item);
    if ($30de6a1f90cac3ee$var$batchTimeouts.has(hostname)) clearTimeout($30de6a1f90cac3ee$var$batchTimeouts.get(hostname));
    $30de6a1f90cac3ee$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $30de6a1f90cac3ee$var$executeBatch(hostname);
    }, $30de6a1f90cac3ee$var$BATCH_DELAY));
};
const $30de6a1f90cac3ee$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $42omo.useRef)(false);
    const scheduledRegister = (0, $42omo.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $30de6a1f90cac3ee$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};
module.exports["useScheduledRegister"] = $30de6a1f90cac3ee$export$db80d61271e4d5af;

});

parcelRegister("g6cf7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $13849139a87405b6$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $13849139a87405b6$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $13849139a87405b6$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $13849139a87405b6$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    return hasSmartCardProvider && $13849139a87405b6$export$aa45d36a96427452(href);
};
var $13849139a87405b6$export$2e2bcd8739ae039 = $13849139a87405b6$var$useResolveHyperlinkValidator;
module.exports["default"] = $13849139a87405b6$export$2e2bcd8739ae039;

});

parcelRegister("8jBuy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

/**
 * HOC to wrap component with IntlProvider if not available
 */ const $255ccdc0ab7e7f63$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
        return props?.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
            locale: "en"
        }, content);
    };
var $255ccdc0ab7e7f63$export$2e2bcd8739ae039 = $255ccdc0ab7e7f63$var$withIntlProvider;
module.exports["default"] = $255ccdc0ab7e7f63$export$2e2bcd8739ae039;

});

parcelRegister("055M6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $afp1H = parcelRequire("afp1H");


var $7Vxvp = parcelRequire("7Vxvp");


var $18ASy = parcelRequire("18ASy");

const $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView = ({ onAuthorize: onAuthorize, provider: provider, showConnectBtn: showConnectBtn, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18ASy.default), props), showConnectBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
        onClick: onAuthorize,
        testId: "button-connect-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: provider?.text
        }
    }))));
};
var $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039 = $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView;
module.exports["default"] = $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039;

});

parcelRegister("jUMCq", function(module, exports) {
$parcel$export(module.exports, "default", () => $edc36e514c97f3fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");


var $eEA8O = parcelRequire("eEA8O");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $afp1H = parcelRequire("afp1H");

const $edc36e514c97f3fa$var$breakWordsCss = null;
const $edc36e514c97f3fa$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).check_this_link))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).go_back)), /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $42omo.createElement((0, $1e2E5.default), {
        locale: "en"
    }, content);
};
var $edc36e514c97f3fa$export$2e2bcd8739ae039 = (0, $gmMgo.default)($edc36e514c97f3fa$var$WarningModal, {
    enforceContext: false
});

});

parcelRegister("lKhNz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $l3dur = parcelRequire("l3dur");


var $lgqac = parcelRequire("lgqac");

const $83b01bdf128d776a$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $83b01bdf128d776a$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $42omo.useState)(null);
    const [url, setUrl] = (0, $42omo.useState)(null);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $l3dur.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $83b01bdf128d776a$var$toUrl(href, window.location.origin);
        const linkTextUrl = $83b01bdf128d776a$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};
module.exports["useLinkWarningModal"] = $83b01bdf128d776a$export$32b76c003683c2ec;

});

parcelRegister("l3dur", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $2Gb84 = parcelRequire("2Gb84");

const $8a7492fb362aaff8$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
$8a7492fb362aaff8$var$linkify.add('sourcetree:', 'http:');
$8a7492fb362aaff8$var$linkify.add('jamfselfservice:', 'http:');
$8a7492fb362aaff8$var$linkify.add('notes:', 'http:');
const $8a7492fb362aaff8$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8a7492fb362aaff8$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8a7492fb362aaff8$var$tlds.push($8a7492fb362aaff8$var$tlds2Char);
$8a7492fb362aaff8$var$linkify.tlds($8a7492fb362aaff8$var$tlds, false);
const $8a7492fb362aaff8$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8a7492fb362aaff8$var$normaliseLinkHref = (url)=>{
    const match = $8a7492fb362aaff8$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8a7492fb362aaff8$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8a7492fb362aaff8$var$linkifyMatch(str);
    if (!match.length) match = $8a7492fb362aaff8$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8a7492fb362aaff8$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8a7492fb362aaff8$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8a7492fb362aaff8$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8a7492fb362aaff8$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8a7492fb362aaff8$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8a7492fb362aaff8$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8a7492fb362aaff8$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8a7492fb362aaff8$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8a7492fb362aaff8$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8a7492fb362aaff8$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["isSafeUrl"] = $8a7492fb362aaff8$export$c9f92f5469372e0f;
module.exports["normalizeUrl"] = $8a7492fb362aaff8$export$6535eb414fa2c8b6;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("7HI7Y", function(module, exports) {
$parcel$export(module.exports, "merge", () => $59bec75d4837f566$export$4950aa0f605343fb, (v) => $59bec75d4837f566$export$4950aa0f605343fb = v);
var $59bec75d4837f566$export$4950aa0f605343fb;
"use strict";

var $YgydF = parcelRequire("YgydF");


var $HHFyQ = parcelRequire("HHFyQ");


var $5Dgek = parcelRequire("5Dgek");


var $kQ0lo = parcelRequire("kQ0lo");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $59bec75d4837f566$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($5Dgek.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $YgydF.Observable) return observables[0];
    return $kQ0lo.mergeAll(concurrent)(new $HHFyQ.ArrayObservable(observables, scheduler));
}
$59bec75d4837f566$export$4950aa0f605343fb = $59bec75d4837f566$var$merge;

});

parcelRegister("kQ0lo", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $f2b8ee495d9150ab$export$18aef43295bbe906, (v) => $f2b8ee495d9150ab$export$18aef43295bbe906 = v);
var $f2b8ee495d9150ab$export$18aef43295bbe906;
"use strict";

var $XrDsM = parcelRequire("XrDsM");


var $hsCka = parcelRequire("hsCka");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $f2b8ee495d9150ab$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $XrDsM.mergeMap($hsCka.identity, null, concurrent);
}
$f2b8ee495d9150ab$export$18aef43295bbe906 = $f2b8ee495d9150ab$var$mergeAll;

});

parcelRegister("hsCka", function(module, exports) {
$parcel$export(module.exports, "identity", () => $cb62c79807c8a85d$export$f0954fd7d5368655, (v) => $cb62c79807c8a85d$export$f0954fd7d5368655 = v);
var $cb62c79807c8a85d$export$f0954fd7d5368655;
"use strict";
function $cb62c79807c8a85d$var$identity(x) {
    return x;
}
$cb62c79807c8a85d$export$f0954fd7d5368655 = $cb62c79807c8a85d$var$identity;

});

parcelRegister("alaek", function(module, exports) {
$parcel$export(module.exports, "default", () => $21bae01687242d76$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $6fnsQ = parcelRequire("6fnsQ");


var $cmDjE = parcelRequire("cmDjE");

const $21bae01687242d76$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`;
const $21bae01687242d76$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $6fnsQ.N90)})`;
function $21bae01687242d76$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cmDjE.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
}

});

parcelRegister("cmDjE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5P3yi = parcelRequire("5P3yi");


var $f2BEc = parcelRequire("f2BEc");

const $bdf91181004cdb95$var$boxShadowCssVar = '--avatar-box-shadow';
const $bdf91181004cdb95$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $bdf91181004cdb95$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $bdf91181004cdb95$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $bdf91181004cdb95$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $bdf91181004cdb95$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $bdf91181004cdb95$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $bdf91181004cdb95$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $bdf91181004cdb95$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    const avatarSrc = (0, $f2BEc.getTeamAvatarSrc)(src, teamId); // If src changes, reset state
    (0, $42omo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5P3yi.FallbackAvatar), {
        "aria-label": alt,
        width: $bdf91181004cdb95$var$SIZES[size],
        height: $bdf91181004cdb95$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $gMc0m.default)([
            $bdf91181004cdb95$var$unboundStyles.root,
            $bdf91181004cdb95$var$containerStyles.root,
            $bdf91181004cdb95$var$borderRadiusMap[size],
            $bdf91181004cdb95$var$widthHeightMap[size],
            compact ? $bdf91181004cdb95$var$containerStyles.compactSpacing : $bdf91181004cdb95$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $gMc0m.default)([
                $bdf91181004cdb95$var$avatarImageStyles.image
            ])
        })
    });
};
module.exports["TeamAvatarImage"] = $bdf91181004cdb95$export$ac3673635a5387be;

});

parcelRegister("5P3yi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $2cfa1b514c8db58a$var$styles = {
    wrapper: "_1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $2cfa1b514c8db58a$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($2cfa1b514c8db58a$var$styles.wrapper, props.compact ? $2cfa1b514c8db58a$var$styles.compactWrapperSpacing : $2cfa1b514c8db58a$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}
module.exports["FallbackAvatar"] = $2cfa1b514c8db58a$export$eb63dcc490f6bbcd;

});

parcelRegister("f2BEc", function(module, exports) {
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $e75bf44959780d0d$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}
module.exports["getTeamAvatarSrc"] = $e75bf44959780d0d$export$59ff7d19feb890b6;

});

parcelRegister("eVpDl", function(module, exports) {
"use strict";
var $adda45daebf3b6ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $adda45daebf3b6ff$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $adda45daebf3b6ff$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $adda45daebf3b6ff$var$filter;
var $adda45daebf3b6ff$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adda45daebf3b6ff$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adda45daebf3b6ff$var$FilterSubscriber = function(_super) {
    $adda45daebf3b6ff$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($axeml.Subscriber);

});

parcelRegister("kXEyd", function(module, exports) {
"use strict";
var $f428c5e2ee2b390f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $f428c5e2ee2b390f$var$take(count) {
    return function(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $f428c5e2ee2b390f$var$TakeOperator(count));
    };
}
module.exports.take = $f428c5e2ee2b390f$var$take;
var $f428c5e2ee2b390f$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f428c5e2ee2b390f$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f428c5e2ee2b390f$var$TakeSubscriber = function(_super) {
    $f428c5e2ee2b390f$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("2g0GA", function(module, exports) {
"use strict";
var $1a4d9b96869ee1a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError = function(_super) {
    $1a4d9b96869ee1a1$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError;

});

parcelRegister("1Ria2", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $15a8d410ba774044$export$45b10814cc054894, (v) => $15a8d410ba774044$export$45b10814cc054894 = v);
var $15a8d410ba774044$export$45b10814cc054894;
"use strict";

var $244gB = parcelRequire("244gB");

function $15a8d410ba774044$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $15a8d410ba774044$var$toArray() {
    return $244gB.reduce($15a8d410ba774044$var$toArrayReducer, []);
}
$15a8d410ba774044$export$45b10814cc054894 = $15a8d410ba774044$var$toArray;

});

parcelRegister("244gB", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $180f43c63924c6e6$export$533b26079ad0b4b, (v) => $180f43c63924c6e6$export$533b26079ad0b4b = v);
var $180f43c63924c6e6$export$533b26079ad0b4b;
"use strict";

var $kiSup = parcelRequire("kiSup");


var $ib5HR = parcelRequire("ib5HR");


var $avZwt = parcelRequire("avZwt");


var $5wWzN = parcelRequire("5wWzN");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $180f43c63924c6e6$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $5wWzN.pipe($kiSup.scan(accumulator, seed), $ib5HR.takeLast(1), $avZwt.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $5wWzN.pipe($kiSup.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $ib5HR.takeLast(1))(source);
    };
}
$180f43c63924c6e6$export$533b26079ad0b4b = $180f43c63924c6e6$var$reduce;

});

parcelRegister("kiSup", function(module, exports) {
"use strict";
var $ec7fc18d41270381$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $ec7fc18d41270381$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $ec7fc18d41270381$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $ec7fc18d41270381$var$scan;
var $ec7fc18d41270381$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ec7fc18d41270381$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ec7fc18d41270381$var$ScanSubscriber = function(_super) {
    $ec7fc18d41270381$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ib5HR", function(module, exports) {
"use strict";
var $d3bdae4589ae3cf1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $d3bdae4589ae3cf1$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $d3bdae4589ae3cf1$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $d3bdae4589ae3cf1$var$takeLast;
var $d3bdae4589ae3cf1$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d3bdae4589ae3cf1$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d3bdae4589ae3cf1$var$TakeLastSubscriber = function(_super) {
    $d3bdae4589ae3cf1$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("avZwt", function(module, exports) {
"use strict";
var $7a7c85c9732247d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $7a7c85c9732247d4$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $7a7c85c9732247d4$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $7a7c85c9732247d4$var$defaultIfEmpty;
var $7a7c85c9732247d4$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a7c85c9732247d4$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a7c85c9732247d4$var$DefaultIfEmptySubscriber = function(_super) {
    $7a7c85c9732247d4$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($axeml.Subscriber);

});

parcelRegister("hu8We", function(module, exports) {
$parcel$export(module.exports, "of", () => $cbac2bf0af029aab$export$ba255e9e49e00608, (v) => $cbac2bf0af029aab$export$ba255e9e49e00608 = v);
var $cbac2bf0af029aab$export$ba255e9e49e00608;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");

$cbac2bf0af029aab$export$ba255e9e49e00608 = $HHFyQ.ArrayObservable.of;

});

parcelRegister("fulrs", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteDelay = $kVeeY.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($6j5QO.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($6j5QO.Notification.createComplete());
    };
    return DelaySubscriber;
}($axeml.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("3u6GG", function(module, exports) {
$parcel$export(module.exports, "async", () => $28995c6d2039be6b$export$12af436354f1a4f7, (v) => $28995c6d2039be6b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $28995c6d2039be6b$export$12af436354f1a4f7;
"use strict";

var $k8JsH = parcelRequire("k8JsH");


var $iOeLv = parcelRequire("iOeLv");

$28995c6d2039be6b$export$12af436354f1a4f7 = new $iOeLv.AsyncScheduler($k8JsH.AsyncAction);

});

parcelRegister("kVeeY", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f3b42d67f4ad5339$export$871608497c498473, (v) => $f3b42d67f4ad5339$export$871608497c498473 = v);
var $f3b42d67f4ad5339$export$871608497c498473;
"use strict";
function $f3b42d67f4ad5339$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f3b42d67f4ad5339$export$871608497c498473 = $f3b42d67f4ad5339$var$isDate;

});

parcelRegister("7soXU", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $grxv4 = parcelRequire("grxv4");


var $3rvSa = parcelRequire("3rvSa");

const $9f89bc087ab3777e$export$9f7977d4a2561bee = (Component)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
        const mediaClient = (0, $42omo.useMemo)(()=>existingMediaClient ?? (0, $grxv4.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Provider, {
            value: mediaClient,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaClient
            })
        });
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        }));
module.exports["withMediaClient"] = $9f89bc087ab3777e$export$9f7977d4a2561bee;

});

parcelRegister("3rvSa", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");

const $1c0162128aea5b38$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $1c0162128aea5b38$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1c0162128aea5b38$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};
module.exports["MediaClientContext"] = $1c0162128aea5b38$export$ba5d7212f2b4619f;
module.exports["MediaClientProvider"] = $1c0162128aea5b38$export$5bff351c86f56d97;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("3BZZG", function(module, exports) {
const $b77837f445efd10f$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b77837f445efd10f$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b77837f445efd10f$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b77837f445efd10f$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b77837f445efd10f$export$d87a47989c00f322;
    if (appearance === 'square') return $b77837f445efd10f$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b77837f445efd10f$export$aeb48196afcd236a;
    return $b77837f445efd10f$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $b77837f445efd10f$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $b77837f445efd10f$export$ed7b8a4728e9c63;

});

parcelRegister("7bPHJ", function(module, exports) {
const $f5d20cba8da3e43a$export$ec1779cb96554e1 = 'media';
module.exports["ANALYTICS_MEDIA_CHANNEL"] = $f5d20cba8da3e43a$export$ec1779cb96554e1;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("hc71J", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $484fceb19a2d8a9d$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $484fceb19a2d8a9d$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $484fceb19a2d8a9d$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $484fceb19a2d8a9d$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $484fceb19a2d8a9d$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $484fceb19a2d8a9d$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $484fceb19a2d8a9d$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain' && (0, $dh538.fg)('platform_media-default-code-viewer-for-plain-text')) return 'text';
            return null;
    }
}
module.exports["getExtension"] = $484fceb19a2d8a9d$export$78d71f9ed5534abe;
module.exports["isCodeViewerItem"] = $484fceb19a2d8a9d$export$bb139b46f345ca28;
module.exports["getLanguageType"] = $484fceb19a2d8a9d$export$ba4368c844580f9e;

});

parcelRegister("2nsxJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");

function $d27af5912c8c4782$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const fileState = (0, $i2CQL.useMediaStore)((state)=>state.files[id]);
    (0, $42omo.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}
module.exports["useFileState"] = $d27af5912c8c4782$export$90ff537b0999afb;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("i2CQL", function(module, exports) {

var $equi6 = parcelRequire("equi6");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $equi6.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("equi6", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $a80afd8c2b9b4a58$export$6ccbb43953eebf8);

var $l7KxQ = parcelRequire("l7KxQ");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $a80afd8c2b9b4a58$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $a80afd8c2b9b4a58$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = false;
const $a80afd8c2b9b4a58$var$identity = (arg)=>arg;
function $a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector = $a80afd8c2b9b4a58$var$identity, equalityFn) {
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$a80afd8c2b9b4a58$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = true;
    }
    const slice = $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $a80afd8c2b9b4a58$var$useDebugValue(slice);
    return slice;
}
const $a80afd8c2b9b4a58$var$createImpl = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $l7KxQ.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $a80afd8c2b9b4a58$export$185802fd694ee1f5 = (createState)=>createState ? $a80afd8c2b9b4a58$var$createImpl(createState) : $a80afd8c2b9b4a58$var$createImpl;
var $a80afd8c2b9b4a58$export$2e2bcd8739ae039 = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $a80afd8c2b9b4a58$export$185802fd694ee1f5(createState);
};

});

parcelRegister("8QL6C", function(module, exports) {

var $6mxnm = parcelRequire("6mxnm");


var $hMBjV = parcelRequire("hMBjV");


var $78fzv = parcelRequire("78fzv");

const $586e61da7604bdbd$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $586e61da7604bdbd$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hMBjV.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $6mxnm.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $586e61da7604bdbd$export$836625761e76d373 = {
    mediaInline: false
};
function $586e61da7604bdbd$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $78fzv.getGenericFeatureFlag)(flagName, $586e61da7604bdbd$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $586e61da7604bdbd$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $586e61da7604bdbd$export$383e8f51978266d;

});

parcelRegister("6mxnm", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $6b97f3fad80b5910$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $6b97f3fad80b5910$export$2db74afa1ef496f1;

});

parcelRegister("hMBjV", function(module, exports) {
const $d17c6572fbd16cff$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $d17c6572fbd16cff$export$189fe120be7e73fc = ()=>$d17c6572fbd16cff$var$productKeys;
module.exports["getProductKeys"] = $d17c6572fbd16cff$export$189fe120be7e73fc;

});

parcelRegister("78fzv", function(module, exports) {

var $bcpPc = parcelRequire("bcpPc");

function $18475707c4faede4$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $bcpPc.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $18475707c4faede4$export$f2687d0de19e4973;

});

parcelRegister("bcpPc", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $6c56cea62b261d1c$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $6c56cea62b261d1c$export$d125817a2695dbc9;

});

parcelRegister("21oLb", function(module, exports) {
const $fc8b4ffdd5763df8$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $fc8b4ffdd5763df8$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $fc8b4ffdd5763df8$export$43142f95b8de7a91 = (orientation)=>{
    return $fc8b4ffdd5763df8$var$ORIENT_TRANSFORMS[orientation];
};
module.exports["isRotated"] = $fc8b4ffdd5763df8$export$8af433705f41088f;
module.exports["getCssFromImageOrientation"] = $fc8b4ffdd5763df8$export$43142f95b8de7a91;

});

parcelRegister("6YcJ1", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");


var $5kpUJ = parcelRequire("5kpUJ");


var $a6JW6 = parcelRequire("a6JW6");


var $21oLb = parcelRequire("21oLb");

const { Orientation: $42560c37dcf792ae$var$Orientation, XResolution: $42560c37dcf792ae$var$XResolution } = (0, $ek6ZB.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $42560c37dcf792ae$var$DPI_WEB_BASELINE = 72;
async function $42560c37dcf792ae$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $42560c37dcf792ae$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $42560c37dcf792ae$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $42560c37dcf792ae$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $42560c37dcf792ae$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $42560c37dcf792ae$var$DPI_WEB_BASELINE;
        else return $42560c37dcf792ae$export$268f92356524130b(tags, $42560c37dcf792ae$var$XResolution, $42560c37dcf792ae$var$DPI_WEB_BASELINE) / $42560c37dcf792ae$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $42560c37dcf792ae$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$42560c37dcf792ae$var$Orientation]) {
        const tagValue = tags[$42560c37dcf792ae$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $ek6ZB.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $42560c37dcf792ae$export$67689507e8404821(file) {
    const tags = await (0, $5kpUJ.readImageMetaTags)(file);
    return $42560c37dcf792ae$var$getOrientationFromTags(tags);
}
function $42560c37dcf792ae$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $42560c37dcf792ae$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $42560c37dcf792ae$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5kpUJ.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $42560c37dcf792ae$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $42560c37dcf792ae$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $a6JW6.loadImage)(src);
        const { width: width, height: height } = (0, $a6JW6.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}
module.exports["getImageInfo"] = $42560c37dcf792ae$export$2176b0e68c10508f;
module.exports["getOrientation"] = $42560c37dcf792ae$export$67689507e8404821;

});

parcelRegister("ek6ZB", function(module, exports) {
var $8a97053409898982$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8a97053409898982$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8a97053409898982$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};
module.exports["ImageType"] = $8a97053409898982$export$48c85e6e32ef0825;
module.exports["SupportedImageMetaTag"] = $8a97053409898982$export$e369bb48cf33e564;
module.exports["ExifOrientation"] = $8a97053409898982$export$f6ea0c89fd7d156;

});

parcelRegister("5kpUJ", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");


var $gg2Io = parcelRequire("gg2Io");


var $284pz = parcelRequire("284pz");


var $joOsL = parcelRequire("joOsL");

async function $291ad249ab0ec7e3$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $ek6ZB.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $284pz.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $joOsL.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $ek6ZB.ImageType).JPEG) return await (0, $gg2Io.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}
module.exports["readImageMetaTags"] = $291ad249ab0ec7e3$export$41982b5c7acb23c4;

});

parcelRegister("gg2Io", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");

const { XResolution: $b1cf2398fd086f5b$var$XResolution, YResolution: $b1cf2398fd086f5b$var$YResolution } = (0, $ek6ZB.SupportedImageMetaTag);
let $b1cf2398fd086f5b$var$loadImage;

function $b1cf2398fd086f5b$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$b1cf2398fd086f5b$var$loadImage) {
            const module = await (parcelRequire("8vQIW"));
            $b1cf2398fd086f5b$var$loadImage = module.default || module;
        }
        $b1cf2398fd086f5b$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $b1cf2398fd086f5b$var$XResolution || key === $b1cf2398fd086f5b$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}
module.exports["readJPEGExifMetaData"] = $b1cf2398fd086f5b$export$556b2ccec62d7f2a;

});

parcelRegister("8vQIW", function(module, exports) {

let $632a1dd47094042d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $632a1dd47094042d$var$load("b8BDn").then(()=>parcelRequire('6fuwe'));

});

parcelRegister("284pz", function(module, exports) {

var $a6JW6 = parcelRequire("a6JW6");

let $0075b80fbc950777$var$pngChunksExtract;

async function $0075b80fbc950777$export$5fb37736440fca6f(file) {
    if (!$0075b80fbc950777$var$pngChunksExtract) {
        const module = await (parcelRequire("9MxN8"));
        $0075b80fbc950777$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $a6JW6.fileToArrayBuffer)(file);
    const chunks = $0075b80fbc950777$var$pngChunksExtract(buffer);
    return await $0075b80fbc950777$export$9185743fdd58ce45(chunks);
}
async function $0075b80fbc950777$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}
module.exports["readPNGXMPMetaData"] = $0075b80fbc950777$export$5fb37736440fca6f;

});

parcelRegister("a6JW6", function(module, exports) {

var $lzyQK = parcelRequire("lzyQK");


var $b4DX7 = parcelRequire("b4DX7");


var $dfQbH = parcelRequire("dfQbH");


var $lkBga = parcelRequire("lkBga");


var $9AnKp = parcelRequire("9AnKp");


var $d77HU = parcelRequire("d77HU");


var $4dLYc = parcelRequire("4dLYc");


var $5W6v1 = parcelRequire("5W6v1");


var $av4P2 = parcelRequire("av4P2");


var $giYeH = parcelRequire("giYeH");


var $eWLPt = parcelRequire("eWLPt");


var $gH8Rx = parcelRequire("gH8Rx");


var $iFCP2 = parcelRequire("iFCP2");


var $cQbj1 = parcelRequire("cQbj1");


var $7t8Pn = parcelRequire("7t8Pn");


var $hc71J = parcelRequire("hc71J");

function $a344fc5ee1d7372a$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $a344fc5ee1d7372a$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $a344fc5ee1d7372a$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $a344fc5ee1d7372a$export$849633012686f7ee(file)
    };
}
async function $a344fc5ee1d7372a$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $a344fc5ee1d7372a$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $a344fc5ee1d7372a$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $a344fc5ee1d7372a$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $a344fc5ee1d7372a$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $a344fc5ee1d7372a$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $a344fc5ee1d7372a$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($av4P2)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eWLPt)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($av4P2)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($giYeH)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5W6v1)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cQbj1)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFCP2)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    }
];
function $a344fc5ee1d7372a$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $a344fc5ee1d7372a$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $hc71J.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9AnKp)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d77HU)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4dLYc)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}
module.exports["dataURItoFile"] = $a344fc5ee1d7372a$export$80d19edb7b1ae293;
module.exports["fileToDataURI"] = $a344fc5ee1d7372a$export$849633012686f7ee;
module.exports["getFileInfo"] = $a344fc5ee1d7372a$export$ca39f27fe4f7d9b4;
module.exports["fileToArrayBuffer"] = $a344fc5ee1d7372a$export$956310555b96755a;
module.exports["loadImage"] = $a344fc5ee1d7372a$export$fe58198efe02b173;
module.exports["readImageNaturalOrientationFromDOM"] = $a344fc5ee1d7372a$export$325d46491952db2d;
module.exports["findParentByClassname"] = $a344fc5ee1d7372a$export$89ff65f1d45dfb03;
module.exports["getMimeIcon"] = $a344fc5ee1d7372a$export$61a1de0822e2820;

});

parcelRegister("d77HU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $98c1e84a3b388e2b$var$_react = $98c1e84a3b388e2b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $98c1e84a3b388e2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $98c1e84a3b388e2b$var$Figma24Icon = (props)=>/*#__PURE__*/ $98c1e84a3b388e2b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$98c1e84a3b388e2b$var$Figma24Icon.displayName = 'Figma24Icon';
var $98c1e84a3b388e2b$var$_default = module.exports.default = $98c1e84a3b388e2b$var$Figma24Icon;

});

parcelRegister("9MxN8", function(module, exports) {

let $71f2cf053b480bb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71f2cf053b480bb9$var$load("dLFEp").then(()=>parcelRequire('ahNRS'));

});

parcelRegister("joOsL", function(module, exports) {
function $2efab4fabe8932ef$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}
module.exports["parseXMPMetaData"] = $2efab4fabe8932ef$export$55c3bc9841b19de2;

});

parcelRegister("aWYXa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gxsT9 = parcelRequire("gxsT9");


var $cbc8g = parcelRequire("cbc8g");


var $2wyC2 = parcelRequire("2wyC2");


var $21oLb = parcelRequire("21oLb");


var $iP9n7 = parcelRequire("iP9n7");

const $e496909ca63f7b47$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $42omo.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $42omo.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $42omo.useState)(false);
    const imgRef = (0, $42omo.useRef)(null);
    const imageRef = (0, $42omo.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $21oLb.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $21oLb.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
        data: {
            hasMediaComponent: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2wyC2.ImageComponent), {
        loading: loading,
        "data-testid": "media-image",
        "data-vc": "media-image",
        draggable: false,
        alt: alt,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onLoad: imageLoadHandler,
        onError: onImageError,
        imageRef: mergedRef,
        src: dataURI,
        crossOrigin: crossOrigin,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }));
});
module.exports["MediaImage"] = $e496909ca63f7b47$export$1f97dc1e9d072692;

});

parcelRegister("2wyC2", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $42omo = parcelRequire("42omo");

/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $a49532cd1c66edc2$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $a49532cd1c66edc2$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlassian/a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$a49532cd1c66edc2$var$imgStyle,
            ...style
        }
    }));
};
module.exports["ImageComponent"] = $a49532cd1c66edc2$export$fd536c918b58ab76;

});

parcelRegister("k0QVR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");

var $dIgeg = parcelRequire("dIgeg");


var $hXlr4 = parcelRequire("hXlr4");

var $2nsxJ = parcelRequire("2nsxJ");

var $jRNsq = parcelRequire("jRNsq");


var $JXmwv = parcelRequire("JXmwv");


var $dh538 = parcelRequire("dh538");


var $9x4nt = parcelRequire("9x4nt");


var $fgSvy = parcelRequire("fgSvy");


var $cCL2U = parcelRequire("cCL2U");


var $kJP4J = parcelRequire("kJP4J");

var $2dkDS = parcelRequire("2dkDS");

var $gL31c = parcelRequire("gL31c");


var $CPDDv = parcelRequire("CPDDv");

var $dXMn6 = parcelRequire("dXMn6");


var $hNBEk = parcelRequire("hNBEk");

// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $24cb43d67162c399$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $24cb43d67162c399$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const [status, setStatus] = (0, $42omo.useState)('loading');
    const [error, setError] = (0, $42omo.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $42omo.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $42omo.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $42omo.useState)('not-resolved');
    const ssrReliabilityRef = (0, $42omo.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (isLoading && (0, $dh538.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $42omo.useMemo)(()=>dimensions ? (0, $hNBEk.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $hNBEk.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $gL31c.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $dXMn6.getSSRData)(identifier, resizeMode);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $kJP4J.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $fgSvy.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet
                };
            }
        }
    };
    const [preview, setPreview] = (0, $42omo.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $2nsxJ.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $hZ6O7.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $42omo.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $42omo.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $cCL2U.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $cCL2U.MediaFilePreviewError)('metadata-fetch', (0, $dIgeg.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (0, $dXMn6.getSSRData)(identifier, resizeMode)?.loadPromise;
        if (preview && (0, $kJP4J.isSSRDataPreview)(preview) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $hNBEk.useCurrentValueRef)(()=>{
        return (0, $kJP4J.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $42omo.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $hNBEk.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $hNBEk.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $42omo.useEffect)(()=>{
        const cachedPreview = (0, $gL31c.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $hNBEk.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $2dkDS.isSupportedLocalPreview)(mediaType) && (0, $JXmwv.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $kJP4J.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $hNBEk.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $kJP4J.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            if (preview && (0, $kJP4J.isSSRPreview)(preview) && (0, $dh538.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $cCL2U.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $42omo.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $kJP4J.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext);
        const isSSR = (0, $kJP4J.isSSRDataPreview)(failedPreview) || ((0, $dh538.fg)('jfp-magma-fix-failed-ssr-preview-load') ? (0, $kJP4J.isSSRClientPreview)(failedPreview) : false);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) {
            ssrReliabilityRef.current.server = (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $kJP4J.isLocalPreview)(failedPreview);
        const isRemote = (0, $kJP4J.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $cCL2U.ImageLoadError)(failedPreview?.source);
            (0, $gL31c.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $42omo.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $kJP4J.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $kJP4J.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $CPDDv.generateScriptProps)(identifier, preview?.dataURI, resizeMode, preview?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $dh538.fg)('media-perf-uplift-mutation-fix')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $hXlr4.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $dh538.fg)('media-perf-uplift-mutation-fix') ? $24cb43d67162c399$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};
module.exports["useFilePreview"] = $24cb43d67162c399$export$4eaebdef02112fe4;

});

parcelRegister("hXlr4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $jRNsq = parcelRequire("jRNsq");


var $c5usV = parcelRequire("c5usV");


var $fLL9S = parcelRequire("fLL9S");

function $cc642dccb112c2b8$var$useCurrentValueRef(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
const $cc642dccb112c2b8$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const innerRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const registerCopyIntentRef = $cc642dccb112c2b8$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $c5usV.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $c5usV.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $42omo.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $dh538.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $42omo.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_media_cross_client_copy')) (0, $fLL9S.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $fLL9S.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};
module.exports["useCopyIntent"] = $cc642dccb112c2b8$export$46fd859414de9d62;

});

parcelRegister("c5usV", function(module, exports) {

var $2ASLw = parcelRequire("2ASLw");

const $e6e8f319cddd6152$var$getRequestErrorDetails = (err)=>{
    if ((0, $2ASLw.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
    return undefined;
};
const $e6e8f319cddd6152$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $2ASLw.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$e6e8f319cddd6152$var$getRequestErrorDetails(error)
        }
    };
};
const $e6e8f319cddd6152$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};
module.exports["getCopyIntentErrorPayload"] = $e6e8f319cddd6152$export$3ab52330b662b987;
module.exports["getCopyIntentSuccessPayload"] = $e6e8f319cddd6152$export$aacb463551da2e8f;

});

parcelRegister("fLL9S", function(module, exports) {
const $88290e8f8b3102b1$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};
module.exports["getDocument"] = $88290e8f8b3102b1$export$f65ca476c09acec0;

});

parcelRegister("fgSvy", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");


var $cCL2U = parcelRequire("cCL2U");

const $2de7fc98fb618862$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $2de7fc98fb618862$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $2de7fc98fb618862$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $2de7fc98fb618862$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $2de7fc98fb618862$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $2de7fc98fb618862$export$4af9d71992e89714(error),
        error: $2de7fc98fb618862$export$88c61dcad53762da(error),
        errorDetail: $2de7fc98fb618862$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $2de7fc98fb618862$export$29aa614726672b2e(error)
    };
};
const $2de7fc98fb618862$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$2de7fc98fb618862$export$74aaf4784c2edb2c(new (0, $cCL2U.ImageLoadError)(preview.source), metadataTraceContext)
    });
module.exports["extractErrorInfo"] = $2de7fc98fb618862$export$74aaf4784c2edb2c;
module.exports["createFailedSSRObject"] = $2de7fc98fb618862$export$768c370ed0dbaeb3;

});

parcelRegister("cCL2U", function(module, exports) {
class $3c049ab9f06e4fad$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $3c049ab9f06e4fad$export$2c035820a31723e extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $3c049ab9f06e4fad$export$10ab445310d30114 extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $3c049ab9f06e4fad$export$18e89b7e50818288 extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $3c049ab9f06e4fad$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $3c049ab9f06e4fad$export$d0a45ab59b4606b extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(source){
        super($3c049ab9f06e4fad$var$getImageLoadPrimaryReason(source));
    }
}
function $3c049ab9f06e4fad$export$553696a6e769784c(err) {
    return err instanceof $3c049ab9f06e4fad$export$96e559194c287cf4;
}
const $3c049ab9f06e4fad$export$b380593ba3516c6f = (err)=>err instanceof $3c049ab9f06e4fad$export$2c035820a31723e;
const $3c049ab9f06e4fad$export$e1d87830b3784f94 = (err)=>err instanceof $3c049ab9f06e4fad$export$10ab445310d30114;
const $3c049ab9f06e4fad$export$443aeb298d35d79d = (err)=>$3c049ab9f06e4fad$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $3c049ab9f06e4fad$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($3c049ab9f06e4fad$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $3c049ab9f06e4fad$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $3c049ab9f06e4fad$export$96e559194c287cf4(primaryReason, error);
};
module.exports["MediaFilePreviewError"] = $3c049ab9f06e4fad$export$96e559194c287cf4;
module.exports["LocalPreviewError"] = $3c049ab9f06e4fad$export$2c035820a31723e;
module.exports["RemotePreviewError"] = $3c049ab9f06e4fad$export$10ab445310d30114;
module.exports["SsrPreviewError"] = $3c049ab9f06e4fad$export$18e89b7e50818288;
module.exports["ImageLoadError"] = $3c049ab9f06e4fad$export$d0a45ab59b4606b;
module.exports["ensureMediaFilePreviewError"] = $3c049ab9f06e4fad$export$7156ce7b78b49bd7;

});

parcelRegister("kJP4J", function(module, exports) {

var $Girkv = parcelRequire("Girkv");


var $cCL2U = parcelRequire("cCL2U");


var $gL31c = parcelRequire("gL31c");


var $2dkDS = parcelRequire("2dkDS");

const $8efa99034f89c3f1$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $Girkv.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $gL31c.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $8efa99034f89c3f1$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    return mediaBlobUrlAttrs ? (0, $Girkv.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
};
const $8efa99034f89c3f1$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    try {
        const dataURI = $8efa99034f89c3f1$var$getDataUri(mediaClient, id, params, mediaBlobUrlAttrs);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $8efa99034f89c3f1$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, mediaBlobUrlAttrs);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $cCL2U.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $8efa99034f89c3f1$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $8efa99034f89c3f1$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $8efa99034f89c3f1$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $2dkDS.getRemotePreview)(mediaClient, id, params, traceContext);
    return $8efa99034f89c3f1$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $8efa99034f89c3f1$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $2dkDS.getLocalPreview)(filePreview);
    return $8efa99034f89c3f1$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
module.exports["getSSRPreview"] = $8efa99034f89c3f1$export$faf1c301c59a1bdc;
module.exports["isLocalPreview"] = $8efa99034f89c3f1$export$78ad02c5efc361c9;
module.exports["isRemotePreview"] = $8efa99034f89c3f1$export$87442a14a8a19e0;
module.exports["isSSRClientPreview"] = $8efa99034f89c3f1$export$36aae1afbc0a9661;
module.exports["isSSRDataPreview"] = $8efa99034f89c3f1$export$f366c2c8a792cce6;
module.exports["isSSRPreview"] = $8efa99034f89c3f1$export$dea79d05143ccf4;
module.exports["getAndCacheRemotePreview"] = $8efa99034f89c3f1$export$49721bcc26fb9388;
module.exports["getAndCacheLocalPreview"] = $8efa99034f89c3f1$export$98e935d981c884d;

});

parcelRegister("gL31c", function(module, exports) {

var $2hUgu = parcelRequire("2hUgu");

const $35b59c22b0648810$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $35b59c22b0648810$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $35b59c22b0648810$export$b7e8ee3f7a41459 = new $35b59c22b0648810$export$7b50526c091bb915((0, $2hUgu.createObjectURLCache)());
module.exports["mediaFilePreviewCache"] = $35b59c22b0648810$export$b7e8ee3f7a41459;

});

parcelRegister("2hUgu", function(module, exports) {

var $majy4 = parcelRequire("majy4");


var $9trs7 = parcelRequire("9trs7");

const $0bd1a53c7b384653$export$36d0f9859761643d = 50;
class $0bd1a53c7b384653$var$ExtendedLRUCache extends (0, $9trs7.LRUMap) {
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
    constructor(limit){
        super(limit);
        this.eventEmitter = void 0;
        this.eventEmitter = new (0, $majy4.EventEmitter2)();
    }
}
class $0bd1a53c7b384653$export$75d1c8c9ba1d0773 {
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
    constructor(size){
        this.cache = void 0;
        this.cache = new $0bd1a53c7b384653$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
}
const $0bd1a53c7b384653$export$ba71be67d5c32535 = ()=>new $0bd1a53c7b384653$export$75d1c8c9ba1d0773($0bd1a53c7b384653$export$36d0f9859761643d);
module.exports["createObjectURLCache"] = $0bd1a53c7b384653$export$ba71be67d5c32535;

});

parcelRegister("2dkDS", function(module, exports) {

var $24z7I = parcelRequire("24z7I");


var $6YcJ1 = parcelRequire("6YcJ1");


var $cCL2U = parcelRequire("cCL2U");


var $eyZtk = parcelRequire("eyZtk");

const $706888ba5ac0fb3d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $706888ba5ac0fb3d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $6YcJ1.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $706888ba5ac0fb3d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $eyZtk.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $706888ba5ac0fb3d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $24z7I.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $706888ba5ac0fb3d$var$getImageLocalPreview(value);
            case 'video':
                return $706888ba5ac0fb3d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $cCL2U.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $cCL2U.LocalPreviewError)('local-preview-unsupported');
};
const $706888ba5ac0fb3d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $cCL2U.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};
module.exports["isSupportedLocalPreview"] = $706888ba5ac0fb3d$export$1fa85b75e8662d54;
module.exports["getLocalPreview"] = $706888ba5ac0fb3d$export$3d6ed68e437b8c99;
module.exports["getRemotePreview"] = $706888ba5ac0fb3d$export$bfe20bd01db02b3;

});

parcelRegister("eyZtk", function(module, exports) {
const $5b6ea74f3cda8ff5$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};
module.exports["takeSnapshot"] = $5b6ea74f3cda8ff5$export$4269d30173168e5c;

});

parcelRegister("CPDDv", function(module, exports) {

var $ucbUh = parcelRequire("ucbUh");

const $bd2cdc2cc4d0320a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $bd2cdc2cc4d0320a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $bd2cdc2cc4d0320a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $bd2cdc2cc4d0320a$var$dashed = (param)=>param ? `-${param}` : '';
const $bd2cdc2cc4d0320a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$bd2cdc2cc4d0320a$var$dashed(collectionName)}${$bd2cdc2cc4d0320a$var$dashed(occurrenceKey)}${$bd2cdc2cc4d0320a$var$dashed(resizeMode)}`;
const $bd2cdc2cc4d0320a$export$4310981e0aa4ce67 = (key, paramDataURI, paramMode, paramSrcSet, dimensions, error, featureFlags = {}, globalScope = window)=>{
    const mediaCardSsr = $bd2cdc2cc4d0320a$export$ede93d4564eaa8da(globalScope);
    if (featureFlags['media-perf-uplift-mutation-fix']) {
        const prevData = mediaCardSsr[key];
        const isPreviousImageLarger = prevData?.mode === paramMode && prevData && prevData.dimensions?.width && dimensions?.width && prevData.dimensions.width > dimensions.width;
        const srcSet = isPreviousImageLarger ? prevData?.srcSet : paramSrcSet;
        const dataURI = isPreviousImageLarger ? prevData?.dataURI : paramDataURI;
        const img = script?.parentElement?.querySelector('img');
        if (img && dataURI) img.src = dataURI;
        if (img && srcSet) img.srcset = srcSet;
        const loadPromise = new Promise((resolve, reject)=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            img?.addEventListener('load', ()=>{
                resolve(void 0);
            });
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            img?.addEventListener('error', ()=>{
                reject(new Error('Failed to load image'));
            });
        });
        mediaCardSsr[key] = isPreviousImageLarger ? prevData : {
            dataURI: dataURI,
            dimensions: dimensions,
            error: error,
            srcSet: srcSet,
            loadPromise: loadPromise
        };
    } else mediaCardSsr[key] = {
        dataURI: paramDataURI,
        dimensions: dimensions,
        error: error
    };
};
const $bd2cdc2cc4d0320a$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const functionCall = (0, $ucbUh.printFunctionCall)($bd2cdc2cc4d0320a$export$4310981e0aa4ce67, $bd2cdc2cc4d0320a$export$a47fb462a08de82f(identifier, mode), dataURI, mode, srcSet, dimensions, error, featureFlags);
    return (0, $ucbUh.printScript)([
        $bd2cdc2cc4d0320a$export$ede93d4564eaa8da.toString(),
        $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $bd2cdc2cc4d0320a$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $bd2cdc2cc4d0320a$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });
module.exports["getMediaCardSSR"] = $bd2cdc2cc4d0320a$export$ede93d4564eaa8da;
module.exports["getKey"] = $bd2cdc2cc4d0320a$export$a47fb462a08de82f;
module.exports["generateScriptProps"] = $bd2cdc2cc4d0320a$export$de7c49925e44d75d;

});

parcelRegister("ucbUh", function(module, exports) {
const $728d0f08f4e41c7f$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $728d0f08f4e41c7f$var$printParams = (args)=>args.map((arg)=>$728d0f08f4e41c7f$var$printParam(arg)).join(',');
const $728d0f08f4e41c7f$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$728d0f08f4e41c7f$var$printParams(args)});`;
const $728d0f08f4e41c7f$export$8b902fb69a2f17c1 = (statements)=>`(function(){
			 let script = document.currentScript;
 			 ${statements.join(';')}
			 document.currentScript.remove();
		})();
		`;
module.exports["printFunctionCall"] = $728d0f08f4e41c7f$export$3742967cc82ac85a;
module.exports["printScript"] = $728d0f08f4e41c7f$export$8b902fb69a2f17c1;

});

parcelRegister("dXMn6", function(module, exports) {

var $CPDDv = parcelRequire("CPDDv");

const $f006128302984542$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $CPDDv.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $CPDDv.getKey)(identifier, resizeMode)];
};
module.exports["getSSRData"] = $f006128302984542$export$d3a890b0f7844b6f;

});

parcelRegister("hNBEk", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5debdc9c0997a52e$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $5debdc9c0997a52e$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $5debdc9c0997a52e$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $5debdc9c0997a52e$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $5debdc9c0997a52e$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["isBigger"] = $5debdc9c0997a52e$export$912a00e9a5470d9a;
module.exports["createRequestDimensions"] = $5debdc9c0997a52e$export$3063221e86a58f9;
module.exports["useCurrentValueRef"] = $5debdc9c0997a52e$export$b3e10e1f0fbb71db;

});

parcelRegister("46EIy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cewj5 = parcelRequire("cewj5");


var $6ZDLj = parcelRequire("6ZDLj");


var $dh538 = parcelRequire("dh538");

const $340ce807e864e408$var$DURATION_MIN = 0.5;
const $340ce807e864e408$var$DURATION_MAX = 1.0;
const $340ce807e864e408$var$EXTRA_PADDING = 4;
const $340ce807e864e408$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $340ce807e864e408$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $340ce807e864e408$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $340ce807e864e408$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $340ce807e864e408$var$DURATION_MAX - $340ce807e864e408$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $340ce807e864e408$var$DURATION_MAX), $340ce807e864e408$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $340ce807e864e408$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $340ce807e864e408$var$EXTRA_PADDING) return newOffset - $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $340ce807e864e408$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        if (!(0, $dh538.fg)('platform_editor_disable_trigger_scroll_event')) // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, $340ce807e864e408$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($cewj5)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$340ce807e864e408$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $340ce807e864e408$var$mapReactChildToReactNode(child, index) {
    const key = $340ce807e864e408$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $340ce807e864e408$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $340ce807e864e408$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $340ce807e864e408$export$817db220b90d8024;

});

parcelRegister("cewj5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $8e7fda51b7396b67$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$8e7fda51b7396b67$var$debounce.debounce = $8e7fda51b7396b67$var$debounce;
module.exports = $8e7fda51b7396b67$var$debounce;

});

parcelRegister("6ZDLj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bwcZT = parcelRequire("bwcZT");

const $15c7f4a4aa94e52b$export$924abd21043fc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowLeftWrapper), props);
const $15c7f4a4aa94e52b$export$a5ffe38c17bbc0a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ShadowRight), props);
const $15c7f4a4aa94e52b$export$abf07652016c7e56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowRightWrapper), props);
const $15c7f4a4aa94e52b$export$b39b1b86b48b621f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.LeftArrow), props);
const $15c7f4a4aa94e52b$export$6208675820d4cc50 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.RightArrow), props);
const $15c7f4a4aa94e52b$export$d37eb83491863cbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripViewWrapper), props);
const $15c7f4a4aa94e52b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripList), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$54cfc70c184c0713 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListItem), props);
module.exports["LeftArrow"] = $15c7f4a4aa94e52b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $15c7f4a4aa94e52b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $15c7f4a4aa94e52b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $15c7f4a4aa94e52b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $15c7f4a4aa94e52b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $15c7f4a4aa94e52b$export$54cfc70c184c0713;

});

parcelRegister("bwcZT", function(module, exports) {
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3bV1Q = parcelRequire("3bV1Q");


var $4HvFx = parcelRequire("4HvFx");


var $46EIy = parcelRequire("46EIy");

const $1156f5d5007639c5$var$filmStripViewStyles = null;
const $1156f5d5007639c5$var$filmStripListWrapperStyles = null;
const $1156f5d5007639c5$var$filmStripListStyles = null;
const $1156f5d5007639c5$var$filmStripListItemStyles = null;
const $1156f5d5007639c5$var$arrowWrapperStyles = null;
const $1156f5d5007639c5$var$arrowLeftWrapperStyles = null;
const $1156f5d5007639c5$var$arrowRightWrapperStyles = null;
const $1156f5d5007639c5$var$shadowStyles = null;
const $1156f5d5007639c5$var$shadowLeftStyles = null;
const $1156f5d5007639c5$var$shadowRightStyles = null;
const $1156f5d5007639c5$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ])
    }, children);
const $1156f5d5007639c5$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
const $1156f5d5007639c5$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ])
    }, children);
const $1156f5d5007639c5$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
const $1156f5d5007639c5$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3bV1Q))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $1156f5d5007639c5$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HvFx))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $1156f5d5007639c5$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ])
    }, children);
const $1156f5d5007639c5$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ])
    }, children));
const $1156f5d5007639c5$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ])
    }, children));
const $1156f5d5007639c5$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $1156f5d5007639c5$export$924abd21043fc000;
module.exports["ShadowRight"] = $1156f5d5007639c5$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $1156f5d5007639c5$export$abf07652016c7e56;
module.exports["LeftArrow"] = $1156f5d5007639c5$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $1156f5d5007639c5$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $1156f5d5007639c5$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $1156f5d5007639c5$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $1156f5d5007639c5$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $1156f5d5007639c5$export$54cfc70c184c0713;

});

parcelRegister("aL0VQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");


var $jQCJ9 = parcelRequire("jQCJ9");

const $4cae511015088d55$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
function $4cae511015088d55$export$f91c9e51e5ab027d(ids) {
    const nonErrorFiles = (0, $i2CQL.useMediaStore)((state)=>Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState)));
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const collections = (0, $42omo.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $42omo.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id })=>file.id === id)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $jQCJ9.usePrevious)(files);
    (0, $42omo.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file)=>file && prev.every((prevFile)=>prevFile.id !== file.id || prevFile.status !== file.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file)=>{
            const collectionName = collections[file.id];
            mediaClient.file.getFileState(file.id, {
                collectionName: collectionName,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $42omo.useMemo)(()=>Object.fromEntries(files.map((file)=>[
                file.id,
                file.hash
            ])), [
        files
    ]);
    return hashMap;
}
module.exports["useFileHashes"] = $4cae511015088d55$export$f91c9e51e5ab027d;

});

parcelRegister("jQCJ9", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8227eceacc56cecd$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $8227eceacc56cecd$export$5cae361ad82dce8b;

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("hezkK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $huXH9 = parcelRequire("huXH9");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9yt4X = parcelRequire("9yt4X");


var $4Ve7Q = parcelRequire("4Ve7Q");

const $4efd70df50f13ebd$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $4efd70df50f13ebd$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $4efd70df50f13ebd$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $4efd70df50f13ebd$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "aria-label": label,
        xcss: $4efd70df50f13ebd$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $dh538.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $huXH9.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $huXH9.AVATAR_SIZES)[size]
            } : {}
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $4efd70df50f13ebd$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4efd70df50f13ebd$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "img",
                    xcss: $4efd70df50f13ebd$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $4Ve7Q.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9yt4X.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    size: size
                })
            })
        })
    });
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $4efd70df50f13ebd$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $4efd70df50f13ebd$export$38b71b080e1832c8;

});

parcelRegister("9yt4X", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $huXH9 = parcelRequire("huXH9");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $087487947faf3e7f$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};
const $087487947faf3e7f$var$Observer = ({ onLoad: onLoad })=>{
    (0, $42omo.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $087487947faf3e7f$var$AutoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Jp34")));

const $087487947faf3e7f$var$AutoFixAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iXcnT")));

const $087487947faf3e7f$var$AutoReviewAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aUp1o")));

const $087487947faf3e7f$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3KJ0b")));

const $087487947faf3e7f$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eKuAc")));

const $087487947faf3e7f$var$CultureAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6kpkG")));

const $087487947faf3e7f$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Q4wY")));

const $087487947faf3e7f$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dRCU8")));

const $087487947faf3e7f$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kQTXK")));

const $087487947faf3e7f$var$GenericAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kFBSF")));

const $087487947faf3e7f$var$HireWriterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("44XTS")));

const $087487947faf3e7f$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2SnMt")));

const $087487947faf3e7f$var$MyUserManualAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cXu7g")));

const $087487947faf3e7f$var$OkrOracleAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3EvKg")));

const $087487947faf3e7f$var$OpsAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htmh0")));

const $087487947faf3e7f$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kTVse")));

const $087487947faf3e7f$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("emHN5")));

const $087487947faf3e7f$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9Oxg9")));

const $087487947faf3e7f$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("doqXm")));

const $087487947faf3e7f$var$RovoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k0SSx")));

const $087487947faf3e7f$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kVvzt")));

const $087487947faf3e7f$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Hx38")));

const $087487947faf3e7f$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3v9w9")));
const $087487947faf3e7f$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $087487947faf3e7f$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $087487947faf3e7f$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $087487947faf3e7f$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $087487947faf3e7f$var$colorList = [
    $087487947faf3e7f$export$cf7c9ad03f4a70b2,
    $087487947faf3e7f$export$3e344798f7855e62,
    $087487947faf3e7f$export$a3d0897f023251ae,
    $087487947faf3e7f$export$d933daaf7b69e6ee
];
const $087487947faf3e7f$var$avatarList = [
    $087487947faf3e7f$var$CustomerInsightAvatar,
    $087487947faf3e7f$var$BacklogBuddyAvatar,
    $087487947faf3e7f$var$DecisionDirectorAvatar,
    $087487947faf3e7f$var$CommsCrafterAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$OkrOracleAvatar,
    $087487947faf3e7f$var$CultureAvatar,
    $087487947faf3e7f$var$SocialMediaScribeAvatar,
    $087487947faf3e7f$var$TeamConnectionAvatar,
    $087487947faf3e7f$var$HireWriterAvatar,
    $087487947faf3e7f$var$OpsAgentAvatar,
    $087487947faf3e7f$var$ResearchScoutAvatar,
    $087487947faf3e7f$var$ReleaseNotesAvatar,
    $087487947faf3e7f$var$MyUserManualAvatar,
    $087487947faf3e7f$var$PitchPerfectorAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$AutoFixAvatar,
    $087487947faf3e7f$var$AutoReviewAvatar,
    $087487947faf3e7f$var$MarketingMessageMaestroAvatar,
    $087487947faf3e7f$var$FeatureFlagAvatar,
    $087487947faf3e7f$var$ProductRequirementAvatar
];
const $087487947faf3e7f$export$a834793a4d0d739e = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
const $087487947faf3e7f$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoFixAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MarketingMessageMaestroAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ResearchScoutAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$HireWriterAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$SocialMediaScribeAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$FeatureFlagAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$DecisionDirectorAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ProductRequirementAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$BacklogBuddyAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$WorkflowBuilderAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoReviewAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    }
}; /**
    * agentIdentityAccountId examples:
    * 5b985e7c96cb052b5f65c830
    * 712020:19e57f67-c132-462b-8503-0c19953122cd
    *
    * agentId examples:
    * cd002f25-46e4-4023-80ff-32e4d90849b4
    */ 
const $087487947faf3e7f$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $087487947faf3e7f$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $087487947faf3e7f$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
    //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $087487947faf3e7f$var$ROVO_DEV_AGENT_ID && (0, $dh538.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
    if (typeof agentNamedId === 'string' && $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $087487947faf3e7f$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $087487947faf3e7f$var$colorList.length);
        const colorIndex = combinationIndex % $087487947faf3e7f$var$colorList.length;
        const Avatar = $087487947faf3e7f$var$avatarList[avatarIndex];
        const color = $087487947faf3e7f$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $l998X.jsx)(Avatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$GenericAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
            secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
        }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    };
};
const $087487947faf3e7f$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $087487947faf3e7f$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($087487947faf3e7f$var$styles.banner, fillSpace ? $087487947faf3e7f$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $087487947faf3e7f$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $087487947faf3e7f$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $087487947faf3e7f$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
            fallback: null,
            children: [
                onLoad && /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$Observer, {
                    onLoad: onLoad
                }),
                render
            ]
        })
    });
};
module.exports["AgentBanner"] = $087487947faf3e7f$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $087487947faf3e7f$export$96bb253b7de22616;

});

parcelRegister("1Jp34", function(module, exports) {

let $142d6c869fc93f1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $142d6c869fc93f1c$var$load("c9Qqc").then(()=>parcelRequire('f0XYo'));

});

parcelRegister("iXcnT", function(module, exports) {

let $dcc757fb35de9e43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcc757fb35de9e43$var$load("1TK6P").then(()=>parcelRequire('kdo1N'));

});

parcelRegister("aUp1o", function(module, exports) {

let $7f128b1159aaf0b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f128b1159aaf0b3$var$load("grvAy").then(()=>parcelRequire('1xsEe'));

});

parcelRegister("3KJ0b", function(module, exports) {

let $2bb8937090f7886d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb8937090f7886d$var$load("23K0q").then(()=>parcelRequire('iOx72'));

});

parcelRegister("eKuAc", function(module, exports) {

let $abcd15b4f7a895b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abcd15b4f7a895b0$var$load("3kQkj").then(()=>parcelRequire('5yA7f'));

});

parcelRegister("6kpkG", function(module, exports) {

let $49b842e0f53b0840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49b842e0f53b0840$var$load("6OXgE").then(()=>parcelRequire('40gXx'));

});

parcelRegister("1Q4wY", function(module, exports) {

let $156e297d03d850f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $156e297d03d850f4$var$load("cbucA").then(()=>parcelRequire('e6WCz'));

});

parcelRegister("dRCU8", function(module, exports) {

let $a17e67305e32e080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a17e67305e32e080$var$load("bVhr1").then(()=>parcelRequire('b4yf3'));

});

parcelRegister("kQTXK", function(module, exports) {

let $f2e41300efb7f39f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2e41300efb7f39f$var$load("kE0QC").then(()=>parcelRequire('lRRwN'));

});

parcelRegister("kFBSF", function(module, exports) {

let $f0c5054f72bf4788$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0c5054f72bf4788$var$load("eVFXf").then(()=>parcelRequire('xXksI'));

});

parcelRegister("44XTS", function(module, exports) {

let $2f86000f50552006$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f86000f50552006$var$load("9FhBz").then(()=>parcelRequire('gHjiO'));

});

parcelRegister("2SnMt", function(module, exports) {

let $21831245fa81e40e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21831245fa81e40e$var$load("6zB8z").then(()=>parcelRequire('9sJzD'));

});

parcelRegister("cXu7g", function(module, exports) {

let $96f25b251372ce30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96f25b251372ce30$var$load("eENGY").then(()=>parcelRequire('cxxnV'));

});

parcelRegister("3EvKg", function(module, exports) {

let $2a8dbb6f12744413$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a8dbb6f12744413$var$load("hmlb0").then(()=>parcelRequire('8nSrm'));

});

parcelRegister("htmh0", function(module, exports) {

let $cb866c206a5b0b04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb866c206a5b0b04$var$load("2NGxc").then(()=>parcelRequire('hGaQU'));

});

parcelRegister("kTVse", function(module, exports) {

let $f37582f3db40c2c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f37582f3db40c2c1$var$load("bPgcq").then(()=>parcelRequire('4zXPl'));

});

parcelRegister("emHN5", function(module, exports) {

let $a75516b19f472f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a75516b19f472f5d$var$load("31b1q").then(()=>parcelRequire('1xC4V'));

});

parcelRegister("9Oxg9", function(module, exports) {

let $725295393c538ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $725295393c538ed1$var$load("8Lh9U").then(()=>parcelRequire('kqZOw'));

});

parcelRegister("doqXm", function(module, exports) {

let $9c026d43c7a38bfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c026d43c7a38bfd$var$load("6ZzYJ").then(()=>parcelRequire('bZPun'));

});

parcelRegister("k0SSx", function(module, exports) {

let $e91e6080a2f1e543$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e91e6080a2f1e543$var$load("2zIbn").then(()=>parcelRequire('bXyC6'));

});

parcelRegister("kVvzt", function(module, exports) {

let $f3c19ee75daa2848$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3c19ee75daa2848$var$load("410SS").then(()=>parcelRequire('aY5Ef'));

});

parcelRegister("2Hx38", function(module, exports) {

let $1f793be472254651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f793be472254651$var$load("z3s9q").then(()=>parcelRequire('9mYoH'));

});

parcelRegister("3v9w9", function(module, exports) {

let $28cba65833e09a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28cba65833e09a5e$var$load("9gqcE").then(()=>parcelRequire('3hbTz'));

});

parcelRegister("4Ve7Q", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c1395595ab243cbd$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $c1395595ab243cbd$export$defe85febe8b728c;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("kSoKM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cgtv4 = parcelRequire("cgtv4");


var $aFUXX = parcelRequire("aFUXX");

function $095aa81eb4c35edf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $095aa81eb4c35edf$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    }
});
const $095aa81eb4c35edf$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>expanded ? [
                $095aa81eb4c35edf$var$expandIconWrapperStyle(),
                $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle
            ] : $095aa81eb4c35edf$var$expandIconWrapperStyle()
    }, children);
};
const $095aa81eb4c35edf$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`
        }
    });
const $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $095aa81eb4c35edf$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $095aa81eb4c35edf$export$c67faf67c1185cba = /*#__PURE__*/ (0, $42omo.forwardRef)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props, ref)=>{
    const { children: children, ...rest } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $095aa81eb4c35edf$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children));
});
module.exports["messages"] = $095aa81eb4c35edf$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $095aa81eb4c35edf$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $095aa81eb4c35edf$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $095aa81eb4c35edf$export$c67faf67c1185cba;

});

parcelRegister("1A9t2", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $6d2a4e7dc7af02b0$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}
module.exports["reduce"] = $6d2a4e7dc7af02b0$export$533b26079ad0b4b;

});

parcelRegister("kDHbX", function(module, exports) {
$parcel$export(module.exports, "captureException", () => (parcelRequire("2YBYF")).captureException);
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("zhyda")).default);

var $2YBYF = parcelRequire("2YBYF");


var $zhyda = parcelRequire("zhyda");


var $7G5lK = parcelRequire("7G5lK");


});

parcelRegister("2YBYF", function(module, exports) {

var $jJdxh = parcelRequire("jJdxh");

const $8a08e7796fbf4a43$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $jJdxh.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $8a08e7796fbf4a43$export$f5282963edea4a68 = (location, error, details = {})=>(0, $jJdxh.default).captureException(location, error, details);
module.exports["captureException"] = $8a08e7796fbf4a43$export$f5282963edea4a68;

});

parcelRegister("jJdxh", function(module, exports) {
// This is the only file that should directly import Raven.

var $805AA = parcelRequire("805AA");

var $k3i2h = parcelRequire("k3i2h");

var $ffG6S = parcelRequire("ffG6S");


var $exBjF = parcelRequire("exBjF");

var $emwrp = parcelRequire("emwrp");

var $6JOHL = parcelRequire("6JOHL");

var $erpTL = parcelRequire("erpTL");


var $da6ky = parcelRequire("da6ky");

const $e63d427485e90328$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $e63d427485e90328$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $e63d427485e90328$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $e63d427485e90328$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $e63d427485e90328$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $k3i2h.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $e63d427485e90328$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$e63d427485e90328$var$getFilteredIntegrations(integrations),
                new $emwrp.Dedupe(),
                new $6JOHL.ExtraErrorData(),
                new $erpTL.Transaction(),
                new $exBjF.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $ffG6S.init({
        ...defaultConfig,
        ...config
    });
    try {
        $805AA.setExtras(getExtraContext());
    } catch (e) {
        $805AA.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $e63d427485e90328$var$tags = [
    'packageName',
    'teamName'
];
const $e63d427485e90328$var$captureException = (location, error, details)=>{
    $805AA.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($e63d427485e90328$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $805AA.captureException(error);
};
const $e63d427485e90328$var$sentryErrorHandler = {
    installGlobalHandler: $e63d427485e90328$var$installGlobalHandler,
    captureException: $e63d427485e90328$var$captureException
};
var $e63d427485e90328$export$2e2bcd8739ae039 = $e63d427485e90328$var$sentryErrorHandler;
module.exports["default"] = $e63d427485e90328$export$2e2bcd8739ae039;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("zhyda", function(module, exports) {

var $hwDTW = parcelRequire("hwDTW");


var $1j3sF = parcelRequire("1j3sF");


var $hzZxz = parcelRequire("hzZxz");

var $3C50A = parcelRequire("3C50A");


var $2YBYF = parcelRequire("2YBYF");

let $b0036220825f82c1$var$analyticsClient;
const $b0036220825f82c1$export$d4079397f9611138 = (client)=>{
    $b0036220825f82c1$var$analyticsClient = client;
};
const $b0036220825f82c1$export$bf406c01a195b215 = ()=>{
    $b0036220825f82c1$var$analyticsClient = undefined;
};
const $b0036220825f82c1$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $hzZxz.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($hwDTW))));
        if (event && event.context) {
            const fullEvent = (0, $hzZxz.extractAWCDataFromEvent)(event);
            (0, $2YBYF.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $2YBYF.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $3C50A.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($b0036220825f82c1$var$analyticsClient && $b0036220825f82c1$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $b0036220825f82c1$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $2YBYF.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $b0036220825f82c1$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $b0036220825f82c1$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $b0036220825f82c1$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $b0036220825f82c1$export$2e2bcd8739ae039 = $b0036220825f82c1$var$fireErrorAnalytics;
module.exports["default"] = $b0036220825f82c1$export$2e2bcd8739ae039;

});

parcelRegister("hwDTW", function(module, exports) {

var $eHPLt = parcelRequire("eHPLt");


var $1WABR = parcelRequire("1WABR");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");


var $bRRFB = parcelRequire("bRRFB");


var $cSA01 = parcelRequire("cSA01");


var $erbrP = parcelRequire("erbrP");


var $gQUlr = parcelRequire("gQUlr");

/** `Object#toString` result references. */ var $cc24605e9ae7f4f1$var$mapTag = '[object Map]', $cc24605e9ae7f4f1$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $cc24605e9ae7f4f1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cc24605e9ae7f4f1$var$hasOwnProperty = $cc24605e9ae7f4f1$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $cc24605e9ae7f4f1$var$isEmpty(value) {
    if (value == null) return true;
    if ($bRRFB(value) && ($fZxmY(value) || typeof value == 'string' || typeof value.splice == 'function' || $cSA01(value) || $gQUlr(value) || $dI6Ko(value))) return !value.length;
    var tag = $1WABR(value);
    if (tag == $cc24605e9ae7f4f1$var$mapTag || tag == $cc24605e9ae7f4f1$var$setTag) return !value.size;
    if ($erbrP(value)) return !$eHPLt(value).length;
    for(var key in value){
        if ($cc24605e9ae7f4f1$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $cc24605e9ae7f4f1$var$isEmpty;

});

parcelRegister("hzZxz", function(module, exports) {

var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bHD89 = parcelRequire("bHD89");


var $01od0 = parcelRequire("01od0");

const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $50a1a1624abaf5e4$export$1c850cf68c053906;

});

parcelRegister("e7URT", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a48dd4fd18e75a65$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a48dd4fd18e75a65$var$isUndefined;

});

parcelRegister("bHD89", function(module, exports) {
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["MODAL"] = $f220a889fcad0dca$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $f220a889fcad0dca$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $f220a889fcad0dca$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $f220a889fcad0dca$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $f220a889fcad0dca$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $f220a889fcad0dca$export$2ceccf177fae277c;

});

parcelRegister("01od0", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $e7URT = parcelRequire("e7URT");


var $apAFY = parcelRequire("apAFY");


var $lgmus = parcelRequire("lgmus");


var $1j3sF = parcelRequire("1j3sF");


var $da6ky = parcelRequire("da6ky");

const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))((0, (/*@__PURE__*/$parcel$interopDefault($5qOzM)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $4b9739432bab74fb$export$a3569ac53b82a914;
module.exports["getAttributes"] = $4b9739432bab74fb$export$fe94072fee8a6976;
module.exports["getSource"] = $4b9739432bab74fb$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $4b9739432bab74fb$export$6f40cdf6d42c018d;
module.exports["getAction"] = $4b9739432bab74fb$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $4b9739432bab74fb$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $4b9739432bab74fb$export$7c8178cc9001d237;
module.exports["getContainerType"] = $4b9739432bab74fb$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $4b9739432bab74fb$export$fa986b91291934c7;
module.exports["getObjectType"] = $4b9739432bab74fb$export$11cc42aebef2ef3a;
module.exports["getTags"] = $4b9739432bab74fb$export$af63d7414243dad3;

});

parcelRegister("3C50A", function(module, exports) {

var $apAFY = parcelRequire("apAFY");


var $bHD89 = parcelRequire("bHD89");


var $1J0ov = parcelRequire("1J0ov");

const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $24a3efb1cf8e29fc$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $24a3efb1cf8e29fc$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $24a3efb1cf8e29fc$export$79f423cc3fd39762;

});

parcelRegister("1J0ov", function(module, exports) {
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $9c601e99598456fc$export$e6baab532ef8c6bf;

});

parcelRegister("7G5lK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");


var $zhyda = parcelRequire("zhyda");

class $b901a3778c48e0b9$var$CatchAndReportErrors extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $zhyda.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: children
        });
    }
}
const $b901a3778c48e0b9$var$reportingErrorBoundary = (0, $1DWH0.default)()($b901a3778c48e0b9$var$CatchAndReportErrors);
var $b901a3778c48e0b9$export$2e2bcd8739ae039 = $b901a3778c48e0b9$var$reportingErrorBoundary;

});

parcelRegister("gWF6I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $JyXl5 = parcelRequire("JyXl5");

function $8122506f239babd4$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $JyXl5.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__),
        children: children
    });
}
const $8122506f239babd4$export$43b1f3e917d65526 = $8122506f239babd4$export$6c22afad970ad5ac;
const $8122506f239babd4$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)($8122506f239babd4$export$6c22afad970ad5ac, {
        children: children
    });
};
function $8122506f239babd4$export$e237a628f59c9f4e() {
    const environment = (0, $irOoi.useRelayEnvironment)();
    return (0, $42omo.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}
module.exports["AtlassianRelayEnvironmentProvider"] = $8122506f239babd4$export$6c22afad970ad5ac;
module.exports["RelayEnvironmentProvider"] = $8122506f239babd4$export$43b1f3e917d65526;
module.exports["ConditionalRelayEnvironmentProvider"] = $8122506f239babd4$export$2f6292af3d34630d;
module.exports["useRelayEnvironmentProvider"] = $8122506f239babd4$export$e237a628f59c9f4e;

});

parcelRegister("JyXl5", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $dh538 = parcelRequire("dh538");


var $3tMMZ = parcelRequire("3tMMZ");


var $hvWxm = parcelRequire("hvWxm");


var $59hua = parcelRequire("59hua");


var $iTyoD = parcelRequire("iTyoD");


var $kzjMJ = parcelRequire("kzjMJ");


var $7gNIX = parcelRequire("7gNIX");

const $e443eef90c98bdab$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $e443eef90c98bdab$export$df54517d175e6d6b = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({
    network: (0, $3e6Uc.Network).create((request, variables, cacheConfig)=>{
        // use new fetch if the feature flag is enabled
        if ((0, $dh538.fg)('platform_environment_for_atlassian_studio') || (0, $dh538.fg)('relay_store_for_platform_packages_in_confluence')) return (0, $59hua.fetch)(request, variables, cacheConfig, {
            getLoggingAndMetricsHelper: $e443eef90c98bdab$var$getLoggingAndMetricsHelper,
            withErrorHandling: (source)=>source,
            validateResponse: (request, response)=>{
                const errors = 'errors' in response ? response.errors : undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    (0, $hvWxm.captureErrors)(errors, {
                        operationName: request.name,
                        requestId: requestId
                    });
                    if ((0, $hvWxm.isUnauthenticated)(errors)) return false;
                }
                return true;
            },
            onInvalidResponse: ()=>{},
            queryResponseCache: new (0, $kzjMJ.SSRQueryResponseCache)({
                cacheName: 'relay-cache/v2/AGG',
                size: Infinity,
                ttl: Infinity
            }),
            isServer: globalThis.__SERVER__
        });
        // fallback to currnt fetch
        return (0, $iTyoD.fetchFn)(request, variables, cacheConfig);
    }, (0, $7gNIX.subscribe))
}));
module.exports["__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__"] = $e443eef90c98bdab$export$df54517d175e6d6b;

});

parcelRegister("kzjMJ", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");

function $55e864d84c99338e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $3e6Uc.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $55e864d84c99338e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $55e864d84c99338e$export$be21c283b097d175 extends (0, $3e6Uc.QueryResponseCache) {
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $55e864d84c99338e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        this.cacheName = void 0;
        this.requestMetadata = void 0;
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
}
module.exports["SSRQueryResponseCache"] = $55e864d84c99338e$export$be21c283b097d175;

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false,
    isCollabOffline: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    setIsCollabOffline: (isCollabOffline)=>({ setState: setState })=>{
            setState({
                isCollabOffline: isCollabOffline
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false,
                isCollabOffline: false
            });
        }
};
const $cf3a2c4e252823d7$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$var$Store, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$var$Store, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$var$Store);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$var$Store, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$var$Store, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
const $cf3a2c4e252823d7$export$cef3009c3c52412e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$var$Store, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isCollabOffline')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;
module.exports["useNativeCollabOfflineStatus"] = $cf3a2c4e252823d7$export$cef3009c3c52412e;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("cLo2u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    // Space-level data is used to retrieve information about a space's external collaborators
    // in multiple places across the package. Attempt to get spaceKey from a range of sources.
    // If we are in a view-page context, spaceKey data may be available from PageState.
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // Otherwise, RoutesContext may contain the information we need
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    // Now that our context hooks have executed, we can return if we have a match.
    // Return statements are separated out for optimum readability.
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    // Legacy server-rendered UI pages do not have the "match" object in RoutesContext, but
    // they can contain space information in the <meta> data tag.
    const documentMetaSpaceKey = typeof document !== 'undefined' ? document.querySelector('meta#confluence-space-key')?.content : null;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("bflGB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lisKW = parcelRequire("lisKW");

parcelRequire("4ARHe");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps })=>{
    const deprecatedListener = (0, $42omo.useCallback)((e, combo)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_shortcut_deprecation_flag')) (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
            flags: flags,
            acceleratorTriggered: combo,
            accelerator: accelerator,
            deprecatedAccelerator: deprecatedAccelerator
        });
        listener(e, combo);
    }, [
        listener,
        accelerator,
        deprecatedAccelerator,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /* This 2nd ShortcutListenerInternal is used to also display a flag informing the user
        that the shortcut they used is deprecated, while still triggering the listener. */ deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
        accelerator: deprecatedAccelerator,
        listener: deprecatedListener,
        ...otherProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
        accelerator: accelerator,
        listener: listener,
        ...otherProps
    }));
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("lisKW", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (0, module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("4ARHe", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'ctrl+mod+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $cgtv4.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_zulpv77o _1e0c1txw _4cvr1h6o"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 604800000);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("4tOXV", function(module, exports) {
/* ShortcutVisualizer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");


var $1Whri = parcelRequire("1Whri");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent;
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_1rjcv77o _1e0c1txw _4cvr1h6o",
    base: "_2rko12b0 _1rjcv77o _18zru2gc _1e0c1o8l _18u0v77o _2hwxv77o",
    contentBefore: "_18u01b66 _2hwxze3t",
    darkBackground: "_bfhk18j9",
    lightBackground: "_bfhkysee"
};
const $05ef07480c610d29$var$i18n = (0, $cgtv4.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = ({ shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: isTooltip = false })=>{
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $8C5kA.default)();
    const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const shouldRenderShortcutSegment = (0, $6mKj3.expVal)('confluence_frontend_fix_shortcut_hydration', 'isEnabled', false) ? areKeyboardShortcutsEnabled && !renderServerPlaceholder || isEditorShortcut : areKeyboardShortcutsEnabled || isEditorShortcut; // This is going to be rendered in a <span> so no <div> should be used here.
    // Otherwise it will break HTML structure causing SSR hydration mismatch.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $05ef07480c610d29$var$styles.flexCenter
    }, contentBefore, shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            key: `${shortcutSegment}-${index}`,
            xcss: (0, $1Whri.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
        }, shortcutSegment)));
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $42omo.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    (0, $42omo.useEffect)(()=>{
        if (typeof window.__SHORTCUT_ENABLED__ !== 'boolean') {
            if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = // preloadShortcutEnabledState will set window.__SHORTCUT_ENABLED__
            isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
            $640354b193201be7$var$inflightPromise.then(setEnabled);
        }
        $640354b193201be7$var$updaters.add(setEnabled);
        return ()=>{
            $640354b193201be7$var$updaters.delete(setEnabled);
        };
    }, [
        isLoggedIn,
        isLicensed
    ]);
    const notify = (0, $42omo.useCallback)(async (enabled)=>{
        try {
            const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    enabled: enabled
                })
            });
            if (res.ok) {
                const newEnabled = await res.text() === 'true';
                // Any newly created hook instance will get the updated value
                window.__SHORTCUT_ENABLED__ = newEnabled;
                // Notify all the existing hooks on the page that we have updated the value
                $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
            }
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
                attribution: (0, $3IBnw.Attribution).BACKBONE
            });
        }
    }, []);
    return [
        Boolean(enabled),
        notify
    ];
};
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("1eaCJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829({ name: name, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>experienceTracker.succeed({
            name: name,
            attributes: attributes
        }), [
        name,
        attributes,
        experienceTracker
    ]);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = (props)=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $9ee4137247832c84$var$getExperimentValue = (0, $c6GJD.default).getExperimentValue;
const $9ee4137247832c84$var$EXPERIMENT = 'platform_global_preview_panels_default_width';
const $9ee4137247832c84$export$c82b124a4ae0f274 = 'isEnabled';
const $9ee4137247832c84$export$56368731b0f4a091 = 'minimumWidth';
const $9ee4137247832c84$export$97a0618f336c05be = 'ratio';
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$FALLBACK_RATIO = 0.25;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    if (!$9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$c82b124a4ae0f274, false)) return $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    const windowWidth = window.innerWidth;
    const minWidthForWiderPanel = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$56368731b0f4a091, Number.MAX_VALUE);
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth > minWidthForWiderPanel) {
        const panelWidthToWindowWidthRatio = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$97a0618f336c05be, $9ee4137247832c84$var$FALLBACK_RATIO);
        const proposedPanelWidth = Math.round(windowWidth * panelWidthToWindowWidthRatio);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("awHlv", function(module, exports) {
var $14957aea32c8ee8e$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    return SyncBlockError;
}({});
module.exports["SyncBlockError"] = $14957aea32c8ee8e$export$686dd843fdf311d4;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $cD1qu = parcelRequire("cD1qu");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED',
            'DELETED'
        ],
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
var $bd3b81debc212a33$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $bd3b81debc212a33$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch (error) {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $bd3b81debc212a33$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (contentStatusFilters.includes(comment?.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        const isOpen = !$bd3b81debc212a33$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            isUnread: false,
            wasRemovedByAnotherUser: false,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply,
                    isUnread: false,
                    wasRemovedByAnotherUser: false
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $bd3b81debc212a33$export$6036c2c532b2fa41(commentsDataMap);
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        hasNestedComments: hasNestedComments
    };
};
// Utility type for comparing content status arrays
// Because arrays are passed as reference types, we need to be careful about equality checks or we
// may end up in infinite loops in useEffect or useMemo if the array reference changes even though
// the contents are the same.
const $bd3b81debc212a33$var$areContentStatusArraysEqual = (contentStatus1, contentStatus2)=>{
    if (contentStatus1.length !== contentStatus2.length) return false;
    for (const status1 of contentStatus1){
        if (!contentStatus2.includes(status1)) return false;
    }
    return true;
};
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    // Add the newly added comment to the end of the root comments list
    const updatedRootComments = [
        ...cachedRootComments,
        newComment
    ];
    // Increment total count. Note that we can only add individual comments without any replies, but
    // let's be safe and adjust for any replies in case this ever changes
    const updatedTotalCount = totalCount + repliesCount + 1;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array with the new reply added, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies || [],
            newComment
        ];
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Increment total count. We can only add individual comments without any replies, but let's be
        // safe and adjust for any replies in case this ever changes
        updatedTotalCount += 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: onCompleted, onError: onError } = options;
    const contentStatusRef = (0, $42omo.useRef)([]);
    // Check if contentStatus array has changed.  Content status is passed as an array by reference,
    // and anonymous functions may recreate the array with a new reference on each render, so we need
    // to check the contents for equality to avoid infinite loops in useEffect/useMemo below.
    const hasContentStatusChanged = !$bd3b81debc212a33$var$areContentStatusArraysEqual(contentStatusRef.current, contentStatus);
    contentStatusRef.current = contentStatus;
    const [processedData, setProcessedData] = (0, $42omo.useState)({
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        hasNestedComments: false,
        isDataProcessed: false
    });
    const handleQueryError = (0, $42omo.useCallback)((error)=>{
        // Handle specific GraphQL errors gracefully
        // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
        // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        onError?.(error);
    }, [
        onError
    ]);
    // Skip query if no content ID or explicitly skipped
    const shouldSkip = !contentId || options.skip;
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        fetchPolicy: fetchPolicy,
        onCompleted: (data)=>{
            onCompleted?.(data);
        },
        onError: handleQueryError
    });
    // Process and categorize comments when data changes
    (0, $42omo.useEffect)(()=>{
        // Don't process data while loading
        // This prevents any issues where data changes briefly during the loading state, which can lead to flickering
        if (queryResponse.loading) return;
        if (queryResponse.data?.comments?.nodes) {
            const allComments = (queryResponse.data?.comments?.nodes || []).filter((node)=>node !== null);
            const categorized = $bd3b81debc212a33$export$2fa0b601110c277b(allComments, contentStatus);
            setProcessedData({
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            });
        } else setProcessedData({
            allComments: [],
            allFilteredComments: [],
            openInlineComments: [],
            openFooterComments: [],
            resolvedComments: [],
            openComments: [],
            commentsDataMap: {
                inline: {},
                general: {}
            },
            hasNestedComments: false,
            isDataProcessed: true // Even if no data, we've processed the empty state
        });
    // Only reprocess if data changes or contentStatus contents has changed (not just the reference)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        queryResponse.data,
        queryResponse.loading,
        hasContentStatusChanged
    ]);
    // Memoized computed values for performance
    // Note that commentCount and hasAnyComments are based on filtered (by contentStatus) comments
    // from the query, just like GQL results would look like if we had passed a contentStatus filter
    // to the query itself.
    const commentCount = (0, $42omo.useMemo)(()=>processedData.allFilteredComments.length, [
        processedData.allFilteredComments.length
    ]);
    const hasAnyComments = (0, $42omo.useMemo)(()=>commentCount > 0, [
        commentCount
    ]);
    // Refetch function with error handling
    const refetch = (0, $42omo.useCallback)(async ()=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            handleQueryError(error);
        }
    }, [
        queryResponse,
        handleQueryError
    ]);
    const addCommentInCache = (0, $42omo.useCallback)(({ newComment: newComment, onError: onError })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $42omo.useCallback)(({ commentId: commentId, onError: onError })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        ...processedData,
        isDataProcessed: processedData.isDataProcessed,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$31ad16301fa5dfb4 = async ({ contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
] })=>{
    const variables = $bd3b81debc212a33$export$66fa4e722aa8c832(contentId);
    try {
        // Execute the query and wait for data to come back
        const data = await (0, $c0rhi.queryInterop)({
            query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
            variables: variables,
            fetchPolicy: 'cache-first'
        });
        if (!data?.data?.comments?.nodes) return {
            allFilteredComments: [],
            openComments: [],
            openInlineComments: [],
            openFooterComments: [],
            resolvedComments: [],
            commentsDataMap: {
                inline: {},
                general: {}
            },
            hasNestedComments: false
        };
        const filteredNodes = data.data.comments.nodes.filter((node)=>node !== null);
        // Categorize the comments using the existing categorizeComments function
        return $bd3b81debc212a33$export$2fa0b601110c277b(filteredNodes, contentStatus);
    } catch (error) {
        // Query error - return empty categorized data
        // [Optional - Add some custom logic here] - caller handles error
        throw error;
    }
};
module.exports["buildDefaultCommentsContentStatusFilters"] = $bd3b81debc212a33$export$e237bdee87974d46;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["fetchAllCommentsData"] = $bd3b81debc212a33$export$31ad16301fa5dfb4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<ffe25591c3e17983b11fcfcb1d4214ba>>
 * @relayHash 9e9dce87233142bdde0be6a1e1389db3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "9e9dce87233142bdde0be6a1e1389db3",
            "id": "ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "f3f3f95ad61519f75dd5ba8d0cde2302";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("c0rhi", function(module, exports) {

var $kczYx = parcelRequire("kczYx");


var $86okN = parcelRequire("86okN");


var $1RY07 = parcelRequire("1RY07");

function $ca39dfd4a17910a6$export$c53086aa5c7d04b4(params) {
    return $ca39dfd4a17910a6$var$queryInteropApollo(params);
}
function $ca39dfd4a17910a6$var$queryInteropRelay(params) {
    const relayFetchPolicy = $ca39dfd4a17910a6$var$mapFetchPolicyForQuery(params.fetchPolicy);
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: ()=>(0, $kczYx.fetchQuery)(window.GLOBAL_RELAY_ENV, params.query, params.variables ?? {}, {
                fetchPolicy: relayFetchPolicy
            }).toPromise()
    });
}
function $ca39dfd4a17910a6$var$queryInteropApollo({ query: query, ...rest }) {
    return window['GLOBAL_APOLLO_CLIENT'].query({
        ...rest,
        query: (0, $86okN.toDocumentNode)(query)
    });
}
// Relay:  https://relay.dev/docs/guided-tour/reusing-cached-data/fetch-policies/
// Apollo: https://www.apollographql.com/docs/react/data/queries#supported-fetch-policies
function $ca39dfd4a17910a6$var$mapFetchPolicyForQuery(fetchPolicy) {
    switch(fetchPolicy){
        case 'no-cache':
        case 'network-only':
            return 'network-only';
        case 'cache-first':
        case 'cache-only':
        default:
            return 'store-or-network';
    }
}
module.exports["queryInterop"] = $ca39dfd4a17910a6$export$c53086aa5c7d04b4;

});

parcelRegister("kgNLQ", function(module, exports) {
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$fb9051669482cbe0 = (condition, trueFn, falseFn)=>condition ? trueFn : falseFn;
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // Reply parent not found
    return undefined;
};
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["selectUpdateFunction"] = $344a24116515d334$export$fb9051669482cbe0;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;

});

parcelRegister("lesF8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $6cQbn = parcelRequire("6cQbn");

function $0eec8481dd12dbe1$export$4153d6fbc2386422(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
    });
}
module.exports["CommentEditor"] = $0eec8481dd12dbe1$export$4153d6fbc2386422;

});

parcelRegister("7EEGh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $1PKpt = parcelRequire("1PKpt");

function $c97a308eea576e63$export$5252bd745392dcde(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $1PKpt.default)
    });
}
module.exports["ChromelessEditor"] = $c97a308eea576e63$export$5252bd745392dcde;

});

parcelRegister("hXzKU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("3VQ3F"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("3VQ3F"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("3VQ3F"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c82smr _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("3VQ3F", function(module, exports) {

let $2dcf13a0670a1972$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2dcf13a0670a1972$var$load("iY2SX"),
    $2dcf13a0670a1972$var$load("4cER0"),
    $2dcf13a0670a1972$var$load("jwWp5"),
    $2dcf13a0670a1972$var$load("2Cftu"),
    $2dcf13a0670a1972$var$load("4i0CB"),
    $2dcf13a0670a1972$var$load("aeEUI"),
    $2dcf13a0670a1972$var$load("8ab9M"),
    $2dcf13a0670a1972$var$load("gyOzw"),
    $2dcf13a0670a1972$var$load("9wxKg"),
    $2dcf13a0670a1972$var$load("fZt2F"),
    $2dcf13a0670a1972$var$load("dIKn2"),
    $2dcf13a0670a1972$var$load("8fdGr"),
    $2dcf13a0670a1972$var$load("fnmhc"),
    $2dcf13a0670a1972$var$load("kdoia"),
    $2dcf13a0670a1972$var$load("2YffH"),
    $2dcf13a0670a1972$var$load("dclpt"),
    $2dcf13a0670a1972$var$load("tKhaz"),
    $2dcf13a0670a1972$var$load("iIL8i"),
    $2dcf13a0670a1972$var$load("3gnID"),
    $2dcf13a0670a1972$var$load("attzI"),
    $2dcf13a0670a1972$var$load("ihbI9"),
    $2dcf13a0670a1972$var$load("c7kN1"),
    $2dcf13a0670a1972$var$load("9A0ig"),
    $2dcf13a0670a1972$var$load("90kvt"),
    $2dcf13a0670a1972$var$load("eYere"),
    $2dcf13a0670a1972$var$load("at1W4"),
    $2dcf13a0670a1972$var$load("lkOIY"),
    $2dcf13a0670a1972$var$load("hcj2C"),
    $2dcf13a0670a1972$var$load("2UF2x"),
    $2dcf13a0670a1972$var$load("65rGD"),
    $2dcf13a0670a1972$var$load("5Vmp6"),
    $2dcf13a0670a1972$var$load("ioxaT"),
    $2dcf13a0670a1972$var$load("9XYQ9"),
    $2dcf13a0670a1972$var$load("edPhJ"),
    $2dcf13a0670a1972$var$load("fTFcV"),
    $2dcf13a0670a1972$var$load("h4k4y"),
    $2dcf13a0670a1972$var$load("5abXM"),
    $2dcf13a0670a1972$var$load("k78EM"),
    $2dcf13a0670a1972$var$load("enYNd"),
    $2dcf13a0670a1972$var$load("5pvpJ"),
    $2dcf13a0670a1972$var$load("8bZKp"),
    $2dcf13a0670a1972$var$load("7RNcA"),
    $2dcf13a0670a1972$var$load("kjZZD"),
    $2dcf13a0670a1972$var$load("kWNlz"),
    $2dcf13a0670a1972$var$load("cHTTI"),
    $2dcf13a0670a1972$var$load("1qlDN"),
    $2dcf13a0670a1972$var$load("1yVM6"),
    $2dcf13a0670a1972$var$load("6wr18"),
    $2dcf13a0670a1972$var$load("cyGuT"),
    $2dcf13a0670a1972$var$load("hhss7"),
    $2dcf13a0670a1972$var$load("ePdWC"),
    $2dcf13a0670a1972$var$load("lBzRN"),
    $2dcf13a0670a1972$var$load("kel4J"),
    $2dcf13a0670a1972$var$load("Wowvf"),
    $2dcf13a0670a1972$var$load("7whwt"),
    $2dcf13a0670a1972$var$load("let0D"),
    $2dcf13a0670a1972$var$load("87NBA"),
    $2dcf13a0670a1972$var$load("8KnyD"),
    $2dcf13a0670a1972$var$load("bRz9K"),
    $2dcf13a0670a1972$var$load("ffEVr"),
    $2dcf13a0670a1972$var$load("kUbUu"),
    $2dcf13a0670a1972$var$load("7EorR"),
    $2dcf13a0670a1972$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("9ImuD", function(module, exports) {

























const $efd7e121efbbc6f0$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("5Ndvb"));
        case 'da-DK':
            return (parcelRequire("iiIXH"));
        case 'de-DE':
            return (parcelRequire("2Tsxu"));
        case 'en-US':
            return (parcelRequire("kcHy2"));
        case 'en-GB':
            return (parcelRequire("itcXa"));
        case 'en-ZZ':
            return (parcelRequire("gchso"));
        case 'es-ES':
            return (parcelRequire("96L2T"));
        case 'fi-FI':
            return (parcelRequire("jaVup"));
        case 'fr-FR':
            return (parcelRequire("97KoO"));
        case 'hu-HU':
            return (parcelRequire("8lubX"));
        case 'it-IT':
            return (parcelRequire("eNKAp"));
        case 'ja-JP':
            return (parcelRequire("eVHt2"));
        case 'ko-KR':
            return (parcelRequire("9l54B"));
        case 'no-NO':
            return (parcelRequire("9lkMC"));
        case 'nl-NL':
            return (parcelRequire("7m1Mp"));
        case 'pl-PL':
            return (parcelRequire("fGUyM"));
        case 'pt-BR':
            return (parcelRequire("4jTFc"));
        case 'ru-RU':
            return (parcelRequire("aHFLL"));
        case 'sv-SE':
            return (parcelRequire("iNU9J"));
        case 'tr-TR':
            return (parcelRequire("iHxcT"));
        case 'th-TH':
            return (parcelRequire("bhuCG"));
        case 'uk-UA':
            return (parcelRequire("lLUi2"));
        case 'vi-VN':
            return (parcelRequire("fL5hj"));
        case 'zh-TW':
            return (parcelRequire("fpOoD"));
        case 'zh-CN':
            return (parcelRequire("ag1zA"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $efd7e121efbbc6f0$var$fetchTranslations = async (locale)=>{
    const module = await $efd7e121efbbc6f0$var$importTranslations(locale);
    return module.default;
};
var $efd7e121efbbc6f0$export$2e2bcd8739ae039 = $efd7e121efbbc6f0$var$fetchTranslations;
module.exports["default"] = $efd7e121efbbc6f0$export$2e2bcd8739ae039;

});

parcelRegister("5Ndvb", function(module, exports) {

let $437c00935acb14ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $437c00935acb14ea$var$load("i1TuF").then(()=>parcelRequire('1jUpD'));

});

parcelRegister("iiIXH", function(module, exports) {

let $d52cc8f43585e630$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d52cc8f43585e630$var$load("eEPT4").then(()=>parcelRequire('jPcpM'));

});

parcelRegister("2Tsxu", function(module, exports) {

let $21b6db1ee7e67ba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b6db1ee7e67ba5$var$load("gkfGT").then(()=>parcelRequire('2HnQV'));

});

parcelRegister("kcHy2", function(module, exports) {

let $eb56b55f48170862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb56b55f48170862$var$load("6kSRw").then(()=>parcelRequire('9NBPE'));

});

parcelRegister("itcXa", function(module, exports) {

let $d724fbaf6f612dc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d724fbaf6f612dc2$var$load("2dFTF").then(()=>parcelRequire('hIkMa'));

});

parcelRegister("gchso", function(module, exports) {

let $bcab4eeeab7106ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcab4eeeab7106ed$var$load("auo6z").then(()=>parcelRequire('7hjEd'));

});

parcelRegister("96L2T", function(module, exports) {

let $6a192ae0f9ce7ae7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a192ae0f9ce7ae7$var$load("685rk").then(()=>parcelRequire('3knLh'));

});

parcelRegister("jaVup", function(module, exports) {

let $df5b8bb747e71066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5b8bb747e71066$var$load("fp6pG").then(()=>parcelRequire('QPojr'));

});

parcelRegister("97KoO", function(module, exports) {

let $6a48c2662010f84a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a48c2662010f84a$var$load("6bt8l").then(()=>parcelRequire('lTPon'));

});

parcelRegister("8lubX", function(module, exports) {

let $6137b461e0c0d233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6137b461e0c0d233$var$load("jjvsl").then(()=>parcelRequire('goIHn'));

});

parcelRegister("eNKAp", function(module, exports) {

let $ac69c757ef6ed44a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac69c757ef6ed44a$var$load("bAfbH").then(()=>parcelRequire('gwGzH'));

});

parcelRegister("eVHt2", function(module, exports) {

let $ade81b488ae26811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ade81b488ae26811$var$load("5Q9X0").then(()=>parcelRequire('56b4I'));

});

parcelRegister("9l54B", function(module, exports) {

let $6cca02a75f916cfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cca02a75f916cfb$var$load("ePkyJ").then(()=>parcelRequire('69j0k'));

});

parcelRegister("9lkMC", function(module, exports) {

let $6cd63251145b2739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cd63251145b2739$var$load("hpdFn").then(()=>parcelRequire('7suyn'));

});

parcelRegister("7m1Mp", function(module, exports) {

let $55abf7e453b9933f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55abf7e453b9933f$var$load("8qW90").then(()=>parcelRequire('1l5oU'));

});

parcelRegister("fGUyM", function(module, exports) {

let $b6c6a6ea694df539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6c6a6ea694df539$var$load("a1OSV").then(()=>parcelRequire('7azO9'));

});

parcelRegister("4jTFc", function(module, exports) {

let $32541d63110b786f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32541d63110b786f$var$load("8AvOI").then(()=>parcelRequire('cqo8f'));

});

parcelRegister("aHFLL", function(module, exports) {

let $7cae5214955aa781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7cae5214955aa781$var$load("jxu37").then(()=>parcelRequire('2ob2Z'));

});

parcelRegister("iNU9J", function(module, exports) {

let $db085cfb205ba45c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db085cfb205ba45c$var$load("10YQF").then(()=>parcelRequire('6bYmv'));

});

parcelRegister("iHxcT", function(module, exports) {

let $d9d6005709d91a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9d6005709d91a65$var$load("daBgp").then(()=>parcelRequire('eURXY'));

});

parcelRegister("bhuCG", function(module, exports) {

let $8369094a4603e1c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8369094a4603e1c8$var$load("bI6N0").then(()=>parcelRequire('evqpq'));

});

parcelRegister("lLUi2", function(module, exports) {

let $fd99a6c46b5179db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd99a6c46b5179db$var$load("3Qhls").then(()=>parcelRequire('3uadp'));

});

parcelRegister("fL5hj", function(module, exports) {

let $b78f56f44c93f165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b78f56f44c93f165$var$load("dgXIC").then(()=>parcelRequire('1Aznz'));

});

parcelRegister("fpOoD", function(module, exports) {

let $b39048758b7c76b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39048758b7c76b0$var$load("jh4hi").then(()=>parcelRequire('am6cJ'));

});

parcelRegister("ag1zA", function(module, exports) {

let $777c9e58e5d8ad11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $777c9e58e5d8ad11$var$load("2AL0H").then(()=>parcelRequire('5vTPX'));

});

parcelRegister("7MEO5", function(module, exports) {
"use strict";
var $5aacab81e886bd11$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $5aacab81e886bd11$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dxnq4 = parcelRequire("dxnq4");


$5aacab81e886bd11$var$__export((parcelRequire("3lrmR")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $5aacab81e886bd11$var$InvalidAriError = /** @class */ function(_super) {
    $5aacab81e886bd11$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $5aacab81e886bd11$var$InvalidAriError;
function $5aacab81e886bd11$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $5aacab81e886bd11$var$basicCharConstraint = $dxnq4.pattern(/^[a-z][a-z.-]*$/);
var $5aacab81e886bd11$var$resourceOwnerConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$resourceTypeConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$cloudIdConstraints = [
    $dxnq4.lengthBetween(36, 255)
];
var $5aacab81e886bd11$var$siteResourceType = 'site';
var $5aacab81e886bd11$var$resourceIdChars = /[\w-._~:@#]/.source;
var $5aacab81e886bd11$var$resourceIdConstraints = [
    $dxnq4.pattern(new RegExp("^" + $5aacab81e886bd11$var$resourceIdChars + "+(/" + $5aacab81e886bd11$var$resourceIdChars + "*)*(;v=" + $5aacab81e886bd11$var$resourceIdChars + "*)*$"))
]; /**
                                                                                                                                                          * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                                          * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                                          */ 
function $5aacab81e886bd11$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $5aacab81e886bd11$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $5aacab81e886bd11$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $5aacab81e886bd11$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $5aacab81e886bd11$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $5aacab81e886bd11$var$parse(decodeURIComponent(encodedAriString));
    }; /**
      * Converts this Ari to a string.
      */ 
    ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $5aacab81e886bd11$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $5aacab81e886bd11$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    }; /**
      * Converts this object to its json representation
      */ 
    ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    }; /**
      * Checks if this context is the same as another context
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
      */ 
    ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }; /**
      * This method checks if the current context contains the other context.
      *
      * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
      * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
      *
      * @param {Ari} other
      * @returns {boolean}
      */ 
    ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    }; /**
      * Checks if this context is the same as or contains the provided context.
      *
      * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
      *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
      *
      * e.g.
      * ```
      * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
      * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
      */ 
    ResourceIdentifier.prototype.matches = function(other) {
        return $5aacab81e886bd11$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $5aacab81e886bd11$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $5aacab81e886bd11$var$siteResourceType && !cloudId) return new $dxnq4.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $dxnq4.validateField(this, 'resourceOwner', $5aacab81e886bd11$var$resourceOwnerConstraints),
            $dxnq4.validateField(this, 'resourceType', $5aacab81e886bd11$var$resourceTypeConstraints),
            $dxnq4.validateField(this, 'resourceId', $5aacab81e886bd11$var$resourceIdConstraints),
            $dxnq4.validateField(this, 'cloudId', $5aacab81e886bd11$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $5aacab81e886bd11$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $5aacab81e886bd11$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $5aacab81e886bd11$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $5aacab81e886bd11$var$parse(ariString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $5aacab81e886bd11$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $5aacab81e886bd11$var$parseEncoded(encodedAriString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $5aacab81e886bd11$var$parseEncoded;

});

parcelRegister("dxnq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9db08607176ba86f$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $9db08607176ba86f$var$LengthConstraint;
var $9db08607176ba86f$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $9db08607176ba86f$var$RegexConstraint;
var $9db08607176ba86f$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $9db08607176ba86f$var$GeneralValidationError;
var $9db08607176ba86f$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $9db08607176ba86f$var$ConstraintViolation;
function $9db08607176ba86f$var$lengthBetween(min, max) {
    return new $9db08607176ba86f$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $9db08607176ba86f$var$lengthBetween;
function $9db08607176ba86f$var$pattern(regex) {
    return new $9db08607176ba86f$var$RegexConstraint(regex);
}
module.exports.pattern = $9db08607176ba86f$var$pattern;
function $9db08607176ba86f$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $9db08607176ba86f$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $9db08607176ba86f$var$validateField;

});

parcelRegister("3lrmR", function(module, exports) {
"use strict";
var $26f88fee2c23b642$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3uwoy = parcelRequire("3uwoy");

var $26f88fee2c23b642$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($26f88fee2c23b642$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $26f88fee2c23b642$var$AppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $26f88fee2c23b642$var$AppFamilyAriError;
var $26f88fee2c23b642$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $26f88fee2c23b642$var$NotAppFamilyAriError;
var $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $26f88fee2c23b642$var$parseAppAri(ari) {
    return $3uwoy.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $26f88fee2c23b642$var$parseAppAri;
function $26f88fee2c23b642$var$createAppAri(json) {
    return new $3uwoy.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $26f88fee2c23b642$var$createAppAri;

});

parcelRegister("3uwoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3lrmR = parcelRequire("3lrmR");


var $7MEO5 = parcelRequire("7MEO5");

var $28ad4d654e27c81d$var$versionPrefix = ';v=';
var $28ad4d654e27c81d$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $3lrmR.AppFamilyAri.resourceOwner) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $3lrmR.AppFamilyAri.resourceOwner);
        if (!resourceType || $3lrmR.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceType must be one of " + $3lrmR.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $3lrmR.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($28ad4d654e27c81d$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($28ad4d654e27c81d$var$versionPrefix) > versionIndex) throw new $3lrmR.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($28ad4d654e27c81d$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($28ad4d654e27c81d$var$stripToUndefined);
        if (segments.length > 4) throw new $3lrmR.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $3lrmR.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType || resourceType === $3lrmR.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $3lrmR.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $3lrmR.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $3lrmR.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $28ad4d654e27c81d$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $28ad4d654e27c81d$var$AppFamilyAriImpl;
function $28ad4d654e27c81d$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("cOau5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kycWk = parcelRequire("kycWk");


var $F4YLX = parcelRequire("F4YLX");


const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    return {
        title: 'Redaction',
        type: (0, $kycWk.REDACTION_EXTENSION_TYPE),
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("9wNwY"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("9wNwY", function(module, exports) {

let $6efd85fb623c7239$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6efd85fb623c7239$var$load("8JZKd").then(()=>parcelRequire('aKJ2P'));

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("i5WUp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $9Rf00 = parcelRequire("9Rf00");

var $au4KV = parcelRequire("au4KV");


var $gWF6I = parcelRequire("gWF6I");


var $9NDUe = parcelRequire("9NDUe");

var $2Gu9D = parcelRequire("2Gu9D");


var $in8wv = parcelRequire("in8wv");


var $kt1Xc = parcelRequire("kt1Xc");


var $2UyBL = parcelRequire("2UyBL");

const $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $990b0c00f1a7800f$var$DEFAULT_MAX_LINES = 4;
const $990b0c00f1a7800f$var$styles = {
    container: "_11c81o8v"
};
const $990b0c00f1a7800f$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $990b0c00f1a7800f$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true
    });
const $990b0c00f1a7800f$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $990b0c00f1a7800f$var$getAnalyticsConfig(props),
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$ac90160f7ae1e32f, {
            ...props
        })
    });
};
const $990b0c00f1a7800f$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $990b0c00f1a7800f$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $irOoi.useQueryLoader)((0, $2UyBL.default));
    const isLoadingRef = (0, $42omo.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $2Gu9D.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $990b0c00f1a7800f$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $dh538.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        };
    // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($990b0c00f1a7800f$var$styles.container),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {}),
                children: queryRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kt1Xc.AISnippetLoader), {
                    queryRef: queryRef,
                    fallbackText: fallbackText,
                    contentId: contentId,
                    source: source,
                    isHidden: isHidden,
                    maxLines: maxLines,
                    showFooter: showFooter,
                    showAwareness: showAwareness
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: isEnabledForJira ? content : /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
            entrypointId: $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID,
            userId: userId,
            displayName: displayName,
            children: content
        })
    });
};
const $990b0c00f1a7800f$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$1b2af18ca4bb327b, {
            ...props
        })
    });
};
module.exports["AISnippetWithRelayEnvironment"] = $990b0c00f1a7800f$export$c9a07cebec67e951;

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $oWrxz = parcelRequire("oWrxz");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3pfAb.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $oWrxz.getTagsWithPlatfromTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        aiExperienceName,
        aiFeatureName,
        product,
        proactiveGeneratedAI,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        userGeneratedAI,
        isAIFeature,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    return {
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("oWrxz", function(module, exports) {
const $b35ed956ecf5e00e$export$8dd34cb3211cf994 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatfromTag"] = $b35ed956ecf5e00e$export$8dd34cb3211cf994;

});

parcelRegister("9Rf00", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

const $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $a07f007de41f1483$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a07f007de41f1483$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $8C5kA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a07f007de41f1483$export$f906c21bacdb2d8e.Provider, {
        value: contextValue,
        children: children
    });
};
const $a07f007de41f1483$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $42omo.useContext)($a07f007de41f1483$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $a07f007de41f1483$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $a07f007de41f1483$export$ff3deb4415ee32e3;

});

parcelRegister("au4KV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $cgtv4.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("2Gu9D", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

const $b5fd5f50ef335781$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $42omo.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $42omo.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $42omo.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $b5fd5f50ef335781$export$fade2d05a6320d49;

});

parcelRegister("in8wv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");


var $c6GJD = parcelRequire("c6GJD");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fYQcF = parcelRequire("fYQcF");


var $aFC6o = parcelRequire("aFC6o");

var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");


var $fXbFR = parcelRequire("fXbFR");

const $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $b015c3cc5e677900$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $b015c3cc5e677900$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines })=>{
    const ref = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $42omo.useRef)(text);
    const isExperimentEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        ref: ref,
        children: [
            showAwareness && /*#__PURE__*/ (0, $l998X.jsx)((0, $aFC6o.AIAwareness), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                maxLines: maxLines,
                children: isExperimentEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    options: {
                        disableParsingRawHTML: true
                    },
                    children: $b015c3cc5e677900$var$sanitizeMarkdown(text || '')
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    children: text || ''
                })
            }),
            showFooter && text && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iuafG.AIDisclaimer), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aXh2V.AIFeedbackComponent), {
                        contentId: contentId
                    })
                ]
            })
        ]
    });
};
module.exports["AISnippetContent"] = $b015c3cc5e677900$export$3cf37822a11d3ff3;

});

parcelRegister("aFC6o", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eLAh6 = parcelRequire("eLAh6");

const $902b2990c09c9892$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $902b2990c09c9892$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $eLAh6.i18n).rovoAwarenessMessage,
        define: (0, $eLAh6.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($902b2990c09c9892$var$styles.text),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                    size: "xxsmall",
                    appearance: "brand",
                    shouldUseNewLogoDesign: true
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: formatMessage(message)
                })
            ]
        })
    });
};
module.exports["AIAwareness"] = $902b2990c09c9892$export$fde99ed387d90f1;

});

parcelRegister("eLAh6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8e99185ad20025a1$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $8e99185ad20025a1$export$a7357cdd1f0b0168;

});

parcelRegister("iuafG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fSglY = parcelRequire("fSglY");

const $8fdbd961e8c69c33$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $8fdbd961e8c69c33$export$e0542ba0c737fe5c = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disclaimerMessage = formatMessage((0, $fSglY.i18n).disclaimerMessage);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8fdbd961e8c69c33$var$styles.text),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest",
            children: disclaimerMessage
        })
    });
};
module.exports["AIDisclaimer"] = $8fdbd961e8c69c33$export$e0542ba0c737fe5c;

});

parcelRegister("fSglY", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168;

});

parcelRegister("aXh2V", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $biiXa = parcelRequire("biiXa");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $6fnsQ = parcelRequire("6fnsQ");


var $3gadb = parcelRequire("3gadb");


var $9Rf00 = parcelRequire("9Rf00");


var $aFwxm = parcelRequire("aFwxm");

const $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $00b0d3bf57a2c2c6$var$i18n = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Good response"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Bad response"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $00b0d3bf57a2c2c6$var$PrivacyPolicyLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    });
const $00b0d3bf57a2c2c6$var$ResearchGroupLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    });
const $00b0d3bf57a2c2c6$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...$00b0d3bf57a2c2c6$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$PrivacyPolicyLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $dh538.fg)('product-terminology-refresh') ? $00b0d3bf57a2c2c6$var$i18n.improveAtlassianTextAppify : $00b0d3bf57a2c2c6$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$ResearchGroupLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $00b0d3bf57a2c2c6$export$f9f34317e5bc3551 = ({ contentId: contentId })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const feedbackCollectorProperties = (0, $9Rf00.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagTitle),
            description: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                spacing: "spacious",
                color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`,
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const onLikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const onDislikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        onClick: (e)=>e.stopPropagation(),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                isSelected: hasGoodFeedbackBeenSubmitted
                            }),
                            onClick: onLikeClicked,
                            testId: "feedback-like-button",
                            isDisabled: hasGoodFeedbackBeenSubmitted
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                    isSelected: hasBadFeedbackBeenSubmitted
                                })
                            }),
                            onClick: onDislikeClicked,
                            testId: "feedback-dislike-button",
                            isDisabled: hasBadFeedbackBeenSubmitted
                        })
                    })
                }),
                isFeedbackOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $biiXa.default), {
                    locale: feedbackCollectorProperties.locale,
                    onSubmit: onFeedbackSubmit,
                    onClose: ()=>setIsFeedbackOpen(false),
                    atlassianAccountId: feedbackCollectorProperties.userId,
                    name: feedbackCollectorProperties.displayName,
                    entrypointId: feedbackCollectorProperties.entrypointId,
                    summaryPlaceholder: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryPlaceholder),
                    additionalFields: [
                        {
                            id: feedbackCollectorProperties.feedbackContextId,
                            value: feedbackContextString
                        }
                    ],
                    feedbackTitle: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackTitle),
                    showTypeField: false,
                    customTextAreaLabel: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryTitle),
                    canBeContactedLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$CanContactLabel, {}),
                    enrolInResearchLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$EnrolLabel, {})
                })
            ]
        })
    }));
};
module.exports["AIFeedbackComponent"] = $00b0d3bf57a2c2c6$export$f9f34317e5bc3551;

});

parcelRegister("aFwxm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $321f16821ba8d88a$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $321f16821ba8d88a$export$ec2ba0e929740f73;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("kt1Xc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $2UyBL = parcelRequire("2UyBL");

parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $9Rf00 = parcelRequire("9Rf00");


var $in8wv = parcelRequire("in8wv");

const $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $45557925e309956a$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $irOoi.usePreloadedQuery)((0, $2UyBL.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines
    });
    if ((0, $dh538.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name,
        children: content
    });
    return content;
};
module.exports["AISnippetLoader"] = $45557925e309956a$export$f50b64530422ea99;

});

parcelRegister("2UyBL", function(module, exports) {
/**
 * @generated SignedSource<<83c7dc86ba34b94d5c11c0df299d770d>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $06d2529594a8e25b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06d2529594a8e25b$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $06d2529594a8e25b$export$2e2bcd8739ae039 = $06d2529594a8e25b$var$node;
module.exports["default"] = $06d2529594a8e25b$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("1TEgr"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const PLACEHOLDER_SIZE = props.height || 26;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ...animationProps,
            "data-testid": "emoji-placeholder",
            "data-css-target": "emoji-placeholder",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                width: `${PLACEHOLDER_SIZE}px`,
                height: `${PLACEHOLDER_SIZE}px`,
                margin: props.loadingMargin
            },
            className: (0, $gMc0m.default)([
                "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
            ])
        })));
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("1TEgr", function(module, exports) {

let $161a291a189419fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $161a291a189419fd$var$load("bRz9K"),
    $161a291a189419fd$var$load("6wr18"),
    $161a291a189419fd$var$load("kjZZD"),
    $161a291a189419fd$var$load("ffEVr"),
    $161a291a189419fd$var$load("2bmVk"),
    $161a291a189419fd$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("84PmI", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $22cce201c1053098$export$8d219f4743712a45 = ()=>{
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const { locale: locale } = (0, $8C5kA.default)();
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    // Will remove this after translation is ready
    // https://hello.jira.atlassian.cloud/browse/CFFD-871
    const isEnglishLocale = locale.toLowerCase().startsWith('en');
    return isRovoEnabled && isEnglishLocale && (0, $9wGTI.fg)('rovo_awareness_enabled');
};
module.exports["useIsEligibleRovoAwareness"] = $22cce201c1053098$export$8d219f4743712a45;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $46J5o = parcelRequire("46J5o");


var $80Dol = parcelRequire("80Dol");


var $4ZRmn = parcelRequire("4ZRmn");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $46J5o.MentionNameClient)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite) {
    let includeExternalCollaborators = false;
    const data = await (0, $4ZRmn.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("kN1ON", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");

class $68b29c117af189b3$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $6mYMS.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $6mYMS.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $68b29c117af189b3$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $3jsXx.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $68b29c117af189b3$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $68b29c117af189b3$export$2ae0434dccdcb77e;

});

parcelRegister("ly0vw", function(module, exports) {

var $jaPjp = parcelRequire("jaPjp");


var $bqMS3 = parcelRequire("bqMS3");

class $c68c97e41ce8434f$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $c68c97e41ce8434f$export$7b4524ed61cc8203 extends (0, $bqMS3.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $c68c97e41ce8434f$var$PresenceResource extends $c68c97e41ce8434f$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $c68c97e41ce8434f$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $c68c97e41ce8434f$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $c68c97e41ce8434f$export$80bae4549cafd20d();
    }
}
class $c68c97e41ce8434f$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $c68c97e41ce8434f$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $c68c97e41ce8434f$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $c68c97e41ce8434f$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($c68c97e41ce8434f$export$80bae4549cafd20d.isFocusState(presence)) return $c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $c68c97e41ce8434f$export$2e2bcd8739ae039 = $c68c97e41ce8434f$var$PresenceResource;
module.exports["default"] = $c68c97e41ce8434f$export$2e2bcd8739ae039;

});

parcelRegister("46J5o", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $k1vn7 = parcelRequire("k1vn7");

class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $k1vn7.MENTIONS_LOOKUP_LIMIT;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $k1vn7.preloadMentionsUsers)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}
module.exports["MentionNameClient"] = $71c2faaa98a432d0$export$82da878d725997a7;

});

parcelRegister("k1vn7", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $eSUdr = parcelRequire("eSUdr");


var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.queryAgg)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $eSUdr.default)`query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){id name}}`,
            variables: {
                ids: ids
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await $ed0e2cb9f5186ade$var$getUserData(ids);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};
module.exports["MENTIONS_LOOKUP_LIMIT"] = $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
module.exports["preloadMentionsUsers"] = $ed0e2cb9f5186ade$export$3adfff745266e959;

});

parcelRegister("80Dol", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
const $76cb501321125a14$var$MAX_RESULTS = 20;
class $76cb501321125a14$export$f500b4849378edff extends (0, $bqMS3.default) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const response = await this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            else this.isTeam(recommended);
            return this.convertToTeamMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        return {
            query: query,
            mentions: [
                ...mentions,
                ...jiraMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isUser(recommended) {
        return recommended.entityType === 'USER';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
            userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)() : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("4ZRmn", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $egFdh = parcelRequire("egFdh");

const $2de55e06904eb9f2$export$5ced7267a5286f97 = async ()=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $egFdh.MentionsProviderQuery)
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $2de55e06904eb9f2$export$5ced7267a5286f97;

});

parcelRegister("4IoVL", function(module, exports) {

var $eGqQQ = parcelRequire("eGqQQ");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $kEk2z = parcelRequire("kEk2z");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $kEk2z.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $kEk2z.fetchExternalShareMediaToken) : (0, $kEk2z.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async ()=>{
        const data = await dataGetter();
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter());
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $kEk2z.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? await (0, $kEk2z.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $kEk2z.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $kEk2z.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    if (!(0, $9wGTI.fg)('dlp_allow_content_dsp_check_without_space_details')) {
        // Note: If you can't provide spaceKey, you can't enable downloads in media viewer
        if (!spaceKey) return true;
    }
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch (e) {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async ()=>{
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: options.contentId,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $eGqQQ.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $eGqQQ.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    // We deliberately do NOT register the global listener dynamically each token fetch.
    // Instead we register once per provider creation with the then-current options snapshot.
    // If you need the listener to react to changed options, recreate the provider instead.
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadMediaClientConfig(opts);
        })(),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadCollectionId(opts);
        })()
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: initialOptions.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("kzNtP", function(module, exports) {

var $9ILXP = parcelRequire("9ILXP");


var $a4TK8 = parcelRequire("a4TK8");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $9ILXP.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $luiqu = parcelRequire("luiqu");


var $enSbc = parcelRequire("enSbc");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $luiqu.TemplateMediaSessionDownloadQuery),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $enSbc.TemplateMediaSessionUploadQuery),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("luiqu", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $440c59eac2d55b68$export$73060cbb44bbb81a = (0, $eSUdr.default)`query TemplateMediaSessionDownloadQuery($spaceKey:String$templateIds:[String]!$collectionId:String){templateMediaSession(spaceKey:$spaceKey templateIds:$templateIds collectionId:$collectionId){collections{key value}configuration{fileStoreUrl clientId}downloadToken{value duration}}}`;
module.exports["TemplateMediaSessionDownloadQuery"] = $440c59eac2d55b68$export$73060cbb44bbb81a;

});

parcelRegister("enSbc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f50e5e4b8dc0ddde$export$44b2025315083eb = (0, $eSUdr.default)`query TemplateMediaSessionUploadQuery($spaceKey:String$templateIds:[String]!$collectionId:String){templateMediaSession(spaceKey:$spaceKey templateIds:$templateIds collectionId:$collectionId){collections{key value}configuration{fileStoreUrl clientId}uploadToken{value duration}}}`;
module.exports["TemplateMediaSessionUploadQuery"] = $f50e5e4b8dc0ddde$export$44b2025315083eb;

});

parcelRegister("kEk2z", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $9ILXP = parcelRequire("9ILXP");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $fOjen = parcelRequire("fOjen");


var $gVyaz = parcelRequire("gVyaz");


var $1qiwK = parcelRequire("1qiwK");


var $7tJer = parcelRequire("7tJer");


var $25RVt = parcelRequire("25RVt");


var $egLSs = parcelRequire("egLSs");


var $gB1dF = parcelRequire("gB1dF");

let $0f304931c974fcbd$var$isFirstLoad = true;
const $0f304931c974fcbd$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment' && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint')) // Hard disable drag-and-drop upload functionality for comments
    return;
    // Use regular mutation for normal uploads (file browser, copy-paste, etc.)
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $0f304931c974fcbd$export$2b7fb70f168591f8 = (contentId)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $1qiwK.MediaDownloadTokenQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $0f304931c974fcbd$var$isFirstLoad ? 'cache-first' : 'network-only'
    }).then(/* onFulfilled */ (value)=>{
        $0f304931c974fcbd$var$isFirstLoad = false;
        try {
            $0f304931c974fcbd$var$throttleFetchMediaTokenErrors(contentId)(value?.errors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $0f304931c974fcbd$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $0f304931c974fcbd$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((_cacheKey)=>{
    /**
	 * The errors that happened last time. The `GraphQLError` instances are big
	 * and are not trivial to compare so `prevErrors` caches partial info.
	 */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
			 * The new/current errors which will become `prevErrors` at the end of
			 * this iteration.
			 */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $0f304931c974fcbd$export$e5e77dc812ab6e52 = (contentId)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $gVyaz.ExternalShareMediaDownloadTokenQuery),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $0f304931c974fcbd$export$db4c125247d46dd = (shareToken)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $gB1dF.ExternalContentMediaSessionQuery),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $0f304931c974fcbd$export$2b96f2ad626f63d2 = (contentId)=>(0, $hp2SH.getApolloClient)().query({
        query: (0, $7tJer.MediaUploadTokenQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache'
    });
const $0f304931c974fcbd$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $0f304931c974fcbd$export$2b96f2ad626f63d2(contentId);
    const client = (0, $hp2SH.getApolloClient)();
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await client.query({
            query: (0, $7tJer.MediaUploadTokenQuery),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return client.query({
        query: (0, $7tJer.MediaUploadTokenQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $0f304931c974fcbd$export$4205291ac54c446e = async (contentId, cloudId)=>{
    const client = (0, $hp2SH.getApolloClient)();
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await client.query({
            query: (0, $7tJer.CommentMediaUploadTokenQuery),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return client.query({
        query: (0, $7tJer.CommentMediaUploadTokenQuery),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $0f304931c974fcbd$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    let variables = {
        action: (0, $fOjen.DataSecurityPolicyAction).PAGE_EXPORT,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1
    };
    if (spaceKey) variables = {
        ...variables,
        spaceKey: spaceKey
    };
    /* Note -> relay compatible query replacement available, in @confluence/data-security package.
	 * Leaving as is for now, to preserve consistent behavior w/ this direct getApolloClient() call
	 */ // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $25RVt.DSPIsActionEnabledForContentQuery),
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first'
    });
};
module.exports["setAttachment"] = $0f304931c974fcbd$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $0f304931c974fcbd$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $0f304931c974fcbd$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $0f304931c974fcbd$export$db4c125247d46dd;
module.exports["getUploadToken"] = $0f304931c974fcbd$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $0f304931c974fcbd$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $0f304931c974fcbd$export$4777fc7c5d601381;

});

parcelRegister("gVyaz", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c52c799589981459$export$89a863448acd97ea = (0, $eSUdr.default)`query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id body{atlas_doc_format{mediaToken{token}}}}mediaConfiguration{clientId fileStoreUrl}}`;
module.exports["ExternalShareMediaDownloadTokenQuery"] = $c52c799589981459$export$89a863448acd97ea;

});

parcelRegister("7tJer", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $645f8a5252e0af3f$export$2b84bdb858844a5e = (0, $eSUdr.default)`query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value}configuration{clientId fileStoreUrl}collection}}`;
const $645f8a5252e0af3f$export$28c8b8565d1828fc = (0, $eSUdr.default)`query CommentMediaUploadTokenQuery($cloudId:ID!$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId contentId:$contentId){token{value}configuration{clientId fileStoreUrl}collection}}`;
module.exports["MediaUploadTokenQuery"] = $645f8a5252e0af3f$export$2b84bdb858844a5e;
module.exports["CommentMediaUploadTokenQuery"] = $645f8a5252e0af3f$export$28c8b8565d1828fc;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("gB1dF", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $ce4bd6b1fab7850a$export$ba0c5347c62cd2c8 = (0, $eSUdr.default)`query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl clientId}}}`;
module.exports["ExternalContentMediaSessionQuery"] = $ce4bd6b1fab7850a$export$ba0c5347c62cd2c8;

});

parcelRegister("kQiXs", function(module, exports) {

var $kEk2z = parcelRequire("kEk2z");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $kEk2z.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("7mpOv", function(module, exports) {

var $gejop = parcelRequire("gejop");


var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$var$UseIsAIEnabledForContentQuery = (0, $gejop.default);
const $7ae32555811cd45f$var$isAIReadAllowed = (operationsList)=>{
    if (operationsList) return operationsList.some((item)=>item?.operation === 'ai_read');
    else return false;
};
const $7ae32555811cd45f$export$cc5edac91cdebf9b = ({ contentId: contentId })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7ae32555811cd45f$var$UseIsAIEnabledForContentQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || (0, $lzcvT.isFedRamp)() || !isAdminHubAIEnabled && !shouldShowRovo || !(0, $9wGTI.fg)('confluence_ai_access_policy')
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    if (!(0, $9wGTI.fg)('confluence_ai_access_policy')) return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
    const aiRead = $7ae32555811cd45f$var$isAIReadAllowed(data?.content?.nodes?.[0]?.operations);
    return {
        isAIEnabledForContent: aiRead && isAdminHubAIEnabled,
        isRovoEnabledForContent: aiRead && shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("8hhCV", function(module, exports) {
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("ddaFh", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $99e4c30beb50cab3$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $99e4c30beb50cab3$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $99e4c30beb50cab3$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $99e4c30beb50cab3$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $99e4c30beb50cab3$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $99e4c30beb50cab3$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $99e4c30beb50cab3$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $99e4c30beb50cab3$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts);
        this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $99e4c30beb50cab3$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("aXYYd", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $7fbeb5806114903d$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $7fbeb5806114903d$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7fbeb5806114903d$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $7fbeb5806114903d$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7fbeb5806114903d$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $7fbeb5806114903d$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7fbeb5806114903d$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7fbeb5806114903d$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $7fbeb5806114903d$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("2yP1g", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $1dd655228c96cedb$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $1dd655228c96cedb$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1dd655228c96cedb$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $1dd655228c96cedb$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1dd655228c96cedb$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $1dd655228c96cedb$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $1dd655228c96cedb$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $1dd655228c96cedb$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $1dd655228c96cedb$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("dj7jL", function(module, exports) {
const $e6073c916b049162$export$bc4191f7b8dfa3a4 = {
    CONFLUENCE: 'confluence',
    JIRA: 'jira'
};
module.exports["PARENT_PRODUCTS"] = $e6073c916b049162$export$bc4191f7b8dfa3a4;

});

parcelRegister("1DfVr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4BDAe = parcelRequire("4BDAe");


var $io4wE = parcelRequire("io4wE");

const $af9c2f3d9e69f02f$export$46eb6ca3d43ca839 = (parentProduct, cloudId, onClose)=>{
    const { open: open, close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const openConfluencePagePreviewPanel = (0, $42omo.useCallback)((url, onOpen, panelData)=>{
        open({
            panel: {
                id: `confluence-page-preview-panel_${url.split('/').pop()}`,
                type: 'confluence-page',
                content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $io4wE.default), {
                        props: {
                            url: url,
                            parentProduct: parentProduct,
                            cloudId: cloudId,
                            panelData: panelData
                        },
                        entryPoints: {},
                        extraProps: {},
                        queries: {}
                    }),
                product: 'confluencePreviewPanel'
            },
            onOpen: onOpen
        });
    }, [
        open,
        parentProduct,
        cloudId
    ]);
    const closeConfluencePagePreviewPanel = (0, $42omo.useCallback)(()=>{
        close(onClose);
    }, [
        close,
        onClose
    ]);
    return {
        openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
        closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
    };
};
module.exports["useConfluencePagePreviewPanel"] = $af9c2f3d9e69f02f$export$46eb6ca3d43ca839;

});

parcelRegister("io4wE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8jHAi = parcelRequire("8jHAi");


var $cOrQJ = parcelRequire("cOrQJ");


var $bHGk9 = parcelRequire("bHGk9");


var $ibFXh = parcelRequire("ibFXh");

var $1GJJf = parcelRequire("1GJJf");

var $aSy6D = parcelRequire("aSy6D");

var $8APLM = parcelRequire("8APLM");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");


var $4BDAe = parcelRequire("4BDAe");


var $cu1WV = parcelRequire("cu1WV");


var $aXOz9 = parcelRequire("aXOz9");

const $178f91e075c3dc2a$var$styles = {
    body: "_16jlkb7n _18m915vq _ca0q1ejb _u5f31ejb _19bv1ejb"
};
const $178f91e075c3dc2a$var$ConfluencePagePreviewPanel = ({ props: { url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData } })=>{
    const { close: close, setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const themeState = (0, $cOrQJ.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        setAnalyticsClient((0, $aXOz9.initializeAnalyticsClient)(cloudId));
    }, [
        cloudId,
        setAnalyticsClient
    ]);
    const onModeChange = (mode)=>(0, $aXOz9.onEditMode)(mode, setPanelWidth);
    const onClose = ()=>{
        close();
    };
    const formattedUrl = (0, $42omo.useMemo)(()=>(0, $aXOz9.constructUrl)(themeState, url, panelData), [
        panelData,
        url,
        themeState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        testId: "confluence-preview-panel",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $3ZVni.PreviewPanelHeader), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                onClose: onClose,
                url: formattedUrl,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                        title: formatMessage((0, $cu1WV.messages).pageTitle),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                            label: "",
                            size: "medium"
                        })
                    }),
                    panelData?.actions && /*#__PURE__*/ (0, $l998X.jsx)((0, $1GJJf.PreviewPanelActionGroup), {
                        children: panelData.actions.expand && /*#__PURE__*/ (0, $l998X.jsx)((0, $8APLM.PreviewPanelExpand), {
                            onClick: panelData?.actions?.expand
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                styles: $178f91e075c3dc2a$var$styles.body,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bHGk9.EmbeddedConfluence), {
                    url: formattedUrl,
                    showFooter: false,
                    hasFooterLogo: false,
                    onModeChange: onModeChange,
                    parentProduct: parentProduct,
                    embeddedConfluenceSource: "confluence-page-preview-panel",
                    themeState: themeState
                })
            })
        ]
    });
};
var $178f91e075c3dc2a$export$2e2bcd8739ae039 = $178f91e075c3dc2a$var$ConfluencePagePreviewPanel;
module.exports["default"] = $178f91e075c3dc2a$export$2e2bcd8739ae039;

});

parcelRegister("bHGk9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");
var $jyd5r = parcelRequire("jyd5r");


var $kFwgS = parcelRequire("kFwgS");

var $I1nNR = parcelRequire("I1nNR");

var $kudeD = parcelRequire("kudeD");


var $9ImuD = parcelRequire("9ImuD");

const $4a221c0892a490b0$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
}; // @ts-ignore

const $4a221c0892a490b0$var$LazyEmbeddedConfluence = (0, $96msn.lazyForPaint)(()=>(parcelRequire("luk71")));
const $4a221c0892a490b0$export$c4789cfd0b0cd2c4 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9ImuD.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kudeD.PerformanceMetricsProvider), {
            contentType: props.mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? 'editPage' : 'viewPage',
            sourceComponent: 'EmbeddedConfluence',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4a221c0892a490b0$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($4a221c0892a490b0$var$LazyEmbeddedConfluence, {
                    ...props
                })
            })
        })
    });
module.exports["EmbeddedConfluence"] = $4a221c0892a490b0$export$c4789cfd0b0cd2c4;

});

parcelRegister("luk71", function(module, exports) {

let $fa4c002b596f7eaa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fa4c002b596f7eaa$var$load("8bZKp"),
    $fa4c002b596f7eaa$var$load("Wowvf"),
    $fa4c002b596f7eaa$var$load("hhss7"),
    $fa4c002b596f7eaa$var$load("kG8pF")
]).then(()=>parcelRequire('9bXIX'));

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("1GJJf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

const $1fc8fb56653d2345$export$b3bbf50939c515ce = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: testId,
        space: "space.050",
        alignBlock: "center",
        children: children
    });
};
module.exports["PreviewPanelActionGroup"] = $1fc8fb56653d2345$export$b3bbf50939c515ce;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, styles: styles })=>{
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!styles && styles),
        children: children
    });
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("8APLM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lOzEN = parcelRequire("lOzEN");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $91e6116a3cc9352a$export$40b251582cb3e1fe = ({ onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelExpand"] = $91e6116a3cc9352a$export$40b251582cb3e1fe;

});

parcelRegister("fZVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $920790d5dac34360$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $920790d5dac34360$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $8tdj3 = parcelRequire("8tdj3");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $fZVub = parcelRequire("fZVub");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        if (url) window.open($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                        appearance: "subtle",
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("cu1WV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $11543dd8ad4b06d3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pageTitle: {
        id: "confluence.page.preview.panel.pageTitle",
        defaultMessage: "Confluence Page"
    },
    whiteboardTitle: {
        id: "confluence.page.preview.panel.whiteboardTitle",
        defaultMessage: "Confluence Whiteboard"
    }
});
module.exports["messages"] = $11543dd8ad4b06d3$export$defe85febe8b728c;

});

parcelRegister("aXOz9", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $kFwgS = parcelRequire("kFwgS");


var $3WsBD = parcelRequire("3WsBD");

const $8f94b4972688fbbf$export$232fd46a0431e57a = (mode, setPanelWidth)=>mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? setPanelWidth(Math.floor(window.innerWidth / 2)) : {};
const $8f94b4972688fbbf$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $5DUgU.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $8f94b4972688fbbf$export$fbee84a774b6734d = (url, themeParam)=>{
    if (!themeParam) return url;
    if (!url.includes('?')) return `${url}?${themeParam}`;
    const [baseUrl, params] = url.split('?');
    const paramsArr = params.split('&');
    if (paramsArr.includes(themeParam)) return url;
    const otherParams = paramsArr.filter((param)=>!(param.split('=')[0] === 'themeState')).join('&');
    const newParams = otherParams ? `${themeParam}&${otherParams}` : themeParam;
    return `${baseUrl}?${newParams}`;
};
const $8f94b4972688fbbf$export$7d842b959fcdcd03 = (cloudId)=>{
    const analyticsClient = new (0, $a9sR2.default)({
        product: 'confluencePreviewPanel',
        env: $8f94b4972688fbbf$export$4acedbb0ac692186(window.location?.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    if (cloudId) analyticsClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
    return analyticsClient;
};
const $8f94b4972688fbbf$export$d9ce73382ee04318 = (originalUrl, embedUrl)=>{
    if (!embedUrl) return originalUrl;
    try {
        const previewUrl = new URL(embedUrl);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            const resolved = new URL(`https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`);
            // Preserve all original URL parameters
            const originalUrl_ = new URL(originalUrl);
            for (const [key, value] of originalUrl_.searchParams)resolved.searchParams.set(key, value);
            return resolved.toString();
        }
    } catch (error) {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
const $8f94b4972688fbbf$export$a639a54e55b70225 = (themeState, url, panelData)=>{
    const themeStateParam = themeState ? `themeState=${(0, $3WsBD.themeStateObjectToQueryString)(themeState)}` : '';
    const cardStateUrl = panelData ? $8f94b4972688fbbf$export$d9ce73382ee04318(url, panelData?.embedUrl) : url;
    const formattedUrl = themeStateParam ? $8f94b4972688fbbf$export$fbee84a774b6734d(cardStateUrl, themeStateParam) : cardStateUrl;
    return formattedUrl;
};
module.exports["onEditMode"] = $8f94b4972688fbbf$export$232fd46a0431e57a;
module.exports["initializeAnalyticsClient"] = $8f94b4972688fbbf$export$7d842b959fcdcd03;
module.exports["constructUrl"] = $8f94b4972688fbbf$export$a639a54e55b70225;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

const $f9885621a7911f5b$var$noop = ()=>{};
function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const reportErrorUFO = (0, $dh538.fg)('entry_point_container_ufo_report_error') ? (0, $eduVw.useUFOReportError)() : $f9885621a7911f5b$var$noop;
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        if ((0, $dh538.fg)('entry_point_container_ufo_report_error')) reportErrorUFO({
            name: id,
            errorMessage: error.message,
            errorStack: error.stack,
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("Asv1P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fTXBo = parcelRequire("fTXBo");

const $040545af9856ecf6$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const methodRef = (0, $fTXBo.useTrackedRef)(method);
    const payloadRef = (0, $fTXBo.useTrackedRef)(payload);
    return (0, $42omo.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};
module.exports["useCallbackWithAnalytics"] = $040545af9856ecf6$export$53c2b9c37c40e0d8;

});

parcelRegister("8DMug", function(module, exports) {

var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $g9Srd = parcelRequire("g9Srd");

/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $7a0922b43eeb26f0$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const exiting = (0, $g9Srd.useExitingPersistence)();
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    const setTimeout = (0, $jtTDB.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $dclyF.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4c48T.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4c48T.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $7a0922b43eeb26f0$export$2e2bcd8739ae039 = $7a0922b43eeb26f0$var$ShrinkOut;
module.exports["default"] = $7a0922b43eeb26f0$export$2e2bcd8739ae039;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("l7fKC", function(module, exports) {
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const isResponsiveEnabled = (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true);
    const toolbar = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, isResponsiveEnabled && $a3c14e992c9fdb13$var$styles.toolbarResponsive, isResponsiveEnabled && $a3c14e992c9fdb13$var$styles.hiddenSelectors, (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $a3c14e992c9fdb13$var$styles.toolbarSeparator, (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        role: "toolbar",
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'inline' : undefined,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j0UQK.ViewEventEmitter), {
                actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $l998X.jsx)((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    if (isResponsiveEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveWrapper), {
        children: wrappedToolbar
    });
    return wrappedToolbar;
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = ({ children: children, label: label, breakpointPreset: breakpointPreset, reducedBreakpoints: reducedBreakpoints })=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        reducedBreakpoints: reducedBreakpoints,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
            role: "toolbar",
            "aria-label": label,
            "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar),
        role: "toolbar",
        "aria-label": label,
        "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined,
        children: children
    });
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw",
    fullpage: "_t3a8glyw _1x5z1ule _6nrqglyw _1fq21ule _1ireglyw _zy2m1ule _hfbeglyw _gw6d1ule",
    reduced: "_j094glyw _1mc51ule _gipeglyw _311r1ule _11u4glyw _v1i61ule _19x4glyw _qck01ule",
    jiraIssue: "_3tohglyw _b5je1ule _1y2iglyw _w3191ule _tr9jglyw _1xve1ule _19x4glyw _qck01ule",
    jsmComment: "_gp7jglyw _luyr1ule _1gcoglyw _bx071ule _dtzlglyw _5ur11ule _19x4glyw _qck01ule",
    confluenceComment: "_j094glyw _1mc51ule _gipeglyw _311r1ule _4kfbglyw _j1h31ule _19x4glyw _qck01ule",
    responsiveRules: "_t3a8glyw _1x5z1ule _6nrqglyw _1fq21ule _1ireglyw _zy2m1ule _hfbeglyw _gw6d1ule",
    responsiveRulesReduced: "_j094glyw _1mc51ule _gipeglyw _311r1ule _11u4glyw _v1i61ule _19x4glyw _qck01ule",
    responsiveRulesReducedOverridden: "_e2nbglyw _ol4q1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset, reducedBreakpoints: reducedBreakpoints })=>{
    // Use new preset-based logic when preset is provided and feature gate is enabled
    if (breakpointPreset && (0, $dh538.fg)('platform_editor_toolbar_aifc_responsive_improve')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($bc8e1bf6110fb52a$var$styles.responsiveContainer, $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset]),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($bc8e1bf6110fb52a$var$styles.responsiveContainer, reducedBreakpoints ? $bc8e1bf6110fb52a$var$styles.responsiveRulesReduced : $bc8e1bf6110fb52a$var$styles.responsiveRules, reducedBreakpoints && (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $bc8e1bf6110fb52a$var$styles.responsiveRulesReducedOverridden),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("12Oyv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $dh538 = parcelRequire("dh538");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            let index = doc?.activeElement ? focusableElements.findIndex((el)=>el === doc?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if ((0, $dh538.fg)('platform_editor_toolbar_aifc_patch_7')) switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
            else switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("j0UQK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $d7ZU3 = parcelRequire("d7ZU3");

var $led7c = parcelRequire("led7c");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$var$isSSR = Boolean(undefined);
const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $8cc71206023006a6$var$isSSR) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("7pxpu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eWRwJ = parcelRequire("eWRwJ");

var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $sXTCx = parcelRequire("sXTCx");


var $aFv56 = parcelRequire("aFv56");


var $l4JAB = parcelRequire("l4JAB");


var $655oj = parcelRequire("655oj");


const $669d74d97f0070d8$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("bTgMt"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $669d74d97f0070d8$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $655oj.useDatasourceClientExtension)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("bTgMt"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $669d74d97f0070d8$export$612752b1e088a45e;
module.exports["useDatasourceLifecycleAnalytics"] = $669d74d97f0070d8$export$c82e48d9fd97c55b;

});

parcelRegister("sXTCx", function(module, exports) {
const $8b92489052cdb314$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $8b92489052cdb314$export$3f072f06b90c3985;

});

parcelRegister("aFv56", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $260a3ee885876edc$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $260a3ee885876edc$export$2e2bcd8739ae039 = $260a3ee885876edc$var$createEventPayload;
module.exports["default"] = $260a3ee885876edc$export$2e2bcd8739ae039;

});

parcelRegister("l4JAB", function(module, exports) {
/* eslint-disable compat/compat */ const $1f035c9bfd2157e4$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $1f035c9bfd2157e4$export$51d09170c61ebe04;

});

parcelRegister("bTgMt", function(module, exports) {

let $8a81d9124884779c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a81d9124884779c$var$load("jkPqm"),
    $8a81d9124884779c$var$load("9wxKg"),
    $8a81d9124884779c$var$load("87NBA"),
    $8a81d9124884779c$var$load("6cVEd")
]).then(()=>parcelRequire('bSBwg'));

});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");



class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("gQLyD")),
                (parcelRequire("9uSZV"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("gQLyD", function(module, exports) {

let $c44664a124e9c48f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c44664a124e9c48f$var$load("h4k4y"),
    $c44664a124e9c48f$var$load("fGT64"),
    $c44664a124e9c48f$var$load("jkPqm"),
    $c44664a124e9c48f$var$load("7whwt"),
    $c44664a124e9c48f$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("9uSZV", function(module, exports) {

let $6ea193cc18f5fbcd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6ea193cc18f5fbcd$var$load("fGT64"),
    $6ea193cc18f5fbcd$var$load("f35QR"),
    $6ea193cc18f5fbcd$var$load("eVYW1"),
    $6ea193cc18f5fbcd$var$load("ls0Um"),
    $6ea193cc18f5fbcd$var$load("020xd"),
    $6ea193cc18f5fbcd$var$load("eTBsW"),
    $6ea193cc18f5fbcd$var$load("bYxCZ"),
    $6ea193cc18f5fbcd$var$load("6HBYC"),
    $6ea193cc18f5fbcd$var$load("eDqo1"),
    $6ea193cc18f5fbcd$var$load("lxiFd"),
    $6ea193cc18f5fbcd$var$load("1oiJ6"),
    $6ea193cc18f5fbcd$var$load("huUvS"),
    $6ea193cc18f5fbcd$var$load("6wr18"),
    $6ea193cc18f5fbcd$var$load("h4k4y"),
    $6ea193cc18f5fbcd$var$load("4lnLb"),
    $6ea193cc18f5fbcd$var$load("6vhrJ"),
    $6ea193cc18f5fbcd$var$load("ffEVr"),
    $6ea193cc18f5fbcd$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("cc99d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0db38dacc0710f$var$_react = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("42omo")));

var $8e0db38dacc0710f$var$_baseNew = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8e0db38dacc0710f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0db38dacc0710f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $8e0db38dacc0710f$var$_react.default.createElement($8e0db38dacc0710f$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$8e0db38dacc0710f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $8e0db38dacc0710f$var$_default = module.exports.default = $8e0db38dacc0710f$var$FieldTextIcon;

});

parcelRegister("51lK8", function(module, exports) {

var $4T4vf = parcelRequire("4T4vf");


var $f1MqO = parcelRequire("f1MqO");

const $883f68a01157ae2e$var$api = (0, $f1MqO.makeApi)({
    monitor: (0, $4T4vf.monitorForElements)
});
const $883f68a01157ae2e$export$4b66ee8317094cdb = $883f68a01157ae2e$var$api.autoScroll;
const $883f68a01157ae2e$export$c9168f41de61f525 = $883f68a01157ae2e$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $883f68a01157ae2e$export$4b66ee8317094cdb;

});

parcelRegister("f1MqO", function(module, exports) {

var $bSjaC = parcelRequire("bSjaC");

parcelRequire("eItNK");
var $aYpzB = parcelRequire("aYpzB");


var $jtbk8 = parcelRequire("jtbk8");


var $ejbcR = parcelRequire("ejbcR");


var $h66Yh = parcelRequire("h66Yh");

function $d8d8df98db63a460$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $bSjaC.combine)((0, $ejbcR.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $aYpzB.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $aYpzB.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $h66Yh.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $jtbk8.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $d8d8df98db63a460$export$b8fa21320a811083;

});

parcelRegister("eItNK", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("aYpzB")).once);

var $aYpzB = parcelRequire("aYpzB");


});

parcelRegister("jtbk8", function(module, exports) {
parcelRequire("5jQxm");
var $66utD = parcelRequire("66utD");


var $1PEak = parcelRequire("1PEak");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $ae06eb7a26d5c40d$var$schedulers = new Map();
function $ae06eb7a26d5c40d$export$5cff7ac265db316a(monitor) {
    const scheduler = $ae06eb7a26d5c40d$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $ae06eb7a26d5c40d$var$makeScheduler(monitor);
    $ae06eb7a26d5c40d$var$schedulers.set(monitor, created);
    return created;
}
function $ae06eb7a26d5c40d$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $66utD.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $1PEak.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $1PEak.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $ae06eb7a26d5c40d$export$5cff7ac265db316a;

});

parcelRegister("1PEak", function(module, exports) {
const $b8aa3381b771fe03$var$ledger = new Map();
const $b8aa3381b771fe03$var$requested = new Set();
function $b8aa3381b771fe03$export$8c764c3f2fc3d2d2(element) {
    $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element);
    const entry = $b8aa3381b771fe03$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b8aa3381b771fe03$var$ledger.set(element, fresh);
    return fresh;
}
function $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element) {
    $b8aa3381b771fe03$var$requested.add(element);
}
function $b8aa3381b771fe03$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b8aa3381b771fe03$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b8aa3381b771fe03$var$ledger.forEach((_, element)=>{
        if (!$b8aa3381b771fe03$var$requested.has(element)) $b8aa3381b771fe03$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b8aa3381b771fe03$var$requested.clear();
}
function $b8aa3381b771fe03$export$13ae770ed39b71ea() {
    $b8aa3381b771fe03$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b8aa3381b771fe03$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b8aa3381b771fe03$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b8aa3381b771fe03$export$13ae770ed39b71ea;

});

parcelRegister("ejbcR", function(module, exports) {
const $ba3cc2be2c89e337$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $ba3cc2be2c89e337$export$aea217a45095ce11 = `[${$ba3cc2be2c89e337$export$4b152ab55cad4fd6}="true"]`;
function $ba3cc2be2c89e337$export$4ec12fb57dfebd53(element) {
    element.setAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $ba3cc2be2c89e337$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $ba3cc2be2c89e337$export$4ec12fb57dfebd53;

});

parcelRegister("h66Yh", function(module, exports) {

var $h9dtK = parcelRequire("h9dtK");


var $1PEak = parcelRequire("1PEak");


var $ejbcR = parcelRequire("ejbcR");


var $6DDhO = parcelRequire("6DDhO");

function $568f43811c88fe4c$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $568f43811c88fe4c$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $ejbcR.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $568f43811c88fe4c$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $1PEak.markAndGetEngagement)(element);
    const config = (0, $h9dtK.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $6DDhO.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $568f43811c88fe4c$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $1PEak.markAndGetEngagement)(element);
        const config = (0, $h9dtK.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $6DDhO.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $568f43811c88fe4c$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $568f43811c88fe4c$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(remainder)) return;
    $568f43811c88fe4c$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $568f43811c88fe4c$export$233199807749476d;

});

parcelRegister("h9dtK", function(module, exports) {
const $35bbc9592dd770aa$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $35bbc9592dd770aa$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $35bbc9592dd770aa$export$e96028ec7ff9d079(provided) {
    return {
        ...$35bbc9592dd770aa$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $35bbc9592dd770aa$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $35bbc9592dd770aa$export$e96028ec7ff9d079;

});

parcelRegister("6DDhO", function(module, exports) {

var $hhm38 = parcelRequire("hhm38");


var $ajYex = parcelRequire("ajYex");


var $lFBSq = parcelRequire("lFBSq");


var $wfJXn = parcelRequire("wfJXn");


var $eIOs5 = parcelRequire("eIOs5");


var $6UNNA = parcelRequire("6UNNA");

function $d6a7fe667f94accc$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $d6a7fe667f94accc$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $d6a7fe667f94accc$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ajYex.edges).reduce((map, edge)=>{
        const hitbox = (0, $lFBSq.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ajYex.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $eIOs5.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $6UNNA.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $hhm38.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $d6a7fe667f94accc$export$6cfa6dfe6898b98f;

});

parcelRegister("hhm38", function(module, exports) {
const $7d638df63a9348c1$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $7d638df63a9348c1$export$ccd6d9407403fcad;

});

parcelRegister("ajYex", function(module, exports) {
const $e2d5736e549d9f1a$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e2d5736e549d9f1a$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $e2d5736e549d9f1a$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $e2d5736e549d9f1a$export$7fc144124ccf8292;

});

parcelRegister("lFBSq", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $84ZAS = parcelRequire("84ZAS");

function $c2a3ef074bb4151d$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $8e8VQ.axisLookup)[axis];
        const side = (0, $84ZAS.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $c2a3ef074bb4151d$export$b9a449c20abb0e9 = {
    top: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $c2a3ef074bb4151d$export$b9a449c20abb0e9;

});

parcelRegister("8e8VQ", function(module, exports) {
const $88deb29ded672487$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $88deb29ded672487$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $88deb29ded672487$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $88deb29ded672487$var$vertical,
        crossAxis: $88deb29ded672487$var$horizontal
    },
    horizontal: {
        mainAxis: $88deb29ded672487$var$horizontal,
        crossAxis: $88deb29ded672487$var$vertical
    }
};
module.exports["axisLookup"] = $88deb29ded672487$export$42e42cdab35a2b96;

});

parcelRegister("84ZAS", function(module, exports) {
const $5948654a23ca7c24$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $5948654a23ca7c24$export$a45c0cd714a4dbaa;

});

parcelRegister("wfJXn", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $htU2u = parcelRequire("htU2u");


var $84ZAS = parcelRequire("84ZAS");

// We want a consistent scroll speed across devices, regardless of framerate
function $3f544cf5427e20fd$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $3f544cf5427e20fd$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $8e8VQ.axisLookup)[axis];
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $3f544cf5427e20fd$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $3f544cf5427e20fd$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $3f544cf5427e20fd$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $htU2u.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $3f544cf5427e20fd$export$470a2ff46db8cee8;

});

parcelRegister("htU2u", function(module, exports) {
function $1fec9052eae48826$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $1fec9052eae48826$export$1a29de000a332d74;

});

parcelRegister("eIOs5", function(module, exports) {
function $602bab09026eed2a$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $602bab09026eed2a$export$7120fdbd90bd1292;

});

parcelRegister("6UNNA", function(module, exports) {
function $92037081dc0ecd04$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $92037081dc0ecd04$export$cda7a9d4399bf2e3;

});

parcelRegister("1MUpo", function(module, exports) {
const $72d61fc920bbc248$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $72d61fc920bbc248$export$27903d543b563e39;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("btHGY", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $fKV6c = parcelRequire("fKV6c");

const $9af2e217c87bad78$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fKV6c.MediaImageWithMediaClient), {
            ...props
        })
    });
module.exports["MediaImageWithErrorBoundary"] = $9af2e217c87bad78$export$758a2fef95a29ad0;

});

parcelRegister("fKV6c", function(module, exports) {
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7soXU = parcelRequire("7soXU");


var $k0QVR = parcelRequire("k0QVR");


var $dh538 = parcelRequire("dh538");

const $30e6950c7927d39d$var$copyDivStyles = null;
const $30e6950c7927d39d$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $k0QVR.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $dh538.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $gMc0m.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $l998X.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $30e6950c7927d39d$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $42omo.useMemo)(()=>(0, $7soXU.withMediaClient)($30e6950c7927d39d$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $l998X.jsx)(MediaImageComponent, {
        ...props
    });
};
module.exports["MediaImageWithMediaClient"] = $30e6950c7927d39d$export$8acd7eecc88dfeb5;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("7ShCl", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $cgtv4.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    }
});
module.exports["aiMessages"] = $3d55d2ba43147efd$export$480e55f805d7990f;

});

parcelRegister("b4emg", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");

const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $8841f32d2d46ed1f$export$d109ab46c9575565;

});

parcelRegister("d7r2R", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $376a36c4bbddbe1c$var$Loading = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: props.alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
var $376a36c4bbddbe1c$export$2e2bcd8739ae039 = $376a36c4bbddbe1c$var$Loading;
module.exports["default"] = $376a36c4bbddbe1c$export$2e2bcd8739ae039;

});

parcelRegister("ls2Fy", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $cgtv4 = parcelRequire("cgtv4");

const $19b135ef0d7ad272$export$21be832820f3e6e6 = (0, $cgtv4.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $19b135ef0d7ad272$export$21be832820f3e6e6;

});

parcelRegister("5jDm8", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3ded415c71850a5f$var$nativeFloor = Math.floor, $3ded415c71850a5f$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $3ded415c71850a5f$var$baseRandom(lower, upper) {
    return lower + $3ded415c71850a5f$var$nativeFloor($3ded415c71850a5f$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $3ded415c71850a5f$var$baseRandom;

});

parcelRegister("a6t12", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $8j9VY = parcelRequire("8j9VY");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");


var $5XsiK = parcelRequire("5XsiK");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");


var $dD7ks = parcelRequire("dD7ks");


var $9wGTI = parcelRequire("9wGTI");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $cgtv4.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const reportingLines = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $42omo.useMemo)(()=>(0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $42omo.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $5XsiK.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId).then(push, ()=>{});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            isVisible: (0, $9wGTI.fg)('fix_profilecard_trigger_isvisible') ? undefined : isVisible,
            onVisibilityChange: onVisibilityChange || ((changedIsVisible)=>{
                setIsVisible(changedIsVisible);
            }),
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ariaLabel: ariaLabel
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("bedVD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");

const $e4e11ee9fe4a88c9$var$i18n = (0, $cgtv4.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = ({ followed: followed })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip),
        position: "bottom",
        testId: "feed-follow-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow)));
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $eSUdr.default)`query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}`;
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $eSUdr.default)`mutation useFeedFollowFeedFollowMutation($follow:[ID]$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow unfollowUsers:$unfollow}){success}}`;
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $xQxzY.useQuery)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error)
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $1KmJq.useMutation)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            },
            'FeedFollowQuery'
        ]
    });
    const followedUsers = data?.getFeedUserConfig?.accountIds;
    const getToggleFollowUser = (0, $42omo.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch (_) {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    const feedFollowData = {
        renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
        loading: queryLoading,
        getToggleFollowUser: getToggleFollowUser,
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        followedUsers: followedUsers
    };
    const feedFollowDataMemoized = (0, $42omo.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? feedFollowDataMemoized : feedFollowData;
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("bumSD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7c52C = parcelRequire("7c52C");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $2XqLN.default)((cloudId, /**
		 * @deprecated This is no longer used we should remove in a future
		 */ _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $7c52C.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $8zKPT = parcelRequire("8zKPT");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $hp2SH = parcelRequire("hp2SH");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $8zKPT.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const UserProfileClientForConfluencePromise = (0, $hp2SH.getApolloClient)().query({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            }
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/**
 * @generated SignedSource<<6837b1662181fa3feff08f9973248f40>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $eSUdr.default)`query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false id:$userId){id confluence{permissionType}}entitlements{externalCollaborator{isEntitled}}}`;
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("gj42z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again"
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = ({ feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: feedConfigError
    }) : null, mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (showErrorFlag) flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
        });
        return null;
    })) : null);
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("8QQGs", function(module, exports) {
"use strict";
var $671c0bfbaf864118$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $671c0bfbaf864118$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $671c0bfbaf864118$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $671c0bfbaf864118$var$catchError;
var $671c0bfbaf864118$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $671c0bfbaf864118$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $671c0bfbaf864118$var$CatchSubscriber = function(_super) {
    $671c0bfbaf864118$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dZ9AU.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("2mnXV", function(module, exports) {
"use strict";
var $1b8039eb254298fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1b8039eb254298fd$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $1b8039eb254298fd$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $1b8039eb254298fd$var$distinctUntilChanged;
var $1b8039eb254298fd$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8039eb254298fd$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8039eb254298fd$var$DistinctUntilChangedSubscriber = function(_super) {
    $1b8039eb254298fd$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3FcLR.tryCatch(this.keySelector)(value);
            if (key === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3FcLR.tryCatch(this.compare)(this.key, key);
            if (result === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3VDUL", function(module, exports) {
"use strict";
var $2dc5a83127dcb05a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2dc5a83127dcb05a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2dc5a83127dcb05a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2dc5a83127dcb05a$var$skipWhile;
var $2dc5a83127dcb05a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc5a83127dcb05a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc5a83127dcb05a$var$SkipWhileSubscriber = function(_super) {
    $2dc5a83127dcb05a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("j8M4E", function(module, exports) {
"use strict";
var $def40e2be1e8c847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $def40e2be1e8c847$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $def40e2be1e8c847$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $def40e2be1e8c847$var$switchMap;
var $def40e2be1e8c847$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $def40e2be1e8c847$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $def40e2be1e8c847$var$SwitchMapSubscriber = function(_super) {
    $def40e2be1e8c847$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("i3vZV", function(module, exports) {
"use strict";
var $d25153e5d88b6a52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

function $d25153e5d88b6a52$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $d25153e5d88b6a52$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $d25153e5d88b6a52$var$timeInterval;
var $d25153e5d88b6a52$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $d25153e5d88b6a52$var$TimeInterval;
var $d25153e5d88b6a52$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d25153e5d88b6a52$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d25153e5d88b6a52$var$TimeIntervalSubscriber = function(_super) {
    $d25153e5d88b6a52$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $d25153e5d88b6a52$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ePuNq", function(module, exports) {
"use strict";
var $acbdb7992e24bbb8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6GdLZ = parcelRequire("6GdLZ");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $acbdb7992e24bbb8$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteTimeout = $kVeeY.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $acbdb7992e24bbb8$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6GdLZ.TimeoutError()));
    };
}
module.exports.timeout = $acbdb7992e24bbb8$var$timeout;
var $acbdb7992e24bbb8$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acbdb7992e24bbb8$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acbdb7992e24bbb8$var$TimeoutSubscriber = function(_super) {
    $acbdb7992e24bbb8$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GdLZ", function(module, exports) {
"use strict";
var $4dd15960f755eae6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4dd15960f755eae6$var$TimeoutError = function(_super) {
    $4dd15960f755eae6$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4dd15960f755eae6$var$TimeoutError;

});

parcelRegister("5h38X", function(module, exports) {
"use strict";
var $3d70fa8830a46307$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $bGuMq = parcelRequire("bGuMq");

/**
 * @class BehaviorSubject<T>
 */ var $3d70fa8830a46307$var$BehaviorSubject = function(_super) {
    $3d70fa8830a46307$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($augeV.Subject);
module.exports.BehaviorSubject = $3d70fa8830a46307$var$BehaviorSubject;

});

parcelRegister("8lYIw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8T1Wf = parcelRequire("8T1Wf");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { target: target, name: name, href: href = null, to: to = null, params: params = {} } = props;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: ""
    });
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    return match && target !== '_blank' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
        ...props,
        ref: ref,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: path
    });
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)(({ path: path, ...parentProps }, ref)=>{
    const { children: children, className: className, target: target, testId: testId, style: style, id: id } = parentProps;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    const onAnchorLinkClick = (e)=>{
        // @ts-ignore this should probably be `e.currentTarget`
        onPageReload(e.target.getAttribute('href'), false);
        if (parentProps.onClick) parentProps.onClick(e);
    };
    const onAnchorContextMenuClick = (e)=>{
        parentProps.onContextMenu?.(e);
    };
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: path,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onAnchorLinkClick,
        onContextMenu: onAnchorContextMenuClick,
        target: target,
        id: id,
        rel: target === '_blank' ? 'noreferrer' : undefined,
        "data-testid": testId,
        ref: ref,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ match: match, ...parentProps }, ref)=>{
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    const onMouseDownCapture = async ()=>preloadRoute(match);
    /**
   * Define the `onClick` handler for `react-router-dom`
   * [Link](https://github.com/ReactTraining/react-router/blob/346153e38365e6a88657ce2e4e5acada290fc430/packages/react-router-dom/modules/Link.js)
   * to make sure the SPA transition will go through RouteManager's push
   * method. Under the hood `RouteManager#push` still calls `history.push`, but
   * in addition it can reach out specified route policy if any. If not
   * eligible for SPA transition, then it will continue delegate to
   * react-router-dom Link to handle the click.
   */ const onClick = (event)=>{
        if (parentProps.onClick) parentProps.onClick(event);
        const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
        if (!event.defaultPrevented && details?.href) {
            event.preventDefault();
            routesContext.push(details.href);
        }
    };
    const onContextMenu = (e)=>{
        parentProps.onContextMenu?.(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8T1Wf.Link), {
        to: `${match.pathname}${match.search}${match.hash}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onClick,
        onContextMenu: onContextMenu,
        onMouseDownCapture: onMouseDownCapture,
        innerRef: ref,
        id: id,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children);
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("8T1Wf", function(module, exports) {

var $QU6QS = parcelRequire("QU6QS");


var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");




var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $dRnqM = parcelRequire("dRnqM");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6784f6b3e56cd8b3$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6784f6b3e56cd8b3$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $6784f6b3e56cd8b3$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $fgJFQ.createLocation)(to, null, null, currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef === "undefined") $6784f6b3e56cd8b3$var$forwardRef = $6784f6b3e56cd8b3$var$forwardRefShim;
function $6784f6b3e56cd8b3$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6784f6b3e56cd8b3$var$LinkAnchor = $6784f6b3e56cd8b3$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $bDniu.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $7Q5yr.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6784f6b3e56cd8b3$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a = $6784f6b3e56cd8b3$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6784f6b3e56cd8b3$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $bDniu.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history;
        var location = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $7Q5yr.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6784f6b3e56cd8b3$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $fgJFQ.createPath)(context.location) === (0, $fgJFQ.createPath)($6784f6b3e56cd8b3$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props);
    });
});
var $6784f6b3e56cd8b3$var$toType, $6784f6b3e56cd8b3$var$refType;
var $6784f6b3e56cd8b3$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef$1 === "undefined") $6784f6b3e56cd8b3$var$forwardRef$1 = $6784f6b3e56cd8b3$var$forwardRefShim$1;
function $6784f6b3e56cd8b3$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6784f6b3e56cd8b3$export$b0d92dbee9b5b60d = $6784f6b3e56cd8b3$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $bDniu.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $QU6QS.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $6784f6b3e56cd8b3$var$joinClassnames(className, activeClassName);
            style = (0, $7Q5yr.default)({}, style, activeStyle);
        }
        var props = (0, $7Q5yr.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim$1 !== $6784f6b3e56cd8b3$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6784f6b3e56cd8b3$export$a6c7ac8248d6e38a, props);
    });
});
var $6784f6b3e56cd8b3$var$ariaCurrentType;
module.exports["Link"] = $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a;

});

parcelRegister("9Z0wk", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $5e18336ff60a0b69$var$editedContentStyles = {
    root: "_syaz1rpy"
};
const $5e18336ff60a0b69$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $gMc0m.default)([
            $5e18336ff60a0b69$var$editedContentStyles.root
        ]),
        children: children
    });
$5e18336ff60a0b69$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5e18336ff60a0b69$export$2e2bcd8739ae039 = $5e18336ff60a0b69$var$Edited;
module.exports["default"] = $5e18336ff60a0b69$export$2e2bcd8739ae039;

});

parcelRegister("b7C1K", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $818dd8908b5ce504$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $818dd8908b5ce504$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $818dd8908b5ce504$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $818dd8908b5ce504$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $818dd8908b5ce504$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $818dd8908b5ce504$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $818dd8908b5ce504$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $818dd8908b5ce504$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $818dd8908b5ce504$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const atlGeneralHeightChanges = (0, $42omo.useRef)([]);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)(()=>{
        if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'];
            return initialHeight ?? 0;
        } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
    });
    const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const isATLGeneralWebPanelFixed = panels.length > 0;
    (0, $42omo.useEffect)(()=>{
        const listener = (e)=>{
            let newHeight;
            if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
                setWebPanelHeight(e?.detail?.height ?? 0);
                newHeight = e?.detail?.height ?? 0;
            } else {
                setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
            }
            // Track ATL General Webpanel height changes for page initial load
            if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__)) {
                // Last height is the SSR rendered height or last observed height
                const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                // If the last height is not the same as the new height, track the change
                if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                window['__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__'] = atlGeneralHeightChanges.current;
            }
        };
        if (isATLGeneralWebPanelFixed) document.addEventListener('atlGeneralWebPanelHeightUpdated', listener);
        return ()=>{
            if (isATLGeneralWebPanelFixed) document.removeEventListener('atlGeneralWebPanelHeightUpdated', listener);
        };
    }, [
        isATLGeneralWebPanelFixed
    ]);
    return {
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        atlGeneralWebPanelHeight: webPanelHeight
    };
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $8pvtc = parcelRequire("8pvtc");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const { loading: loading, data: data, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8pvtc.WebPanelLocationQuery), {
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    const panels = (data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: loading,
        error: error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("gtauf", function(module, exports) {
const $5a9379de970b4a33$export$aafb32b192c8228c = (node)=>{
    return {
        blockInstanceId: node.attrs.localId,
        content: node.content.toJSON(),
        resourceId: node.attrs.resourceId
    };
};
const $5a9379de970b4a33$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $5a9379de970b4a33$export$e48674e492c1dce3 = (localId, resourceId)=>{
    return {
        type: 'bodiedSyncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $5a9379de970b4a33$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$5a9379de970b4a33$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined) || [];
};
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $5a9379de970b4a33$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $5a9379de970b4a33$export$c5b34fb9069ebb1d;
module.exports["createBodiedSyncBlockNode"] = $5a9379de970b4a33$export$e48674e492c1dce3;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $5a9379de970b4a33$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $5a9379de970b4a33$export$18b85168a73dad03;

});

parcelRegister("lEQpi", function(module, exports) {

var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
    }
    constructor(dataProvider){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        // In future, if reference manager needs to reach to source manager and read it's current in memorey cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider);
    }
}
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;

});

parcelRegister("3RNNl", function(module, exports) {

var $4FxUL = parcelRequire("4FxUL");


var $awHlv = parcelRequire("awHlv");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");

class $bf9ff2ea047058dc$export$fb04276dca31302e {
    /**
   * Refreshes the subscriptions for all sync blocks.
   * @returns {Promise<void>}
   */ async refreshSubscriptions() {
        if (this.isRefreshingSubscriptions) return;
        this.isRefreshingSubscriptions = true;
        const syncBlocks = [];
        for (const [resourceId, callbacks] of this.subscriptions.entries())Object.keys(callbacks).forEach((localId)=>{
            syncBlocks.push((0, $gtauf.createSyncBlockNode)(localId, resourceId));
        });
        try {
            // fetch latest data for all subscribed sync blocks
            // this function will update the cache and call the subscriptions
            await this.fetchSyncBlocksData(syncBlocks);
        } catch (error) {
        // TODO: EDITOR-1921 - add error analytics
        } finally{
            this.isRefreshingSubscriptions = false;
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        if (!resourceId || !this.dataProvider) return;
        if (this.syncBlockURLRequests.get(resourceId)) return;
        this.syncBlockURLRequests.set(resourceId, true);
        const existingSyncBlock = this.getFromCache(resourceId);
        if (!existingSyncBlock) return;
        // skip if source URL and title are already present
        if (existingSyncBlock.data?.sourceURL && existingSyncBlock.data?.sourceTitle) return;
        const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId } = existingSyncBlock.data || {};
        if (!sourceAri || !product || !blockInstanceId) return;
        this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product).then((sourceInfo)=>{
            if (!sourceInfo) return;
            this.updateCacheWithSourceInfo(resourceId, sourceInfo);
            if (sourceInfo.title) this.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
        }).finally(()=>{
            this.syncBlockURLRequests.delete(resourceId);
        });
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return Promise.resolve([]);
        if (!this.dataProvider) throw new Error('Data provider not set');
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [], blocksWithNotFoundError = [];
        syncBlockNodes.forEach((node)=>{
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error === (0, $awHlv.SyncBlockError).NotFound) blocksWithNotFoundError.push(existingSyncBlock);
            else nodesToFetch.push(node);
        });
        const data = await this.dataProvider.fetchNodesData(nodesToFetch);
        if (!data) throw new Error('Failed to fetch sync block node data');
        const resolvedData = [];
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) return;
            if (syncBlockInstance.error) {
                this.updateCache(syncBlockInstance);
                resolvedData.push(syncBlockInstance);
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            resolvedData.push(resolvedSyncBlockInstance);
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return [
            ...resolvedData,
            ...blocksWithNotFoundError
        ];
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const { resourceId: resourceId } = syncBlock;
        if (resourceId) {
            this.syncBlockCache.set(resourceId, syncBlock);
            const callbacks = this.subscriptions.get(resourceId);
            if (callbacks) Object.values(callbacks).forEach((callback)=>{
                callback(syncBlock);
            });
        }
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    getFromCache(resourceId) {
        return this.syncBlockCache.get(resourceId);
    }
    deleteFromCache(resourceId) {
        this.syncBlockCache.delete(resourceId);
        this.providerFactories.delete(resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // call the callback immediately if we have cached data
        const cachedData = this.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.fetchSyncBlocksData([
            (0, $gtauf.createSyncBlockNode)(localId, resourceId)
        ]).catch(()=>{});
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) {
                    this.subscriptions.delete(resourceId);
                    this.deleteFromCache(resourceId);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribe(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        return this.subscribeToSyncBlock(resourceId, localId, callback);
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock) return undefined;
        return syncBlock.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        if (!this.dataProvider) return undefined;
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = this.dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        }
        if (providerCreator) this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        return providerFactory;
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        if (!this.dataProvider) return;
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        if (hasMediaProvider && hasEmojiProvider) return;
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock || !syncBlock.data?.sourceAri || !syncBlock.data?.product) return;
        const parentInfo = this.dataProvider.retrieveSyncBlockParentInfo(syncBlock.data?.sourceAri, syncBlock.data?.product);
        if (!parentInfo) return;
        const { contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider) {
            if (providerCreator.createMediaProvider && contentId && contentProduct) {
                const mediaProvider = providerCreator.createMediaProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
            }
        }
        if (!hasEmojiProvider) {
            if (providerCreator.createEmojiProvider && contentId && contentProduct) {
                const emojiProvider = providerCreator.createEmojiProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
            }
        }
    }
    destroy() {
        this.dataProvider = undefined;
        this.syncBlockCache.clear();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.syncBlockURLRequests.clear();
        this.providerFactories.clear();
        this.isRefreshingSubscriptions = false;
        this.providerFactories.forEach((providerFactory)=>{
            providerFactory.destroy();
        });
        this.providerFactories.clear();
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        this.syncBlockCache = void 0;
        this.subscriptions = void 0;
        this.titleSubscriptions = void 0;
        this.providerFactories = void 0;
        this.syncBlockURLRequests = void 0;
        this.isRefreshingSubscriptions = false;
        this.syncBlockCache = new Map();
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.dataProvider = dataProvider;
        this.syncBlockURLRequests = new Map();
        this.providerFactories = new Map();
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {
const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simple return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) // if the new result has no data, we simply return the old result
    // TODO: EDITOR-2533 - handle this case based on the error type and whether we should keep old data or not
    return oldResult;
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined
        }
    };
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dBGrG", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $4Ih1z = parcelRequire("4Ih1z");


var $gtauf = parcelRequire("gtauf");

class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode) {
        if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
        const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
        if (!localId || !resourceId) throw new Error('Local ID or resource ID is not set');
        const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
        this.syncBlockCache.set(resourceId, syncBlockData);
        return true;
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that are waiting to be deleted to avoid nodes being re-created
                if (!syncBlockData.pendingDeletion) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    bodiedSyncBlockData.push(syncBlockData);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            return writeResults.every((result)=>result.resourceId !== undefined);
        } catch  {
            //TODO: EDITOR-1921 - add error analytics
            return false;
        }
    }
    setEditorView(editorView) {
        this.editorView = editorView;
    }
    registerPendingCreation(resourceId) {
        this.pendingResourceId = resourceId;
    }
    /**
   * Register callback function (which inserts node, handles focus etc) to be used later when creation to backend succeed
   */ registerCreationCallback(callback) {
        this.creationCallback = callback;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success) {
        if (success && this.creationCallback) this.creationCallback();
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
    }
    /**
   *
   * @returns true if waiting for the result of saving new bodiedSyncBlock to backend
   */ hasPendingCreation() {
        return !!this.pendingResourceId;
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const localId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        const sourceId = this.dataProvider?.getSourceId();
        if (!this.dataProvider || !sourceId) throw new Error('Provider of sync block plugin is not set');
        const resourceId = this.dataProvider.generateResourceId(sourceId, localId);
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   */ createBodiedSyncBlockNode(attrs) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const { resourceId: resourceId, localId: blockInstanceId } = attrs;
            this.dataProvider.writeNodesData([
                (0, $gtauf.createBodiedSyncBlockNode)(blockInstanceId, resourceId)
            ], [
                {
                    content: [],
                    blockInstanceId: blockInstanceId,
                    resourceId: resourceId
                }
            ]).then((results)=>{
                results.forEach((result)=>{
                    const resourceId = result.resourceId;
                    if (resourceId) this.commitPendingCreation(true);
                    else this.commitPendingCreation(false);
                });
            }).catch((_reason)=>{
                this.commitPendingCreation(false);
            // TODO: EDITOR-1921 - add error analytics
            });
            this.registerPendingCreation(resourceId);
        } catch (error) {
            if (this.hasPendingCreation()) this.commitPendingCreation(false);
        // TODO: EDITOR-1921 - add error analytics
        }
    }
    async deleteSyncBlocksWithConfirmation(tr, syncBlockIds) {
        if (this.confirmationCallback) {
            this.confirmationTransaction = tr;
            const confirmed = await this.confirmationCallback(syncBlockIds.length);
            if (confirmed) {
                this.editorView?.dispatch(this.confirmationTransaction.setMeta('isConfirmedSyncBlockDeletion', true));
                try {
                    if (!this.dataProvider) throw new Error('Data provider not set');
                    syncBlockIds.forEach((Ids)=>{
                        this.setPendingDeletion(Ids, true);
                    });
                    const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId));
                    let callback;
                    if (results.every((result)=>result.success)) callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                    else callback = (Ids)=>{
                        this.setPendingDeletion(Ids, false);
                    };
                    syncBlockIds.forEach(callback);
                } catch (_error) {
                    syncBlockIds.forEach((Ids)=>{
                        this.setPendingDeletion(Ids, false);
                    });
                // TODO: EDITOR-1921 - add error analytics
                }
            }
            this.confirmationTransaction = undefined;
        }
    }
    rebaseTransaction(incomingTr, state) {
        if (!this.confirmationTransaction) return;
        this.confirmationTransaction = (0, $4Ih1z.rebaseTransaction)(this.confirmationTransaction, incomingTr, state);
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.confirmationTransaction = undefined;
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
        this.dataProvider = undefined;
        this.editorView = undefined;
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        this.editorView = void 0;
        this.syncBlockCache = void 0;
        this.confirmationCallback = void 0;
        this.confirmationTransaction = void 0;
        this.pendingResourceId = void 0;
        this.creationCallback = void 0;
        this.setPendingDeletion = (Ids, value)=>{
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.syncBlockCache = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("4Ih1z", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

const $2ca5f7e83e81a6b9$export$9ad1230a11332b62 = (currentTr, incomingTr, state)=>{
    if (!incomingTr.docChanged) return currentTr;
    const currentMapping = new (0, $aXG5V.Mapping)(incomingTr.mapping.maps);
    const rebasedTransaction = state.tr;
    currentTr.steps.forEach((step)=>{
        const mappedStep = step.map(currentMapping);
        if (mappedStep) {
            rebasedTransaction.step(mappedStep);
            currentMapping.appendMap(mappedStep.getMap());
        }
    });
    return rebasedTransaction;
};
module.exports["rebaseTransaction"] = $2ca5f7e83e81a6b9$export$9ad1230a11332b62;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $awHlv = parcelRequire("awHlv");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId)=>{
    const [syncBlockInstance, setSyncBlockInstance] = (0, $42omo.useState)(null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
        if (!syncBlockNode) return;
        setIsLoading(true);
        try {
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            // Set error state if fetching fails
            setSyncBlockInstance({
                resourceId: resourceId || '',
                error: (0, $awHlv.SyncBlockError).Errored
            });
        }
        setIsLoading(false);
    }, [
        isLoading,
        localId,
        manager.referenceManager,
        resourceId
    ]);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setSyncBlockInstance(data);
            setIsLoading(false);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        localId,
        manager.referenceManager,
        resourceId
    ]);
    return {
        isLoading: isLoading,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5JEoN"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5JEoN", function(module, exports) {

let $42d07e1c20ae910c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42d07e1c20ae910c$var$load("Wowvf"),
    $42d07e1c20ae910c$var$load("6wr18"),
    $42d07e1c20ae910c$var$load("ffEVr"),
    $42d07e1c20ae910c$var$load("hhss7"),
    $42d07e1c20ae910c$var$load("cyGuT"),
    $42d07e1c20ae910c$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("fZitC", function(module, exports) {
const $51296ea8f82bf4e5$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $51296ea8f82bf4e5$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_m, r, g, b)=>r + r + g + g + b + b);
const $51296ea8f82bf4e5$var$rgbFromHex = (input)=>{
    const fullHex = $51296ea8f82bf4e5$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $51296ea8f82bf4e5$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $51296ea8f82bf4e5$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $51296ea8f82bf4e5$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $51296ea8f82bf4e5$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $51296ea8f82bf4e5$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $51296ea8f82bf4e5$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $51296ea8f82bf4e5$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $51296ea8f82bf4e5$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $51296ea8f82bf4e5$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $51296ea8f82bf4e5$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $51296ea8f82bf4e5$var$rgbToLch = (rgb)=>$51296ea8f82bf4e5$var$labToLch($51296ea8f82bf4e5$var$xyzToLab($51296ea8f82bf4e5$var$rgbToXyz(rgb)));
const $51296ea8f82bf4e5$var$lchToRgb = (lch)=>$51296ea8f82bf4e5$var$xyzToRgb($51296ea8f82bf4e5$var$labToXyz($51296ea8f82bf4e5$var$lchToLab(lch)));
const $51296ea8f82bf4e5$export$f38e45b0889fb431 = (hexColor)=>{
    const rgb = $51296ea8f82bf4e5$var$rgbFromHex(hexColor);
    if (rgb === null) return undefined;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $51296ea8f82bf4e5$var$rgbToLch(rgb);
    return lch.l;
};
const $51296ea8f82bf4e5$var$modifyLightness = (hexColor, percent, getShouldModifyLightness)=>{
    const rgb = $51296ea8f82bf4e5$var$rgbFromHex(hexColor);
    if (rgb === null) return hexColor;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $51296ea8f82bf4e5$var$rgbToLch(rgb);
    if (getShouldModifyLightness(lch.l)) lch.l = $51296ea8f82bf4e5$var$clamp(percent, 0, 100);
    return $51296ea8f82bf4e5$var$rgbToHex($51296ea8f82bf4e5$var$lchToRgb(lch));
};
const $51296ea8f82bf4e5$export$5ec9a60e757390f1 = (hexColor, capPercent)=>{
    return $51296ea8f82bf4e5$var$modifyLightness(hexColor, capPercent, (lightnessValue)=>lightnessValue > capPercent);
};
const $51296ea8f82bf4e5$export$16d9f224c1d58542 = (hexColor, minPercent)=>{
    return $51296ea8f82bf4e5$var$modifyLightness(hexColor, minPercent, (lightnessValue)=>lightnessValue < minPercent);
};
module.exports["getLightnessPercentage"] = $51296ea8f82bf4e5$export$f38e45b0889fb431;
module.exports["reduceLightness"] = $51296ea8f82bf4e5$export$5ec9a60e757390f1;
module.exports["increaseLightness"] = $51296ea8f82bf4e5$export$16d9f224c1d58542;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("iP9x4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $5yfLD = parcelRequire("5yfLD");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        }
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentId: contentId, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && !!spaceKey) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        }
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfigMemoized = (0, $2XqLN.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($5yfLD))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfigMemoized(config);
};
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");


var $jf9LK = parcelRequire("jf9LK");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        if (featureName in (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))) {
            const activeFeatureGate = featureName;
            const featureGateKey = (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))[activeFeatureGate];
            return (0, $9wGTI.fg)(featureGateKey);
        }
        return false;
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("jf9LK", function(module, exports) {
module.exports = JSON.parse("{\"whiteboardSolidHeader\":\"confluence_frontend_solid_whiteboard_header\",\"whiteboardOptOut\":\"whiteboards_compliance_opt_out\",\"digitalTeammate\":\"cc-ai-whiteboards-enable-digital-teammate\",\"aiFirstCreation\":\"aifc_create_enabled\"}");

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("bMPhU", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7EIq6", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $5xTWd = parcelRequire("5xTWd");


var $gTyTP = parcelRequire("gTyTP");


var $jtuBN = parcelRequire("jtuBN");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $iLgzu = parcelRequire("iLgzu");


var $7NtNc = parcelRequire("7NtNc");


var $bp4rK = parcelRequire("bp4rK");

const $649b778bbd82b1bb$export$1defcb29347f9ac6 = (spaceKey)=>{
    const { isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled } = (0, $5xTWd.useCreateSpaceExperiment)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isFeatureWhichRequiresEditFeaturesEnabled = isSpaceTypesCreationFlowEnabled || isLivePagesFeatureEnabled;
    const defaultSpaceQueryArgs = {
        skip: !isFeatureWhichRequiresEditFeaturesEnabled || spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    };
    const { data: defaultSpaceKeyData } = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_schema_exp_2', 'isEnabled', true) ? (0, $iLgzu.useExperimentalPromotedSpacesQuery)(defaultSpaceQueryArgs) : (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $bp4rK.GetDefaultSpaceQuery), defaultSpaceQueryArgs);
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !isFeatureWhichRequiresEditFeaturesEnabled || !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData } = (0, $9wGTI.fg)('stop_watching_space_level_query') ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions) : (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const defaultReturnValue = !isSpaceTypesCreationFlowEnabled;
    const isCreateWhiteboardEnabled = enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled : defaultReturnValue;
    const isCreateBlogEnabled = enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled : defaultReturnValue;
    const isCreateDatabaseEnabled = enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled : defaultReturnValue;
    const isCreateSmartLinkEnabled = enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled : defaultReturnValue;
    const isCreateLiveDocEnabled = enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled : false;
    const isCreateFolderEnabled = enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled : defaultReturnValue;
    return {
        isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
        isCreateBlogEnabled: isCreateBlogEnabled,
        isCreateDatabaseEnabled: isCreateDatabaseEnabled,
        isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
        isCreateLiveDocEnabled: isCreateLiveDocEnabled,
        isCreateFolderEnabled: isCreateFolderEnabled
    };
};
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("5xTWd", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gTyTP = parcelRequire("gTyTP");

const $c339f8d667855dc1$export$718c8063156c26da = ()=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isSpaceTypesCreationFlowEnabled = isLivePagesFeatureEnabled || (0, $9wGTI.fg)('space_types_creation_flow');
    return {
        isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled
    };
};
module.exports["useCreateSpaceExperiment"] = $c339f8d667855dc1$export$718c8063156c26da;

});

parcelRegister("7NtNc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ada047e01258ab08$export$a08098e2700d7e94 = (0, $eSUdr.default)`query SpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;
module.exports["SpaceEnabledContentTypesQuery"] = $ada047e01258ab08$export$a08098e2700d7e94;

});

parcelRegister("bp4rK", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a9375ef73dfcb073$export$9d480e5fa307b726 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query GetDefaultSpaceQuery($promotedSpaceKey:String)@experimental{experimentalPromotedSpaces(promotedSpacesLimit:1 otherSpacesLimit:1 promotedSpaceKey:$promotedSpaceKey){nodes{id}}}`;
module.exports["GetDefaultSpaceQuery"] = $a9375ef73dfcb073$export$9d480e5fa307b726;

});

parcelRegister("foRF9", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $hp2SH = parcelRequire("hp2SH");


var $6mKj3 = parcelRequire("6mKj3");


var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$359c6f7177354dc2 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives, graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $eSUdr.default)`query MacroPlaceholderADFQuery($contentId:ID!$macroDefinition:String!)@experimental{experimentalMacroPlaceholderADF(contentId:$contentId macroDefinition:$macroDefinition){json}}`;
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = options;
    const experimentalMacroPlaceholderADFArgs = {
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    };
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const results = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_schema_exp_5', 'isEnabled', true) ? await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)(experimentalMacroPlaceholderADFArgs) : await (0, $hp2SH.getApolloClient)().query({
        query: $5faed47790e8728c$export$359c6f7177354dc2,
        ...experimentalMacroPlaceholderADFArgs
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl, isLivePagesFeatureEnabled);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $cgtv4.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("gGHFp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $6yq6d = parcelRequire("6yq6d");


var $flWvL = parcelRequire("flWvL");

function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage) && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp');
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $6yq6d.ContentModeQuery), {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        returnPartialData: true,
        skip: !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || !contentId
    });
    let serverModeRaw;
    if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) {
        const contentProps = data?.content?.nodes?.[0]?.contentProperties;
        if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
        else serverModeRaw = contentProps?.latest?.contentMode;
    } else serverModeRaw = undefined;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') ? Boolean(loading) : false,
            error: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') ? error ?? null : null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("31HPn", function(module, exports) {
const $23fc703b824b091d$export$38c6526d67de94bb = 'xen:macro';
const $23fc703b824b091d$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $23fc703b824b091d$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $23fc703b824b091d$export$46fc26821adc3495 = 'connectAddon';
const $23fc703b824b091d$export$95077f102dafd025 = 'migratedServerP2Addon';
const $23fc703b824b091d$export$981e47da3e2dfc13 = 'bodiedExtension';
const $23fc703b824b091d$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $23fc703b824b091d$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $23fc703b824b091d$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $23fc703b824b091d$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $23fc703b824b091d$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $23fc703b824b091d$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $23fc703b824b091d$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $23fc703b824b091d$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $23fc703b824b091d$export$bf4c163a4c708db1;

});

parcelRegister("2igSQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");


var $2xdp1 = parcelRequire("2xdp1");


var $kwjRd = parcelRequire("kwjRd");


var $idCCS = parcelRequire("idCCS");

const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};
module.exports["TemplateVariableInput"] = $f852cc0c808326c8$export$cdee65ffaf9b2fb7;

});

parcelRegister("2xdp1", function(module, exports) {

var $55ggG = parcelRequire("55ggG");

const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;
module.exports["defaultVariableName"] = $df54c7f294e74661$export$178c63c1bbc65458;
module.exports["TEXT_TYPE"] = $df54c7f294e74661$export$ae3b897442224943;
module.exports["MULTI_LINES_TYPE"] = $df54c7f294e74661$export$a43e313f04be91d7;
module.exports["LIST_TYPE"] = $df54c7f294e74661$export$22c50a44ec8aa5dd;
module.exports["ROWS_DEFAULT"] = $df54c7f294e74661$export$d1952e7dbe0fefc9;
module.exports["COLUMNS_DEFAULT"] = $df54c7f294e74661$export$777b44f8413b254e;

});

parcelRegister("55ggG", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});
module.exports["i18n"] = $446fbea06bd2a31f$export$a7357cdd1f0b0168;

});

parcelRegister("kwjRd", function(module, exports) {
/* SharedComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkxmi2 _otyrpxbi _n3tdv77o _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko458z _bfhk1s93",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1nmz9jpi _syazi7uo _k48p4jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko18r2 _syaz1rpy _bfhk1s93 _1nmz9jpi",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _o5724jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _kqswh2mm _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_vr2wn7od",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
module.exports["TemplateVariableInputWrapper"] = $f809923cf8cfa046$export$4af78215734bfe2b;
module.exports["TemplateVariableNameWrapper"] = $f809923cf8cfa046$export$59d0bfd82baefce0;
module.exports["TemplateVariableName"] = $f809923cf8cfa046$export$8eff3c6bf5b8c758;
module.exports["TemplateVariableType"] = $f809923cf8cfa046$export$b4ff36272a61159f;
module.exports["TemplateVariableInputFieldWrapper"] = $f809923cf8cfa046$export$e3cad7a6d45ce703;
module.exports["TemplateVariableTextareaInputFieldWrapper"] = $f809923cf8cfa046$export$e9df20cb66227872;
module.exports["ButtonStyle"] = $f809923cf8cfa046$export$bdc3c19374266b98;
module.exports["DropDownInputWrapper"] = $f809923cf8cfa046$export$c996e1cc40266f34;

});

parcelRegister("idCCS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $cuAuQ = parcelRequire("cuAuQ");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $kwjRd = parcelRequire("kwjRd");


var $2xdp1 = parcelRequire("2xdp1");

const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $8C5kA.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $42omo.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $42omo.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cuAuQ.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cuAuQ.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $8C5kA.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $8C5kA.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            // @ts-ignore cols used to be in the list of props of TextArea but later then removed
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        // @ts-ignore cols used to be in the list of props of TextArea but later then removed
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};
module.exports["TemplateVariableInputComponent"] = $ab3c5e793706abd9$export$f57c870ff73570c7;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9wGTI = parcelRequire("9wGTI");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...$d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...$d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES,
            ...contexts,
            ...keys
        ];
        if ((0, $9wGTI.fg)('pgxp_connect_macro_inline_image_bugfix')) deps.push(...$d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES);
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("8cOoD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("fySJw", function(module, exports) {

var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            this.emit(localId, data.eventData);
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $6g1oe = parcelRequire("6g1oe");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    // fetch ADF structure of JIM, and modify it to provide to editor later
    const jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, jiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("fNtDT", function(module, exports) {

let $b8026cfc4781e004$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8026cfc4781e004$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("6nXDf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a6325bd22772a7a$export$2e2bcd8739ae039);

var $c3Z6w = parcelRequire("c3Z6w");


var $b5utg = parcelRequire("b5utg");

function $4a6325bd22772a7a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $b5utg.default)(1, arguments);
    return (0, $c3Z6w.default)(dirtyDate, Date.now(), options);
}

});

parcelRegister("hl0fg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $42omo.useState)(getSize);
    (0, $42omo.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && // @ts-expect-error - false is not allowed as an expected value
    (0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', false)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("2O9nH"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("dMpIw"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("2O9nH", function(module, exports) {

let $20b7872e62f3d20a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20b7872e62f3d20a$var$load("7whwt"),
    $20b7872e62f3d20a$var$load("6Nsud"),
    $20b7872e62f3d20a$var$load("gmzZ6"),
    $20b7872e62f3d20a$var$load("4JQof"),
    $20b7872e62f3d20a$var$load("ipiLs"),
    $20b7872e62f3d20a$var$load("aNH1E"),
    $20b7872e62f3d20a$var$load("aZinD"),
    $20b7872e62f3d20a$var$load("bAXKU"),
    $20b7872e62f3d20a$var$load("l3dqd"),
    $20b7872e62f3d20a$var$load("9Z7qK"),
    $20b7872e62f3d20a$var$load("duPDN"),
    $20b7872e62f3d20a$var$load("70qyO"),
    $20b7872e62f3d20a$var$load("1Jgsw"),
    $20b7872e62f3d20a$var$load("dclpt"),
    $20b7872e62f3d20a$var$load("tKhaz"),
    $20b7872e62f3d20a$var$load("iIL8i"),
    $20b7872e62f3d20a$var$load("lkOIY"),
    $20b7872e62f3d20a$var$load("hcj2C"),
    $20b7872e62f3d20a$var$load("2UF2x"),
    $20b7872e62f3d20a$var$load("9jS5g"),
    $20b7872e62f3d20a$var$load("4eboO"),
    $20b7872e62f3d20a$var$load("fgAx2"),
    $20b7872e62f3d20a$var$load("8YSo7"),
    $20b7872e62f3d20a$var$load("fqGSw"),
    $20b7872e62f3d20a$var$load("lqbST"),
    $20b7872e62f3d20a$var$load("jwWp5"),
    $20b7872e62f3d20a$var$load("gLGsg"),
    $20b7872e62f3d20a$var$load("2F69B"),
    $20b7872e62f3d20a$var$load("2Cftu"),
    $20b7872e62f3d20a$var$load("4i0CB"),
    $20b7872e62f3d20a$var$load("jkPqm"),
    $20b7872e62f3d20a$var$load("awqCy"),
    $20b7872e62f3d20a$var$load("6wr18"),
    $20b7872e62f3d20a$var$load("cyGuT"),
    $20b7872e62f3d20a$var$load("8ab9M"),
    $20b7872e62f3d20a$var$load("gyOzw"),
    $20b7872e62f3d20a$var$load("ePdWC"),
    $20b7872e62f3d20a$var$load("lBzRN"),
    $20b7872e62f3d20a$var$load("9wxKg"),
    $20b7872e62f3d20a$var$load("fZt2F"),
    $20b7872e62f3d20a$var$load("Wowvf"),
    $20b7872e62f3d20a$var$load("let0D"),
    $20b7872e62f3d20a$var$load("87NBA"),
    $20b7872e62f3d20a$var$load("8KnyD"),
    $20b7872e62f3d20a$var$load("bRz9K"),
    $20b7872e62f3d20a$var$load("6Up0b"),
    $20b7872e62f3d20a$var$load("ffEVr"),
    $20b7872e62f3d20a$var$load("kUbUu"),
    $20b7872e62f3d20a$var$load("4Lgj0"),
    $20b7872e62f3d20a$var$load("kSJiq"),
    $20b7872e62f3d20a$var$load("dIKn2"),
    $20b7872e62f3d20a$var$load("8fdGr"),
    $20b7872e62f3d20a$var$load("hhss7"),
    $20b7872e62f3d20a$var$load("fnmhc"),
    $20b7872e62f3d20a$var$load("kdoia"),
    $20b7872e62f3d20a$var$load("7EorR"),
    $20b7872e62f3d20a$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("dMpIw", function(module, exports) {

let $a083b4f670df0be6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a083b4f670df0be6$var$load("fqGSw"),
    $a083b4f670df0be6$var$load("4Lgj0"),
    $a083b4f670df0be6$var$load("kSJiq"),
    $a083b4f670df0be6$var$load("LXZNT"),
    $a083b4f670df0be6$var$load("coJiW"),
    $a083b4f670df0be6$var$load("h4Nf7"),
    $a083b4f670df0be6$var$load("2Cftu"),
    $a083b4f670df0be6$var$load("4i0CB"),
    $a083b4f670df0be6$var$load("Wowvf"),
    $a083b4f670df0be6$var$load("9iITj"),
    $a083b4f670df0be6$var$load("89Sbl"),
    $a083b4f670df0be6$var$load("7EorR"),
    $a083b4f670df0be6$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("62fWd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");

const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $3c9dbf4421667f34$export$64f0f7e9be5f8ff;

});

parcelRegister("cwXs1", function(module, exports) {

var $6V5uh = parcelRequire("6V5uh");


var $7sea9 = parcelRequire("7sea9");


var $dmgN7 = parcelRequire("dmgN7");

function $91f696e693fdbefb$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $91f696e693fdbefb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dmgN7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $91f696e693fdbefb$var$createEmotion = function createEmotion(options) {
    var cache = (0, $6V5uh.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered, undefined);
        (0, $dmgN7.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $91f696e693fdbefb$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered);
        $91f696e693fdbefb$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $91f696e693fdbefb$var$merge(cache.registered, css, $91f696e693fdbefb$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $dmgN7.getRegisteredStyles).bind(null, cache.registered),
        merge: $91f696e693fdbefb$var$merge.bind(null, cache.registered, css)
    };
};
var $91f696e693fdbefb$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
var $91f696e693fdbefb$export$2e2bcd8739ae039 = $91f696e693fdbefb$var$createEmotion;
module.exports["default"] = $91f696e693fdbefb$export$2e2bcd8739ae039;

});

parcelRegister("6V5uh", function(module, exports) {

var $17TcT = parcelRequire("17TcT");


var $iJwkl = parcelRequire("iJwkl");

parcelRequire("bDkqZ");

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $509c529e1de59914$var$delimiter = '/*|*/';
var $509c529e1de59914$var$needle = $509c529e1de59914$var$delimiter + '}';
function $509c529e1de59914$var$toSheet(block) {
    if (block) $509c529e1de59914$var$Sheet.current.insert(block + '}');
}
var $509c529e1de59914$var$Sheet = {
    current: null
};
var $509c529e1de59914$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $509c529e1de59914$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $509c529e1de59914$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $509c529e1de59914$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $509c529e1de59914$var$delimiter : '');
            }
        case -2:
            content.split($509c529e1de59914$var$needle).forEach($509c529e1de59914$var$toSheet);
    }
};
var $509c529e1de59914$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $iJwkl.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($509c529e1de59914$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $509c529e1de59914$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $17TcT.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $509c529e1de59914$export$2e2bcd8739ae039 = $509c529e1de59914$var$createCache;
module.exports["default"] = $509c529e1de59914$export$2e2bcd8739ae039;

});

parcelRegister("17TcT", function(module, exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $0d2144d6479b12ec$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $0d2144d6479b12ec$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $0d2144d6479b12ec$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $0d2144d6479b12ec$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $0d2144d6479b12ec$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();
module.exports["StyleSheet"] = $0d2144d6479b12ec$export$9d753cd7ae895cce;

});

parcelRegister("iJwkl", function(module, exports) {
function $da358174ef16096d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $da358174ef16096d$export$2e2bcd8739ae039 = $da358174ef16096d$var$stylis_min;
module.exports["default"] = $da358174ef16096d$export$2e2bcd8739ae039;

});

parcelRegister("bDkqZ", function(module, exports) {
var $87833012dd311f8f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $87833012dd311f8f$export$2e2bcd8739ae039 = $87833012dd311f8f$var$weakMemoize;

});

parcelRegister("7sea9", function(module, exports) {

var $f2VtL = parcelRequire("f2VtL");


var $5LEcS = parcelRequire("5LEcS");


var $1scxZ = parcelRequire("1scxZ");

var $56d622567ec5b15a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $56d622567ec5b15a$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $56d622567ec5b15a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $56d622567ec5b15a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $56d622567ec5b15a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $56d622567ec5b15a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $56d622567ec5b15a$var$processStyleName = (0, $1scxZ.default)(function(styleName) {
    return $56d622567ec5b15a$var$isCustomProperty(styleName) ? styleName : styleName.replace($56d622567ec5b15a$var$hyphenateRegex, '-$&').toLowerCase();
});
var $56d622567ec5b15a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($56d622567ec5b15a$var$animationRegex, function(match, p1, p2) {
                $56d622567ec5b15a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $56d622567ec5b15a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $5LEcS.default)[key] !== 1 && !$56d622567ec5b15a$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $56d622567ec5b15a$var$contentValuePattern, $56d622567ec5b15a$var$contentValues, $56d622567ec5b15a$var$oldProcessStyleValue, $56d622567ec5b15a$var$msPattern, $56d622567ec5b15a$var$hyphenPattern, $56d622567ec5b15a$var$hyphenatedCache;
var $56d622567ec5b15a$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $56d622567ec5b15a$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $56d622567ec5b15a$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $56d622567ec5b15a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $56d622567ec5b15a$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $56d622567ec5b15a$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $56d622567ec5b15a$var$cursor;
                var result = interpolation(mergedProps);
                $56d622567ec5b15a$var$cursor = previousCursor;
                return $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $56d622567ec5b15a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($56d622567ec5b15a$var$isProcessableValue(value)) string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + $56d622567ec5b15a$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($56d622567ec5b15a$var$isProcessableValue(value[_i])) string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + $56d622567ec5b15a$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case 'animation':
                case 'animationName':
                    string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $56d622567ec5b15a$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $56d622567ec5b15a$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $56d622567ec5b15a$var$cursor;
var $56d622567ec5b15a$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $56d622567ec5b15a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $56d622567ec5b15a$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $56d622567ec5b15a$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $f2VtL.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $56d622567ec5b15a$var$cursor
    };
};
module.exports["serializeStyles"] = $56d622567ec5b15a$export$6321afa313b251b5;

});

parcelRegister("f2VtL", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $af43a1132694bb05$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $af43a1132694bb05$export$2e2bcd8739ae039 = $af43a1132694bb05$var$murmur2;
module.exports["default"] = $af43a1132694bb05$export$2e2bcd8739ae039;

});

parcelRegister("5LEcS", function(module, exports) {
var $433087baeb224055$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $433087baeb224055$export$2e2bcd8739ae039 = $433087baeb224055$var$unitlessKeys;
module.exports["default"] = $433087baeb224055$export$2e2bcd8739ae039;

});

parcelRegister("1scxZ", function(module, exports) {
function $10f223981f04db65$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $10f223981f04db65$export$2e2bcd8739ae039 = $10f223981f04db65$var$memoize;
module.exports["default"] = $10f223981f04db65$export$2e2bcd8739ae039;

});

parcelRegister("fy6ox", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $7tyMu = parcelRequire("7tyMu");

const $5d73e8e60584e113$var$Author = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAuthor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7tyMu.default), {
        hasAuthor: true,
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$5d73e8e60584e113$var$Author.displayName = 'CommentAuthor';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5d73e8e60584e113$export$2e2bcd8739ae039 = $5d73e8e60584e113$var$Author;
module.exports["default"] = $5d73e8e60584e113$export$2e2bcd8739ae039;

});

parcelRegister("7tyMu", function(module, exports) {
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

const $a24e02791d90685a$var$textStyles = {
    root: "_syazazsu"
};
const $a24e02791d90685a$var$anchorStyles = {
    root: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz"
};
const $a24e02791d90685a$var$noAuthorStyles = {
    root: "_k48p1kw7"
};
const $a24e02791d90685a$var$hasAuthorStyles = {
    root: "_k48p1wq8"
}; /**
    * __Field__
    *
    * A field appears in the comment header to add metadata to the comment.
    *
    * @internal
    */ 
const $a24e02791d90685a$var$Field = ({ children: children, hasAuthor: hasAuthor, href: href, onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver, testId: testId })=>{
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: href,
        xcss: (0, $1Whri.cx)($a24e02791d90685a$var$textStyles.root, $a24e02791d90685a$var$anchorStyles.root, hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root),
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
        /**
                     * It is not normally acceptable to add key handlers to non-interactive elements
                     * as this is an accessibility anti-pattern. However, because this instance is
                     * to add support for analytics instead of creating an inaccessible
                     * custom element, we can add role="presentation" so that there are no negative
                     * impacts to assistive technologies.
                     */ role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $a24e02791d90685a$var$textStyles.root,
            hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root
        ]),
        children: children
    });
};
var $a24e02791d90685a$export$2e2bcd8739ae039 = $a24e02791d90685a$var$Field;
module.exports["default"] = $a24e02791d90685a$export$2e2bcd8739ae039;

});

parcelRegister("fJJGs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $7tyMu = parcelRequire("7tyMu");

const $d3930f6319807484$var$CommentTime = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentTime',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7tyMu.default), {
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$d3930f6319807484$var$CommentTime.displayName = 'CommentTime';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3930f6319807484$export$2e2bcd8739ae039 = $d3930f6319807484$var$CommentTime;
module.exports["default"] = $d3930f6319807484$export$2e2bcd8739ae039;

});

parcelRegister("hlzjm", function(module, exports) {
/* comment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $bVeqx = parcelRequire("bVeqx");


var $cV7U6 = parcelRequire("cV7U6");


var $ijtAN = parcelRequire("ijtAN");

const $93d62a86395aa94f$var$textStyles = {
    root: "_syazi7uo",
    disabled: "_syaz1gmx"
};
/**
 * __Comment__
 *
 * Comments enable discussions on an entity such as a page, blog post, work item, or pull request.
 */ const $93d62a86395aa94f$var$Comment = ({ actions: actions = [], restrictedTo: restrictedTo = '', highlighted: highlighted = false, isSaving: isSaving = false, savingText: savingText = 'Sending...', isError: isError = false, errorActions: errorActions = [], errorIconLabel: errorIconLabel = '', author: author, avatar: avatar, children: children, content: content, edited: edited, time: time, type: type, testId: testId, id: id, afterContent: afterContent, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const headerProps = {
        author: author,
        edited: edited,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        time: time,
        type: type,
        headingLevel: headingLevel,
        shouldHeaderWrap: shouldHeaderWrap
    };
    const footerProps = {
        actions: actions,
        errorActions: errorActions,
        errorIconLabel: errorIconLabel,
        isError: isError,
        isSaving: isSaving
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ijtAN.default), {
        testId: testId,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        id: id,
        avatar: avatar,
        content: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cV7U6.default), {
                            testId: testId && `${testId}-header`,
                            ...headerProps
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            testId: testId && `${testId}-content`,
                            xcss: (0, $1Whri.cx)($93d62a86395aa94f$var$textStyles.root, (isSaving || isError) && $93d62a86395aa94f$var$textStyles.disabled),
                            children: content
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $bVeqx.default), {
                    testId: testId && `${testId}-footer`,
                    ...footerProps
                }),
                afterContent
            ]
        }),
        highlighted: highlighted,
        children: children
    });
};
$93d62a86395aa94f$var$Comment.displayName = 'Comment';
var $93d62a86395aa94f$export$2e2bcd8739ae039 = $93d62a86395aa94f$var$Comment;
module.exports["default"] = $93d62a86395aa94f$export$2e2bcd8739ae039;

});

parcelRegister("bVeqx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5MACL = parcelRequire("5MACL");


var $dcJ7R = parcelRequire("dcJ7R");


var $6fnsQ = parcelRequire("6fnsQ");

/**
 * __Footer items__
 *
 * The footer items in the comment. Usually reserved for error messages.
 *
 * @internal
 */ const $d2b873e75f9e4281$var$Footer = ({ actions: actions = [], errorActions: errorActions = [], errorIconLabel: errorIconLabel, isError: isError, isSaving: isSaving, testId: testId })=>{
    if (isSaving || !(actions.length || errorActions.length)) return null;
    const items = isError ? errorActions : actions;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        space: "space.100",
        separator: "\xb7",
        children: [
            isError && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5MACL))), {
                spacing: "spacious",
                color: `var(--ds-icon-warning, ${(0, $6fnsQ.Y500)})`,
                label: errorIconLabel ? errorIconLabel : ''
            }),
            items.map((item, key)=>Object.assign({}, item, {
                    key: key
                }))
        ]
    });
};
$d2b873e75f9e4281$var$Footer.displayName = 'CommentFooter';
var $d2b873e75f9e4281$export$2e2bcd8739ae039 = $d2b873e75f9e4281$var$Footer;
module.exports["default"] = $d2b873e75f9e4281$export$2e2bcd8739ae039;

});

parcelRegister("cV7U6", function(module, exports) {
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9Q2dU = parcelRequire("9Q2dU");


var $17uVW = parcelRequire("17uVW");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $09aac408a5a8747f$var$headingStyles = {
    root: "_11c82smr"
};
const $09aac408a5a8747f$var$iconWrapperStyles = {
    root: "_18zrv77o _1e0c1txw"
};
const $09aac408a5a8747f$var$headerItemStyles = {
    root: "_o5721q9c _1o9zidpf"
};
const $09aac408a5a8747f$var$authorBoxStyles = {
    root: "_1nmz9jpi _1ul9idpf _p12f1osq"
}; /**
    * __Header items__
    *
    * Comment header items.
    *
    * @internal
    */ 
const $09aac408a5a8747f$var$Header = ({ author: author, edited: edited, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, time: time, testId: testId, type: type, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const Heading = `h${headingLevel}`;
    const shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
    return shouldRender ? /*#__PURE__*/ (0, $l998X.jsx)(Heading, {
        className: (0, $gMc0m.default)([
            $09aac408a5a8747f$var$headingStyles.root
        ]),
        children: shouldHeaderWrap === false ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            as: "span",
            shouldWrap: false,
            children: [
                author,
                type && /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    testId: testId && `${testId}-type`,
                    children: type
                }),
                time && !isSaving && !isError && time,
                edited || null,
                isSaving ? savingText : null,
                restrictedTo && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.050",
                        as: "span",
                        children: [
                            "\u2022",
                            (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "span",
                                xcss: $09aac408a5a8747f$var$iconWrapperStyles.root,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                    color: "currentColor",
                                    label: "",
                                    size: "small"
                                })
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($17uVW))), {
                                size: "small",
                                label: ""
                            }),
                            restrictedTo
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            rowSpace: "space.0",
            as: "span",
            shouldWrap: true,
            children: [
                author && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$authorBoxStyles.root,
                    children: author
                }),
                type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        testId: testId && `${testId}-type`,
                        children: type
                    })
                }),
                time && !isSaving && !isError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: time
                }),
                edited && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: edited
                }),
                isSaving && savingText && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $09aac408a5a8747f$var$headerItemStyles.root,
                    children: savingText
                }),
                restrictedTo && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.050",
                            as: "span",
                            children: [
                                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    as: "span",
                                    xcss: $09aac408a5a8747f$var$iconWrapperStyles.root,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                        color: "currentColor",
                                        label: "",
                                        size: "small"
                                    })
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($17uVW))), {
                                    size: "small",
                                    label: ""
                                }),
                                restrictedTo
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
$09aac408a5a8747f$var$Header.displayName = 'CommentHeader';
var $09aac408a5a8747f$export$2e2bcd8739ae039 = $09aac408a5a8747f$var$Header;
module.exports["default"] = $09aac408a5a8747f$export$2e2bcd8739ae039;

});

parcelRegister("ijtAN", function(module, exports) {
/* layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");


var $6JC10 = parcelRequire("6JC10");


var $lmM8h = parcelRequire("lmM8h");

const $768cc646e91e2e58$var$containerStyles = {
    root: "_kqswh2mm _yv0e5bpd _1lmc1gx3"
};
const $768cc646e91e2e58$var$inlineCommentStyles = {
    root: "_1lmc1rav"
};
const $768cc646e91e2e58$var$noChildrenStyles = {
    root: "_1lmcvpz5"
};
// if the background is appied on Box and tokens are not switched on it breaks.
// This can be safely removed (and applied on Box) when tokens are on by default
const $768cc646e91e2e58$var$highlightOverlayStyles = {
    root: "_1r04x0bf _nd5l1sux _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _kqswstnw _lcxvglyw"
};
const $768cc646e91e2e58$var$stackOverrideStyles = {
    root: "_nd5l1dav _1q511ejb"
};
/**
 * __CommentLayout__
 *
 * The base layout for the comment component.
 *
 */ const $768cc646e91e2e58$var$Layout = ({ content: content, children: children, highlighted: highlighted, id: id, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, avatar: avatar })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        gap: "space.100",
        xcss: (0, $1Whri.cx)($768cc646e91e2e58$var$containerStyles.root, shouldRenderNestedCommentsInline && $768cc646e91e2e58$var$inlineCommentStyles.root, !children && $768cc646e91e2e58$var$noChildrenStyles.root),
        testId: testId,
        id: id,
        children: [
            avatar && /*#__PURE__*/ (0, $l998X.jsx)((0, $6JC10.default), {
                children: avatar
            }),
            content && /*#__PURE__*/ (0, $l998X.jsx)((0, $lmM8h.default), {
                children: content
            }),
            children && /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                xcss: $768cc646e91e2e58$var$stackOverrideStyles.root,
                space: "space.400",
                children: children
            }),
            highlighted && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $768cc646e91e2e58$var$highlightOverlayStyles.root,
                backgroundColor: "color.background.neutral",
                testId: testId && `${testId}-highlighted`
            })
        ]
    });
$768cc646e91e2e58$var$Layout.displayName = 'CommentLayout';
var $768cc646e91e2e58$export$2e2bcd8739ae039 = $768cc646e91e2e58$var$Layout;
module.exports["default"] = $768cc646e91e2e58$export$2e2bcd8739ae039;

});

parcelRegister("6JC10", function(module, exports) {
/* avatar-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $d6ff3474eb3a1c0a$var$avatarSectionStyles = {
    root: "_nd5l1ofd"
};
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */ const $d6ff3474eb3a1c0a$var$AvatarSlot = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d6ff3474eb3a1c0a$var$avatarSectionStyles.root,
        children: children
    });
var $d6ff3474eb3a1c0a$export$2e2bcd8739ae039 = $d6ff3474eb3a1c0a$var$AvatarSlot;
module.exports["default"] = $d6ff3474eb3a1c0a$export$2e2bcd8739ae039;

});

parcelRegister("lmM8h", function(module, exports) {
/* content-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $df8b60abd3030907$var$contentSlotStyles = {
    root: "_nd5l8niw _1ul9idpf _1q51v77o _slp31hna"
};
const $df8b60abd3030907$var$ContentSlot = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $df8b60abd3030907$var$contentSlotStyles.root
        ]),
        children: children
    });
var $df8b60abd3030907$export$2e2bcd8739ae039 = $df8b60abd3030907$var$ContentSlot;
module.exports["default"] = $df8b60abd3030907$export$2e2bcd8739ae039;

});

parcelRegister("jq9iL", function(module, exports) {
$parcel$export(module.exports, "getFiles", () => (parcelRequire("3E6Lz")).getFiles);
$parcel$export(module.exports, "containsFiles", () => (parcelRequire("3E6Lz")).containsFiles);

var $3E6Lz = parcelRequire("3E6Lz");


});

parcelRegister("3E6Lz", function(module, exports) {
function $709b2838a61f0f18$export$ed3e218cf6ca2bc6({ source: source }) {
    return source.types.includes('Files');
}
function $709b2838a61f0f18$export$d964e69f1fd5fd4c({ source: source }) {
    return source.items// unlike other media types, for files:
    // item.kind is 'file'
    // item.type is the type of file eg 'image/jpg'
    // for other media types, item.type is the mime format
    .filter((item)=>item.kind === 'file').map((item)=>item.getAsFile()).filter((file)=>file != null);
}
module.exports["containsFiles"] = $709b2838a61f0f18$export$ed3e218cf6ca2bc6;
module.exports["getFiles"] = $709b2838a61f0f18$export$d964e69f1fd5fd4c;

});

parcelRegister("2HGN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $42omo.useState)();
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const widthValue = metadata?.editorWidth?.value;
            const version = metadata?.editorWidth?.version;
            if (widthValue) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    const draftAppearanceQuery = (0, $8VcPj.getContentAppearanceQuery)((0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $j1Ss3.useQuery)(draftAppearanceQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        }
    });
    const context = (0, $42omo.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        return {
            contentAppearance: contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $42omo.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            isAIUnsplashImage: false,
            aiSuggestedUnsplashImages: undefined,
            shouldShowAIUnsplashHeaderToolbar: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setIsAIUnsplashImage = (isAIUnsplashImage)=>this.setState({
                isAIUnsplashImage: isAIUnsplashImage
            });
        this.setAISuggestedUnsplashImages = (aiSuggestedUnsplashImages)=>this.setState({
                aiSuggestedUnsplashImages: aiSuggestedUnsplashImages
            });
        this.setShouldShowAIUnsplashHeaderToolbar = (shouldShowAIUnsplashHeaderToolbar)=>this.setState({
                shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar
            });
        this.resetToDefaults = ()=>{
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setIsAIUnsplashImage(false);
            this.setAISuggestedUnsplashImages(undefined);
            this.setShouldShowAIUnsplashHeaderToolbar(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("iSWIi", function(module, exports) {

var $77wHb = parcelRequire("77wHb");

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $038c4daf1440bb6a$var$partition = $77wHb(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $038c4daf1440bb6a$var$partition;

});

parcelRegister("dmKyV", function(module, exports) {
$parcel$export(module.exports, "WRM", () => (parcelRequire("1UB3e")).default);
$parcel$export(module.exports, "withWRMDependencies", () => (parcelRequire("6u5YI")).default);

var $1UB3e = parcelRequire("1UB3e");


var $6u5YI = parcelRequire("6u5YI");


});

parcelRegister("1UB3e", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 */ const $1647c2fd90c2cc68$var$WRM = {
    require (dependencies, callback) {
        return new Promise((resolve)=>{
            (0, $cpjd2.requireLegacyWRM)(dependencies, (modules)=>{
                resolve(modules);
                if (callback) callback(modules);
            }, ()=>{});
        });
    }
};
var $1647c2fd90c2cc68$export$2e2bcd8739ae039 = $1647c2fd90c2cc68$var$WRM;
module.exports["default"] = $1647c2fd90c2cc68$export$2e2bcd8739ae039;

});

parcelRegister("6u5YI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 *
 * withWRMDependencies is a decorator for loading WRM dependencies.
 *
 * It's a helper which besides loading dependencies will also hide the component
 * while the dependencies are not loaded avoiding FOUC and weird behaviours.
 *
 * usage:
 *
 * withWRMDependencies('wr!mypluginkey')(
 *  class MyComponent extends Component {}
 * )
 *
 * or
 *
 * withWRMDependencies(['wrc!myContext', 'wr!myWebResource'])(
 *  class MyComponent extends Component {}
 * )
 */ function $4b8a2e9a57493429$var$withWRMDependencies(dependencies, options) {
    const configs = {
        isBlocking: true,
        ...options
    };
    return (BaseComponent)=>{
        class WRMComponent extends (0, $42omo.Component) {
            componentDidMount() {
                this.mounted = true;
                if (dependencies && dependencies.length > 0) (0, $cpjd2.requireLegacyWRM)(dependencies, this.markAsLoaded, ()=>{});
                else this.markAsLoaded();
            }
            componentWillUnmount() {
                this.mounted = false;
            }
            render() {
                const { dependenciesLoaded: dependenciesLoaded } = this.state;
                if (dependenciesLoaded || !configs.isBlocking) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, {
                    ...this.props,
                    wrmDependenciesLoaded: dependenciesLoaded
                });
                else return null;
            }
            constructor(...args){
                super(...args);
                this.state = {
                    dependenciesLoaded: false
                };
                this.markAsLoaded = ()=>{
                    if (this.mounted) this.setState({
                        dependenciesLoaded: true
                    });
                };
            }
        }
        WRMComponent.displayName = `WRMComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return WRMComponent;
    };
}
var $4b8a2e9a57493429$export$2e2bcd8739ae039 = $4b8a2e9a57493429$var$withWRMDependencies;
module.exports["default"] = $4b8a2e9a57493429$export$2e2bcd8739ae039;

});

parcelRegister("fBjVq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3141cf32c54bf764$var$RendererLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AfRhk",
    // Name needs to match the one in next/packages/view-page/src/index.ts
    name: "ClassicRendererLoader",
    loader: ()=>(parcelRequire("ipPfv"))
});
var $3141cf32c54bf764$export$2e2bcd8739ae039 = $3141cf32c54bf764$var$RendererLoader;
module.exports["default"] = $3141cf32c54bf764$export$2e2bcd8739ae039;

});

parcelRegister("ipPfv", function(module, exports) {

let $d68250d1285b4a40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d68250d1285b4a40$var$load("7Omhy"),
    $d68250d1285b4a40$var$load("2YffH"),
    $d68250d1285b4a40$var$load("6Nsud"),
    $d68250d1285b4a40$var$load("gmzZ6"),
    $d68250d1285b4a40$var$load("4JQof"),
    $d68250d1285b4a40$var$load("A1eSR"),
    $d68250d1285b4a40$var$load("2rCak"),
    $d68250d1285b4a40$var$load("ipiLs"),
    $d68250d1285b4a40$var$load("aNH1E"),
    $d68250d1285b4a40$var$load("aZinD"),
    $d68250d1285b4a40$var$load("bAXKU"),
    $d68250d1285b4a40$var$load("l3dqd"),
    $d68250d1285b4a40$var$load("duPDN"),
    $d68250d1285b4a40$var$load("70qyO"),
    $d68250d1285b4a40$var$load("1Jgsw"),
    $d68250d1285b4a40$var$load("dclpt"),
    $d68250d1285b4a40$var$load("tKhaz"),
    $d68250d1285b4a40$var$load("iIL8i"),
    $d68250d1285b4a40$var$load("eYere"),
    $d68250d1285b4a40$var$load("at1W4"),
    $d68250d1285b4a40$var$load("lkOIY"),
    $d68250d1285b4a40$var$load("hcj2C"),
    $d68250d1285b4a40$var$load("2UF2x"),
    $d68250d1285b4a40$var$load("jwWp5"),
    $d68250d1285b4a40$var$load("gLGsg"),
    $d68250d1285b4a40$var$load("3CHGC"),
    $d68250d1285b4a40$var$load("cgLyI"),
    $d68250d1285b4a40$var$load("2F69B"),
    $d68250d1285b4a40$var$load("2Cftu"),
    $d68250d1285b4a40$var$load("4i0CB"),
    $d68250d1285b4a40$var$load("49GA1"),
    $d68250d1285b4a40$var$load("32K9i"),
    $d68250d1285b4a40$var$load("h4k4y"),
    $d68250d1285b4a40$var$load("aeEUI"),
    $d68250d1285b4a40$var$load("iXzmH"),
    $d68250d1285b4a40$var$load("65c4i"),
    $d68250d1285b4a40$var$load("kjZZD"),
    $d68250d1285b4a40$var$load("6wr18"),
    $d68250d1285b4a40$var$load("cyGuT"),
    $d68250d1285b4a40$var$load("hhss7"),
    $d68250d1285b4a40$var$load("8ab9M"),
    $d68250d1285b4a40$var$load("gyOzw"),
    $d68250d1285b4a40$var$load("ePdWC"),
    $d68250d1285b4a40$var$load("lBzRN"),
    $d68250d1285b4a40$var$load("9wxKg"),
    $d68250d1285b4a40$var$load("Wowvf"),
    $d68250d1285b4a40$var$load("6O8m6"),
    $d68250d1285b4a40$var$load("5GxU8"),
    $d68250d1285b4a40$var$load("amUNi"),
    $d68250d1285b4a40$var$load("7whwt"),
    $d68250d1285b4a40$var$load("699ae"),
    $d68250d1285b4a40$var$load("i7QCq"),
    $d68250d1285b4a40$var$load("87NBA"),
    $d68250d1285b4a40$var$load("8KnyD"),
    $d68250d1285b4a40$var$load("ffEVr"),
    $d68250d1285b4a40$var$load("kUbUu"),
    $d68250d1285b4a40$var$load("4Lgj0"),
    $d68250d1285b4a40$var$load("kSJiq"),
    $d68250d1285b4a40$var$load("dIKn2"),
    $d68250d1285b4a40$var$load("8fdGr"),
    $d68250d1285b4a40$var$load("fnmhc"),
    $d68250d1285b4a40$var$load("kdoia"),
    $d68250d1285b4a40$var$load("7EorR"),
    $d68250d1285b4a40$var$load("8CeYz")
]).then(()=>parcelRequire('djmKw'));

});

parcelRegister("c5zvz", function(module, exports) {
$parcel$export(module.exports, "useConfluenceStandardToPremiumPUBTouchpoint", () => (parcelRequire("fBwOr")).useConfluenceStandardToPremiumPUBTouchpoint);
$parcel$export(module.exports, "StandardToPremiumModalMountComponent", () => (parcelRequire("5DQLv")).StandardToPremiumModalMountComponent);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5izcQ = parcelRequire("5izcQ");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");



var $fBwOr = parcelRequire("fBwOr");


var $5DQLv = parcelRequire("5DQLv");

const $ce6cbe4a9370c72f$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw _1ydi18uv",
            __cmplp.className
        ])
    });
});

const $ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IlAy6",
    name: "EditionAwarenessUpsellLoadable",
    loader: async ()=>(await (parcelRequire("2Je4C"))).EditionAwarenessUpsell
});
const $ce6cbe4a9370c72f$export$f255ec0f3619af65 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(({ navVersion: navVersion })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable, {
        navVersion: navVersion
    })));
});
module.exports["EditionAwarenessUpsellExperiment"] = $ce6cbe4a9370c72f$export$f255ec0f3619af65;

});

parcelRegister("fBwOr", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $50xoH = parcelRequire("50xoH");


var $gKr8t = parcelRequire("gKr8t");


var $7Sm4c = parcelRequire("7Sm4c");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $99oLS = parcelRequire("99oLS");


var $hxSIT = parcelRequire("hxSIT");


var $aT8im = parcelRequire("aT8im");

const $000cc169882182f2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    persistentUpgradeMenuItemFreePlanTitle: {
        id: "experiment-edition-awareness-for-standard-to-premium.section.message.persistent-upgrade.menuitem.premiumplan.title",
        defaultMessage: "Upgrade"
    }
});
const $000cc169882182f2$export$70b32605d3b8db81 = (navVersion)=>{
    const [renderFailed, setRenderFailed] = (0, $42omo.useState)(false);
    const { cloudId: cloudId, isEligibleForUpsellExperiment: isEligibleForUpsellExperiment, hasDismissedButton: hasDismissedButton } = (0, $aT8im.useConfluenceStandardToPremiumExperiment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal, setModalProps: setModalProps } = (0, $99oLS.useConfluenceStandardToPremiumModalActions)();
    // isEligibleForUpsellExperiment checks for experiment enrollment as well
    const meetsBaseEligibility = isEligibleForUpsellExperiment && hasDismissedButton;
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery($cloudId:ID!$productKey:String!$trialOfferingName:String!){tenantContexts(cloudIds:[$cloudId])@optIn(to:["CcpAllUserUpgradeAndPay" "HamsAllUserUpgradeAndPay"]){entitlementInfo(hamsProductKey:$productKey){paidEntitlement:entitlement(where:{inTrialOrPreDunning:false}){experienceCapabilities{changeOfferingV2(offeringName:$trialOfferingName){experienceUrl}}}}}}`, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId,
            productKey: 'confluence',
            trialOfferingName: 'Premium'
        },
        skip: !meetsBaseEligibility
    });
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'persistent-upgrade-button-standard-to-premium',
                source: 'useConfluenceStandardToPremiumPUBTouchpoint',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion,
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isEligibleForStandardToPremiumPersistentUpgradeButton = meetsBaseEligibility && !renderFailed;
    const experienceUrl = data?.tenantContexts?.[0]?.entitlementInfo?.paidEntitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    if (!loading && isEligibleForStandardToPremiumPersistentUpgradeButton && (!experienceUrl || experienceUrl?.includes('admin/billing'))) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'error',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessStandardToPremiumDialog',
            attributes: {
                product: 'confluence',
                touchpointIntent: 'startTrial',
                dialogId: 'standard-to-premium',
                dialogType: 'modal',
                error: 'No change offering URL found for premium upgrade - using fallback',
                navVersion: navVersion,
                changeOfferingUrl: experienceUrl ?? '',
                isEligibleForStandardToPremiumPersistentUpgradeButton: isEligibleForStandardToPremiumPersistentUpgradeButton
            },
            source: 'useConfluenceStandardToPremiumPUBTouchpoint'
        }
    }).fire();
    // remove the edition from the change plan urls so they land on the plan selection page for hams || ccp
    // there may be a key in shared tenant context api that can be used instead of this
    const learnMoreUrl = (0, $hxSIT.useBuildLearnMoreLink)(experienceUrl);
    const handlePUBClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'persistent-upgrade-button-standard-to-premium',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion
                },
                source: 'useConfluenceStandardToPremiumPUBTouchpoint'
            }
        }).fire();
        setModalProps({
            experienceUrl: experienceUrl ?? '',
            learnMoreUrl: learnMoreUrl,
            navVersion: navVersion
        });
        showModal({
            touchpointId: 'edition-awareness-standard-to-premium-pub'
        });
    }, [
        createAnalyticsEvent,
        showModal,
        setModalProps,
        experienceUrl,
        learnMoreUrl,
        navVersion
    ]);
    if (!isEligibleForStandardToPremiumPersistentUpgradeButton || loading || error) return [];
    return [
        {
            heading: {
                ...$000cc169882182f2$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanTitle
            },
            items: [
                {
                    action: ()=>handlePUBClick(),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
                        onError: ()=>setRenderFailed(true)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $50xoH.EditionAwarenessStandardPubTouchpoint), {
                        product: "confluence",
                        testId: "edition-awareness-standard-pub-touchpoint",
                        navVersion: navVersion
                    })),
                    key: 'try-premium-plan'
                }
            ]
        }
    ];
};
module.exports["useConfluenceStandardToPremiumPUBTouchpoint"] = $000cc169882182f2$export$70b32605d3b8db81;

});

parcelRegister("50xoH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $5nBzc = parcelRequire("5nBzc");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $343be00b8c32c969$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label",
        defaultMessage: "Try the Premium plan"
    },
    persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge",
        defaultMessage: "FREE 30-DAY TRIAL"
    }
});
const $343be00b8c32c969$var$menuItemContentStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexWrap: 'nowrap'
});
const $343be00b8c32c969$var$lozengeContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100'
});
function $343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl({ product: product, testId: testId, navVersion: navVersion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editionAwarenessStandardToPremiumPUB',
                attributes: {
                    source: 'EditionAwarenessStandardPubTouchpoint',
                    product: product,
                    navVersion: navVersion
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        xcss: $343be00b8c32c969$var$menuItemContentStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...$343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $343be00b8c32c969$var$lozengeContainerStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    appearance: "new",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...$343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment
                    })
                })
            })
        ]
    });
}
function $343be00b8c32c969$export$bf5f4133d9c358a3(props) {
    const { product: product, navVersion: navVersion } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnError = (0, $42omo.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            source: 'unknownErrorSource',
            attributes: {
                product: product,
                edition: 'standard',
                navVersion: navVersion,
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $l998X.jsx)($343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl, {
            ...props
        })
    });
}
module.exports["EditionAwarenessStandardPubTouchpoint"] = $343be00b8c32c969$export$bf5f4133d9c358a3;

});

parcelRegister("99oLS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9968f6026062a518$var$initialState = {
    isOpen: false,
    learnMoreUrl: '',
    experienceUrl: '',
    navVersion: undefined
};
const $9968f6026062a518$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        },
    setModalProps: ({ learnMoreUrl: learnMoreUrl, experienceUrl: experienceUrl, navVersion: navVersion })=>({ setState: setState })=>{
            setState({
                learnMoreUrl: learnMoreUrl,
                experienceUrl: experienceUrl,
                navVersion: navVersion
            });
        }
};
const $9968f6026062a518$var$store = (0, $1P1Tu.createStore)({
    initialState: $9968f6026062a518$var$initialState,
    actions: $9968f6026062a518$var$actions,
    name: 'editionAwarenessStandardToPremiumModalStore'
});
const $9968f6026062a518$export$d912d1373319011f = (0, $9zUhf.createActionsHook)($9968f6026062a518$var$store);
const $9968f6026062a518$export$cd5aa218e504e6f3 = (0, $9zUhf.createHook)($9968f6026062a518$var$store);
module.exports["useConfluenceStandardToPremiumModalActions"] = $9968f6026062a518$export$d912d1373319011f;
module.exports["useConfluenceStandardToPremiumModal"] = $9968f6026062a518$export$cd5aa218e504e6f3;

});

parcelRegister("hxSIT", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8c4b8f8f76d4beac$export$9bcf733c7567f1c = (baseUrl)=>{
    const FALLBACK_URL = '/admin/billing';
    return (0, $42omo.useMemo)(()=>{
        if (!baseUrl) return FALLBACK_URL;
        try {
            const url = new URL(baseUrl);
            const isHams = url.pathname.includes('change-edition');
            if (isHams) // remove "/<edition>" at the end of the path
            url.pathname = url.pathname.split('/').slice(0, -1).join('/');
            else {
                url.searchParams.delete('offeringName');
                url.searchParams.delete('offeringname');
            }
            return url.toString();
        } catch (err) {
            return FALLBACK_URL;
        }
    }, [
        baseUrl
    ]);
};
module.exports["useBuildLearnMoreLink"] = $8c4b8f8f76d4beac$export$9bcf733c7567f1c;

});

parcelRegister("5DQLv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Xlut2",
    name: "LazyStandardToPremiumModal",
    loader: async ()=>(await (parcelRequire("5qldL"))).StandardToPremiumModal
});
const $cf9f6e6dcd5627ce$export$4b9ed4d06294662c = ()=>{
    if ((0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal, null);
    return null;
};
module.exports["StandardToPremiumModalMountComponent"] = $cf9f6e6dcd5627ce$export$4b9ed4d06294662c;

});

parcelRegister("5qldL", function(module, exports) {

let $3f2fd77cc9fb3402$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f2fd77cc9fb3402$var$load("6wr18"),
    $3f2fd77cc9fb3402$var$load("hUapU"),
    $3f2fd77cc9fb3402$var$load("lRtGG"),
    $3f2fd77cc9fb3402$var$load("8UKe0"),
    $3f2fd77cc9fb3402$var$load("ffEVr"),
    $3f2fd77cc9fb3402$var$load("hhss7"),
    $3f2fd77cc9fb3402$var$load("9CRBg")
]).then(()=>parcelRequire('hCU0r'));

});

parcelRegister("2Je4C", function(module, exports) {

let $1fcab377d2f9a5e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1fcab377d2f9a5e5$var$load("8KnyD"),
    $1fcab377d2f9a5e5$var$load("6wr18"),
    $1fcab377d2f9a5e5$var$load("icLtf"),
    $1fcab377d2f9a5e5$var$load("kFEyO"),
    $1fcab377d2f9a5e5$var$load("8JZKd"),
    $1fcab377d2f9a5e5$var$load("6KFfh"),
    $1fcab377d2f9a5e5$var$load("eufZR"),
    $1fcab377d2f9a5e5$var$load("eeaKR"),
    $1fcab377d2f9a5e5$var$load("hhss7"),
    $1fcab377d2f9a5e5$var$load("awqCy"),
    $1fcab377d2f9a5e5$var$load("ffEVr"),
    $1fcab377d2f9a5e5$var$load("7EorR"),
    $1fcab377d2f9a5e5$var$load("lz2pE")
]).then(()=>parcelRequire('7Bwbp'));

});

parcelRegister("eDAGu", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");


var $i7t6K = parcelRequire("i7t6K");

let $7ca3f558dc62e54e$var$pe = null;
const $7ca3f558dc62e54e$var$getObserver = ()=>{
    if ($7ca3f558dc62e54e$var$pe !== null) return $7ca3f558dc62e54e$var$pe;
    $7ca3f558dc62e54e$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LongTask) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).Event) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event].push(entry);
        });
    });
    return $7ca3f558dc62e54e$var$pe;
};
const $7ca3f558dc62e54e$export$231c167ad8c908df = ()=>{
    if ($7ca3f558dc62e54e$var$pe) {
        // Disconnect the observer if it's already set up
        $7ca3f558dc62e54e$var$pe.disconnect();
        $7ca3f558dc62e54e$var$pe = null;
    }
    for (const type of Object.values((0, $2c1Wz.PerformanceObserverEntryTypes)))$7ca3f558dc62e54e$var$getObserver().observe({
        type: type,
        buffered: true
    });
};
module.exports["startLightHouseObservers"] = $7ca3f558dc62e54e$export$231c167ad8c908df;

});

parcelRegister("lTjel", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $94ecb5e99e218b76$export$b602c35a55c29946 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "-DYr1",
    name: "ErrorAppLoader",
    loader: async ()=>(await (parcelRequire("bZGgW"))).ErrorApp
});
module.exports["ErrorAppLoader"] = $94ecb5e99e218b76$export$b602c35a55c29946;

});

parcelRegister("aFgFx", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");




var $ahDyi = parcelRequire("ahDyi");

async function $457aeee54b862c4a$export$b1c9c77d4871a337(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey),
        $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey) {
    await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $ahDyi.EmbedUnifiedQuery),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
}
async function $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey) {}
module.exports["preloadEmbedData"] = $457aeee54b862c4a$export$b1c9c77d4871a337;

});

parcelRegister("kyd3u", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $9wGTI = parcelRequire("9wGTI");



var $9ycGg = parcelRequire("9ycGg");




var $fiBb3 = parcelRequire("fiBb3");


var $80xNa = parcelRequire("80xNa");

function $7f1954fc7a2cd99f$export$c628356b573f8241({ isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey, contentId: contentId }) {
    const queries = [];
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline') && (0, $9wGTI.fg)('cc_ssr_preload_header_data_for_edit_page')) {
        queries.push((0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fiBb3.ContentHeaderUnifiedQuery),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                versionOverride: null,
                embeddedContentRender: null,
                limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                includeGeneratedBy: (0, $9wGTI.fg)('cc-activation-user-generated-by-byline'),
                ...isUnpublishedDraft && {
                    status: [
                        'draft'
                    ]
                }
            }
        }));
        queries.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
module.exports["preloadEditorByLineData"] = $7f1954fc7a2cd99f$export$c628356b573f8241;

});

parcelRegister("6YxJf", function(module, exports) {

var $MyxIQ = parcelRequire("MyxIQ");

const $3050fc659ed4bb43$export$4be2eb0104d640dc = async (preloadedSessionContext)=>{
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-home-banner', preloadedSessionContext);
};
module.exports["preloadPostOfficeConfluenceHomeBanner"] = $3050fc659ed4bb43$export$4be2eb0104d640dc;

});

parcelRegister("1Rv6U", function(module, exports) {
// Data Plugin definition and utility types
const $355a7b1aa3f573ec$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $355a7b1aa3f573ec$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $355a7b1aa3f573ec$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $355a7b1aa3f573ec$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};
module.exports["PluginTypes"] = $355a7b1aa3f573ec$export$a235a73f7b906dce;
module.exports["ContainerTypes"] = $355a7b1aa3f573ec$export$6e383182a26455ff;
module.exports["UserIdTypes"] = $355a7b1aa3f573ec$export$e391bab95adb8396;

});

parcelRegister("h3nb6", function(module, exports) {
/* eslint-disable no-restricted-syntax */ 
var $42omo = parcelRequire("42omo");


var $64KID = parcelRequire("64KID");


var $kE2cJ = parcelRequire("kE2cJ");


var $jmjWc = parcelRequire("jmjWc");


const $e9270d50e13c4524$export$58ad04e57ec143c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DOtt7",
    name: "RedirectLegacyCopyPageLoader",
    loader: async ()=>(await (parcelRequire("3JgB7"))).RedirectLegacyCopyPage
});
$e9270d50e13c4524$export$58ad04e57ec143c3.NAVIGATION_PARAMS = ()=>false;






const $1547fdfac1788133$export$70a5a4ee184a1106 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hF4WF",
    name: "RedirectLegacyViewPageLoader",
    loader: async ()=>(await (parcelRequire("9RxHT"))).RedirectLegacyViewPage
});
$1547fdfac1788133$export$70a5a4ee184a1106.NAVIGATION_PARAMS = ()=>false;




// These are routes shared between SSR and SPA

var $jiFpb = parcelRequire("jiFpb");


var $4lJOK = parcelRequire("4lJOK");


var $hDf9e = parcelRequire("hDf9e");


var $hkCxu = parcelRequire("hkCxu");


var $k1285 = parcelRequire("k1285");




var $jiJCD = parcelRequire("jiJCD");





var $kFqI2 = parcelRequire("kFqI2");


var $kJOOQ = parcelRequire("kJOOQ");

parcelRequire("6g1oe");


var $aTWRz = parcelRequire("aTWRz");

var $iyEDi = parcelRequire("iyEDi");

const $8012954d5e28a430$export$33ab8fb3f76d8b14 = ()=>{
    const location = (0, $kFqI2.useSelector)((0, $iyEDi.getLocation));
    const dispatch = (0, $kFqI2.useDispatch)();
    (0, $42omo.useEffect)(()=>{
        const { query: query, pathname: pathname } = location;
        let contentType;
        if (pathname.indexOf('/createpage.action') !== -1 || pathname.indexOf('/createpage-entervariables.action') !== -1) contentType = 'pages';
        else if (pathname.indexOf('/createblogpost.action') !== -1) contentType = 'blog';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        let spaceKey;
        if (typeof query.spaceKey !== 'undefined' && query.spaceKey) spaceKey = query.spaceKey;
        else if (typeof query.draftId !== 'undefined' && /^[0-9]+$/.test(query.draftId)) spaceKey = 'byDraft';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        const newQuery = {};
        Object.keys(query).filter((param)=>param !== 'spaceKey').forEach((param)=>newQuery[param] = query[param]);
        const nextLocation = {
            ...location,
            pathname: `${(0, $aTWRz.CONTEXT_PATH)}/spaces/${spaceKey}/${contentType}/create`,
            query: newQuery,
            search: (0, $jiJCD.format)({
                query: newQuery
            })
        };
        dispatch((0, $kJOOQ.replace)(nextLocation));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$8012954d5e28a430$export$33ab8fb3f76d8b14.NAVIGATION_PARAMS = ()=>false;






var $4l6Wo = parcelRequire("4l6Wo");


var $aVKfT = parcelRequire("aVKfT");

const $d553d8b4da7f3160$export$25552d6a584e1fb8 = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    // Construct the module id from URL params to match the format expected by ForgeGlobalSettingsExtensionPoint
    // Format: ari:cloud:ecosystem::extension/{appId}/{envId}/static/{moduleKey}
    // This matches against app.id in the Forge extensions list
    const id = `ari:cloud:ecosystem::extension/${appId}/${envId}/static/${forgeManifestRoute}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVKfT.ForgeGlobalSettingsExtensionPoint), {
        key: id,
        id: id
    });
};
$d553d8b4da7f3160$export$25552d6a584e1fb8.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeApps'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });












const $5d42f987126d0d25$var$AdminForgeAppsRedirect = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "vKaNx",
    name: "AdminForgeAppsRedirect",
    loader: async ()=>(await (parcelRequire("jOXb3"))).AdminForgeAppsRedirect
});
const $5d42f987126d0d25$export$1eaead8b8e68953c = ({ params: params, query: query })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5d42f987126d0d25$var$AdminForgeAppsRedirect, {
        params: params,
        query: query
    });
};
$5d42f987126d0d25$export$1eaead8b8e68953c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeAppsRedirect'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









var $aF1vZ = parcelRequire("aF1vZ");


var $9wGTI = parcelRequire("9wGTI");

const $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aF1vZ.AdvancedSearch), null);
$f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: (0, $9wGTI.fg)('unified_search_in_confluence') ? null : {
            screenEvent: {
                name: 'advancedSearchScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};


/* eslint react/prop-types:0 */ 









const $f9284ca1d97b2b7a$export$32926c3a37851958 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Rr_Hq",
    name: "BetaFeaturesSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("9qbTD"))).BetaFeaturesSiteSettingsPage
});


const $7949c11e9e78d917$export$39279dc1d0cb138f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9284ca1d97b2b7a$export$32926c3a37851958), null);
$7949c11e9e78d917$export$39279dc1d0cb138f.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'betaFeaturesScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });








var $8g7sM = parcelRequire("8g7sM");




var $78QFu = parcelRequire("78QFu");





const $b4ceb88d52b227e6$var$ExternalSharePageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8xw-",
    name: "ExternalSharePageLoader",
    loader: async ()=>(await (parcelRequire("9Ouxr"))).ExternalSharePage
});
const $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f = ({ params: { contentId: contentId, externalToken: externalToken }, hash: hash })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b4ceb88d52b227e6$var$ExternalSharePageLoader, {
        siteUrl: window.location.hostname,
        contentId: contentId === 'undefined' ? undefined : contentId,
        shareToken: externalToken,
        queryHash: hash,
        ContentRenderer: (0, $8g7sM.default)
    });
$b4ceb88d52b227e6$export$2f64eafbbfb5bb9f.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: true,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                routeName: name
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $2a1308b9f924bd74$export$dceb5680f254ba0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4i8AJ",
    name: "ForgeGlobalPageExtensionPoint",
    loader: async ()=>(await (parcelRequire("7lrfj"))).GlobalPage
});


const $88f9531119605f50$export$a0e2b6c59fd25a4e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2a1308b9f924bd74$export$dceb5680f254ba0d), {
        key: `${appId}-${envId}-${forgeManifestRoute}`,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$88f9531119605f50$export$a0e2b6c59fd25a4e.NAVIGATION_PARAMS = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'globalPageScreen',
                id: appId,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};












const $5651b1434c6bae88$var$SitePermissions = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8YbJt",
    name: "SitePermissions",
    loader: async ()=>(await (parcelRequire("3oadb"))).SitePermissions
});
const $5651b1434c6bae88$export$72e24cb8f0330a61 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5651b1434c6bae88$var$SitePermissions, null);
$5651b1434c6bae88$export$72e24cb8f0330a61.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









var $ayyKy = parcelRequire("ayyKy");


var $9HNv5 = parcelRequire("9HNv5");







var $agglT = parcelRequire("agglT");


const $b11848dc615e604f$export$b212d6e1ccf8d345 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uZr6h",
    loader: async ()=>(await (parcelRequire("8aYco"))).CompanyHubSettingsPage,
    name: 'CompanyHubSettingsPage'
});



var $8NC5Z = parcelRequire("8NC5Z");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");




var $2Uf3N = parcelRequire("2Uf3N");






















var $1NBp8 = parcelRequire("1NBp8");


var $iquRY = parcelRequire("iquRY");


const $3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3C38l",
    name: "SpacePermissionsSettingsRouteComponent",
    loader: async ()=>(parcelRequire("iGLU4"))
});
const $3dace45d43821ccc$var$DEFAULT_TAB = 'users';
const $3dace45d43821ccc$export$c4e68572e7b94bc6 = ({ name: routeName, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } })=>{
    //
    // Warning:
    // "Hub permissions" is a customization of "Space permissions" predating RBAC so
    // "Hub permissions" is to be used in the Company Hub-type of space and
    // "Space permissions" or RBAC are to be used in all other types of space!
    //
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (isCompanyHub) {
        if (routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
            params: {
                tab: 'users'
            }
        });
    } else {
        //RBAC Milestone 2 Redirect Logic in case users try to access via url
        const isSpacePermissionsTab = tab === 'users' || tab === 'groups' || tab === 'guests';
        if (isSpacePermissionsTab && isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_MEMBERS).name,
            params: {
                spaceKey: spaceKey
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$3dace45d43821ccc$export$c4e68572e7b94bc6.NAVIGATION_PARAMS = (routeMatch, isNav4Enabled)=>{
    const { name: name, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: tab === 'public-links' ? 'spacePermissionsPublicLinksScreen' : `${tab}SpacePermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: $3dace45d43821ccc$var$getSideNav(routeMatch, isNav4Enabled),
            spaceKey: spaceKey
        }
    };
};
const $3dace45d43821ccc$var$getSideNav = (routeMatch, isNav4Enabled)=>(0, $cEgMD.isCompanyHubSpaceKey)(routeMatch.params.spaceKey) && (0, $ayyKy.getCompanyHubSideNav)(routeMatch) ? (0, $4l6Wo.ADMIN_HOME_ID) : isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID);









const $94454e5f287d76d5$export$a9d78c41686becfd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2UE21",
    loader: async ()=>(await (parcelRequire("k3h41"))).SpaceRoleManagementPage,
    name: 'SpaceRoleManagementPage'
});

















const $f9fff28badc7670c$export$214350c926cc60f2 = ({ name: routeName, params: { spaceKey: spaceKey } })=>{
    const { isRbacEnabled: isRbacEnabled, loading: loading } = (0, $iquRY.useSpaceRoleMode)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub && routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
        params: {
            tab: 'users'
        }
    });
    if (!loading && !isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94454e5f287d76d5$export$a9d78c41686becfd), {
        spaceKey: spaceKey
    });
};
$f9fff28badc7670c$export$214350c926cc60f2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceMembersScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });





/**
 * The routes "Company Hub settings > Users" and "Hub permissions" in the Confluence app.
 * `AdminCompanyHubPermissionsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute({ params: params, ...props }) {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (isSiteAdmin && shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHubPermissions"
    });
    if (!params.tab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).USERS
    });
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9fff28badc7670c$export$214350c926cc60f2), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dace45d43821ccc$export$c4e68572e7b94bc6), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
}
$ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: params } = routeMatch;
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $ayyKy.getCompanyHubSideNav)(routeMatch) ? (0, $4l6Wo.ADMIN_HOME_ID) : (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: `${params.tab || 'consolidated'}HubPermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: navView,
            spaceKey: spaceKey
        }
    };
};
const $ce2a2ee7f6871785$export$eeb7368e8bf944ac = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute);


















const $4fa13b181dc663ad$var$CustomizeNavigation = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Ss1hK",
    name: "CustomizeNavigation",
    loader: async ()=>(await (parcelRequire("gpuqf"))).CustomizeNavigation
});
const $4fa13b181dc663ad$export$3206f56dd9eda6e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fa13b181dc663ad$var$CustomizeNavigation, null);
$4fa13b181dc663ad$export$3206f56dd9eda6e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'customizeNavigationScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });
const $4fa13b181dc663ad$export$5744f34ed241a45c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$4fa13b181dc663ad$export$5744f34ed241a45c.NAVIGATION_PARAMS = ()=>false;









const $9dff8dc763109b25$export$a4a7c409f3d3e524 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LLjB-",
    name: "GlobalAutomationRoute",
    loader: async ()=>(await (parcelRequire("6V55f"))).Automation
});
$9dff8dc763109b25$export$a4a7c409f3d3e524.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalAutomationRoute'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });












const $3e17cd15ad9a2d77$var$UserDetails = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4otHM",
    name: "UserDetails",
    loader: async ()=>(await (parcelRequire("aDv5i"))).UserDetails
});
const $3e17cd15ad9a2d77$export$ef0ae9b94af7599 = ({ params: { accountId: accountId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e17cd15ad9a2d77$var$UserDetails, {
        accountId: accountId
    });
$3e17cd15ad9a2d77$export$ef0ae9b94af7599.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsUserDetailsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });





parcelRequire("b1pD4");
var $3ACqI = parcelRequire("3ACqI");





const $a311429dbe08f666$export$6b6e4f47fea5bdb9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w4gXW",
    name: "ViewPagePdfExportLoader",
    loader: async ()=>(await (parcelRequire("7d2cw"))).ViewPagePdfExportPage
});


parcelRequire("4Yv1J");
var $f5aR2 = parcelRequire("f5aR2");

parcelRequire("crTA1");
var $iqZzD = parcelRequire("iqZzD");

const $de365c057d45c0f8$export$d4d3fe32e0af1ab9 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a311429dbe08f666$export$6b6e4f47fea5bdb9), {
        contentId: String(contentId),
        spaceKey: String(spaceKey),
        classicComments: (0, $3ACqI.CommentsSectionLoader)
    })));
$de365c057d45c0f8$export$d4d3fe32e0af1ab9.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                contentId: contentId,
                routeName: name,
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });






var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");

parcelRequire("4Yv1J");


parcelRequire("crTA1");


const $cdc5bb1b4ce25ace$export$f10520cd46ef45dd = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djZz9.SpaceOverviewLoader), {
        spaceKey: String(spaceKey)
    })));
$cdc5bb1b4ce25ace$export$f10520cd46ef45dd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                routeName: name,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            },
            spaceKey: spaceKey
        },
        MainLayout: {
            enableNavigation: false
        }
    });






var $1wgMJ = parcelRequire("1wgMJ");








var $56QzY = parcelRequire("56QzY");


const $24a857c7c96255d7$var$PeopleDirectory = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zWQBJ",
    name: "PeopleDirectory",
    loader: async ()=>(await (parcelRequire("eKeNR"))).PeopleDirectory
});
const $24a857c7c96255d7$export$c7bf94fd367d52ef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24a857c7c96255d7$var$PeopleDirectory, {
        statusCodeHandlers: {
            401: (0, $1wgMJ.redirectToLoginPage)
        }
    });
$24a857c7c96255d7$export$c7bf94fd367d52ef.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            name: 'inProdPeopleDirectory',
            attributes: {
                navdexPointType: (0, $56QzY.START_TOUCH)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};












const $a6aaee7eaacb3bc0$export$1696ac6f866195be = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MGscQ",
    name: "MarketplaceRoute",
    loader: async ()=>(await (parcelRequire("kAxaH"))).Marketplace
});
$a6aaee7eaacb3bc0$export$1696ac6f866195be.NAVIGATION_PARAMS = ({ name: name })=>{
    let eventName = '';
    let navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    if (name === (0, $1NBp8.MARKETPLACE_FIND_APPS).name) {
        eventName = 'marketplaceFindApps';
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    } else if (name === (0, $1NBp8.MARKETPLACE_APP_REQUESTS).name) {
        eventName = 'marketplaceAppRequests';
        navView = (0, $4l6Wo.ADMIN_HOME_ID);
    } else if ((0, $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS).name) {
        eventName = 'marketplacePromotions';
        navView = (0, $4l6Wo.ADMIN_HOME_ID);
    }
    return {
        Screen: {
            screenEvent: {
                name: eventName,
                id: eventName
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};












const $3dce15286068fd34$export$f2df3d24f362ca75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "QJy0w",
    name: "ForgeSpacePageExtensionPoint",
    loader: async ()=>(await (parcelRequire("5gklh"))).SpacePage
});


parcelRequire("crTA1");


const $e20a45805838a7c5$export$16cbc228d727cb5e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dce15286068fd34$export$f2df3d24f362ca75), {
        key: appId + envId + forgeManifestRoute,
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    }));
};
$e20a45805838a7c5$export$16cbc228d727cb5e.NAVIGATION_PARAMS = ({ name: name, params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });


/* eslint react/prop-types:0 */ 









const $70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zXYF3",
    name: "SpaceSettingsForgeAppsRouteComponent",
    loader: ()=>(parcelRequire("kjKSX"))
});
const $70d1956925899c9e$export$21a09e0ddc77eafe = ({ params: { appId: appId, forgeManifestRoute: forgeManifestRoute, envId: envId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent, {
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$70d1956925899c9e$export$21a09e0ddc77eafe.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, appId: appId, envId: envId } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId
                }
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZLKey",
    name: "SpaceSettingsArchiveSpaceRouteComponent",
    loader: ()=>(parcelRequire("hTO1G"))
});
const $3d2592d831aaf97c$export$c5e406a0947cdc56 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent, {
        spaceKey: spaceKey
    });
$3d2592d831aaf97c$export$c5e406a0947cdc56.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsArchiveSpace',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "640l2",
    name: "SpaceSettingsEditorConversionRouteComponent",
    loader: ()=>(parcelRequire("WJkgK"))
});
const $c1c9698c93be07c8$export$698dfc3fe326e6d2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent, {
        spaceKey: spaceKey
    });
$c1c9698c93be07c8$export$698dfc3fe326e6d2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditorConversion',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "dJgx9",
    name: "SpaceSettingsContentStateRouteComponent",
    loader: ()=>(parcelRequire("gObvh"))
});
const $ada82682e35c0989$export$9cf7aa4fa48eb220 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent, {
        spaceKey: spaceKey
    });
$ada82682e35c0989$export$9cf7aa4fa48eb220.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsContentState',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-Bup",
    name: "SpaceSettingsRelatedPagesRouteComponent",
    loader: async ()=>(await (parcelRequire("grDVy"))).SpaceSettingsRelatedPagesRouteComponent
});
const $5fd2607ebf0fb934$export$50efde5a87cc8957 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent, {
        spaceKey: spaceKey
    });
$5fd2607ebf0fb934$export$50efde5a87cc8957.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsRelatedPages',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iFso2",
    name: "SpaceSettingsEditFeaturesRouteComponent",
    loader: async ()=>(await (parcelRequire("kSHES"))).SpaceSettingsEditFeaturesRouteComponent
});
const $c991c60ce35a3f45$export$769dfef0447f3a55 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent, {
        spaceKey: spaceKey
    });
$c991c60ce35a3f45$export$769dfef0447f3a55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditFeatures',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });






var $feuG2 = parcelRequire("feuG2");




parcelRequire("crTA1");


const $ae6364090fd3faa0$export$45c01163cd56b3a2 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.LazySpaceDetailsPage), {
        spaceKey: spaceKey
    }));
};
$ae6364090fd3faa0$export$45c01163cd56b3a2.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: (0, $feuG2.SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });












const $ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EJBqs",
    name: "SpaceLookAndFeelSettingsRouteComponent",
    loader: async ()=>(parcelRequire("7SwJt"))
});
const $ea3042d7dfb4b938$export$9ebf5b01b0356442 = ({ params: { spaceKey: spaceKey, tab: tab } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$ea3042d7dfb4b938$export$9ebf5b01b0356442.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingLookAndFeelPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












var $8dwdz = parcelRequire("8dwdz");

parcelRequire("crTA1");



const $6079beeead36a4aa$var$ArchivedPagesListContainer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mIHzp",
    name: "ArchivedPagesListContainer",
    loader: async ()=>(await (parcelRequire("f4SWy"))).ArchivedPagesListContainer
});
const $6079beeead36a4aa$export$77792abc2bfae7a1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6079beeead36a4aa$var$ArchivedPagesListContainer, {
        spaceKey: spaceKey
    }));
};
$6079beeead36a4aa$export$77792abc2bfae7a1.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    return {
        Screen: {
            screenEvent: {
                name: 'spaceArchivedPages',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            enableNavigation: !isMobile
        }
    };
};


/* eslint react/prop-types:0 */ 









const $9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EYcHq",
    name: "SpaceSettingsDataClassificationRouteComponent",
    loader: ()=>(parcelRequire("jOUeC"))
});
const $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent, {
        spaceKey: spaceKey
    });
$9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsDataClassification',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oooFg",
    name: "SpaceSettingsWatermarkConfigurationRouteComponent",
    loader: ()=>(parcelRequire("amnPv"))
});
const $0db33795337c2a26$export$2bb331cf926ecae2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent, {
        spaceKey: spaceKey
    });
$0db33795337c2a26$export$2bb331cf926ecae2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsWatermarkConfiguration',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });





parcelRequire("bDjCi");
var $ltKTq = parcelRequire("ltKTq");
var $bDjCi = parcelRequire("bDjCi");

function $e84d6ad8839aa142$export$355693d248632c9a() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).MY_CALENDARS
    });
}
$e84d6ad8839aa142$export$355693d248632c9a.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'myCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });





parcelRequire("bDjCi");


function $d017e5de5f44817e$export$6443958a7203f769() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).MULTIPLE_CALENDARS
    });
}
$d017e5de5f44817e$export$6443958a7203f769.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'multipleCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });





parcelRequire("bDjCi");


function $d3bef7a856c272ba$export$5984a4822491c8de() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).EMBEDDED_MULTIPLE_CALENDARS
    });
}
$d3bef7a856c272ba$export$5984a4822491c8de.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'embeddedMultipleCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });


/* eslint-disable react/prop-types */ 








parcelRequire("bDjCi");



const $116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "tO6zv",
    name: "SpaceTeamCalendarsRouteComponent",
    loader: ()=>(parcelRequire("iAxzI"))
});
const $116a232d5237eb91$export$c1ba174e1a668b1a = ({ params: { subCalendarId: subCalendarId } })=>{
    const calendarContext = subCalendarId ? (0, $ltKTq.CALENDAR_CONTEXT).SPACE_SUBCALENDAR : (0, $ltKTq.CALENDAR_CONTEXT).SPACE_CALENDARS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent, {
        subCalendarId: subCalendarId,
        calendarContext: calendarContext
    });
};
$116a232d5237eb91$export$c1ba174e1a668b1a.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'spaceTeamCalendarsScreen',
                id: spaceKey,
                attributes: {
                    isSingleCalendar: !!subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};





parcelRequire("bDjCi");


const $40c2c72cc1663e14$export$b6ba0c14cb68dffc = ({ params: { subCalendarId: subCalendarId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).EMBEDDED_SUBCALENDAR,
        subCalendarId: subCalendarId
    });
};
$40c2c72cc1663e14$export$b6ba0c14cb68dffc.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceEmbeddedSubcalendarScreen',
                id: spaceKey,
                attributes: {
                    subCalendarId: subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });












const $8089a5c0318e4300$export$d299494231e51197 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XYKgm",
    name: "LazySpaceDirectory",
    loader: async ()=>(await (parcelRequire("f6zUg"))).SpaceDirectory
});


const $6b9376eebbcdd446$export$e2f6c7ec524fdd6a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8089a5c0318e4300$export$d299494231e51197), null);
$6b9376eebbcdd446$export$e2f6c7ec524fdd6a.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDirectoryScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });





















const $bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EHSjL",
    name: "SpaceSettingsLandingPageRouteComponent",
    loader: ()=>(parcelRequire("l40Ef"))
});
const $bdfe305fbc319d8d$export$b0e13503df86295 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name,
        params: {
            spaceKey: spaceKey,
            tab: 'users'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent, {
        spaceKey: spaceKey
    });
};
$bdfe305fbc319d8d$export$b0e13503df86295.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsLandingPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });








parcelRequire("b1pD4");



var $6O2BV = parcelRequire("6O2BV");


var $gdv5Z = parcelRequire("gdv5Z");


var $1iSzD = parcelRequire("1iSzD");


var $ep3mz = parcelRequire("ep3mz");





var $7EX8o = parcelRequire("7EX8o");

parcelRequire("4Yv1J");



var $4H46k = parcelRequire("4H46k");


var $9pOEz = parcelRequire("9pOEz");

const $6c697104f01a0e5d$var$EmbeddedSpaceOverview = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $6c697104f01a0e5d$var$SpaceOverview = ({ spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djZz9.SpaceOverviewLoader), {
        spaceKey: spaceKey
    });
};
const $6c697104f01a0e5d$export$495cec58911c040d = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contextContentId ?? '';
    const component = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6c697104f01a0e5d$var$EmbeddedSpaceOverview, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6c697104f01a0e5d$var$SpaceOverview, {
        spaceKey: spaceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null));
};
var $6c697104f01a0e5d$export$2e2bcd8739ae039 = $6c697104f01a0e5d$export$495cec58911c040d;


const $8290afb66ac54848$export$200c90655ff1c697 = (0, $4lJOK.getSpaceOverviewRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));








parcelRequire("b1pD4");















const $0b1718e5f1e38843$export$26b856d756d6b8dc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "h8KkD",
    name: "HubRendererLoader",
    loader: async ()=>(await (parcelRequire("f6jYE"))).HubRendererComponent
});








parcelRequire("4Yv1J");









const $f6b27607b6d81126$var$EmbeddedHubRenderer = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $f6b27607b6d81126$export$964c57d73cd4c096 = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contextContentId ?? '';
    const component = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f6b27607b6d81126$var$EmbeddedHubRenderer, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0b1718e5f1e38843$export$26b856d756d6b8dc), {
        spaceKey: spaceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null));
};
const $f6b27607b6d81126$export$d8819c37d45ffdfc = (0, $hDf9e.getCompanyHubRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));


























/**
 * The route "Company Hub settings > Analytics" in the Confluence app.
 * `CompanyHubAnalyticsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute() {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHub"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).ANALYTICS
    });
}
$b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = isNav4Enabled ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubAnalytics'
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_ANALYTICS).name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $b5f6e0dacae3f98e$export$ccf9c625603cc873 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute);









var $eXODy = parcelRequire("eXODy");








var $hnvzE = parcelRequire("hnvzE");


var $2VZOl = parcelRequire("2VZOl");


var $8KbKw = parcelRequire("8KbKw");


var $hQm1C = parcelRequire("hQm1C");


var $eqNP8 = parcelRequire("eqNP8");








var $gTyTP = parcelRequire("gTyTP");


var $39rFu = parcelRequire("39rFu");


var $8Hqv7 = parcelRequire("8Hqv7");


var $6gETM = parcelRequire("6gETM");


var $8jRXE = parcelRequire("8jRXE");

const $6a336fa33a376cf7$var$EditPageLoaderInternal = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader })=>{
    const [prevContentId, setPrevContentId] = (0, $42omo.useState)(contentId);
    const [prevContentType, setPrevContentType] = (0, $42omo.useState)(contentType);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { referredFromLivePage: referredFromLivePage } = (0, $39rFu.useEditPageLoadingValues)();
    const { loadEditor: setEditPageLoadingValues } = (0, $39rFu.useEditPageLoadingActions)();
    const [livePageTransitionHandled, setLivePageTransitionHandled] = (0, $42omo.useState)(false);
    // This useEffect allows us to unmount and remount the ClassicEditorContextProvider,
    // NativeCollabLoader, and FullPageEditor when switching from one edit page to another edit page.
    // This is necessary to reset the editor properly for edit -> edit transitions.
    (0, $42omo.useEffect)(()=>{
        setPrevContentId(contentId);
        setLivePageTransitionHandled(false);
    }, [
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        setPrevContentType(contentType);
    }, [
        contentType
    ]);
    // Be careful when modifying this useEffect as this can break live page -> edit page transitions
    // This effect is a temporary solution to address an issue where the editor does not reset properly when navigating from a live page.
    // The editor tends to hold onto state from the previous page, causing problems when switching between pages if a full unmount doesn't occur.
    // This effects resets the editor by force-unmounting it by showing the loading screen when it detects a transition from a live page.
    (0, $42omo.useEffect)(()=>{
        // livePageTransitionHandled is used to prevent the editor from showing the loading screen endlessly
        if (referredFromLivePage && !livePageTransitionHandled) {
            setLivePageTransitionHandled(true);
            // Need to reset this property or it'll be retained when the browser back button is used.
            // In that case, it doesn't go through the flow that sets the value again.
            setEditPageLoadingValues({
                referredFromLivePage: undefined
            });
        }
    }, [
        referredFromLivePage,
        livePageTransitionHandled,
        setEditPageLoadingValues
    ]);
    if (contentId !== prevContentId || contentType !== prevContentType || referredFromLivePage && !livePageTransitionHandled) // isLoading is set to true by a state change, which does not happen immediately after content id changes
    // To make sure loading screen shows up immediately after content id changes, compare new content id with the content id in ref
    // This is smilar to how componentWillUpdate works in a classic react component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
    const EditPageWrapper = ClassicEditorContextProviderLoader ?? (({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "edit-page-default-wrapper"
        }, children));
    return(// @ts-ignore - Property 'isWithinEditor' is missing in type '{ children: Element; }' but required in type '{ children: any; isWithinEditor: any; }'
    // This error was introduced after upgrading to TypeScript 5
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hQm1C.NativeCollabLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(contentId, draftShareId)
    }, (propsFromNativeCollab)=>{
        if (propsFromNativeCollab.subType === 'live' && !propsFromNativeCollab.isOverviewPage && isLivePagesFeatureEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.VIEW_PAGE).name,
            params: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        });
        // This TreeRootForServerPlaceholderWrapper placed here to ensure the proper lookup of the placeholders for
        // SSRed loadables. Due to different component trees between server (EditPageLoader) and client (EditPageLoaderServer)
        // the placeholder ids hierarchy is different. This wrapper terminates the lookup for placeholder ids on the common parent,
        // so it matches on both server and client.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Hqv7.FullCycleRenderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jRXE.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        })));
    }))));
};
const $6a336fa33a376cf7$export$b6d447abe5222d2c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "edit-page-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a336fa33a376cf7$var$EditPageLoaderInternal, props));
};



var $ak57N = parcelRequire("ak57N");


var $34NZw = parcelRequire("34NZw");


var $5vi32 = parcelRequire("5vi32");














var $cZa7r = parcelRequire("cZa7r");








var $6mKj3 = parcelRequire("6mKj3");

const $0e80cf500c4229e5$export$5cc0e8d070ec38e9 = ({ params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam }, query: query, pathname: pathname })=>{
    const draftShareId = typeof query?.draftShareId === 'string' ? query.draftShareId : undefined;
    // editRouteTypeParam !== contentType !== pageType
    // editContentType is blog or pages
    // contentType is blogpost or page
    // pageType is blog or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldRedirectCompanyHubEditRoute = isCompanyHub && (0, $1NBp8.COMPANY_HUB_EDIT).pattern !== pathname;
    if (shouldRedirectCompanyHubEditRoute) // The company hub edit route should handle upsell scenarios and other cases
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.COMPANY_HUB_EDIT).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6a336fa33a376cf7$export$b6d447abe5222d2c), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })));
};
$0e80cf500c4229e5$export$5cc0e8d070ec38e9.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const isPageLikeContent = editRouteTypeParam === 'pages' || editRouteTypeParam === 'blog';
    const isBlog = editRouteTypeParam === 'blog';
    // editRouteTypeParam !== contentType
    // editRouteTypeParam is blog or pages
    // contentType is blogpost or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    let viewId = (0, $4l6Wo.CONTAINER_HOME_ID);
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) viewId = (0, $4l6Wo.PRODUCT_HOME_ID);
    else if (isBlog) viewId = (0, $4l6Wo.CONTAINER_BLOG_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END)
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: (0, $6mKj3.expVal)('confluence_editor_min_width_fix', 'isEnabled', false) ? false : true,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $1f7939e43bf6965f$export$335f265b0f783405 = (0, $hkCxu.getCompanyHubEditRoute)((0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9));



























var $6gbpH = parcelRequire("6gbpH");


var $7f6xB = parcelRequire("7f6xB");


var $cbvYp = parcelRequire("cbvYp");


var $4cOi8 = parcelRequire("4cOi8");


var $bQm3c = parcelRequire("bQm3c");


var $eDATL = parcelRequire("eDATL");

const $ca035e1fc91a5c2a$export$b1a4eb0063bc2123 = ({ params: { contentId: contentId, contentType: editRouteTypeParam } })=>{
    const sessionData = (0, $bQm3c.useSessionData)();
    // Don't render until session data is available to prevent context errors
    if (!sessionData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gbpH.HubEditorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbvYp.ConfluenceDependenciesProvider), {
        mode: (0, $4cOi8.ExtensionMode).EDITOR,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f6xB.HeadingLinksStyleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDATL.default), {
        contentId: contentId,
        product: "CONFLUENCE",
        hasEditPermission: true,
        viewMode: "edit",
        userPreferencesProvider: undefined,
        isLoomPluginEnabled: false,
        editorPluginAIOptions: undefined,
        editorPluginAIDefinitionsEnabled: false,
        editorPluginAIDefinitionsConfig: undefined,
        editorPluginAIProactiveEnabled: false,
        editorPluginAIProactiveConfig: undefined,
        isDesktop: false,
        contextPanelOptions: undefined,
        getExtensionHeight: undefined,
        __rendererExtensionOptions: undefined,
        PropsProvider: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })))));
};
$ca035e1fc91a5c2a$export$b1a4eb0063bc2123.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const contentType = 'page';
    const viewId = (0, $4l6Wo.PRODUCT_HOME_ID);
    const screenEventName = 'companyHubEditorScreen';
    const screenIsInSpace = false;
    return {
        Screen: {
            screenEvent: {
                name: screenEventName,
                id: spaceKey,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END),
                    screenIsInSpace: screenIsInSpace
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $437f27e114bb0121$export$29545d7913f7e4d9 = (0, $k1285.getCompanyHubEditorRoute)((0, $ca035e1fc91a5c2a$export$b1a4eb0063bc2123));


















/**
 * The route "Company Hub settings" in the Confluence app.
 * `CompanyHubSettingsRoute` wraps this one to implement the Company Hub pseudo app.
 */ const $dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), null);
$dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const navView = isNav4Enabled ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubSettingsScreen',
                attributes: {
                    // Company Hub hides its space from the user, doesn't refer to its page
                    // as such, is rather presented to the user as "a new surface", and thus
                    // doesn't constitute space usage from the perspective of the user.
                    screenIsInSpace: false
                }
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_SETTINGS).name,
                spaceKey: (0, $cEgMD.getCompanyHubSpaceKey)()
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $dbfb738401d21a8a$export$5df4bb70a888e6ef = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute);

















parcelRequire("crTA1");



const $3ae3b5e6a32b9f05$var$SpacePages = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Mg0yj",
    name: "SpacePages",
    loader: async ()=>(await (parcelRequire("eb9uS"))).SpacePages
});
const $3ae3b5e6a32b9f05$export$64ef8a59e56631d4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ae3b5e6a32b9f05$var$SpacePages, null));
};
$3ae3b5e6a32b9f05$export$64ef8a59e56631d4.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spacePagesScreen',
                attributes: {
                    navigationLayer: 'container',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true
        }
    });








parcelRequire("crTA1");





const $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazySpaceBlogRedirect), null));
$5fbf62dcc2c7f9c7$export$59ba7d1ff575355e.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'blogHomeScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_BLOG_ID),
            spaceKey: spaceKey
        }
    });












const $604611f3b9c6a1bd$export$6fe611e4bd8a9f83 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KbMaW",
    name: 'ManagePagesLoader',
    loader: async ()=>{
        return (await (parcelRequire("4edSW"))).ManagePagesV2;
    }
});






var $lt6Lx = parcelRequire("lt6Lx");


var $wtSEP = parcelRequire("wtSEP");

parcelRequire("crTA1");


const $95e685c28d9f350e$export$690ececaf2f5ac01 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $604611f3b9c6a1bd$export$6fe611e4bd8a9f83), {
        spaceKey: spaceKey
    }));
};
$95e685c28d9f350e$export$690ececaf2f5ac01.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceBulkTools',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1mKe4",
    name: "TemplateMigrationPreviewLoader",
    loader: async ()=>(await (parcelRequire("3P3RU"))).TemplateMigrationPreview
});


const $a310d6589e3c6137$export$2549ad5558b468ce = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4), {
        templateId: contentId
    });
$a310d6589e3c6137$export$2549ad5558b468ce.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'templateMigrationPreviewScreen'
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false
    });












const $ab6a74840300f72c$export$8cf1c696fd3c0922 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-xoDL",
    name: "TemplateEditorLoader",
    loader: async ()=>{
        const { TemplateEditor: TemplateEditor } = await (parcelRequire("lSOk7"));
        return TemplateEditor;
    }
});


function $db60bab822fccf44$var$getId(params) {
    const { contentId: contentId, pluginKey: pluginKey, moduleKey: moduleKey } = params;
    return !contentId && moduleKey ? `${pluginKey}:${moduleKey}` : contentId;
}
const $db60bab822fccf44$export$b015e9e7191a93bd = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab6a74840300f72c$export$8cf1c696fd3c0922), {
        templateId: id,
        spaceKey: spaceKey
    }));
};
$db60bab822fccf44$export$b015e9e7191a93bd.NAVIGATION_PARAMS = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'editTemplatePageScreen',
                id: id || ''
            },
            pageState: {
                contentId: id,
                spaceKey: spaceKey
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    };
};









const $e6c819a73b1c7672$export$70238cd3868b67c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gd8xC",
    name: "Onboarding",
    loader: async ()=>(await (parcelRequire("1Q4ws"))).Onboarding
});



var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");

const $52219feed318a69e$export$329ee42b27a3306e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c819a73b1c7672$export$70238cd3868b67c9), null));
$52219feed318a69e$export$329ee42b27a3306e.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'onboardingContainerScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: false
    });















const $72fe25ca1dda155a$export$e5cc8897c2b49b25 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "P5sQM",
    name: "ContentHistoryLoader",
    loader: async ()=>(await (parcelRequire("2kCzs"))).ContentHistory
});



var $gGwl1 = parcelRequire("gGwl1");










const $48c85dee1e05da94$var$parseVersionParam = (value)=>{
    if (!value || Array.isArray(value)) return undefined;
    const parsedValue = parseInt(value, 10);
    return isNaN(parsedValue) ? undefined : parsedValue;
};
const $48c85dee1e05da94$var$ContentHistoryRouteComponent = ({ params: { spaceKey: spaceKey, contentId: contentId }, query: query })=>{
    const version1 = $48c85dee1e05da94$var$parseVersionParam(query?.version1);
    const version2 = $48c85dee1e05da94$var$parseVersionParam(query?.version2);
    return (0, $6mKj3.expValEquals)('confluence_content_history_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGwl1.NewContentHistory), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        version1: version1,
        version2: version2
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $72fe25ca1dda155a$export$e5cc8897c2b49b25), {
        spaceKey: spaceKey,
        contentId: contentId,
        stack: "classic"
    });
};
$48c85dee1e05da94$var$ContentHistoryRouteComponent.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    return {
        Screen: {
            screenEvent: {
                name: isCompanyHub ? 'hubHistoryScreen' : 'pageHistoryScreen',
                id: contentId
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isCompanyHub ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};
const $48c85dee1e05da94$export$e510023ce2e8f364 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($48c85dee1e05da94$var$ContentHistoryRouteComponent, (route)=>(0, $cEgMD.isCompanyHubSpaceKey)(route?.params?.spaceKey));












const $64e99ecf69e59c34$export$9defecaf7509c9ff = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NjYCL",
    name: "TemplateGalleryLoader",
    loader: async ()=>(await (parcelRequire("2RoXr"))).TemplateGallery
});


const $0f81c6a8d9931e4d$export$e2ed88affe37abdc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64e99ecf69e59c34$export$9defecaf7509c9ff), null);
$0f81c6a8d9931e4d$export$e2ed88affe37abdc.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'templateGalleryScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });









const $eedda2b5abe28404$export$25901255b411dbc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hLwu8",
    name: "MacroRendererPageLoader",
    loader: async ()=>(await (parcelRequire("iEUAa"))).MacroRendererPage
});


parcelRequire("4Yv1J");


const $fcdf58a0a381c832$export$29b5dbba9b9e21d8 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eedda2b5abe28404$export$25901255b411dbc4), {
        contentId: contentId,
        ContentExtensionsProvider: (0, $f5aR2.ContentExtensionsProvider)
    });
};
$fcdf58a0a381c832$export$29b5dbba9b9e21d8.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'mobileMacroRendererScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false
    });









const $7b810fd40f00ac37$var$MobileAppTakeoverPageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oLwa7",
    name: "MobileAppTakeoverPageLoader",
    loader: async ()=>(await (parcelRequire("ipfH1"))).MobileAppTakeoverPage
});
const $7b810fd40f00ac37$export$1a98ae7373202607 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b810fd40f00ac37$var$MobileAppTakeoverPageLoader, null);
$7b810fd40f00ac37$export$1a98ae7373202607.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'mobileTakeoverPage'
            }
        },
        MainLayout: false
    });









var $hwzJf = parcelRequire("hwzJf");


var $idSff = parcelRequire("idSff");

const $75f6c666a9c742b2$export$e5707bd7e32dbf9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idSff.SiteHomepageRedirectLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hwzJf.GoToHomeLoader), null));
$75f6c666a9c742b2$export$e5707bd7e32dbf9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'wikiScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });

















const $4625b8b3d160569d$export$48d3d184aade51b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hwzJf.GoToHomeLoader), null);
$4625b8b3d160569d$export$48d3d184aade51b1.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            editorPreloader: (0, $eXODy.getEditorPreloader)
        }
    });











const $92a0e12da2d6b5f0$export$bf305e48a79a981b = {
    attributes: {
        navdexPointType: (0, $56QzY.END)
    }
};


const $c3c08e13adc00b49$export$daeca97aa431dd80 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "blogpost"
    });
$c3c08e13adc00b49$export$daeca97aa431dd80.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });









const $93e08279e521422d$export$92431fd1ef2a3e02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "page"
    });
$93e08279e521422d$export$92431fd1ef2a3e02.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });






var $8MiHL = parcelRequire("8MiHL");





const $2807fe6645e49e0b$export$6a3218472cdf374a = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "pages",
        contentId: contentId,
        spaceKey: spaceKey
    });
$2807fe6645e49e0b$export$6a3218472cdf374a.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b).attributes,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });











const $cdf2efa932a544ee$export$657999c2675036a8 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "blog",
        contentId: contentId,
        spaceKey: spaceKey
    });
$cdf2efa932a544ee$export$657999c2675036a8.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'blogpost'
            }
        },
        MainLayout: false
    });













const $9ba53981e2ca7f45$export$a835caedc175b18 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "c8AJW",
    name: "EmbeddedEditPageLoader",
    loader: async ()=>(await (parcelRequire("4JvlJ"))).EmbeddedEditPage
});



const $dde5e37bf0f94188$export$a338f76d183c610 = ({ params: { contentId: contentId, spaceKey: spaceKey }, query: { draftShareId: draftShareId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ba53981e2ca7f45$export$a835caedc175b18), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: String(draftShareId),
        contentType: "page"
    }));
$dde5e37bf0f94188$export$a338f76d183c610.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageEmbedScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });









const $91e544e3fd3704c7$export$bae7b470830e7536 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EbSw2",
    name: "SmartCreatePageEditorLoader",
    loader: async ()=>(await (parcelRequire("hk8wA"))).SmartCreatePageEditorDataWrapper
});















const $bb42a89ba72dd22d$export$997e52ba9fce325c = ({ params: { contentId: contentId }, query: { sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId } })=>{
    if (!(0, $9wGTI.fg)('aifc_create_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.HOME).toUrl()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91e544e3fd3704c7$export$bae7b470830e7536), {
        contentId: contentId,
        sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId
    }));
};
$bb42a89ba72dd22d$export$997e52ba9fce325c.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageSmartCreateScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });


/* eslint react/prop-types:0 */ 









const $d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xxPa8",
    name: "SpaceSettingsAutomationRouteComponent",
    loader: ()=>(parcelRequire("gZQYc"))
});
const $d6b8391ba067d418$export$3e7656e40361b9c3 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent, {
        spaceKey: spaceKey
    });
$d6b8391ba067d418$export$3e7656e40361b9c3.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingAutomationRoute',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $90cab0c9e6efa470$export$c5b2c959a5ee5a4a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Lsv8X",
    name: "ConnectSpaceCustomContentListView",
    loader: async ()=>(await (parcelRequire("iXUzT"))).ConnectSpaceCustomContentListView
});


const $25fdeb0a789de125$export$1045fc666c352ae6 = ({ params: { spaceKey: spaceKey, type: type } })=>{
    const [stateKey, setStateKey] = (0, $42omo.useState)(history?.state?.key || Math.random());
    // Updating a key state and reload ConnectSpaceCustomContentListView component.
    //
    // Connect Apps can have an inner history state (created with AP.history), which add
    // hashtag to URL (for example: #!state1)
    // When user navigates to this route again the URL is reset to initial state and
    // hashtag is removed, but inner app does not get any notifications about that and
    // don't reset inner app state.
    //
    // To fix this issue we are listening history.state.key, and when it's changed
    // (user create a new entry in history) refresh component
    (0, $42omo.useEffect)(()=>{
        // We rely on history.state.key that is not documented, but major browsers have it
        if (history?.state?.key) setStateKey(history.state.key);
        else if (!history?.state?._AP) setStateKey(Math.random());
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        history?.state,
        setStateKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90cab0c9e6efa470$export$c5b2c959a5ee5a4a), {
        spaceKey: spaceKey,
        type: type,
        key: stateKey
    });
};
$25fdeb0a789de125$export$1045fc666c352ae6.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, type: type } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceCustomContent',
                id: spaceKey,
                attributes: {
                    type: type
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });









const $ae3041c2a586590e$export$cc376322db18bf6e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sjwPy",
    name: "CustomContentOnPageComponentLoader",
    loader: async ()=>(await (parcelRequire("7b5IB"))).CustomContentOnPageComponent
});





const $4af991445198673b$export$80477c996ae74379 = ({ params: { contentId: contentId, spaceKey: spaceKey, type: type } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ae3041c2a586590e$export$cc376322db18bf6e), {
        contentId: contentId,
        spaceKey: spaceKey,
        type: type === 'undefined' ? '' : type
    });
};
$4af991445198673b$export$80477c996ae74379.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentOnPage',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $95bd051929613722$export$f536037c46d4c012 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9X2ye",
    name: "CustomContentView",
    loader: async ()=>(await (parcelRequire("8R4tZ"))).CustomContentView
});


const $c7473af47fe3192c$export$b836ebd0f49cc9f5 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95bd051929613722$export$f536037c46d4c012), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$c7473af47fe3192c$export$b836ebd0f49cc9f5.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentView',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $0960da40109465b4$var$PublicLinksSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rP97Y",
    name: "PublicLinksSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("4pErf"))
});
const $0960da40109465b4$export$af4daa43ca1332b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0960da40109465b4$var$PublicLinksSettingsPageRouteComponent, null);
$0960da40109465b4$export$af4daa43ca1332b9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'publicLinksSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $95bdd88deead3c11$export$ecc44bd892306adb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "00c23",
    name: "ContactAdministratorRoute",
    loader: async ()=>(await (parcelRequire("dqpQq"))).ContactAdministratorPage
});
$95bdd88deead3c11$export$ecc44bd892306adb.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            screenEvent: {
                name: 'contactAdministratorScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};






















const $1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FJbMa",
    name: "RoleBasedAccessControlHubRouteComponent",
    loader: async ()=>(parcelRequire("fFYfK"))
});
const $1fb601398675b5a1$export$23838e4b7dc196e5 = ()=>{
    if (!(0, $6mKj3.expVal)('confluence_rbac_pre_planning_release_fe', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent, null);
};
$1fb601398675b5a1$export$23838e4b7dc196e5.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: 'roleBasedAccessControlHubScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};












const $e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LCRNu",
    name: "AdminAnnouncementBannerRenderer",
    loader: async ()=>(await (parcelRequire("eUF5C"))).AdminAnnouncementBannerRenderer
});
const $e77b8eed9c4fe03f$export$81a4ecf687c4a61b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer, null);
};
$e77b8eed9c4fe03f$export$81a4ecf687c4a61b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminAnnouncementBannerRenderer'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });















const $36a63e56cd2b2984$var$AdminCenterPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yN5_D",
    name: "AdminCenterPage",
    loader: async ()=>(await (parcelRequire("6X7p0"))).AdminCenterPage
});
const $36a63e56cd2b2984$export$60c1a30975370191 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36a63e56cd2b2984$var$AdminCenterPage, null);
$36a63e56cd2b2984$export$60c1a30975370191.NAVIGATION_PARAMS = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenter',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};














parcelRequire("crTA1");



const $015145ca08e6a13a$var$AdminCenterSpacePage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1dPKI",
    name: "AdminCenterSpacePage",
    loader: async ()=>(await (parcelRequire("6X7p0"))).AdminCenterSpacePage
});
const $015145ca08e6a13a$export$bd929b984ffc4a9 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($015145ca08e6a13a$var$AdminCenterSpacePage, {
        spaceKey: spaceKey
    }));
};
$015145ca08e6a13a$export$bd929b984ffc4a9.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenterSpace',
                id: spaceKey,
                attributes: {
                    edition: edition
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};















var $euL71 = parcelRequire("euL71");

const $6f06338c7fe23a44$export$44bc7d6c094dc951 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition === (0, $euL71.ConfluenceEdition).PREMIUM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CENTER).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
};
$6f06338c7fe23a44$export$44bc7d6c094dc951.NAVIGATION_PARAMS = ()=>false;


/* eslint react/prop-types:0 */ 









const $e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HYdso",
    name: "SpaceSettingsExportSpaceUnavailableRouteComponent",
    loader: ()=>(parcelRequire("fVdPo"))
});
const $e2d8d9818dde6381$export$1d1f8d0ef7c7a185 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent, {
        spaceKey: spaceKey
    });
$e2d8d9818dde6381$export$1d1f8d0ef7c7a185.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsExportSpaceUnavailable',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });














var $9TVBV = parcelRequire("9TVBV");


const $55b7ec62080e1638$export$98f6226b8f451523 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TMJ6c",
    loader: async ()=>(await (parcelRequire("bbaoL"))).BulkSpacePermissionsPortal,
    name: 'BulkSpacePermissionsPortal'
});

const $55b7ec62080e1638$export$405a6cc8f1c994c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LzFeC",
    loader: async ()=>(await Promise.resolve((parcelRequire("9TVBV")))).BulkSpacePermissionsPage,
    name: 'BulkSpacePermissionsPage'
});







const $fe2917192dc4f6b9$export$db2035bfb5892b74 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VMbza",
    loader: async ()=>(await Promise.resolve((parcelRequire("kAGh9")))).BulkAccessManagementPage,
    name: 'BulkAccessManagementPage'
});





const $4255a2123073399b$export$a1ed7a563d6f8c80 = ()=>{
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe2917192dc4f6b9$export$db2035bfb5892b74), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $55b7ec62080e1638$export$405a6cc8f1c994c8), null);
};
$4255a2123073399b$export$a1ed7a563d6f8c80.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9TVBV.ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });














parcelRequire("bDjCi");
var $e8WZK = parcelRequire("e8WZK");

const $d1361d4d835db3f1$export$5164e66822dc5aec = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendarSiteSettingsPage), null);
};
$d1361d4d835db3f1$export$5164e66822dc5aec.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $e8WZK.ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $f1b6649640833ae0$export$acaa2dba3cb8a594 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sV2io",
    name: "LazyConfigurationPage",
    loader: async ()=>(await (parcelRequire("7LCJI"))).ConfigurationPage
});



var $go5PI = parcelRequire("go5PI");




const $daea30cdb73fa105$export$9a9547459861b1d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1b6649640833ae0$export$acaa2dba3cb8a594), null);
$daea30cdb73fa105$export$9a9547459861b1d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $go5PI.ADMIN_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $26ef48198c7a4b22$export$c666402e8e189c20 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XqQyJ",
    name: "LazyDefaultSpaceLogoConfigPage",
    loader: async ()=>(await (parcelRequire("kFe3Q"))).DefaultSpaceLogoConfigPage
});



var $87xWZ = parcelRequire("87xWZ");




const $cf2a30228181ae7a$export$12cd952fb663f2a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26ef48198c7a4b22$export$c666402e8e189c20), null);
$cf2a30228181ae7a$export$12cd952fb663f2a5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $87xWZ.ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $0035ce34a536ea29$export$b15e4e022e4cf20b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Gs9zR",
    name: "LazyHeaderAndFooterPage",
    loader: async ()=>(await (parcelRequire("ksDMU"))).HeaderAndFooterPage
});



var $9VF1g = parcelRequire("9VF1g");




const $d9d1782c5d23f713$export$66aaa3e4fa4fb446 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0035ce34a536ea29$export$b15e4e022e4cf20b), null);
$d9d1782c5d23f713$export$66aaa3e4fa4fb446.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9VF1g.ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $20670991d47ae85d$export$eeb35ce919747456 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g_FZa",
    name: "LazyTemplatesAndBlueprintsPage",
    loader: async ()=>(await (parcelRequire("ktfnc"))).TemplatesAndBlueprintsPage
});



var $kzcPl = parcelRequire("kzcPl");




const $3de5f90ca85ac387$export$fb8cddd2e05884ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $20670991d47ae85d$export$eeb35ce919747456), null);
$3de5f90ca85ac387$export$fb8cddd2e05884ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $kzcPl.ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });


/* eslint react/prop-types:0 */ 







// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 



var $3Tdyk = parcelRequire("3Tdyk");


const $ee7f717a6b819a49$export$9be270b9ed22878c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "v1sq_",
    name: "LazyNotificationsSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("pI7qq"))).NotificationsSiteSettingsPage
});


const $5035325f0c8b9a13$export$65794158c09a379 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee7f717a6b819a49$export$9be270b9ed22878c), null);
$5035325f0c8b9a13$export$65794158c09a379.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $3Tdyk.ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });














var $i6ccO = parcelRequire("i6ccO");


const $13b2a397a1cc2782$export$bac0713ec898bd76 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CRbee",
    name: "LazySpaceReportsSiteSettings",
    loader: async ()=>(await (parcelRequire("aDiH1"))).SpaceReports
});


const $ba2c2ff5f89f0551$export$2667c61817b129fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13b2a397a1cc2782$export$bac0713ec898bd76), null);
$ba2c2ff5f89f0551$export$2667c61817b129fd.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $i6ccO.ADMIN_SPACE_REPORT_SCREEN)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $a1651aa6544b68ec$export$d90af831494c8387 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HbgyC",
    name: "LazyCodeMacroConfigurationPage",
    loader: async ()=>(await (parcelRequire("1wgeK"))).ConfigureCodeMacroPage
});



var $jPtik = parcelRequire("jPtik");




const $2e9a50b174f89446$export$761483e0f415164e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1651aa6544b68ec$export$d90af831494c8387), null);
$2e9a50b174f89446$export$761483e0f415164e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $jPtik.ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });











const $0fb617f0ce9f4007$export$8984debadcec9d93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$0fb617f0ce9f4007$export$8984debadcec9d93.NAVIGATION_PARAMS = ()=>false;









const $545b6e8effa8c8db$export$a21466da6a7c3088 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9Xsqa",
    name: "LazySecurityConfigurationPage",
    loader: async ()=>(await (parcelRequire("2OOsw"))).SecurityConfigurationPage
});



var $5vGLM = parcelRequire("5vGLM");




const $7fe52c8ec8c71cab$export$b882bc9c4e633e9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $545b6e8effa8c8db$export$a21466da6a7c3088), null);
$7fe52c8ec8c71cab$export$b882bc9c4e633e9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $5vGLM.ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $78ef366567be569a$export$80059957d731c042 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w8ZSB",
    name: "LazyApplicationNavigatorPage",
    loader: async ()=>(await (parcelRequire("eOW3x"))).ApplicationNavigatorPage
});



var $dWfBt = parcelRequire("dWfBt");




const $98f73671c286928d$export$55ff18e8dde17771 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $78ef366567be569a$export$80059957d731c042), null);
$98f73671c286928d$export$55ff18e8dde17771.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $dWfBt.ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $b750d916e554f7df$export$93a51467d25d0499 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "84mIg",
    name: "LazyMacroUsagePage",
    loader: async ()=>(await (parcelRequire("bz3UX"))).MacroUsagePage
});



var $9JmJC = parcelRequire("9JmJC");




const $2395a25321aca708$export$1e71122b3eac56e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b750d916e554f7df$export$93a51467d25d0499), null);
$2395a25321aca708$export$1e71122b3eac56e4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9JmJC.ADMIN_MACRO_USAGE_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $b1c56f7f0cd3abfc$export$db3288808f1d2cee = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TlnkG",
    name: "LazyTrashedSpacesPage",
    loader: async ()=>(await (parcelRequire("f99tb"))).TrashedSpacesPage
});



var $4l9JY = parcelRequire("4l9JY");




const $b9260b374d11ae03$export$154b40ed25137a69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1c56f7f0cd3abfc$export$db3288808f1d2cee), null);
$b9260b374d11ae03$export$154b40ed25137a69.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $4l9JY.ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $b17503f7798017b5$export$2ed44b7640eeeaea = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7LBt",
    name: "LazyImportSpacesPage",
    loader: async ()=>(await (parcelRequire("dCOIH"))).ImportSpacesPage
});



var $434W4 = parcelRequire("434W4");




const $d9481fcbb25a62a6$export$6078cc5c61cdb00c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b17503f7798017b5$export$2ed44b7640eeeaea), null);
$d9481fcbb25a62a6$export$6078cc5c61cdb00c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $434W4.ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $856e303ba52ed6c6$export$f522a213bf45cbaf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "s23-1",
    name: "LazyJiraMacroRepairPage",
    loader: async ()=>(await (parcelRequire("iMgCe"))).JiraMacroRepairPage
});



var $2i0P8 = parcelRequire("2i0P8");




const $3ed31ec1d64e85a3$export$1162e5a60ee7576b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $856e303ba52ed6c6$export$f522a213bf45cbaf), null);
$3ed31ec1d64e85a3$export$1162e5a60ee7576b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $2i0P8.ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $c621c947d336edb6$export$39b0a52384de05d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MZ13C",
    name: "LazyThemesPage",
    loader: async ()=>(await (parcelRequire("bKpjI"))).ThemesPage
});



var $ft9Jc = parcelRequire("ft9Jc");




const $95678b1264993b8d$export$cdc2bb4346e935c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c621c947d336edb6$export$39b0a52384de05d), null);
$95678b1264993b8d$export$cdc2bb4346e935c9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $ft9Jc.ADMIN_THEMES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $94ac68953a95a3c6$export$def53ea7cb291102 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4g9eZ",
    name: "LazyPdfExportPage",
    loader: async ()=>(await (parcelRequire("cGA12"))).PdfExportPage
});



var $fmC2G = parcelRequire("fmC2G");




const $d726f64aa7b98b71$export$81e12ffb7d442c0c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94ac68953a95a3c6$export$def53ea7cb291102), null);
$d726f64aa7b98b71$export$81e12ffb7d442c0c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $fmC2G.ADMIN_PDF_EXPORT_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









var $8Nhaa = parcelRequire("8Nhaa");




const $b39b3b8c8cb41baf$export$9334d2c8540310e3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ge6Hg",
    name: "SpaceManagerLoader",
    loader: async ()=>(await (parcelRequire("6Dt64"))).SpaceManager
});


const $244c44f585122129$export$986d179bc3f7f637 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b39b3b8c8cb41baf$export$9334d2c8540310e3), null);
$244c44f585122129$export$986d179bc3f7f637.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $8Nhaa.SPACE_MANAGER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



/* eslint react/prop-types:0 */ 









const $d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9HaD7",
    name: "LazyDefaultSpacePermissionsPage",
    loader: async ()=>(await (parcelRequire("1Si0y"))).DefaultSpacePermissionsPage
});
const $d3d38e453fe82603$export$6b4028c8cfa4e9e1 = (routeMatch)=>{
    const { params: { tab: tab } } = routeMatch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage, {
        activeTab: tab
    });
};
$d3d38e453fe82603$export$6b4028c8cfa4e9e1.NAVIGATION_PARAMS = (routeMatch)=>({
        Screen: {
            screenEvent: {
                name: 'siteSpacePermissionsScreen',
                attributes: {
                    tab: routeMatch.params.tab
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });











function $09759410f0cf9b55$export$e7dd35a659f967b8({ params: { key: key, spaceKey: spaceKey }, query: query }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: key || spaceKey,
            query: query
        }
    });
}
$09759410f0cf9b55$export$e7dd35a659f967b8.NAVIGATION_PARAMS = ()=>false;











function $26b63860644dba7c$export$7bc70d297bcfbf4f(extra) {
    const redirectComponent = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name,
            params: {
                query: {
                    ...query,
                    ...extra
                }
            }
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}









var $7Snc9 = parcelRequire("7Snc9");

const $7cf8f51aa88b9ccf$export$df2de76576f721a1 = ({ pathname: pathname, search: search, query: query })=>{
    if (query['unmatched-route']) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Snc9.NotFound), null);
    search = search.startsWith('?') ? `${search}&unmatched-route=true` : `?unmatched-route=true`;
    return(//Redirect for .action pages that forces a full page reload
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    }));
};
$7cf8f51aa88b9ccf$export$df2de76576f721a1.NAVIGATION_PARAMS = ()=>false;











const $0a13ad86816c36c0$export$cdc5cf7d787e5e31 = ({ pathname: pathname, search: search, query: query })=>{
    const { draftId: draftId } = query;
    if (typeof draftId !== 'string' || !/^[0-9]+$/.test(draftId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.WIKI).name
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    });
};
$0a13ad86816c36c0$export$cdc5cf7d787e5e31.NAVIGATION_PARAMS = ()=>false;









var $d73E7 = parcelRequire("d73E7");

const $09a888bb83dd7791$export$d584a39bdee41574 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    });
$09a888bb83dd7791$export$d584a39bdee41574.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey }, query: { focusedCommentId: focusedCommentId, focusedMentionId: focusedMentionId } })=>({
        Screen: {
            screenEvent: {
                name: 'whiteboardScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    focusedCommentId: focusedCommentId,
                    focusedMentionId: focusedMentionId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'whiteboard',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });












const $18b64a781b16c69e$export$e1e87cd6ad2f9497 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yFgQP",
    name: "FolderRedirectLoader",
    loader: async ()=>(await (parcelRequire("3aHlq"))).FolderRedirect
});






const $ab5acfcef8296b21$export$cdb01b3d24a21485 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1C8qv",
    name: "FolderContainerLoader",
    loader: async ()=>(await (parcelRequire("6oMqS"))).FolderContainer
});





const $6e131d5d0e81b5af$export$110a009c083fc1fc = ({ params: { contentId: contentId } })=>(0, $9wGTI.fg)('confluence_cloud_folder_view') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab5acfcef8296b21$export$cdb01b3d24a21485), {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18b64a781b16c69e$export$e1e87cd6ad2f9497), {
        contentId: contentId
    });
$6e131d5d0e81b5af$export$110a009c083fc1fc.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'folderScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'folder',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });






var $dpPtd = parcelRequire("dpPtd");





const $1f4e11c8ff1e70c5$export$e1cd63b567cc2910 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LWjU2",
    name: "EmbedRouteLoader",
    loader: async ()=>(await (parcelRequire("hVRC2"))).EmbedContainer
});





parcelRequire("crTA1");





const $a86e8bdaaaef979c$export$1a870b21a11af9ae = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910), {
        contentId: contentId,
        spaceKey: spaceKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "EmbedViewRoute"
    }));
$a86e8bdaaaef979c$export$1a870b21a11af9ae.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'smartLinkEmbedPageScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    contentType: 'embed'
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'embed',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });









const $ff966974ac17a8ae$export$d5b2cc659cf7a894 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "K1tWi",
    name: "DatabaseContainerLoader",
    loader: async ()=>(await (parcelRequire("1MVQO"))).DatabaseContainer
});









var $bwC5h = parcelRequire("bwC5h");




const $b443bc65ee980e3b$export$2b633aba04c212bb = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>(0, $9wGTI.fg)('confluence-fix-space-db-redirect-behaviour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    }));
$b443bc65ee980e3b$export$2b633aba04c212bb.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'databaseScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'database',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });














const $88d3e4eaff5b722d$export$4c4704aeef10cf08 = (0, $4lJOK.getSpaceOverviewRoute)(({ spaceKey: spaceKey, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey,
            query: query
        }
    }));









const $79a774581f86de14$export$e7975a21b41d4767 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hYSgM",
    name: "LazyLoader",
    loader: ()=>(parcelRequire("epBQg"))
});









var $iufgB = parcelRequire("iufgB");







var $6CEg5 = parcelRequire("6CEg5");




const $4da47b9dcf27590f$export$9af206dbb2b6a483 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iufgB.CreateContentRouteComponentLoader), {
        preloadWhiteboardRouteComponent: (0, $d73E7.WhiteboardRouteComponentLoader).preload,
        preloadDatabaseRouteComponent: (0, $ff966974ac17a8ae$export$d5b2cc659cf7a894).preload,
        preloadPageAndBlogRouteComponent: (0, $79a774581f86de14$export$e7975a21b41d4767).preload,
        preloadSmartLinkEmbedRouteComponent: (0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910).preload
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
        subject: "PageTree",
        subjectId: "newContentRendered"
    }));
$4da47b9dcf27590f$export$9af206dbb2b6a483.NAVIGATION_PARAMS = ({ name: routeName, params: { spaceKey: spaceKey, contentType: createRouteTypeParam }, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    // spaceKey comes from query object while on creation route
    const currentSpaceKey = spaceKey || query?.spaceKey;
    const isPageLikeContent = createRouteTypeParam === 'page' || createRouteTypeParam === 'blog';
    return {
        Screen: {
            screenEvent: {
                name: 'createContentScreen'
            },
            pageState: {
                spaceKey: currentSpaceKey,
                routeName: routeName
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            // CREATE_CONTENT route can return an undefined spaceKey during creation so we render a loading screen
            navView: query.spaceKey ? (0, $4l6Wo.CONTAINER_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_LOADING_ID),
            spaceKey: currentSpaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};
























var $ko9Ek = parcelRequire("ko9Ek");




















var $4D2qK = parcelRequire("4D2qK");





const $37eba1df63470b23$export$f574cd97f97b4d34 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XaRNl",
    name: "ViewPageLiteHeaderLoader",
    loader: async ()=>(await (parcelRequire("grnbw"))).ViewPageLiteHeader
});


parcelRequire("8pBIa");
var $6Evf5 = parcelRequire("6Evf5");

parcelRequire("4Yv1J");


parcelRequire("crTA1");





const $92d3732f6f6decb7$export$e537bc4c45dc607c = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>{
    const isPage = routeName === (0, $1NBp8.VIEW_PAGE).name;
    const isBlog = routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || routeName === (0, $1NBp8.VIEW_BLOG).name;
    let contentType;
    // any one of VIEW_BLOG_DATE_LEGACY, VIEW_BLOG or VIEW_PAGE route can end up here from ViewPageOrBlogRoute
    if (isBlog) contentType = 'blogpost';
    else if (isPage) contentType = 'page';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'viewPageScreen',
            id: contentId,
            attributes: {
                isPublicView: false,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            objectType: contentType,
            objectId: contentId
        },
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            routeName: routeName,
            contentSlug: contentSlug,
            isLite: true,
            contentType: contentType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $37eba1df63470b23$export$f574cd97f97b4d34), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4D2qK.ViewPageLiteLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Evf5.default), {
        pageType: contentType
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "ViewPageLiteRoute"
    }));
};



var $lJlG6 = parcelRequire("lJlG6");

function $7a7b7faa4141aa1d$var$isLite(query) {
    return Boolean(query?.lite);
}
function $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() {
    return window?.__SSR_RENDERED__ && window?.__DELAYED_CONTENT_REDIRECTION__?.contentSlug || '';
}
const $7a7b7faa4141aa1d$export$51ff3cc323c1250d = (props)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { name: name, params: params, query: query } = props;
    const { contentId: contentId, spaceKey: spaceKey } = params;
    const isViewPage = name === (0, $1NBp8.VIEW_PAGE).name;
    if ($7a7b7faa4141aa1d$var$isLite(query)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92d3732f6f6decb7$export$e537bc4c45dc607c), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ko9Ek.ViewPageRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isMobile: isMobile,
        isPage: isViewPage,
        // TODO: When we have a new `<MobileAppViewPageLoader />` component for the mobile app, update this component to
        //   pass `isMobileApp` here as an additional prop, and inside the component, check if `isMobileApp` is true and
        //   if so, use the new `<MobileAppViewPageLoader />` component
        // https://product-fabric.atlassian.net/browse/REACT-8691
        isEmbeddedConfluence: isEmbeddedConfluence || isMobileApp
    }));
};
$7a7b7faa4141aa1d$export$51ff3cc323c1250d.NAVIGATION_PARAMS = ({ name: name, params: params, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence && !isMobileApp;
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    const isViewBlog = name === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || name === (0, $1NBp8.VIEW_BLOG).name;
    const contentType = isViewBlog ? 'blogpost' : 'page';
    if ($7a7b7faa4141aa1d$var$isLite(query)) return false;
    // Use contentSlug from SSR delayed-redirection if available
    const correctContentSlug = $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() || contentSlug || '';
    return {
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                objectType: contentType,
                objectId: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType,
                contentSlug: correctContentSlug
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: isViewBlog ? (0, $4l6Wo.CONTAINER_BLOG_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            isViewPage: true
        }
    };
};









const $674c97fafa39ddaa$export$c8774699c65926c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "djuV7",
    name: "TopicHomepage",
    loader: async ()=>(await (parcelRequire("f5cug"))).TopicHomepageComponent
});














const $ad7e3274b7fede14$export$54f890efdb9a624 = ({ params: { topicId: topicId } })=>{
    if (!(0, $9wGTI.fg)('confluence_enable_ai_topics_homepage')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $674c97fafa39ddaa$export$c8774699c65926c8), {
        topicId: topicId
    });
};
$ad7e3274b7fede14$export$54f890efdb9a624.NAVIGATION_PARAMS = ({ params: { topicId: topicId } })=>({
        Screen: {
            screenEvent: {
                name: 'topicsScreen'
            },
            pageState: {
                topicId: topicId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            topicId: topicId
        }
    });












const $44ff6e33806985ff$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ULKKd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("jEQIl"))
});
const $44ff6e33806985ff$export$384dd5b6b76557b1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey
    });
};
$44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'questionsScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });






var $dY5Vp = parcelRequire("dY5Vp");




function $281ce5bf20714bdc$export$aea18e9fd89afe15({ params: { spaceKey: spaceKey, questionId: questionId } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dY5Vp.LazyQuestions), {
        spaceKey: spaceKey,
        questionId: questionId
    });
}
$281ce5bf20714bdc$export$aea18e9fd89afe15.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'questionScreen',
                questionId: questionId
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $34607f68a2922062$export$5d828b79b8aa9d27 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y34AA",
    name: "SiteAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("hherG"))).SiteAnalyticsPage
});





const $63dcc013c61b21bf$export$ccfda76403f5bd22 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34607f68a2922062$export$5d828b79b8aa9d27), null);
};
$63dcc013c61b21bf$export$ccfda76403f5bd22.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab } })=>{
    return {
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                tab: tab
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};









const $421f3eadd830fd14$export$6dd852c6aabadfda = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rTAZ6",
    name: "SitePermissionsPageLoader",
    loader: async ()=>(await (parcelRequire("exiD9"))).SitePermissionsPage
});





const $2dd41eaa3836b7ed$export$7ed59daacefa1324 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $421f3eadd830fd14$export$6dd852c6aabadfda), null);
};
$2dd41eaa3836b7ed$export$7ed59daacefa1324.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'instanceAnalyticsPermissions'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $b925f878325ca863$export$1c22a22c4bc3d8e9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "D9x42",
    name: "PageAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("4GF8o"))).PageAnalyticsPage
});





const $2ddeeae61cd450c5$export$77b30b491c5d0ee0 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b925f878325ca863$export$1c22a22c4bc3d8e9), {
        contentId: contentId
    });
};
$2ddeeae61cd450c5$export$77b30b491c5d0ee0.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, tab: tab } })=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });









const $9c22efa8f8a6df7c$export$5c0ffde074fc4758 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VV9sG",
    name: "SpaceAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("hGZAP"))).SpaceAnalyticsPage
});





parcelRequire("crTA1");


const $e76c2474e57ea114$export$af7907eff44c835f = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c22efa8f8a6df7c$export$5c0ffde074fc4758), {
        spaceKey: spaceKey
    }));
};
$e76c2474e57ea114$export$af7907eff44c835f.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, tab: tab } }, isNav4Enabled)=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });














const $4a724484ea837e6c$export$703d82918dc06325 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: 'analytics'
        })
    });
$4a724484ea837e6c$export$703d82918dc06325.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceAnalyticsPermissions',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });





















const $b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Fm82P",
    name: "LazySpaceLegacyContentRouteComponent",
    loader: async ()=>(await (parcelRequire("5tYsv"))).SpaceLegacyContentRouteComponent
});
const $b819de32c6839e12$export$f983b39883686021 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('cc-admin-exp-legacy-content-report', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent, {
        spaceKey: spaceKey
    });
};
$b819de32c6839e12$export$f983b39883686021.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'legacyContentScreen'
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $bab2dace65c311d3$export$2b00c7dac5a350a7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "c1xIf",
    name: "SmartCreateSpaceLoader",
    loader: async ()=>(await (parcelRequire("dt6VG"))).SmartCreateSpace
});











const $f9a064f293d5119a$export$683599b1d0dc8e7b = ()=>{
    if (!(0, $9wGTI.fg)('aifc_space_creation_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.HOME).toUrl()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bab2dace65c311d3$export$2b00c7dac5a350a7), null);
};
$f9a064f293d5119a$export$683599b1d0dc8e7b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'spaceSmartCreateScreen'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $e1b3581d111cffc5$export$d563a43e58d8e249 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nNYrs",
    name: "LazyUserAccessPage",
    loader: async ()=>(await (parcelRequire("kx184"))).UserAccessPage
});



var $l5PUQ = parcelRequire("l5PUQ");

const $c4bba5ee88869a52$export$45dbe3e1239d2b94 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1b3581d111cffc5$export$d563a43e58d8e249), null);
$c4bba5ee88869a52$export$45dbe3e1239d2b94.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $l5PUQ.ADMIN_USER_ACCESS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });






var $4xcIM = parcelRequire("4xcIM");


var $dh538 = parcelRequire("dh538");













const $69b9df17dc76bcc3$export$31b05ec87f8c8c11 = 'confluence-fe-space-settings-enable-afm-pdf';

const $69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EoQbw",
    name: "LazyExportSpaceRouteComponent",
    loader: async ()=>(await (parcelRequire("964fa"))).ExportSpaceRouteComponent
});
const $69b9df17dc76bcc3$export$4d1bd2808cfd2f38 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $dh538.fg)($69b9df17dc76bcc3$export$31b05ec87f8c8c11)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.LEGACY_SPACE_PDF_EXPORT).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent, {
        spaceKey: spaceKey
    });
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.propTypes = {
    params: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
    }).isRequired
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'ExportSpaceScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $8e1d38472579226f$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yT4rd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("jEQIl"))
});
const $8e1d38472579226f$export$6cff3d6e80ecc64 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e1d38472579226f$var$QuestionsRouteComponent, {
        isGlobalPage: true
    });
};
$8e1d38472579226f$export$6cff3d6e80ecc64.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });












const $a488bad1e68dd6a7$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6VNHf",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("jEQIl"))
});
const $a488bad1e68dd6a7$export$5c0c86e79c0609bd = ({ params: { questionId: questionId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a488bad1e68dd6a7$var$QuestionsRouteComponent, {
        questionId: questionId,
        spaceKey: spaceKey,
        isGlobalPage: true
    });
};
$a488bad1e68dd6a7$export$5c0c86e79c0609bd.NAVIGATION_PARAMS = ({ params: { questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionScreen',
                questionId: questionId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });












const $9ab50fb164cbfbde$export$dd9490b68a84a0bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nwZgf",
    name: "PremiumAdminFeaturesPageLoader",
    loader: async ()=>(await (parcelRequire("jPfZt"))).PremiumAdminFeaturesPageContainer
});





const $d159621a32e8ccb1$export$400e9e9431ca8a0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ab50fb164cbfbde$export$dd9490b68a84a0bc), null);
$d159621a32e8ccb1$export$400e9e9431ca8a0.NAVIGATION_PARAMS = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'premiumAdminFeaturesScreen',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};








// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 




const $ce2cb80274e3a560$export$67d9d65bd2b4815 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PsbBz",
    name: "ImporterDashboardLoader",
    loader: async ()=>(await (parcelRequire("az3Zv"))).ImporterDashboard
});


const $e2dae4d283de07f2$export$abf2f9d0f3a44f9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ce2cb80274e3a560$export$67d9d65bd2b4815), null);
$e2dae4d283de07f2$export$abf2f9d0f3a44f9c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'IMPORTER_STATUS_DASHBOARD'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $95bf1213cdd8988b$export$989c0e84e4723f09 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "e5N_k",
    name: "LazyNBMPage",
    loader: async ()=>(await (parcelRequire("4AqoJ"))).NBMPage
});





const $0a6ea19b0fb236e1$export$e644f8e819f9f36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95bf1213cdd8988b$export$989c0e84e4723f09), null);
$0a6ea19b0fb236e1$export$e644f8e819f9f36.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminNBMMigration'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $198dcbe4d14ced85$export$a3c0c81377169fa4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "7zyLS",
    name: "LazyDCScriptMigrationPage",
    loader: async ()=>(await (parcelRequire("edpw6"))).DCScriptMigrationPage
});





const $a58212c7e75084fc$export$4b568b9f0da70fe4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $198dcbe4d14ced85$export$a3c0c81377169fa4), null);
$a58212c7e75084fc$export$4b568b9f0da70fe4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminDCScriptMigration'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });









const $68d7a2def2ba29ce$export$2779aee8643e6e52 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "eJge6",
    name: "LazyNBMPerformanceReportPage",
    loader: async ()=>(await (parcelRequire("e13Ip"))).NBMPerformanceReportPage
});





const $8a13ebd6aa0a88b0$export$84f173be1e35ceff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $68d7a2def2ba29ce$export$2779aee8643e6e52), null);
$8a13ebd6aa0a88b0$export$84f173be1e35ceff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminNBMPerformanceReport'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });












const $2eac21f7c787ce68$export$e9527e3d8dc95465 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2Y2rY",
    name: "AttachmentsPageLoader",
    loader: async ()=>(await (parcelRequire("7K78n"))).AttachmentsPage
});








const $167b5527ac95ab07$export$fd9e136112feb41f = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expValEquals)('cc_attachments_page', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2eac21f7c787ce68$export$e9527e3d8dc95465), {
        contentId: contentId,
        spaceKey: spaceKey
    });
};
$167b5527ac95ab07$export$fd9e136112feb41f.NAVIGATION_PARAMS = ({ name: routeName, params: params })=>{
    const { spaceKey: spaceKey, contentId: contentId } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'attachmentsPage',
                id: contentId
            },
            pageState: {
                routeName: routeName,
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};





















const $b29dfc1baf0b1da5$export$842f6d7651a65eb6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qf_1G",
    name: "AISearchPage",
    loader: async ()=>(await (parcelRequire("gZXR7"))).AISearchMain
});


const $962d6764e800d7d4$export$e23fb2c3ce6c7abf = ()=>{
    if (!(0, $9wGTI.fg)('rovo_ai_mode_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b29dfc1baf0b1da5$export$842f6d7651a65eb6), null);
};
$962d6764e800d7d4$export$e23fb2c3ce6c7abf.NAVIGATION_PARAMS = (routeMatch)=>{
    const aiSearchQuery = routeMatch?.query?.aiSearchQuery ?? '';
    return {
        Screen: {
            screenEvent: {
                name: 'aiSearchPageScreen'
            },
            pageState: {
                aiSearchQuery: aiSearchQuery
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            aiSearchQuery: aiSearchQuery
        }
    };
};












const $8fead1916e46fc92$export$8fc14d22356d64d4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ljR4j",
    name: "LazyPermissionsExportPage",
    loader: async ()=>(await (parcelRequire("4M3H8"))).PermissionsExportPage
});


const $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE = 'adminPermissionsExport';
const $6deffcd0919e3152$export$9dc6a62d8cf9ae06 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8fead1916e46fc92$export$8fc14d22356d64d4), null);
$6deffcd0919e3152$export$9dc6a62d8cf9ae06.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });











var $92IuX = parcelRequire("92IuX");



const $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE = 'audit-log';
const $beac86ab997501a9$export$b6dab1e8a8b6a66d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92IuX.AuditLogLoader), null);
$beac86ab997501a9$export$b6dab1e8a8b6a66d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });


function $c6a4b2258628a516$var$redirect(name) {
    const redirectComponent = ({ params: params = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: name,
            params: params
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}
const $c6a4b2258628a516$export$4d9abfe5519d76c6 = (0, $jiFpb.processNavigationParams)({
    [(0, $64KID.namedRoutes).BASE.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).WIKI.name),
    [(0, $64KID.namedRoutes).WIKI.name]: (0, $75f6c666a9c742b2$export$e5707bd7e32dbf9b),
    [(0, $64KID.namedRoutes).HOME.name]: (0, $4625b8b3d160569d$export$48d3d184aade51b1),
    [(0, $64KID.namedRoutes).MOBILE_TAKEOVER_PAGE.name]: (0, $7b810fd40f00ac37$export$1a98ae7373202607),
    [(0, $64KID.namedRoutes).MOBILE_MACRO_RENDERER.name]: (0, $fcdf58a0a381c832$export$29b5dbba9b9e21d8),
    [(0, $64KID.namedRoutes).TEMPLATE_GALLERY.name]: (0, $0f81c6a8d9931e4d$export$e2ed88affe37abdc),
    [(0, $64KID.namedRoutes).EDIT_PAGE.name]: (0, $2807fe6645e49e0b$export$6a3218472cdf374a),
    [(0, $64KID.namedRoutes).EDIT_BLOG.name]: (0, $cdf2efa932a544ee$export$657999c2675036a8),
    [(0, $64KID.namedRoutes).EDIT_PAGE_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_BLOG_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name]: (0, $dde5e37bf0f94188$export$a338f76d183c610),
    [(0, $64KID.namedRoutes).EDIT_PAGE_SMART_CREATE.name]: (0, $bb42a89ba72dd22d$export$997e52ba9fce325c),
    [(0, $64KID.namedRoutes).CREATE_CONTENT.name]: (0, $4da47b9dcf27590f$export$9af206dbb2b6a483),
    [(0, $64KID.namedRoutes).CREATE_PAGE.name]: (0, $93e08279e521422d$export$92431fd1ef2a3e02),
    [(0, $64KID.namedRoutes).CREATE_BLOG.name]: (0, $c3c08e13adc00b49$export$daeca97aa431dd80),
    [(0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_PAGE_VARIABLES_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).RESUME_DRAFT_LEGACY.name]: (0, $0a13ad86816c36c0$export$cdc5cf7d787e5e31),
    [(0, $64KID.namedRoutes).COPY_PAGE_LEGACY.name]: (0, $e9270d50e13c4524$export$58ad04e57ec143c3),
    [(0, $64KID.namedRoutes).DASHBOARD_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).SPA_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).INDEX_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).VIEW_PAGE_ACTION_LEGACY.name]: (0, $1547fdfac1788133$export$70a5a4ee184a1106),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    // it should be after "INDEX_ACTION_LEGACY", and can't be the last one, as it will brake navigation to space settings
    [(0, $64KID.namedRoutes).ACTION_REDIRECT_LEGACY.name]: (0, $7cf8f51aa88b9ccf$export$df2de76576f721a1),
    [(0, $64KID.namedRoutes).SPACE_DIRECTORY.name]: (0, $6b9376eebbcdd446$export$e2f6c7ec524fdd6a),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_REDIRECT_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX.name]: (0, $88d3e4eaff5b722d$export$4c4704aeef10cf08),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW.name]: (0, $8290afb66ac54848$export$200c90655ff1c697),
    [(0, $64KID.namedRoutes).HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    [(0, $64KID.namedRoutes).HUB_EDIT.name]: (0, $437f27e114bb0121$export$29545d7913f7e4d9),
    [(0, $64KID.namedRoutes).COMPANY_HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    [(0, $64KID.namedRoutes).COMPANY_HUB_ANALYTICS.name]: (0, $b5f6e0dacae3f98e$export$ccf9c625603cc873),
    [(0, $64KID.namedRoutes).COMPANY_HUB_EDIT.name]: (0, $1f7939e43bf6965f$export$335f265b0f783405),
    [(0, $64KID.namedRoutes).COMPANY_HUB_SETTINGS.name]: (0, $dbfb738401d21a8a$export$5df4bb70a888e6ef),
    [(0, $64KID.namedRoutes).GLOBAL_PAGE_FORGE.name]: (0, $88f9531119605f50$export$a0e2b6c59fd25a4e),
    [(0, $64KID.namedRoutes).SPACE_PAGES.name]: (0, $3ae3b5e6a32b9f05$export$64ef8a59e56631d4),
    [(0, $64KID.namedRoutes).VIEW_PAGE.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).BLOG_HOME.name]: (0, $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e),
    [(0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).VIEW_BLOG.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).WHITEBOARD_HOME.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_PAGES.name),
    [(0, $64KID.namedRoutes).WHITEBOARD_BOARD.name]: (0, $09a888bb83dd7791$export$d584a39bdee41574),
    [(0, $64KID.namedRoutes).DATABASE_VIEW.name]: (0, $b443bc65ee980e3b$export$2b633aba04c212bb),
    [(0, $64KID.namedRoutes).EMBED_VIEW.name]: (0, $a86e8bdaaaef979c$export$1a870b21a11af9ae),
    [(0, $64KID.namedRoutes).FOLDER_VIEW.name]: (0, $6e131d5d0e81b5af$export$110a009c083fc1fc),
    [(0, $64KID.namedRoutes).CONTACT_ADMINISTRATOR.name]: (0, $95bdd88deead3c11$export$ecc44bd892306adb),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS_SUBCALENDAR.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_EMBEDDED_SUBCALENDAR.name]: (0, $40c2c72cc1663e14$export$b6ba0c14cb68dffc),
    [(0, $64KID.namedRoutes).MULTIPLE_SUBCALENDAR.name]: (0, $d017e5de5f44817e$export$6443958a7203f769),
    [(0, $64KID.namedRoutes).EMBEDDED_MULTIPLE_SUBCALENDAR.name]: (0, $d3bef7a856c272ba$export$5984a4822491c8de),
    [(0, $64KID.namedRoutes).DISCOVER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: ''
    }),
    [(0, $64KID.namedRoutes).ALL_UPDATES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 0
    }),
    [(0, $64KID.namedRoutes).POPULAR.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 1,
        feedType: 'POPULAR'
    }),
    [(0, $64KID.namedRoutes).MY_WORK_HOME.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_WORK_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).RECENT_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).MY_WORK_RECENT.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1,
        filter: 'WORKED_ON'
    }),
    [(0, $64KID.namedRoutes).RECENT_PAGES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_RECENTLY_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).RECENT_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).MY_SAVED_FOR_LATER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).RECENT_SAVED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).TEMPLATE_MIGRATION_PREVIEW.name]: (0, $a310d6589e3c6137$export$2549ad5558b468ce),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_BLUEPRINT.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).ADVANCED_SEARCH.name]: (0, $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f),
    [(0, $64KID.namedRoutes).EXTERNAL_SHARE.name]: (0, $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f),
    [(0, $64KID.namedRoutes).PEOPLE_DIRECTORY.name]: (0, $24a857c7c96255d7$export$c7bf94fd367d52ef),
    [(0, $64KID.namedRoutes).MARKETPLACE_APP_REQUESTS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_MANAGE_PROMOTIONS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_FIND_APPS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).CONTENT_HISTORY.name]: (0, $48c85dee1e05da94$export$e510023ce2e8f364),
    [(0, $64KID.namedRoutes).ONBOARDING.name]: (0, $52219feed318a69e$export$329ee42b27a3306e),
    [(0, $64KID.namedRoutes).ADMIN_GLOBAL_AUTOMATION.name]: (0, $9dff8dc763109b25$export$a4a7c409f3d3e524),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS.name]: (0, $5651b1434c6bae88$export$72e24cb8f0330a61),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HUB_PERMISSIONS.name]: (0, $ce2a2ee7f6871785$export$eeb7368e8bf944ac),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HOME_BUILDER.name]: (0, $4fa13b181dc663ad$export$5744f34ed241a45c),
    [(0, $64KID.namedRoutes).ADMIN_CUSTOMIZE_NAVIGATION.name]: (0, $4fa13b181dc663ad$export$3206f56dd9eda6e),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS.name]: (0, $3e17cd15ad9a2d77$export$ef0ae9b94af7599),
    [(0, $64KID.namedRoutes).ADMIN_EDIT_EXTERNAL_SHARING.name]: (0, $0960da40109465b4$export$af4daa43ca1332b9),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS_REDIRECT.name]: (0, $5d42f987126d0d25$export$1eaead8b8e68953c),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS.name]: (0, $d553d8b4da7f3160$export$25552d6a584e1fb8),
    [(0, $64KID.namedRoutes).ADMIN_BETA_FEATURES.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name),
    [(0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name]: (0, $7949c11e9e78d917$export$39279dc1d0cb138f),
    [(0, $64KID.namedRoutes).ADMIN_NOTIFICATIONS.name]: (0, $5035325f0c8b9a13$export$65794158c09a379),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS.name]: (0, $63dcc013c61b21bf$export$ccfda76403f5bd22),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS_PERMISSIONS.name]: (0, $2dd41eaa3836b7ed$export$7ed59daacefa1324),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS.name]: (0, $e76c2474e57ea114$export$af7907eff44c835f),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS_PERMISSIONS.name]: (0, $4a724484ea837e6c$export$703d82918dc06325),
    [(0, $64KID.namedRoutes).SPACE_SMART_CREATE.name]: (0, $f9a064f293d5119a$export$683599b1d0dc8e7b),
    [(0, $64KID.namedRoutes).PAGE_ANALYTICS.name]: (0, $2ddeeae61cd450c5$export$77b30b491c5d0ee0),
    [(0, $64KID.namedRoutes).SPACE_ARCHIVED_PAGES.name]: (0, $6079beeead36a4aa$export$77792abc2bfae7a1),
    [(0, $64KID.namedRoutes).SPACE_BULK_TOOLS.name]: (0, $95e685c28d9f350e$export$690ececaf2f5ac01),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name]: (0, $bdfe305fbc319d8d$export$b0e13503df86295),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE_ALT.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name),
    [(0, $64KID.namedRoutes).SPACE_FORGE_APPS.name]: (0, $e20a45805838a7c5$export$16cbc228d727cb5e),
    [(0, $64KID.namedRoutes).SPACE_CUSTOM_CONTENT_LIST.name]: (0, $25fdeb0a789de125$export$1045fc666c352ae6),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_FORGE_APPS.name]: (0, $70d1956925899c9e$export$21a09e0ddc77eafe),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ARCHIVE_SPACE.name]: (0, $3d2592d831aaf97c$export$c5e406a0947cdc56),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDITOR_CONVERSION.name]: (0, $c1c9698c93be07c8$export$698dfc3fe326e6d2),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AUTOMATION.name]: (0, $d6b8391ba067d418$export$3e7656e40361b9c3),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS_AND_STATUS.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_CONTENT_STATE.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DATA_CLASSIFICATION.name]: (0, $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_WATERMARK_CONFIGURATION.name]: (0, $0db33795337c2a26$export$2bb331cf926ecae2),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE.name]: (0, $e2d8d9818dde6381$export$1d1f8d0ef7c7a185),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT.name]: (0, $69b9df17dc76bcc3$export$4d1bd2808cfd2f38),
    [(0, $64KID.namedRoutes).SPACE_LEGACY_CONTENT.name]: (0, $b819de32c6839e12$export$f983b39883686021),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_RELATED_PAGES.name]: (0, $5fd2607ebf0fb934$export$50efde5a87cc8957),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDIT_FEATURES.name]: (0, $c991c60ce35a3f45$export$769dfef0447f3a55),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DETAILS.name]: (0, $ae6364090fd3faa0$export$45c01163cd56b3a2),
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_NATIVE.name]: (0, $44ff6e33806985ff$export$384dd5b6b76557b1),
    [(0, $64KID.namedRoutes).SPACE_QUESTION_NATIVE.name]: (0, $281ce5bf20714bdc$export$aea18e9fd89afe15),
    [(0, $64KID.namedRoutes).QUESTIONS_NATIVE.name]: (0, $8e1d38472579226f$export$6cff3d6e80ecc64),
    [(0, $64KID.namedRoutes).QUESTION_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_TOPICS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_TOPIC_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_EXPERTS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).MY_CALENDAR.name]: (0, $e84d6ad8839aa142$export$355693d248632c9a),
    [(0, $64KID.namedRoutes).PDF_EXPORT_PAGE.name]: (0, $de365c057d45c0f8$export$d4d3fe32e0af1ab9),
    [(0, $64KID.namedRoutes).PDF_EXPORT_SPACE.name]: (0, $cdc5bb1b4ce25ace$export$f10520cd46ef45dd),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENTS_ON_PAGE_LIST.name]: (0, $4af991445198673b$export$80477c996ae74379),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENT_VIEW.name]: (0, $c7473af47fe3192c$export$b836ebd0f49cc9f5),
    [(0, $64KID.namedRoutes).SPACE_PERMISSIONS_SETTINGS.name]: (0, $3dace45d43821ccc$export$c4e68572e7b94bc6),
    [(0, $64KID.namedRoutes).ROLE_BASED_ACCESS_CONTROL_HUB.name]: (0, $1fb601398675b5a1$export$23838e4b7dc196e5),
    [(0, $64KID.namedRoutes).SPACE_LOOK_AND_FEEL_SETTINGS.name]: (0, $ea3042d7dfb4b938$export$9ebf5b01b0356442),
    [(0, $64KID.namedRoutes).ADMIN_ANNOUNCEMENT_BANNER_RENDERER.name]: (0, $e77b8eed9c4fe03f$export$81a4ecf687c4a61b),
    [(0, $64KID.namedRoutes).SPACE_MANAGER.name]: (0, $244c44f585122129$export$986d179bc3f7f637),
    [(0, $64KID.namedRoutes).USER_ACCESS.name]: (0, $c4bba5ee88869a52$export$45dbe3e1239d2b94),
    [(0, $64KID.namedRoutes).ADMIN_CENTER.name]: (0, $36a63e56cd2b2984$export$60c1a30975370191),
    [(0, $64KID.namedRoutes).ADMIN_CENTER_SPACE.name]: (0, $015145ca08e6a13a$export$bd929b984ffc4a9),
    [(0, $64KID.namedRoutes).ADMIN_SETTINGS.name]: (0, $6f06338c7fe23a44$export$44bc7d6c094dc951),
    [(0, $64KID.namedRoutes).ADMIN_BULK_PERMISSIONS.name]: (0, $4255a2123073399b$export$a1ed7a563d6f8c80),
    [(0, $64KID.namedRoutes).ADMIN_SITE_SPACE_PERMISSIONS.name]: (0, $d3d38e453fe82603$export$6b4028c8cfa4e9e1),
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CALENDARS.name]: (0, $d1361d4d835db3f1$export$5164e66822dc5aec),
    [(0, $64KID.namedRoutes).ADMIN_CONFIGURATION.name]: (0, $daea30cdb73fa105$export$9a9547459861b1d),
    [(0, $64KID.namedRoutes).ADMIN_DEFAULT_SPACE_LOGO.name]: (0, $cf2a30228181ae7a$export$12cd952fb663f2a5),
    [(0, $64KID.namedRoutes).ADMIN_HEADER_AND_FOOTER.name]: (0, $d9d1782c5d23f713$export$66aaa3e4fa4fb446),
    [(0, $64KID.namedRoutes).ADMIN_TEMPLATES_AND_BLUEPRINTS.name]: (0, $3de5f90ca85ac387$export$fb8cddd2e05884ff),
    [(0, $64KID.namedRoutes).ADMIN_CODE_MACRO_CONFIGURATION.name]: (0, $2e9a50b174f89446$export$761483e0f415164e),
    [(0, $64KID.namedRoutes).ADMIN_COLOR_SCHEME.name]: (0, $0fb617f0ce9f4007$export$8984debadcec9d93),
    [(0, $64KID.namedRoutes).ADMIN_SECURITY_CONFIGURATION.name]: (0, $7fe52c8ec8c71cab$export$b882bc9c4e633e9b),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_REPORTS.name]: (0, $ba2c2ff5f89f0551$export$2667c61817b129fd),
    [(0, $64KID.namedRoutes).ADMIN_APPLICATION_NAVIGATOR.name]: (0, $98f73671c286928d$export$55ff18e8dde17771),
    [(0, $64KID.namedRoutes).ADMIN_TRASHED_SPACES.name]: (0, $b9260b374d11ae03$export$154b40ed25137a69),
    [(0, $64KID.namedRoutes).ADMIN_IMPORT_SPACES.name]: (0, $d9481fcbb25a62a6$export$6078cc5c61cdb00c),
    [(0, $64KID.namedRoutes).ADMIN_JIRA_MACRO_REPAIR.name]: (0, $3ed31ec1d64e85a3$export$1162e5a60ee7576b),
    [(0, $64KID.namedRoutes).ADMIN_MACRO_USAGE.name]: (0, $2395a25321aca708$export$1e71122b3eac56e4),
    [(0, $64KID.namedRoutes).ADMIN_THEMES.name]: (0, $95678b1264993b8d$export$cdc2bb4346e935c9),
    [(0, $64KID.namedRoutes).ADMIN_PDF_EXPORT.name]: (0, $d726f64aa7b98b71$export$81e12ffb7d442c0c),
    [(0, $64KID.namedRoutes).ADMIN_DC_SCRIPT_MIGRATION.name]: (0, $a58212c7e75084fc$export$4b568b9f0da70fe4),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_PERFORMANCE_REPORT.name]: (0, $8a13ebd6aa0a88b0$export$84f173be1e35ceff),
    [(0, $64KID.namedRoutes).SPACE_MEMBERS.name]: (0, $f9fff28badc7670c$export$214350c926cc60f2),
    [(0, $64KID.namedRoutes).TOPICS.name]: (0, $ad7e3274b7fede14$export$54f890efdb9a624),
    [(0, $64KID.namedRoutes).PREMIUM_ADMIN_FEATURES_EXPERIMENT.name]: (0, $d159621a32e8ccb1$export$400e9e9431ca8a0),
    [(0, $64KID.namedRoutes).IMPORTER_STATUS_DASHBOARD.name]: (0, $e2dae4d283de07f2$export$abf2f9d0f3a44f9c),
    [(0, $64KID.namedRoutes).ATTACHMENTS_PAGE.name]: (0, $167b5527ac95ab07$export$fd9e136112feb41f),
    [(0, $64KID.namedRoutes).AI_SEARCH_PAGE.name]: (0, $962d6764e800d7d4$export$e23fb2c3ce6c7abf),
    [(0, $64KID.namedRoutes).PERMISSIONS_EXPORT.name]: (0, $6deffcd0919e3152$export$9dc6a62d8cf9ae06),
    [(0, $64KID.namedRoutes).NEW_AUDIT_LOG.name]: (0, $beac86ab997501a9$export$b6dab1e8a8b6a66d)
});
module.exports["routeComponents"] = $c6a4b2258628a516$export$4d9abfe5519d76c6;

});

parcelRegister("7Snc9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4l6Wo = parcelRequire("4l6Wo");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $4H46k = parcelRequire("4H46k");

function $1cae7e3e681988dd$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
        screenEvent: {
            name: 'notFoundScreen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5gmpn.MainLayout), {
        navView: (0, $4l6Wo.PRODUCT_HOME_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConfluenceNotFound), null)));
}
module.exports["NotFound"] = $1cae7e3e681988dd$export$271f9f08425019c7;

});

parcelRegister("irDFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d9861065b5c0df$export$2e2bcd8739ae039);

var $jmjWc = parcelRequire("jmjWc");


var $d6d9861065b5c0df$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "yQebH",
    name: "packages.confluence-frontend-server.src.components.EngagementMessages.EngagementMessages",
    loader: ()=>(parcelRequire("lI1M4"))
});

});

parcelRegister("6VsaQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $50adebb1075ad3af$export$2e2bcd8739ae039);

var $jmjWc = parcelRequire("jmjWc");


var $50adebb1075ad3af$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "exd9t",
    name: "packages.confluence-frontend-server.src.components.ReduxError.src.index",
    loader: ()=>(parcelRequire("syHJB"))
});

});

parcelRegister("8A6YM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eXmBZ = parcelRequire("eXmBZ");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $kZ5GD = parcelRequire("kZ5GD");


var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $2gD2K = parcelRequire("2gD2K");


var $9wGTI = parcelRequire("9wGTI");


var $iquRY = parcelRequire("iquRY");

const $ec94e17fe3441559$var$i18n = (0, $cgtv4.defineMessages)({
    archivedSpacesTooltip: {
        id: "bulk-permissions.space.archived-spaces-tooltip",
        defaultMessage: "Archived spaces are not included in bulk permissions actions."
    },
    archivedSpacesTooltipBulkAccess: {
        id: "bulk-permissions.space.archived-spaces-tooltip-bulk-access",
        defaultMessage: "Archived spaces are not included in bulk access actions."
    },
    archivedSpacesTooltipIconLabel: {
        id: "bulk-permissions.space.archived-spaces-tooltip-icon-label",
        defaultMessage: "Archived space information"
    },
    spaceSelectionHeader: {
        id: "bulk-permissions.space.space-selection-header",
        defaultMessage: "Choose which spaces"
    },
    spaceAccessSelectionHeader: {
        id: "bulk-permissions.space.space-access-selection-header",
        defaultMessage: "On which spaces<asterisk>*</asterisk>"
    },
    spaceAccessInclusionExclusionSelectionHeader: {
        id: "bulk-permissions.space.space-access-inclusion-exclusion-selection-header",
        defaultMessage: "For which spaces<asterisk>*</asterisk>"
    },
    spaceMenuTrigger: {
        id: "bulk-permissions.space.space-access-menu-trigger.non-final",
        defaultMessage: "Select spaces"
    },
    spaceMenuNoOptions: {
        id: "bulk-permissions.space.space-access-menu-no-options.non-final",
        defaultMessage: "No spaces match your search"
    },
    spaceSelectionOne: {
        id: "bulk-permissions.space.space-selection-one",
        defaultMessage: "All"
    },
    spaceSelectionOneDescription: {
        id: "bulk-permissions.space.space-selection-one.description.non-final",
        defaultMessage: "All spaces within your tenant"
    },
    spaceSelectionTwo: {
        id: "bulk-permissions.space.space-selection-two",
        defaultMessage: "All (excluding personal)"
    },
    spaceSelectionTwoDescription: {
        id: "bulk-permissions.space.space-selection-two.description.non-final",
        defaultMessage: "All spaces within your tenant, except for personal spaces."
    },
    spaceSelectionThree: {
        id: "bulk-permissions.space.space-selection-three.non-final",
        defaultMessage: "All (excluding specific spaces)"
    },
    spaceSelectionThreeDescription: {
        id: "bulk-permissions.space.space-selection-three.description.non-final",
        defaultMessage: "All spaces within your tenant, excluding selected specific spaces"
    },
    spaceSelectionFour: {
        id: "bulk-permissions.space.space-selection-four",
        defaultMessage: "Only personal"
    },
    spaceSelectionFourDescription: {
        id: "bulk-permissions.space.space-selection-four.description.non-final",
        defaultMessage: "Only select personal spaces within this tenant"
    },
    spaceSelectionFive: {
        id: "bulk-permissions.space.space-selection-five.non-final",
        defaultMessage: "Only specific spaces"
    },
    spaceSelectionFiveDescription: {
        id: "bulk-permissions.space.space-selection-five.description.non-final",
        defaultMessage: "Only select specific spaces"
    }
});
var $ec94e17fe3441559$export$463c90b38fc542de = /*#__PURE__*/ function(SpaceSelection) {
    SpaceSelection["AllExcludingPersonal"] = "all-excluding-personal";
    SpaceSelection["AllIncludingPersonal"] = "all-including-personal";
    SpaceSelection["OnlyPersonal"] = "only-personal";
    //the following are options for GA
    SpaceSelection["OnlySpecificSpaces"] = "only-specific-spaces";
    SpaceSelection["AllExcludingSpecific"] = "all-excluding-specific";
    return SpaceSelection;
}({});
const $ec94e17fe3441559$var$spaceSelectionOptions = [
    {
        value: "all-excluding-personal",
        label: $ec94e17fe3441559$var$i18n.spaceSelectionOne,
        description: $ec94e17fe3441559$var$i18n.spaceSelectionOneDescription
    },
    {
        value: "all-including-personal",
        label: $ec94e17fe3441559$var$i18n.spaceSelectionTwo,
        description: $ec94e17fe3441559$var$i18n.spaceSelectionTwoDescription
    },
    {
        value: "all-excluding-specific",
        label: $ec94e17fe3441559$var$i18n.spaceSelectionThree,
        description: $ec94e17fe3441559$var$i18n.spaceSelectionThreeDescription
    },
    {
        value: "only-personal",
        label: $ec94e17fe3441559$var$i18n.spaceSelectionFour,
        description: $ec94e17fe3441559$var$i18n.spaceSelectionFourDescription
    },
    {
        value: "only-specific-spaces",
        label: $ec94e17fe3441559$var$i18n.spaceSelectionFive,
        description: $ec94e17fe3441559$var$i18n.spaceSelectionFiveDescription
    }
];
const $ec94e17fe3441559$var$spaceSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $ec94e17fe3441559$var$spaceSelectionSelectStyle = (0, $ecnYn.xcss)({
    width: '300px',
    paddingBottom: 'space.100'
});
const $ec94e17fe3441559$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $ec94e17fe3441559$var$optionStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    flexDirection: 'column'
});
const $ec94e17fe3441559$export$1117068039e5ec07 = ({ spaceSelection: spaceSelection, onRadioChange: onRadioChange, onMenuOpen: onMenuOpen, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const getOptionLabel = (option)=>{
        return `${option.label} ${option.description}`;
    };
    const formatOptionLabel = (option, { selectValue: selectValue })=>{
        const selected = selectValue?.[0]?.value;
        const isSelected = selected ? selected === option.value : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $ec94e17fe3441559$var$optionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "bold"
        }, formatMessage(option.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: isSelected ? 'color.text.subtle' : 'color.text.subtlest',
            size: "small"
        }, formatMessage(option.description)));
    };
    const onSelectMenuOpen = ()=>{
        if (typeof onMenuOpen === 'function') onMenuOpen();
    };
    const onSelectChange = (selection)=>{
        if (typeof onChange === 'function') onChange(selection.value);
    };
    const spaceSelectionHeader = ()=>{
        if ((0, $9wGTI.fg)('confluence_rbac_spaces_ga')) return $ec94e17fe3441559$var$i18n.spaceAccessInclusionExclusionSelectionHeader;
        else if (isRbacEnabled) return $ec94e17fe3441559$var$i18n.spaceAccessSelectionHeader;
        else return $ec94e17fe3441559$var$i18n.spaceSelectionHeader;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle
    }, formatMessage(spaceSelectionHeader(), {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $ec94e17fe3441559$var$asteriskStyle
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isRbacEnabled ? formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipBulkAccess) : formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltip),
        position: "right"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    ...iconProps,
                    size: "small"
                }),
            appearance: "subtle",
            label: formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipIconLabel),
            spacing: "compact",
            shape: "circle",
            ...tooltipProps
        })))), (0, $9wGTI.fg)('confluence_rbac_spaces_ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionSelectStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
        testId: "bulk-access-space-selection-select",
        placeholder: formatMessage($ec94e17fe3441559$var$i18n.spaceMenuTrigger),
        options: $ec94e17fe3441559$var$spaceSelectionOptions,
        formatOptionLabel: formatOptionLabel,
        onChange: onSelectChange,
        onMenuOpen: onSelectMenuOpen,
        menuPosition: "fixed",
        maxMenuHeight: 320,
        scrollBehavior: "outside",
        defaultValue: $ec94e17fe3441559$var$spaceSelectionOptions[0],
        value: $ec94e17fe3441559$var$spaceSelectionOptions.find((option)=>option.value === spaceSelection),
        getOptionLabel: getOptionLabel,
        noOptionsMessage: ()=>formatMessage($ec94e17fe3441559$var$i18n.spaceMenuNoOptions)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "all-including-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-including-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionOne)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "all-excluding-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-excluding-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionTwo)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "only-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "only-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionFour)
    })));
};
module.exports["SpaceSelection"] = $ec94e17fe3441559$export$463c90b38fc542de;
module.exports["SpaceSelectionRadioButtons"] = $ec94e17fe3441559$export$1117068039e5ec07;

});

parcelRegister("eIwUX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $auKqk = parcelRequire("auKqk");


var $75i5X = parcelRequire("75i5X");


var $aGLO2 = parcelRequire("aGLO2");

const $57959768319b5632$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "bulk-permissions.restricted.title",
        defaultMessage: "This item is restricted"
    },
    message: {
        id: "bulk-permissions.space-settings.restricted.message",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }
});
const $57959768319b5632$export$b5dab984a2ed58cb = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($75i5X))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($aGLO2))),
        errorTitle: intl.formatMessage($57959768319b5632$var$i18n.title),
        errorMessage: intl.formatMessage($57959768319b5632$var$i18n.message)
    });
};
module.exports["RestrictedView"] = $57959768319b5632$export$b5dab984a2ed58cb;

});

parcelRegister("lM2MU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $6UBEn = parcelRequire("6UBEn");


var $2ZJmt = parcelRequire("2ZJmt");

const $b25698afe0cbfe9a$var$i18n = (0, $cgtv4.defineMessages)({
    loadingTitle: {
        id: "bulk-permissions.space.loading-title",
        defaultMessage: "We\u2019re processing your change"
    },
    loadingDialogDescription: {
        id: "bulk-permissions.space.loading-dialog-description",
        defaultMessage: "Don\u2019t navigate away or refresh."
    }
});
const $b25698afe0cbfe9a$var$LoadingSubSectionStyle = (0, $ecnYn.xcss)({
    rowGap: 'space.300',
    paddingBottom: 'space.800'
});
const $b25698afe0cbfe9a$export$7d8626d803788e96 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b25698afe0cbfe9a$var$i18n.loadingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b25698afe0cbfe9a$var$LoadingSubSectionStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b25698afe0cbfe9a$var$i18n.loadingDialogDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UBEn.default), {
        isIndeterminate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), null));
module.exports["LoadingDialog"] = $b25698afe0cbfe9a$export$7d8626d803788e96;

});

parcelRegister("2c1Wz", function(module, exports) {
var $49cc78e79e334ef6$export$a4def92db6fc8e17 = /*#__PURE__*/ function(PerformanceObserverEntryTypes) {
    PerformanceObserverEntryTypes["LayoutShift"] = "layout-shift";
    PerformanceObserverEntryTypes["LongTask"] = "longtask";
    PerformanceObserverEntryTypes["Event"] = "event";
    return PerformanceObserverEntryTypes;
}({});
module.exports["PerformanceObserverEntryTypes"] = $49cc78e79e334ef6$export$a4def92db6fc8e17;

});

parcelRegister("i7t6K", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");

class $4313abb7a0000648$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    // Default maxLength is an arbitrary number but it is long enough to capture tasks within the full experience
    // 1000 x 50ms = 50s which should be long enough for every healthy experience
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $4313abb7a0000648$export$f7dc16cbd16f7bbe = {
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).Event]: new $4313abb7a0000648$export$2c6e86519c9e8188()
};
// This function is exposed to the window object to be used in the integration tests
// to fail the test if there is a layout shift in the page
const $4313abb7a0000648$var$hadLayoutShift = (predicate)=>{
    const buffer = $4313abb7a0000648$export$f7dc16cbd16f7bbe[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].buffer;
    return predicate(buffer);
};
window.__hadLayoutShift = $4313abb7a0000648$var$hadLayoutShift;
module.exports["EntriesBuffer"] = $4313abb7a0000648$export$f7dc16cbd16f7bbe;

});

parcelRegister("jiFpb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $8dwdz = parcelRequire("8dwdz");


var $6pwLK = parcelRequire("6pwLK");


var $1dnxO = parcelRequire("1dnxO");

const $6a421125f8ad1b8e$var$routeWithNavigationMapping = new Map();
function $6a421125f8ad1b8e$export$658b4fa209be6b36(match) {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    // We need to ensure all the entries calling processNavigationParams are returning the same RouteWithNavigation instance
    // So that they won't get re-mounted when switching between routes
    const RouteWithNavParams = $6a421125f8ad1b8e$var$routeWithNavigationMapping.get(match.name);
    if (!RouteWithNavParams) return null;
    const { NAVIGATION_PARAMS: NAVIGATION_PARAMS } = RouteWithNavParams;
    if (typeof NAVIGATION_PARAMS !== 'function') return null;
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const spaceNavParams = NAVIGATION_PARAMS(match, isNav4Enabled);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RouteWithNavParams, match);
    if (spaceNavParams === false) return element;
    const { Screen: screen, MainLayout: mainLayout, BannerContext: bannerContext } = spaceNavParams;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), screen, mainLayout === false ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !isMobile,
        ...mainLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pwLK.BannerContextProvider), {
        includeTopNav: bannerContext?.includeTopNav
    }, element)));
}
function $6a421125f8ad1b8e$export$5ce5fb2a75a2a873(routes) {
    for(const name in routes){
        const RouteWithNavParams = routes[name];
        if (typeof RouteWithNavParams.NAVIGATION_PARAMS !== 'function') throw new Error(`Route must define a static NAVIGATION_PARAMS function. ${name} is missing the NAVIGATION_PARAMS function. Please read patterns/routing.md`);
        $6a421125f8ad1b8e$var$routeWithNavigationMapping.set(name, RouteWithNavParams);
        routes[name] = $6a421125f8ad1b8e$export$658b4fa209be6b36;
    }
    return routes;
}
module.exports["processNavigationParams"] = $6a421125f8ad1b8e$export$5ce5fb2a75a2a873;

});

parcelRegister("4lJOK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $4l6Wo = parcelRequire("4l6Wo");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $iqPBi = parcelRequire("iqPBi");

function $3dad7419d64a8662$export$3731f94d374dc29b(Component) {
    const SpaceOverviewRoute = (match)=>{
        const { params: { spaceKey: spaceKey = '', contentId: contentId = '' }, query: query } = match;
        if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.COMPANY_HUB).name
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPBi.SpaceBase), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        }));
    };
    SpaceOverviewRoute.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey = '' }, query: { mode: mode = '' } })=>({
            Screen: {
                screenEvent: {
                    name: 'spaceOverviewScreen',
                    id: spaceKey,
                    attributes: {
                        isGlobalMode: mode === 'global',
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        spaceKey: spaceKey
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.SPACE_OVERVIEW).name,
                    contentType: 'page'
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.CONTAINER_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        });
    return SpaceOverviewRoute;
}
const $3dad7419d64a8662$export$2df060b942be85a7 = $3dad7419d64a8662$export$3731f94d374dc29b((0, $djZz9.SpaceOverviewLoader));
module.exports["getSpaceOverviewRoute"] = $3dad7419d64a8662$export$3731f94d374dc29b;

});

parcelRegister("hDf9e", function(module, exports) {

var $42omo = parcelRequire("42omo");





var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

const $0d72b6e269966c48$var$isOnCompanyHubRouteArgs = {
    selector: (routeName)=>(0, $1NBp8.COMPANY_HUB).name === routeName
};

const $0d72b6e269966c48$export$83316d703678f96f = ({ children: children })=>{
    const isOnCompanyHubRoute = (0, $dPJCf.useRouteName)($0d72b6e269966c48$var$isOnCompanyHubRouteArgs);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticCaught = (0, $42omo.useCallback)(async (event, channel)=>{
        if (event?.payload?.action === 'clicked' || event?.payload?.actionSubject === 'smartLink' && event?.payload?.action === 'renderSuccess') await (parcelRequire("hz81G")).then(async ({ handleEventCaught: handleEventCaught })=>{
            await handleEventCaught(activationId, cloudId, createAnalyticsEvent, event, !!isOnCompanyHubRoute, channel, spaceId);
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        isOnCompanyHubRoute,
        spaceId
    ]);
    if (!isOnCompanyHubRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: "*",
        onEvent: handleAnalyticCaught
    }, children);
};



var $4l6Wo = parcelRequire("4l6Wo");


var $9HNv5 = parcelRequire("9HNv5");


var $8NC5Z = parcelRequire("8NC5Z");


var $7CeAz = parcelRequire("7CeAz");





var $56QzY = parcelRequire("56QzY");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $eqNP8 = parcelRequire("eqNP8");





var $jKzCD = parcelRequire("jKzCD");


var $e4o8D = parcelRequire("e4o8D");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $8d67d674949172ba$export$d135e6fd61f0ae86(Component) {
    const CompanyHubRoute = ()=>{
        const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled, isCompanyHubPublished: isCompanyHubPublished } = (0, $7CeAz.useIsCompanyHubEnabled)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
        const { push: push } = (0, $dPJCf.useRouteActions)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                push((0, $1NBp8.COMPANY_HUB_EDIT).toUrl({}, {
                    query: {
                        redirect: 'first-time',
                        contentId: homepageId
                    }
                }));
            },
            route: (0, $1NBp8.COMPANY_HUB).pattern
        });
        if (isCreatingHub) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        screenEventAttributes.publishedCompanyHub = isCompanyHubPublished;
        if (shouldShowPremiumUpsell) {
            /**
			 * SSR compatibility: CompanyHomeBuilderUpsellPage uses UpsellLooknFeel/SectionMessage
			 * which lacks SSR support. Rendering during SSR would cause:
			 * - Hydration mismatches between server/client renders
			 * - Visible layout shift (CLS) during client hydration since SectionMessage
			 *   appears at the top of the content area
			 *
			 * For now, client-side rendering only, until components are refactored for SSR support.
			 */ if (renderServerPlaceholder) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
                featureName: "companyHub"
            });
        }
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (!isCompanyHubEntryPointEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name
        });
        // The only different between SPA and SSR is we don't render space base in SSR
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0d72b6e269966c48$export$83316d703678f96f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: ""
        }));
    };
    const screenEventAttributes = {
        navdexPointType: (0, $56QzY.START_TOUCH),
        // Company Hub hides its space from the user, doesn't refer to its page
        // as such, is rather presented to the user as "a new surface", and thus
        // doesn't constitute space usage from the perspective of the user.
        screenIsInSpace: false
    };
    /**
	 * Warning: Though the function NAVIGATION_PARAMS is invoked during render,
	 * each route has its own implementation. Consequently, it cannot invoke
	 * hooks or, during route transitions between implementations that invoke
	 * different hooks, the rule of hooks to invoke a hook the same number of
	 * times during each render would be violated and an error would be thrown
	 * by React that would damage the DOM.
	 */ CompanyHubRoute.NAVIGATION_PARAMS = ()=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHub',
                    id: spaceKey,
                    // Warning: The value of the analytics event attribute
                    // publishedCompanyHub that ScreenEvent sends will be
                    // inaccurate on initial SPA load without SSR, because
                    // ScreenEvent sends before SPAViewContext has loaded.
                    attributes: screenEventAttributes
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.COMPANY_HUB).name
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.PRODUCT_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubRoute);
}
const $8d67d674949172ba$export$ea13ab632841088 = $8d67d674949172ba$export$d135e6fd61f0ae86((0, $djZz9.SpaceOverviewLoader));
module.exports["getCompanyHubRoute"] = $8d67d674949172ba$export$d135e6fd61f0ae86;

});

parcelRegister("hkCxu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $4l6Wo = parcelRequire("4l6Wo");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");








var $5gmpn = parcelRequire("5gmpn");


var $iJ8K8 = parcelRequire("iJ8K8");


var $ak57N = parcelRequire("ak57N");


var $8dwdz = parcelRequire("8dwdz");











var $6pwLK = parcelRequire("6pwLK");

function $ef4380efcf1da8eb$export$b5c57a98f1ddfa55(uri) {
    return uri.includes('/edit-v2/');
}
function $ef4380efcf1da8eb$export$4ceedc3d36a46889(query) {
    const draftShareId = query?.draftShareId;
    return Array.isArray(draftShareId) ? draftShareId?.[0] : draftShareId;
}


const $ec45f4b8e7cc34aa$export$6a3218472cdf374a = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey }, query: query })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !isCompanyHub
    });
    const contentType = name === (0, $1NBp8.EDIT_PAGE_V2).name || name === (0, $1NBp8.COMPANY_HUB_EDIT).name ? 'page' : 'blogpost';
    const draftShareId = (0, $ef4380efcf1da8eb$export$4ceedc3d36a46889)(query);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pwLK.BannerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }));
    //
    // navView
    //
    let navView = (0, $4l6Wo.CONTAINER_HOME_ID);
    if (isCompanyHub) {
        if (shouldShowPremiumUpsell) return null;
        else if (name === (0, $1NBp8.COMPANY_HUB_EDIT).name) // CompanyHubEditRoute provides its own Screen and MainLayout.
        return children;
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    } else if (contentType === 'blogpost') navView = (0, $4l6Wo.CONTAINER_BLOG_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        },
        screenEvent: {
            name: 'editPageScreen',
            id: contentId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !(0, $8dwdz.shouldShowMobileWeb)(),
        spaceKey: spaceKey,
        navView: navView,
        isEdit: true
    }, children));
};



var $2Uf3N = parcelRequire("2Uf3N");

function $aa6dab5502f2e37f$export$39a78a0252c20555(component) {
    const CompanyHubEditRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $42omo.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the EditPageRoute is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        // Company Hub hides its space from the user, doesn't refer to its page
                        // as such, is rather presented to the user as "a new surface", and thus
                        // doesn't constitute space usage from the perspective of the user.
                        screenIsInSpace: false
                    }
                },
                // When no contentId is passed, Screen.js handles querying it and updating pageState with it.
                // usually, this is done by the Screen.js component, but in this case, we need to do it here
                // because contentId is not getting queried properly on route creation.
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditRoute);
}
const $aa6dab5502f2e37f$export$31ce72eecdb1dd8 = $aa6dab5502f2e37f$export$39a78a0252c20555((0, $ec45f4b8e7cc34aa$export$6a3218472cdf374a));
module.exports["getCompanyHubEditRoute"] = $aa6dab5502f2e37f$export$39a78a0252c20555;

});

parcelRegister("k1285", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eDATL = parcelRequire("eDATL");


var $cEgMD = parcelRequire("cEgMD");


var $4l6Wo = parcelRequire("4l6Wo");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $7c7def46d7360d1a$export$340541672a1ec29f(component) {
    const CompanyHubEditorRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $42omo.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the HubEditor is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditorRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditorScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        screenIsInSpace: false
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditorRoute);
}
const $7c7def46d7360d1a$export$5c9c0a4930517099 = $7c7def46d7360d1a$export$340541672a1ec29f((0, $eDATL.default));
module.exports["getCompanyHubEditorRoute"] = $7c7def46d7360d1a$export$340541672a1ec29f;

});

parcelRegister("8g7sM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3f88486f5953222$export$2e2bcd8739ae039);

var $jmjWc = parcelRequire("jmjWc");


var $kb9X9 = parcelRequire("kb9X9");

const $c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD = `confluence.fabric.content.renderer.download`;

var $c3f88486f5953222$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cDY9-",
    name: 'ClassicContentRendererLoader',
    loader: async ()=>{
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.start`);
        const module = await (parcelRequire("7X6Jc"));
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.end`);
        return module;
    }
});

});

parcelRegister("2Uf3N", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


const $44a1291d5f4bf190$export$bbf3d8e57337c75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xoU6a",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'CompanyHubMainLayout',
    loader: async ()=>(await (parcelRequire("9J6Xv"))).CompanyHubMainLayout
});


function $13aed4a881b0bcc1$export$f5fe5ef796a4c528(Wrapped, routeMatchPredicate = ()=>true) {
    const CompanyHubPseudoAppRoute = (props)=>{
        const wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapped, props);
        if (routeMatchPredicate(props)) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44a1291d5f4bf190$export$bbf3d8e57337c75), null, wrapped);
        return wrapped;
    };
    CompanyHubPseudoAppRoute.NAVIGATION_PARAMS = (...args)=>{
        const wrappedNavParams = Wrapped.NAVIGATION_PARAMS(...args);
        if (routeMatchPredicate(args[0])) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return typeof wrappedNavParams === 'object' ? {
            ...wrappedNavParams,
            MainLayout: false
        } : false;
        return wrappedNavParams;
    };
    return CompanyHubPseudoAppRoute;
}
module.exports["getCompanyHubPseudoAppRoute"] = $13aed4a881b0bcc1$export$f5fe5ef796a4c528;

});

parcelRegister("92IuX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf6f9a67c56b1fae$export$a52edf641f55b288 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qAAZg",
    name: "AuditLogLoader",
    loader: async ()=>(await (parcelRequire("43Ghm"))).AuditLog
});
module.exports["AuditLogLoader"] = $cf6f9a67c56b1fae$export$a52edf641f55b288;

});

parcelRegister("75i5X", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("aGLO2", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();

});

parcelRegister("9HNv5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d561062df6e47d30$export$4047609c83584c4b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nCrwB",
    name: "CompanyHomeBuilderUpsellPage",
    loader: async ()=>(await (parcelRequire("hRE2l"))).CompanyHomeBuilderUpsellPage
});
module.exports["CompanyHomeBuilderUpsellPage"] = $d561062df6e47d30$export$4047609c83584c4b;

});

parcelRegister("jKzCD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1uFM6 = parcelRequire("1uFM6");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $8NC5Z = parcelRequire("8NC5Z");


var $gi8UL = parcelRequire("gi8UL");

function $6d8995f9c98e457c$export$567b73f497a151cb({ onSuccess: onSuccess, onExists: onExists, route: route }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCreatingHub, setIsCreatingHub] = (0, $42omo.useState)(false);
    const [creationError, setCreationError] = (0, $42omo.useState)(null);
    const { isSiteAdmin: isSiteAdmin, frontCoverState: frontCoverState } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const isCompanyHubUnset = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).UNSET;
    const hasCreatedHub = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasCreatedHub.current) {
            const shouldCreateHub = isCompanyHubUnset && isSiteAdmin && !shouldShowPremiumUpsell && !isCreatingHub;
            if (shouldCreateHub) {
                let wasHubCreated = false;
                setIsCreatingHub(true);
                hasCreatedHub.current = true;
                experienceTracker.start({
                    name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
                });
                (0, $gi8UL.createCompanyHubSpace)().then(({ didCreateSpace: didCreateSpace, homepageId: homepageId })=>{
                    if (didCreateSpace) {
                        experienceTracker.succeed({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE)
                        });
                        wasHubCreated = true;
                        onSuccess?.(homepageId);
                    } else {
                        experienceTracker.abort({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                            reason: 'Hub space already exists. Handled by redirecting user to Hub editor without first time experience'
                        });
                        onExists?.(homepageId);
                    }
                }).catch((error)=>{
                    setCreationError(error);
                    if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User has stale admin permissions'
                    });
                    else if ((0, $1uFM6.isUnauthorizedError)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User is not authenticated'
                    });
                    else experienceTracker.fail({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        error: error
                    });
                }).finally(()=>{
                    setIsCreatingHub(false);
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            source: 'companyHub',
                            action: 'created',
                            actionSubject: 'onRouteStart',
                            actionSubjectId: 'companyHubOnRouteCreation',
                            attributes: {
                                created: wasHubCreated,
                                route: route
                            }
                        }
                    }).fire();
                });
            }
        }
    }, [
        isCompanyHubUnset,
        isSiteAdmin,
        createAnalyticsEvent,
        shouldShowPremiumUpsell,
        isCreatingHub,
        experienceTracker,
        onSuccess,
        onExists,
        route
    ]);
    return {
        isCreatingHub: isCreatingHub,
        creationError: creationError
    };
}
module.exports["useCompanyHubOnRouteCreationFlow"] = $6d8995f9c98e457c$export$567b73f497a151cb;

});

parcelRegister("eCfJ3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $abC4X = parcelRequire("abC4X");


var $7p4As = parcelRequire("7p4As");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $2Nwuj = parcelRequire("2Nwuj");


var $1NBp8 = parcelRequire("1NBp8");


var $1uFM6 = parcelRequire("1uFM6");


var $gi8UL = parcelRequire("gi8UL");


var $iQTig = parcelRequire("iQTig");


var $5X6zn = parcelRequire("5X6zn");

const $3f49c0dd8d66c83c$var$containerStyles = (0, $ecnYn.xcss)({
    height: '90vh',
    paddingInline: 'space.200'
});
const $3f49c0dd8d66c83c$export$c09c08db0e42b276 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const errorConfig = (0, $42omo.useMemo)(()=>{
        if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5X6zn))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagDescription, {
                a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, chunks)
            })
        };
        if ((0, $1uFM6.isUnauthorizedError)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5X6zn))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagDescription, {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
            }),
            buttonLabel: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagButton),
            buttonLink: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        };
        return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iQTig))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagDescription)
        };
    }, [
        error,
        formatMessage
    ]);
    const { imageUrl: imageUrl, title: title, description: description, buttonLabel: buttonLabel, buttonLink: buttonLink } = errorConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $3f49c0dd8d66c83c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: title,
        description: description,
        primaryAction: buttonLabel && buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "primary",
            href: buttonLink
        }, buttonLabel) : undefined,
        imageUrl: imageUrl
    }));
};
module.exports["HubErrorPageComponent"] = $3f49c0dd8d66c83c$export$c09c08db0e42b276;

});

parcelRegister("ak57N", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $a0c4fc2f529fa1f8$export$99fa8db8497fb663 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fAvbz",
    name: 'EditPageLoaderServer',
    loader: async ()=>(await (parcelRequire("6vGTt"))).EditPageLoaderServer,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).NativeCollabLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).FullPageEditorLoader
    ]
});
module.exports["EditPageLoaderServer"] = $a0c4fc2f529fa1f8$export$99fa8db8497fb663;

});

parcelRegister("eDATL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $5AtW0 = parcelRequire("5AtW0");


var $e6Iiv = parcelRequire("e6Iiv");


var $auTg8 = parcelRequire("auTg8");


var $1JdaQ = parcelRequire("1JdaQ");


var $k00oi = parcelRequire("k00oi");

var $7bZ3i = parcelRequire("7bZ3i");


var $gdv5Z = parcelRequire("gdv5Z");


var $fwDOR = parcelRequire("fwDOR");


var $9hlns = parcelRequire("9hlns");


var $8Ixq2 = parcelRequire("8Ixq2");

var $jrlgF = parcelRequire("jrlgF");

var $g3LxX = parcelRequire("g3LxX");

var $gqsO5 = parcelRequire("gqsO5");


var $calJ6 = parcelRequire("calJ6");

var $3y8SL = parcelRequire("3y8SL");


var $bsZfq = parcelRequire("bsZfq");


var $fs87B = parcelRequire("fs87B");

var $40t6Q = parcelRequire("40t6Q");


var $55iAf = parcelRequire("55iAf");


var $8nA5C = parcelRequire("8nA5C");


var $iIQ1o = parcelRequire("iIQ1o");


var $fMq01 = parcelRequire("fMq01");

const $a9c57e8f71b11b09$var$hubEditorStyles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc"
};
const $a9c57e8f71b11b09$var$EditorInternal = (props)=>{
    const intl = (0, $8C5kA.default)();
    const [editorApi, setEditorApi] = (0, $42omo.useState)(undefined);
    const { editorActions: editorActions, contentId: contentId, userId: userId, cloudId: cloudId, product: product, mediaProvider: mediaProvider, setExternalEditorApi: setExternalEditorApi, additionalExtensionProviders: additionalExtensionProviders = [], loadAdditionalExtensionProviders: loadAdditionalExtensionProviders, PropsProvider: PropsProvider, linkPickerOptions: linkPickerOptions } = props;
    const smartCardClient = (0, $42omo.useMemo)(()=>new (0, $k00oi.default)(), []);
    const { pageMediaConfig: pageMediaConfig } = (0, $gqsO5.useHubContext)();
    const { closeConfigPanel: closeConfigPanel, openConfigPanel: openConfigPanel } = (0, $3y8SL.useHubEditorExtensionConfigPanel)(editorActions);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId }] = (0, $g3LxX.useExtensionsState)();
    const { setIsInViewMode: setIsInViewMode } = (0, $g3LxX.useExtensionsActions)();
    const hubExtensionProviders = (0, $40t6Q.useHubExtensionProviders)({
        contentId: contentId,
        intl: intl,
        PropsProvider: PropsProvider,
        editorActions: editorActions,
        openConfigPanel: openConfigPanel
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // Load additional extension providers when editor is ready; we need to inject
    // editor-specific props
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (loadAdditionalExtensionProviders && editorActions) loadAdditionalExtensionProviders({
            editorActions: editorActions,
            openConfigPanel: openConfigPanel
        });
    }, [
        loadAdditionalExtensionProviders,
        editorActions,
        openConfigPanel
    ]); // Combine hub extensions with additional extensions
    const allExtensionProviders = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return [
            ...hubExtensionProviders,
            ...additionalExtensionProviders
        ];
    }, [
        hubExtensionProviders,
        additionalExtensionProviders
    ]);
    const mediaOptions = (0, $iIQ1o.useMediaOptions)({
        contentId: contentId,
        editorAPI: editorApi,
        customMediaProvider: mediaProvider,
        mediaConfig: pageMediaConfig
    });
    const { preset: preset, editorApi: presetEditorApi } = (0, $1JdaQ.usePreset)(()=>{
        return (0, $8nA5C.createHubEditorPreset)({
            ...props,
            intl: intl,
            mediaOptions: mediaOptions,
            linkPickerOptions: linkPickerOptions
        });
    }, [
        intl,
        props.hasEditPermission,
        props.isLoomPluginEnabled,
        props.editorPluginAIDefinitionsEnabled,
        props.editorPluginAIProactiveEnabled,
        props.editorPluginHubTextColorEnabled,
        props.isDesktop,
        contentId,
        mediaOptions,
        linkPickerOptions
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]);
    (0, $42omo.useEffect)(()=>{
        setEditorApi(presetEditorApi);
        if (!setExternalEditorApi || !presetEditorApi) return;
        setExternalEditorApi(presetEditorApi);
    }, [
        presetEditorApi,
        setExternalEditorApi
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
        product: product,
        client: smartCardClient,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bsZfq.EditorLinkingFeatures), {
            product: product,
            cloudId: cloudId,
            options: (0, $55iAf.LINKING_FEATURES_CARD_OPTIONS),
            linkPickerOptions: linkPickerOptions,
            children: (linkingFeatures)=>{
                return hubExtensionProviders.length > 0 && additionalExtensionProviders.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e6Iiv.ComposableEditor), {
                    appearance: "full-page",
                    ...linkingFeatures,
                    ...props,
                    preset: preset,
                    ...allExtensionProviders.length > 0 ? {
                        extensionProviders: allExtensionProviders
                    } : {},
                    editorActions: editorActions,
                    contextPanel: /*#__PURE__*/ (0, $l998X.jsx)((0, $calJ6.HubEditorConfigPanelEntryPoint), {
                        localId: selectedExtensionLocalId || '',
                        closeConfigPanel: closeConfigPanel,
                        editorActions: editorActions,
                        contentId: contentId,
                        editorApi: editorApi,
                        propsProvider: PropsProvider
                    }),
                    emojiProvider: (0, $fs87B.getEmojiProvider)({
                        cloudId: cloudId,
                        userId: userId
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                    name: "hub-extensions-loader",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $a9c57e8f71b11b09$var$hubEditorStyles.spinnerContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                            size: 'large',
                            label: formatMessage((0, $fMq01.default).hubStudioLoadingSpinnerLabel)
                        })
                    })
                });
            }
        })
    });
};
const $a9c57e8f71b11b09$var$HubEditor = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jrlgF.HubErrorBoundary), {
        packageName: "@atlassian/hub-editor",
        id: "hub-editor",
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auTg8.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5AtW0.default), {
                render: (editorActions)=>/*#__PURE__*/ (0, $l998X.jsx)($a9c57e8f71b11b09$var$EditorInternal, {
                        editorActions: editorActions,
                        ...props
                    })
            })
        })
    });
};
var $a9c57e8f71b11b09$export$2e2bcd8739ae039 = $a9c57e8f71b11b09$var$HubEditor;
module.exports["default"] = $a9c57e8f71b11b09$export$2e2bcd8739ae039;

});

parcelRegister("iQTig", function(module, exports) {
module.exports = new URL("GenericError.cd21964e.svg", import.meta.url).toString();

});

parcelRegister("5X6zn", function(module, exports) {
module.exports = new URL("RestrictedError.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("calJ6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $4wH3g = parcelRequire("4wH3g");


var $fwDOR = parcelRequire("fwDOR");


var $8Ixq2 = parcelRequire("8Ixq2");

var $jrlgF = parcelRequire("jrlgF");


const $694cf1213eae6915$export$4478acc98fcf11fd = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "mk0Xe",
    name: "LazyHubEditorConfigPanel",
    loader: async ()=>(await (parcelRequire("l0fE5"))).HubEditorConfigPanel,
    loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "editor-config-panel-chunk-loader"
        })
});
const $694cf1213eae6915$export$99ce0b7d4622b2b7 = /*#__PURE__*/ (0, $42omo.memo)(({ localId: localId, closeConfigPanel: closeConfigPanel, contentId: contentId, editorActions: editorActions, editorApi: editorApi, propsProvider: propsProvider })=>{
    if (localId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jrlgF.HubErrorBoundary), {
        id: "hub-editor-config-panel",
        packageName: "@atlassian/hub-editor-config-panel",
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {}),
        shouldForceError: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)($694cf1213eae6915$export$4478acc98fcf11fd, {
            localId: localId,
            closeConfigPanel: closeConfigPanel,
            contentId: contentId,
            editorActions: editorActions,
            editorApi: editorApi,
            propsProvider: propsProvider
        })
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
module.exports["HubEditorConfigPanelEntryPoint"] = $694cf1213eae6915$export$99ce0b7d4622b2b7;

});

parcelRegister("3y8SL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ks2lK = parcelRequire("ks2lK");


var $4TXTZ = parcelRequire("4TXTZ");


var $g3LxX = parcelRequire("g3LxX");


var $80hhG = parcelRequire("80hhG");

const $df25cdf8a2d7986f$var$UFOPRESS_EVENT = 'editor-config-panel-edit';
const $df25cdf8a2d7986f$export$b3c1b53ec616df30 = (editorActions)=>{
    const { setSelectedExtensionLocalId: setSelectedExtensionLocalId } = (0, $g3LxX.useExtensionsActions)();
    const openConfigPanel = (0, $42omo.useCallback)((localId)=>{
        if (!localId) return;
        const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
        const editorView = editorActions._privateGetEditorView();
        const selection = editorView?.state?.selection;
        if (selection instanceof (0, $ks2lK.NodeSelection)) {
            if ((0, $80hhG.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $4TXTZ.default)($df25cdf8a2d7986f$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        } else {
            if (type !== 'multiBodiedExtension' || !editorView?.state) return;
            // Handle MultiBodiedExtension config panel
            let multiBodiedExtensionPosition = editorView.state.selection.from;
            editorView.state.tr.doc.descendants((node, pos)=>{
                if (node.attrs?.localId === localId) {
                    multiBodiedExtensionPosition = pos;
                    return;
                }
            });
            editorView.dispatch(editorView.state.tr?.setSelection?.((0, $ks2lK.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
            if ((0, $80hhG.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $4TXTZ.default)($df25cdf8a2d7986f$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        }
        !!extensionKey && extensionType;
    }, [
        setSelectedExtensionLocalId,
        editorActions
    ]);
    const closeConfigPanel = (0, $42omo.useCallback)(()=>{
        setSelectedExtensionLocalId(null);
    }, [
        setSelectedExtensionLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel
        }), [
        openConfigPanel,
        closeConfigPanel
    ]);
};
module.exports["useHubEditorExtensionConfigPanel"] = $df25cdf8a2d7986f$export$b3c1b53ec616df30;

});

parcelRegister("bsZfq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $477dG = parcelRequire("477dG");


var $jhcFr = parcelRequire("jhcFr");

const $5b35bc9304135edf$export$2a89c15ccab17d33 = (0, $2XqLN.default)((product)=>{
    /**
	 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
	 * (only supports Cloud single-issue URLs right now)
	 */ const smartLinksBeforeMacros = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
    // Make smart links connect to staging when developing locally.
    const environment = undefined;
    const cardProvider = Promise.resolve(new (0, $477dG.EditorCardProvider)(environment, undefined, product));
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
    return {
        provider: cardProvider,
        resolveBeforeMacros: smartLinksBeforeMacros,
        allowBlockCards: true,
        allowEmbeds: true
    };
});
const $5b35bc9304135edf$export$5681a80d8b7b2bfb = (product)=>{
    return (0, $42omo.useMemo)(()=>{
        return $5b35bc9304135edf$export$2a89c15ccab17d33(product);
    }, [
        product
    ]);
};
const $5b35bc9304135edf$export$535281304894bcdc = (product, cardOptions)=>{
    const baseSmartLinks = $5b35bc9304135edf$export$5681a80d8b7b2bfb(product);
    return (0, $42omo.useMemo)(()=>({
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        }), [
        baseSmartLinks,
        cardOptions
    ]);
};
const $5b35bc9304135edf$export$78db118acf87bd21 = (product, options, cloudId, linkPickerOptions)=>{
    const config = $5b35bc9304135edf$export$535281304894bcdc(product, options);
    const productConfig = (0, $42omo.useMemo)(()=>({
            product: product,
            cloudId: cloudId
        }), [
        product,
        cloudId
    ]);
    const linkPickerProps = (0, $jhcFr.useLinkPickerEditorProps)(undefined, productConfig);
    const linkPickerPlugins = linkPickerOptions?.linkPickerPlugins;
    return (0, $42omo.useMemo)(()=>({
            linking: {
                ...config.linking,
                linkPicker: {
                    ...config.linking?.linkPicker,
                    ...linkPickerProps,
                    ...linkPickerPlugins && {
                        plugins: linkPickerPlugins
                    }
                },
                smartLinks: {
                    ...config.linking?.smartLinks
                }
            }
        }), [
        config,
        linkPickerProps,
        linkPickerPlugins
    ]);
};
const $5b35bc9304135edf$export$9b0cf83b2bedfd63 = ({ children: children, options: options, cloudId: cloudId, product: product = 'CONFLUENCE', linkPickerOptions: linkPickerOptions })=>{
    const mergedProps = $5b35bc9304135edf$export$78db118acf87bd21(product, options, cloudId, linkPickerOptions);
    return children(mergedProps);
};
module.exports["EditorLinkingFeatures"] = $5b35bc9304135edf$export$9b0cf83b2bedfd63;

});

parcelRegister("fs87B", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $ibzAc = parcelRequire("ibzAc");

const $7c7d6f28eb9ed9b2$var$BASE_URL = '/gateway/api/emoji';
const $7c7d6f28eb9ed9b2$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$7c7d6f28eb9ed9b2$var$BASE_URL}/standard`
        },
        {
            url: `${$7c7d6f28eb9ed9b2$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$7c7d6f28eb9ed9b2$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $7c7d6f28eb9ed9b2$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const disableUpload = extraConfig?.disableUpload ?? false;
    const emojiSSRConfigString = extraConfig?.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $7c7d6f28eb9ed9b2$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const emojiConfig = $7c7d6f28eb9ed9b2$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $ibzAc.default)(emojiConfig);
}, $7c7d6f28eb9ed9b2$var$resolverOfMemoize);
const $7c7d6f28eb9ed9b2$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((extraConfig)=>{
    const emojiResource = $7c7d6f28eb9ed9b2$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $7c7d6f28eb9ed9b2$var$resolverOfMemoize);
module.exports["getEmojiProvider"] = $7c7d6f28eb9ed9b2$export$8210f5f78c0bcf27;

});

parcelRegister("40t6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cKAxI = parcelRequire("cKAxI");


var $g6QUH = parcelRequire("g6QUH");


var $4cOi8 = parcelRequire("4cOi8");

var $8wrz6 = parcelRequire("8wrz6");


var $rsHkn = parcelRequire("rsHkn");


var $aYtOO = parcelRequire("aYtOO");


var $2QkXB = parcelRequire("2QkXB");


var $2baLD = parcelRequire("2baLD");


var $5zHV6 = parcelRequire("5zHV6");

const $5e59c19caa0b430a$export$c7edf67c9c07ecac = (props)=>{
    const { contentId: contentId, intl: intl, PropsProvider: PropsProvider, editorActions: editorActions, openConfigPanel: openConfigPanel } = props;
    const [extensionProviders, setExtensionProviders] = (0, $42omo.useState)([]);
    const loadProviders = (0, $42omo.useCallback)(async ()=>{
        const hubExtensionProviders = [];
        const defaultExtensionProviderProps = {
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $4cOi8.ExtensionMode).EDITOR,
            defaultParameters: (0, $8wrz6.getHubDefaultParameters)()
        };
        const defaultExtensionInstanceProps = {
            editorActions: editorActions,
            openConfigPanel: openConfigPanel,
            intl: intl,
            contentId: contentId
        };
        try {
            const DEFAULT_EXTENSION_PROVIDERS = [
                (0, $2baLD.spotlightExtensionProvider),
                (0, $aYtOO.linksMenuExtensionProvider),
                (0, $cKAxI.cardsExtensionProvider),
                (0, $g6QUH.carouselExtensionProvider)
            ];
            DEFAULT_EXTENSION_PROVIDERS.forEach(async (extensionProvider)=>{
                const providerInstance = await extensionProvider(defaultExtensionProviderProps);
                const provider = await providerInstance(defaultExtensionInstanceProps);
                hubExtensionProviders.push(provider);
            });
            // section provider
            const sectionExtProviderInstance = await (0, $2QkXB.sectionExtensionProvider)({
                ...defaultExtensionProviderProps,
                getSectionExtensionContents: $5zHV6.getSectionExtensionContents
            });
            const sectionExtProvider = await sectionExtProviderInstance(defaultExtensionInstanceProps);
            hubExtensionProviders.push(sectionExtProvider);
            const hubElementPlaceholderExtensionProviderInstance = await (0, $rsHkn.hubElementPlaceholderExtensionProvider)(defaultExtensionInstanceProps);
            hubExtensionProviders.push(hubElementPlaceholderExtensionProviderInstance);
            setExtensionProviders(hubExtensionProviders);
        } catch (error) {
        // todo: log error to analytics
        }
    }, [
        editorActions,
        openConfigPanel,
        intl,
        PropsProvider,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        loadProviders();
    }, [
        loadProviders
    ]);
    return extensionProviders;
};
module.exports["useHubExtensionProviders"] = $5e59c19caa0b430a$export$c7edf67c9c07ecac;

});

parcelRegister("55iAf", function(module, exports) {
const $9b887f242ff81a3d$export$c5dfd3b79761d51f = {
    allowDatasource: true
};
module.exports["LINKING_FEATURES_CARD_OPTIONS"] = $9b887f242ff81a3d$export$c5dfd3b79761d51f;

});

parcelRegister("8nA5C", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $akLj5 = parcelRequire("akLj5");

function $6efdd0a20b4dcd75$export$3f6a2f4541d2f102(props) {
    const { intl: intl, mediaOptions: mediaOptions, linkPickerOptions: linkPickerOptions } = props;
    const __livePage = false;
    // const editorPluginAIOptions = createPageEditorPluginAIOptions({
    // 	product,
    // 	aiGlobalOptIn: { status: 'disabled', triggerOptInFlow: () => { } },
    // 	PromptEditor: createPromptEditor({
    // 		enableLinks: false,
    // 		linking: {
    // 			smartLinks: { provider: undefined },
    // 		},
    // 		mentionProvider: undefined,
    // 		featureFlags: {},
    // 	}),
    // 	isRovoEnabled: false,
    // });
    return (0, $akLj5.hubPreset)({
        intl: intl,
        pluginOptions: {
            base: {
                __livePage: __livePage
            },
            helpDialog: {
                imageUploadProviderExists: Boolean(mediaOptions?.provider),
                aiEnabled: false
            },
            hyperlink: {
                linkPicker: {
                    plugins: linkPickerOptions?.linkPickerPlugins || []
                },
                onClickCallback: undefined
            },
            quickInsert: {
                emptyStateHandler: undefined,
                quickInsert: props.quickInsert
            },
            placeholder: {
                viewMode: props.viewMode,
                isAIEnabled: false
            },
            selection: {
                __livePage: __livePage
            },
            editorDisabled: {
                disabled: undefined
            },
            annotation: {
                annotationManager: undefined,
                createCommentExperience: undefined,
                selectCommentExperience: undefined,
                viewInlineCommentTraceUFOPress: undefined
            },
            tasksAndDecisions: {
                hasEditPermission: props.hasEditPermission,
                requestToEditContent: undefined,
                hasRequestedEditPermission: undefined
            },
            contextPanel: props.contextPanelOptions ? {
                objectSideBar: props.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                extensionHandlers: props.extensionHandlers,
                __rendererExtensionOptions: props.__rendererExtensionOptions,
                getExtensionHeight: props.getExtensionHeight
            },
            card: {
                __livePage: __livePage,
                linkPicker: props.linking?.linkPicker,
                onClickCallback: props.linking?.smartLinks?.onClickCallback
            },
            avatarGroup: {
                collabEdit: undefined
            },
            // ai: editorPluginAIOptions,
            loom: {
                renderButton: ()=>null
            },
            editorViewMode: {
                viewMode: props.viewMode
            },
            // aiDefinitions: props.editorPluginAIDefinitionsConfig,
            // aiProactive: props.editorPluginAIProactiveConfig,
            selectionMarker: {
                __livePage: __livePage
            },
            engagementPlatform: {
                coordinationClient: {
                    start: ()=>Promise.resolve(false),
                    stop: ()=>Promise.resolve(false)
                }
            },
            selectionExtension: {},
            metrics: {},
            primaryToolbar: {
                contextualFormattingEnabled: true
            },
            selectionToolbar: {
                contextualFormattingEnabled: true
            }
        },
        providers: {
            userPreferencesProvider: props.userPreferencesProvider,
            userPreferencesProviderNext: props.userPreferencesProviderNext,
            cardProvider: props.linking?.smartLinks?.provider,
            contextIdentifierProvider: props.contextIdentifierProvider,
            inlineCommentAnnotationProvider: props.annotationProviders?.inlineComment,
            mediaProvider: mediaOptions?.provider,
            syncMediaProvider: props.media?.syncProvider,
            mentionProvider: props.mentionProvider,
            profilecardProvider: props.mention?.profilecardProvider,
            emojiProvider: props.emojiProvider,
            autoformattingProvider: props.autoformattingProvider,
            taskDecisionProvider: props.taskDecisionProvider
        },
        enabledOptionalPlugins: {
            toolbar: (0, $dh538.fg)('hub_enable_inline_toolbar_plugin'),
            findReplace: Boolean(props.allowFindReplace),
            loom: props.isLoomPluginEnabled,
            aiDefinitions: props.editorPluginAIDefinitionsEnabled,
            aiProactive: props.editorPluginAIProactiveEnabled,
            connectivity: // @ts-expect-error - false is not allowed as expected value for boolean experiments
            props.isDesktop || (0, $1oCLl.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', false),
            metrics: (0, $dh538.fg)('platform_editor_ease_of_use_metrics'),
            ncsStepMetrics: true,
            codeBlockAdvanced: true,
            selectionExtension: (0, $1oCLl.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            // aiExperience: Boolean(props.editorPluginAIOptions?.aiGlobalOptIn?.status !== 'disabled'),
            interaction: (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
            userPreferences: (0, $dh538.fg)('platform_editor_use_preferences_plugin'),
            companyHubTextColor: props.editorPluginHubTextColorEnabled ?? false
        }
    });
}
module.exports["createHubEditorPreset"] = $6efdd0a20b4dcd75$export$3f6a2f4541d2f102;

});

parcelRegister("iIQ1o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gqsO5 = parcelRequire("gqsO5");

const $65ae352143522577$export$74fedad14355d824 = ({ contentId: contentId, editorAPI: editorAPI, customMediaProvider: customMediaProvider, mediaConfig: mediaConfig })=>{
    const resolver = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        const createMediaProvider = ()=>{
            return (0, $gqsO5.getMediaProvider)(mediaConfig?.mediaCollectionName ?? '', mediaConfig?.asapIssuer ?? '', mediaConfig?.mediaToken ?? '', mediaConfig?.mediaUrl ?? '');
        };
        const mediaProvider = createMediaProvider();
        if (mediaProvider) {
            if (editorAPI?.media?.actions) editorAPI.media.actions.setProvider(Promise.resolve(mediaProvider));
            if (resolver.current) resolver.current(mediaProvider);
        }
    }, [
        contentId,
        mediaConfig,
        editorAPI
    ]);
    return (0, $42omo.useMemo)(()=>{
        const provider = customMediaProvider ?? new Promise((resolve)=>{
            resolver.current = resolve;
        });
        return {
            provider: provider,
            allowMediaSingle: true,
            allowMediaGroup: true,
            allowResizing: true,
            allowLinking: true,
            allowResizingInTables: true,
            allowAltTextOnImages: true,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowMarkdownVideo: true,
            allowCaptions: true,
            allowAnnotation: true,
            allowLazyLoading: true,
            allowAdvancedToolBarOptions: true,
            allowDropzoneDropLine: true,
            allowMediaInline: true,
            allowTemplatePlaceholders: true,
            featureFlags: {}
        };
    }, [
        customMediaProvider
    ]);
};
module.exports["useMediaOptions"] = $65ae352143522577$export$74fedad14355d824;

});

parcelRegister("fMq01", function(module, exports) {
$parcel$export(module.exports, "default", () => $9acc7bbf03b4f2ec$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $9acc7bbf03b4f2ec$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    hubStudioLoadingSpinnerLabel: {
        id: "hub-editor.loading-spinner-label",
        defaultMessage: "Loading hub"
    }
});

});

parcelRegister("80hhG", function(module, exports) {

var $kcoxM = parcelRequire("kcoxM");


var $5Ac5G = parcelRequire("5Ac5G");


var $cNwLI = parcelRequire("cNwLI");


var $lf1vG = parcelRequire("lf1vG");


var $bl1ay = parcelRequire("bl1ay");


var $ab2CU = parcelRequire("ab2CU");


var $cVaAA = parcelRequire("cVaAA");


var $3cMhk = parcelRequire("3cMhk");

const $38f295c1ec230ae3$export$fe220054b070cbc4 = [
    (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
    (0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE),
    (0, $kcoxM.CARDS_EXTENSION_TYPE),
    (0, $cVaAA.LINKS_MENU_EXTENSION_TYPE),
    (0, $cNwLI.SECTION_EXTENSION_TYPE),
    (0, $lf1vG.SEARCH_EXTENSION_TYPE),
    (0, $5Ac5G.carouselExtensionType),
    (0, $cNwLI.RESOURCE_TILES_EXTENSION_TYPE),
    (0, $3cMhk.CALLOUT_BANNER_EXTENSION_TYPE),
    (0, $ab2CU.JSM_HELP_EXTENSION_TYPE)
];
module.exports["ALLOWED_EXTENSIONS"] = $38f295c1ec230ae3$export$fe220054b070cbc4;

});

parcelRegister("8wrz6", function(module, exports) {

var $cNwLI = parcelRequire("cNwLI");

const $381233ec895a9449$export$25a6d2da841ddb1d = ()=>{
    return {
        backgroundColor: `var(${0, $cNwLI.HUB_PRIMARY_COLOR_CSS_VAR}, ${`var(--ds-background-accent-gray-subtler, ${0, $cNwLI.DEFAULT_BRANDING_COLOR})`})`,
        textColor: `var(${0, $cNwLI.HUB_PRIMARY_TEXT_COLOR_CSS_VAR}, ${"var(--ds-text, #292A2E)"})`
    };
};
module.exports["getHubDefaultParameters"] = $381233ec895a9449$export$25a6d2da841ddb1d;

});

parcelRegister("akLj5", function(module, exports) {

var $bupcf = parcelRequire("bupcf");


var $3ihIB = parcelRequire("3ihIB");


var $hr8mu = parcelRequire("hr8mu");


var $jmHSv = parcelRequire("jmHSv");


var $cpn0f = parcelRequire("cpn0f");


var $PJ00O = parcelRequire("PJ00O");


var $fi7Vj = parcelRequire("fi7Vj");


var $fPXRH = parcelRequire("fPXRH");


var $55skd = parcelRequire("55skd");


var $2E0F0 = parcelRequire("2E0F0");


var $khxQ7 = parcelRequire("khxQ7");


var $hSJYu = parcelRequire("hSJYu");


var $cwPVT = parcelRequire("cwPVT");


var $duFi2 = parcelRequire("duFi2");


var $agrUc = parcelRequire("agrUc");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $01uqX = parcelRequire("01uqX");


var $7rj2U = parcelRequire("7rj2U");


var $jgFdO = parcelRequire("jgFdO");


var $gyXPd = parcelRequire("gyXPd");


var $5y9PZ = parcelRequire("5y9PZ");


var $2yr9J = parcelRequire("2yr9J");


var $kbe7k = parcelRequire("kbe7k");


var $1nZXu = parcelRequire("1nZXu");


var $kIhx9 = parcelRequire("kIhx9");


var $bS1lJ = parcelRequire("bS1lJ");


var $2nH2Y = parcelRequire("2nH2Y");


var $4iQt6 = parcelRequire("4iQt6");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $3mcWz = parcelRequire("3mcWz");


var $hcboS = parcelRequire("hcboS");


var $8ABVP = parcelRequire("8ABVP");


var $fTvEN = parcelRequire("fTvEN");


var $eyggb = parcelRequire("eyggb");


var $l7rln = parcelRequire("l7rln");


var $dtCIm = parcelRequire("dtCIm");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $6q6xk = parcelRequire("6q6xk");


var $fYKTL = parcelRequire("fYKTL");


var $fCLXZ = parcelRequire("fCLXZ");


var $flknw = parcelRequire("flknw");


var $cu2RD = parcelRequire("cu2RD");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $aUwPP = parcelRequire("aUwPP");


var $cVhn8 = parcelRequire("cVhn8");


var $6AqNX = parcelRequire("6AqNX");


var $05jmd = parcelRequire("05jmd");


var $5HHoF = parcelRequire("5HHoF");


var $80JwR = parcelRequire("80JwR");


var $cWFvG = parcelRequire("cWFvG");


var $2U68K = parcelRequire("2U68K");


var $dH9DB = parcelRequire("dH9DB");


var $kcvNv = parcelRequire("kcvNv");


var $b3BjA = parcelRequire("b3BjA");


var $36iDo = parcelRequire("36iDo");


var $59fTa = parcelRequire("59fTa");


var $kYgUn = parcelRequire("kYgUn");


var $8HLyI = parcelRequire("8HLyI");


var $itirX = parcelRequire("itirX");


var $e6sdP = parcelRequire("e6sdP");


var $5DsxN = parcelRequire("5DsxN");


var $1GAIu = parcelRequire("1GAIu");


var $bULcr = parcelRequire("bULcr");


var $4NiQW = parcelRequire("4NiQW");


var $5Qu3R = parcelRequire("5Qu3R");


var $7nKrc = parcelRequire("7nKrc");


var $c8680 = parcelRequire("c8680");


var $6borH = parcelRequire("6borH");


var $eeGWn = parcelRequire("eeGWn");


var $jaskt = parcelRequire("jaskt");


var $i2zv0 = parcelRequire("i2zv0");


var $5mDFx = parcelRequire("5mDFx");


var $3JBsx = parcelRequire("3JBsx");


var $1KHo7 = parcelRequire("1KHo7");


var $fMaLE = parcelRequire("fMaLE");


var $bz4KD = parcelRequire("bz4KD");


var $kw2eg = parcelRequire("kw2eg");


var $vxKdN = parcelRequire("vxKdN");


var $3O0YV = parcelRequire("3O0YV");


var $hEicH = parcelRequire("hEicH");


var $fI6T7 = parcelRequire("fI6T7");


var $dh538 = parcelRequire("dh538");


var $1ewUw = parcelRequire("1ewUw");


var $7OCNe = parcelRequire("7OCNe");


var $1fXM6 = parcelRequire("1fXM6");


var $4MVLq = parcelRequire("4MVLq");


var $5RVAG = parcelRequire("5RVAG");


var $fWkcL = parcelRequire("fWkcL");


var $iWSPQ = parcelRequire("iWSPQ");


var $4y9Kz = parcelRequire("4y9Kz");


var $cHFKB = parcelRequire("cHFKB");


var $eRg9X = parcelRequire("eRg9X");


var $1sSwB = parcelRequire("1sSwB");


var $aJHVS = parcelRequire("aJHVS");


var $9tRxr = parcelRequire("9tRxr");


var $i2djY = parcelRequire("i2djY");


var $jQ06G = parcelRequire("jQ06G");


var $5Dd7d = parcelRequire("5Dd7d");


var $bVUSv = parcelRequire("bVUSv");


var $b4WWq = parcelRequire("b4WWq");


var $78pY6 = parcelRequire("78pY6");


var $4REcT = parcelRequire("4REcT");


var $dxCwJ = parcelRequire("dxCwJ");


var $86sOu = parcelRequire("86sOu");


var $kzRVg = parcelRequire("kzRVg");


var $8J4Ig = parcelRequire("8J4Ig");


var $h5EPM = parcelRequire("h5EPM");


var $71mY6 = parcelRequire("71mY6");


var $f3DGR = parcelRequire("f3DGR");


var $aKz7i = parcelRequire("aKz7i");


var $gzLIB = parcelRequire("gzLIB");


var $dhSx4 = parcelRequire("dhSx4");


var $7IWcn = parcelRequire("7IWcn");


var $k2N06 = parcelRequire("k2N06");


var $6Hz7H = parcelRequire("6Hz7H");


var $a05p6 = parcelRequire("a05p6");


var $kM0Zd = parcelRequire("kM0Zd");


var $fgDQY = parcelRequire("fgDQY");


var $2MD6X = parcelRequire("2MD6X");


var $9go3B = parcelRequire("9go3B");


var $c9cMu = parcelRequire("c9cMu");


var $iKcD8 = parcelRequire("iKcD8");


var $jWhwv = parcelRequire("jWhwv");


var $3Xrfi = parcelRequire("3Xrfi");


var $hjUys = parcelRequire("hjUys");


var $8fkUp = parcelRequire("8fkUp");


var $1gKzC = parcelRequire("1gKzC");


var $1yQ82 = parcelRequire("1yQ82");


var $2tLa9 = parcelRequire("2tLa9");


var $9NORi = parcelRequire("9NORi");


var $dfnwW = parcelRequire("dfnwW");


var $2brVr = parcelRequire("2brVr");


var $1tg3R = parcelRequire("1tg3R");


var $19tf6 = parcelRequire("19tf6");


var $7BhUY = parcelRequire("7BhUY");

function $79b8bfc371482db1$export$b21c20e4234a3291(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the HubPresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return new (0, $bupcf.EditorPresetBuilder)().add([
        (0, $l7rln.featureFlagsPlugin),
        (0, $h5EPM.featureFlagsPluginOptions)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $jmHSv.analyticsPlugin),
        (0, $fWkcL.analyticsPluginOptions)({
            options: pluginOptions.analytics
        })
    ]).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        (0, $fgDQY.pastePluginOptions)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        (0, $jQ06G.contextIdentifierPluginOptions)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $fi7Vj.default),
        (0, $cHFKB.basePluginOptions)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        (0, $7BhUY.userPreferencesPluginOptions)({
            providers: providers
        })
    ], Boolean(enabledOptionalPlugins.interaction) && (0, $dh538.fg)('platform_editor_use_preferences_plugin')).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        (0, $19tf6.typeAheadPluginOptions)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $HYzBP.default)).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        {
            contextualFormattingEnabled: 'always-inline'
        }
    ], Boolean(enabledOptionalPlugins.toolbar)).add([
        (0, $itirX.primaryToolbarPlugin),
        (0, $c9cMu.primaryToolbarPluginOptions)({
            options: pluginOptions.primaryToolbar
        })
    ]).add((0, $kw2eg.undoRedoPlugin)).add([
        (0, $khxQ7.blockTypePlugin),
        (0, $eRg9X.blockTypePluginOptions)({
            options: pluginOptions.blockType
        })
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        (0, $8fkUp.selectionToolbarPluginOptions)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        (0, $gzLIB.hyperlinkPluginOptions)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        (0, $2brVr.textFormattingPluginOptions)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        (0, $iKcD8.quickInsertPluginOptions)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        (0, $2MD6X.placeholderPluginOptions)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        (0, $78pY6.editorDisabledPluginOptions)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $6borH.submitEditorPlugin),
        (0, $1yQ82.submitEditorPluginOptions)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $kIhx9.copyButtonPlugin)).add((0, $7sK9h.floatingToolbarPlugin)).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $bULcr.selectionPlugin),
        (0, $hjUys.selectionPluginOptions)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $7rj2U.default),
        (0, $i2djY.codeBlockPluginOptions)({
            options: pluginOptions.codeBlock
        })
    ]).add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).add([
        (0, $cwPVT.breakoutPlugin),
        (0, $1sSwB.breakoutPluginOptions)()
    ]).add((0, $hr8mu.alignmentPlugin)).add([
        (0, $i2zv0.textColorPlugin),
        (0, $dfnwW.textColorPluginOptions)({
            options: pluginOptions.textColor
        })
    ]).maybeAdd((0, $1fXM6.companyHubTextColorPlugin), Boolean(enabledOptionalPlugins.companyHubTextColor)).add((0, $5HHoF.listPlugin)).add((0, $5DsxN.rulePlugin)).add([
        (0, $fTvEN.expandPlugin),
        (0, $kzRVg.expandPluginOptions)()
    ]).add((0, $fCLXZ.guidelinePlugin)).add([
        (0, $fYKTL.gridPlugin),
        (0, $f3DGR.gridPluginOptions)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $cpn0f.annotationPlugin),
        (0, $iWSPQ.annotationPluginOptions)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $cWFvG.mediaPlugin),
        (0, $6Hz7H.mediaPluginOptions)({
            intl: intl,
            providers: providers
        })
    ]).add((0, $2U68K.mediaInsertPlugin)).add((0, $duFi2.default)).add([
        (0, $hcboS.emojiPlugin),
        (0, $dxCwJ.emojiPluginOptions)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $eeGWn.default),
        (0, $2tLa9.tablePluginOptions)()
    ]).add([
        (0, $jaskt.tasksAndDecisionsPlugin),
        (0, $9NORi.tasksAndDecisionsPluginOptions)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $flknw.helpDialogPlugin),
        (0, $aKz7i.helpDialogPluginOptions)({
            options: {
                imageUploadProviderExists: false,
                // aiEnabled: enabledOptionalPlugins.aiExperience,
                aiEnabled: false
            }
        })
    ]).add([
        (0, $b3BjA.default),
        (0, $kM0Zd.panelPluginOptions)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $1nZXu.contextPanelPlugin),
        (0, $5Dd7d.contextPanelPluginOptions)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $eyggb.extensionPlugin),
        (0, $8J4Ig.extensionPluginOptions)({
            options: pluginOptions.extension
        })
    ]).add([
        (0, $4iQt6.default),
        (0, $b4WWq.datePluginOptions)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $8HLyI.default),
        (0, $9go3B.placeholderTextPluginOptions)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $05jmd.layoutPlugin),
        (0, $7IWcn.layoutPluginOptions)()
    ]).add([
        (0, $agrUc.cardPlugin),
        (0, $aJHVS.cardPluginOptions)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $bS1lJ.customAutoformatPlugin),
        (0, $bVUSv.customAutoformatPluginOptions)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $c8680.statusPlugin),
        (0, $1gKzC.statusPluginOptions)({
            options: pluginOptions.status
        })
    ]).add((0, $aUwPP.indentationPlugin)).add((0, $1GAIu.scrollIntoViewPlugin)).add([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        (0, $1tg3R.toolbarListsIndentationPluginOptions)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $cVhn8.insertBlockPlugin),
        (0, $dhSx4.insertBlockPluginOptions)()
    ]).add([
        (0, $PJ00O.avatarGroupPlugin),
        (0, $4y9Kz.avatarGroupPluginOptions)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        (0, $71mY6.findReplacePluginOptions)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $hSJYu.borderPlugin)).add((0, $6q6xk.fragmentPlugin)).add((0, $59fTa.pasteOptionsToolbarPlugin)).add([
        (0, $01uqX.codeBidiWarningPlugin),
        (0, $9tRxr.codeBidiWarningPluginOptions)()
    ])// .maybeAdd(
    // 	[aiPlugin, aiPluginOptions({ options: pluginOptions.ai })],
    // 	enabledOptionalPlugins.aiExperience,
    // )
    .maybeAdd([
        (0, $80JwR.loomPlugin),
        (0, $k2N06.loomPluginOptions)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $3mcWz.editorViewModePlugin),
        (0, $4REcT.editorViewModePluginOptions)({
            options: pluginOptions.editorViewMode
        })
    ])// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $1ewUw.aiDefinitionsPlugin),
        (0, $4MVLq.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions)// aiProactivePlugin depends on aiPlugin
    .maybeAdd([
        (0, $7OCNe.aiProactivePlugin),
        (0, $5RVAG.aiProactivePluginOptions)({
            options: pluginOptions.aiProactive
        })
    ], enabledOptionalPlugins.aiProactive).add([
        (0, $5Qu3R.selectionMarkerPlugin),
        (0, $3Xrfi.selectionMarkerPluginOptions)({
            options: pluginOptions.selectionMarker
        })
    ]).add((0, $2E0F0.blockControlsPlugin)).add((0, $cu2RD.highlightPlugin)).add([
        (0, $8ABVP.engagementPlatformPlugin),
        (0, $86sOu.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $5y9PZ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd((0, $kcvNv.ncsStepMetricsPlugin), enabledOptionalPlugins.ncsStepMetrics).maybeAdd([
        (0, $dH9DB.metricsPlugin),
        (0, $a05p6.metricsPluginOptions)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).maybeAdd((0, $jgFdO.codeBlockAdvancedPlugin), enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $4NiQW.selectionExtensionPlugin),
        (0, $jWhwv.selectionExtensionPluginOptions)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).add((0, $3O0YV.userIntentPlugin));
}
module.exports["hubPreset"] = $79b8bfc371482db1$export$b21c20e4234a3291;

});

parcelRegister("1fXM6", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6Hx3Z = parcelRequire("6Hx3Z");


var $gUTWz = parcelRequire("gUTWz");


var $649jV = parcelRequire("649jV");


var $9F27L = parcelRequire("9F27L");

const $cc94862f8d1d66f3$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $cc94862f8d1d66f3$export$164d98bc1a6b118 = ({ config: textColorConfig, api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9F27L.PrimaryToolbarComponent), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'textColor',
        component: primaryToolbarComponent
    });
    return {
        name: 'companyHubTextColor',
        marks () {
            return [
                {
                    name: 'companyHubTextColor',
                    mark: (0, $6Hx3Z.textColor)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'companyHubTextColor',
                    plugin: ({ dispatch: dispatch })=>(0, $649jV.createPlugin)(dispatch, $cc94862f8d1d66f3$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $649jV.pluginKey).getState(editorState);
        },
        actions: {
            changeColor: (color)=>{
                return (0, $gUTWz.changeColor)(color, api?.analytics?.actions);
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["companyHubTextColorPlugin"] = $cc94862f8d1d66f3$export$164d98bc1a6b118;

});

parcelRegister("4MVLq", function(module, exports) {
function $d45ccd44c931de7b$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}
module.exports["aiDefinitionsPluginOptions"] = $d45ccd44c931de7b$export$13aeab2a71badd1e;

});

parcelRegister("5RVAG", function(module, exports) {
function $bbd24a9e045c6cd8$export$3dd05c02043bb4e8({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIProactiveConfig`.
    return options;
}
module.exports["aiProactivePluginOptions"] = $bbd24a9e045c6cd8$export$3dd05c02043bb4e8;

});

parcelRegister("fWkcL", function(module, exports) {
function $acf26518460f3499$export$bfd53895e8497571({}) {
    return {};
}
module.exports["analyticsPluginOptions"] = $acf26518460f3499$export$bfd53895e8497571;

});

parcelRegister("iWSPQ", function(module, exports) {
function $0b0084cdebc703c9$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: undefined,
        annotationManager: options.annotationManager
    };
}
module.exports["annotationPluginOptions"] = $0b0084cdebc703c9$export$b3e029fd31f94f55;

});

parcelRegister("4y9Kz", function(module, exports) {
function $69a335eff8f686c5$export$eeaea850bc5c5797({ options: options }) {
    return {
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}
module.exports["avatarGroupPluginOptions"] = $69a335eff8f686c5$export$eeaea850bc5c5797;

});

parcelRegister("cHFKB", function(module, exports) {
function $38a0d8518c026de5$export$a23b3fa66082f163({ options: options }) {
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: undefined
    };
}
module.exports["basePluginOptions"] = $38a0d8518c026de5$export$a23b3fa66082f163;

});

parcelRegister("eRg9X", function(module, exports) {
function $9f528e524f6d39d5$export$817c0e398e6ff750({}) {
    return {
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}
module.exports["blockTypePluginOptions"] = $9f528e524f6d39d5$export$817c0e398e6ff750;

});

parcelRegister("1sSwB", function(module, exports) {
function $629d78bc6ac5b14e$export$3be6b735d5cbc3e6() {
    return {
        allowBreakoutButton: true
    };
}
module.exports["breakoutPluginOptions"] = $629d78bc6ac5b14e$export$3be6b735d5cbc3e6;

});

parcelRegister("aJHVS", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");

/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $17845e7231cbde23$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $17845e7231cbde23$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        allowDatasource: false,
        provider: providers.cardProvider,
        resolveBeforeMacros: $17845e7231cbde23$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        onClickCallback: options.onClickCallback,
        fullWidthMode: false,
        linkPicker: options.linkPicker,
        lpLinkPicker: true,
        editorAppearance: 'full-page',
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $eTj7Y.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}
module.exports["cardPluginOptions"] = $17845e7231cbde23$export$514131654bb897e2;

});

parcelRegister("9tRxr", function(module, exports) {
function $2071df89d6cd2287$export$3f0ff0bcf72f4d98() {
    return {
        appearance: 'full-page'
    };
}
module.exports["codeBidiWarningPluginOptions"] = $2071df89d6cd2287$export$3f0ff0bcf72f4d98;

});

parcelRegister("i2djY", function(module, exports) {
function $d6ebf8f29df564a1$export$74cc43e84bb9c20({}) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false
    };
}
module.exports["codeBlockPluginOptions"] = $d6ebf8f29df564a1$export$74cc43e84bb9c20;

});

parcelRegister("jQ06G", function(module, exports) {
function $e3f44214a7b3dbd1$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}
module.exports["contextIdentifierPluginOptions"] = $e3f44214a7b3dbd1$export$2c26eb5ff90afcfd;

});

parcelRegister("5Dd7d", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $26ea6a4e9a24a366$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}
module.exports["contextPanelPluginOptions"] = $26ea6a4e9a24a366$export$48a60d81b6bb28e3;

});

parcelRegister("bVUSv", function(module, exports) {
function $fec23932796ad742$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}
module.exports["customAutoformatPluginOptions"] = $fec23932796ad742$export$f18d68682e981a91;

});

parcelRegister("b4WWq", function(module, exports) {
function $ef880343d49ffe72$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}
module.exports["datePluginOptions"] = $ef880343d49ffe72$export$5598bb2314a53fa8;

});

parcelRegister("78pY6", function(module, exports) {
function $b19d9c84f5cf0ba1$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}
module.exports["editorDisabledPluginOptions"] = $b19d9c84f5cf0ba1$export$de47eee62065048e;

});

parcelRegister("4REcT", function(module, exports) {
function $94460a3ae74708d0$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}
module.exports["editorViewModePluginOptions"] = $94460a3ae74708d0$export$36a79e2b5698697a;

});

parcelRegister("dxCwJ", function(module, exports) {
function $3d4c034b969d8545$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider
    };
}
module.exports["emojiPluginOptions"] = $3d4c034b969d8545$export$7adcaf18ca5c72c4;

});

parcelRegister("86sOu", function(module, exports) {

var $axAnW = parcelRequire("axAnW");

var $kkQZq = parcelRequire("kkQZq");

var $iPfZG = parcelRequire("iPfZG");

var $hwWwS = parcelRequire("hwWwS");

function $2867aa80797b1484$export$128eafe7f843e327({ options: options }) {
    return {
        epComponents: {
            EngagementSpotlight: $iPfZG.EngagementSpotlight,
            EngagementInlineDialog: $kkQZq.default,
            Coordination: $axAnW.default
        },
        epHooks: {
            useCoordination: $hwWwS.useCoordination
        },
        coordinationClient: options.coordinationClient
    };
}
module.exports["engagementPlatformPluginOptions"] = $2867aa80797b1484$export$128eafe7f843e327;

});

parcelRegister("kzRVg", function(module, exports) {
function $3f3e4f29f2065e64$export$ed53f0c49fce09d6() {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: 'full-page',
        allowInteractiveExpand: true,
        __livePage: false
    };
}
module.exports["expandPluginOptions"] = $3f3e4f29f2065e64$export$ed53f0c49fce09d6;

});

parcelRegister("8J4Ig", function(module, exports) {
function $13dc9dee75d5bdd5$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: true,
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: 'full-page',
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight
    };
}
module.exports["extensionPluginOptions"] = $13dc9dee75d5bdd5$export$c18b9102cd0790c9;

});

parcelRegister("h5EPM", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $30d1497707429888$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        lpLinkPicker: true,
        tableDragAndDrop: (0, $iu6m9.editorExperiment)('platform_editor_tables_drag_and_drop', true),
        tableWithFixedColumnWidthsOption: true,
        tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["featureFlagsPluginOptions"] = $30d1497707429888$export$3bff061e5229a7;

});

parcelRegister("71mY6", function(module, exports) {
function $d1cac142960ff61c$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}
module.exports["findReplacePluginOptions"] = $d1cac142960ff61c$export$d9e183f0607e1b5d;

});

parcelRegister("f3DGR", function(module, exports) {
function $7b1a452cbb48f485$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}
module.exports["gridPluginOptions"] = $7b1a452cbb48f485$export$c66d0d1462a05bd;

});

parcelRegister("aKz7i", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $88af40f8c2f52f9b$export$2a67100cd9c61f05({ options: options }) {
    if ((0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return options;
    return false;
}
module.exports["helpDialogPluginOptions"] = $88af40f8c2f52f9b$export$2a67100cd9c61f05;

});

parcelRegister("gzLIB", function(module, exports) {
function $8da7b06601c8ee38$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: 'full-page',
        lpLinkPicker: true,
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}
module.exports["hyperlinkPluginOptions"] = $8da7b06601c8ee38$export$ab9ae3984d5aef33;

});

parcelRegister("dhSx4", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $ad7b1b353b46da00$export$1e11b615e9dc119e() {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: 'full-page'
    };
}
module.exports["insertBlockPluginOptions"] = $ad7b1b353b46da00$export$1e11b615e9dc119e;

});

parcelRegister("7IWcn", function(module, exports) {
function $1ec840f9865e761e$export$33fb6c6592b2cd5f() {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: 'full-page'
    };
}
module.exports["layoutPluginOptions"] = $1ec840f9865e761e$export$33fb6c6592b2cd5f;

});

parcelRegister("k2N06", function(module, exports) {
function $7880f5c156c13df4$export$feaee25faac0c640({ options: options }) {
    return {
        renderButton: options.renderButton,
        shouldShowToolbarButton: undefined
    };
}
module.exports["loomPluginOptions"] = $7880f5c156c13df4$export$feaee25faac0c640;

});

parcelRegister("6Hz7H", function(module, exports) {

var $fvooL = parcelRequire("fvooL");

function $06402620f0da3ac5$export$484123ae56f6fbd9({ intl: intl, providers: providers }) {
    return {
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage((0, $fvooL.i18n).invalidAltText)
            ];
            return [];
        },
        featureFlags: {
            mediaInline: true
        },
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: false,
        editorAppearance: 'full-page',
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        waitForMediaUpload: true
    };
}
module.exports["mediaPluginOptions"] = $06402620f0da3ac5$export$484123ae56f6fbd9;

});

parcelRegister("a05p6", function(module, exports) {
function $fbb0f2e011f7db3d$export$4677177d82484aef({ options: options }) {
    return options;
}
module.exports["metricsPluginOptions"] = $fbb0f2e011f7db3d$export$4677177d82484aef;

});

parcelRegister("kM0Zd", function(module, exports) {
function $3a82bd1b55f2a13e$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}
module.exports["panelPluginOptions"] = $3a82bd1b55f2a13e$export$c18e432f323b002e;

});

parcelRegister("fgDQY", function(module, exports) {
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $30425996693f45d2$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $30425996693f45d2$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $30425996693f45d2$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}
module.exports["pastePluginOptions"] = $30425996693f45d2$export$6b1ad42d09c74964;

});

parcelRegister("2MD6X", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");


var $dRcd0 = parcelRequire("dRcd0");

function $61bb71a0a099da18$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const placeholder = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (!options.isAIEnabled && (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return intl.formatMessage((0, $dRcd0.i18n).editorEmptyDocumentPlaceholderAI);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $dRcd0.i18n).defaultPlaceholder);
        if (!options.isAIEnabled) return intl.formatMessage((0, $dRcd0.i18n).aiPlaceholder);
        return intl.formatMessage((0, $dRcd0.i18n).easyCommandsPlaceholder);
    })();
    return {
        placeholder: placeholder
    };
}
module.exports["placeholderPluginOptions"] = $61bb71a0a099da18$export$c6841f879d4c8aef;

});

parcelRegister("9go3B", function(module, exports) {
function $d7ec44375c0c69ab$export$8b53e6ddc7cf96b4({}) {
    return {};
}
module.exports["placeholderTextPluginOptions"] = $d7ec44375c0c69ab$export$8b53e6ddc7cf96b4;

});

parcelRegister("c9cMu", function(module, exports) {
function $096819e9e3145dca$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["primaryToolbarPluginOptions"] = $096819e9e3145dca$export$44901d053a58e418;

});

parcelRegister("iKcD8", function(module, exports) {
function $851eded84e8bf107$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}
module.exports["quickInsertPluginOptions"] = $851eded84e8bf107$export$26cff1f2fe9f781b;

});

parcelRegister("jWhwv", function(module, exports) {
function $f4b12af64bc7f2eb$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}
module.exports["selectionExtensionPluginOptions"] = $f4b12af64bc7f2eb$export$222c5aa4c9fb0805;

});

parcelRegister("3Xrfi", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

function $0f50d38d2e30ef8c$export$197b78e13e8987d2({ options: options }) {
    return {
        hideCursorOnInit: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
}
module.exports["selectionMarkerPluginOptions"] = $0f50d38d2e30ef8c$export$197b78e13e8987d2;

});

parcelRegister("hjUys", function(module, exports) {
function $b34077e910610c2a$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}
module.exports["selectionPluginOptions"] = $b34077e910610c2a$export$ddc2936355c1da67;

});

parcelRegister("8fkUp", function(module, exports) {
function $fc71367a7a47d521$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider
    };
}
module.exports["selectionToolbarPluginOptions"] = $fc71367a7a47d521$export$bc6dcb3c2a6112e1;

});

parcelRegister("1gKzC", function(module, exports) {
function $706ab7504ddbc2fe$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}
module.exports["statusPluginOptions"] = $706ab7504ddbc2fe$export$9d286ea8d36eb908;

});

parcelRegister("1yQ82", function(module, exports) {
function $a2229dc7f4dff797$export$3612ff8a6b94af71({}) {
    return undefined;
}
module.exports["submitEditorPluginOptions"] = $a2229dc7f4dff797$export$3612ff8a6b94af71;

});

parcelRegister("2tLa9", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $3bb66ac430418946$export$9868b594778cf535() {
    return {
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        dragAndDropEnabled: (0, $iu6m9.editorExperiment)('platform_editor_tables_drag_and_drop', true),
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: false,
        wasFullWidthEnabled: false,
        getEditorFeatureFlags: ()=>({
                tableWithFixedColumnWidthsOption: true,
                tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false
    };
}
module.exports["tablePluginOptions"] = $3bb66ac430418946$export$9868b594778cf535;

});

parcelRegister("9NORi", function(module, exports) {
function $0274cb1d352a52e1$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission
    };
}
module.exports["tasksAndDecisionsPluginOptions"] = $0274cb1d352a52e1$export$1d23e03c42bfc1ac;

});

parcelRegister("dfnwW", function(module, exports) {
function $6878daa5f772afae$export$a4eedeb4455295f2({}) {
    return true;
}
module.exports["textColorPluginOptions"] = $6878daa5f772afae$export$a4eedeb4455295f2;

});

parcelRegister("2brVr", function(module, exports) {
function $92619e811c751fec$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}
module.exports["textFormattingPluginOptions"] = $92619e811c751fec$export$cb883a3a9320698e;

});

parcelRegister("1tg3R", function(module, exports) {
function $0d249c3975c8bf3b$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}
module.exports["toolbarListsIndentationPluginOptions"] = $0d249c3975c8bf3b$export$bd221c449644c740;

});

parcelRegister("19tf6", function(module, exports) {
function $63f1cbdbc55ad759$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}
module.exports["typeAheadPluginOptions"] = $63f1cbdbc55ad759$export$612ea2d32c3e4c96;

});

parcelRegister("7BhUY", function(module, exports) {
function $00f1b9d5a2046f3b$export$abdb0d09187eec69({ providers: providers }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        initialUserPreferences: undefined
    };
}
module.exports["userPreferencesPluginOptions"] = $00f1b9d5a2046f3b$export$abdb0d09187eec69;

});

parcelRegister("gUTWz", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $dAtrv = parcelRequire("dAtrv");


var $gOLwW = parcelRequire("gOLwW");


var $649jV = parcelRequire("649jV");


var $dWTvx = parcelRequire("dWTvx");


var $11geo = parcelRequire("11geo");

/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $09a1cabeb139a72f$var$createWithColorAnalytics(newColor, previousColor, editorAnalyticsApi) {
    return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColor.toLowerCase(),
            previousColor: previousColor?.toLowerCase() || ''
        }
    });
}
const $09a1cabeb139a72f$export$917538e4f4eb20f9 = (color, editorAnalyticsApi)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $649jV.pluginKey).getState(state);
            const activeColor = (0, $gOLwW.getActiveColor)(state);
            const withColorAnalytics = $09a1cabeb139a72f$var$createWithColorAnalytics(color, activeColor, editorAnalyticsApi);
            if (pluginState?.disabled) return false;
            if (color === pluginState?.defaultColor) {
                withColorAnalytics((0, $dWTvx.removeColor)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $11geo.toggleColor)(color))(state, dispatch);
            return true;
        }
        return false;
    };
module.exports["changeColor"] = $09a1cabeb139a72f$export$917538e4f4eb20f9;

});

parcelRegister("649jV", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $gOLwW = parcelRequire("gOLwW");


var $51Ekf = parcelRequire("51Ekf");


var $jsAOX = parcelRequire("jsAOX");

function $60cdae16545b9719$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = pluginConfig?.defaultColor || (0, $51Ekf.DEFAULT_COLOR);
    const state = {
        color: (0, $gOLwW.getActiveColor)(editorState),
        disabled: (0, $jsAOX.getDisabledState)(editorState),
        defaultColor: defaultColor.color
    };
    return state;
}
var $60cdae16545b9719$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
    return ACTIONS;
}({});
const $60cdae16545b9719$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('companyHubTextColorPlugin');
function $60cdae16545b9719$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $1S4f7.SafePlugin)({
        key: $60cdae16545b9719$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $60cdae16545b9719$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($60cdae16545b9719$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    default:
                        nextState = {
                            ...pluginState,
                            color: (0, $gOLwW.getActiveColor)(newState),
                            disabled: (0, $jsAOX.getDisabledState)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled) {
                    dispatch($60cdae16545b9719$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        },
        props: {
            attributes: ()=>({
                    'data-company-hub-text-color-plugin': 'true'
                })
        }
    });
}
module.exports["ACTIONS"] = $60cdae16545b9719$export$92a1a3b7554e9387;
module.exports["pluginKey"] = $60cdae16545b9719$export$18d4026d1ea86bb1;
module.exports["createPlugin"] = $60cdae16545b9719$export$ae829ec7b2625219;

});

parcelRegister("9F27L", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $eiA8Z = parcelRequire("eiA8Z");


var $2iDug = parcelRequire("2iDug");

const $bde92491bf906b85$export$94516d5cccf573e3 = (0, $gmMgo.default)(({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled, api: api })=>{
    const { color: color, defaultColor: defaultColor, disabled: textColorDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'companyHubTextColor'
    ], (states)=>({
            color: states.companyHubTextColorState?.color,
            defaultColor: states.companyHubTextColorState?.defaultColor,
            disabled: states.companyHubTextColorState?.disabled
        }));
    if (color === undefined || defaultColor === undefined) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2iDug.ToolbarCompanyHubTextColor), {
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            disabled: textColorDisabled
        },
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: isReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $2iDug.ToolbarType).PRIMARY
    });
});
module.exports["PrimaryToolbarComponent"] = $bde92491bf906b85$export$94516d5cccf573e3;

});

parcelRegister("fvooL", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $4c417a863b46d1bc$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    invalidAltText: {
        id: "editor-presets-hub.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
module.exports["i18n"] = $4c417a863b46d1bc$export$a7357cdd1f0b0168;

});

parcelRegister("dRcd0", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $38c68446ccb3ecb5$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    easyCommandsPlaceholder: {
        id: "editor-presets-hub.placeholder.easy-commands-placeholder",
        defaultMessage: "Type / for all elements."
    },
    aiPlaceholder: {
        id: "editor-presets-hub.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence or / to add elements."
    },
    defaultPlaceholder: {
        id: "editor-presets-hub.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-hub.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    }
});
module.exports["i18n"] = $38c68446ccb3ecb5$export$a7357cdd1f0b0168;

});

parcelRegister("gOLwW", function(module, exports) {

var $51Ekf = parcelRequire("51Ekf");

const $e4d18f8204e3b966$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $51Ekf.DEFAULT_COLOR).color;
};
module.exports["getActiveColor"] = $e4d18f8204e3b966$export$1c6fa8f53a5fb47f;

});

parcelRegister("dWTvx", function(module, exports) {

var $b167b = parcelRequire("b167b");


var $649jV = parcelRequire("649jV");

const $46cef95780a91da9$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema } = state;
        const { textColor: textColor } = schema.marks;
        const tr = state.tr;
        (0, $b167b.removeMark)(textColor)({
            tr: tr
        });
        if (dispatch) dispatch(tr.setMeta((0, $649jV.pluginKey), {
            action: (0, $649jV.ACTIONS).RESET_COLOR
        }));
        return true;
    };
module.exports["removeColor"] = $46cef95780a91da9$export$4a26621adcb675d6;

});

parcelRegister("11geo", function(module, exports) {

var $b167b = parcelRequire("b167b");


var $51Ekf = parcelRequire("51Ekf");


var $jsAOX = parcelRequire("jsAOX");


var $649jV = parcelRequire("649jV");

const $5208421582db85a4$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        const tr = state.tr;
        const disabledState = (0, $jsAOX.getDisabledState)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $649jV.pluginKey), {
                action: (0, $649jV.ACTIONS).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            (0, $51Ekf.overrideMarks).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $b167b.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $b167b.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            dispatch(tr);
        }
        return true;
    };
module.exports["toggleColor"] = $5208421582db85a4$export$afb561a73dff6672;

});

parcelRegister("51Ekf", function(module, exports) {
const $c7a1c16bad17b13f$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $c7a1c16bad17b13f$export$37394b0fa44b998c = {
    color: "var(--ds-text, #292A2E)",
    label: 'Default'
};
module.exports["overrideMarks"] = $c7a1c16bad17b13f$export$ccbc17c7832f26ef;
module.exports["DEFAULT_COLOR"] = $c7a1c16bad17b13f$export$37394b0fa44b998c;

});

parcelRegister("jsAOX", function(module, exports) {

var $l6xRR = parcelRequire("l6xRR");


var $51Ekf = parcelRequire("51Ekf");

const $a905280a2fd3ea3a$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $a905280a2fd3ea3a$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $a905280a2fd3ea3a$var$hasLinkMark($cursor) || (0, $l6xRR.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $51Ekf.overrideMarks).includes(mark.type.name);
        };
        if ((0, $l6xRR.isMarkExcluded)(textColor, state.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};
module.exports["getDisabledState"] = $a905280a2fd3ea3a$export$4af1020a67b5ec91;

});

parcelRegister("2iDug", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $8mBDG = parcelRequire("8mBDG");


var $5n7dr = parcelRequire("5n7dr");

var $koWgP = parcelRequire("koWgP");


var $gUTWz = parcelRequire("gUTWz");


var $eB87j = parcelRequire("eB87j");

var $3cccdde471a746af$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primary";
    ToolbarType["FLOATING"] = "floating";
    return ToolbarType;
}({});
const $3cccdde471a746af$export$803d4933f12f6ddc = (0, $gmMgo.default)(({ pluginState: pluginState, editorView: editorView, pluginInjectionApi: pluginInjectionApi, disabled: disabled })=>{
    const blackWhiteColorMap = (0, $koWgP.createBuiltInColorMap)({
        knownColors: [
            "var(--ds-text-inverse, #FFFFFF)",
            "var(--ds-text, #292A2E)"
        ]
    });
    const changeTextColor = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((color)=>{
        if (color && !disabled) (0, $gUTWz.changeColor)(color, pluginInjectionApi?.analytics?.actions)(editorView.state, editorView.dispatch);
        editorView?.focus();
        return false;
    }, [
        disabled,
        editorView,
        pluginInjectionApi?.analytics?.actions
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8mBDG.ToolbarDropdownWrapper), {
        "data-testid": "company-hub-text-color-picker",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
            analyticsSource: "companyHubToolbarTextColor",
            builtInColorMap: blackWhiteColorMap,
            onChange: changeTextColor,
            value: pluginState.color || pluginState.defaultColor,
            isDisabled: disabled || pluginState.disabled,
            pickerTitle: (0, $eB87j.messages).colorPickerTitle,
            showCustomPalette: true,
            showTextIcon: true,
            enableBorderLessStyle: true
        })
    });
});
module.exports["ToolbarType"] = $3cccdde471a746af$export$a5d11b3163e4b1a5;
module.exports["ToolbarCompanyHubTextColor"] = $3cccdde471a746af$export$803d4933f12f6ddc;

});

parcelRegister("eB87j", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $204e6db0a10d1a26$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    colorPickerTitle: {
        id: "company-hub-text-color.color-picker-dropdown.picker-title",
        defaultMessage: "Text Color"
    }
});
module.exports["messages"] = $204e6db0a10d1a26$export$defe85febe8b728c;

});

$parcel$global.rwr("aFBfl", () => { 
var $42omo = parcelRequire("42omo");


var $2FNjD = parcelRequire("2FNjD");


var $egy7N = parcelRequire("egy7N");


var $6dGgK = parcelRequire("6dGgK");


var $4FYDR = parcelRequire("4FYDR");


var $jTxSS = parcelRequire("jTxSS");


var $hnvzE = parcelRequire("hnvzE");


var $5QpZa = parcelRequire("5QpZa");


var $5nRL1 = parcelRequire("5nRL1");


var $1iSzD = parcelRequire("1iSzD");


var $lJlG6 = parcelRequire("lJlG6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3ay3Q = parcelRequire("3ay3Q");


var $aanDq = parcelRequire("aanDq");

var $hS38r = parcelRequire("hS38r");

function $7826f8c58773ce67$export$a311cb1baa7d2d62() {
    (0, $hS38r.resourceTimingBuffer).start();
}



var $hPcrh = parcelRequire("hPcrh");





var $04e9M = parcelRequire("04e9M");


var $9eE57 = parcelRequire("9eE57");


var $4VJDS = parcelRequire("4VJDS");


var $i7t6K = parcelRequire("i7t6K");


var $2c1Wz = parcelRequire("2c1Wz");

function $dc2c9e680a6dd356$var$findFiberNode(domNode) {
    if (!domNode) return undefined;
    const key = Object.keys(domNode).find((k)=>k.startsWith('__reactFiber$'));
    return key ? domNode[key] : undefined;
}
function $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) {
    let current = fiberNode;
    while(current){
        if (current.memoizedProps?.__boundaryMarker) return current.memoizedProps?.attribution ?? 'unknown';
        current = current.return;
    }
    return 'not-attributed';
}
function $dc2c9e680a6dd356$var$toQuerySelector(node) {
    const path = [];
    if (node instanceof HTMLElement) {
        if (node.tagName) path.push(node.tagName.toLowerCase());
        if (node.id) path.push(`#${node.id}`);
        if (node.className) path.push(`.${node.className.split(' ').join('.')}`);
        if (node.dataset) Object.entries(node.dataset).forEach(([key, value])=>{
            path.push(`[data-${key}=${value}]`);
        });
    }
    return path.join('');
}
const $dc2c9e680a6dd356$export$36b44777ebe5656d = (experienceName, clsAttributionConfig)=>{
    const layoutShiftMap = new Map();
    const shifts = (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].buffer;
    const includeEntries = clsAttributionConfig.includeEntries?.[experienceName] ?? false;
    shifts.forEach((shift)=>{
        shift.sources.forEach((source)=>{
            let hasInsideShift = false;
            let hasOutsideShift = false;
            if (source.previousRect.x !== source.currentRect.x || source.previousRect.y !== source.currentRect.y) hasOutsideShift = true;
            if (source.previousRect.width !== source.currentRect.width || source.previousRect.height !== source.currentRect.height) hasInsideShift = true;
            const getDebugEntry = ()=>({
                    shift: shift.value,
                    hasInsideShift: hasInsideShift,
                    hasOutsideShift: hasOutsideShift,
                    element: source.node ? $dc2c9e680a6dd356$var$toQuerySelector(source.node) : 'undefined'
                });
            const fiberNode = $dc2c9e680a6dd356$var$findFiberNode(source.node);
            const attribution = fiberNode ? $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) : 'nonReact';
            if (layoutShiftMap.has(attribution)) {
                const stats = layoutShiftMap.get(attribution);
                stats.totalShift += shift.value;
                if (includeEntries) stats.entries.push(getDebugEntry());
            } else layoutShiftMap.set(attribution, {
                totalShift: shift.value,
                entries: includeEntries ? [
                    getDebugEntry()
                ] : []
            });
        });
    });
    return Object.fromEntries(layoutShiftMap);
};


const $4f467cf502568ccb$export$2d8f8d64dc343d7b = ()=>{
    if (typeof window === 'undefined' || !window.__HYDRATABLE__) return undefined;
    return {
        successful: !window.__HYDRATION_ERRORS__?.length,
        warningCount: 0,
        minWarningComponentDepth: 0,
        maxWarningComponentDepth: 0
    };
};



var $5ZqQS = parcelRequire("5ZqQS");


var $6VdZc = parcelRequire("6VdZc");


var $8Lf0D = parcelRequire("8Lf0D");

var $jy3Cx = parcelRequire("jy3Cx");


var $5leFG = parcelRequire("5leFG");

const $2ba6133bff070823$export$8c5248f0cec8446d = new (0, $5leFG.EventBus)();


var $80c67148001d6fe8$var$_JSCacheRate;
class $80c67148001d6fe8$export$aca60c726e4e7838 {
    /**
   * Clear Cache
   *
   * Clears all existing cache entries
   */ static clearCache() {
        this.IDs.reset();
        this.Cache.clear();
    }
    /**
   * Compute Cache Rate
   *
   * Iterates the cache looking for the LRU cache compute
   * and creates a new compute based upon the results of
   * it (if it exists). If not, it'll compute cache rate
   * using a bottom-up iteration of loaded assets
   */ static computeCacheRate(time) {
        let lastKey = '';
        const entries = this.Cache.keys;
        const maxIndex = entries.length - 1;
        for(let i = maxIndex; i > -1; i--){
            const key = entries[i];
            const { time: stopTime } = this.Cache.get(key);
            if (time > stopTime) {
                lastKey = key;
                break;
            }
        }
        let newEntry;
        if (lastKey) newEntry = this.mergeFromLastKey(lastKey, time);
        else newEntry = this.iterateResources(time);
        const ID = $80c67148001d6fe8$export$aca60c726e4e7838.IDs.ID();
        $80c67148001d6fe8$export$aca60c726e4e7838.Cache.set(ID, {
            time: time,
            ...newEntry
        });
        return $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(ID);
    }
    /**
   * Merge From Last Key
   *
   * Combines the LRU cache rate with a cache rate being computed
   */ static mergeFromLastKey(key, time) {
        const { lastIndex: lastIndex, criticalPath: criticalPath } = $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(key);
        const { lastIndex: newIndex, criticalPath: newCriticalPath } = this.iterateResources(time, lastIndex + 1);
        return {
            lastIndex: newIndex,
            criticalPath: this.merge(criticalPath, newCriticalPath)
        };
    }
    /**
   * Iterate Resources
   *
   * Iterates performance resource timings given a time and from (index)
   * filter. While iterating, this method will accumulate the scripts
   * that have loaded prior to the input time and capture the last index
   * of the final script loaded within that scope
   */ static iterateResources(time, from = 0) {
        const criticalPath = this.criticalPath;
        const resources = window.performance.getEntriesByType('resource');
        const { length: length } = resources;
        let lastIndex = from;
        for(let i = lastIndex; i < length; i++){
            const entry = resources[i];
            if (entry.initiatorType !== 'script' || entry.responseEnd > time) continue;
            lastIndex = i;
            if (entry.transferSize) criticalPath.nonCachedSize += entry.encodedBodySize;
            else {
                criticalPath.cachedCount += 1;
                criticalPath.cachedSize += entry.encodedBodySize;
            }
            criticalPath.totalSize += entry.encodedBodySize;
            criticalPath.scripts.push({
                name: entry.name.split('/').pop() || '',
                start: entry.startTime,
                end: entry.responseEnd,
                size: entry.encodedBodySize
            });
        }
        return {
            criticalPath: criticalPath,
            lastIndex: lastIndex
        };
    }
    /**
   * Critical Path
   *
   * Returns an initialized `CriticalPath` object
   */ static get criticalPath() {
        return {
            scripts: [],
            totalSize: 0,
            cachedCount: 0,
            cachedSize: 0,
            nonCachedSize: 0
        };
    }
    /**
   * Merge
   *
   * Merges the properties of two critical path objects
   */ static merge(cachedCP, newCP) {
        return {
            scripts: cachedCP.scripts.concat(newCP.scripts),
            totalSize: cachedCP.totalSize + newCP.totalSize,
            cachedCount: cachedCP.cachedCount + newCP.cachedCount,
            cachedSize: cachedCP.cachedSize + newCP.cachedSize,
            nonCachedSize: cachedCP.nonCachedSize + newCP.nonCachedSize
        };
    }
}
$80c67148001d6fe8$var$_JSCacheRate = $80c67148001d6fe8$export$aca60c726e4e7838;
$80c67148001d6fe8$export$aca60c726e4e7838.IDs = new (0, $8Lf0D.AutoIncrementingID)();
$80c67148001d6fe8$export$aca60c726e4e7838.Cache = new (0, $jy3Cx.Cache)();
$80c67148001d6fe8$export$aca60c726e4e7838.Listener = (0, $2ba6133bff070823$export$8c5248f0cec8446d).on('page-transition', $80c67148001d6fe8$var$_JSCacheRate.clearCache.bind($80c67148001d6fe8$var$_JSCacheRate));


const $798e13e8b010d13b$export$2ae1dd61fa7d6fb4 = (stop)=>{
    const { criticalPath: { scripts: scripts, totalSize: totalSize, cachedCount: cachedCount, cachedSize: cachedSize, nonCachedSize: nonCachedSize } } = (0, $80c67148001d6fe8$export$aca60c726e4e7838).computeCacheRate(stop);
    return {
        cachedRate: cachedCount / scripts.length * 100,
        count: scripts.length,
        size: totalSize,
        cachedSize: cachedSize,
        nonCachedSize: nonCachedSize,
        sizeBasedCachedRate: cachedSize / (cachedSize + nonCachedSize)
    };
};


const $1f8015dad40e09ac$export$4a5a528f9e4c1e63 = ()=>window.jQuery?.fn?.jquery;


const $8476ac2738811490$export$30c543c9fd9ad97 = ({ stop: stop })=>{
    const customAttributes = {
        initial: (0, $6VdZc.isInitial)(),
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        jqVer: (0, $1f8015dad40e09ac$export$4a5a528f9e4c1e63)()
    };
    return customAttributes;
};


var $lqJ5I = parcelRequire("lqJ5I");

const $894ba807f7f34abc$export$3f2fb183b6cd13c4 = ({})=>{
    // Only track frontend calls, skip during SSR
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (typeof window === 'undefined') return {
        frontendTotalOperations: 0
    };
    const stats = (0, $lqJ5I.networkTracker).getStats();
    return {
        frontendTotalOperations: stats.totalOperations
    };
};


var $17wUi = parcelRequire("17wUi");

const $4c29a57cb1cefaed$var$isAssets = (x)=>{
    if (typeof x !== 'object' || !x) return false;
    for (const value of Object.values(x)){
        if (typeof value !== 'string') return false;
    }
    return true;
};
const $4c29a57cb1cefaed$var$scriptInitiator = {
    script: true,
    other: true,
    link: true
};
const $4c29a57cb1cefaed$var$CACHED_ASSETS_KEY = 'confluence.cachedAssets';
const $4c29a57cb1cefaed$var$criticalChunkPrefixes = {
    'query-preloader': true,
    'translations.en-US': true,
    runtime: true,
    atlaskit: true,
    afp: true,
    static: true,
    vendors: true,
    app: true
};
const $4c29a57cb1cefaed$var$getCachedAssets = ()=>{
    try {
        const assets = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem($4c29a57cb1cefaed$var$CACHED_ASSETS_KEY)) || {};
        if (!$4c29a57cb1cefaed$var$isAssets(assets)) return {};
        return assets;
    } catch (ex) {
        return {};
    }
};
const $4c29a57cb1cefaed$var$updateCachedAssets = (assets)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($4c29a57cb1cefaed$var$CACHED_ASSETS_KEY, JSON.stringify(assets));
    } catch (ex) {
    // NOOP
    }
};
const $4c29a57cb1cefaed$export$445ccb86da5ca9ca = (endTime)=>{
    const cachedChunks = $4c29a57cb1cefaed$var$getCachedAssets();
    const loadedChunks = {};
    const criticalChunks = {};
    let totalChunkCount = 0;
    performance.getEntriesByType('resource').forEach((entry)=>{
        const { initiatorType: initiatorType, responseEnd: responseEnd, duration: duration, name: name } = entry;
        // Discard non-scripts and scripts that were loaded after the end time
        if (!$4c29a57cb1cefaed$var$scriptInitiator[initiatorType] || responseEnd > endTime) return;
        const chunkName = name.split('/').pop();
        if (!chunkName) return;
        const chunkPrefix = chunkName.split('~').shift();
        if (!chunkPrefix) return;
        // Match loaded chunk name with cached chunk name for all critical chunks
        if ($4c29a57cb1cefaed$var$criticalChunkPrefixes[chunkPrefix]) {
            loadedChunks[chunkPrefix] = chunkName;
            criticalChunks[chunkPrefix] = {
                cached: cachedChunks[chunkPrefix] === chunkName,
                duration: duration
            };
        }
        totalChunkCount++;
    });
    $4c29a57cb1cefaed$var$updateCachedAssets(loadedChunks);
    return {
        criticalChunks: criticalChunks,
        totalChunkCount: totalChunkCount
    };
};



var $gpK3n = parcelRequire("gpK3n");






const $ac2afaf945b706af$var$getElementSelector = (element)=>{
    const selector = `${element.tagName.toLowerCase()}.${element.className?.split(' ').join('.')}`;
    if (element.dataset?.testid) return `${selector}[data-testid="${element.dataset?.testid}"]`;
    return selector;
};
const $ac2afaf945b706af$export$2980a1865b8e55dd = (hydrationErrors)=>{
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $4VJDS.default).getString('confluence_hydration_error_logging', '{}'));
    } catch (error) {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    return hydrationErrors.reduce((accumulator, error)=>{
        if (!error.type || !error.msg) return accumulator;
        if (!accumulator[error.type]) accumulator[error.type] = '';
        if (!accumulator.selectors) accumulator.selectors = '';
        // Log selectors for mismatched hydration errors. The presense of parentNode or parent
        // depend on actual hydration error / patch used.
        const finalParent = error.parent || error.parentNode;
        if (loggingConfig.selectors && (finalParent || error.child)) {
            const parent = finalParent ? $ac2afaf945b706af$var$getElementSelector(finalParent) : 'n/a';
            const child = error.child ? $ac2afaf945b706af$var$getElementSelector(error.child) : 'n/a';
            accumulator.selectors += `${parent}->${child}; `;
        }
        if (loggingConfig.errors) accumulator[error.type] += (accumulator[error.type] ? ' ; ' : '') + error.msg;
        // Add error stack
        if (loggingConfig.stack && error.stack) {
            if (!accumulator.stack) accumulator.stack = '';
            accumulator.stack += `Stack: ${error.stack} \n`;
        }
        return accumulator;
    }, {});
};

const $58d4f470662e1918$export$494b6359b6a45bfd = ()=>{
    const heightChanges = window?.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__;
    const result = {
        initialHeight: window?.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0,
        changes: heightChanges?.length || 0
    };
    if (heightChanges?.length) result.finalHeight = heightChanges[heightChanges.length - 1];
    return result;
};

const $feab3ea7dc0c8aa0$export$b471d97e795847e1 = (resourceTimings)=>{
    for (const entry of resourceTimings){
        if (entry.initiatorType !== 'script') continue;
        // As of Feb 2021, `nextHopProtocol` is only supported by 73% of browsers
        // https://caniuse.com/mdn-api_performanceresourcetiming_nexthopprotocol
        if (entry?.nextHopProtocol) return entry.nextHopProtocol;
    }
    return 'unknown';
};

const $8b39c089fbdae2d5$export$96934690d8345a62 = (obj)=>{
    if (typeof obj !== 'object' || !obj) return {};
    const recursivelyBuildCustomValues = (obj)=>{
        const customValues = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (Array.isArray(value)) customValues[key] = value.map((e)=>JSON.stringify(e)).join(',');
            else if (typeof value === 'object' && value) {
                const nestedValues = recursivelyBuildCustomValues(value);
                Object.entries(nestedValues).forEach(([nestedKey, nestedValue])=>{
                    customValues[`${key}:${nestedKey}`] = nestedValue;
                });
            } else {
                if (typeof value === 'number') customValues[key] = Math.round(value);
                else if (typeof value === 'boolean') customValues[key] = value;
                else customValues[key] = String(value);
            }
        });
        return customValues;
    };
    return recursivelyBuildCustomValues(obj);
};



function $31b0fb0fb1951a4c$var$limitTop10(obj) {
    return Object.fromEntries(Object.entries(obj).sort((a, b)=>b[1] - a[1]).slice(0, 10));
}
const $31b0fb0fb1951a4c$export$7908ff149a3cbadd = ({ stop: stop })=>{
    const customAttributes = {
        transitionId: (0, $6VdZc.browserMetricsState).transitionId,
        // HTTP protocol used to fetch resources
        // Use multiple domains for http/1.1 users
        // Set in packages/confluence-frontend-server/templates/generator.js
        domainSharding: Boolean(window.__GET_CC_ASSET_URL),
        // HTTP protocol used to fetch resources
        httpProtocol: (0, $feab3ea7dc0c8aa0$export$b471d97e795847e1)(performance.getEntriesByType('resource')),
        // Add the critical path JS assets size stats
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        // Send stats on expensive queries and unnecessary watches
        apolloDiffStoreStats: (0, $8b39c089fbdae2d5$export$96934690d8345a62)($31b0fb0fb1951a4c$var$limitTop10(window?.__APOLLO_STATS__?.diffStore || {}))
    };
    Object.entries((0, $gpK3n.collectDurationFromPerfMarkers)('CFP-63.')).forEach(([fieldName, value])=>{
        customAttributes[`cfp63Durations:${fieldName}`] = value;
    });
    if ((0, $6VdZc.browserMetricsState).transitionId === 0) {
        const navigationTimings = window.performance.getEntriesByType('navigation');
        if (navigationTimings.length) {
            // TypeScript isn't returning the proper type for this, so some
            // casting here
            const firstTiming = navigationTimings[0];
            if (firstTiming.transferSize != null) customAttributes.pageLoadedFromCache = firstTiming.transferSize === 0;
        }
        // Record the current version of jQuery
        customAttributes.jqVer = window.jQuery?.fn?.jquery;
        // Record if page is rendered by React SSR service
        customAttributes.ssr = Boolean(window.__SSR_RENDERED__);
        customAttributes.ssrTraceId = window.__SSR_TRACE_ID__ ?? '';
        // only send ssr macro metrics if there is at least one macro on the SSRd page
        if (window?.__SSR_MACROS_INFO__) customAttributes.ssrMacrosInfo = window.__SSR_MACROS_INFO__;
        // Record user clicks and intent to click on SSR placeholder elements
        customAttributes.ssrInteractions = window?.__SSR_INTERACTIONS__ || {};
        // @ts-ignore `__SSR_INTERACTIONS_DURATIONS__` maintains an array of numbers, but browser-metrics doesn't really accept arrays. Might make sense to comma-join the values
        customAttributes.ssrInteractionsDurations = window?.__SSR_INTERACTIONS_DURATIONS__ || {};
        customAttributes.ssrQueryTimeouts = window?.__SSR_QUERY_TIMEOUTS__ || {};
        customAttributes.ssrPartialSuccess = window?.__SSR_PARTIAL_SUCCESS__ || {};
        if (window?.__SSR_STREAM_END__) customAttributes.ssrStreamEnd = window.__SSR_STREAM_END__;
        customAttributes.reactStreaming = window.__SSR_REACT_STREAMING__ || false;
        // Record loadable ids that timed out
        customAttributes.loadableTimeouts = Array.from(new Set(window?.__LOADABLE_TIMEOUTS__ || [])).join(',');
        if (window?.__HYDRATION_ERRORS__) customAttributes.hydrationErrors = (0, $ac2afaf945b706af$export$2980a1865b8e55dd)(window.__HYDRATION_ERRORS__);
        customAttributes.hydratable = window?.__HYDRATABLE__ || false;
        customAttributes.hydrationFailed = window?.__HYDRATION_FAILED__ || false;
        // Record the number of SSRed elements
        customAttributes.totalSSRedElements = window?.__TOTAL_SSR_ELEMENTS__ || 0;
        // Calculates which query is the long pole, as well as its duration
        customAttributes.longPoleQuery = window?.__SSR_LONG_POLE_QUERY__ || {};
        // Node counts from AK renderer, available in fabric only
        customAttributes.rendererNodesCount = window?.__RENDERER_NODES_COUNT__ || {};
        customAttributes.remoteLocalStorage = window?.__REMOTE_LOCAL_STORAGE__?.length || 0;
        customAttributes.atlGeneralHeightChanges = (0, $8b39c089fbdae2d5$export$96934690d8345a62)((0, $58d4f470662e1918$export$494b6359b6a45bfd)());
        // Add the caching status of each asset
        const cacheStatus = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cacheStatus: (0, $4c29a57cb1cefaed$export$445ccb86da5ca9ca)(stop)
        });
        for (const [key, value] of Object.entries(cacheStatus))customAttributes[key] = value;
    }
    return customAttributes;
};

const $47229cc534a9628f$export$79c58f8fef22ebf2 = ()=>{
    const customAttributes = {
        ssrRegion: window.__SSR_REGION__ ?? ''
    };
    return customAttributes;
};



var $eSuZj = parcelRequire("eSuZj");

const $18160efac3c2d8a9$export$8f5840779a8ebb97 = (interaction, otherMetadataFromSessionData)=>{
    const buildInfoData = (0, $eSuZj.getBuildInfo)();
    const buildInfo = {};
    if (buildInfoData) Object.keys(buildInfoData).forEach((item)=>{
        const newKey = `buildInfo:${item}`;
        buildInfo[newKey] = buildInfoData[item];
    });
    const data = {
        ...(0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $8476ac2738811490$export$30c543c9fd9ad97)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $47229cc534a9628f$export$79c58f8fef22ebf2)(),
        ...buildInfo,
        ...otherMetadataFromSessionData
    };
    return {
        confluence: data
    };
};


const $65f6d9e9d3e9996f$export$3def7672244bab0c = ()=>{
    const ssrTTRMark = performance?.getEntriesByName('CFP-63.ssr-ttr');
    if (!ssrTTRMark || !ssrTTRMark[0]) return undefined;
    // rounded to the nearest integer as the VC component log only uses integers as keys
    return Math.round(ssrTTRMark[0].startTime);
};
const $65f6d9e9d3e9996f$export$bf7408e83532dcd0 = ()=>{
    if (!window.__SSR_MEASURES__) return [];
    const ssrTimings = Object.keys(window.__SSR_MEASURES__).map((key)=>{
        return {
            label: key,
            data: window.__SSR_MEASURES__[key]
        };
    });
    return ssrTimings || [];
};



var $lMdlY = parcelRequire("lMdlY");

function $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) {
    return !!traceId && /^[a-z0-9]+$/i.test(traceId) && traceId.length >= 16;
}
function $9d8d828ea9fa0be5$export$47cd5ebc723ead8d() {
    const traceId = window.__SSR_TRACE_ID__;
    const traceSampled = window.__SSR_TRACE_SAMPLED__;
    // Only enable trace propagation if the trace is sampled.
    // Keep per-request unique traceIds for prod traffic until we have the x-request-id solution.
    // See: https://hello.atlassian.net/wiki/spaces/~71202065d425fcbfb345c9a5639940cc3845bb/pages/4187050054/Trace+Propagation+Across+an+Experience
    if (!traceSampled) return;
    const validTraceId = $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) ? traceId : undefined;
    const validSpanId = validTraceId ? validTraceId.substring(validTraceId.length - 16) : undefined;
    // If the traceId is invalid, we ignore it and don't set the trace context.
    // This would fallback to default behavior where trace context is not propagated.
    if (validTraceId && validSpanId) (0, $lMdlY.setActiveTrace)(validTraceId, validSpanId, '' /* trace type param is unused */ );
}





const $7d85b53d694de3c0$export$5fc9317dcf7889c3 = {
    sanitiseEndpoints: (url)=>url,
    mapResources: (url)=>url,
    hasTimingHeaders: (url)=>url.includes('graphql')
};


const $30ba73f8286a8f5a$export$69f5225124bf14a6 = {
    typingMethod: 'timeout',
    kind: {
        hover: 0,
        legacy: 0,
        typing: 0,
        press: 1,
        page_load: 1,
        transition: 1,
        generic: 0
    },
    rates: {
        unknown: 1000
    },
    removeInteractionsUFOPrefixes: true,
    enableEditorLnvHandler: true,
    autoGeneratedRate: 1000,
    rules: [],
    awaitBM3TTI: [],
    ufoNameOverrides: {},
    killswitch: [],
    segmentPrefix: 'ufo-',
    enabled: true,
    doNotAbortActivePressInteraction: [],
    doNotAbortActivePressInteractionOnTransition: [],
    enableCompleteUsingDoubleRAF: true,
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    namePrefix: 'ufo-',
    removePageSegmentsUFOPrefixes: false
};
const $30ba73f8286a8f5a$var$getConfig = (configName)=>{
    try {
        return JSON.parse((0, $4VJDS.default).getString(configName, ''));
    } catch (error) {
        // TODO: AFO-4167: Change the fallback to be `{}` once we have a stable config for FedRamp environment
        return $30ba73f8286a8f5a$export$69f5225124bf14a6;
    }
};
function $30ba73f8286a8f5a$var$runConfigureSsrTiming() {
    (0, $hPcrh.configure)({
        getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
        // from confluence/next/packages/browser-metrics/src/initializeBrowserMetrics.ts
        // TODO: add correct functions to `getTimings` and `getFeatureFlags`
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $30ba73f8286a8f5a$export$6381c51f97ce9880({ shard: shard, cloudId: cloudId }) {
    const config = (0, $9wGTI.fg)('ufo-use-statsig-config-confluence-new') ? $30ba73f8286a8f5a$var$getConfig('confluence_ufo_config') : $30ba73f8286a8f5a$export$69f5225124bf14a6;
    if (!config?.enabled) return;
    if ((0, $9wGTI.fg)('confluence_add_ufo_resource_timings')) {
        (0, $aanDq.configure)((0, $7d85b53d694de3c0$export$5fc9317dcf7889c3));
        (0, $7826f8c58773ce67$export$a311cb1baa7d2d62)();
    }
    $30ba73f8286a8f5a$var$runConfigureSsrTiming();
    (0, $9d8d828ea9fa0be5$export$47cd5ebc723ead8d)();
    const perfPushExperienceRates = {
        'view-page': 1,
        'edit-page': 1,
        'live-edit': 1,
        'space-overview': 1,
        'confluence-home': 1,
        'advanced-search': 1,
        'unified-search': 1
    };
    (0, $3ay3Q.init)((0, $04e9M.getAnalyticsWebClient)(), {
        postInteractionLog: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        experimentalInteractionMetrics: {
            enabled: (0, $9wGTI.fg)('ufo-enable-experimental-holds-confluence'),
            rates: perfPushExperienceRates
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        enableSegmentHighlighting: false,
        enableAdditionalPerformanceMarks: false,
        shouldCalculateLighthouseMetricsFromTTAI: true,
        manuallyTrackReactProfilerMounts: true,
        product: 'confluence',
        region: shard || 'unknown',
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            selectorConfig: {
                id: false,
                role: false,
                className: true,
                testId: true
            },
            devToolsEnabled: (0, $4VJDS.default).isKillSwitchOn('confluence_enable_ttvc_devtool'),
            stopVCAtInteractionFinish: (0, $9wGTI.fg)('stop_vc_at_interaction_finish'),
            enabledVCRevisions: {
                all: (0, $6mKj3.expVal)('confluence_frontend_v2_removal', 'isEnabled', false) ? [
                    'fy25.03'
                ] : [
                    'fy25.02',
                    'fy25.03'
                ]
            },
            includeSSRInV3: (0, $9wGTI.fg)('confluence_include_ssr_in_vc_v3'),
            includeSSRRatio: (0, $9wGTI.fg)('confluence_vc_v3_ssr_ratio')
        },
        getReactHydrationStats: (0, $9wGTI.fg)('confluence_frontend_enable_hydration_stats') ? (0, $4f467cf502568ccb$export$2d8f8d64dc343d7b) : undefined,
        ...config,
        minorInteractions: [
            'space-navigation-hover',
            'hover-page-card'
        ],
        ssr: {
            getSSRDoneTime: $65f6d9e9d3e9996f$export$3def7672244bab0c,
            getSSRTimings: $65f6d9e9d3e9996f$export$bf7408e83532dcd0
        },
        additionalPayloadData: (interaction)=>(0, $18160efac3c2d8a9$export$8f5840779a8ebb97)(interaction, {
                cloudId: cloudId,
                isShardPreProd: shard ? shard.startsWith('conf-prod-us-preprod') : false,
                layoutShiftWithAttribution: (0, $dc2c9e680a6dd356$export$36b44777ebe5656d)(interaction.ufoName, $30ba73f8286a8f5a$var$getConfig('confluence_cls_attribution_config'))
            }),
        extraSearchPageInteraction: {
            enabled: (0, $9wGTI.fg)('react_ufo_unified_search_ignoring_sain_metric'),
            searchPageMetricName: 'unified_search'
        }
    });
}
// UFO library emits mutation debug data once it is available. Debug data includes all mutations listed in the UFO dev tools,
// as well as includes a UFO traceId that can be linked to UFO (BM) page load event
// https://hello.atlassian.net/wiki/spaces/APD/pages/5398802024/RUNBOOK+Emitting+and+receiving+TTVC+debug+data+from+UFO
if (typeof window !== 'undefined') // @ts-ignore
window.__on_ufo_vc_debug_data_ready = function(data) {
    // only send debug data for clean V3 events
    if (data?.revision === 'fy25.03' && data?.isClean && (0, $9wGTI.fg)('confluence_emit_v3_debug_data')) {
        const payload = {
            source: 'confluenceRoot',
            action: 'emitted',
            actionSubject: 'debugDataV3',
            attributes: {
                ...data
            },
            eventType: 'operational'
        };
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
            analyticsClient.sendOperationalEvent(payload);
        });
    }
    const apolloStats = window['__APOLLO_STATS__'];
    if (apolloStats?.diffStore) {
        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
        const entries = Object.entries(apolloStats?.diffStore).sort((a, b)=>b[1] - a[1]).slice(0, 10);
        for (const [query, value] of entries)// cc_fe_telemetry_apolloDiffStore in SFX
        monitoringClient.gauge(`apolloDiffStore`, value, [
            `query:${query}`
        ]);
    }
    // This is to inform extrnal tools/tests that page finished loading and "performance measured" events were emitted.
    // @ts-ignore
    window.__TTVC_READY__ = true;
};



var $2v1PW = parcelRequire("2v1PW");




function $e8bac4b2464d29b3$export$77f9905a9b9e760d(_sessionData) {
    (0, $2v1PW.init)({
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        experiences: {
            'edit-page': {
                enabled: true
            },
            'live-edit': {
                enabled: true
            }
        }
    });
}






var $c6GJD = parcelRequire("c6GJD");


var $3kTfj = parcelRequire("3kTfj");














var $6vg9V = parcelRequire("6vg9V");


var $7W8i8 = parcelRequire("7W8i8");


var $hpjl4 = parcelRequire("hpjl4");

const $b48399af2cf0b1aa$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hpjl4.JS_LOAD_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hpjl4.JS_LOAD_END))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_END))),
            type: 'end'
        };
        return null;
    }
};



var $j4jXg = parcelRequire("j4jXg");




// used for page-load and page-segment-load events
const $a7aad5d0a1d87072$export$eb13033bc77c7e96 = [
    'confluence.ssr.page-statuses',
    'confluence_ssr_enable_tesseract_stream_endpoint',
    'confluence_use_canary',
    'confluence_use_parcel',
    'confluence_react_streaming',
    'confluence_preload_forge_viewport_heights',
    'confluence_frontend_vc_observer_initialization',
    'confluence_frontend_remove_comments_placeholder',
    'enable_loadable_placeholder_for_legacy_macros',
    'edition_awareness_standard_upsell_confluence_ab',
    'edition_awareness_standard_upsell_confluence_ab_fg',
    'confluence_frontend_content_body_container',
    'platform-ssr-table-resize',
    'edit-team-connection-from-confluence',
    'confluence_frontend_ssr_autohighlights',
    'confluence_frontend_content_wrapper',
    'confluence_frontend_exclude_page_properties_vc',
    'confluence_preload_smartlink_live_page',
    'content_early_connect_iframe_initialization',
    'confluence_preload_pagetree_space_transition',
    'confluence_frontend_fix_smart_link_flickering',
    'confluence_emit_v3_debug_data',
    'nav4_confluence_global_links',
    'confluence_frontend_nav_spotlight_press_tracing',
    'confluence_use_atlaspack',
    'confluence_use_atlaspack_variant_1',
    'confluence_use_atlaspack_variant_2',
    'stop_watching_more_queries',
    'platform_ufo_exclude_3p_extensions_from_ttvc',
    'confluence_frontend_cookies_show_banner_ssr',
    'confluence_frontend_v2_removal',
    'confluence_frontend_iframe_exclusion',
    'confluence_frontend_statlas_redirect',
    'confluence_frontend_cookie_banner_new_min_height',
    'confluence_ssr_use_fallback_token',
    'confluence_frontend_enable_react_dom_context_patch',
    'confluence_ssr_preload_fallback_token',
    'memoize_prefiltered_extensions',
    'fix_preload_share_and_restrict_query_chaining_',
    'confluence_exclude_children_macro_from_blocklist',
    'twcg-206_confluence_upgrade_permanent_free_fg',
    'confluence_selective_hydrate_eop_recommendations',
    'confluence_use_react-compiler'
];
const $a7aad5d0a1d87072$export$e669174961337a38 = [];



var $78QFu = parcelRequire("78QFu");

const $105e628ab69b7692$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const clsData = {
        score: 0,
        nodeCounts: {}
    };
    const allLayoutShifts = buffer.getAll();
    const layoutShifts = allLayoutShifts.filter(// Filter for layoutShifts within start and stop time and if entry had no recent user input (which can cause CLS)
    (entry)=>entry.startTime >= start && entry.startTime <= stop && !entry.hadRecentInput);
    const sessionWindows = [];
    let currentWindow = null;
    // Record CLS offenderes by node type
    layoutShifts.forEach((layoutShift)=>{
        layoutShift.sources.forEach((source)=>{
            const { node: node } = source;
            const nodeKey = `${node?.localName || '-'}(:)${node?.className || '-'}`;
            const count = clsData.nodeCounts[nodeKey];
            if (count > 0) clsData.nodeCounts[nodeKey] += 1;
            else clsData.nodeCounts[nodeKey] = 1;
        });
    });
    // Group layout shifts into session windows and calculate score
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric rounded to 4 decimal places
    clsData.score = Math.round(maxScore * 10000) / 10000;
    return clsData;
};


const $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $f69af1ee3d00be57$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    // and overlap with the start and stop window in any way
    (entry)=>entry.startTime <= stop && entry.duration > $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // accumulate observed tbt even when the entry's duration is outside the stop window
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION;
        // accumulate total tbt within start and stop window
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });


const $35573fd923792093$export$f878c419d6dfad3e = 10;
const $35573fd923792093$var$getEstimatedP98LongestInteraction = (interactionEvents)=>{
    const sortedInteractions = [
        ...interactionEvents
    ].sort((a, b)=>b.duration - a.duration);
    sortedInteractions.splice($35573fd923792093$export$f878c419d6dfad3e);
    // If we have an usually high number of interactions,
    // ignore the longest interaction and take the next one.
    // https://web.dev/articles/inp#what-is-inp -> "Details on how INP is calculated"
    const p98Index = Math.min(sortedInteractions.length - 1, Math.floor(interactionEvents.length / 50));
    return {
        p98: sortedInteractions[p98Index],
        interactionCount: sortedInteractions.length
    };
};
const $35573fd923792093$export$6693a9916ea977ef = (start, stop, buffer)=>{
    const inpData = {
        score: 0,
        interactionCounts: {}
    };
    const allEvents = buffer.getAll();
    const interactionEvents = allEvents.filter((entry)=>entry.startTime >= start && entry.startTime <= stop && entry.entryType !== 'first-input' && //@ts-ignore for some reason our Typecheck says this property doesn't exist but its in the reference https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEventTiming
        entry.interactionId);
    if (interactionEvents.length) {
        const { p98: p98, interactionCount: interactionCount } = $35573fd923792093$var$getEstimatedP98LongestInteraction(interactionEvents);
        inpData.score = p98.duration;
        inpData.interactionCounts = interactionCount;
    }
    return inpData;
};








// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 




const $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $6947188617eea69c$export$b7f047fd73089148 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    (entry)=>entry.duration > $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((longTaskTiming, entry)=>{
        longTaskTiming += entry.duration - $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION;
        return longTaskTiming;
    }, 0);






var $eDAGu = parcelRequire("eDAGu");

const $21a76cadeda71c1e$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $21a76cadeda71c1e$export$b46cecdf698e4bb5 = async ({ start: start, stop: stop })=>{
    // PerformanceObserver is not deterministic in reporting entries, so a 500ms delay is needed
    // 500ms was tested in Jira and it captured enough data without causing a volume drop in reported events
    await $21a76cadeda71c1e$export$1391212d75b2ee65(500);
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    const longTaskTiming = (0, $6947188617eea69c$export$b7f047fd73089148)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const metrics = {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls.score,
        'metric:clsNodeCounts': cls.nodeCounts,
        'metric:longTaskTiming': Math.round(longTaskTiming)
    };
    return metrics;
};


const $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS = 8000;
const $834cc9c1e99eabd0$export$d4724968c3d7ea5 = async ({ start: start, stop: stop })=>{
    const webVitalsAttributes = {
        uuid: (0, $78QFu.getUniquePageLoadId)().uuid ?? ''
    };
    // wait for 8 seconds to calculate CLS to account for macros causing page layout shifts
    await (0, $21a76cadeda71c1e$export$1391212d75b2ee65)($834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS);
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    // for slow pages, TTI is marked too early which causes TBT numbers to be inaccurate so we extend the stop time
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const inp = (0, $35573fd923792093$export$6693a9916ea977ef)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event]);
    webVitalsAttributes['metric:inpForInitialLoad'] = inp.score;
    webVitalsAttributes['metric:clsForInitialLoad'] = cls.score;
    webVitalsAttributes['metric:clsOffendersForInitialLoad'] = cls.nodeCounts;
    webVitalsAttributes['metric:tbtForInitialLoad'] = Math.round(tbt.total); // sum of blocking time for long tasks within the 'start' and 'stop' time
    return webVitalsAttributes;
};





const $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d = (sessionData)=>{
    const { cloudId: cloudId, environment: environment, shard: shard } = sessionData;
    const plugins = [];
    plugins.push((0, $21a76cadeda71c1e$export$b46cecdf698e4bb5));
    /**
	 * https://product-fabric.atlassian.net/browse/CCP-1320
	 * Remove unused attributes in page-segment-load event
	 */ const buildInfo = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        buildInfo: (0, $eSuZj.getBuildInfo)()
    });
    /**
	 * Data to be added to all events.
	 */ const allEventConfig = {
        custom: (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cloudId: cloudId,
            environment: environment,
            shard: shard,
            ssr: Boolean(window.__SSR_RENDERED__)
        }),
        featureFlags: (0, $a7aad5d0a1d87072$export$e669174961337a38),
        sfxEvents: {
            activeTab: (0, $j4jXg.PageVisibleFields).pageVisibleState
        },
        plugins: plugins
    };
    /**
	 * Data to be added to only page-load events.
	 */ const pageLoadEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2),
            (0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    /**
	 * Data to be added to only custom events.
	 */ const pageSegmentLoadEventConfig = {
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-segment-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96),
        enableBundleEvalTimings: false
    };
    const customEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97)
        ]
    };
    const webVitalsConfig = {
        custom: buildInfo,
        enabled: true,
        plugins: [
            (0, $834cc9c1e99eabd0$export$d4724968c3d7ea5)
        ],
        // Undefined timeout defaults to 30000ms, increasing timeout here on Cypress tests to prevent flakiness.
        timeout: window?.Cypress ? undefined : 10000,
        ttciEnabled: false,
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    return {
        all: allEventConfig,
        [(0, $j4jXg.BMEventsType).PAGE_LOAD]: pageLoadEventConfig,
        [(0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD]: pageSegmentLoadEventConfig,
        [(0, $j4jXg.BMEventsType).CUSTOM]: customEventConfig,
        [(0, $j4jXg.BMEventsType).WEB_VITALS]: webVitalsConfig
    };
};





let $ae045ed661bc53ec$var$isBrowserMetricsInitialized = false;
const $ae045ed661bc53ec$var$logger = (0, $7W8i8.getLogger)('initializeBrowserMetrics');
const $ae045ed661bc53ec$var$criticalAssetsList = [
    'app',
    'atl',
    'runtime',
    'vendors',
    'ssr-scripts',
    'stable_vendors',
    'query-preloader',
    'browser-not-supported'
];
function $ae045ed661bc53ec$var$mapResources(url) {
    return $ae045ed661bc53ec$var$criticalAssetsList.find((asset)=>url.includes(`/${asset}.`)) || 'ignored';
}

const $ae045ed661bc53ec$export$efcab8bd082cbc1f = (sessionData)=>{
    if (!$ae045ed661bc53ec$var$isBrowserMetricsInitialized) {
        const { shard: shard } = sessionData;
        const getAnalyticsWebClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const product = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence';
        (parcelRequire("5j7rq")).then((ufo)=>ufo.setup(sessionData, getAnalyticsWebClientPromise)).catch((error)=>{
            $ae045ed661bc53ec$var$logger.error`Fail to import UFO client: ${error}`;
        });
        (0, $eDAGu.startLightHouseObservers)();
        (0, $3kTfj.browserMetrics).init({
            info: {
                app: {
                    framework: {
                        name: 'react',
                        version: (0, $42omo.version)
                    },
                    version: {
                        web: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                        ssr: window.__SSR_BUILD__
                    }
                },
                hostname: window.location.hostname,
                product: product,
                region: shard
            },
            plugins: {
                featureFlags: {
                    client: Promise.resolve({
                        getValue: (featureFlagKey)=>{
                            // Using `FeatureGates.checkGate` here to avoid triggering exposure tracking
                            // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
                            return (0, $c6GJD.default).checkGate(featureFlagKey);
                        }
                    })
                },
                resourceTimings: {
                    mapResources: $ae045ed661bc53ec$var$mapResources,
                    // Not interested in fetch requests as we have already marked wf/
                    sanitiseEndpoints: ()=>'ignored'
                },
                bundleEvalTimings: $b48399af2cf0b1aa$export$1a2bb347935fc536
            },
            endpoints: {
                eventPipelineClient: getAnalyticsWebClientPromise,
                metalClient: (0, $6vg9V.getMetalClient)()
            },
            events: (0, $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d)(sessionData),
            ssr: {
                getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
                getTimings: ()=>window.__SSR_MEASURES__ || {}
            },
            enableReactUFOTracker: true
        });
        $ae045ed661bc53ec$var$isBrowserMetricsInitialized = true;
    }
};



var $KcDWk = parcelRequire("KcDWk");


var $iC5L0 = parcelRequire("iC5L0");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ezH4I = parcelRequire("ezH4I");

var $3GQl6 = parcelRequire("3GQl6");


var $hZpML = parcelRequire("hZpML");





var $cMvQV = parcelRequire("cMvQV");


var $9j59h = parcelRequire("9j59h");




var $lTjel = parcelRequire("lTjel");









/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 


const $db1172108b431747$export$bc237d627614fc48 = `!function(e,t){const n=t.__SSR_INTERACTIONS__={},i=t.__SSR_INTERACTIONS_DURATIONS__={},o=t.__SSR_EVENT_LISTENERS__=[];Array.from(e.getElementsByClassName("ssrMouseEvent")).forEach((t=>{t.previousSibling&&((t,s)=>{if(!t||!s)return;const r=e=>{if(!e)return!1;if(e.disabled)return!0;let t=!1;for(let n=0;n<e.childNodes.length;n++)if(r(e.childNodes[n])){t=!0;break}return t};if(r(t)){var c;const n=e.createElement("div");n.style.cssText="display: inline-block; position: relative;",n.setAttribute("data-testid","".concat(s,"_CLICK_CONTAINER"));const i=e.createElement("div");i.style.cssText="content: ''; position: absolute; top: 0; left: 0; bottom: 0; right: 0;",i.setAttribute("data-testid","".concat(s,"_CLICK_AREA")),null===(c=t.parentElement)||void 0===c||c.replaceChild(n,t),n.append(t),n.append(i),t=i}const a=e=>{n[e]=!0,i[e]=[...i[e]||[],performance.now()]};let l,d=!1;const u=()=>{a("".concat(s,"_CLICK"))},_=()=>{d=!0,l=setTimeout((function(){d&&(a("".concat(s,"_HOVER")),d=!1)}),100)},E=()=>{l&&clearTimeout(l),d=!1};t.addEventListener("click",u,!0),t.addEventListener("mouseenter",_),t.addEventListener("mouseleave",E),o.push([t,"click",u,!0]),o.push([t,"mouseenter",_,void 0]),o.push([t,"mouseleave",E,void 0])})(t.previousSibling,t.value)}))}(document,window);`;


const $c07037197fae7cb7$export$a6f691eaa46471c3 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $db1172108b431747$export$bc237d627614fc48)}}`
        }
    });
};








const $ab36569cbfed18a7$export$857c9d19bfa05cb5 = ({})=>{
    // If there are no comments to SSR don't run scripts
    if (!window.__SSR_INLINE_COMMENT_MARKS__ || window.__SSR_INLINE_COMMENT_MARKS__ && window.__SSR_INLINE_COMMENT_MARKS__.length < 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "inline-comments-script",
        "data-testid": "inline-comments-script",
        "data-marks": window.__SSR_INLINE_COMMENT_MARKS__,
        "data-focused": window.__SSR_FOCUSED_INLINE_COMMENTS__
    });
};


const $2eff8a40a60fa79f$export$708921e5c63e07ae = ({})=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab36569cbfed18a7$export$857c9d19bfa05cb5), null);
};








function $a6e2c333ce8dee1c$export$d2cb5cf8969d339e() {
    const script = `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.start");` + // Accessing clientHeight causes the browser to perform a synchronous layout recalculation.
    // While this doesn't directly trigger a "paint" operation, it increases the likelihood of one
    // occurring shortly afterward. This means it is less likely that users will see a partially
    // painted screen while the browser processes imported JavaScript modules.
    `window.document.documentElement.clientHeight;` + `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.end")`;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: script
        }
    });
}


const $8714b2bec379cfae$export$bd148a921cde8da1 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6e2c333ce8dee1c$export$d2cb5cf8969d339e), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c07037197fae7cb7$export$a6f691eaa46471c3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2eff8a40a60fa79f$export$708921e5c63e07ae), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.end`), !window.__SSR_REACT_STREAMING__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            // Suppress error when performance API failed.
            // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
            // That's why wrap with try catch statement.
            __html: 'if(window["__SSR_RENDERED__"]){try{window.performance.mark("CFP-63.ssr-ttr");window.performance.measure("browser-metric:fmp",undefined,"CFP-63.ssr-ttr")}catch(e){}}'
        }
    }));
};







/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 



var $dh538 = parcelRequire("dh538");


var $a9dFP = parcelRequire("a9dFP");


var $ajqJ5 = parcelRequire("ajqJ5");

/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $1f244cc9b266328f$var$getSSRAutoScript = (colorMode, // TODO: This should be marked as required once safe to roll out.
contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $ajqJ5.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $a9dFP.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $dh538.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $ajqJ5.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $a9dFP.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $1f244cc9b266328f$export$2e2bcd8739ae039 = $1f244cc9b266328f$var$getSSRAutoScript;


var $hY0xh = parcelRequire("hY0xh");

var $geGFh = parcelRequire("geGFh");


var $58u2L = parcelRequire("58u2L");

class $60061fec709c0fa4$export$f9bc2ffe605f0ec0 {
    setThemeStateBasedOnSavedThemeState(theme) {
        // If theme is undefined, no reason to set that in themeState as it's not actually a theme (just Original)
        if (theme) this.themeState = {
            ...this.getThemeState(),
            ...theme,
            typography: 'typography'
        };
    }
    getThemeState() {
        return this.themeState;
    }
    async getThemeStylesScript() {
        // Generates an array of styles
        if (this.getThemeState().colorMode) {
            const modifiedThemeState = {
                ...this.getThemeState(),
                typography: 'typography'
            };
            const themeStyles = await (0, $geGFh.default)(modifiedThemeState);
            // Add a stylesheet for each theme being used
            return themeStyles.map((theme)=>{
                const attributes = Object.entries(theme.attrs).map(([key, value])=>`${key}="${value}"`);
                return `<style ${attributes}>${theme.css}</style>`;
            }).join('');
        } else return '';
    }
    getSSRAutoColorModeScript() {
        // Creates and returns the script used to set the html attributes if the user choose 'auto'
        const currentColorMode = this.getThemeState().colorMode;
        if (currentColorMode === 'auto') {
            const nonceValue = window.__SSR_NONCE_VALUE__;
            const scriptContent = (0, $1f244cc9b266328f$export$2e2bcd8739ae039)(currentColorMode);
            return nonceValue !== undefined ? `<script nonce="${nonceValue}">${scriptContent}</script>` : `<script>${scriptContent}</script>`;
        } else return '';
    }
    getThemeHtmlAttrsScript({ forceAuto: forceAuto = false } = {}) {
        // Simple script to add theme attributes to HTML tag based on users codeMode selection
        const currentThemeState = this.getThemeState();
        if (currentThemeState.colorMode) {
            const themeAttrs = (0, $hY0xh.default)(currentThemeState);
            if (currentThemeState.colorMode === 'auto' || forceAuto) /*
               If the colorMode is auto, we don't want to just default to "light" because if the user's
               browser setting is "dark", this would set the "data-color-mode" to "light" and then set
               again with "dark" with the script from getSSRAutoColorModeScript(). Removing the "data-color-mode"
               setAttribute for "auto" makes sure that it is only set once by the getSSRAutoColorModeScript()
             */ delete themeAttrs['data-color-mode'];
            const attributeSetters = Object.entries(themeAttrs).map(([attr, value])=>`document?.documentElement?.setAttribute("${attr}", "${value}");`).join('');
            return `try { ${attributeSetters} } catch (e) {}`;
        } else return '';
    }
    constructor(){
        this.themeState = void 0;
        // If colorMode doesn't get set, you don't want to return anything
        this.themeState = (0, $58u2L.getDefaultTheme)();
    }
}


const $cad415a4c0599362$export$fd920a796bc0c5e = new (0, $60061fec709c0fa4$export$f9bc2ffe605f0ec0)();



var $bj5fB = parcelRequire("bj5fB");

const $ef8ede6c338f8be6$export$6838ff380832204f = ({ uri: uri })=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)(uri);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $cad415a4c0599362$export$fd920a796bc0c5e).getThemeHtmlAttrsScript({
                forceAuto: isMobileApp
            })}}`
        }
    });
};


const $d847caf3274d14b7$export$f3385cdc6645f7e3 = ({ uri: uri })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ef8ede6c338f8be6$export$6838ff380832204f), {
        uri: uri
    }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.end`));







const $799291abed68198f$export$640957ec8f6fdf34 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.start`), children, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.end`));
};



var $4JHZe = parcelRequire("4JHZe");


var $irVI7 = parcelRequire("irVI7");


var $dYU3e = parcelRequire("dYU3e");


var $7NOdL = parcelRequire("7NOdL");

function $c63485f681d81d31$export$693b572d94b96722() {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $7NOdL.ThemeQuery)
    });
}



var $lyWac = parcelRequire("lyWac");





var $4vyfK = parcelRequire("4vyfK");


var $djivE = parcelRequire("djivE");

function $c3ef336b2b86bed6$export$2d0f6d5aa0911699() {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $djivE.AppNavigationUnifiedQuery)
        }),
        (0, $4vyfK.preloadWebItemLocation)({
            location: 'system.header/left'
        })
    ]);
}



var $xwvlW = parcelRequire("xwvlW");


var $d9tcB = parcelRequire("d9tcB");








var $1gIBc = parcelRequire("1gIBc");

function $6fde6b8ecb80ae64$export$822712ef6af09820() {
    const { cloudId: cloudId, edition: edition, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    const queries = [];
    // Add preloading on SSR only if user is on Confluence Free
    if (isLoggedIn && cloudId && edition === (0, $d9tcB.ConfluenceEdition).FREE) queries.push((0, $dYU3e.queryAgg)({
        query: (0, $1gIBc.ConfluenceFreePoolTargetExperimentQuery),
        variables: {
            cloudId: cloudId,
            productKey: 'confluence.ondemand'
        }
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}


















var $bPDOf = parcelRequire("bPDOf");


var $66UJS = parcelRequire("66UJS");

const $07b476ef513689d8$export$e5077e9c81abf107 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
            ]
        }
    });
};



var $hAiCi = parcelRequire("hAiCi");





var $74VX5 = parcelRequire("74VX5");

const $b7ee762a3100e127$export$18585825cd8ca022 = ()=>{
    return (0, $dYU3e.queryAgg)({
        query: (0, $74VX5.default)
    });
};


async function $a6a4fe9083f3db22$export$d46e9819bcc1eb51() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    const topNavigationPromises = [
        (0, $dYU3e.query)({
            query: (0, $hAiCi.default),
            variables: {
                includeNav4AdminOptIn: (0, $9wGTI.fg)('confluence_nav4_ga_phase_1')
            }
        })
    ];
    if ((0, $9wGTI.fg)('aifc_create_enabled')) topNavigationPromises.push((0, $07b476ef513689d8$export$e5077e9c81abf107)());
    if (userId && (0, $9wGTI.fg)('confluence_frontend_preload_notifications')) //skip for anon
    topNavigationPromises.push((0, $b7ee762a3100e127$export$18585825cd8ca022)());
    return (0, $lyWac.waitForAllReturnWhenError)(topNavigationPromises);
}









var $a1A9A = parcelRequire("a1A9A");

async function $969a3e14c27be3bd$export$9930aa21f1e6a4e3() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!userId) return;
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)({
        query: (0, $a1A9A.OperationsQuery)
    });
}









var $9WAeG = parcelRequire("9WAeG");


var $f7B1p = parcelRequire("f7B1p");


var $60cDW = parcelRequire("60cDW");

const $55fac8bf1a108c66$export$509bd252264314bd = 'backbone';
const $55fac8bf1a108c66$export$ece352750a2c4ea1 = async ()=>{
    if (window.__COOKIE_CONSENT_CATEGORIES__) return window.__COOKIE_CONSENT_CATEGORIES__;
    const { perimeter: perimeter } = (0, $60cDW.getSSRRenderInputs)();
    // if we are in FedRAMP, don't preload the consent categories
    if (perimeter === 'fedramp-moderate') return window.__COOKIE_CONSENT_CATEGORIES__ = null;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:CookieCategories', async ()=>{
        try {
            const res = await (async ()=>{
                const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult = await (0, $f7B1p.cfetch)(`https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json`, {
                    method: 'GET',
                    credentials: 'omit',
                    headers: {
                        Accept: 'application/json'
                    }
                });
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                return _asyncResult;
            })();
            if (!res.ok) throw new Error(`Cannot load Cookie Consent Categories: ${res.statusText}`);
            const result = await (async ()=>{
                const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult2 = await res.json();
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                return _asyncResult2;
            })();
            return window.__COOKIE_CONSENT_CATEGORIES__ = result;
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: $55fac8bf1a108c66$export$509bd252264314bd
            });
            return window.__COOKIE_CONSENT_CATEGORIES__ = null;
        }
    });
};






var $7MEbC = parcelRequire("7MEbC");










const $c841b55372d4071a$export$509bd252264314bd = 'backbone';
const $c841b55372d4071a$export$96f49c018063fe60 = async ()=>{
    if (window.__PRELOADED_COOKIE_PREFERENCES__) return window.__PRELOADED_COOKIE_PREFERENCES__;
    const { perimeter: perimeter } = (0, $60cDW.getSSRRenderInputs)();
    // if we are in FedRAMP, don't preload the consent categories
    if (perimeter === 'fedramp-moderate') return window.__PRELOADED_COOKIE_PREFERENCES__ = null;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:Preferences', async ()=>{
        try {
            const result = await (async ()=>{
                const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult = await (0, $7MEbC.getPreferences)();
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                return _asyncResult;
            })();
            return window.__PRELOADED_COOKIE_PREFERENCES__ = result || null;
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: $c841b55372d4071a$export$509bd252264314bd
            });
            return window.__PRELOADED_COOKIE_PREFERENCES__ = null;
        }
    });
};



var $eiCiP = parcelRequire("eiCiP");


var $9fLxI = parcelRequire("9fLxI");





var $9p5st = parcelRequire("9p5st");

function $88b2ba3b9422ec6a$export$3837c35a0d92ab93() {
    const macroParams = window['__LEGACY_MACRO_PARAMS__'] || [];
    window['__LEGACY_MACRO_PARAMS__'] = [];
    // eslint-disable-next-line check-preloaders/no-promise-all
    return Promise.all(macroParams.map(({ isMacroContentAndBody: isMacroContentAndBody, ...rest })=>{
        const preloadMacroQuery = isMacroContentAndBody ? (0, $9p5st.MacroBodyRendererQueryWithTags) : (0, $9p5st.MacroContentRendererQueryWithTags);
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: preloadMacroQuery,
            variables: rest,
            context: {
                single: true
            }
        });
    }));
}









var $iHLZT = parcelRequire("iHLZT");


var $l6Xaz = parcelRequire("l6Xaz");


var $bUqLQ = parcelRequire("bUqLQ");

async function $821e100427ee88aa$export$ce64f7b5556cdb62({ preloadSuperBatchForSSR: preloadSuperBatchForSSR = false } = {}) {
    if (preloadSuperBatchForSSR) {
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ const superbatchData = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $dYU3e.query)({
                query: (0, $bUqLQ.FrontendResourceRenderQuery)
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        const resourceList = superbatchData?.data?.internalFrontendResource?.resourceList || [];
        const { js: js, css: css } = resourceList.reduce((acc, resource)=>{
            const html = (0, $l6Xaz.convertSuperBatchResourceToScriptTags)(resource);
            acc[resource.type].push(html);
            return acc;
        }, {
            js: [],
            css: []
        });
        (0, $iHLZT.superbatchJSRecorder).add((0, $l6Xaz.removeJquery)(js.join('\n')));
        (0, $iHLZT.superbatchCSSRecorder).add(css.join('\n'));
    } else if (!window.__SUPERBATCH_REQUESTED__) /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)({
        query: (0, $bUqLQ.FrontendResourceRenderQuery)
    });
    return Promise.resolve();
}






var $hvqgK = parcelRequire("hvqgK");








var $3mugH = parcelRequire("3mugH");


var $d6NtA = parcelRequire("d6NtA");





var $cgNzK = parcelRequire("cgNzK");







const $29df517881fdeca7$export$c2d188ccf9271ffd = 'CookiePreferencesQuery';
const $29df517881fdeca7$export$990c5eb6cb59ce1c = async ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__) return window.__COOKIE_CONSENT_PREFERENCES__;
    const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, userId: userId, perimeter: perimeter } = (0, $60cDW.getSSRRenderInputs)();
    // If the consent token cookie exist (user has already set their preferences), there is no need to
    // fetch the preferences from ConsentHub
    if ((0, $6mKj3.expVal)('confluence_ssr_preload_fallback_token', 'isEnabled', false) ? cookiesConsentToken && cookiesFallbackToken : cookiesConsentToken) return window.__COOKIE_CONSENT_PREFERENCES__ = {
        consentToken: cookiesConsentToken,
        fallbackConsentToken: cookiesFallbackToken
    };
    if (!userId) {
        const consentToken = (0, $hvqgK.serializeConsents)({});
        window.__COOKIE_CONSENT_PREFERENCES__ = consentToken ? {
            consentToken: consentToken
        } : null;
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (perimeter === 'fedramp-moderate') return window.__COOKIE_CONSENT_PREFERENCES__ = null;
    // Only compute hostEnv when we actually need to make a network call
    const { environment: environment } = (0, $xwvlW.getPreloaderFnContext)();
    const hostEnv = environment === 'PRODUCTION' ? 'prod' : 'staging';
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:CookieConsentPreferences', async ()=>{
        let result = null;
        const isLocalPillar = (0, $d6NtA.isLocal)();
        const url = isLocalPillar ? '/gateway/api/consenthub/session/user/consents/cookies' : `https://atl-preferences-center-elb.${hostEnv}.atl-paas.net/rest/user/${userId}/consents/cookies`;
        try {
            const res = await (async ()=>{
                const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult = await (0, $f7B1p.cfetch)(url, (0, $cgNzK.constructCompatibleRequestInit)({
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                        ...Boolean(undefined) && Boolean(undefined) && !isLocalPillar ? {
                            'x-ssr-service-name': 'atl-preferences-center'
                        } : {}
                    },
                    credentials: 'include'
                }));
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                return _asyncResult;
            })();
            if (!res.ok) throw new Error(`Cannot load Cookie Consent Preferences: ${res.statusText}`);
            result = await (async ()=>{
                const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult2 = await res.json();
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                return _asyncResult2;
            })();
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Fetching cookie preferences failed: ${e.message}`));
        }
        if (result && Object.keys(result).length) return window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign({}, result, {
            fallbackConsentToken: cookiesFallbackToken
        });
        else return window.__COOKIE_CONSENT_PREFERENCES__ = null;
    });
};









var $8nle6 = parcelRequire("8nle6");





var $eS4vC = parcelRequire("eS4vC");

// When firing preload functions we don't have experience tracker started thus we can only annotate the request through URL match
function $df23aac6d1130849$export$7388eaba0b85ff24(exp) {
    window['GLOBAL_FALLBACK_ATL_EXP'] = exp;
}













var $lesra = parcelRequire("lesra");





var $eSUdr = parcelRequire("eSUdr");

const $e86bb77932783694$export$ef738b2af6d7e87a = (0, $eSUdr.default)`query UserSettingsQuery($isNotLicensed:Boolean!){userPreferences@skip(if:$isNotLicensed){shouldShowCardOnPageTreeHover feedRecommendedUserSettingsDismissTimestamp userSpacesNotifiedOfExternalCollab favouriteTemplateEntityIds homePagesDisplayView feedType feedTab recentFilter missionControlOverview missionControlMetricSuggestions{suggestion value dismissalDateTime}confluenceEditorSettings{toolbarDockingInitialPosition}missionControlFeatureDiscoverySuggestions{suggestion dismissalDateTime}globalPageCardAppearancePreference homeWidgets{id state __typename}recentFilter isHomeOnboardingDismissed theme watchMyOwnContent nav4OptOut __typename}featureDiscovery{pluginKey featureKey userKey date}}`;


const $96ee7afaced2313e$export$758dd268a3743917 = 'default';
const $96ee7afaced2313e$export$e0e94d96f49a1aa = async ({ themeState: themeState })=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    // Apply themeState immediately if provided via query param (always defined for embedded pages)
    if (themeState) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(decodeURIComponent(themeState)));
    const response = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $e86bb77932783694$export$ef738b2af6d7e87a),
            variables: {
                isNotLicensed: !isLicensed
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    const theme = response?.data?.userPreferences?.theme;
    // Apply user preference theme only when no themeState is provided (prevents flicker from mismatch)
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) {
        if (!themeState && theme) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(theme));
    } else if (theme) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(theme));
    return response;
};






var $5btyx = parcelRequire("5btyx");

var $liVIA = parcelRequire("liVIA");








var $dBcar = parcelRequire("dBcar");




const $e0b364cfa44ad6fc$export$6c6d6d173d015704 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
                (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
            ]
        }
    });
};















var $8CHHT = parcelRequire("8CHHT");











var $8dUjs = parcelRequire("8dUjs");

const $0253e305bf4bf030$export$8b5d8927d613430e = async ()=>{
    const { edition: edition, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const { webItemParams: webItemParams, forgeExtensionParams: forgeExtensionParams } = (0, $8dUjs.getGlobalAppsParams)({
        edition: edition,
        accessStatus: accessStatus
    });
    const promises = [
        (0, $4vyfK.preloadWebItemLocation)(webItemParams)
    ];
    if ((0, $9wGTI.fg)('confluence_nav_4_global_forge_extensions_preload')) promises.push((0, $8CHHT.preloadUseExtensionList)(forgeExtensionParams));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};


const $34aa8f5c495a6ba2$export$3efc211209d16247 = async ()=>{
    const { cloudId: cloudId, userId: userId, activationId: activationId } = (0, $xwvlW.getPreloaderFnContext)();
    const promises = [
        (0, $0253e305bf4bf030$export$8b5d8927d613430e)()
    ];
    if (userId) promises.push((0, $dYU3e.queryAgg)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: $34aa8f5c495a6ba2$var$preloadGlobalNavigationComponentQuery,
        context: {
            headers: {
                'Atl-Client-Name': 'confluence-frontend'
            }
        },
        variables: {
            entityAri: (0, $5btyx.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: (0, $liVIA.IdentityUserAri).create({
                userId: userId
            }).toString()
        }
    }));
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cfind-4473-creation-focused-nav', 'cohort', 'treatment')) promises.push((0, $e0b364cfa44ad6fc$export$6c6d6d173d015704)());
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
const $34aa8f5c495a6ba2$var$preloadGlobalNavigationComponentQuery = (0, $eSUdr.default)`query preloadGlobalNavigationComponentQuery($entityAri:ID!$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri ownerAri:$ownerAri){sidebar{nodes{menuId visible}}}}`;









var $he3NE = parcelRequire("he3NE");

async function $99732775da1ff29d$export$dfd129d3c3f4c561() {
    const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $he3NE.GetLicensedProductsQuery),
        variables: {
            cloudId: cloudId
        }
    });
}









var $9sGCn = parcelRequire("9sGCn");











var $aT8im = parcelRequire("aT8im");

async function $1f8e7f4831866dd9$export$f92adbce3a1ce419() {
    const { isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return;
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $aT8im.useConfluenceStandardToPremiumExperimentQuery),
        variables: {
            key: (0, $aT8im.EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED)
        }
    });
}






var $iaqHp = parcelRequire("iaqHp");

const $da1fd1e44d7582fe$export$b4f1825d0b62630d = ()=>(0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $iaqHp.EditorPreferencesQuery)
    });



var $iUV81 = parcelRequire("iUV81");


var $3y1ko = parcelRequire("3y1ko");


var $hXDOc = parcelRequire("hXDOc");


var $kM8fE = parcelRequire("kM8fE");





var $wPrRK = parcelRequire("wPrRK");











var $kkLBe = parcelRequire("kkLBe");








var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");
/** @graphql cc **/ 


const $4727114abcb2cba4$export$4b6471b3bef7aea6 = (0, $eSUdr.default)`query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false){spaceHomepage(spaceKey:$spaceKey version:$versionOverride){id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;



var $2GGOW = parcelRequire("2GGOW");





var $hNtOj = parcelRequire("hNtOj");

function $1acff4ea84553836$var$processContentPreloadPermissionError(result) {
    result?.errors?.forEach((error)=>{
        // The "Cannot find space" condition is handled by redirecting to the correct space
        // even if error is not propagated to ContentPrerequisites where it is normally handled.
        if ((0, $2GGOW.isUnauthorizedError)(error)) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('view', error);
    });
}
const $1acff4ea84553836$export$dba3e11e87da376f = (data)=>({
        content: data?.spaceHomepage ? {
            nodes: [
                data?.spaceHomepage
            ],
            // @ts-ignore
            __typename: 'PaginatedContentListWithChild'
        } : null,
        space: data?.space || null
    });
function $1acff4ea84553836$export$97ce9ab4bdd6b3fc({ contentId: contentId, spaceKey: spaceKey, isBlog: isBlog, versionOverride: versionOverride = null }) {
    window.performance.mark('CFP-63.preloadContent.start');
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    // Space overview
    if (spaceKey && !contentId) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $4727114abcb2cba4$export$4b6471b3bef7aea6),
            variables: {
                spaceKey: spaceKey,
                versionOverride: versionOverride,
                isSSR: isSSR,
                useNewContentTopper: true
            },
            errorPolicy: 'all'
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // Record the end mark and timestamp to track *both* duration of preloading
            // and timestamp of the moment when preloading finished
            window.performance.mark('CFP-63.preloadContent.end');
            window.performance.mark('CFP-63.preloadContentEnd');
            const data = result?.data;
            const homepageId = data?.spaceHomepage?.id;
            if (homepageId) {
                // update result with transformed data
                result.data = $1acff4ea84553836$export$dba3e11e87da376f(data);
                (0, $dYU3e.writeQuery)({
                    /* @ts-expect-error http://go/cfe-use-relay-artifacts */ query: (0, $61vTv.ContentUnifiedQuery),
                    variables: {
                        contentId: homepageId,
                        spaceKey: spaceKey,
                        versionOverride: versionOverride,
                        isSSR: isSSR,
                        useNewContentTopper: true
                    },
                    data: {
                        ...result.data
                    }
                });
            }
            $1acff4ea84553836$var$processContentPreloadPermissionError(result);
            return {
                result: result,
                hasErrors: result?.hasErrors
            };
        });
    })();
    const chooseContentUnifiedQuery = isBlog ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    const queryVariables = {
        contentId: contentId,
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isSSR: isSSR,
        useNewContentTopper: true
    };
    if (isSSR) queryVariables.preloadLabels = true;
    return (()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: chooseContentUnifiedQuery,
            variables: queryVariables,
            errorPolicy: 'all'
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            // Record the end mark and timestamp to track *both* duration of preloading
            // and timestamp of the moment when preloading finished
            window.performance.mark('CFP-63.preloadContent.end');
            window.performance.mark('CFP-63.preloadContentEnd');
            $1acff4ea84553836$var$processContentPreloadPermissionError(result);
            return {
                result: result,
                hasErrors: result?.hasErrors
            };
        });
    })();
}



var $furnK = parcelRequire("furnK");


var $lcQ5b = parcelRequire("lcQ5b");





var $hVYQB = parcelRequire("hVYQB");

const $6dc053709e1de01d$export$4a518872c59a5d22 = ({ contentId: contentId, draftShareId: draftShareId })=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $hVYQB.DraftRedirectQuery),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'draft'
            ]
        }
    });
};



var $2WwwU = parcelRequire("2WwwU");


var $4zhNK = parcelRequire("4zhNK");


var $fyUox = parcelRequire("fyUox");


var $gKMkU = parcelRequire("gKMkU");


var $iV8Fk = parcelRequire("iV8Fk");





var $ld6xp = parcelRequire("ld6xp");





var $2XqLN = parcelRequire("2XqLN");


var $lcuos = parcelRequire("lcuos");


var $bSXAs = parcelRequire("bSXAs");


var $6aq5c = parcelRequire("6aq5c");


var $1UrkW = parcelRequire("1UrkW");


var $8pcS0 = parcelRequire("8pcS0");


var $6mEZ3 = parcelRequire("6mEZ3");








var $92uc5 = parcelRequire("92uc5");


var $8mIlz = parcelRequire("8mIlz");


var $6Cce7 = parcelRequire("6Cce7");







const $cd2d56ef117b2819$export$e87714e2a0c200ee = 8;
const $cd2d56ef117b2819$export$717eaf20c85e91ca = 'confluence-extensions-server-render-blocklist';


const $64a1b8a95751bd5c$var$knownExtensionSet = new Set((0, $8pcS0.serverRenderedExtensions));
const $64a1b8a95751bd5c$var$getMacroId = (node)=>node.attrs?.parameters?.macroMetadata?.macroId?.value;
const $64a1b8a95751bd5c$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $64a1b8a95751bd5c$var$augmentWithMarks = (marks)=>{
    if (!marks?.length) return {};
    const fragments = marks.filter((mark)=>mark.type === 'fragment');
    if (fragments.length) return {
        fragmentLocalId: fragments[0].attrs.localId
    };
    return {};
};
const $64a1b8a95751bd5c$var$blocklistCache = new Map();
const $64a1b8a95751bd5c$export$80c99e8065c92427 = ()=>$64a1b8a95751bd5c$var$blocklistCache.clear();
const $64a1b8a95751bd5c$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    if ($64a1b8a95751bd5c$var$blocklistCache.has(extensionKey)) return $64a1b8a95751bd5c$var$blocklistCache.get(extensionKey);
    const isBlocked = blocklist.length > 0 && blocklist.some((block)=>{
        try {
            const blockRegex = new RegExp(block, 'ig');
            return blockRegex.test(extensionKey);
        } catch (err) {
            // Malformed regex/input, consider extension being not blocked
            return false;
        }
    });
    $64a1b8a95751bd5c$var$blocklistCache.set(extensionKey, isBlocked);
    return isBlocked;
};
// The rule of excluding extensions from querying in the prepare phase of SSR are the following:
//  - extension should be located at the top of the page, assuming extensions returned by the
//    adf-utils/filter are in the order from top to down of the page;
//  - extension should be common/legacy, i.e. of type "com.atlassian.confluence.macro.core";
//  - extension should not be a part of those we have a special handling in SPA (excepting children macro);
//  - extensions shouldn't have an output in a content query.
const $64a1b8a95751bd5c$var$byExcluded = (excludeExtensionIdSet, numberOfExtensionsToSSR = 0)=>(node, index)=>{
        const { parameters: parameters, extensionKey: extensionKey, extensionType: extensionType } = node.attrs || {};
        return index < numberOfExtensionsToSSR && extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE && (!$64a1b8a95751bd5c$var$knownExtensionSet.has(extensionKey) || extensionKey === 'children') && !parameters.macroOutput && !excludeExtensionIdSet.has($64a1b8a95751bd5c$var$getMacroId(node));
    };
const $64a1b8a95751bd5c$var$getSchema = (0, $2XqLN.default)(()=>(0, $1UrkW.getSchemaBasedOnStage)((0, $bSXAs.ADFStages).STAGE_0));
const $64a1b8a95751bd5c$var$createMacroQueryParamsProvider = (documentADF)=>{
    // This code (both `getRendererDocument` and `getRendererNodeContent`) inspired by `renderDocument`
    // function in `platform/packages/editor/renderer/src/render-document.ts`
    // Here we convert the `content` of our adf node to renderer/editor/ProseMirror node,
    // which ensures `content` in preloader and in SSR render would match and would not cause apollo cache mismatch.
    const getRendererDocument = (0, $2XqLN.default)(()=>{
        const schema = $64a1b8a95751bd5c$var$getSchema();
        const validDocumentADF = (0, $6aq5c.validateADFEntity)(schema, documentADF);
        const pnDoc = schema.nodeFromJSON(validDocumentADF);
        return {
            version: 1,
            type: 'doc',
            content: pnDoc.content.toJSON()
        };
    });
    const getRendererNodeContent = (macroId)=>{
        const rendererDocument = getRendererDocument();
        const [rendererNode] = (0, $lcuos.filter)(rendererDocument, (n)=>$64a1b8a95751bd5c$var$getMacroId(n) === macroId);
        return rendererNode.content || [];
    };
    return (node)=>{
        const requestADF = (0, $6mEZ3.extensionToADF)(node);
        requestADF.attrs = {
            ...requestADF.attrs,
            ...$64a1b8a95751bd5c$var$augmentWithMarks(node.marks)
        };
        if (requestADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) requestADF.content = getRendererNodeContent($64a1b8a95751bd5c$var$getMacroId(node));
        delete requestADF.attrs.layout;
        return {
            ...requestADF,
            type: node.type
        };
    };
};
const $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionKeys, extensionsBlocklist)=>{
    if (renderOnlyExtensionKeys && renderOnlyExtensionKeys.length === 0) return {};
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const blocklistedExtensions = extensionsBlocklist.split(',').map((extensionName)=>extensionName.trim()).filter(Boolean);
    // Catch error if contentNodes is empty
    if (!contentNodes || !contentNodes[0]) return {
        general: 'contentNodesEmpty'
    };
    // Leave early when there's TinyMCE or borked content
    if (contentNodes[0].body.dynamic?.representation !== 'atlas_doc_format') return {};
    // Exclude extensions that are included into the content response as we don't need
    // to load any data for these extensions.
    const excludeExtensionIdSet = new Set((contentNodes[0].macroRenderedOutput || []).map((ext)=>ext.key));
    let documentADF;
    try {
        documentADF = JSON.parse(contentNodes[0].body.dynamic.value);
    } catch (err) {
        // While contentNodes[0].body.dynamic.value should be defined in all valid cases,
        // and should it not, the experience for the user will be broken anyway, we want
        // to swallow this error, skip macros preloading and let SPA handle the case, as
        // SPA already have proper experience tracking.
        return;
    }
    const toMacroQueryParams = $64a1b8a95751bd5c$var$createMacroQueryParamsProvider(documentADF);
    const extensions = $64a1b8a95751bd5c$var$extractExtensions(documentADF).filter($64a1b8a95751bd5c$var$byExcluded(excludeExtensionIdSet, numberOfExtensionsToSSR || (0, $cd2d56ef117b2819$export$e87714e2a0c200ee))).filter((node)=>!renderOnlyExtensionKeys || renderOnlyExtensionKeys.includes(node?.attrs?.extensionKey)).map(toMacroQueryParams);
    if (numberOfExtensionsToSSR === 0) return extensions.length === 0 ? {} : undefined;
    // eslint-disable-next-line check-preloaders/no-promise-all
    const preloadResult = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await Promise.all(extensions.map(async (extensionADF)=>{
            const { isMacroContentAndBody: isMacroContentAndBody, ...variables } = (0, $8mIlz.getMacroQueryVariables)({
                adf: extensionADF,
                contentId: contentId
            });
            const attr = extensionADF.attrs;
            const extensionKey = attr?.extensionKey;
            const failure = (reason)=>({
                    [`${extensionKey}:${$64a1b8a95751bd5c$var$getMacroId(extensionADF)}`]: reason
                });
            const failureIfNotSuccess = (reason)=>(success)=>success ? undefined : failure(reason);
            // we may block some extensions via feature flags
            if ($64a1b8a95751bd5c$var$isBlocklisted(blocklistedExtensions, extensionKey)) return failure('blocklist');
            let macroBodyPreloadPromise = Promise.resolve(undefined);
            if (extensionADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) macroBodyPreloadPromise = (()=>{
                const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                return (0, $wPrRK.slowQueryGuard)(`ExtensionContentConverter_${extensionKey || 'unknown'}`, ()=>{
                    return (0, $dYU3e.query)({
                        variables: (0, $92uc5.getContentConverterVariables)({
                            content: extensionADF.content,
                            contentId: contentId
                        }),
                        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $6Cce7.ContentConverterQuery),
                        context: {
                            single: true
                        }
                    });
                }, macroTimeout).then((_result)=>{
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                    return failureIfNotSuccess('timeout-macrobody')(_result);
                });
            })();
            const macroPreloadPromise = (()=>{
                const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
                return (0, $wPrRK.slowQueryGuard)(`Extension_${extensionKey || 'unknown'}`, ()=>{
                    return (0, $dYU3e.query)({
                        variables: variables,
                        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: isMacroContentAndBody ? (0, $9p5st.MacroBodyRendererQueryWithTags) : (0, $9p5st.MacroContentRendererQueryWithTags),
                        context: {
                            single: true
                        }
                    });
                }, macroTimeout).then((_result)=>{
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
                    return failureIfNotSuccess('timeout')(_result);
                });
            })();
            // eslint-disable-next-line check-preloaders/no-promise-all
            const [macroPreloadResult, macroBodyPreloadResult] = await (async ()=>{
                const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult2 = await Promise.all([
                    macroPreloadPromise,
                    macroBodyPreloadPromise
                ]);
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
                return _asyncResult2;
            })();
            return {
                ...macroPreloadResult || {},
                ...macroBodyPreloadResult || {}
            };
        }));
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    const preloadFailures = preloadResult ? preloadResult.filter((item)=>!!item) : [];
    return Object.assign({}, ...preloadFailures);
};
async function $64a1b8a95751bd5c$export$f860aab1074a1289(contentId, contentNodes, extensionsBlocklist, numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee), renderOnlyExtensionIds) {
    // Function has early return so we extracted it out to avoid setting global in every return
    return window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = await (async ()=>{
        const _beforeResult5 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult3 = await $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionIds, extensionsBlocklist);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult5);
        return _asyncResult3;
    })();
}















var $g1f2M = parcelRequire("g1f2M");











const $eb281dfded33b271$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $eb281dfded33b271$var$hasExtensions = (contentNodes)=>{
    try {
        const adf = JSON.parse(contentNodes[0].body.dynamic.value);
        const extensions = $eb281dfded33b271$var$extractExtensions(adf);
        return extensions.length > 0;
    } catch (e) {
        return false;
    }
};
const $eb281dfded33b271$var$failureIfNotSuccess = (reason)=>(success)=>success ? undefined : {
            MacrosQuery_extensions: reason
        };
const $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodesOrPromise)=>{
    const blocklist = (0, $ld6xp.getMultiMacroQueryBlocklistFF)();
    const isContentNodePromise = typeof contentNodesOrPromise?.then === 'function';
    if (contentNodesOrPromise && !isContentNodePromise) {
        if (!$eb281dfded33b271$var$hasExtensions(contentNodesOrPromise)) return {};
    }
    const noExtensionsSignal = new Promise((resolve)=>{
        if (isContentNodePromise) contentNodesOrPromise.then((contentNodes)=>{
            if (!$eb281dfded33b271$var$hasExtensions(contentNodes)) resolve();
        });
    });
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const preloadResult = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $wPrRK.slowQueryGuard)('MacrosQuery_preload', ()=>{
                return (0, $dYU3e.query)({
                    variables: {
                        first: (0, $cd2d56ef117b2819$export$e87714e2a0c200ee),
                        contentId: contentId,
                        blocklist: blocklist
                    },
                    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $g1f2M.MacrosQuery),
                    context: {
                        single: true
                    }
                });
            }, macroTimeout, noExtensionsSignal).then((_result)=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                return $eb281dfded33b271$var$failureIfNotSuccess('timeout-rendered-macros')(_result);
            });
        })();
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return preloadResult ? Object.assign({}, ...[
        preloadResult
    ]) : {};
};
async function $eb281dfded33b271$export$b470c165ef60e727(contentId, contentNodesOrPromise) {
    // Function has early return so we extracted it out to avoid setting global in every return
    const topXFailed = await (async ()=>{
        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodesOrPromise);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
        return _asyncResult2;
    })();
    window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = topXFailed;
    return topXFailed;
}



const $7411787db12277fb$export$64dcb3aec0dc81b3 = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee) })=>{
    if (useMultipleMacrosQuery) return (0, $eb281dfded33b271$export$b470c165ef60e727)(contentId, contentNodes);
    else {
        const legacyBlocklistedExtensions = (0, $4VJDS.default).getString((0, $cd2d56ef117b2819$export$717eaf20c85e91ca), '');
        // if we're using MacrosQuery but this is the call for the old query, we need to
        // check if there are any blocklisted (for the Macros query) macros on the page
        // and attempt to use the old queries to render them instead
        const blocklistedExtensions = (0, $ld6xp.getMultiMacroQueryBlocklistFF)();
        return (0, $64a1b8a95751bd5c$export$f860aab1074a1289)(contentId, contentNodes, legacyBlocklistedExtensions, numberOfExtensionsToSSR, blocklistedExtensions);
    }
};





















var $8vxJi = parcelRequire("8vxJi");


function $64996f4302e0f23b$var$convertResourceToScriptTags(resource) {
    const nonce = window.__SSR_NONCE_VALUE__;
    if (resource.resourceType === 'CSS') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''} />`;
    else if (resource.resourceType === 'JAVASCRIPT') return `<script nonce="${nonce}" src="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''}></script>`;
    return '';
}
const $64996f4302e0f23b$export$51bf8f21dab6d404 = async ()=>{
    if (!((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false))) return;
    try {
        let uri;
        uri = '/wiki/rest/webResources/1.0/resources';
        const response = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $f7B1p.cfetch)(uri, {
                method: 'POST',
                body: JSON.stringify({
                    r: [
                        'confluence.web.resources:querystring',
                        'confluence.web.resources:navigator-context',
                        'com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
                    ],
                    c: [],
                    xc: [
                        '_super'
                    ],
                    xr: [
                        'com.atlassian.plugins.jquery:jquery',
                        'com.atlassian.plugins.jquery:jquery-migrate'
                    ]
                })
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        if (!response.ok) throw new Error(`Failed to preload web resources: ${response.status}`);
        const data = await (async ()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult2 = await response.json();
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            return _asyncResult2;
        })();
        // unparsedData in the response will later be claimed by window.WRM.data.claim()
        // This need to be fore all the JS scripts because they might claim the data while executing.
        if (data?.unparsedData) {
            const entries = [];
            for (const [key, value] of Object.entries(data.unparsedData))// value is a stringified JSON object.
            entries.push(`d["${key}"]=${(0, $8vxJi.stringifyForSSR)(value)}`);
            (0, $iHLZT.superbatchJSRecorder).addConnectResource(`<script>(function(d){if(d){${entries.join(';')}}})(window?.WRM?._unparsedData)</script>`);
        }
        (0, $iHLZT.superbatchJSRecorder).addConnectResource(data?.resources?.filter((resource)=>resource.resourceType === 'JAVASCRIPT')?.map((resource)=>$64996f4302e0f23b$var$convertResourceToScriptTags(resource)).join('\n'));
        (0, $iHLZT.superbatchCSSRecorder).addConnectResource(data?.resources?.filter((resource)=>resource.resourceType === 'CSS')?.map((resource)=>$64996f4302e0f23b$var$convertResourceToScriptTags(resource)).join('\n'));
    } catch (error) {
        (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Unable to preload connect web resources: ${error.message}`));
    }
};



var $1i2qc = parcelRequire("1i2qc");








var $fOjen = parcelRequire("fOjen");


var $25RVt = parcelRequire("25RVt");

const $151aa4f2ef9a59b5$export$dc87c93837fe9dba = async (contentId, spaceKey)=>{
    const response = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            /* Note -> relay compatible query replacement available, in @confluence/data-security package.
       * Leaving as is for now, to preserve consistent behavior w/ related getApolloClient() call
       * in graphql-helpers.ts
       */ /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $25RVt.DSPIsActionEnabledForContentQuery),
            variables: {
                action: (0, $fOjen.DataSecurityPolicyAction).PAGE_EXPORT,
                contentId: contentId,
                contentStatus: 'CURRENT',
                contentVersion: 1,
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return response;
};



var $kZZXz = parcelRequire("kZZXz");


var $28DDG = parcelRequire("28DDG");


var $22UVa = parcelRequire("22UVa");


var $1NBp8 = parcelRequire("1NBp8");


var $dhOY2 = parcelRequire("dhOY2");


var $7tT2b = parcelRequire("7tT2b");







const $2c43f8284c39f713$export$e687ae7a39790072 = (0, $eSUdr.default)`query PresenceSettingsQuery($cloudId:ID!$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId spaceKey:$spaceKey){isEnabledOnContentView}}`;


function $853f14d41fe05930$export$fb43949e55e0c9d2({ cloudId: cloudId, spaceKey: spaceKey }) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $2c43f8284c39f713$export$e687ae7a39790072),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        }
    });
}






var $9ycGg = parcelRequire("9ycGg");





var $gBI6h = parcelRequire("gBI6h");


var $lt4mJ = parcelRequire("lt4mJ");


var $eSLr0 = parcelRequire("eSLr0");


var $5Rwa0 = parcelRequire("5Rwa0");








var $7Ndnw = parcelRequire("7Ndnw");





var $gDMf3 = parcelRequire("gDMf3");


var $fNrAc = parcelRequire("fNrAc");






var $cg3Zk = parcelRequire("cg3Zk");

function $c44bc7c35ccb995d$export$b39ebabf96e926c8(id) {
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)({
        query: (0, $cg3Zk.RequestViewQuery),
        variables: {
            id: id
        }
    });
}



var $ePnB5 = parcelRequire("ePnB5");


var $jsQRz = parcelRequire("jsQRz");





var $eDV4X = parcelRequire("eDV4X");


var $fD4xZ = parcelRequire("fD4xZ");

function $4e24c7560d847d2b$export$1c5f808d33dd5bee({ contentId: contentId }) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $fD4xZ.default),
        variables: {
            contentId: contentId,
            status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES),
            refetchQuery: false
        },
        fetchPolicy: 'network-only'
    });
}









var $9xoMO = parcelRequire("9xoMO");




const $ae623fc05873186d$export$8770175d3079e1c0 = [
    'onboarding-origin-state:attributes',
    'onboarding-state:isFoundingAdmin',
    'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
    'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
    'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
    'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
    'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
    'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight',
    'onboarding-state:isRedactionsTourVisible',
    'onboarding-state:isContentWrapperLabelsTourDismissed',
    'onboarding-state:isMoreActionsTourVisible',
    'onboarding-state:isMoreActionsHintVisible',
    'random:ShareAndRestrictDialog:spotlightSeen',
    'home-onboarding-takeover-v2:hasSeenHomeNudge',
    'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    'home-onboarding-takeover-v2:takeoverSeenAt',
    'home-onboarding-takeover-v2:onboardingActionStates',
    'home-onboarding-takeover-v2:isCollapsed',
    'home-onboarding-takeover-v2:hasSeenConfetti',
    'home-onboarding-takeover-v2:hasDismissedCarousel',
    'home-onboarding-takeover-v2:hasDismissedLearningResources',
    'home-onboarding-takeover-v2:hasDismissedTakeover',
    'editor-state:editorOnboardingEligiblity',
    'editor-state:editorVisited',
    'editor-state:wasDraftBannerSeen',
    'editor-state:isDraftBannerVisible',
    'editor-state:isLandInEditorBannerVisible',
    'editor-state:hasUserPublished',
    'editor-state:successFlagCompleted',
    'editor-state:recentSpotlightOpen',
    'editor-state:recentSpotlightCompleted',
    'editor-state:editorTutorialSuccessFlagCompleted',
    'editor-state:wasEditorConversionModalSeen',
    'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    'onboarding-intent-experiences:onboardingIntentExperienceLandClosed',
    'page:pagePresenceAvatarGroupSpotlightSeen',
    'page:pageTelepointerAvatarGroupSpotlightSeen',
    'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt',
    'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
    'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner',
    'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    'trial-components:trialGracePeriodBannerDismissed',
    'trial-components:dismissedTrialnullDayFlag',
    'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen',
    'land-in-sample-space:hasDismissedBanner',
    'land-in-sample-space:hasSeenSampleContentFlag',
    'live-page-nudge:wasLivePageNudgeSeen',
    'nav4:isNav4GlobalSpotlightDismissed',
    'nav4:isNav4SpaceTourDismissed',
    'personalized-templates-v2:onboardingActionStates',
    'personalized-templates-v2:hasDismissedOnboardingActions',
    'personalized-templates-v2:takeoverSeenAt',
    'personalized-templates-v2:isTemplateListDismissed',
    'personalized-templates-v2:templateUsageValues',
    'templates-collection:isTaggedForTemplatesCollectionExperiment',
    'templates-collection:isTemplatesSectionDismissed',
    'onboarding-state:introWorkflow',
    'onboarding-state:legacy',
    'onboarding-state:isSampleContentV2SpotlightVisible',
    'onboarding-state:landOnPath',
    'onboarding-state:teamSpaceCreated',
    'onboarding-state:improvedGetStartedPath',
    'onboarding-state:improvedGetStartedWhiteboardPath',
    'optional-nth-user-guided-tour:tourSeenAt',
    'optional-nth-user-guided-tour:hasDismissedTour',
    'optional-nth-user-guided-tour:hasCompletedTour',
    'optional-nth-user-guided-tour:hasSeenFinishNudge',
    'optional-nth-user-guided-tour:isEnrolledAsNewUser',
    'nav4:isNav4CollapseReminderSpotlightDismissed',
    'storage-enforcement-state:flagsDismissedFreeThreshold',
    'onboarding-state:nthUserOnboardingFlagViewed',
    'onboarding-state:nthUserOnboardingCompletedTimestamp',
    'onboarding-state:nthUserOnboardingPageViewed',
    'onboarding-state:nthUserGSPagePath',
    'onboarding-state:nthUserBannerDismissed'
];
const $ae623fc05873186d$export$c279cfd6dfc47585 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: (0, $9wGTI.fg)('confluence_preload_all_onboarding_keys') ? (0, $9xoMO.OnboardingKeysCombined) : $ae623fc05873186d$export$8770175d3079e1c0
        }
    });
};







var $1swiX = parcelRequire("1swiX");





var $dpyxe = parcelRequire("dpyxe");





var $cRQNp = parcelRequire("cRQNp");


var $3Tnjq = parcelRequire("3Tnjq");




var $80xNa = parcelRequire("80xNa");



















var $aqBZ0 = parcelRequire("aqBZ0");


var $ccWUN = parcelRequire("ccWUN");


var $gFF2G = parcelRequire("gFF2G");

function $12c3454d795c5c51$export$3ae0996a709f5fba(contentId) {
    if (!contentId) return Promise.resolve();
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            query: (0, $gFF2G.default),
            variables: {
                contentId: contentId
            }
        }).then(({ data: data })=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            const contentStatus = data?.content?.nodes?.[0]?.status;
            const isContentArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
            if (isContentArchived) return (0, $dYU3e.query)({
                query: (0, $ccWUN.default),
                variables: {
                    contentId: contentId
                }
            });
            return Promise.resolve();
        });
    })();
}


function $d3f749dabb808bb9$export$8114133102d6f1fd(contentId, spaceKey) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fyUox.preloadPageTitleContentProperties)({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        (0, $12c3454d795c5c51$export$3ae0996a709f5fba)(contentId)
    ]);
}



var $4trRg = parcelRequire("4trRg");




const $4158c1d6b24615da$export$7a6b4ce398eb3192 = (0, $eSUdr.default)`query UnifiedSpaceQuery($spaceKey:String){space(key:$spaceKey){id key name type status alias dataClassificationTags didContainUserContent homepageId containsExternalCollaborators operations{operation targetType}currentUser{isAdmin isFavourited isWatched isAnonymouslyAuthorized}externalCollaboratorCount homepage{id operations{operation}properties(keys:["emoji-title-published"]){nodes{id key value}}}icon{path}links{webui}history{createdDate}theme{name themeKey}lookAndFeel{headings{key value}content{header{background backgroundAttachment backgroundBlendMode backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPosition backgroundRepeat backgroundSize borderRadius padding}screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{customHeaderAndFooter{header{html js css spaUnfriendlyMacros{name}}footer{html js css spaUnfriendlyMacros{name}}}}spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;





const $1d72fef168a20b6f$export$be884ca5181c66aa = (0, $eSUdr.default)`query UnifiedSidebarLinksQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id webItemKey webItemCompleteKey title url position styleClass icon{path width height isDefault}iconClass hidden canHide tooltip linkIdentifier type}quick{id url position title styleClass}}}`;


/** @graphql cc **/ 


const $b4749e5dd7184d60$export$32430b45163821f2 = (0, $eSUdr.default)`query UnifiedUserQuery{isSiteAdmin hasUserAccessAdminRole userCanCreateContent isNewUser currentConfluenceUser{isAnonymous}user:confluence_atlassianUser(current:true){id displayName timeZone photos{value isPrimary}emails{value isPrimary}confluence{permissionType space{id}operations{operation targetType}accessStatus accountId userKey locale}}}`;


const $445d6fd463fd83fa$var$createPreloadContentTask = (contentId, isBlog, spaceKey, contentNodesPromiseResolve)=>{
    return (0, $kkLBe.prepareGuardExceptionTask)('Content', ()=>(()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
                contentId: contentId,
                isBlog: isBlog,
                spaceKey: spaceKey
            }).then(({ result: result, hasErrors: hasErrors })=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                contentNodesPromiseResolve?.(result?.data?.content?.nodes);
                if (hasErrors) return (0, $lyWac.waitForAllReturnWhenError)([
                    (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey),
                    (0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId),
                    (0, $6dc053709e1de01d$export$4a518872c59a5d22)({
                        contentId: contentId,
                        draftShareId: window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? ''
                    })
                ]);
            });
        })());
};
const $445d6fd463fd83fa$var$createContentMainTasks = (params)=>{
    const { spaceKey: spaceKey, contentId: contentId, isLicensed: isLicensed, userId: userId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute, isBlog: isBlog } = params;
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    return [
        (0, $furnK.preloadContentHeader)({
            spaceKey: spaceKey,
            contentId: contentId,
            isLicensed: isLicensed,
            userId: userId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            useNewContentTopper: true
        }),
        (0, $d3f749dabb808bb9$export$8114133102d6f1fd)(contentId, spaceKey),
        (0, $fyUox.preloadPageTitleContentProperties)({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        (0, $kkLBe.prepareGuardExceptionTask)('Connect Web Resources', ()=>(0, $64996f4302e0f23b$export$51bf8f21dab6d404)()),
        (0, $kkLBe.prepareGuardExceptionTask)('Macros', ()=>(0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                contentId: contentId,
                useMultipleMacrosQuery: true,
                contentNodes: contentNodesPromise
            })),
        $445d6fd463fd83fa$var$createPreloadContentTask(contentId, isBlog, spaceKey, contentNodesPromiseResolve),
        (0, $gBI6h.preloadPageStatusQuery)(contentId),
        (0, $lt4mJ.preloadLegacyBridge)({
            contentId: contentId,
            isBlog: isBlog
        }),
        (0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            includeContentBody: false,
            useCache: true
        }),
        (0, $2WwwU.preloadContentSmartLinks)(contentId)
    ];
};
const $445d6fd463fd83fa$export$9503d022471fff24 = async (match, url, isTransition = false, previousMatch = null)=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, environment: environment, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled, activationId: activationId } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    // following functions will be triggered after we load data
    const postLoadingTasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const isInitialLoad = !isTransition;
    const shouldPreloadNavigation = !isEmbeddedConfluence && (isInitialLoad || (0, $1swiX.shouldPreloadNavigationForTransition)(previousMatch));
    // Get isArchived from cached page data
    const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
    // Don't preload queries that will be updated by editor if previous route is edit_page
    const isPrevEditRoute = previousMatch?.name === (0, $1NBp8.EDIT_PAGE_V2).name || previousMatch?.name === (0, $1NBp8.EDIT_BLOG_V2).name || previousMatch?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || previousMatch?.name === (0, $1NBp8.HUB_EDIT).name;
    if (isPrevEditRoute && isTransition) // Preload for edit -> view transition
    return (0, $furnK.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        isLicensed: isLicensed,
        userId: userId,
        username: username,
        edition: edition,
        isPrevEditRoute: isPrevEditRoute,
        useNewContentTopper: true
    });
    if ((0, $6mKj3.expVal)('cc_preload_content_first', 'isEnabled', false)) // Content main
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>$445d6fd463fd83fa$var$createContentMainTasks({
            spaceKey: spaceKey,
            contentId: contentId,
            isLicensed: isLicensed,
            userId: userId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            isBlog: isBlog
        })));
    if ((0, $9wGTI.fg)('confluence_preload_user_data')) /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ tasks.push((0, $dYU3e.query)({
        query: (0, $b4749e5dd7184d60$export$32430b45163821f2)
    }));
    // Consolidated preloaders
    if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) {
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ tasks.push((0, $dYU3e.query)({
            query: (0, $4158c1d6b24615da$export$7a6b4ce398eb3192),
            variables: {
                spaceKey: spaceKey
            }
        }));
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ tasks.push((0, $dYU3e.query)({
            query: (0, $1d72fef168a20b6f$export$be884ca5181c66aa),
            variables: {
                spaceKey: spaceKey
            }
        }));
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ tasks.push((0, $dYU3e.query)({
            query: (0, $b4749e5dd7184d60$export$32430b45163821f2)
        }));
    }
    // Preload superbatch for connect iframes
    if ((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Superbatch', ()=>(0, $821e100427ee88aa$export$ce64f7b5556cdb62)({
            preloadSuperBatchForSSR: true
        })));
    if (!isPrevEditRoute) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, edition === (0, $80xNa.CONFLUENCE_EDITION).FREE));
    // Content types header (object header) + Unified Share and Restrict Button
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
        const contentTypesHeaderPreloadTasks = [];
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
            // preload data for whether "unpublished changes" label should show in view page object header
            contentTypesHeaderPreloadTasks.push((0, $4vyfK.preloadWebItemLocation)({
                location: 'page.metadata.banner',
                contentId: contentId
            }));
        }
        // (No need to call preloadPageRestrictionsQuery() here; it will be called by
        //  preloadContentHeader() )
        return contentTypesHeaderPreloadTasks;
    }));
    if (!(0, $6mKj3.expVal)('cc_preload_content_first', 'isEnabled', false)) // Content main
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>$445d6fd463fd83fa$var$createContentMainTasks({
            spaceKey: spaceKey,
            contentId: contentId,
            isLicensed: isLicensed,
            userId: userId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            isBlog: isBlog
        })));
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true,
        isArchived: isArchived
    }));
    // Navigation, Page tree and blog tree for blog post
    if (shouldPreloadNavigation) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
        return (0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog);
    }));
    // Space details
    if (!(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) tasks.push((0, $8nle6.preloadSpaceDetail)(spaceKey));
    // Inline Comments
    if (match?.query.focusedCommentId) tasks.push((0, $kZZXz.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    // Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // Recommendations
    const recommendationsTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_preload_recommendation_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    tasks.push((0, $wPrRK.slowQueryGuard)('preloadEndOfPageRecommendation', ()=>{
        return (0, $dhOY2.preloadEndOfPageRecommendation)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlog ? 'blogpost' : 'page'
        });
    }, recommendationsTimeout));
    // Stuff only needed for initial load
    if (isInitialLoad) {
        tasks.push(// We only refresh token when it is about to expire.
        (0, $1i2qc.preloadMediaToken)(contentId));
        if (!(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) tasks.push((0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey));
        if ((0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) tasks.push((0, $151aa4f2ef9a59b5$export$dc87c93837fe9dba)(contentId, spaceKey));
    }
    // Labels
    if (isTransition) tasks.push((0, $4e24c7560d847d2b$export$1c5f808d33dd5bee)({
        contentId: contentId
    }));
    // Preload web panel atl_general
    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    // Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog));
    // Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights')) {
        const extensionListLoader = ()=>(0, $8CHHT.preloadUseExtensionList)({
                contentId: contentId,
                spaceKey: spaceKey,
                moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
            });
        if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) postLoadingTasks.push(extensionListLoader);
        else tasks.push(extensionListLoader());
    }
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Preload content-based AI enablement check
    if ((0, $9wGTI.fg)('confluence_ai_access_policy')) {
        const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
        if (isAdminHubAIEnabled || shouldShowRovo) tasks.push((0, $fNrAc.preloadUseIsAIEnabledForContentQuery)(contentId));
    }
    // Preload definition autohighlights
    if ((0, $9wGTI.fg)('confluence_frontend_ssr_autohighlights')) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlog ? 'blogpost' : 'page'
    }));
    // Preload footer comments for the redesigned footer comment experience
    // SSRing live pages necessitates non-server (i.e. transition) preloading, so enable here too for consistency in the footer component
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // this query is needed for the new redesigned footer comment experience
    {
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $ePnB5.preloadFooterComments)(contentId, isArchived));
    }
    // Preload add comment permission check for the redesigned footer comment experience
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $jsQRz.preloadAddCommentPermissionCheck)(contentId));
    }
    // Preload onboarding state for view page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) tasks.push((0, $ae623fc05873186d$export$c279cfd6dfc47585)());
    // Preload Smart Create Feedback Banner
    if ((0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    const errors = await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $lyWac.waitForAllReturnWhenError)(tasks);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult;
    })();
    const postLoadingErrors = await (async ()=>{
        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await (0, $lyWac.waitForAllReturnWhenError)(postLoadingTasks.map((task)=>task()));
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
        return _asyncResult2;
    })();
    if (errors || postLoadingErrors) return [
        ...errors || [],
        ...postLoadingErrors || []
    ];
};

















const $c958f3980bc3f97b$export$93f1ddb751c9753 = (0, $eSUdr.default)`query SpaceOverviewIdQuery($spaceKey:String){space(key:$spaceKey){id homepageId}}`;


function $12a2f5ca95176b67$export$c390629d140bb37e(spaceKey) {
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $c958f3980bc3f97b$export$93f1ddb751c9753),
            variables: {
                spaceKey: spaceKey
            }
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return {
                result: result,
                hasErrors: result.hasErrors
            };
        });
    })();
}



















var $7tHGa = parcelRequire("7tHGa");





var $gSfo4 = parcelRequire("gSfo4");


var $2xSF7 = parcelRequire("2xSF7");

function $2257f3db82626244$export$fc412545d4d6ad12(contentId, contentStatus) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $2xSF7.ContentDataClassificationQuery),
        variables: {
            contentId: contentId,
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)([
                contentStatus
            ])
        }
    });
}






var $hqBgv = parcelRequire("hqBgv");

function $8ae9d41ffef0e01d$export$3ac98e53839cf12f() {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $hqBgv.DataClassificationEnabledQuery)
    });
}


async function $c7f6674d8ea135ae$export$137d64ae0bf4fe94(contentId) {
    const queries = [];
    if ((0, $9wGTI.fg)('disable_classification_enabled_query')) {
        // if the feature flag is enabled, we always preload the content classification
        queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
        return (0, $lyWac.waitForAllReturnWhenError)(queries);
    }
    if ((0, $9wGTI.fg)('enable_classification_query_async_calls')) {
        queries.push((0, $8ae9d41ffef0e01d$export$3ac98e53839cf12f)());
        queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
        return (0, $lyWac.waitForAllReturnWhenError)(queries);
    }
    const result = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $8ae9d41ffef0e01d$export$3ac98e53839cf12f)();
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    const isDataClassificationEnabled = result?.data?.isDataClassificationEnabled;
    if (isDataClassificationEnabled) queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}




















var $lumgz = parcelRequire("lumgz");

function $e1c1a581f9cef1d6$export$f73e4f65960ffd6e(spaceKey) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $lumgz.spaceForBaseSpaceQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}



var $ivyMZ = parcelRequire("ivyMZ");


var $6anVB = parcelRequire("6anVB");


var $5iG5Q = parcelRequire("5iG5Q");














var $cEgMD = parcelRequire("cEgMD");





var $5jrGM = parcelRequire("5jrGM");

function $7df05aa0881398cb$export$ac86736f8ee66015(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $5jrGM.ScreenQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}



var $IGlEW = parcelRequire("IGlEW");


var $82xkT = parcelRequire("82xkT");











var $3D1KL = parcelRequire("3D1KL");


var $kb8ij = parcelRequire("kb8ij");








var $7C95e = parcelRequire("7C95e");

function $281f296bea45b91b$export$61b87ca9f0bb7f96(spaceKey) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $7C95e.FavouriteSpaceQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}


function $428e758fdbd08d59$export$9a90cdaf2bd47339({ contentId: contentId, spaceKey: spaceKey, userId: userId, isLicensed: isLicensed = false }) {
    /**
   * Watch dialog button:
   * next/packages/ssr-app/src/module-replacements/@confluence/watch-dialog.js
   *
   * "..." button:
   * See next/packages/ssr-app/src/module-replacements/@confluence/content-tools.js
   *
   * Share button:
   * See next/packages/ssr-app/src/module-replacements/@confluence/share.js
   */ return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:pageButtons', async ()=>{
        const tasks = [
            (0, $3D1KL.preloadEditButton)({
                spaceKey: spaceKey,
                contentId: contentId
            })
        ];
        const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        if (!isCompanyHub) // Determine whether to show restriction and share button
        tasks.push((0, $4vyfK.preloadWebItemLocation)({
            location: 'system.content.button',
            // Special case when we know the content id the code in SpaceOverviewGroupedButtons only cares about content id
            ...contentId ? {
                contentId: contentId
            } : {
                spaceKey: spaceKey
            }
        }), (0, $kb8ij.preloadWatchDialog)({
            spaceKey: spaceKey,
            isLicensed: isLicensed,
            userId: userId,
            contentId: contentId
        }), (0, $281f296bea45b91b$export$61b87ca9f0bb7f96)(spaceKey));
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    });
}


const $79570d1de8e3464e$export$ba9b2fb7540ef84 = (spaceKey)=>(0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $82xkT.SpaceOverviewQuery),
        variables: {
            spaceKey: spaceKey,
            excludeOperations: Boolean(!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey))
        }
    });
const $79570d1de8e3464e$var$preloadSpaceOverviewQueries = async ({ homepageId: homepageId = '', spaceKey: spaceKey, previousMatch: previousMatch, versionOverride: versionOverride })=>{
    const { userId: userId, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    if (homepageId) {
        // If we know the homepageId, preload early
        tasks.push((0, $IGlEW.preloadSideNavigationNeedsContentId)(spaceKey, homepageId));
        tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(homepageId));
    }
    tasks.push((0, $kkLBe.prepareGuardExceptionTask)('ContentAndMacros', ()=>(()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
                contentId: homepageId,
                spaceKey: spaceKey,
                isBlog: false,
                versionOverride: versionOverride
            }).then(({ result: result, hasErrors: hasErrors })=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                const contentId = homepageId || result?.data?.content?.nodes[0]?.id;
                // in the event that there are errors (no id from result) and the homepageId is not valid (error when loading the space),
                // bypass preloadContentPrereqs since contentId is undefined
                if (!contentId) return;
                contentNodesPromiseResolve?.(result?.data?.content?.nodes);
                const promises = [];
                if (!homepageId) {
                    // If we don't know the homepageId, preloadContent will tell us the id
                    promises.push((0, $IGlEW.preloadSideNavigationNeedsContentId)(spaceKey, contentId));
                    promises.push((0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                        contentId: contentId,
                        useMultipleMacrosQuery: true,
                        contentNodes: result?.data?.content?.nodes
                    }));
                    tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(contentId));
                }
                if (hasErrors) promises.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey, {
                    versionOverride: versionOverride
                }));
                return (0, $lyWac.waitForAllReturnWhenError)(promises);
            });
        })()), (0, $428e758fdbd08d59$export$9a90cdaf2bd47339)({
        contentId: homepageId,
        spaceKey: spaceKey,
        userId: userId,
        isLicensed: isLicensed
    }));
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    const shouldPreloadPageTree = previousMatch && previousMatch?.params?.spaceKey !== spaceKey && (0, $9wGTI.fg)('confluence_preload_pagetree_space_transition'); // preload page tree on transition if the previous space key is different from the new space key
    if (shouldPreloadPageTree) tasks.push((0, $6anVB.preloadPageTree)({
        contentId: homepageId,
        spaceKey: spaceKey,
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        isSuperAdmin: false
    }), (0, $5iG5Q.preloadBlogTree)({
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
async function $79570d1de8e3464e$export$2fae7b45037154b8({ spaceKey: spaceKey, homepageId: homepageId, homepageIdPromise: homepageIdPromise, previousMatch: previousMatch, versionOverride: versionOverride }) {
    const promises = [
        (0, $7df05aa0881398cb$export$ac86736f8ee66015)(spaceKey),
        (0, $e1c1a581f9cef1d6$export$f73e4f65960ffd6e)(spaceKey),
        (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey)
    ];
    if (homepageId || homepageIdPromise) // In some case we append homepageId as a query param. Then preload with it.
    // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
    promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
        homepageId: homepageId,
        spaceKey: spaceKey,
        previousMatch: previousMatch,
        versionOverride: versionOverride
    }));
    else if (Boolean(undefined)) // Use new query to preload as space key then transform to the old queries.
    // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
    promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
        spaceKey: spaceKey
    }));
    else // If we have no information on home id and yet using old query, we need to fetch it first.
    promises.push((()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        return $79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey).then((res)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            // Because homepageId was provided by the function caller, it may or may
            // not be out of sync with backend:
            const actualHomepageId = res?.data?.space?.homepage?.id;
            if (actualHomepageId) return $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
                homepageId: actualHomepageId,
                spaceKey: spaceKey,
                previousMatch: previousMatch,
                versionOverride: versionOverride
            });
        });
    })());
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}





















var $2z79p = parcelRequire("2z79p");

function $3c8474b5b6cc7016$export$986e86a20e675444({ accountId: accountId }) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $2z79p.AudienceSegmentationContextProviderQuery),
        variables: {
            accountId: accountId
        }
    });
}

















const $de1bf574523c3b16$export$7237b12e4aa9c6c = async ()=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (activationId && cloudId) return `~HUB-${cloudId}-${activationId}~`;
};










var $c3Qwv = parcelRequire("c3Qwv");


















const $fe22b38e04163065$var$homepageIdPromiseMap = new Map();
const $fe22b38e04163065$var$homepageIdMap = new Map();
const $fe22b38e04163065$var$loadHomepageId = async (spaceKey)=>{
    const { result: result, hasErrors: hasErrors } = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $12a2f5ca95176b67$export$c390629d140bb37e)(spaceKey);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return !hasErrors && result?.data?.space?.homepageId || null;
};
const $fe22b38e04163065$export$75a73f2fbf5e96e8 = async (match)=>{
    const { spaceKey: spaceKey } = match.params;
    const homepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    if (homepageId) return;
    const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) ?? $fe22b38e04163065$var$loadHomepageId(spaceKey);
    // Keep both maps in sync - promises and actual values for synchronous access
    $fe22b38e04163065$var$homepageIdPromiseMap.set(spaceKey, homepageIdPromise);
    return homepageIdPromise.then((homepageId)=>{
        $fe22b38e04163065$var$homepageIdMap.set(spaceKey, homepageId);
    });
};
const $fe22b38e04163065$export$75071d943b36f58f = async (match, previousMatch, _url)=>{
    const { cloudId: cloudId, isLicensed: isLicensed, userId: userId, activationId: activationId } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const initialHomepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    const tasks = [];
    spaceKey;
    const isCompanyHub = match.name === (0, $1NBp8.COMPANY_HUB).name;
    const companyHubSpaceKey = isCompanyHub ? await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await (0, $de1bf574523c3b16$export$7237b12e4aa9c6c)();
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })() : undefined;
    const versionOverride = companyHubSpaceKey && match.query ? (0, $c3Qwv.getSingleParamInt)(match.query, 'versionOverride') : null;
    const homepageId = initialHomepageId || $fe22b38e04163065$var$homepageIdMap.get(spaceKey ?? companyHubSpaceKey);
    tasks.push((0, $79570d1de8e3464e$export$2fae7b45037154b8)({
        spaceKey: spaceKey ?? companyHubSpaceKey,
        homepageId: homepageId,
        homepageIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        previousMatch: previousMatch,
        versionOverride: versionOverride
    }));
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') && homepageId) {
        // Get isArchived from cached page data
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(homepageId ?? undefined);
        tasks.push((0, $4trRg.preloadContentMode)({
            contentId: homepageId,
            isDraft: true,
            useCache: true,
            isArchived: isArchived
        }));
    }
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId || '',
        contentIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        spaceKey: spaceKey ?? companyHubSpaceKey
    }));
    if ((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        // Preload superbatch
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Superbatch', ()=>(0, $821e100427ee88aa$export$ce64f7b5556cdb62)({
                preloadSuperBatchForSSR: true
            })));
        // Preload Connect web resources
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Connect Web Resources', ()=>(0, $64996f4302e0f23b$export$51bf8f21dab6d404)()));
    }
    tasks.push((0, $8nle6.preloadSpaceDetail)(spaceKey));
    if (isCompanyHub && userId) tasks.push((0, $3c8474b5b6cc7016$export$986e86a20e675444)({
        accountId: userId
    }));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Space Overview's homepageId is needed for the content types header, but may not be in the URL
    // depending on which route was used.  skip preloading if it's not in the url because sequential calls block SSR
    if (!isCompanyHub && homepageId && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(homepageId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Standalone Restrictions button needs to have its data preloaded)
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(homepageId, false));
    }
    // Unified Share and Restrict Button
    if (!isCompanyHub && homepageId && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(homepageId));
    // Preload definition autohighlights
    if (homepageId && (0, $9wGTI.fg)('confluence_frontend_ssr_autohighlights')) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: homepageId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: 'page'
    }));
    // Preload media token for cover image
    if (homepageId && (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr')) tasks.push((0, $1i2qc.preloadMediaToken)(homepageId));
    if (homepageId) tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: homepageId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: homepageId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    if (!isCompanyHub && !homepageId && ((0, $9wGTI.fg)('confluence_frontend_usd_ssr') || (0, $9wGTI.fg)('confluence_frontend_content_wrapper'))) {
        // Unified Share and Restrict Button
        if ((0, $6mKj3.expValEquals)('fix_preload_share_and_restrict_query_chaining_', 'cohort', 'test')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
        //moved chained queries to the bottom to unblock other queries needed to preload & to combine the contentId query
        const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) || $fe22b38e04163065$var$loadHomepageId(spaceKey);
        await (async ()=>{
            const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult3 = await homepageIdPromise.then((contentId)=>{
                if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
                    tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId ?? '', false));
                }
                if (!(0, $6mKj3.expValEquals)('fix_preload_share_and_restrict_query_chaining_', 'cohort', 'test') && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId ?? ''));
                if (contentId) {
                    // Preload web panel atl_general
                    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
                        contentId: contentId,
                        location: (0, $eSLr0.ATL_GENERAL)
                    }), (0, $5Rwa0.preloadWebPanelLocation)({
                        contentId: contentId,
                        location: (0, $eSLr0.ATL_FOOTER)
                    }));
                    // Preload media token for cover image
                    if ((0, $9wGTI.fg)('confluence_frontend_cover_image_ssr')) tasks.push((0, $1i2qc.preloadMediaToken)(contentId));
                }
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
            return _asyncResult3;
        })();
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
const $fe22b38e04163065$export$d1ef19b00f2c3147 = ()=>{
    $fe22b38e04163065$var$homepageIdMap.clear();
    $fe22b38e04163065$var$homepageIdPromiseMap.clear();
};



var $7A94k = parcelRequire("7A94k");






















var $c3dSY = parcelRequire("c3dSY");


var $aVmIf = parcelRequire("aVmIf");




const $4706763577468788$export$b7b653968af0ab1f = (0, $eSUdr.default)`query ContentIdByReferenceIdQueryWhiteboards($id:String!){contentIdByReferenceId(referenceId:$id)}`;


async function $7ba44aaf109d7b00$export$69c63edd0aeaee0b({ spaceKey: spaceKey, contentId: contentId }) {
    const preloadPromises = [
        $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey),
        $7ba44aaf109d7b00$var$preloadSpace(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(preloadPromises);
}
async function $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey) {
    const UUIDRegex = /[-]/;
    const isUuidBasedId = UUIDRegex.test(contentId);
    if (isUuidBasedId) await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $4706763577468788$export$b7b653968af0ab1f),
            variables: {
                id: contentId
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    else await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $c3dSY.WhiteboardUnifiedQuery),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                // The DSP query doesn't currently user the content version value, so using a fixed value
                contentVersion: 1
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
}
async function $7ba44aaf109d7b00$var$preloadSpace(spaceKey) {
    await (async ()=>{
        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult3 = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $aVmIf.SpaceQuery),
            variables: {
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
        return _asyncResult3;
    })();
}

















const $d639d659544153c3$export$a107836a8bcfc0c9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    // Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Standalone Restrictions button needs to have its data preloaded)
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    if ((0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    tasks.push((0, $7ba44aaf109d7b00$export$69c63edd0aeaee0b)({
        spaceKey: spaceKey,
        contentId: contentId
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};























var $2iJnA = parcelRequire("2iJnA");

async function $6ac7363a4b3b3fec$export$de0a909710c86263(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey),
        $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey) {
    await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $2iJnA.DatabaseUnifiedQuery),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                // The DSP query doesn't currently user the content version value, so using a fixed value
                contentVersion: 1
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
}
async function $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey) {}














const $f7a595baa9e6d446$export$f9f9f93ef86bfae1 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $6ac7363a4b3b3fec$export$de0a909710c86263)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};















var $1TElT = parcelRequire("1TElT");


var $65pdw = parcelRequire("65pdw");


var $9wImN = parcelRequire("9wImN");

const $136b2b02116ae317$var$preloadEditorData = async (contentId)=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $9wImN.SmartCreatePageEditorDataWrapperComponentQuery),
        variables: {
            contentId: contentId
        }
    });
};
const $136b2b02116ae317$export$6e1d336ae32be6c2 = async (contentId)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $136b2b02116ae317$var$preloadEditorData(contentId),
        (0, $1TElT.preloadEmojiTitle)(contentId, '', false),
        (0, $65pdw.preloadEditorPageCoverPicture)(contentId, '', false)
    ]);
};


const $ff76ae367134cd26$export$2a230d51c69b591b = async (contentId)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $136b2b02116ae317$export$6e1d336ae32be6c2)(contentId),
        (0, $1i2qc.preloadMediaToken)(contentId)
    ]);
};














var $aFgFx = parcelRequire("aFgFx");





















const $a17ca091e4cf9f3d$export$18e29f32c47bffc9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    // Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true
    }));
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $aFgFx.preloadEmbedData)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};






var $cvj7x = parcelRequire("cvj7x");


var $fywGr = parcelRequire("fywGr");










const $0b2e6fb8cfab3270$export$6554070330cad05b = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                ...Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA))
            ]
        }
    });
};











const $8401ee2f6eb43799$export$6316c27636a04811 = ()=>{
    return (0, $dYU3e.query)({
        // Will be addressed in: https://hello.jira.atlassian.cloud/browse/ACTIVATION-1475
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED
            ]
        }
    });
};











const $4b6107ec1852de14$export$f487e1233221fed9 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP
            ]
        }
    });
};






var $7PLO8 = parcelRequire("7PLO8");


var $32Xjk = parcelRequire("32Xjk");

const $8332e6e273585306$export$3e6908d03c4e3a25 = (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $32Xjk.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        }
    });
};












var $8R0gj = parcelRequire("8R0gj");




var $kyd3u = parcelRequire("kyd3u");

























var $4VWAo = parcelRequire("4VWAo");


























const $32e736695aa13b8b$export$8abf4a07f4444858 = async (match, _url, isTransition = false)=>{
    const { userId: userId, isLicensed: isLicensed, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, environment: environment } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const isBlog = Boolean((0, $kM8fE.matchEditBlog)(_url));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const shouldPreloadMentionsProvider = Boolean(undefined);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    tasks.push((0, $cvj7x.preloadEditorData)({
        spaceKey: spaceKey,
        contentId: contentId,
        cloudId: cloudId,
        shouldPreloadMentionsProvider: shouldPreloadMentionsProvider,
        useCache: false,
        isBlog: isBlog
    }));
    // we dont know if a page is unpublished until we get data back. guess based on the draftShareId being in the url
    const guessIsUnpublishedDraft = Boolean(match?.query?.draftShareId);
    tasks.push((0, $kyd3u.preloadEditorByLineData)({
        isUnpublishedDraft: guessIsUnpublishedDraft,
        spaceKey: spaceKey,
        contentId: contentId
    }));
    // When `platform_editor_smart_card_otp` is enabled, we don't need to preload the smart links,
    // because it will be handled by the editor's one-tick providers.
    if (!(0, $6mKj3.expVal)('platform_editor_smart_card_otp', 'isEnabled', false)) {
        const contentIdWithAri = `ari:cloud:confluence:${cloudId}:page/${contentId}`;
        tasks.push((0, $2WwwU.preloadContentSmartLinks)(contentIdWithAri, true));
    }
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Standalone Restrictions button needs to have its data preloaded
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    if (isLicensed) {
        tasks.push((0, $fywGr.preloadEditorOnboardingState)());
        tasks.push((0, $0b2e6fb8cfab3270$export$6554070330cad05b)());
        if ((0, $9wGTI.fg)('auto_page_emoji_kill_switch')) {
            tasks.push((0, $4b6107ec1852de14$export$f487e1233221fed9)());
            tasks.push((0, $8401ee2f6eb43799$export$6316c27636a04811)());
            tasks.push((0, $8332e6e273585306$export$3e6908d03c4e3a25)(contentId));
        }
        // preloadSiteUserTraits will handle the access status and ensure licensed access only
        if ((0, $9wGTI.fg)('cc_activation_hide_changeboarding_for_new_users')) tasks.push((0, $4VWAo.preloadSiteUserTraits)());
    }
    if (isTransition) return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    tasks.push((0, $8R0gj.preloadDraft)(contentId));
    tasks.push((0, $8nle6.preloadSpaceDetail)(spaceKey));
    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    tasks.push((0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId));
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    // Preload Smart Create Feedback Banner
    if ((0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};








async function $73df6e46d3afaa7c$export$9c3872cc60e7dbce(match, _url) {
    const { contentId: contentId, draftShareId: draftShareId } = match.params;
    await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $8R0gj.preloadDraft)(contentId, draftShareId);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
}















var $dPxOK = parcelRequire("dPxOK");


var $f3nZa = parcelRequire("f3nZa");


var $86moY = parcelRequire("86moY");


var $7AO3u = parcelRequire("7AO3u");


var $ERQv7 = parcelRequire("ERQv7");


var $dC2j7 = parcelRequire("dC2j7");

const $61c2bc00711f31ff$export$e56b81ae74d866fc = (options)=>{
    if ((0, $9wGTI.fg)('cc-agg-migration_space-pages-to-agg')) return $61c2bc00711f31ff$var$preloadSpacePagesAgg(options);
    return $61c2bc00711f31ff$export$351ea83c83d9b2e2(options);
};
const $61c2bc00711f31ff$var$preloadSpacePagesAgg = (options)=>{
    const variables = (0, $dC2j7.getPreloadAggSpacePagesQueryVariables)(options);
    const { spaceKey: spaceKey, isLoggedIn: isLoggedIn, spaceId: spaceId = '' } = options;
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.queryAgg)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $ERQv7.SearchResultsAGGSearchQuery),
            variables: variables
        }),
        ...!spaceId ? [
            (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $f3nZa.PagesSpaceIdQuery),
                variables: {
                    spaceKey: spaceKey
                }
            })
        ] : [],
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $86moY.SpacePagesPersistenceQuery),
                variables: {
                    spaceKey: spaceKey
                }
            })
        ] : []
    ]);
};
const $61c2bc00711f31ff$export$351ea83c83d9b2e2 = ({ spaceKey: spaceKey, queryParams: queryParams, userId: userId, isLicensed: isLicensed, isLoggedIn: isLoggedIn, spaceId: spaceId = '', isWhiteboardEnabled: isWhiteboardEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false })=>{
    const pagesFilter = (0, $c3Qwv.getSingleParam)(queryParams, 'pagesFilter');
    const searchText = (0, $c3Qwv.getSingleParam)(queryParams, 'text') || '';
    const variables = {
        first: 24,
        maxNumberOfResults: (0, $dC2j7.SPACE_PAGES_QUERY_LIMIT),
        searchText: searchText,
        filters: {
            spaces: {
                spaceKeys: [
                    spaceKey
                ]
            },
            titleMatchOnly: {
                titleMatchOnly: true
            },
            ...pagesFilter === 'worked-on' && userId && isLicensed && {
                contributors: {
                    accountIds: [
                        userId
                    ]
                }
            },
            ...pagesFilter === 'starred' && isLicensed && {
                labels: [
                    {
                        namespace: 'MY',
                        name: 'favourite'
                    }
                ]
            },
            statuses: {
                statuses: [
                    (0, $7AO3u.ConfluenceSearchContentStatus).CURRENT,
                    (0, $7AO3u.ConfluenceSearchContentStatus).DRAFT
                ]
            }
        },
        sortBy: [
            {
                field: (0, $7AO3u.ConfluenceContentSortingParameter).LAST_MODIFIED_DATE,
                order: (0, $7AO3u.SortOrder).DESC
            }
        ],
        isLicensed: Boolean(isLicensed),
        includeRecommended: false,
        spaceId: spaceId,
        scopes: [
            (0, $7AO3u.ConfluenceContentSearchScope).PAGE,
            ...isWhiteboardEnabled ? [
                (0, $7AO3u.ConfluenceContentSearchScope).WHITEBOARD
            ] : [],
            ...isDatabaseEnabled ? [
                (0, $7AO3u.ConfluenceContentSearchScope).DATABASE
            ] : [],
            (0, $7AO3u.ConfluenceContentSearchScope).EMBED,
            (0, $7AO3u.ConfluenceContentSearchScope).FOLDER
        ]
    };
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $dPxOK.SpacePagesQuery),
            variables: variables
        }),
        ...!spaceId ? [
            (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $f3nZa.PagesSpaceIdQuery),
                variables: {
                    spaceKey: spaceKey
                }
            })
        ] : [],
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $86moY.SpacePagesPersistenceQuery),
                variables: {
                    spaceKey: spaceKey
                }
            })
        ] : []
    ]);
};






var $yuLaV = parcelRequire("yuLaV");




const $106eac55bed5d4af$export$206b1c2d74bc11a2 = async (match)=>{
    const { userId: userId, isLoggedIn: isLoggedIn, accessStatus: accessStatus, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    return (0, $61c2bc00711f31ff$export$e56b81ae74d866fc)({
        cloudId: cloudId,
        spaceKey: spaceKey,
        queryParams: match.query,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn,
        spaceId: '',
        isWhiteboardEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled
    });
};





















const $0ef4e79dd69588ad$export$9f53340e87bacbbd = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { cloudId: cloudId } = preloadedSessionContext;
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Standalone Restrictions button needs to have its data preloaded
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};












var $5IsL6 = parcelRequire("5IsL6");








var $5WLjq = parcelRequire("5WLjq");

/** @graphql cc **/ 


const $f949b26e1eea859f$export$6567b01beefeacf2 = (0, $eSUdr.default)`query HomeLeftPanelAdministrationQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin}`;


const $91746eda3fd3599a$export$9671d08731c11b3b = ({ isLoggedIn: isLoggedIn, isLicensed: isLicensed })=>{
    // Spaces list and Administration section shown in the left navigation
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $5WLjq.preloadSpacesList)({
            isLicensed: isLicensed
        }),
        $91746eda3fd3599a$var$preloadLeftPanelAdministrationQuery({
            isLoggedIn: isLoggedIn
        })
    ]);
};
const $91746eda3fd3599a$var$preloadLeftPanelAdministrationQuery = ({ isLoggedIn: isLoggedIn })=>{
    const queryOptions = {
        query: (0, $f949b26e1eea859f$export$6567b01beefeacf2),
        skip: !isLoggedIn
    };
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)(queryOptions);
};









var $li6DS = parcelRequire("li6DS");










const $fedd9a86a97c3653$export$520ec834118606cc = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: Object.values({
                ...(0, $dBcar.ONBOARDING_INTENT_EXPERIENCES),
                ...(0, $dBcar.ONBOARDING_EXPERIENCES)
            })
        }
    });
};






var $7HSaW = parcelRequire("7HSaW");

const $94117ca0130c8194$export$1cf448b10191509a = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $7HSaW.GetLicensedProductsQuery)
    });
};





const $b8044be2d73de97b$export$67bd345805db186 = 'IntentBasedOnboardingQuery';
const $b8044be2d73de97b$export$609c06e14413a6a4 = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fedd9a86a97c3653$export$520ec834118606cc)(),
        (0, $94117ca0130c8194$export$1cf448b10191509a)()
    ]);
};











const $cb1fee227126f2d7$export$dad044a8af3d0272 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                ...Object.values((0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL))
            ]
        }
    });
};


















var $iyPd9 = parcelRequire("iyPd9");

const $5a23c886f3a0cac9$export$3764d460af2e353f = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $iyPd9.FeatureDiscoveryQuery)
    });
};


const $69ec3a471529e315$export$34e54806d88e1d6d = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
            variables: {
                key: [
                    (0, $dBcar.NTH_USER_AUTO_FOLLOW_SPACES).HAS_AUTO_FOLLOWED_SPACES
                ]
            }
        }),
        (0, $5a23c886f3a0cac9$export$3764d460af2e353f)()
    ]);
};














const $93195c1826ddd102$export$d281ff0f2b693fb2 = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
            variables: {
                key: Object.values((0, $dBcar.NTH_USER_AUTO_FOLLOW_TEAMMATES))
            }
        })
    ]);
};





/** @graphql cc **/ 





const $ed982393e1964ab9$var$queryString = `
		query TemplatesCollectionEligibleQuery {
		onboardingState(
			key: ${JSON.stringify(Object.values({
    ...(0, $dBcar.TEMPLATES_COLLECTION),
    ...(0, $dBcar.ONBOARDING_EXPERIENCES)
}))}
		) {
			key
			value
		}
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
		user: confluence_atlassianUser {
			id
			team
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;
const $ed982393e1964ab9$export$22168b2e6752c7f = (0, $eSUdr.default)($ed982393e1964ab9$var$queryString);


const $b7411e454a753e13$export$61d1d0b9775c631b = ()=>(0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $ed982393e1964ab9$export$22168b2e6752c7f)
    });















var $3cztU = parcelRequire("3cztU");


var $g4evd = parcelRequire("g4evd");


var $lNpDX = parcelRequire("lNpDX");

const $f413d4da5ba15b92$export$77a2c40a93849218 = ({ isLoggedIn: isLoggedIn })=>{
    // If the user is not logged in we show the following feed by default
    // so only preload that feed. If the user is logged in preload both
    // feeds and the feed preference
    const tasks = [
        (0, $dYU3e.query)({
            query: (0, $3cztU.default),
            variables: {
                first: (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_ssr', 5),
                includeGeneratedBy: (0, $9wGTI.fg)('cc-activation-use-generated-by-content-property')
            }
        })
    ];
    if (isLoggedIn) tasks.push((0, $dYU3e.query)({
        query: (0, $lNpDX.default),
        variables: {
            first: (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 10 : (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'popular_ssr', 5),
            includeGeneratedBy: (0, $9wGTI.fg)('cc-activation-use-generated-by-content-property')
        }
    }), (0, $dYU3e.query)({
        query: (0, $g4evd.default)
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};





var $6YxJf = parcelRequire("6YxJf");
























var $1gy7x = parcelRequire("1gy7x");

const $e192ddb06e08d8ca$export$853a2dce20c9140 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS))
            ]
        }
    });
};









var $eyUJP = parcelRequire("eyUJP");



const $fe35e2c6f7a7af9b$export$67d796e2874a7983 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS))
            ]
        }
    });
};


const $6dafd0e2e7720a45$export$52f7d5f014c70397 = (0, $eSUdr.default)`query preloadPersonalizedTemplatesGetPersonalSpaceDetailQuery{user:confluence_atlassianUser(current:true){id team confluence{hasPersonalSpace space{id key}}}}`;
const $6dafd0e2e7720a45$export$d511c4ef608546dd = (0, $eSUdr.default)`query preloadPersonalizedTemplatesAllTemplatesQuery{allTemplates(usePersonalSpace:true){nodes{templateId contentBlueprintId blueprintModuleCompleteKey itemModuleCompleteKey name}}}`;
const $6dafd0e2e7720a45$export$afb599a42c0eebf0 = (0, $eSUdr.default)`query preloadPersonalizedTemplatesSubAnchorQuery($accountId:ID!){growthUnifiedProfile_getUnifiedProfile(accountId:$accountId){paidChannelContext{confluence{subAnchor}}}}`;
const $6dafd0e2e7720a45$export$bce6819fc0965b3 = (0, $eSUdr.default)`query preloadPersonalizedTemplatesLicensedUserCountQuery{license{licenseConsumingUserCount}}`;
const $6dafd0e2e7720a45$export$3687d58480022124 = (userId, accessStatus)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $dYU3e.query)({
            query: $6dafd0e2e7720a45$export$52f7d5f014c70397
        }),
        (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: $6dafd0e2e7720a45$export$d511c4ef608546dd,
            variables: {
                usePersonalSpace: true
            }
        }),
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $dYU3e.queryAgg)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: $6dafd0e2e7720a45$export$afb599a42c0eebf0,
                variables: {
                    accountId: userId || ''
                }
            })
        ] : [],
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $e192ddb06e08d8ca$export$853a2dce20c9140)()
        ] : [],
        (0, $fe35e2c6f7a7af9b$export$67d796e2874a7983)(),
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $dYU3e.query)({
            query: $6dafd0e2e7720a45$export$bce6819fc0965b3
        })
    ]);
};









var $5cryL = parcelRequire("5cryL");




const $96880fbb4220964f$export$df70f7f5a1c068ca = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                // Shared between flag and banner
                (0, $dBcar.ONBOARDING_EXPERIENCES).IMPROVED_GET_STARTED_NTH_USER_PATH,
                // Flag only - likely doesn't show on server side rendering but preloading for consistency
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_FLAG_VIEWED,
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP,
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_PAGE_VIEWED,
                // Banner only
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_BANNER_DISMISSED,
                (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED
            ]
        }
    });
};











const $c81a9dc13c505c10$export$42b064b77c9ba75f = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                // For the banner and cards
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).SELECTED_TEMPLATES,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_AT,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER
            ]
        }
    });
};






var $2fsJn = parcelRequire("2fsJn");





var $9qLVv = parcelRequire("9qLVv");




const $f7e633197ba92e9b$export$15c17c0aadf15ebc = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                ...Object.values((0, $9qLVv.ROVO_AWARENESS_ONBOARDING_STATE_KEYS))
            ]
        }
    });
};









var $b4VFP = parcelRequire("b4VFP");




const $e5a69db009315bb4$export$f8fb9f2632d64c50 = ()=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
            ]
        }
    });
};














async function $f9c790251d59765e$export$954f05a5dfd487e4(cloudId) {
    const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
    const controller = new AbortController();
    const timeout = setTimeout(()=>controller.abort(), 250);
    try {
        return await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (()=>{
                const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                return (0, $f7B1p.cfetch)(url, {
                    method: 'GET',
                    signal: controller.signal
                }).then(async (res)=>{
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                    if (!res.ok) throw new Error();
                    return await (async ()=>{
                        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
                        const _asyncResult2 = await res.json();
                        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
                        return _asyncResult2;
                    })();
                });
            })();
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
    } finally{
        clearTimeout(timeout);
    }
}
const $f9c790251d59765e$export$4b9897cda1bf4a28 = async ()=>{
    if (window.__SSR_SITE_TRAITS__) return;
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (accessStatus !== 'LICENSED_USE_ACCESS' && accessStatus !== 'LICENSED_ADMIN_ACCESS') return;
    if (!cloudId) return;
    try {
        const data = await (async ()=>{
            const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult3 = await $f9c790251d59765e$export$954f05a5dfd487e4(cloudId);
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
            return _asyncResult3;
        })();
        window.__SSR_SITE_TRAITS__ = data;
    } catch (error) {
        return;
    }
};















var $7OD0G = parcelRequire("7OD0G");

function $d85b408e33b913ac$export$d97df32fa415897c({ isLicensed: isLicensed }) {
    if (!isLicensed) return Promise.resolve();
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $7OD0G.HomeWidgetsQuery)
    });
}


const $ef1b2e92c64fee29$export$3e66106e6cf0fa15 = ({ isLicensed: isLicensed })=>{
    return (0, $d85b408e33b913ac$export$d97df32fa415897c)({
        isLicensed: isLicensed
    });
};






var $d2JgU = parcelRequire("d2JgU");

function $4f0b16a97f4cdcc7$export$a3d255f35641358b() {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $d2JgU.WelcomeMessagesQuery)
    });
}



var $a67vB = parcelRequire("a67vB");


var $y9T5W = parcelRequire("y9T5W");

const $5a0086fce17702fe$var$preloadRecentWork = (args)=>{
    const queryOptions = (0, $a67vB.getRecentWorkQueryOptions)(args);
    if (queryOptions.skip) return Promise.resolve({});
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)(queryOptions);
};
const $5a0086fce17702fe$export$afe654e7a7c068fa = ({ userId: userId, cloudId: cloudId, isLicensed: isLicensed, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false })=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { accessStatus: accessStatus } = preloadedSessionContext;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    const isEnglishLocale = preloadedSessionContext.locale?.toLowerCase()?.startsWith('en');
    const tasks = [
        $5a0086fce17702fe$var$preloadRecentWork({
            cloudId: cloudId,
            isLoggedIn: !!userId,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isDatabaseEnabled: isDatabaseEnabled,
            first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH),
            isActivityV3MigrationEnabled: (0, $li6DS.getIsActivityV3RecentsEnabled)()
        }),
        (0, $f413d4da5ba15b92$export$77a2c40a93849218)({
            isLoggedIn: !!userId
        }),
        (0, $ef1b2e92c64fee29$export$3e66106e6cf0fa15)({
            isLicensed: isLicensed
        })
    ];
    if ((0, $6mKj3.expVal)('cc_ssr_preload_welcome_messages', 'isEnabled', false)) tasks.push((0, $4f0b16a97f4cdcc7$export$a3d255f35641358b)());
    if (userId) {
        tasks.push((0, $b8044be2d73de97b$export$609c06e14413a6a4)(), (0, $b7411e454a753e13$export$61d1d0b9775c631b)(), (0, $cb1fee227126f2d7$export$dad044a8af3d0272)());
        if (isLicensed && canAccessHome) {
            if ((0, $9wGTI.fg)('cc-engagement-auto-follow-recommended-spaces-gate')) tasks.push((0, $69ec3a471529e315$export$34e54806d88e1d6d)());
            if ((0, $9wGTI.fg)('cc-engagement-getting-started-nth-user-gate')) tasks.push((0, $96880fbb4220964f$export$df70f7f5a1c068ca)());
            if ((0, $9wGTI.fg)('autofollow-teammates-preconditions')) tasks.push((0, $93195c1826ddd102$export$d281ff0f2b693fb2)());
            if (isEnglishLocale && (0, $9wGTI.fg)('rovo_awareness_enabled')) tasks.push((0, $f7e633197ba92e9b$export$15c17c0aadf15ebc)());
            tasks.push((0, $e5a69db009315bb4$export$f8fb9f2632d64c50)());
        }
    }
    if (isLicensed && canAccessHome && userId && (0, $9wGTI.fg)('cc-ssr-preload-use-cases-nth-user-onboarding')) tasks.push((0, $c81a9dc13c505c10$export$42b064b77c9ba75f)());
    if (isLicensed && canAccessHome && userId && accessStatus && (0, $9wGTI.fg)('cc-ssr-preload-personalized-templates')) tasks.push((0, $6dafd0e2e7720a45$export$3687d58480022124)(userId, accessStatus));
    if (isLicensed && canAccessHome && userId && cloudId && (0, $9wGTI.fg)('cc_preload_tap_traits')) {
        tasks.push((0, $4VWAo.preloadSiteUserTraits)());
        tasks.push((0, $f9c790251d59765e$export$4b9897cda1bf4a28)());
    }
    const unifiedSpacePreloader = (0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: undefined
    }, (0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false));
    if (unifiedSpacePreloader) // @ts-ignore-next-line
    tasks.push(unifiedSpacePreloader); //type can be undefined, but the surrounding conditional prevents it
    const isLocaleEligible = (0, $9wGTI.fg)('post-office_confluence-home-banner-v2-locale-check') ? preloadedSessionContext.locale.toLowerCase().startsWith('en') : true;
    if (userId && // Manually check locale in code, instead of using Statsig, because CCFE does not have locale populated with value during FG initialization yet.
    isLocaleEligible && // suppress exposure because if feed is empty, users do not see the banner even if they are initially assigned to be in Variation
    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('post_office_confluence_home_banner_experiment_-_v2', 'cohort', 'variation')) {
        // Confluence Home Banner in SSR
        const preloadPostOfficeHomeBanner = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceHomeBanner', async ()=>{
                const result = await (0, $6YxJf.preloadPostOfficeConfluenceHomeBanner)(preloadedSessionContext);
                return result ?? {};
            });
        };
        tasks.push(preloadPostOfficeHomeBanner());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};












var $iNq0h = parcelRequire("iNq0h");

const $e4b2bfbed97961bc$export$a8fc7c44e5aafa61 = ({ isLoggedIn: isLoggedIn })=>{
    if (!isLoggedIn) return Promise.resolve({});
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)({
        query: (0, $iNq0h.HomeViewsUserPreferencesQuery)
    });
};



var $k2RxH = parcelRequire("k2RxH");


var $dTFEh = parcelRequire("dTFEh");

const $914eb87cd194adde$export$daee90b6ccc653e0 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $k2RxH.getRecentQueryOptions)({
            pill: 'all',
            cloudId: cloudId,
            endCursor: '',
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled
        })),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        }),
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $dTFEh.HomeRecentUserPreferencesQuery)
            })
        ] : []
    ]);
};










var $h6oqk = parcelRequire("h6oqk");

const $82a332f3eb0b7b32$export$9151a9689f071b49 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $dYU3e.query)((0, $h6oqk.getStarredQueryOptions)({})),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};










var $kgC8N = parcelRequire("kgC8N");

const $db48a3960bd53439$export$ef22b7398f0c0746 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $dYU3e.query)((0, $kgC8N.getDraftsQueryOptions)({})),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};



var $01STT = parcelRequire("01STT");

const $f65ab46c8acdebd2$var$getSelectedView = (matchParams)=>{
    const view = matchParams?.view;
    return Object.values((0, $01STT.View)).includes(view) ? view : (0, $01STT.View).OVERVIEW;
};
const $f65ab46c8acdebd2$var$preloadSelectedView = ({ cloudId: cloudId, isLicensed: isLicensed, userId: userId, matchParams: matchParams, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false })=>{
    if (!cloudId) return Promise.resolve({});
    const isLoggedIn = Boolean(userId);
    const selectedView = $f65ab46c8acdebd2$var$getSelectedView(matchParams);
    switch(selectedView){
        case (0, $01STT.View).RECENT:
            return (0, $914eb87cd194adde$export$daee90b6ccc653e0)({
                cloudId: cloudId,
                isLoggedIn: isLoggedIn,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled
            });
        case (0, $01STT.View).STARRED:
            return (0, $82a332f3eb0b7b32$export$9151a9689f071b49)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).DRAFTS:
            return (0, $db48a3960bd53439$export$ef22b7398f0c0746)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).OVERVIEW:
        default:
            return (0, $5a0086fce17702fe$export$afe654e7a7c068fa)({
                userId: userId,
                cloudId: cloudId,
                isLicensed: isLicensed,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled
            });
    }
};
const $f65ab46c8acdebd2$export$ae91664215c56ac5 = (options)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>(0, $91746eda3fd3599a$export$9671d08731c11b3b)({
                //preloads left nav
                isLoggedIn: Boolean(options.userId),
                isLicensed: options.isLicensed
            })),
        (0, $5IsL6.preloadCreateSpace)({
            isLicensed: options.isLicensed
        }),
        $f65ab46c8acdebd2$var$preloadSelectedView(options)
    ]);
};









var $bFNdd = parcelRequire("bFNdd");










const $179951d621935e1e$export$cefc517f3ae2aa98 = async (match)=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId, cloudId: cloudId, accessStatus: accessStatus } = preloadedSessionContext;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const tasks = [];
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    //All top Navigation preloading is done in next/packages/query-preloaders/src/index.ts
    if (isLicensed && canAccessHome) tasks.push((0, $f65ab46c8acdebd2$export$ae91664215c56ac5)({
        cloudId: cloudId,
        isLicensed: isLicensed,
        userId: userId,
        matchParams: match.params,
        isWhiteboardViewedEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled
    }));
    //appears to be used by onboarding PersonCardListNewHome.tsx
    tasks.push((0, $8nle6.preloadPersonalSpaceDetail)());
    //not sure what this is or why it isn't loded in the side nav preloader
    if ((0, $9wGTI.fg)('po-connie-side-nav-ssr-shadow')) tasks.push((0, $bFNdd.preloadPostOfficeConfluenceSideNav)(preloadedSessionContext));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};









var $iwZYw = parcelRequire("iwZYw");

const $dfe1021c2b61fce7$export$eec5c6a2cd111615 = ()=>(0, $dYU3e.query)({
        query: (0, $iwZYw.default)
    });





/** @graphql cc **/ 


const $9da8bf16e8e9b3d1$export$7612bace2450507d = (0, $eSUdr.default)`query GetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed isStorageEnforcementGracePeriodComplete gracePeriodEndDate}}`;


const $b5b554d7930e19fd$export$91ccde13a31d1982 = ()=>(0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $9da8bf16e8e9b3d1$export$7612bace2450507d)
    });


const $5368439faec350a5$export$6c7e4784651f052f = async ()=>{
    const { edition: edition } = (0, $xwvlW.getPreloaderFnContext)();
    const upperCaseEdition = edition?.toUpperCase() || '';
    if (upperCaseEdition === 'PREMIUM' || upperCaseEdition === 'STANDARD') return (0, $dfe1021c2b61fce7$export$eec5c6a2cd111615)();
    else if (upperCaseEdition === 'FREE') return (0, $b5b554d7930e19fd$export$91ccde13a31d1982)();
};






var $l998X = parcelRequire("l998X");










var $721f12379a69ffbe$exports = {};

var $6Ovzg = parcelRequire("6Ovzg");


var $bJedp = parcelRequire("bJedp");

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $721f12379a69ffbe$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $6Ovzg(object, source, $bJedp(source), customizer);
}
$721f12379a69ffbe$exports = $721f12379a69ffbe$var$isMatchWith;


const $f93f74f184f2a2a2$export$b211ce59c0ea1cfb = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};






var $PAiZW = parcelRequire("PAiZW");


var $6yHRM = parcelRequire("6yHRM");

const $f1742253be8873a8$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};


const $1f89a5665998c680$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $1f89a5665998c680$export$daf66a67c26dc848 = (config)=>{
    const currentScopeNames = $1f89a5665998c680$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $42omo.useCallback)((input)=>$1f89a5665998c680$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentScopeNames
    ]);
    const [state, setState] = (0, $42omo.useState)($1f89a5665998c680$var$initialState);
    const route = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    const nextScopeNames = $1f89a5665998c680$var$scopesNamesAsString(next);
    const updateKey = `${currentScopeNames}-${nextScopeNames}`;
    $1f89a5665998c680$var$usePostOfficeScopeSpy(state, config);
    (0, $42omo.useEffect)(()=>{
        if ($1f89a5665998c680$export$fcc046cb16c47539({
            next: next,
            state: state,
            treatIntersectionAsSame: config.treatIntersectionAsSame
        })) setState(({ current: current })=>({
                updateKey: (0, $dh538.fg)('po-scopes-update-use-simple-hash') ? (0, $f93f74f184f2a2a2$export$b211ce59c0ea1cfb)(updateKey) : Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateKey
    ]);
    return state;
};
const $1f89a5665998c680$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $1f89a5665998c680$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $1f89a5665998c680$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $1f89a5665998c680$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $1f89a5665998c680$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname, search: search } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
};
const $1f89a5665998c680$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($721f12379a69ffbe$exports)))(contextMatch, inputMatch, (contextValue, inputValue)=>$1f89a5665998c680$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $1f89a5665998c680$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $1f89a5665998c680$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $1f89a5665998c680$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $1f89a5665998c680$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $1f89a5665998c680$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($1f89a5665998c680$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $1f89a5665998c680$export$fcc046cb16c47539 = ({ next: next, state: state, treatIntersectionAsSame: treatIntersectionAsSame })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (treatIntersectionAsSame) {
        if (currentSet.length !== 0 && nextSet.length === 0) return true;
    } else {
        if (currentSet.length !== nextSet.length) return true;
    }
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $1f89a5665998c680$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $f1742253be8873a8$export$92469b55607f005b)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $42omo.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $1f89a5665998c680$var$scopesNamesAsString(state.current)
    ]);
};


var $cpPWT = parcelRequire("cpPWT");


var $2mPpz = parcelRequire("2mPpz");


var $cyz5M = parcelRequire("cyz5M");


var $6Ht9d = parcelRequire("6Ht9d");


var $j0Fou = parcelRequire("j0Fou");

const $34734b2d588fba6f$export$963cdca6c7580c53 = [
    {
        messageTemplateId: 'confluence-nudge-for-jira',
        statsigExperiment: 'post-office_expt_confluence-nudge-for-jira',
        statsigAAExperiment: 'post-office_expt_confluence-nudge-for-jira_aa',
        statsigParameterName: 'cohort',
        statsigTestCohort: 'variation'
    },
    {
        messageTemplateId: 'confluence-inline-reactions-mcu-nudge',
        statsigExperiment: 'cc-engagement-convert-dwell-only-mcu-to-react-exp',
        statsigAAExperiment: 'cc-engagement-convert-dwell-only-mcu-exp_aa',
        statsigParameterName: 'cohort',
        statsigTestCohort: 'experiment'
    },
    {
        messageTemplateId: 'confluence-3p-connector-nudge',
        statsigExperiment: 'post-office_3p_user_authentication_nudge',
        statsigParameterName: 'cohort',
        statsigTestCohort: 'variation'
    },
    {
        messageTemplateId: 'confluence-inline-reactions-mau-nudge',
        statsigExperiment: 'cc-engagement-dwell-mau-reactions-nudge-experiment',
        statsigParameterName: 'cohort',
        statsigTestCohort: 'experiment'
    },
    {
        messageTemplateId: 'rovo-3rd-party-integration-admin-nudge',
        // https://switcheroo.atlassian.com/ui/gates/24208f75-386c-46f9-9c2b-4fa50eaef53c/key/post-office_rovo-admin-nudge_experiment
        statsigExperiment: 'post-office_rovo-admin-nudge_experiment',
        statsigParameterName: 'cohort',
        statsigTestCohort: 'variation'
    }
];
























const $6dedf2638d31103b$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'atlassian-apps'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'shadow-it-apps'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'app-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/pages',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-content',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/*/.*'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-space-settings',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.+?/settings(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/blogs',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/(?!.*/edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/issue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse/.*?'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'list'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list/detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/risk-insights',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/settings/change-management?tab=risk-insights'
                }
            }
        }
    },
    {
        name: 'jira/itsm/incidents-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/incidents/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/global-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/issues'
                },
                search: {
                    matches: '.*filter.*'
                }
            }
        }
    },
    {
        name: 'jira/issues-full-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        // Jira Plans timeline/list view
        name: 'jira/plan/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/timeline'
                }
            }
        }
    },
    {
        // Jira Plans calendar view
        name: 'jira/plan/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/calendar'
                }
            }
        }
    },
    {
        // Jira Plans program board
        name: 'jira/plan/program',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/program'
                }
            }
        }
    },
    {
        // Any pages within Jira Plan
        name: 'jira/plan',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'for-you'
                }
            }
        }
    },
    {
        name: 'jira/ops/alerts',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-details',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/integration',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/integrations/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team-policies',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/policies'
                }
            }
        }
    },
    {
        name: 'jira/ops/group-detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/group-detail'
                }
            }
        }
    },
    {
        name: 'jira/ops/heartbeats',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/heartbeats'
                }
            }
        }
    },
    {
        name: 'jira/ops/who-is-on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/who-is-on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-notifications',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/personal/alert-notifications'
                }
            }
        }
    },
    {
        name: 'jira/settings/products/ops/incoming-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/products/ops/incoming-call(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/for-you',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/for-you'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/projects/incidents',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/section/incidents/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/list-detail-view',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*list.*'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/software/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        // Any project route in JSW
        name: 'jira/software/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JSW
        name: 'jira/software/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Any project route in JWM
        name: 'jira/business/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JWM
        name: 'jira/business/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Project directory
        name: 'jira/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/projects'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/.+?/list'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/project-summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        name: 'jira/software/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/[^/]+)?/projects/[^/]+/boards'
                }
            }
        }
    },
    {
        name: 'loom/all',
        when: {
            context: {
                product: 'loom'
            }
        }
    },
    {
        name: 'loom/home',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'home'
                }
            }
        }
    },
    {
        name: 'loom/looms/videos',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'looms/videos'
                }
            }
        }
    },
    {
        name: 'loom/meetings',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'meetings'
                }
            }
        }
    },
    {
        name: 'loom/notifications/all',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'notifications/all'
                }
            }
        }
    },
    {
        name: 'loom/watch-later',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'watch-later'
                }
            }
        }
    },
    {
        name: 'loom/history',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'history'
                }
            }
        }
    },
    {
        name: 'loom/settings/account',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/account'
                }
            }
        }
    },
    {
        name: 'loom/settings/workspace',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/workspace'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/cmp/project-settings/project-config/issuelayout',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/issuelayout'
                }
            }
        }
    },
    {
        name: 'studio/rovo-agents',
        when: {
            context: {
                product: 'atlassianStudio',
                subproduct: 'rovo-agents'
            }
        }
    },
    {
        name: 'studio/all',
        when: {
            context: {
                product: 'atlassianStudio'
            }
        }
    }
];









var $7XIdu = parcelRequire("7XIdu");




const $e1aac9cee19c4445$export$32c78d11bbf53e24 = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const handleVisibilityChange = (0, $42omo.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $c6GJD.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};






var $aXjWU = parcelRequire("aXjWU");




const $59232e6304ca41ab$export$f768c879be33d97b = ({ messageInstanceId: messageInstanceId, epMessageId: epMessageId, onTriggerChange: onTriggerChange })=>{
    const { isActive: requestStart } = (0, $aXjWU.useTrigger)(epMessageId + '-start');
    const { isActive: isStarted } = (0, $aXjWU.useTrigger)(epMessageId + '-started');
    const { isActive: requestDismiss } = (0, $aXjWU.useTrigger)(epMessageId + '-dismiss');
    const { isActive: ctaClick } = (0, $aXjWU.useTrigger)(epMessageId + '-cta-click');
    const isActiveValue = requestStart || isStarted || requestDismiss || ctaClick || false;
    (0, $42omo.useEffect)(()=>{
        onTriggerChange(messageInstanceId, isActiveValue);
    }, [
        messageInstanceId,
        isActiveValue,
        onTriggerChange
    ]);
    return null; // This component doesn't render anything
};
const $59232e6304ca41ab$export$7dae77a66c2e7b7e = (messages)=>{
    const [triggerStates, setTriggerStates] = (0, $42omo.useState)({});
    // Get all ep-migration messages
    const epMessages = (0, $42omo.useMemo)(()=>messages?.filter((message)=>message.messageTemplateId === 'ep-migration-external-messages') || [], [
        messages
    ]);
    const handleTriggerChange = (0, $42omo.useCallback)((messageInstanceId, isActive)=>{
        setTriggerStates((prev)=>{
            // Only update if the value actually changed
            if (prev[messageInstanceId] === isActive) return prev;
            return {
                ...prev,
                [messageInstanceId]: isActive
            };
        });
    }, []);
    const EpTriggerWrapper = (0, $42omo.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    epMessages.map((message)=>{
                        const epMessageId = message.epMessageId;
                        return epMessageId && typeof epMessageId === 'string' ? /*#__PURE__*/ (0, $l998X.jsx)($59232e6304ca41ab$export$f768c879be33d97b, {
                            messageInstanceId: message.messageInstanceId,
                            epMessageId: epMessageId,
                            onTriggerChange: handleTriggerChange
                        }, message.messageInstanceId) : null;
                    }),
                    children
                ]
            }), [
        epMessages,
        handleTriggerChange
    ]);
    return {
        triggerStates: triggerStates,
        EpTriggerWrapper: EpTriggerWrapper
    };
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 





var $efabf7fc7645c810$export$2e2bcd8739ae039 = {
    'ep-migration-inapp-2055': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("agV92"))),
    'ep-migration-inapp-3273': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4pbFR"))),
    'jira-ops-unified-view-revamp': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5cdgS")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 





var $bdf039b65c039a67$export$2e2bcd8739ae039 = {
    'ep-migration-inapp-1736': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dYHzb"))),
    'ep-migration-inapp-1737': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7u34o"))),
    'ep-migration-jira-ops-team-heartbeats': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9LxyI")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 




var $6194010d1f4df1bc$export$2e2bcd8739ae039 = {
    'confluence-fast-and-snappy-survey': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("19SzR"))),
    'confluence-lovability-survey': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gTwHj")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 




var $6c8e587a6a218e6f$export$2e2bcd8739ae039 = {
    'confluence-inline-reactions-mau-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lH9P7"))),
    'confluence-inline-reactions-mcu-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cvTkr")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $bdf2c4d5183adaaf$export$2e2bcd8739ae039 = {
    'rovo-awareness-survey': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8vaSI")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $5423659134c53036$export$2e2bcd8739ae039 = {
    'commerce-subscription-auto-upgrade-no-payment-method-ccp': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("h53hv")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $8638ff0e6475ebcb$export$2e2bcd8739ae039 = {
    'cpq-user-feedback': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fxiho")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $c87077a162f8871c$export$2e2bcd8739ae039 = {
    'shared-user-preferences-onboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4uGo9")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 









var $ca937ed6076f1963$export$2e2bcd8739ae039 = {
    'confluence-commented-on-page-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3SqrE"))),
    'confluence-continue-reading-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("70JJt"))),
    'confluence-inline-reactions-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kW2gP"))),
    'confluence-mentioned-in-comment-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9mJEY"))),
    'confluence-mentioned-on-page-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5GcCI"))),
    'confluence-nudge-for-jira': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Ekgi"))),
    'rovo-3rd-party-integration-admin-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jU7vx")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 









var $086deb55cabb6fda$export$2e2bcd8739ae039 = {
    'ep-migration-inapp-2131': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7DE3Q"))),
    'ep-migration-inapp-2270': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2tUZf"))),
    'ep-migration-inapp-2271': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("l1Npo"))),
    'ep-migration-inapp-3280': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9oIeY"))),
    'ep-migration-inapp-3282': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6hb9T"))),
    'starburst-screen-space-flags-twc-welcome-modal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gq7xe"))),
    'twc-xflow-modal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iO8cz")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 




var $207d3e09a911b71a$export$2e2bcd8739ae039 = {
    'jira-plan-add-user-changeboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f0kKh"))),
    'jira-plans-efa-change-boarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("l9IZw")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $51600f98ad98a81f$export$2e2bcd8739ae039 = {
    'jira-board-inline-editing-onboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dAAas")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $19a68b7b40785f4f$export$2e2bcd8739ae039 = {
    'jira-issueview-status': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("i4Qwf")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 




var $b4174f9c1f7fc0cd$export$2e2bcd8739ae039 = {
    'jira-list-conditional-formatting': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("i3736"))),
    'jira-nin-grid-navigation-onboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6J1Ey")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 




var $f1defad88f3ededc$export$2e2bcd8739ae039 = {
    'jira-access-page-contact-sales-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9eRe1"))),
    'jira-onboarding-hub-welcome-modal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ivT4W")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 




var $129cbb20b7714616$export$2e2bcd8739ae039 = {
    'jira-project-term-refresh-changeboarding-flag': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4R2KF"))),
    'ptr-changeboarding-space-navigation-spotlight': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eaJgs")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 







var $cf53bc18bbf356e9$export$2e2bcd8739ae039 = {
    'jira-forms-conditional-fields-changeboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3MMPs"))),
    'jira-forms-public-forms-changeboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("DrreJ"))),
    'jira-forms-public-forms-changeboarding-flag': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("diOLt"))),
    'jira-in-context-config-sidebar-changeboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iObgZ"))),
    'jira-software-cmp-currency-field-changeboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lUC1Z")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $656798fd77e3357e$export$2e2bcd8739ae039 = {
    'jira-issueview-layouts': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fXMRT")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 




var $c31e2766579ab80c$export$2e2bcd8739ae039 = {
    'frozen-columns-onboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iJ5jF"))),
    'jira-nin-group-by-any-field-changeboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9EEgw")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $b94020546ef5812e$export$2e2bcd8739ae039 = {
    'jsm-project-summary-onboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bX57u")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $bd942ad5ddfcfd20$export$2e2bcd8739ae039 = {
    'welcome-to-premium-flag': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("18uKq")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $53fd973e0d2f480f$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f7nwM")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $fda6a8631e4ef6c6$export$2e2bcd8739ae039 = {
    'mercury-edit-hierarchy-spotlight': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("68Axg")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $39ad37f7bb22409d$export$2e2bcd8739ae039 = {
    'end-of-trial-extension': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kWSyz")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 






var $284371f7cedb00b6$export$2e2bcd8739ae039 = {
    'confluence-3p-connector-nudge': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b4MNL"))),
    'ep-migration-external-messages': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("88jnE"))),
    'jira-messaging-research-recruitment': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f8JUn"))),
    'test-screen-space-flags-message': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1MKv1")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $d18ed3e4124c4bae$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6vcqN")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $38271d17d63a8119$export$2e2bcd8739ae039 = {
    'rovo-agents-scenario-onboarding': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4SxCw")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $167adc8c0cdfce2e$export$2e2bcd8739ae039 = {
    'rovo-button-onboarding-spotlight': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("93rDA")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 






var $4789487cd8e09fd4$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lkMgQ"))),
    'test-message-inapp-ep-modal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("l3ZbL"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jv9C2"))),
    'test-message-tap-ingestion-trigger-subscription': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cwbpJ")))
};


const $90021a5e9b56864d$export$e30378e28ad3e6ab = {
    ...(0, $efabf7fc7645c810$export$2e2bcd8739ae039),
    ...(0, $bdf039b65c039a67$export$2e2bcd8739ae039),
    ...(0, $6194010d1f4df1bc$export$2e2bcd8739ae039),
    ...(0, $6c8e587a6a218e6f$export$2e2bcd8739ae039),
    ...(0, $bdf2c4d5183adaaf$export$2e2bcd8739ae039),
    ...(0, $5423659134c53036$export$2e2bcd8739ae039),
    ...(0, $8638ff0e6475ebcb$export$2e2bcd8739ae039),
    ...(0, $c87077a162f8871c$export$2e2bcd8739ae039),
    ...(0, $ca937ed6076f1963$export$2e2bcd8739ae039),
    ...(0, $086deb55cabb6fda$export$2e2bcd8739ae039),
    ...(0, $207d3e09a911b71a$export$2e2bcd8739ae039),
    ...(0, $51600f98ad98a81f$export$2e2bcd8739ae039),
    ...(0, $19a68b7b40785f4f$export$2e2bcd8739ae039),
    ...(0, $b4174f9c1f7fc0cd$export$2e2bcd8739ae039),
    ...(0, $f1defad88f3ededc$export$2e2bcd8739ae039),
    ...(0, $129cbb20b7714616$export$2e2bcd8739ae039),
    ...(0, $cf53bc18bbf356e9$export$2e2bcd8739ae039),
    ...(0, $656798fd77e3357e$export$2e2bcd8739ae039),
    ...(0, $c31e2766579ab80c$export$2e2bcd8739ae039),
    ...(0, $b94020546ef5812e$export$2e2bcd8739ae039),
    ...(0, $bd942ad5ddfcfd20$export$2e2bcd8739ae039),
    ...(0, $53fd973e0d2f480f$export$2e2bcd8739ae039),
    ...(0, $fda6a8631e4ef6c6$export$2e2bcd8739ae039),
    ...(0, $39ad37f7bb22409d$export$2e2bcd8739ae039),
    ...(0, $284371f7cedb00b6$export$2e2bcd8739ae039),
    ...(0, $d18ed3e4124c4bae$export$2e2bcd8739ae039),
    ...(0, $38271d17d63a8119$export$2e2bcd8739ae039),
    ...(0, $167adc8c0cdfce2e$export$2e2bcd8739ae039),
    ...(0, $4789487cd8e09fd4$export$2e2bcd8739ae039)
};
const { initializeMessageRenderer: $90021a5e9b56864d$export$bce4e5106d86e473, MessageRenderer: $90021a5e9b56864d$export$2df1250b8f917a59 } = (0, $cyz5M.asMessageRenderer)($90021a5e9b56864d$export$e30378e28ad3e6ab);


const $06473bad2d5b4749$export$ba528679f358bf09 = ({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const isEPExternalMessageSSFEnabled = (0, $c6GJD.default).checkGate('post-office_enable_ep_external_message_web');
    const isEPExternalMessageSSREnabled = (0, $c6GJD.default).checkGate('post-office_enabled_ep_external_message_ssr');
    const [localMessageState, setLocalMessageState] = (0, $42omo.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? preloadedInitialData?.messages : undefined;
        return undefined;
    });
    const [localExternalMessageState, setLocalExternalMessageState] = (0, $42omo.useState)(()=>{
        // Initialize from preloadedInitialData only if both feature gates are enabled
        if (isEPExternalMessageSSREnabled && isEPExternalMessageSSFEnabled && preloadedInitialData?.externalMessages) return preloadedInitialData.externalMessages.length > 0 ? preloadedInitialData.externalMessages : undefined;
        return undefined;
    });
    // Dismissals are stored locally to keep the local state relatively immutable,
    // except unless explicitly refreshed from the server.
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $42omo.useState)([]);
    // Filter the messages at runtime to ensure they are always accurate and
    // so we don't need to manage the dismissed messages in the state.
    const { filteredMessages: filteredMessages, filteredExternalMessages: filteredExternalMessages } = (0, $42omo.useMemo)(()=>{
        return {
            filteredMessages: localMessageState?.filter((msg)=>!dismissedMessageInstanceIds.includes(msg.messageInstanceId)),
            filteredExternalMessages: localExternalMessageState?.filter((msg)=>!dismissedMessageInstanceIds.includes(msg.messageInstanceId))
        };
    }, [
        localMessageState,
        localExternalMessageState,
        dismissedMessageInstanceIds
    ]);
    (0, $6Ht9d.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $cpPWT.useMessagePlacementHooks)();
    const handleDismiss = (0, $42omo.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        // dismiss the current message instance
        setDismissedMessageInstanceIds((current)=>[
                ...current,
                messageInstanceId
            ]);
    }, []);
    const onDismissed = (0, $42omo.useCallback)((messageInstanceId)=>{
        handleDismiss({
            messageInstanceId: messageInstanceId
        });
    }, [
        handleDismiss
    ]);
    (0, $42omo.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $42omo.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $42omo.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    (0, $42omo.useEffect)(()=>{
        // update the preloaded initial data with the accurate filtered messages
        if (typeof setPreloadedInitialData === 'function') {
            if (isEPExternalMessageSSREnabled && isEPExternalMessageSSFEnabled) setPreloadedInitialData({
                messages: filteredMessages ?? [],
                externalMessages: filteredExternalMessages ?? []
            });
            else setPreloadedInitialData({
                messages: filteredMessages ?? []
            });
        }
    }, [
        filteredMessages,
        filteredExternalMessages,
        setPreloadedInitialData,
        isEPExternalMessageSSREnabled,
        isEPExternalMessageSSFEnabled
    ]);
    const activeScopes = (0, $1f89a5665998c680$export$daf66a67c26dc848)({
        scopes: $6dedf2638d31103b$export$54a06e3f4a159ad8,
        treatIntersectionAsSame: (0, $c6GJD.default).checkGate('post-office-ssf-treat-intersection-as-same')
    });
    const messagesState = (0, $j0Fou.usePlacementApi)('/update-messages', {
        queryParams: {
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: (0, $c6GJD.default).checkGate('post-office-ssf-enable-continuous-auto-refetch') ? !!activeScopes.updateKey && !filteredMessages?.length : !!activeScopes.updateKey && typeof filteredMessages === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) {
            const messages = messagesState.data.messages;
            let selectedMessage;
            // New experiments in the screen-space-flags placement must be added to the EXPERIMENTAL_MESSAGES list
            for (const message of messages){
                const experimentalMessage = (0, $34734b2d588fba6f$export$963cdca6c7580c53).find((p)=>p.messageTemplateId === message.messageTemplateId);
                if (experimentalMessage) {
                    const cohort = (0, $c6GJD.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                        fireExperimentExposure: true
                    });
                    if (experimentalMessage?.statsigAAExperiment) (0, $c6GJD.default).getExperimentValue(experimentalMessage.statsigAAExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                        fireExperimentExposure: true
                    });
                    if (cohort === experimentalMessage.statsigTestCohort) {
                        selectedMessage = message;
                        break;
                    }
                } else {
                    selectedMessage = message;
                    break;
                }
            }
            setLocalMessageState(selectedMessage ? [
                selectedMessage
            ] : []);
        }
        if (isEPExternalMessageSSFEnabled && messagesState.data?.externalMessages?.length) setLocalExternalMessageState(messagesState.data.externalMessages);
    }, [
        messagesState.data
    ]);
    const { triggerStates: epTriggerStates, EpTriggerWrapper: EpTriggerWrapper } = (0, $59232e6304ca41ab$export$7dae77a66c2e7b7e)(isEPExternalMessageSSFEnabled ? localExternalMessageState : undefined);
    // find if an EP message has been triggered
    const activeEpMessageInstanceId = isEPExternalMessageSSFEnabled ? Object.keys(epTriggerStates).find((messageInstanceId)=>epTriggerStates[messageInstanceId] === true) : undefined;
    // Check for EP External messages first because they are not rendered until triggered from the front-end
    // and they will not be rendered if a non-ep message is currently rendered due to the choreographer
    const [currentLocalMessage] = filteredMessages ?? [];
    const currentExternalMessage = filteredExternalMessages?.find((msg)=>msg.messageInstanceId === activeEpMessageInstanceId);
    const activeExternalMessage = isEPExternalMessageSSFEnabled && activeEpMessageInstanceId ? currentExternalMessage : currentLocalMessage;
    const messageToRender = currentLocalMessage ?? activeExternalMessage;
    const content = (0, $c6GJD.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e1aac9cee19c4445$export$32c78d11bbf53e24), {
        children: messageToRender ? /*#__PURE__*/ (0, $42omo.createElement)((0, $90021a5e9b56864d$export$2df1250b8f917a59), {
            ...messageToRender,
            key: messageToRender.messageInstanceId,
            id: messageToRender.messageInstanceId,
            messageInstanceId: messageToRender.messageInstanceId,
            onDismissed: onDismissed,
            SuspenseBoundary: (0, $cyz5M.MaybeSuspenseBoundary),
            jiraFlagsService: jiraFlagsService,
            onError: reportUnexpectedError,
            reportExpectedError: reportExpectedError
        }) : null
    }) : null;
    // Wrap content with trigger tracker components if feature gate is enabled
    return isEPExternalMessageSSFEnabled ? /*#__PURE__*/ (0, $l998X.jsx)(EpTriggerWrapper, {
        children: content
    }) : content;
};






/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $23990983e3348fe0$export$a5cfae247d8360ef = 'screen-space-flags';


/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $jQRRW = parcelRequire("jQRRW");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $k3ebb = parcelRequire("k3ebb");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bce6c13b69697278$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $bce6c13b69697278$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("ktaGw")));
        case 'da':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("1nAmB")));
        case 'de':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("kADfk")));
        case 'en-GB':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("39Kqy")));
        case 'en-US':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("lspmN")));
        case 'en-XA':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("OUGQx")));
        case 'en-XB':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("aXzEj")));
        case 'en-ZZ':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("eeT8z")));
        case 'en':
            return $bce6c13b69697278$var$importHelper(await Promise.resolve((parcelRequire("k3ebb"))));
        case 'es':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("gWIaz")));
        case 'et':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("7edTv")));
        case 'fi':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("4OGmS")));
        case 'fr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("7BE2v")));
        case 'hr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("56MyO")));
        case 'hu':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("qLVGx")));
        case 'it':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("48zwW")));
        case 'ja':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("cQeIN")));
        case 'ko':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("1Dxz8")));
        case 'nb':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("d4Hmo")));
        case 'nl':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("gjyaO")));
        case 'pl':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("cAhBk")));
        case 'pt-BR':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("8YHHO")));
        case 'ro':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("759f8")));
        case 'ru':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("7Y4Mm")));
        case 'sl':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("fBb1L")));
        case 'sr-RS':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("fO9qZ")));
        case 'sr-YR':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("kYiGN")));
        case 'sr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("25Upz")));
        case 'sv':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("2KPG0")));
        case 'th':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("8uKnv")));
        case 'tr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("hHp3F")));
        case 'uk':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("ex8X1")));
        case 'vi':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("6SbWl")));
        case 'zh-CN':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("6wqja")));
        case 'zh-TW':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("5VpDs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($k3ebb));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $b2ONX = parcelRequire("b2ONX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e84fe42f89af6fb4$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e84fe42f89af6fb4$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("8gKl9")));
        case 'da':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("jpSOO")));
        case 'de':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("6AecT")));
        case 'en-GB':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("hlWDs")));
        case 'en-US':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("l6nXd")));
        case 'en-XA':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iEmwp")));
        case 'en-XB':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("2gNE9")));
        case 'en-ZZ':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("aTgWD")));
        case 'en':
            return $e84fe42f89af6fb4$var$importHelper(await Promise.resolve((parcelRequire("b2ONX"))));
        case 'es':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iiAsS")));
        case 'et':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("2tWdS")));
        case 'fi':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iiOFt")));
        case 'fr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("aeHTQ")));
        case 'hr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("5GK6s")));
        case 'hu':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("eEw0a")));
        case 'it':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("jthau")));
        case 'ja':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("84Cxf")));
        case 'ko':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iW3kM")));
        case 'nb':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("9nNUV")));
        case 'nl':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("81GdU")));
        case 'pl':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("92qiC")));
        case 'pt-BR':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("9bHyb")));
        case 'ro':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("gvcyQ")));
        case 'ru':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("jRfhy")));
        case 'sl':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("irGVY")));
        case 'sr-RS':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("7O4me")));
        case 'sr-YR':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("4s7jC")));
        case 'sr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("dA2nN")));
        case 'sv':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("9IUYg")));
        case 'th':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("bCUq0")));
        case 'tr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("ew9Iy")));
        case 'uk':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("h6IDB")));
        case 'vi':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("hKi96")));
        case 'zh-CN':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("4Dsjr")));
        case 'zh-TW':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("laflr")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($b2ONX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $faKVU = parcelRequire("faKVU");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $41aea332c559312c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $41aea332c559312c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("2hVW4")));
        case 'da':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("fAaEK")));
        case 'de':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("8GjgQ")));
        case 'en-GB':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("5a41J")));
        case 'en-US':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("fix6E")));
        case 'en-XA':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("bwCLU")));
        case 'en-XB':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("4bt64")));
        case 'en-ZZ':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("6MvOp")));
        case 'en':
            return $41aea332c559312c$var$importHelper(await Promise.resolve((parcelRequire("faKVU"))));
        case 'es':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("60oCJ")));
        case 'et':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("hgfXf")));
        case 'fi':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("bf7FY")));
        case 'fr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("8TUis")));
        case 'hr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("goxB3")));
        case 'hu':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("atMnC")));
        case 'it':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("eDBpO")));
        case 'ja':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("fndj2")));
        case 'ko':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("1Fzpx")));
        case 'nb':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("4ZXgO")));
        case 'nl':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("7ArxX")));
        case 'pl':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("kHy3v")));
        case 'pt-BR':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("27vXu")));
        case 'ro':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("aGvLS")));
        case 'ru':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("brfyh")));
        case 'sl':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("9S126")));
        case 'sr-RS':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("7Hl4N")));
        case 'sr-YR':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("18607")));
        case 'sr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("k3ViT")));
        case 'sv':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("cISby")));
        case 'th':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("3JasV")));
        case 'tr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("9euEq")));
        case 'uk':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("bQrvq")));
        case 'vi':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("5y8fx")));
        case 'zh-CN':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("jUr6Q")));
        case 'zh-TW':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("1PEi6")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($faKVU));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $96o0f = parcelRequire("96o0f");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c806437e9ab3c705$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $c806437e9ab3c705$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("8pkfo")));
        case 'da':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("3xGoG")));
        case 'de':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("40eBS")));
        case 'en-GB':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("aPwCB")));
        case 'en-US':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4ugRI")));
        case 'en-XA':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("lXmGM")));
        case 'en-XB':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("f4AyR")));
        case 'en-ZZ':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("kCR1F")));
        case 'en':
            return $c806437e9ab3c705$var$importHelper(await Promise.resolve((parcelRequire("96o0f"))));
        case 'es':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("cmHVh")));
        case 'et':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4l2T3")));
        case 'fi':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("dFQgI")));
        case 'fr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("2dfft")));
        case 'hr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("kvq2U")));
        case 'hu':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("fuDUl")));
        case 'it':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("CbMTN")));
        case 'ja':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("95nBU")));
        case 'ko':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("5zIEY")));
        case 'nb':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("g3fl3")));
        case 'nl':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("lY2P3")));
        case 'pl':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("hSkuL")));
        case 'pt-BR':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("2LCWr")));
        case 'ro':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("l3u53")));
        case 'ru':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("iagzr")));
        case 'sl':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("a57cu")));
        case 'sr-RS':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("hhSu4")));
        case 'sr-YR':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4j5zJ")));
        case 'sr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("gVJGC")));
        case 'sv':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("frDwI")));
        case 'th':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("DmzaP")));
        case 'tr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("bi3sU")));
        case 'uk':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("8cyvu")));
        case 'vi':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("9qg2r")));
        case 'zh-CN':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("e0XLq")));
        case 'zh-TW':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4senR")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($96o0f));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ayxoO = parcelRequire("ayxoO");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4954c74f42031292$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4954c74f42031292$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("44VVw")));
        case 'da':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("lj8VP")));
        case 'de':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("7b5JG")));
        case 'en-GB':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("fkiO8")));
        case 'en-US':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ctn5G")));
        case 'en-XA':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("lEFIu")));
        case 'en-XB':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("6Vy8L")));
        case 'en-ZZ':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("i9SUy")));
        case 'en':
            return $4954c74f42031292$var$importHelper(await Promise.resolve((parcelRequire("ayxoO"))));
        case 'es':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("3D2oa")));
        case 'et':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("aBfSC")));
        case 'fi':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("aXfLu")));
        case 'fr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("hHbpn")));
        case 'hr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("3FQml")));
        case 'hu':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("epMeh")));
        case 'it':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("M4CYG")));
        case 'ja':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ax0T5")));
        case 'ko':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("h19CY")));
        case 'nb':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("jd0kM")));
        case 'nl':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("cP3TX")));
        case 'pl':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("kkbnw")));
        case 'pt-BR':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("jwK8C")));
        case 'ro':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("h63LY")));
        case 'ru':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("bZxBV")));
        case 'sl':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("8dMdU")));
        case 'sr-RS':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("bb8gm")));
        case 'sr-YR':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("gEoeD")));
        case 'sr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ax3oZ")));
        case 'sv':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("6qkex")));
        case 'th':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("cnFuw")));
        case 'tr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("32434")));
        case 'uk':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("cnPZE")));
        case 'vi':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ceQUP")));
        case 'zh-CN':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("2Ee5k")));
        case 'zh-TW':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("lYBDN")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ayxoO));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $e77Av = parcelRequire("e77Av");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4d103c8ed05eb4fd$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $4d103c8ed05eb4fd$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("lnCdp")));
        case 'da':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("eb1gR")));
        case 'de':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("5RIKb")));
        case 'en-GB':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("dovsn")));
        case 'en-US':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("8ujMv")));
        case 'en-XA':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("7uLNo")));
        case 'en-XB':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("h5IDc")));
        case 'en-ZZ':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("eqahM")));
        case 'en':
            return $4d103c8ed05eb4fd$var$importHelper(await Promise.resolve((parcelRequire("e77Av"))));
        case 'es':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("gUfa2")));
        case 'et':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("fzoAJ")));
        case 'fi':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("bHHEy")));
        case 'fr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("1LZnU")));
        case 'hr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("e5v3e")));
        case 'hu':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("9nIBZ")));
        case 'it':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("26FpJ")));
        case 'ja-JP':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("4Gifa")));
        case 'ja':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("gjCMe")));
        case 'ko':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("2uT7I")));
        case 'nb':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("hvuuM")));
        case 'nl':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("hnBZg")));
        case 'pl':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("7SJn9")));
        case 'pt-BR':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("j05vz")));
        case 'ro':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("i0UGC")));
        case 'ru':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("7sBhv")));
        case 'sl':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("luKLP")));
        case 'sr-RS':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("1eM5i")));
        case 'sr-YR':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("5VqXr")));
        case 'sr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("aFL7V")));
        case 'sv':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("hADG6")));
        case 'th':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("h6zhf")));
        case 'tr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("gk800")));
        case 'uk':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("8KsH5")));
        case 'vi':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("8gA9a")));
        case 'zh-CN':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("e3o5i")));
        case 'zh-TW':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("2Zvud")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($e77Av));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cYsan = parcelRequire("cYsan");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f1d52e5870ae9a59$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $f1d52e5870ae9a59$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("4P6Vl")));
        case 'da':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("27aNh")));
        case 'de':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("aSlsY")));
        case 'en-GB':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("cOAck")));
        case 'en-US':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("76gkg")));
        case 'en-XA':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2Bl1Y")));
        case 'en-XB':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("grzFC")));
        case 'en-ZZ':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("6JE8A")));
        case 'en':
            return $f1d52e5870ae9a59$var$importHelper(await Promise.resolve((parcelRequire("cYsan"))));
        case 'es':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("9S9M8")));
        case 'et':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("gkLcq")));
        case 'fi':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("lLyBc")));
        case 'fr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("4jCEx")));
        case 'hr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("7OGyS")));
        case 'hu':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("8clR5")));
        case 'it':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("3MYuU")));
        case 'ja':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("aBCf4")));
        case 'ko':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("5Bhq2")));
        case 'nb':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("3rRY7")));
        case 'nl':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("30lWk")));
        case 'pl':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("hA595")));
        case 'pt-BR':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("3RoXR")));
        case 'ro':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2j9hJ")));
        case 'ru':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("eRauK")));
        case 'sl':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("krh33")));
        case 'sr-RS':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("eaNh3")));
        case 'sr-YR':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("dbpza")));
        case 'sr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("gDeem")));
        case 'sv':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("16hwG")));
        case 'th':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("hsd8R")));
        case 'tr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2JjwY")));
        case 'uk':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("epoZZ")));
        case 'vi':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2k0Bf")));
        case 'zh-CN':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("gGmMl")));
        case 'zh-TW':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("4Juzw")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cYsan));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $hutRG = parcelRequire("hutRG");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0730a88e59717014$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $0730a88e59717014$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("erlv3")));
        case 'da':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("hyrCI")));
        case 'de':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("lRpEo")));
        case 'en-GB':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("ggw2O")));
        case 'en-US':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("hPTao")));
        case 'en-XA':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("lcBLN")));
        case 'en-XB':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("dBkh6")));
        case 'en-ZZ':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("dFJoB")));
        case 'en':
            return $0730a88e59717014$var$importHelper(await Promise.resolve((parcelRequire("hutRG"))));
        case 'es':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4Dzz2")));
        case 'et':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("9oSEu")));
        case 'fi':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("2LYdk")));
        case 'fr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4BCOh")));
        case 'hr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("j1vKh")));
        case 'hu':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("6bsbz")));
        case 'it':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("alXGr")));
        case 'ja':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("2zxWZ")));
        case 'ko':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("5ucB7")));
        case 'nb':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("h6Pun")));
        case 'nl':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("9AvLk")));
        case 'pl':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("3ABqE")));
        case 'pt-BR':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("lW5ia")));
        case 'ro':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("biIex")));
        case 'ru':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4Xmpo")));
        case 'sl':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("8105H")));
        case 'sr-RS':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("6GstT")));
        case 'sr-YR':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("b825f")));
        case 'sr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("7HCuW")));
        case 'sv':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("9Uxty")));
        case 'th':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("fwEkh")));
        case 'tr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4QDVl")));
        case 'uk':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("k26Lv")));
        case 'vi':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("7jx5e")));
        case 'zh-CN':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("c0uLU")));
        case 'zh-TW':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("gqxhP")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hutRG));
    }
};



var $8SCD0 = parcelRequire("8SCD0");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cGs9w = parcelRequire("cGs9w");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d75107a999e7d9fe$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d75107a999e7d9fe$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("dhNNU")));
        case 'da':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("jeBuB")));
        case 'de':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("j6f4O")));
        case 'en-GB':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("kD2zY")));
        case 'en-US':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("92Bya")));
        case 'en-XA':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("aOWdw")));
        case 'en-XB':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("7t4bC")));
        case 'en-ZZ':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("7Sa8a")));
        case 'en':
            return $d75107a999e7d9fe$var$importHelper(await Promise.resolve((parcelRequire("cGs9w"))));
        case 'es':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lXA5l")));
        case 'et':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("5aTpK")));
        case 'fi':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("7fLFn")));
        case 'fr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lhgAS")));
        case 'hr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lNiHq")));
        case 'hu':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("h1f53")));
        case 'it':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("9euo9")));
        case 'ja':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("aQeTx")));
        case 'ko':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("jKCUu")));
        case 'nb':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("1u5LJ")));
        case 'nl':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("d2bnS")));
        case 'pl':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("bd2Zq")));
        case 'pt-BR':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("1wPMw")));
        case 'ro':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("gF5rz")));
        case 'ru':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("elclF")));
        case 'sl':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("kbgzR")));
        case 'sr-RS':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("v1pT0")));
        case 'sr-YR':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("l0Crr")));
        case 'sr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("9PZYW")));
        case 'sv':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("injBd")));
        case 'th':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("hzgJF")));
        case 'tr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("2aS0a")));
        case 'uk':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("5cu4s")));
        case 'vi':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lplb2")));
        case 'zh-CN':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("8nYPU")));
        case 'zh-TW':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("50zN1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cGs9w));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Wdqe = parcelRequire("8Wdqe");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b7fe572d491aa75$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9b7fe572d491aa75$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("9VKWU")));
        case 'da':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("eEiCw")));
        case 'de':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("9JB41")));
        case 'en-GB':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("hV07a")));
        case 'en-US':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("gDq2e")));
        case 'en-XA':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6bPds")));
        case 'en-XB':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("ecgTI")));
        case 'en-ZZ':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6o8ua")));
        case 'en':
            return $9b7fe572d491aa75$var$importHelper(await Promise.resolve((parcelRequire("8Wdqe"))));
        case 'es':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("9QeTC")));
        case 'et':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("8bUPH")));
        case 'fi':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("jydp9")));
        case 'fr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("iloKM")));
        case 'hr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("dfyFv")));
        case 'hu':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("kENzV")));
        case 'it':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6eell")));
        case 'ja':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("1YD3M")));
        case 'ko':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("4kGYK")));
        case 'nb':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("4Hq5s")));
        case 'nl':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6Fddj")));
        case 'pl':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6BShP")));
        case 'pt-BR':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("67yyE")));
        case 'ro':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("El8YA")));
        case 'ru':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("eYNBw")));
        case 'sl':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("dEblD")));
        case 'sr-RS':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("jh6sZ")));
        case 'sr-YR':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("eAgqe")));
        case 'sr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("7LJh0")));
        case 'sv':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("aqwUD")));
        case 'th':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("2JiTe")));
        case 'tr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("4gyuP")));
        case 'uk':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("2cyZP")));
        case 'vi':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("hhfGW")));
        case 'zh-CN':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("gvgJi")));
        case 'zh-TW':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("btEIp")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Wdqe));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5U1zM = parcelRequire("5U1zM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2ef667146b868deb$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2ef667146b868deb$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("kCxZ5")));
        case 'da':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("alWoE")));
        case 'de':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("2k0yx")));
        case 'en-GB':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("iFxq4")));
        case 'en-US':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("3Xjc2")));
        case 'en-XA':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("51O5A")));
        case 'en-XB':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("dnjzB")));
        case 'en-ZZ':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("ahSoT")));
        case 'en':
            return $2ef667146b868deb$var$importHelper(await Promise.resolve((parcelRequire("5U1zM"))));
        case 'es':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("cJXik")));
        case 'et':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("3f0Fr")));
        case 'fi':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("iWQO6")));
        case 'fr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("c6nXU")));
        case 'hr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("7M0f6")));
        case 'hu':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("15WTx")));
        case 'it':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("lAzjh")));
        case 'ja':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("beV3E")));
        case 'ko':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("8Kz2Z")));
        case 'nb':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("aFbGF")));
        case 'nl':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("a24Sy")));
        case 'pl':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("6tcP1")));
        case 'pt-BR':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("7kDLD")));
        case 'ro':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("9JcU7")));
        case 'ru':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("1eIXL")));
        case 'sl':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("ik5VI")));
        case 'sr-RS':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("1wmX4")));
        case 'sr-YR':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("gJj4D")));
        case 'sr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("kGFwa")));
        case 'sv':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("6XJTT")));
        case 'th':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("cDsqP")));
        case 'tr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("1sfji")));
        case 'uk':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("hwmk8")));
        case 'vi':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("8aXh4")));
        case 'zh-CN':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("gAZxn")));
        case 'zh-TW':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("2LLiX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5U1zM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6rGkx = parcelRequire("6rGkx");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $05f1fcbef8ad6b50$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $05f1fcbef8ad6b50$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("btONi")));
        case 'da':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("cVlbZ")));
        case 'de':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("kBSwR")));
        case 'en-GB':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("iq2Ha")));
        case 'en-US':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("5Za3J")));
        case 'en-XA':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("7qdcA")));
        case 'en-XB':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("fVPDF")));
        case 'en-ZZ':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("18JTz")));
        case 'en':
            return $05f1fcbef8ad6b50$var$importHelper(await Promise.resolve((parcelRequire("6rGkx"))));
        case 'es':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("dO75E")));
        case 'et':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("6nyeE")));
        case 'fi':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("lyfNH")));
        case 'fr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("3EeAE")));
        case 'hr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("hqdIj")));
        case 'hu':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("dW9f5")));
        case 'it':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("9wfQB")));
        case 'ja':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("hRkFc")));
        case 'ko':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("ddJov")));
        case 'nb':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("jigr4")));
        case 'nl':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("54TR9")));
        case 'pl':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("ecgqg")));
        case 'pt-BR':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("kNY9t")));
        case 'ro':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("6R1Tz")));
        case 'ru':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("1OM09")));
        case 'sl':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("2VfZD")));
        case 'sr-RS':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("bzCDp")));
        case 'sr-YR':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("aMyR0")));
        case 'sr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("7AUrQ")));
        case 'sv':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("2PyPc")));
        case 'th':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("YyzdC")));
        case 'tr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("iURxI")));
        case 'uk':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("hTDKi")));
        case 'vi':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("a1UKY")));
        case 'zh-CN':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("i0vtB")));
        case 'zh-TW':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("6xqzX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6rGkx));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kKV5X = parcelRequire("kKV5X");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b27778c6df0a1ea3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b27778c6df0a1ea3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1NYRC")));
        case 'da':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("dYrYA")));
        case 'de':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("kEZZO")));
        case 'en-GB':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("if7BP")));
        case 'en-US':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gkAL1")));
        case 'en-XA':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("galxv")));
        case 'en-XB':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1KbcF")));
        case 'en-ZZ':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("5R3U2")));
        case 'en':
            return $b27778c6df0a1ea3$var$importHelper(await Promise.resolve((parcelRequire("kKV5X"))));
        case 'es':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gbJYL")));
        case 'et':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("cdHiZ")));
        case 'fi':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("ULOdL")));
        case 'fr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("iJaMK")));
        case 'hr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("2Tui6")));
        case 'hu':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("dCK44")));
        case 'it':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1aPXW")));
        case 'ja':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("bs5bi")));
        case 'ko':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("f9TiZ")));
        case 'nb':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("cS71P")));
        case 'nl':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("bHpBu")));
        case 'pl':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gc3W0")));
        case 'pt-BR':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("cW099")));
        case 'ro':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1iQtT")));
        case 'ru':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("dQkcb")));
        case 'sl':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("eCQlI")));
        case 'sr-RS':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("8erZp")));
        case 'sr-YR':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("4nl4V")));
        case 'sr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("abr61")));
        case 'sv':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("aJo6X")));
        case 'th':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gqVEY")));
        case 'tr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("85Yqg")));
        case 'uk':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("3AeHJ")));
        case 'vi':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("55eKA")));
        case 'zh-CN':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1iVmS")));
        case 'zh-TW':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("ed1DR")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kKV5X));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8eaIp = parcelRequire("8eaIp");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e7828c42cee8f105$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e7828c42cee8f105$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("8soQH")));
        case 'da':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("AcmB1")));
        case 'de':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("eBZC4")));
        case 'en-GB':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("aQguK")));
        case 'en-US':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("34B0a")));
        case 'en-XA':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("cxnmS")));
        case 'en-XB':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4EYTl")));
        case 'en-ZZ':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("bJtGs")));
        case 'en':
            return $e7828c42cee8f105$var$importHelper(await Promise.resolve((parcelRequire("8eaIp"))));
        case 'es':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("j11u3")));
        case 'et':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4Iu9a")));
        case 'fi':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2Nl1L")));
        case 'fr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("iFn6p")));
        case 'hr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("b3s7K")));
        case 'hu':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("1TvLV")));
        case 'it':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("f2hYx")));
        case 'ja':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4CBdR")));
        case 'ko':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("1RKr2")));
        case 'nb':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("bhjSn")));
        case 'nl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("9bBvZ")));
        case 'pl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("lHU96")));
        case 'pt-BR':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("7uvFj")));
        case 'ro':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("845sW")));
        case 'ru':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("gu9bW")));
        case 'sl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2jE4Q")));
        case 'sr-RS':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("fXcft")));
        case 'sr-YR':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("iQ2Vw")));
        case 'sr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("gtYuO")));
        case 'sv':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("asYPk")));
        case 'th':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("3jL6F")));
        case 'tr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("dt5Ek")));
        case 'uk':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("8CrAA")));
        case 'vi':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("5Xak2")));
        case 'zh-CN':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2x03E")));
        case 'zh-TW':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4a5zq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8eaIp));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6Ey85 = parcelRequire("6Ey85");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1b8402c44ebac4e9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1b8402c44ebac4e9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ls6Zj")));
        case 'da':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("15mZm")));
        case 'de':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("doZ7S")));
        case 'en-GB':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("diQmT")));
        case 'en-US':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("7hpmi")));
        case 'en-XA':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("8Fw4S")));
        case 'en-XB':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("l1He6")));
        case 'en-ZZ':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ilTZL")));
        case 'en':
            return $1b8402c44ebac4e9$var$importHelper(await Promise.resolve((parcelRequire("6Ey85"))));
        case 'es':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("3BLr5")));
        case 'et':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("cAkqT")));
        case 'fi':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("2pYQB")));
        case 'fr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("hQ4xx")));
        case 'hr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("1gNZX")));
        case 'hu':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("54YVY")));
        case 'it':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("9IWwn")));
        case 'ja':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("5MqOz")));
        case 'ko':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("6O41U")));
        case 'nb':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("dMSCA")));
        case 'nl':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("w1ZQX")));
        case 'pl':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("47Edk")));
        case 'pt-BR':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("i7S8e")));
        case 'ro':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("eM3rX")));
        case 'ru':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("gsuf5")));
        case 'sl':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("3GLTX")));
        case 'sr-RS':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ghIyH")));
        case 'sr-YR':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("kTdQD")));
        case 'sr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ao0pU")));
        case 'sv':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("d5zS6")));
        case 'th':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("kU9Bh")));
        case 'tr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("6gc2r")));
        case 'uk':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("6q3fz")));
        case 'vi':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("l9eWx")));
        case 'zh-CN':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("5qgOk")));
        case 'zh-TW':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("37UgO")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6Ey85));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8tEET = parcelRequire("8tEET");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $97f5f84bf86ebe81$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $97f5f84bf86ebe81$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("iitm0")));
        case 'da':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9a0Kb")));
        case 'de':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9X8kp")));
        case 'en-GB':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("d4wxz")));
        case 'en-US':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("8N0XQ")));
        case 'en-XA':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("qvwys")));
        case 'en-XB':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("jJAhj")));
        case 'en-ZZ':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("aC7Do")));
        case 'en':
            return $97f5f84bf86ebe81$var$importHelper(await Promise.resolve((parcelRequire("8tEET"))));
        case 'es':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("a2hH9")));
        case 'et':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("aGNXV")));
        case 'fi':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3ygJs")));
        case 'fr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("lEm5y")));
        case 'hr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("8yWzv")));
        case 'hu':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("byGSA")));
        case 'it':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("71g5k")));
        case 'ja':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("6HenW")));
        case 'ko':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("5HXUg")));
        case 'nb':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("eODHb")));
        case 'nl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("dLADO")));
        case 'pl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("24VEe")));
        case 'pt-BR':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("40iY1")));
        case 'ro':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("egl1q")));
        case 'ru':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9mMGO")));
        case 'sl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3qFE0")));
        case 'sr-RS':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3wQcD")));
        case 'sr-YR':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("fDOxt")));
        case 'sr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9Eqsz")));
        case 'sv':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("gyn2A")));
        case 'th':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("hhf8Q")));
        case 'tr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9prlg")));
        case 'uk':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("bGNnN")));
        case 'vi':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("glZwc")));
        case 'zh-CN':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("29rck")));
        case 'zh-TW':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3upPm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8tEET));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $7Avpo = parcelRequire("7Avpo");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a91ad1c44fedb273$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a91ad1c44fedb273$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("a0TdC")));
        case 'da':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("gqO11")));
        case 'de':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("80j8c")));
        case 'en-GB':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("ggGPf")));
        case 'en-US':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("eIhkO")));
        case 'en-XA':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("kykTy")));
        case 'en-XB':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("hXpMY")));
        case 'en-ZZ':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("3zH5O")));
        case 'en':
            return $a91ad1c44fedb273$var$importHelper(await Promise.resolve((parcelRequire("7Avpo"))));
        case 'es':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("kMfIv")));
        case 'et':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("6NYY8")));
        case 'fi':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("8yglT")));
        case 'fr':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("i28gE")));
        case 'hr':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("eZ5im")));
        case 'hu':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("g64jS")));
        case 'it':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("e7ciT")));
        case 'ja':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("igB6V")));
        case 'ko':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("70kBu")));
        case 'nb':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("784yx")));
        case 'nl':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("2Gi8T")));
        case 'pl':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("7QniB")));
        case 'pt-BR':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("9DALs")));
        case 'ro':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("gdtHV")));
        case 'ru':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("dwptc")));
        case 'sl':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("gLV0w")));
        case 'sr-RS':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("blQVb")));
        case 'sr-YR':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("1lI9B")));
        case 'sr':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("1pmm2")));
        case 'sv':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("1TOTx")));
        case 'th':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("2SPfj")));
        case 'tr':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("grmIM")));
        case 'uk':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("kLC05")));
        case 'vi':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("eCIUg")));
        case 'zh-CN':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("jioKh")));
        case 'zh-TW':
            return $a91ad1c44fedb273$var$importHelper(await (parcelRequire("hhWJp")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7Avpo));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $57xWx = parcelRequire("57xWx");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6d7e9baaccc5244a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $6d7e9baaccc5244a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("gAEGB")));
        case 'da':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("dMJF5")));
        case 'de':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("6pKIv")));
        case 'en-GB':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("jqwrY")));
        case 'en-US':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("3W8CE")));
        case 'en-XA':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("h214p")));
        case 'en-XB':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("kLlQM")));
        case 'en-ZZ':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("iCeA1")));
        case 'en':
            return $6d7e9baaccc5244a$var$importHelper(await Promise.resolve((parcelRequire("57xWx"))));
        case 'es':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("5rCoM")));
        case 'et':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("aw1rm")));
        case 'fi':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8ITYw")));
        case 'fr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("c0Gtc")));
        case 'hr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("leZEY")));
        case 'hu':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("7tJBP")));
        case 'it':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("5yLqW")));
        case 'ja':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("6yV4D")));
        case 'ko':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("ezNqT")));
        case 'nb':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8tM0n")));
        case 'nl':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("hr9h0")));
        case 'pl':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("lTIc2")));
        case 'pt-BR':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("ghpeV")));
        case 'ro':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("cZ8Qj")));
        case 'ru':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("kEyaV")));
        case 'sl':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8InNC")));
        case 'sr-RS':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("hfnTn")));
        case 'sr-YR':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("67PcB")));
        case 'sr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("22vVN")));
        case 'sv':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("aA24d")));
        case 'th':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("fFh2C")));
        case 'tr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8x8Qx")));
        case 'uk':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("kOrUi")));
        case 'vi':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("c5TSF")));
        case 'zh-CN':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("dlwhB")));
        case 'zh-TW':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("bzFAS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($57xWx));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5j4Cn = parcelRequire("5j4Cn");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b18328e6473975e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8b18328e6473975e$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("dBqKf")));
        case 'da':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("3Qq1K")));
        case 'de':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("dV1W3")));
        case 'en-GB':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("90jP0")));
        case 'en-US':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("iC5L5")));
        case 'en-XA':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("hsrB8")));
        case 'en-XB':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("iJkX5")));
        case 'en-ZZ':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("dcLFo")));
        case 'en':
            return $8b18328e6473975e$var$importHelper(await Promise.resolve((parcelRequire("5j4Cn"))));
        case 'es':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("9l0bw")));
        case 'et':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("ilvnY")));
        case 'fi':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("jCs0C")));
        case 'fr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("5SsPO")));
        case 'hr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("d9xvN")));
        case 'hu':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("frfnt")));
        case 'it':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("inUxe")));
        case 'ja':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("flQhK")));
        case 'ko':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("1OMhC")));
        case 'nb':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("81qiI")));
        case 'nl':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("3BqL6")));
        case 'pl':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("jGcQ3")));
        case 'pt-BR':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("1uDtI")));
        case 'ro':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("lduSs")));
        case 'ru':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("7rL6x")));
        case 'sl':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("13N5z")));
        case 'sr-RS':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("6p4u1")));
        case 'sr-YR':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("hmV0j")));
        case 'sr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("82CEB")));
        case 'sv':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("cqbvt")));
        case 'th':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("4OMwv")));
        case 'tr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("aTMcN")));
        case 'uk':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("cSl8T")));
        case 'vi':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("grGrh")));
        case 'zh-CN':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("4fT85")));
        case 'zh-TW':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("hsL5e")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5j4Cn));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $7BpGO = parcelRequire("7BpGO");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b1f55b02ab5dd48a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b1f55b02ab5dd48a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("6QBDZ")));
        case 'da':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("hsbp6")));
        case 'de':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("5XNq8")));
        case 'en-GB':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("jaglo")));
        case 'en-US':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("lln0M")));
        case 'en-XA':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("4R0PP")));
        case 'en-XB':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("zm9ce")));
        case 'en-ZZ':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2PCg8")));
        case 'en':
            return $b1f55b02ab5dd48a$var$importHelper(await Promise.resolve((parcelRequire("7BpGO"))));
        case 'es':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("cSEky")));
        case 'et':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("8jOSK")));
        case 'fi':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("lqJAb")));
        case 'fr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("hLNRp")));
        case 'hr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("hEaLO")));
        case 'hu':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("edyni")));
        case 'it':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("3v8Uk")));
        case 'ja':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bUyhs")));
        case 'ko':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("4DZSE")));
        case 'nb':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("kZ3Vp")));
        case 'nl':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("5L9Y0")));
        case 'pl':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("9VlSx")));
        case 'pt-BR':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2IZJt")));
        case 'ro':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2IzXu")));
        case 'ru':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bholk")));
        case 'sl':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("8bDhu")));
        case 'sr-RS':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("4wkUe")));
        case 'sr-YR':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("jKH7t")));
        case 'sr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("ax7Wv")));
        case 'sv':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("iXAiR")));
        case 'th':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("1kllb")));
        case 'tr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bMeLJ")));
        case 'uk':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("cGxs1")));
        case 'vi':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bQE6x")));
        case 'zh-CN':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("5fPLI")));
        case 'zh-TW':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2h5uo")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7BpGO));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8nApX = parcelRequire("8nApX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb8ac3a3a164780d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $bb8ac3a3a164780d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("dkP8f")));
        case 'da':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9K0ut")));
        case 'de':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("erGSk")));
        case 'en-GB':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("xzGgN")));
        case 'en-US':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("afhQo")));
        case 'en-XA':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("418JS")));
        case 'en-XB':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("2bn0B")));
        case 'en-ZZ':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("4bOOa")));
        case 'en':
            return $bb8ac3a3a164780d$var$importHelper(await Promise.resolve((parcelRequire("8nApX"))));
        case 'es':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("euHFi")));
        case 'et':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9FYQQ")));
        case 'fi':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9PYIr")));
        case 'fr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("aOs9j")));
        case 'hr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("apYGp")));
        case 'hu':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("bQEQ9")));
        case 'it':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9gMNA")));
        case 'ja':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("bUcVf")));
        case 'ko':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("bE0oF")));
        case 'nb':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("dcBMI")));
        case 'nl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("eayvQ")));
        case 'pl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("ktNCp")));
        case 'pt-BR':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("iF5CO")));
        case 'ro':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("7ynNQ")));
        case 'ru':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("cRdXf")));
        case 'sl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("431S1")));
        case 'sr-RS':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("cLOXU")));
        case 'sr-YR':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9k4WX")));
        case 'sr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("kuR5A")));
        case 'sv':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("8mOnM")));
        case 'th':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("aSGVv")));
        case 'tr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("akt5W")));
        case 'uk':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("6Mt5i")));
        case 'vi':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("fSpz2")));
        case 'zh-CN':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("10c2u")));
        case 'zh-TW':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("fzjVn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8nApX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kHXyL = parcelRequire("kHXyL");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9580f92347c74f32$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9580f92347c74f32$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("1d7Xm")));
        case 'da':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("fhIlA")));
        case 'de':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("97nLs")));
        case 'en-GB':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("hnGKA")));
        case 'en-US':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("3Lnvg")));
        case 'en-XA':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("2uM3C")));
        case 'en-XB':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("8yElw")));
        case 'en-ZZ':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("auCC2")));
        case 'en':
            return $9580f92347c74f32$var$importHelper(await Promise.resolve((parcelRequire("kHXyL"))));
        case 'es':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("3WFy2")));
        case 'et':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("4vHmF")));
        case 'fi':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("lYcKE")));
        case 'fr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("9G9oT")));
        case 'hr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("8iP56")));
        case 'hu':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("iDdYL")));
        case 'it':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("7sVxF")));
        case 'ja':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("1NRP3")));
        case 'ko':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("eSyFb")));
        case 'nb':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("jiKDf")));
        case 'nl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("lOf4U")));
        case 'pl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("14cLa")));
        case 'pt-BR':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("7gvhr")));
        case 'ro':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("isYx2")));
        case 'ru':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("2ivap")));
        case 'sl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("bspFP")));
        case 'sr-RS':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("iT7Bj")));
        case 'sr-YR':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("1ufvN")));
        case 'sr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("gummO")));
        case 'sv':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("4kqhJ")));
        case 'th':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("gip1e")));
        case 'tr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("lRss2")));
        case 'uk':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("kSxqn")));
        case 'vi':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("452Wi")));
        case 'zh-CN':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("jJkiB")));
        case 'zh-TW':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("fVcfA")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kHXyL));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jeVa2 = parcelRequire("jeVa2");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1cfeadb092a11e96$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1cfeadb092a11e96$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("8jtTq")));
        case 'da':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("cv3GI")));
        case 'de':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("ZXTsi")));
        case 'en-GB':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("lY5PF")));
        case 'en-US':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("9V8xD")));
        case 'en-XA':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("7pWep")));
        case 'en-XB':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("6rKzg")));
        case 'en-ZZ':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("2oKaF")));
        case 'en':
            return $1cfeadb092a11e96$var$importHelper(await Promise.resolve((parcelRequire("jeVa2"))));
        case 'es':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("41esF")));
        case 'et':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("dRD1P")));
        case 'fi':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("fFTG6")));
        case 'fr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("bCI0M")));
        case 'hr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("4l9p8")));
        case 'hu':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("brtXp")));
        case 'it':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("FE06j")));
        case 'ja':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("4QkHm")));
        case 'ko':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("gbbp3")));
        case 'nb':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("e82Fu")));
        case 'nl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("e6FoT")));
        case 'pl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("fhiWh")));
        case 'pt-BR':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("aWZX5")));
        case 'ro':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("aV1kH")));
        case 'ru':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("6f7fJ")));
        case 'sl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("7y5pr")));
        case 'sr-RS':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("jHNNf")));
        case 'sr-YR':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("8Qs2q")));
        case 'sr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("kVBlv")));
        case 'sv':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("46N3z")));
        case 'th':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("l5yjD")));
        case 'tr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("gM1Sd")));
        case 'uk':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("jcc6B")));
        case 'vi':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("eSb44")));
        case 'zh-CN':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("ab3Wu")));
        case 'zh-TW':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("4KkWY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jeVa2));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kMgxO = parcelRequire("kMgxO");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $193ea6a661b759dc$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $193ea6a661b759dc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("myuXu")));
        case 'da':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1Zl29")));
        case 'de':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("3ktao")));
        case 'en-GB':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("aTDX5")));
        case 'en-US':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("gMxgr")));
        case 'en-XA':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1Af9x")));
        case 'en-XB':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("buXa0")));
        case 'en-ZZ':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("ccbpW")));
        case 'en':
            return $193ea6a661b759dc$var$importHelper(await Promise.resolve((parcelRequire("kMgxO"))));
        case 'es':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("j434L")));
        case 'et':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("dMsU4")));
        case 'fi':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("jyRDE")));
        case 'fr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("9pglX")));
        case 'hr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("iozT6")));
        case 'hu':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("dJrYt")));
        case 'it':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7B9fx")));
        case 'ja':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7GCXU")));
        case 'ko':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("eDQJt")));
        case 'nb':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("h2jfy")));
        case 'nl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("jFjcD")));
        case 'pl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("2pDy6")));
        case 'pt-BR':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7ef6d")));
        case 'ro':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("na8Hk")));
        case 'ru':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("cgktE")));
        case 'sl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1I6NP")));
        case 'sr-RS':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("9BVla")));
        case 'sr-YR':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("cZ5ja")));
        case 'sr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("im5oS")));
        case 'sv':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("e6ztg")));
        case 'th':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("lTjdd")));
        case 'tr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("f1Q5v")));
        case 'uk':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("gDyIy")));
        case 'vi':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("9JZXX")));
        case 'zh-CN':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("e8Hp5")));
        case 'zh-TW':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("2iQNZ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kMgxO));
    }
};



var $3nDO6 = parcelRequire("3nDO6");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $l7nJS = parcelRequire("l7nJS");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9d7691261b962abe$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9d7691261b962abe$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("7F3wY")));
        case 'da':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("5ThXX")));
        case 'de':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("ifLF0")));
        case 'en-GB':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("hQpPC")));
        case 'en-US':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("grX31")));
        case 'en-XA':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("56m6k")));
        case 'en-XB':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("j2jty")));
        case 'en-ZZ':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("aUTQd")));
        case 'en':
            return $9d7691261b962abe$var$importHelper(await Promise.resolve((parcelRequire("l7nJS"))));
        case 'es':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("2lc7b")));
        case 'et':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("9De0h")));
        case 'fi':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("dPQCn")));
        case 'fr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("a3wwm")));
        case 'hr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("N8n34")));
        case 'hu':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("f73Ab")));
        case 'it':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("d1TD1")));
        case 'ja':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("hqk7Y")));
        case 'ko':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("6JSr6")));
        case 'nb':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("PTBOV")));
        case 'nl':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("BDhK6")));
        case 'pl':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("az4lL")));
        case 'pt-BR':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("kjp2o")));
        case 'ro':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("3G2oA")));
        case 'ru':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("eDz89")));
        case 'sl':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("j0FpS")));
        case 'sr-RS':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("3VhJA")));
        case 'sr-YR':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("gsLZE")));
        case 'sr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("ebIbe")));
        case 'sv':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("eJp0O")));
        case 'th':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("hXakN")));
        case 'tr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("dn1vt")));
        case 'uk':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("3kGQX")));
        case 'vi':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("fcA9B")));
        case 'zh-CN':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("ayJEf")));
        case 'zh-TW':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("eWB3S")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($l7nJS));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6e6y3 = parcelRequire("6e6y3");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9c1e78a592d7dad$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a9c1e78a592d7dad$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("idRZz")));
        case 'da':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("7d8jN")));
        case 'de':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("eJosu")));
        case 'en-GB':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fSR9p")));
        case 'en-US':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("2aOul")));
        case 'en-XA':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("8KWRB")));
        case 'en-XB':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("aD6lN")));
        case 'en-ZZ':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("ht1nW")));
        case 'en':
            return $a9c1e78a592d7dad$var$importHelper(await Promise.resolve((parcelRequire("6e6y3"))));
        case 'es':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("6TdpN")));
        case 'et':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("3dPbj")));
        case 'fi':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("bNrrT")));
        case 'fr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fzWvN")));
        case 'hr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("k9LUw")));
        case 'hu':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("7NEGR")));
        case 'it':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fHFaz")));
        case 'ja':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("lB4Ue")));
        case 'ko':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("hcpTt")));
        case 'nb':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("lLSQO")));
        case 'nl':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("04L3J")));
        case 'pl':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("7Gmd2")));
        case 'pt-BR':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("eCPZn")));
        case 'ro':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("2siS3")));
        case 'ru':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("jYxQj")));
        case 'sl':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("i2pRS")));
        case 'sr-RS':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("6851R")));
        case 'sr-YR':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("79owM")));
        case 'sr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fOIhl")));
        case 'sv':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("dgcZd")));
        case 'th':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("hR3zt")));
        case 'tr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("kHeB2")));
        case 'uk':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("jX25P")));
        case 'vi':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("inesZ")));
        case 'zh-CN':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("4hAqw")));
        case 'zh-TW':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("62O4L")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6e6y3));
    }
};



var $kdvUL = parcelRequire("kdvUL");

const $15113d446a8ed41e$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $bce6c13b69697278$export$720676d8cac8fbb)(locale),
        (0, $e84fe42f89af6fb4$export$720676d8cac8fbb)(locale),
        (0, $41aea332c559312c$export$720676d8cac8fbb)(locale),
        (0, $c806437e9ab3c705$export$720676d8cac8fbb)(locale),
        (0, $4954c74f42031292$export$720676d8cac8fbb)(locale),
        (0, $4d103c8ed05eb4fd$export$720676d8cac8fbb)(locale),
        (0, $f1d52e5870ae9a59$export$720676d8cac8fbb)(locale),
        (0, $0730a88e59717014$export$720676d8cac8fbb)(locale),
        (0, $8SCD0.messagesLoader)(locale),
        (0, $d75107a999e7d9fe$export$720676d8cac8fbb)(locale),
        (0, $9b7fe572d491aa75$export$720676d8cac8fbb)(locale),
        (0, $2ef667146b868deb$export$720676d8cac8fbb)(locale),
        (0, $05f1fcbef8ad6b50$export$720676d8cac8fbb)(locale),
        (0, $b27778c6df0a1ea3$export$720676d8cac8fbb)(locale),
        (0, $e7828c42cee8f105$export$720676d8cac8fbb)(locale),
        (0, $1b8402c44ebac4e9$export$720676d8cac8fbb)(locale),
        (0, $97f5f84bf86ebe81$export$720676d8cac8fbb)(locale),
        (0, $a91ad1c44fedb273$export$720676d8cac8fbb)(locale),
        (0, $6d7e9baaccc5244a$export$720676d8cac8fbb)(locale),
        (0, $8b18328e6473975e$export$720676d8cac8fbb)(locale),
        (0, $b1f55b02ab5dd48a$export$720676d8cac8fbb)(locale),
        (0, $bb8ac3a3a164780d$export$720676d8cac8fbb)(locale),
        (0, $9580f92347c74f32$export$720676d8cac8fbb)(locale),
        (0, $1cfeadb092a11e96$export$720676d8cac8fbb)(locale),
        (0, $193ea6a661b759dc$export$720676d8cac8fbb)(locale),
        (0, $3nDO6.messagesLoader)(locale),
        (0, $9d7691261b962abe$export$720676d8cac8fbb)(locale),
        (0, $a9c1e78a592d7dad$export$720676d8cac8fbb)(locale),
        (0, $kdvUL.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $15113d446a8ed41e$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $jQRRW.withIntlProvider)({
        messagesLoader: $15113d446a8ed41e$export$d5a462ce7bd04520
    }, Component);
};


const $0381e4ebc4c9b908$export$c32237a999261c49 = (input)=>(0, $1f89a5665998c680$export$ec890b48cae4cc1c)({
        scopes: $6dedf2638d31103b$export$54a06e3f4a159ad8
    })(input);
const $0381e4ebc4c9b908$export$c60b43809441c5b0 = (0, $15113d446a8ed41e$export$b0eee5de066b2bf5)((0, $2mPpz.createPlacementComponent)((0, $23990983e3348fe0$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const newDismissalLogicIsEnabled = (0, $c6GJD.default).checkGate('post-office_ssf-enable-new-dismissal-logic');
    if (newDismissalLogicIsEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $06473bad2d5b4749$export$ba528679f358bf09), {
        ...props
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)($0381e4ebc4c9b908$var$ScreenSpaceFlagsPlacementOriginalDismissals, {
        ...props
    });
}), {
    choreographer: {
        isDefaultEnabled: true
    }
}));
const $0381e4ebc4c9b908$var$ScreenSpaceFlagsPlacementOriginalDismissals = ({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const isEPExternalMessageSSFEnabled = (0, $c6GJD.default).checkGate('post-office_enable_ep_external_message_web');
    const isEPExternalMessageSSREnabled = (0, $c6GJD.default).checkGate('post-office_enabled_ep_external_message_ssr');
    const [localMessageState, setLocalMessageState] = (0, $42omo.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? preloadedInitialData?.messages : undefined;
        return undefined;
    });
    const [localExternalMessageState, setLocalExternalMessageState] = (0, $42omo.useState)(()=>{
        // Initialize from preloadedInitialData only if both feature gates are enabled
        if (isEPExternalMessageSSREnabled && isEPExternalMessageSSFEnabled && preloadedInitialData?.externalMessages) return preloadedInitialData.externalMessages.length > 0 ? preloadedInitialData.externalMessages : undefined;
        return undefined;
    });
    (0, $6Ht9d.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $cpPWT.useMessagePlacementHooks)();
    const handleDismiss = (0, $42omo.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        if (isEPExternalMessageSSREnabled && isEPExternalMessageSSFEnabled) {
            // NEW LOGIC: Improved dismissal handling with precise checking and state tracking
            let updatedLocalMessageState;
            // Check if message is in localMessageState
            setLocalMessageState((current)=>{
                if (current?.some((msg)=>msg.messageInstanceId === messageInstanceId)) {
                    const newState = current.filter((e)=>e.messageInstanceId !== messageInstanceId);
                    updatedLocalMessageState = newState;
                    if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                        messages: newState,
                        externalMessages: preloadedInitialData?.externalMessages
                    });
                    return newState;
                }
                return current;
            });
            // Check if message is in localExternalMessageState
            setLocalExternalMessageState((current)=>{
                if (current?.some((msg)=>msg.messageInstanceId === messageInstanceId)) {
                    const newState = current.filter((e)=>e.messageInstanceId !== messageInstanceId);
                    const updatedExternalMessages = newState.length > 0 ? newState : undefined;
                    if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                        messages: updatedLocalMessageState ?? preloadedInitialData?.messages ?? [],
                        externalMessages: updatedExternalMessages
                    });
                    return updatedExternalMessages;
                }
                return current;
            });
        } else // OLD LOGIC: Original behavior when feature gate is disabled
        setLocalMessageState((current)=>{
            if (current) {
                const newState = current.filter((e)=>e.messageInstanceId !== messageInstanceId);
                if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                    messages: newState
                });
                return newState;
            }
            return undefined;
        });
    }, [
        setPreloadedInitialData,
        preloadedInitialData,
        isEPExternalMessageSSFEnabled,
        isEPExternalMessageSSREnabled
    ]);
    const onDismissed = (0, $42omo.useCallback)((_messageInstanceId)=>{
        setLocalMessageState([]);
        if (isEPExternalMessageSSREnabled && isEPExternalMessageSSFEnabled) {
            // NEW LOGIC: Clear external message state and update preloadedInitialData
            setLocalExternalMessageState(undefined);
            if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                messages: [],
                ...isEPExternalMessageSSFEnabled && {
                    externalMessages: undefined
                }
            });
        } else // OLD LOGIC: Only clear regular messages
        if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
            messages: []
        });
    }, [
        setPreloadedInitialData,
        isEPExternalMessageSSFEnabled,
        isEPExternalMessageSSREnabled
    ]);
    (0, $42omo.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $42omo.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $42omo.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    const activeScopes = (0, $1f89a5665998c680$export$daf66a67c26dc848)({
        scopes: $6dedf2638d31103b$export$54a06e3f4a159ad8,
        treatIntersectionAsSame: (0, $c6GJD.default).checkGate('post-office-ssf-treat-intersection-as-same')
    });
    const messagesState = (0, $j0Fou.usePlacementApi)('/update-messages', {
        queryParams: {
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: (0, $c6GJD.default).checkGate('post-office-ssf-enable-continuous-auto-refetch') ? !!activeScopes.updateKey && !localMessageState?.length : !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) {
            const messages = messagesState.data.messages;
            let selectedMessage;
            // New experiments in the screen-space-flags placement must be added to the EXPERIMENTAL_MESSAGES list
            for (const message of messages){
                const experimentalMessage = (0, $34734b2d588fba6f$export$963cdca6c7580c53).find((p)=>p.messageTemplateId === message.messageTemplateId);
                if (experimentalMessage) {
                    const cohort = (0, $c6GJD.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                        fireExperimentExposure: true
                    });
                    if (experimentalMessage?.statsigAAExperiment) (0, $c6GJD.default).getExperimentValue(experimentalMessage.statsigAAExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                        fireExperimentExposure: true
                    });
                    if (cohort === experimentalMessage.statsigTestCohort) {
                        selectedMessage = message;
                        break;
                    }
                } else {
                    selectedMessage = message;
                    break;
                }
            }
            setLocalMessageState(selectedMessage ? [
                selectedMessage
            ] : []);
        }
        if (isEPExternalMessageSSFEnabled && messagesState.data?.externalMessages?.length) setLocalExternalMessageState(messagesState.data.externalMessages);
    }, [
        messagesState.data
    ]);
    const { triggerStates: epTriggerStates, EpTriggerWrapper: EpTriggerWrapper } = (0, $59232e6304ca41ab$export$7dae77a66c2e7b7e)(isEPExternalMessageSSFEnabled ? localExternalMessageState : undefined);
    // find if an EP message has been triggered
    const activeEpMessageInstanceId = isEPExternalMessageSSFEnabled ? Object.keys(epTriggerStates).find((messageInstanceId)=>epTriggerStates[messageInstanceId] === true) : undefined;
    // Check for EP External messages first because they are not rendered until triggered from the front-end
    // and they will not be rendered if a non-ep message is currently rendered due to the choreographer
    const [currentLocalMessage] = localMessageState ?? [];
    const currentExternalMessage = localExternalMessageState?.find((msg)=>msg.messageInstanceId === activeEpMessageInstanceId);
    const activeExternalMessage = isEPExternalMessageSSFEnabled && activeEpMessageInstanceId ? currentExternalMessage : currentLocalMessage;
    const messageToRender = currentLocalMessage ?? activeExternalMessage;
    const content = (0, $c6GJD.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e1aac9cee19c4445$export$32c78d11bbf53e24), {
        children: messageToRender ? /*#__PURE__*/ (0, $42omo.createElement)((0, $90021a5e9b56864d$export$2df1250b8f917a59), {
            ...messageToRender,
            key: messageToRender.messageInstanceId,
            id: messageToRender.messageInstanceId,
            messageInstanceId: messageToRender.messageInstanceId,
            onDismissed: onDismissed,
            SuspenseBoundary: (0, $cyz5M.MaybeSuspenseBoundary),
            jiraFlagsService: jiraFlagsService,
            onError: reportUnexpectedError,
            reportExpectedError: reportExpectedError
        }) : null
    }) : null;
    // Wrap content with trigger tracker components if feature gate is enabled
    return isEPExternalMessageSSFEnabled ? /*#__PURE__*/ (0, $l998X.jsx)(EpTriggerWrapper, {
        children: content
    }) : content;
};
var $0381e4ebc4c9b908$export$2e2bcd8739ae039 = $0381e4ebc4c9b908$export$c60b43809441c5b0;



var $9QvUi = parcelRequire("9QvUi");











var $kO3gu = parcelRequire("kO3gu");

const $47d6b670e406d296$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $47d6b670e406d296$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $47d6b670e406d296$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $42omo.useMemo)(()=>{
        if (returnOverride) return $47d6b670e406d296$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $47d6b670e406d296$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
const $47d6b670e406d296$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $47d6b670e406d296$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($47d6b670e406d296$export$e5ffd38dcf6e5c53, $47d6b670e406d296$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $47d6b670e406d296$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $47d6b670e406d296$var$stringifyPayload(payload)
        });
    };
const $47d6b670e406d296$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $47d6b670e406d296$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($47d6b670e406d296$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $47d6b670e406d296$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};


const $29f905239c235f73$export$52e362b70e115c68 = (0, $47d6b670e406d296$export$52e362b70e115c68);
const $29f905239c235f73$export$c05392ff95b4319d = (0, $47d6b670e406d296$export$c05392ff95b4319d);




var $lAJUP = parcelRequire("lAJUP");




const $95ecb474353a02ba$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $29f905239c235f73$export$52e362b70e115c68), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9QvUi.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $95ecb474353a02ba$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $6yHRM.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $l998X.jsx)($95ecb474353a02ba$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $0381e4ebc4c9b908$export$c60b43809441c5b0),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");





var $bQm3c = parcelRequire("bQm3c");





var $0VKZa = parcelRequire("0VKZa");

const $ccd0dc06d2167081$export$f6564e60882bdf90 = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const [messageErrorToReport, setMessageErrorToReport] = (0, $42omo.useState)();
    const [preloadedInitialData, setPreloadedInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('screen-space-flags/update-messages');
    const memoizedPlacementProps = (0, $42omo.useMemo)(()=>({
            reportExpectedError: (0, $7Sm4c.markErrorAsHandled),
            reportUnexpectedError: setMessageErrorToReport,
            preloadedInitialData: preloadedInitialData,
            setPreloadedInitialData: setPreloadedInitialData
        }), [
        preloadedInitialData,
        setPreloadedInitialData
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    if ((0, $9wGTI.fg)('confluence-screen-space-overlay-no-anonymous-users')) {
        if (!userId) return null;
    }
    return (0, $9wGTI.fg)('post-office-screen-space-overlay-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95ecb474353a02ba$export$46db7cd62b063064), {
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9QvUi.default), {
        placementId: "screen-space-flags",
        // @ts-ignore - Type 'ComponentType<ErrorBoundariedProps<Placement>>' is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $0381e4ebc4c9b908$export$c60b43809441c5b0),
        placementProps: memoizedPlacementProps,
        disableInitialData: true
    }), messageErrorToReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: messageErrorToReport
    }))) : null;
});
const $ccd0dc06d2167081$export$1966d6abb8c3b6 = async (preloadedSessionContext, match)=>{
    const activeScopes = (0, $0381e4ebc4c9b908$export$c32237a999261c49)({
        route: {
            hostname: '',
            pathname: match?.pathname ?? '',
            search: match?.search ?? ''
        },
        context: (0, $0VKZa.sessionToPostOfficeContext)(preloadedSessionContext)
    });
    const updateMessagesBody = {
        current: activeScopes,
        previous: []
    };
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('screen-space-flags', preloadedSessionContext, {
        resource: '/update-messages',
        requestInit: {
            method: 'POST',
            body: JSON.stringify(updateMessagesBody)
        }
    });
};








async function $f217a7781374a3c1$export$5ab53e93f975c926(match) {
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId } = preloadedSessionContext;
    if (!userId || !match) return;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ScreenSpaceFlags', async ()=>{
        return (0, $ccd0dc06d2167081$export$1966d6abb8c3b6)(preloadedSessionContext, match);
    });
}


















var $6wbAc = parcelRequire("6wbAc");

async function $143cdfd4eb3dc7a0$export$f8ed1334515840af(spaceKey) {
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        const result = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $6wbAc.SpaceRestrictionCheckQuery),
                variables: {
                    spaceKey: spaceKey
                },
                errorPolicy: 'all',
                // Preloaders are called both on server at initial load AND transition on client-side.
                // On server-side it doesn't matter fetch policy because we only gonna request once.
                // On client-side it must be network-only to get fresh data.
                // At usage we use getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery to get from preloaded cache.
                fetchPolicy: 'network-only'
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        window['__SPACE_RESTRICTED_CHECK_ERROR__'] = false;
        window['__SPACE_NOTFOUND_CHECK_ERROR__'] = false;
        if (result?.errors) result.errors.forEach((error)=>{
            const status_code = error?.extensions?.statusCode;
            if (status_code === 403) {
                window['__SPACE_RESTRICTED_CHECK_ERROR__'] = true;
                (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (status_code === 404 || status_code === 400) {
                window['__SPACE_NOTFOUND_CHECK_ERROR__'] = true;
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        });
    } else {
        const queryResult = (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $6wbAc.SpaceRestrictionCheckQuery),
            variables: {
                spaceKey: spaceKey
            },
            errorPolicy: 'all',
            fetchPolicy: 'network-only'
        });
        return queryResult.then((result)=>{
            window['__SPACE_RESTRICTED_CHECK_ERROR__'] = false;
            window['__SPACE_NOTFOUND_CHECK_ERROR__'] = false;
            if (result?.errors) result.errors.forEach((error)=>{
                const status_code = error?.extensions?.statusCode;
                if (status_code === 403) {
                    window['__SPACE_RESTRICTED_CHECK_ERROR__'] = true;
                    (0, $7Sm4c.markErrorAsHandled)(error);
                } else if (status_code === 404 || status_code === 400) {
                    window['__SPACE_NOTFOUND_CHECK_ERROR__'] = true;
                    (0, $7Sm4c.markErrorAsHandled)(error);
                }
            });
            return result;
        }, (error)=>{
            return Promise.reject(error);
        });
    }
}


const $f7b10b9020854fc7$export$6fb7f9b73aaa748e = async (spaceKey)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $143cdfd4eb3dc7a0$export$f8ed1334515840af)(spaceKey)
    ]);
};


async function $e80763d537fd4542$export$6aefe8c2dfd7fe98(url) {
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE) || match?.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match?.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || match?.experience === (0, $irVI7.LIVE_PAGE_VIEW_EXPERIENCE)) return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $9fLxI.getExtensionManifest)({
            spaceKey: match.params.spaceKey
        }),
        (0, $8nle6.preloadSpaceDetail)(match.params.spaceKey),
        (0, $821e100427ee88aa$export$ce64f7b5556cdb62)(),
        (0, $88b2ba3b9422ec6a$export$3837c35a0d92ab93)()
    ]);
}
async function $e80763d537fd4542$export$57d895781a697848(url, isTransition = false, previousMatch = null, preloadOptions) {
    const commonTasks = [];
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience) (0, $df23aac6d1130849$export$7388eaba0b85ff24)(match.experience);
    /**
   * There are synchronous operations in preparing session data.
   * All queries that independent to session data should be fired first.
   */ if (!isTransition) {
        commonTasks.push((0, $29df517881fdeca7$export$990c5eb6cb59ce1c)());
        if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) commonTasks.push((0, $55fac8bf1a108c66$export$ece352750a2c4ea1)(), (0, $c841b55372d4071a$export$96f49c018063fe60)());
        if (match?.experience === (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE)) // The PDF export route only renders a specific Confluence page's title and content.
        // So, we don't need to fetch data for certain common Confluence features and preferences such as navigation and user settings.
        // Note 1: PDF export is not a SSR capability and also need not support SPA transitions, as it is only accessible via direct URL.
        commonTasks.push(// Remote local storage
        (0, $eiCiP.preloadLocalStorage)(), // Forge UI user profile
        (0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
        else if (match?.experience !== (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE)) {
            // external share doesn't have navigation, returns only errors
            commonTasks.push((0, $eiCiP.preloadLocalStorage)(), (0, $5368439faec350a5$export$6c7e4784651f052f)());
            if (//this will preload nav4 queries even when users are opted out. This is because
            //we do not have access to site settings, user Preferences, or local storage at this point in the preloading
            (0, $9wGTI.fg)('confluence_nav_4') || (0, $9wGTI.fg)('confluence_nav4_ga_phase_1') || (0, $9wGTI.fg)('confluence_nav4_ga_phase_2') || (0, $6mKj3.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false)) {
                //new for nav4 queries
                commonTasks.push((0, $c63485f681d81d31$export$693b572d94b96722)());
                commonTasks.push((0, $99732775da1ff29d$export$dfd129d3c3f4c561)());
                if ((0, $6mKj3.expVal)('confluence_app_navigation_preloading_in_suspense', 'isEnabled', false)) commonTasks.push((0, $eS4vC.createDataFetcherForSuspense)('top-nav', ()=>[
                        (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)(),
                        (0, $c3ef336b2b86bed6$export$2d0f6d5aa0911699)(),
                        (0, $3y1ko.preloadShortcutEnabledState)()
                    ]));
                else {
                    commonTasks.push((0, $c3ef336b2b86bed6$export$2d0f6d5aa0911699)());
                    commonTasks.push((0, $eS4vC.createDataFetcherForSuspense)('top-nav', ()=>[
                            (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)(),
                            (0, $3y1ko.preloadShortcutEnabledState)()
                        ]));
                }
                commonTasks.push((0, $34aa8f5c495a6ba2$export$3efc211209d16247)());
            } else commonTasks.push((0, $c3ef336b2b86bed6$export$2d0f6d5aa0911699)());
            if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) commonTasks.push((0, $da1fd1e44d7582fe$export$b4f1825d0b62630d)());
            if ((0, $9wGTI.fg)('twcg-206_confluence_upgrade_permanent_free_fg')) commonTasks.push((0, $6fde6b8ecb80ae64$export$822712ef6af09820)());
            // https://switcheroo.atlassian.com/ui/gates/0d974cd3-c266-43ed-9312-0980df443012/key/post-office_screen-space-flags-confluence-ssr
            if ((0, $9wGTI.fg)('post-office_screen-space-flags-confluence-ssr')) commonTasks.push((0, $f217a7781374a3c1$export$5ab53e93f975c926)(match));
            commonTasks.push((0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
            const experience = match?.experience;
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: [
                    (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE),
                    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
                ].includes(experience) ? match?.query?.themeState : undefined
            }));
            if ((0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) commonTasks.push((0, $1f8e7f4831866dd9$export$f92adbce3a1ce419)());
        }
    }
    if (!match) // Following code are specific to each route.
    // If we don't get a match here then there is nothing interesting
    return Promise.resolve();
    let routeTasks = Promise.resolve();
    const commonRouteTasks = [];
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        // Routes can have common data if the route has a space key
        const spaceKey = match?.params?.spaceKey;
        if (spaceKey) commonRouteTasks.push((0, $f7b10b9020854fc7$export$6fb7f9b73aaa748e)(spaceKey));
    // TODO: We should do similar for content id here
    // but currently preloadPageRestrictionsQuery is spread out in each individual route.
    }
    if (match.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE)) {
        const { isLivePage: isLivePageSSR } = (0, $60cDW.getSSRRenderInputs)();
        // On transition, validate whether we're a live doc. If so, only preload live doc routes, not all view page routes. Prevents unnecessary GQL calls, e.g. ContentUnifiedQuery.
        let isLivePageTransition = false;
        const contentId = match?.params?.contentId;
        if (contentId && !isLivePageSSR) {
            const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
            isLivePageTransition = isTransition && subType === 'live' && isArchived === false;
        }
        routeTasks = isLivePageSSR || isLivePageTransition ? (0, $iUV81.preloadLivePageRoute)(match, url) : (0, $445d6fd463fd83fa$export$9503d022471fff24)(match, url, isTransition, previousMatch);
    } else if (match.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match.experience === (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE)) {
        if (preloadOptions?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) routeTasks = (0, $fe22b38e04163065$export$75a73f2fbf5e96e8)(match);
        else routeTasks = (0, $fe22b38e04163065$export$75071d943b36f58f)(match, previousMatch, url);
    } else if (match.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE)) routeTasks = (0, $d639d659544153c3$export$a107836a8bcfc0c9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.DATABASE_EXPERIENCE)) routeTasks = (0, $f7a595baa9e6d446$export$f9f9f93ef86bfae1)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EMBED_EXPERIENCE)) routeTasks = (0, $a17ca091e4cf9f3d$export$18e29f32c47bffc9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE)) routeTasks = (0, $ff76ae367134cd26$export$2a230d51c69b591b)(match.params.contentId);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) routeTasks = (0, $32e736695aa13b8b$export$8abf4a07f4444858)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.HOME_EXPERIENCE)) routeTasks = (0, $179951d621935e1e$export$cefc517f3ae2aa98)(match);
    else if (match.experience === (0, $irVI7.SPACE_PAGES_EXPERIENCE)) routeTasks = (0, $106eac55bed5d4af$export$206b1c2d74bc11a2)(match);
    else if (match.experience === (0, $irVI7.CONTENT_HISTORY_EXPERIENCE)) routeTasks = (0, $0ef4e79dd69588ad$export$9f53340e87bacbbd)(match);
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $lyWac.waitForAllReturnWhenError)([
            (0, $eS4vC.createDataFetcherForSuspense)('default', ()=>[
                    routeTasks,
                    ...commonRouteTasks
                ]),
            ...commonTasks
        ]).then((errors)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (errors) for (const e of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(e);
        });
    })();
}
async function $e80763d537fd4542$export$faa68b5324f40037(pageUrl) {
    const match = $e80763d537fd4542$var$matchRoute(pageUrl);
    if (!match) return;
    if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $73df6e46d3afaa7c$export$9c3872cc60e7dbce)(match, pageUrl);
}
function $e80763d537fd4542$var$matchRoute(url) {
    let match;
    let experience;
    if (match = (0, $kM8fE.matchViewPage)(url)) experience = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchWhiteboardPage)(url)) experience = (0, $irVI7.WHITEBOARD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpaceOverview)(url)) experience = (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE);
    else if (match = (0, $kM8fE.matchCompanyHub)(url)) experience = (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchHome)(url)) experience = (0, $irVI7.HOME_EXPERIENCE);
    else if (match = (0, $kM8fE.matchFabricEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchExternalShare)(url)) experience = (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpacePages)(url)) experience = (0, $irVI7.SPACE_PAGES_EXPERIENCE);
    else if (match = (0, $kM8fE.matchContentHistory)(url)) experience = (0, $irVI7.CONTENT_HISTORY_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbeddedEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchDatabasePage)(url)) experience = (0, $irVI7.DATABASE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbedPage)(url)) experience = (0, $irVI7.EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSmartCreateEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE);
    else if ((0, $kM8fE.matchPdfExport)(url)) {
        match = (0, $kM8fE.matchPdfExport)(url);
        experience = (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE);
    }
    return match && {
        ...match,
        experience: experience
    };
}
async function $e80763d537fd4542$export$bd8e570400e2d126() {
    const pageUrl = window.location.toString();
    // Extensions Manifest and extensions data (when preloading is requested for them)
    // are heavy and should not be loaded on server side and embedded into HTML.
    $e80763d537fd4542$export$6aefe8c2dfd7fe98(pageUrl);
    if (window.__SSR_RENDERED__) $e80763d537fd4542$export$faa68b5324f40037(pageUrl);
    else $e80763d537fd4542$export$57d895781a697848(pageUrl);
}






var $8PKGr = parcelRequire("8PKGr");


var $aXEzU = parcelRequire("aXEzU");





var $dtDUi = parcelRequire("dtDUi");


var $dA1Sn = parcelRequire("dA1Sn");


var $gnYQc = parcelRequire("gnYQc");





var $68uaC = parcelRequire("68uaC");





var $2DVQX = parcelRequire("2DVQX");


var $id4ij = parcelRequire("id4ij");

const $2bffd0a48908e22c$export$daa1e83127b2f677 = async ()=>{
    const imageElements = Array.prototype.slice.call(document.getElementById('content') ? document.getElementById('content').querySelectorAll('img') : []);
    window._contentMediaSources = imageElements.filter((element)=>(0, $id4ij.isPartOfElementStillInViewPort)(element)).map((element)=>element.src);
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");


var $4xcIM = parcelRequire("4xcIM");





var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $3pfAb = parcelRequire("3pfAb");








var $fCcUZ = parcelRequire("fCcUZ");


var $kDuN4 = parcelRequire("kDuN4");








var $c3xd8 = parcelRequire("c3xd8");


var $dP3ac = parcelRequire("dP3ac");








const $89c4065b6c91d839$var$noop = ()=>{};
const $89c4065b6c91d839$var$RouteListenerContext = /*#__PURE__*/ (0, $42omo.createContext)({
    update: $89c4065b6c91d839$var$noop
});
const $89c4065b6c91d839$export$7a2084f4baac29a7 = ()=>(0, $f1742253be8873a8$export$92469b55607f005b)();
const $89c4065b6c91d839$export$72fd8977abf03d60 = ()=>(0, $42omo.useContext)($89c4065b6c91d839$var$RouteListenerContext);
const $89c4065b6c91d839$export$755edb1665399d41 = ()=>{
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = $89c4065b6c91d839$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $42omo.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $42omo.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $89c4065b6c91d839$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $89c4065b6c91d839$export$72fd8977abf03d60();
    (0, $42omo.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $89c4065b6c91d839$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $89c4065b6c91d839$export$755edb1665399d41();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($89c4065b6c91d839$var$RouteListenerContext.Provider, {
        value: routeUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yHRM.PostOfficeRouteProvider), route, children));
};



var $3Bn1T = parcelRequire("3Bn1T");





var $4H1Ql = parcelRequire("4H1Ql");





var $5DUgU = parcelRequire("5DUgU");




const $5238aa3ac06c99b9$var$ENGAGEMENT_PLATFORM_CHANNEL = 'engagementPlatform';
const $5238aa3ac06c99b9$var$isPromise = (value)=>{
    return value && typeof value.then === 'function';
};
const $5238aa3ac06c99b9$export$3476bc3bd0845b44 = ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        if (!analyticsClientInstance) return;
        const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
        const userId = restPayload?.userId || attributes?.userId;
        const tenantId = restPayload?.tenantId || attributes?.tenantId;
        if (eventType !== 'track' && eventType !== 'operational') return;
        if (!userId || !tenantId) return;
        // Handle Promise if analyticsClientInstance is a Promise
        const processEvent = (client)=>{
            // Update client with user and tenant info
            try {
                if (tenantId) client.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, tenantId);
                if (userId) client.setUserInfo((0, $5DUgU.userType).ATLASSIAN_ACCOUNT, userId);
            } catch (error) {
                return;
            }
            // Build payload with tenantId at top level (userId is automatically included via setUserInfo)
            const gasPayload = {
                ...restPayload,
                tenantId: tenantId,
                ...attributes ? {
                    attributes: attributes
                } : {}
            };
            if (eventType === 'track') client.sendTrackEvent(gasPayload);
            else if (eventType === 'operational') client.sendOperationalEvent(gasPayload);
        };
        if ($5238aa3ac06c99b9$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
        else processEvent(analyticsClientInstance);
    }, [
        analyticsClientInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: $5238aa3ac06c99b9$var$ENGAGEMENT_PLATFORM_CHANNEL,
        onEvent: handleEvent
    }, children);
};





const $3e0678b32258dc83$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};






var $ltrno = parcelRequire("ltrno");


var $kt8c2 = parcelRequire("kt8c2");

const $9a4b8c66470cb7c0$var$STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const $9a4b8c66470cb7c0$var$CACHE_KEY = 'placement-api';
const $9a4b8c66470cb7c0$var$CACHE_EXPIRY = 120000; // 2 minutes
const $9a4b8c66470cb7c0$var$storageClient = new (0, $kt8c2.default)($9a4b8c66470cb7c0$var$STORAGE_KEY);
const $9a4b8c66470cb7c0$export$3c979fbaa76beaf9 = (cache)=>{
    if (cache instanceof Map && cache.size > 0) {
        const existingCache = $9a4b8c66470cb7c0$export$54eb3e634424b746();
        const mergedCache = new Map([
            ...existingCache,
            ...cache
        ]);
        const appCache = Array.from(mergedCache.entries());
        // localStorage.getItem("POST_OFFICE__CLIENT_CACHE_placement-api")
        $9a4b8c66470cb7c0$var$storageClient.setItemWithExpiry($9a4b8c66470cb7c0$var$CACHE_KEY, appCache, $9a4b8c66470cb7c0$var$CACHE_EXPIRY);
    }
};
const $9a4b8c66470cb7c0$export$54eb3e634424b746 = ()=>{
    if (typeof window === 'undefined') // Return a dummy storage for server-side rendering
    return new Map();
    // When initializing, we restore the data from `localStorage` into a map.
    const cache = $9a4b8c66470cb7c0$var$storageClient.getItem($9a4b8c66470cb7c0$var$CACHE_KEY) || [];
    return new Map(cache);
};
const $9a4b8c66470cb7c0$export$711c5bb855c82238 = (useSWRNext)=>{
    return (key, fetcher, config)=>{
        const { cache: cache } = (0, $ltrno.useSWRConfig)();
        const swr = useSWRNext(key, fetcher, config);
        /**
		 * This will execute even when data is pulled from the local storage cache.
		 * This means that the cache will be updated and the CACHE_EXPIRY reset to be a rolling window.
		 *
		 * We may want to change this behaviour in the future to only update the cache when the data is NOT pulled from the local storage cache.
		 */ (0, $42omo.useEffect)(()=>{
            if (swr.data !== undefined) $9a4b8c66470cb7c0$export$3c979fbaa76beaf9(cache);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            swr.data
        ]);
        return swr;
    };
};


const $7282dd84f12498d5$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const stableEnvironment = (0, $4H1Ql.useStableObject)((0, $3e0678b32258dc83$export$ae3dab16eb1fc2cc)((0, $c3xd8.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $4H1Ql.useStableObject)($7282dd84f12498d5$var$composeConfig((0, $PAiZW.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $42omo.useMemo)(()=>(0, $cpPWT.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7282dd84f12498d5$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3xd8.PostOfficeEnvironmentProvider), {
        value: stableEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $PAiZW.InternalPostOfficeContextProvider), {
        value: stableContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Bn1T.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cpPWT.MessagePlacementProvider), {
        value: memoizedMessagePlacementValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $89c4065b6c91d839$export$31986273b686f5ea), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXjWU.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7282dd84f12498d5$var$MaybeAnalyticsListener, {
        analyticsClientInstance: analyticsClientInstance
    }, children))))))));
};
const $7282dd84f12498d5$var$swrConfig = {
    provider: (0, $9a4b8c66470cb7c0$export$54eb3e634424b746),
    use: [
        (0, $9a4b8c66470cb7c0$export$711c5bb855c82238)
    ]
};
const $7282dd84f12498d5$var$MaybePostOfficeCacheProvider = ({ children: children })=>{
    if ((0, $dh538.fg)('post-office-use-placement-with-client')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fCcUZ.SWRConfig), {
        value: $7282dd84f12498d5$var$swrConfig
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $7282dd84f12498d5$var$MaybeAnalyticsListener = ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isEPExposuresListenerEnabled = (0, $dh538.fg)('post-office_ep_exposures_enabled');
    const isAnalyticsListenerEnabled = (0, $dh538.fg)('post-office-analytics-listener-enabled');
    let content = children;
    if (isEPExposuresListenerEnabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5238aa3ac06c99b9$export$3476bc3bd0845b44), {
        analyticsClientInstance: analyticsClientInstance
    }, content);
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $dP3ac.postOfficeGasv3ListenerStore);
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            channel: "*",
            onEvent: handleEvent
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content);
};
const $7282dd84f12498d5$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });









var $dPJCf = parcelRequire("dPJCf");


var $7zgzO = parcelRequire("7zgzO");











var $djMdn = parcelRequire("djMdn");


var $ibzAc = parcelRequire("ibzAc");





var $32x2E = parcelRequire("32x2E");

const $b765bc6fd36943f2$export$e2036a91fb26c8cf = (url)=>{
    /* Extracting Confluence page data from URL because we don't have access to the page context
	 * from the Screen Space Flags placement.
	 *
	 * Sample page URL: wiki/spaces/{spaceKey}/pages/{contentId}/This+is+the+title+of+a+page
	 * Sample blog URL: wiki/spaces/{spaceKey}/blog/2025/04/11/{contentId}/This+is+the+title+of+a+blog+post
	 */ const [, spaceKey, rawContentType, contentId] = url.match(/\/wiki\/spaces\/([^/]+)\/(pages|blog)(?:\/\d{4}\/\d{2}\/\d{2})?\/([^/]+)/) || [];
    const contentType = rawContentType === 'pages' ? 'page' : rawContentType === 'blog' ? 'blogpost' : rawContentType;
    return {
        spaceKey: spaceKey,
        contentType: contentType,
        contentId: contentId
    };
};






var $xQxzY = parcelRequire("xQxzY");


var $8dbvt = parcelRequire("8dbvt");


var $4XcQZ = parcelRequire("4XcQZ");

/**
 * @graphql cc
 */ 


const $bd7e8efd102a89c2$export$40ae2927f44e642d = (0, $eSUdr.default)`query SpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id title type subType status links{webui editui}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}lastModifiedDate}history{createdBy{profilePicture{path}displayName ...on KnownUser{accountId}}ownedBy{profilePicture{path}displayName ...on KnownUser{accountId}}}space{id key alias name}likes{count}version{by{profilePicture{path}displayName ...on KnownUser{accountId}}}}}`;



const $19a192258e8db8bc$export$1d93f080b8c40251 = (skip = false)=>{
    const { contentId: contentId, spaceKey: spaceKey } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(globalThis.location.href);
    // Get recommendation data
    const { data: recPageData, loading: recPageLoading, error: recPageError } = (0, $xQxzY.useQuery)((0, $4XcQZ.EndOfPageRecommendationQuery), {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        skip: !contentId || !spaceKey || skip
    });
    // Transform/sort data and grab first rec
    const recommendedPage = (0, $42omo.useMemo)(()=>{
        const rankedPages = $19a192258e8db8bc$var$transformAndOrderRecs(recPageData?.getRecommendedPages?.recommendedPages);
        return rankedPages?.[0];
    }, [
        recPageData
    ]);
    // Get avatar and name of the page owner
    const { data: hoverPageData, loading: hoverPageLoading, error: hoverPageError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $bd7e8efd102a89c2$export$40ae2927f44e642d), {
        variables: {
            id: recommendedPage ? recommendedPage.id : ''
        },
        skip: !recommendedPage || skip
    });
    const pageRecommendationData = {
        data: undefined,
        loading: hoverPageLoading || recPageLoading,
        hoverPageError: hoverPageError,
        recPageError: recPageError
    };
    if (hoverPageData?.singleContent?.history?.ownedBy?.displayName && hoverPageData?.singleContent?.history?.ownedBy?.profilePicture?.path && recommendedPage?.links?.webui && recommendedPage?.title.text) pageRecommendationData.data = {
        pageOwner: {
            name: hoverPageData.singleContent.history.ownedBy.displayName,
            avatarUrl: hoverPageData.singleContent.history.ownedBy.profilePicture.path
        },
        page: {
            title: recommendedPage.title.text,
            url: `/wiki${recommendedPage.links.webui}`
        }
    };
    return pageRecommendationData;
};
/**
 * The ordering of recs array is determined by the "ranking" in the backend.
 * Each rec will have a corresponding "strategies" array that can have one or multiple strategies.
 * We want to ensure that we are choosing strategies from each rec in a way that avoids monotony on the UI.
 * To accomplish this, we must first sort the recs array depending on the number of strategies each rec has, in
 * ascending order. We then pass each rec to transformEndOfPageRecContent which helps to choose the strategy, and
 * finally we return the transformed array back to the intial ranking order determind by the backend
 */ const $19a192258e8db8bc$var$transformAndOrderRecs = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>(0, $8dbvt.transformEndOfPageRecContent)(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};


/* eslint-disable graphql-relay-compat/no-import-graphql-operations */ /* eslint-disable no-restricted-imports */ 







var $3V1KT = parcelRequire("3V1KT");





var $2OQgp = parcelRequire("2OQgp");





const $f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT = {
    data: undefined,
    loading: false,
    error: undefined
};
// Helper function to fetch the specific names of users who reacted to a specific emoji
const $f95c9b8c12af7d64$var$getReactedUsersForEmoji = async (contentId, contentType, emojiId)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const { data: data } = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $2OQgp.ReactedUsersQuery),
        variables: {
            contentId: contentId,
            contentType: contentType.toUpperCase(),
            containerId: contentId,
            containerType: contentType.toUpperCase(),
            emojiId: emojiId
        }
    });
    return data;
};
// Helper function to get unique users who reacted to any emoji
const $f95c9b8c12af7d64$var$getUniqueReactedUsers = async (contentId, contentType, emojiIds)=>{
    const uniqueUsers = {};
    // Process all emojis in parallel to get all unique users
    await Promise.allSettled(emojiIds.filter(Boolean).map(async (emojiId)=>{
        const data = await $f95c9b8c12af7d64$var$getReactedUsersForEmoji(contentId, contentType, emojiId);
        // Add all users to the unique users map
        for (const user of data.reactedUsers.confluencePerson)if (user?.displayName && user.accountId) uniqueUsers[user.accountId] = user.displayName;
    }));
    return uniqueUsers;
};
const $f95c9b8c12af7d64$export$a35f2f61e0cb4308 = (numberOfReactedUsers, skip = false)=>{
    // Needed for Confluence-required analytic events
    const { userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { contentId: contentId, contentType: contentType } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(window.location.href);
    const [reactedUsers, setReactedUsers] = (0, $42omo.useState)($f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT);
    const [uniqueUsersCount, setUniqueUsersCount] = (0, $42omo.useState)(0);
    // Fetch page author and author's avatar URL
    const { data: spaceHoverPageCardResult, loading: spaceHoverPageCardLoading, error: spaceHoverPageCardError } = (0, $xQxzY.useQuery)((0, $bd7e8efd102a89c2$export$40ae2927f44e642d), {
        variables: {
            id: contentId
        },
        skip: !contentId || skip
    });
    // Fetch total reactions count and emoji ID summary
    const { data: reactionsContentData, loading: reactionsLoading, error: reactionsError } = (0, $xQxzY.useQuery)((0, $3V1KT.ReactionsContentQuery), {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip
    });
    // Use the emoji ID summary from reactionsContentData to fetch the specific names of users who reacted
    (0, $42omo.useEffect)(()=>{
        const emojiIds = reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.flatMap((reaction)=>reaction?.emojiId ?? []);
        // Need to put this in a function and then call it because we can't use async/await in useEffect
        const getReactedUsers = async ()=>{
            if (!contentId || !contentType || !emojiIds || reactedUsers.data || reactedUsers.loading) return;
            setReactedUsers({
                loading: true
            });
            try {
                // Get all unique users in parallel
                const uniqueUsers = await $f95c9b8c12af7d64$var$getUniqueReactedUsers(contentId, contentType, emojiIds);
                // Take only the first numberOfReactedUsers users for the reactedUsers state
                const limitedUsers = Object.values(uniqueUsers).slice(0, numberOfReactedUsers);
                // Update state
                setUniqueUsersCount(Object.keys(uniqueUsers).length);
                setReactedUsers({
                    data: limitedUsers,
                    loading: false
                });
            } catch (error) {
                setReactedUsers({
                    loading: false,
                    error: error
                });
            }
        };
        getReactedUsers();
    }, [
        contentId,
        contentType,
        reactionsContentData,
        reactedUsers,
        numberOfReactedUsers
    ]);
    // Transform this so that it matches Post Office's expected shape (for use with the ReactionWrapper component)
    const transformedReactionsSummary = (0, $42omo.useMemo)(()=>({
            reactionsSummary: {
                ari: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.ari || '',
                containerAri: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.containerAri || '',
                reactionsSummaryForEmoji: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.map((emoji)=>{
                    // Only return emoji objects that have all required non-null values
                    if (emoji?.count != null && emoji?.emojiId != null && emoji?.reacted != null) return {
                        count: emoji.count,
                        emojiId: emoji.emojiId,
                        reacted: emoji.reacted,
                        __typename: 'ReactionsSummaryForEmoji'
                    };
                    return null; // Return null for incomplete emoji data
                }) || [],
                __typename: 'ReactionsSummaryResponse'
            }
        }), [
        reactionsContentData
    ]);
    return {
        data: {
            authorName: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.displayName ?? undefined,
            authorAvatar: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.profilePicture?.path,
            reactionsCount: uniqueUsersCount,
            reactionsSummary: transformedReactionsSummary,
            reactedUsers: reactedUsers.data,
            userId: userId || undefined,
            activationId: activationId
        },
        loading: spaceHoverPageCardLoading || reactionsLoading || reactedUsers.loading,
        error: spaceHoverPageCardError || reactionsError || reactedUsers.error
    };
};


const $a730e736ff2c0fdb$export$50c48a5a1548e4da = ({ children: children })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const experimentsContextValue = (0, $42omo.useMemo)(()=>{
        return {
            usePageRecommendationData: $19a192258e8db8bc$export$1d93f080b8c40251,
            useInlineReactionsData: $f95c9b8c12af7d64$export$a35f2f61e0cb4308,
            getPageDataFromUrl: $b765bc6fd36943f2$export$e2036a91fb26c8cf,
            emojiProvider: (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
                userId: userId,
                cloudId: cloudId
            })
        };
    }, [
        userId,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djMdn.ConfluenceExperimentsContext).Provider, {
        value: experimentsContextValue
    }, children);
};











const $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME = 40000; // ms
const $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME = 60000; // ms
const $f6be7463febe9936$export$2855524b2284c48 = ({ children: children })=>{
    const { fireTrigger: fireTrigger } = (0, $aXjWU.useFirePostOfficeTrigger)({
        triggerId: 'confluence-page-dwelled'
    });
    const onEvent = (0, $42omo.useCallback)((event)=>{
        if (event.payload?.data?.action === 'dwelled' && event.payload?.data?.actionSubject === 'page') {
            const dwellTime = event.payload.data.attributes?.dwellTime;
            // Dwell events are triggered at 5, 10, 20, 40, 80s, but we want 60s
            if (event.payload.data.attributes?.finalDwellEvent) fireTrigger({
                isActive: false
            });
            else if (dwellTime && dwellTime >= $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME && dwellTime <= $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: onEvent,
        channel: "*"
    }, children);
};


const $074500c4d6f25c0d$var$ConfluencePostOfficeProvider = ({ children: children })=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, environment: environment, locale: locale, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const context = (0, $42omo.useMemo)(()=>({
            current: (0, $0VKZa.sessionToPostOfficeContext)({
                accessStatus: accessStatus,
                activationId: activationId,
                cloudId: cloudId,
                locale: locale,
                orgId: orgId,
                edition: edition
            })
        }), [
        activationId,
        cloudId,
        accessStatus,
        locale,
        orgId,
        edition
    ]);
    const env = (0, $42omo.useMemo)(()=>({
            env: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    const analyticsClientInstance = (0, $42omo.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7282dd84f12498d5$export$fb465b6e855c1e85), {
        context: context,
        environment: env,
        analyticsClientInstance: analyticsClientInstance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6be7463febe9936$export$2855524b2284c48), null, children));
};
const $074500c4d6f25c0d$export$fb465b6e855c1e85 = ({ children: children })=>{
    return (0, $9wGTI.fg)('post-office-screen-space-overlay-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($074500c4d6f25c0d$var$ConfluencePostOfficeProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a730e736ff2c0fdb$export$50c48a5a1548e4da), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $074500c4d6f25c0d$var$ReactRouterListener = ({ children: children })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    (0, $89c4065b6c91d839$export$bb606326acdd1a64)([
        routeDataRef?.current?.href ?? '',
        routeDataRef.current?.routeName ?? ''
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $074500c4d6f25c0d$var$ConfluenceRouterListener = ({ children: children })=>{
    const routeContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    (0, $89c4065b6c91d839$export$bb606326acdd1a64)([
        routeContext.getHref() ?? '',
        routeContext.match?.name ?? ''
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $074500c4d6f25c0d$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    return (0, $9wGTI.fg)('post-office-screen-space-overlay-confluence') ? (0, $9wGTI.fg)('post-office-new-confluence-router-listener') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($074500c4d6f25c0d$var$ConfluenceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($074500c4d6f25c0d$var$ReactRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};







var $lonEO = parcelRequire("lonEO");


var $kZDrw = parcelRequire("kZDrw");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $f7i8j = parcelRequire("f7i8j");


var $jVK0t = parcelRequire("jVK0t");







parcelRequire("42omo");







parcelRequire("2YerA");
var $jCM2u = parcelRequire("jCM2u");
var $fqrVl = parcelRequire("fqrVl");


var $8z9j5 = parcelRequire("8z9j5");


var $7TH2w = parcelRequire("7TH2w");

const $f63d596471d12742$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $7TH2w.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $7TH2w.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $7TH2w.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};


// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.



const $7ddb7856a75b7fbe$var$GROWTH_TAG = 'growth';
const $7ddb7856a75b7fbe$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $7ddb7856a75b7fbe$var$getSources = (context)=>$7ddb7856a75b7fbe$var$extractFromEventContext([
        'source'
    ], context);
const $7ddb7856a75b7fbe$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $7ddb7856a75b7fbe$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $7ddb7856a75b7fbe$var$last = (values)=>values[values.length - 1];
const $7ddb7856a75b7fbe$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $7ddb7856a75b7fbe$var$getSources(context);
    const source = $7ddb7856a75b7fbe$var$last(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = $7ddb7856a75b7fbe$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $7ddb7856a75b7fbe$var$last($7ddb7856a75b7fbe$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($7ddb7856a75b7fbe$var$GROWTH_TAG);
    switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};


parcelRequire("49sr4");
var $82BVR = parcelRequire("82BVR");

const $82f75673d6758a24$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $82f75673d6758a24$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $82f75673d6758a24$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $82f75673d6758a24$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $82f75673d6758a24$export$2a45a00073911255 = '/software';


var $1d705bbdb490746b$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});


const $38a222a070b75a8d$var$utmCampaignMap = {
    'atlassian-switcher': (0, $1d705bbdb490746b$export$fc604aa353a97e10)['atlassian-switcher']
};
const $38a222a070b75a8d$var$isBundledProduct = (productKey)=>{
    return [
        (0, $82BVR.Targets).JIRA_SOFTWARE,
        (0, $82BVR.Targets).JIRA_SERVICE_DESK,
        (0, $82BVR.Targets).JIRA_CORE,
        (0, $82BVR.Targets).CONFLUENCE
    ].includes(productKey);
};
const $38a222a070b75a8d$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $82BVR.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $82BVR.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $82BVR.Targets).JIRA_CORE]: 'jira-core',
        [(0, $82BVR.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $38a222a070b75a8d$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $82BVR.Targets).OPSGENIE
    ].includes(productKey);
};
const $38a222a070b75a8d$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $82BVR.Targets).OPSGENIE]: (0, $82f75673d6758a24$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $38a222a070b75a8d$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($38a222a070b75a8d$var$utmCampaignMap[sourceComponent]);
};
const $38a222a070b75a8d$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $38a222a070b75a8d$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$38a222a070b75a8d$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $38a222a070b75a8d$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $82f75673d6758a24$export$c37558e5c67d2b01) : (0, $82f75673d6758a24$export$f199baf8dfc7621e);
    const utmParams = $38a222a070b75a8d$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $82f75673d6758a24$export$2a45a00073911255);
    if ($38a222a070b75a8d$var$isBundledProduct(productKey)) {
        path = (0, $82f75673d6758a24$export$e6c04a1dd86d1c14);
        bundleParams = $38a222a070b75a8d$var$getBundleSignUpParams(productKey);
    } else if ($38a222a070b75a8d$var$isProductWithCustomSignUpPath(productKey)) path = $38a222a070b75a8d$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $38a222a070b75a8d$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $38a222a070b75a8d$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};








const $ab8bd02760c6d61c$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $ab8bd02760c6d61c$export$9d8252a268f4fa72 = 'errorCaught';
const $ab8bd02760c6d61c$export$1045419caf49b395 = 'errorBoundary';
const $ab8bd02760c6d61c$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $ab8bd02760c6d61c$export$e5c2c058fa8068a6 = 'uiInitialized';
const $ab8bd02760c6d61c$export$e67cdcb8867a3bd0 = 'openInvoked';




const $fbfb52c7bf4616fb$var$name = "platform-pkg";
const $fbfb52c7bf4616fb$var$version = "0.0.0-use.local";
const $fbfb52c7bf4616fb$var$payload = {
    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
    action: (0, $ab8bd02760c6d61c$export$9d8252a268f4fa72),
    actionSubject: (0, $ab8bd02760c6d61c$export$1045419caf49b395)
};
const $fbfb52c7bf4616fb$var$context = [
    {
        source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
    },
    {
        packageName: $fbfb52c7bf4616fb$var$name,
        packageVersion: $fbfb52c7bf4616fb$var$version
    }
];
class $fbfb52c7bf4616fb$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $fbfb52c7bf4616fb$var$payload,
            context: $fbfb52c7bf4616fb$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}


const $2990596a720578f3$var$version = "0.0.0-use.local";
const $2990596a720578f3$export$84f9cf7ef89d4c26 = {
    version: $2990596a720578f3$var$version
};
const $2990596a720578f3$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $2990596a720578f3$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};


const $c3f4a60925dc07c0$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};






const $2e3c136e31b0a37a$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("bdD2n")));
const $2e3c136e31b0a37a$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $42omo.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $42omo.useState)(false);
        const fireEvent = (0, $42omo.useMemo)(()=>(0, $f63d596471d12742$export$91b4dd3bfc301325)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $42omo.useState)();
        const onAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
            const gasV3Event = (0, $7ddb7856a75b7fbe$export$3f40e8c44448be30)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $c3f4a60925dc07c0$export$a5a156dc5df42f0)((0, $2990596a720578f3$export$59518efab336a8b5)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $42omo.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                        action: (0, $ab8bd02760c6d61c$export$e5c2c058fa8068a6),
                        actionSubject: (0, $ab8bd02760c6d61c$export$d54c183f56e39aa5),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $42omo.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $c3f4a60925dc07c0$export$a5a156dc5df42f0)({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: (0, $ab8bd02760c6d61c$export$e67cdcb8867a3bd0),
                    actionSubject: (0, $ab8bd02760c6d61c$export$d54c183f56e39aa5)
                }, options),
                context: [
                    {
                        source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $fqrVl.Journeys).GET_STARTED && redirectToWac) {
                (0, $38a222a070b75a8d$export$2827e2473cb9a346)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $42omo.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $8z9j5.default)();
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $jCM2u.BaseCrossFlowApiProvider), {
            onOpen: onOpen,
            children: [
                children,
                requestOptions && /*#__PURE__*/ (0, $l998X.jsx)((0, $fbfb52c7bf4616fb$export$e926676385687eaf), {
                    onAnalyticsEvent: onAnalyticsEvent,
                    onError: onError,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $l998X.jsx)(IntegrationView, {
                            ...baseProviderProps,
                            ...requestOptions,
                            onAnalyticsEvent: onAnalyticsEvent,
                            originProduct: originProduct,
                            theme: colorMode,
                            onClose: onClose,
                            onHandShake: onHandShake,
                            plugins: plugins,
                            env: env,
                            redirectToWac: redirectToWac,
                            zIndex: requestOptions.zIndex ?? 1000
                        })
                    })
                })
            ]
        });
    };
const $2e3c136e31b0a37a$export$d900e4062895cd7c = $2e3c136e31b0a37a$export$79d79d8dd8574306($2e3c136e31b0a37a$var$IntegrationView);



const $3ca71cfad0801800$var$ConfluenceProvider = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2e3c136e31b0a37a$export$d900e4062895cd7c), {
        ...props,
        originProduct: "confluence"
    });
};
var $3ca71cfad0801800$export$2e2bcd8739ae039 = $3ca71cfad0801800$var$ConfluenceProvider;











var $1Rv6U = parcelRequire("1Rv6U");

const $fe198622d822a4a2$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetContainers,
        fetch
    ];
};
const $fe198622d822a4a2$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetUsers,
        fetch
    ];
};
const $fe198622d822a4a2$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $fe198622d822a4a2$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetAvailableSites,
        fetch
    ];
};






var $gFHOP = parcelRequire("gFHOP");

function $3dc98590eeed1246$var$hasSiteSettings(data) {
    return data && typeof data === 'object' && data['siteSettings'] && data['tenant'];
}
const $3dc98590eeed1246$var$getCloudId = async ()=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const { data: data } = await (0, $hp2SH.getApolloClient)().query({
        // eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
        query: (0, $gFHOP.SiteInformationQuery)
    });
    const containers = [];
    if ($3dc98590eeed1246$var$hasSiteSettings(data)) {
        const { siteTitle: siteTitle } = data.siteSettings;
        const tenantId = data.tenant.cloudId;
        containers.push({
            id: tenantId,
            displayName: siteTitle,
            type: (0, $1Rv6U.ContainerTypes).ATLASSIAN_CLOUD_ID
        });
    }
    return {
        type: (0, $1Rv6U.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $3dc98590eeed1246$export$81d1d40061d190bc = (0, $fe198622d822a4a2$export$76378b0f825c024c)($3dc98590eeed1246$var$getCloudId);







const $c394a569c7bfdabb$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await (0, $f7B1p.cfetch)(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    idType: (0, $1Rv6U.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    id: value.id,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $c394a569c7bfdabb$export$7c44908d2777db01 = (0, $fe198622d822a4a2$export$8feb7eae83cf8cd5)($c394a569c7bfdabb$var$getUsers);


const $70d683a301b7be27$export$d900e4062895cd7c = ({ children: children })=>{
    const { cloudId: cloudId, locale: locale } = (0, $bQm3c.useSessionData)();
    const analyticWebClient = (0, $42omo.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    const isMarketingOptOut = document.querySelector("meta[name='ajs-marketing-opt-out']")?.getAttribute('content') === 'true';
    if (isMarketingOptOut) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ca71cfad0801800$export$2e2bcd8739ae039), {
        cloudId: cloudId,
        analyticsClient: analyticWebClient,
        locale: locale,
        plugins: [
            (0, $c394a569c7bfdabb$export$7c44908d2777db01),
            (0, $3dc98590eeed1246$export$81d1d40061d190bc)
        ]
    }, children);
};



var $fcF01 = parcelRequire("fcF01");


var $d5ap9 = parcelRequire("d5ap9");


var $1ytiN = parcelRequire("1ytiN");





var $lsxnT = parcelRequire("lsxnT");











var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $hSHWm = parcelRequire("hSHWm");


var $jmjWc = parcelRequire("jmjWc");


const $639a6e255dabf06b$export$96cfefeef4383728 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "mA5-d",
    name: "CoreInvitesLoadable",
    loader: async ()=>(await (parcelRequire("bEsuL"))).CoreInvites
});



var $koZ31 = parcelRequire("koZ31");










const $8855e66edaf78755$var$INVITE_DIALOG_PARAM = 'inviteDialog';
const $8855e66edaf78755$var$getOpenModalParam = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get($8855e66edaf78755$var$INVITE_DIALOG_PARAM) || '';
};
function $8855e66edaf78755$export$fd22f9b0c5d723c2(openCoreInvites) {
    (0, $42omo.useEffect)(()=>{
        if (!window) return;
        if (!(0, $9wGTI.fg)('cfind-confluence-open-invite-param')) return;
        if ($8855e66edaf78755$var$getOpenModalParam() !== 'open') return;
        openCoreInvites((0, $koZ31.CoreInvitesSource).OPEN_MODAL_QUERY_PARAM);
        // remove the query param from the URL without reloading the page
        const url = new URL(window.location.href);
        url.searchParams.delete($8855e66edaf78755$var$INVITE_DIALOG_PARAM);
        window.history.replaceState({}, document.title, url.toString());
    }, [
        openCoreInvites
    ]);
}


const $685338b3d2a4b0a3$var$noop = ()=>{
    return undefined;
};
function $685338b3d2a4b0a3$export$2e865a7ec399eb55({ children: children }) {
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [initialInvitees, setInitialInvitees] = (0, $42omo.useState)([]);
    const [source, setSource] = (0, $42omo.useState)((0, $koZ31.CoreInvitesSource).UNKNOWN);
    const [showSpotlight, setShowSpotlight] = (0, $42omo.useState)(false);
    const [productContext, setProductContext] = (0, $42omo.useState)(undefined);
    const stablePropsRef = (0, $42omo.useRef)({
        onInviteCompleted: $685338b3d2a4b0a3$var$noop,
        onModalClose: $685338b3d2a4b0a3$var$noop
    });
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const contextualInviteNudgeChoreographer = useChoreographer('cc-contextual-invite-nudge', {
        start: ()=>setShowSpotlight(true),
        stop: ()=>setShowSpotlight(false)
    });
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const handleModalOpen = (0, $42omo.useCallback)((touchPoint, { onModalClosed: onModalClosed = $685338b3d2a4b0a3$var$noop, onInviteCompleted: onInviteCompleted = $685338b3d2a4b0a3$var$noop, getContextualInviteNudgeProps: getContextualInviteNudgeProps } = {}, initialInvitees = [], productContextMetadata)=>{
        setInitialInvitees(initialInvitees);
        setSource(touchPoint || (0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(productContextMetadata);
        stablePropsRef.current.onModalClose = onModalClosed;
        stablePropsRef.current.onInviteCompleted = onInviteCompleted;
        setIsOpen(true);
        const shouldShow = getContextualInviteNudgeProps?.()?.showSpotlight;
        if (shouldShow) contextualInviteNudgeChoreographer.startMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setInitialInvitees,
        setSource,
        setIsOpen
    ]);
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        setSource((0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(undefined);
        // remember the current value for later invocation, since we're about to override it
        const onClosed = stablePropsRef.current.onModalClose;
        stablePropsRef.current.onModalClose = $685338b3d2a4b0a3$var$noop;
        stablePropsRef.current.onInviteCompleted = $685338b3d2a4b0a3$var$noop;
        setIsOpen(false);
        onClosed();
        contextualInviteNudgeChoreographer.stopMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setSource,
        setIsOpen
    ]);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failExperienceOnError = (0, $42omo.useCallback)((error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CORE_INVITES_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const coreInviteContext = (0, $42omo.useMemo)(()=>({
            openCoreInvites: handleModalOpen
        }), [
        handleModalOpen
    ]);
    const displayInfiSpotlight = true;
    const inviteCompletedHandler = (0, $42omo.useCallback)((result)=>{
        stablePropsRef.current.onInviteCompleted(result);
    }, [
        stablePropsRef
    ]);
    (0, $8855e66edaf78755$export$fd22f9b0c5d723c2)(handleModalOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSHWm.CoreInvitesContext).Provider, {
        value: coreInviteContext
    }, children, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH,
        onError: failExperienceOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $639a6e255dabf06b$export$96cfefeef4383728), {
        initialInvitees: initialInvitees,
        onSendHandler: handleModalClose,
        onCancelHandler: handleModalClose,
        onInviteCompletedHandler: inviteCompletedHandler,
        source: source,
        orgId: orgId,
        displayInfiSpotlight: displayInfiSpotlight,
        showSpotlight: showSpotlight,
        experimentalProductContext: productContext
    })));
}



var $hrAmX = parcelRequire("hrAmX");


var $bJX6u = parcelRequire("bJX6u");


var $ktUCG = parcelRequire("ktUCG");


var $brNvA = parcelRequire("brNvA");


var $cryCi = parcelRequire("cryCi");


var $fN9wG = parcelRequire("fN9wG");





var $97W74 = parcelRequire("97W74");








var $6g1oe = parcelRequire("6g1oe");





var $dBmJE = parcelRequire("dBmJE");


var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $kCeSx = parcelRequire("kCeSx");


var $cbc8g = parcelRequire("cbc8g");


var $2cEww = parcelRequire("2cEww");






var $aXWtB = parcelRequire("aXWtB");





var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");








var $7aRa9 = parcelRequire("7aRa9");

parcelRequire("gLUd5");
var $5Z4kM = parcelRequire("5Z4kM");














var $gEtAQ = parcelRequire("gEtAQ");


var $jlIaF = parcelRequire("jlIaF");










var $2Nwuj = parcelRequire("2Nwuj");

const $b59268334a98f13b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    genericSSRErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.generic.message",
        defaultMessage: "Reason: {reason}."
    },
    branchDeployErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.branch.deploy.message",
        defaultMessage: "Possible outdated branch deploy detected. Your PR changes might not be tested against SSR accurately."
    },
    runbookLink: {
        id: "ssr-render-failure-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug this failure."
    }
});
const $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4898451942/Branch+Deploys`;
const $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4911008649/SSR+Render+Failures`;
const $b59268334a98f13b$export$487f09dcd3f678bf = ({ ssrErrors: ssrErrors, isBranchDeployFailure: isBranchDeployFailure })=>{
    const runbookLink = isBranchDeployFailure ? $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK : $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, isBranchDeployFailure ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b59268334a98f13b$export$a7357cdd1f0b0168.branchDeployErrorFlagReason) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.genericSSRErrorFlagReason,
        values: {
            reason: ssrErrors[0]
        }
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: runbookLink
                }, chunks)
        }
    }));
};













const $5e5853def1ddf657$var$i18n = (0, $cgtv4.defineMessages)({
    hydrationErrorMessage: {
        id: "ssr-render-failure-notification.hydration.flag.message",
        defaultMessage: "To view the hydration mismatches, refer to window.__HYDRATION_ERRORS__ in the browser console."
    },
    runbookLink: {
        id: "ssr-render-failure-notification.hydration.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug the mismatches."
    }
});
const $5e5853def1ddf657$export$7922b21049d03e3b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5e5853def1ddf657$var$i18n.hydrationErrorMessage)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$5e5853def1ddf657$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: "https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches"
                }, chunks)
        }
    }));
};


const $008c5cd8cb4c3a95$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    ssrRenderErrorFlagTitle: {
        id: "ssr-render-failure-notification.flag",
        defaultMessage: "This page was NOT SSR RENDERED!"
    },
    hydrationErrorFlagTitle: {
        id: "ssr-render-failure-notification.hydration.flag",
        defaultMessage: "This page was NOT HYDRATED PROPERLY!"
    }
});
const $008c5cd8cb4c3a95$export$475a1abe7cf690a3 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownErrorFlagRef = (0, $42omo.useRef)(false);
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    // we want to exclude testing environments and pollinator tenants from showing the error flag
    const isTestEnvironment = (0, $4VJDS.default).isKillSwitchOn('confluence_frontend_ssr_failure_notification');
    // We only want to show the error flag in the dev/staging environment
    // however, branch deploys on production will default to process.env.CLOUD_ENV = 'branch'
    const isStagingEnvironment = [
        'dev',
        'branch',
        'staging',
        'stg-fedm'
    ].includes("canary") && environment !== 'PRODUCTION';
    (0, $42omo.useEffect)(()=>{
        if (!isStagingEnvironment || isTestEnvironment) return;
        // regex to match /spaces/:spaceKey/blogs (blogs overview)
        const blogsOverviewRegex = new RegExp(`^${(0, $jlIaF.CONTEXT_PATH)}/spaces/[^/]+/blogs$`);
        // Helper function to determine if we should skip error checking for certain paths
        const isAllowedPath = (pathname)=>{
            return (0, $gEtAQ.isHomePage)() || (0, $gEtAQ.isViewPage)() || (0, $gEtAQ.isSpaceOverview)() || (0, $gEtAQ.isBlogPage)() || (0, $gEtAQ.isWhiteboard)() || (0, $gEtAQ.isDatabase)() || Boolean((0, $1NBp8.EDIT_PAGE).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(pathname)) || Boolean(blogsOverviewRegex.test(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB).match(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB_EDIT).match(pathname)) || Boolean((0, $1NBp8.EMBED_VIEW).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_SMART_CREATE).match(pathname)) || Boolean('/'.match(pathname));
        };
        if (isAllowedPath(window.location.pathname)) {
            const showHydrationError = ()=>{
                if (!hasShownErrorFlagRef.current) {
                    flags.showErrorFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.hydrationErrorFlagTitle),
                        isAutoDismiss: false,
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e5853def1ddf657$export$7922b21049d03e3b), null)
                    });
                    hasShownErrorFlagRef.current = true;
                }
            };
            // @ts-expect-error - true is not allowed as a default value
            if ((0, $6mKj3.expVal)('confluence_frontend_hydration_error_events_exp', 'isEnabled', true)) window.addEventListener('hydrationError', showHydrationError);
            // sometimes errors exist but the page is still SSRd successfully - we don't want to show the SSR render error flag in this case
            if (window.__SSR_RENDERED__) {
                // if the page is SSRd successfully we check if the page was hydrated successfully, and show a hydration error flag if not
                if (window.__HYDRATION_FAILED__) showHydrationError();
                return;
            }
            // COMPILED dev warnings show up on every SSRd page even if the page is SSRd successfully,
            // so we need to filter them out to distinguish from actual errors being reported for local dev ssr
            const ssrErrors = window.__SSR_ERROR__?.filter((err)=>!err.includes('DEV WARNING')) ?? [];
            // on old branch deploys, ssr errors can still be empty but the page might not be SSRd successfully
            const isBranchDeployFailure = (0, $5Z4kM.isBranchDeployFn)() && !window.__SSR_RENDERED__ && !ssrErrors?.length;
            if (!hasShownErrorFlagRef.current && (isBranchDeployFailure || ssrErrors.length)) {
                flags.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.ssrRenderErrorFlagTitle),
                    isAutoDismiss: false,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b59268334a98f13b$export$487f09dcd3f678bf), {
                        ssrErrors: ssrErrors,
                        isBranchDeployFailure: isBranchDeployFailure
                    })
                });
                hasShownErrorFlagRef.current = true;
            }
            return ()=>{
                window.removeEventListener('hydrationError', showHydrationError);
            };
        }
    }, [
        isStagingEnvironment,
        flags,
        isTestEnvironment
    ]);
    return null;
});
const $008c5cd8cb4c3a95$export$4e5ff544be3ec09b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($008c5cd8cb4c3a95$export$475a1abe7cf690a3, null));
};



var $iJELi = parcelRequire("iJELi");


var $8n9tL = parcelRequire("8n9tL");


var $4o1RV = parcelRequire("4o1RV");


var $aFbGo = parcelRequire("aFbGo");


var $64KID = parcelRequire("64KID");








var $4PPzL = parcelRequire("4PPzL");


var $5q601 = parcelRequire("5q601");










const $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION = 50;
const $e7cb2c525109c7cf$export$de3c307012927947 = (start, stop, idleThreshold, buffer)=>{
    const entires = buffer.getAll().filter((entry)=>entry.duration >= $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION).map((entry)=>({
            start: entry.startTime,
            stop: entry.startTime + entry.duration
        })).filter((entry)=>entry.stop > start && entry.start < stop).concat([
        // Add a fake entry to simplify the logic below
        {
            start: stop,
            stop: stop
        }
    ]).sort((a, b)=>a.start - b.start);
    let lastStop = start;
    for (const entry of entires){
        if (lastStop + idleThreshold < entry.start) return lastStop;
        lastStop = entry.stop;
    }
    return null;
};









var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $682a207fed74bf66$export$e49353726941624a = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.TIME_TO_APP_IDLE_KEY)
});



const $f6158bccfa436061$var$IDLE_THRESHOLD = 3000;
const $f6158bccfa436061$var$RETRY_INTERVAL = $f6158bccfa436061$var$IDLE_THRESHOLD * 2;
const $f6158bccfa436061$var$TIMEOUT_INTERVAL = 300000; // 5 minutes
const $f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT = 1000;
const $f6158bccfa436061$var$performance = window.performance;
const $f6158bccfa436061$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $f6158bccfa436061$var$wainNextIdle = ()=>{
    const onIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelCallback = (id)=>{
        if (onIdleCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    };
    return new Promise((resolve)=>{
        const callbackId = onIdleCallback(()=>{
            cancelCallback(callbackId);
            resolve();
        });
    });
};
const $f6158bccfa436061$export$560b992b8a813cfb = /*#__PURE__*/ (0, $42omo.memo)(({})=>{
    const routes = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routeName = routes.match?.name || '';
    const contentId = routes.match?.params?.contentId || '';
    const transitionId = routes.transitionId || 0;
    (0, $42omo.useEffect)(()=>{
        const htmlTime = $f6158bccfa436061$var$performance?.getEntriesByName?.('CFP-63.html').pop()?.startTime || 0;
        const isInitialLoad = transitionId === 0;
        const metric = (0, $682a207fed74bf66$export$e49353726941624a)(`${transitionId}-${routeName}-${contentId}`);
        // we have two different 'startTime' variables in this context:
        // 'metricStartTime' - This is used for reporting to the metric and for calculating duration.
        // 'startTime' - This is used as a boundary for idle time calculation. There may be instances where the HTML is ready,
        // but the component is not yet rendered. In such cases, we use the component's first render time as the start boundary.
        const startTime = $f6158bccfa436061$var$performance?.now();
        const metricStartTime = isInitialLoad ? htmlTime : startTime;
        let abortedTime = 0;
        metric.start({
            startTime: metricStartTime
        });
        async function measureTimeToAppIdle() {
            while(true){
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$RETRY_INTERVAL);
                // wait for current long task to complete
                await $f6158bccfa436061$var$wainNextIdle();
                const endTime = $f6158bccfa436061$var$performance?.now();
                // wait to allow performance observer to collect recent entries
                // note that `endTime` somewhat behind after this line, but it's ok
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT);
                const idleTime = (0, $e7cb2c525109c7cf$export$de3c307012927947)(startTime, endTime, $f6158bccfa436061$var$IDLE_THRESHOLD, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                const aborted = abortedTime && (!idleTime || abortedTime < idleTime) ? 'transition' : false;
                const timedOut = endTime - metricStartTime > $f6158bccfa436061$var$TIMEOUT_INTERVAL;
                if (idleTime || timedOut || aborted) {
                    const stopTime = idleTime || endTime;
                    const duration = stopTime - metricStartTime;
                    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(startTime, stopTime, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                    const customData = {
                        duration: duration,
                        startTime: metricStartTime,
                        stopTime: stopTime,
                        aborted: aborted,
                        transitionId: transitionId,
                        routeName: routeName,
                        contentId: contentId,
                        timedOut: timedOut,
                        idleThreshold: $f6158bccfa436061$var$IDLE_THRESHOLD,
                        tbtObserved: Math.round(tbt.observed),
                        tbtTotal: Math.round(tbt.total),
                        totalElementsToHydrate: (0, $ezH4I.getTotalHydratedElements)()
                    };
                    metric.stop({
                        stopTime: stopTime,
                        customData: customData
                    });
                    return;
                }
            }
        }
        measureTimeToAppIdle();
        return ()=>{
            abortedTime = $f6158bccfa436061$var$performance?.now();
        };
    }, [
        transitionId,
        routeName,
        contentId
    ]);
    return null;
});







var $iFjdQ = parcelRequire("iFjdQ");




function $192302f00fa5cc0a$export$8c3a984654991d73(routeName) {
    if (!routeName) return;
    switch(routeName){
        // edit route names taken from @confluence/browser-metrics/src/metricKeys.ts
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION));
            return;
        default:
            return;
    }
}



var $jfrcs = parcelRequire("jfrcs");





var $aeSHO = parcelRequire("aeSHO");


var $25MM7 = parcelRequire("25MM7");


var $NAPtM = parcelRequire("NAPtM");


var $iJiK8 = parcelRequire("iJiK8");

















var $ikfiQ = parcelRequire("ikfiQ");


var $4MlWS = parcelRequire("4MlWS");




const $1e9c3a5949b84c99$export$f358e6beaa924843 = (0, $eSUdr.default)`query NetworkStatusListenerQuery{network{status}}`;



const $8bd37d13e213b9df$var$NetworkStatusFlagLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Umim",
    name: "NetworkStatusFlagLoader",
    loader: ()=>(parcelRequire("aYxMO"))
});
const $8bd37d13e213b9df$export$529640d4682c2 = ()=>{
    const { data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $1e9c3a5949b84c99$export$f358e6beaa924843), {
        fetchPolicy: 'cache-only',
        skip: (0, $6mKj3.expValEquals)('confluence_replace_apollo_client_schema', 'isEnabled', true)
    });
    const networkStatus = (0, $ikfiQ.useNetworkStatusListenerCache)();
    const status = (0, $6mKj3.expValEquals)('confluence_replace_apollo_client_schema', 'isEnabled', true) ? networkStatus : data?.network?.status;
    // 1. experience-tracker
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let reason;
    switch(status){
        case (0, $4MlWS.ClientNetworkStatus).IP_BLOCKED:
            reason = 'IP blocked';
            break;
        case (0, $4MlWS.ClientNetworkStatus).OFFLINE:
            reason = 'Network unavailable';
            break;
    }
    if (reason) experienceTracker.abort({
        reason: reason,
        checkForTimeout: false
    });
    // 2. flags
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8bd37d13e213b9df$var$NetworkStatusFlagLoader, {
        status: status
    });
};



var $bEdUx = parcelRequire("bEdUx");


var $itS9i = parcelRequire("itS9i");


var $hmRc4 = parcelRequire("hmRc4");


var $8Ss4E = parcelRequire("8Ss4E");


























var $hBkCm = parcelRequire("hBkCm");




var $k3pHv = parcelRequire("k3pHv");

const $b7aff31f4e633d8f$var$checkDomainApproval = async (cloudId, userId, onError)=>{
    let OrgMemberCapabilityType = /*#__PURE__*/ function(OrgMemberCapabilityType) {
        OrgMemberCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
        OrgMemberCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
        OrgMemberCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
        return OrgMemberCapabilityType;
    }({});
    const params = new URLSearchParams({
        resource: `ari:cloud:confluence::site/${cloudId}`
    });
    let hasCapabilities = false;
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                resource: `ari:cloud:confluence::site/${cloudId}`,
                ACCEPT: 'application/json',
                'Account-Id': userId
            }
        });
        const data = await response.json();
        if (Object.values(data.results)[0] in OrgMemberCapabilityType) hasCapabilities = true;
    } catch (e) {
        const response = (0, $hBkCm.BadStatusError).isBadStatusError(e) ? e.response : undefined;
        const error = new Error(`Error in getting approved domains, status = ${response?.status}, message = "${response?.statusText}"`);
        onError(error);
    }
    return hasCapabilities;
};
const $b7aff31f4e633d8f$export$435bbe3b3c44f9d8 = (isExternalShareRequest = false)=>{
    const { isLicensed: isLicensed, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isApprovedOrgMember, setIsApprovedOrgMember] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const validateDomain = async ()=>{
            if (userId && !isLicensed && isExternalShareRequest) {
                const isApproved = await $b7aff31f4e633d8f$var$checkDomainApproval(cloudId, userId, (error)=>{
                    experienceTracker.fail({
                        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
                        error: error
                    });
                });
                isApproved && setIsApprovedOrgMember(isApproved);
            }
        };
        validateDomain();
    }, [
        userId,
        isLicensed,
        cloudId,
        experienceTracker,
        isExternalShareRequest
    ]);
    if (!userId) return {
        userType: (0, $k3pHv.UserTypes).ANONYMOUS
    };
    if (isLicensed) return {
        userType: (0, $k3pHv.UserTypes).CONFLUENCE_USER
    };
    return {
        userType: isApprovedOrgMember ? (0, $k3pHv.UserTypes).ORG_MEMBER : (0, $k3pHv.UserTypes).ATLASSIAN_USER
    };
};



var $gXrHX = parcelRequire("gXrHX");

const $a5952995c9c756c1$export$355d4724e049b0df = ({ children: children, path: path, shareToken: shareToken })=>{
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(path);
    const { userType: userType } = (0, $b7aff31f4e633d8f$export$435bbe3b3c44f9d8)(isExternalShareRequest);
    // Extract shareToken from path if it's an external share request
    const extractedShareToken = (0, $42omo.useMemo)(()=>{
        if (isExternalShareRequest) {
            const match = (0, $1NBp8.EXTERNAL_SHARE).match(path);
            return match?.params?.externalToken || undefined;
        }
        return undefined;
    }, [
        isExternalShareRequest,
        path
    ]);
    // Use provided shareToken if available, otherwise use extracted one
    const resolvedShareToken = shareToken || extractedShareToken;
    const externalShareContextValue = (0, $42omo.useMemo)(()=>({
            isExternalShareRequest: isExternalShareRequest,
            userType: userType,
            shareToken: resolvedShareToken
        }), [
        isExternalShareRequest,
        userType,
        resolvedShareToken
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gXrHX.ExternalShareContext).Provider, {
        value: externalShareContextValue
    }, children);
};






const $af5e1b3a6aa255af$export$38f39b921d5551c1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Bc3Ba",
    name: "Heartbeat",
    loader: async ()=>(await (parcelRequire("dTt0t"))).Heartbeat
});



var $39rFu = parcelRequire("39rFu");













var $inPa6 = parcelRequire("inPa6");


var $gqqjz = parcelRequire("gqqjz");

const $e4d79357fba42d43$var$i18n = (0, $cgtv4.defineMessages)({
    localStorageQuotaExceededTitle: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.title",
        defaultMessage: "We ran into a problem"
    },
    localStorageQuotaExceededDescription: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.description",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We\u2019ve noticed an issue that may affect your experience on Confluence. Select \"Refresh\" below to fix it."
    },
    refreshLocalStorage: {
        id: "local-storage-quota-subscriber.flag.refresh.title",
        defaultMessage: "Refresh"
    }
});
const $e4d79357fba42d43$export$b2c5189af5b5e948 = ()=>{
    const [isOverflown, setIsOverflown] = (0, $42omo.useState)(false);
    const [wasShown, setWasShown] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const onQuotaExceeded = ()=>setIsOverflown(true);
        window.addEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        return ()=>{
            setIsOverflown(false);
            window.removeEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        };
    }, [
        setIsOverflown
    ]);
    const clearLocalStorage = ()=>{
        window.localStorage.clear();
        window.location.reload();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LocalStorageQuotaSubscriber',
                action: 'clicked',
                actionSubject: 'LocalStorageQuotaExceededFlag',
                actionSubjectId: 'localStorageQuotaCleared'
            }
        }).fire();
    };
    const showFlag = (flags)=>{
        if (wasShown) return;
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e4d79357fba42d43$var$i18n.refreshLocalStorage),
                    href: '',
                    onClick: ()=>clearLocalStorage()
                }
            ]
        });
        setWasShown(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (isOverflown) showFlag(flags);
        return null;
    });
};






var $7J5Uc = parcelRequire("7J5Uc");

const $0f25e4f8facf0d0e$export$913cb5ed19d2180b = (initialTheme)=>{
    const { initializeTheme: initializeTheme } = (0, $7J5Uc.useThemingActions)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



var $cBuRD = parcelRequire("cBuRD");





var $6UYek = parcelRequire("6UYek");


var $eHj6r = parcelRequire("eHj6r");








const $852a6819cc9585c3$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = false;
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled via feature flag or environment variable
    if ((0, $9wGTI.fg)('confluence_strict_mode') || false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).StrictMode, null, children);
    else return children;
};



var $2JYae = parcelRequire("2JYae");





var $3WLLD = parcelRequire("3WLLD");








var $ek3aD = parcelRequire("ek3aD");










var $1z9oK = parcelRequire("1z9oK");

/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */ 






var $iXCQx = parcelRequire("iXCQx");

const $003e065b50dd1979$var$RUNBOOK_URL = 'https://hello.atlassian.net/wiki/spaces/~7120202da6a0b2c4184c0da3ba8ade6d08feaa/pages/5761728624/React+suspense+boundary+errors+run-book';
const $003e065b50dd1979$export$4f6d1b579f9e99e4 = ({ operationName: operationName, errorType: errorType, args: args })=>{
    let message;
    switch(errorType){
        case 'outside-boundary':
            {
                const expectedBoundaries = args?.expectedBoundaries?.join(', ') || '';
                message = `Query "${operationName}" preloaded in [${expectedBoundaries}] but accessed outside any suspense boundary.`;
                break;
            }
        case 'boundary-mismatch':
            {
                const expectedBoundaries = args?.expectedBoundaries?.join(', ') || '';
                const currentBoundaries = args?.currentBoundaries?.join(" \u2192 ") || '';
                message = `Query "${operationName}" preloaded in [${expectedBoundaries}] but accessed in "${currentBoundaries}" boundary.`;
                break;
            }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "queryBoundaryErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, message), (errorType === 'boundary-mismatch' || errorType === 'outside-boundary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ' ', "See", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: $003e065b50dd1979$var$RUNBOOK_URL
    }, "this page"), ' ', "for details."));
};


class $82be4d32af71312a$var$BoundaryErrorHandler {
    constructor(flags){
        this.flags = flags;
        this.errorStream = void 0;
        this.cleanup = ()=>{
            if (this.errorStream) this.errorStream.removeListener(this.handleBoundaryError);
        };
        this.handleBoundaryError = (error)=>{
            const flagId = `query-boundary-${error.errorType}-${error.operationName}`;
            let flagTitle = null;
            switch(error.errorType){
                case 'outside-boundary':
                    flagTitle = 'Query Used Outside Suspense Boundary!';
                    break;
                case 'boundary-mismatch':
                    flagTitle = 'Query Boundary Mismatch!';
                    break;
            }
            if (flagTitle) this.flags.showErrorFlag({
                id: flagId,
                title: flagTitle,
                isAutoDismiss: false,
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $003e065b50dd1979$export$4f6d1b579f9e99e4), error)
            });
        };
        if (window.__SSR_REACT_STREAMING__) {
            this.errorStream = (0, $1z9oK.getClientStream)('query-boundary-errors');
            this.errorStream.addListener(this.handleBoundaryError);
        }
    }
}
const $82be4d32af71312a$export$edc06ce642e48a51 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    (0, $42omo.useEffect)(()=>{
        if (!window.__SSR_REACT_STREAMING__) return;
        // Create the handler which will automatically set up the listener
        const handler = new $82be4d32af71312a$var$BoundaryErrorHandler(flags);
        return ()=>{
            handler.cleanup();
        };
    }, [
        flags
    ]);
    return null;
});
const $82be4d32af71312a$export$5413c6653c828d95 = ()=>{
    return null;
};











var $h3nb6 = parcelRequire("h3nb6");


var $7Snc9 = parcelRequire("7Snc9");






const $fcc81ac864e755d2$export$ac4cd9f30299a490 = 0.8;
const $fcc81ac864e755d2$export$632c6346c3a8c3e2 = 10000; // 10 seconds
const $fcc81ac864e755d2$export$de8f032132af9697 = 30000; // Normal pages have around 10-20k event listeners
let $fcc81ac864e755d2$var$routeName = 'unknown';
let $fcc81ac864e755d2$var$analyticsClient = null;
let $fcc81ac864e755d2$var$memoryMonitorInterval = null;
let $fcc81ac864e755d2$var$eventListenerCount = 0;
let $fcc81ac864e755d2$var$initializedEventListeners = false;
function $fcc81ac864e755d2$var$bytesToMB(bytes) {
    const MB = 1048576;
    return bytes / MB;
}
function $fcc81ac864e755d2$export$5ed8144ed56e505a() {
    if (!$fcc81ac864e755d2$var$analyticsClient) return false;
    if (performance.memory) {
        const { jsHeapSizeLimit: jsHeapSizeLimit, usedJSHeapSize: usedJSHeapSize } = performance.memory;
        const heapThreshold = jsHeapSizeLimit * $fcc81ac864e755d2$export$ac4cd9f30299a490;
        if (usedJSHeapSize > heapThreshold) $fcc81ac864e755d2$var$analyticsClient.sendOperationalEvent({
            source: 'confluence-memory-monitor',
            action: 'measured',
            actionSubject: 'highHeapUsage',
            attributes: {
                heapUsagePercent: Math.floor(usedJSHeapSize / jsHeapSizeLimit * 100),
                heapUsageMB: Math.floor($fcc81ac864e755d2$var$bytesToMB(usedJSHeapSize)),
                maxHeapSizeMB: Math.floor($fcc81ac864e755d2$var$bytesToMB(jsHeapSizeLimit)),
                route: $fcc81ac864e755d2$var$routeName
            }
        });
    }
    if ($fcc81ac864e755d2$var$initializedEventListeners && $fcc81ac864e755d2$var$eventListenerCount > $fcc81ac864e755d2$export$de8f032132af9697) $fcc81ac864e755d2$var$analyticsClient.sendOperationalEvent({
        source: 'confluence-memory-monitor',
        action: 'measured',
        actionSubject: 'highEventListenerCount',
        attributes: {
            eventListenerCount: $fcc81ac864e755d2$var$eventListenerCount,
            route: $fcc81ac864e755d2$var$routeName
        }
    });
    return true;
}
function $fcc81ac864e755d2$export$76f12cc80b7fd2f3(client) {
    if (!(0, $9wGTI.fg)('confluence_frontend_memory_monitor')) return null;
    $fcc81ac864e755d2$var$analyticsClient = client;
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
    if (!$fcc81ac864e755d2$var$initializedEventListeners) {
        EventTarget.prototype.addEventListener = function(type, listener, options) {
            $fcc81ac864e755d2$var$eventListenerCount++;
            originalAddEventListener.call(this, type, listener, options);
        };
        EventTarget.prototype.removeEventListener = function(type, listener, options) {
            $fcc81ac864e755d2$var$eventListenerCount--;
            originalRemoveEventListener.call(this, type, listener, options);
        };
        $fcc81ac864e755d2$var$initializedEventListeners = true;
    }
    if (!$fcc81ac864e755d2$var$memoryMonitorInterval) $fcc81ac864e755d2$var$memoryMonitorInterval = setInterval($fcc81ac864e755d2$export$5ed8144ed56e505a, $fcc81ac864e755d2$export$632c6346c3a8c3e2);
    return true;
}
function $fcc81ac864e755d2$export$d0c8b02fd4ae0022(name) {
    $fcc81ac864e755d2$var$routeName = name;
}
function $fcc81ac864e755d2$export$b35196bdb32e40c9() {
    if ($fcc81ac864e755d2$var$memoryMonitorInterval) {
        clearInterval($fcc81ac864e755d2$var$memoryMonitorInterval);
        $fcc81ac864e755d2$var$memoryMonitorInterval = null;
    }
}



var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $jwv1p = parcelRequire("jwv1p");


var $eIKcA = parcelRequire("eIKcA");


var $4QflW = parcelRequire("4QflW");





const $a409a9cb99445cc0$var$ShortcutsProvider = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zhDj6",
    name: "ShortcutsProvider",
    loader: ()=>(parcelRequire("7GuCn"))
});
var $a409a9cb99445cc0$export$2e2bcd8739ae039 = $a409a9cb99445cc0$var$ShortcutsProvider;





var $irDFR = parcelRequire("irDFR");












const $1f18aab14ff5333d$export$4a5ef4d351acbcfc = async (url, isTransition)=>{
    const shouldPreload = isTransition || !window.__SSR_RENDERED__;
    let match;
    if (match = (0, $kM8fE.matchHome)(url)) (0, $jwv1p.preloadHome)(match);
    else if ((0, $kM8fE.matchSpaceOverview)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadSpaceOverview)();
    } else if ((0, $kM8fE.matchLivePage)(url) && shouldPreload) {
        if (await (0, $aXEzU.waitUntilStatsigInitialized)()) (0, $jwv1p.preloadLivePagesComponents)();
    } else if (match = (0, $kM8fE.matchViewPage)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadViewPageComponents)(match);
    } else if ((0, $kM8fE.matchFabricEditor)(url)) (0, $jwv1p.preloadNativeEditorComponentsPreloader)();
    else if ((0, $kM8fE.matchCreateContent)(url)) (0, $jwv1p.preloadCreateContent)();
    else if ((0, $kM8fE.matchWhiteboardPage)(url)) (0, $jwv1p.preloadWhiteboardPage)();
    else if ((0, $kM8fE.matchSearch)(url)) (0, $jwv1p.preloadSearch)();
};





var $6VsaQ = parcelRequire("6VsaQ");



const $126a66f6ad21916b$var$browserHistory = (0, $hmRc4.getBrowserHistory)();
function $126a66f6ad21916b$export$86fbec116b87613f({ sessionData: sessionData }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance.mark('CFP-63.app-component-render');
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    // When loading confluence from the mobile app, we need the theme to respect the system color mode of the app
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    // Initializing the theme in a non-blocking way, instead of using <ThemeContainer>, so
    // that the app does not flash and re-paint after the SPA loads on top of the SSR page.
    (0, $0f25e4f8facf0d0e$export$913cb5ed19d2180b)(initialTheme);
    // Lite Mode™ check outside of the router
    // For certain pages supporting lite mode some functionality is not needed
    const isLite = (0, $aFbGo.isViewPageLite)();
    // Check if app is being loaded in iFrame
    // We don't want to render the Rovo Chat wrapper if in iFrame
    const isIframe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))) !== 'undefined' && (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).self !== (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).top;
    const startPageLoadMetrics = (0, $42omo.useCallback)((routeName = '', ufoName = routeName, transitionId, contentId = '')=>{
        (0, $jfrcs.startBrowserMetricsPageLoad)(routeName, ufoName, transitionId, contentId);
        if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $2cEww.addUFOCustomCohortData)('isDesktop', isDesktop);
        else (0, $cbc8g.addUFOCustomData)({
            isDesktop: isDesktop
        });
    }, [
        isDesktop
    ]);
    const onRoute = (0, $42omo.useCallback)(async (match, transitionId)=>{
        // Reset window.__APOLLO_STATS__ on transition
        (0, $eHj6r.resetApolloStats)();
        // transitionId = 0 when it is initial load, and 0 is falsey
        if (transitionId) {
            // The page can't be rendered by SSR if is a transition
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__SSR_RENDERED__'] = false;
            //hydrateRoot and related logic should not be enabled on transitions
            //as its only for ssr rendered page
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__HYDRATABLE__'] = false;
            (0, $KcDWk.releaseSSRedLegacyMacros)();
            // Delayed content redirection is not needed on transitions
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__DELAYED_CONTENT_REDIRECTION__'] = {};
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.clearAnalyticsDebugger)();
        } else (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance.mark('CFP-63.route-manager-initialized');
        (0, $78QFu.setUniquePageLoadId)(match?.name ?? '', match, transitionId, sessionData);
        (0, $8Ss4E.startExperienceForRoute)(match, transitionId, sessionData);
        (0, $fcc81ac864e755d2$export$d0c8b02fd4ae0022)(match?.name ?? 'unknown');
        (0, $2ba6133bff070823$export$8c5248f0cec8446d).stream([
            {
                type: 'page-transition',
                ID: transitionId
            }
        ]);
        const transitionPreloaderCurrentCallbackIDs = (0, $ek3aD.getGlobalTransitionPreloader)().getCurrentRouteCallbackIds();
        const isSeamlessTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionPreloaderCurrentCallbackIDs.includes('live_doc_preloading_transition_callback_id') && transitionId !== 0 : false;
        //if the new editor metrics FF is on, start BM here only if the route is not edit page or if it is initial load, or an embedded editor.
        if (!isSeamlessTransition && ((0, $9wGTI.fg)('ccint-6065-fix-embedded-editor-metrics') ? !(0, $gEtAQ.isEditPage)(match?.name) || transitionId === 0 : !(0, $gEtAQ.isEditPage)(match?.name) || transitionId === 0 || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)())) {
            (0, $jfrcs.startBrowserMetricsPageLoad)(match?.name ?? '', match?.ufoName, transitionId, match?.params.contentId);
            if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $2cEww.addUFOCustomCohortData)('isDesktop', isDesktop);
            else (0, $cbc8g.addUFOCustomData)({
                isDesktop: isDesktop
            });
            //If it is an embedded editor, start the BM right here since it does a full page reload
            if ((0, $gEtAQ.isEditPage)(match?.name) && (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) {
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_FMP_ACTION));
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_TTI_ACTION));
            }
        }
        // With fg('ccint-6065-fix-embedded-editor-metrics') enabled:
        // Start embedded editor BM for initial load and transitions here
        if ((0, $gEtAQ.isEditPage)(match?.name) && (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && (0, $9wGTI.fg)('ccint-6065-fix-embedded-editor-metrics')) {
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_TTI_ACTION));
        }
        // add SSR stats to initial page load only
        // we will be utilizing serverTime to track BE perf in Statsig
        if (transitionId === 0) {
            /** @type {Object<string, {startTime: number, duration: number} | undefined>} */ const ssrMeasure = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__SSR_MEASURES__'];
            const serverTime = ssrMeasure ? Object.keys(ssrMeasure).filter((key)=>key.startsWith('ssr-app/prepare/preloadQuery/fetch:')).reduce((total, key)=>total + (ssrMeasure[key]?.duration ?? 0), 0) : 0;
            /** @type {number | undefined} */ const serverCallCount = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__FETCH_COUNT__'];
            if (serverTime && serverCallCount) (0, $cbc8g.addUFOCustomData)({
                serverTime: serverTime,
                serverCallCount: serverCallCount
            });
        }
        // mark edit experience after transition to new route is complete
        (0, $192302f00fa5cc0a$export$8c3a984654991d73)(match?.name);
        (0, $5ZqQS.getMonitoringClient)().updateContext({
            pageName: match?.name ?? 'unknown',
            transitionId: transitionId,
            product: (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence'
        });
    }, [
        sessionData,
        isDesktop
    ]);
    /**
   * Please note this App is a pure component.
   * This means following components will NOT re-render when user navigates.
   * Please be careful when adding any component that requires router information.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $852a6819cc9585c3$export$5f8d39834fd61797), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $008c5cd8cb4c3a95$export$4e5ff544be3ec09b), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82be4d32af71312a$export$5413c6653c828d95), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
        history: $126a66f6ad21916b$var$browserHistory,
        context: (0, $kFqI2.ReactReduxContext)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kCeSx.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5952995c9c756c1$export$355d4724e049b0df), {
        path: $126a66f6ad21916b$var$browserHistory.location.pathname
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
        nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
        livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UYek.SubscriptionsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
        routeComponents: (0, $h3nb6.routeComponents),
        namedRoutes: (0, $64KID.namedRoutes),
        notFound: (0, $7Snc9.NotFound),
        onInitialize: onRoute,
        onTransition: onRoute,
        onPreload: $126a66f6ad21916b$var$onPreloadRoute,
        routePolicy: routePolicy,
        setBrowserHistoryListener: (0, $hmRc4.setBrowserHistoryListener),
        startPageLoadMetrics: startPageLoadMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af5e1b3a6aa255af$export$38f39b921d5551c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6158bccfa436061$export$560b992b8a813cfb), null), (0, $9wGTI.fg)('post-office-new-confluence-router-listener') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $074500c4d6f25c0d$export$9f8d3084fd3d5fc0), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), !isIframe && isRovoEnabled && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bEdUx.HighlightActionsProviderForNav3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bd37d13e213b9df$export$529640d4682c2), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a409a9cb99445cc0$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6VsaQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e4d79357fba42d43$export$b2c5189af5b5e948), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irDFR.default), null)))));
}
$126a66f6ad21916b$export$86fbec116b87613f.propTypes = {
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
};
function $126a66f6ad21916b$var$onPreloadRoute({ url: url }, previousMatch, options) {
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(url, true);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJS) return;
    (0, $e80763d537fd4542$export$57d895781a697848)(url, true, previousMatch, options);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) return;
    (0, $e80763d537fd4542$export$6aefe8c2dfd7fe98)(url);
}


class $2652ca00a3968b71$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getChildContext() {
        const { context: context } = this.props;
        const noop = ()=>{};
        return {
            insertCss: context.insertCss || noop
        };
    }
    render() {
        window.performance.mark('CFP-63.root-component-render');
        const { store: store, apolloClient: apolloClient, sessionData: sessionData } = this.props;
        return(// This is at the top because the root-level UnstatedProvider must not re-render
        // otherwise it will lose and recreate its instances
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                new (0, $hrAmX.BannerStateContainer)({
                    initialState: {
                        banners: window.__SSR_BANNERS__
                    }
                }),
                new (0, $bJX6u.ContentStateStateContainer)(window.__SSR_CONTENT_STATE__),
                ...(0, $9wGTI.fg)('confluence_populate_emoji_title_container_ssr') ? [
                    new (0, $ktUCG.EmojiTitleStateContainer)(window.__SSR_EMOJI_TITLE__)
                ] : []
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: apolloClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70d683a301b7be27$export$d900e4062895cd7c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $685338b3d2a4b0a3$export$2e865a7ec399eb55), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN9wG.XProductUserInviteProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $brNvA.ReattachCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $074500c4d6f25c0d$export$fb465b6e855c1e85), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $126a66f6ad21916b$export$86fbec116b87613f), {
            sessionData: sessionData
        }), !(0, $9wGTI.fg)('post-office-new-confluence-router-listener') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $074500c4d6f25c0d$export$9f8d3084fd3d5fc0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccd0dc06d2167081$export$f6564e60882bdf90), null))))))))))))))))))));
    }
}
$2652ca00a3968b71$export$2e2bcd8739ae039.displayName = 'Root';
$2652ca00a3968b71$export$2e2bcd8739ae039.childContextTypes = {
    /**
   * Handler for css injection in components.
   */ insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
$2652ca00a3968b71$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    /**
   * Context including the css handler (It has different versions for client and server rendering)
   */ context: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    }),
    apolloClient: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
};







const $64ffce910ca717e1$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $64ffce910ca717e1$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error('Cannot remove a child from a different parent', child, this);
                    $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $64ffce910ca717e1$var$extractNodeData(childNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $64ffce910ca717e1$var$extractNodeData(newNode),
        referenceNode: $64ffce910ca717e1$var$extractNodeData(referenceNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $64ffce910ca717e1$var$sendAnalyticsEvent(action, nodeData) {
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'confluenceFrontendServer',
            actionSubject: 'domManipulationError',
            action: 'error',
            attributes: {
                suppressedError: action,
                ...nodeData
            }
        });
    });
}
function $64ffce910ca717e1$var$extractNodeData(node) {
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: node.parentElement?.nodeName,
        isConnected: node.isConnected
    };
}



var $7LuKf = parcelRequire("7LuKf");







function $55460e99d99202dd$export$841e9db237ec2bdb(rootNode) {
    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_COMMENT, {
        acceptNode: (node)=>{
            return node.nodeValue === '$' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
    });
    const suspenseComments = [];
    let currentNode = null;
    while(currentNode = walker.nextNode())suspenseComments.push(currentNode);
    return suspenseComments;
}
function $55460e99d99202dd$export$c4c689e5d93ba5b6(node) {
    // Check if the node itself has data-hydration-shield
    if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute('data-hydration-shield')) return true;
    // Check if the parent has data-hydration-shield
    const parent = node.parentNode;
    if (parent?.nodeType === Node.ELEMENT_NODE && parent.hasAttribute('data-hydration-shield')) return true;
    return false;
}
function $55460e99d99202dd$export$9efc73f328295609(boundary) {
    let nextNode = boundary.nextSibling;
    // Skip text nodes that are just whitespace
    while(nextNode && nextNode.nodeType === Node.TEXT_NODE && !nextNode.textContent?.trim())nextNode = nextNode.nextSibling;
    // Return the next node if it is an element node
    if (nextNode && nextNode.nodeType === Node.ELEMENT_NODE) return nextNode;
}
function $55460e99d99202dd$export$b5009d2dcc72fd5c(rootNode, root) {
    (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).flushSync(()=>{
        $55460e99d99202dd$export$841e9db237ec2bdb(rootNode).forEach((boundary)=>{
            const node = $55460e99d99202dd$export$9efc73f328295609(boundary);
            // Skip nodes within LoadableActivatable components if experiment is enabled
            if (node && $55460e99d99202dd$export$c4c689e5d93ba5b6(node) && (0, $6mKj3.expVal)('confluence_frontend_exclude_activatable_hydration', 'isEnabled', false)) return;
            if (node) root.unstable_scheduleHydration(node);
        });
        root.unstable_scheduleHydration(rootNode);
    });
}



var $2DIgf = parcelRequire("2DIgf");

const $cff4f803b29c74e8$export$e99e0154cbe3afef = (rootNode)=>{
    const vcObserver = (0, $2DIgf.getVCObserver)();
    vcObserver.setSSRElement(rootNode);
    vcObserver.setReactRootRenderStart();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            vcObserver.setReactRootRenderStop();
        });
    });
};


function $82f3624e89bd584a$export$62028ff70825ead9(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
}





const $2dec69702766fc49$export$8d40dc283f5baa52 = (url)=>{
    const match = (0, $1NBp8.VIEW_PAGE).match(url) && window.__SSR_IS_LIVE_PAGE__ || (0, $1NBp8.EDIT_PAGE_V2).match(url) || (0, $1NBp8.EDIT_BLOG_V2).match(url);
    return !!match;
};





const $c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH = 100000;
const $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH = 1000;
const $c641ec602c55a36e$export$423e2732e9c54334 = ({ componentStack: componentStack })=>{
    if (!componentStack) return '';
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $4VJDS.default).getString('confluence_hydration_error_logging', '{}'));
    } catch (error) {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    if (loggingConfig.stack) {
        const errorStackLogLen = loggingConfig.stackLength ?? $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH;
        const clampedErrorStackLog = Math.min($c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH, errorStackLogLen);
        return componentStack.toString().substring(0, clampedErrorStackLog) ?? '';
    }
    return '';
};



function $301b91f6022f88c3$export$6f190738a936fdf9(error, errorInfo) {
    if (typeof window !== 'undefined' && window.dispatchEvent) window.dispatchEvent(new CustomEvent('hydrationError', {
        detail: {
            error: error.message,
            stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo),
            timestamp: Date.now()
        }
    }));
}



var $awd1Q = parcelRequire("awd1Q");





var $7RVQB = parcelRequire("7RVQB");

let $c4a23b150b65622f$var$translationPromise = null;
async function $c4a23b150b65622f$export$d72c30eb19cf29ca() {
    if ($c4a23b150b65622f$var$translationPromise === null) $c4a23b150b65622f$var$translationPromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_TRANSLATION, ()=>(0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage)));
    return $c4a23b150b65622f$var$translationPromise;
}


if (window?.performance) {
    window.performance.mark('CFP-63.app');
    window.performance.mark('navigation-fmp.NavigationFMP.start');
    window.performance.mark('side-navigation-fmp.SideNavigationFMP.start');
}
// Try load translation early if we know locale from SSR
if (window.__SSR_LOCALE__) (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)();


(0, $82f3624e89bd584a$export$62028ff70825ead9)(async function() {
    /**
   * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
   * This ensures we catch and track any errors that occur during the app's initialization,
   * including async operations and React rendering. Moving this call later would risk missing
   * early errors.
   * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
   */ (0, $5QpZa.default)();
    // When page is being refreshed or redirected from server we run into a condition when redirect
    // url requested from the server and SPA (which resources are loaded via early HTML flush) is
    // being initialized at the same time. We don't want to waste browser resources/make network
    // calls when page is going to be redirected anyway, so bail out early.
    if (document.querySelector(`meta[http-equiv="Refresh"]`)) return;
    // collect SSR placeholder dimensions at the start of initialization
    // to bypass capturing of intermediate loading states in dimensions check
    if (window.__DELAY_COLLECT_SSR_PLACEHOLDERS__) (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).COLLECT_PLACEHOLDER_DIMENSIONS, ()=>{
        (0, $5nRL1.collectSSRPlaceholderDimensions)(document, window);
    });
    const rootNode = document.getElementById('confluence-ui');
    if (window.__HYDRATABLE__) {
        // remove nonce attributes from style tags to support react hydration
        document.querySelectorAll('style[nonce]').forEach((styleTag)=>{
            styleTag.removeAttribute('nonce');
        });
        (0, $dA1Sn.saveFullCycleOutput)();
    }
    const { client: client, aggClient: aggClient } = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).CREATE_APOLLO_CLIENTS, ()=>({
            client: (0, $hp2SH.getApolloClient)(),
            aggClient: (0, $gKr8t.getAGGClient)()
        }));
    let initializeEmbeddedConfluencePromise;
    // @TODO: Update this to use `isMobileApp_DO_NOT_USE()` once we remove the experiment-gate
    if ((0, $lJlG6.isMobileApp_checkGateViaSSR_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("i2w4s"))).initialize();
    else if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("kcni8"))).initialize();
    let browserNotSupported;
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $cMvQV.setUserAgent)();
    // Bypass browser compatibility checks in the case of the Confluence native mobile app;
    // it is the responsibility of the mobile app to ensure the rendering of Confluence
    const shouldCheckBrowserCompatibility = !(0, $cMvQV.isNativeMobile)();
    if (shouldCheckBrowserCompatibility) {
        browserNotSupported = (0, $2DVQX.coreBrowserNotSupported)();
        if (browserNotSupported) // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), rootNode);
    }
    const sessionDataPromise = (async ()=>{
        const sessionData = await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_SESSION_DATA, ()=>(0, $aXEzU.getSessionDataAndInitializeStatsig)());
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        // Note: this MUST be done before preload queries below
        // in order to ensure performant AGG queries
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        // If page is SSRed preload data that is only needed for hydration
        // If page is not SSRed, preload all the data.
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        (0, $e80763d537fd4542$export$bd8e570400e2d126)();
        try {
            await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_INITIALIZE_STORAGE_MANAGER, async ()=>{
                await (0, $17wUi.initializeStorageManager)({
                    userId: userId,
                    isLicensed: isLicensed
                });
                (0, $gnYQc.applyPersistedStatsigOverrides)();
                (0, $ae045ed661bc53ec$export$efcab8bd082cbc1f)(sessionData);
                (0, $30ba73f8286a8f5a$export$6381c51f97ce9880)(sessionData);
                if ((0, $6mKj3.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $e8bac4b2464d29b3$export$77f9905a9b9e760d)(sessionData);
            });
            return sessionData;
        } catch  {
            // HOT-89887: server is giving 403 errors on an expired token, causing Apollo
            // to throw. Uncaught, the React app wouldn't start, and can't acknowledge
            // messages from the service worker; thus the service worker can't trigger a
            // redirect to the login page; thus user gets stuck at the Confluence logo
            // screen. By catching here, we can at least bootstrap the app and proceed to
            // the redirect.
            //
            // https://jira.atlassian.com/browse/CONFCLOUD-71974: IP allowlisting is
            // causing a 403 scenario similar to HOT-89887 above.
            return (0, $iC5L0.getEmptySessionData)();
        }
    })();
    // Preload loadable id defined in the global __LOADABLE__ array
    // If the page is rendered by React SSR service this promise will be blocking.
    // On normal SPA it is not blocking.
    const preloadLoadablePromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_LOADABLE, ()=>(0, $3GQl6.preloadLoadable)());
    const initializeCookiesPromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_INITIALIZE_COOKIES, ()=>(0, $68uaC.Cookies).initialize());
    // Captures the media sources in the current view port as early as possible while SSR response is displaying.
    (0, $2bffd0a48908e22c$export$daa1e83127b2f677)();
    // Preload components/JS chunks as early as possible, when entry point is loaded and
    // route is known, so they'll be ready by the moment when they're actually used.
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(window.location.toString(), false);
    Promise.all([
        sessionDataPromise,
        // No-Op if load translation is already called earlier
        (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)(),
        preloadLoadablePromise,
        initializeEmbeddedConfluencePromise,
        initializeCookiesPromise
    ]).then(([sessionData])=>{
        // If cloudId is not present in sessionData, we can assume sessionData did not load successfully. Instead of
        // allowing the app to render the red error message, we can render our simplified Error App that fires key analytics
        // events and shows a more pleasing error UI.
        if (sessionData.cloudId === '' && !(0, $9wGTI.fg)('confluence_fe_error_app_disabled')) {
            let isMobileTakeoverPage = false;
            try {
                if (window?.location?.pathname) isMobileTakeoverPage = Boolean((0, $1NBp8.MOBILE_TAKEOVER_PAGE).match(window.location.pathname));
            } catch  {
                // If anything goes wrong, default to false (don't skip ErrorAppLoader)
                isMobileTakeoverPage = false;
            }
            if (!isMobileTakeoverPage) {
                const root = (0, $2FNjD.createRoot)(rootNode);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lTjel.ErrorAppLoader), {
                    entryPoint: "confluence-frontend"
                }));
                return;
            }
        }
        // Initialize VCObserver before any rendering logic
        if (rootNode && (0, $9wGTI.fg)('confluence_frontend_vc_observer_initialization')) (0, $cff4f803b29c74e8$export$e99e0154cbe3afef)(rootNode);
        // Redux store
        const store = (0, $3Tw8v.default)();
        (0, $9F7Qb.subscribe)(store);
        // When __APOLLO_STATE__ is available in the global variable it means we are bootstrapping SPA over a SSR rendered page.
        // __APOLLO_STATE__ is the serialized apollo cache that is enough to render everything that has already preloaded in preloadLoadable.
        // We are disabling network so on the first render so the components will read from cache only not firing queries again.
        // See https://github.com/apollographql/apollo-client/issues/4814
        if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = true;
        if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = true;
        if (typeof window !== 'undefined' && (0, $6mKj3.expValEquals)('confluence_frontend_enable_react_dom_context_patch', 'isEnabled', true)) window.__CC_REACT_DOM_CONTEXT_PATCH__ = true;
        // Workaround for this google translate problem https://github.com/facebook/react/issues/11538#issuecomment-417504600
        // which is causing this issue https://product-fabric.atlassian.net/browse/CCP-2409, affecting view page reliability
        (0, $64ffce910ca717e1$export$d1215808cd22e615)();
        // code for regression drill logic. Systematic way of indentifying and tracking performance regressions in web pages
        // will be used to test out criterion, a new perfomacne tracking software
        // for more info visit https://hello.atlassian.net/wiki/spaces/CVMAI/pages/3761808800/Regression+Drill+Plan
        const delayValueForRegression = (0, $4VJDS.default).getNumber('confluence_frontend_preprod_slow', 0);
        /**
     * Emotion has 2 ways of SSR support
     * 1. Render style tags along with the component
     * 2. Extract the styles with createEmotionServer
     * Normally we don't need t client side extraction because all the style tags should be in <head>
     * However with streaming there is no good way to support it.
     * The "css" key here is special it runs the logic of moving all the style tags to <head> before React hydrates on the the client side.
     * Reference: https://github.com/emotion-js/emotion/blob/38db311adf024fe8a24b57c687824c47abbd0957/packages/cache/src/index.ts#L63
     */ const cache = (0, $egy7N.default)({
            key: 'css'
        });
        const App = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "confluence-root"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d847caf3274d14b7$export$f3385cdc6645f7e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.C), {
            value: cache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $799291abed68198f$export$640957ec8f6fdf34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2652ca00a3968b71$export$2e2bcd8739ae039), {
            store: store,
            context: {
                insertCss: (styles)=>styles._insertCss()
            },
            apolloClient: client,
            sessionData: sessionData
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8714b2bec379cfae$export$bd148a921cde8da1), null));
        const renderCallback = ()=>{
            if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = false;
            if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = false;
            (0, $7LuKf.initialization)(sessionData);
            // Inside of cleanUpLoadablePlaceholders function, it delayed cleaning up loadable placeholders.
            (0, $ezH4I.cleanUpLoadablePlaceholders)();
            (0, $KcDWk.releaseUnusedSSRedLegacyMacrosWithDelay)();
            const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($4FYDR)))(navigator.userAgent);
            const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
                // GASv3 analytics client is initialized inside of initialization() so we
                // must call the analytics client after that function has been called.
                if (shouldCheckBrowserCompatibility) analyticsClient.sendOperationalEvent({
                    source: 'confluenceRoot',
                    action: 'executed',
                    actionSubject: 'browserRuntimeCheck',
                    attributes: {
                        failedCoreBrowserCheck: browserNotSupported,
                        browserName: browserName,
                        browserVersion: browserVersion
                    }
                });
                (0, $fcc81ac864e755d2$export$76f12cc80b7fd2f3)(analyticsClient);
            });
            if (rootNode && !(0, $9wGTI.fg)('confluence_frontend_vc_observer_initialization')) (0, $cff4f803b29c74e8$export$e99e0154cbe3afef)(rootNode);
        };
        const ConcurrentApp = ()=>{
            (0, $42omo.useEffect)(()=>{
                renderCallback();
            }, []);
            return App;
        };
        const isHydratable = window['__HYDRATABLE__'] && ((0, $2dec69702766fc49$export$8d40dc283f5baa52)(window.location.toString()) ? (0, $6mKj3.expValEquals)('confluence_editor_hydration_partial', 'isEnabled', true) : true);
        if (isHydratable) {
            window['__HYDRATION_FAILED__'] = false;
            const root = (0, $2FNjD.hydrateRoot)(rootNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConcurrentApp, null), {
                onRecoverableError: (error, errorInfo)=>{
                    if (window['__HYDRATION_ERRORS__'] && error?.message) window['__HYDRATION_ERRORS__'].push({
                        type: 'ERROR_MESSAGES_FROM_REACT',
                        msg: error.message,
                        stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo)
                    });
                    const { hydrationFailed: hydrationFailed, friendlyMessage: friendlyMessage, docLink: docLink } = (0, $dtDUi.matchHydrationError)(error);
                    if (hydrationFailed) {
                        window['__HYDRATION_FAILED__'] = true;
                        if ((0, $6mKj3.expValEquals)('confluence_frontend_hydration_error_events_exp', 'isEnabled', true)) (0, $301b91f6022f88c3$export$6f190738a936fdf9)(error, errorInfo);
                    }
                }
            });
            window.__REACT_ROOT__ = root;
            if (window.__SSR_REACT_STREAMING__) // When streaming is enabled, we can schedule a synchronous hydration for all
            // resolved suspense boundaries in the root node as otherwise there is a
            // performance regression in React 18 that impacts TTAI
            //
            // https://hello.atlassian.net/wiki/spaces/~moates/pages/5497372057/Challenges+with+Selective+Hydration
            //
            // When we move to React 19 we can remove this.
            //
            // @see scheduleSyncHydration
            (0, $55460e99d99202dd$export$b5009d2dcc72fd5c)(rootNode, root);
        } else {
            const concurrentRoot = (0, $2FNjD.createRoot)(rootNode);
            concurrentRoot.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConcurrentApp, null));
        }
    });
});
 }, ["7EorR","2gnOU","8URLr","eiF7i","aZinD","kdoia","fnmhc","hhss7","8fdGr","dIKn2","cK6rU","4fAr4","kSJiq","4Lgj0","kUbUu","ffEVr","87NBA","let0D","i7QCq","699ae","7whwt","5GxU8","6O8m6","Wowvf","cIHDc","4shpn","9wxKg","lBzRN","ePdWC","gyOzw","8ab9M","amEt1","gRb4i","cHTTI","kWNlz","kjZZD","6wr18","7RNcA","8bZKp","65c4i","iXzmH","aeEUI","enYNd","k78EM","5abXM","32K9i","49GA1","4i0CB","2Cftu","cgLyI","3CHGC","jwWp5","5Vmp6","65rGD","2UF2x","hcj2C","lkOIY","at1W4","eYere","90kvt","4cER0","iY2SX","c7kN1","ihbI9","iIL8i","51haJ","b0cmi","2F69B","2rCak","A1eSR","2YffH","7Omhy","1QTBI"]);

$parcel$global.rlb("aFBfl")
//# sourceMappingURL=dashboard-spa-container-jquery3.f11252db.js.map
